// Local categories configuration.
// This overrides categories fetched from hosted assets (Sharetribe Console).
// To activate: remove 'categories' from appCdnAssets in configDefault.js
// Structure: { categories: [{ name, id, subcategories: [{ name, id, subcategories: [] }] }] }

const categoriesConfig = {
  "categories": [
    {
      "id": "aerial-equipment",
      "name": "Aerial Equipment",
      "subcategories": [
        {
          "id": "aerial-equipment-genie",
          "name": "Genie",
          "subcategories": [
            {
              "id": "aerial-equipment-genie-awp20",
              "name": "AWP20",
              "subcategories": []
            },
            {
              "id": "aerial-equipment-genie-awp24",
              "name": "AWP24",
              "subcategories": []
            },
            {
              "id": "aerial-equipment-genie-awp25",
              "name": "AWP25",
              "subcategories": []
            },
            {
              "id": "aerial-equipment-genie-awp30",
              "name": "AWP30",
              "subcategories": []
            },
            {
              "id": "aerial-equipment-genie-awp36",
              "name": "AWP36",
              "subcategories": []
            },
            {
              "id": "aerial-equipment-genie-awp40",
              "name": "AWP40",
              "subcategories": []
            },
            {
              "id": "aerial-equipment-genie-gh3-8",
              "name": "GH3.8",
              "subcategories": []
            },
            {
              "id": "aerial-equipment-genie-gh5-6",
              "name": "GH5.6",
              "subcategories": []
            },
            {
              "id": "aerial-equipment-genie-gl4",
              "name": "GL4",
              "subcategories": []
            },
            {
              "id": "aerial-equipment-genie-gl8",
              "name": "GL8",
              "subcategories": []
            },
            {
              "id": "aerial-equipment-genie-gl10",
              "name": "GL10",
              "subcategories": []
            },
            {
              "id": "aerial-equipment-genie-gl12",
              "name": "GL12",
              "subcategories": []
            },
            {
              "id": "aerial-equipment-genie-gr12",
              "name": "GR12",
              "subcategories": []
            },
            {
              "id": "aerial-equipment-genie-gr15",
              "name": "GR15",
              "subcategories": []
            },
            {
              "id": "aerial-equipment-genie-gr20",
              "name": "GR20",
              "subcategories": []
            },
            {
              "id": "aerial-equipment-genie-gr26",
              "name": "GR26",
              "subcategories": []
            },
            {
              "id": "aerial-equipment-genie-grc12",
              "name": "GRC12",
              "subcategories": []
            },
            {
              "id": "aerial-equipment-genie-gs1330",
              "name": "GS1330",
              "subcategories": []
            },
            {
              "id": "aerial-equipment-genie-gs1432",
              "name": "GS1432",
              "subcategories": []
            },
            {
              "id": "aerial-equipment-genie-gs1530",
              "name": "GS1530",
              "subcategories": []
            },
            {
              "id": "aerial-equipment-genie-gs1532",
              "name": "GS1532",
              "subcategories": []
            },
            {
              "id": "aerial-equipment-genie-gs1930",
              "name": "GS1930",
              "subcategories": []
            },
            {
              "id": "aerial-equipment-genie-gs1932",
              "name": "GS1932",
              "subcategories": []
            },
            {
              "id": "aerial-equipment-genie-gs2032",
              "name": "GS2032",
              "subcategories": []
            },
            {
              "id": "aerial-equipment-genie-gs2046",
              "name": "GS2046",
              "subcategories": []
            },
            {
              "id": "aerial-equipment-genie-gs2632",
              "name": "GS2632",
              "subcategories": []
            },
            {
              "id": "aerial-equipment-genie-gs2646",
              "name": "GS2646",
              "subcategories": []
            },
            {
              "id": "aerial-equipment-genie-gs2688",
              "name": "GS2688",
              "subcategories": []
            },
            {
              "id": "aerial-equipment-genie-gs2669",
              "name": "GS2669",
              "subcategories": []
            },
            {
              "id": "aerial-equipment-genie-gs3232",
              "name": "GS3232",
              "subcategories": []
            },
            {
              "id": "aerial-equipment-genie-gs3246",
              "name": "GS3246",
              "subcategories": []
            },
            {
              "id": "aerial-equipment-genie-gs3268",
              "name": "GS3268",
              "subcategories": []
            },
            {
              "id": "aerial-equipment-genie-gs3369",
              "name": "GS3369",
              "subcategories": []
            },
            {
              "id": "aerial-equipment-genie-gs3384",
              "name": "GS3384",
              "subcategories": []
            },
            {
              "id": "aerial-equipment-genie-gs3390",
              "name": "GS3390",
              "subcategories": []
            },
            {
              "id": "aerial-equipment-genie-gs4046",
              "name": "GS4046",
              "subcategories": []
            },
            {
              "id": "aerial-equipment-genie-gs4047",
              "name": "GS4047",
              "subcategories": []
            },
            {
              "id": "aerial-equipment-genie-gs4069",
              "name": "GS4069",
              "subcategories": []
            },
            {
              "id": "aerial-equipment-genie-gs4390",
              "name": "GS4390",
              "subcategories": []
            },
            {
              "id": "aerial-equipment-genie-gs4655",
              "name": "GS4655",
              "subcategories": []
            },
            {
              "id": "aerial-equipment-genie-gs5390",
              "name": "GS5390",
              "subcategories": []
            },
            {
              "id": "aerial-equipment-genie-gth007",
              "name": "GTH007",
              "subcategories": []
            },
            {
              "id": "aerial-equipment-genie-gth636",
              "name": "GTH636",
              "subcategories": []
            },
            {
              "id": "aerial-equipment-genie-gth644",
              "name": "GTH644",
              "subcategories": []
            },
            {
              "id": "aerial-equipment-genie-gth842",
              "name": "GTH842",
              "subcategories": []
            },
            {
              "id": "aerial-equipment-genie-gth844",
              "name": "GTH844",
              "subcategories": []
            },
            {
              "id": "aerial-equipment-genie-gth1056",
              "name": "GTH1056",
              "subcategories": []
            },
            {
              "id": "aerial-equipment-genie-gth1256",
              "name": "GTH1256",
              "subcategories": []
            },
            {
              "id": "aerial-equipment-genie-gth1544",
              "name": "GTH1544",
              "subcategories": []
            },
            {
              "id": "aerial-equipment-genie-gth2506",
              "name": "GTH2506",
              "subcategories": []
            },
            {
              "id": "aerial-equipment-genie-gth3007",
              "name": "GTH3007",
              "subcategories": []
            },
            {
              "id": "aerial-equipment-genie-gth4010",
              "name": "GTH4010",
              "subcategories": []
            },
            {
              "id": "aerial-equipment-genie-gth4013",
              "name": "GTH4013",
              "subcategories": []
            },
            {
              "id": "aerial-equipment-genie-gth4014",
              "name": "GTH4014",
              "subcategories": []
            },
            {
              "id": "aerial-equipment-genie-gth4017",
              "name": "GTH4017",
              "subcategories": []
            },
            {
              "id": "aerial-equipment-genie-gth4018",
              "name": "GTH4018",
              "subcategories": []
            },
            {
              "id": "aerial-equipment-genie-gth5022",
              "name": "GTH5022",
              "subcategories": []
            },
            {
              "id": "aerial-equipment-genie-gth5519",
              "name": "GTH5519",
              "subcategories": []
            },
            {
              "id": "aerial-equipment-genie-gth6622",
              "name": "GTH6622",
              "subcategories": []
            },
            {
              "id": "aerial-equipment-genie-iwp25",
              "name": "IWP25",
              "subcategories": []
            },
            {
              "id": "aerial-equipment-genie-iwp30",
              "name": "IWP30",
              "subcategories": []
            },
            {
              "id": "aerial-equipment-genie-pli24",
              "name": "PLI24",
              "subcategories": []
            },
            {
              "id": "aerial-equipment-genie-qs20",
              "name": "QS20",
              "subcategories": []
            },
            {
              "id": "aerial-equipment-genie-s40",
              "name": "S40",
              "subcategories": []
            },
            {
              "id": "aerial-equipment-genie-s45",
              "name": "S45",
              "subcategories": []
            },
            {
              "id": "aerial-equipment-genie-s60",
              "name": "S60",
              "subcategories": []
            },
            {
              "id": "aerial-equipment-genie-s65",
              "name": "S65",
              "subcategories": []
            },
            {
              "id": "aerial-equipment-genie-s80",
              "name": "S80",
              "subcategories": []
            },
            {
              "id": "aerial-equipment-genie-s85",
              "name": "S85",
              "subcategories": []
            },
            {
              "id": "aerial-equipment-genie-s105",
              "name": "S105",
              "subcategories": []
            },
            {
              "id": "aerial-equipment-genie-s120",
              "name": "S120",
              "subcategories": []
            },
            {
              "id": "aerial-equipment-genie-s125",
              "name": "S125",
              "subcategories": []
            },
            {
              "id": "aerial-equipment-genie-sla5",
              "name": "SLA5",
              "subcategories": []
            },
            {
              "id": "aerial-equipment-genie-sla10",
              "name": "SLA10",
              "subcategories": []
            },
            {
              "id": "aerial-equipment-genie-sla15",
              "name": "SLA15",
              "subcategories": []
            },
            {
              "id": "aerial-equipment-genie-sla20",
              "name": "SLA20",
              "subcategories": []
            },
            {
              "id": "aerial-equipment-genie-sl-a25",
              "name": "SL;A25",
              "subcategories": []
            },
            {
              "id": "aerial-equipment-genie-slc12",
              "name": "SLC12",
              "subcategories": []
            },
            {
              "id": "aerial-equipment-genie-slc18",
              "name": "SLC18",
              "subcategories": []
            },
            {
              "id": "aerial-equipment-genie-slc24",
              "name": "SLC24",
              "subcategories": []
            },
            {
              "id": "aerial-equipment-genie-sx105",
              "name": "SX105",
              "subcategories": []
            },
            {
              "id": "aerial-equipment-genie-sx125",
              "name": "SX125",
              "subcategories": []
            },
            {
              "id": "aerial-equipment-genie-sx135",
              "name": "SX135",
              "subcategories": []
            },
            {
              "id": "aerial-equipment-genie-sx150",
              "name": "SX150",
              "subcategories": []
            },
            {
              "id": "aerial-equipment-genie-sx180",
              "name": "SX180",
              "subcategories": []
            },
            {
              "id": "aerial-equipment-genie-tmz34",
              "name": "TMZ34",
              "subcategories": []
            },
            {
              "id": "aerial-equipment-genie-tmz50",
              "name": "TMZ50",
              "subcategories": []
            },
            {
              "id": "aerial-equipment-genie-tmztz34-20",
              "name": "TMZTZ34/20",
              "subcategories": []
            },
            {
              "id": "aerial-equipment-genie-tz50",
              "name": "TZ50",
              "subcategories": []
            },
            {
              "id": "aerial-equipment-genie-v1854",
              "name": "V1854",
              "subcategories": []
            },
            {
              "id": "aerial-equipment-genie-v2470",
              "name": "V2470",
              "subcategories": []
            },
            {
              "id": "aerial-equipment-genie-z20",
              "name": "Z20",
              "subcategories": []
            },
            {
              "id": "aerial-equipment-genie-z30",
              "name": "Z30",
              "subcategories": []
            },
            {
              "id": "aerial-equipment-genie-z33-18",
              "name": "Z33/18",
              "subcategories": []
            },
            {
              "id": "aerial-equipment-genie-z34",
              "name": "Z34",
              "subcategories": []
            },
            {
              "id": "aerial-equipment-genie-z40",
              "name": "Z40",
              "subcategories": []
            },
            {
              "id": "aerial-equipment-genie-z45",
              "name": "Z45",
              "subcategories": []
            },
            {
              "id": "aerial-equipment-genie-z51-30",
              "name": "Z51/30",
              "subcategories": []
            },
            {
              "id": "aerial-equipment-genie-z60",
              "name": "Z60",
              "subcategories": []
            },
            {
              "id": "aerial-equipment-genie-z62",
              "name": "Z62",
              "subcategories": []
            },
            {
              "id": "aerial-equipment-genie-z80",
              "name": "Z80",
              "subcategories": []
            },
            {
              "id": "aerial-equipment-genie-z135",
              "name": "Z135",
              "subcategories": []
            },
            {
              "id": "aerial-equipment-genie-zx135",
              "name": "ZX135",
              "subcategories": []
            },
            {
              "id": "aerial-equipment-genie-other",
              "name": "OTHER",
              "subcategories": []
            }
          ]
        },
        {
          "id": "aerial-equipment-jlg",
          "name": "Jlg",
          "subcategories": [
            {
              "id": "aerial-equipment-jlg-6rs",
              "name": "6RS",
              "subcategories": []
            },
            {
              "id": "aerial-equipment-jlg-10",
              "name": "10",
              "subcategories": []
            },
            {
              "id": "aerial-equipment-jlg-12",
              "name": "12",
              "subcategories": []
            },
            {
              "id": "aerial-equipment-jlg-15",
              "name": "15",
              "subcategories": []
            },
            {
              "id": "aerial-equipment-jlg-20",
              "name": "20",
              "subcategories": []
            },
            {
              "id": "aerial-equipment-jlg-24",
              "name": "24",
              "subcategories": []
            },
            {
              "id": "aerial-equipment-jlg-25",
              "name": "25",
              "subcategories": []
            },
            {
              "id": "aerial-equipment-jlg-30",
              "name": "30",
              "subcategories": []
            },
            {
              "id": "aerial-equipment-jlg-33",
              "name": "33",
              "subcategories": []
            },
            {
              "id": "aerial-equipment-jlg-35",
              "name": "35",
              "subcategories": []
            },
            {
              "id": "aerial-equipment-jlg-36",
              "name": "36",
              "subcategories": []
            },
            {
              "id": "aerial-equipment-jlg-38",
              "name": "38",
              "subcategories": []
            },
            {
              "id": "aerial-equipment-jlg-40",
              "name": "40",
              "subcategories": []
            },
            {
              "id": "aerial-equipment-jlg-41",
              "name": "41",
              "subcategories": []
            },
            {
              "id": "aerial-equipment-jlg-45",
              "name": "45",
              "subcategories": []
            },
            {
              "id": "aerial-equipment-jlg-60",
              "name": "60",
              "subcategories": []
            },
            {
              "id": "aerial-equipment-jlg-80",
              "name": "80",
              "subcategories": []
            },
            {
              "id": "aerial-equipment-jlg-120",
              "name": "120",
              "subcategories": []
            },
            {
              "id": "aerial-equipment-jlg-210",
              "name": "210",
              "subcategories": []
            },
            {
              "id": "aerial-equipment-jlg-245",
              "name": "245",
              "subcategories": []
            },
            {
              "id": "aerial-equipment-jlg-260",
              "name": "260",
              "subcategories": []
            },
            {
              "id": "aerial-equipment-jlg-266",
              "name": "266",
              "subcategories": []
            },
            {
              "id": "aerial-equipment-jlg-307",
              "name": "307",
              "subcategories": []
            },
            {
              "id": "aerial-equipment-jlg-313",
              "name": "313",
              "subcategories": []
            },
            {
              "id": "aerial-equipment-jlg-320",
              "name": "320",
              "subcategories": []
            },
            {
              "id": "aerial-equipment-jlg-330",
              "name": "330",
              "subcategories": []
            },
            {
              "id": "aerial-equipment-jlg-340",
              "name": "340",
              "subcategories": []
            },
            {
              "id": "aerial-equipment-jlg-400",
              "name": "400",
              "subcategories": []
            },
            {
              "id": "aerial-equipment-jlg-430",
              "name": "430",
              "subcategories": []
            },
            {
              "id": "aerial-equipment-jlg-450",
              "name": "450",
              "subcategories": []
            },
            {
              "id": "aerial-equipment-jlg-460",
              "name": "460",
              "subcategories": []
            },
            {
              "id": "aerial-equipment-jlg-500",
              "name": "500",
              "subcategories": []
            },
            {
              "id": "aerial-equipment-jlg-510",
              "name": "510",
              "subcategories": []
            },
            {
              "id": "aerial-equipment-jlg-519",
              "name": "519",
              "subcategories": []
            },
            {
              "id": "aerial-equipment-jlg-520",
              "name": "520",
              "subcategories": []
            },
            {
              "id": "aerial-equipment-jlg-530",
              "name": "530",
              "subcategories": []
            },
            {
              "id": "aerial-equipment-jlg-544",
              "name": "544",
              "subcategories": []
            },
            {
              "id": "aerial-equipment-jlg-600",
              "name": "600",
              "subcategories": []
            },
            {
              "id": "aerial-equipment-jlg-642",
              "name": "642",
              "subcategories": []
            },
            {
              "id": "aerial-equipment-jlg-644",
              "name": "644",
              "subcategories": []
            },
            {
              "id": "aerial-equipment-jlg-660",
              "name": "660",
              "subcategories": []
            },
            {
              "id": "aerial-equipment-jlg-670",
              "name": "670",
              "subcategories": []
            },
            {
              "id": "aerial-equipment-jlg-680",
              "name": "680",
              "subcategories": []
            },
            {
              "id": "aerial-equipment-jlg-740",
              "name": "740",
              "subcategories": []
            },
            {
              "id": "aerial-equipment-jlg-742",
              "name": "742",
              "subcategories": []
            },
            {
              "id": "aerial-equipment-jlg-800",
              "name": "800",
              "subcategories": []
            },
            {
              "id": "aerial-equipment-jlg-823",
              "name": "823",
              "subcategories": []
            },
            {
              "id": "aerial-equipment-jlg-830",
              "name": "830",
              "subcategories": []
            },
            {
              "id": "aerial-equipment-jlg-832",
              "name": "832",
              "subcategories": []
            },
            {
              "id": "aerial-equipment-jlg-860",
              "name": "860",
              "subcategories": []
            },
            {
              "id": "aerial-equipment-jlg-925",
              "name": "925",
              "subcategories": []
            },
            {
              "id": "aerial-equipment-jlg-943",
              "name": "943",
              "subcategories": []
            },
            {
              "id": "aerial-equipment-jlg-944",
              "name": "944",
              "subcategories": []
            },
            {
              "id": "aerial-equipment-jlg-1030",
              "name": "1030",
              "subcategories": []
            },
            {
              "id": "aerial-equipment-jlg-1043",
              "name": "1043",
              "subcategories": []
            },
            {
              "id": "aerial-equipment-jlg-1044",
              "name": "1044",
              "subcategories": []
            },
            {
              "id": "aerial-equipment-jlg-1055",
              "name": "1055",
              "subcategories": []
            },
            {
              "id": "aerial-equipment-jlg-1075",
              "name": "1075",
              "subcategories": []
            },
            {
              "id": "aerial-equipment-jlg-1200",
              "name": "1200",
              "subcategories": []
            },
            {
              "id": "aerial-equipment-jlg-1230",
              "name": "1230",
              "subcategories": []
            },
            {
              "id": "aerial-equipment-jlg-1250",
              "name": "1250",
              "subcategories": []
            },
            {
              "id": "aerial-equipment-jlg-1255",
              "name": "1255",
              "subcategories": []
            },
            {
              "id": "aerial-equipment-jlg-1350",
              "name": "1350",
              "subcategories": []
            },
            {
              "id": "aerial-equipment-jlg-1500",
              "name": "1500",
              "subcategories": []
            },
            {
              "id": "aerial-equipment-jlg-1532",
              "name": "1532",
              "subcategories": []
            },
            {
              "id": "aerial-equipment-jlg-1644",
              "name": "1644",
              "subcategories": []
            },
            {
              "id": "aerial-equipment-jlg-1732",
              "name": "1732",
              "subcategories": []
            },
            {
              "id": "aerial-equipment-jlg-1850",
              "name": "1850",
              "subcategories": []
            },
            {
              "id": "aerial-equipment-jlg-1930",
              "name": "1930",
              "subcategories": []
            },
            {
              "id": "aerial-equipment-jlg-1932",
              "name": "1932",
              "subcategories": []
            },
            {
              "id": "aerial-equipment-jlg-2030",
              "name": "2030",
              "subcategories": []
            },
            {
              "id": "aerial-equipment-jlg-2032",
              "name": "2032",
              "subcategories": []
            },
            {
              "id": "aerial-equipment-jlg-2033",
              "name": "2033",
              "subcategories": []
            },
            {
              "id": "aerial-equipment-jlg-2630",
              "name": "2630",
              "subcategories": []
            },
            {
              "id": "aerial-equipment-jlg-2632",
              "name": "2632",
              "subcategories": []
            },
            {
              "id": "aerial-equipment-jlg-2646",
              "name": "2646",
              "subcategories": []
            },
            {
              "id": "aerial-equipment-jlg-2733",
              "name": "2733",
              "subcategories": []
            },
            {
              "id": "aerial-equipment-jlg-3246",
              "name": "3246",
              "subcategories": []
            },
            {
              "id": "aerial-equipment-jlg-3248",
              "name": "3248",
              "subcategories": []
            },
            {
              "id": "aerial-equipment-jlg-3369",
              "name": "3369",
              "subcategories": []
            },
            {
              "id": "aerial-equipment-jlg-3394",
              "name": "3394",
              "subcategories": []
            },
            {
              "id": "aerial-equipment-jlg-3509",
              "name": "3509",
              "subcategories": []
            },
            {
              "id": "aerial-equipment-jlg-3512",
              "name": "3512",
              "subcategories": []
            },
            {
              "id": "aerial-equipment-jlg-3513",
              "name": "3513",
              "subcategories": []
            },
            {
              "id": "aerial-equipment-jlg-3969",
              "name": "3969",
              "subcategories": []
            },
            {
              "id": "aerial-equipment-jlg-4009",
              "name": "4009",
              "subcategories": []
            },
            {
              "id": "aerial-equipment-jlg-4013",
              "name": "4013",
              "subcategories": []
            },
            {
              "id": "aerial-equipment-jlg-4017",
              "name": "4017",
              "subcategories": []
            },
            {
              "id": "aerial-equipment-jlg-4045",
              "name": "4045",
              "subcategories": []
            },
            {
              "id": "aerial-equipment-jlg-4069",
              "name": "4069",
              "subcategories": []
            },
            {
              "id": "aerial-equipment-jlg-4394",
              "name": "4394",
              "subcategories": []
            },
            {
              "id": "aerial-equipment-jlg-6042",
              "name": "6042",
              "subcategories": []
            },
            {
              "id": "aerial-equipment-jlg-ae1932",
              "name": "AE1932",
              "subcategories": []
            },
            {
              "id": "aerial-equipment-jlg-ag313",
              "name": "AG313",
              "subcategories": []
            },
            {
              "id": "aerial-equipment-jlg-ag519",
              "name": "AG519",
              "subcategories": []
            },
            {
              "id": "aerial-equipment-jlg-ag823",
              "name": "AG823",
              "subcategories": []
            },
            {
              "id": "aerial-equipment-jlg-ag832",
              "name": "AG832",
              "subcategories": []
            },
            {
              "id": "aerial-equipment-jlg-ag925",
              "name": "AG925",
              "subcategories": []
            },
            {
              "id": "aerial-equipment-jlg-cm1732",
              "name": "CM1732",
              "subcategories": []
            },
            {
              "id": "aerial-equipment-jlg-cm2546",
              "name": "CM2546",
              "subcategories": []
            },
            {
              "id": "aerial-equipment-jlg-e18",
              "name": "E18",
              "subcategories": []
            },
            {
              "id": "aerial-equipment-jlg-e300",
              "name": "E300",
              "subcategories": []
            },
            {
              "id": "aerial-equipment-jlg-e313",
              "name": "E313",
              "subcategories": []
            },
            {
              "id": "aerial-equipment-jlg-e400",
              "name": "E400",
              "subcategories": []
            },
            {
              "id": "aerial-equipment-jlg-e450",
              "name": "E450",
              "subcategories": []
            },
            {
              "id": "aerial-equipment-jlg-e600",
              "name": "E600",
              "subcategories": []
            },
            {
              "id": "aerial-equipment-jlg-ec450",
              "name": "EC450",
              "subcategories": []
            },
            {
              "id": "aerial-equipment-jlg-ec520",
              "name": "EC520",
              "subcategories": []
            },
            {
              "id": "aerial-equipment-jlg-ec600",
              "name": "EC600",
              "subcategories": []
            },
            {
              "id": "aerial-equipment-jlg-ecolift1-5",
              "name": "ECOLIFT1.5",
              "subcategories": []
            },
            {
              "id": "aerial-equipment-jlg-ecolift50",
              "name": "ECOLIFT50",
              "subcategories": []
            },
            {
              "id": "aerial-equipment-jlg-ecolift70",
              "name": "ECOLIFT70",
              "subcategories": []
            },
            {
              "id": "aerial-equipment-jlg-ert2669",
              "name": "ERT2669",
              "subcategories": []
            },
            {
              "id": "aerial-equipment-jlg-ert3369",
              "name": "ERT3369",
              "subcategories": []
            },
            {
              "id": "aerial-equipment-jlg-ert4069",
              "name": "ERT4069",
              "subcategories": []
            },
            {
              "id": "aerial-equipment-jlg-ert4769",
              "name": "ERT4769",
              "subcategories": []
            },
            {
              "id": "aerial-equipment-jlg-es1330",
              "name": "ES1330",
              "subcategories": []
            },
            {
              "id": "aerial-equipment-jlg-es1530",
              "name": "ES1530",
              "subcategories": []
            },
            {
              "id": "aerial-equipment-jlg-es1932",
              "name": "ES1932",
              "subcategories": []
            },
            {
              "id": "aerial-equipment-jlg-es2632",
              "name": "ES2632",
              "subcategories": []
            },
            {
              "id": "aerial-equipment-jlg-es2646",
              "name": "ES2646",
              "subcategories": []
            },
            {
              "id": "aerial-equipment-jlg-es3246",
              "name": "ES3246",
              "subcategories": []
            },
            {
              "id": "aerial-equipment-jlg-es1930m",
              "name": "ES1930M",
              "subcategories": []
            },
            {
              "id": "aerial-equipment-jlg-es4046",
              "name": "ES4046",
              "subcategories": []
            },
            {
              "id": "aerial-equipment-jlg-et350",
              "name": "ET350",
              "subcategories": []
            },
            {
              "id": "aerial-equipment-jlg-et500",
              "name": "ET500",
              "subcategories": []
            },
            {
              "id": "aerial-equipment-jlg-fs80",
              "name": "FS80",
              "subcategories": []
            },
            {
              "id": "aerial-equipment-jlg-ft70",
              "name": "FT70",
              "subcategories": []
            },
            {
              "id": "aerial-equipment-jlg-g5",
              "name": "G5",
              "subcategories": []
            },
            {
              "id": "aerial-equipment-jlg-g6",
              "name": "G6",
              "subcategories": []
            },
            {
              "id": "aerial-equipment-jlg-g9",
              "name": "G9",
              "subcategories": []
            },
            {
              "id": "aerial-equipment-jlg-g10",
              "name": "G10",
              "subcategories": []
            },
            {
              "id": "aerial-equipment-jlg-g12",
              "name": "G12",
              "subcategories": []
            },
            {
              "id": "aerial-equipment-jlg-g15",
              "name": "G15",
              "subcategories": []
            },
            {
              "id": "aerial-equipment-jlg-h340",
              "name": "H340",
              "subcategories": []
            },
            {
              "id": "aerial-equipment-jlg-h600",
              "name": "H600",
              "subcategories": []
            },
            {
              "id": "aerial-equipment-jlg-h800",
              "name": "H800",
              "subcategories": []
            },
            {
              "id": "aerial-equipment-jlg-m400",
              "name": "M400",
              "subcategories": []
            },
            {
              "id": "aerial-equipment-jlg-m450",
              "name": "M450",
              "subcategories": []
            },
            {
              "id": "aerial-equipment-jlg-m600",
              "name": "M600",
              "subcategories": []
            },
            {
              "id": "aerial-equipment-jlg-m3369",
              "name": "M3369",
              "subcategories": []
            },
            {
              "id": "aerial-equipment-jlg-m4069",
              "name": "M4069",
              "subcategories": []
            },
            {
              "id": "aerial-equipment-jlg-n35",
              "name": "N35",
              "subcategories": []
            },
            {
              "id": "aerial-equipment-jlg-n40",
              "name": "N40",
              "subcategories": []
            },
            {
              "id": "aerial-equipment-jlg-r6",
              "name": "R6",
              "subcategories": []
            },
            {
              "id": "aerial-equipment-jlg-r1370",
              "name": "R1370",
              "subcategories": []
            },
            {
              "id": "aerial-equipment-jlg-r1385",
              "name": "R1385",
              "subcategories": []
            },
            {
              "id": "aerial-equipment-jlg-r1932",
              "name": "R1932",
              "subcategories": []
            },
            {
              "id": "aerial-equipment-jlg-r2632",
              "name": "R2632",
              "subcategories": []
            },
            {
              "id": "aerial-equipment-jlg-r2646",
              "name": "R2646",
              "subcategories": []
            },
            {
              "id": "aerial-equipment-jlg-r3246",
              "name": "R3246",
              "subcategories": []
            },
            {
              "id": "aerial-equipment-jlg-r4045",
              "name": "R4045",
              "subcategories": []
            },
            {
              "id": "aerial-equipment-jlg-r11100",
              "name": "R11100",
              "subcategories": []
            },
            {
              "id": "aerial-equipment-jlg-r13100",
              "name": "R13100",
              "subcategories": []
            },
            {
              "id": "aerial-equipment-jlg-rt2669",
              "name": "RT2669",
              "subcategories": []
            },
            {
              "id": "aerial-equipment-jlg-rt3369",
              "name": "RT3369",
              "subcategories": []
            },
            {
              "id": "aerial-equipment-jlg-rt3394",
              "name": "RT3394",
              "subcategories": []
            },
            {
              "id": "aerial-equipment-jlg-rt4069",
              "name": "RT4069",
              "subcategories": []
            },
            {
              "id": "aerial-equipment-jlg-rt4394",
              "name": "RT4394",
              "subcategories": []
            },
            {
              "id": "aerial-equipment-jlg-rt4769",
              "name": "RT4769",
              "subcategories": []
            },
            {
              "id": "aerial-equipment-jlg-rt5394",
              "name": "RT5394",
              "subcategories": []
            },
            {
              "id": "aerial-equipment-jlg-t350",
              "name": "T350",
              "subcategories": []
            },
            {
              "id": "aerial-equipment-jlg-t500",
              "name": "T500",
              "subcategories": []
            },
            {
              "id": "aerial-equipment-jlg-toucan-8e",
              "name": "TOUCAN 8E",
              "subcategories": []
            },
            {
              "id": "aerial-equipment-jlg-toucan10e",
              "name": "TOUCAN10E",
              "subcategories": []
            },
            {
              "id": "aerial-equipment-jlg-toucan-12e",
              "name": "TOUCAN 12E",
              "subcategories": []
            },
            {
              "id": "aerial-equipment-jlg-toucan-20e",
              "name": "TOUCAN 20E",
              "subcategories": []
            },
            {
              "id": "aerial-equipment-jlg-toucan-26e",
              "name": "TOUCAN 26E",
              "subcategories": []
            },
            {
              "id": "aerial-equipment-jlg-toucan-32e",
              "name": "TOUCAN 32E",
              "subcategories": []
            },
            {
              "id": "aerial-equipment-jlg-toucan-800a",
              "name": "TOUCAN 800A",
              "subcategories": []
            },
            {
              "id": "aerial-equipment-jlg-toucan-1100a",
              "name": "TOUCAN 1100A",
              "subcategories": []
            },
            {
              "id": "aerial-equipment-jlg-toucan-duo",
              "name": "TOUCAN DUO",
              "subcategories": []
            },
            {
              "id": "aerial-equipment-jlg-toucan-e33mj",
              "name": "TOUCAN E33MJ",
              "subcategories": []
            },
            {
              "id": "aerial-equipment-jlg-wp08",
              "name": "WP08",
              "subcategories": []
            },
            {
              "id": "aerial-equipment-jlg-x430",
              "name": "X430",
              "subcategories": []
            },
            {
              "id": "aerial-equipment-jlg-x500",
              "name": "X500",
              "subcategories": []
            },
            {
              "id": "aerial-equipment-jlg-x540",
              "name": "X540",
              "subcategories": []
            },
            {
              "id": "aerial-equipment-jlg-x550",
              "name": "X550",
              "subcategories": []
            },
            {
              "id": "aerial-equipment-jlg-x600",
              "name": "X600",
              "subcategories": []
            },
            {
              "id": "aerial-equipment-jlg-x660",
              "name": "X660",
              "subcategories": []
            },
            {
              "id": "aerial-equipment-jlg-x700",
              "name": "X700",
              "subcategories": []
            },
            {
              "id": "aerial-equipment-jlg-x770",
              "name": "X770",
              "subcategories": []
            },
            {
              "id": "aerial-equipment-jlg-x1000",
              "name": "X1000",
              "subcategories": []
            },
            {
              "id": "aerial-equipment-jlg-other",
              "name": "OTHER",
              "subcategories": []
            }
          ]
        },
        {
          "id": "aerial-equipment-skyjack",
          "name": "Skyjack",
          "subcategories": [
            {
              "id": "aerial-equipment-skyjack-sj12",
              "name": "SJ12",
              "subcategories": []
            },
            {
              "id": "aerial-equipment-skyjack-sj16",
              "name": "SJ16",
              "subcategories": []
            },
            {
              "id": "aerial-equipment-skyjack-sj20",
              "name": "SJ20",
              "subcategories": []
            },
            {
              "id": "aerial-equipment-skyjack-sj30",
              "name": "SJ30",
              "subcategories": []
            },
            {
              "id": "aerial-equipment-skyjack-sj40",
              "name": "SJ40",
              "subcategories": []
            },
            {
              "id": "aerial-equipment-skyjack-sj45",
              "name": "SJ45",
              "subcategories": []
            },
            {
              "id": "aerial-equipment-skyjack-sj46",
              "name": "SJ46",
              "subcategories": []
            },
            {
              "id": "aerial-equipment-skyjack-sj60",
              "name": "SJ60",
              "subcategories": []
            },
            {
              "id": "aerial-equipment-skyjack-sj61",
              "name": "SJ61",
              "subcategories": []
            },
            {
              "id": "aerial-equipment-skyjack-sj63",
              "name": "SJ63",
              "subcategories": []
            },
            {
              "id": "aerial-equipment-skyjack-sj66",
              "name": "SJ66",
              "subcategories": []
            },
            {
              "id": "aerial-equipment-skyjack-sj82",
              "name": "SJ82",
              "subcategories": []
            },
            {
              "id": "aerial-equipment-skyjack-sj85",
              "name": "SJ85",
              "subcategories": []
            },
            {
              "id": "aerial-equipment-skyjack-sj86",
              "name": "SJ86",
              "subcategories": []
            },
            {
              "id": "aerial-equipment-skyjack-sj519",
              "name": "SJ519",
              "subcategories": []
            },
            {
              "id": "aerial-equipment-skyjack-sj643",
              "name": "SJ643",
              "subcategories": []
            },
            {
              "id": "aerial-equipment-skyjack-sj843",
              "name": "SJ843",
              "subcategories": []
            },
            {
              "id": "aerial-equipment-skyjack-sj1044",
              "name": "SJ1044",
              "subcategories": []
            },
            {
              "id": "aerial-equipment-skyjack-sj1056",
              "name": "SJ1056",
              "subcategories": []
            },
            {
              "id": "aerial-equipment-skyjack-sj1256",
              "name": "SJ1256",
              "subcategories": []
            },
            {
              "id": "aerial-equipment-skyjack-sj3213",
              "name": "SJ3213",
              "subcategories": []
            },
            {
              "id": "aerial-equipment-skyjack-sj3215",
              "name": "SJ3215",
              "subcategories": []
            },
            {
              "id": "aerial-equipment-skyjack-sj3219",
              "name": "SJ3219",
              "subcategories": []
            },
            {
              "id": "aerial-equipment-skyjack-sj3220",
              "name": "SJ3220",
              "subcategories": []
            },
            {
              "id": "aerial-equipment-skyjack-sj3226",
              "name": "SJ3226",
              "subcategories": []
            },
            {
              "id": "aerial-equipment-skyjack-sj3232",
              "name": "SJ3232",
              "subcategories": []
            },
            {
              "id": "aerial-equipment-skyjack-sj4626",
              "name": "SJ4626",
              "subcategories": []
            },
            {
              "id": "aerial-equipment-skyjack-sj4726",
              "name": "SJ4726",
              "subcategories": []
            },
            {
              "id": "aerial-equipment-skyjack-sj4732",
              "name": "SJ4732",
              "subcategories": []
            },
            {
              "id": "aerial-equipment-skyjack-sj4740",
              "name": "SJ4740",
              "subcategories": []
            },
            {
              "id": "aerial-equipment-skyjack-sj5545",
              "name": "SJ5545",
              "subcategories": []
            },
            {
              "id": "aerial-equipment-skyjack-sj6826",
              "name": "SJ6826",
              "subcategories": []
            },
            {
              "id": "aerial-equipment-skyjack-sj6832",
              "name": "SJ6832",
              "subcategories": []
            },
            {
              "id": "aerial-equipment-skyjack-sj6940",
              "name": "SJ6940",
              "subcategories": []
            },
            {
              "id": "aerial-equipment-skyjack-sj7027",
              "name": "SJ7027",
              "subcategories": []
            },
            {
              "id": "aerial-equipment-skyjack-sj7127",
              "name": "SJ7127",
              "subcategories": []
            },
            {
              "id": "aerial-equipment-skyjack-sj7135",
              "name": "SJ7135",
              "subcategories": []
            },
            {
              "id": "aerial-equipment-skyjack-sj8243",
              "name": "SJ8243",
              "subcategories": []
            },
            {
              "id": "aerial-equipment-skyjack-sj8831",
              "name": "SJ8831",
              "subcategories": []
            },
            {
              "id": "aerial-equipment-skyjack-sj8841",
              "name": "SJ8841",
              "subcategories": []
            },
            {
              "id": "aerial-equipment-skyjack-sj8850",
              "name": "SJ8850",
              "subcategories": []
            },
            {
              "id": "aerial-equipment-skyjack-sj9233",
              "name": "SJ9233",
              "subcategories": []
            },
            {
              "id": "aerial-equipment-skyjack-sj9243",
              "name": "SJ9243",
              "subcategories": []
            },
            {
              "id": "aerial-equipment-skyjack-sj9250",
              "name": "SJ9250",
              "subcategories": []
            },
            {
              "id": "aerial-equipment-skyjack-sj9253",
              "name": "SJ9253",
              "subcategories": []
            },
            {
              "id": "aerial-equipment-skyjack-sj9664",
              "name": "SJ9664",
              "subcategories": []
            },
            {
              "id": "aerial-equipment-skyjack-sjii3226",
              "name": "SJII3226",
              "subcategories": []
            },
            {
              "id": "aerial-equipment-skyjack-sjii4626",
              "name": "SJII4626",
              "subcategories": []
            },
            {
              "id": "aerial-equipment-skyjack-sjiii3015",
              "name": "SJIII3015",
              "subcategories": []
            },
            {
              "id": "aerial-equipment-skyjack-sjiii3215",
              "name": "SJIII3215",
              "subcategories": []
            },
            {
              "id": "aerial-equipment-skyjack-sjiii3219",
              "name": "SJIII3219",
              "subcategories": []
            },
            {
              "id": "aerial-equipment-skyjack-sjiii3220",
              "name": "SJIII3220",
              "subcategories": []
            },
            {
              "id": "aerial-equipment-skyjack-sjiii3226",
              "name": "SJIII3226",
              "subcategories": []
            },
            {
              "id": "aerial-equipment-skyjack-sjiii4620",
              "name": "SJIII4620",
              "subcategories": []
            },
            {
              "id": "aerial-equipment-skyjack-sjiii4626",
              "name": "SJIII4626",
              "subcategories": []
            },
            {
              "id": "aerial-equipment-skyjack-sjiii4632",
              "name": "SJIII4632",
              "subcategories": []
            },
            {
              "id": "aerial-equipment-skyjack-sjiii4740",
              "name": "SJIII4740",
              "subcategories": []
            },
            {
              "id": "aerial-equipment-skyjack-sjiii4832",
              "name": "SJIII4832",
              "subcategories": []
            },
            {
              "id": "aerial-equipment-skyjack-sjkb33",
              "name": "SJKB33",
              "subcategories": []
            },
            {
              "id": "aerial-equipment-skyjack-sjlb12",
              "name": "SJLB12",
              "subcategories": []
            },
            {
              "id": "aerial-equipment-skyjack-sjm3219",
              "name": "SJM3219",
              "subcategories": []
            },
            {
              "id": "aerial-equipment-skyjack-vr642",
              "name": "VR642",
              "subcategories": []
            },
            {
              "id": "aerial-equipment-skyjack-vr843",
              "name": "VR843",
              "subcategories": []
            },
            {
              "id": "aerial-equipment-skyjack-vr1056",
              "name": "VR1056",
              "subcategories": []
            },
            {
              "id": "aerial-equipment-skyjack-zb2044",
              "name": "ZB2044",
              "subcategories": []
            },
            {
              "id": "aerial-equipment-skyjack-zb20044",
              "name": "ZB20044",
              "subcategories": []
            },
            {
              "id": "aerial-equipment-skyjack-other",
              "name": "OTHER",
              "subcategories": []
            }
          ]
        },
        {
          "id": "aerial-equipment-jcb",
          "name": "Jcb",
          "subcategories": [
            {
              "id": "aerial-equipment-jcb-25",
              "name": "25",
              "subcategories": []
            },
            {
              "id": "aerial-equipment-jcb-27",
              "name": "27",
              "subcategories": []
            },
            {
              "id": "aerial-equipment-jcb-30",
              "name": "30",
              "subcategories": []
            },
            {
              "id": "aerial-equipment-jcb-35",
              "name": "35",
              "subcategories": []
            },
            {
              "id": "aerial-equipment-jcb-35d",
              "name": "35D",
              "subcategories": []
            },
            {
              "id": "aerial-equipment-jcb-55",
              "name": "55",
              "subcategories": []
            },
            {
              "id": "aerial-equipment-jcb-504",
              "name": "504",
              "subcategories": []
            },
            {
              "id": "aerial-equipment-jcb-505",
              "name": "505",
              "subcategories": []
            },
            {
              "id": "aerial-equipment-jcb-506",
              "name": "506",
              "subcategories": []
            },
            {
              "id": "aerial-equipment-jcb-507",
              "name": "507",
              "subcategories": []
            },
            {
              "id": "aerial-equipment-jcb-508",
              "name": "508",
              "subcategories": []
            },
            {
              "id": "aerial-equipment-jcb-509",
              "name": "509",
              "subcategories": []
            },
            {
              "id": "aerial-equipment-jcb-510",
              "name": "510",
              "subcategories": []
            },
            {
              "id": "aerial-equipment-jcb-512",
              "name": "512",
              "subcategories": []
            },
            {
              "id": "aerial-equipment-jcb-514",
              "name": "514",
              "subcategories": []
            },
            {
              "id": "aerial-equipment-jcb-515",
              "name": "515",
              "subcategories": []
            },
            {
              "id": "aerial-equipment-jcb-516",
              "name": "516",
              "subcategories": []
            },
            {
              "id": "aerial-equipment-jcb-520",
              "name": "520",
              "subcategories": []
            },
            {
              "id": "aerial-equipment-jcb-524",
              "name": "524",
              "subcategories": []
            },
            {
              "id": "aerial-equipment-jcb-525",
              "name": "525",
              "subcategories": []
            },
            {
              "id": "aerial-equipment-jcb-526",
              "name": "526",
              "subcategories": []
            },
            {
              "id": "aerial-equipment-jcb-527",
              "name": "527",
              "subcategories": []
            },
            {
              "id": "aerial-equipment-jcb-528",
              "name": "528",
              "subcategories": []
            },
            {
              "id": "aerial-equipment-jcb-530",
              "name": "530",
              "subcategories": []
            },
            {
              "id": "aerial-equipment-jcb-531",
              "name": "531",
              "subcategories": []
            },
            {
              "id": "aerial-equipment-jcb-532",
              "name": "532",
              "subcategories": []
            },
            {
              "id": "aerial-equipment-jcb-533",
              "name": "533",
              "subcategories": []
            },
            {
              "id": "aerial-equipment-jcb-535",
              "name": "535",
              "subcategories": []
            },
            {
              "id": "aerial-equipment-jcb-536",
              "name": "536",
              "subcategories": []
            },
            {
              "id": "aerial-equipment-jcb-537",
              "name": "537",
              "subcategories": []
            },
            {
              "id": "aerial-equipment-jcb-538",
              "name": "538",
              "subcategories": []
            },
            {
              "id": "aerial-equipment-jcb-540",
              "name": "540",
              "subcategories": []
            },
            {
              "id": "aerial-equipment-jcb-541",
              "name": "541",
              "subcategories": []
            },
            {
              "id": "aerial-equipment-jcb-542",
              "name": "542",
              "subcategories": []
            },
            {
              "id": "aerial-equipment-jcb-550",
              "name": "550",
              "subcategories": []
            },
            {
              "id": "aerial-equipment-jcb-555",
              "name": "555",
              "subcategories": []
            },
            {
              "id": "aerial-equipment-jcb-560",
              "name": "560",
              "subcategories": []
            },
            {
              "id": "aerial-equipment-jcb-926",
              "name": "926",
              "subcategories": []
            },
            {
              "id": "aerial-equipment-jcb-930",
              "name": "930",
              "subcategories": []
            },
            {
              "id": "aerial-equipment-jcb-940",
              "name": "940",
              "subcategories": []
            },
            {
              "id": "aerial-equipment-jcb-950",
              "name": "950",
              "subcategories": []
            },
            {
              "id": "aerial-equipment-jcb-a45",
              "name": "A45",
              "subcategories": []
            },
            {
              "id": "aerial-equipment-jcb-aj48",
              "name": "AJ48",
              "subcategories": []
            },
            {
              "id": "aerial-equipment-jcb-s1530",
              "name": "S1530",
              "subcategories": []
            },
            {
              "id": "aerial-equipment-jcb-s1930",
              "name": "S1930",
              "subcategories": []
            },
            {
              "id": "aerial-equipment-jcb-s1932",
              "name": "S1932",
              "subcategories": []
            },
            {
              "id": "aerial-equipment-jcb-s2632",
              "name": "S2632",
              "subcategories": []
            },
            {
              "id": "aerial-equipment-jcb-s3246",
              "name": "S3246",
              "subcategories": []
            },
            {
              "id": "aerial-equipment-jcb-s4046",
              "name": "S4046",
              "subcategories": []
            },
            {
              "id": "aerial-equipment-jcb-s4550",
              "name": "S4550",
              "subcategories": []
            },
            {
              "id": "aerial-equipment-jcb-tm320",
              "name": "TM320",
              "subcategories": []
            },
            {
              "id": "aerial-equipment-jcb-other",
              "name": "OTHER",
              "subcategories": []
            }
          ]
        },
        {
          "id": "aerial-equipment-toyota",
          "name": "Toyota",
          "subcategories": [
            {
              "id": "aerial-equipment-toyota-02fg",
              "name": "02FG",
              "subcategories": []
            },
            {
              "id": "aerial-equipment-toyota-022fd",
              "name": "022FD",
              "subcategories": []
            },
            {
              "id": "aerial-equipment-toyota-022fg",
              "name": "022FG",
              "subcategories": []
            },
            {
              "id": "aerial-equipment-toyota-022td",
              "name": "022TD",
              "subcategories": []
            },
            {
              "id": "aerial-equipment-toyota-025fd",
              "name": "025FD",
              "subcategories": []
            },
            {
              "id": "aerial-equipment-toyota-025fg",
              "name": "025FG",
              "subcategories": []
            },
            {
              "id": "aerial-equipment-toyota-026fd",
              "name": "026FD",
              "subcategories": []
            },
            {
              "id": "aerial-equipment-toyota-026fdf",
              "name": "026FDF",
              "subcategories": []
            },
            {
              "id": "aerial-equipment-toyota-027fd",
              "name": "027FD",
              "subcategories": []
            },
            {
              "id": "aerial-equipment-toyota-027fdf",
              "name": "027FDF",
              "subcategories": []
            },
            {
              "id": "aerial-equipment-toyota-027fg",
              "name": "027FG",
              "subcategories": []
            },
            {
              "id": "aerial-equipment-toyota-028fdf",
              "name": "028FDF",
              "subcategories": []
            },
            {
              "id": "aerial-equipment-toyota-028fgf",
              "name": "028FGF",
              "subcategories": []
            },
            {
              "id": "aerial-equipment-toyota-028fgjf",
              "name": "028FGJF",
              "subcategories": []
            },
            {
              "id": "aerial-equipment-toyota-028fgk",
              "name": "028FGK",
              "subcategories": []
            },
            {
              "id": "aerial-equipment-toyota-tonero-28",
              "name": "TONERO 28",
              "subcategories": []
            },
            {
              "id": "aerial-equipment-toyota-tonero-68",
              "name": "TONERO 68",
              "subcategories": []
            },
            {
              "id": "aerial-equipment-toyota-2fb",
              "name": "2FB",
              "subcategories": []
            },
            {
              "id": "aerial-equipment-toyota-2fbca",
              "name": "2FBCA",
              "subcategories": []
            },
            {
              "id": "aerial-equipment-toyota-2fbcu",
              "name": "2FBCU",
              "subcategories": []
            },
            {
              "id": "aerial-equipment-toyota-2fd",
              "name": "2FD",
              "subcategories": []
            },
            {
              "id": "aerial-equipment-toyota-2fg",
              "name": "2FG",
              "subcategories": []
            },
            {
              "id": "aerial-equipment-toyota-2fgc",
              "name": "2FGC",
              "subcategories": []
            },
            {
              "id": "aerial-equipment-toyota-2tg",
              "name": "2TG",
              "subcategories": []
            },
            {
              "id": "aerial-equipment-toyota-2thd",
              "name": "2THD",
              "subcategories": []
            },
            {
              "id": "aerial-equipment-toyota-3fb",
              "name": "3FB",
              "subcategories": []
            },
            {
              "id": "aerial-equipment-toyota-3fd",
              "name": "3FD",
              "subcategories": []
            },
            {
              "id": "aerial-equipment-toyota-3fgl",
              "name": "3FGL",
              "subcategories": []
            },
            {
              "id": "aerial-equipment-toyota-4fb25",
              "name": "4FB25",
              "subcategories": []
            },
            {
              "id": "aerial-equipment-toyota-4fg",
              "name": "4FG",
              "subcategories": []
            },
            {
              "id": "aerial-equipment-toyota-5fbc",
              "name": "5FBC",
              "subcategories": []
            },
            {
              "id": "aerial-equipment-toyota-5fbcu",
              "name": "5FBCU",
              "subcategories": []
            },
            {
              "id": "aerial-equipment-toyota-5fbe",
              "name": "5FBE",
              "subcategories": []
            },
            {
              "id": "aerial-equipment-toyota-5fd",
              "name": "5FD",
              "subcategories": []
            },
            {
              "id": "aerial-equipment-toyota-5fgc",
              "name": "5FGC",
              "subcategories": []
            },
            {
              "id": "aerial-equipment-toyota-6bncu",
              "name": "6BNCU",
              "subcategories": []
            },
            {
              "id": "aerial-equipment-toyota-6bpu",
              "name": "6BPU",
              "subcategories": []
            },
            {
              "id": "aerial-equipment-toyota-6bru",
              "name": "6BRU",
              "subcategories": []
            },
            {
              "id": "aerial-equipment-toyota-6bwc",
              "name": "6BWC",
              "subcategories": []
            },
            {
              "id": "aerial-equipment-toyota-6bwr",
              "name": "6BWR",
              "subcategories": []
            },
            {
              "id": "aerial-equipment-toyota-6bws",
              "name": "6BWS",
              "subcategories": []
            },
            {
              "id": "aerial-equipment-toyota-6fbre",
              "name": "6FBRE",
              "subcategories": []
            },
            {
              "id": "aerial-equipment-toyota-6fdf",
              "name": "6FDF",
              "subcategories": []
            },
            {
              "id": "aerial-equipment-toyota-6fgc",
              "name": "6FGC",
              "subcategories": []
            },
            {
              "id": "aerial-equipment-toyota-6fgu",
              "name": "6FGU",
              "subcategories": []
            },
            {
              "id": "aerial-equipment-toyota-6tb50",
              "name": "6TB50",
              "subcategories": []
            },
            {
              "id": "aerial-equipment-toyota-7bncu",
              "name": "7BNCU",
              "subcategories": []
            },
            {
              "id": "aerial-equipment-toyota-7bpue",
              "name": "7BPUE",
              "subcategories": []
            },
            {
              "id": "aerial-equipment-toyota-7bru",
              "name": "7BRU",
              "subcategories": []
            },
            {
              "id": "aerial-equipment-toyota-7bws",
              "name": "7BWS",
              "subcategories": []
            },
            {
              "id": "aerial-equipment-toyota-7fb",
              "name": "7FB",
              "subcategories": []
            },
            {
              "id": "aerial-equipment-toyota-7fbcu",
              "name": "7FBCU",
              "subcategories": []
            },
            {
              "id": "aerial-equipment-toyota-7fbe",
              "name": "7FBE",
              "subcategories": []
            },
            {
              "id": "aerial-equipment-toyota-7fbef",
              "name": "7FBEF",
              "subcategories": []
            },
            {
              "id": "aerial-equipment-toyota-7fbest",
              "name": "7FBEST",
              "subcategories": []
            },
            {
              "id": "aerial-equipment-toyota-7fbeu",
              "name": "7FBEU",
              "subcategories": []
            },
            {
              "id": "aerial-equipment-toyota-7fbh",
              "name": "7FBH",
              "subcategories": []
            },
            {
              "id": "aerial-equipment-toyota-7fbmf",
              "name": "7FBMF",
              "subcategories": []
            },
            {
              "id": "aerial-equipment-toyota-7fbr",
              "name": "7FBR",
              "subcategories": []
            },
            {
              "id": "aerial-equipment-toyota-7fd",
              "name": "7FD",
              "subcategories": []
            },
            {
              "id": "aerial-equipment-toyota-7fda",
              "name": "7FDA",
              "subcategories": []
            },
            {
              "id": "aerial-equipment-toyota-7fdku",
              "name": "7FDKU",
              "subcategories": []
            },
            {
              "id": "aerial-equipment-toyota-7fdn",
              "name": "7FDN",
              "subcategories": []
            },
            {
              "id": "aerial-equipment-toyota-7fdu",
              "name": "7FDU",
              "subcategories": []
            },
            {
              "id": "aerial-equipment-toyota-7fg",
              "name": "7FG",
              "subcategories": []
            },
            {
              "id": "aerial-equipment-toyota-7fgau",
              "name": "7FGAU",
              "subcategories": []
            },
            {
              "id": "aerial-equipment-toyota-7fgcu",
              "name": "7FGCU",
              "subcategories": []
            },
            {
              "id": "aerial-equipment-toyota-7fgcsu",
              "name": "7FGCSU",
              "subcategories": []
            },
            {
              "id": "aerial-equipment-toyota-7fgku",
              "name": "7FGKU",
              "subcategories": []
            },
            {
              "id": "aerial-equipment-toyota-7fgl",
              "name": "7FGL",
              "subcategories": []
            },
            {
              "id": "aerial-equipment-toyota-7fgu",
              "name": "7FGU",
              "subcategories": []
            },
            {
              "id": "aerial-equipment-toyota-7hbw",
              "name": "7HBW",
              "subcategories": []
            },
            {
              "id": "aerial-equipment-toyota-7tb",
              "name": "7TB",
              "subcategories": []
            },
            {
              "id": "aerial-equipment-toyota-8bdru",
              "name": "8BDRU",
              "subcategories": []
            },
            {
              "id": "aerial-equipment-toyota-8bncu",
              "name": "8BNCU",
              "subcategories": []
            },
            {
              "id": "aerial-equipment-toyota-8bpu",
              "name": "8BPU",
              "subcategories": []
            },
            {
              "id": "aerial-equipment-toyota-8bpue",
              "name": "8BPUE",
              "subcategories": []
            },
            {
              "id": "aerial-equipment-toyota-8bpuh",
              "name": "8BPUH",
              "subcategories": []
            },
            {
              "id": "aerial-equipment-toyota-8bru",
              "name": "8BRU",
              "subcategories": []
            },
            {
              "id": "aerial-equipment-toyota-8bws",
              "name": "8BWS",
              "subcategories": []
            },
            {
              "id": "aerial-equipment-toyota-8fb",
              "name": "8FB",
              "subcategories": []
            },
            {
              "id": "aerial-equipment-toyota-8fbc",
              "name": "8FBC",
              "subcategories": []
            },
            {
              "id": "aerial-equipment-toyota-8fbchu",
              "name": "8FBCHU",
              "subcategories": []
            },
            {
              "id": "aerial-equipment-toyota-8fbcu",
              "name": "8FBCU",
              "subcategories": []
            },
            {
              "id": "aerial-equipment-toyota-8fbe",
              "name": "8FBE",
              "subcategories": []
            },
            {
              "id": "aerial-equipment-toyota-8fbek",
              "name": "8FBEK",
              "subcategories": []
            },
            {
              "id": "aerial-equipment-toyota-8fbes",
              "name": "8FBES",
              "subcategories": []
            },
            {
              "id": "aerial-equipment-toyota-8fbet",
              "name": "8FBET",
              "subcategories": []
            },
            {
              "id": "aerial-equipment-toyota-8fbm",
              "name": "8FBM",
              "subcategories": []
            },
            {
              "id": "aerial-equipment-toyota-8fbmkt",
              "name": "8FBMKT",
              "subcategories": []
            },
            {
              "id": "aerial-equipment-toyota-8fbmt",
              "name": "8FBMT",
              "subcategories": []
            },
            {
              "id": "aerial-equipment-toyota-8fd",
              "name": "8FD",
              "subcategories": []
            },
            {
              "id": "aerial-equipment-toyota-8fdf",
              "name": "8FDF",
              "subcategories": []
            },
            {
              "id": "aerial-equipment-toyota-8fdu",
              "name": "8FDU",
              "subcategories": []
            },
            {
              "id": "aerial-equipment-toyota-8fg",
              "name": "8FG",
              "subcategories": []
            },
            {
              "id": "aerial-equipment-toyota-8fgc",
              "name": "8FGC",
              "subcategories": []
            },
            {
              "id": "aerial-equipment-toyota-8fgcu",
              "name": "8FGCU",
              "subcategories": []
            },
            {
              "id": "aerial-equipment-toyota-8fgu",
              "name": "8FGU",
              "subcategories": []
            },
            {
              "id": "aerial-equipment-toyota-8hbc",
              "name": "8HBC",
              "subcategories": []
            },
            {
              "id": "aerial-equipment-toyota-8hbe",
              "name": "8HBE",
              "subcategories": []
            },
            {
              "id": "aerial-equipment-toyota-8hbw",
              "name": "8HBW",
              "subcategories": []
            },
            {
              "id": "aerial-equipment-toyota-8tb",
              "name": "8TB",
              "subcategories": []
            },
            {
              "id": "aerial-equipment-toyota-9bdru",
              "name": "9BDRU",
              "subcategories": []
            },
            {
              "id": "aerial-equipment-toyota-9bru",
              "name": "9BRU",
              "subcategories": []
            },
            {
              "id": "aerial-equipment-toyota-9fbh",
              "name": "9FBH",
              "subcategories": []
            },
            {
              "id": "aerial-equipment-toyota-9fbm",
              "name": "9FBM",
              "subcategories": []
            },
            {
              "id": "aerial-equipment-toyota-305fbcu",
              "name": "305FBCU",
              "subcategories": []
            },
            {
              "id": "aerial-equipment-toyota-307fbcu",
              "name": "307FBCU",
              "subcategories": []
            },
            {
              "id": "aerial-equipment-toyota-328fg",
              "name": "328FG",
              "subcategories": []
            },
            {
              "id": "aerial-equipment-toyota-408fd",
              "name": "408FD",
              "subcategories": []
            },
            {
              "id": "aerial-equipment-toyota-424fg",
              "name": "424FG",
              "subcategories": []
            },
            {
              "id": "aerial-equipment-toyota-425fg",
              "name": "425FG",
              "subcategories": []
            },
            {
              "id": "aerial-equipment-toyota-425fgf",
              "name": "425FGF",
              "subcategories": []
            },
            {
              "id": "aerial-equipment-toyota-426fd",
              "name": "426FD",
              "subcategories": []
            },
            {
              "id": "aerial-equipment-toyota-426fg",
              "name": "426FG",
              "subcategories": []
            },
            {
              "id": "aerial-equipment-toyota-426fgcu",
              "name": "426FGCU",
              "subcategories": []
            },
            {
              "id": "aerial-equipment-toyota-426fgu",
              "name": "426FGU",
              "subcategories": []
            },
            {
              "id": "aerial-equipment-toyota-427fd",
              "name": "427FD",
              "subcategories": []
            },
            {
              "id": "aerial-equipment-toyota-427fda",
              "name": "427FDA",
              "subcategories": []
            },
            {
              "id": "aerial-equipment-toyota-427fg",
              "name": "427FG",
              "subcategories": []
            },
            {
              "id": "aerial-equipment-toyota-505fd",
              "name": "505FD",
              "subcategories": []
            },
            {
              "id": "aerial-equipment-toyota-508fgcu",
              "name": "508FGCU",
              "subcategories": []
            },
            {
              "id": "aerial-equipment-toyota-508fgu",
              "name": "508FGU",
              "subcategories": []
            },
            {
              "id": "aerial-equipment-toyota-526fgcu",
              "name": "526FGCU",
              "subcategories": []
            },
            {
              "id": "aerial-equipment-toyota-526fgu",
              "name": "526FGU",
              "subcategories": []
            },
            {
              "id": "aerial-equipment-toyota-528fdf",
              "name": "528FDF",
              "subcategories": []
            },
            {
              "id": "aerial-equipment-toyota-528fdjf",
              "name": "528FDJF",
              "subcategories": []
            },
            {
              "id": "aerial-equipment-toyota-623fdf",
              "name": "623FDF",
              "subcategories": []
            },
            {
              "id": "aerial-equipment-toyota-626fdf",
              "name": "626FDF",
              "subcategories": []
            },
            {
              "id": "aerial-equipment-toyota-627fdf",
              "name": "627FDF",
              "subcategories": []
            },
            {
              "id": "aerial-equipment-toyota-628fd",
              "name": "628FD",
              "subcategories": []
            },
            {
              "id": "aerial-equipment-toyota-728fd",
              "name": "728FD",
              "subcategories": []
            },
            {
              "id": "aerial-equipment-toyota-bt",
              "name": "BT",
              "subcategories": []
            },
            {
              "id": "aerial-equipment-toyota-cbt4",
              "name": "CBT4",
              "subcategories": []
            },
            {
              "id": "aerial-equipment-toyota-cbt6",
              "name": "CBT6",
              "subcategories": []
            },
            {
              "id": "aerial-equipment-toyota-cbty",
              "name": "CBTY",
              "subcategories": []
            },
            {
              "id": "aerial-equipment-toyota-fbesf",
              "name": "FBESF",
              "subcategories": []
            },
            {
              "id": "aerial-equipment-toyota-fbmf",
              "name": "FBMF",
              "subcategories": []
            },
            {
              "id": "aerial-equipment-toyota-fd",
              "name": "FD",
              "subcategories": []
            },
            {
              "id": "aerial-equipment-toyota-fdzn",
              "name": "FDZN",
              "subcategories": []
            },
            {
              "id": "aerial-equipment-toyota-fg",
              "name": "FG",
              "subcategories": []
            },
            {
              "id": "aerial-equipment-toyota-fgc",
              "name": "FGC",
              "subcategories": []
            },
            {
              "id": "aerial-equipment-toyota-geneo",
              "name": "GENEO",
              "subcategories": []
            },
            {
              "id": "aerial-equipment-toyota-kx5h",
              "name": "KX5H",
              "subcategories": []
            },
            {
              "id": "aerial-equipment-toyota-lhe",
              "name": "LHE",
              "subcategories": []
            },
            {
              "id": "aerial-equipment-toyota-lpe",
              "name": "LPE",
              "subcategories": []
            },
            {
              "id": "aerial-equipment-toyota-rf1-bh",
              "name": "RF1-BH",
              "subcategories": []
            },
            {
              "id": "aerial-equipment-toyota-rre",
              "name": "RRE",
              "subcategories": []
            },
            {
              "id": "aerial-equipment-toyota-sll",
              "name": "SLL",
              "subcategories": []
            },
            {
              "id": "aerial-equipment-toyota-spe",
              "name": "SPE",
              "subcategories": []
            },
            {
              "id": "aerial-equipment-toyota-sse",
              "name": "SSE",
              "subcategories": []
            },
            {
              "id": "aerial-equipment-toyota-swe",
              "name": "SWE",
              "subcategories": []
            },
            {
              "id": "aerial-equipment-toyota-thd",
              "name": "THD",
              "subcategories": []
            },
            {
              "id": "aerial-equipment-toyota-thda",
              "name": "THDA",
              "subcategories": []
            },
            {
              "id": "aerial-equipment-toyota-thdc",
              "name": "THDC",
              "subcategories": []
            },
            {
              "id": "aerial-equipment-toyota-thdm",
              "name": "THDM",
              "subcategories": []
            },
            {
              "id": "aerial-equipment-toyota-toro-max",
              "name": "TORO-MAX",
              "subcategories": []
            },
            {
              "id": "aerial-equipment-toyota-other",
              "name": "OTHER",
              "subcategories": []
            }
          ]
        },
        {
          "id": "aerial-equipment-hyster",
          "name": "Hyster",
          "subcategories": [
            {
              "id": "aerial-equipment-hyster-30tx",
              "name": "30TX",
              "subcategories": []
            },
            {
              "id": "aerial-equipment-hyster-50lp",
              "name": "50LP",
              "subcategories": []
            },
            {
              "id": "aerial-equipment-hyster-a1",
              "name": "A1",
              "subcategories": []
            },
            {
              "id": "aerial-equipment-hyster-b60",
              "name": "B60",
              "subcategories": []
            },
            {
              "id": "aerial-equipment-hyster-b80",
              "name": "B80",
              "subcategories": []
            },
            {
              "id": "aerial-equipment-hyster-be80",
              "name": "BE80",
              "subcategories": []
            },
            {
              "id": "aerial-equipment-hyster-be100",
              "name": "BE100",
              "subcategories": []
            },
            {
              "id": "aerial-equipment-hyster-challenger-80",
              "name": "CHALLENGER 80",
              "subcategories": []
            },
            {
              "id": "aerial-equipment-hyster-challenger-150",
              "name": "CHALLENGER 150",
              "subcategories": []
            },
            {
              "id": "aerial-equipment-hyster-e1-75",
              "name": "E1.75",
              "subcategories": []
            },
            {
              "id": "aerial-equipment-hyster-e5-5xn",
              "name": "E5.5XN",
              "subcategories": []
            },
            {
              "id": "aerial-equipment-hyster-e5-50",
              "name": "E5.50",
              "subcategories": []
            },
            {
              "id": "aerial-equipment-hyster-e25",
              "name": "E25",
              "subcategories": []
            },
            {
              "id": "aerial-equipment-hyster-e30",
              "name": "E30",
              "subcategories": []
            },
            {
              "id": "aerial-equipment-hyster-e35",
              "name": "E35",
              "subcategories": []
            },
            {
              "id": "aerial-equipment-hyster-e40",
              "name": "E40",
              "subcategories": []
            },
            {
              "id": "aerial-equipment-hyster-e45",
              "name": "E45",
              "subcategories": []
            },
            {
              "id": "aerial-equipment-hyster-e50",
              "name": "E50",
              "subcategories": []
            },
            {
              "id": "aerial-equipment-hyster-e55",
              "name": "E55",
              "subcategories": []
            },
            {
              "id": "aerial-equipment-hyster-e60",
              "name": "E60",
              "subcategories": []
            },
            {
              "id": "aerial-equipment-hyster-e65",
              "name": "E65",
              "subcategories": []
            },
            {
              "id": "aerial-equipment-hyster-e70",
              "name": "E70",
              "subcategories": []
            },
            {
              "id": "aerial-equipment-hyster-e80",
              "name": "E80",
              "subcategories": []
            },
            {
              "id": "aerial-equipment-hyster-e100",
              "name": "E100",
              "subcategories": []
            },
            {
              "id": "aerial-equipment-hyster-e120",
              "name": "E120",
              "subcategories": []
            },
            {
              "id": "aerial-equipment-hyster-h1-25",
              "name": "H1.25",
              "subcategories": []
            },
            {
              "id": "aerial-equipment-hyster-h1-8",
              "name": "H1.8",
              "subcategories": []
            },
            {
              "id": "aerial-equipment-hyster-h2-0",
              "name": "H2.0",
              "subcategories": []
            },
            {
              "id": "aerial-equipment-hyster-h2-00",
              "name": "H2.00",
              "subcategories": []
            },
            {
              "id": "aerial-equipment-hyster-h2-5",
              "name": "H2.5",
              "subcategories": []
            },
            {
              "id": "aerial-equipment-hyster-h2-50",
              "name": "H2.50",
              "subcategories": []
            },
            {
              "id": "aerial-equipment-hyster-h3-0",
              "name": "H3.0",
              "subcategories": []
            },
            {
              "id": "aerial-equipment-hyster-h3-00",
              "name": "H3.00",
              "subcategories": []
            },
            {
              "id": "aerial-equipment-hyster-h3-20",
              "name": "H3.20",
              "subcategories": []
            },
            {
              "id": "aerial-equipment-hyster-h3-5",
              "name": "H3.5",
              "subcategories": []
            },
            {
              "id": "aerial-equipment-hyster-h4-0",
              "name": "H4.0",
              "subcategories": []
            },
            {
              "id": "aerial-equipment-hyster-h4-00",
              "name": "H4.00",
              "subcategories": []
            },
            {
              "id": "aerial-equipment-hyster-h4-5",
              "name": "H4.5",
              "subcategories": []
            },
            {
              "id": "aerial-equipment-hyster-h5-00",
              "name": "H5.00",
              "subcategories": []
            },
            {
              "id": "aerial-equipment-hyster-h5-0",
              "name": "H5.0",
              "subcategories": []
            },
            {
              "id": "aerial-equipment-hyster-h5-50",
              "name": "H5.50",
              "subcategories": []
            },
            {
              "id": "aerial-equipment-hyster-h5-5",
              "name": "H5.5",
              "subcategories": []
            },
            {
              "id": "aerial-equipment-hyster-h7-0",
              "name": "H7.0",
              "subcategories": []
            },
            {
              "id": "aerial-equipment-hyster-h7-00",
              "name": "H7.00",
              "subcategories": []
            },
            {
              "id": "aerial-equipment-hyster-h8-0",
              "name": "H8.0",
              "subcategories": []
            },
            {
              "id": "aerial-equipment-hyster-h8-00",
              "name": "H8.00",
              "subcategories": []
            },
            {
              "id": "aerial-equipment-hyster-h10-00",
              "name": "H10.00",
              "subcategories": []
            },
            {
              "id": "aerial-equipment-hyster-h12",
              "name": "H12",
              "subcategories": []
            },
            {
              "id": "aerial-equipment-hyster-h12-00",
              "name": "H12.00",
              "subcategories": []
            },
            {
              "id": "aerial-equipment-hyster-h14-00",
              "name": "H14.00",
              "subcategories": []
            },
            {
              "id": "aerial-equipment-hyster-h15-00",
              "name": "H15.00",
              "subcategories": []
            },
            {
              "id": "aerial-equipment-hyster-h16-00",
              "name": "H16.00",
              "subcategories": []
            },
            {
              "id": "aerial-equipment-hyster-h16",
              "name": "H16",
              "subcategories": []
            },
            {
              "id": "aerial-equipment-hyster-h18-00",
              "name": "H18.00",
              "subcategories": []
            },
            {
              "id": "aerial-equipment-hyster-h18",
              "name": "H18",
              "subcategories": []
            },
            {
              "id": "aerial-equipment-hyster-h20",
              "name": "H20",
              "subcategories": []
            },
            {
              "id": "aerial-equipment-hyster-h22",
              "name": "H22",
              "subcategories": []
            },
            {
              "id": "aerial-equipment-hyster-h22-00",
              "name": "H22.00",
              "subcategories": []
            },
            {
              "id": "aerial-equipment-hyster-h23",
              "name": "H23",
              "subcategories": []
            },
            {
              "id": "aerial-equipment-hyster-h25",
              "name": "H25",
              "subcategories": []
            },
            {
              "id": "aerial-equipment-hyster-h30",
              "name": "H30",
              "subcategories": []
            },
            {
              "id": "aerial-equipment-hyster-h32-00",
              "name": "H32.00",
              "subcategories": []
            },
            {
              "id": "aerial-equipment-hyster-h32-00",
              "name": "H32.00",
              "subcategories": []
            },
            {
              "id": "aerial-equipment-hyster-h35",
              "name": "H35",
              "subcategories": []
            },
            {
              "id": "aerial-equipment-hyster-h40-00",
              "name": "H40.00",
              "subcategories": []
            },
            {
              "id": "aerial-equipment-hyster-h4",
              "name": "H4",
              "subcategories": []
            },
            {
              "id": "aerial-equipment-hyster-h44",
              "name": "H44",
              "subcategories": []
            },
            {
              "id": "aerial-equipment-hyster-h44-00",
              "name": "H44.00",
              "subcategories": []
            },
            {
              "id": "aerial-equipment-hyster-h48-00",
              "name": "H48.00",
              "subcategories": []
            },
            {
              "id": "aerial-equipment-hyster-h50",
              "name": "H50",
              "subcategories": []
            },
            {
              "id": "aerial-equipment-hyster-h52-00",
              "name": "H52.00",
              "subcategories": []
            },
            {
              "id": "aerial-equipment-hyster-h60",
              "name": "H60",
              "subcategories": []
            },
            {
              "id": "aerial-equipment-hyster-h65",
              "name": "H65",
              "subcategories": []
            },
            {
              "id": "aerial-equipment-hyster-h70",
              "name": "H70",
              "subcategories": []
            },
            {
              "id": "aerial-equipment-hyster-h80",
              "name": "H80",
              "subcategories": []
            },
            {
              "id": "aerial-equipment-hyster-h90",
              "name": "H90",
              "subcategories": []
            },
            {
              "id": "aerial-equipment-hyster-h100",
              "name": "H100",
              "subcategories": []
            },
            {
              "id": "aerial-equipment-hyster-h110",
              "name": "H110",
              "subcategories": []
            },
            {
              "id": "aerial-equipment-hyster-h120",
              "name": "H120",
              "subcategories": []
            },
            {
              "id": "aerial-equipment-hyster-h135",
              "name": "H135",
              "subcategories": []
            },
            {
              "id": "aerial-equipment-hyster-h150",
              "name": "H150",
              "subcategories": []
            },
            {
              "id": "aerial-equipment-hyster-h155",
              "name": "H155",
              "subcategories": []
            },
            {
              "id": "aerial-equipment-hyster-h165",
              "name": "H165",
              "subcategories": []
            },
            {
              "id": "aerial-equipment-hyster-h170",
              "name": "H170",
              "subcategories": []
            },
            {
              "id": "aerial-equipment-hyster-h175",
              "name": "H175",
              "subcategories": []
            },
            {
              "id": "aerial-equipment-hyster-h180",
              "name": "H180",
              "subcategories": []
            },
            {
              "id": "aerial-equipment-hyster-h190",
              "name": "H190",
              "subcategories": []
            },
            {
              "id": "aerial-equipment-hyster-h200",
              "name": "H200",
              "subcategories": []
            },
            {
              "id": "aerial-equipment-hyster-h210",
              "name": "H210",
              "subcategories": []
            },
            {
              "id": "aerial-equipment-hyster-h230",
              "name": "H230",
              "subcategories": []
            },
            {
              "id": "aerial-equipment-hyster-h250",
              "name": "H250",
              "subcategories": []
            },
            {
              "id": "aerial-equipment-hyster-h280",
              "name": "H280",
              "subcategories": []
            },
            {
              "id": "aerial-equipment-hyster-h300",
              "name": "H300",
              "subcategories": []
            },
            {
              "id": "aerial-equipment-hyster-h330",
              "name": "H330",
              "subcategories": []
            },
            {
              "id": "aerial-equipment-hyster-h350",
              "name": "H350",
              "subcategories": []
            },
            {
              "id": "aerial-equipment-hyster-h360",
              "name": "H360",
              "subcategories": []
            },
            {
              "id": "aerial-equipment-hyster-h400",
              "name": "H400",
              "subcategories": []
            },
            {
              "id": "aerial-equipment-hyster-h440",
              "name": "H440",
              "subcategories": []
            },
            {
              "id": "aerial-equipment-hyster-h450",
              "name": "H450",
              "subcategories": []
            },
            {
              "id": "aerial-equipment-hyster-h500",
              "name": "H500",
              "subcategories": []
            },
            {
              "id": "aerial-equipment-hyster-h520",
              "name": "H520",
              "subcategories": []
            },
            {
              "id": "aerial-equipment-hyster-h550",
              "name": "H550",
              "subcategories": []
            },
            {
              "id": "aerial-equipment-hyster-h620",
              "name": "H620",
              "subcategories": []
            },
            {
              "id": "aerial-equipment-hyster-h650",
              "name": "H650",
              "subcategories": []
            },
            {
              "id": "aerial-equipment-hyster-h700",
              "name": "H700",
              "subcategories": []
            },
            {
              "id": "aerial-equipment-hyster-h1050",
              "name": "H1050",
              "subcategories": []
            },
            {
              "id": "aerial-equipment-hyster-h1150",
              "name": "H1150",
              "subcategories": []
            },
            {
              "id": "aerial-equipment-hyster-hr45",
              "name": "HR45",
              "subcategories": []
            },
            {
              "id": "aerial-equipment-hyster-hy55",
              "name": "HY55",
              "subcategories": []
            },
            {
              "id": "aerial-equipment-hyster-j1-5",
              "name": "J1.5",
              "subcategories": []
            },
            {
              "id": "aerial-equipment-hyster-j1-6",
              "name": "J1.6",
              "subcategories": []
            },
            {
              "id": "aerial-equipment-hyster-j1-60",
              "name": "J1.60",
              "subcategories": []
            },
            {
              "id": "aerial-equipment-hyster-j1-80",
              "name": "J1.80",
              "subcategories": []
            },
            {
              "id": "aerial-equipment-hyster-j1-8",
              "name": "J1.8",
              "subcategories": []
            },
            {
              "id": "aerial-equipment-hyster-j2-0",
              "name": "J2.0",
              "subcategories": []
            },
            {
              "id": "aerial-equipment-hyster-j2-5",
              "name": "J2.5",
              "subcategories": []
            },
            {
              "id": "aerial-equipment-hyster-j3-0",
              "name": "J3.0",
              "subcategories": []
            },
            {
              "id": "aerial-equipment-hyster-j30",
              "name": "J30",
              "subcategories": []
            },
            {
              "id": "aerial-equipment-hyster-j35",
              "name": "J35",
              "subcategories": []
            },
            {
              "id": "aerial-equipment-hyster-j40",
              "name": "J40",
              "subcategories": []
            },
            {
              "id": "aerial-equipment-hyster-j50",
              "name": "J50",
              "subcategories": []
            },
            {
              "id": "aerial-equipment-hyster-j60",
              "name": "J60",
              "subcategories": []
            },
            {
              "id": "aerial-equipment-hyster-lo",
              "name": "LO",
              "subcategories": []
            },
            {
              "id": "aerial-equipment-hyster-n30",
              "name": "N30",
              "subcategories": []
            },
            {
              "id": "aerial-equipment-hyster-n35",
              "name": "N35",
              "subcategories": []
            },
            {
              "id": "aerial-equipment-hyster-n40",
              "name": "N40",
              "subcategories": []
            },
            {
              "id": "aerial-equipment-hyster-n45",
              "name": "N45",
              "subcategories": []
            },
            {
              "id": "aerial-equipment-hyster-p2-0",
              "name": "P2.0",
              "subcategories": []
            },
            {
              "id": "aerial-equipment-hyster-p150",
              "name": "P150",
              "subcategories": []
            },
            {
              "id": "aerial-equipment-hyster-r1-6",
              "name": "R1.6",
              "subcategories": []
            },
            {
              "id": "aerial-equipment-hyster-r2-5",
              "name": "R2.5",
              "subcategories": []
            },
            {
              "id": "aerial-equipment-hyster-r30",
              "name": "R30",
              "subcategories": []
            },
            {
              "id": "aerial-equipment-hyster-rs45",
              "name": "RS45",
              "subcategories": []
            },
            {
              "id": "aerial-equipment-hyster-rs46",
              "name": "RS46",
              "subcategories": []
            },
            {
              "id": "aerial-equipment-hyster-s3-0",
              "name": "S3.0",
              "subcategories": []
            },
            {
              "id": "aerial-equipment-hyster-s6-00",
              "name": "S6.00",
              "subcategories": []
            },
            {
              "id": "aerial-equipment-hyster-s7-0",
              "name": "S7.0",
              "subcategories": []
            },
            {
              "id": "aerial-equipment-hyster-s7-00",
              "name": "S7.00",
              "subcategories": []
            },
            {
              "id": "aerial-equipment-hyster-s25",
              "name": "S25",
              "subcategories": []
            },
            {
              "id": "aerial-equipment-hyster-s30",
              "name": "S30",
              "subcategories": []
            },
            {
              "id": "aerial-equipment-hyster-s35",
              "name": "S35",
              "subcategories": []
            },
            {
              "id": "aerial-equipment-hyster-s40",
              "name": "S40",
              "subcategories": []
            },
            {
              "id": "aerial-equipment-hyster-s50",
              "name": "S50",
              "subcategories": []
            },
            {
              "id": "aerial-equipment-hyster-s55",
              "name": "S55",
              "subcategories": []
            },
            {
              "id": "aerial-equipment-hyster-s60",
              "name": "S60",
              "subcategories": []
            },
            {
              "id": "aerial-equipment-hyster-s70",
              "name": "S70",
              "subcategories": []
            },
            {
              "id": "aerial-equipment-hyster-s80",
              "name": "S80",
              "subcategories": []
            },
            {
              "id": "aerial-equipment-hyster-s100",
              "name": "S100",
              "subcategories": []
            },
            {
              "id": "aerial-equipment-hyster-s120",
              "name": "S120",
              "subcategories": []
            },
            {
              "id": "aerial-equipment-hyster-s135",
              "name": "S135",
              "subcategories": []
            },
            {
              "id": "aerial-equipment-hyster-s150",
              "name": "S150",
              "subcategories": []
            },
            {
              "id": "aerial-equipment-hyster-s155",
              "name": "S155",
              "subcategories": []
            },
            {
              "id": "aerial-equipment-hyster-s180",
              "name": "S180",
              "subcategories": []
            },
            {
              "id": "aerial-equipment-hyster-s200",
              "name": "S200",
              "subcategories": []
            },
            {
              "id": "aerial-equipment-hyster-t5z",
              "name": "T5Z",
              "subcategories": []
            },
            {
              "id": "aerial-equipment-hyster-t7zac",
              "name": "T7ZAC",
              "subcategories": []
            },
            {
              "id": "aerial-equipment-hyster-v35",
              "name": "V35",
              "subcategories": []
            },
            {
              "id": "aerial-equipment-hyster-w20",
              "name": "W20",
              "subcategories": []
            },
            {
              "id": "aerial-equipment-hyster-w25",
              "name": "W25",
              "subcategories": []
            },
            {
              "id": "aerial-equipment-hyster-w30",
              "name": "W30",
              "subcategories": []
            },
            {
              "id": "aerial-equipment-hyster-w40",
              "name": "W40",
              "subcategories": []
            },
            {
              "id": "aerial-equipment-hyster-w45",
              "name": "W45",
              "subcategories": []
            },
            {
              "id": "aerial-equipment-hyster-w80",
              "name": "W80",
              "subcategories": []
            },
            {
              "id": "aerial-equipment-hyster-z90",
              "name": "Z90",
              "subcategories": []
            },
            {
              "id": "aerial-equipment-hyster-h48",
              "name": "H48",
              "subcategories": []
            },
            {
              "id": "aerial-equipment-hyster-other",
              "name": "OTHER",
              "subcategories": []
            }
          ]
        },
        {
          "id": "aerial-equipment-caterpillar",
          "name": "Caterpillar",
          "subcategories": [
            {
              "id": "aerial-equipment-caterpillar-2c",
              "name": "2C",
              "subcategories": []
            },
            {
              "id": "aerial-equipment-caterpillar-2ec",
              "name": "2EC",
              "subcategories": []
            },
            {
              "id": "aerial-equipment-caterpillar-2ep",
              "name": "2EP",
              "subcategories": []
            },
            {
              "id": "aerial-equipment-caterpillar-2epc",
              "name": "2EPC",
              "subcategories": []
            },
            {
              "id": "aerial-equipment-caterpillar-2et",
              "name": "2ET",
              "subcategories": []
            },
            {
              "id": "aerial-equipment-caterpillar-2p",
              "name": "2P",
              "subcategories": []
            },
            {
              "id": "aerial-equipment-caterpillar-2pd",
              "name": "2PD",
              "subcategories": []
            },
            {
              "id": "aerial-equipment-caterpillar-499a",
              "name": "499A",
              "subcategories": []
            },
            {
              "id": "aerial-equipment-caterpillar-ah40",
              "name": "AH40",
              "subcategories": []
            },
            {
              "id": "aerial-equipment-caterpillar-ah60",
              "name": "AH60",
              "subcategories": []
            },
            {
              "id": "aerial-equipment-caterpillar-b10",
              "name": "B10",
              "subcategories": []
            },
            {
              "id": "aerial-equipment-caterpillar-c3000",
              "name": "C3000",
              "subcategories": []
            },
            {
              "id": "aerial-equipment-caterpillar-c3500",
              "name": "C3500",
              "subcategories": []
            },
            {
              "id": "aerial-equipment-caterpillar-c4000",
              "name": "C4000",
              "subcategories": []
            },
            {
              "id": "aerial-equipment-caterpillar-c5000",
              "name": "C5000",
              "subcategories": []
            },
            {
              "id": "aerial-equipment-caterpillar-c6000",
              "name": "C6000",
              "subcategories": []
            },
            {
              "id": "aerial-equipment-caterpillar-c6500",
              "name": "C6500",
              "subcategories": []
            },
            {
              "id": "aerial-equipment-caterpillar-cc4000",
              "name": "CC4000",
              "subcategories": []
            },
            {
              "id": "aerial-equipment-caterpillar-dp15",
              "name": "DP15",
              "subcategories": []
            },
            {
              "id": "aerial-equipment-caterpillar-dp18",
              "name": "DP18",
              "subcategories": []
            },
            {
              "id": "aerial-equipment-caterpillar-dp20",
              "name": "DP20",
              "subcategories": []
            },
            {
              "id": "aerial-equipment-caterpillar-dp25",
              "name": "DP25",
              "subcategories": []
            },
            {
              "id": "aerial-equipment-caterpillar-dp30",
              "name": "DP30",
              "subcategories": []
            },
            {
              "id": "aerial-equipment-caterpillar-dp33",
              "name": "DP33",
              "subcategories": []
            },
            {
              "id": "aerial-equipment-caterpillar-dp35",
              "name": "DP35",
              "subcategories": []
            },
            {
              "id": "aerial-equipment-caterpillar-dp40",
              "name": "DP40",
              "subcategories": []
            },
            {
              "id": "aerial-equipment-caterpillar-dp45",
              "name": "DP45",
              "subcategories": []
            },
            {
              "id": "aerial-equipment-caterpillar-dp50",
              "name": "DP50",
              "subcategories": []
            },
            {
              "id": "aerial-equipment-caterpillar-dp55",
              "name": "DP55",
              "subcategories": []
            },
            {
              "id": "aerial-equipment-caterpillar-dp70",
              "name": "DP70",
              "subcategories": []
            },
            {
              "id": "aerial-equipment-caterpillar-dp80",
              "name": "DP80",
              "subcategories": []
            },
            {
              "id": "aerial-equipment-caterpillar-dp90",
              "name": "DP90",
              "subcategories": []
            },
            {
              "id": "aerial-equipment-caterpillar-dp100",
              "name": "DP100",
              "subcategories": []
            },
            {
              "id": "aerial-equipment-caterpillar-dp115",
              "name": "DP115",
              "subcategories": []
            },
            {
              "id": "aerial-equipment-caterpillar-dp120",
              "name": "DP120",
              "subcategories": []
            },
            {
              "id": "aerial-equipment-caterpillar-dp135",
              "name": "DP135",
              "subcategories": []
            },
            {
              "id": "aerial-equipment-caterpillar-dp150",
              "name": "DP150",
              "subcategories": []
            },
            {
              "id": "aerial-equipment-caterpillar-dv43",
              "name": "DV43",
              "subcategories": []
            },
            {
              "id": "aerial-equipment-caterpillar-e3000",
              "name": "E3000",
              "subcategories": []
            },
            {
              "id": "aerial-equipment-caterpillar-e3500",
              "name": "E3500",
              "subcategories": []
            },
            {
              "id": "aerial-equipment-caterpillar-e4000",
              "name": "E4000",
              "subcategories": []
            },
            {
              "id": "aerial-equipment-caterpillar-e5000",
              "name": "E5000",
              "subcategories": []
            },
            {
              "id": "aerial-equipment-caterpillar-e5500",
              "name": "E5500",
              "subcategories": []
            },
            {
              "id": "aerial-equipment-caterpillar-e6000",
              "name": "E6000",
              "subcategories": []
            },
            {
              "id": "aerial-equipment-caterpillar-e6500",
              "name": "E6500",
              "subcategories": []
            },
            {
              "id": "aerial-equipment-caterpillar-e12000",
              "name": "E12000",
              "subcategories": []
            },
            {
              "id": "aerial-equipment-caterpillar-ec25",
              "name": "EC25",
              "subcategories": []
            },
            {
              "id": "aerial-equipment-caterpillar-ec30",
              "name": "EC30",
              "subcategories": []
            },
            {
              "id": "aerial-equipment-caterpillar-ec4000",
              "name": "EC4000",
              "subcategories": []
            },
            {
              "id": "aerial-equipment-caterpillar-ep15",
              "name": "EP15",
              "subcategories": []
            },
            {
              "id": "aerial-equipment-caterpillar-ep16",
              "name": "EP16",
              "subcategories": []
            },
            {
              "id": "aerial-equipment-caterpillar-ep18",
              "name": "EP18",
              "subcategories": []
            },
            {
              "id": "aerial-equipment-caterpillar-ep20",
              "name": "EP20",
              "subcategories": []
            },
            {
              "id": "aerial-equipment-caterpillar-ep25",
              "name": "EP25",
              "subcategories": []
            },
            {
              "id": "aerial-equipment-caterpillar-ep30",
              "name": "EP30",
              "subcategories": []
            },
            {
              "id": "aerial-equipment-caterpillar-ep3000",
              "name": "EP3000",
              "subcategories": []
            },
            {
              "id": "aerial-equipment-caterpillar-ex5000",
              "name": "EX5000",
              "subcategories": []
            },
            {
              "id": "aerial-equipment-caterpillar-f30",
              "name": "F30",
              "subcategories": []
            },
            {
              "id": "aerial-equipment-caterpillar-f35",
              "name": "F35",
              "subcategories": []
            },
            {
              "id": "aerial-equipment-caterpillar-fg25",
              "name": "FG25",
              "subcategories": []
            },
            {
              "id": "aerial-equipment-caterpillar-fg35",
              "name": "FG35",
              "subcategories": []
            },
            {
              "id": "aerial-equipment-caterpillar-fgc25",
              "name": "FGC25",
              "subcategories": []
            },
            {
              "id": "aerial-equipment-caterpillar-gc15",
              "name": "GC15",
              "subcategories": []
            },
            {
              "id": "aerial-equipment-caterpillar-gc18",
              "name": "GC18",
              "subcategories": []
            },
            {
              "id": "aerial-equipment-caterpillar-gc25",
              "name": "GC25",
              "subcategories": []
            },
            {
              "id": "aerial-equipment-caterpillar-gc30",
              "name": "GC30",
              "subcategories": []
            },
            {
              "id": "aerial-equipment-caterpillar-gc35",
              "name": "GC35",
              "subcategories": []
            },
            {
              "id": "aerial-equipment-caterpillar-gc40",
              "name": "GC40",
              "subcategories": []
            },
            {
              "id": "aerial-equipment-caterpillar-gc45",
              "name": "GC45",
              "subcategories": []
            },
            {
              "id": "aerial-equipment-caterpillar-gc55",
              "name": "GC55",
              "subcategories": []
            },
            {
              "id": "aerial-equipment-caterpillar-gc60",
              "name": "GC60",
              "subcategories": []
            },
            {
              "id": "aerial-equipment-caterpillar-gc70",
              "name": "GC70",
              "subcategories": []
            },
            {
              "id": "aerial-equipment-caterpillar-gp10",
              "name": "GP10",
              "subcategories": []
            },
            {
              "id": "aerial-equipment-caterpillar-gp15",
              "name": "GP15",
              "subcategories": []
            },
            {
              "id": "aerial-equipment-caterpillar-gp18",
              "name": "GP18",
              "subcategories": []
            },
            {
              "id": "aerial-equipment-caterpillar-gp20",
              "name": "GP20",
              "subcategories": []
            },
            {
              "id": "aerial-equipment-caterpillar-gp25",
              "name": "GP25",
              "subcategories": []
            },
            {
              "id": "aerial-equipment-caterpillar-gp30",
              "name": "GP30",
              "subcategories": []
            },
            {
              "id": "aerial-equipment-caterpillar-gp33",
              "name": "GP33",
              "subcategories": []
            },
            {
              "id": "aerial-equipment-caterpillar-gp35",
              "name": "GP35",
              "subcategories": []
            },
            {
              "id": "aerial-equipment-caterpillar-gp40",
              "name": "GP40",
              "subcategories": []
            },
            {
              "id": "aerial-equipment-caterpillar-gp45",
              "name": "GP45",
              "subcategories": []
            },
            {
              "id": "aerial-equipment-caterpillar-gp50",
              "name": "GP50",
              "subcategories": []
            },
            {
              "id": "aerial-equipment-caterpillar-gp55",
              "name": "GP55",
              "subcategories": []
            },
            {
              "id": "aerial-equipment-caterpillar-gpl40",
              "name": "GPL40",
              "subcategories": []
            },
            {
              "id": "aerial-equipment-caterpillar-m50",
              "name": "M50",
              "subcategories": []
            },
            {
              "id": "aerial-equipment-caterpillar-m100",
              "name": "M100",
              "subcategories": []
            },
            {
              "id": "aerial-equipment-caterpillar-mc30",
              "name": "MC30",
              "subcategories": []
            },
            {
              "id": "aerial-equipment-caterpillar-n020",
              "name": "N020",
              "subcategories": []
            },
            {
              "id": "aerial-equipment-caterpillar-n0r22",
              "name": "N0R22",
              "subcategories": []
            },
            {
              "id": "aerial-equipment-caterpillar-n0r30",
              "name": "N0R30",
              "subcategories": []
            },
            {
              "id": "aerial-equipment-caterpillar-npp16",
              "name": "NPP16",
              "subcategories": []
            },
            {
              "id": "aerial-equipment-caterpillar-npp20",
              "name": "NPP20",
              "subcategories": []
            },
            {
              "id": "aerial-equipment-caterpillar-npp60",
              "name": "NPP60",
              "subcategories": []
            },
            {
              "id": "aerial-equipment-caterpillar-npv20",
              "name": "NPV20",
              "subcategories": []
            },
            {
              "id": "aerial-equipment-caterpillar-npv60",
              "name": "NPV60",
              "subcategories": []
            },
            {
              "id": "aerial-equipment-caterpillar-nr14",
              "name": "NR14",
              "subcategories": []
            },
            {
              "id": "aerial-equipment-caterpillar-nr16",
              "name": "NR16",
              "subcategories": []
            },
            {
              "id": "aerial-equipment-caterpillar-nr20",
              "name": "NR20",
              "subcategories": []
            },
            {
              "id": "aerial-equipment-caterpillar-nr25",
              "name": "NR25",
              "subcategories": []
            },
            {
              "id": "aerial-equipment-caterpillar-nr3000",
              "name": "NR3000",
              "subcategories": []
            },
            {
              "id": "aerial-equipment-caterpillar-nr4000",
              "name": "NR4000",
              "subcategories": []
            },
            {
              "id": "aerial-equipment-caterpillar-nr4500",
              "name": "NR4500",
              "subcategories": []
            },
            {
              "id": "aerial-equipment-caterpillar-nsp12",
              "name": "NSP12",
              "subcategories": []
            },
            {
              "id": "aerial-equipment-caterpillar-nsp16",
              "name": "NSP16",
              "subcategories": []
            },
            {
              "id": "aerial-equipment-caterpillar-p3000",
              "name": "P3000",
              "subcategories": []
            },
            {
              "id": "aerial-equipment-caterpillar-p5000",
              "name": "P5000",
              "subcategories": []
            },
            {
              "id": "aerial-equipment-caterpillar-p6000",
              "name": "P6000",
              "subcategories": []
            },
            {
              "id": "aerial-equipment-caterpillar-p6500",
              "name": "P6500",
              "subcategories": []
            },
            {
              "id": "aerial-equipment-caterpillar-p7000",
              "name": "P7000",
              "subcategories": []
            },
            {
              "id": "aerial-equipment-caterpillar-p8000",
              "name": "P8000",
              "subcategories": []
            },
            {
              "id": "aerial-equipment-caterpillar-p9000",
              "name": "P9000",
              "subcategories": []
            },
            {
              "id": "aerial-equipment-caterpillar-p10000",
              "name": "P10000",
              "subcategories": []
            },
            {
              "id": "aerial-equipment-caterpillar-p11000",
              "name": "P11000",
              "subcategories": []
            },
            {
              "id": "aerial-equipment-caterpillar-p12000",
              "name": "P12000",
              "subcategories": []
            },
            {
              "id": "aerial-equipment-caterpillar-p33000",
              "name": "P33000",
              "subcategories": []
            },
            {
              "id": "aerial-equipment-caterpillar-p36000",
              "name": "P36000",
              "subcategories": []
            },
            {
              "id": "aerial-equipment-caterpillar-pd8000",
              "name": "PD8000",
              "subcategories": []
            },
            {
              "id": "aerial-equipment-caterpillar-pd10000",
              "name": "PD10000",
              "subcategories": []
            },
            {
              "id": "aerial-equipment-caterpillar-pd11000",
              "name": "PD11000",
              "subcategories": []
            },
            {
              "id": "aerial-equipment-caterpillar-pd12000",
              "name": "PD12000",
              "subcategories": []
            },
            {
              "id": "aerial-equipment-caterpillar-r80",
              "name": "R80",
              "subcategories": []
            },
            {
              "id": "aerial-equipment-caterpillar-rc60",
              "name": "RC60",
              "subcategories": []
            },
            {
              "id": "aerial-equipment-caterpillar-t30",
              "name": "T30",
              "subcategories": []
            },
            {
              "id": "aerial-equipment-caterpillar-t35",
              "name": "T35",
              "subcategories": []
            },
            {
              "id": "aerial-equipment-caterpillar-t40",
              "name": "T40",
              "subcategories": []
            },
            {
              "id": "aerial-equipment-caterpillar-t50",
              "name": "T50",
              "subcategories": []
            },
            {
              "id": "aerial-equipment-caterpillar-t80",
              "name": "T80",
              "subcategories": []
            },
            {
              "id": "aerial-equipment-caterpillar-t125",
              "name": "T125",
              "subcategories": []
            },
            {
              "id": "aerial-equipment-caterpillar-t150",
              "name": "T150",
              "subcategories": []
            },
            {
              "id": "aerial-equipment-caterpillar-t250",
              "name": "T250",
              "subcategories": []
            },
            {
              "id": "aerial-equipment-caterpillar-t300",
              "name": "T300",
              "subcategories": []
            },
            {
              "id": "aerial-equipment-caterpillar-tc30",
              "name": "TC30",
              "subcategories": []
            },
            {
              "id": "aerial-equipment-caterpillar-tc60",
              "name": "TC60",
              "subcategories": []
            },
            {
              "id": "aerial-equipment-caterpillar-th62",
              "name": "TH62",
              "subcategories": []
            },
            {
              "id": "aerial-equipment-caterpillar-th63",
              "name": "TH63",
              "subcategories": []
            },
            {
              "id": "aerial-equipment-caterpillar-th83",
              "name": "TH83",
              "subcategories": []
            },
            {
              "id": "aerial-equipment-caterpillar-th103",
              "name": "TH103",
              "subcategories": []
            },
            {
              "id": "aerial-equipment-caterpillar-th220",
              "name": "TH220",
              "subcategories": []
            },
            {
              "id": "aerial-equipment-caterpillar-th255",
              "name": "TH255",
              "subcategories": []
            },
            {
              "id": "aerial-equipment-caterpillar-th314",
              "name": "TH314",
              "subcategories": []
            },
            {
              "id": "aerial-equipment-caterpillar-th330",
              "name": "TH330",
              "subcategories": []
            },
            {
              "id": "aerial-equipment-caterpillar-th336",
              "name": "TH336",
              "subcategories": []
            },
            {
              "id": "aerial-equipment-caterpillar-th337",
              "name": "TH337",
              "subcategories": []
            },
            {
              "id": "aerial-equipment-caterpillar-th340",
              "name": "TH340",
              "subcategories": []
            },
            {
              "id": "aerial-equipment-caterpillar-th350",
              "name": "TH350",
              "subcategories": []
            },
            {
              "id": "aerial-equipment-caterpillar-th357",
              "name": "TH357",
              "subcategories": []
            },
            {
              "id": "aerial-equipment-caterpillar-th360",
              "name": "TH360",
              "subcategories": []
            },
            {
              "id": "aerial-equipment-caterpillar-th406",
              "name": "TH406",
              "subcategories": []
            },
            {
              "id": "aerial-equipment-caterpillar-th407",
              "name": "TH407",
              "subcategories": []
            },
            {
              "id": "aerial-equipment-caterpillar-th408",
              "name": "TH408",
              "subcategories": []
            },
            {
              "id": "aerial-equipment-caterpillar-th414",
              "name": "TH414",
              "subcategories": []
            },
            {
              "id": "aerial-equipment-caterpillar-th417",
              "name": "TH417",
              "subcategories": []
            },
            {
              "id": "aerial-equipment-caterpillar-th460",
              "name": "TH460",
              "subcategories": []
            },
            {
              "id": "aerial-equipment-caterpillar-th514",
              "name": "TH514",
              "subcategories": []
            },
            {
              "id": "aerial-equipment-caterpillar-th560",
              "name": "TH560",
              "subcategories": []
            },
            {
              "id": "aerial-equipment-caterpillar-th580",
              "name": "TH580",
              "subcategories": []
            },
            {
              "id": "aerial-equipment-caterpillar-th3510",
              "name": "TH3510",
              "subcategories": []
            },
            {
              "id": "aerial-equipment-caterpillar-tl642",
              "name": "TL642",
              "subcategories": []
            },
            {
              "id": "aerial-equipment-caterpillar-tl943",
              "name": "TL943",
              "subcategories": []
            },
            {
              "id": "aerial-equipment-caterpillar-tl1055",
              "name": "TL1055",
              "subcategories": []
            },
            {
              "id": "aerial-equipment-caterpillar-tl1255",
              "name": "TL1255",
              "subcategories": []
            },
            {
              "id": "aerial-equipment-caterpillar-v40",
              "name": "V40",
              "subcategories": []
            },
            {
              "id": "aerial-equipment-caterpillar-v50",
              "name": "V50",
              "subcategories": []
            },
            {
              "id": "aerial-equipment-caterpillar-v60",
              "name": "V60",
              "subcategories": []
            },
            {
              "id": "aerial-equipment-caterpillar-v80",
              "name": "V80",
              "subcategories": []
            },
            {
              "id": "aerial-equipment-caterpillar-v90",
              "name": "V90",
              "subcategories": []
            },
            {
              "id": "aerial-equipment-caterpillar-v140",
              "name": "V140",
              "subcategories": []
            },
            {
              "id": "aerial-equipment-caterpillar-v150",
              "name": "V150",
              "subcategories": []
            },
            {
              "id": "aerial-equipment-caterpillar-v180",
              "name": "V180",
              "subcategories": []
            },
            {
              "id": "aerial-equipment-caterpillar-v200",
              "name": "V200",
              "subcategories": []
            },
            {
              "id": "aerial-equipment-caterpillar-v225",
              "name": "V225",
              "subcategories": []
            },
            {
              "id": "aerial-equipment-caterpillar-v250",
              "name": "V250",
              "subcategories": []
            },
            {
              "id": "aerial-equipment-caterpillar-v300",
              "name": "V300",
              "subcategories": []
            },
            {
              "id": "aerial-equipment-caterpillar-v330",
              "name": "V330",
              "subcategories": []
            },
            {
              "id": "aerial-equipment-caterpillar-v550",
              "name": "V550",
              "subcategories": []
            },
            {
              "id": "aerial-equipment-caterpillar-v900",
              "name": "V900",
              "subcategories": []
            },
            {
              "id": "aerial-equipment-caterpillar-vc60",
              "name": "VC60",
              "subcategories": []
            },
            {
              "id": "aerial-equipment-caterpillar-other",
              "name": "OTHER",
              "subcategories": []
            }
          ]
        },
        {
          "id": "aerial-equipment-manitou",
          "name": "Manitou",
          "subcategories": [
            {
              "id": "aerial-equipment-manitou-26vjr",
              "name": "26VJR",
              "subcategories": []
            },
            {
              "id": "aerial-equipment-manitou-78sec",
              "name": "78SEC",
              "subcategories": []
            },
            {
              "id": "aerial-equipment-manitou-100",
              "name": "100",
              "subcategories": []
            },
            {
              "id": "aerial-equipment-manitou-105",
              "name": "105",
              "subcategories": []
            },
            {
              "id": "aerial-equipment-manitou-120",
              "name": "120",
              "subcategories": []
            },
            {
              "id": "aerial-equipment-manitou-140",
              "name": "140",
              "subcategories": []
            },
            {
              "id": "aerial-equipment-manitou-150",
              "name": "150",
              "subcategories": []
            },
            {
              "id": "aerial-equipment-manitou-160",
              "name": "160",
              "subcategories": []
            },
            {
              "id": "aerial-equipment-manitou-170",
              "name": "170",
              "subcategories": []
            },
            {
              "id": "aerial-equipment-manitou-180",
              "name": "180",
              "subcategories": []
            },
            {
              "id": "aerial-equipment-manitou-200",
              "name": "200",
              "subcategories": []
            },
            {
              "id": "aerial-equipment-manitou-220",
              "name": "220",
              "subcategories": []
            },
            {
              "id": "aerial-equipment-manitou-260",
              "name": "260",
              "subcategories": []
            },
            {
              "id": "aerial-equipment-manitou-280",
              "name": "280",
              "subcategories": []
            },
            {
              "id": "aerial-equipment-manitou-aetj",
              "name": "AETJ",
              "subcategories": []
            },
            {
              "id": "aerial-equipment-manitou-atj",
              "name": "ATJ",
              "subcategories": []
            },
            {
              "id": "aerial-equipment-manitou-atj60",
              "name": "ATJ60",
              "subcategories": []
            },
            {
              "id": "aerial-equipment-manitou-bt420",
              "name": "BT420",
              "subcategories": []
            },
            {
              "id": "aerial-equipment-manitou-bt425",
              "name": "BT425",
              "subcategories": []
            },
            {
              "id": "aerial-equipment-manitou-ep15",
              "name": "EP15",
              "subcategories": []
            },
            {
              "id": "aerial-equipment-manitou-ep22",
              "name": "EP22",
              "subcategories": []
            },
            {
              "id": "aerial-equipment-manitou-er",
              "name": "ER",
              "subcategories": []
            },
            {
              "id": "aerial-equipment-manitou-m26",
              "name": "M26",
              "subcategories": []
            },
            {
              "id": "aerial-equipment-manitou-m30",
              "name": "M30",
              "subcategories": []
            },
            {
              "id": "aerial-equipment-manitou-m40",
              "name": "M40",
              "subcategories": []
            },
            {
              "id": "aerial-equipment-manitou-m50",
              "name": "M50",
              "subcategories": []
            },
            {
              "id": "aerial-equipment-manitou-m70",
              "name": "M70",
              "subcategories": []
            },
            {
              "id": "aerial-equipment-manitou-m226",
              "name": "M226",
              "subcategories": []
            },
            {
              "id": "aerial-equipment-manitou-m426",
              "name": "M426",
              "subcategories": []
            },
            {
              "id": "aerial-equipment-manitou-man-go",
              "name": "MAN'GO",
              "subcategories": []
            },
            {
              "id": "aerial-equipment-manitou-mb26",
              "name": "MB26",
              "subcategories": []
            },
            {
              "id": "aerial-equipment-manitou-mb60h",
              "name": "MB60H",
              "subcategories": []
            },
            {
              "id": "aerial-equipment-manitou-mc18",
              "name": "MC18",
              "subcategories": []
            },
            {
              "id": "aerial-equipment-manitou-mc20",
              "name": "MC20",
              "subcategories": []
            },
            {
              "id": "aerial-equipment-manitou-mc25",
              "name": "MC25",
              "subcategories": []
            },
            {
              "id": "aerial-equipment-manitou-mc30",
              "name": "MC30",
              "subcategories": []
            },
            {
              "id": "aerial-equipment-manitou-mc50",
              "name": "MC50",
              "subcategories": []
            },
            {
              "id": "aerial-equipment-manitou-mc70",
              "name": "MC70",
              "subcategories": []
            },
            {
              "id": "aerial-equipment-manitou-me316",
              "name": "ME316",
              "subcategories": []
            },
            {
              "id": "aerial-equipment-manitou-me318",
              "name": "ME318",
              "subcategories": []
            },
            {
              "id": "aerial-equipment-manitou-me320",
              "name": "ME320",
              "subcategories": []
            },
            {
              "id": "aerial-equipment-manitou-me420",
              "name": "ME420",
              "subcategories": []
            },
            {
              "id": "aerial-equipment-manitou-me425",
              "name": "ME425",
              "subcategories": []
            },
            {
              "id": "aerial-equipment-manitou-me430",
              "name": "ME430",
              "subcategories": []
            },
            {
              "id": "aerial-equipment-manitou-mh25",
              "name": "MH25",
              "subcategories": []
            },
            {
              "id": "aerial-equipment-manitou-mht780",
              "name": "MHT780",
              "subcategories": []
            },
            {
              "id": "aerial-equipment-manitou-mht790",
              "name": "MHT790",
              "subcategories": []
            },
            {
              "id": "aerial-equipment-manitou-mht860",
              "name": "MHT860",
              "subcategories": []
            },
            {
              "id": "aerial-equipment-manitou-mht950",
              "name": "MHT950",
              "subcategories": []
            },
            {
              "id": "aerial-equipment-manitou-mht1490",
              "name": "MHT1490",
              "subcategories": []
            },
            {
              "id": "aerial-equipment-manitou-mht10120",
              "name": "MHT10120",
              "subcategories": []
            },
            {
              "id": "aerial-equipment-manitou-mht10130",
              "name": "MHT10130",
              "subcategories": []
            },
            {
              "id": "aerial-equipment-manitou-mht10135",
              "name": "MHT10135",
              "subcategories": []
            },
            {
              "id": "aerial-equipment-manitou-mht10160",
              "name": "MHT10160",
              "subcategories": []
            },
            {
              "id": "aerial-equipment-manitou-mht10180",
              "name": "MHT10180",
              "subcategories": []
            },
            {
              "id": "aerial-equipment-manitou-mht10200",
              "name": "MHT10200",
              "subcategories": []
            },
            {
              "id": "aerial-equipment-manitou-mht10210",
              "name": "MHT10210",
              "subcategories": []
            },
            {
              "id": "aerial-equipment-manitou-mht10225",
              "name": "MHT10225",
              "subcategories": []
            },
            {
              "id": "aerial-equipment-manitou-mht10230",
              "name": "MHT10230",
              "subcategories": []
            },
            {
              "id": "aerial-equipment-manitou-mht11250",
              "name": "MHT11250",
              "subcategories": []
            },
            {
              "id": "aerial-equipment-manitou-mht12330",
              "name": "MHT12330",
              "subcategories": []
            },
            {
              "id": "aerial-equipment-manitou-mhtx780",
              "name": "MHTX780",
              "subcategories": []
            },
            {
              "id": "aerial-equipment-manitou-mhtx790",
              "name": "MHTX790",
              "subcategories": []
            },
            {
              "id": "aerial-equipment-manitou-mhtx10120",
              "name": "MHTX10120",
              "subcategories": []
            },
            {
              "id": "aerial-equipment-manitou-mhtx10130",
              "name": "MHTX10130",
              "subcategories": []
            },
            {
              "id": "aerial-equipment-manitou-mi15",
              "name": "MI15",
              "subcategories": []
            },
            {
              "id": "aerial-equipment-manitou-mi18",
              "name": "MI18",
              "subcategories": []
            },
            {
              "id": "aerial-equipment-manitou-mi25",
              "name": "MI25",
              "subcategories": []
            },
            {
              "id": "aerial-equipment-manitou-mi30",
              "name": "MI30",
              "subcategories": []
            },
            {
              "id": "aerial-equipment-manitou-mi35",
              "name": "MI35",
              "subcategories": []
            },
            {
              "id": "aerial-equipment-manitou-mi40",
              "name": "MI40",
              "subcategories": []
            },
            {
              "id": "aerial-equipment-manitou-mi45",
              "name": "MI45",
              "subcategories": []
            },
            {
              "id": "aerial-equipment-manitou-mi50",
              "name": "MI50",
              "subcategories": []
            },
            {
              "id": "aerial-equipment-manitou-mi55",
              "name": "MI55",
              "subcategories": []
            },
            {
              "id": "aerial-equipment-manitou-mi60",
              "name": "MI60",
              "subcategories": []
            },
            {
              "id": "aerial-equipment-manitou-mi70",
              "name": "MI70",
              "subcategories": []
            },
            {
              "id": "aerial-equipment-manitou-mi80",
              "name": "MI80",
              "subcategories": []
            },
            {
              "id": "aerial-equipment-manitou-mi100",
              "name": "MI100",
              "subcategories": []
            },
            {
              "id": "aerial-equipment-manitou-mla627",
              "name": "MLA627",
              "subcategories": []
            },
            {
              "id": "aerial-equipment-manitou-mlt420",
              "name": "MLT420",
              "subcategories": []
            },
            {
              "id": "aerial-equipment-manitou-mlt523",
              "name": "MLT523",
              "subcategories": []
            },
            {
              "id": "aerial-equipment-manitou-mlt524",
              "name": "MLT524",
              "subcategories": []
            },
            {
              "id": "aerial-equipment-manitou-mlt526",
              "name": "MLT526",
              "subcategories": []
            },
            {
              "id": "aerial-equipment-manitou-mlt625",
              "name": "MLT625",
              "subcategories": []
            },
            {
              "id": "aerial-equipment-manitou-mlt626",
              "name": "MLT626",
              "subcategories": []
            },
            {
              "id": "aerial-equipment-manitou-mlt627",
              "name": "MLT627",
              "subcategories": []
            },
            {
              "id": "aerial-equipment-manitou-mlt629",
              "name": "MLT629",
              "subcategories": []
            },
            {
              "id": "aerial-equipment-manitou-mlt630",
              "name": "MLT630",
              "subcategories": []
            },
            {
              "id": "aerial-equipment-manitou-mlt633",
              "name": "MLT633",
              "subcategories": []
            },
            {
              "id": "aerial-equipment-manitou-mlt634",
              "name": "MLT634",
              "subcategories": []
            },
            {
              "id": "aerial-equipment-manitou-mlt635",
              "name": "MLT635",
              "subcategories": []
            },
            {
              "id": "aerial-equipment-manitou-mlt730",
              "name": "MLT730",
              "subcategories": []
            },
            {
              "id": "aerial-equipment-manitou-mlt731",
              "name": "MLT731",
              "subcategories": []
            },
            {
              "id": "aerial-equipment-manitou-mlt733",
              "name": "MLT733",
              "subcategories": []
            },
            {
              "id": "aerial-equipment-manitou-mlt735",
              "name": "MLT735",
              "subcategories": []
            },
            {
              "id": "aerial-equipment-manitou-mlt737",
              "name": "MLT737",
              "subcategories": []
            },
            {
              "id": "aerial-equipment-manitou-mlt738",
              "name": "MLT738",
              "subcategories": []
            },
            {
              "id": "aerial-equipment-manitou-mlt741",
              "name": "MLT741",
              "subcategories": []
            },
            {
              "id": "aerial-equipment-manitou-mlt742",
              "name": "MLT742",
              "subcategories": []
            },
            {
              "id": "aerial-equipment-manitou-mlt840",
              "name": "MLT840",
              "subcategories": []
            },
            {
              "id": "aerial-equipment-manitou-mlt841",
              "name": "MLT841",
              "subcategories": []
            },
            {
              "id": "aerial-equipment-manitou-mlt845",
              "name": "MLT845",
              "subcategories": []
            },
            {
              "id": "aerial-equipment-manitou-mlt850",
              "name": "MLT850",
              "subcategories": []
            },
            {
              "id": "aerial-equipment-manitou-mlt935",
              "name": "MLT935",
              "subcategories": []
            },
            {
              "id": "aerial-equipment-manitou-mlt940",
              "name": "MLT940",
              "subcategories": []
            },
            {
              "id": "aerial-equipment-manitou-mlt960",
              "name": "MLT960",
              "subcategories": []
            },
            {
              "id": "aerial-equipment-manitou-mlt961",
              "name": "MLT961",
              "subcategories": []
            },
            {
              "id": "aerial-equipment-manitou-mlt1035",
              "name": "MLT1035",
              "subcategories": []
            },
            {
              "id": "aerial-equipment-manitou-mlt1040",
              "name": "MLT1040",
              "subcategories": []
            },
            {
              "id": "aerial-equipment-manitou-mlt1041",
              "name": "MLT1041",
              "subcategories": []
            },
            {
              "id": "aerial-equipment-manitou-mltx732",
              "name": "MLTX732",
              "subcategories": []
            },
            {
              "id": "aerial-equipment-manitou-mltx735",
              "name": "MLTX735",
              "subcategories": []
            },
            {
              "id": "aerial-equipment-manitou-mltx741",
              "name": "MLTX741",
              "subcategories": []
            },
            {
              "id": "aerial-equipment-manitou-mltx840",
              "name": "MLTX840",
              "subcategories": []
            },
            {
              "id": "aerial-equipment-manitou-mrt1432",
              "name": "MRT1432",
              "subcategories": []
            },
            {
              "id": "aerial-equipment-manitou-mrt1635",
              "name": "MRT1635",
              "subcategories": []
            },
            {
              "id": "aerial-equipment-manitou-mrt1640",
              "name": "MRT1640",
              "subcategories": []
            },
            {
              "id": "aerial-equipment-manitou-mrt1742",
              "name": "MRT1742",
              "subcategories": []
            },
            {
              "id": "aerial-equipment-manitou-mrt1840",
              "name": "MRT1840",
              "subcategories": []
            },
            {
              "id": "aerial-equipment-manitou-mrt1845",
              "name": "MRT1845",
              "subcategories": []
            },
            {
              "id": "aerial-equipment-manitou-mrt1850",
              "name": "MRT1850",
              "subcategories": []
            },
            {
              "id": "aerial-equipment-manitou-mrt2145",
              "name": "MRT2145",
              "subcategories": []
            },
            {
              "id": "aerial-equipment-manitou-mrt2150",
              "name": "MRT2150",
              "subcategories": []
            },
            {
              "id": "aerial-equipment-manitou-mrt2260",
              "name": "MRT2260",
              "subcategories": []
            },
            {
              "id": "aerial-equipment-manitou-mrt2470",
              "name": "MRT2470",
              "subcategories": []
            },
            {
              "id": "aerial-equipment-manitou-mrt2540",
              "name": "MRT2540",
              "subcategories": []
            },
            {
              "id": "aerial-equipment-manitou-mrt2545",
              "name": "MRT2545",
              "subcategories": []
            },
            {
              "id": "aerial-equipment-manitou-mrt2550",
              "name": "MRT2550",
              "subcategories": []
            },
            {
              "id": "aerial-equipment-manitou-mrt2570",
              "name": "MRT2570",
              "subcategories": []
            },
            {
              "id": "aerial-equipment-manitou-mrt2660",
              "name": "MRT2660",
              "subcategories": []
            },
            {
              "id": "aerial-equipment-manitou-mrt3050",
              "name": "MRT3050",
              "subcategories": []
            },
            {
              "id": "aerial-equipment-manitou-mrt3060",
              "name": "MRT3060",
              "subcategories": []
            },
            {
              "id": "aerial-equipment-manitou-mrt3255",
              "name": "MRT3255",
              "subcategories": []
            },
            {
              "id": "aerial-equipment-manitou-mrt3570",
              "name": "MRT3570",
              "subcategories": []
            },
            {
              "id": "aerial-equipment-manitou-mrtx1840",
              "name": "MRTX1840",
              "subcategories": []
            },
            {
              "id": "aerial-equipment-manitou-msi25",
              "name": "MSI25",
              "subcategories": []
            },
            {
              "id": "aerial-equipment-manitou-msi30",
              "name": "MSI30",
              "subcategories": []
            },
            {
              "id": "aerial-equipment-manitou-msi35",
              "name": "MSI35",
              "subcategories": []
            },
            {
              "id": "aerial-equipment-manitou-msi40",
              "name": "MSI40",
              "subcategories": []
            },
            {
              "id": "aerial-equipment-manitou-msi50",
              "name": "MSI50",
              "subcategories": []
            },
            {
              "id": "aerial-equipment-manitou-mt420",
              "name": "MT420",
              "subcategories": []
            },
            {
              "id": "aerial-equipment-manitou-mt425",
              "name": "MT425",
              "subcategories": []
            },
            {
              "id": "aerial-equipment-manitou-mt430",
              "name": "MT430",
              "subcategories": []
            },
            {
              "id": "aerial-equipment-manitou-mt523",
              "name": "MT523",
              "subcategories": []
            },
            {
              "id": "aerial-equipment-manitou-mt625",
              "name": "MT625",
              "subcategories": []
            },
            {
              "id": "aerial-equipment-manitou-mt730",
              "name": "MT730",
              "subcategories": []
            },
            {
              "id": "aerial-equipment-manitou-mt732",
              "name": "MT732",
              "subcategories": []
            },
            {
              "id": "aerial-equipment-manitou-mt733",
              "name": "MT733",
              "subcategories": []
            },
            {
              "id": "aerial-equipment-manitou-mt735",
              "name": "MT735",
              "subcategories": []
            },
            {
              "id": "aerial-equipment-manitou-mt835",
              "name": "MT835",
              "subcategories": []
            },
            {
              "id": "aerial-equipment-manitou-mt8340",
              "name": "MT8340",
              "subcategories": []
            },
            {
              "id": "aerial-equipment-manitou-mt930",
              "name": "MT930",
              "subcategories": []
            },
            {
              "id": "aerial-equipment-manitou-mt932",
              "name": "MT932",
              "subcategories": []
            },
            {
              "id": "aerial-equipment-manitou-mt933",
              "name": "MT933",
              "subcategories": []
            },
            {
              "id": "aerial-equipment-manitou-mt935",
              "name": "MT935",
              "subcategories": []
            },
            {
              "id": "aerial-equipment-manitou-mt1030",
              "name": "MT1030",
              "subcategories": []
            },
            {
              "id": "aerial-equipment-manitou-mt1033",
              "name": "MT1033",
              "subcategories": []
            },
            {
              "id": "aerial-equipment-manitou-mt1040",
              "name": "MT1040",
              "subcategories": []
            },
            {
              "id": "aerial-equipment-manitou-mt1044",
              "name": "MT1044",
              "subcategories": []
            },
            {
              "id": "aerial-equipment-manitou-mt1058",
              "name": "MT1058",
              "subcategories": []
            },
            {
              "id": "aerial-equipment-manitou-mt1135",
              "name": "MT1135",
              "subcategories": []
            },
            {
              "id": "aerial-equipment-manitou-mt1230",
              "name": "MT1230",
              "subcategories": []
            },
            {
              "id": "aerial-equipment-manitou-mt1232",
              "name": "MT1232",
              "subcategories": []
            },
            {
              "id": "aerial-equipment-manitou-mt1233",
              "name": "MT1233",
              "subcategories": []
            },
            {
              "id": "aerial-equipment-manitou-mt1235",
              "name": "MT1235",
              "subcategories": []
            },
            {
              "id": "aerial-equipment-manitou-mt1240",
              "name": "MT1240",
              "subcategories": []
            },
            {
              "id": "aerial-equipment-manitou-mt1330",
              "name": "MT1330",
              "subcategories": []
            },
            {
              "id": "aerial-equipment-manitou-mt1335",
              "name": "MT1335",
              "subcategories": []
            },
            {
              "id": "aerial-equipment-manitou-nt1337",
              "name": "NT1337",
              "subcategories": []
            },
            {
              "id": "aerial-equipment-manitou-mt1340",
              "name": "MT1340",
              "subcategories": []
            },
            {
              "id": "aerial-equipment-manitou-mt1435",
              "name": "MT1435",
              "subcategories": []
            },
            {
              "id": "aerial-equipment-manitou-mt1436",
              "name": "MT1436",
              "subcategories": []
            },
            {
              "id": "aerial-equipment-manitou-mt1440",
              "name": "MT1440",
              "subcategories": []
            },
            {
              "id": "aerial-equipment-manitou-mt1645",
              "name": "MT1645",
              "subcategories": []
            },
            {
              "id": "aerial-equipment-manitou-mt1740",
              "name": "MT1740",
              "subcategories": []
            },
            {
              "id": "aerial-equipment-manitou-mt1745",
              "name": "MT1745",
              "subcategories": []
            },
            {
              "id": "aerial-equipment-manitou-mt1840",
              "name": "MT1840",
              "subcategories": []
            },
            {
              "id": "aerial-equipment-manitou-mt5519",
              "name": "MT5519",
              "subcategories": []
            },
            {
              "id": "aerial-equipment-manitou-mt6034",
              "name": "MT6034",
              "subcategories": []
            },
            {
              "id": "aerial-equipment-manitou-mt6642",
              "name": "MT6642",
              "subcategories": []
            },
            {
              "id": "aerial-equipment-manitou-mt10055",
              "name": "MT10055",
              "subcategories": []
            },
            {
              "id": "aerial-equipment-manitou-mta519",
              "name": "MTA519",
              "subcategories": []
            },
            {
              "id": "aerial-equipment-manitou-mta642",
              "name": "MTA642",
              "subcategories": []
            },
            {
              "id": "aerial-equipment-manitou-mta842",
              "name": "MTA842",
              "subcategories": []
            },
            {
              "id": "aerial-equipment-manitou-mta950",
              "name": "MTA950",
              "subcategories": []
            },
            {
              "id": "aerial-equipment-manitou-mta1055",
              "name": "MTA1055",
              "subcategories": []
            },
            {
              "id": "aerial-equipment-manitou-mta1242",
              "name": "MTA1242",
              "subcategories": []
            },
            {
              "id": "aerial-equipment-manitou-mta1255",
              "name": "MTA1255",
              "subcategories": []
            },
            {
              "id": "aerial-equipment-manitou-mta5519",
              "name": "MTA5519",
              "subcategories": []
            },
            {
              "id": "aerial-equipment-manitou-mta6034",
              "name": "MTA6034",
              "subcategories": []
            },
            {
              "id": "aerial-equipment-manitou-mta6642",
              "name": "MTA6642",
              "subcategories": []
            },
            {
              "id": "aerial-equipment-manitou-mta8044",
              "name": "MTA8044",
              "subcategories": []
            },
            {
              "id": "aerial-equipment-manitou-mta9050",
              "name": "MTA9050",
              "subcategories": []
            },
            {
              "id": "aerial-equipment-manitou-mta10055",
              "name": "MTA10055",
              "subcategories": []
            },
            {
              "id": "aerial-equipment-manitou-mta12055",
              "name": "MTA12055",
              "subcategories": []
            },
            {
              "id": "aerial-equipment-manitou-mtx625",
              "name": "MTX625",
              "subcategories": []
            },
            {
              "id": "aerial-equipment-manitou-mtx732",
              "name": "MTX732",
              "subcategories": []
            },
            {
              "id": "aerial-equipment-manitou-mtx733",
              "name": "MTX733",
              "subcategories": []
            },
            {
              "id": "aerial-equipment-manitou-mtx1440",
              "name": "MTX1440",
              "subcategories": []
            },
            {
              "id": "aerial-equipment-manitou-mtx1740",
              "name": "MTX1740",
              "subcategories": []
            },
            {
              "id": "aerial-equipment-manitou-mvt735",
              "name": "MVT735",
              "subcategories": []
            },
            {
              "id": "aerial-equipment-manitou-mvt1332",
              "name": "MVT1332",
              "subcategories": []
            },
            {
              "id": "aerial-equipment-manitou-mx30",
              "name": "MX30",
              "subcategories": []
            },
            {
              "id": "aerial-equipment-manitou-mx50",
              "name": "MX50",
              "subcategories": []
            },
            {
              "id": "aerial-equipment-manitou-mxt1740",
              "name": "MXT1740",
              "subcategories": []
            },
            {
              "id": "aerial-equipment-manitou-p450h",
              "name": "P450H",
              "subcategories": []
            },
            {
              "id": "aerial-equipment-manitou-se",
              "name": "SE",
              "subcategories": []
            },
            {
              "id": "aerial-equipment-manitou-se808",
              "name": "SE808",
              "subcategories": []
            },
            {
              "id": "aerial-equipment-manitou-se1932",
              "name": "SE1932",
              "subcategories": []
            },
            {
              "id": "aerial-equipment-manitou-se2632",
              "name": "SE2632",
              "subcategories": []
            },
            {
              "id": "aerial-equipment-manitou-t604",
              "name": "T604",
              "subcategories": []
            },
            {
              "id": "aerial-equipment-manitou-t1002",
              "name": "T1002",
              "subcategories": []
            },
            {
              "id": "aerial-equipment-manitou-tj65",
              "name": "TJ65",
              "subcategories": []
            },
            {
              "id": "aerial-equipment-manitou-tj65",
              "name": "TJ65+",
              "subcategories": []
            },
            {
              "id": "aerial-equipment-manitou-tj80",
              "name": "TJ80+",
              "subcategories": []
            },
            {
              "id": "aerial-equipment-manitou-tj85",
              "name": "TJ85",
              "subcategories": []
            },
            {
              "id": "aerial-equipment-manitou-tmm45",
              "name": "TMM45",
              "subcategories": []
            },
            {
              "id": "aerial-equipment-manitou-tmt25",
              "name": "TMT25",
              "subcategories": []
            },
            {
              "id": "aerial-equipment-manitou-tmt27",
              "name": "TMT27",
              "subcategories": []
            },
            {
              "id": "aerial-equipment-manitou-tmt55",
              "name": "TMT55",
              "subcategories": []
            },
            {
              "id": "aerial-equipment-manitou-tmt320",
              "name": "TMT320",
              "subcategories": []
            },
            {
              "id": "aerial-equipment-manitou-tmt325",
              "name": "TMT325",
              "subcategories": []
            },
            {
              "id": "aerial-equipment-manitou-tmv55",
              "name": "TMV55",
              "subcategories": []
            },
            {
              "id": "aerial-equipment-manitou-ulm-412",
              "name": "ULM 412",
              "subcategories": []
            },
            {
              "id": "aerial-equipment-manitou-ulm-415",
              "name": "ULM 415",
              "subcategories": []
            },
            {
              "id": "aerial-equipment-manitou-v-air-23",
              "name": "V'AIR 23",
              "subcategories": []
            },
            {
              "id": "aerial-equipment-manitou-mrtx2550",
              "name": "MRTX2550",
              "subcategories": []
            },
            {
              "id": "aerial-equipment-manitou-other",
              "name": "OTHER",
              "subcategories": []
            }
          ]
        },
        {
          "id": "aerial-equipment-sky-trak",
          "name": "Sky Trak",
          "subcategories": [
            {
              "id": "aerial-equipment-sky-trak-3013",
              "name": "3013",
              "subcategories": []
            },
            {
              "id": "aerial-equipment-sky-trak-3606",
              "name": "3606",
              "subcategories": []
            },
            {
              "id": "aerial-equipment-sky-trak-5028",
              "name": "5028",
              "subcategories": []
            },
            {
              "id": "aerial-equipment-sky-trak-6000",
              "name": "6000",
              "subcategories": []
            },
            {
              "id": "aerial-equipment-sky-trak-6034",
              "name": "6034",
              "subcategories": []
            },
            {
              "id": "aerial-equipment-sky-trak-6036",
              "name": "6036",
              "subcategories": []
            },
            {
              "id": "aerial-equipment-sky-trak-6042",
              "name": "6042",
              "subcategories": []
            },
            {
              "id": "aerial-equipment-sky-trak-7038",
              "name": "7038",
              "subcategories": []
            },
            {
              "id": "aerial-equipment-sky-trak-8042",
              "name": "8042",
              "subcategories": []
            },
            {
              "id": "aerial-equipment-sky-trak-9038",
              "name": "9038",
              "subcategories": []
            },
            {
              "id": "aerial-equipment-sky-trak-10042",
              "name": "10042",
              "subcategories": []
            },
            {
              "id": "aerial-equipment-sky-trak-10054",
              "name": "10054",
              "subcategories": []
            },
            {
              "id": "aerial-equipment-sky-trak-12054",
              "name": "12054",
              "subcategories": []
            },
            {
              "id": "aerial-equipment-sky-trak-g5",
              "name": "G5",
              "subcategories": []
            },
            {
              "id": "aerial-equipment-sky-trak-mmv",
              "name": "MMV",
              "subcategories": []
            },
            {
              "id": "aerial-equipment-sky-trak-other",
              "name": "OTHER",
              "subcategories": []
            }
          ]
        },
        {
          "id": "aerial-equipment-yale",
          "name": "Yale",
          "subcategories": [
            {
              "id": "aerial-equipment-yale-11fg25pvfe",
              "name": "11FG25PVFE",
              "subcategories": []
            },
            {
              "id": "aerial-equipment-yale-clc120",
              "name": "CLC120",
              "subcategories": []
            },
            {
              "id": "aerial-equipment-yale-d3p220",
              "name": "D3P220",
              "subcategories": []
            },
            {
              "id": "aerial-equipment-yale-d3v200",
              "name": "D3V200",
              "subcategories": []
            },
            {
              "id": "aerial-equipment-yale-erc040",
              "name": "ERC040",
              "subcategories": []
            },
            {
              "id": "aerial-equipment-yale-erc045",
              "name": "ERC045",
              "subcategories": []
            },
            {
              "id": "aerial-equipment-yale-erc050",
              "name": "ERC050",
              "subcategories": []
            },
            {
              "id": "aerial-equipment-yale-erc060",
              "name": "ERC060",
              "subcategories": []
            },
            {
              "id": "aerial-equipment-yale-erc065",
              "name": "ERC065",
              "subcategories": []
            },
            {
              "id": "aerial-equipment-yale-erc070",
              "name": "ERC070",
              "subcategories": []
            },
            {
              "id": "aerial-equipment-yale-erc080",
              "name": "ERC080",
              "subcategories": []
            },
            {
              "id": "aerial-equipment-yale-erc25",
              "name": "ERC25",
              "subcategories": []
            },
            {
              "id": "aerial-equipment-yale-erc40",
              "name": "ERC40",
              "subcategories": []
            },
            {
              "id": "aerial-equipment-yale-erc100",
              "name": "ERC100",
              "subcategories": []
            },
            {
              "id": "aerial-equipment-yale-erc120",
              "name": "ERC120",
              "subcategories": []
            },
            {
              "id": "aerial-equipment-yale-erp025",
              "name": "ERP025",
              "subcategories": []
            },
            {
              "id": "aerial-equipment-yale-erp030",
              "name": "ERP030",
              "subcategories": []
            },
            {
              "id": "aerial-equipment-yale-erp035",
              "name": "ERP035",
              "subcategories": []
            },
            {
              "id": "aerial-equipment-yale-erp040",
              "name": "ERP040",
              "subcategories": []
            },
            {
              "id": "aerial-equipment-yale-erp050",
              "name": "ERP050",
              "subcategories": []
            },
            {
              "id": "aerial-equipment-yale-erp060",
              "name": "ERP060",
              "subcategories": []
            },
            {
              "id": "aerial-equipment-yale-erp070",
              "name": "ERP070",
              "subcategories": []
            },
            {
              "id": "aerial-equipment-yale-erp080",
              "name": "ERP080",
              "subcategories": []
            },
            {
              "id": "aerial-equipment-yale-erp16",
              "name": "ERP16",
              "subcategories": []
            },
            {
              "id": "aerial-equipment-yale-erp18",
              "name": "ERP18",
              "subcategories": []
            },
            {
              "id": "aerial-equipment-yale-erp20",
              "name": "ERP20",
              "subcategories": []
            },
            {
              "id": "aerial-equipment-yale-erp25",
              "name": "ERP25",
              "subcategories": []
            },
            {
              "id": "aerial-equipment-yale-erp30",
              "name": "ERP30",
              "subcategories": []
            },
            {
              "id": "aerial-equipment-yale-erp35",
              "name": "ERP35",
              "subcategories": []
            },
            {
              "id": "aerial-equipment-yale-erp40",
              "name": "ERP40",
              "subcategories": []
            },
            {
              "id": "aerial-equipment-yale-esc030",
              "name": "ESC030",
              "subcategories": []
            },
            {
              "id": "aerial-equipment-yale-esc035",
              "name": "ESC035",
              "subcategories": []
            },
            {
              "id": "aerial-equipment-yale-esc040",
              "name": "ESC040",
              "subcategories": []
            },
            {
              "id": "aerial-equipment-yale-g51c",
              "name": "G51C",
              "subcategories": []
            },
            {
              "id": "aerial-equipment-yale-g51p",
              "name": "G51P",
              "subcategories": []
            },
            {
              "id": "aerial-equipment-yale-g83p",
              "name": "G83P",
              "subcategories": []
            },
            {
              "id": "aerial-equipment-yale-gc030",
              "name": "GC030",
              "subcategories": []
            },
            {
              "id": "aerial-equipment-yale-gc040",
              "name": "GC040",
              "subcategories": []
            },
            {
              "id": "aerial-equipment-yale-gc050",
              "name": "GC050",
              "subcategories": []
            },
            {
              "id": "aerial-equipment-yale-gc060",
              "name": "GC060",
              "subcategories": []
            },
            {
              "id": "aerial-equipment-yale-gc080",
              "name": "GC080",
              "subcategories": []
            },
            {
              "id": "aerial-equipment-yale-gc100",
              "name": "GC100",
              "subcategories": []
            },
            {
              "id": "aerial-equipment-yale-gc120",
              "name": "GC120",
              "subcategories": []
            },
            {
              "id": "aerial-equipment-yale-gc155",
              "name": "GC155",
              "subcategories": []
            },
            {
              "id": "aerial-equipment-yale-gdc155",
              "name": "GDC155",
              "subcategories": []
            },
            {
              "id": "aerial-equipment-yale-gdp030",
              "name": "GDP030",
              "subcategories": []
            },
            {
              "id": "aerial-equipment-yale-gdp040",
              "name": "GDP040",
              "subcategories": []
            },
            {
              "id": "aerial-equipment-yale-gdp050",
              "name": "GDP050",
              "subcategories": []
            },
            {
              "id": "aerial-equipment-yale-gdp060",
              "name": "GDP060",
              "subcategories": []
            },
            {
              "id": "aerial-equipment-yale-gdp070",
              "name": "GDP070",
              "subcategories": []
            },
            {
              "id": "aerial-equipment-yale-gdp080",
              "name": "GDP080",
              "subcategories": []
            },
            {
              "id": "aerial-equipment-yale-gdp090",
              "name": "GDP090",
              "subcategories": []
            },
            {
              "id": "aerial-equipment-yale-gdp16",
              "name": "GDP16",
              "subcategories": []
            },
            {
              "id": "aerial-equipment-yale-gdp20",
              "name": "GDP20",
              "subcategories": []
            },
            {
              "id": "aerial-equipment-yale-gdp25",
              "name": "GDP25",
              "subcategories": []
            },
            {
              "id": "aerial-equipment-yale-gdp30",
              "name": "GDP30",
              "subcategories": []
            },
            {
              "id": "aerial-equipment-yale-gdp35",
              "name": "GDP35",
              "subcategories": []
            },
            {
              "id": "aerial-equipment-yale-gdp360",
              "name": "GDP360",
              "subcategories": []
            },
            {
              "id": "aerial-equipment-yale-gdp40",
              "name": "GDP40",
              "subcategories": []
            },
            {
              "id": "aerial-equipment-yale-gdp45",
              "name": "GDP45",
              "subcategories": []
            },
            {
              "id": "aerial-equipment-yale-gdp80",
              "name": "GDP80",
              "subcategories": []
            },
            {
              "id": "aerial-equipment-yale-gdp100",
              "name": "GDP100",
              "subcategories": []
            },
            {
              "id": "aerial-equipment-yale-gdp110",
              "name": "GDP110",
              "subcategories": []
            },
            {
              "id": "aerial-equipment-yale-gdp120",
              "name": "GDP120",
              "subcategories": []
            },
            {
              "id": "aerial-equipment-yale-gdp135",
              "name": "GDP135",
              "subcategories": []
            },
            {
              "id": "aerial-equipment-yale-gdp155",
              "name": "GDP155",
              "subcategories": []
            },
            {
              "id": "aerial-equipment-yale-gdp160",
              "name": "GDP160",
              "subcategories": []
            },
            {
              "id": "aerial-equipment-yale-gdp170",
              "name": "GDP170",
              "subcategories": []
            },
            {
              "id": "aerial-equipment-yale-gdp190",
              "name": "GDP190",
              "subcategories": []
            },
            {
              "id": "aerial-equipment-yale-gdp210",
              "name": "GDP210",
              "subcategories": []
            },
            {
              "id": "aerial-equipment-yale-gdp230",
              "name": "GDP230",
              "subcategories": []
            },
            {
              "id": "aerial-equipment-yale-gdp280",
              "name": "GDP280",
              "subcategories": []
            },
            {
              "id": "aerial-equipment-yale-gdp300",
              "name": "GDP300",
              "subcategories": []
            },
            {
              "id": "aerial-equipment-yale-gdp330",
              "name": "GDP330",
              "subcategories": []
            },
            {
              "id": "aerial-equipment-yale-glc030",
              "name": "GLC030",
              "subcategories": []
            },
            {
              "id": "aerial-equipment-yale-glc035",
              "name": "GLC035",
              "subcategories": []
            },
            {
              "id": "aerial-equipment-yale-glc040",
              "name": "GLC040",
              "subcategories": []
            },
            {
              "id": "aerial-equipment-yale-glc050",
              "name": "GLC050",
              "subcategories": []
            },
            {
              "id": "aerial-equipment-yale-glc055",
              "name": "GLC055",
              "subcategories": []
            },
            {
              "id": "aerial-equipment-yale-glc060",
              "name": "GLC060",
              "subcategories": []
            },
            {
              "id": "aerial-equipment-yale-glc070",
              "name": "GLC070",
              "subcategories": []
            },
            {
              "id": "aerial-equipment-yale-glc080",
              "name": "GLC080",
              "subcategories": []
            },
            {
              "id": "aerial-equipment-yale-glc100",
              "name": "GLC100",
              "subcategories": []
            },
            {
              "id": "aerial-equipment-yale-glc120",
              "name": "GLC120",
              "subcategories": []
            },
            {
              "id": "aerial-equipment-yale-glc135",
              "name": "GLC135",
              "subcategories": []
            },
            {
              "id": "aerial-equipment-yale-glc155",
              "name": "GLC155",
              "subcategories": []
            },
            {
              "id": "aerial-equipment-yale-glc200",
              "name": "GLC200",
              "subcategories": []
            },
            {
              "id": "aerial-equipment-yale-glp030",
              "name": "GLP030",
              "subcategories": []
            },
            {
              "id": "aerial-equipment-yale-glp035",
              "name": "GLP035",
              "subcategories": []
            },
            {
              "id": "aerial-equipment-yale-glp040",
              "name": "GLP040",
              "subcategories": []
            },
            {
              "id": "aerial-equipment-yale-glp050",
              "name": "GLP050",
              "subcategories": []
            },
            {
              "id": "aerial-equipment-yale-glp060",
              "name": "GLP060",
              "subcategories": []
            },
            {
              "id": "aerial-equipment-yale-glp070",
              "name": "GLP070",
              "subcategories": []
            },
            {
              "id": "aerial-equipment-yale-glp080",
              "name": "GLP080",
              "subcategories": []
            },
            {
              "id": "aerial-equipment-yale-glp090",
              "name": "GLP090",
              "subcategories": []
            },
            {
              "id": "aerial-equipment-yale-glp18",
              "name": "GLP18",
              "subcategories": []
            },
            {
              "id": "aerial-equipment-yale-glp20",
              "name": "GLP20",
              "subcategories": []
            },
            {
              "id": "aerial-equipment-yale-glp25",
              "name": "GLP25",
              "subcategories": []
            },
            {
              "id": "aerial-equipment-yale-glp30",
              "name": "GLP30",
              "subcategories": []
            },
            {
              "id": "aerial-equipment-yale-glp35",
              "name": "GLP35",
              "subcategories": []
            },
            {
              "id": "aerial-equipment-yale-glp50",
              "name": "GLP50",
              "subcategories": []
            },
            {
              "id": "aerial-equipment-yale-glp60",
              "name": "GLP60",
              "subcategories": []
            },
            {
              "id": "aerial-equipment-yale-glp100",
              "name": "GLP100",
              "subcategories": []
            },
            {
              "id": "aerial-equipment-yale-glp120",
              "name": "GLP120",
              "subcategories": []
            },
            {
              "id": "aerial-equipment-yale-glp155",
              "name": "GLP155",
              "subcategories": []
            },
            {
              "id": "aerial-equipment-yale-glp175",
              "name": "GLP175",
              "subcategories": []
            },
            {
              "id": "aerial-equipment-yale-glp300",
              "name": "GLP300",
              "subcategories": []
            },
            {
              "id": "aerial-equipment-yale-gp030",
              "name": "GP030",
              "subcategories": []
            },
            {
              "id": "aerial-equipment-yale-gp040",
              "name": "GP040",
              "subcategories": []
            },
            {
              "id": "aerial-equipment-yale-gp050",
              "name": "GP050",
              "subcategories": []
            },
            {
              "id": "aerial-equipment-yale-gp060",
              "name": "GP060",
              "subcategories": []
            },
            {
              "id": "aerial-equipment-yale-gp080",
              "name": "GP080",
              "subcategories": []
            },
            {
              "id": "aerial-equipment-yale-gp090",
              "name": "GP090",
              "subcategories": []
            },
            {
              "id": "aerial-equipment-yale-gp30ux",
              "name": "GP30UX",
              "subcategories": []
            },
            {
              "id": "aerial-equipment-yale-gp40",
              "name": "GP40",
              "subcategories": []
            },
            {
              "id": "aerial-equipment-yale-gp50",
              "name": "GP50",
              "subcategories": []
            },
            {
              "id": "aerial-equipment-yale-gp60",
              "name": "GP60",
              "subcategories": []
            },
            {
              "id": "aerial-equipment-yale-gp120",
              "name": "GP120",
              "subcategories": []
            },
            {
              "id": "aerial-equipment-yale-gp155",
              "name": "GP155",
              "subcategories": []
            },
            {
              "id": "aerial-equipment-yale-gp170",
              "name": "GP170",
              "subcategories": []
            },
            {
              "id": "aerial-equipment-yale-gtp050",
              "name": "GTP050",
              "subcategories": []
            },
            {
              "id": "aerial-equipment-yale-gtp060",
              "name": "GTP060",
              "subcategories": []
            },
            {
              "id": "aerial-equipment-yale-gtp070",
              "name": "GTP070",
              "subcategories": []
            },
            {
              "id": "aerial-equipment-yale-gtp080",
              "name": "GTP080",
              "subcategories": []
            },
            {
              "id": "aerial-equipment-yale-gtp18",
              "name": "GTP18",
              "subcategories": []
            },
            {
              "id": "aerial-equipment-yale-gtp35",
              "name": "GTP35",
              "subcategories": []
            },
            {
              "id": "aerial-equipment-yale-gtp100",
              "name": "GTP100",
              "subcategories": []
            },
            {
              "id": "aerial-equipment-yale-k51at40",
              "name": "K51AT40",
              "subcategories": []
            },
            {
              "id": "aerial-equipment-yale-mcw025",
              "name": "MCW025",
              "subcategories": []
            },
            {
              "id": "aerial-equipment-yale-mcw040",
              "name": "MCW040",
              "subcategories": []
            },
            {
              "id": "aerial-equipment-yale-mo",
              "name": "MO",
              "subcategories": []
            },
            {
              "id": "aerial-equipment-yale-mp0",
              "name": "MP0",
              "subcategories": []
            },
            {
              "id": "aerial-equipment-yale-mpb040",
              "name": "MPB040",
              "subcategories": []
            },
            {
              "id": "aerial-equipment-yale-mpb045",
              "name": "MPB045",
              "subcategories": []
            },
            {
              "id": "aerial-equipment-yale-mpe060",
              "name": "MPE060",
              "subcategories": []
            },
            {
              "id": "aerial-equipment-yale-mpe080",
              "name": "MPE080",
              "subcategories": []
            },
            {
              "id": "aerial-equipment-yale-mpr080",
              "name": "MPR080",
              "subcategories": []
            },
            {
              "id": "aerial-equipment-yale-mpw050",
              "name": "MPW050",
              "subcategories": []
            },
            {
              "id": "aerial-equipment-yale-mpw060",
              "name": "MPW060",
              "subcategories": []
            },
            {
              "id": "aerial-equipment-yale-mr14",
              "name": "MR14",
              "subcategories": []
            },
            {
              "id": "aerial-equipment-yale-mr16",
              "name": "MR16",
              "subcategories": []
            },
            {
              "id": "aerial-equipment-yale-mr20",
              "name": "MR20",
              "subcategories": []
            },
            {
              "id": "aerial-equipment-yale-mrw030",
              "name": "MRW030",
              "subcategories": []
            },
            {
              "id": "aerial-equipment-yale-ms040",
              "name": "MS040",
              "subcategories": []
            },
            {
              "id": "aerial-equipment-yale-ms10",
              "name": "MS10",
              "subcategories": []
            },
            {
              "id": "aerial-equipment-yale-msw025",
              "name": "MSW025",
              "subcategories": []
            },
            {
              "id": "aerial-equipment-yale-msw030",
              "name": "MSW030",
              "subcategories": []
            },
            {
              "id": "aerial-equipment-yale-msw040",
              "name": "MSW040",
              "subcategories": []
            },
            {
              "id": "aerial-equipment-yale-mtr007",
              "name": "MTR007",
              "subcategories": []
            },
            {
              "id": "aerial-equipment-yale-ndr030",
              "name": "NDR030",
              "subcategories": []
            },
            {
              "id": "aerial-equipment-yale-ndr035",
              "name": "NDR035",
              "subcategories": []
            },
            {
              "id": "aerial-equipment-yale-nr035",
              "name": "NR035",
              "subcategories": []
            },
            {
              "id": "aerial-equipment-yale-nr040",
              "name": "NR040",
              "subcategories": []
            },
            {
              "id": "aerial-equipment-yale-nr045",
              "name": "NR045",
              "subcategories": []
            },
            {
              "id": "aerial-equipment-yale-nta030",
              "name": "NTA030",
              "subcategories": []
            },
            {
              "id": "aerial-equipment-yale-os030",
              "name": "OS030",
              "subcategories": []
            },
            {
              "id": "aerial-equipment-yale-ya55",
              "name": "YA55",
              "subcategories": []
            },
            {
              "id": "aerial-equipment-yale-other",
              "name": "OTHER",
              "subcategories": []
            }
          ]
        },
        {
          "id": "aerial-equipment-clark",
          "name": "Clark",
          "subcategories": [
            {
              "id": "aerial-equipment-clark-50",
              "name": "50",
              "subcategories": []
            },
            {
              "id": "aerial-equipment-clark-c5",
              "name": "C5",
              "subcategories": []
            },
            {
              "id": "aerial-equipment-clark-c15",
              "name": "C15",
              "subcategories": []
            },
            {
              "id": "aerial-equipment-clark-c18",
              "name": "C18",
              "subcategories": []
            },
            {
              "id": "aerial-equipment-clark-c20",
              "name": "C20",
              "subcategories": []
            },
            {
              "id": "aerial-equipment-clark-c25",
              "name": "C25",
              "subcategories": []
            },
            {
              "id": "aerial-equipment-clark-c30",
              "name": "C30",
              "subcategories": []
            },
            {
              "id": "aerial-equipment-clark-c32",
              "name": "C32",
              "subcategories": []
            },
            {
              "id": "aerial-equipment-clark-c35",
              "name": "C35",
              "subcategories": []
            },
            {
              "id": "aerial-equipment-clark-c40",
              "name": "C40",
              "subcategories": []
            },
            {
              "id": "aerial-equipment-clark-c45",
              "name": "C45",
              "subcategories": []
            },
            {
              "id": "aerial-equipment-clark-c50",
              "name": "C50",
              "subcategories": []
            },
            {
              "id": "aerial-equipment-clark-c55",
              "name": "C55",
              "subcategories": []
            },
            {
              "id": "aerial-equipment-clark-c60",
              "name": "C60",
              "subcategories": []
            },
            {
              "id": "aerial-equipment-clark-c70",
              "name": "C70",
              "subcategories": []
            },
            {
              "id": "aerial-equipment-clark-c75",
              "name": "C75",
              "subcategories": []
            },
            {
              "id": "aerial-equipment-clark-c500",
              "name": "C500",
              "subcategories": []
            },
            {
              "id": "aerial-equipment-clark-cf40",
              "name": "CF40",
              "subcategories": []
            },
            {
              "id": "aerial-equipment-clark-cdp140",
              "name": "CDP140",
              "subcategories": []
            },
            {
              "id": "aerial-equipment-clark-cgc20",
              "name": "CGC20",
              "subcategories": []
            },
            {
              "id": "aerial-equipment-clark-cgc25",
              "name": "CGC25",
              "subcategories": []
            },
            {
              "id": "aerial-equipment-clark-cgc30",
              "name": "CGC30",
              "subcategories": []
            },
            {
              "id": "aerial-equipment-clark-cgc40",
              "name": "CGC40",
              "subcategories": []
            },
            {
              "id": "aerial-equipment-clark-cgc50",
              "name": "CGC50",
              "subcategories": []
            },
            {
              "id": "aerial-equipment-clark-cgc55",
              "name": "CGC55",
              "subcategories": []
            },
            {
              "id": "aerial-equipment-clark-cgc60",
              "name": "CGC60",
              "subcategories": []
            },
            {
              "id": "aerial-equipment-clark-cgc70",
              "name": "CGC70",
              "subcategories": []
            },
            {
              "id": "aerial-equipment-clark-cgp25",
              "name": "CGP25",
              "subcategories": []
            },
            {
              "id": "aerial-equipment-clark-cgp30",
              "name": "CGP30",
              "subcategories": []
            },
            {
              "id": "aerial-equipment-clark-cgp40",
              "name": "CGP40",
              "subcategories": []
            },
            {
              "id": "aerial-equipment-clark-ch60",
              "name": "CH60",
              "subcategories": []
            },
            {
              "id": "aerial-equipment-clark-ch100",
              "name": "CH100",
              "subcategories": []
            },
            {
              "id": "aerial-equipment-clark-chy160",
              "name": "CHY160",
              "subcategories": []
            },
            {
              "id": "aerial-equipment-clark-cj55",
              "name": "CJ55",
              "subcategories": []
            },
            {
              "id": "aerial-equipment-clark-cmp25",
              "name": "CMP25",
              "subcategories": []
            },
            {
              "id": "aerial-equipment-clark-cmp40",
              "name": "CMP40",
              "subcategories": []
            },
            {
              "id": "aerial-equipment-clark-cmp45",
              "name": "CMP45",
              "subcategories": []
            },
            {
              "id": "aerial-equipment-clark-cmp50",
              "name": "CMP50",
              "subcategories": []
            },
            {
              "id": "aerial-equipment-clark-cmp60",
              "name": "CMP60",
              "subcategories": []
            },
            {
              "id": "aerial-equipment-clark-cmp70",
              "name": "CMP70",
              "subcategories": []
            },
            {
              "id": "aerial-equipment-clark-cps12",
              "name": "CPS12",
              "subcategories": []
            },
            {
              "id": "aerial-equipment-clark-ctm12",
              "name": "CTM12",
              "subcategories": []
            },
            {
              "id": "aerial-equipment-clark-cy40",
              "name": "CY40",
              "subcategories": []
            },
            {
              "id": "aerial-equipment-clark-cy60",
              "name": "CY60",
              "subcategories": []
            },
            {
              "id": "aerial-equipment-clark-cy300",
              "name": "CY300",
              "subcategories": []
            },
            {
              "id": "aerial-equipment-clark-cy800",
              "name": "CY800",
              "subcategories": []
            },
            {
              "id": "aerial-equipment-clark-cys250",
              "name": "CYS250",
              "subcategories": []
            },
            {
              "id": "aerial-equipment-clark-dpl60",
              "name": "DPL60",
              "subcategories": []
            },
            {
              "id": "aerial-equipment-clark-dpl70",
              "name": "DPL70",
              "subcategories": []
            },
            {
              "id": "aerial-equipment-clark-dpm30",
              "name": "DPM30",
              "subcategories": []
            },
            {
              "id": "aerial-equipment-clark-ec25",
              "name": "EC25",
              "subcategories": []
            },
            {
              "id": "aerial-equipment-clark-ecg25",
              "name": "ECG25",
              "subcategories": []
            },
            {
              "id": "aerial-equipment-clark-ecg30",
              "name": "ECG30",
              "subcategories": []
            },
            {
              "id": "aerial-equipment-clark-ec500",
              "name": "EC500",
              "subcategories": []
            },
            {
              "id": "aerial-equipment-clark-esx15",
              "name": "ESX15",
              "subcategories": []
            },
            {
              "id": "aerial-equipment-clark-esx20",
              "name": "ESX20",
              "subcategories": []
            },
            {
              "id": "aerial-equipment-clark-esx25",
              "name": "ESX25",
              "subcategories": []
            },
            {
              "id": "aerial-equipment-clark-gcs17",
              "name": "GCS17",
              "subcategories": []
            },
            {
              "id": "aerial-equipment-clark-gcx40",
              "name": "GCX40",
              "subcategories": []
            },
            {
              "id": "aerial-equipment-clark-gcx50",
              "name": "GCX50",
              "subcategories": []
            },
            {
              "id": "aerial-equipment-clark-gex18",
              "name": "GEX18",
              "subcategories": []
            },
            {
              "id": "aerial-equipment-clark-gex20",
              "name": "GEX20",
              "subcategories": []
            },
            {
              "id": "aerial-equipment-clark-gex25",
              "name": "GEX25",
              "subcategories": []
            },
            {
              "id": "aerial-equipment-clark-gpm20",
              "name": "GPM20",
              "subcategories": []
            },
            {
              "id": "aerial-equipment-clark-gps15",
              "name": "GPS15",
              "subcategories": []
            },
            {
              "id": "aerial-equipment-clark-gps20",
              "name": "GPS20",
              "subcategories": []
            },
            {
              "id": "aerial-equipment-clark-gps25",
              "name": "GPS25",
              "subcategories": []
            },
            {
              "id": "aerial-equipment-clark-gps30",
              "name": "GPS30",
              "subcategories": []
            },
            {
              "id": "aerial-equipment-clark-gpx20",
              "name": "GPX20",
              "subcategories": []
            },
            {
              "id": "aerial-equipment-clark-gpx25",
              "name": "GPX25",
              "subcategories": []
            },
            {
              "id": "aerial-equipment-clark-gpx30",
              "name": "GPX30",
              "subcategories": []
            },
            {
              "id": "aerial-equipment-clark-gpx35",
              "name": "GPX35",
              "subcategories": []
            },
            {
              "id": "aerial-equipment-clark-gpx40",
              "name": "GPX40",
              "subcategories": []
            },
            {
              "id": "aerial-equipment-clark-gts20",
              "name": "GTS20",
              "subcategories": []
            },
            {
              "id": "aerial-equipment-clark-gts25",
              "name": "GTS25",
              "subcategories": []
            },
            {
              "id": "aerial-equipment-clark-gts30",
              "name": "GTS30",
              "subcategories": []
            },
            {
              "id": "aerial-equipment-clark-gts33",
              "name": "GTS33",
              "subcategories": []
            },
            {
              "id": "aerial-equipment-clark-gtx18",
              "name": "GTX18",
              "subcategories": []
            },
            {
              "id": "aerial-equipment-clark-gtx20",
              "name": "GTX20",
              "subcategories": []
            },
            {
              "id": "aerial-equipment-clark-hwx",
              "name": "HWX",
              "subcategories": []
            },
            {
              "id": "aerial-equipment-clark-hwxe",
              "name": "HWXE",
              "subcategories": []
            },
            {
              "id": "aerial-equipment-clark-l35",
              "name": "L35",
              "subcategories": []
            },
            {
              "id": "aerial-equipment-clark-lwio",
              "name": "LWIO",
              "subcategories": []
            },
            {
              "id": "aerial-equipment-clark-np300",
              "name": "NP300",
              "subcategories": []
            },
            {
              "id": "aerial-equipment-clark-npr15",
              "name": "NPR15",
              "subcategories": []
            },
            {
              "id": "aerial-equipment-clark-npr17",
              "name": "NPR17",
              "subcategories": []
            },
            {
              "id": "aerial-equipment-clark-npr20",
              "name": "NPR20",
              "subcategories": []
            },
            {
              "id": "aerial-equipment-clark-npr22",
              "name": "NPR22",
              "subcategories": []
            },
            {
              "id": "aerial-equipment-clark-npx15",
              "name": "NPX15",
              "subcategories": []
            },
            {
              "id": "aerial-equipment-clark-npx17",
              "name": "NPX17",
              "subcategories": []
            },
            {
              "id": "aerial-equipment-clark-npx20",
              "name": "NPX20",
              "subcategories": []
            },
            {
              "id": "aerial-equipment-clark-op15",
              "name": "OP15",
              "subcategories": []
            },
            {
              "id": "aerial-equipment-clark-osq192",
              "name": "OSQ192",
              "subcategories": []
            },
            {
              "id": "aerial-equipment-clark-osx15",
              "name": "OSX15",
              "subcategories": []
            },
            {
              "id": "aerial-equipment-clark-pwx30",
              "name": "PWX30",
              "subcategories": []
            },
            {
              "id": "aerial-equipment-clark-rhy",
              "name": "RHY",
              "subcategories": []
            },
            {
              "id": "aerial-equipment-clark-s20",
              "name": "S20",
              "subcategories": []
            },
            {
              "id": "aerial-equipment-clark-s25",
              "name": "S25",
              "subcategories": []
            },
            {
              "id": "aerial-equipment-clark-s30",
              "name": "S30",
              "subcategories": []
            },
            {
              "id": "aerial-equipment-clark-s32",
              "name": "S32",
              "subcategories": []
            },
            {
              "id": "aerial-equipment-clark-s35",
              "name": "S35",
              "subcategories": []
            },
            {
              "id": "aerial-equipment-clark-s40",
              "name": "S40",
              "subcategories": []
            },
            {
              "id": "aerial-equipment-clark-s50",
              "name": "S50",
              "subcategories": []
            },
            {
              "id": "aerial-equipment-clark-sec",
              "name": "SEC",
              "subcategories": []
            },
            {
              "id": "aerial-equipment-clark-ses",
              "name": "SES",
              "subcategories": []
            },
            {
              "id": "aerial-equipment-clark-sse",
              "name": "SSE",
              "subcategories": []
            },
            {
              "id": "aerial-equipment-clark-ss2",
              "name": "SS2",
              "subcategories": []
            },
            {
              "id": "aerial-equipment-clark-tm15",
              "name": "TM15",
              "subcategories": []
            },
            {
              "id": "aerial-equipment-clark-tm20",
              "name": "TM20",
              "subcategories": []
            },
            {
              "id": "aerial-equipment-clark-tmg15",
              "name": "TMG15",
              "subcategories": []
            },
            {
              "id": "aerial-equipment-clark-tmg20",
              "name": "TMG20",
              "subcategories": []
            },
            {
              "id": "aerial-equipment-clark-tmx15",
              "name": "TMX15",
              "subcategories": []
            },
            {
              "id": "aerial-equipment-clark-tmx17",
              "name": "TMX17",
              "subcategories": []
            },
            {
              "id": "aerial-equipment-clark-tmx20",
              "name": "TMX20",
              "subcategories": []
            },
            {
              "id": "aerial-equipment-clark-tmx25",
              "name": "TMX25",
              "subcategories": []
            },
            {
              "id": "aerial-equipment-clark-twli20",
              "name": "TWLI20",
              "subcategories": []
            },
            {
              "id": "aerial-equipment-clark-ut60",
              "name": "UT60",
              "subcategories": []
            },
            {
              "id": "aerial-equipment-clark-wm10-1415",
              "name": "WM10-1415",
              "subcategories": []
            },
            {
              "id": "aerial-equipment-clark-wpl25",
              "name": "WPL25",
              "subcategories": []
            },
            {
              "id": "aerial-equipment-clark-wpl40",
              "name": "WPL40",
              "subcategories": []
            },
            {
              "id": "aerial-equipment-clark-wpx45",
              "name": "WPX45",
              "subcategories": []
            },
            {
              "id": "aerial-equipment-clark-wsrx30",
              "name": "WSRX30",
              "subcategories": []
            },
            {
              "id": "aerial-equipment-clark-other",
              "name": "OTHER",
              "subcategories": []
            }
          ]
        },
        {
          "id": "aerial-equipment-crown",
          "name": "Crown",
          "subcategories": [
            {
              "id": "aerial-equipment-crown-20mt",
              "name": "20MT",
              "subcategories": []
            },
            {
              "id": "aerial-equipment-crown-30sc",
              "name": "30SC",
              "subcategories": []
            },
            {
              "id": "aerial-equipment-crown-30wb",
              "name": "30WB",
              "subcategories": []
            },
            {
              "id": "aerial-equipment-crown-30wr",
              "name": "30WR",
              "subcategories": []
            },
            {
              "id": "aerial-equipment-crown-40wb",
              "name": "40WB",
              "subcategories": []
            },
            {
              "id": "aerial-equipment-crown-60fpt",
              "name": "60FPT",
              "subcategories": []
            },
            {
              "id": "aerial-equipment-crown-c5",
              "name": "C5",
              "subcategories": []
            },
            {
              "id": "aerial-equipment-crown-cd80",
              "name": "CD80",
              "subcategories": []
            },
            {
              "id": "aerial-equipment-crown-cg30",
              "name": "CG30",
              "subcategories": []
            },
            {
              "id": "aerial-equipment-crown-cgc20",
              "name": "CGC20",
              "subcategories": []
            },
            {
              "id": "aerial-equipment-crown-es4000",
              "name": "ES4000",
              "subcategories": []
            },
            {
              "id": "aerial-equipment-crown-esr5000",
              "name": "ESR5000",
              "subcategories": []
            },
            {
              "id": "aerial-equipment-crown-esr5240",
              "name": "ESR5240",
              "subcategories": []
            },
            {
              "id": "aerial-equipment-crown-et4000",
              "name": "ET4000",
              "subcategories": []
            },
            {
              "id": "aerial-equipment-crown-fc4010",
              "name": "FC4010",
              "subcategories": []
            },
            {
              "id": "aerial-equipment-crown-fc4020",
              "name": "FC4020",
              "subcategories": []
            },
            {
              "id": "aerial-equipment-crown-fc4510",
              "name": "FC4510",
              "subcategories": []
            },
            {
              "id": "aerial-equipment-crown-fc4525",
              "name": "FC4525",
              "subcategories": []
            },
            {
              "id": "aerial-equipment-crown-fc4545",
              "name": "FC4545",
              "subcategories": []
            },
            {
              "id": "aerial-equipment-crown-fc5215",
              "name": "FC5215",
              "subcategories": []
            },
            {
              "id": "aerial-equipment-crown-fc5225",
              "name": "FC5225",
              "subcategories": []
            },
            {
              "id": "aerial-equipment-crown-lp3520",
              "name": "LP3520",
              "subcategories": []
            },
            {
              "id": "aerial-equipment-crown-pc4500",
              "name": "PC4500",
              "subcategories": []
            },
            {
              "id": "aerial-equipment-crown-pe3540",
              "name": "PE3540",
              "subcategories": []
            },
            {
              "id": "aerial-equipment-crown-pe4000",
              "name": "PE4000",
              "subcategories": []
            },
            {
              "id": "aerial-equipment-crown-pe4500",
              "name": "PE4500",
              "subcategories": []
            },
            {
              "id": "aerial-equipment-crown-pr3040",
              "name": "PR3040",
              "subcategories": []
            },
            {
              "id": "aerial-equipment-crown-pr4500",
              "name": "PR4500",
              "subcategories": []
            },
            {
              "id": "aerial-equipment-crown-pw3520",
              "name": "PW3520",
              "subcategories": []
            },
            {
              "id": "aerial-equipment-crown-rc3020",
              "name": "RC3020",
              "subcategories": []
            },
            {
              "id": "aerial-equipment-crown-rc5510",
              "name": "RC5510",
              "subcategories": []
            },
            {
              "id": "aerial-equipment-crown-rc5525",
              "name": "RC5525",
              "subcategories": []
            },
            {
              "id": "aerial-equipment-crown-rc5530",
              "name": "RC5530",
              "subcategories": []
            },
            {
              "id": "aerial-equipment-crown-rc5535",
              "name": "RC5535",
              "subcategories": []
            },
            {
              "id": "aerial-equipment-crown-rc5540",
              "name": "RC5540",
              "subcategories": []
            },
            {
              "id": "aerial-equipment-crown-rc5545",
              "name": "RC5545",
              "subcategories": []
            },
            {
              "id": "aerial-equipment-crown-rc5725",
              "name": "RC5725",
              "subcategories": []
            },
            {
              "id": "aerial-equipment-crown-rc5745",
              "name": "RC5745",
              "subcategories": []
            },
            {
              "id": "aerial-equipment-crown-rd5220",
              "name": "RD5220",
              "subcategories": []
            },
            {
              "id": "aerial-equipment-crown-rd5225",
              "name": "RD5225",
              "subcategories": []
            },
            {
              "id": "aerial-equipment-crown-rd5280",
              "name": "RD5280",
              "subcategories": []
            },
            {
              "id": "aerial-equipment-crown-rd5725",
              "name": "RD5725",
              "subcategories": []
            },
            {
              "id": "aerial-equipment-crown-rd5795",
              "name": "RD5795",
              "subcategories": []
            },
            {
              "id": "aerial-equipment-crown-rm6025",
              "name": "RM6025",
              "subcategories": []
            },
            {
              "id": "aerial-equipment-crown-rmd6025",
              "name": "RMD6025",
              "subcategories": []
            },
            {
              "id": "aerial-equipment-crown-rmd6095",
              "name": "RMD6095",
              "subcategories": []
            },
            {
              "id": "aerial-equipment-crown-rr3020",
              "name": "RR3020",
              "subcategories": []
            },
            {
              "id": "aerial-equipment-crown-rr5010",
              "name": "RR5010",
              "subcategories": []
            },
            {
              "id": "aerial-equipment-crown-rr5020",
              "name": "RR5020",
              "subcategories": []
            },
            {
              "id": "aerial-equipment-crown-rr5210",
              "name": "RR5210",
              "subcategories": []
            },
            {
              "id": "aerial-equipment-crown-rr5220",
              "name": "RR5220",
              "subcategories": []
            },
            {
              "id": "aerial-equipment-crown-rr5225",
              "name": "RR5225",
              "subcategories": []
            },
            {
              "id": "aerial-equipment-crown-rr5715",
              "name": "RR5715",
              "subcategories": []
            },
            {
              "id": "aerial-equipment-crown-rr5725",
              "name": "RR5725",
              "subcategories": []
            },
            {
              "id": "aerial-equipment-crown-sc3013",
              "name": "SC3013",
              "subcategories": []
            },
            {
              "id": "aerial-equipment-crown-sc4010",
              "name": "SC4010",
              "subcategories": []
            },
            {
              "id": "aerial-equipment-crown-sc4020",
              "name": "SC4020",
              "subcategories": []
            },
            {
              "id": "aerial-equipment-crown-sc4040",
              "name": "SC4040",
              "subcategories": []
            },
            {
              "id": "aerial-equipment-crown-sc4240",
              "name": "SC4240",
              "subcategories": []
            },
            {
              "id": "aerial-equipment-crown-sc4510",
              "name": "SC4510",
              "subcategories": []
            },
            {
              "id": "aerial-equipment-crown-sc4540",
              "name": "SC4540",
              "subcategories": []
            },
            {
              "id": "aerial-equipment-crown-sc5210",
              "name": "SC5210",
              "subcategories": []
            },
            {
              "id": "aerial-equipment-crown-sc5215",
              "name": "SC5215",
              "subcategories": []
            },
            {
              "id": "aerial-equipment-crown-sc5225",
              "name": "SC5225",
              "subcategories": []
            },
            {
              "id": "aerial-equipment-crown-sc5245",
              "name": "SC5245",
              "subcategories": []
            },
            {
              "id": "aerial-equipment-crown-sct6010",
              "name": "SCT6010",
              "subcategories": []
            },
            {
              "id": "aerial-equipment-crown-sh5520",
              "name": "SH5520",
              "subcategories": []
            },
            {
              "id": "aerial-equipment-crown-shr5520",
              "name": "SHR5520",
              "subcategories": []
            },
            {
              "id": "aerial-equipment-crown-shr5540",
              "name": "SHR5540",
              "subcategories": []
            },
            {
              "id": "aerial-equipment-crown-sp1510",
              "name": "SP1510",
              "subcategories": []
            },
            {
              "id": "aerial-equipment-crown-sp3010",
              "name": "SP3010",
              "subcategories": []
            },
            {
              "id": "aerial-equipment-crown-sp3020",
              "name": "SP3020",
              "subcategories": []
            },
            {
              "id": "aerial-equipment-crown-sp3210",
              "name": "SP3210",
              "subcategories": []
            },
            {
              "id": "aerial-equipment-crown-sp3405",
              "name": "SP3405",
              "subcategories": []
            },
            {
              "id": "aerial-equipment-crown-sp3410",
              "name": "SP3410",
              "subcategories": []
            },
            {
              "id": "aerial-equipment-crown-sp3420",
              "name": "SP3420",
              "subcategories": []
            },
            {
              "id": "aerial-equipment-crown-sp3500",
              "name": "SP3500",
              "subcategories": []
            },
            {
              "id": "aerial-equipment-crown-sp3505",
              "name": "SP3505",
              "subcategories": []
            },
            {
              "id": "aerial-equipment-crown-sp3510",
              "name": "SP3510",
              "subcategories": []
            },
            {
              "id": "aerial-equipment-crown-sp3520",
              "name": "SP3520",
              "subcategories": []
            },
            {
              "id": "aerial-equipment-crown-sp3570",
              "name": "SP3570",
              "subcategories": []
            },
            {
              "id": "aerial-equipment-crown-sp4000",
              "name": "SP4000",
              "subcategories": []
            },
            {
              "id": "aerial-equipment-crown-sp4020",
              "name": "SP4020",
              "subcategories": []
            },
            {
              "id": "aerial-equipment-crown-sp4050",
              "name": "SP4050",
              "subcategories": []
            },
            {
              "id": "aerial-equipment-crown-sx3000",
              "name": "SX3000",
              "subcategories": []
            },
            {
              "id": "aerial-equipment-crown-tr3560",
              "name": "TR3560",
              "subcategories": []
            },
            {
              "id": "aerial-equipment-crown-tr4500",
              "name": "TR4500",
              "subcategories": []
            },
            {
              "id": "aerial-equipment-crown-tsp6000",
              "name": "TSP6000",
              "subcategories": []
            },
            {
              "id": "aerial-equipment-crown-tsp6500",
              "name": "TSP6500",
              "subcategories": []
            },
            {
              "id": "aerial-equipment-crown-wav50",
              "name": "WAV50",
              "subcategories": []
            },
            {
              "id": "aerial-equipment-crown-wav60",
              "name": "WAV60",
              "subcategories": []
            },
            {
              "id": "aerial-equipment-crown-we2300",
              "name": "WE2300",
              "subcategories": []
            },
            {
              "id": "aerial-equipment-crown-2p2345",
              "name": "2P2345",
              "subcategories": []
            },
            {
              "id": "aerial-equipment-crown-wp2345",
              "name": "WP2345",
              "subcategories": []
            },
            {
              "id": "aerial-equipment-crown-wp3035",
              "name": "WP3035",
              "subcategories": []
            },
            {
              "id": "aerial-equipment-crown-wp3045",
              "name": "WP3045",
              "subcategories": []
            },
            {
              "id": "aerial-equipment-crown-ws2300",
              "name": "WS2300",
              "subcategories": []
            },
            {
              "id": "aerial-equipment-crown-other",
              "name": "OTHER",
              "subcategories": []
            }
          ]
        },
        {
          "id": "aerial-equipment-dieci",
          "name": "Dieci",
          "subcategories": [
            {
              "id": "aerial-equipment-dieci-a55-19",
              "name": "A55.19",
              "subcategories": []
            },
            {
              "id": "aerial-equipment-dieci-af-28-7",
              "name": "AF 28.7",
              "subcategories": []
            },
            {
              "id": "aerial-equipment-dieci-af-30-7",
              "name": "AF 30.7",
              "subcategories": []
            },
            {
              "id": "aerial-equipment-dieci-af-30-9",
              "name": "AF 30.9",
              "subcategories": []
            },
            {
              "id": "aerial-equipment-dieci-af-32-6",
              "name": "AF 32.6",
              "subcategories": []
            },
            {
              "id": "aerial-equipment-dieci-af-32-7",
              "name": "AF 32.7",
              "subcategories": []
            },
            {
              "id": "aerial-equipment-dieci-af-32-9",
              "name": "AF 32.9",
              "subcategories": []
            },
            {
              "id": "aerial-equipment-dieci-am-60-9",
              "name": "AM 60.9",
              "subcategories": []
            },
            {
              "id": "aerial-equipment-dieci-am-75-10",
              "name": "AM 75.10",
              "subcategories": []
            },
            {
              "id": "aerial-equipment-dieci-ap-40-7",
              "name": "AP 40.7",
              "subcategories": []
            },
            {
              "id": "aerial-equipment-dieci-ap-40-7h",
              "name": "AP 40.7H",
              "subcategories": []
            },
            {
              "id": "aerial-equipment-dieci-ap-42-7",
              "name": "AP 42.7",
              "subcategories": []
            },
            {
              "id": "aerial-equipment-dieci-as-35-6",
              "name": "AS 35.6",
              "subcategories": []
            },
            {
              "id": "aerial-equipment-dieci-as-38-1",
              "name": "AS 38.1",
              "subcategories": []
            },
            {
              "id": "aerial-equipment-dieci-as-40-7",
              "name": "AS 40.7",
              "subcategories": []
            },
            {
              "id": "aerial-equipment-dieci-at-35-7",
              "name": "AT 35.7",
              "subcategories": []
            },
            {
              "id": "aerial-equipment-dieci-apollo-20-4",
              "name": "APOLLO 20.4",
              "subcategories": []
            },
            {
              "id": "aerial-equipment-dieci-apollo-25-6",
              "name": "APOLLO 25.6",
              "subcategories": []
            },
            {
              "id": "aerial-equipment-dieci-apollo-26-6",
              "name": "APOLLO 26.6",
              "subcategories": []
            },
            {
              "id": "aerial-equipment-dieci-dedalus-30-7",
              "name": "DEDALUS 30.7",
              "subcategories": []
            },
            {
              "id": "aerial-equipment-dieci-dedalus-30-9",
              "name": "DEDALUS 30.9",
              "subcategories": []
            },
            {
              "id": "aerial-equipment-dieci-hercules-120-10",
              "name": "HERCULES 120.10",
              "subcategories": []
            },
            {
              "id": "aerial-equipment-dieci-hercules-130-10",
              "name": "HERCULES 130.10",
              "subcategories": []
            },
            {
              "id": "aerial-equipment-dieci-hercules-210-10",
              "name": "HERCULES 210.10",
              "subcategories": []
            },
            {
              "id": "aerial-equipment-dieci-hercules-264-32",
              "name": "HERCULES 264.32",
              "subcategories": []
            },
            {
              "id": "aerial-equipment-dieci-icarus-10-44",
              "name": "ICARUS 10.44",
              "subcategories": []
            },
            {
              "id": "aerial-equipment-dieci-icarus-10-44c",
              "name": "ICARUS 10.44C",
              "subcategories": []
            },
            {
              "id": "aerial-equipment-dieci-icarus-11-58",
              "name": "ICARUS 11.58",
              "subcategories": []
            },
            {
              "id": "aerial-equipment-dieci-icarus-12-56",
              "name": "ICARUS 12.56",
              "subcategories": []
            },
            {
              "id": "aerial-equipment-dieci-icarus-12-56c",
              "name": "ICARUS 12.56C",
              "subcategories": []
            },
            {
              "id": "aerial-equipment-dieci-icarus-12-56d",
              "name": "ICARUS 12.56D",
              "subcategories": []
            },
            {
              "id": "aerial-equipment-dieci-icarus-30-16",
              "name": "ICARUS 30.16",
              "subcategories": []
            },
            {
              "id": "aerial-equipment-dieci-icarus-40-14",
              "name": "ICARUS 40.14",
              "subcategories": []
            },
            {
              "id": "aerial-equipment-dieci-icarus-40-17",
              "name": "ICARUS 40.17",
              "subcategories": []
            },
            {
              "id": "aerial-equipment-dieci-icarus-45-17",
              "name": "ICARUS 45.17",
              "subcategories": []
            },
            {
              "id": "aerial-equipment-dieci-icarus-50-18gd",
              "name": "ICARUS 50.18GD",
              "subcategories": []
            },
            {
              "id": "aerial-equipment-dieci-icarus-60-18",
              "name": "ICARUS 60.18",
              "subcategories": []
            },
            {
              "id": "aerial-equipment-dieci-kvl300",
              "name": "KVL300",
              "subcategories": []
            },
            {
              "id": "aerial-equipment-dieci-mini-agri-25-6",
              "name": "MINI AGRI 25.6",
              "subcategories": []
            },
            {
              "id": "aerial-equipment-dieci-mini-agri-26-6",
              "name": "MINI AGRI 26.6",
              "subcategories": []
            },
            {
              "id": "aerial-equipment-dieci-pegasus-35-16",
              "name": "PEGASUS 35.16",
              "subcategories": []
            },
            {
              "id": "aerial-equipment-dieci-pegasus-40-18",
              "name": "PEGASUS 40.18",
              "subcategories": []
            },
            {
              "id": "aerial-equipment-dieci-pegasus-40-25",
              "name": "PEGASUS 40.25",
              "subcategories": []
            },
            {
              "id": "aerial-equipment-dieci-pegasus-45-21",
              "name": "PEGASUS 45.21",
              "subcategories": []
            },
            {
              "id": "aerial-equipment-dieci-pegasus-45-30",
              "name": "PEGASUS 45.30",
              "subcategories": []
            },
            {
              "id": "aerial-equipment-dieci-pegasus-50-21",
              "name": "PEGASUS 50.21",
              "subcategories": []
            },
            {
              "id": "aerial-equipment-dieci-pegasus-50-25",
              "name": "PEGASUS 50.25",
              "subcategories": []
            },
            {
              "id": "aerial-equipment-dieci-pegasus-50-26",
              "name": "PEGASUS 50.26",
              "subcategories": []
            },
            {
              "id": "aerial-equipment-dieci-samson-70-10",
              "name": "SAMSON 70.10",
              "subcategories": []
            },
            {
              "id": "aerial-equipment-dieci-samson-75-10",
              "name": "SAMSON 75.10",
              "subcategories": []
            },
            {
              "id": "aerial-equipment-dieci-xrm7-732",
              "name": "XRM7.732",
              "subcategories": []
            },
            {
              "id": "aerial-equipment-dieci-zeus-38-10",
              "name": "ZEUS 38.10",
              "subcategories": []
            },
            {
              "id": "aerial-equipment-dieci-zues-40-13",
              "name": "ZUES 40.13",
              "subcategories": []
            },
            {
              "id": "aerial-equipment-dieci-zues-40-13-gd",
              "name": "ZUES 40.13 GD",
              "subcategories": []
            },
            {
              "id": "aerial-equipment-dieci-other",
              "name": "OTHER",
              "subcategories": []
            }
          ]
        },
        {
          "id": "aerial-equipment-doosan",
          "name": "Doosan",
          "subcategories": [
            {
              "id": "aerial-equipment-doosan-b15",
              "name": "B15",
              "subcategories": []
            },
            {
              "id": "aerial-equipment-doosan-b20",
              "name": "B20",
              "subcategories": []
            },
            {
              "id": "aerial-equipment-doosan-b20t",
              "name": "B20T",
              "subcategories": []
            },
            {
              "id": "aerial-equipment-doosan-b25",
              "name": "B25",
              "subcategories": []
            },
            {
              "id": "aerial-equipment-doosan-b30",
              "name": "B30",
              "subcategories": []
            },
            {
              "id": "aerial-equipment-doosan-b35",
              "name": "B35",
              "subcategories": []
            },
            {
              "id": "aerial-equipment-doosan-b50",
              "name": "B50",
              "subcategories": []
            },
            {
              "id": "aerial-equipment-doosan-bc15",
              "name": "BC15",
              "subcategories": []
            },
            {
              "id": "aerial-equipment-doosan-bc18",
              "name": "BC18",
              "subcategories": []
            },
            {
              "id": "aerial-equipment-doosan-bc25",
              "name": "BC25",
              "subcategories": []
            },
            {
              "id": "aerial-equipment-doosan-bc30",
              "name": "BC30",
              "subcategories": []
            },
            {
              "id": "aerial-equipment-doosan-bc32",
              "name": "BC32",
              "subcategories": []
            },
            {
              "id": "aerial-equipment-doosan-ber30",
              "name": "BER30",
              "subcategories": []
            },
            {
              "id": "aerial-equipment-doosan-bop15",
              "name": "BOP15",
              "subcategories": []
            },
            {
              "id": "aerial-equipment-doosan-br18",
              "name": "BR18",
              "subcategories": []
            },
            {
              "id": "aerial-equipment-doosan-br20",
              "name": "BR20",
              "subcategories": []
            },
            {
              "id": "aerial-equipment-doosan-bsl16",
              "name": "BSL16",
              "subcategories": []
            },
            {
              "id": "aerial-equipment-doosan-bw23",
              "name": "BW23",
              "subcategories": []
            },
            {
              "id": "aerial-equipment-doosan-bwp17",
              "name": "BWP17",
              "subcategories": []
            },
            {
              "id": "aerial-equipment-doosan-bws17",
              "name": "BWS17",
              "subcategories": []
            },
            {
              "id": "aerial-equipment-doosan-bwt45",
              "name": "BWT45",
              "subcategories": []
            },
            {
              "id": "aerial-equipment-doosan-d15",
              "name": "D15",
              "subcategories": []
            },
            {
              "id": "aerial-equipment-doosan-d20",
              "name": "D20",
              "subcategories": []
            },
            {
              "id": "aerial-equipment-doosan-d25",
              "name": "D25",
              "subcategories": []
            },
            {
              "id": "aerial-equipment-doosan-d30",
              "name": "D30",
              "subcategories": []
            },
            {
              "id": "aerial-equipment-doosan-d33",
              "name": "D33",
              "subcategories": []
            },
            {
              "id": "aerial-equipment-doosan-d35",
              "name": "D35",
              "subcategories": []
            },
            {
              "id": "aerial-equipment-doosan-d40",
              "name": "D40",
              "subcategories": []
            },
            {
              "id": "aerial-equipment-doosan-d45",
              "name": "D45",
              "subcategories": []
            },
            {
              "id": "aerial-equipment-doosan-d50",
              "name": "D50",
              "subcategories": []
            },
            {
              "id": "aerial-equipment-doosan-d55",
              "name": "D55",
              "subcategories": []
            },
            {
              "id": "aerial-equipment-doosan-d60",
              "name": "D60",
              "subcategories": []
            },
            {
              "id": "aerial-equipment-doosan-d70",
              "name": "D70",
              "subcategories": []
            },
            {
              "id": "aerial-equipment-doosan-d80",
              "name": "D80",
              "subcategories": []
            },
            {
              "id": "aerial-equipment-doosan-d90",
              "name": "D90",
              "subcategories": []
            },
            {
              "id": "aerial-equipment-doosan-d100",
              "name": "D100",
              "subcategories": []
            },
            {
              "id": "aerial-equipment-doosan-d110",
              "name": "D110",
              "subcategories": []
            },
            {
              "id": "aerial-equipment-doosan-d120",
              "name": "D120",
              "subcategories": []
            },
            {
              "id": "aerial-equipment-doosan-d130",
              "name": "D130",
              "subcategories": []
            },
            {
              "id": "aerial-equipment-doosan-d140",
              "name": "D140",
              "subcategories": []
            },
            {
              "id": "aerial-equipment-doosan-d160",
              "name": "D160",
              "subcategories": []
            },
            {
              "id": "aerial-equipment-doosan-dv180",
              "name": "DV180",
              "subcategories": []
            },
            {
              "id": "aerial-equipment-doosan-dv250",
              "name": "DV250",
              "subcategories": []
            },
            {
              "id": "aerial-equipment-doosan-g15",
              "name": "G15",
              "subcategories": []
            },
            {
              "id": "aerial-equipment-doosan-g18",
              "name": "G18",
              "subcategories": []
            },
            {
              "id": "aerial-equipment-doosan-g20",
              "name": "G20",
              "subcategories": []
            },
            {
              "id": "aerial-equipment-doosan-g25",
              "name": "G25",
              "subcategories": []
            },
            {
              "id": "aerial-equipment-doosan-g30",
              "name": "G30",
              "subcategories": []
            },
            {
              "id": "aerial-equipment-doosan-g3",
              "name": "G3",
              "subcategories": []
            },
            {
              "id": "aerial-equipment-doosan-g33",
              "name": "G33",
              "subcategories": []
            },
            {
              "id": "aerial-equipment-doosan-g35",
              "name": "G35",
              "subcategories": []
            },
            {
              "id": "aerial-equipment-doosan-g40",
              "name": "G40",
              "subcategories": []
            },
            {
              "id": "aerial-equipment-doosan-g45",
              "name": "G45",
              "subcategories": []
            },
            {
              "id": "aerial-equipment-doosan-g50",
              "name": "G50",
              "subcategories": []
            },
            {
              "id": "aerial-equipment-doosan-g55",
              "name": "G55",
              "subcategories": []
            },
            {
              "id": "aerial-equipment-doosan-g70",
              "name": "G70",
              "subcategories": []
            },
            {
              "id": "aerial-equipment-doosan-gc15",
              "name": "GC15",
              "subcategories": []
            },
            {
              "id": "aerial-equipment-doosan-gc20",
              "name": "GC20",
              "subcategories": []
            },
            {
              "id": "aerial-equipment-doosan-gc25",
              "name": "GC25",
              "subcategories": []
            },
            {
              "id": "aerial-equipment-doosan-gc30",
              "name": "GC30",
              "subcategories": []
            },
            {
              "id": "aerial-equipment-doosan-gc33",
              "name": "GC33",
              "subcategories": []
            },
            {
              "id": "aerial-equipment-doosan-gc35",
              "name": "GC35",
              "subcategories": []
            },
            {
              "id": "aerial-equipment-doosan-gc40",
              "name": "GC40",
              "subcategories": []
            },
            {
              "id": "aerial-equipment-doosan-gc45",
              "name": "GC45",
              "subcategories": []
            },
            {
              "id": "aerial-equipment-doosan-gc55",
              "name": "GC55",
              "subcategories": []
            },
            {
              "id": "aerial-equipment-doosan-other",
              "name": "OTHER",
              "subcategories": []
            }
          ]
        },
        {
          "id": "aerial-equipment-hamgcha",
          "name": "Hamgcha",
          "subcategories": []
        },
        {
          "id": "aerial-equipment-haulotte",
          "name": "Haulotte",
          "subcategories": []
        },
        {
          "id": "aerial-equipment-heli",
          "name": "Heli",
          "subcategories": [
            {
              "id": "aerial-equipment-heli-1932",
              "name": "1932",
              "subcategories": []
            },
            {
              "id": "aerial-equipment-heli-cbd15",
              "name": "CBD15",
              "subcategories": []
            },
            {
              "id": "aerial-equipment-heli-cbd20",
              "name": "CBD20",
              "subcategories": []
            },
            {
              "id": "aerial-equipment-heli-cbd25",
              "name": "CBD25",
              "subcategories": []
            },
            {
              "id": "aerial-equipment-heli-cbd30",
              "name": "CBD30",
              "subcategories": []
            },
            {
              "id": "aerial-equipment-heli-cbd35",
              "name": "CBD35",
              "subcategories": []
            },
            {
              "id": "aerial-equipment-heli-cbs10",
              "name": "CBS10",
              "subcategories": []
            },
            {
              "id": "aerial-equipment-heli-cbs15",
              "name": "CBS15",
              "subcategories": []
            },
            {
              "id": "aerial-equipment-heli-cbs20",
              "name": "CBS20",
              "subcategories": []
            },
            {
              "id": "aerial-equipment-heli-cdd12",
              "name": "CDD12",
              "subcategories": []
            },
            {
              "id": "aerial-equipment-heli-cdd14",
              "name": "CDD14",
              "subcategories": []
            },
            {
              "id": "aerial-equipment-heli-cdd15",
              "name": "CDD15",
              "subcategories": []
            },
            {
              "id": "aerial-equipment-heli-cdd16",
              "name": "CDD16",
              "subcategories": []
            },
            {
              "id": "aerial-equipment-heli-cdd20",
              "name": "CDD20",
              "subcategories": []
            },
            {
              "id": "aerial-equipment-heli-cpc30",
              "name": "CPC30",
              "subcategories": []
            },
            {
              "id": "aerial-equipment-heli-cpc35",
              "name": "CPC35",
              "subcategories": []
            },
            {
              "id": "aerial-equipment-heli-cpcd15",
              "name": "CPCD15",
              "subcategories": []
            },
            {
              "id": "aerial-equipment-heli-cpcd18",
              "name": "CPCD18",
              "subcategories": []
            },
            {
              "id": "aerial-equipment-heli-cpcd20",
              "name": "CPCD20",
              "subcategories": []
            },
            {
              "id": "aerial-equipment-heli-cpcd25",
              "name": "CPCD25",
              "subcategories": []
            },
            {
              "id": "aerial-equipment-heli-cpcd30",
              "name": "CPCD30",
              "subcategories": []
            },
            {
              "id": "aerial-equipment-heli-cpcd35",
              "name": "CPCD35",
              "subcategories": []
            },
            {
              "id": "aerial-equipment-heli-cpcd40",
              "name": "CPCD40",
              "subcategories": []
            },
            {
              "id": "aerial-equipment-heli-cpcd45",
              "name": "CPCD45",
              "subcategories": []
            },
            {
              "id": "aerial-equipment-heli-cpcd45",
              "name": "CPCD45",
              "subcategories": []
            },
            {
              "id": "aerial-equipment-heli-cpcd50",
              "name": "CPCD50",
              "subcategories": []
            },
            {
              "id": "aerial-equipment-heli-cpcd55",
              "name": "CPCD55",
              "subcategories": []
            },
            {
              "id": "aerial-equipment-heli-cpcd60",
              "name": "CPCD60",
              "subcategories": []
            },
            {
              "id": "aerial-equipment-heli-cpcd70",
              "name": "CPCD70",
              "subcategories": []
            },
            {
              "id": "aerial-equipment-heli-cpcd80",
              "name": "CPCD80",
              "subcategories": []
            },
            {
              "id": "aerial-equipment-heli-cpcd100",
              "name": "CPCD100",
              "subcategories": []
            },
            {
              "id": "aerial-equipment-heli-cpcd120",
              "name": "CPCD120",
              "subcategories": []
            },
            {
              "id": "aerial-equipment-heli-cpcd135",
              "name": "CPCD135",
              "subcategories": []
            },
            {
              "id": "aerial-equipment-heli-cpcd150",
              "name": "CPCD150",
              "subcategories": []
            },
            {
              "id": "aerial-equipment-heli-cpcd160",
              "name": "CPCD160",
              "subcategories": []
            },
            {
              "id": "aerial-equipment-heli-cpcd180",
              "name": "CPCD180",
              "subcategories": []
            },
            {
              "id": "aerial-equipment-heli-cpcd200",
              "name": "CPCD200",
              "subcategories": []
            },
            {
              "id": "aerial-equipment-heli-cpcd250",
              "name": "CPCD250",
              "subcategories": []
            },
            {
              "id": "aerial-equipment-heli-cpcd250",
              "name": "CPCD250",
              "subcategories": []
            },
            {
              "id": "aerial-equipment-heli-cpcd280",
              "name": "CPCD280",
              "subcategories": []
            },
            {
              "id": "aerial-equipment-heli-cpcd300",
              "name": "CPCD300",
              "subcategories": []
            },
            {
              "id": "aerial-equipment-heli-cpcd320",
              "name": "CPCD320",
              "subcategories": []
            },
            {
              "id": "aerial-equipment-heli-cpcd350",
              "name": "CPCD350",
              "subcategories": []
            },
            {
              "id": "aerial-equipment-heli-cpcd380",
              "name": "CPCD380",
              "subcategories": []
            },
            {
              "id": "aerial-equipment-heli-cpcd420",
              "name": "CPCD420",
              "subcategories": []
            },
            {
              "id": "aerial-equipment-heli-cpd10sq",
              "name": "CPD10SQ",
              "subcategories": []
            },
            {
              "id": "aerial-equipment-heli-cpd15",
              "name": "CPD15",
              "subcategories": []
            },
            {
              "id": "aerial-equipment-heli-cpd18",
              "name": "CPD18",
              "subcategories": []
            },
            {
              "id": "aerial-equipment-heli-cpd20",
              "name": "CPD20",
              "subcategories": []
            },
            {
              "id": "aerial-equipment-heli-cpd25",
              "name": "CPD25",
              "subcategories": []
            },
            {
              "id": "aerial-equipment-heli-cpd30",
              "name": "CPD30",
              "subcategories": []
            },
            {
              "id": "aerial-equipment-heli-cpd35",
              "name": "CPD35",
              "subcategories": []
            },
            {
              "id": "aerial-equipment-heli-cpd38",
              "name": "CPD38",
              "subcategories": []
            },
            {
              "id": "aerial-equipment-heli-cpd40",
              "name": "CPD40",
              "subcategories": []
            },
            {
              "id": "aerial-equipment-heli-cpd45",
              "name": "CPD45",
              "subcategories": []
            },
            {
              "id": "aerial-equipment-heli-cpd50",
              "name": "CPD50",
              "subcategories": []
            },
            {
              "id": "aerial-equipment-heli-cpd60",
              "name": "CPD60",
              "subcategories": []
            },
            {
              "id": "aerial-equipment-heli-cpd70",
              "name": "CPD70",
              "subcategories": []
            },
            {
              "id": "aerial-equipment-heli-cpd85",
              "name": "CPD85",
              "subcategories": []
            },
            {
              "id": "aerial-equipment-heli-cpd100",
              "name": "CPD100",
              "subcategories": []
            },
            {
              "id": "aerial-equipment-heli-cpd180",
              "name": "CPD180",
              "subcategories": []
            },
            {
              "id": "aerial-equipment-heli-cpqd25",
              "name": "CPQD25",
              "subcategories": []
            },
            {
              "id": "aerial-equipment-heli-cpqd35",
              "name": "CPQD35",
              "subcategories": []
            },
            {
              "id": "aerial-equipment-heli-cpqd40",
              "name": "CPQD40",
              "subcategories": []
            },
            {
              "id": "aerial-equipment-heli-cpqd50",
              "name": "CPQD50",
              "subcategories": []
            },
            {
              "id": "aerial-equipment-heli-cpqd70",
              "name": "CPQD70",
              "subcategories": []
            },
            {
              "id": "aerial-equipment-heli-cpqyd15",
              "name": "CPQYD15",
              "subcategories": []
            },
            {
              "id": "aerial-equipment-heli-cpqyd18",
              "name": "CPQYD18",
              "subcategories": []
            },
            {
              "id": "aerial-equipment-heli-cpqyd20",
              "name": "CPQYD20",
              "subcategories": []
            },
            {
              "id": "aerial-equipment-heli-cpqyd25",
              "name": "CPQYD25",
              "subcategories": []
            },
            {
              "id": "aerial-equipment-heli-cpqyd30",
              "name": "CPQYD30",
              "subcategories": []
            },
            {
              "id": "aerial-equipment-heli-cpqyd35",
              "name": "CPQYD35",
              "subcategories": []
            },
            {
              "id": "aerial-equipment-heli-cpqyd40",
              "name": "CPQYD40",
              "subcategories": []
            },
            {
              "id": "aerial-equipment-heli-cpqyd45",
              "name": "CPQYD45",
              "subcategories": []
            },
            {
              "id": "aerial-equipment-heli-cpqyd50",
              "name": "CPQYD50",
              "subcategories": []
            },
            {
              "id": "aerial-equipment-heli-cpqyd55",
              "name": "CPQYD55",
              "subcategories": []
            },
            {
              "id": "aerial-equipment-heli-cpyd15",
              "name": "CPYD15",
              "subcategories": []
            },
            {
              "id": "aerial-equipment-heli-cpyd18",
              "name": "CPYD18",
              "subcategories": []
            },
            {
              "id": "aerial-equipment-heli-cpyd20",
              "name": "CPYD20",
              "subcategories": []
            },
            {
              "id": "aerial-equipment-heli-cpyd25",
              "name": "CPYD25",
              "subcategories": []
            },
            {
              "id": "aerial-equipment-heli-cpyd30",
              "name": "CPYD30",
              "subcategories": []
            },
            {
              "id": "aerial-equipment-heli-cpyd32",
              "name": "CPYD32",
              "subcategories": []
            },
            {
              "id": "aerial-equipment-heli-cpyd40",
              "name": "CPYD40",
              "subcategories": []
            },
            {
              "id": "aerial-equipment-heli-cpyd50",
              "name": "CPYD50",
              "subcategories": []
            },
            {
              "id": "aerial-equipment-heli-cqdh12",
              "name": "CQDH12",
              "subcategories": []
            },
            {
              "id": "aerial-equipment-heli-cqdh14",
              "name": "CQDH14",
              "subcategories": []
            },
            {
              "id": "aerial-equipment-heli-cqdh15",
              "name": "CQDH15",
              "subcategories": []
            },
            {
              "id": "aerial-equipment-heli-cqdh20",
              "name": "CQDH20",
              "subcategories": []
            },
            {
              "id": "aerial-equipment-heli-cqd14",
              "name": "CQD14",
              "subcategories": []
            },
            {
              "id": "aerial-equipment-heli-cqd15",
              "name": "CQD15",
              "subcategories": []
            },
            {
              "id": "aerial-equipment-heli-cqd16",
              "name": "CQD16",
              "subcategories": []
            },
            {
              "id": "aerial-equipment-heli-cqd18",
              "name": "CQD18",
              "subcategories": []
            },
            {
              "id": "aerial-equipment-heli-cqd20",
              "name": "CQD20",
              "subcategories": []
            },
            {
              "id": "aerial-equipment-heli-cqd25",
              "name": "CQD25",
              "subcategories": []
            },
            {
              "id": "aerial-equipment-heli-cqdm12",
              "name": "CQDM12",
              "subcategories": []
            },
            {
              "id": "aerial-equipment-heli-cqdm15",
              "name": "CQDM15",
              "subcategories": []
            },
            {
              "id": "aerial-equipment-heli-fb315g",
              "name": "FB315G",
              "subcategories": []
            },
            {
              "id": "aerial-equipment-heli-fd20",
              "name": "FD20",
              "subcategories": []
            },
            {
              "id": "aerial-equipment-heli-fd30",
              "name": "FD30",
              "subcategories": []
            },
            {
              "id": "aerial-equipment-heli-fd155",
              "name": "FD155",
              "subcategories": []
            },
            {
              "id": "aerial-equipment-heli-fd220",
              "name": "FD220",
              "subcategories": []
            },
            {
              "id": "aerial-equipment-heli-fg60",
              "name": "FG60",
              "subcategories": []
            },
            {
              "id": "aerial-equipment-heli-gpyd25",
              "name": "GPYD25",
              "subcategories": []
            },
            {
              "id": "aerial-equipment-heli-hfd20",
              "name": "HFD20",
              "subcategories": []
            },
            {
              "id": "aerial-equipment-heli-hfd50",
              "name": "HFD50",
              "subcategories": []
            },
            {
              "id": "aerial-equipment-heli-jx12j",
              "name": "JX12J",
              "subcategories": []
            },
            {
              "id": "aerial-equipment-heli-opl10",
              "name": "OPL10",
              "subcategories": []
            },
            {
              "id": "aerial-equipment-heli-opl15",
              "name": "OPL15",
              "subcategories": []
            },
            {
              "id": "aerial-equipment-heli-ops15",
              "name": "OPS15",
              "subcategories": []
            },
            {
              "id": "aerial-equipment-heli-opsm",
              "name": "OPSM",
              "subcategories": []
            },
            {
              "id": "aerial-equipment-heli-zm400s",
              "name": "ZM400S",
              "subcategories": []
            },
            {
              "id": "aerial-equipment-heli-other",
              "name": "OTHER",
              "subcategories": []
            }
          ]
        },
        {
          "id": "aerial-equipment-hoist",
          "name": "Hoist",
          "subcategories": [
            {
              "id": "aerial-equipment-hoist-e300",
              "name": "E300",
              "subcategories": []
            },
            {
              "id": "aerial-equipment-hoist-e350",
              "name": "E350",
              "subcategories": []
            },
            {
              "id": "aerial-equipment-hoist-e400",
              "name": "E400",
              "subcategories": []
            },
            {
              "id": "aerial-equipment-hoist-f180",
              "name": "F180",
              "subcategories": []
            },
            {
              "id": "aerial-equipment-hoist-f220",
              "name": "F220",
              "subcategories": []
            },
            {
              "id": "aerial-equipment-hoist-f250",
              "name": "F250",
              "subcategories": []
            },
            {
              "id": "aerial-equipment-hoist-f300",
              "name": "F300",
              "subcategories": []
            },
            {
              "id": "aerial-equipment-hoist-f350",
              "name": "F350",
              "subcategories": []
            },
            {
              "id": "aerial-equipment-hoist-f400",
              "name": "F400",
              "subcategories": []
            },
            {
              "id": "aerial-equipment-hoist-f500",
              "name": "F500",
              "subcategories": []
            },
            {
              "id": "aerial-equipment-hoist-f600",
              "name": "F600",
              "subcategories": []
            },
            {
              "id": "aerial-equipment-hoist-fke10",
              "name": "FKE10",
              "subcategories": []
            },
            {
              "id": "aerial-equipment-hoist-fke13",
              "name": "FKE13",
              "subcategories": []
            },
            {
              "id": "aerial-equipment-hoist-fke15",
              "name": "FKE15",
              "subcategories": []
            },
            {
              "id": "aerial-equipment-hoist-fks15",
              "name": "FKS15",
              "subcategories": []
            },
            {
              "id": "aerial-equipment-hoist-fks20",
              "name": "FKS20",
              "subcategories": []
            },
            {
              "id": "aerial-equipment-hoist-fr25",
              "name": "FR25",
              "subcategories": []
            },
            {
              "id": "aerial-equipment-hoist-fr40",
              "name": "FR40",
              "subcategories": []
            },
            {
              "id": "aerial-equipment-hoist-fr60",
              "name": "FR60",
              "subcategories": []
            },
            {
              "id": "aerial-equipment-hoist-m75",
              "name": "M75",
              "subcategories": []
            },
            {
              "id": "aerial-equipment-hoist-m250",
              "name": "M250",
              "subcategories": []
            },
            {
              "id": "aerial-equipment-hoist-m350",
              "name": "M350",
              "subcategories": []
            },
            {
              "id": "aerial-equipment-hoist-m370",
              "name": "M370",
              "subcategories": []
            },
            {
              "id": "aerial-equipment-hoist-p220",
              "name": "P220",
              "subcategories": []
            },
            {
              "id": "aerial-equipment-hoist-p300",
              "name": "P300",
              "subcategories": []
            },
            {
              "id": "aerial-equipment-hoist-p360",
              "name": "P360",
              "subcategories": []
            },
            {
              "id": "aerial-equipment-hoist-p550",
              "name": "P550",
              "subcategories": []
            },
            {
              "id": "aerial-equipment-hoist-p650",
              "name": "P650",
              "subcategories": []
            },
            {
              "id": "aerial-equipment-hoist-p800",
              "name": "P800",
              "subcategories": []
            },
            {
              "id": "aerial-equipment-hoist-p925",
              "name": "P925",
              "subcategories": []
            },
            {
              "id": "aerial-equipment-hoist-p1050",
              "name": "P1050",
              "subcategories": []
            },
            {
              "id": "aerial-equipment-hoist-pv3000",
              "name": "PV3000",
              "subcategories": []
            },
            {
              "id": "aerial-equipment-hoist-other",
              "name": "OTHER",
              "subcategories": []
            }
          ]
        },
        {
          "id": "aerial-equipment-hyundai",
          "name": "Hyundai",
          "subcategories": [
            {
              "id": "aerial-equipment-hyundai-10btr",
              "name": "10BTR",
              "subcategories": []
            },
            {
              "id": "aerial-equipment-hyundai-12lpt-i",
              "name": "12LPT-I",
              "subcategories": []
            },
            {
              "id": "aerial-equipment-hyundai-13bop",
              "name": "13BOP",
              "subcategories": []
            },
            {
              "id": "aerial-equipment-hyundai-15brp",
              "name": "15BRP",
              "subcategories": []
            },
            {
              "id": "aerial-equipment-hyundai-15bt",
              "name": "15BT",
              "subcategories": []
            },
            {
              "id": "aerial-equipment-hyundai-15d",
              "name": "15D",
              "subcategories": []
            },
            {
              "id": "aerial-equipment-hyundai-15l",
              "name": "15L",
              "subcategories": []
            },
            {
              "id": "aerial-equipment-hyundai-18bcs",
              "name": "18BCS",
              "subcategories": []
            },
            {
              "id": "aerial-equipment-hyundai-18brp",
              "name": "18BRP",
              "subcategories": []
            },
            {
              "id": "aerial-equipment-hyundai-18bt",
              "name": "18BT",
              "subcategories": []
            },
            {
              "id": "aerial-equipment-hyundai-18l",
              "name": "18L",
              "subcategories": []
            },
            {
              "id": "aerial-equipment-hyundai-18lc",
              "name": "18LC",
              "subcategories": []
            },
            {
              "id": "aerial-equipment-hyundai-20bt",
              "name": "20BT",
              "subcategories": []
            },
            {
              "id": "aerial-equipment-hyundai-20brp",
              "name": "20BRP",
              "subcategories": []
            },
            {
              "id": "aerial-equipment-hyundai-20d",
              "name": "20D",
              "subcategories": []
            },
            {
              "id": "aerial-equipment-hyundai-20da",
              "name": "20DA",
              "subcategories": []
            },
            {
              "id": "aerial-equipment-hyundai-20l",
              "name": "20L",
              "subcategories": []
            },
            {
              "id": "aerial-equipment-hyundai-25b",
              "name": "25B",
              "subcategories": []
            },
            {
              "id": "aerial-equipment-hyundai-25bc",
              "name": "25BC",
              "subcategories": []
            },
            {
              "id": "aerial-equipment-hyundai-25bh",
              "name": "25BH",
              "subcategories": []
            },
            {
              "id": "aerial-equipment-hyundai-25d",
              "name": "25D",
              "subcategories": []
            },
            {
              "id": "aerial-equipment-hyundai-25g",
              "name": "25G",
              "subcategories": []
            },
            {
              "id": "aerial-equipment-hyundai-25l",
              "name": "25L",
              "subcategories": []
            },
            {
              "id": "aerial-equipment-hyundai-25lc",
              "name": "25LC",
              "subcategories": []
            },
            {
              "id": "aerial-equipment-hyundai-25le",
              "name": "25LE",
              "subcategories": []
            },
            {
              "id": "aerial-equipment-hyundai-30b-9u",
              "name": "30B-9U",
              "subcategories": []
            },
            {
              "id": "aerial-equipment-hyundai-30b-x",
              "name": "30B-X",
              "subcategories": []
            },
            {
              "id": "aerial-equipment-hyundai-30bc",
              "name": "30BC",
              "subcategories": []
            },
            {
              "id": "aerial-equipment-hyundai-30d",
              "name": "30D",
              "subcategories": []
            },
            {
              "id": "aerial-equipment-hyundai-30d-9v",
              "name": "30D-9V",
              "subcategories": []
            },
            {
              "id": "aerial-equipment-hyundai-30g-9a",
              "name": "30G-9A",
              "subcategories": []
            },
            {
              "id": "aerial-equipment-hyundai-30l",
              "name": "30L",
              "subcategories": []
            },
            {
              "id": "aerial-equipment-hyundai-30lc",
              "name": "30LC",
              "subcategories": []
            },
            {
              "id": "aerial-equipment-hyundai-33d",
              "name": "33D",
              "subcategories": []
            },
            {
              "id": "aerial-equipment-hyundai-35d",
              "name": "35D",
              "subcategories": []
            },
            {
              "id": "aerial-equipment-hyundai-35da",
              "name": "35DA",
              "subcategories": []
            },
            {
              "id": "aerial-equipment-hyundai-35de",
              "name": "35DE",
              "subcategories": []
            },
            {
              "id": "aerial-equipment-hyundai-35ds",
              "name": "35DS",
              "subcategories": []
            },
            {
              "id": "aerial-equipment-hyundai-35l",
              "name": "35L",
              "subcategories": []
            },
            {
              "id": "aerial-equipment-hyundai-35le",
              "name": "35LE",
              "subcategories": []
            },
            {
              "id": "aerial-equipment-hyundai-40d",
              "name": "40D",
              "subcategories": []
            },
            {
              "id": "aerial-equipment-hyundai-40ds",
              "name": "40DS",
              "subcategories": []
            },
            {
              "id": "aerial-equipment-hyundai-40l",
              "name": "40L",
              "subcategories": []
            },
            {
              "id": "aerial-equipment-hyundai-45d",
              "name": "45D",
              "subcategories": []
            },
            {
              "id": "aerial-equipment-hyundai-45ds",
              "name": "45DS",
              "subcategories": []
            },
            {
              "id": "aerial-equipment-hyundai-45l",
              "name": "45L",
              "subcategories": []
            },
            {
              "id": "aerial-equipment-hyundai-50d",
              "name": "50D",
              "subcategories": []
            },
            {
              "id": "aerial-equipment-hyundai-50da",
              "name": "50DA",
              "subcategories": []
            },
            {
              "id": "aerial-equipment-hyundai-50l",
              "name": "50L",
              "subcategories": []
            },
            {
              "id": "aerial-equipment-hyundai-60l",
              "name": "60L",
              "subcategories": []
            },
            {
              "id": "aerial-equipment-hyundai-70d",
              "name": "70D",
              "subcategories": []
            },
            {
              "id": "aerial-equipment-hyundai-70ds",
              "name": "70DS",
              "subcategories": []
            },
            {
              "id": "aerial-equipment-hyundai-80d",
              "name": "80D",
              "subcategories": []
            },
            {
              "id": "aerial-equipment-hyundai-110d",
              "name": "110D",
              "subcategories": []
            },
            {
              "id": "aerial-equipment-hyundai-130d",
              "name": "130D",
              "subcategories": []
            },
            {
              "id": "aerial-equipment-hyundai-160d",
              "name": "160D",
              "subcategories": []
            },
            {
              "id": "aerial-equipment-hyundai-180d",
              "name": "180D",
              "subcategories": []
            },
            {
              "id": "aerial-equipment-hyundai-250d",
              "name": "250D",
              "subcategories": []
            },
            {
              "id": "aerial-equipment-hyundai-hbf18",
              "name": "HBF18",
              "subcategories": []
            },
            {
              "id": "aerial-equipment-hyundai-hbf25",
              "name": "HBF25",
              "subcategories": []
            },
            {
              "id": "aerial-equipment-hyundai-hdf30",
              "name": "HDF30",
              "subcategories": []
            },
            {
              "id": "aerial-equipment-hyundai-hlf25",
              "name": "HLF25",
              "subcategories": []
            },
            {
              "id": "aerial-equipment-hyundai-pf75",
              "name": "PF75",
              "subcategories": []
            },
            {
              "id": "aerial-equipment-hyundai-other",
              "name": "OTHER",
              "subcategories": []
            }
          ]
        },
        {
          "id": "aerial-equipment-komatsu",
          "name": "Komatsu",
          "subcategories": [
            {
              "id": "aerial-equipment-komatsu-fb15",
              "name": "FB15",
              "subcategories": []
            },
            {
              "id": "aerial-equipment-komatsu-fb18",
              "name": "FB18",
              "subcategories": []
            },
            {
              "id": "aerial-equipment-komatsu-fb20",
              "name": "FB20",
              "subcategories": []
            },
            {
              "id": "aerial-equipment-komatsu-fb25",
              "name": "FB25",
              "subcategories": []
            },
            {
              "id": "aerial-equipment-komatsu-fd25",
              "name": "FD25",
              "subcategories": []
            },
            {
              "id": "aerial-equipment-komatsu-fd30",
              "name": "FD30",
              "subcategories": []
            },
            {
              "id": "aerial-equipment-komatsu-fd50",
              "name": "FD50",
              "subcategories": []
            },
            {
              "id": "aerial-equipment-komatsu-fd60",
              "name": "FD60",
              "subcategories": []
            },
            {
              "id": "aerial-equipment-komatsu-fd70",
              "name": "FD70",
              "subcategories": []
            },
            {
              "id": "aerial-equipment-komatsu-fd100",
              "name": "FD100",
              "subcategories": []
            },
            {
              "id": "aerial-equipment-komatsu-fd115",
              "name": "FD115",
              "subcategories": []
            },
            {
              "id": "aerial-equipment-komatsu-fd135",
              "name": "FD135",
              "subcategories": []
            },
            {
              "id": "aerial-equipment-komatsu-fd150",
              "name": "FD150",
              "subcategories": []
            },
            {
              "id": "aerial-equipment-komatsu-fd160",
              "name": "FD160",
              "subcategories": []
            },
            {
              "id": "aerial-equipment-komatsu-fd200",
              "name": "FD200",
              "subcategories": []
            },
            {
              "id": "aerial-equipment-komatsu-fg15",
              "name": "FG15",
              "subcategories": []
            },
            {
              "id": "aerial-equipment-komatsu-fg18",
              "name": "FG18",
              "subcategories": []
            },
            {
              "id": "aerial-equipment-komatsu-fg20",
              "name": "FG20",
              "subcategories": []
            },
            {
              "id": "aerial-equipment-komatsu-fg25",
              "name": "FG25",
              "subcategories": []
            },
            {
              "id": "aerial-equipment-komatsu-fg30",
              "name": "FG30",
              "subcategories": []
            },
            {
              "id": "aerial-equipment-komatsu-fg35",
              "name": "FG35",
              "subcategories": []
            },
            {
              "id": "aerial-equipment-komatsu-fg40",
              "name": "FG40",
              "subcategories": []
            },
            {
              "id": "aerial-equipment-komatsu-fg45",
              "name": "FG45",
              "subcategories": []
            },
            {
              "id": "aerial-equipment-komatsu-fg50",
              "name": "FG50",
              "subcategories": []
            },
            {
              "id": "aerial-equipment-komatsu-fg70",
              "name": "FG70",
              "subcategories": []
            },
            {
              "id": "aerial-equipment-komatsu-fh40",
              "name": "FH40",
              "subcategories": []
            },
            {
              "id": "aerial-equipment-komatsu-fh45",
              "name": "FH45",
              "subcategories": []
            },
            {
              "id": "aerial-equipment-komatsu-fh70",
              "name": "FH70",
              "subcategories": []
            },
            {
              "id": "aerial-equipment-komatsu-fr18",
              "name": "FR18",
              "subcategories": []
            },
            {
              "id": "aerial-equipment-komatsu-wh613",
              "name": "WH613",
              "subcategories": []
            },
            {
              "id": "aerial-equipment-komatsu-wh714",
              "name": "WH714",
              "subcategories": []
            },
            {
              "id": "aerial-equipment-komatsu-other",
              "name": "OTHER",
              "subcategories": []
            }
          ]
        },
        {
          "id": "aerial-equipment-lgmg",
          "name": "Lgmg",
          "subcategories": [
            {
              "id": "aerial-equipment-lgmg-a09je",
              "name": "A09JE",
              "subcategories": []
            },
            {
              "id": "aerial-equipment-lgmg-a14je",
              "name": "A14JE",
              "subcategories": []
            },
            {
              "id": "aerial-equipment-lgmg-a45",
              "name": "A45",
              "subcategories": []
            },
            {
              "id": "aerial-equipment-lgmg-ar",
              "name": "AR",
              "subcategories": []
            },
            {
              "id": "aerial-equipment-lgmg-ar11",
              "name": "AR11",
              "subcategories": []
            },
            {
              "id": "aerial-equipment-lgmg-ar14",
              "name": "AR14",
              "subcategories": []
            },
            {
              "id": "aerial-equipment-lgmg-ar16",
              "name": "AR16",
              "subcategories": []
            },
            {
              "id": "aerial-equipment-lgmg-ar20",
              "name": "AR20",
              "subcategories": []
            },
            {
              "id": "aerial-equipment-lgmg-ar45",
              "name": "AR45",
              "subcategories": []
            },
            {
              "id": "aerial-equipment-lgmg-ar52",
              "name": "AR52",
              "subcategories": []
            },
            {
              "id": "aerial-equipment-lgmg-as0607",
              "name": "AS0607",
              "subcategories": []
            },
            {
              "id": "aerial-equipment-lgmg-as1930",
              "name": "AS1930",
              "subcategories": []
            },
            {
              "id": "aerial-equipment-lgmg-as1932",
              "name": "AS1932",
              "subcategories": []
            },
            {
              "id": "aerial-equipment-lgmg-as2632",
              "name": "AS2632",
              "subcategories": []
            },
            {
              "id": "aerial-equipment-lgmg-as2646",
              "name": "AS2646",
              "subcategories": []
            },
            {
              "id": "aerial-equipment-lgmg-as3246",
              "name": "AS3246",
              "subcategories": []
            },
            {
              "id": "aerial-equipment-lgmg-as4046",
              "name": "AS4046",
              "subcategories": []
            },
            {
              "id": "aerial-equipment-lgmg-as4650",
              "name": "AS4650",
              "subcategories": []
            },
            {
              "id": "aerial-equipment-lgmg-as0808",
              "name": "AS0808",
              "subcategories": []
            },
            {
              "id": "aerial-equipment-lgmg-as1212",
              "name": "AS1212",
              "subcategories": []
            },
            {
              "id": "aerial-equipment-lgmg-h1056",
              "name": "H1056",
              "subcategories": []
            },
            {
              "id": "aerial-equipment-lgmg-m1230",
              "name": "M1230",
              "subcategories": []
            },
            {
              "id": "aerial-equipment-lgmg-m2530",
              "name": "M2530",
              "subcategories": []
            },
            {
              "id": "aerial-equipment-lgmg-m2640",
              "name": "M2640",
              "subcategories": []
            },
            {
              "id": "aerial-equipment-lgmg-s0808",
              "name": "S0808",
              "subcategories": []
            },
            {
              "id": "aerial-equipment-lgmg-s1012",
              "name": "S1012",
              "subcategories": []
            },
            {
              "id": "aerial-equipment-lgmg-s1212",
              "name": "S1212",
              "subcategories": []
            },
            {
              "id": "aerial-equipment-lgmg-s1932",
              "name": "S1932",
              "subcategories": []
            },
            {
              "id": "aerial-equipment-lgmg-s2632",
              "name": "S2632",
              "subcategories": []
            },
            {
              "id": "aerial-equipment-lgmg-s2646",
              "name": "S2646",
              "subcategories": []
            },
            {
              "id": "aerial-equipment-lgmg-s3246",
              "name": "S3246",
              "subcategories": []
            },
            {
              "id": "aerial-equipment-lgmg-s4046",
              "name": "S4046",
              "subcategories": []
            },
            {
              "id": "aerial-equipment-lgmg-s4650",
              "name": "S4650",
              "subcategories": []
            },
            {
              "id": "aerial-equipment-lgmg-sr1018",
              "name": "SR1018",
              "subcategories": []
            },
            {
              "id": "aerial-equipment-lgmg-sr1218",
              "name": "SR1218",
              "subcategories": []
            },
            {
              "id": "aerial-equipment-lgmg-sr1623",
              "name": "SR1623",
              "subcategories": []
            },
            {
              "id": "aerial-equipment-lgmg-sr3369",
              "name": "SR3369",
              "subcategories": []
            },
            {
              "id": "aerial-equipment-lgmg-sr4069",
              "name": "SR4069",
              "subcategories": []
            },
            {
              "id": "aerial-equipment-lgmg-sr4390",
              "name": "SR4390",
              "subcategories": []
            },
            {
              "id": "aerial-equipment-lgmg-sr5390",
              "name": "SR5390",
              "subcategories": []
            },
            {
              "id": "aerial-equipment-lgmg-ss0407",
              "name": "SS0407",
              "subcategories": []
            },
            {
              "id": "aerial-equipment-lgmg-ss0507",
              "name": "SS0507",
              "subcategories": []
            },
            {
              "id": "aerial-equipment-lgmg-ss1230",
              "name": "SS1230",
              "subcategories": []
            },
            {
              "id": "aerial-equipment-lgmg-ss1932",
              "name": "SS1932",
              "subcategories": []
            },
            {
              "id": "aerial-equipment-lgmg-t22",
              "name": "T22",
              "subcategories": []
            },
            {
              "id": "aerial-equipment-lgmg-t65",
              "name": "T65",
              "subcategories": []
            },
            {
              "id": "aerial-equipment-lgmg-t85",
              "name": "T85",
              "subcategories": []
            },
            {
              "id": "aerial-equipment-lgmg-a43",
              "name": "A43",
              "subcategories": []
            },
            {
              "id": "aerial-equipment-lgmg-other",
              "name": "OTHER",
              "subcategories": []
            }
          ]
        },
        {
          "id": "aerial-equipment-magni",
          "name": "Magni",
          "subcategories": [
            {
              "id": "aerial-equipment-magni-ba20",
              "name": "BA20",
              "subcategories": []
            },
            {
              "id": "aerial-equipment-magni-dab18",
              "name": "DAB18",
              "subcategories": []
            },
            {
              "id": "aerial-equipment-magni-dab20",
              "name": "DAB20",
              "subcategories": []
            },
            {
              "id": "aerial-equipment-magni-ds1218",
              "name": "DS1218",
              "subcategories": []
            },
            {
              "id": "aerial-equipment-magni-ds1418",
              "name": "DS1418",
              "subcategories": []
            },
            {
              "id": "aerial-equipment-magni-ds1523",
              "name": "DS1523",
              "subcategories": []
            },
            {
              "id": "aerial-equipment-magni-ds1823",
              "name": "DS1823",
              "subcategories": []
            },
            {
              "id": "aerial-equipment-magni-ds2223",
              "name": "DS2223",
              "subcategories": []
            },
            {
              "id": "aerial-equipment-magni-dtb24",
              "name": "DTB24",
              "subcategories": []
            },
            {
              "id": "aerial-equipment-magni-dtb30",
              "name": "DTB30",
              "subcategories": []
            },
            {
              "id": "aerial-equipment-magni-eab12",
              "name": "EAB12",
              "subcategories": []
            },
            {
              "id": "aerial-equipment-magni-es0607",
              "name": "ES0607",
              "subcategories": []
            },
            {
              "id": "aerial-equipment-magni-es0708",
              "name": "ES0708",
              "subcategories": []
            },
            {
              "id": "aerial-equipment-magni-es0807",
              "name": "ES0807",
              "subcategories": []
            },
            {
              "id": "aerial-equipment-magni-es808",
              "name": "ES808",
              "subcategories": []
            },
            {
              "id": "aerial-equipment-magni-es1008",
              "name": "ES1008",
              "subcategories": []
            },
            {
              "id": "aerial-equipment-magni-es1012",
              "name": "ES1012",
              "subcategories": []
            },
            {
              "id": "aerial-equipment-magni-es1212",
              "name": "ES1212",
              "subcategories": []
            },
            {
              "id": "aerial-equipment-magni-es1418",
              "name": "ES1418",
              "subcategories": []
            },
            {
              "id": "aerial-equipment-magni-es1612",
              "name": "ES1612",
              "subcategories": []
            },
            {
              "id": "aerial-equipment-magni-es2223",
              "name": "ES2223",
              "subcategories": []
            },
            {
              "id": "aerial-equipment-magni-etbj30",
              "name": "ETBJ30",
              "subcategories": []
            },
            {
              "id": "aerial-equipment-magni-hth10-10",
              "name": "HTH10.10",
              "subcategories": []
            },
            {
              "id": "aerial-equipment-magni-hth12-10",
              "name": "HTH12.10",
              "subcategories": []
            },
            {
              "id": "aerial-equipment-magni-hth16-10",
              "name": "HTH16.10",
              "subcategories": []
            },
            {
              "id": "aerial-equipment-magni-hth20-10",
              "name": "HTH20.10",
              "subcategories": []
            },
            {
              "id": "aerial-equipment-magni-hth24-11",
              "name": "HTH24.11",
              "subcategories": []
            },
            {
              "id": "aerial-equipment-magni-hth25-11",
              "name": "HTH25.11",
              "subcategories": []
            },
            {
              "id": "aerial-equipment-magni-hth27-11",
              "name": "HTH27.11",
              "subcategories": []
            },
            {
              "id": "aerial-equipment-magni-hth30-12",
              "name": "HTH30.12",
              "subcategories": []
            },
            {
              "id": "aerial-equipment-magni-hth35-12",
              "name": "HTH35.12",
              "subcategories": []
            },
            {
              "id": "aerial-equipment-magni-mjp07",
              "name": "MJP07",
              "subcategories": []
            },
            {
              "id": "aerial-equipment-magni-mjp08",
              "name": "MJP08",
              "subcategories": []
            },
            {
              "id": "aerial-equipment-magni-mjp11-5",
              "name": "MJP11.5",
              "subcategories": []
            },
            {
              "id": "aerial-equipment-magni-rth4-18",
              "name": "RTH4.18",
              "subcategories": []
            },
            {
              "id": "aerial-equipment-magni-rth5-18",
              "name": "RTH5.18",
              "subcategories": []
            },
            {
              "id": "aerial-equipment-magni-rth5-21",
              "name": "RTH5.21",
              "subcategories": []
            },
            {
              "id": "aerial-equipment-magni-rth5-23",
              "name": "RTH5.23",
              "subcategories": []
            },
            {
              "id": "aerial-equipment-magni-rth5-25",
              "name": "RTH5.25",
              "subcategories": []
            },
            {
              "id": "aerial-equipment-magni-rth5-30",
              "name": "RTH5.30",
              "subcategories": []
            },
            {
              "id": "aerial-equipment-magni-rth5-35",
              "name": "RTH5.35",
              "subcategories": []
            },
            {
              "id": "aerial-equipment-magni-rth5-39",
              "name": "RTH5.39",
              "subcategories": []
            },
            {
              "id": "aerial-equipment-magni-rth6-21",
              "name": "RTH6.21",
              "subcategories": []
            },
            {
              "id": "aerial-equipment-magni-rth6-22",
              "name": "RTH6.22",
              "subcategories": []
            },
            {
              "id": "aerial-equipment-magni-rth6-23",
              "name": "RTH6.23",
              "subcategories": []
            },
            {
              "id": "aerial-equipment-magni-rth6-25",
              "name": "RTH6.25",
              "subcategories": []
            },
            {
              "id": "aerial-equipment-magni-rth6-26",
              "name": "RTH6.26",
              "subcategories": []
            },
            {
              "id": "aerial-equipment-magni-rth6-30",
              "name": "RTH6.30",
              "subcategories": []
            },
            {
              "id": "aerial-equipment-magni-rth6-31",
              "name": "RTH6.31",
              "subcategories": []
            },
            {
              "id": "aerial-equipment-magni-rth6-35",
              "name": "RTH6.35",
              "subcategories": []
            },
            {
              "id": "aerial-equipment-magni-rth6-39",
              "name": "RTH6.39",
              "subcategories": []
            },
            {
              "id": "aerial-equipment-magni-rth6-46",
              "name": "RTH6.46",
              "subcategories": []
            },
            {
              "id": "aerial-equipment-magni-rth6-51",
              "name": "RTH6.51",
              "subcategories": []
            },
            {
              "id": "aerial-equipment-magni-rth7-26",
              "name": "RTH7.26",
              "subcategories": []
            },
            {
              "id": "aerial-equipment-magni-rth8-25",
              "name": "RTH8.25",
              "subcategories": []
            },
            {
              "id": "aerial-equipment-magni-rth8-27",
              "name": "RTH8.27",
              "subcategories": []
            },
            {
              "id": "aerial-equipment-magni-rth8-35",
              "name": "RTH8.35",
              "subcategories": []
            },
            {
              "id": "aerial-equipment-magni-rth8-39",
              "name": "RTH8.39",
              "subcategories": []
            },
            {
              "id": "aerial-equipment-magni-rth8-46",
              "name": "RTH8.46",
              "subcategories": []
            },
            {
              "id": "aerial-equipment-magni-rth8-51",
              "name": "RTH8.51",
              "subcategories": []
            },
            {
              "id": "aerial-equipment-magni-rth13-37",
              "name": "RTH13.37",
              "subcategories": []
            },
            {
              "id": "aerial-equipment-magni-rth13-26",
              "name": "RTH13.26",
              "subcategories": []
            },
            {
              "id": "aerial-equipment-magni-th3-6",
              "name": "TH3.6",
              "subcategories": []
            },
            {
              "id": "aerial-equipment-magni-th4-5",
              "name": "TH4,5",
              "subcategories": []
            },
            {
              "id": "aerial-equipment-magni-th5-8",
              "name": "TH5.8",
              "subcategories": []
            },
            {
              "id": "aerial-equipment-magni-th5-24",
              "name": "TH5.24",
              "subcategories": []
            },
            {
              "id": "aerial-equipment-magni-th5-5",
              "name": "TH5,5",
              "subcategories": []
            },
            {
              "id": "aerial-equipment-magni-th6-10",
              "name": "TH6.10",
              "subcategories": []
            },
            {
              "id": "aerial-equipment-magni-th6-20",
              "name": "TH6.20",
              "subcategories": []
            },
            {
              "id": "aerial-equipment-magni-th12-80",
              "name": "TH12.80",
              "subcategories": []
            },
            {
              "id": "aerial-equipment-magni-other",
              "name": "OTHER",
              "subcategories": []
            }
          ]
        },
        {
          "id": "aerial-equipment-merlo",
          "name": "Merlo",
          "subcategories": [
            {
              "id": "aerial-equipment-merlo-ew-25-5-90",
              "name": "EW 25.5-90",
              "subcategories": []
            },
            {
              "id": "aerial-equipment-merlo-mpr15",
              "name": "MPR15",
              "subcategories": []
            },
            {
              "id": "aerial-equipment-merlo-mpr25",
              "name": "MPR25",
              "subcategories": []
            },
            {
              "id": "aerial-equipment-merlo-multi-30-6",
              "name": "MULTI 30.6",
              "subcategories": []
            },
            {
              "id": "aerial-equipment-merlo-multi-34-7",
              "name": "MULTI 34.7",
              "subcategories": []
            },
            {
              "id": "aerial-equipment-merlo-multi-34-7-140",
              "name": "MULTI 34.7 140",
              "subcategories": []
            },
            {
              "id": "aerial-equipment-merlo-multi-40-7",
              "name": "MULTI 40.7",
              "subcategories": []
            },
            {
              "id": "aerial-equipment-merlo-multi-40-9",
              "name": "MULTI 40.9",
              "subcategories": []
            },
            {
              "id": "aerial-equipment-merlo-multi-44-9",
              "name": "MULTI 44.9",
              "subcategories": []
            },
            {
              "id": "aerial-equipment-merlo-multi-44-9-cs-170",
              "name": "MULTI 44.9 CS 170",
              "subcategories": []
            },
            {
              "id": "aerial-equipment-merlo-p25-6",
              "name": "P25.6",
              "subcategories": []
            },
            {
              "id": "aerial-equipment-merlo-p25-9",
              "name": "P25.9",
              "subcategories": []
            },
            {
              "id": "aerial-equipment-merlo-p26-6",
              "name": "P26.6",
              "subcategories": []
            },
            {
              "id": "aerial-equipment-merlo-p27-6",
              "name": "P27.6",
              "subcategories": []
            },
            {
              "id": "aerial-equipment-merlo-p28-7",
              "name": "P28.7",
              "subcategories": []
            },
            {
              "id": "aerial-equipment-merlo-p30-7",
              "name": "P30.7",
              "subcategories": []
            },
            {
              "id": "aerial-equipment-merlo-p30-9",
              "name": "P30.9",
              "subcategories": []
            },
            {
              "id": "aerial-equipment-merlo-p30-10",
              "name": "P30.10",
              "subcategories": []
            },
            {
              "id": "aerial-equipment-merlo-p32-6",
              "name": "P32.6",
              "subcategories": []
            },
            {
              "id": "aerial-equipment-merlo-p34-7",
              "name": "P34.7",
              "subcategories": []
            },
            {
              "id": "aerial-equipment-merlo-p35",
              "name": "P35",
              "subcategories": []
            },
            {
              "id": "aerial-equipment-merlo-p36-7",
              "name": "P36.7",
              "subcategories": []
            },
            {
              "id": "aerial-equipment-merlo-p38-10",
              "name": "P38.10",
              "subcategories": []
            },
            {
              "id": "aerial-equipment-merlo-p38-13",
              "name": "P38.13",
              "subcategories": []
            },
            {
              "id": "aerial-equipment-merlo-p38-14",
              "name": "P38.14",
              "subcategories": []
            },
            {
              "id": "aerial-equipment-merlo-p40-7",
              "name": "P40.7",
              "subcategories": []
            },
            {
              "id": "aerial-equipment-merlo-p40-9",
              "name": "P40.9",
              "subcategories": []
            },
            {
              "id": "aerial-equipment-merlo-p40-13",
              "name": "P40.13",
              "subcategories": []
            },
            {
              "id": "aerial-equipment-merlo-p40-14",
              "name": "P40.14",
              "subcategories": []
            },
            {
              "id": "aerial-equipment-merlo-p40-17",
              "name": "P40.17",
              "subcategories": []
            },
            {
              "id": "aerial-equipment-merlo-p41-7",
              "name": "P41.7",
              "subcategories": []
            },
            {
              "id": "aerial-equipment-merlo-p50-17",
              "name": "P50.17",
              "subcategories": []
            },
            {
              "id": "aerial-equipment-merlo-p50-18",
              "name": "P50.18",
              "subcategories": []
            },
            {
              "id": "aerial-equipment-merlo-p55-9",
              "name": "P55.9",
              "subcategories": []
            },
            {
              "id": "aerial-equipment-merlo-p60-10",
              "name": "P60.10",
              "subcategories": []
            },
            {
              "id": "aerial-equipment-merlo-p65-14",
              "name": "P65.14",
              "subcategories": []
            },
            {
              "id": "aerial-equipment-merlo-p72-10",
              "name": "P72.10",
              "subcategories": []
            },
            {
              "id": "aerial-equipment-merlo-p101-10",
              "name": "P101.10",
              "subcategories": []
            },
            {
              "id": "aerial-equipment-merlo-p120-10",
              "name": "P120.10",
              "subcategories": []
            },
            {
              "id": "aerial-equipment-merlo-roto-30-13",
              "name": "ROTO 30.13",
              "subcategories": []
            },
            {
              "id": "aerial-equipment-merlo-roto-30-16",
              "name": "ROTO 30.16",
              "subcategories": []
            },
            {
              "id": "aerial-equipment-merlo-roto-38-14",
              "name": "ROTO 38.14",
              "subcategories": []
            },
            {
              "id": "aerial-equipment-merlo-roto-38-16",
              "name": "ROTO 38.16",
              "subcategories": []
            },
            {
              "id": "aerial-equipment-merlo-roto-40-18",
              "name": "ROTO 40.18",
              "subcategories": []
            },
            {
              "id": "aerial-equipment-merlo-roto-40-25",
              "name": "ROTO 40.25",
              "subcategories": []
            },
            {
              "id": "aerial-equipment-merlo-roto-40-26",
              "name": "ROTO 40.26",
              "subcategories": []
            },
            {
              "id": "aerial-equipment-merlo-roto-40-30",
              "name": "ROTO 40.30",
              "subcategories": []
            },
            {
              "id": "aerial-equipment-merlo-roto-45-19",
              "name": "ROTO 45.19",
              "subcategories": []
            },
            {
              "id": "aerial-equipment-merlo-roto-45-21",
              "name": "ROTO 45.21",
              "subcategories": []
            },
            {
              "id": "aerial-equipment-merlo-roto-50-21",
              "name": "ROTO 50.21",
              "subcategories": []
            },
            {
              "id": "aerial-equipment-merlo-roto-50-26",
              "name": "ROTO 50.26",
              "subcategories": []
            },
            {
              "id": "aerial-equipment-merlo-roto-50-30",
              "name": "ROTO 50.30",
              "subcategories": []
            },
            {
              "id": "aerial-equipment-merlo-roto-50-35",
              "name": "ROTO 50.35",
              "subcategories": []
            },
            {
              "id": "aerial-equipment-merlo-roto-60-24",
              "name": "ROTO 60.24",
              "subcategories": []
            },
            {
              "id": "aerial-equipment-merlo-roto-70-24",
              "name": "ROTO 70.24",
              "subcategories": []
            },
            {
              "id": "aerial-equipment-merlo-roto-70-28",
              "name": "ROTO 70.28",
              "subcategories": []
            },
            {
              "id": "aerial-equipment-merlo-tf-27-6",
              "name": "TF 27.6",
              "subcategories": []
            },
            {
              "id": "aerial-equipment-merlo-tf-30-9",
              "name": "TF 30.9",
              "subcategories": []
            },
            {
              "id": "aerial-equipment-merlo-tf-33-7",
              "name": "TF 33.7",
              "subcategories": []
            },
            {
              "id": "aerial-equipment-merlo-tf-33-9",
              "name": "TF 33.9",
              "subcategories": []
            },
            {
              "id": "aerial-equipment-merlo-tf-35-7",
              "name": "TF 35.7",
              "subcategories": []
            },
            {
              "id": "aerial-equipment-merlo-tf-38-7",
              "name": "TF 38.7",
              "subcategories": []
            },
            {
              "id": "aerial-equipment-merlo-tf-38-10",
              "name": "TF 38.10",
              "subcategories": []
            },
            {
              "id": "aerial-equipment-merlo-tf-42-7",
              "name": "TF 42.7",
              "subcategories": []
            },
            {
              "id": "aerial-equipment-merlo-tf45-11",
              "name": "TF45.11",
              "subcategories": []
            },
            {
              "id": "aerial-equipment-merlo-tf50-8",
              "name": "TF50.8",
              "subcategories": []
            },
            {
              "id": "aerial-equipment-merlo-tf65-9",
              "name": "TF65.9",
              "subcategories": []
            },
            {
              "id": "aerial-equipment-merlo-other",
              "name": "OTHER",
              "subcategories": []
            }
          ]
        },
        {
          "id": "aerial-equipment-mitsubishi",
          "name": "Mitsubishi",
          "subcategories": [
            {
              "id": "aerial-equipment-mitsubishi-2fbc",
              "name": "2FBC",
              "subcategories": []
            },
            {
              "id": "aerial-equipment-mitsubishi-edr15",
              "name": "EDR15",
              "subcategories": []
            },
            {
              "id": "aerial-equipment-mitsubishi-eop15",
              "name": "EOP15",
              "subcategories": []
            },
            {
              "id": "aerial-equipment-mitsubishi-esr15",
              "name": "ESR15",
              "subcategories": []
            },
            {
              "id": "aerial-equipment-mitsubishi-esr18",
              "name": "ESR18",
              "subcategories": []
            },
            {
              "id": "aerial-equipment-mitsubishi-esr20",
              "name": "ESR20",
              "subcategories": []
            },
            {
              "id": "aerial-equipment-mitsubishi-f25b-15",
              "name": "F25B-15",
              "subcategories": []
            },
            {
              "id": "aerial-equipment-mitsubishi-fb15",
              "name": "FB15",
              "subcategories": []
            },
            {
              "id": "aerial-equipment-mitsubishi-fb16",
              "name": "FB16",
              "subcategories": []
            },
            {
              "id": "aerial-equipment-mitsubishi-fb18",
              "name": "FB18",
              "subcategories": []
            },
            {
              "id": "aerial-equipment-mitsubishi-fb20",
              "name": "FB20",
              "subcategories": []
            },
            {
              "id": "aerial-equipment-mitsubishi-fb25",
              "name": "FB25",
              "subcategories": []
            },
            {
              "id": "aerial-equipment-mitsubishi-fb35",
              "name": "FB35",
              "subcategories": []
            },
            {
              "id": "aerial-equipment-mitsubishi-fb45",
              "name": "FB45",
              "subcategories": []
            },
            {
              "id": "aerial-equipment-mitsubishi-fbc15",
              "name": "FBC15",
              "subcategories": []
            },
            {
              "id": "aerial-equipment-mitsubishi-fbc18",
              "name": "FBC18",
              "subcategories": []
            },
            {
              "id": "aerial-equipment-mitsubishi-fbc25",
              "name": "FBC25",
              "subcategories": []
            },
            {
              "id": "aerial-equipment-mitsubishi-fbc30",
              "name": "FBC30",
              "subcategories": []
            },
            {
              "id": "aerial-equipment-mitsubishi-fbcs",
              "name": "FBCS",
              "subcategories": []
            },
            {
              "id": "aerial-equipment-mitsubishi-fd18",
              "name": "FD18",
              "subcategories": []
            },
            {
              "id": "aerial-equipment-mitsubishi-fd20",
              "name": "FD20",
              "subcategories": []
            },
            {
              "id": "aerial-equipment-mitsubishi-fd25",
              "name": "FD25",
              "subcategories": []
            },
            {
              "id": "aerial-equipment-mitsubishi-fd30",
              "name": "FD30",
              "subcategories": []
            },
            {
              "id": "aerial-equipment-mitsubishi-fd33",
              "name": "FD33",
              "subcategories": []
            },
            {
              "id": "aerial-equipment-mitsubishi-fd35",
              "name": "FD35",
              "subcategories": []
            },
            {
              "id": "aerial-equipment-mitsubishi-fd40",
              "name": "FD40",
              "subcategories": []
            },
            {
              "id": "aerial-equipment-mitsubishi-fd45",
              "name": "FD45",
              "subcategories": []
            },
            {
              "id": "aerial-equipment-mitsubishi-fd50",
              "name": "FD50",
              "subcategories": []
            },
            {
              "id": "aerial-equipment-mitsubishi-fd60",
              "name": "FD60",
              "subcategories": []
            },
            {
              "id": "aerial-equipment-mitsubishi-fd70",
              "name": "FD70",
              "subcategories": []
            },
            {
              "id": "aerial-equipment-mitsubishi-fd100",
              "name": "FD100",
              "subcategories": []
            },
            {
              "id": "aerial-equipment-mitsubishi-fd120",
              "name": "FD120",
              "subcategories": []
            },
            {
              "id": "aerial-equipment-mitsubishi-fd150",
              "name": "FD150",
              "subcategories": []
            },
            {
              "id": "aerial-equipment-mitsubishi-fd160",
              "name": "FD160",
              "subcategories": []
            },
            {
              "id": "aerial-equipment-mitsubishi-fd250",
              "name": "FD250",
              "subcategories": []
            },
            {
              "id": "aerial-equipment-mitsubishi-fd300",
              "name": "FD300",
              "subcategories": []
            },
            {
              "id": "aerial-equipment-mitsubishi-fg15",
              "name": "FG15",
              "subcategories": []
            },
            {
              "id": "aerial-equipment-mitsubishi-fg18",
              "name": "FG18",
              "subcategories": []
            },
            {
              "id": "aerial-equipment-mitsubishi-fg20",
              "name": "FG20",
              "subcategories": []
            },
            {
              "id": "aerial-equipment-mitsubishi-fg25",
              "name": "FG25",
              "subcategories": []
            },
            {
              "id": "aerial-equipment-mitsubishi-fg30",
              "name": "FG30",
              "subcategories": []
            },
            {
              "id": "aerial-equipment-mitsubishi-fg33",
              "name": "FG33",
              "subcategories": []
            },
            {
              "id": "aerial-equipment-mitsubishi-fg35",
              "name": "FG35",
              "subcategories": []
            },
            {
              "id": "aerial-equipment-mitsubishi-fg40",
              "name": "FG40",
              "subcategories": []
            },
            {
              "id": "aerial-equipment-mitsubishi-fg45",
              "name": "FG45",
              "subcategories": []
            },
            {
              "id": "aerial-equipment-mitsubishi-fg50",
              "name": "FG50",
              "subcategories": []
            },
            {
              "id": "aerial-equipment-mitsubishi-fg55",
              "name": "FG55",
              "subcategories": []
            },
            {
              "id": "aerial-equipment-mitsubishi-fgc15",
              "name": "FGC15",
              "subcategories": []
            },
            {
              "id": "aerial-equipment-mitsubishi-fgc18",
              "name": "FGC18",
              "subcategories": []
            },
            {
              "id": "aerial-equipment-mitsubishi-fgc20",
              "name": "FGC20",
              "subcategories": []
            },
            {
              "id": "aerial-equipment-mitsubishi-fgc25",
              "name": "FGC25",
              "subcategories": []
            },
            {
              "id": "aerial-equipment-mitsubishi-fgc30",
              "name": "FGC30",
              "subcategories": []
            },
            {
              "id": "aerial-equipment-mitsubishi-fgc33",
              "name": "FGC33",
              "subcategories": []
            },
            {
              "id": "aerial-equipment-mitsubishi-fgc40",
              "name": "FGC40",
              "subcategories": []
            },
            {
              "id": "aerial-equipment-mitsubishi-fgc45",
              "name": "FGC45",
              "subcategories": []
            },
            {
              "id": "aerial-equipment-mitsubishi-fgc55",
              "name": "FGC55",
              "subcategories": []
            },
            {
              "id": "aerial-equipment-mitsubishi-fgc70",
              "name": "FGC70",
              "subcategories": []
            },
            {
              "id": "aerial-equipment-mitsubishi-fge25p",
              "name": "FGE25P",
              "subcategories": []
            },
            {
              "id": "aerial-equipment-mitsubishi-pmwt",
              "name": "PMWT",
              "subcategories": []
            },
            {
              "id": "aerial-equipment-mitsubishi-pw23",
              "name": "PW23",
              "subcategories": []
            },
            {
              "id": "aerial-equipment-mitsubishi-pwr30",
              "name": "PWR30",
              "subcategories": []
            },
            {
              "id": "aerial-equipment-mitsubishi-rbm25",
              "name": "RBM25",
              "subcategories": []
            },
            {
              "id": "aerial-equipment-mitsubishi-v70b45",
              "name": "V70B45",
              "subcategories": []
            },
            {
              "id": "aerial-equipment-mitsubishi-other",
              "name": "OTHER",
              "subcategories": []
            }
          ]
        },
        {
          "id": "aerial-equipment-moffett",
          "name": "Moffett",
          "subcategories": [
            {
              "id": "aerial-equipment-moffett-e4-20-1",
              "name": "E4 20.1",
              "subcategories": []
            },
            {
              "id": "aerial-equipment-moffett-lp5500",
              "name": "LP5500",
              "subcategories": []
            },
            {
              "id": "aerial-equipment-moffett-m4-20-1",
              "name": "M4 20.1",
              "subcategories": []
            },
            {
              "id": "aerial-equipment-moffett-m4-20-3",
              "name": "M4 20.3",
              "subcategories": []
            },
            {
              "id": "aerial-equipment-moffett-m4-20-4",
              "name": "M4 20.4",
              "subcategories": []
            },
            {
              "id": "aerial-equipment-moffett-m4-25-3",
              "name": "M4 25.3",
              "subcategories": []
            },
            {
              "id": "aerial-equipment-moffett-m4-32-3",
              "name": "M4 32.3",
              "subcategories": []
            },
            {
              "id": "aerial-equipment-moffett-m5-25-3",
              "name": "M5 25.3",
              "subcategories": []
            },
            {
              "id": "aerial-equipment-moffett-m5-25-4",
              "name": "M5 25.4",
              "subcategories": []
            },
            {
              "id": "aerial-equipment-moffett-m5-50-3",
              "name": "M5 50.3",
              "subcategories": []
            },
            {
              "id": "aerial-equipment-moffett-m5-50-4",
              "name": "M5 50.4",
              "subcategories": []
            },
            {
              "id": "aerial-equipment-moffett-m7-24-3",
              "name": "M7 24.3",
              "subcategories": []
            },
            {
              "id": "aerial-equipment-moffett-m8-25-3",
              "name": "M8 25.3",
              "subcategories": []
            },
            {
              "id": "aerial-equipment-moffett-m8-50-3",
              "name": "M8 50.3",
              "subcategories": []
            },
            {
              "id": "aerial-equipment-moffett-m8-55-3",
              "name": "M8 55.3",
              "subcategories": []
            },
            {
              "id": "aerial-equipment-moffett-m8-55-4",
              "name": "M8 55.4",
              "subcategories": []
            },
            {
              "id": "aerial-equipment-moffett-m8-80-4",
              "name": "M8 80.4",
              "subcategories": []
            },
            {
              "id": "aerial-equipment-moffett-m8-55-3",
              "name": "M8 55.3",
              "subcategories": []
            },
            {
              "id": "aerial-equipment-moffett-m8-70-3",
              "name": "M8 70.3",
              "subcategories": []
            },
            {
              "id": "aerial-equipment-moffett-m9-55-3",
              "name": "M9 55.3",
              "subcategories": []
            },
            {
              "id": "aerial-equipment-moffett-m45",
              "name": "M45",
              "subcategories": []
            },
            {
              "id": "aerial-equipment-moffett-m50",
              "name": "M50",
              "subcategories": []
            },
            {
              "id": "aerial-equipment-moffett-m55",
              "name": "M55",
              "subcategories": []
            },
            {
              "id": "aerial-equipment-moffett-m70",
              "name": "M70",
              "subcategories": []
            },
            {
              "id": "aerial-equipment-moffett-m80",
              "name": "M80",
              "subcategories": []
            },
            {
              "id": "aerial-equipment-moffett-m2703",
              "name": "M2703",
              "subcategories": []
            },
            {
              "id": "aerial-equipment-moffett-m5000",
              "name": "M5000",
              "subcategories": []
            },
            {
              "id": "aerial-equipment-moffett-m5500",
              "name": "M5500",
              "subcategories": []
            },
            {
              "id": "aerial-equipment-moffett-m7000",
              "name": "M7000",
              "subcategories": []
            },
            {
              "id": "aerial-equipment-moffett-m8000",
              "name": "M8000",
              "subcategories": []
            },
            {
              "id": "aerial-equipment-moffett-p6000",
              "name": "P6000",
              "subcategories": []
            },
            {
              "id": "aerial-equipment-moffett-tm55-4",
              "name": "TM55.4",
              "subcategories": []
            },
            {
              "id": "aerial-equipment-moffett-tm50-3",
              "name": "TM50.3",
              "subcategories": []
            },
            {
              "id": "aerial-equipment-moffett-other",
              "name": "OTHER",
              "subcategories": []
            }
          ]
        },
        {
          "id": "aerial-equipment-nissan",
          "name": "Nissan",
          "subcategories": [
            {
              "id": "aerial-equipment-nissan-1n1l",
              "name": "1N1L",
              "subcategories": []
            },
            {
              "id": "aerial-equipment-nissan-1s1l15",
              "name": "1S1L15",
              "subcategories": []
            },
            {
              "id": "aerial-equipment-nissan-1s1l18",
              "name": "1S1L18",
              "subcategories": []
            },
            {
              "id": "aerial-equipment-nissan-1s1l20",
              "name": "1S1L20",
              "subcategories": []
            },
            {
              "id": "aerial-equipment-nissan-1q2l25",
              "name": "1Q2L25",
              "subcategories": []
            },
            {
              "id": "aerial-equipment-nissan-1s1l15",
              "name": "1S1L15",
              "subcategories": []
            },
            {
              "id": "aerial-equipment-nissan-1s1l20",
              "name": "1S1L20",
              "subcategories": []
            },
            {
              "id": "aerial-equipment-nissan-257h",
              "name": "257H",
              "subcategories": []
            },
            {
              "id": "aerial-equipment-nissan-ah01a15",
              "name": "AH01A15",
              "subcategories": []
            },
            {
              "id": "aerial-equipment-nissan-aph02a25",
              "name": "APH02A25",
              "subcategories": []
            },
            {
              "id": "aerial-equipment-nissan-bf03a35",
              "name": "BF03A35",
              "subcategories": []
            },
            {
              "id": "aerial-equipment-nissan-bgf03",
              "name": "BGF03",
              "subcategories": []
            },
            {
              "id": "aerial-equipment-nissan-cfa1a15",
              "name": "CFA1A15",
              "subcategories": []
            },
            {
              "id": "aerial-equipment-nissan-chgp02l35",
              "name": "CHGP02L35",
              "subcategories": []
            },
            {
              "id": "aerial-equipment-nissan-ck1b1l18",
              "name": "CK1B1L18",
              "subcategories": []
            },
            {
              "id": "aerial-equipment-nissan-cp1b2l25",
              "name": "CP1B2L25",
              "subcategories": []
            },
            {
              "id": "aerial-equipment-nissan-cp1f2",
              "name": "CP1F2",
              "subcategories": []
            },
            {
              "id": "aerial-equipment-nissan-cph01a15",
              "name": "CPH01A15",
              "subcategories": []
            },
            {
              "id": "aerial-equipment-nissan-cph02a25",
              "name": "CPH02A25",
              "subcategories": []
            },
            {
              "id": "aerial-equipment-nissan-cpj01a18",
              "name": "CPJ01A18",
              "subcategories": []
            },
            {
              "id": "aerial-equipment-nissan-cpj02a25",
              "name": "CPJ02A25",
              "subcategories": []
            },
            {
              "id": "aerial-equipment-nissan-csp01l15",
              "name": "CSP01L15",
              "subcategories": []
            },
            {
              "id": "aerial-equipment-nissan-cwgp02l30",
              "name": "CWGP02L30",
              "subcategories": []
            },
            {
              "id": "aerial-equipment-nissan-cwp02l25",
              "name": "CWP02L25",
              "subcategories": []
            },
            {
              "id": "aerial-equipment-nissan-cygm02l28s",
              "name": "CYGM02L28S",
              "subcategories": []
            },
            {
              "id": "aerial-equipment-nissan-df05n70",
              "name": "DF05N70",
              "subcategories": []
            },
            {
              "id": "aerial-equipment-nissan-f04b40",
              "name": "F04B40",
              "subcategories": []
            },
            {
              "id": "aerial-equipment-nissan-f04b45",
              "name": "F04B45",
              "subcategories": []
            },
            {
              "id": "aerial-equipment-nissan-f04l500",
              "name": "F04L500",
              "subcategories": []
            },
            {
              "id": "aerial-equipment-nissan-fd01a15",
              "name": "FD01A15",
              "subcategories": []
            },
            {
              "id": "aerial-equipment-nissan-fd02a20",
              "name": "FD02A20",
              "subcategories": []
            },
            {
              "id": "aerial-equipment-nissan-fd02a25",
              "name": "FD02A25",
              "subcategories": []
            },
            {
              "id": "aerial-equipment-nissan-fj02a25",
              "name": "FJ02A25",
              "subcategories": []
            },
            {
              "id": "aerial-equipment-nissan-g1n1l",
              "name": "G1N1L",
              "subcategories": []
            },
            {
              "id": "aerial-equipment-nissan-gq02l30",
              "name": "GQ02L30",
              "subcategories": []
            },
            {
              "id": "aerial-equipment-nissan-gx50",
              "name": "GX50",
              "subcategories": []
            },
            {
              "id": "aerial-equipment-nissan-h01a15",
              "name": "H01A15",
              "subcategories": []
            },
            {
              "id": "aerial-equipment-nissan-j01a18",
              "name": "J01A18",
              "subcategories": []
            },
            {
              "id": "aerial-equipment-nissan-jhc01l18hu",
              "name": "JHC01L18HU",
              "subcategories": []
            },
            {
              "id": "aerial-equipment-nissan-kcph01a15",
              "name": "KCPH01A15",
              "subcategories": []
            },
            {
              "id": "aerial-equipment-nissan-kcph02a20",
              "name": "KCPH02A20",
              "subcategories": []
            },
            {
              "id": "aerial-equipment-nissan-kcph02a25",
              "name": "KCPH02A25",
              "subcategories": []
            },
            {
              "id": "aerial-equipment-nissan-kcugh02f35",
              "name": "KCUGH02F35",
              "subcategories": []
            },
            {
              "id": "aerial-equipment-nissan-m01l15",
              "name": "M01L15",
              "subcategories": []
            },
            {
              "id": "aerial-equipment-nissan-map1f1a15",
              "name": "MAP1F1A15",
              "subcategories": []
            },
            {
              "id": "aerial-equipment-nissan-map1f2a25",
              "name": "MAP1F2A25",
              "subcategories": []
            },
            {
              "id": "aerial-equipment-nissan-mck1b1l15",
              "name": "MCK1B1L15",
              "subcategories": []
            },
            {
              "id": "aerial-equipment-nissan-mcp1f1a15",
              "name": "MCP1F1A15",
              "subcategories": []
            },
            {
              "id": "aerial-equipment-nissan-mcp1f1a18",
              "name": "MCP1F1A18",
              "subcategories": []
            },
            {
              "id": "aerial-equipment-nissan-mcp1f1a20",
              "name": "MCP1F1A20",
              "subcategories": []
            },
            {
              "id": "aerial-equipment-nissan-mcp1f2a20",
              "name": "MCP1F2A20",
              "subcategories": []
            },
            {
              "id": "aerial-equipment-nissan-mcp1f2a25",
              "name": "MCP1F2A25",
              "subcategories": []
            },
            {
              "id": "aerial-equipment-nissan-mcpg1b25",
              "name": "MCPG1B25",
              "subcategories": []
            },
            {
              "id": "aerial-equipment-nissan-mcpl01a15",
              "name": "MCPL01A15",
              "subcategories": []
            },
            {
              "id": "aerial-equipment-nissan-mcppl01a20",
              "name": "MCPPL01A20",
              "subcategories": []
            },
            {
              "id": "aerial-equipment-nissan-mcpl02a25",
              "name": "MCPL02A25",
              "subcategories": []
            },
            {
              "id": "aerial-equipment-nissan-mct1b2l20",
              "name": "MCT1B2L20",
              "subcategories": []
            },
            {
              "id": "aerial-equipment-nissan-mct1b2l25",
              "name": "MCT1B2L25",
              "subcategories": []
            },
            {
              "id": "aerial-equipment-nissan-mctg1b2l",
              "name": "MCTG1B2L",
              "subcategories": []
            },
            {
              "id": "aerial-equipment-nissan-mcu1f2a25",
              "name": "MCU1F2A25",
              "subcategories": []
            },
            {
              "id": "aerial-equipment-nissan-mcu1f2a30",
              "name": "MCU1F2A30",
              "subcategories": []
            },
            {
              "id": "aerial-equipment-nissan-ncug1f2f30",
              "name": "NCUG1F2F30",
              "subcategories": []
            },
            {
              "id": "aerial-equipment-nissan-mcug1f2f36",
              "name": "MCUG1F2F36",
              "subcategories": []
            },
            {
              "id": "aerial-equipment-nissan-mcugl02f36",
              "name": "MCUGL02F36",
              "subcategories": []
            },
            {
              "id": "aerial-equipment-nissan-mcul02a28",
              "name": "MCUL02A28",
              "subcategories": []
            },
            {
              "id": "aerial-equipment-nissan-mj1f4a35",
              "name": "MJ1F4A35",
              "subcategories": []
            },
            {
              "id": "aerial-equipment-nissan-mj1f4a40",
              "name": "MJ1F4A40",
              "subcategories": []
            },
            {
              "id": "aerial-equipment-nissan-mj1fa50",
              "name": "MJ1FA50",
              "subcategories": []
            },
            {
              "id": "aerial-equipment-nissan-mp1f1a18",
              "name": "MP1F1A18",
              "subcategories": []
            },
            {
              "id": "aerial-equipment-nissan-mp1f2a20",
              "name": "MP1F2A20",
              "subcategories": []
            },
            {
              "id": "aerial-equipment-nissan-mp1f2a25",
              "name": "MP1F2A25",
              "subcategories": []
            },
            {
              "id": "aerial-equipment-nissan-mpl02a15",
              "name": "MPL02A15",
              "subcategories": []
            },
            {
              "id": "aerial-equipment-nissan-mpl02a25",
              "name": "MPL02A25",
              "subcategories": []
            },
            {
              "id": "aerial-equipment-nissan-mu1f2a25",
              "name": "MU1F2A25",
              "subcategories": []
            },
            {
              "id": "aerial-equipment-nissan-mug1f2a30",
              "name": "MUG1F2A30",
              "subcategories": []
            },
            {
              "id": "aerial-equipment-nissan-mugl02a30",
              "name": "MUGL02A30",
              "subcategories": []
            },
            {
              "id": "aerial-equipment-nissan-mw1f4a45",
              "name": "MW1F4A45",
              "subcategories": []
            },
            {
              "id": "aerial-equipment-nissan-mwg1f4a50",
              "name": "MWG1F4A50",
              "subcategories": []
            },
            {
              "id": "aerial-equipment-nissan-myg1f2a30",
              "name": "MYG1F2A30",
              "subcategories": []
            },
            {
              "id": "aerial-equipment-nissan-myg1f2a35",
              "name": "MYG1F2A35",
              "subcategories": []
            },
            {
              "id": "aerial-equipment-nissan-mygl02a30",
              "name": "MYGL02A30",
              "subcategories": []
            },
            {
              "id": "aerial-equipment-nissan-mygl02a35",
              "name": "MYGL02A35",
              "subcategories": []
            },
            {
              "id": "aerial-equipment-nissan-nha01a15",
              "name": "NHA01A15",
              "subcategories": []
            },
            {
              "id": "aerial-equipment-nissan-nh01m15",
              "name": "NH01M15",
              "subcategories": []
            },
            {
              "id": "aerial-equipment-nissan-nh02m20",
              "name": "NH02M20",
              "subcategories": []
            },
            {
              "id": "aerial-equipment-nissan-nj01a15",
              "name": "NJ01A15",
              "subcategories": []
            },
            {
              "id": "aerial-equipment-nissan-p1d1a15",
              "name": "P1D1A15",
              "subcategories": []
            },
            {
              "id": "aerial-equipment-nissan-p50",
              "name": "P50",
              "subcategories": []
            },
            {
              "id": "aerial-equipment-nissan-pda01a15",
              "name": "PDA01A15",
              "subcategories": []
            },
            {
              "id": "aerial-equipment-nissan-pd90",
              "name": "PD90",
              "subcategories": []
            },
            {
              "id": "aerial-equipment-nissan-pf02",
              "name": "PF02",
              "subcategories": []
            },
            {
              "id": "aerial-equipment-nissan-pf02a20",
              "name": "PF02A20",
              "subcategories": []
            },
            {
              "id": "aerial-equipment-nissan-pf02a25",
              "name": "PF02A25",
              "subcategories": []
            },
            {
              "id": "aerial-equipment-nissan-ph02a25",
              "name": "PH02A25",
              "subcategories": []
            },
            {
              "id": "aerial-equipment-nissan-ph02m25",
              "name": "PH02M25",
              "subcategories": []
            },
            {
              "id": "aerial-equipment-nissan-pja01a15",
              "name": "PJA01A15",
              "subcategories": []
            },
            {
              "id": "aerial-equipment-nissan-pj02a20",
              "name": "PJ02A20",
              "subcategories": []
            },
            {
              "id": "aerial-equipment-nissan-pj02a25",
              "name": "PJ02A25",
              "subcategories": []
            },
            {
              "id": "aerial-equipment-nissan-q02l25",
              "name": "Q02L25",
              "subcategories": []
            },
            {
              "id": "aerial-equipment-nissan-rgh02a28",
              "name": "RGH02A28",
              "subcategories": []
            },
            {
              "id": "aerial-equipment-nissan-rpxt2w2g60",
              "name": "RPXT2W2G60",
              "subcategories": []
            },
            {
              "id": "aerial-equipment-nissan-sm1h235",
              "name": "SM1H235",
              "subcategories": []
            },
            {
              "id": "aerial-equipment-nissan-tgxt22w4g20",
              "name": "TGXT22W4G20",
              "subcategories": []
            },
            {
              "id": "aerial-equipment-nissan-u1d2a20",
              "name": "U1D2A20",
              "subcategories": []
            },
            {
              "id": "aerial-equipment-nissan-u1d2a25",
              "name": "U1D2A25",
              "subcategories": []
            },
            {
              "id": "aerial-equipment-nissan-ud02a25",
              "name": "UD02A25",
              "subcategories": []
            },
            {
              "id": "aerial-equipment-nissan-ug1d2a32",
              "name": "UG1D2A32",
              "subcategories": []
            },
            {
              "id": "aerial-equipment-nissan-ugd02a30",
              "name": "UGD02A30",
              "subcategories": []
            },
            {
              "id": "aerial-equipment-nissan-ugj02a30",
              "name": "UGJ02A30",
              "subcategories": []
            },
            {
              "id": "aerial-equipment-nissan-vf05h70",
              "name": "VF05H70",
              "subcategories": []
            },
            {
              "id": "aerial-equipment-nissan-wgf03a40",
              "name": "WGF03A40",
              "subcategories": []
            },
            {
              "id": "aerial-equipment-nissan-wgf03a45",
              "name": "WGF03A45",
              "subcategories": []
            },
            {
              "id": "aerial-equipment-nissan-y1d2a25",
              "name": "Y1D2A25",
              "subcategories": []
            },
            {
              "id": "aerial-equipment-nissan-y1f2a25",
              "name": "Y1F2A25",
              "subcategories": []
            },
            {
              "id": "aerial-equipment-nissan-yg1d2a30",
              "name": "YG1D2A30",
              "subcategories": []
            },
            {
              "id": "aerial-equipment-nissan-other",
              "name": "OTHER",
              "subcategories": []
            }
          ]
        },
        {
          "id": "aerial-equipment-niftylift",
          "name": "Niftylift",
          "subcategories": [
            {
              "id": "aerial-equipment-niftylift-120",
              "name": "120",
              "subcategories": []
            },
            {
              "id": "aerial-equipment-niftylift-150",
              "name": "150",
              "subcategories": []
            },
            {
              "id": "aerial-equipment-niftylift-170",
              "name": "170",
              "subcategories": []
            },
            {
              "id": "aerial-equipment-niftylift-at34t",
              "name": "AT34T",
              "subcategories": []
            },
            {
              "id": "aerial-equipment-niftylift-hr12",
              "name": "HR12",
              "subcategories": []
            },
            {
              "id": "aerial-equipment-niftylift-hr15",
              "name": "HR15",
              "subcategories": []
            },
            {
              "id": "aerial-equipment-niftylift-hr17",
              "name": "HR17",
              "subcategories": []
            },
            {
              "id": "aerial-equipment-niftylift-hr21",
              "name": "HR21",
              "subcategories": []
            },
            {
              "id": "aerial-equipment-niftylift-hr28",
              "name": "HR28",
              "subcategories": []
            },
            {
              "id": "aerial-equipment-niftylift-n120",
              "name": "N120",
              "subcategories": []
            },
            {
              "id": "aerial-equipment-niftylift-sd34t",
              "name": "SD34T",
              "subcategories": []
            },
            {
              "id": "aerial-equipment-niftylift-sd50",
              "name": "SD50",
              "subcategories": []
            },
            {
              "id": "aerial-equipment-niftylift-sd64",
              "name": "SD64",
              "subcategories": []
            },
            {
              "id": "aerial-equipment-niftylift-sp34",
              "name": "SP34",
              "subcategories": []
            },
            {
              "id": "aerial-equipment-niftylift-sp45",
              "name": "SP45",
              "subcategories": []
            },
            {
              "id": "aerial-equipment-niftylift-sp50",
              "name": "SP50",
              "subcategories": []
            },
            {
              "id": "aerial-equipment-niftylift-sp64",
              "name": "SP64",
              "subcategories": []
            },
            {
              "id": "aerial-equipment-niftylift-sp65",
              "name": "SP65",
              "subcategories": []
            },
            {
              "id": "aerial-equipment-niftylift-sp85",
              "name": "SP85",
              "subcategories": []
            },
            {
              "id": "aerial-equipment-niftylift-td34",
              "name": "TD34",
              "subcategories": []
            },
            {
              "id": "aerial-equipment-niftylift-td42",
              "name": "TD42",
              "subcategories": []
            },
            {
              "id": "aerial-equipment-niftylift-td120",
              "name": "TD120",
              "subcategories": []
            },
            {
              "id": "aerial-equipment-niftylift-tm34",
              "name": "TM34",
              "subcategories": []
            },
            {
              "id": "aerial-equipment-niftylift-tm40",
              "name": "TM40",
              "subcategories": []
            },
            {
              "id": "aerial-equipment-niftylift-tm42",
              "name": "TM42",
              "subcategories": []
            },
            {
              "id": "aerial-equipment-niftylift-tm64",
              "name": "TM64",
              "subcategories": []
            },
            {
              "id": "aerial-equipment-niftylift-tm50",
              "name": "TM50",
              "subcategories": []
            },
            {
              "id": "aerial-equipment-niftylift-other",
              "name": "OTHER",
              "subcategories": []
            }
          ]
        },
        {
          "id": "aerial-equipment-raymond",
          "name": "Raymond",
          "subcategories": [
            {
              "id": "aerial-equipment-raymond-80csr40",
              "name": "80CSR40",
              "subcategories": []
            },
            {
              "id": "aerial-equipment-raymond-102tf45",
              "name": "102TF45",
              "subcategories": []
            },
            {
              "id": "aerial-equipment-raymond-60c30",
              "name": "60C30",
              "subcategories": []
            },
            {
              "id": "aerial-equipment-raymond-80csr40",
              "name": "80CSR40",
              "subcategories": []
            },
            {
              "id": "aerial-equipment-raymond-102tf45",
              "name": "102TF45",
              "subcategories": []
            },
            {
              "id": "aerial-equipment-raymond-112tmfre60",
              "name": "112TMFRE60",
              "subcategories": []
            },
            {
              "id": "aerial-equipment-raymond-1520opc",
              "name": "1520OPC",
              "subcategories": []
            },
            {
              "id": "aerial-equipment-raymond-415c30",
              "name": "415C30",
              "subcategories": []
            },
            {
              "id": "aerial-equipment-raymond-415c35",
              "name": "415C35",
              "subcategories": []
            },
            {
              "id": "aerial-equipment-raymond-420c40",
              "name": "420C40",
              "subcategories": []
            },
            {
              "id": "aerial-equipment-raymond-425c30",
              "name": "425C30",
              "subcategories": []
            },
            {
              "id": "aerial-equipment-raymond-425c35",
              "name": "425C35",
              "subcategories": []
            },
            {
              "id": "aerial-equipment-raymond-425c40",
              "name": "425C40",
              "subcategories": []
            },
            {
              "id": "aerial-equipment-raymond-425c50",
              "name": "425C50",
              "subcategories": []
            },
            {
              "id": "aerial-equipment-raymond-445c35",
              "name": "445C35",
              "subcategories": []
            },
            {
              "id": "aerial-equipment-raymond-445c40",
              "name": "445C40",
              "subcategories": []
            },
            {
              "id": "aerial-equipment-raymond-520opc30",
              "name": "520OPC30",
              "subcategories": []
            },
            {
              "id": "aerial-equipment-raymond-530pc",
              "name": "530PC",
              "subcategories": []
            },
            {
              "id": "aerial-equipment-raymond-540opc30",
              "name": "540OPC30",
              "subcategories": []
            },
            {
              "id": "aerial-equipment-raymond-550opc30",
              "name": "550OPC30",
              "subcategories": []
            },
            {
              "id": "aerial-equipment-raymond-560opc30",
              "name": "560OPC30",
              "subcategories": []
            },
            {
              "id": "aerial-equipment-raymond-720r",
              "name": "720R",
              "subcategories": []
            },
            {
              "id": "aerial-equipment-raymond-730dr",
              "name": "730DR",
              "subcategories": []
            },
            {
              "id": "aerial-equipment-raymond-730r",
              "name": "730R",
              "subcategories": []
            },
            {
              "id": "aerial-equipment-raymond-740dr",
              "name": "740DR",
              "subcategories": []
            },
            {
              "id": "aerial-equipment-raymond-740r",
              "name": "740R",
              "subcategories": []
            },
            {
              "id": "aerial-equipment-raymond-742dr",
              "name": "742DR",
              "subcategories": []
            },
            {
              "id": "aerial-equipment-raymond-750dr",
              "name": "750DR",
              "subcategories": []
            },
            {
              "id": "aerial-equipment-raymond-750r",
              "name": "750R",
              "subcategories": []
            },
            {
              "id": "aerial-equipment-raymond-752dr",
              "name": "752DR",
              "subcategories": []
            },
            {
              "id": "aerial-equipment-raymond-752r",
              "name": "752R",
              "subcategories": []
            },
            {
              "id": "aerial-equipment-raymond-760r",
              "name": "760R",
              "subcategories": []
            },
            {
              "id": "aerial-equipment-raymond-770r",
              "name": "770R",
              "subcategories": []
            },
            {
              "id": "aerial-equipment-raymond-960csr30",
              "name": "960CSR30",
              "subcategories": []
            },
            {
              "id": "aerial-equipment-raymond-970csr30",
              "name": "970CSR30",
              "subcategories": []
            },
            {
              "id": "aerial-equipment-raymond-3030",
              "name": "3030",
              "subcategories": []
            },
            {
              "id": "aerial-equipment-raymond-4250",
              "name": "4250",
              "subcategories": []
            },
            {
              "id": "aerial-equipment-raymond-4460c30",
              "name": "4460C30",
              "subcategories": []
            },
            {
              "id": "aerial-equipment-raymond-4460c35",
              "name": "4460C35",
              "subcategories": []
            },
            {
              "id": "aerial-equipment-raymond-4460c40",
              "name": "4460C40",
              "subcategories": []
            },
            {
              "id": "aerial-equipment-raymond-4700c40",
              "name": "4700C40",
              "subcategories": []
            },
            {
              "id": "aerial-equipment-raymond-4700c50",
              "name": "4700C50",
              "subcategories": []
            },
            {
              "id": "aerial-equipment-raymond-4700c60",
              "name": "4700C60",
              "subcategories": []
            },
            {
              "id": "aerial-equipment-raymond-4750",
              "name": "4750",
              "subcategories": []
            },
            {
              "id": "aerial-equipment-raymond-6210",
              "name": "6210",
              "subcategories": []
            },
            {
              "id": "aerial-equipment-raymond-7310",
              "name": "7310",
              "subcategories": []
            },
            {
              "id": "aerial-equipment-raymond-8210",
              "name": "8210",
              "subcategories": []
            },
            {
              "id": "aerial-equipment-raymond-8250",
              "name": "8250",
              "subcategories": []
            },
            {
              "id": "aerial-equipment-raymond-8400",
              "name": "8400",
              "subcategories": []
            },
            {
              "id": "aerial-equipment-raymond-8410",
              "name": "8410",
              "subcategories": []
            },
            {
              "id": "aerial-equipment-raymond-8500",
              "name": "8500",
              "subcategories": []
            },
            {
              "id": "aerial-equipment-raymond-8510",
              "name": "8510",
              "subcategories": []
            },
            {
              "id": "aerial-equipment-raymond-8600",
              "name": "8600",
              "subcategories": []
            },
            {
              "id": "aerial-equipment-raymond-8610",
              "name": "8610",
              "subcategories": []
            },
            {
              "id": "aerial-equipment-raymond-8900",
              "name": "8900",
              "subcategories": []
            },
            {
              "id": "aerial-equipment-raymond-9800",
              "name": "9800",
              "subcategories": []
            },
            {
              "id": "aerial-equipment-raymond-dss350",
              "name": "DSS350",
              "subcategories": []
            },
            {
              "id": "aerial-equipment-raymond-easi",
              "name": "EASI",
              "subcategories": []
            },
            {
              "id": "aerial-equipment-raymond-easi-4dr45tt",
              "name": "EASI 4DR45TT",
              "subcategories": []
            },
            {
              "id": "aerial-equipment-raymond-easi-dr25tt",
              "name": "EASI DR25TT",
              "subcategories": []
            },
            {
              "id": "aerial-equipment-raymond-easi-dr30tt",
              "name": "EASI DR30TT",
              "subcategories": []
            },
            {
              "id": "aerial-equipment-raymond-easi-opc30tt",
              "name": "EASI OPC30TT",
              "subcategories": []
            },
            {
              "id": "aerial-equipment-raymond-easi-r30tt",
              "name": "EASI R30TT",
              "subcategories": []
            },
            {
              "id": "aerial-equipment-raymond-easi-r35tt",
              "name": "EASI R35TT",
              "subcategories": []
            },
            {
              "id": "aerial-equipment-raymond-easi-r40tt",
              "name": "EASI R40TT",
              "subcategories": []
            },
            {
              "id": "aerial-equipment-raymond-easi-r45tt",
              "name": "EASI R45TT",
              "subcategories": []
            },
            {
              "id": "aerial-equipment-raymond-r30c30",
              "name": "R30C30",
              "subcategories": []
            },
            {
              "id": "aerial-equipment-raymond-r30tt",
              "name": "R30TT",
              "subcategories": []
            },
            {
              "id": "aerial-equipment-raymond-r40c40",
              "name": "R40C40",
              "subcategories": []
            },
            {
              "id": "aerial-equipment-raymond-ras25",
              "name": "RAS25",
              "subcategories": []
            },
            {
              "id": "aerial-equipment-raymond-rrs30",
              "name": "RRS30",
              "subcategories": []
            },
            {
              "id": "aerial-equipment-raymond-rss22",
              "name": "RSS22",
              "subcategories": []
            },
            {
              "id": "aerial-equipment-raymond-rss40",
              "name": "RSS40",
              "subcategories": []
            },
            {
              "id": "aerial-equipment-raymond-rtw30",
              "name": "RTW30",
              "subcategories": []
            },
            {
              "id": "aerial-equipment-raymond-sacsr",
              "name": "SACSR",
              "subcategories": []
            },
            {
              "id": "aerial-equipment-raymond-other",
              "name": "OTHER",
              "subcategories": []
            }
          ]
        },
        {
          "id": "aerial-equipment-sany",
          "name": "Sany",
          "subcategories": [
            {
              "id": "aerial-equipment-sany-rsc45",
              "name": "RSC45",
              "subcategories": []
            },
            {
              "id": "aerial-equipment-sany-scp100",
              "name": "SCP100",
              "subcategories": []
            },
            {
              "id": "aerial-equipment-sany-scp130",
              "name": "SCP130",
              "subcategories": []
            },
            {
              "id": "aerial-equipment-sany-scp140",
              "name": "SCP140",
              "subcategories": []
            },
            {
              "id": "aerial-equipment-sany-scp160",
              "name": "SCP160",
              "subcategories": []
            },
            {
              "id": "aerial-equipment-sany-scp250",
              "name": "SCP250",
              "subcategories": []
            },
            {
              "id": "aerial-equipment-sany-scp320",
              "name": "SCP320",
              "subcategories": []
            },
            {
              "id": "aerial-equipment-sany-spa20",
              "name": "SPA20",
              "subcategories": []
            },
            {
              "id": "aerial-equipment-sany-spc250",
              "name": "SPC250",
              "subcategories": []
            },
            {
              "id": "aerial-equipment-sany-sps0407dc",
              "name": "SPS0407DC",
              "subcategories": []
            },
            {
              "id": "aerial-equipment-sany-sps0608dc",
              "name": "SPS0608DC",
              "subcategories": []
            },
            {
              "id": "aerial-equipment-sany-sps608hd",
              "name": "SPS608HD",
              "subcategories": []
            },
            {
              "id": "aerial-equipment-sany-sps1012ha",
              "name": "SPS1012HA",
              "subcategories": []
            },
            {
              "id": "aerial-equipment-sany-sps1414ha",
              "name": "SPS1414HA",
              "subcategories": []
            },
            {
              "id": "aerial-equipment-sany-spt22",
              "name": "SPT22",
              "subcategories": []
            },
            {
              "id": "aerial-equipment-sany-spt26",
              "name": "SPT26",
              "subcategories": []
            },
            {
              "id": "aerial-equipment-sany-srsc45",
              "name": "SRSC45",
              "subcategories": []
            },
            {
              "id": "aerial-equipment-sany-sth634",
              "name": "STH634",
              "subcategories": []
            },
            {
              "id": "aerial-equipment-sany-sth844",
              "name": "STH844",
              "subcategories": []
            },
            {
              "id": "aerial-equipment-sany-sth1056",
              "name": "STH1056",
              "subcategories": []
            },
            {
              "id": "aerial-equipment-sany-sth1256",
              "name": "STH1256",
              "subcategories": []
            },
            {
              "id": "aerial-equipment-sany-sth1440",
              "name": "STH1440",
              "subcategories": []
            },
            {
              "id": "aerial-equipment-sany-sth1840",
              "name": "STH1840",
              "subcategories": []
            },
            {
              "id": "aerial-equipment-sany-other",
              "name": "OTHER",
              "subcategories": []
            }
          ]
        },
        {
          "id": "aerial-equipment-snorkel",
          "name": "Snorkel",
          "subcategories": [
            {
              "id": "aerial-equipment-snorkel-400",
              "name": "400",
              "subcategories": []
            },
            {
              "id": "aerial-equipment-snorkel-460",
              "name": "460",
              "subcategories": []
            },
            {
              "id": "aerial-equipment-snorkel-600",
              "name": "600",
              "subcategories": []
            },
            {
              "id": "aerial-equipment-snorkel-2100",
              "name": "2100",
              "subcategories": []
            },
            {
              "id": "aerial-equipment-snorkel-a38",
              "name": "A38",
              "subcategories": []
            },
            {
              "id": "aerial-equipment-snorkel-a46",
              "name": "A46",
              "subcategories": []
            },
            {
              "id": "aerial-equipment-snorkel-a62",
              "name": "A62",
              "subcategories": []
            },
            {
              "id": "aerial-equipment-snorkel-ab46",
              "name": "AB46",
              "subcategories": []
            },
            {
              "id": "aerial-equipment-snorkel-ab50",
              "name": "AB50",
              "subcategories": []
            },
            {
              "id": "aerial-equipment-snorkel-ab60",
              "name": "AB60",
              "subcategories": []
            },
            {
              "id": "aerial-equipment-snorkel-ab80",
              "name": "AB80",
              "subcategories": []
            },
            {
              "id": "aerial-equipment-snorkel-ab85",
              "name": "AB85",
              "subcategories": []
            },
            {
              "id": "aerial-equipment-snorkel-atb50",
              "name": "ATB50",
              "subcategories": []
            },
            {
              "id": "aerial-equipment-snorkel-mb20",
              "name": "MB20",
              "subcategories": []
            },
            {
              "id": "aerial-equipment-snorkel-mb26",
              "name": "MB26",
              "subcategories": []
            },
            {
              "id": "aerial-equipment-snorkel-mhp13",
              "name": "MHP13",
              "subcategories": []
            },
            {
              "id": "aerial-equipment-snorkel-mph-13-35",
              "name": "MPH 13/35",
              "subcategories": []
            },
            {
              "id": "aerial-equipment-snorkel-mhp-15-44",
              "name": "MHP 15/44",
              "subcategories": []
            },
            {
              "id": "aerial-equipment-snorkel-ml20",
              "name": "ML20",
              "subcategories": []
            },
            {
              "id": "aerial-equipment-snorkel-ml24",
              "name": "ML24",
              "subcategories": []
            },
            {
              "id": "aerial-equipment-snorkel-ml25",
              "name": "ML25",
              "subcategories": []
            },
            {
              "id": "aerial-equipment-snorkel-pro100",
              "name": "PRO100",
              "subcategories": []
            },
            {
              "id": "aerial-equipment-snorkel-s1930",
              "name": "S1930",
              "subcategories": []
            },
            {
              "id": "aerial-equipment-snorkel-s2255",
              "name": "S2255",
              "subcategories": []
            },
            {
              "id": "aerial-equipment-snorkel-s2755",
              "name": "S2755",
              "subcategories": []
            },
            {
              "id": "aerial-equipment-snorkel-s2770",
              "name": "S2770",
              "subcategories": []
            },
            {
              "id": "aerial-equipment-snorkel-s3006",
              "name": "S3006",
              "subcategories": []
            },
            {
              "id": "aerial-equipment-snorkel-s3008",
              "name": "S3008",
              "subcategories": []
            },
            {
              "id": "aerial-equipment-snorkel-s3010",
              "name": "S3010",
              "subcategories": []
            },
            {
              "id": "aerial-equipment-snorkel-s3013",
              "name": "S3013",
              "subcategories": []
            },
            {
              "id": "aerial-equipment-snorkel-s3210",
              "name": "S3210",
              "subcategories": []
            },
            {
              "id": "aerial-equipment-snorkel-s3215",
              "name": "S3215",
              "subcategories": []
            },
            {
              "id": "aerial-equipment-snorkel-s3219",
              "name": "S3219",
              "subcategories": []
            },
            {
              "id": "aerial-equipment-snorkel-s3220",
              "name": "S3220",
              "subcategories": []
            },
            {
              "id": "aerial-equipment-snorkel-s3226",
              "name": "S3226",
              "subcategories": []
            },
            {
              "id": "aerial-equipment-snorkel-s3246",
              "name": "S3246",
              "subcategories": []
            },
            {
              "id": "aerial-equipment-snorkel-s3370",
              "name": "S3370",
              "subcategories": []
            },
            {
              "id": "aerial-equipment-snorkel-s3970",
              "name": "S3970",
              "subcategories": []
            },
            {
              "id": "aerial-equipment-snorkel-s4726",
              "name": "S4726",
              "subcategories": []
            },
            {
              "id": "aerial-equipment-snorkel-s4732",
              "name": "S4732",
              "subcategories": []
            },
            {
              "id": "aerial-equipment-snorkel-s4740",
              "name": "S4740",
              "subcategories": []
            },
            {
              "id": "aerial-equipment-snorkel-s9033",
              "name": "S9033",
              "subcategories": []
            },
            {
              "id": "aerial-equipment-snorkel-s9053",
              "name": "S9053",
              "subcategories": []
            },
            {
              "id": "aerial-equipment-snorkel-s9056",
              "name": "S9056",
              "subcategories": []
            },
            {
              "id": "aerial-equipment-snorkel-s9070",
              "name": "S9070",
              "subcategories": []
            },
            {
              "id": "aerial-equipment-snorkel-sb126",
              "name": "SB126",
              "subcategories": []
            },
            {
              "id": "aerial-equipment-snorkel-sl25",
              "name": "SL25",
              "subcategories": []
            },
            {
              "id": "aerial-equipment-snorkel-sl26",
              "name": "SL26",
              "subcategories": []
            },
            {
              "id": "aerial-equipment-snorkel-sl30",
              "name": "SL30",
              "subcategories": []
            },
            {
              "id": "aerial-equipment-snorkel-sr626",
              "name": "SR626",
              "subcategories": []
            },
            {
              "id": "aerial-equipment-snorkel-sr1054",
              "name": "SR1054",
              "subcategories": []
            },
            {
              "id": "aerial-equipment-snorkel-sr1331",
              "name": "SR1331",
              "subcategories": []
            },
            {
              "id": "aerial-equipment-snorkel-sr5719",
              "name": "SR5719",
              "subcategories": []
            },
            {
              "id": "aerial-equipment-snorkel-sr9244",
              "name": "SR9244",
              "subcategories": []
            },
            {
              "id": "aerial-equipment-snorkel-t46",
              "name": "T46",
              "subcategories": []
            },
            {
              "id": "aerial-equipment-snorkel-t66",
              "name": "T66",
              "subcategories": []
            },
            {
              "id": "aerial-equipment-snorkel-tb37",
              "name": "TB37",
              "subcategories": []
            },
            {
              "id": "aerial-equipment-snorkel-tb42",
              "name": "TB42",
              "subcategories": []
            },
            {
              "id": "aerial-equipment-snorkel-tb47",
              "name": "TB47",
              "subcategories": []
            },
            {
              "id": "aerial-equipment-snorkel-tb60",
              "name": "TB60",
              "subcategories": []
            },
            {
              "id": "aerial-equipment-snorkel-tb66",
              "name": "TB66",
              "subcategories": []
            },
            {
              "id": "aerial-equipment-snorkel-tb80",
              "name": "TB80",
              "subcategories": []
            },
            {
              "id": "aerial-equipment-snorkel-tb85",
              "name": "TB85",
              "subcategories": []
            },
            {
              "id": "aerial-equipment-snorkel-tb86",
              "name": "TB86",
              "subcategories": []
            },
            {
              "id": "aerial-equipment-snorkel-tb120",
              "name": "TB120",
              "subcategories": []
            },
            {
              "id": "aerial-equipment-snorkel-tb126",
              "name": "TB126",
              "subcategories": []
            },
            {
              "id": "aerial-equipment-snorkel-tba80",
              "name": "TBA80",
              "subcategories": []
            },
            {
              "id": "aerial-equipment-snorkel-tl37",
              "name": "TL37",
              "subcategories": []
            },
            {
              "id": "aerial-equipment-snorkel-tl39",
              "name": "TL39",
              "subcategories": []
            },
            {
              "id": "aerial-equipment-snorkel-tl49",
              "name": "TL49",
              "subcategories": []
            },
            {
              "id": "aerial-equipment-snorkel-tm12",
              "name": "TM12",
              "subcategories": []
            },
            {
              "id": "aerial-equipment-snorkel-tm16",
              "name": "TM16",
              "subcategories": []
            },
            {
              "id": "aerial-equipment-snorkel-ul25",
              "name": "UL25",
              "subcategories": []
            },
            {
              "id": "aerial-equipment-snorkel-ul32",
              "name": "UL32",
              "subcategories": []
            },
            {
              "id": "aerial-equipment-snorkel-ul40",
              "name": "UL40",
              "subcategories": []
            },
            {
              "id": "aerial-equipment-snorkel-x26n",
              "name": "X26N",
              "subcategories": []
            },
            {
              "id": "aerial-equipment-snorkel-other",
              "name": "OTHER",
              "subcategories": []
            }
          ]
        },
        {
          "id": "aerial-equipment-taylor",
          "name": "Taylor",
          "subcategories": [
            {
              "id": "aerial-equipment-taylor-gt50",
              "name": "GT50",
              "subcategories": []
            },
            {
              "id": "aerial-equipment-taylor-gt60",
              "name": "GT60",
              "subcategories": []
            },
            {
              "id": "aerial-equipment-taylor-gt80",
              "name": "GT80",
              "subcategories": []
            },
            {
              "id": "aerial-equipment-taylor-gt90",
              "name": "GT90",
              "subcategories": []
            },
            {
              "id": "aerial-equipment-taylor-gt100",
              "name": "GT100",
              "subcategories": []
            },
            {
              "id": "aerial-equipment-taylor-gt120",
              "name": "GT120",
              "subcategories": []
            },
            {
              "id": "aerial-equipment-taylor-gt180",
              "name": "GT180",
              "subcategories": []
            },
            {
              "id": "aerial-equipment-taylor-gt360",
              "name": "GT360",
              "subcategories": []
            },
            {
              "id": "aerial-equipment-taylor-gtr90",
              "name": "GTR90",
              "subcategories": []
            },
            {
              "id": "aerial-equipment-taylor-pt550",
              "name": "PT550",
              "subcategories": []
            },
            {
              "id": "aerial-equipment-taylor-rs9968",
              "name": "RS9968",
              "subcategories": []
            },
            {
              "id": "aerial-equipment-taylor-t220",
              "name": "T220",
              "subcategories": []
            },
            {
              "id": "aerial-equipment-taylor-t250",
              "name": "T250",
              "subcategories": []
            },
            {
              "id": "aerial-equipment-taylor-t300",
              "name": "T300",
              "subcategories": []
            },
            {
              "id": "aerial-equipment-taylor-t330",
              "name": "T330",
              "subcategories": []
            },
            {
              "id": "aerial-equipment-taylor-t360",
              "name": "T360",
              "subcategories": []
            },
            {
              "id": "aerial-equipment-taylor-t520",
              "name": "T520",
              "subcategories": []
            },
            {
              "id": "aerial-equipment-taylor-t650l",
              "name": "T650L",
              "subcategories": []
            },
            {
              "id": "aerial-equipment-taylor-tb300",
              "name": "TB300",
              "subcategories": []
            },
            {
              "id": "aerial-equipment-taylor-tc230",
              "name": "TC230",
              "subcategories": []
            },
            {
              "id": "aerial-equipment-taylor-te180",
              "name": "TE180",
              "subcategories": []
            },
            {
              "id": "aerial-equipment-taylor-te250",
              "name": "TE250",
              "subcategories": []
            },
            {
              "id": "aerial-equipment-taylor-te275",
              "name": "TE275",
              "subcategories": []
            },
            {
              "id": "aerial-equipment-taylor-te300",
              "name": "TE300",
              "subcategories": []
            },
            {
              "id": "aerial-equipment-taylor-te330",
              "name": "TE330",
              "subcategories": []
            },
            {
              "id": "aerial-equipment-taylor-te360",
              "name": "TE360",
              "subcategories": []
            },
            {
              "id": "aerial-equipment-taylor-te520",
              "name": "TE520",
              "subcategories": []
            },
            {
              "id": "aerial-equipment-taylor-te650",
              "name": "TE650",
              "subcategories": []
            },
            {
              "id": "aerial-equipment-taylor-te800",
              "name": "TE800",
              "subcategories": []
            },
            {
              "id": "aerial-equipment-taylor-te925",
              "name": "TE925",
              "subcategories": []
            },
            {
              "id": "aerial-equipment-taylor-te1100",
              "name": "TE1100",
              "subcategories": []
            },
            {
              "id": "aerial-equipment-taylor-tec155",
              "name": "TEC155",
              "subcategories": []
            },
            {
              "id": "aerial-equipment-taylor-tec950",
              "name": "TEC950",
              "subcategories": []
            },
            {
              "id": "aerial-equipment-taylor-tetcp1100",
              "name": "TETCP1100",
              "subcategories": []
            },
            {
              "id": "aerial-equipment-taylor-th350",
              "name": "TH350",
              "subcategories": []
            },
            {
              "id": "aerial-equipment-taylor-thb250",
              "name": "THB250",
              "subcategories": []
            },
            {
              "id": "aerial-equipment-taylor-thb300",
              "name": "THB300",
              "subcategories": []
            },
            {
              "id": "aerial-equipment-taylor-thc300",
              "name": "THC300",
              "subcategories": []
            },
            {
              "id": "aerial-equipment-taylor-thc400",
              "name": "THC400",
              "subcategories": []
            },
            {
              "id": "aerial-equipment-taylor-thc800",
              "name": "THC800",
              "subcategories": []
            },
            {
              "id": "aerial-equipment-taylor-thd160",
              "name": "THD160",
              "subcategories": []
            },
            {
              "id": "aerial-equipment-taylor-thd300",
              "name": "THD300",
              "subcategories": []
            },
            {
              "id": "aerial-equipment-taylor-thd360",
              "name": "THD360",
              "subcategories": []
            },
            {
              "id": "aerial-equipment-taylor-thdc955",
              "name": "THDC955",
              "subcategories": []
            },
            {
              "id": "aerial-equipment-taylor-thdc974",
              "name": "THDC974",
              "subcategories": []
            },
            {
              "id": "aerial-equipment-taylor-thdc975",
              "name": "THDC975",
              "subcategories": []
            },
            {
              "id": "aerial-equipment-taylor-tn520s",
              "name": "TN520S",
              "subcategories": []
            },
            {
              "id": "aerial-equipment-taylor-trsi994",
              "name": "TRSI994",
              "subcategories": []
            },
            {
              "id": "aerial-equipment-taylor-ts1068",
              "name": "TS1068",
              "subcategories": []
            },
            {
              "id": "aerial-equipment-taylor-ts9972",
              "name": "TS9972",
              "subcategories": []
            },
            {
              "id": "aerial-equipment-taylor-ts9985",
              "name": "TS9985",
              "subcategories": []
            },
            {
              "id": "aerial-equipment-taylor-tx4",
              "name": "TX4",
              "subcategories": []
            },
            {
              "id": "aerial-equipment-taylor-tx160",
              "name": "TX160",
              "subcategories": []
            },
            {
              "id": "aerial-equipment-taylor-tx175",
              "name": "TX175",
              "subcategories": []
            },
            {
              "id": "aerial-equipment-taylor-tx220",
              "name": "TX220",
              "subcategories": []
            },
            {
              "id": "aerial-equipment-taylor-tx250",
              "name": "TX250",
              "subcategories": []
            },
            {
              "id": "aerial-equipment-taylor-tx280",
              "name": "TX280",
              "subcategories": []
            },
            {
              "id": "aerial-equipment-taylor-tx300",
              "name": "TX300",
              "subcategories": []
            },
            {
              "id": "aerial-equipment-taylor-tx330",
              "name": "TX330",
              "subcategories": []
            },
            {
              "id": "aerial-equipment-taylor-tx360",
              "name": "TX360",
              "subcategories": []
            },
            {
              "id": "aerial-equipment-taylor-tx520",
              "name": "TX520",
              "subcategories": []
            },
            {
              "id": "aerial-equipment-taylor-tx550",
              "name": "TX550",
              "subcategories": []
            },
            {
              "id": "aerial-equipment-taylor-tx650",
              "name": "TX650",
              "subcategories": []
            },
            {
              "id": "aerial-equipment-taylor-tx800",
              "name": "TX800",
              "subcategories": []
            },
            {
              "id": "aerial-equipment-taylor-tx900",
              "name": "TX900",
              "subcategories": []
            },
            {
              "id": "aerial-equipment-taylor-tx925",
              "name": "TX925",
              "subcategories": []
            },
            {
              "id": "aerial-equipment-taylor-tx4030",
              "name": "TX4030",
              "subcategories": []
            },
            {
              "id": "aerial-equipment-taylor-txb180",
              "name": "TXB180",
              "subcategories": []
            },
            {
              "id": "aerial-equipment-taylor-txh350",
              "name": "TXH350",
              "subcategories": []
            },
            {
              "id": "aerial-equipment-taylor-txi520",
              "name": "TXI520",
              "subcategories": []
            },
            {
              "id": "aerial-equipment-taylor-txi650",
              "name": "TXI650",
              "subcategories": []
            },
            {
              "id": "aerial-equipment-taylor-txi700",
              "name": "TXI700",
              "subcategories": []
            },
            {
              "id": "aerial-equipment-taylor-txlc",
              "name": "TXLC",
              "subcategories": []
            },
            {
              "id": "aerial-equipment-taylor-tyb220",
              "name": "TYB220",
              "subcategories": []
            },
            {
              "id": "aerial-equipment-taylor-wpy",
              "name": "WPY",
              "subcategories": []
            },
            {
              "id": "aerial-equipment-taylor-x160",
              "name": "X160",
              "subcategories": []
            },
            {
              "id": "aerial-equipment-taylor-x175",
              "name": "X175",
              "subcategories": []
            },
            {
              "id": "aerial-equipment-taylor-x180",
              "name": "X180",
              "subcategories": []
            },
            {
              "id": "aerial-equipment-taylor-x200",
              "name": "X200",
              "subcategories": []
            },
            {
              "id": "aerial-equipment-taylor-x220",
              "name": "X220",
              "subcategories": []
            },
            {
              "id": "aerial-equipment-taylor-x250",
              "name": "X250",
              "subcategories": []
            },
            {
              "id": "aerial-equipment-taylor-x280",
              "name": "X280",
              "subcategories": []
            },
            {
              "id": "aerial-equipment-taylor-x300",
              "name": "X300",
              "subcategories": []
            },
            {
              "id": "aerial-equipment-taylor-x330",
              "name": "X330",
              "subcategories": []
            },
            {
              "id": "aerial-equipment-taylor-x360",
              "name": "X360",
              "subcategories": []
            },
            {
              "id": "aerial-equipment-taylor-x500",
              "name": "X500",
              "subcategories": []
            },
            {
              "id": "aerial-equipment-taylor-x550",
              "name": "X550",
              "subcategories": []
            },
            {
              "id": "aerial-equipment-taylor-x650",
              "name": "X650",
              "subcategories": []
            },
            {
              "id": "aerial-equipment-taylor-x700",
              "name": "X700",
              "subcategories": []
            },
            {
              "id": "aerial-equipment-taylor-xb",
              "name": "XB",
              "subcategories": []
            },
            {
              "id": "aerial-equipment-taylor-xc220",
              "name": "XC220",
              "subcategories": []
            },
            {
              "id": "aerial-equipment-taylor-xc250",
              "name": "XC250",
              "subcategories": []
            },
            {
              "id": "aerial-equipment-taylor-xc300",
              "name": "XC300",
              "subcategories": []
            },
            {
              "id": "aerial-equipment-taylor-xc350",
              "name": "XC350",
              "subcategories": []
            },
            {
              "id": "aerial-equipment-taylor-xec",
              "name": "XEC",
              "subcategories": []
            },
            {
              "id": "aerial-equipment-taylor-xh180",
              "name": "XH180",
              "subcategories": []
            },
            {
              "id": "aerial-equipment-taylor-xh350",
              "name": "XH350",
              "subcategories": []
            },
            {
              "id": "aerial-equipment-taylor-xh360",
              "name": "XH360",
              "subcategories": []
            },
            {
              "id": "aerial-equipment-taylor-xh370",
              "name": "XH370",
              "subcategories": []
            },
            {
              "id": "aerial-equipment-taylor-xh400",
              "name": "XH400",
              "subcategories": []
            },
            {
              "id": "aerial-equipment-taylor-xh550",
              "name": "XH550",
              "subcategories": []
            },
            {
              "id": "aerial-equipment-taylor-xh700",
              "name": "XH700",
              "subcategories": []
            },
            {
              "id": "aerial-equipment-taylor-xhc",
              "name": "XHC",
              "subcategories": []
            },
            {
              "id": "aerial-equipment-taylor-xlc",
              "name": "XLC",
              "subcategories": []
            },
            {
              "id": "aerial-equipment-taylor-xrs",
              "name": "XRS",
              "subcategories": []
            },
            {
              "id": "aerial-equipment-taylor-y18",
              "name": "Y18",
              "subcategories": []
            },
            {
              "id": "aerial-equipment-taylor-y24",
              "name": "Y24",
              "subcategories": []
            },
            {
              "id": "aerial-equipment-taylor-other",
              "name": "OTHER",
              "subcategories": []
            }
          ]
        },
        {
          "id": "aerial-equipment-terex",
          "name": "Terex",
          "subcategories": [
            {
              "id": "aerial-equipment-terex-fdc25",
              "name": "FDC25",
              "subcategories": []
            },
            {
              "id": "aerial-equipment-terex-gth636",
              "name": "GTH636",
              "subcategories": []
            },
            {
              "id": "aerial-equipment-terex-gyro-4518",
              "name": "GYRO 4518",
              "subcategories": []
            },
            {
              "id": "aerial-equipment-terex-rs60",
              "name": "RS60",
              "subcategories": []
            },
            {
              "id": "aerial-equipment-terex-ss636",
              "name": "SS636",
              "subcategories": []
            },
            {
              "id": "aerial-equipment-terex-ss644",
              "name": "SS644",
              "subcategories": []
            },
            {
              "id": "aerial-equipment-terex-ss842",
              "name": "SS842",
              "subcategories": []
            },
            {
              "id": "aerial-equipment-terex-ss1056",
              "name": "SS1056",
              "subcategories": []
            },
            {
              "id": "aerial-equipment-terex-t45",
              "name": "T45",
              "subcategories": []
            },
            {
              "id": "aerial-equipment-terex-t250",
              "name": "T250",
              "subcategories": []
            },
            {
              "id": "aerial-equipment-terex-ta30",
              "name": "TA30",
              "subcategories": []
            },
            {
              "id": "aerial-equipment-terex-ta50",
              "name": "TA50",
              "subcategories": []
            },
            {
              "id": "aerial-equipment-terex-tb60",
              "name": "TB60",
              "subcategories": []
            },
            {
              "id": "aerial-equipment-terex-tb66",
              "name": "TB66",
              "subcategories": []
            },
            {
              "id": "aerial-equipment-terex-tb80",
              "name": "TB80",
              "subcategories": []
            },
            {
              "id": "aerial-equipment-terex-tb100",
              "name": "TB100",
              "subcategories": []
            },
            {
              "id": "aerial-equipment-terex-telelift-2506",
              "name": "TELELIFT 2506",
              "subcategories": []
            },
            {
              "id": "aerial-equipment-terex-telelift-3517",
              "name": "TELELIFT 3517",
              "subcategories": []
            },
            {
              "id": "aerial-equipment-terex-telelift-3713",
              "name": "TELELIFT 3713",
              "subcategories": []
            },
            {
              "id": "aerial-equipment-terex-telelift-4013",
              "name": "TELELIFT 4013",
              "subcategories": []
            },
            {
              "id": "aerial-equipment-terex-tfc45",
              "name": "TFC45",
              "subcategories": []
            },
            {
              "id": "aerial-equipment-terex-th636",
              "name": "TH636",
              "subcategories": []
            },
            {
              "id": "aerial-equipment-terex-th644",
              "name": "TH644",
              "subcategories": []
            },
            {
              "id": "aerial-equipment-terex-th842",
              "name": "TH842",
              "subcategories": []
            },
            {
              "id": "aerial-equipment-terex-th844",
              "name": "TH844",
              "subcategories": []
            },
            {
              "id": "aerial-equipment-terex-th1056",
              "name": "TH1056",
              "subcategories": []
            },
            {
              "id": "aerial-equipment-terex-tl45",
              "name": "TL45",
              "subcategories": []
            },
            {
              "id": "aerial-equipment-terex-ts20",
              "name": "TS20",
              "subcategories": []
            },
            {
              "id": "aerial-equipment-terex-tm250r",
              "name": "TM250R",
              "subcategories": []
            },
            {
              "id": "aerial-equipment-terex-tx55-19",
              "name": "TX55-19",
              "subcategories": []
            },
            {
              "id": "aerial-equipment-terex-other",
              "name": "OTHER",
              "subcategories": []
            }
          ]
        },
        {
          "id": "aerial-equipment-unicarriers",
          "name": "Unicarriers",
          "subcategories": [
            {
              "id": "aerial-equipment-unicarriers-1s1l20nv",
              "name": "1S1L20NV",
              "subcategories": []
            },
            {
              "id": "aerial-equipment-unicarriers-a1n1l",
              "name": "A1N1L",
              "subcategories": []
            },
            {
              "id": "aerial-equipment-unicarriers-af30",
              "name": "AF30",
              "subcategories": []
            },
            {
              "id": "aerial-equipment-unicarriers-af35",
              "name": "AF35",
              "subcategories": []
            },
            {
              "id": "aerial-equipment-unicarriers-af50",
              "name": "AF50",
              "subcategories": []
            },
            {
              "id": "aerial-equipment-unicarriers-bxc30",
              "name": "BXC30",
              "subcategories": []
            },
            {
              "id": "aerial-equipment-unicarriers-bxc35",
              "name": "BXC35",
              "subcategories": []
            },
            {
              "id": "aerial-equipment-unicarriers-bxc40",
              "name": "BXC40",
              "subcategories": []
            },
            {
              "id": "aerial-equipment-unicarriers-bxc50",
              "name": "BXC50",
              "subcategories": []
            },
            {
              "id": "aerial-equipment-unicarriers-bxc60",
              "name": "BXC60",
              "subcategories": []
            },
            {
              "id": "aerial-equipment-unicarriers-bxc80",
              "name": "BXC80",
              "subcategories": []
            },
            {
              "id": "aerial-equipment-unicarriers-bxp30",
              "name": "BXP30",
              "subcategories": []
            },
            {
              "id": "aerial-equipment-unicarriers-cf30",
              "name": "CF30",
              "subcategories": []
            },
            {
              "id": "aerial-equipment-unicarriers-cf35",
              "name": "CF35",
              "subcategories": []
            },
            {
              "id": "aerial-equipment-unicarriers-cf40",
              "name": "CF40",
              "subcategories": []
            },
            {
              "id": "aerial-equipment-unicarriers-cf50",
              "name": "CF50",
              "subcategories": []
            },
            {
              "id": "aerial-equipment-unicarriers-cf60",
              "name": "CF60",
              "subcategories": []
            },
            {
              "id": "aerial-equipment-unicarriers-cf70",
              "name": "CF70",
              "subcategories": []
            },
            {
              "id": "aerial-equipment-unicarriers-cf80",
              "name": "CF80",
              "subcategories": []
            },
            {
              "id": "aerial-equipment-unicarriers-cf100",
              "name": "CF100",
              "subcategories": []
            },
            {
              "id": "aerial-equipment-unicarriers-cf120",
              "name": "CF120",
              "subcategories": []
            },
            {
              "id": "aerial-equipment-unicarriers-cf155",
              "name": "CF155",
              "subcategories": []
            },
            {
              "id": "aerial-equipment-unicarriers-cfs40",
              "name": "CFS40",
              "subcategories": []
            },
            {
              "id": "aerial-equipment-unicarriers-cfs65",
              "name": "CFS65",
              "subcategories": []
            },
            {
              "id": "aerial-equipment-unicarriers-fcg25",
              "name": "FCG25",
              "subcategories": []
            },
            {
              "id": "aerial-equipment-unicarriers-fcg30",
              "name": "FCG30",
              "subcategories": []
            },
            {
              "id": "aerial-equipment-unicarriers-fg25",
              "name": "FG25",
              "subcategories": []
            },
            {
              "id": "aerial-equipment-unicarriers-fg30",
              "name": "FG30",
              "subcategories": []
            },
            {
              "id": "aerial-equipment-unicarriers-fhd30",
              "name": "FHD30",
              "subcategories": []
            },
            {
              "id": "aerial-equipment-unicarriers-fhd35",
              "name": "FHD35",
              "subcategories": []
            },
            {
              "id": "aerial-equipment-unicarriers-mctg1b2l",
              "name": "MCTG1B2L",
              "subcategories": []
            },
            {
              "id": "aerial-equipment-unicarriers-mj1f4",
              "name": "MJ1F4",
              "subcategories": []
            },
            {
              "id": "aerial-equipment-unicarriers-mxs3",
              "name": "MXS3",
              "subcategories": []
            },
            {
              "id": "aerial-equipment-unicarriers-mxs20",
              "name": "MXS20",
              "subcategories": []
            },
            {
              "id": "aerial-equipment-unicarriers-pf30",
              "name": "PF30",
              "subcategories": []
            },
            {
              "id": "aerial-equipment-unicarriers-pf35",
              "name": "PF35",
              "subcategories": []
            },
            {
              "id": "aerial-equipment-unicarriers-pf40",
              "name": "PF40",
              "subcategories": []
            },
            {
              "id": "aerial-equipment-unicarriers-pf50",
              "name": "PF50",
              "subcategories": []
            },
            {
              "id": "aerial-equipment-unicarriers-pf55",
              "name": "PF55",
              "subcategories": []
            },
            {
              "id": "aerial-equipment-unicarriers-pf60",
              "name": "PF60",
              "subcategories": []
            },
            {
              "id": "aerial-equipment-unicarriers-pf70",
              "name": "PF70",
              "subcategories": []
            },
            {
              "id": "aerial-equipment-unicarriers-pf80",
              "name": "PF80",
              "subcategories": []
            },
            {
              "id": "aerial-equipment-unicarriers-pf90",
              "name": "PF90",
              "subcategories": []
            },
            {
              "id": "aerial-equipment-unicarriers-pf100",
              "name": "PF100",
              "subcategories": []
            },
            {
              "id": "aerial-equipment-unicarriers-pfd40",
              "name": "PFD40",
              "subcategories": []
            },
            {
              "id": "aerial-equipment-unicarriers-pfd60",
              "name": "PFD60",
              "subcategories": []
            },
            {
              "id": "aerial-equipment-unicarriers-pfd70",
              "name": "PFD70",
              "subcategories": []
            },
            {
              "id": "aerial-equipment-unicarriers-pfd110",
              "name": "PFD110",
              "subcategories": []
            },
            {
              "id": "aerial-equipment-unicarriers-fd45",
              "name": "FD45",
              "subcategories": []
            },
            {
              "id": "aerial-equipment-unicarriers-pfd155",
              "name": "PFD155",
              "subcategories": []
            },
            {
              "id": "aerial-equipment-unicarriers-pfd175",
              "name": "PFD175",
              "subcategories": []
            },
            {
              "id": "aerial-equipment-unicarriers-pfu50",
              "name": "PFU50",
              "subcategories": []
            },
            {
              "id": "aerial-equipment-unicarriers-rpx60",
              "name": "RPX60",
              "subcategories": []
            },
            {
              "id": "aerial-equipment-unicarriers-scx40",
              "name": "SCX40",
              "subcategories": []
            },
            {
              "id": "aerial-equipment-unicarriers-srx30",
              "name": "SRX30",
              "subcategories": []
            },
            {
              "id": "aerial-equipment-unicarriers-srx35",
              "name": "SRX35",
              "subcategories": []
            },
            {
              "id": "aerial-equipment-unicarriers-srx45",
              "name": "SRX45",
              "subcategories": []
            },
            {
              "id": "aerial-equipment-unicarriers-tgxe20",
              "name": "TGXE20",
              "subcategories": []
            },
            {
              "id": "aerial-equipment-unicarriers-tx30",
              "name": "TX30",
              "subcategories": []
            },
            {
              "id": "aerial-equipment-unicarriers-tx35",
              "name": "TX35",
              "subcategories": []
            },
            {
              "id": "aerial-equipment-unicarriers-tx40",
              "name": "TX40",
              "subcategories": []
            },
            {
              "id": "aerial-equipment-unicarriers-wlx45",
              "name": "WLX45",
              "subcategories": []
            },
            {
              "id": "aerial-equipment-unicarriers-wpx60",
              "name": "WPX60",
              "subcategories": []
            },
            {
              "id": "aerial-equipment-unicarriers-other",
              "name": "OTHER",
              "subcategories": []
            }
          ]
        },
        {
          "id": "aerial-equipment-viper",
          "name": "Viper",
          "subcategories": [
            {
              "id": "aerial-equipment-viper-fb15",
              "name": "FB15",
              "subcategories": []
            },
            {
              "id": "aerial-equipment-viper-fb16",
              "name": "FB16",
              "subcategories": []
            },
            {
              "id": "aerial-equipment-viper-fb25",
              "name": "FB25",
              "subcategories": []
            },
            {
              "id": "aerial-equipment-viper-fb30",
              "name": "FB30",
              "subcategories": []
            },
            {
              "id": "aerial-equipment-viper-fb35",
              "name": "FB35",
              "subcategories": []
            },
            {
              "id": "aerial-equipment-viper-fb50",
              "name": "FB50",
              "subcategories": []
            },
            {
              "id": "aerial-equipment-viper-fd25",
              "name": "FD25",
              "subcategories": []
            },
            {
              "id": "aerial-equipment-viper-fd30",
              "name": "FD30",
              "subcategories": []
            },
            {
              "id": "aerial-equipment-viper-fd35",
              "name": "FD35",
              "subcategories": []
            },
            {
              "id": "aerial-equipment-viper-fd45",
              "name": "FD45",
              "subcategories": []
            },
            {
              "id": "aerial-equipment-viper-fd50",
              "name": "FD50",
              "subcategories": []
            },
            {
              "id": "aerial-equipment-viper-fd60",
              "name": "FD60",
              "subcategories": []
            },
            {
              "id": "aerial-equipment-viper-fd70",
              "name": "FD70",
              "subcategories": []
            },
            {
              "id": "aerial-equipment-viper-fd80",
              "name": "FD80",
              "subcategories": []
            },
            {
              "id": "aerial-equipment-viper-fd100",
              "name": "FD100",
              "subcategories": []
            },
            {
              "id": "aerial-equipment-viper-fy15",
              "name": "FY15",
              "subcategories": []
            },
            {
              "id": "aerial-equipment-viper-fy18",
              "name": "FY18",
              "subcategories": []
            },
            {
              "id": "aerial-equipment-viper-fy20",
              "name": "FY20",
              "subcategories": []
            },
            {
              "id": "aerial-equipment-viper-fd20",
              "name": "FD20",
              "subcategories": []
            },
            {
              "id": "aerial-equipment-viper-fy25",
              "name": "FY25",
              "subcategories": []
            },
            {
              "id": "aerial-equipment-viper-fy30",
              "name": "FY30",
              "subcategories": []
            },
            {
              "id": "aerial-equipment-viper-fy32",
              "name": "FY32",
              "subcategories": []
            },
            {
              "id": "aerial-equipment-viper-fy35",
              "name": "FY35",
              "subcategories": []
            },
            {
              "id": "aerial-equipment-viper-fy45",
              "name": "FY45",
              "subcategories": []
            },
            {
              "id": "aerial-equipment-viper-fy50",
              "name": "FY50",
              "subcategories": []
            },
            {
              "id": "aerial-equipment-viper-fy70",
              "name": "FY70",
              "subcategories": []
            },
            {
              "id": "aerial-equipment-viper-rt80",
              "name": "RT80",
              "subcategories": []
            },
            {
              "id": "aerial-equipment-viper-rt110",
              "name": "RT110",
              "subcategories": []
            },
            {
              "id": "aerial-equipment-viper-rtd25",
              "name": "RTD25",
              "subcategories": []
            },
            {
              "id": "aerial-equipment-viper-rtd30",
              "name": "RTD30",
              "subcategories": []
            },
            {
              "id": "aerial-equipment-viper-rtd35",
              "name": "RTD35",
              "subcategories": []
            },
            {
              "id": "aerial-equipment-viper-vcps30-40",
              "name": "VCPS30-40",
              "subcategories": []
            },
            {
              "id": "aerial-equipment-viper-vcws25-35",
              "name": "VCWS25-35",
              "subcategories": []
            },
            {
              "id": "aerial-equipment-viper-vrt40-50s",
              "name": "VRT40-50S",
              "subcategories": []
            },
            {
              "id": "aerial-equipment-viper-vps40-40s",
              "name": "VPS40-40S",
              "subcategories": []
            },
            {
              "id": "aerial-equipment-viper-vpt60",
              "name": "VPT60",
              "subcategories": []
            },
            {
              "id": "aerial-equipment-viper-vp30x-50s",
              "name": "VP30X-50S",
              "subcategories": []
            },
            {
              "id": "aerial-equipment-viper-vt519",
              "name": "VT519",
              "subcategories": []
            },
            {
              "id": "aerial-equipment-viper-vtt90",
              "name": "VTT90",
              "subcategories": []
            },
            {
              "id": "aerial-equipment-viper-other",
              "name": "OTHER",
              "subcategories": []
            }
          ]
        }
      ]
    },
    {
      "id": "aggregate",
      "name": "Aggregate",
      "subcategories": [
        {
          "id": "aggregate-powerscreen",
          "name": "Powerscreen",
          "subcategories": [
            {
              "id": "aggregate-powerscreen-4x6",
              "name": "4X6",
              "subcategories": []
            },
            {
              "id": "aggregate-powerscreen-4x8",
              "name": "4X8",
              "subcategories": []
            },
            {
              "id": "aggregate-powerscreen-8x10",
              "name": "8X10",
              "subcategories": []
            },
            {
              "id": "aggregate-powerscreen-30x50",
              "name": "30X50",
              "subcategories": []
            },
            {
              "id": "aggregate-powerscreen-36x50",
              "name": "36X50",
              "subcategories": []
            },
            {
              "id": "aggregate-powerscreen-36x80",
              "name": "36X80",
              "subcategories": []
            },
            {
              "id": "aggregate-powerscreen-65-ft",
              "name": "65 FT",
              "subcategories": []
            },
            {
              "id": "aggregate-powerscreen-315",
              "name": "315",
              "subcategories": []
            },
            {
              "id": "aggregate-powerscreen-550",
              "name": "550",
              "subcategories": []
            },
            {
              "id": "aggregate-powerscreen-615",
              "name": "615",
              "subcategories": []
            },
            {
              "id": "aggregate-powerscreen-725",
              "name": "725",
              "subcategories": []
            },
            {
              "id": "aggregate-powerscreen-820",
              "name": "820",
              "subcategories": []
            },
            {
              "id": "aggregate-powerscreen-830",
              "name": "830",
              "subcategories": []
            },
            {
              "id": "aggregate-powerscreen-100sr",
              "name": "100SR",
              "subcategories": []
            },
            {
              "id": "aggregate-powerscreen-maxtrak-1000",
              "name": "MAXTRAK 1000",
              "subcategories": []
            },
            {
              "id": "aggregate-powerscreen-maxtrax-100e",
              "name": "MAXTRAX 100E",
              "subcategories": []
            },
            {
              "id": "aggregate-powerscreen-maxtrak-1150",
              "name": "MAXTRAK 1150",
              "subcategories": []
            },
            {
              "id": "aggregate-powerscreen-maxtrak-1150-pre-screen",
              "name": "MAXTRAK 1150 PRE-SCREEN",
              "subcategories": []
            },
            {
              "id": "aggregate-powerscreen-maxtrak-1300",
              "name": "MAXTRAK 1300",
              "subcategories": []
            },
            {
              "id": "aggregate-powerscreen-maxtrak-1300x",
              "name": "MAXTRAK 1300X",
              "subcategories": []
            },
            {
              "id": "aggregate-powerscreen-maxtrak-1400",
              "name": "MAXTRAK 1400",
              "subcategories": []
            },
            {
              "id": "aggregate-powerscreen-maxtrak-1500",
              "name": "MAXTRAK 1500",
              "subcategories": []
            },
            {
              "id": "aggregate-powerscreen-5036",
              "name": "5036",
              "subcategories": []
            },
            {
              "id": "aggregate-powerscreen-7436",
              "name": "7436",
              "subcategories": []
            },
            {
              "id": "aggregate-powerscreen-8036",
              "name": "8036",
              "subcategories": []
            },
            {
              "id": "aggregate-powerscreen-chieftan",
              "name": "CHIEFTAN",
              "subcategories": []
            },
            {
              "id": "aggregate-powerscreen-chieftan-10x5",
              "name": "CHIEFTAN 10X5",
              "subcategories": []
            },
            {
              "id": "aggregate-powerscreen-chieftan-400",
              "name": "CHIEFTAN 400",
              "subcategories": []
            },
            {
              "id": "aggregate-powerscreen-chieftan-600",
              "name": "CHIEFTAN 600",
              "subcategories": []
            },
            {
              "id": "aggregate-powerscreen-chieftan-1200",
              "name": "CHIEFTAN 1200",
              "subcategories": []
            },
            {
              "id": "aggregate-powerscreen-chieftan-1400",
              "name": "CHIEFTAN 1400",
              "subcategories": []
            },
            {
              "id": "aggregate-powerscreen-chieftan-1400t",
              "name": "CHIEFTAN 1400T",
              "subcategories": []
            },
            {
              "id": "aggregate-powerscreen-chieftan-1500",
              "name": "CHIEFTAN 1500",
              "subcategories": []
            },
            {
              "id": "aggregate-powerscreen-chieftan-1700",
              "name": "CHIEFTAN 1700",
              "subcategories": []
            },
            {
              "id": "aggregate-powerscreen-chieftan-1700x",
              "name": "CHIEFTAN 1700X",
              "subcategories": []
            },
            {
              "id": "aggregate-powerscreen-chieftan-1800",
              "name": "CHIEFTAN 1800",
              "subcategories": []
            },
            {
              "id": "aggregate-powerscreen-chieftan-2100",
              "name": "CHIEFTAN 2100",
              "subcategories": []
            },
            {
              "id": "aggregate-powerscreen-chieftan-2100x",
              "name": "CHIEFTAN 2100X",
              "subcategories": []
            },
            {
              "id": "aggregate-powerscreen-chieftan-2200",
              "name": "CHIEFTAN 2200",
              "subcategories": []
            },
            {
              "id": "aggregate-powerscreen-chieftan-2200-3-deck",
              "name": "CHIEFTAN 2200 3 DECK",
              "subcategories": []
            },
            {
              "id": "aggregate-powerscreen-chieftan-4516",
              "name": "CHIEFTAN 4516",
              "subcategories": []
            },
            {
              "id": "aggregate-powerscreen-commander",
              "name": "COMMANDER",
              "subcategories": []
            },
            {
              "id": "aggregate-powerscreen-commander-408",
              "name": "COMMANDER 408",
              "subcategories": []
            },
            {
              "id": "aggregate-powerscreen-commander-510",
              "name": "COMMANDER 510",
              "subcategories": []
            },
            {
              "id": "aggregate-powerscreen-ct65",
              "name": "CT65",
              "subcategories": []
            },
            {
              "id": "aggregate-powerscreen-ct75",
              "name": "CT75",
              "subcategories": []
            },
            {
              "id": "aggregate-powerscreen-ct80",
              "name": "CT80",
              "subcategories": []
            },
            {
              "id": "aggregate-powerscreen-ct100",
              "name": "CT100",
              "subcategories": []
            },
            {
              "id": "aggregate-powerscreen-ct140",
              "name": "CT140",
              "subcategories": []
            },
            {
              "id": "aggregate-powerscreen-fines-master-120",
              "name": "FINES MASTER 120",
              "subcategories": []
            },
            {
              "id": "aggregate-powerscreen-gladiator-h6203",
              "name": "GLADIATOR H6203",
              "subcategories": []
            },
            {
              "id": "aggregate-powerscreen-gladiator-h8203",
              "name": "GLADIATOR H8203",
              "subcategories": []
            },
            {
              "id": "aggregate-powerscreen-gladiator-mt1150",
              "name": "GLADIATOR MT1150",
              "subcategories": []
            },
            {
              "id": "aggregate-powerscreen-gladiator-mt1150sr",
              "name": "GLADIATOR MT1150SR",
              "subcategories": []
            },
            {
              "id": "aggregate-powerscreen-gladiator-1300",
              "name": "GLADIATOR 1300",
              "subcategories": []
            },
            {
              "id": "aggregate-powerscreen-gladiator-pt400",
              "name": "GLADIATOR PT400",
              "subcategories": []
            },
            {
              "id": "aggregate-powerscreen-gladiator-pt450",
              "name": "GLADIATOR PT450",
              "subcategories": []
            },
            {
              "id": "aggregate-powerscreen-gladiator-pt600",
              "name": "GLADIATOR PT600",
              "subcategories": []
            },
            {
              "id": "aggregate-powerscreen-gladiator-tp320sr",
              "name": "GLADIATOR TP320SR",
              "subcategories": []
            },
            {
              "id": "aggregate-powerscreen-h6203",
              "name": "H6203",
              "subcategories": []
            },
            {
              "id": "aggregate-powerscreen-h6203r",
              "name": "H6203R",
              "subcategories": []
            },
            {
              "id": "aggregate-powerscreen-hl75",
              "name": "HL75",
              "subcategories": []
            },
            {
              "id": "aggregate-powerscreen-ll75",
              "name": "LL75",
              "subcategories": []
            },
            {
              "id": "aggregate-powerscreen-mark-ii",
              "name": "MARK II",
              "subcategories": []
            },
            {
              "id": "aggregate-powerscreen-mark-iii",
              "name": "MARK III",
              "subcategories": []
            },
            {
              "id": "aggregate-powerscreen-metrotrak",
              "name": "METROTRAK",
              "subcategories": []
            },
            {
              "id": "aggregate-powerscreen-metrotrak-ha",
              "name": "METROTRAK HA",
              "subcategories": []
            },
            {
              "id": "aggregate-powerscreen-mk-i",
              "name": "MK I",
              "subcategories": []
            },
            {
              "id": "aggregate-powerscreen-mk-ii",
              "name": "MK II",
              "subcategories": []
            },
            {
              "id": "aggregate-powerscreen-phoenix",
              "name": "PHOENIX",
              "subcategories": []
            },
            {
              "id": "aggregate-powerscreen-phoenix-1600",
              "name": "PHOENIX 1600",
              "subcategories": []
            },
            {
              "id": "aggregate-powerscreen-phoenix-2100",
              "name": "PHOENIX 2100",
              "subcategories": []
            },
            {
              "id": "aggregate-powerscreen-phoenix-3300",
              "name": "PHOENIX 3300",
              "subcategories": []
            },
            {
              "id": "aggregate-powerscreen-powergrid",
              "name": "POWERGRID",
              "subcategories": []
            },
            {
              "id": "aggregate-powerscreen-powergrid-800",
              "name": "POWERGRID 800",
              "subcategories": []
            },
            {
              "id": "aggregate-powerscreen-powergrid-1200",
              "name": "POWERGRID 1200",
              "subcategories": []
            },
            {
              "id": "aggregate-powerscreen-powerscrub",
              "name": "POWERSCRUB",
              "subcategories": []
            },
            {
              "id": "aggregate-powerscreen-powerscrub-120r",
              "name": "POWERSCRUB 120R",
              "subcategories": []
            },
            {
              "id": "aggregate-powerscreen-powertrack",
              "name": "POWERTRACK",
              "subcategories": []
            },
            {
              "id": "aggregate-powerscreen-powertrack-800",
              "name": "POWERTRACK 800",
              "subcategories": []
            },
            {
              "id": "aggregate-powerscreen-powertrak-750",
              "name": "POWERTRAK 750",
              "subcategories": []
            },
            {
              "id": "aggregate-powerscreen-premeirtrak-300",
              "name": "PREMEIRTRAK 300",
              "subcategories": []
            },
            {
              "id": "aggregate-powerscreen-premiertrak-330",
              "name": "PREMIERTRAK 330",
              "subcategories": []
            },
            {
              "id": "aggregate-powerscreen-premiertrak-400",
              "name": "PREMIERTRAK 400",
              "subcategories": []
            },
            {
              "id": "aggregate-powerscreen-premiertrak-400x",
              "name": "PREMIERTRAK 400X",
              "subcategories": []
            },
            {
              "id": "aggregate-powerscreen-premiertrak-420e",
              "name": "PREMIERTRAK 420E",
              "subcategories": []
            },
            {
              "id": "aggregate-powerscreen-preimiertrak-450",
              "name": "PREIMIERTRAK 450",
              "subcategories": []
            },
            {
              "id": "aggregate-powerscreen-premiertrak-600",
              "name": "PREMIERTRAK 600",
              "subcategories": []
            },
            {
              "id": "aggregate-powerscreen-premeirtrak-600-lf",
              "name": "PREMEIRTRAK 600 LF",
              "subcategories": []
            },
            {
              "id": "aggregate-powerscreen-premiertrak-600e",
              "name": "PREMIERTRAK 600E",
              "subcategories": []
            },
            {
              "id": "aggregate-powerscreen-premiertrak-760",
              "name": "PREMIERTRAK 760",
              "subcategories": []
            },
            {
              "id": "aggregate-powerscreen-premiertrak-1180",
              "name": "PREMIERTRAK 1180",
              "subcategories": []
            },
            {
              "id": "aggregate-powerscreen-preimiertrak-r300",
              "name": "PREIMIERTRAK R300",
              "subcategories": []
            },
            {
              "id": "aggregate-powerscreen-premiertrak-r400",
              "name": "PREMIERTRAK R400",
              "subcategories": []
            },
            {
              "id": "aggregate-powerscreen-premiertrak-r400x",
              "name": "PREMIERTRAK R400X",
              "subcategories": []
            },
            {
              "id": "aggregate-powerscreen-premmiertrak-r450",
              "name": "PREMMIERTRAK R450",
              "subcategories": []
            },
            {
              "id": "aggregate-powerscreen-premiertrak-450",
              "name": "PREMIERTRAK 450",
              "subcategories": []
            },
            {
              "id": "aggregate-powerscreen-standard-chief",
              "name": "STANDARD CHIEF",
              "subcategories": []
            },
            {
              "id": "aggregate-powerscreen-sw70",
              "name": "SW70",
              "subcategories": []
            },
            {
              "id": "aggregate-powerscreen-titan-600",
              "name": "TITAN 600",
              "subcategories": []
            },
            {
              "id": "aggregate-powerscreen-titan-1300",
              "name": "TITAN 1300",
              "subcategories": []
            },
            {
              "id": "aggregate-powerscreen-titan-1800",
              "name": "TITAN 1800",
              "subcategories": []
            },
            {
              "id": "aggregate-powerscreen-titan-2300",
              "name": "TITAN 2300",
              "subcategories": []
            },
            {
              "id": "aggregate-powerscreen-trakpactor-230",
              "name": "TRAKPACTOR 230",
              "subcategories": []
            },
            {
              "id": "aggregate-powerscreen-trakpactor-230sr",
              "name": "TRAKPACTOR 230SR",
              "subcategories": []
            },
            {
              "id": "aggregate-powerscreen-trackpactor-260",
              "name": "TRACKPACTOR 260",
              "subcategories": []
            },
            {
              "id": "aggregate-powerscreen-trackpactor-260sr",
              "name": "TRACKPACTOR 260SR",
              "subcategories": []
            },
            {
              "id": "aggregate-powerscreen-trackpactor-290",
              "name": "TRACKPACTOR 290",
              "subcategories": []
            },
            {
              "id": "aggregate-powerscreen-trackpactor-320",
              "name": "TRACKPACTOR 320",
              "subcategories": []
            },
            {
              "id": "aggregate-powerscreen-trackpactor-320sr",
              "name": "TRACKPACTOR 320SR",
              "subcategories": []
            },
            {
              "id": "aggregate-powerscreen-trackpactor-480",
              "name": "TRACKPACTOR 480",
              "subcategories": []
            },
            {
              "id": "aggregate-powerscreen-trakpactor-480sr",
              "name": "TRAKPACTOR 480SR",
              "subcategories": []
            },
            {
              "id": "aggregate-powerscreen-trakpactor-500",
              "name": "TRAKPACTOR 500",
              "subcategories": []
            },
            {
              "id": "aggregate-powerscreen-trakpactor-500sr",
              "name": "TRAKPACTOR 500SR",
              "subcategories": []
            },
            {
              "id": "aggregate-powerscreen-trakpactor-550",
              "name": "TRAKPACTOR 550",
              "subcategories": []
            },
            {
              "id": "aggregate-powerscreen-trakpactor-550sr",
              "name": "TRAKPACTOR 550SR",
              "subcategories": []
            },
            {
              "id": "aggregate-powerscreen-turbo-chieftan",
              "name": "TURBO CHIEFTAN",
              "subcategories": []
            },
            {
              "id": "aggregate-powerscreen-turbo-chieftan-1200",
              "name": "TURBO CHIEFTAN 1200",
              "subcategories": []
            },
            {
              "id": "aggregate-powerscreen-turbo-chieftan-1400",
              "name": "TURBO CHIEFTAN 1400",
              "subcategories": []
            },
            {
              "id": "aggregate-powerscreen-warrior-600",
              "name": "WARRIOR 600",
              "subcategories": []
            },
            {
              "id": "aggregate-powerscreen-warrior-800",
              "name": "WARRIOR 800",
              "subcategories": []
            },
            {
              "id": "aggregate-powerscreen-warrior-1400",
              "name": "WARRIOR 1400",
              "subcategories": []
            },
            {
              "id": "aggregate-powerscreen-warrior-1400x",
              "name": "WARRIOR 1400X",
              "subcategories": []
            },
            {
              "id": "aggregate-powerscreen-warrior-1800",
              "name": "WARRIOR 1800",
              "subcategories": []
            },
            {
              "id": "aggregate-powerscreen-warrior-1800x",
              "name": "WARRIOR 1800X",
              "subcategories": []
            },
            {
              "id": "aggregate-powerscreen-warrior-2100",
              "name": "WARRIOR 2100",
              "subcategories": []
            },
            {
              "id": "aggregate-powerscreen-warrior-2100-spaleck",
              "name": "WARRIOR 2100 SPALECK",
              "subcategories": []
            },
            {
              "id": "aggregate-powerscreen-warrior-2400",
              "name": "WARRIOR 2400",
              "subcategories": []
            },
            {
              "id": "aggregate-powerscreen-xa400",
              "name": "XA400",
              "subcategories": []
            },
            {
              "id": "aggregate-powerscreen-xh320",
              "name": "XH320",
              "subcategories": []
            },
            {
              "id": "aggregate-powerscreen-xh500",
              "name": "XH500",
              "subcategories": []
            },
            {
              "id": "aggregate-powerscreen-xr400",
              "name": "XR400",
              "subcategories": []
            },
            {
              "id": "aggregate-powerscreen-xv350",
              "name": "XV350",
              "subcategories": []
            },
            {
              "id": "aggregate-powerscreen-other",
              "name": "OTHER",
              "subcategories": []
            }
          ]
        },
        {
          "id": "aggregate-mccloskey",
          "name": "Mccloskey",
          "subcategories": [
            {
              "id": "aggregate-mccloskey-5x16",
              "name": "5X16",
              "subcategories": []
            },
            {
              "id": "aggregate-mccloskey-6x20",
              "name": "6X20",
              "subcategories": []
            },
            {
              "id": "aggregate-mccloskey-30x60",
              "name": "30X60",
              "subcategories": []
            },
            {
              "id": "aggregate-mccloskey-30x80",
              "name": "30X80",
              "subcategories": []
            },
            {
              "id": "aggregate-mccloskey-36x80",
              "name": "36X80",
              "subcategories": []
            },
            {
              "id": "aggregate-mccloskey-36x100",
              "name": "36X100",
              "subcategories": []
            },
            {
              "id": "aggregate-mccloskey-42x35",
              "name": "42X35",
              "subcategories": []
            },
            {
              "id": "aggregate-mccloskey-123",
              "name": "123",
              "subcategories": []
            },
            {
              "id": "aggregate-mccloskey-302",
              "name": "302",
              "subcategories": []
            },
            {
              "id": "aggregate-mccloskey-512",
              "name": "512",
              "subcategories": []
            },
            {
              "id": "aggregate-mccloskey-514",
              "name": "514",
              "subcategories": []
            },
            {
              "id": "aggregate-mccloskey-516",
              "name": "516",
              "subcategories": []
            },
            {
              "id": "aggregate-mccloskey-616",
              "name": "616",
              "subcategories": []
            },
            {
              "id": "aggregate-mccloskey-621",
              "name": "621",
              "subcategories": []
            },
            {
              "id": "aggregate-mccloskey-628",
              "name": "628",
              "subcategories": []
            },
            {
              "id": "aggregate-mccloskey-728",
              "name": "728",
              "subcategories": []
            },
            {
              "id": "aggregate-mccloskey-733",
              "name": "733",
              "subcategories": []
            },
            {
              "id": "aggregate-mccloskey-4800",
              "name": "4800",
              "subcategories": []
            },
            {
              "id": "aggregate-mccloskey-c2",
              "name": "C2",
              "subcategories": []
            },
            {
              "id": "aggregate-mccloskey-c3",
              "name": "C3",
              "subcategories": []
            },
            {
              "id": "aggregate-mccloskey-c4",
              "name": "C4",
              "subcategories": []
            },
            {
              "id": "aggregate-mccloskey-c38",
              "name": "C38",
              "subcategories": []
            },
            {
              "id": "aggregate-mccloskey-c44",
              "name": "C44",
              "subcategories": []
            },
            {
              "id": "aggregate-mccloskey-c52",
              "name": "C52",
              "subcategories": []
            },
            {
              "id": "aggregate-mccloskey-csp200",
              "name": "CSP200",
              "subcategories": []
            },
            {
              "id": "aggregate-mccloskey-es250",
              "name": "ES250",
              "subcategories": []
            },
            {
              "id": "aggregate-mccloskey-et-521r",
              "name": "ET-521R",
              "subcategories": []
            },
            {
              "id": "aggregate-mccloskey-et-620",
              "name": "ET-620",
              "subcategories": []
            },
            {
              "id": "aggregate-mccloskey-h360",
              "name": "H360",
              "subcategories": []
            },
            {
              "id": "aggregate-mccloskey-i3c",
              "name": "I3C",
              "subcategories": []
            },
            {
              "id": "aggregate-mccloskey-i34",
              "name": "I34",
              "subcategories": []
            },
            {
              "id": "aggregate-mccloskey-i4",
              "name": "I4",
              "subcategories": []
            },
            {
              "id": "aggregate-mccloskey-i44",
              "name": "I44",
              "subcategories": []
            },
            {
              "id": "aggregate-mccloskey-i54",
              "name": "I54",
              "subcategories": []
            },
            {
              "id": "aggregate-mccloskey-j3cr",
              "name": "J3CR",
              "subcategories": []
            },
            {
              "id": "aggregate-mccloskey-j4",
              "name": "J4",
              "subcategories": []
            },
            {
              "id": "aggregate-mccloskey-j3cr",
              "name": "J3CR",
              "subcategories": []
            },
            {
              "id": "aggregate-mccloskey-j6",
              "name": "J6",
              "subcategories": []
            },
            {
              "id": "aggregate-mccloskey-j40",
              "name": "J40",
              "subcategories": []
            },
            {
              "id": "aggregate-mccloskey-j45",
              "name": "J45",
              "subcategories": []
            },
            {
              "id": "aggregate-mccloskey-j50",
              "name": "J50",
              "subcategories": []
            },
            {
              "id": "aggregate-mccloskey-kompaq",
              "name": "KOMPAQ",
              "subcategories": []
            },
            {
              "id": "aggregate-mccloskey-mcb",
              "name": "MCB",
              "subcategories": []
            },
            {
              "id": "aggregate-mccloskey-mdw48",
              "name": "MDW48",
              "subcategories": []
            },
            {
              "id": "aggregate-mccloskey-mini-sizer",
              "name": "MINI SIZER",
              "subcategories": []
            },
            {
              "id": "aggregate-mccloskey-mws3625t",
              "name": "MWS3625T",
              "subcategories": []
            },
            {
              "id": "aggregate-mccloskey-r70",
              "name": "R70",
              "subcategories": []
            },
            {
              "id": "aggregate-mccloskey-r105",
              "name": "R105",
              "subcategories": []
            },
            {
              "id": "aggregate-mccloskey-r155",
              "name": "R155",
              "subcategories": []
            },
            {
              "id": "aggregate-mccloskey-r230",
              "name": "R230",
              "subcategories": []
            },
            {
              "id": "aggregate-mccloskey-rf80",
              "name": "RF80",
              "subcategories": []
            },
            {
              "id": "aggregate-mccloskey-s110",
              "name": "S110",
              "subcategories": []
            },
            {
              "id": "aggregate-mccloskey-s130",
              "name": "S130",
              "subcategories": []
            },
            {
              "id": "aggregate-mccloskey-s1302",
              "name": "S1302",
              "subcategories": []
            },
            {
              "id": "aggregate-mccloskey-s1303",
              "name": "S1303",
              "subcategories": []
            },
            {
              "id": "aggregate-mccloskey-s190",
              "name": "S190",
              "subcategories": []
            },
            {
              "id": "aggregate-mccloskey-s250",
              "name": "S250",
              "subcategories": []
            },
            {
              "id": "aggregate-mccloskey-s275",
              "name": "S275",
              "subcategories": []
            },
            {
              "id": "aggregate-mccloskey-sdx95",
              "name": "SDX95",
              "subcategories": []
            },
            {
              "id": "aggregate-mccloskey-sdx100",
              "name": "SDX100",
              "subcategories": []
            },
            {
              "id": "aggregate-mccloskey-sdx130",
              "name": "SDX130",
              "subcategories": []
            },
            {
              "id": "aggregate-mccloskey-st80",
              "name": "ST80",
              "subcategories": []
            },
            {
              "id": "aggregate-mccloskey-st100",
              "name": "ST100",
              "subcategories": []
            },
            {
              "id": "aggregate-mccloskey-ts4065",
              "name": "TS4065",
              "subcategories": []
            },
            {
              "id": "aggregate-mccloskey-ts4080",
              "name": "TS4080",
              "subcategories": []
            },
            {
              "id": "aggregate-mccloskey-sf80",
              "name": "SF80",
              "subcategories": []
            },
            {
              "id": "aggregate-mccloskey-uf1200",
              "name": "UF1200",
              "subcategories": []
            },
            {
              "id": "aggregate-mccloskey-v80",
              "name": "V80",
              "subcategories": []
            },
            {
              "id": "aggregate-mccloskey-ws3250",
              "name": "WS3250",
              "subcategories": []
            },
            {
              "id": "aggregate-mccloskey-other",
              "name": "OTHER",
              "subcategories": []
            }
          ]
        },
        {
          "id": "aggregate-metso",
          "name": "Metso",
          "subcategories": [
            {
              "id": "aggregate-metso-6x20",
              "name": "6X20",
              "subcategories": []
            },
            {
              "id": "aggregate-metso-b6150se",
              "name": "B6150SE",
              "subcategories": []
            },
            {
              "id": "aggregate-metso-b7150se",
              "name": "B7150SE",
              "subcategories": []
            },
            {
              "id": "aggregate-metso-b9100se",
              "name": "B9100SE",
              "subcategories": []
            },
            {
              "id": "aggregate-metso-c80",
              "name": "C80",
              "subcategories": []
            },
            {
              "id": "aggregate-metso-c96",
              "name": "C96",
              "subcategories": []
            },
            {
              "id": "aggregate-metso-c100",
              "name": "C100",
              "subcategories": []
            },
            {
              "id": "aggregate-metso-c106",
              "name": "C106",
              "subcategories": []
            },
            {
              "id": "aggregate-metso-c110",
              "name": "C110",
              "subcategories": []
            },
            {
              "id": "aggregate-metso-c120",
              "name": "C120",
              "subcategories": []
            },
            {
              "id": "aggregate-metso-c125",
              "name": "C125",
              "subcategories": []
            },
            {
              "id": "aggregate-metso-c130",
              "name": "C130",
              "subcategories": []
            },
            {
              "id": "aggregate-metso-c160",
              "name": "C160",
              "subcategories": []
            },
            {
              "id": "aggregate-metso-c3054",
              "name": "C3054",
              "subcategories": []
            },
            {
              "id": "aggregate-metso-ct3-25",
              "name": "CT3.25",
              "subcategories": []
            },
            {
              "id": "aggregate-metso-ct85",
              "name": "CT85",
              "subcategories": []
            },
            {
              "id": "aggregate-metso-ct100r",
              "name": "CT100R",
              "subcategories": []
            },
            {
              "id": "aggregate-metso-cv100",
              "name": "CV100",
              "subcategories": []
            },
            {
              "id": "aggregate-metso-cvb2050",
              "name": "CVB2050",
              "subcategories": []
            },
            {
              "id": "aggregate-metso-cw85",
              "name": "CW85",
              "subcategories": []
            },
            {
              "id": "aggregate-metso-cw100",
              "name": "CW100",
              "subcategories": []
            },
            {
              "id": "aggregate-metso-dr24",
              "name": "DR24",
              "subcategories": []
            },
            {
              "id": "aggregate-metso-fs303",
              "name": "FS303",
              "subcategories": []
            },
            {
              "id": "aggregate-metso-gp7",
              "name": "GP7",
              "subcategories": []
            },
            {
              "id": "aggregate-metso-gp11",
              "name": "GP11",
              "subcategories": []
            },
            {
              "id": "aggregate-metso-gp100",
              "name": "GP100",
              "subcategories": []
            },
            {
              "id": "aggregate-metso-gp300",
              "name": "GP300",
              "subcategories": []
            },
            {
              "id": "aggregate-metso-gp300s",
              "name": "GP300S",
              "subcategories": []
            },
            {
              "id": "aggregate-metso-hp3",
              "name": "HP3",
              "subcategories": []
            },
            {
              "id": "aggregate-metso-hp100",
              "name": "HP100",
              "subcategories": []
            },
            {
              "id": "aggregate-metso-hp200",
              "name": "HP200",
              "subcategories": []
            },
            {
              "id": "aggregate-metso-hp300",
              "name": "HP300",
              "subcategories": []
            },
            {
              "id": "aggregate-metso-hp400",
              "name": "HP400",
              "subcategories": []
            },
            {
              "id": "aggregate-metso-hp500",
              "name": "HP500",
              "subcategories": []
            },
            {
              "id": "aggregate-metso-is453",
              "name": "IS453",
              "subcategories": []
            },
            {
              "id": "aggregate-metso-lokotrack-lt106",
              "name": "LOKOTRACK LT106",
              "subcategories": []
            },
            {
              "id": "aggregate-metso-lokotrak-lt220d",
              "name": "LOKOTRAK LT220D",
              "subcategories": []
            },
            {
              "id": "aggregate-metso-lokotrack-lt300gp",
              "name": "LOKOTRACK LT300GP",
              "subcategories": []
            },
            {
              "id": "aggregate-metso-lokotrack-lt300hp",
              "name": "LOKOTRACK LT300HP",
              "subcategories": []
            },
            {
              "id": "aggregate-metso-lokotrak-lt213",
              "name": "LOKOTRAK LT213",
              "subcategories": []
            },
            {
              "id": "aggregate-metso-lokotrack-sw348",
              "name": "LOKOTRACK SW348",
              "subcategories": []
            },
            {
              "id": "aggregate-metso-lokotrack-urban-lt96",
              "name": "LOKOTRACK URBAN LT96",
              "subcategories": []
            },
            {
              "id": "aggregate-metso-lokotrack-urban-lt120",
              "name": "LOKOTRACK URBAN LT120",
              "subcategories": []
            },
            {
              "id": "aggregate-metso-lt96",
              "name": "LT96",
              "subcategories": []
            },
            {
              "id": "aggregate-metso-lt105",
              "name": "LT105",
              "subcategories": []
            },
            {
              "id": "aggregate-metso-lt106",
              "name": "LT106",
              "subcategories": []
            },
            {
              "id": "aggregate-metso-lt110",
              "name": "LT110",
              "subcategories": []
            },
            {
              "id": "aggregate-metso-lt116",
              "name": "LT116",
              "subcategories": []
            },
            {
              "id": "aggregate-metso-lt120",
              "name": "LT120",
              "subcategories": []
            },
            {
              "id": "aggregate-metso-lt125",
              "name": "LT125",
              "subcategories": []
            },
            {
              "id": "aggregate-metso-lt200",
              "name": "LT200",
              "subcategories": []
            },
            {
              "id": "aggregate-metso-lt220",
              "name": "LT220",
              "subcategories": []
            },
            {
              "id": "aggregate-metso-lt300",
              "name": "LT300",
              "subcategories": []
            },
            {
              "id": "aggregate-metso-lt1100",
              "name": "LT1100",
              "subcategories": []
            },
            {
              "id": "aggregate-metso-lt1110",
              "name": "LT1110",
              "subcategories": []
            },
            {
              "id": "aggregate-metso-lt1213",
              "name": "LT1213",
              "subcategories": []
            },
            {
              "id": "aggregate-metso-lt1315",
              "name": "LT1315",
              "subcategories": []
            },
            {
              "id": "aggregate-metso-lt1415",
              "name": "LT1415",
              "subcategories": []
            },
            {
              "id": "aggregate-metso-lt3054",
              "name": "LT3054",
              "subcategories": []
            },
            {
              "id": "aggregate-metso-lt7150",
              "name": "LT7150",
              "subcategories": []
            },
            {
              "id": "aggregate-metso-ltst4-10",
              "name": "LTST4.10",
              "subcategories": []
            },
            {
              "id": "aggregate-metso-m-j6000m",
              "name": "M&J6000M",
              "subcategories": []
            },
            {
              "id": "aggregate-metso-nordberg-hp",
              "name": "NORDBERG HP",
              "subcategories": []
            },
            {
              "id": "aggregate-metso-nordberg-hp350e",
              "name": "NORDBERG HP350E",
              "subcategories": []
            },
            {
              "id": "aggregate-metso-nordberg-hp400",
              "name": "NORDBERG HP400",
              "subcategories": []
            },
            {
              "id": "aggregate-metso-nordberg-lt105",
              "name": "NORDBERG LT105",
              "subcategories": []
            },
            {
              "id": "aggregate-metso-nordtrack-ct24",
              "name": "NORDTRACK CT24",
              "subcategories": []
            },
            {
              "id": "aggregate-metso-nordtrack-ct85",
              "name": "NORDTRACK CT85",
              "subcategories": []
            },
            {
              "id": "aggregate-metso-nordtrack-ct100",
              "name": "NORDTRACK CT100",
              "subcategories": []
            },
            {
              "id": "aggregate-metso-nordtrack-i908",
              "name": "NORDTRACK I908",
              "subcategories": []
            },
            {
              "id": "aggregate-metso-nordtrack-j90",
              "name": "NORDTRACK J90",
              "subcategories": []
            },
            {
              "id": "aggregate-metso-nordtrack-j127",
              "name": "NORDTRACK J127",
              "subcategories": []
            },
            {
              "id": "aggregate-metso-nordtrack-s2-5",
              "name": "NORDTRACK S2.5",
              "subcategories": []
            },
            {
              "id": "aggregate-metso-nordtrack-s3-7",
              "name": "NORDTRACK S3.7",
              "subcategories": []
            },
            {
              "id": "aggregate-metso-nordtrack-s3-9",
              "name": "NORDTRACK S3.9",
              "subcategories": []
            },
            {
              "id": "aggregate-metso-nordtrack-s4-7",
              "name": "NORDTRACK S4.7",
              "subcategories": []
            },
            {
              "id": "aggregate-metso-nordtrack-s4-9",
              "name": "NORDTRACK S4.9",
              "subcategories": []
            },
            {
              "id": "aggregate-metso-nordtrack-s4-12",
              "name": "NORDTRACK S4.12",
              "subcategories": []
            },
            {
              "id": "aggregate-metso-nordtrack-i1011",
              "name": "NORDTRACK I1011",
              "subcategories": []
            },
            {
              "id": "aggregate-metso-np1110",
              "name": "NP1110",
              "subcategories": []
            },
            {
              "id": "aggregate-metso-np1213",
              "name": "NP1213",
              "subcategories": []
            },
            {
              "id": "aggregate-metso-np1315",
              "name": "NP1315",
              "subcategories": []
            },
            {
              "id": "aggregate-metso-np1415",
              "name": "NP1415",
              "subcategories": []
            },
            {
              "id": "aggregate-metso-np1520",
              "name": "NP1520",
              "subcategories": []
            },
            {
              "id": "aggregate-metso-np1620",
              "name": "NP1620",
              "subcategories": []
            },
            {
              "id": "aggregate-metso-nw80",
              "name": "NW80",
              "subcategories": []
            },
            {
              "id": "aggregate-metso-rcs5",
              "name": "RCS5",
              "subcategories": []
            },
            {
              "id": "aggregate-metso-st2-3",
              "name": "ST2.3",
              "subcategories": []
            },
            {
              "id": "aggregate-metso-st2-4",
              "name": "ST2.4",
              "subcategories": []
            },
            {
              "id": "aggregate-metso-st2-8",
              "name": "ST2.8",
              "subcategories": []
            },
            {
              "id": "aggregate-metso-st2-8e",
              "name": "ST2.8E",
              "subcategories": []
            },
            {
              "id": "aggregate-metso-st3-5",
              "name": "ST3.5",
              "subcategories": []
            },
            {
              "id": "aggregate-metso-st3-8",
              "name": "ST3.8",
              "subcategories": []
            },
            {
              "id": "aggregate-metso-st4-8",
              "name": "ST4.8",
              "subcategories": []
            },
            {
              "id": "aggregate-metso-st4-10",
              "name": "ST4.10",
              "subcategories": []
            },
            {
              "id": "aggregate-metso-st171",
              "name": "ST171",
              "subcategories": []
            },
            {
              "id": "aggregate-metso-st272",
              "name": "ST272",
              "subcategories": []
            },
            {
              "id": "aggregate-metso-st352",
              "name": "ST352",
              "subcategories": []
            },
            {
              "id": "aggregate-metso-st356",
              "name": "ST356",
              "subcategories": []
            },
            {
              "id": "aggregate-metso-st620",
              "name": "ST620",
              "subcategories": []
            },
            {
              "id": "aggregate-metso-other",
              "name": "OTHER",
              "subcategories": []
            }
          ]
        },
        {
          "id": "aggregate-kinglink",
          "name": "Kinglink",
          "subcategories": []
        },
        {
          "id": "aggregate-kleeman",
          "name": "Kleeman",
          "subcategories": [
            {
              "id": "aggregate-kleeman-kt65",
              "name": "KT65",
              "subcategories": []
            },
            {
              "id": "aggregate-kleeman-kt80",
              "name": "KT80",
              "subcategories": []
            },
            {
              "id": "aggregate-kleeman-kts130",
              "name": "KTS130",
              "subcategories": []
            },
            {
              "id": "aggregate-kleeman-mbt20i",
              "name": "MBT20I",
              "subcategories": []
            },
            {
              "id": "aggregate-kleeman-mbt24i",
              "name": "MBT24I",
              "subcategories": []
            },
            {
              "id": "aggregate-kleeman-mc100",
              "name": "MC100",
              "subcategories": []
            },
            {
              "id": "aggregate-kleeman-mc110",
              "name": "MC110",
              "subcategories": []
            },
            {
              "id": "aggregate-kleeman-mc120",
              "name": "MC120",
              "subcategories": []
            },
            {
              "id": "aggregate-kleeman-mc125",
              "name": "MC125",
              "subcategories": []
            },
            {
              "id": "aggregate-kleeman-mc09",
              "name": "MC09",
              "subcategories": []
            },
            {
              "id": "aggregate-kleeman-mc011",
              "name": "MC011",
              "subcategories": []
            },
            {
              "id": "aggregate-kleeman-mc090",
              "name": "MC090",
              "subcategories": []
            },
            {
              "id": "aggregate-kleeman-mc0110",
              "name": "MC0110",
              "subcategories": []
            },
            {
              "id": "aggregate-kleeman-mobirex-mr100i-neo",
              "name": "MOBIREX MR100I NEO",
              "subcategories": []
            },
            {
              "id": "aggregate-kleeman-mobirex-mr100zs",
              "name": "MOBIREX MR100ZS",
              "subcategories": []
            },
            {
              "id": "aggregate-kleeman-mobirex-mr110i-evo2",
              "name": "MOBIREX MR110I EVO2",
              "subcategories": []
            },
            {
              "id": "aggregate-kleeman-mobirex-mr110z-si",
              "name": "MOBIREX MR110Z SI",
              "subcategories": []
            },
            {
              "id": "aggregate-kleeman-mobirex-mr130i-evo2",
              "name": "MOBIREX MR130I EVO2",
              "subcategories": []
            },
            {
              "id": "aggregate-kleeman-mobirex-mr130z",
              "name": "MOBIREX MR130Z",
              "subcategories": []
            },
            {
              "id": "aggregate-kleeman-mobirex-mrt130z-evo",
              "name": "MOBIREX MRT130Z EVO",
              "subcategories": []
            },
            {
              "id": "aggregate-kleeman-mobirex-mr130z-evo2",
              "name": "MOBIREX MR130Z EVO2",
              "subcategories": []
            },
            {
              "id": "aggregate-kleeman-mobirex-mr130zi-evo2",
              "name": "MOBIREX MR130ZI EVO2",
              "subcategories": []
            },
            {
              "id": "aggregate-kleeman-mobirex-mr130zs-evo2",
              "name": "MOBIREX MR130ZS EVO2",
              "subcategories": []
            },
            {
              "id": "aggregate-kleeman-mobirex-mr130zis-evo2",
              "name": "MOBIREX MR130ZIS EVO2",
              "subcategories": []
            },
            {
              "id": "aggregate-kleeman-mr110",
              "name": "MR110",
              "subcategories": []
            },
            {
              "id": "aggregate-kleeman-mr130",
              "name": "MR130",
              "subcategories": []
            },
            {
              "id": "aggregate-kleeman-mr122",
              "name": "MR122",
              "subcategories": []
            },
            {
              "id": "aggregate-kleeman-ms13",
              "name": "MS13",
              "subcategories": []
            },
            {
              "id": "aggregate-kleeman-ms15",
              "name": "MS15",
              "subcategories": []
            },
            {
              "id": "aggregate-kleeman-ms16",
              "name": "MS16",
              "subcategories": []
            },
            {
              "id": "aggregate-kleeman-ms19",
              "name": "MS19",
              "subcategories": []
            },
            {
              "id": "aggregate-kleeman-ms21",
              "name": "MS21",
              "subcategories": []
            },
            {
              "id": "aggregate-kleeman-ms702",
              "name": "MS702",
              "subcategories": []
            },
            {
              "id": "aggregate-kleeman-ms703",
              "name": "MS703",
              "subcategories": []
            },
            {
              "id": "aggregate-kleeman-ms953",
              "name": "MS953",
              "subcategories": []
            },
            {
              "id": "aggregate-kleeman-msc-702i",
              "name": "MSC 702I",
              "subcategories": []
            },
            {
              "id": "aggregate-kleeman-msc-703i",
              "name": "MSC 703I",
              "subcategories": []
            },
            {
              "id": "aggregate-kleeman-msc-952i",
              "name": "MSC 952I",
              "subcategories": []
            },
            {
              "id": "aggregate-kleeman-msc-953i",
              "name": "MSC 953I",
              "subcategories": []
            },
            {
              "id": "aggregate-kleeman-mss-502i-evo",
              "name": "MSS 502I EVO",
              "subcategories": []
            },
            {
              "id": "aggregate-kleeman-mss-802i-evo",
              "name": "MSS 802I EVO",
              "subcategories": []
            },
            {
              "id": "aggregate-kleeman-other",
              "name": "OTHER",
              "subcategories": []
            }
          ]
        },
        {
          "id": "aggregate-sandvik",
          "name": "Sandvik",
          "subcategories": [
            {
              "id": "aggregate-sandvik-c12",
              "name": "C12",
              "subcategories": []
            },
            {
              "id": "aggregate-sandvik-ch420",
              "name": "CH420",
              "subcategories": []
            },
            {
              "id": "aggregate-sandvik-ch430",
              "name": "CH430",
              "subcategories": []
            },
            {
              "id": "aggregate-sandvik-ch440",
              "name": "CH440",
              "subcategories": []
            },
            {
              "id": "aggregate-sandvik-ch660",
              "name": "CH660",
              "subcategories": []
            },
            {
              "id": "aggregate-sandvik-ch870",
              "name": "CH870",
              "subcategories": []
            },
            {
              "id": "aggregate-sandvik-cj412",
              "name": "CJ412",
              "subcategories": []
            },
            {
              "id": "aggregate-sandvik-cj612",
              "name": "CJ612",
              "subcategories": []
            },
            {
              "id": "aggregate-sandvik-cj613",
              "name": "CJ613",
              "subcategories": []
            },
            {
              "id": "aggregate-sandvik-cj615",
              "name": "CJ615",
              "subcategories": []
            },
            {
              "id": "aggregate-sandvik-cm4800",
              "name": "CM4800",
              "subcategories": []
            },
            {
              "id": "aggregate-sandvik-cs440",
              "name": "CS440",
              "subcategories": []
            },
            {
              "id": "aggregate-sandvik-cv117",
              "name": "CV117",
              "subcategories": []
            },
            {
              "id": "aggregate-sandvik-cv216",
              "name": "CV216",
              "subcategories": []
            },
            {
              "id": "aggregate-sandvik-cv217",
              "name": "CV217",
              "subcategories": []
            },
            {
              "id": "aggregate-sandvik-h3800",
              "name": "H3800",
              "subcategories": []
            },
            {
              "id": "aggregate-sandvik-h4800",
              "name": "H4800",
              "subcategories": []
            },
            {
              "id": "aggregate-sandvik-jm1208",
              "name": "JM1208",
              "subcategories": []
            },
            {
              "id": "aggregate-sandvik-p300",
              "name": "P300",
              "subcategories": []
            },
            {
              "id": "aggregate-sandvik-p500",
              "name": "P500",
              "subcategories": []
            },
            {
              "id": "aggregate-sandvik-qa331",
              "name": "QA331",
              "subcategories": []
            },
            {
              "id": "aggregate-sandvik-qa335",
              "name": "QA335",
              "subcategories": []
            },
            {
              "id": "aggregate-sandvik-qa340",
              "name": "QA340",
              "subcategories": []
            },
            {
              "id": "aggregate-sandvik-qa440",
              "name": "QA440",
              "subcategories": []
            },
            {
              "id": "aggregate-sandvik-qa441",
              "name": "QA441",
              "subcategories": []
            },
            {
              "id": "aggregate-sandvik-qa442",
              "name": "QA442",
              "subcategories": []
            },
            {
              "id": "aggregate-sandvik-qa451",
              "name": "QA451",
              "subcategories": []
            },
            {
              "id": "aggregate-sandvik-qa452",
              "name": "QA452",
              "subcategories": []
            },
            {
              "id": "aggregate-sandvik-qe140",
              "name": "QE140",
              "subcategories": []
            },
            {
              "id": "aggregate-sandvik-qe141",
              "name": "QE141",
              "subcategories": []
            },
            {
              "id": "aggregate-sandvik-qe241",
              "name": "QE241",
              "subcategories": []
            },
            {
              "id": "aggregate-sandvik-qe340",
              "name": "QE340",
              "subcategories": []
            },
            {
              "id": "aggregate-sandvik-qe341",
              "name": "QE341",
              "subcategories": []
            },
            {
              "id": "aggregate-sandvik-qe342",
              "name": "QE342",
              "subcategories": []
            },
            {
              "id": "aggregate-sandvik-qe440",
              "name": "QE440",
              "subcategories": []
            },
            {
              "id": "aggregate-sandvik-qe442",
              "name": "QE442",
              "subcategories": []
            },
            {
              "id": "aggregate-sandvik-qh330",
              "name": "QH330",
              "subcategories": []
            },
            {
              "id": "aggregate-sandvik-qh331",
              "name": "QH331",
              "subcategories": []
            },
            {
              "id": "aggregate-sandvik-qh441",
              "name": "QH441",
              "subcategories": []
            },
            {
              "id": "aggregate-sandvik-qi240",
              "name": "QI240",
              "subcategories": []
            },
            {
              "id": "aggregate-sandvik-qi340",
              "name": "QI340",
              "subcategories": []
            },
            {
              "id": "aggregate-sandvik-qi341",
              "name": "QI341",
              "subcategories": []
            },
            {
              "id": "aggregate-sandvik-qi353",
              "name": "QI353",
              "subcategories": []
            },
            {
              "id": "aggregate-sandvik-qi441",
              "name": "QI441",
              "subcategories": []
            },
            {
              "id": "aggregate-sandvik-qi442",
              "name": "QI442",
              "subcategories": []
            },
            {
              "id": "aggregate-sandvik-qj240",
              "name": "QJ240",
              "subcategories": []
            },
            {
              "id": "aggregate-sandvik-qj241",
              "name": "QJ241",
              "subcategories": []
            },
            {
              "id": "aggregate-sandvik-qj330",
              "name": "QJ330",
              "subcategories": []
            },
            {
              "id": "aggregate-sandvik-qj331",
              "name": "QJ331",
              "subcategories": []
            },
            {
              "id": "aggregate-sandvik-qj340",
              "name": "QJ340",
              "subcategories": []
            },
            {
              "id": "aggregate-sandvik-qj341",
              "name": "QJ341",
              "subcategories": []
            },
            {
              "id": "aggregate-sandvik-qs331",
              "name": "QS331",
              "subcategories": []
            },
            {
              "id": "aggregate-sandvik-qs332",
              "name": "QS332",
              "subcategories": []
            },
            {
              "id": "aggregate-sandvik-rp105",
              "name": "RP105",
              "subcategories": []
            },
            {
              "id": "aggregate-sandvik-rp108",
              "name": "RP108",
              "subcategories": []
            },
            {
              "id": "aggregate-sandvik-s4800",
              "name": "S4800",
              "subcategories": []
            },
            {
              "id": "aggregate-sandvik-sc216",
              "name": "SC216",
              "subcategories": []
            },
            {
              "id": "aggregate-sandvik-sv1321",
              "name": "SV1321",
              "subcategories": []
            },
            {
              "id": "aggregate-sandvik-uh320",
              "name": "UH320",
              "subcategories": []
            },
            {
              "id": "aggregate-sandvik-uh373",
              "name": "UH373",
              "subcategories": []
            },
            {
              "id": "aggregate-sandvik-uh440",
              "name": "UH440",
              "subcategories": []
            },
            {
              "id": "aggregate-sandvik-uh573",
              "name": "UH573",
              "subcategories": []
            },
            {
              "id": "aggregate-sandvik-uj310",
              "name": "UJ310",
              "subcategories": []
            },
            {
              "id": "aggregate-sandvik-uj440",
              "name": "UJ440",
              "subcategories": []
            },
            {
              "id": "aggregate-sandvik-uj473",
              "name": "UJ473",
              "subcategories": []
            },
            {
              "id": "aggregate-sandvik-uj640",
              "name": "UJ640",
              "subcategories": []
            },
            {
              "id": "aggregate-sandvik-uk373",
              "name": "UK373",
              "subcategories": []
            },
            {
              "id": "aggregate-sandvik-x44",
              "name": "X44",
              "subcategories": []
            },
            {
              "id": "aggregate-sandvik-other",
              "name": "OTHER",
              "subcategories": []
            }
          ]
        },
        {
          "id": "aggregate-astec",
          "name": "Astec",
          "subcategories": [
            {
              "id": "aggregate-astec-10-ft",
              "name": "10 FT",
              "subcategories": []
            },
            {
              "id": "aggregate-astec-10x14",
              "name": "10X14",
              "subcategories": []
            },
            {
              "id": "aggregate-astec-30x17",
              "name": "30X17",
              "subcategories": []
            },
            {
              "id": "aggregate-astec-32x16",
              "name": "32X16",
              "subcategories": []
            },
            {
              "id": "aggregate-astec-92-ft",
              "name": "92 FT",
              "subcategories": []
            },
            {
              "id": "aggregate-astec-1814",
              "name": "1814",
              "subcategories": []
            },
            {
              "id": "aggregate-astec-1822",
              "name": "1822",
              "subcategories": []
            },
            {
              "id": "aggregate-astec-1830",
              "name": "1830",
              "subcategories": []
            },
            {
              "id": "aggregate-astec-2148",
              "name": "2148",
              "subcategories": []
            },
            {
              "id": "aggregate-astec-2618",
              "name": "2618",
              "subcategories": []
            },
            {
              "id": "aggregate-astec-3660",
              "name": "3660",
              "subcategories": []
            },
            {
              "id": "aggregate-astec-5044",
              "name": "5044",
              "subcategories": []
            },
            {
              "id": "aggregate-astec-6203",
              "name": "6203",
              "subcategories": []
            },
            {
              "id": "aggregate-astec-7110",
              "name": "7110",
              "subcategories": []
            },
            {
              "id": "aggregate-astec-7203",
              "name": "7203",
              "subcategories": []
            },
            {
              "id": "aggregate-astec-8203",
              "name": "8203",
              "subcategories": []
            },
            {
              "id": "aggregate-astec-cc1-6",
              "name": "CC1.6",
              "subcategories": []
            },
            {
              "id": "aggregate-astec-cs2650",
              "name": "CS2650",
              "subcategories": []
            },
            {
              "id": "aggregate-astec-cs3055",
              "name": "CS3055",
              "subcategories": []
            },
            {
              "id": "aggregate-astec-cs3244",
              "name": "CS3244",
              "subcategories": []
            },
            {
              "id": "aggregate-astec-foldngo-2512",
              "name": "FOLDNGO 2512",
              "subcategories": []
            },
            {
              "id": "aggregate-astec-ft200",
              "name": "FT200",
              "subcategories": []
            },
            {
              "id": "aggregate-astec-ft300",
              "name": "FT300",
              "subcategories": []
            },
            {
              "id": "aggregate-astec-ft2500",
              "name": "FT2500",
              "subcategories": []
            },
            {
              "id": "aggregate-astec-ft2650",
              "name": "FT2650",
              "subcategories": []
            },
            {
              "id": "aggregate-astec-ft3055",
              "name": "FT3055",
              "subcategories": []
            },
            {
              "id": "aggregate-astec-ft4250",
              "name": "FT4250",
              "subcategories": []
            },
            {
              "id": "aggregate-astec-gt104",
              "name": "GT104",
              "subcategories": []
            },
            {
              "id": "aggregate-astec-gt125",
              "name": "GT125",
              "subcategories": []
            },
            {
              "id": "aggregate-astec-gt145",
              "name": "GT145",
              "subcategories": []
            },
            {
              "id": "aggregate-astec-gt165",
              "name": "GT165",
              "subcategories": []
            },
            {
              "id": "aggregate-astec-gt205",
              "name": "GT205",
              "subcategories": []
            },
            {
              "id": "aggregate-astec-gt206",
              "name": "GT206",
              "subcategories": []
            },
            {
              "id": "aggregate-astec-gt440",
              "name": "GT440",
              "subcategories": []
            },
            {
              "id": "aggregate-astec-gt3260",
              "name": "GT3260",
              "subcategories": []
            },
            {
              "id": "aggregate-astec-gt4265",
              "name": "GT4265",
              "subcategories": []
            },
            {
              "id": "aggregate-astec-gt4280",
              "name": "GT4280",
              "subcategories": []
            },
            {
              "id": "aggregate-astec-gt4875",
              "name": "GT4875",
              "subcategories": []
            },
            {
              "id": "aggregate-astec-gt42100",
              "name": "GT42100",
              "subcategories": []
            },
            {
              "id": "aggregate-astec-kodiak-k300",
              "name": "KODIAK K300+",
              "subcategories": []
            },
            {
              "id": "aggregate-astec-kodiak-k300-6203cc",
              "name": "KODIAK K300+6203CC",
              "subcategories": []
            },
            {
              "id": "aggregate-astec-kodiak-k350",
              "name": "KODIAK K350",
              "subcategories": []
            },
            {
              "id": "aggregate-astec-kodiak-k400",
              "name": "KODIAK K400",
              "subcategories": []
            },
            {
              "id": "aggregate-astec-kodiak-k400pm",
              "name": "KODIAK K400PM",
              "subcategories": []
            },
            {
              "id": "aggregate-astec-kds710",
              "name": "KDS710",
              "subcategories": []
            },
            {
              "id": "aggregate-astec-prosizer-3100",
              "name": "PROSIZER 3100",
              "subcategories": []
            },
            {
              "id": "aggregate-astec-prosizer-3600",
              "name": "PROSIZER 3600",
              "subcategories": []
            },
            {
              "id": "aggregate-astec-ptsc2520a",
              "name": "PTSC2520A",
              "subcategories": []
            },
            {
              "id": "aggregate-astec-ptsc2618vm",
              "name": "PTSC2618VM",
              "subcategories": []
            },
            {
              "id": "aggregate-astec-ptcs2818vm",
              "name": "PTCS2818VM",
              "subcategories": []
            },
            {
              "id": "aggregate-astec-ranger-c12",
              "name": "RANGER C12",
              "subcategories": []
            },
            {
              "id": "aggregate-astec-ranger-i32",
              "name": "RANGER I32",
              "subcategories": []
            },
            {
              "id": "aggregate-astec-ranger-j20",
              "name": "RANGER J20",
              "subcategories": []
            },
            {
              "id": "aggregate-astec-ranger-sd09",
              "name": "RANGER SD09",
              "subcategories": []
            },
            {
              "id": "aggregate-astec-ranger-sf10",
              "name": "RANGER SF10",
              "subcategories": []
            },
            {
              "id": "aggregate-astec-ranger-srt11",
              "name": "RANGER SRT11",
              "subcategories": []
            },
            {
              "id": "aggregate-astec-ranger-ss10",
              "name": "RANGER SS10",
              "subcategories": []
            },
            {
              "id": "aggregate-astec-ranger-ss13",
              "name": "RANGER SS13",
              "subcategories": []
            },
            {
              "id": "aggregate-astec-seb75",
              "name": "SEB75",
              "subcategories": []
            },
            {
              "id": "aggregate-astec-titan-t300",
              "name": "TITAN T300",
              "subcategories": []
            },
            {
              "id": "aggregate-astec-titan-t400",
              "name": "TITAN T400",
              "subcategories": []
            },
            {
              "id": "aggregate-astec-th48-70",
              "name": "TH48-70",
              "subcategories": []
            },
            {
              "id": "aggregate-astec-other",
              "name": "OTHER",
              "subcategories": []
            }
          ]
        },
        {
          "id": "aggregate-superior",
          "name": "Superior",
          "subcategories": [
            {
              "id": "aggregate-superior-5x10",
              "name": "5X10",
              "subcategories": []
            },
            {
              "id": "aggregate-superior-6x20",
              "name": "6X20",
              "subcategories": []
            },
            {
              "id": "aggregate-superior-8x11",
              "name": "8X11",
              "subcategories": []
            },
            {
              "id": "aggregate-superior-8x16",
              "name": "8X16",
              "subcategories": []
            },
            {
              "id": "aggregate-superior-8x17",
              "name": "8X17",
              "subcategories": []
            },
            {
              "id": "aggregate-superior-8x20",
              "name": "8X20",
              "subcategories": []
            },
            {
              "id": "aggregate-superior-24x70",
              "name": "24X70",
              "subcategories": []
            },
            {
              "id": "aggregate-superior-24x125",
              "name": "24X125",
              "subcategories": []
            },
            {
              "id": "aggregate-superior-36x30",
              "name": "36X30",
              "subcategories": []
            },
            {
              "id": "aggregate-superior-30x40",
              "name": "30X40",
              "subcategories": []
            },
            {
              "id": "aggregate-superior-30x50",
              "name": "30X50",
              "subcategories": []
            },
            {
              "id": "aggregate-superior-30x60",
              "name": "30X60",
              "subcategories": []
            },
            {
              "id": "aggregate-superior-30x70",
              "name": "30X70",
              "subcategories": []
            },
            {
              "id": "aggregate-superior-30x80",
              "name": "30X80",
              "subcategories": []
            },
            {
              "id": "aggregate-superior-30x85",
              "name": "30X85",
              "subcategories": []
            },
            {
              "id": "aggregate-superior-30x95",
              "name": "30X95",
              "subcategories": []
            },
            {
              "id": "aggregate-superior-30x150",
              "name": "30X150",
              "subcategories": []
            },
            {
              "id": "aggregate-superior-36x25",
              "name": "36X25",
              "subcategories": []
            },
            {
              "id": "aggregate-superior-36x35",
              "name": "36X35",
              "subcategories": []
            },
            {
              "id": "aggregate-superior-36x40",
              "name": "36X40",
              "subcategories": []
            },
            {
              "id": "aggregate-superior-36x50",
              "name": "36X50",
              "subcategories": []
            },
            {
              "id": "aggregate-superior-36x55",
              "name": "36X55",
              "subcategories": []
            },
            {
              "id": "aggregate-superior-36x60",
              "name": "36X60",
              "subcategories": []
            },
            {
              "id": "aggregate-superior-36x70",
              "name": "36X70",
              "subcategories": []
            },
            {
              "id": "aggregate-superior-36x80",
              "name": "36X80",
              "subcategories": []
            },
            {
              "id": "aggregate-superior-36x95",
              "name": "36X95",
              "subcategories": []
            },
            {
              "id": "aggregate-superior-36x100",
              "name": "36X100",
              "subcategories": []
            },
            {
              "id": "aggregate-superior-36x125",
              "name": "36X125",
              "subcategories": []
            },
            {
              "id": "aggregate-superior-36x136",
              "name": "36X136",
              "subcategories": []
            },
            {
              "id": "aggregate-superior-36x150",
              "name": "36X150",
              "subcategories": []
            },
            {
              "id": "aggregate-superior-36x500",
              "name": "36X500",
              "subcategories": []
            },
            {
              "id": "aggregate-superior-42x60",
              "name": "42X60",
              "subcategories": []
            },
            {
              "id": "aggregate-superior-42x70",
              "name": "42X70",
              "subcategories": []
            },
            {
              "id": "aggregate-superior-42x125",
              "name": "42X125",
              "subcategories": []
            },
            {
              "id": "aggregate-superior-42x136",
              "name": "42X136",
              "subcategories": []
            },
            {
              "id": "aggregate-superior-42x150",
              "name": "42X150",
              "subcategories": []
            },
            {
              "id": "aggregate-superior-54x35",
              "name": "54X35",
              "subcategories": []
            },
            {
              "id": "aggregate-superior-60x32",
              "name": "60X32",
              "subcategories": []
            },
            {
              "id": "aggregate-superior-5420vgf",
              "name": "5420VGF",
              "subcategories": []
            },
            {
              "id": "aggregate-superior-6203hpsp",
              "name": "6203HPSP",
              "subcategories": []
            },
            {
              "id": "aggregate-superior-6203t36pwp",
              "name": "6203T36PWP",
              "subcategories": []
            },
            {
              "id": "aggregate-superior-6203t44pwp",
              "name": "6203T44PWP",
              "subcategories": []
            },
            {
              "id": "aggregate-superior-7203hbs",
              "name": "7203HBS",
              "subcategories": []
            },
            {
              "id": "aggregate-superior-7203t44a",
              "name": "7203T44A",
              "subcategories": []
            },
            {
              "id": "aggregate-superior-f8x16-36x40pfhbc",
              "name": "F8X16.36X40PFHBC",
              "subcategories": []
            },
            {
              "id": "aggregate-superior-fbx16-42x18pfhbc",
              "name": "FBX16.42X18PFHBC",
              "subcategories": []
            },
            {
              "id": "aggregate-superior-f36x60",
              "name": "F36X60",
              "subcategories": []
            },
            {
              "id": "aggregate-superior-f36x125ps",
              "name": "F36X125PS",
              "subcategories": []
            },
            {
              "id": "aggregate-superior-f36x150f3618",
              "name": "F36X150F3618",
              "subcategories": []
            },
            {
              "id": "aggregate-superior-f42x75",
              "name": "F42X75",
              "subcategories": []
            },
            {
              "id": "aggregate-superior-f3618",
              "name": "F3618",
              "subcategories": []
            },
            {
              "id": "aggregate-superior-f400",
              "name": "F400",
              "subcategories": []
            },
            {
              "id": "aggregate-superior-f2636",
              "name": "F2636",
              "subcategories": []
            },
            {
              "id": "aggregate-superior-f4432",
              "name": "F4432",
              "subcategories": []
            },
            {
              "id": "aggregate-superior-f5101vbds",
              "name": "F5101VBDS",
              "subcategories": []
            },
            {
              "id": "aggregate-superior-f6203hpsp",
              "name": "F6203HPSP",
              "subcategories": []
            },
            {
              "id": "aggregate-superior-f6203hpwpat",
              "name": "F6203HPWPAT",
              "subcategories": []
            },
            {
              "id": "aggregate-superior-f62033hbs",
              "name": "F62033HBS",
              "subcategories": []
            },
            {
              "id": "aggregate-superior-f82023hbs",
              "name": "F82023HBS",
              "subcategories": []
            },
            {
              "id": "aggregate-superior-f82033hbs",
              "name": "F82033HBS",
              "subcategories": []
            },
            {
              "id": "aggregate-superior-f4250161621scp",
              "name": "F4250161621SCP",
              "subcategories": []
            },
            {
              "id": "aggregate-superior-fmw3628",
              "name": "FMW3628",
              "subcategories": []
            },
            {
              "id": "aggregate-superior-guardian",
              "name": "GUARDIAN",
              "subcategories": []
            },
            {
              "id": "aggregate-superior-lww-510",
              "name": "LWW-510",
              "subcategories": []
            },
            {
              "id": "aggregate-superior-p300",
              "name": "P300",
              "subcategories": []
            },
            {
              "id": "aggregate-superior-p300cc",
              "name": "P300CC",
              "subcategories": []
            },
            {
              "id": "aggregate-superior-p400",
              "name": "P400",
              "subcategories": []
            },
            {
              "id": "aggregate-superior-p400rd",
              "name": "P400RD",
              "subcategories": []
            },
            {
              "id": "aggregate-superior-p500",
              "name": "P500",
              "subcategories": []
            },
            {
              "id": "aggregate-superior-powerstacker-36x125",
              "name": "POWERSTACKER 36X125",
              "subcategories": []
            },
            {
              "id": "aggregate-superior-powerstacker-36x150",
              "name": "POWERSTACKER 36X150",
              "subcategories": []
            },
            {
              "id": "aggregate-superior-razertail-48",
              "name": "RAZERTAIL 48",
              "subcategories": []
            },
            {
              "id": "aggregate-superior-razertail-72",
              "name": "RAZERTAIL 72",
              "subcategories": []
            },
            {
              "id": "aggregate-superior-sentry-4520hsi",
              "name": "SENTRY 4520HSI",
              "subcategories": []
            },
            {
              "id": "aggregate-superior-slidepac-36x70",
              "name": "SLIDEPAC 36X70",
              "subcategories": []
            },
            {
              "id": "aggregate-superior-slidepac-42x70",
              "name": "SLIDEPAC 42X70",
              "subcategories": []
            },
            {
              "id": "aggregate-superior-telestacker-36x130",
              "name": "TELESTACKER 36X130",
              "subcategories": []
            },
            {
              "id": "aggregate-superior-telestacker-36x136",
              "name": "TELESTACKER 36X136",
              "subcategories": []
            },
            {
              "id": "aggregate-superior-telestacker-36x150",
              "name": "TELESTACKER 36X150",
              "subcategories": []
            },
            {
              "id": "aggregate-superior-telestacker-42x170",
              "name": "TELESTACKER 42X170",
              "subcategories": []
            },
            {
              "id": "aggregate-superior-v600",
              "name": "V600",
              "subcategories": []
            },
            {
              "id": "aggregate-superior-other",
              "name": "OTHER",
              "subcategories": []
            }
          ]
        },
        {
          "id": "aggregate-cedar-rapids",
          "name": "Cedar Rapids",
          "subcategories": []
        },
        {
          "id": "aggregate-terex-finlay",
          "name": "Terex Finlay",
          "subcategories": [
            {
              "id": "aggregate-terex-finlay-150e",
              "name": "150E",
              "subcategories": []
            },
            {
              "id": "aggregate-terex-finlay-390",
              "name": "390",
              "subcategories": []
            },
            {
              "id": "aggregate-terex-finlay-524",
              "name": "524",
              "subcategories": []
            },
            {
              "id": "aggregate-terex-finlay-595",
              "name": "595",
              "subcategories": []
            },
            {
              "id": "aggregate-terex-finlay-683",
              "name": "683",
              "subcategories": []
            },
            {
              "id": "aggregate-terex-finlay-683-supertrak",
              "name": "683 SUPERTRAK",
              "subcategories": []
            },
            {
              "id": "aggregate-terex-finlay-684-supertrak",
              "name": "684 SUPERTRAK",
              "subcategories": []
            },
            {
              "id": "aggregate-terex-finlay-693-supertrak",
              "name": "693+ SUPERTRAK",
              "subcategories": []
            },
            {
              "id": "aggregate-terex-finlay-694-supertrak",
              "name": "694 SUPERTRAK",
              "subcategories": []
            },
            {
              "id": "aggregate-terex-finlay-694-supertrak",
              "name": "694 + SUPERTRAK",
              "subcategories": []
            },
            {
              "id": "aggregate-terex-finlay-684",
              "name": "684",
              "subcategories": []
            },
            {
              "id": "aggregate-terex-finlay-693",
              "name": "693",
              "subcategories": []
            },
            {
              "id": "aggregate-terex-finlay-694",
              "name": "694+",
              "subcategories": []
            },
            {
              "id": "aggregate-terex-finlay-696",
              "name": "696",
              "subcategories": []
            },
            {
              "id": "aggregate-terex-finlay-798",
              "name": "798",
              "subcategories": []
            },
            {
              "id": "aggregate-terex-finlay-860",
              "name": "860",
              "subcategories": []
            },
            {
              "id": "aggregate-terex-finlay-863",
              "name": "863",
              "subcategories": []
            },
            {
              "id": "aggregate-terex-finlay-873",
              "name": "873",
              "subcategories": []
            },
            {
              "id": "aggregate-terex-finlay-883",
              "name": "883",
              "subcategories": []
            },
            {
              "id": "aggregate-terex-finlay-883t",
              "name": "883T",
              "subcategories": []
            },
            {
              "id": "aggregate-terex-finlay-984",
              "name": "984",
              "subcategories": []
            },
            {
              "id": "aggregate-terex-finlay-c1540",
              "name": "C1540",
              "subcategories": []
            },
            {
              "id": "aggregate-terex-finlay-c1545",
              "name": "C1545",
              "subcategories": []
            },
            {
              "id": "aggregate-terex-finlay-c1550",
              "name": "C1550",
              "subcategories": []
            },
            {
              "id": "aggregate-terex-finlay-i110",
              "name": "I110",
              "subcategories": []
            },
            {
              "id": "aggregate-terex-finlay-i111",
              "name": "I111",
              "subcategories": []
            },
            {
              "id": "aggregate-terex-finlay-i120",
              "name": "I120",
              "subcategories": []
            },
            {
              "id": "aggregate-terex-finlay-i-120rs",
              "name": "I-120RS",
              "subcategories": []
            },
            {
              "id": "aggregate-terex-finlay-i140",
              "name": "I140",
              "subcategories": []
            },
            {
              "id": "aggregate-terex-finlay-ic110",
              "name": "IC110",
              "subcategories": []
            },
            {
              "id": "aggregate-terex-finlay-j960",
              "name": "J960",
              "subcategories": []
            },
            {
              "id": "aggregate-terex-finlay-j1160",
              "name": "J1160",
              "subcategories": []
            },
            {
              "id": "aggregate-terex-finlay-j1170",
              "name": "J1170",
              "subcategories": []
            },
            {
              "id": "aggregate-terex-finlay-j1175",
              "name": "J1175",
              "subcategories": []
            },
            {
              "id": "aggregate-terex-finlay-j1480",
              "name": "J1480",
              "subcategories": []
            },
            {
              "id": "aggregate-terex-finlay-l140",
              "name": "L140",
              "subcategories": []
            },
            {
              "id": "aggregate-terex-finlay-tc80",
              "name": "TC80",
              "subcategories": []
            },
            {
              "id": "aggregate-terex-finlay-tf50l",
              "name": "TF50L",
              "subcategories": []
            },
            {
              "id": "aggregate-terex-finlay-tf75h",
              "name": "TF75H",
              "subcategories": []
            },
            {
              "id": "aggregate-terex-finlay-tf75l",
              "name": "TF75L",
              "subcategories": []
            },
            {
              "id": "aggregate-terex-finlay-tr80",
              "name": "TR80",
              "subcategories": []
            },
            {
              "id": "aggregate-terex-finlay-wr80",
              "name": "WR80",
              "subcategories": []
            },
            {
              "id": "aggregate-terex-finlay-other",
              "name": "OTHER",
              "subcategories": []
            }
          ]
        },
        {
          "id": "aggregate-anaconda",
          "name": "Anaconda",
          "subcategories": [
            {
              "id": "aggregate-anaconda-c12",
              "name": "C12",
              "subcategories": []
            },
            {
              "id": "aggregate-anaconda-df410",
              "name": "DF410",
              "subcategories": []
            },
            {
              "id": "aggregate-anaconda-df514",
              "name": "DF514",
              "subcategories": []
            },
            {
              "id": "aggregate-anaconda-df518",
              "name": "DF518",
              "subcategories": []
            },
            {
              "id": "aggregate-anaconda-fsl100",
              "name": "FSL100",
              "subcategories": []
            },
            {
              "id": "aggregate-anaconda-ftr150",
              "name": "FTR150",
              "subcategories": []
            },
            {
              "id": "aggregate-anaconda-ftr200",
              "name": "FTR200",
              "subcategories": []
            },
            {
              "id": "aggregate-anaconda-i12",
              "name": "I12",
              "subcategories": []
            },
            {
              "id": "aggregate-anaconda-j12",
              "name": "J12",
              "subcategories": []
            },
            {
              "id": "aggregate-anaconda-sr514",
              "name": "SR514",
              "subcategories": []
            },
            {
              "id": "aggregate-anaconda-sr520",
              "name": "SR520",
              "subcategories": []
            },
            {
              "id": "aggregate-anaconda-td516",
              "name": "TD516",
              "subcategories": []
            },
            {
              "id": "aggregate-anaconda-td620",
              "name": "TD620",
              "subcategories": []
            },
            {
              "id": "aggregate-anaconda-tr60",
              "name": "TR60",
              "subcategories": []
            },
            {
              "id": "aggregate-anaconda-tr75",
              "name": "TR75",
              "subcategories": []
            },
            {
              "id": "aggregate-anaconda-tr100",
              "name": "TR100",
              "subcategories": []
            },
            {
              "id": "aggregate-anaconda-tr5036",
              "name": "TR5036",
              "subcategories": []
            },
            {
              "id": "aggregate-anaconda-tr6036",
              "name": "TR6036",
              "subcategories": []
            },
            {
              "id": "aggregate-anaconda-tr7542",
              "name": "TR7542",
              "subcategories": []
            },
            {
              "id": "aggregate-anaconda-other",
              "name": "OTHER",
              "subcategories": []
            }
          ]
        },
        {
          "id": "aggregate-barford",
          "name": "Barford",
          "subcategories": [
            {
              "id": "aggregate-barford-640j",
              "name": "640J",
              "subcategories": []
            },
            {
              "id": "aggregate-barford-750j",
              "name": "750J",
              "subcategories": []
            },
            {
              "id": "aggregate-barford-750j-rs",
              "name": "750J RS",
              "subcategories": []
            },
            {
              "id": "aggregate-barford-1060j",
              "name": "1060J",
              "subcategories": []
            },
            {
              "id": "aggregate-barford-bf4048",
              "name": "BF4048",
              "subcategories": []
            },
            {
              "id": "aggregate-barford-bf7042",
              "name": "BF7042",
              "subcategories": []
            },
            {
              "id": "aggregate-barford-bf7048",
              "name": "BF7048",
              "subcategories": []
            },
            {
              "id": "aggregate-barford-j700x500",
              "name": "J700X500",
              "subcategories": []
            },
            {
              "id": "aggregate-barford-ltf80",
              "name": "LTF80",
              "subcategories": []
            },
            {
              "id": "aggregate-barford-mc1200",
              "name": "MC1200",
              "subcategories": []
            },
            {
              "id": "aggregate-barford-r6536tr",
              "name": "R6536TR",
              "subcategories": []
            },
            {
              "id": "aggregate-barford-s80",
              "name": "S80",
              "subcategories": []
            },
            {
              "id": "aggregate-barford-sm312",
              "name": "SM312",
              "subcategories": []
            },
            {
              "id": "aggregate-barford-sr124",
              "name": "SR124",
              "subcategories": []
            },
            {
              "id": "aggregate-barford-sr165",
              "name": "SR165",
              "subcategories": []
            },
            {
              "id": "aggregate-barford-t512",
              "name": "T512",
              "subcategories": []
            },
            {
              "id": "aggregate-barford-t516",
              "name": "T516",
              "subcategories": []
            },
            {
              "id": "aggregate-barford-t620",
              "name": "T620",
              "subcategories": []
            },
            {
              "id": "aggregate-barford-t640",
              "name": "T640",
              "subcategories": []
            },
            {
              "id": "aggregate-barford-t722r",
              "name": "T722R",
              "subcategories": []
            },
            {
              "id": "aggregate-barford-tr100",
              "name": "TR100",
              "subcategories": []
            },
            {
              "id": "aggregate-barford-tr5048",
              "name": "TR5048",
              "subcategories": []
            },
            {
              "id": "aggregate-barford-tr6536",
              "name": "TR6536",
              "subcategories": []
            },
            {
              "id": "aggregate-barford-tr8036",
              "name": "TR8036",
              "subcategories": []
            },
            {
              "id": "aggregate-barford-tr8048",
              "name": "TR8048",
              "subcategories": []
            },
            {
              "id": "aggregate-barford-us20",
              "name": "US20",
              "subcategories": []
            },
            {
              "id": "aggregate-barford-us70",
              "name": "US70",
              "subcategories": []
            },
            {
              "id": "aggregate-barford-w5032",
              "name": "W5032",
              "subcategories": []
            },
            {
              "id": "aggregate-barford-other",
              "name": "OTHER",
              "subcategories": []
            }
          ]
        },
        {
          "id": "aggregate-custom-bilt",
          "name": "Custom Bilt",
          "subcategories": []
        },
        {
          "id": "aggregate-eagle-crusher",
          "name": "Eagle Crusher",
          "subcategories": [
            {
              "id": "aggregate-eagle-crusher-6x20",
              "name": "6X20",
              "subcategories": []
            },
            {
              "id": "aggregate-eagle-crusher-18x36",
              "name": "18X36",
              "subcategories": []
            },
            {
              "id": "aggregate-eagle-crusher-20x36",
              "name": "20X36",
              "subcategories": []
            },
            {
              "id": "aggregate-eagle-crusher-30x42",
              "name": "30X42",
              "subcategories": []
            },
            {
              "id": "aggregate-eagle-crusher-30x50",
              "name": "30X50",
              "subcategories": []
            },
            {
              "id": "aggregate-eagle-crusher-33d402",
              "name": "33D402",
              "subcategories": []
            },
            {
              "id": "aggregate-eagle-crusher-36x24",
              "name": "36X24",
              "subcategories": []
            },
            {
              "id": "aggregate-eagle-crusher-36x50",
              "name": "36X50",
              "subcategories": []
            },
            {
              "id": "aggregate-eagle-crusher-36x60",
              "name": "36X60",
              "subcategories": []
            },
            {
              "id": "aggregate-eagle-crusher-36x100",
              "name": "36X100",
              "subcategories": []
            },
            {
              "id": "aggregate-eagle-crusher-42x14",
              "name": "42X14",
              "subcategories": []
            },
            {
              "id": "aggregate-eagle-crusher-42x40",
              "name": "42X40",
              "subcategories": []
            },
            {
              "id": "aggregate-eagle-crusher-54cm",
              "name": "54CM",
              "subcategories": []
            },
            {
              "id": "aggregate-eagle-crusher-65d006",
              "name": "65D006",
              "subcategories": []
            },
            {
              "id": "aggregate-eagle-crusher-1000",
              "name": "1000",
              "subcategories": []
            },
            {
              "id": "aggregate-eagle-crusher-1200",
              "name": "1200",
              "subcategories": []
            },
            {
              "id": "aggregate-eagle-crusher-2036",
              "name": "2036",
              "subcategories": []
            },
            {
              "id": "aggregate-eagle-crusher-3242",
              "name": "3242",
              "subcategories": []
            },
            {
              "id": "aggregate-eagle-crusher-ex-plant",
              "name": "EX-PLANT",
              "subcategories": []
            },
            {
              "id": "aggregate-eagle-crusher-jumbo",
              "name": "JUMBO",
              "subcategories": []
            },
            {
              "id": "aggregate-eagle-crusher-jumbo-1400",
              "name": "JUMBO 1400",
              "subcategories": []
            },
            {
              "id": "aggregate-eagle-crusher-maxrp-25",
              "name": "MAXRP 25",
              "subcategories": []
            },
            {
              "id": "aggregate-eagle-crusher-rapidploy-1000",
              "name": "RAPIDPLOY 1000",
              "subcategories": []
            },
            {
              "id": "aggregate-eagle-crusher-riprap",
              "name": "RIPRAP",
              "subcategories": []
            },
            {
              "id": "aggregate-eagle-crusher-ultramax-25",
              "name": "ULTRAMAX 25",
              "subcategories": []
            },
            {
              "id": "aggregate-eagle-crusher-ultramax-400-04",
              "name": "ULTRAMAX 400-04",
              "subcategories": []
            },
            {
              "id": "aggregate-eagle-crusher-ultramax-500-05-cc",
              "name": "ULTRAMAX 500-05 CC",
              "subcategories": []
            },
            {
              "id": "aggregate-eagle-crusher-ultramax-500-05cv",
              "name": "ULTRAMAX 500-05CV",
              "subcategories": []
            },
            {
              "id": "aggregate-eagle-crusher-ultramax-500-05cvss",
              "name": "ULTRAMAX 500-05CVSS",
              "subcategories": []
            },
            {
              "id": "aggregate-eagle-crusher-ultramax-1000-15cc",
              "name": "ULTRAMAX 1000-15CC",
              "subcategories": []
            },
            {
              "id": "aggregate-eagle-crusher-ultramax-1200-25cc",
              "name": "ULTRAMAX 1200-25CC",
              "subcategories": []
            },
            {
              "id": "aggregate-eagle-crusher-ultramax-1200-25ocss",
              "name": "ULTRAMAX 1200-25OCSS",
              "subcategories": []
            },
            {
              "id": "aggregate-eagle-crusher-ultramax-1400-45",
              "name": "ULTRAMAX 1400-45",
              "subcategories": []
            },
            {
              "id": "aggregate-eagle-crusher-ultramax-1400-45cc",
              "name": "ULTRAMAX 1400-45CC.",
              "subcategories": []
            },
            {
              "id": "aggregate-eagle-crusher-ultramax-1400-45ccs",
              "name": "ULTRAMAX 1400-45CCS",
              "subcategories": []
            },
            {
              "id": "aggregate-eagle-crusher-ultramax-1400-45cvs",
              "name": "ULTRAMAX 1400-45CVS",
              "subcategories": []
            },
            {
              "id": "aggregate-eagle-crusher-ultramax-1600-69",
              "name": "ULTRAMAX 1600-69",
              "subcategories": []
            },
            {
              "id": "aggregate-eagle-crusher-ultramax-1600-69ccs",
              "name": "ULTRAMAX 1600-69CCS",
              "subcategories": []
            },
            {
              "id": "aggregate-eagle-crusher-other",
              "name": "OTHER",
              "subcategories": []
            }
          ]
        },
        {
          "id": "aggregate-earthworm-conveyors",
          "name": "Earthworm Conveyors",
          "subcategories": [
            {
              "id": "aggregate-earthworm-conveyors-3x60",
              "name": "3X60",
              "subcategories": []
            },
            {
              "id": "aggregate-earthworm-conveyors-3x80",
              "name": "3X80",
              "subcategories": []
            },
            {
              "id": "aggregate-earthworm-conveyors-3x100",
              "name": "3X100",
              "subcategories": []
            },
            {
              "id": "aggregate-earthworm-conveyors-4x80",
              "name": "4X80",
              "subcategories": []
            },
            {
              "id": "aggregate-earthworm-conveyors-4x100",
              "name": "4X100",
              "subcategories": []
            },
            {
              "id": "aggregate-earthworm-conveyors-8x12",
              "name": "8X12",
              "subcategories": []
            },
            {
              "id": "aggregate-earthworm-conveyors-8x14",
              "name": "8X14",
              "subcategories": []
            },
            {
              "id": "aggregate-earthworm-conveyors-8x16",
              "name": "8X16",
              "subcategories": []
            },
            {
              "id": "aggregate-earthworm-conveyors-8x20",
              "name": "8X20",
              "subcategories": []
            },
            {
              "id": "aggregate-earthworm-conveyors-12x30",
              "name": "12X30",
              "subcategories": []
            },
            {
              "id": "aggregate-earthworm-conveyors-18x30",
              "name": "18X30",
              "subcategories": []
            },
            {
              "id": "aggregate-earthworm-conveyors-18x36",
              "name": "18X36",
              "subcategories": []
            },
            {
              "id": "aggregate-earthworm-conveyors-18x40",
              "name": "18X40",
              "subcategories": []
            },
            {
              "id": "aggregate-earthworm-conveyors-18x45",
              "name": "18X45",
              "subcategories": []
            },
            {
              "id": "aggregate-earthworm-conveyors-18x60",
              "name": "18X60",
              "subcategories": []
            },
            {
              "id": "aggregate-earthworm-conveyors-18x100",
              "name": "18X100",
              "subcategories": []
            },
            {
              "id": "aggregate-earthworm-conveyors-24x20",
              "name": "24X20",
              "subcategories": []
            },
            {
              "id": "aggregate-earthworm-conveyors-24x40",
              "name": "24X40",
              "subcategories": []
            },
            {
              "id": "aggregate-earthworm-conveyors-24x50",
              "name": "24X50",
              "subcategories": []
            },
            {
              "id": "aggregate-earthworm-conveyors-24x60",
              "name": "24X60",
              "subcategories": []
            },
            {
              "id": "aggregate-earthworm-conveyors-24x80",
              "name": "24X80",
              "subcategories": []
            },
            {
              "id": "aggregate-earthworm-conveyors-24x100",
              "name": "24X100",
              "subcategories": []
            },
            {
              "id": "aggregate-earthworm-conveyors-24x110",
              "name": "24X110",
              "subcategories": []
            },
            {
              "id": "aggregate-earthworm-conveyors-30x20",
              "name": "30X20",
              "subcategories": []
            },
            {
              "id": "aggregate-earthworm-conveyors-30x40",
              "name": "30X40",
              "subcategories": []
            },
            {
              "id": "aggregate-earthworm-conveyors-30x50",
              "name": "30X50",
              "subcategories": []
            },
            {
              "id": "aggregate-earthworm-conveyors-30x60",
              "name": "30X60",
              "subcategories": []
            },
            {
              "id": "aggregate-earthworm-conveyors-30x80",
              "name": "30X80",
              "subcategories": []
            },
            {
              "id": "aggregate-earthworm-conveyors-30x100",
              "name": "30X100",
              "subcategories": []
            },
            {
              "id": "aggregate-earthworm-conveyors-30x110",
              "name": "30X110",
              "subcategories": []
            },
            {
              "id": "aggregate-earthworm-conveyors-30x120",
              "name": "30X120",
              "subcategories": []
            },
            {
              "id": "aggregate-earthworm-conveyors-30x150",
              "name": "30X150",
              "subcategories": []
            },
            {
              "id": "aggregate-earthworm-conveyors-30x500",
              "name": "30X500",
              "subcategories": []
            },
            {
              "id": "aggregate-earthworm-conveyors-30x800",
              "name": "30X800",
              "subcategories": []
            },
            {
              "id": "aggregate-earthworm-conveyors-30x1000",
              "name": "30X1000",
              "subcategories": []
            },
            {
              "id": "aggregate-earthworm-conveyors-30x1350",
              "name": "30X1350",
              "subcategories": []
            },
            {
              "id": "aggregate-earthworm-conveyors-36x20",
              "name": "36X20",
              "subcategories": []
            },
            {
              "id": "aggregate-earthworm-conveyors-36x40",
              "name": "36X40",
              "subcategories": []
            },
            {
              "id": "aggregate-earthworm-conveyors-36x50",
              "name": "36X50",
              "subcategories": []
            },
            {
              "id": "aggregate-earthworm-conveyors-36x60",
              "name": "36X60",
              "subcategories": []
            },
            {
              "id": "aggregate-earthworm-conveyors-36x80",
              "name": "36X80",
              "subcategories": []
            },
            {
              "id": "aggregate-earthworm-conveyors-36x100",
              "name": "36X100",
              "subcategories": []
            },
            {
              "id": "aggregate-earthworm-conveyors-36x110",
              "name": "36X110",
              "subcategories": []
            },
            {
              "id": "aggregate-earthworm-conveyors-36x120",
              "name": "36X120",
              "subcategories": []
            },
            {
              "id": "aggregate-earthworm-conveyors-36x150",
              "name": "36X150",
              "subcategories": []
            },
            {
              "id": "aggregate-earthworm-conveyors-36x130",
              "name": "36X130",
              "subcategories": []
            },
            {
              "id": "aggregate-earthworm-conveyors-42x60",
              "name": "42X60",
              "subcategories": []
            },
            {
              "id": "aggregate-earthworm-conveyors-42x80",
              "name": "42X80",
              "subcategories": []
            },
            {
              "id": "aggregate-earthworm-conveyors-42x100",
              "name": "42X100",
              "subcategories": []
            },
            {
              "id": "aggregate-earthworm-conveyors-48x30",
              "name": "48X30",
              "subcategories": []
            },
            {
              "id": "aggregate-earthworm-conveyors-48x60",
              "name": "48X60",
              "subcategories": []
            },
            {
              "id": "aggregate-earthworm-conveyors-48x74",
              "name": "48X74",
              "subcategories": []
            },
            {
              "id": "aggregate-earthworm-conveyors-48x80",
              "name": "48X80",
              "subcategories": []
            },
            {
              "id": "aggregate-earthworm-conveyors-48x100",
              "name": "48X100",
              "subcategories": []
            },
            {
              "id": "aggregate-earthworm-conveyors-other",
              "name": "OTHER",
              "subcategories": []
            }
          ]
        },
        {
          "id": "aggregate-eagle-iron-works",
          "name": "Eagle Iron Works",
          "subcategories": [
            {
              "id": "aggregate-eagle-iron-works-6x20",
              "name": "6X20",
              "subcategories": []
            },
            {
              "id": "aggregate-eagle-iron-works-10x40",
              "name": "10X40",
              "subcategories": []
            },
            {
              "id": "aggregate-eagle-iron-works-27x8-5",
              "name": "27X8.5",
              "subcategories": []
            },
            {
              "id": "aggregate-eagle-iron-works-30x18",
              "name": "30X18",
              "subcategories": []
            },
            {
              "id": "aggregate-eagle-iron-works-36-in",
              "name": "36 IN",
              "subcategories": []
            },
            {
              "id": "aggregate-eagle-iron-works-36x10",
              "name": "36X10",
              "subcategories": []
            },
            {
              "id": "aggregate-eagle-iron-works-36x12",
              "name": "36X12",
              "subcategories": []
            },
            {
              "id": "aggregate-eagle-iron-works-36x18",
              "name": "36X18",
              "subcategories": []
            },
            {
              "id": "aggregate-eagle-iron-works-36x25",
              "name": "36X25",
              "subcategories": []
            },
            {
              "id": "aggregate-eagle-iron-works-36x30",
              "name": "36X30",
              "subcategories": []
            },
            {
              "id": "aggregate-eagle-iron-works-42x30",
              "name": "42X30",
              "subcategories": []
            },
            {
              "id": "aggregate-eagle-iron-works-42x32",
              "name": "42X32",
              "subcategories": []
            },
            {
              "id": "aggregate-eagle-iron-works-44x20",
              "name": "44X20",
              "subcategories": []
            },
            {
              "id": "aggregate-eagle-iron-works-44x32",
              "name": "44X32",
              "subcategories": []
            },
            {
              "id": "aggregate-eagle-iron-works-44x35",
              "name": "44X35",
              "subcategories": []
            },
            {
              "id": "aggregate-eagle-iron-works-54x24",
              "name": "54X24",
              "subcategories": []
            },
            {
              "id": "aggregate-eagle-iron-works-bmd",
              "name": "BMD",
              "subcategories": []
            },
            {
              "id": "aggregate-eagle-iron-works-falcon-724",
              "name": "FALCON 724",
              "subcategories": []
            },
            {
              "id": "aggregate-eagle-iron-works-other",
              "name": "OTHER",
              "subcategories": []
            }
          ]
        },
        {
          "id": "aggregate-edge",
          "name": "Edge",
          "subcategories": [
            {
              "id": "aggregate-edge-186t",
              "name": "186T",
              "subcategories": []
            },
            {
              "id": "aggregate-edge-fts",
              "name": "FTS",
              "subcategories": []
            },
            {
              "id": "aggregate-edge-fts65",
              "name": "FTS65",
              "subcategories": []
            },
            {
              "id": "aggregate-edge-fts75",
              "name": "FTS75",
              "subcategories": []
            },
            {
              "id": "aggregate-edge-lts65",
              "name": "LTS65",
              "subcategories": []
            },
            {
              "id": "aggregate-edge-mc1400",
              "name": "MC1400",
              "subcategories": []
            },
            {
              "id": "aggregate-edge-ms50",
              "name": "MS50",
              "subcategories": []
            },
            {
              "id": "aggregate-edge-ms65",
              "name": "MS65",
              "subcategories": []
            },
            {
              "id": "aggregate-edge-ms80",
              "name": "MS80",
              "subcategories": []
            },
            {
              "id": "aggregate-edge-ms100",
              "name": "MS100",
              "subcategories": []
            },
            {
              "id": "aggregate-edge-screenpro-s16",
              "name": "SCREENPRO S16",
              "subcategories": []
            },
            {
              "id": "aggregate-edge-screenpro-s18",
              "name": "SCREENPRO S18",
              "subcategories": []
            },
            {
              "id": "aggregate-edge-sm186m",
              "name": "SM186M",
              "subcategories": []
            },
            {
              "id": "aggregate-edge-trc622",
              "name": "TRC622",
              "subcategories": []
            },
            {
              "id": "aggregate-edge-trm516",
              "name": "TRM516",
              "subcategories": []
            },
            {
              "id": "aggregate-edge-trtm622",
              "name": "TRTM622",
              "subcategories": []
            },
            {
              "id": "aggregate-edge-trm831",
              "name": "TRM831",
              "subcategories": []
            },
            {
              "id": "aggregate-edge-trt516",
              "name": "TRT516",
              "subcategories": []
            },
            {
              "id": "aggregate-edge-trt620",
              "name": "TRT620",
              "subcategories": []
            },
            {
              "id": "aggregate-edge-trt622",
              "name": "TRT622",
              "subcategories": []
            },
            {
              "id": "aggregate-edge-ts65",
              "name": "TS65",
              "subcategories": []
            },
            {
              "id": "aggregate-edge-ts80",
              "name": "TS80",
              "subcategories": []
            },
            {
              "id": "aggregate-edge-ts100",
              "name": "TS100",
              "subcategories": []
            },
            {
              "id": "aggregate-edge-tsr80",
              "name": "TSR80",
              "subcategories": []
            },
            {
              "id": "aggregate-edge-other",
              "name": "OTHER",
              "subcategories": []
            }
          ]
        },
        {
          "id": "aggregate-evoquip",
          "name": "Evoquip",
          "subcategories": [
            {
              "id": "aggregate-evoquip-bison-35",
              "name": "BISON 35",
              "subcategories": []
            },
            {
              "id": "aggregate-evoquip-bison-120",
              "name": "BISON 120",
              "subcategories": []
            },
            {
              "id": "aggregate-evoquip-bison-280",
              "name": "BISON 280",
              "subcategories": []
            },
            {
              "id": "aggregate-evoquip-cobra-230",
              "name": "COBRA 230",
              "subcategories": []
            },
            {
              "id": "aggregate-evoquip-cobra-230r",
              "name": "COBRA 230R",
              "subcategories": []
            },
            {
              "id": "aggregate-evoquip-cobra-260r",
              "name": "COBRA 260R",
              "subcategories": []
            },
            {
              "id": "aggregate-evoquip-cobra-290",
              "name": "COBRA 290",
              "subcategories": []
            },
            {
              "id": "aggregate-evoquip-cobra-290r",
              "name": "COBRA 290R",
              "subcategories": []
            },
            {
              "id": "aggregate-evoquip-colt-600",
              "name": "COLT 600",
              "subcategories": []
            },
            {
              "id": "aggregate-evoquip-colt-800",
              "name": "COLT 800",
              "subcategories": []
            },
            {
              "id": "aggregate-evoquip-colt-1000",
              "name": "COLT 1000",
              "subcategories": []
            },
            {
              "id": "aggregate-evoquip-colt-1600",
              "name": "COLT 1600",
              "subcategories": []
            },
            {
              "id": "aggregate-evoquip-falcon-820",
              "name": "FALCON 820",
              "subcategories": []
            },
            {
              "id": "aggregate-evoquip-falcon-1220",
              "name": "FALCON 1220",
              "subcategories": []
            },
            {
              "id": "aggregate-evoquip-falcon-1230",
              "name": "FALCON 1230",
              "subcategories": []
            },
            {
              "id": "aggregate-evoquip-harrier-750",
              "name": "HARRIER 750",
              "subcategories": []
            },
            {
              "id": "aggregate-evoquip-tc60",
              "name": "TC60",
              "subcategories": []
            },
            {
              "id": "aggregate-evoquip-tc65",
              "name": "TC65",
              "subcategories": []
            },
            {
              "id": "aggregate-evoquip-tc80",
              "name": "TC80",
              "subcategories": []
            },
            {
              "id": "aggregate-evoquip-other",
              "name": "OTHER",
              "subcategories": []
            }
          ]
        },
        {
          "id": "aggregate-excel",
          "name": "Excel",
          "subcategories": [
            {
              "id": "aggregate-excel-3-bin",
              "name": "3 BIN",
              "subcategories": []
            },
            {
              "id": "aggregate-excel-6x20",
              "name": "6X20",
              "subcategories": []
            },
            {
              "id": "aggregate-excel-30x60",
              "name": "30X60",
              "subcategories": []
            },
            {
              "id": "aggregate-excel-30x80",
              "name": "30X80",
              "subcategories": []
            },
            {
              "id": "aggregate-excel-30x100",
              "name": "30X100",
              "subcategories": []
            },
            {
              "id": "aggregate-excel-36-sbf",
              "name": "36 SBF",
              "subcategories": []
            },
            {
              "id": "aggregate-excel-36x60",
              "name": "36X60",
              "subcategories": []
            },
            {
              "id": "aggregate-excel-36x80",
              "name": "36X80",
              "subcategories": []
            },
            {
              "id": "aggregate-excel-36x100",
              "name": "36X100",
              "subcategories": []
            },
            {
              "id": "aggregate-excel-750",
              "name": "750",
              "subcategories": []
            },
            {
              "id": "aggregate-excel-1500",
              "name": "1500",
              "subcategories": []
            },
            {
              "id": "aggregate-excel-2014",
              "name": "2014",
              "subcategories": []
            },
            {
              "id": "aggregate-excel-cobra-1200",
              "name": "COBRA 1200",
              "subcategories": []
            },
            {
              "id": "aggregate-excel-grizzly-xl",
              "name": "GRIZZLY XL",
              "subcategories": []
            },
            {
              "id": "aggregate-excel-port-a-pug-iii",
              "name": "PORT-A-PUG III",
              "subcategories": []
            },
            {
              "id": "aggregate-excel-sepro-42x50",
              "name": "SEPRO 42X50",
              "subcategories": []
            },
            {
              "id": "aggregate-excel-texas-crusher",
              "name": "TEXAS CRUSHER",
              "subcategories": []
            },
            {
              "id": "aggregate-excel-xl500",
              "name": "XL500",
              "subcategories": []
            },
            {
              "id": "aggregate-excel-other",
              "name": "OTHER",
              "subcategories": []
            }
          ]
        },
        {
          "id": "aggregate-extec",
          "name": "Extec",
          "subcategories": [
            {
              "id": "aggregate-extec-8x12",
              "name": "8X12",
              "subcategories": []
            },
            {
              "id": "aggregate-extec-40-ft",
              "name": "40 FT",
              "subcategories": []
            },
            {
              "id": "aggregate-extec-160x120",
              "name": "160X120",
              "subcategories": []
            },
            {
              "id": "aggregate-extec-5000",
              "name": "5000",
              "subcategories": []
            },
            {
              "id": "aggregate-extec-6000",
              "name": "6000",
              "subcategories": []
            },
            {
              "id": "aggregate-extec-all-star",
              "name": "ALL STAR",
              "subcategories": []
            },
            {
              "id": "aggregate-extec-boxer",
              "name": "BOXER",
              "subcategories": []
            },
            {
              "id": "aggregate-extec-c10",
              "name": "C10",
              "subcategories": []
            },
            {
              "id": "aggregate-extec-c12",
              "name": "C12",
              "subcategories": []
            },
            {
              "id": "aggregate-extec-e7",
              "name": "E7",
              "subcategories": []
            },
            {
              "id": "aggregate-extec-megabite",
              "name": "MEGABITE",
              "subcategories": []
            },
            {
              "id": "aggregate-extec-robotrac",
              "name": "ROBOTRAC",
              "subcategories": []
            },
            {
              "id": "aggregate-extec-robotrac-7000",
              "name": "ROBOTRAC 7000",
              "subcategories": []
            },
            {
              "id": "aggregate-extec-s3",
              "name": "S3",
              "subcategories": []
            },
            {
              "id": "aggregate-extec-s4",
              "name": "S4",
              "subcategories": []
            },
            {
              "id": "aggregate-extec-s5",
              "name": "S5",
              "subcategories": []
            },
            {
              "id": "aggregate-extec-screen-mobile",
              "name": "SCREEN MOBILE",
              "subcategories": []
            },
            {
              "id": "aggregate-extec-turbo",
              "name": "TURBO",
              "subcategories": []
            },
            {
              "id": "aggregate-extec-turbo-trac",
              "name": "TURBO TRAC",
              "subcategories": []
            },
            {
              "id": "aggregate-extec-x44-sbs",
              "name": "X44 SBS",
              "subcategories": []
            },
            {
              "id": "aggregate-extec-other",
              "name": "OTHER",
              "subcategories": []
            }
          ]
        },
        {
          "id": "aggregate-fae",
          "name": "Fae",
          "subcategories": [
            {
              "id": "aggregate-fae-mth-225",
              "name": "MTH 225",
              "subcategories": []
            },
            {
              "id": "aggregate-fae-mtl200",
              "name": "MTL200",
              "subcategories": []
            },
            {
              "id": "aggregate-fae-mtm225",
              "name": "MTM225",
              "subcategories": []
            },
            {
              "id": "aggregate-fae-rsh-hp-200",
              "name": "RSH/HP/200",
              "subcategories": []
            },
            {
              "id": "aggregate-fae-rsl-100",
              "name": "RSL 100",
              "subcategories": []
            },
            {
              "id": "aggregate-fae-rsl-125",
              "name": "RSL 125",
              "subcategories": []
            },
            {
              "id": "aggregate-fae-rsl-150",
              "name": "RSL 150",
              "subcategories": []
            },
            {
              "id": "aggregate-fae-rsl-dt255",
              "name": "RSL/DT255",
              "subcategories": []
            },
            {
              "id": "aggregate-fae-rsm-225",
              "name": "RSM 225",
              "subcategories": []
            },
            {
              "id": "aggregate-fae-stc-125",
              "name": "STC 125",
              "subcategories": []
            },
            {
              "id": "aggregate-fae-stc-150",
              "name": "STC 150",
              "subcategories": []
            },
            {
              "id": "aggregate-fae-stc-200",
              "name": "STC 200",
              "subcategories": []
            },
            {
              "id": "aggregate-fae-stc-ssl-150",
              "name": "STC/SSL 150",
              "subcategories": []
            },
            {
              "id": "aggregate-fae-stc-dt150",
              "name": "STC/DT150",
              "subcategories": []
            },
            {
              "id": "aggregate-fae-stch-225",
              "name": "STCH 225",
              "subcategories": []
            },
            {
              "id": "aggregate-fae-stcl-125",
              "name": "STCL 125",
              "subcategories": []
            },
            {
              "id": "aggregate-fae-stcm-125",
              "name": "STCM 125",
              "subcategories": []
            },
            {
              "id": "aggregate-fae-other",
              "name": "OTHER",
              "subcategories": []
            }
          ]
        },
        {
          "id": "aggregate-finlay",
          "name": "Finlay",
          "subcategories": [
            {
              "id": "aggregate-finlay-5x12",
              "name": "5X12",
              "subcategories": []
            },
            {
              "id": "aggregate-finlay-105",
              "name": "105",
              "subcategories": []
            },
            {
              "id": "aggregate-finlay-165",
              "name": "165",
              "subcategories": []
            },
            {
              "id": "aggregate-finlay-303",
              "name": "303",
              "subcategories": []
            },
            {
              "id": "aggregate-finlay-312",
              "name": "312",
              "subcategories": []
            },
            {
              "id": "aggregate-finlay-390",
              "name": "390",
              "subcategories": []
            },
            {
              "id": "aggregate-finlay-393",
              "name": "393",
              "subcategories": []
            },
            {
              "id": "aggregate-finlay-520",
              "name": "520",
              "subcategories": []
            },
            {
              "id": "aggregate-finlay-hydragrid-590",
              "name": "HYDRAGRID 590",
              "subcategories": []
            },
            {
              "id": "aggregate-finlay-hydratrak-595",
              "name": "HYDRATRAK 595",
              "subcategories": []
            },
            {
              "id": "aggregate-finlay-683",
              "name": "683",
              "subcategories": []
            },
            {
              "id": "aggregate-finlay-683-supertrak",
              "name": "683 SUPERTRAK'",
              "subcategories": []
            },
            {
              "id": "aggregate-finlay-684-supertrak",
              "name": "684 SUPERTRAK",
              "subcategories": []
            },
            {
              "id": "aggregate-finlay-684",
              "name": "684",
              "subcategories": []
            },
            {
              "id": "aggregate-finlay-693",
              "name": "693",
              "subcategories": []
            },
            {
              "id": "aggregate-finlay-790",
              "name": "790",
              "subcategories": []
            },
            {
              "id": "aggregate-finlay-883",
              "name": "883",
              "subcategories": []
            },
            {
              "id": "aggregate-finlay-c-1540",
              "name": "C-1540",
              "subcategories": []
            },
            {
              "id": "aggregate-finlay-c-1545",
              "name": "C-1545",
              "subcategories": []
            },
            {
              "id": "aggregate-finlay-i-100rs",
              "name": "I-100RS",
              "subcategories": []
            },
            {
              "id": "aggregate-finlay-i-120rs",
              "name": "I-120RS",
              "subcategories": []
            },
            {
              "id": "aggregate-finlay-j-1160",
              "name": "J-1160",
              "subcategories": []
            },
            {
              "id": "aggregate-finlay-tr-80",
              "name": "TR-80",
              "subcategories": []
            },
            {
              "id": "aggregate-finlay-other",
              "name": "OTHER",
              "subcategories": []
            }
          ]
        },
        {
          "id": "aggregate-irock",
          "name": "Irock",
          "subcategories": [
            {
              "id": "aggregate-irock-itc38",
              "name": "ITC38",
              "subcategories": []
            },
            {
              "id": "aggregate-irock-itc200",
              "name": "ITC200",
              "subcategories": []
            },
            {
              "id": "aggregate-irock-itc300",
              "name": "ITC300",
              "subcategories": []
            },
            {
              "id": "aggregate-irock-m8036",
              "name": "M8036",
              "subcategories": []
            },
            {
              "id": "aggregate-irock-magnum-20",
              "name": "MAGNUM 20",
              "subcategories": []
            },
            {
              "id": "aggregate-irock-mt8036",
              "name": "MT8036",
              "subcategories": []
            },
            {
              "id": "aggregate-irock-mv8036",
              "name": "MV8036",
              "subcategories": []
            },
            {
              "id": "aggregate-irock-rds15",
              "name": "RDS15",
              "subcategories": []
            },
            {
              "id": "aggregate-irock-rds20",
              "name": "RDS20",
              "subcategories": []
            },
            {
              "id": "aggregate-irock-tc15",
              "name": "TC15",
              "subcategories": []
            },
            {
              "id": "aggregate-irock-tc20",
              "name": "TC20",
              "subcategories": []
            },
            {
              "id": "aggregate-irock-tj2440",
              "name": "TJ2440",
              "subcategories": []
            },
            {
              "id": "aggregate-irock-tj2745",
              "name": "TJ2745",
              "subcategories": []
            },
            {
              "id": "aggregate-irock-tj2950",
              "name": "TJ2950",
              "subcategories": []
            },
            {
              "id": "aggregate-irock-ts409",
              "name": "TS409",
              "subcategories": []
            },
            {
              "id": "aggregate-irock-ts512",
              "name": "TS512",
              "subcategories": []
            },
            {
              "id": "aggregate-irock-ts514",
              "name": "TS514",
              "subcategories": []
            },
            {
              "id": "aggregate-irock-ts516",
              "name": "TS516",
              "subcategories": []
            },
            {
              "id": "aggregate-irock-ts520",
              "name": "TS520",
              "subcategories": []
            },
            {
              "id": "aggregate-irock-ts522",
              "name": "TS522",
              "subcategories": []
            },
            {
              "id": "aggregate-irock-ts620",
              "name": "TS620",
              "subcategories": []
            },
            {
              "id": "aggregate-irock-ts4512",
              "name": "TS4512",
              "subcategories": []
            },
            {
              "id": "aggregate-irock-wjc2844",
              "name": "WJC2844",
              "subcategories": []
            },
            {
              "id": "aggregate-irock-other",
              "name": "OTHER",
              "subcategories": []
            }
          ]
        },
        {
          "id": "aggregate-iron-city-supply",
          "name": "Iron City Supply",
          "subcategories": [
            {
              "id": "aggregate-iron-city-supply-4x7",
              "name": "4X7",
              "subcategories": []
            },
            {
              "id": "aggregate-iron-city-supply-5x10",
              "name": "5X10",
              "subcategories": []
            },
            {
              "id": "aggregate-iron-city-supply-5x11",
              "name": "5X11",
              "subcategories": []
            },
            {
              "id": "aggregate-iron-city-supply-5x14",
              "name": "5X14",
              "subcategories": []
            },
            {
              "id": "aggregate-iron-city-supply-6-5x10",
              "name": "6.5X10",
              "subcategories": []
            },
            {
              "id": "aggregate-iron-city-supply-8x12",
              "name": "8X12",
              "subcategories": []
            },
            {
              "id": "aggregate-iron-city-supply-8x16",
              "name": "8X16",
              "subcategories": []
            },
            {
              "id": "aggregate-iron-city-supply-18x40",
              "name": "18X40",
              "subcategories": []
            },
            {
              "id": "aggregate-iron-city-supply-24x20",
              "name": "24X20",
              "subcategories": []
            },
            {
              "id": "aggregate-iron-city-supply-24x40",
              "name": "24X40",
              "subcategories": []
            },
            {
              "id": "aggregate-iron-city-supply-24x45",
              "name": "24X45",
              "subcategories": []
            },
            {
              "id": "aggregate-iron-city-supply-24x50",
              "name": "24X50",
              "subcategories": []
            },
            {
              "id": "aggregate-iron-city-supply-24x60",
              "name": "24X60",
              "subcategories": []
            },
            {
              "id": "aggregate-iron-city-supply-24x80",
              "name": "24X80",
              "subcategories": []
            },
            {
              "id": "aggregate-iron-city-supply-24x100",
              "name": "24X100",
              "subcategories": []
            },
            {
              "id": "aggregate-iron-city-supply-24x120",
              "name": "24X120",
              "subcategories": []
            },
            {
              "id": "aggregate-iron-city-supply-30-in",
              "name": "30 IN",
              "subcategories": []
            },
            {
              "id": "aggregate-iron-city-supply-30rcu",
              "name": "30RCU",
              "subcategories": []
            },
            {
              "id": "aggregate-iron-city-supply-30x20",
              "name": "30X20",
              "subcategories": []
            },
            {
              "id": "aggregate-iron-city-supply-30x30",
              "name": "30X30",
              "subcategories": []
            },
            {
              "id": "aggregate-iron-city-supply-30x40",
              "name": "30X40",
              "subcategories": []
            },
            {
              "id": "aggregate-iron-city-supply-30x50",
              "name": "30X50",
              "subcategories": []
            },
            {
              "id": "aggregate-iron-city-supply-30x60",
              "name": "30X60",
              "subcategories": []
            },
            {
              "id": "aggregate-iron-city-supply-30x80",
              "name": "30X80",
              "subcategories": []
            },
            {
              "id": "aggregate-iron-city-supply-30x100",
              "name": "30X100",
              "subcategories": []
            },
            {
              "id": "aggregate-iron-city-supply-30x110",
              "name": "30X110",
              "subcategories": []
            },
            {
              "id": "aggregate-iron-city-supply-36-in",
              "name": "36 IN",
              "subcategories": []
            },
            {
              "id": "aggregate-iron-city-supply-36x20",
              "name": "36X20",
              "subcategories": []
            },
            {
              "id": "aggregate-iron-city-supply-36x36",
              "name": "36X36",
              "subcategories": []
            },
            {
              "id": "aggregate-iron-city-supply-36x40",
              "name": "36X40",
              "subcategories": []
            },
            {
              "id": "aggregate-iron-city-supply-36x50",
              "name": "36X50",
              "subcategories": []
            },
            {
              "id": "aggregate-iron-city-supply-36x60",
              "name": "36X60",
              "subcategories": []
            },
            {
              "id": "aggregate-iron-city-supply-36x80",
              "name": "36X80",
              "subcategories": []
            },
            {
              "id": "aggregate-iron-city-supply-36x100",
              "name": "36X100",
              "subcategories": []
            },
            {
              "id": "aggregate-iron-city-supply-36x120",
              "name": "36X120",
              "subcategories": []
            },
            {
              "id": "aggregate-iron-city-supply-36x150",
              "name": "36X150",
              "subcategories": []
            },
            {
              "id": "aggregate-iron-city-supply-42-in",
              "name": "42 IN",
              "subcategories": []
            },
            {
              "id": "aggregate-iron-city-supply-42x60",
              "name": "42X60",
              "subcategories": []
            },
            {
              "id": "aggregate-iron-city-supply-42x80",
              "name": "42X80",
              "subcategories": []
            },
            {
              "id": "aggregate-iron-city-supply-42x100",
              "name": "42X100",
              "subcategories": []
            },
            {
              "id": "aggregate-iron-city-supply-42x110",
              "name": "42X110",
              "subcategories": []
            },
            {
              "id": "aggregate-iron-city-supply-48x48",
              "name": "48X48",
              "subcategories": []
            },
            {
              "id": "aggregate-iron-city-supply-48x60",
              "name": "48X60",
              "subcategories": []
            },
            {
              "id": "aggregate-iron-city-supply-48x80",
              "name": "48X80",
              "subcategories": []
            },
            {
              "id": "aggregate-iron-city-supply-48x100",
              "name": "48X100",
              "subcategories": []
            },
            {
              "id": "aggregate-iron-city-supply-48-edu",
              "name": "48 EDU",
              "subcategories": []
            },
            {
              "id": "aggregate-iron-city-supply-48-ed-dou",
              "name": "48 ED DOU",
              "subcategories": []
            },
            {
              "id": "aggregate-iron-city-supply-48-hd-rcu",
              "name": "48 HD RCU",
              "subcategories": []
            },
            {
              "id": "aggregate-iron-city-supply-other",
              "name": "OTHER",
              "subcategories": []
            }
          ]
        },
        {
          "id": "aggregate-jci",
          "name": "Jci",
          "subcategories": [
            {
              "id": "aggregate-jci-6x20",
              "name": "6X20",
              "subcategories": []
            },
            {
              "id": "aggregate-jci-7x20",
              "name": "7X20",
              "subcategories": []
            },
            {
              "id": "aggregate-jci-8x20",
              "name": "8X20",
              "subcategories": []
            },
            {
              "id": "aggregate-jci-6203",
              "name": "6203",
              "subcategories": []
            },
            {
              "id": "aggregate-jci-7203",
              "name": "7203",
              "subcategories": []
            },
            {
              "id": "aggregate-jci-8203",
              "name": "8203",
              "subcategories": []
            },
            {
              "id": "aggregate-jci-ft6203",
              "name": "FT6203",
              "subcategories": []
            },
            {
              "id": "aggregate-jci-kodiak-k400",
              "name": "KODIAK K400",
              "subcategories": []
            },
            {
              "id": "aggregate-jci-kodiak-200",
              "name": "KODIAK 200",
              "subcategories": []
            },
            {
              "id": "aggregate-jci-kodiak-400",
              "name": "KODIAK 400",
              "subcategories": []
            },
            {
              "id": "aggregate-jci-other",
              "name": "OTHER",
              "subcategories": []
            }
          ]
        },
        {
          "id": "aggregate-jp-conveyors",
          "name": "Jp Conveyors",
          "subcategories": [
            {
              "id": "aggregate-jp-conveyors-8x14",
              "name": "8X14",
              "subcategories": []
            },
            {
              "id": "aggregate-jp-conveyors-14x60",
              "name": "14X60",
              "subcategories": []
            },
            {
              "id": "aggregate-jp-conveyors-24x60",
              "name": "24X60",
              "subcategories": []
            },
            {
              "id": "aggregate-jp-conveyors-36x30",
              "name": "36X30",
              "subcategories": []
            },
            {
              "id": "aggregate-jp-conveyors-36x40",
              "name": "36X40",
              "subcategories": []
            },
            {
              "id": "aggregate-jp-conveyors-36x60",
              "name": "36X60",
              "subcategories": []
            },
            {
              "id": "aggregate-jp-conveyors-36x80",
              "name": "36X80",
              "subcategories": []
            },
            {
              "id": "aggregate-jp-conveyors-36x100",
              "name": "36X100",
              "subcategories": []
            },
            {
              "id": "aggregate-jp-conveyors-42x40",
              "name": "42X40",
              "subcategories": []
            },
            {
              "id": "aggregate-jp-conveyors-42x60",
              "name": "42X60",
              "subcategories": []
            },
            {
              "id": "aggregate-jp-conveyors-other",
              "name": "OTHER",
              "subcategories": []
            }
          ]
        },
        {
          "id": "aggregate-kafka",
          "name": "Kafka",
          "subcategories": [
            {
              "id": "aggregate-kafka-8x14",
              "name": "8X14",
              "subcategories": []
            },
            {
              "id": "aggregate-kafka-9x16",
              "name": "9X16",
              "subcategories": []
            },
            {
              "id": "aggregate-kafka-19x10",
              "name": "19X10",
              "subcategories": []
            },
            {
              "id": "aggregate-kafka-30x60",
              "name": "30X60",
              "subcategories": []
            },
            {
              "id": "aggregate-kafka-30x80",
              "name": "30X80",
              "subcategories": []
            },
            {
              "id": "aggregate-kafka-36x50",
              "name": "36X50",
              "subcategories": []
            },
            {
              "id": "aggregate-kafka-36x60",
              "name": "36X60",
              "subcategories": []
            },
            {
              "id": "aggregate-kafka-36x80",
              "name": "36X80",
              "subcategories": []
            },
            {
              "id": "aggregate-kafka-36x100",
              "name": "36X100",
              "subcategories": []
            },
            {
              "id": "aggregate-kafka-36x125",
              "name": "36X125",
              "subcategories": []
            },
            {
              "id": "aggregate-kafka-42x60",
              "name": "42X60",
              "subcategories": []
            },
            {
              "id": "aggregate-kafka-48x50",
              "name": "48X50",
              "subcategories": []
            },
            {
              "id": "aggregate-kafka-60x65",
              "name": "60X65",
              "subcategories": []
            },
            {
              "id": "aggregate-kafka-80-ft",
              "name": "80 FT",
              "subcategories": []
            },
            {
              "id": "aggregate-kafka-other",
              "name": "OTHER",
              "subcategories": []
            }
          ]
        },
        {
          "id": "aggregate-keestra",
          "name": "Keestra",
          "subcategories": []
        },
        {
          "id": "aggregate-komplet",
          "name": "Komplet",
          "subcategories": [
            {
              "id": "aggregate-komplet-ds1020",
              "name": "DS1020",
              "subcategories": []
            },
            {
              "id": "aggregate-komplet-dst1020",
              "name": "DST1020",
              "subcategories": []
            },
            {
              "id": "aggregate-komplet-k-ic70",
              "name": "K-IC70",
              "subcategories": []
            },
            {
              "id": "aggregate-komplet-k-jc503",
              "name": "K-JC503",
              "subcategories": []
            },
            {
              "id": "aggregate-komplet-k-jc604",
              "name": "K-JC604",
              "subcategories": []
            },
            {
              "id": "aggregate-komplet-k-jc704",
              "name": "K-JC704",
              "subcategories": []
            },
            {
              "id": "aggregate-komplet-k-jc704",
              "name": "K-JC704+",
              "subcategories": []
            },
            {
              "id": "aggregate-komplet-k-jc805",
              "name": "K-JC805",
              "subcategories": []
            },
            {
              "id": "aggregate-komplet-k-tc460",
              "name": "K-TC460",
              "subcategories": []
            },
            {
              "id": "aggregate-komplet-k-ts30",
              "name": "K-TS30",
              "subcategories": []
            },
            {
              "id": "aggregate-komplet-kompatto-104",
              "name": "KOMPATTO 104",
              "subcategories": []
            },
            {
              "id": "aggregate-komplet-kompatto-5030",
              "name": "KOMPATTO 5030",
              "subcategories": []
            },
            {
              "id": "aggregate-komplet-kompatto-221",
              "name": "KOMPATTO 221",
              "subcategories": []
            },
            {
              "id": "aggregate-komplet-kompatto-sc-221",
              "name": "KOMPATTO SC 221",
              "subcategories": []
            },
            {
              "id": "aggregate-komplet-kompatto-tb-3400",
              "name": "KOMPATTO TB 3400",
              "subcategories": []
            },
            {
              "id": "aggregate-komplet-lem-4825",
              "name": "LEM 4825",
              "subcategories": []
            },
            {
              "id": "aggregate-komplet-lem-track-4825",
              "name": "LEM TRACK 4825",
              "subcategories": []
            },
            {
              "id": "aggregate-komplet-other",
              "name": "OTHER",
              "subcategories": []
            }
          ]
        },
        {
          "id": "aggregate-kpi-jci",
          "name": "Kpi-Jci",
          "subcategories": [
            {
              "id": "aggregate-kpi-jci-5x16",
              "name": "5X16",
              "subcategories": []
            },
            {
              "id": "aggregate-kpi-jci-45x40",
              "name": "45X40",
              "subcategories": []
            },
            {
              "id": "aggregate-kpi-jci-50x20",
              "name": "50X20",
              "subcategories": []
            },
            {
              "id": "aggregate-kpi-jci-942",
              "name": "942",
              "subcategories": []
            },
            {
              "id": "aggregate-kpi-jci-1400",
              "name": "1400",
              "subcategories": []
            },
            {
              "id": "aggregate-kpi-jci-1822",
              "name": "1822",
              "subcategories": []
            },
            {
              "id": "aggregate-kpi-jci-2148",
              "name": "2148",
              "subcategories": []
            },
            {
              "id": "aggregate-kpi-jci-5044",
              "name": "5044",
              "subcategories": []
            },
            {
              "id": "aggregate-kpi-jci-6048",
              "name": "6048",
              "subcategories": []
            },
            {
              "id": "aggregate-kpi-jci-6203",
              "name": "6203",
              "subcategories": []
            },
            {
              "id": "aggregate-kpi-jci-7008",
              "name": "7008",
              "subcategories": []
            },
            {
              "id": "aggregate-kpi-jci-3055",
              "name": "3055",
              "subcategories": []
            },
            {
              "id": "aggregate-kpi-jci-6036",
              "name": "6036",
              "subcategories": []
            },
            {
              "id": "aggregate-kpi-jci-3048",
              "name": "3048",
              "subcategories": []
            },
            {
              "id": "aggregate-kpi-jci-6203",
              "name": "6203",
              "subcategories": []
            },
            {
              "id": "aggregate-kpi-jci-cs2650",
              "name": "CS2650",
              "subcategories": []
            },
            {
              "id": "aggregate-kpi-jci-cs3144",
              "name": "CS3144",
              "subcategories": []
            },
            {
              "id": "aggregate-kpi-jci-ft300",
              "name": "FT300",
              "subcategories": []
            },
            {
              "id": "aggregate-kpi-jci-ft2650",
              "name": "FT2650",
              "subcategories": []
            },
            {
              "id": "aggregate-kpi-jci-ft3055",
              "name": "FT3055",
              "subcategories": []
            },
            {
              "id": "aggregate-kpi-jci-ft4240",
              "name": "FT4240",
              "subcategories": []
            },
            {
              "id": "aggregate-kpi-jci-ft4250",
              "name": "FT4250",
              "subcategories": []
            },
            {
              "id": "aggregate-kpi-jci-ft5260",
              "name": "FT5260",
              "subcategories": []
            },
            {
              "id": "aggregate-kpi-jci-gt104",
              "name": "GT104",
              "subcategories": []
            },
            {
              "id": "aggregate-kpi-jci-gt125",
              "name": "GT125",
              "subcategories": []
            },
            {
              "id": "aggregate-kpi-jci-gt206",
              "name": "GT206",
              "subcategories": []
            },
            {
              "id": "aggregate-kpi-jci-gt145",
              "name": "GT145",
              "subcategories": []
            },
            {
              "id": "aggregate-kpi-jci-gt165",
              "name": "GT165",
              "subcategories": []
            },
            {
              "id": "aggregate-kpi-jci-gt205",
              "name": "GT205",
              "subcategories": []
            },
            {
              "id": "aggregate-kpi-jci-gt440",
              "name": "GT440",
              "subcategories": []
            },
            {
              "id": "aggregate-kpi-jci-gt4280",
              "name": "GT4280",
              "subcategories": []
            },
            {
              "id": "aggregate-kpi-jci-gw205",
              "name": "GW205",
              "subcategories": []
            },
            {
              "id": "aggregate-kpi-jci-kodiak-k300",
              "name": "KODIAK K300",
              "subcategories": []
            },
            {
              "id": "aggregate-kpi-jci-kodiak-k350",
              "name": "KODIAK K350+",
              "subcategories": []
            },
            {
              "id": "aggregate-kpi-jci-kodiak-k400",
              "name": "KODIAK K400",
              "subcategories": []
            },
            {
              "id": "aggregate-kpi-jci-kodiak-k400pm",
              "name": "KODIAK K400PM",
              "subcategories": []
            },
            {
              "id": "aggregate-kpi-jci-vs5054",
              "name": "VS5054",
              "subcategories": []
            },
            {
              "id": "aggregate-kpi-jci-other",
              "name": "OTHER",
              "subcategories": []
            }
          ]
        },
        {
          "id": "aggregate-lippman",
          "name": "Lippman",
          "subcategories": []
        },
        {
          "id": "aggregate-masaba",
          "name": "Masaba",
          "subcategories": [
            {
              "id": "aggregate-masaba-3-bin",
              "name": "3 BIN",
              "subcategories": []
            },
            {
              "id": "aggregate-masaba-5x16",
              "name": "5X16",
              "subcategories": []
            },
            {
              "id": "aggregate-masaba-6x20",
              "name": "6X20",
              "subcategories": []
            },
            {
              "id": "aggregate-masaba-7x20",
              "name": "7X20",
              "subcategories": []
            },
            {
              "id": "aggregate-masaba-8x16",
              "name": "8X16",
              "subcategories": []
            },
            {
              "id": "aggregate-masaba-8x20",
              "name": "8X20",
              "subcategories": []
            },
            {
              "id": "aggregate-masaba-9x16",
              "name": "9X16",
              "subcategories": []
            },
            {
              "id": "aggregate-masaba-10x14",
              "name": "10X14",
              "subcategories": []
            },
            {
              "id": "aggregate-masaba-10x16",
              "name": "10X16",
              "subcategories": []
            },
            {
              "id": "aggregate-masaba-36x25",
              "name": "36X25",
              "subcategories": []
            },
            {
              "id": "aggregate-masaba-36x60",
              "name": "36X60",
              "subcategories": []
            },
            {
              "id": "aggregate-masaba-36x70",
              "name": "36X70",
              "subcategories": []
            },
            {
              "id": "aggregate-masaba-36x80",
              "name": "36X80",
              "subcategories": []
            },
            {
              "id": "aggregate-masaba-36x85",
              "name": "36X85",
              "subcategories": []
            },
            {
              "id": "aggregate-masaba-36x100",
              "name": "36X100",
              "subcategories": []
            },
            {
              "id": "aggregate-masaba-36x125",
              "name": "36X125",
              "subcategories": []
            },
            {
              "id": "aggregate-masaba-36x140",
              "name": "36X140",
              "subcategories": []
            },
            {
              "id": "aggregate-masaba-36x150",
              "name": "36X150",
              "subcategories": []
            },
            {
              "id": "aggregate-masaba-42x125",
              "name": "42X125",
              "subcategories": []
            },
            {
              "id": "aggregate-masaba-42x150",
              "name": "42X150",
              "subcategories": []
            },
            {
              "id": "aggregate-masaba-48-in",
              "name": "48 IN",
              "subcategories": []
            },
            {
              "id": "aggregate-masaba-6203",
              "name": "6203",
              "subcategories": []
            },
            {
              "id": "aggregate-masaba-c120",
              "name": "C120",
              "subcategories": []
            },
            {
              "id": "aggregate-masaba-hp300",
              "name": "HP300",
              "subcategories": []
            },
            {
              "id": "aggregate-masaba-tu48",
              "name": "TU48",
              "subcategories": []
            },
            {
              "id": "aggregate-masaba-other",
              "name": "OTHER",
              "subcategories": []
            }
          ]
        },
        {
          "id": "aggregate-mds",
          "name": "Mds",
          "subcategories": [
            {
              "id": "aggregate-mds-m300",
              "name": "M300",
              "subcategories": []
            },
            {
              "id": "aggregate-mds-m412",
              "name": "M412",
              "subcategories": []
            },
            {
              "id": "aggregate-mds-m413",
              "name": "M413",
              "subcategories": []
            },
            {
              "id": "aggregate-mds-m515",
              "name": "M515",
              "subcategories": []
            },
            {
              "id": "aggregate-mds-m518",
              "name": "M518",
              "subcategories": []
            },
            {
              "id": "aggregate-mds-m616",
              "name": "M616",
              "subcategories": []
            },
            {
              "id": "aggregate-mds-mt15",
              "name": "MT15",
              "subcategories": []
            },
            {
              "id": "aggregate-mds-mt18",
              "name": "MT18",
              "subcategories": []
            },
            {
              "id": "aggregate-mds-other",
              "name": "OTHER",
              "subcategories": []
            }
          ]
        },
        {
          "id": "aggregate-nordberg",
          "name": "Nordberg",
          "subcategories": [
            {
              "id": "aggregate-nordberg-3-ft",
              "name": "3 FT",
              "subcategories": []
            },
            {
              "id": "aggregate-nordberg-4-25",
              "name": "4.25",
              "subcategories": []
            },
            {
              "id": "aggregate-nordberg-20x48",
              "name": "20X48",
              "subcategories": []
            },
            {
              "id": "aggregate-nordberg-32x40",
              "name": "32X40",
              "subcategories": []
            },
            {
              "id": "aggregate-nordberg-42x200",
              "name": "42X200",
              "subcategories": []
            },
            {
              "id": "aggregate-nordberg-43x52",
              "name": "43X52",
              "subcategories": []
            },
            {
              "id": "aggregate-nordberg-51-in",
              "name": "51 IN",
              "subcategories": []
            },
            {
              "id": "aggregate-nordberg-54-in",
              "name": "54 IN",
              "subcategories": []
            },
            {
              "id": "aggregate-nordberg-100-ft",
              "name": "100 FT",
              "subcategories": []
            },
            {
              "id": "aggregate-nordberg-1415",
              "name": "1415",
              "subcategories": []
            },
            {
              "id": "aggregate-nordberg-c100",
              "name": "C100",
              "subcategories": []
            },
            {
              "id": "aggregate-nordberg-c125",
              "name": "C125",
              "subcategories": []
            },
            {
              "id": "aggregate-nordberg-c140",
              "name": "C140",
              "subcategories": []
            },
            {
              "id": "aggregate-nordberg-gp11f",
              "name": "GP11F",
              "subcategories": []
            },
            {
              "id": "aggregate-nordberg-gp11fm",
              "name": "GP11FM",
              "subcategories": []
            },
            {
              "id": "aggregate-nordberg-hp200",
              "name": "HP200",
              "subcategories": []
            },
            {
              "id": "aggregate-nordberg-hp300",
              "name": "HP300",
              "subcategories": []
            },
            {
              "id": "aggregate-nordberg-hp400",
              "name": "HP400",
              "subcategories": []
            },
            {
              "id": "aggregate-nordberg-lt105",
              "name": "LT105",
              "subcategories": []
            },
            {
              "id": "aggregate-nordberg-lt110",
              "name": "LT110",
              "subcategories": []
            },
            {
              "id": "aggregate-nordberg-lt1213",
              "name": "LT1213",
              "subcategories": []
            },
            {
              "id": "aggregate-nordberg-np1415",
              "name": "NP1415",
              "subcategories": []
            },
            {
              "id": "aggregate-nordberg-omnicone-1560",
              "name": "OMNICONE 1560",
              "subcategories": []
            },
            {
              "id": "aggregate-nordberg-st352",
              "name": "ST352",
              "subcategories": []
            },
            {
              "id": "aggregate-nordberg-st620",
              "name": "ST620",
              "subcategories": []
            },
            {
              "id": "aggregate-nordberg-sw348",
              "name": "SW348",
              "subcategories": []
            },
            {
              "id": "aggregate-nordberg-vi400",
              "name": "VI400",
              "subcategories": []
            },
            {
              "id": "aggregate-nordberg-wf500",
              "name": "WF500",
              "subcategories": []
            },
            {
              "id": "aggregate-nordberg-other",
              "name": "OTHER",
              "subcategories": []
            }
          ]
        },
        {
          "id": "aggregate-pioneer",
          "name": "Pioneer",
          "subcategories": [
            {
              "id": "aggregate-pioneer-2-deck",
              "name": "2 DECK",
              "subcategories": []
            },
            {
              "id": "aggregate-pioneer-4x9",
              "name": "4X9",
              "subcategories": []
            },
            {
              "id": "aggregate-pioneer-4x10",
              "name": "4X10",
              "subcategories": []
            },
            {
              "id": "aggregate-pioneer-5x16",
              "name": "5X16",
              "subcategories": []
            },
            {
              "id": "aggregate-pioneer-6x16",
              "name": "6X16",
              "subcategories": []
            },
            {
              "id": "aggregate-pioneer-6x20",
              "name": "6X20",
              "subcategories": []
            },
            {
              "id": "aggregate-pioneer-6x16",
              "name": "6X16",
              "subcategories": []
            },
            {
              "id": "aggregate-pioneer-6x163d",
              "name": "6X163D",
              "subcategories": []
            },
            {
              "id": "aggregate-pioneer-10x36",
              "name": "10X36",
              "subcategories": []
            },
            {
              "id": "aggregate-pioneer-15x36",
              "name": "15X36",
              "subcategories": []
            },
            {
              "id": "aggregate-pioneer-18x30",
              "name": "18X30",
              "subcategories": []
            },
            {
              "id": "aggregate-pioneer-22x48",
              "name": "22X48",
              "subcategories": []
            },
            {
              "id": "aggregate-pioneer-30x42",
              "name": "30X42",
              "subcategories": []
            },
            {
              "id": "aggregate-pioneer-36-in",
              "name": "36 IN",
              "subcategories": []
            },
            {
              "id": "aggregate-pioneer-40x30",
              "name": "40X30",
              "subcategories": []
            },
            {
              "id": "aggregate-pioneer-54-in",
              "name": "54 IN",
              "subcategories": []
            },
            {
              "id": "aggregate-pioneer-54x24",
              "name": "54X24",
              "subcategories": []
            },
            {
              "id": "aggregate-pioneer-60x20",
              "name": "60X20",
              "subcategories": []
            },
            {
              "id": "aggregate-pioneer-271",
              "name": "271",
              "subcategories": []
            },
            {
              "id": "aggregate-pioneer-1948",
              "name": "1948",
              "subcategories": []
            },
            {
              "id": "aggregate-pioneer-2500",
              "name": "2500",
              "subcategories": []
            },
            {
              "id": "aggregate-pioneer-2854",
              "name": "2854",
              "subcategories": []
            },
            {
              "id": "aggregate-pioneer-3042",
              "name": "3042",
              "subcategories": []
            },
            {
              "id": "aggregate-pioneer-4022",
              "name": "4022",
              "subcategories": []
            },
            {
              "id": "aggregate-pioneer-4030",
              "name": "4030",
              "subcategories": []
            },
            {
              "id": "aggregate-pioneer-4240",
              "name": "4240",
              "subcategories": []
            },
            {
              "id": "aggregate-pioneer-4654",
              "name": "4654",
              "subcategories": []
            },
            {
              "id": "aggregate-pioneer-5424",
              "name": "5424",
              "subcategories": []
            },
            {
              "id": "aggregate-pioneer-ft2650",
              "name": "FT2650",
              "subcategories": []
            },
            {
              "id": "aggregate-pioneer-ft4250",
              "name": "FT4250",
              "subcategories": []
            },
            {
              "id": "aggregate-pioneer-texas",
              "name": "TEXAS",
              "subcategories": []
            },
            {
              "id": "aggregate-pioneer-other",
              "name": "OTHER",
              "subcategories": []
            }
          ]
        },
        {
          "id": "aggregate-rock-systems",
          "name": "Rock Systems",
          "subcategories": [
            {
              "id": "aggregate-rock-systems-24x40",
              "name": "24X40",
              "subcategories": []
            },
            {
              "id": "aggregate-rock-systems-48x25",
              "name": "48X25",
              "subcategories": []
            },
            {
              "id": "aggregate-rock-systems-102",
              "name": "102",
              "subcategories": []
            },
            {
              "id": "aggregate-rock-systems-105",
              "name": "105",
              "subcategories": []
            },
            {
              "id": "aggregate-rock-systems-501",
              "name": "501",
              "subcategories": []
            },
            {
              "id": "aggregate-rock-systems-802",
              "name": "802",
              "subcategories": []
            },
            {
              "id": "aggregate-rock-systems-p104-lp",
              "name": "P104-LP",
              "subcategories": []
            },
            {
              "id": "aggregate-rock-systems-other",
              "name": "OTHER",
              "subcategories": []
            }
          ]
        },
        {
          "id": "aggregate-rubble-master",
          "name": "Rubble Master",
          "subcategories": [
            {
              "id": "aggregate-rubble-master-hs3500",
              "name": "HS3500",
              "subcategories": []
            },
            {
              "id": "aggregate-rubble-master-hs5000",
              "name": "HS5000",
              "subcategories": []
            },
            {
              "id": "aggregate-rubble-master-hs7500",
              "name": "HS7500",
              "subcategories": []
            },
            {
              "id": "aggregate-rubble-master-hs11000",
              "name": "HS11000",
              "subcategories": []
            },
            {
              "id": "aggregate-rubble-master-msc8500",
              "name": "MSC8500",
              "subcategories": []
            },
            {
              "id": "aggregate-rubble-master-msc10500",
              "name": "MSC10500",
              "subcategories": []
            },
            {
              "id": "aggregate-rubble-master-mts2410",
              "name": "MTS2410",
              "subcategories": []
            },
            {
              "id": "aggregate-rubble-master-mxj",
              "name": "MXJ",
              "subcategories": []
            },
            {
              "id": "aggregate-rubble-master-mws2409us",
              "name": "MWS2409US",
              "subcategories": []
            },
            {
              "id": "aggregate-rubble-master-rm60",
              "name": "RM60",
              "subcategories": []
            },
            {
              "id": "aggregate-rubble-master-rm70goi",
              "name": "RM70GOI",
              "subcategories": []
            },
            {
              "id": "aggregate-rubble-master-rm80",
              "name": "RM80",
              "subcategories": []
            },
            {
              "id": "aggregate-rubble-master-rm80goi",
              "name": "RM80GOI",
              "subcategories": []
            },
            {
              "id": "aggregate-rubble-master-rm90goi",
              "name": "RM90GOI",
              "subcategories": []
            },
            {
              "id": "aggregate-rubble-master-rm100",
              "name": "RM100",
              "subcategories": []
            },
            {
              "id": "aggregate-rubble-master-rm100goi",
              "name": "RM100GOI",
              "subcategories": []
            },
            {
              "id": "aggregate-rubble-master-rm120goi",
              "name": "RM120GOI",
              "subcategories": []
            },
            {
              "id": "aggregate-rubble-master-rm12ox",
              "name": "RM12OX",
              "subcategories": []
            },
            {
              "id": "aggregate-rubble-master-rmj110x",
              "name": "RMJ110X",
              "subcategories": []
            },
            {
              "id": "aggregate-rubble-master-rm-hs11000m",
              "name": "RM HS11000M",
              "subcategories": []
            },
            {
              "id": "aggregate-rubble-master-other",
              "name": "OTHER",
              "subcategories": []
            }
          ]
        },
        {
          "id": "aggregate-screen-machine",
          "name": "Screen Machine",
          "subcategories": [
            {
              "id": "aggregate-screen-machine-6x12",
              "name": "6X12",
              "subcategories": []
            },
            {
              "id": "aggregate-screen-machine-36x60",
              "name": "36X60",
              "subcategories": []
            },
            {
              "id": "aggregate-screen-machine-516t",
              "name": "516T",
              "subcategories": []
            },
            {
              "id": "aggregate-screen-machine-612",
              "name": "612",
              "subcategories": []
            },
            {
              "id": "aggregate-screen-machine-621",
              "name": "621",
              "subcategories": []
            },
            {
              "id": "aggregate-screen-machine-4043",
              "name": "4043",
              "subcategories": []
            },
            {
              "id": "aggregate-screen-machine-6036",
              "name": "6036",
              "subcategories": []
            },
            {
              "id": "aggregate-screen-machine-8042",
              "name": "8042",
              "subcategories": []
            },
            {
              "id": "aggregate-screen-machine-achiever-46",
              "name": "ACHIEVER 46",
              "subcategories": []
            },
            {
              "id": "aggregate-screen-machine-ch40",
              "name": "CH40",
              "subcategories": []
            },
            {
              "id": "aggregate-screen-machine-developer",
              "name": "DEVELOPER",
              "subcategories": []
            },
            {
              "id": "aggregate-screen-machine-jxt",
              "name": "JXT",
              "subcategories": []
            },
            {
              "id": "aggregate-screen-machine-producer",
              "name": "PRODUCER",
              "subcategories": []
            },
            {
              "id": "aggregate-screen-machine-scalper-77c",
              "name": "SCALPER 77C",
              "subcategories": []
            },
            {
              "id": "aggregate-screen-machine-scalper-107c",
              "name": "SCALPER 107C",
              "subcategories": []
            },
            {
              "id": "aggregate-screen-machine-scalper-107d",
              "name": "SCALPER 107D",
              "subcategories": []
            },
            {
              "id": "aggregate-screen-machine-scalper-107t",
              "name": "SCALPER 107T",
              "subcategories": []
            },
            {
              "id": "aggregate-screen-machine-spyder-512t",
              "name": "SPYDER 512T",
              "subcategories": []
            },
            {
              "id": "aggregate-screen-machine-spyder-514ts",
              "name": "SPYDER 514TS",
              "subcategories": []
            },
            {
              "id": "aggregate-screen-machine-spyder-514ts3",
              "name": "SPYDER 514TS3",
              "subcategories": []
            },
            {
              "id": "aggregate-screen-machine-spyder-516t",
              "name": "SPYDER 516T",
              "subcategories": []
            },
            {
              "id": "aggregate-screen-machine-5620ts3",
              "name": "5620TS3",
              "subcategories": []
            },
            {
              "id": "aggregate-screen-machine-spyder622",
              "name": "SPYDER622",
              "subcategories": []
            },
            {
              "id": "aggregate-screen-machine-th80",
              "name": "TH80",
              "subcategories": []
            },
            {
              "id": "aggregate-screen-machine-th3680",
              "name": "TH3680",
              "subcategories": []
            },
            {
              "id": "aggregate-screen-machine-other",
              "name": "OTHER",
              "subcategories": []
            }
          ]
        },
        {
          "id": "aggregate-screenpod",
          "name": "Screenpod",
          "subcategories": []
        },
        {
          "id": "aggregate-simplicity",
          "name": "Simplicity",
          "subcategories": [
            {
              "id": "aggregate-simplicity-3-deck",
              "name": "3 DECK",
              "subcategories": []
            },
            {
              "id": "aggregate-simplicity-3x10",
              "name": "3X10",
              "subcategories": []
            },
            {
              "id": "aggregate-simplicity-3x14",
              "name": "3X14",
              "subcategories": []
            },
            {
              "id": "aggregate-simplicity-4x14",
              "name": "4X14",
              "subcategories": []
            },
            {
              "id": "aggregate-simplicity-5x10",
              "name": "5X10",
              "subcategories": []
            },
            {
              "id": "aggregate-simplicity-5x12",
              "name": "5X12",
              "subcategories": []
            },
            {
              "id": "aggregate-simplicity-5x16",
              "name": "5X16",
              "subcategories": []
            },
            {
              "id": "aggregate-simplicity-6x16",
              "name": "6X16",
              "subcategories": []
            },
            {
              "id": "aggregate-simplicity-6x20",
              "name": "6X20",
              "subcategories": []
            },
            {
              "id": "aggregate-simplicity-7x20",
              "name": "7X20",
              "subcategories": []
            },
            {
              "id": "aggregate-simplicity-8x20",
              "name": "8X20",
              "subcategories": []
            },
            {
              "id": "aggregate-simplicity-8x24",
              "name": "8X24",
              "subcategories": []
            },
            {
              "id": "aggregate-simplicity-20x6",
              "name": "20X6",
              "subcategories": []
            },
            {
              "id": "aggregate-simplicity-24x45",
              "name": "24X45",
              "subcategories": []
            },
            {
              "id": "aggregate-simplicity-45x18",
              "name": "45X18",
              "subcategories": []
            },
            {
              "id": "aggregate-simplicity-3624",
              "name": "3624",
              "subcategories": []
            },
            {
              "id": "aggregate-simplicity-3816",
              "name": "3816",
              "subcategories": []
            },
            {
              "id": "aggregate-simplicity-6203",
              "name": "6203",
              "subcategories": []
            },
            {
              "id": "aggregate-simplicity-other",
              "name": "OTHER",
              "subcategories": []
            }
          ]
        },
        {
          "id": "aggregate-tci",
          "name": "Tci",
          "subcategories": [
            {
              "id": "aggregate-tci-3-bin",
              "name": "3 BIN",
              "subcategories": []
            },
            {
              "id": "aggregate-tci-6x18",
              "name": "6X18",
              "subcategories": []
            },
            {
              "id": "aggregate-tci-6x20",
              "name": "6X20",
              "subcategories": []
            },
            {
              "id": "aggregate-tci-6x24",
              "name": "6X24",
              "subcategories": []
            },
            {
              "id": "aggregate-tci-8x16",
              "name": "8X16",
              "subcategories": []
            },
            {
              "id": "aggregate-tci-30x40",
              "name": "30X40",
              "subcategories": []
            },
            {
              "id": "aggregate-tci-30x50",
              "name": "30X50",
              "subcategories": []
            },
            {
              "id": "aggregate-tci-30x70",
              "name": "30X70",
              "subcategories": []
            },
            {
              "id": "aggregate-tci-36x25",
              "name": "36X25",
              "subcategories": []
            },
            {
              "id": "aggregate-tci-36x60",
              "name": "36X60",
              "subcategories": []
            },
            {
              "id": "aggregate-tci-36x70",
              "name": "36X70",
              "subcategories": []
            },
            {
              "id": "aggregate-tci-36x80",
              "name": "36X80",
              "subcategories": []
            },
            {
              "id": "aggregate-tci-36x100",
              "name": "36X100",
              "subcategories": []
            },
            {
              "id": "aggregate-tci-42x60",
              "name": "42X60",
              "subcategories": []
            },
            {
              "id": "aggregate-tci-44x32",
              "name": "44X32",
              "subcategories": []
            },
            {
              "id": "aggregate-tci-842t",
              "name": "842T",
              "subcategories": []
            },
            {
              "id": "aggregate-tci-other",
              "name": "OTHER",
              "subcategories": []
            }
          ]
        },
        {
          "id": "aggregate-terex-finlay",
          "name": "Terex Finlay",
          "subcategories": [
            {
              "id": "aggregate-terex-finlay-150e",
              "name": "150E",
              "subcategories": []
            },
            {
              "id": "aggregate-terex-finlay-390",
              "name": "390",
              "subcategories": []
            },
            {
              "id": "aggregate-terex-finlay-524",
              "name": "524",
              "subcategories": []
            },
            {
              "id": "aggregate-terex-finlay-595",
              "name": "595",
              "subcategories": []
            },
            {
              "id": "aggregate-terex-finlay-683",
              "name": "683",
              "subcategories": []
            },
            {
              "id": "aggregate-terex-finlay-683-supertrak",
              "name": "683 SUPERTRAK",
              "subcategories": []
            },
            {
              "id": "aggregate-terex-finlay-684-supertrak",
              "name": "684 SUPERTRAK",
              "subcategories": []
            },
            {
              "id": "aggregate-terex-finlay-693-supertrak",
              "name": "693+ SUPERTRAK",
              "subcategories": []
            },
            {
              "id": "aggregate-terex-finlay-694-supertrak",
              "name": "694 SUPERTRAK",
              "subcategories": []
            },
            {
              "id": "aggregate-terex-finlay-694-supertrak",
              "name": "694 + SUPERTRAK",
              "subcategories": []
            },
            {
              "id": "aggregate-terex-finlay-684",
              "name": "684",
              "subcategories": []
            },
            {
              "id": "aggregate-terex-finlay-693",
              "name": "693",
              "subcategories": []
            },
            {
              "id": "aggregate-terex-finlay-694",
              "name": "694+",
              "subcategories": []
            },
            {
              "id": "aggregate-terex-finlay-696",
              "name": "696",
              "subcategories": []
            },
            {
              "id": "aggregate-terex-finlay-798",
              "name": "798",
              "subcategories": []
            },
            {
              "id": "aggregate-terex-finlay-860",
              "name": "860",
              "subcategories": []
            },
            {
              "id": "aggregate-terex-finlay-863",
              "name": "863",
              "subcategories": []
            },
            {
              "id": "aggregate-terex-finlay-873",
              "name": "873",
              "subcategories": []
            },
            {
              "id": "aggregate-terex-finlay-883",
              "name": "883",
              "subcategories": []
            },
            {
              "id": "aggregate-terex-finlay-883t",
              "name": "883T",
              "subcategories": []
            },
            {
              "id": "aggregate-terex-finlay-984",
              "name": "984",
              "subcategories": []
            },
            {
              "id": "aggregate-terex-finlay-c1540",
              "name": "C1540",
              "subcategories": []
            },
            {
              "id": "aggregate-terex-finlay-c1545",
              "name": "C1545",
              "subcategories": []
            },
            {
              "id": "aggregate-terex-finlay-c1550",
              "name": "C1550",
              "subcategories": []
            },
            {
              "id": "aggregate-terex-finlay-i110",
              "name": "I110",
              "subcategories": []
            },
            {
              "id": "aggregate-terex-finlay-i111",
              "name": "I111",
              "subcategories": []
            },
            {
              "id": "aggregate-terex-finlay-i120",
              "name": "I120",
              "subcategories": []
            },
            {
              "id": "aggregate-terex-finlay-i-120rs",
              "name": "I-120RS",
              "subcategories": []
            },
            {
              "id": "aggregate-terex-finlay-i140",
              "name": "I140",
              "subcategories": []
            },
            {
              "id": "aggregate-terex-finlay-ic110",
              "name": "IC110",
              "subcategories": []
            },
            {
              "id": "aggregate-terex-finlay-j960",
              "name": "J960",
              "subcategories": []
            },
            {
              "id": "aggregate-terex-finlay-j1160",
              "name": "J1160",
              "subcategories": []
            },
            {
              "id": "aggregate-terex-finlay-j1170",
              "name": "J1170",
              "subcategories": []
            },
            {
              "id": "aggregate-terex-finlay-j1175",
              "name": "J1175",
              "subcategories": []
            },
            {
              "id": "aggregate-terex-finlay-j1480",
              "name": "J1480",
              "subcategories": []
            },
            {
              "id": "aggregate-terex-finlay-l140",
              "name": "L140",
              "subcategories": []
            },
            {
              "id": "aggregate-terex-finlay-tc80",
              "name": "TC80",
              "subcategories": []
            },
            {
              "id": "aggregate-terex-finlay-tf50l",
              "name": "TF50L",
              "subcategories": []
            },
            {
              "id": "aggregate-terex-finlay-tf75h",
              "name": "TF75H",
              "subcategories": []
            },
            {
              "id": "aggregate-terex-finlay-tf75l",
              "name": "TF75L",
              "subcategories": []
            },
            {
              "id": "aggregate-terex-finlay-tr80",
              "name": "TR80",
              "subcategories": []
            },
            {
              "id": "aggregate-terex-finlay-wr80",
              "name": "WR80",
              "subcategories": []
            },
            {
              "id": "aggregate-terex-finlay-other",
              "name": "OTHER",
              "subcategories": []
            }
          ]
        }
      ]
    },
    {
      "id": "agriculture-harvesters",
      "name": "Agriculture Harvesters",
      "subcategories": [
        {
          "id": "agriculture-harvesters-harversters",
          "name": "Harversters",
          "subcategories": []
        },
        {
          "id": "agriculture-harvesters-john-deere",
          "name": "John Deere",
          "subcategories": []
        },
        {
          "id": "agriculture-harvesters-case-ih",
          "name": "Case Ih",
          "subcategories": []
        },
        {
          "id": "agriculture-harvesters-mac-don",
          "name": "Mac Don",
          "subcategories": []
        },
        {
          "id": "agriculture-harvesters-new-holland",
          "name": "New Holland",
          "subcategories": []
        },
        {
          "id": "agriculture-harvesters-claas",
          "name": "Claas",
          "subcategories": []
        },
        {
          "id": "agriculture-harvesters-gleaner",
          "name": "Gleaner",
          "subcategories": []
        },
        {
          "id": "agriculture-harvesters-geringhoff",
          "name": "Geringhoff",
          "subcategories": []
        },
        {
          "id": "agriculture-harvesters-massey-fergueson",
          "name": "Massey Fergueson",
          "subcategories": []
        },
        {
          "id": "agriculture-harvesters-shelbourne-reynolds",
          "name": "Shelbourne Reynolds",
          "subcategories": []
        },
        {
          "id": "agriculture-harvesters-drago",
          "name": "Drago",
          "subcategories": []
        },
        {
          "id": "agriculture-harvesters-agco",
          "name": "Agco",
          "subcategories": []
        },
        {
          "id": "agriculture-harvesters-allis-chalmers",
          "name": "Allis Chalmers",
          "subcategories": []
        },
        {
          "id": "agriculture-harvesters-capello",
          "name": "Capello",
          "subcategories": []
        },
        {
          "id": "agriculture-harvesters-challenger",
          "name": "Challenger",
          "subcategories": []
        },
        {
          "id": "agriculture-harvesters-dion",
          "name": "Dion",
          "subcategories": []
        },
        {
          "id": "agriculture-harvesters-fendt",
          "name": "Fendt",
          "subcategories": []
        },
        {
          "id": "agriculture-harvesters-gehl",
          "name": "Gehl",
          "subcategories": []
        },
        {
          "id": "agriculture-harvesters-harvestec",
          "name": "Harvestec",
          "subcategories": []
        },
        {
          "id": "agriculture-harvesters-hesston",
          "name": "Hesston",
          "subcategories": []
        },
        {
          "id": "agriculture-harvesters-honey-bee",
          "name": "Honey Bee",
          "subcategories": []
        },
        {
          "id": "agriculture-harvesters-horning",
          "name": "Horning",
          "subcategories": []
        },
        {
          "id": "agriculture-harvesters-international",
          "name": "International",
          "subcategories": []
        },
        {
          "id": "agriculture-harvesters-ji-case",
          "name": "Ji Case",
          "subcategories": []
        },
        {
          "id": "agriculture-harvesters-kemper",
          "name": "Kemper",
          "subcategories": []
        },
        {
          "id": "agriculture-harvesters-krone",
          "name": "Krone",
          "subcategories": []
        },
        {
          "id": "agriculture-harvesters-laverda",
          "name": "Laverda",
          "subcategories": []
        },
        {
          "id": "agriculture-harvesters-lexion",
          "name": "Lexion",
          "subcategories": []
        },
        {
          "id": "agriculture-harvesters-lilliston",
          "name": "Lilliston",
          "subcategories": []
        },
        {
          "id": "agriculture-harvesters-maya-america",
          "name": "Maya America",
          "subcategories": []
        },
        {
          "id": "agriculture-harvesters-nardi",
          "name": "Nardi",
          "subcategories": []
        },
        {
          "id": "agriculture-harvesters-new-idea",
          "name": "New Idea",
          "subcategories": []
        },
        {
          "id": "agriculture-harvesters-other",
          "name": "Other",
          "subcategories": []
        }
      ]
    },
    {
      "id": "agriculture-tractors",
      "name": "Agriculture Tractors",
      "subcategories": [
        {
          "id": "agriculture-tractors-tractors",
          "name": "Tractors",
          "subcategories": [
            {
              "id": "agriculture-tractors-tractors-tractors-300hp",
              "name": "TRACTORS 300HP +",
              "subcategories": []
            },
            {
              "id": "agriculture-tractors-tractors-john-deere",
              "name": "JOHN DEERE",
              "subcategories": []
            },
            {
              "id": "agriculture-tractors-tractors-casi-ih",
              "name": "CASI IH",
              "subcategories": []
            },
            {
              "id": "agriculture-tractors-tractors-new-holland",
              "name": "NEW HOLLAND",
              "subcategories": []
            },
            {
              "id": "agriculture-tractors-tractors-fendt",
              "name": "FENDT",
              "subcategories": []
            },
            {
              "id": "agriculture-tractors-tractors-versatile",
              "name": "VERSATILE",
              "subcategories": []
            },
            {
              "id": "agriculture-tractors-tractors-challenger",
              "name": "CHALLENGER",
              "subcategories": []
            },
            {
              "id": "agriculture-tractors-tractors-claas",
              "name": "CLAAS",
              "subcategories": []
            },
            {
              "id": "agriculture-tractors-tractors-massey-fergueson",
              "name": "MASSEY FERGUESON",
              "subcategories": []
            },
            {
              "id": "agriculture-tractors-tractors-jcb",
              "name": "JCB",
              "subcategories": []
            },
            {
              "id": "agriculture-tractors-tractors-valtra",
              "name": "VALTRA",
              "subcategories": []
            },
            {
              "id": "agriculture-tractors-tractors-other",
              "name": "OTHER",
              "subcategories": []
            },
            {
              "id": "agriculture-tractors-tractors-tractors-175-299-hp",
              "name": "TRACTORS 175 - 299 HP",
              "subcategories": []
            },
            {
              "id": "agriculture-tractors-tractors-john-deere",
              "name": "JOHN DEERE",
              "subcategories": []
            },
            {
              "id": "agriculture-tractors-tractors-case-ih",
              "name": "CASE IH",
              "subcategories": []
            },
            {
              "id": "agriculture-tractors-tractors-fendt",
              "name": "FENDT",
              "subcategories": []
            },
            {
              "id": "agriculture-tractors-tractors-new-holland",
              "name": "NEW HOLLAND",
              "subcategories": []
            },
            {
              "id": "agriculture-tractors-tractors-massey-fergueson",
              "name": "MASSEY FERGUESON",
              "subcategories": []
            },
            {
              "id": "agriculture-tractors-tractors-claas",
              "name": "CLAAS",
              "subcategories": []
            },
            {
              "id": "agriculture-tractors-tractors-jcb",
              "name": "JCB",
              "subcategories": []
            },
            {
              "id": "agriculture-tractors-tractors-valtra",
              "name": "VALTRA",
              "subcategories": []
            },
            {
              "id": "agriculture-tractors-tractors-versatile",
              "name": "VERSATILE",
              "subcategories": []
            },
            {
              "id": "agriculture-tractors-tractors-duetz-fahr",
              "name": "DUETZ FAHR",
              "subcategories": []
            },
            {
              "id": "agriculture-tractors-tractors-agco",
              "name": "AGCO",
              "subcategories": []
            },
            {
              "id": "agriculture-tractors-tractors-catrelpillar",
              "name": "CATRELPILLAR",
              "subcategories": []
            },
            {
              "id": "agriculture-tractors-tractors-challenger",
              "name": "CHALLENGER",
              "subcategories": []
            },
            {
              "id": "agriculture-tractors-tractors-ford",
              "name": "FORD",
              "subcategories": []
            },
            {
              "id": "agriculture-tractors-tractors-international",
              "name": "INTERNATIONAL",
              "subcategories": []
            },
            {
              "id": "agriculture-tractors-tractors-mccormick",
              "name": "MCCORMICK",
              "subcategories": []
            },
            {
              "id": "agriculture-tractors-tractors-steiger",
              "name": "STEIGER",
              "subcategories": []
            },
            {
              "id": "agriculture-tractors-tractors-other",
              "name": "OTHER",
              "subcategories": []
            },
            {
              "id": "agriculture-tractors-tractors-tractors-100-174-hp",
              "name": "TRACTORS 100 - 174 HP",
              "subcategories": []
            },
            {
              "id": "agriculture-tractors-tractors-john-deere",
              "name": "JOHN DEERE",
              "subcategories": []
            },
            {
              "id": "agriculture-tractors-tractors-case-ih",
              "name": "CASE IH",
              "subcategories": []
            },
            {
              "id": "agriculture-tractors-tractors-new-holland",
              "name": "NEW HOLLAND",
              "subcategories": []
            },
            {
              "id": "agriculture-tractors-tractors-massey-fergueson",
              "name": "MASSEY FERGUESON",
              "subcategories": []
            },
            {
              "id": "agriculture-tractors-tractors-kubota",
              "name": "KUBOTA",
              "subcategories": []
            },
            {
              "id": "agriculture-tractors-tractors-international",
              "name": "INTERNATIONAL",
              "subcategories": []
            },
            {
              "id": "agriculture-tractors-tractors-fendt",
              "name": "FENDT",
              "subcategories": []
            },
            {
              "id": "agriculture-tractors-tractors-duetz-fahr",
              "name": "DUETZ FAHR",
              "subcategories": []
            },
            {
              "id": "agriculture-tractors-tractors-claas",
              "name": "CLAAS",
              "subcategories": []
            },
            {
              "id": "agriculture-tractors-tractors-mccormick",
              "name": "MCCORMICK",
              "subcategories": []
            },
            {
              "id": "agriculture-tractors-tractors-allis-chalmers",
              "name": "ALLIS CHALMERS",
              "subcategories": []
            },
            {
              "id": "agriculture-tractors-tractors-challenger",
              "name": "CHALLENGER",
              "subcategories": []
            },
            {
              "id": "agriculture-tractors-tractors-ford",
              "name": "FORD",
              "subcategories": []
            },
            {
              "id": "agriculture-tractors-tractors-j-i-case",
              "name": "J I CASE",
              "subcategories": []
            },
            {
              "id": "agriculture-tractors-tractors-jcb",
              "name": "JCB",
              "subcategories": []
            },
            {
              "id": "agriculture-tractors-tractors-kioti",
              "name": "KIOTI",
              "subcategories": []
            },
            {
              "id": "agriculture-tractors-tractors-mahindra",
              "name": "MAHINDRA",
              "subcategories": []
            },
            {
              "id": "agriculture-tractors-tractors-valtra",
              "name": "VALTRA",
              "subcategories": []
            },
            {
              "id": "agriculture-tractors-tractors-white",
              "name": "WHITE",
              "subcategories": []
            },
            {
              "id": "agriculture-tractors-tractors-zetor",
              "name": "ZETOR",
              "subcategories": []
            },
            {
              "id": "agriculture-tractors-tractors-other",
              "name": "OTHER",
              "subcategories": []
            },
            {
              "id": "agriculture-tractors-tractors-tractors-40-99-hp",
              "name": "TRACTORS 40 - 99 HP",
              "subcategories": []
            },
            {
              "id": "agriculture-tractors-tractors-john-deere",
              "name": "JOHN DEERE",
              "subcategories": []
            },
            {
              "id": "agriculture-tractors-tractors-new-holland",
              "name": "NEW HOLLAND",
              "subcategories": []
            },
            {
              "id": "agriculture-tractors-tractors-kubota",
              "name": "KUBOTA",
              "subcategories": []
            },
            {
              "id": "agriculture-tractors-tractors-massey-fergueson",
              "name": "MASSEY FERGUESON",
              "subcategories": []
            },
            {
              "id": "agriculture-tractors-tractors-case-ih",
              "name": "CASE IH",
              "subcategories": []
            },
            {
              "id": "agriculture-tractors-tractors-ford",
              "name": "FORD",
              "subcategories": []
            },
            {
              "id": "agriculture-tractors-tractors-international",
              "name": "INTERNATIONAL",
              "subcategories": []
            },
            {
              "id": "agriculture-tractors-tractors-kioti",
              "name": "KIOTI",
              "subcategories": []
            },
            {
              "id": "agriculture-tractors-tractors-mahindra",
              "name": "MAHINDRA",
              "subcategories": []
            },
            {
              "id": "agriculture-tractors-tractors-tym",
              "name": "TYM",
              "subcategories": []
            },
            {
              "id": "agriculture-tractors-tractors-allis-chalmers",
              "name": "ALLIS CHALMERS",
              "subcategories": []
            },
            {
              "id": "agriculture-tractors-tractors-bad-boy",
              "name": "BAD BOY",
              "subcategories": []
            },
            {
              "id": "agriculture-tractors-tractors-bobcat",
              "name": "BOBCAT",
              "subcategories": []
            },
            {
              "id": "agriculture-tractors-tractors-branson",
              "name": "BRANSON",
              "subcategories": []
            },
            {
              "id": "agriculture-tractors-tractors-claas",
              "name": "CLAAS",
              "subcategories": []
            },
            {
              "id": "agriculture-tractors-tractors-duetz-fahr",
              "name": "DUETZ FAHR",
              "subcategories": []
            },
            {
              "id": "agriculture-tractors-tractors-fendt",
              "name": "FENDT",
              "subcategories": []
            },
            {
              "id": "agriculture-tractors-tractors-j-i-case",
              "name": "J I CASE",
              "subcategories": []
            },
            {
              "id": "agriculture-tractors-tractors-landini",
              "name": "LANDINI",
              "subcategories": []
            },
            {
              "id": "agriculture-tractors-tractors-mccormick",
              "name": "MCCORMICK",
              "subcategories": []
            },
            {
              "id": "agriculture-tractors-tractors-oliver",
              "name": "OLIVER",
              "subcategories": []
            },
            {
              "id": "agriculture-tractors-tractors-solis",
              "name": "SOLIS",
              "subcategories": []
            },
            {
              "id": "agriculture-tractors-tractors-uhi",
              "name": "UHI",
              "subcategories": []
            },
            {
              "id": "agriculture-tractors-tractors-white",
              "name": "WHITE",
              "subcategories": []
            },
            {
              "id": "agriculture-tractors-tractors-yanmar",
              "name": "YANMAR",
              "subcategories": []
            },
            {
              "id": "agriculture-tractors-tractors-zetor",
              "name": "ZETOR",
              "subcategories": []
            },
            {
              "id": "agriculture-tractors-tractors-other",
              "name": "OTHER",
              "subcategories": []
            },
            {
              "id": "agriculture-tractors-tractors-tractors-less-than-40-hp",
              "name": "TRACTORS LESS THAN 40 HP",
              "subcategories": []
            },
            {
              "id": "agriculture-tractors-tractors-john-deere",
              "name": "JOHN DEERE",
              "subcategories": []
            },
            {
              "id": "agriculture-tractors-tractors-kubota",
              "name": "KUBOTA",
              "subcategories": []
            },
            {
              "id": "agriculture-tractors-tractors-massey-fergueson",
              "name": "MASSEY FERGUESON",
              "subcategories": []
            },
            {
              "id": "agriculture-tractors-tractors-new-holland",
              "name": "NEW HOLLAND",
              "subcategories": []
            },
            {
              "id": "agriculture-tractors-tractors-kioti",
              "name": "KIOTI",
              "subcategories": []
            },
            {
              "id": "agriculture-tractors-tractors-mahindra",
              "name": "MAHINDRA",
              "subcategories": []
            },
            {
              "id": "agriculture-tractors-tractors-bobcat",
              "name": "BOBCAT",
              "subcategories": []
            },
            {
              "id": "agriculture-tractors-tractors-international",
              "name": "INTERNATIONAL",
              "subcategories": []
            },
            {
              "id": "agriculture-tractors-tractors-yanmar",
              "name": "YANMAR",
              "subcategories": []
            },
            {
              "id": "agriculture-tractors-tractors-ls",
              "name": "LS",
              "subcategories": []
            },
            {
              "id": "agriculture-tractors-tractors-allis-chalmers",
              "name": "ALLIS-CHALMERS",
              "subcategories": []
            },
            {
              "id": "agriculture-tractors-tractors-bad-boy",
              "name": "BAD BOY",
              "subcategories": []
            },
            {
              "id": "agriculture-tractors-tractors-case-ih",
              "name": "CASE IH",
              "subcategories": []
            },
            {
              "id": "agriculture-tractors-tractors-ford",
              "name": "FORD",
              "subcategories": []
            },
            {
              "id": "agriculture-tractors-tractors-ji-case",
              "name": "JI CASE",
              "subcategories": []
            },
            {
              "id": "agriculture-tractors-tractors-mccormick",
              "name": "MCCORMICK",
              "subcategories": []
            },
            {
              "id": "agriculture-tractors-tractors-oliver",
              "name": "OLIVER",
              "subcategories": []
            },
            {
              "id": "agriculture-tractors-tractors-solis",
              "name": "SOLIS",
              "subcategories": []
            },
            {
              "id": "agriculture-tractors-tractors-steiner",
              "name": "STEINER",
              "subcategories": []
            },
            {
              "id": "agriculture-tractors-tractors-tym",
              "name": "TYM",
              "subcategories": []
            },
            {
              "id": "agriculture-tractors-tractors-ventrac",
              "name": "VENTRAC",
              "subcategories": []
            }
          ]
        },
        {
          "id": "agriculture-tractors-tractors-300hp",
          "name": "Tractors 300hp +",
          "subcategories": []
        },
        {
          "id": "agriculture-tractors-john-deere",
          "name": "John Deere",
          "subcategories": []
        },
        {
          "id": "agriculture-tractors-casi-ih",
          "name": "Casi Ih",
          "subcategories": []
        },
        {
          "id": "agriculture-tractors-new-holland",
          "name": "New Holland",
          "subcategories": []
        },
        {
          "id": "agriculture-tractors-fendt",
          "name": "Fendt",
          "subcategories": []
        },
        {
          "id": "agriculture-tractors-versatile",
          "name": "Versatile",
          "subcategories": []
        },
        {
          "id": "agriculture-tractors-challenger",
          "name": "Challenger",
          "subcategories": []
        },
        {
          "id": "agriculture-tractors-claas",
          "name": "Claas",
          "subcategories": []
        },
        {
          "id": "agriculture-tractors-massey-fergueson",
          "name": "Massey Fergueson",
          "subcategories": []
        },
        {
          "id": "agriculture-tractors-jcb",
          "name": "Jcb",
          "subcategories": []
        },
        {
          "id": "agriculture-tractors-valtra",
          "name": "Valtra",
          "subcategories": []
        },
        {
          "id": "agriculture-tractors-other",
          "name": "Other",
          "subcategories": []
        },
        {
          "id": "agriculture-tractors-tractors-175-299-hp",
          "name": "Tractors 175 - 299 Hp",
          "subcategories": []
        },
        {
          "id": "agriculture-tractors-john-deere",
          "name": "John Deere",
          "subcategories": []
        },
        {
          "id": "agriculture-tractors-case-ih",
          "name": "Case Ih",
          "subcategories": []
        },
        {
          "id": "agriculture-tractors-fendt",
          "name": "Fendt",
          "subcategories": []
        },
        {
          "id": "agriculture-tractors-new-holland",
          "name": "New Holland",
          "subcategories": []
        },
        {
          "id": "agriculture-tractors-massey-fergueson",
          "name": "Massey Fergueson",
          "subcategories": []
        },
        {
          "id": "agriculture-tractors-claas",
          "name": "Claas",
          "subcategories": []
        },
        {
          "id": "agriculture-tractors-jcb",
          "name": "Jcb",
          "subcategories": []
        },
        {
          "id": "agriculture-tractors-valtra",
          "name": "Valtra",
          "subcategories": []
        },
        {
          "id": "agriculture-tractors-versatile",
          "name": "Versatile",
          "subcategories": []
        },
        {
          "id": "agriculture-tractors-duetz-fahr",
          "name": "Duetz Fahr",
          "subcategories": []
        },
        {
          "id": "agriculture-tractors-agco",
          "name": "Agco",
          "subcategories": []
        },
        {
          "id": "agriculture-tractors-catrelpillar",
          "name": "Catrelpillar",
          "subcategories": []
        },
        {
          "id": "agriculture-tractors-challenger",
          "name": "Challenger",
          "subcategories": []
        },
        {
          "id": "agriculture-tractors-ford",
          "name": "Ford",
          "subcategories": []
        },
        {
          "id": "agriculture-tractors-international",
          "name": "International",
          "subcategories": []
        },
        {
          "id": "agriculture-tractors-mccormick",
          "name": "Mccormick",
          "subcategories": []
        },
        {
          "id": "agriculture-tractors-steiger",
          "name": "Steiger",
          "subcategories": []
        },
        {
          "id": "agriculture-tractors-other",
          "name": "Other",
          "subcategories": []
        },
        {
          "id": "agriculture-tractors-tractors-100-174-hp",
          "name": "Tractors 100 - 174 Hp",
          "subcategories": []
        },
        {
          "id": "agriculture-tractors-john-deere",
          "name": "John Deere",
          "subcategories": []
        },
        {
          "id": "agriculture-tractors-case-ih",
          "name": "Case Ih",
          "subcategories": []
        },
        {
          "id": "agriculture-tractors-new-holland",
          "name": "New Holland",
          "subcategories": []
        },
        {
          "id": "agriculture-tractors-massey-fergueson",
          "name": "Massey Fergueson",
          "subcategories": []
        },
        {
          "id": "agriculture-tractors-kubota",
          "name": "Kubota",
          "subcategories": []
        },
        {
          "id": "agriculture-tractors-international",
          "name": "International",
          "subcategories": []
        },
        {
          "id": "agriculture-tractors-fendt",
          "name": "Fendt",
          "subcategories": []
        },
        {
          "id": "agriculture-tractors-duetz-fahr",
          "name": "Duetz Fahr",
          "subcategories": []
        },
        {
          "id": "agriculture-tractors-claas",
          "name": "Claas",
          "subcategories": []
        },
        {
          "id": "agriculture-tractors-mccormick",
          "name": "Mccormick",
          "subcategories": []
        },
        {
          "id": "agriculture-tractors-allis-chalmers",
          "name": "Allis Chalmers",
          "subcategories": []
        },
        {
          "id": "agriculture-tractors-challenger",
          "name": "Challenger",
          "subcategories": []
        },
        {
          "id": "agriculture-tractors-ford",
          "name": "Ford",
          "subcategories": []
        },
        {
          "id": "agriculture-tractors-j-i-case",
          "name": "J I Case",
          "subcategories": []
        },
        {
          "id": "agriculture-tractors-jcb",
          "name": "Jcb",
          "subcategories": []
        },
        {
          "id": "agriculture-tractors-kioti",
          "name": "Kioti",
          "subcategories": []
        },
        {
          "id": "agriculture-tractors-mahindra",
          "name": "Mahindra",
          "subcategories": []
        },
        {
          "id": "agriculture-tractors-valtra",
          "name": "Valtra",
          "subcategories": []
        },
        {
          "id": "agriculture-tractors-white",
          "name": "White",
          "subcategories": []
        },
        {
          "id": "agriculture-tractors-zetor",
          "name": "Zetor",
          "subcategories": []
        },
        {
          "id": "agriculture-tractors-other",
          "name": "Other",
          "subcategories": []
        },
        {
          "id": "agriculture-tractors-tractors-40-99-hp",
          "name": "Tractors 40 - 99 Hp",
          "subcategories": []
        },
        {
          "id": "agriculture-tractors-john-deere",
          "name": "John Deere",
          "subcategories": []
        },
        {
          "id": "agriculture-tractors-new-holland",
          "name": "New Holland",
          "subcategories": []
        },
        {
          "id": "agriculture-tractors-kubota",
          "name": "Kubota",
          "subcategories": []
        },
        {
          "id": "agriculture-tractors-massey-fergueson",
          "name": "Massey Fergueson",
          "subcategories": []
        },
        {
          "id": "agriculture-tractors-case-ih",
          "name": "Case Ih",
          "subcategories": []
        },
        {
          "id": "agriculture-tractors-ford",
          "name": "Ford",
          "subcategories": []
        },
        {
          "id": "agriculture-tractors-international",
          "name": "International",
          "subcategories": []
        },
        {
          "id": "agriculture-tractors-kioti",
          "name": "Kioti",
          "subcategories": []
        },
        {
          "id": "agriculture-tractors-mahindra",
          "name": "Mahindra",
          "subcategories": []
        },
        {
          "id": "agriculture-tractors-tym",
          "name": "Tym",
          "subcategories": []
        },
        {
          "id": "agriculture-tractors-allis-chalmers",
          "name": "Allis Chalmers",
          "subcategories": []
        },
        {
          "id": "agriculture-tractors-bad-boy",
          "name": "Bad Boy",
          "subcategories": []
        },
        {
          "id": "agriculture-tractors-bobcat",
          "name": "Bobcat",
          "subcategories": []
        },
        {
          "id": "agriculture-tractors-branson",
          "name": "Branson",
          "subcategories": []
        },
        {
          "id": "agriculture-tractors-claas",
          "name": "Claas",
          "subcategories": []
        },
        {
          "id": "agriculture-tractors-duetz-fahr",
          "name": "Duetz Fahr",
          "subcategories": []
        },
        {
          "id": "agriculture-tractors-fendt",
          "name": "Fendt",
          "subcategories": []
        },
        {
          "id": "agriculture-tractors-j-i-case",
          "name": "J I Case",
          "subcategories": []
        },
        {
          "id": "agriculture-tractors-landini",
          "name": "Landini",
          "subcategories": []
        },
        {
          "id": "agriculture-tractors-mccormick",
          "name": "Mccormick",
          "subcategories": []
        },
        {
          "id": "agriculture-tractors-oliver",
          "name": "Oliver",
          "subcategories": []
        },
        {
          "id": "agriculture-tractors-solis",
          "name": "Solis",
          "subcategories": []
        },
        {
          "id": "agriculture-tractors-uhi",
          "name": "Uhi",
          "subcategories": []
        },
        {
          "id": "agriculture-tractors-white",
          "name": "White",
          "subcategories": []
        },
        {
          "id": "agriculture-tractors-yanmar",
          "name": "Yanmar",
          "subcategories": []
        },
        {
          "id": "agriculture-tractors-zetor",
          "name": "Zetor",
          "subcategories": []
        },
        {
          "id": "agriculture-tractors-other",
          "name": "Other",
          "subcategories": []
        },
        {
          "id": "agriculture-tractors-tractors-less-than-40-hp",
          "name": "Tractors Less Than 40 Hp",
          "subcategories": []
        },
        {
          "id": "agriculture-tractors-john-deere",
          "name": "John Deere",
          "subcategories": []
        },
        {
          "id": "agriculture-tractors-kubota",
          "name": "Kubota",
          "subcategories": []
        },
        {
          "id": "agriculture-tractors-massey-fergueson",
          "name": "Massey Fergueson",
          "subcategories": []
        },
        {
          "id": "agriculture-tractors-new-holland",
          "name": "New Holland",
          "subcategories": []
        },
        {
          "id": "agriculture-tractors-kioti",
          "name": "Kioti",
          "subcategories": []
        },
        {
          "id": "agriculture-tractors-mahindra",
          "name": "Mahindra",
          "subcategories": []
        },
        {
          "id": "agriculture-tractors-bobcat",
          "name": "Bobcat",
          "subcategories": []
        },
        {
          "id": "agriculture-tractors-international",
          "name": "International",
          "subcategories": []
        },
        {
          "id": "agriculture-tractors-yanmar",
          "name": "Yanmar",
          "subcategories": []
        },
        {
          "id": "agriculture-tractors-ls",
          "name": "Ls",
          "subcategories": []
        },
        {
          "id": "agriculture-tractors-allis-chalmers",
          "name": "Allis-Chalmers",
          "subcategories": []
        },
        {
          "id": "agriculture-tractors-bad-boy",
          "name": "Bad Boy",
          "subcategories": []
        },
        {
          "id": "agriculture-tractors-case-ih",
          "name": "Case Ih",
          "subcategories": []
        },
        {
          "id": "agriculture-tractors-ford",
          "name": "Ford",
          "subcategories": []
        },
        {
          "id": "agriculture-tractors-ji-case",
          "name": "Ji Case",
          "subcategories": []
        },
        {
          "id": "agriculture-tractors-mccormick",
          "name": "Mccormick",
          "subcategories": []
        },
        {
          "id": "agriculture-tractors-oliver",
          "name": "Oliver",
          "subcategories": []
        },
        {
          "id": "agriculture-tractors-solis",
          "name": "Solis",
          "subcategories": []
        },
        {
          "id": "agriculture-tractors-steiner",
          "name": "Steiner",
          "subcategories": []
        },
        {
          "id": "agriculture-tractors-tym",
          "name": "Tym",
          "subcategories": []
        },
        {
          "id": "agriculture-tractors-ventrac",
          "name": "Ventrac",
          "subcategories": []
        }
      ]
    },
    {
      "id": "asphalt-equipment",
      "name": "Asphalt Equipment",
      "subcategories": [
        {
          "id": "asphalt-equipment-asphalt",
          "name": "Asphalt",
          "subcategories": [
            {
              "id": "asphalt-equipment-asphalt-vogele",
              "name": "VOGELE",
              "subcategories": []
            },
            {
              "id": "asphalt-equipment-asphalt-wirtgen",
              "name": "WIRTGEN",
              "subcategories": []
            },
            {
              "id": "asphalt-equipment-asphalt-leeboy",
              "name": "LEEBOY",
              "subcategories": []
            },
            {
              "id": "asphalt-equipment-asphalt-caterpillar",
              "name": "CATERPILLAR",
              "subcategories": []
            },
            {
              "id": "asphalt-equipment-asphalt-husqvarna",
              "name": "HUSQVARNA",
              "subcategories": []
            },
            {
              "id": "asphalt-equipment-asphalt-multiquip-whiteman",
              "name": "MULTIQUIP-WHITEMAN",
              "subcategories": []
            },
            {
              "id": "asphalt-equipment-asphalt-toro",
              "name": "TORO",
              "subcategories": []
            },
            {
              "id": "asphalt-equipment-asphalt-bomag",
              "name": "BOMAG",
              "subcategories": []
            },
            {
              "id": "asphalt-equipment-asphalt-roadtec",
              "name": "ROADTEC",
              "subcategories": []
            },
            {
              "id": "asphalt-equipment-asphalt-chikusuiu-canycom",
              "name": "CHIKUSUIU CANYCOM",
              "subcategories": []
            },
            {
              "id": "asphalt-equipment-asphalt-abg",
              "name": "ABG",
              "subcategories": []
            },
            {
              "id": "asphalt-equipment-asphalt-aesco-madsen",
              "name": "AESCO MADSEN",
              "subcategories": []
            },
            {
              "id": "asphalt-equipment-asphalt-allen-eng",
              "name": "ALLEN ENG",
              "subcategories": []
            },
            {
              "id": "asphalt-equipment-asphalt-amag",
              "name": "AMAG",
              "subcategories": []
            },
            {
              "id": "asphalt-equipment-asphalt-ammann",
              "name": "AMMANN",
              "subcategories": []
            },
            {
              "id": "asphalt-equipment-asphalt-asphalt-zipper",
              "name": "ASPHALT ZIPPER",
              "subcategories": []
            },
            {
              "id": "asphalt-equipment-asphalt-astec",
              "name": "ASTEC",
              "subcategories": []
            },
            {
              "id": "asphalt-equipment-asphalt-barber-greene",
              "name": "BARBER GREENE",
              "subcategories": []
            },
            {
              "id": "asphalt-equipment-asphalt-bartell",
              "name": "BARTELL",
              "subcategories": []
            },
            {
              "id": "asphalt-equipment-asphalt-bergkamp",
              "name": "BERGKAMP",
              "subcategories": []
            },
            {
              "id": "asphalt-equipment-asphalt-betonblock",
              "name": "BETONBLOCK",
              "subcategories": []
            },
            {
              "id": "asphalt-equipment-asphalt-bitelli",
              "name": "BITELLI",
              "subcategories": []
            },
            {
              "id": "asphalt-equipment-asphalt-blawknox",
              "name": "BLAWKNOX",
              "subcategories": []
            },
            {
              "id": "asphalt-equipment-asphalt-carlson",
              "name": "CARLSON",
              "subcategories": []
            },
            {
              "id": "asphalt-equipment-asphalt-cedar-rapids",
              "name": "CEDAR RAPIDS",
              "subcategories": []
            },
            {
              "id": "asphalt-equipment-asphalt-cimline",
              "name": "CIMLINE",
              "subcategories": []
            },
            {
              "id": "asphalt-equipment-asphalt-cmi",
              "name": "CMI",
              "subcategories": []
            },
            {
              "id": "asphalt-equipment-asphalt-crafco",
              "name": "CRAFCO",
              "subcategories": []
            },
            {
              "id": "asphalt-equipment-asphalt-diamond",
              "name": "DIAMOND",
              "subcategories": []
            },
            {
              "id": "asphalt-equipment-asphalt-dynapac",
              "name": "DYNAPAC",
              "subcategories": []
            },
            {
              "id": "asphalt-equipment-asphalt-edco",
              "name": "EDCO",
              "subcategories": []
            },
            {
              "id": "asphalt-equipment-asphalt-etnyre",
              "name": "ETNYRE",
              "subcategories": []
            },
            {
              "id": "asphalt-equipment-asphalt-falcon",
              "name": "FALCON",
              "subcategories": []
            },
            {
              "id": "asphalt-equipment-asphalt-gomaco",
              "name": "GOMACO",
              "subcategories": []
            },
            {
              "id": "asphalt-equipment-asphalt-imer",
              "name": "IMER",
              "subcategories": []
            },
            {
              "id": "asphalt-equipment-asphalt-indy",
              "name": "INDY",
              "subcategories": []
            },
            {
              "id": "asphalt-equipment-asphalt-kimera",
              "name": "KIMERA",
              "subcategories": []
            },
            {
              "id": "asphalt-equipment-asphalt-km-international",
              "name": "KM INTERNATIONAL",
              "subcategories": []
            },
            {
              "id": "asphalt-equipment-asphalt-marathon",
              "name": "MARATHON",
              "subcategories": []
            },
            {
              "id": "asphalt-equipment-asphalt-mauldin",
              "name": "MAULDIN",
              "subcategories": []
            },
            {
              "id": "asphalt-equipment-asphalt-metalika",
              "name": "METALIKA",
              "subcategories": []
            },
            {
              "id": "asphalt-equipment-asphalt-midland",
              "name": "MIDLAND",
              "subcategories": []
            },
            {
              "id": "asphalt-equipment-asphalt-multiquip-whiteman",
              "name": "MULTIQUIP-WHITEMAN",
              "subcategories": []
            },
            {
              "id": "asphalt-equipment-asphalt-normet",
              "name": "NORMET",
              "subcategories": []
            },
            {
              "id": "asphalt-equipment-asphalt-power-curbers",
              "name": "POWER CURBERS",
              "subcategories": []
            },
            {
              "id": "asphalt-equipment-asphalt-putzmiester",
              "name": "PUTZMIESTER",
              "subcategories": []
            },
            {
              "id": "asphalt-equipment-asphalt-sami",
              "name": "SAMI",
              "subcategories": []
            },
            {
              "id": "asphalt-equipment-asphalt-schwing",
              "name": "SCHWING",
              "subcategories": []
            },
            {
              "id": "asphalt-equipment-asphalt-struemaster",
              "name": "STRUEMASTER",
              "subcategories": []
            },
            {
              "id": "asphalt-equipment-asphalt-volvo",
              "name": "VOLVO",
              "subcategories": []
            },
            {
              "id": "asphalt-equipment-asphalt-wacker-nueson",
              "name": "WACKER NUESON",
              "subcategories": []
            },
            {
              "id": "asphalt-equipment-asphalt-weiler",
              "name": "WEILER",
              "subcategories": []
            },
            {
              "id": "asphalt-equipment-asphalt-xcmg",
              "name": "XCMG",
              "subcategories": []
            },
            {
              "id": "asphalt-equipment-asphalt-zoomlion",
              "name": "ZOOMLION",
              "subcategories": []
            }
          ]
        },
        {
          "id": "asphalt-equipment-vogele",
          "name": "Vogele",
          "subcategories": [
            {
              "id": "asphalt-equipment-vogele-2116",
              "name": "2116",
              "subcategories": []
            },
            {
              "id": "asphalt-equipment-vogele-2219",
              "name": "2219",
              "subcategories": []
            },
            {
              "id": "asphalt-equipment-vogele-mini-500",
              "name": "MINI 500",
              "subcategories": []
            },
            {
              "id": "asphalt-equipment-vogele-mt1000",
              "name": "MT1000",
              "subcategories": []
            },
            {
              "id": "asphalt-equipment-vogele-mt3000",
              "name": "MT3000",
              "subcategories": []
            },
            {
              "id": "asphalt-equipment-vogele-super-600",
              "name": "SUPER 600",
              "subcategories": []
            },
            {
              "id": "asphalt-equipment-vogele-super-700",
              "name": "SUPER 700",
              "subcategories": []
            },
            {
              "id": "asphalt-equipment-vogele-super-800",
              "name": "SUPER 800",
              "subcategories": []
            },
            {
              "id": "asphalt-equipment-vogele-super-1000",
              "name": "SUPER 1000",
              "subcategories": []
            },
            {
              "id": "asphalt-equipment-vogele-super-1100",
              "name": "SUPER 1100",
              "subcategories": []
            },
            {
              "id": "asphalt-equipment-vogele-super-1203",
              "name": "SUPER 1203",
              "subcategories": []
            },
            {
              "id": "asphalt-equipment-vogele-super-1300-2",
              "name": "SUPER 1300-2",
              "subcategories": []
            },
            {
              "id": "asphalt-equipment-vogele-super-1300-3i",
              "name": "SUPER 1300-3I",
              "subcategories": []
            },
            {
              "id": "asphalt-equipment-vogele-super-1302",
              "name": "SUPER 1302",
              "subcategories": []
            },
            {
              "id": "asphalt-equipment-vogele-super-1303-2",
              "name": "SUPER 1303-2",
              "subcategories": []
            },
            {
              "id": "asphalt-equipment-vogele-super-1303-3",
              "name": "SUPER 1303-3",
              "subcategories": []
            },
            {
              "id": "asphalt-equipment-vogele-super-1303-3i",
              "name": "SUPER 1303-3I",
              "subcategories": []
            },
            {
              "id": "asphalt-equipment-vogele-super1600",
              "name": "SUPER1600",
              "subcategories": []
            },
            {
              "id": "asphalt-equipment-vogele-super-1600-1",
              "name": "SUPER 1600-1",
              "subcategories": []
            },
            {
              "id": "asphalt-equipment-vogele-super-1600-2",
              "name": "SUPER 1600-2",
              "subcategories": []
            },
            {
              "id": "asphalt-equipment-vogele-super-1600-3",
              "name": "SUPER 1600-3",
              "subcategories": []
            },
            {
              "id": "asphalt-equipment-vogele-super-16003i",
              "name": "SUPER 16003I",
              "subcategories": []
            },
            {
              "id": "asphalt-equipment-vogele-super-1700",
              "name": "SUPER 1700",
              "subcategories": []
            },
            {
              "id": "asphalt-equipment-vogele-super-1700-3i",
              "name": "SUPER 1700-3I",
              "subcategories": []
            },
            {
              "id": "asphalt-equipment-vogele-super-1703-3i",
              "name": "SUPER 1703-3I",
              "subcategories": []
            },
            {
              "id": "asphalt-equipment-vogele-super-1800-1",
              "name": "SUPER 1800-1",
              "subcategories": []
            },
            {
              "id": "asphalt-equipment-vogele-super-1800-2",
              "name": "SUPER 1800-2",
              "subcategories": []
            },
            {
              "id": "asphalt-equipment-vogele-super-1800-2-sprayjet",
              "name": "SUPER 1800-2 SPRAYJET",
              "subcategories": []
            },
            {
              "id": "asphalt-equipment-vogele-super-1800-2hd",
              "name": "SUPER 1800-2HD",
              "subcategories": []
            },
            {
              "id": "asphalt-equipment-vogele-super-1800-2l",
              "name": "SUPER 1800-2L",
              "subcategories": []
            },
            {
              "id": "asphalt-equipment-vogele-super-1800-3",
              "name": "SUPER 1800-3",
              "subcategories": []
            },
            {
              "id": "asphalt-equipment-vogele-super-1800-3i",
              "name": "SUPER 1800-3I",
              "subcategories": []
            },
            {
              "id": "asphalt-equipment-vogele-super-1800-3i-sprayjet",
              "name": "SUPER 1800-3I SPRAYJET",
              "subcategories": []
            },
            {
              "id": "asphalt-equipment-vogele-super-1800-5i",
              "name": "SUPER 1800-5I",
              "subcategories": []
            },
            {
              "id": "asphalt-equipment-vogele-super-1803-1",
              "name": "SUPER 1803-1",
              "subcategories": []
            },
            {
              "id": "asphalt-equipment-vogele-super-1803-2",
              "name": "SUPER 1803-2",
              "subcategories": []
            },
            {
              "id": "asphalt-equipment-vogele-super-1800-3",
              "name": "SUPER 1800-3",
              "subcategories": []
            },
            {
              "id": "asphalt-equipment-vogele-super-1803-3i",
              "name": "SUPER 1803-3I",
              "subcategories": []
            },
            {
              "id": "asphalt-equipment-vogele-super-1880-l",
              "name": "SUPER 1880 L",
              "subcategories": []
            },
            {
              "id": "asphalt-equipment-vogele-super-1880-2hd",
              "name": "SUPER 1880-2HD",
              "subcategories": []
            },
            {
              "id": "asphalt-equipment-vogele-super-1880-3l",
              "name": "SUPER 1880-3L",
              "subcategories": []
            },
            {
              "id": "asphalt-equipment-vogele-super-1900-2",
              "name": "SUPER 1900-2",
              "subcategories": []
            },
            {
              "id": "asphalt-equipment-vogele-super-1900-3",
              "name": "SUPER 1900-3",
              "subcategories": []
            },
            {
              "id": "asphalt-equipment-vogele-super1900-3i",
              "name": "SUPER1900-3I",
              "subcategories": []
            },
            {
              "id": "asphalt-equipment-vogele-super-1900-3l",
              "name": "SUPER 1900-3L",
              "subcategories": []
            },
            {
              "id": "asphalt-equipment-vogele-super-1900-5i",
              "name": "SUPER 1900-5I",
              "subcategories": []
            },
            {
              "id": "asphalt-equipment-vogele-super-2000",
              "name": "SUPER 2000",
              "subcategories": []
            },
            {
              "id": "asphalt-equipment-vogele-super-2000-3i",
              "name": "SUPER 2000-3I",
              "subcategories": []
            },
            {
              "id": "asphalt-equipment-vogele-super-2003-3i",
              "name": "SUPER 2003-3I",
              "subcategories": []
            },
            {
              "id": "asphalt-equipment-vogele-super-2100-2",
              "name": "SUPER 2100-2",
              "subcategories": []
            },
            {
              "id": "asphalt-equipment-vogele-super-2100-3",
              "name": "SUPER 2100-3",
              "subcategories": []
            },
            {
              "id": "asphalt-equipment-vogele-super-2100-3i",
              "name": "SUPER 2100-3I",
              "subcategories": []
            },
            {
              "id": "asphalt-equipment-vogele-super-2100-3l",
              "name": "SUPER 2100-3L",
              "subcategories": []
            },
            {
              "id": "asphalt-equipment-vogele-super-2100-5i",
              "name": "SUPER 2100-5I",
              "subcategories": []
            },
            {
              "id": "asphalt-equipment-vogele-super-2100-5x",
              "name": "SUPER 2100-5X",
              "subcategories": []
            },
            {
              "id": "asphalt-equipment-vogele-super-2100c",
              "name": "SUPER 2100C",
              "subcategories": []
            },
            {
              "id": "asphalt-equipment-vogele-super-2500",
              "name": "SUPER 2500",
              "subcategories": []
            },
            {
              "id": "asphalt-equipment-vogele-super-3000-3i",
              "name": "SUPER 3000-3I",
              "subcategories": []
            },
            {
              "id": "asphalt-equipment-vogele-super-1900",
              "name": "SUPER 1900",
              "subcategories": []
            },
            {
              "id": "asphalt-equipment-vogele-vision-5100-2",
              "name": "VISION 5100-2",
              "subcategories": []
            },
            {
              "id": "asphalt-equipment-vogele-vision-5103-2",
              "name": "VISION 5103-2",
              "subcategories": []
            },
            {
              "id": "asphalt-equipment-vogele-vision-5200-2",
              "name": "VISION 5200-2",
              "subcategories": []
            },
            {
              "id": "asphalt-equipment-vogele-vision-5200-2i",
              "name": "VISION 5200-2I",
              "subcategories": []
            },
            {
              "id": "asphalt-equipment-vogele-vision-5203-2i",
              "name": "VISION 5203-2I",
              "subcategories": []
            },
            {
              "id": "asphalt-equipment-vogele-other",
              "name": "OTHER",
              "subcategories": []
            }
          ]
        },
        {
          "id": "asphalt-equipment-wirtgen",
          "name": "Wirtgen",
          "subcategories": [
            {
              "id": "asphalt-equipment-wirtgen-220",
              "name": "220",
              "subcategories": []
            },
            {
              "id": "asphalt-equipment-wirtgen-260sx",
              "name": "260SX",
              "subcategories": []
            },
            {
              "id": "asphalt-equipment-wirtgen-2080sm",
              "name": "2080SM",
              "subcategories": []
            },
            {
              "id": "asphalt-equipment-wirtgen-500dc",
              "name": "500DC",
              "subcategories": []
            },
            {
              "id": "asphalt-equipment-wirtgen-1000",
              "name": "1000",
              "subcategories": []
            },
            {
              "id": "asphalt-equipment-wirtgen-1500",
              "name": "1500",
              "subcategories": []
            },
            {
              "id": "asphalt-equipment-wirtgen-2000",
              "name": "2000",
              "subcategories": []
            },
            {
              "id": "asphalt-equipment-wirtgen-2100",
              "name": "2100",
              "subcategories": []
            },
            {
              "id": "asphalt-equipment-wirtgen-2200",
              "name": "2200",
              "subcategories": []
            },
            {
              "id": "asphalt-equipment-wirtgen-2500",
              "name": "2500",
              "subcategories": []
            },
            {
              "id": "asphalt-equipment-wirtgen-4200",
              "name": "4200",
              "subcategories": []
            },
            {
              "id": "asphalt-equipment-wirtgen-kma220",
              "name": "KMA220",
              "subcategories": []
            },
            {
              "id": "asphalt-equipment-wirtgen-rx4500",
              "name": "RX4500",
              "subcategories": []
            },
            {
              "id": "asphalt-equipment-wirtgen-sf2500",
              "name": "SF2500",
              "subcategories": []
            },
            {
              "id": "asphalt-equipment-wirtgen-sp15",
              "name": "SP15",
              "subcategories": []
            },
            {
              "id": "asphalt-equipment-wirtgen-sp25",
              "name": "SP25",
              "subcategories": []
            },
            {
              "id": "asphalt-equipment-wirtgen-sp62",
              "name": "SP62",
              "subcategories": []
            },
            {
              "id": "asphalt-equipment-wirtgen-sp64",
              "name": "SP64",
              "subcategories": []
            },
            {
              "id": "asphalt-equipment-wirtgen-sp150",
              "name": "SP150",
              "subcategories": []
            },
            {
              "id": "asphalt-equipment-wirtgen-sp250",
              "name": "SP250",
              "subcategories": []
            },
            {
              "id": "asphalt-equipment-wirtgen-sp500",
              "name": "SP500",
              "subcategories": []
            },
            {
              "id": "asphalt-equipment-wirtgen-sp850",
              "name": "SP850",
              "subcategories": []
            },
            {
              "id": "asphalt-equipment-wirtgen-sp1200",
              "name": "SP1200",
              "subcategories": []
            },
            {
              "id": "asphalt-equipment-wirtgen-sp1600",
              "name": "SP1600",
              "subcategories": []
            },
            {
              "id": "asphalt-equipment-wirtgen-tcm180",
              "name": "TCM180",
              "subcategories": []
            },
            {
              "id": "asphalt-equipment-wirtgen-w35",
              "name": "W35",
              "subcategories": []
            },
            {
              "id": "asphalt-equipment-wirtgen-w50",
              "name": "W50",
              "subcategories": []
            },
            {
              "id": "asphalt-equipment-wirtgen-w60",
              "name": "W60",
              "subcategories": []
            },
            {
              "id": "asphalt-equipment-wirtgen-w100",
              "name": "W100",
              "subcategories": []
            },
            {
              "id": "asphalt-equipment-wirtgen-w120",
              "name": "W120",
              "subcategories": []
            },
            {
              "id": "asphalt-equipment-wirtgen-w125",
              "name": "W125",
              "subcategories": []
            },
            {
              "id": "asphalt-equipment-wirtgen-w130",
              "name": "W130",
              "subcategories": []
            },
            {
              "id": "asphalt-equipment-wirtgen-w150",
              "name": "W150",
              "subcategories": []
            },
            {
              "id": "asphalt-equipment-wirtgen-w155",
              "name": "W155",
              "subcategories": []
            },
            {
              "id": "asphalt-equipment-wirtgen-w195",
              "name": "W195",
              "subcategories": []
            },
            {
              "id": "asphalt-equipment-wirtgen-w195i",
              "name": "W195I",
              "subcategories": []
            },
            {
              "id": "asphalt-equipment-wirtgen-w195p",
              "name": "W195P",
              "subcategories": []
            },
            {
              "id": "asphalt-equipment-wirtgen-w200",
              "name": "W200",
              "subcategories": []
            },
            {
              "id": "asphalt-equipment-wirtgen-w205",
              "name": "W205",
              "subcategories": []
            },
            {
              "id": "asphalt-equipment-wirtgen-w210",
              "name": "W210",
              "subcategories": []
            },
            {
              "id": "asphalt-equipment-wirtgen-w215",
              "name": "W215",
              "subcategories": []
            },
            {
              "id": "asphalt-equipment-wirtgen-w220",
              "name": "W220",
              "subcategories": []
            },
            {
              "id": "asphalt-equipment-wirtgen-w240",
              "name": "W240",
              "subcategories": []
            },
            {
              "id": "asphalt-equipment-wirtgen-w250",
              "name": "W250",
              "subcategories": []
            },
            {
              "id": "asphalt-equipment-wirtgen-w350",
              "name": "W350",
              "subcategories": []
            },
            {
              "id": "asphalt-equipment-wirtgen-w500",
              "name": "W500",
              "subcategories": []
            },
            {
              "id": "asphalt-equipment-wirtgen-w600",
              "name": "W600",
              "subcategories": []
            },
            {
              "id": "asphalt-equipment-wirtgen-w1000",
              "name": "W1000",
              "subcategories": []
            },
            {
              "id": "asphalt-equipment-wirtgen-w1200",
              "name": "W1200",
              "subcategories": []
            },
            {
              "id": "asphalt-equipment-wirtgen-w1900",
              "name": "W1900",
              "subcategories": []
            },
            {
              "id": "asphalt-equipment-wirtgen-w2000",
              "name": "W2000",
              "subcategories": []
            },
            {
              "id": "asphalt-equipment-wirtgen-w2100",
              "name": "W2100",
              "subcategories": []
            },
            {
              "id": "asphalt-equipment-wirtgen-wm400",
              "name": "WM400",
              "subcategories": []
            },
            {
              "id": "asphalt-equipment-wirtgen-wm1000",
              "name": "WM1000",
              "subcategories": []
            },
            {
              "id": "asphalt-equipment-wirtgen-wps62",
              "name": "WPS62",
              "subcategories": []
            },
            {
              "id": "asphalt-equipment-wirtgen-wr200",
              "name": "WR200",
              "subcategories": []
            },
            {
              "id": "asphalt-equipment-wirtgen-wr240",
              "name": "WR240",
              "subcategories": []
            },
            {
              "id": "asphalt-equipment-wirtgen-wr250",
              "name": "WR250",
              "subcategories": []
            },
            {
              "id": "asphalt-equipment-wirtgen-wr2000",
              "name": "WR2000",
              "subcategories": []
            },
            {
              "id": "asphalt-equipment-wirtgen-wr2400",
              "name": "WR2400",
              "subcategories": []
            },
            {
              "id": "asphalt-equipment-wirtgen-wr2500",
              "name": "WR2500",
              "subcategories": []
            },
            {
              "id": "asphalt-equipment-wirtgen-other",
              "name": "OTHER",
              "subcategories": []
            }
          ]
        },
        {
          "id": "asphalt-equipment-leeboy",
          "name": "Leeboy",
          "subcategories": [
            {
              "id": "asphalt-equipment-leeboy-1000",
              "name": "1000",
              "subcategories": []
            },
            {
              "id": "asphalt-equipment-leeboy-1200",
              "name": "1200",
              "subcategories": []
            },
            {
              "id": "asphalt-equipment-leeboy-3000",
              "name": "3000",
              "subcategories": []
            },
            {
              "id": "asphalt-equipment-leeboy-4130",
              "name": "4130",
              "subcategories": []
            },
            {
              "id": "asphalt-equipment-leeboy-5000",
              "name": "5000",
              "subcategories": []
            },
            {
              "id": "asphalt-equipment-leeboy-5300",
              "name": "5300",
              "subcategories": []
            },
            {
              "id": "asphalt-equipment-leeboy-6150",
              "name": "6150",
              "subcategories": []
            },
            {
              "id": "asphalt-equipment-leeboy-7000",
              "name": "7000",
              "subcategories": []
            },
            {
              "id": "asphalt-equipment-leeboy-8000",
              "name": "8000",
              "subcategories": []
            },
            {
              "id": "asphalt-equipment-leeboy-8500",
              "name": "8500",
              "subcategories": []
            },
            {
              "id": "asphalt-equipment-leeboy-8510",
              "name": "8510",
              "subcategories": []
            },
            {
              "id": "asphalt-equipment-leeboy-8515",
              "name": "8515",
              "subcategories": []
            },
            {
              "id": "asphalt-equipment-leeboy-8520",
              "name": "8520",
              "subcategories": []
            },
            {
              "id": "asphalt-equipment-leeboy-8530",
              "name": "8530",
              "subcategories": []
            },
            {
              "id": "asphalt-equipment-leeboy-8608",
              "name": "8608",
              "subcategories": []
            },
            {
              "id": "asphalt-equipment-leeboy-8616",
              "name": "8616",
              "subcategories": []
            },
            {
              "id": "asphalt-equipment-leeboy-8816",
              "name": "8816",
              "subcategories": []
            },
            {
              "id": "asphalt-equipment-leeboy-8680",
              "name": "8680",
              "subcategories": []
            },
            {
              "id": "asphalt-equipment-leeboy-9000",
              "name": "9000",
              "subcategories": []
            },
            {
              "id": "asphalt-equipment-leeboy-hb4t",
              "name": "HB4T",
              "subcategories": []
            },
            {
              "id": "asphalt-equipment-leeboy-l150",
              "name": "L150",
              "subcategories": []
            },
            {
              "id": "asphalt-equipment-leeboy-l250",
              "name": "L250",
              "subcategories": []
            },
            {
              "id": "asphalt-equipment-leeboy-l300",
              "name": "L300",
              "subcategories": []
            },
            {
              "id": "asphalt-equipment-leeboy-l500",
              "name": "L500",
              "subcategories": []
            },
            {
              "id": "asphalt-equipment-leeboy-l600",
              "name": "L600",
              "subcategories": []
            },
            {
              "id": "asphalt-equipment-leeboy-l1000",
              "name": "L1000",
              "subcategories": []
            },
            {
              "id": "asphalt-equipment-leeboy-l7000",
              "name": "L7000",
              "subcategories": []
            },
            {
              "id": "asphalt-equipment-leeboy-l8000",
              "name": "L8000",
              "subcategories": []
            },
            {
              "id": "asphalt-equipment-leeboy-l8500",
              "name": "L8500",
              "subcategories": []
            },
            {
              "id": "asphalt-equipment-leeboy-l8510",
              "name": "L8510",
              "subcategories": []
            },
            {
              "id": "asphalt-equipment-leeboy-l8515",
              "name": "L8515",
              "subcategories": []
            },
            {
              "id": "asphalt-equipment-leeboy-l8816",
              "name": "L8816",
              "subcategories": []
            },
            {
              "id": "asphalt-equipment-leeboy-lbc24",
              "name": "LBC24",
              "subcategories": []
            },
            {
              "id": "asphalt-equipment-leeboy-maximizer-3b",
              "name": "MAXIMIZER 3B",
              "subcategories": []
            },
            {
              "id": "asphalt-equipment-leeboy-pf1510",
              "name": "PF1510",
              "subcategories": []
            },
            {
              "id": "asphalt-equipment-leeboy-rwa35a",
              "name": "RWA35A",
              "subcategories": []
            },
            {
              "id": "asphalt-equipment-leeboy-rw100",
              "name": "RW100",
              "subcategories": []
            }
          ]
        },
        {
          "id": "asphalt-equipment-caterpillar",
          "name": "Caterpillar",
          "subcategories": [
            {
              "id": "asphalt-equipment-caterpillar-ap-200",
              "name": "AP-200",
              "subcategories": []
            },
            {
              "id": "asphalt-equipment-caterpillar-ap-255",
              "name": "AP-255",
              "subcategories": []
            },
            {
              "id": "asphalt-equipment-caterpillar-ap300",
              "name": "AP300",
              "subcategories": []
            },
            {
              "id": "asphalt-equipment-caterpillar-ap-355",
              "name": "AP-355",
              "subcategories": []
            },
            {
              "id": "asphalt-equipment-caterpillar-ap-455",
              "name": "AP-455",
              "subcategories": []
            },
            {
              "id": "asphalt-equipment-caterpillar-ap-500",
              "name": "AP-500",
              "subcategories": []
            },
            {
              "id": "asphalt-equipment-caterpillar-ap-555",
              "name": "AP-555",
              "subcategories": []
            },
            {
              "id": "asphalt-equipment-caterpillar-ap-600",
              "name": "AP-600",
              "subcategories": []
            },
            {
              "id": "asphalt-equipment-caterpillar-ap-650",
              "name": "AP-650",
              "subcategories": []
            },
            {
              "id": "asphalt-equipment-caterpillar-ap-655",
              "name": "AP-655",
              "subcategories": []
            },
            {
              "id": "asphalt-equipment-caterpillar-ap-755",
              "name": "AP-755",
              "subcategories": []
            },
            {
              "id": "asphalt-equipment-caterpillar-ap-800",
              "name": "AP-800",
              "subcategories": []
            },
            {
              "id": "asphalt-equipment-caterpillar-ap-900",
              "name": "AP-900",
              "subcategories": []
            },
            {
              "id": "asphalt-equipment-caterpillar-ap-1000",
              "name": "AP-1000",
              "subcategories": []
            },
            {
              "id": "asphalt-equipment-caterpillar-ap-1050",
              "name": "AP-1050",
              "subcategories": []
            },
            {
              "id": "asphalt-equipment-caterpillar-ap-1055",
              "name": "AP-1055",
              "subcategories": []
            },
            {
              "id": "asphalt-equipment-caterpillar-as2301",
              "name": "AS2301",
              "subcategories": []
            },
            {
              "id": "asphalt-equipment-caterpillar-as4251",
              "name": "AS4251",
              "subcategories": []
            },
            {
              "id": "asphalt-equipment-caterpillar-bb621",
              "name": "BB621",
              "subcategories": []
            },
            {
              "id": "asphalt-equipment-caterpillar-bbg-225",
              "name": "BBG-225",
              "subcategories": []
            },
            {
              "id": "asphalt-equipment-caterpillar-bg-2455",
              "name": "BG-2455",
              "subcategories": []
            },
            {
              "id": "asphalt-equipment-caterpillar-pm-102",
              "name": "PM-102",
              "subcategories": []
            },
            {
              "id": "asphalt-equipment-caterpillar-pm-200",
              "name": "PM-200",
              "subcategories": []
            },
            {
              "id": "asphalt-equipment-caterpillar-pm-310",
              "name": "PM-310",
              "subcategories": []
            },
            {
              "id": "asphalt-equipment-caterpillar-pm-312",
              "name": "PM-312",
              "subcategories": []
            },
            {
              "id": "asphalt-equipment-caterpillar-pm-313",
              "name": "PM-313",
              "subcategories": []
            },
            {
              "id": "asphalt-equipment-caterpillar-pm-465",
              "name": "PM-465",
              "subcategories": []
            },
            {
              "id": "asphalt-equipment-caterpillar-pm-565",
              "name": "PM-565",
              "subcategories": []
            },
            {
              "id": "asphalt-equipment-caterpillar-pm-620",
              "name": "PM-620",
              "subcategories": []
            },
            {
              "id": "asphalt-equipment-caterpillar-pm-622",
              "name": "PM-622",
              "subcategories": []
            },
            {
              "id": "asphalt-equipment-caterpillar-pm-822",
              "name": "PM-822",
              "subcategories": []
            },
            {
              "id": "asphalt-equipment-caterpillar-pr-75",
              "name": "PR-75",
              "subcategories": []
            },
            {
              "id": "asphalt-equipment-caterpillar-pr-750",
              "name": "PR-750",
              "subcategories": []
            },
            {
              "id": "asphalt-equipment-caterpillar-pr-1000",
              "name": "PR-1000",
              "subcategories": []
            },
            {
              "id": "asphalt-equipment-caterpillar-rm-250",
              "name": "RM-250",
              "subcategories": []
            },
            {
              "id": "asphalt-equipment-caterpillar-rm-300",
              "name": "RM-300",
              "subcategories": []
            },
            {
              "id": "asphalt-equipment-caterpillar-rm-350",
              "name": "RM-350",
              "subcategories": []
            },
            {
              "id": "asphalt-equipment-caterpillar-rm-400",
              "name": "RM-400",
              "subcategories": []
            },
            {
              "id": "asphalt-equipment-caterpillar-rm-500",
              "name": "RM-500",
              "subcategories": []
            },
            {
              "id": "asphalt-equipment-caterpillar-rm-600",
              "name": "RM-600",
              "subcategories": []
            },
            {
              "id": "asphalt-equipment-caterpillar-rm-800",
              "name": "RM-800",
              "subcategories": []
            },
            {
              "id": "asphalt-equipment-caterpillar-rr-250",
              "name": "RR-250",
              "subcategories": []
            },
            {
              "id": "asphalt-equipment-caterpillar-ss-250",
              "name": "SS-250",
              "subcategories": []
            },
            {
              "id": "asphalt-equipment-caterpillar-other",
              "name": "OTHER",
              "subcategories": []
            }
          ]
        },
        {
          "id": "asphalt-equipment-husqvarna",
          "name": "Husqvarna",
          "subcategories": [
            {
              "id": "asphalt-equipment-husqvarna-soff-cut-150",
              "name": "SOFF-CUT 150",
              "subcategories": []
            },
            {
              "id": "asphalt-equipment-husqvarna-soff-cut-2000",
              "name": "SOFF-CUT 2000",
              "subcategories": []
            },
            {
              "id": "asphalt-equipment-husqvarna-soff-cut-2500",
              "name": "SOFF-CUT 2500",
              "subcategories": []
            },
            {
              "id": "asphalt-equipment-husqvarna-soff-cut-4000",
              "name": "SOFF-CUT 4000",
              "subcategories": []
            },
            {
              "id": "asphalt-equipment-husqvarna-soff-cut-4200",
              "name": "SOFF-CUT 4200",
              "subcategories": []
            },
            {
              "id": "asphalt-equipment-husqvarna-soff-cut-5000",
              "name": "SOFF-CUT 5000",
              "subcategories": []
            },
            {
              "id": "asphalt-equipment-husqvarna-soff-cut-x4000",
              "name": "SOFF-CUT X4000",
              "subcategories": []
            },
            {
              "id": "asphalt-equipment-husqvarna-bg250",
              "name": "BG250",
              "subcategories": []
            },
            {
              "id": "asphalt-equipment-husqvarna-bg20",
              "name": "BG20",
              "subcategories": []
            },
            {
              "id": "asphalt-equipment-husqvarna-bv30",
              "name": "BV30",
              "subcategories": []
            },
            {
              "id": "asphalt-equipment-husqvarna-crt36",
              "name": "CRT36",
              "subcategories": []
            },
            {
              "id": "asphalt-equipment-husqvarna-crt48",
              "name": "CRT48",
              "subcategories": []
            },
            {
              "id": "asphalt-equipment-husqvarna-crtr60",
              "name": "CRTR60",
              "subcategories": []
            },
            {
              "id": "asphalt-equipment-husqvarna-ct36",
              "name": "CT36",
              "subcategories": []
            },
            {
              "id": "asphalt-equipment-husqvarna-ct48",
              "name": "CT48",
              "subcategories": []
            },
            {
              "id": "asphalt-equipment-husqvarna-de120",
              "name": "DE120",
              "subcategories": []
            },
            {
              "id": "asphalt-equipment-husqvarna-fs309",
              "name": "FS309",
              "subcategories": []
            },
            {
              "id": "asphalt-equipment-husqvarna-fs400",
              "name": "FS400",
              "subcategories": []
            },
            {
              "id": "asphalt-equipment-husqvarna-fs513",
              "name": "FS513",
              "subcategories": []
            },
            {
              "id": "asphalt-equipment-husqvarna-fs520",
              "name": "FS520",
              "subcategories": []
            },
            {
              "id": "asphalt-equipment-husqvarna-fs524",
              "name": "FS524",
              "subcategories": []
            },
            {
              "id": "asphalt-equipment-husqvarna-fs600",
              "name": "FS600",
              "subcategories": []
            },
            {
              "id": "asphalt-equipment-husqvarna-fs3500",
              "name": "FS3500",
              "subcategories": []
            },
            {
              "id": "asphalt-equipment-husqvarna-fs4600",
              "name": "FS4600",
              "subcategories": []
            },
            {
              "id": "asphalt-equipment-husqvarna-fs4800",
              "name": "FS4800",
              "subcategories": []
            },
            {
              "id": "asphalt-equipment-husqvarna-fs5000",
              "name": "FS5000",
              "subcategories": []
            },
            {
              "id": "asphalt-equipment-husqvarna-fs6600",
              "name": "FS6600",
              "subcategories": []
            },
            {
              "id": "asphalt-equipment-husqvarna-fs7000",
              "name": "FS7000",
              "subcategories": []
            },
            {
              "id": "asphalt-equipment-husqvarna-htc-270",
              "name": "HTC 270",
              "subcategories": []
            },
            {
              "id": "asphalt-equipment-husqvarna-htc-d60",
              "name": "HTC D60",
              "subcategories": []
            },
            {
              "id": "asphalt-equipment-husqvarna-htc",
              "name": "HTC",
              "subcategories": []
            },
            {
              "id": "asphalt-equipment-husqvarna-pg5",
              "name": "PG5",
              "subcategories": []
            },
            {
              "id": "asphalt-equipment-husqvarna-pg6",
              "name": "PG6",
              "subcategories": []
            },
            {
              "id": "asphalt-equipment-husqvarna-pg8",
              "name": "PG8",
              "subcategories": []
            },
            {
              "id": "asphalt-equipment-husqvarna-pg280",
              "name": "PG280",
              "subcategories": []
            },
            {
              "id": "asphalt-equipment-husqvarna-pg400",
              "name": "PG400",
              "subcategories": []
            },
            {
              "id": "asphalt-equipment-husqvarna-pg450",
              "name": "PG450",
              "subcategories": []
            },
            {
              "id": "asphalt-equipment-husqvarna-pg510",
              "name": "PG510",
              "subcategories": []
            },
            {
              "id": "asphalt-equipment-husqvarna-pg540",
              "name": "PG540",
              "subcategories": []
            },
            {
              "id": "asphalt-equipment-husqvarna-pg690",
              "name": "PG690",
              "subcategories": []
            },
            {
              "id": "asphalt-equipment-husqvarna-pg820",
              "name": "PG820",
              "subcategories": []
            },
            {
              "id": "asphalt-equipment-husqvarna-pg830",
              "name": "PG830",
              "subcategories": []
            },
            {
              "id": "asphalt-equipment-husqvarna-rs7400",
              "name": "RS7400",
              "subcategories": []
            },
            {
              "id": "asphalt-equipment-husqvarna-t4000",
              "name": "T4000",
              "subcategories": []
            },
            {
              "id": "asphalt-equipment-husqvarna-ws482",
              "name": "WS482",
              "subcategories": []
            },
            {
              "id": "asphalt-equipment-husqvarna-x4200",
              "name": "X4200",
              "subcategories": []
            },
            {
              "id": "asphalt-equipment-husqvarna-other",
              "name": "OTHER",
              "subcategories": []
            }
          ]
        },
        {
          "id": "asphalt-equipment-multiquip-whiteman",
          "name": "Multiquip-Whiteman",
          "subcategories": []
        },
        {
          "id": "asphalt-equipment-toro",
          "name": "Toro",
          "subcategories": [
            {
              "id": "asphalt-equipment-toro-68008",
              "name": "68008",
              "subcategories": []
            },
            {
              "id": "asphalt-equipment-toro-cm658",
              "name": "CM658",
              "subcategories": []
            },
            {
              "id": "asphalt-equipment-toro-cm958",
              "name": "CM958",
              "subcategories": []
            },
            {
              "id": "asphalt-equipment-toro-cm1258",
              "name": "CM1258",
              "subcategories": []
            },
            {
              "id": "asphalt-equipment-toro-mb1600",
              "name": "MB1600",
              "subcategories": []
            },
            {
              "id": "asphalt-equipment-toro-mbtx2500",
              "name": "MBTX2500",
              "subcategories": []
            },
            {
              "id": "asphalt-equipment-toro-mbtx2500s",
              "name": "MBTX2500S",
              "subcategories": []
            },
            {
              "id": "asphalt-equipment-toro-mbtx2500t",
              "name": "MBTX2500T",
              "subcategories": []
            },
            {
              "id": "asphalt-equipment-toro-mmx858",
              "name": "MMX858",
              "subcategories": []
            },
            {
              "id": "asphalt-equipment-toro-pt46",
              "name": "PT46",
              "subcategories": []
            },
            {
              "id": "asphalt-equipment-toro-ultra-buggy-2500",
              "name": "ULTRA BUGGY 2500",
              "subcategories": []
            },
            {
              "id": "asphalt-equipment-toro-ultra-buggy-2500t",
              "name": "ULTRA BUGGY 2500T",
              "subcategories": []
            },
            {
              "id": "asphalt-equipment-toro-ultra-buggy-2500ts",
              "name": "ULTRA BUGGY 2500TS",
              "subcategories": []
            },
            {
              "id": "asphalt-equipment-toro-ultra-buggy-e2500",
              "name": "ULTRA BUGGY E2500",
              "subcategories": []
            },
            {
              "id": "asphalt-equipment-toro-ultra-buggy-e2500-thl",
              "name": "ULTRA BUGGY E2500-THL",
              "subcategories": []
            },
            {
              "id": "asphalt-equipment-toro-other",
              "name": "OTHER",
              "subcategories": []
            }
          ]
        },
        {
          "id": "asphalt-equipment-bomag",
          "name": "Bomag",
          "subcategories": [
            {
              "id": "asphalt-equipment-bomag-815",
              "name": "815",
              "subcategories": []
            },
            {
              "id": "asphalt-equipment-bomag-bf200",
              "name": "BF200",
              "subcategories": []
            },
            {
              "id": "asphalt-equipment-bomag-bf223",
              "name": "BF223",
              "subcategories": []
            },
            {
              "id": "asphalt-equipment-bomag-bf300",
              "name": "BF300",
              "subcategories": []
            },
            {
              "id": "asphalt-equipment-bomag-bf600",
              "name": "BF600",
              "subcategories": []
            },
            {
              "id": "asphalt-equipment-bomag-bf691",
              "name": "BF691",
              "subcategories": []
            },
            {
              "id": "asphalt-equipment-bomag-bf700",
              "name": "BF700",
              "subcategories": []
            },
            {
              "id": "asphalt-equipment-bomag-bf800",
              "name": "BF800",
              "subcategories": []
            },
            {
              "id": "asphalt-equipment-bomag-bf880",
              "name": "BF880",
              "subcategories": []
            },
            {
              "id": "asphalt-equipment-bomag-bf980",
              "name": "BF980",
              "subcategories": []
            },
            {
              "id": "asphalt-equipment-bomag-bm500",
              "name": "BM500",
              "subcategories": []
            },
            {
              "id": "asphalt-equipment-bomag-bm600",
              "name": "BM600",
              "subcategories": []
            },
            {
              "id": "asphalt-equipment-bomag-bm1000",
              "name": "BM1000",
              "subcategories": []
            },
            {
              "id": "asphalt-equipment-bomag-bm1200",
              "name": "BM1200",
              "subcategories": []
            },
            {
              "id": "asphalt-equipment-bomag-bm1300",
              "name": "BM1300",
              "subcategories": []
            },
            {
              "id": "asphalt-equipment-bomag-bm2000",
              "name": "BM2000",
              "subcategories": []
            },
            {
              "id": "asphalt-equipment-bomag-bm2200",
              "name": "BM2200",
              "subcategories": []
            },
            {
              "id": "asphalt-equipment-bomag-bs5",
              "name": "BS5",
              "subcategories": []
            },
            {
              "id": "asphalt-equipment-bomag-bs10",
              "name": "BS10",
              "subcategories": []
            },
            {
              "id": "asphalt-equipment-bomag-cr362",
              "name": "CR362",
              "subcategories": []
            },
            {
              "id": "asphalt-equipment-bomag-cr452",
              "name": "CR452",
              "subcategories": []
            },
            {
              "id": "asphalt-equipment-bomag-cr552",
              "name": "CR552",
              "subcategories": []
            },
            {
              "id": "asphalt-equipment-bomag-cr820",
              "name": "CR820",
              "subcategories": []
            },
            {
              "id": "asphalt-equipment-bomag-cr1030",
              "name": "CR1030",
              "subcategories": []
            },
            {
              "id": "asphalt-equipment-bomag-mph100",
              "name": "MPH100",
              "subcategories": []
            },
            {
              "id": "asphalt-equipment-bomag-mph122",
              "name": "MPH122",
              "subcategories": []
            },
            {
              "id": "asphalt-equipment-bomag-mph125",
              "name": "MPH125",
              "subcategories": []
            },
            {
              "id": "asphalt-equipment-bomag-mph362",
              "name": "MPH362",
              "subcategories": []
            },
            {
              "id": "asphalt-equipment-bomag-mph364",
              "name": "MPH364",
              "subcategories": []
            },
            {
              "id": "asphalt-equipment-bomag-mph600",
              "name": "MPH600",
              "subcategories": []
            },
            {
              "id": "asphalt-equipment-bomag-ms4",
              "name": "MS4",
              "subcategories": []
            },
            {
              "id": "asphalt-equipment-bomag-propaver-813-rt",
              "name": "PROPAVER 813 RT",
              "subcategories": []
            },
            {
              "id": "asphalt-equipment-bomag-propaver-814-2",
              "name": "PROPAVER 814-2",
              "subcategories": []
            },
            {
              "id": "asphalt-equipment-bomag-propaver-4410",
              "name": "PROPAVER 4410",
              "subcategories": []
            },
            {
              "id": "asphalt-equipment-bomag-rs300",
              "name": "RS300",
              "subcategories": []
            },
            {
              "id": "asphalt-equipment-bomag-rs360",
              "name": "RS360",
              "subcategories": []
            },
            {
              "id": "asphalt-equipment-bomag-rs460",
              "name": "RS460",
              "subcategories": []
            },
            {
              "id": "asphalt-equipment-bomag-rs500",
              "name": "RS500",
              "subcategories": []
            },
            {
              "id": "asphalt-equipment-bomag-rs650",
              "name": "RS650",
              "subcategories": []
            },
            {
              "id": "asphalt-equipment-bomag-other",
              "name": "OTHER",
              "subcategories": []
            }
          ]
        },
        {
          "id": "asphalt-equipment-roadtec",
          "name": "Roadtec",
          "subcategories": [
            {
              "id": "asphalt-equipment-roadtec-cb100",
              "name": "CB100",
              "subcategories": []
            },
            {
              "id": "asphalt-equipment-roadtec-mtv1000",
              "name": "MTV1000",
              "subcategories": []
            },
            {
              "id": "asphalt-equipment-roadtec-rp150",
              "name": "RP150",
              "subcategories": []
            },
            {
              "id": "asphalt-equipment-roadtec-rp170",
              "name": "RP170",
              "subcategories": []
            },
            {
              "id": "asphalt-equipment-roadtec-rp175",
              "name": "RP175",
              "subcategories": []
            },
            {
              "id": "asphalt-equipment-roadtec-rp190",
              "name": "RP190",
              "subcategories": []
            },
            {
              "id": "asphalt-equipment-roadtec-rp195",
              "name": "RP195",
              "subcategories": []
            },
            {
              "id": "asphalt-equipment-roadtec-rx10",
              "name": "RX10",
              "subcategories": []
            },
            {
              "id": "asphalt-equipment-roadtec-rx100",
              "name": "RX100",
              "subcategories": []
            },
            {
              "id": "asphalt-equipment-roadtec-rx300",
              "name": "RX300",
              "subcategories": []
            },
            {
              "id": "asphalt-equipment-roadtec-rx500",
              "name": "RX500",
              "subcategories": []
            },
            {
              "id": "asphalt-equipment-roadtec-rx505",
              "name": "RX505",
              "subcategories": []
            },
            {
              "id": "asphalt-equipment-roadtec-rx600",
              "name": "RX600",
              "subcategories": []
            },
            {
              "id": "asphalt-equipment-roadtec-rx700",
              "name": "RX700",
              "subcategories": []
            },
            {
              "id": "asphalt-equipment-roadtec-rx900",
              "name": "RX900",
              "subcategories": []
            },
            {
              "id": "asphalt-equipment-roadtec-sb2500",
              "name": "SB2500",
              "subcategories": []
            },
            {
              "id": "asphalt-equipment-roadtec-sb3000",
              "name": "SB3000",
              "subcategories": []
            },
            {
              "id": "asphalt-equipment-roadtec-sp100",
              "name": "SP100",
              "subcategories": []
            },
            {
              "id": "asphalt-equipment-roadtec-sp200",
              "name": "SP200",
              "subcategories": []
            },
            {
              "id": "asphalt-equipment-roadtec-sx2e",
              "name": "SX2E",
              "subcategories": []
            },
            {
              "id": "asphalt-equipment-roadtec-sx4e",
              "name": "SX4E",
              "subcategories": []
            },
            {
              "id": "asphalt-equipment-roadtec-sx6",
              "name": "SX6",
              "subcategories": []
            },
            {
              "id": "asphalt-equipment-roadtec-other",
              "name": "OTHER",
              "subcategories": []
            }
          ]
        },
        {
          "id": "asphalt-equipment-chikusuiu-canycom",
          "name": "Chikusuiu Canycom",
          "subcategories": []
        },
        {
          "id": "asphalt-equipment-abg",
          "name": "Abg",
          "subcategories": [
            {
              "id": "asphalt-equipment-abg-titan-325-epm",
              "name": "TITAN 325 EPM",
              "subcategories": []
            },
            {
              "id": "asphalt-equipment-abg-titan-420",
              "name": "TITAN 420",
              "subcategories": []
            },
            {
              "id": "asphalt-equipment-abg-titan-473",
              "name": "TITAN 473",
              "subcategories": []
            },
            {
              "id": "asphalt-equipment-abg-titan-473-2",
              "name": "TITAN 473-2",
              "subcategories": []
            },
            {
              "id": "asphalt-equipment-abg-titan-525",
              "name": "TITAN 525",
              "subcategories": []
            },
            {
              "id": "asphalt-equipment-abg-titan-2820",
              "name": "TITAN 2820",
              "subcategories": []
            },
            {
              "id": "asphalt-equipment-abg-titan-7820",
              "name": "TITAN 7820",
              "subcategories": []
            },
            {
              "id": "asphalt-equipment-abg-other",
              "name": "OTHER",
              "subcategories": []
            }
          ]
        },
        {
          "id": "asphalt-equipment-aesco-madsen",
          "name": "Aesco Madsen",
          "subcategories": [
            {
              "id": "asphalt-equipment-aesco-madsen-10x30",
              "name": "10X30",
              "subcategories": []
            },
            {
              "id": "asphalt-equipment-aesco-madsen-cfm250",
              "name": "CFM250",
              "subcategories": []
            },
            {
              "id": "asphalt-equipment-aesco-madsen-dm6828",
              "name": "DM6828",
              "subcategories": []
            },
            {
              "id": "asphalt-equipment-aesco-madsen-eco-foam-ii",
              "name": "ECO-FOAM II",
              "subcategories": []
            },
            {
              "id": "asphalt-equipment-aesco-madsen-fb4",
              "name": "FB4",
              "subcategories": []
            },
            {
              "id": "asphalt-equipment-aesco-madsen-hrb680",
              "name": "HRB680",
              "subcategories": []
            },
            {
              "id": "asphalt-equipment-aesco-madsen-pt2500",
              "name": "PT2500",
              "subcategories": []
            },
            {
              "id": "asphalt-equipment-aesco-madsen-rt",
              "name": "RT",
              "subcategories": []
            },
            {
              "id": "asphalt-equipment-aesco-madsen-wm80",
              "name": "WM80",
              "subcategories": []
            },
            {
              "id": "asphalt-equipment-aesco-madsen-other",
              "name": "OTHER",
              "subcategories": []
            }
          ]
        },
        {
          "id": "asphalt-equipment-allen-eng",
          "name": "Allen Eng",
          "subcategories": [
            {
              "id": "asphalt-equipment-allen-eng-1200",
              "name": "1200",
              "subcategories": []
            },
            {
              "id": "asphalt-equipment-allen-eng-ar16",
              "name": "AR16",
              "subcategories": []
            },
            {
              "id": "asphalt-equipment-allen-eng-at14",
              "name": "AT14",
              "subcategories": []
            },
            {
              "id": "asphalt-equipment-allen-eng-at16",
              "name": "AT16",
              "subcategories": []
            },
            {
              "id": "asphalt-equipment-allen-eng-at19",
              "name": "AT19",
              "subcategories": []
            },
            {
              "id": "asphalt-equipment-allen-eng-aw16",
              "name": "AW16",
              "subcategories": []
            },
            {
              "id": "asphalt-equipment-allen-eng-aw21",
              "name": "AW21",
              "subcategories": []
            },
            {
              "id": "asphalt-equipment-allen-eng-bdf4836",
              "name": "BDF4836",
              "subcategories": []
            },
            {
              "id": "asphalt-equipment-allen-eng-hd530",
              "name": "HD530",
              "subcategories": []
            },
            {
              "id": "asphalt-equipment-allen-eng-hd2020",
              "name": "HD2020",
              "subcategories": []
            },
            {
              "id": "asphalt-equipment-allen-eng-hd7070",
              "name": "HD7070",
              "subcategories": []
            },
            {
              "id": "asphalt-equipment-allen-eng-hde1010",
              "name": "HDE1010",
              "subcategories": []
            },
            {
              "id": "asphalt-equipment-allen-eng-hdx600",
              "name": "HDX600",
              "subcategories": []
            },
            {
              "id": "asphalt-equipment-allen-eng-hdx760",
              "name": "HDX760",
              "subcategories": []
            },
            {
              "id": "asphalt-equipment-allen-eng-hdx780",
              "name": "HDX780",
              "subcategories": []
            },
            {
              "id": "asphalt-equipment-allen-eng-hdx705",
              "name": "HDX705",
              "subcategories": []
            },
            {
              "id": "asphalt-equipment-allen-eng-hdx805",
              "name": "HDX805",
              "subcategories": []
            },
            {
              "id": "asphalt-equipment-allen-eng-hp205",
              "name": "HP205",
              "subcategories": []
            },
            {
              "id": "asphalt-equipment-allen-eng-mp215",
              "name": "MP215",
              "subcategories": []
            },
            {
              "id": "asphalt-equipment-allen-eng-mp245",
              "name": "MP245",
              "subcategories": []
            },
            {
              "id": "asphalt-equipment-allen-eng-msp445",
              "name": "MSP445",
              "subcategories": []
            },
            {
              "id": "asphalt-equipment-allen-eng-msp455",
              "name": "MSP455",
              "subcategories": []
            },
            {
              "id": "asphalt-equipment-allen-eng-msp465",
              "name": "MSP465",
              "subcategories": []
            },
            {
              "id": "asphalt-equipment-allen-eng-msp475",
              "name": "MSP475",
              "subcategories": []
            },
            {
              "id": "asphalt-equipment-allen-eng-pro424",
              "name": "PRO424",
              "subcategories": []
            },
            {
              "id": "asphalt-equipment-allen-eng-pro436",
              "name": "PRO436",
              "subcategories": []
            },
            {
              "id": "asphalt-equipment-allen-eng-pro446",
              "name": "PRO446",
              "subcategories": []
            },
            {
              "id": "asphalt-equipment-allen-eng-razorback-se12",
              "name": "RAZORBACK SE12",
              "subcategories": []
            },
            {
              "id": "asphalt-equipment-allen-eng-rp245",
              "name": "RP245",
              "subcategories": []
            },
            {
              "id": "asphalt-equipment-allen-eng-rtf-epu",
              "name": "RTF EPU",
              "subcategories": []
            },
            {
              "id": "asphalt-equipment-allen-eng-sa-12",
              "name": "SA 12",
              "subcategories": []
            },
            {
              "id": "asphalt-equipment-allen-eng-se-12",
              "name": "SE 12",
              "subcategories": []
            },
            {
              "id": "asphalt-equipment-allen-eng-sp446",
              "name": "SP446",
              "subcategories": []
            },
            {
              "id": "asphalt-equipment-allen-eng-trtp255",
              "name": "TRTP255",
              "subcategories": []
            },
            {
              "id": "asphalt-equipment-allen-eng-other",
              "name": "OTHER",
              "subcategories": []
            }
          ]
        },
        {
          "id": "asphalt-equipment-amag",
          "name": "Amag",
          "subcategories": [
            {
              "id": "asphalt-equipment-amag-cs2-12",
              "name": "CS2-12",
              "subcategories": []
            },
            {
              "id": "asphalt-equipment-amag-cs3-16",
              "name": "CS3-16",
              "subcategories": []
            },
            {
              "id": "asphalt-equipment-amag-cs3-17",
              "name": "CS3-17",
              "subcategories": []
            },
            {
              "id": "asphalt-equipment-amag-mft2-8",
              "name": "MFT2-8",
              "subcategories": []
            },
            {
              "id": "asphalt-equipment-amag-mft3-19",
              "name": "MFT3-19",
              "subcategories": []
            },
            {
              "id": "asphalt-equipment-amag-mft-mx",
              "name": "MFT MX",
              "subcategories": []
            },
            {
              "id": "asphalt-equipment-amag-ms-f-3",
              "name": "MS F-3",
              "subcategories": []
            },
            {
              "id": "asphalt-equipment-amag-ms-r-5",
              "name": "MS R-5",
              "subcategories": []
            },
            {
              "id": "asphalt-equipment-amag-ps2-11",
              "name": "PS2-11",
              "subcategories": []
            },
            {
              "id": "asphalt-equipment-amag-ts2-12",
              "name": "TS2-12",
              "subcategories": []
            },
            {
              "id": "asphalt-equipment-amag-other",
              "name": "OTHER",
              "subcategories": []
            }
          ]
        },
        {
          "id": "asphalt-equipment-ammann",
          "name": "Ammann",
          "subcategories": [
            {
              "id": "asphalt-equipment-ammann-aft300",
              "name": "AFT300",
              "subcategories": []
            },
            {
              "id": "asphalt-equipment-ammann-aft500",
              "name": "AFT500",
              "subcategories": []
            },
            {
              "id": "asphalt-equipment-ammann-afw150",
              "name": "AFW150",
              "subcategories": []
            },
            {
              "id": "asphalt-equipment-ammann-afw270",
              "name": "AFW270",
              "subcategories": []
            },
            {
              "id": "asphalt-equipment-ammann-afw350",
              "name": "AFW350",
              "subcategories": []
            },
            {
              "id": "asphalt-equipment-ammann-cbt60",
              "name": "CBT60",
              "subcategories": []
            },
            {
              "id": "asphalt-equipment-ammann-pw3503",
              "name": "PW3503",
              "subcategories": []
            },
            {
              "id": "asphalt-equipment-ammann-rss-120",
              "name": "RSS 120",
              "subcategories": []
            },
            {
              "id": "asphalt-equipment-ammann-other",
              "name": "OTHER",
              "subcategories": []
            }
          ]
        },
        {
          "id": "asphalt-equipment-asphalt-zipper",
          "name": "Asphalt Zipper",
          "subcategories": [
            {
              "id": "asphalt-equipment-asphalt-zipper-360x",
              "name": "360X",
              "subcategories": []
            },
            {
              "id": "asphalt-equipment-asphalt-zipper-az300",
              "name": "AZ300",
              "subcategories": []
            },
            {
              "id": "asphalt-equipment-asphalt-zipper-az300b",
              "name": "AZ300B",
              "subcategories": []
            },
            {
              "id": "asphalt-equipment-asphalt-zipper-az360",
              "name": "AZ360",
              "subcategories": []
            },
            {
              "id": "asphalt-equipment-asphalt-zipper-az360hd",
              "name": "AZ360HD",
              "subcategories": []
            },
            {
              "id": "asphalt-equipment-asphalt-zipper-az480",
              "name": "AZ480",
              "subcategories": []
            },
            {
              "id": "asphalt-equipment-asphalt-zipper-az480hd",
              "name": "AZ480HD",
              "subcategories": []
            },
            {
              "id": "asphalt-equipment-asphalt-zipper-az480s",
              "name": "AZ480S",
              "subcategories": []
            },
            {
              "id": "asphalt-equipment-asphalt-zipper-az500",
              "name": "AZ500",
              "subcategories": []
            },
            {
              "id": "asphalt-equipment-asphalt-zipper-az550b",
              "name": "AZ550B",
              "subcategories": []
            },
            {
              "id": "asphalt-equipment-asphalt-zipper-az600b",
              "name": "AZ600B",
              "subcategories": []
            },
            {
              "id": "asphalt-equipment-asphalt-zipper-other",
              "name": "OTHER",
              "subcategories": []
            }
          ]
        },
        {
          "id": "asphalt-equipment-astec",
          "name": "Astec",
          "subcategories": [
            {
              "id": "asphalt-equipment-astec-200-ton",
              "name": "200 TON",
              "subcategories": []
            },
            {
              "id": "asphalt-equipment-astec-250-tph",
              "name": "250 TPH",
              "subcategories": []
            },
            {
              "id": "asphalt-equipment-astec-300tph",
              "name": "300TPH",
              "subcategories": []
            },
            {
              "id": "asphalt-equipment-astec-carlson-cp85",
              "name": "CARLSON CP85",
              "subcategories": []
            },
            {
              "id": "asphalt-equipment-astec-carlson-cp100-ii",
              "name": "CARLSON CP100 II",
              "subcategories": []
            },
            {
              "id": "asphalt-equipment-astec-carlson-cp130",
              "name": "CARLSON CP130",
              "subcategories": []
            },
            {
              "id": "asphalt-equipment-astec-double-barrell",
              "name": "DOUBLE BARRELL",
              "subcategories": []
            },
            {
              "id": "asphalt-equipment-astec-pddc",
              "name": "PDDC",
              "subcategories": []
            },
            {
              "id": "asphalt-equipment-astec-rbh",
              "name": "RBH",
              "subcategories": []
            },
            {
              "id": "asphalt-equipment-astec-roadtec-mtv1100",
              "name": "ROADTEC MTV1100",
              "subcategories": []
            },
            {
              "id": "asphalt-equipment-astec-roadtec-rp170",
              "name": "ROADTEC RP170",
              "subcategories": []
            },
            {
              "id": "asphalt-equipment-astec-roadtec-rp195",
              "name": "ROADTEC RP195",
              "subcategories": []
            },
            {
              "id": "asphalt-equipment-astec-roadtec-rp195f",
              "name": "ROADTEC RP195F",
              "subcategories": []
            },
            {
              "id": "asphalt-equipment-astec-roadtec-sb3000",
              "name": "ROADTEC SB3000",
              "subcategories": []
            },
            {
              "id": "asphalt-equipment-astec-roadtec-rp175",
              "name": "ROADTEC RP175",
              "subcategories": []
            },
            {
              "id": "asphalt-equipment-astec-roadtec-rx405",
              "name": "ROADTEC RX405",
              "subcategories": []
            },
            {
              "id": "asphalt-equipment-astec-roadtec-rx505e",
              "name": "ROADTEC RX505E",
              "subcategories": []
            },
            {
              "id": "asphalt-equipment-astec-s-10",
              "name": "S-10",
              "subcategories": []
            },
            {
              "id": "asphalt-equipment-astec-tc2000",
              "name": "TC2000",
              "subcategories": []
            },
            {
              "id": "asphalt-equipment-astec-vt140sl",
              "name": "VT140SL",
              "subcategories": []
            },
            {
              "id": "asphalt-equipment-astec-other",
              "name": "OTHER",
              "subcategories": []
            }
          ]
        },
        {
          "id": "asphalt-equipment-barber-greene",
          "name": "Barber Greene",
          "subcategories": []
        },
        {
          "id": "asphalt-equipment-bartell",
          "name": "Bartell",
          "subcategories": [
            {
              "id": "asphalt-equipment-bartell-b424",
              "name": "B424",
              "subcategories": []
            },
            {
              "id": "asphalt-equipment-bartell-b436",
              "name": "B436",
              "subcategories": []
            },
            {
              "id": "asphalt-equipment-bartell-bss1813",
              "name": "BSS1813",
              "subcategories": []
            },
            {
              "id": "asphalt-equipment-bartell-cb45",
              "name": "CB45",
              "subcategories": []
            },
            {
              "id": "asphalt-equipment-bartell-mmh6",
              "name": "MMH6",
              "subcategories": []
            },
            {
              "id": "asphalt-equipment-bartell-other",
              "name": "OTHER",
              "subcategories": []
            }
          ]
        },
        {
          "id": "asphalt-equipment-bergkamp",
          "name": "Bergkamp",
          "subcategories": [
            {
              "id": "asphalt-equipment-bergkamp-fp5",
              "name": "FP5",
              "subcategories": []
            },
            {
              "id": "asphalt-equipment-bergkamp-hd10",
              "name": "HD10",
              "subcategories": []
            },
            {
              "id": "asphalt-equipment-bergkamp-m1",
              "name": "M1",
              "subcategories": []
            },
            {
              "id": "asphalt-equipment-bergkamp-m208",
              "name": "M208",
              "subcategories": []
            },
            {
              "id": "asphalt-equipment-bergkamp-m210",
              "name": "M210",
              "subcategories": []
            },
            {
              "id": "asphalt-equipment-bergkamp-ma30",
              "name": "MA30",
              "subcategories": []
            },
            {
              "id": "asphalt-equipment-bergkamp-ms18dt-11yd",
              "name": "MS18DT-11YD",
              "subcategories": []
            },
            {
              "id": "asphalt-equipment-bergkamp-sb804",
              "name": "SB804",
              "subcategories": []
            },
            {
              "id": "asphalt-equipment-bergkamp-sp5",
              "name": "SP5",
              "subcategories": []
            },
            {
              "id": "asphalt-equipment-bergkamp-other",
              "name": "OTHER",
              "subcategories": []
            }
          ]
        },
        {
          "id": "asphalt-equipment-betonblock",
          "name": "Betonblock",
          "subcategories": []
        },
        {
          "id": "asphalt-equipment-bitelli",
          "name": "Bitelli",
          "subcategories": []
        },
        {
          "id": "asphalt-equipment-blawknox",
          "name": "Blawknox",
          "subcategories": []
        },
        {
          "id": "asphalt-equipment-carlson",
          "name": "Carlson",
          "subcategories": [
            {
              "id": "asphalt-equipment-carlson-cp75",
              "name": "CP75",
              "subcategories": []
            },
            {
              "id": "asphalt-equipment-carlson-cp85",
              "name": "CP85",
              "subcategories": []
            },
            {
              "id": "asphalt-equipment-carlson-cp90",
              "name": "CP90",
              "subcategories": []
            },
            {
              "id": "asphalt-equipment-carlson-cp100",
              "name": "CP100",
              "subcategories": []
            },
            {
              "id": "asphalt-equipment-carlson-cp130",
              "name": "CP130",
              "subcategories": []
            },
            {
              "id": "asphalt-equipment-carlson-wp800",
              "name": "WP800",
              "subcategories": []
            },
            {
              "id": "asphalt-equipment-carlson-other",
              "name": "OTHER",
              "subcategories": []
            }
          ]
        },
        {
          "id": "asphalt-equipment-cedar-rapids",
          "name": "Cedar Rapids",
          "subcategories": [
            {
              "id": "asphalt-equipment-cedar-rapids-6-ton",
              "name": "6 TON",
              "subcategories": []
            },
            {
              "id": "asphalt-equipment-cedar-rapids-500-tph",
              "name": "500 TPH",
              "subcategories": []
            },
            {
              "id": "asphalt-equipment-cedar-rapids-8828",
              "name": "8828",
              "subcategories": []
            },
            {
              "id": "asphalt-equipment-cedar-rapids-bsf520",
              "name": "BSF520",
              "subcategories": []
            },
            {
              "id": "asphalt-equipment-cedar-rapids-cr331",
              "name": "CR331",
              "subcategories": []
            },
            {
              "id": "asphalt-equipment-cedar-rapids-cr351",
              "name": "CR351",
              "subcategories": []
            },
            {
              "id": "asphalt-equipment-cedar-rapids-cr352",
              "name": "CR352",
              "subcategories": []
            },
            {
              "id": "asphalt-equipment-cedar-rapids-cr361",
              "name": "CR361",
              "subcategories": []
            },
            {
              "id": "asphalt-equipment-cedar-rapids-cr451",
              "name": "CR451",
              "subcategories": []
            },
            {
              "id": "asphalt-equipment-cedar-rapids-cr461",
              "name": "CR461",
              "subcategories": []
            },
            {
              "id": "asphalt-equipment-cedar-rapids-cr552",
              "name": "CR552",
              "subcategories": []
            },
            {
              "id": "asphalt-equipment-cedar-rapids-cr561",
              "name": "CR561",
              "subcategories": []
            },
            {
              "id": "asphalt-equipment-cedar-rapids-h50",
              "name": "H50",
              "subcategories": []
            },
            {
              "id": "asphalt-equipment-cedar-rapids-ms2",
              "name": "MS2",
              "subcategories": []
            },
            {
              "id": "asphalt-equipment-cedar-rapids-ms4",
              "name": "MS4",
              "subcategories": []
            },
            {
              "id": "asphalt-equipment-cedar-rapids-other",
              "name": "OTHER",
              "subcategories": []
            }
          ]
        },
        {
          "id": "asphalt-equipment-cimline",
          "name": "Cimline",
          "subcategories": [
            {
              "id": "asphalt-equipment-cimline-105",
              "name": "105",
              "subcategories": []
            },
            {
              "id": "asphalt-equipment-cimline-110",
              "name": "110",
              "subcategories": []
            },
            {
              "id": "asphalt-equipment-cimline-c1",
              "name": "C1",
              "subcategories": []
            },
            {
              "id": "asphalt-equipment-cimline-durapatcher-p1",
              "name": "DURAPATCHER P1",
              "subcategories": []
            },
            {
              "id": "asphalt-equipment-cimline-durapatcher-p2",
              "name": "DURAPATCHER P2",
              "subcategories": []
            },
            {
              "id": "asphalt-equipment-cimline-durapatcher-p3",
              "name": "DURAPATCHER P3",
              "subcategories": []
            },
            {
              "id": "asphalt-equipment-cimline-k2",
              "name": "K2",
              "subcategories": []
            },
            {
              "id": "asphalt-equipment-cimline-k5",
              "name": "K5",
              "subcategories": []
            },
            {
              "id": "asphalt-equipment-cimline-m1",
              "name": "M1",
              "subcategories": []
            },
            {
              "id": "asphalt-equipment-cimline-m2",
              "name": "M2",
              "subcategories": []
            },
            {
              "id": "asphalt-equipment-cimline-m4",
              "name": "M4",
              "subcategories": []
            },
            {
              "id": "asphalt-equipment-cimline-magma-110",
              "name": "MAGMA 110",
              "subcategories": []
            },
            {
              "id": "asphalt-equipment-cimline-magma-150",
              "name": "MAGMA 150",
              "subcategories": []
            },
            {
              "id": "asphalt-equipment-cimline-magma-230",
              "name": "MAGMA 230",
              "subcategories": []
            },
            {
              "id": "asphalt-equipment-cimline-magma-m1",
              "name": "MAGMA M1",
              "subcategories": []
            },
            {
              "id": "asphalt-equipment-cimline-magma-m2",
              "name": "MAGMA M2",
              "subcategories": []
            },
            {
              "id": "asphalt-equipment-cimline-me2",
              "name": "ME2",
              "subcategories": []
            },
            {
              "id": "asphalt-equipment-cimline-me3",
              "name": "ME3",
              "subcategories": []
            },
            {
              "id": "asphalt-equipment-cimline-pcr25",
              "name": "PCR25",
              "subcategories": []
            },
            {
              "id": "asphalt-equipment-cimline-pcr30",
              "name": "PCR30",
              "subcategories": []
            },
            {
              "id": "asphalt-equipment-cimline-r3",
              "name": "R3",
              "subcategories": []
            },
            {
              "id": "asphalt-equipment-cimline-x2",
              "name": "X2",
              "subcategories": []
            },
            {
              "id": "asphalt-equipment-cimline-other",
              "name": "OTHER",
              "subcategories": []
            }
          ]
        },
        {
          "id": "asphalt-equipment-cmi",
          "name": "Cmi",
          "subcategories": [
            {
              "id": "asphalt-equipment-cmi-75-ton",
              "name": "75 TON",
              "subcategories": []
            },
            {
              "id": "asphalt-equipment-cmi-100-ton",
              "name": "100 TON",
              "subcategories": []
            },
            {
              "id": "asphalt-equipment-cmi-200-tph",
              "name": "200 TPH",
              "subcategories": []
            },
            {
              "id": "asphalt-equipment-cmi-ap-600",
              "name": "AP-600",
              "subcategories": []
            },
            {
              "id": "asphalt-equipment-cmi-mtp400",
              "name": "MTP400",
              "subcategories": []
            },
            {
              "id": "asphalt-equipment-cmi-mtp4004",
              "name": "MTP4004",
              "subcategories": []
            },
            {
              "id": "asphalt-equipment-cmi-pr500",
              "name": "PR500",
              "subcategories": []
            },
            {
              "id": "asphalt-equipment-cmi-pr800",
              "name": "PR800",
              "subcategories": []
            },
            {
              "id": "asphalt-equipment-cmi-pr1000",
              "name": "PR1000",
              "subcategories": []
            },
            {
              "id": "asphalt-equipment-cmi-ps350",
              "name": "PS350",
              "subcategories": []
            },
            {
              "id": "asphalt-equipment-cmi-ps6004",
              "name": "PS6004",
              "subcategories": []
            },
            {
              "id": "asphalt-equipment-cmi-pvmx9",
              "name": "PVMX9",
              "subcategories": []
            },
            {
              "id": "asphalt-equipment-cmi-ra318",
              "name": "RA318",
              "subcategories": []
            },
            {
              "id": "asphalt-equipment-cmi-rs400",
              "name": "RS400",
              "subcategories": []
            },
            {
              "id": "asphalt-equipment-cmi-rs425",
              "name": "RS425",
              "subcategories": []
            },
            {
              "id": "asphalt-equipment-cmi-rs500",
              "name": "RS500",
              "subcategories": []
            },
            {
              "id": "asphalt-equipment-cmi-rs650",
              "name": "RS650",
              "subcategories": []
            },
            {
              "id": "asphalt-equipment-cmi-rs800",
              "name": "RS800",
              "subcategories": []
            },
            {
              "id": "asphalt-equipment-cmi-se652",
              "name": "SE652",
              "subcategories": []
            },
            {
              "id": "asphalt-equipment-cmi-se653",
              "name": "SE653",
              "subcategories": []
            },
            {
              "id": "asphalt-equipment-cmi-sf450",
              "name": "SF450",
              "subcategories": []
            },
            {
              "id": "asphalt-equipment-cmi-sf3004",
              "name": "SF3004",
              "subcategories": []
            },
            {
              "id": "asphalt-equipment-cmi-sf6004",
              "name": "SF6004",
              "subcategories": []
            },
            {
              "id": "asphalt-equipment-cmi-suburban-56-120",
              "name": "SUBURBAN 56-120",
              "subcategories": []
            },
            {
              "id": "asphalt-equipment-cmi-super-200",
              "name": "SUPER 200",
              "subcategories": []
            },
            {
              "id": "asphalt-equipment-cmi-tc3004",
              "name": "TC3004",
              "subcategories": []
            },
            {
              "id": "asphalt-equipment-cmi-tr225",
              "name": "TR225",
              "subcategories": []
            },
            {
              "id": "asphalt-equipment-cmi-other",
              "name": "OTHER",
              "subcategories": []
            }
          ]
        },
        {
          "id": "asphalt-equipment-crafco",
          "name": "Crafco",
          "subcategories": [
            {
              "id": "asphalt-equipment-crafco-25",
              "name": "25",
              "subcategories": []
            },
            {
              "id": "asphalt-equipment-crafco-250",
              "name": "250",
              "subcategories": []
            },
            {
              "id": "asphalt-equipment-crafco-200",
              "name": "200",
              "subcategories": []
            },
            {
              "id": "asphalt-equipment-crafco-air-stream",
              "name": "AIR STREAM",
              "subcategories": []
            },
            {
              "id": "asphalt-equipment-crafco-ez-series-ii",
              "name": "EZ SERIES II",
              "subcategories": []
            },
            {
              "id": "asphalt-equipment-crafco-magnum",
              "name": "MAGNUM",
              "subcategories": []
            },
            {
              "id": "asphalt-equipment-crafco-patcher-4",
              "name": "PATCHER 4",
              "subcategories": []
            },
            {
              "id": "asphalt-equipment-crafco-patcher-ii",
              "name": "PATCHER II",
              "subcategories": []
            },
            {
              "id": "asphalt-equipment-crafco-polypatch",
              "name": "POLYPATCH",
              "subcategories": []
            },
            {
              "id": "asphalt-equipment-crafco-super-shot-125",
              "name": "SUPER SHOT 125",
              "subcategories": []
            },
            {
              "id": "asphalt-equipment-crafco-super-shot-250",
              "name": "SUPER SHOT 250",
              "subcategories": []
            },
            {
              "id": "asphalt-equipment-crafco-other",
              "name": "OTHER",
              "subcategories": []
            }
          ]
        },
        {
          "id": "asphalt-equipment-diamond",
          "name": "Diamond",
          "subcategories": [
            {
              "id": "asphalt-equipment-diamond-cc148",
              "name": "CC148",
              "subcategories": []
            },
            {
              "id": "asphalt-equipment-diamond-cc150",
              "name": "CC150",
              "subcategories": []
            },
            {
              "id": "asphalt-equipment-diamond-cc190",
              "name": "CC190",
              "subcategories": []
            },
            {
              "id": "asphalt-equipment-diamond-cc1300",
              "name": "CC1300",
              "subcategories": []
            },
            {
              "id": "asphalt-equipment-diamond-cc2500",
              "name": "CC2500",
              "subcategories": []
            },
            {
              "id": "asphalt-equipment-diamond-cc3500",
              "name": "CC3500",
              "subcategories": []
            },
            {
              "id": "asphalt-equipment-diamond-cc3538",
              "name": "CC3538",
              "subcategories": []
            },
            {
              "id": "asphalt-equipment-diamond-cc3700",
              "name": "CC3700",
              "subcategories": []
            },
            {
              "id": "asphalt-equipment-diamond-cc5048",
              "name": "CC5048",
              "subcategories": []
            },
            {
              "id": "asphalt-equipment-diamond-cc5555",
              "name": "CC5555",
              "subcategories": []
            },
            {
              "id": "asphalt-equipment-diamond-cc6571",
              "name": "CC6571",
              "subcategories": []
            },
            {
              "id": "asphalt-equipment-diamond-cc6774",
              "name": "CC6774",
              "subcategories": []
            },
            {
              "id": "asphalt-equipment-diamond-cc7574",
              "name": "CC7574",
              "subcategories": []
            },
            {
              "id": "asphalt-equipment-diamond-cc9074",
              "name": "CC9074",
              "subcategories": []
            },
            {
              "id": "asphalt-equipment-diamond-cce0900",
              "name": "CCE0900",
              "subcategories": []
            },
            {
              "id": "asphalt-equipment-diamond-cvg1",
              "name": "CVG1",
              "subcategories": []
            },
            {
              "id": "asphalt-equipment-diamond-other",
              "name": "OTHER",
              "subcategories": []
            }
          ]
        },
        {
          "id": "asphalt-equipment-dynapac",
          "name": "Dynapac",
          "subcategories": [
            {
              "id": "asphalt-equipment-dynapac-1200",
              "name": "1200",
              "subcategories": []
            },
            {
              "id": "asphalt-equipment-dynapac-d12",
              "name": "D12",
              "subcategories": []
            },
            {
              "id": "asphalt-equipment-dynapac-d14",
              "name": "D14",
              "subcategories": []
            },
            {
              "id": "asphalt-equipment-dynapac-d17",
              "name": "D17",
              "subcategories": []
            },
            {
              "id": "asphalt-equipment-dynapac-d25",
              "name": "D25",
              "subcategories": []
            },
            {
              "id": "asphalt-equipment-dynapac-d30",
              "name": "D30",
              "subcategories": []
            },
            {
              "id": "asphalt-equipment-dynapac-f5",
              "name": "F5",
              "subcategories": []
            },
            {
              "id": "asphalt-equipment-dynapac-f6",
              "name": "F6",
              "subcategories": []
            },
            {
              "id": "asphalt-equipment-dynapac-f8",
              "name": "F8",
              "subcategories": []
            },
            {
              "id": "asphalt-equipment-dynapac-f80",
              "name": "F80",
              "subcategories": []
            },
            {
              "id": "asphalt-equipment-dynapac-f121",
              "name": "F121",
              "subcategories": []
            },
            {
              "id": "asphalt-equipment-dynapac-f141",
              "name": "F141",
              "subcategories": []
            },
            {
              "id": "asphalt-equipment-dynapac-f800",
              "name": "F800",
              "subcategories": []
            },
            {
              "id": "asphalt-equipment-dynapac-f1000",
              "name": "F1000",
              "subcategories": []
            },
            {
              "id": "asphalt-equipment-dynapac-f1200",
              "name": "F1200",
              "subcategories": []
            },
            {
              "id": "asphalt-equipment-dynapac-f1250",
              "name": "F1250",
              "subcategories": []
            },
            {
              "id": "asphalt-equipment-dynapac-f1700",
              "name": "F1700",
              "subcategories": []
            },
            {
              "id": "asphalt-equipment-dynapac-mf2500",
              "name": "MF2500",
              "subcategories": []
            },
            {
              "id": "asphalt-equipment-dynapac-pl350",
              "name": "PL350",
              "subcategories": []
            },
            {
              "id": "asphalt-equipment-dynapac-pl500",
              "name": "PL500",
              "subcategories": []
            },
            {
              "id": "asphalt-equipment-dynapac-pl2000",
              "name": "PL2000",
              "subcategories": []
            },
            {
              "id": "asphalt-equipment-dynapac-sd1800",
              "name": "SD1800",
              "subcategories": []
            },
            {
              "id": "asphalt-equipment-dynapac-sd2500",
              "name": "SD2500",
              "subcategories": []
            },
            {
              "id": "asphalt-equipment-dynapac-other",
              "name": "OTHER",
              "subcategories": []
            }
          ]
        },
        {
          "id": "asphalt-equipment-edco",
          "name": "Edco",
          "subcategories": [
            {
              "id": "asphalt-equipment-edco-2ec",
              "name": "2EC",
              "subcategories": []
            },
            {
              "id": "asphalt-equipment-edco-2ecng1-5",
              "name": "2ECNG1.5",
              "subcategories": []
            },
            {
              "id": "asphalt-equipment-edco-2gcng",
              "name": "2GCNG",
              "subcategories": []
            },
            {
              "id": "asphalt-equipment-edco-2gcng11h",
              "name": "2GCNG11H",
              "subcategories": []
            },
            {
              "id": "asphalt-equipment-edco-cd5",
              "name": "CD5",
              "subcategories": []
            },
            {
              "id": "asphalt-equipment-edco-cpm8",
              "name": "CPM8",
              "subcategories": []
            },
            {
              "id": "asphalt-equipment-edco-cpm10",
              "name": "CPM10",
              "subcategories": []
            },
            {
              "id": "asphalt-equipment-edco-cpu10",
              "name": "CPU10",
              "subcategories": []
            },
            {
              "id": "asphalt-equipment-edco-ds18-13h",
              "name": "DS18-13H",
              "subcategories": []
            },
            {
              "id": "asphalt-equipment-edco-ds20",
              "name": "DS20",
              "subcategories": []
            },
            {
              "id": "asphalt-equipment-edco-sec1-5l",
              "name": "SEC1.5L",
              "subcategories": []
            },
            {
              "id": "asphalt-equipment-edco-sk14",
              "name": "SK14",
              "subcategories": []
            },
            {
              "id": "asphalt-equipment-edco-ss18",
              "name": "SS18",
              "subcategories": []
            },
            {
              "id": "asphalt-equipment-edco-ss20",
              "name": "SS20",
              "subcategories": []
            },
            {
              "id": "asphalt-equipment-edco-ss24",
              "name": "SS24",
              "subcategories": []
            },
            {
              "id": "asphalt-equipment-edco-ss26",
              "name": "SS26",
              "subcategories": []
            },
            {
              "id": "asphalt-equipment-edco-tmc7",
              "name": "TMC7",
              "subcategories": []
            },
            {
              "id": "asphalt-equipment-edco-vac",
              "name": "VAC",
              "subcategories": []
            },
            {
              "id": "asphalt-equipment-edco-vortex-200",
              "name": "VORTEX 200",
              "subcategories": []
            },
            {
              "id": "asphalt-equipment-edco-other",
              "name": "OTHER",
              "subcategories": []
            }
          ]
        },
        {
          "id": "asphalt-equipment-etnyre",
          "name": "Etnyre",
          "subcategories": [
            {
              "id": "asphalt-equipment-etnyre-2000-gal",
              "name": "2000 GAL",
              "subcategories": []
            },
            {
              "id": "asphalt-equipment-etnyre-6500-gal",
              "name": "6500 GAL",
              "subcategories": []
            },
            {
              "id": "asphalt-equipment-etnyre-7500-gal",
              "name": "7500 GAL",
              "subcategories": []
            },
            {
              "id": "asphalt-equipment-etnyre-10000-gal",
              "name": "10000 GAL",
              "subcategories": []
            },
            {
              "id": "asphalt-equipment-etnyre-bt",
              "name": "BT",
              "subcategories": []
            },
            {
              "id": "asphalt-equipment-etnyre-bthl",
              "name": "BTHL",
              "subcategories": []
            },
            {
              "id": "asphalt-equipment-etnyre-bths",
              "name": "BTHS",
              "subcategories": []
            },
            {
              "id": "asphalt-equipment-etnyre-bxhl",
              "name": "BXHL",
              "subcategories": []
            },
            {
              "id": "asphalt-equipment-etnyre-centennial",
              "name": "CENTENNIAL",
              "subcategories": []
            },
            {
              "id": "asphalt-equipment-etnyre-centennial-ii",
              "name": "CENTENNIAL II",
              "subcategories": []
            },
            {
              "id": "asphalt-equipment-etnyre-chip-spreader",
              "name": "CHIP SPREADER",
              "subcategories": []
            },
            {
              "id": "asphalt-equipment-etnyre-ecs250",
              "name": "ECS250",
              "subcategories": []
            },
            {
              "id": "asphalt-equipment-etnyre-ecs400",
              "name": "ECS400",
              "subcategories": []
            },
            {
              "id": "asphalt-equipment-etnyre-fc400",
              "name": "FC400",
              "subcategories": []
            },
            {
              "id": "asphalt-equipment-etnyre-fx500",
              "name": "FX500",
              "subcategories": []
            },
            {
              "id": "asphalt-equipment-etnyre-k",
              "name": "K",
              "subcategories": []
            },
            {
              "id": "asphalt-equipment-etnyre-mu10trk",
              "name": "MU10TRK",
              "subcategories": []
            },
            {
              "id": "asphalt-equipment-etnyre-mu600",
              "name": "MU600",
              "subcategories": []
            },
            {
              "id": "asphalt-equipment-etnyre-quad",
              "name": "QUAD",
              "subcategories": []
            },
            {
              "id": "asphalt-equipment-etnyre-shooter-1500",
              "name": "SHOOTER 1500",
              "subcategories": []
            },
            {
              "id": "asphalt-equipment-etnyre-tr6",
              "name": "TR6",
              "subcategories": []
            },
            {
              "id": "asphalt-equipment-etnyre-other",
              "name": "OTHER",
              "subcategories": []
            }
          ]
        },
        {
          "id": "asphalt-equipment-falcon",
          "name": "Falcon",
          "subcategories": [
            {
              "id": "asphalt-equipment-falcon-2t",
              "name": "2T",
              "subcategories": []
            },
            {
              "id": "asphalt-equipment-falcon-3t",
              "name": "3T",
              "subcategories": []
            },
            {
              "id": "asphalt-equipment-falcon-4t",
              "name": "4T",
              "subcategories": []
            },
            {
              "id": "asphalt-equipment-falcon-6t",
              "name": "6T",
              "subcategories": []
            },
            {
              "id": "asphalt-equipment-falcon-other",
              "name": "OTHER",
              "subcategories": []
            }
          ]
        },
        {
          "id": "asphalt-equipment-gomaco",
          "name": "Gomaco",
          "subcategories": [
            {
              "id": "asphalt-equipment-gomaco-3300",
              "name": "3300",
              "subcategories": []
            },
            {
              "id": "asphalt-equipment-gomaco-9000",
              "name": "9000",
              "subcategories": []
            },
            {
              "id": "asphalt-equipment-gomaco-9500",
              "name": "9500",
              "subcategories": []
            },
            {
              "id": "asphalt-equipment-gomaco-c450",
              "name": "C450",
              "subcategories": []
            },
            {
              "id": "asphalt-equipment-gomaco-c750",
              "name": "C750",
              "subcategories": []
            },
            {
              "id": "asphalt-equipment-gomaco-commander-iii",
              "name": "COMMANDER III",
              "subcategories": []
            },
            {
              "id": "asphalt-equipment-gomaco-commander-iiix",
              "name": "COMMANDER IIIX",
              "subcategories": []
            },
            {
              "id": "asphalt-equipment-gomaco-gph2800",
              "name": "GPH2800",
              "subcategories": []
            },
            {
              "id": "asphalt-equipment-gomaco-gp3",
              "name": "GP3",
              "subcategories": []
            },
            {
              "id": "asphalt-equipment-gomaco-gp4",
              "name": "GP4",
              "subcategories": []
            },
            {
              "id": "asphalt-equipment-gomaco-gp2400",
              "name": "GP2400",
              "subcategories": []
            },
            {
              "id": "asphalt-equipment-gomaco-gp2600",
              "name": "GP2600",
              "subcategories": []
            },
            {
              "id": "asphalt-equipment-gomaco-gp2800",
              "name": "GP2800",
              "subcategories": []
            },
            {
              "id": "asphalt-equipment-gomaco-gp3000",
              "name": "GP3000",
              "subcategories": []
            },
            {
              "id": "asphalt-equipment-gomaco-gp4000",
              "name": "GP4000",
              "subcategories": []
            },
            {
              "id": "asphalt-equipment-gomaco-gt3200",
              "name": "GT3200",
              "subcategories": []
            },
            {
              "id": "asphalt-equipment-gomaco-gt3300",
              "name": "GT3300",
              "subcategories": []
            },
            {
              "id": "asphalt-equipment-gomaco-gt3600",
              "name": "GT3600",
              "subcategories": []
            },
            {
              "id": "asphalt-equipment-gomaco-gt6200",
              "name": "GT6200",
              "subcategories": []
            },
            {
              "id": "asphalt-equipment-gomaco-gt6300",
              "name": "GT6300",
              "subcategories": []
            },
            {
              "id": "asphalt-equipment-gomaco-idbd",
              "name": "IDBD",
              "subcategories": []
            },
            {
              "id": "asphalt-equipment-gomaco-ps2600",
              "name": "PS2600",
              "subcategories": []
            },
            {
              "id": "asphalt-equipment-gomaco-rtp500",
              "name": "RTP500",
              "subcategories": []
            },
            {
              "id": "asphalt-equipment-gomaco-sl450",
              "name": "SL450",
              "subcategories": []
            },
            {
              "id": "asphalt-equipment-gomaco-spanit-2000",
              "name": "SPANIT 2000",
              "subcategories": []
            },
            {
              "id": "asphalt-equipment-gomaco-tc600",
              "name": "TC600",
              "subcategories": []
            },
            {
              "id": "asphalt-equipment-gomaco-other",
              "name": "OTHER",
              "subcategories": []
            }
          ]
        },
        {
          "id": "asphalt-equipment-imer",
          "name": "Imer",
          "subcategories": [
            {
              "id": "asphalt-equipment-imer-1106312",
              "name": "1106312",
              "subcategories": []
            },
            {
              "id": "asphalt-equipment-imer-booster-70",
              "name": "BOOSTER 70",
              "subcategories": []
            },
            {
              "id": "asphalt-equipment-imer-btk1500p",
              "name": "BTK1500P",
              "subcategories": []
            },
            {
              "id": "asphalt-equipment-imer-gerris-800",
              "name": "GERRIS 800",
              "subcategories": []
            },
            {
              "id": "asphalt-equipment-imer-multis-55",
              "name": "MULTIS 55",
              "subcategories": []
            },
            {
              "id": "asphalt-equipment-imer-oneday-105",
              "name": "ONEDAY 105",
              "subcategories": []
            },
            {
              "id": "asphalt-equipment-imer-prestige-300",
              "name": "PRESTIGE 300",
              "subcategories": []
            },
            {
              "id": "asphalt-equipment-imer-terra-cut-500",
              "name": "TERRA CUT 500",
              "subcategories": []
            },
            {
              "id": "asphalt-equipment-imer-workman-ii-250",
              "name": "WORKMAN II 250",
              "subcategories": []
            },
            {
              "id": "asphalt-equipment-imer-workman-ii-350",
              "name": "WORKMAN II 350",
              "subcategories": []
            },
            {
              "id": "asphalt-equipment-imer-p4-65",
              "name": "P4.65",
              "subcategories": []
            },
            {
              "id": "asphalt-equipment-imer-other",
              "name": "OTHER",
              "subcategories": []
            }
          ]
        },
        {
          "id": "asphalt-equipment-indy",
          "name": "Indy",
          "subcategories": [
            {
              "id": "asphalt-equipment-indy-ipb16",
              "name": "IPB16",
              "subcategories": []
            },
            {
              "id": "asphalt-equipment-indy-ipb21",
              "name": "IPB21",
              "subcategories": []
            }
          ]
        },
        {
          "id": "asphalt-equipment-kimera",
          "name": "Kimera",
          "subcategories": [
            {
              "id": "asphalt-equipment-kimera-d420",
              "name": "D420",
              "subcategories": []
            },
            {
              "id": "asphalt-equipment-kimera-d720",
              "name": "D720",
              "subcategories": []
            },
            {
              "id": "asphalt-equipment-kimera-d930",
              "name": "D930",
              "subcategories": []
            },
            {
              "id": "asphalt-equipment-kimera-d440",
              "name": "D440",
              "subcategories": []
            },
            {
              "id": "asphalt-equipment-kimera-d740",
              "name": "D740",
              "subcategories": []
            },
            {
              "id": "asphalt-equipment-kimera-d980",
              "name": "D980",
              "subcategories": []
            },
            {
              "id": "asphalt-equipment-kimera-k960",
              "name": "K960",
              "subcategories": []
            },
            {
              "id": "asphalt-equipment-kimera-k1260",
              "name": "K1260",
              "subcategories": []
            },
            {
              "id": "asphalt-equipment-kimera-k24150",
              "name": "K24150",
              "subcategories": []
            },
            {
              "id": "asphalt-equipment-kimera-l1688",
              "name": "L1688",
              "subcategories": []
            },
            {
              "id": "asphalt-equipment-kimera-l1648",
              "name": "L1648",
              "subcategories": []
            },
            {
              "id": "asphalt-equipment-kimera-l1866",
              "name": "L1866",
              "subcategories": []
            },
            {
              "id": "asphalt-equipment-kimera-l1566",
              "name": "L1566",
              "subcategories": []
            },
            {
              "id": "asphalt-equipment-kimera-s430",
              "name": "S430",
              "subcategories": []
            },
            {
              "id": "asphalt-equipment-kimera-s730",
              "name": "S730",
              "subcategories": []
            },
            {
              "id": "asphalt-equipment-kimera-other",
              "name": "OTHER",
              "subcategories": []
            }
          ]
        },
        {
          "id": "asphalt-equipment-km-international",
          "name": "Km International",
          "subcategories": [
            {
              "id": "asphalt-equipment-km-international-crack-jet-ii",
              "name": "CRACK JET II",
              "subcategories": []
            },
            {
              "id": "asphalt-equipment-km-international-km2",
              "name": "KM2",
              "subcategories": []
            },
            {
              "id": "asphalt-equipment-km-international-km4",
              "name": "KM4",
              "subcategories": []
            },
            {
              "id": "asphalt-equipment-km-international-km1000",
              "name": "KM1000",
              "subcategories": []
            },
            {
              "id": "asphalt-equipment-km-international-km4000",
              "name": "KM4000",
              "subcategories": []
            },
            {
              "id": "asphalt-equipment-km-international-km8000",
              "name": "KM8000",
              "subcategories": []
            },
            {
              "id": "asphalt-equipment-km-international-kmt2",
              "name": "KMT2",
              "subcategories": []
            },
            {
              "id": "asphalt-equipment-km-international-lb2",
              "name": "LB2",
              "subcategories": []
            },
            {
              "id": "asphalt-equipment-km-international-other",
              "name": "OTHER",
              "subcategories": []
            }
          ]
        },
        {
          "id": "asphalt-equipment-marathon",
          "name": "Marathon",
          "subcategories": [
            {
              "id": "asphalt-equipment-marathon-cr250",
              "name": "CR250",
              "subcategories": []
            },
            {
              "id": "asphalt-equipment-marathon-cr300",
              "name": "CR300",
              "subcategories": []
            },
            {
              "id": "asphalt-equipment-marathon-df10",
              "name": "DF10",
              "subcategories": []
            },
            {
              "id": "asphalt-equipment-marathon-df100",
              "name": "DF100",
              "subcategories": []
            },
            {
              "id": "asphalt-equipment-marathon-dps550",
              "name": "DPS550",
              "subcategories": []
            },
            {
              "id": "asphalt-equipment-marathon-hepr36",
              "name": "HEPR36",
              "subcategories": []
            },
            {
              "id": "asphalt-equipment-marathon-hmt4000",
              "name": "HMT4000",
              "subcategories": []
            },
            {
              "id": "asphalt-equipment-marathon-hmt8000",
              "name": "HMT8000",
              "subcategories": []
            },
            {
              "id": "asphalt-equipment-marathon-keb115",
              "name": "KEB115",
              "subcategories": []
            },
            {
              "id": "asphalt-equipment-marathon-keb260t",
              "name": "KEB260T",
              "subcategories": []
            },
            {
              "id": "asphalt-equipment-marathon-kera-10",
              "name": "KERA 10",
              "subcategories": []
            },
            {
              "id": "asphalt-equipment-marathon-kera180",
              "name": "KERA180",
              "subcategories": []
            },
            {
              "id": "asphalt-equipment-marathon-ld600",
              "name": "LD600",
              "subcategories": []
            },
            {
              "id": "asphalt-equipment-marathon-mm250",
              "name": "MM250",
              "subcategories": []
            },
            {
              "id": "asphalt-equipment-marathon-pas200",
              "name": "PAS200",
              "subcategories": []
            },
            {
              "id": "asphalt-equipment-marathon-pes200",
              "name": "PES200",
              "subcategories": []
            },
            {
              "id": "asphalt-equipment-marathon-rcr30",
              "name": "RCR30",
              "subcategories": []
            },
            {
              "id": "asphalt-equipment-marathon-tps115",
              "name": "TPS115",
              "subcategories": []
            },
            {
              "id": "asphalt-equipment-marathon-tps250",
              "name": "TPS250",
              "subcategories": []
            },
            {
              "id": "asphalt-equipment-marathon-tps500",
              "name": "TPS500",
              "subcategories": []
            },
            {
              "id": "asphalt-equipment-marathon-ucmk",
              "name": "UCMK",
              "subcategories": []
            },
            {
              "id": "asphalt-equipment-marathon-tra",
              "name": "TRA",
              "subcategories": []
            },
            {
              "id": "asphalt-equipment-marathon-other",
              "name": "OTHER",
              "subcategories": []
            }
          ]
        },
        {
          "id": "asphalt-equipment-mauldin",
          "name": "Mauldin",
          "subcategories": [
            {
              "id": "asphalt-equipment-mauldin-650",
              "name": "650",
              "subcategories": []
            },
            {
              "id": "asphalt-equipment-mauldin-690",
              "name": "690",
              "subcategories": []
            },
            {
              "id": "asphalt-equipment-mauldin-760",
              "name": "760",
              "subcategories": []
            },
            {
              "id": "asphalt-equipment-mauldin-1360",
              "name": "1360",
              "subcategories": []
            },
            {
              "id": "asphalt-equipment-mauldin-1550",
              "name": "1550",
              "subcategories": []
            },
            {
              "id": "asphalt-equipment-mauldin-1750",
              "name": "1750",
              "subcategories": []
            },
            {
              "id": "asphalt-equipment-mauldin-1860",
              "name": "1860",
              "subcategories": []
            },
            {
              "id": "asphalt-equipment-mauldin-mt300",
              "name": "MT300",
              "subcategories": []
            },
            {
              "id": "asphalt-equipment-mauldin-mt600",
              "name": "MT600",
              "subcategories": []
            },
            {
              "id": "asphalt-equipment-mauldin-mu600",
              "name": "MU600",
              "subcategories": []
            },
            {
              "id": "asphalt-equipment-mauldin-mu1000",
              "name": "MU1000",
              "subcategories": []
            },
            {
              "id": "asphalt-equipment-mauldin-ps2000",
              "name": "PS2000",
              "subcategories": []
            },
            {
              "id": "asphalt-equipment-mauldin-ps3500",
              "name": "PS3500",
              "subcategories": []
            },
            {
              "id": "asphalt-equipment-mauldin-other",
              "name": "OTHER",
              "subcategories": []
            }
          ]
        },
        {
          "id": "asphalt-equipment-metalika",
          "name": "Metalika",
          "subcategories": [
            {
              "id": "asphalt-equipment-metalika-asp-1000",
              "name": "ASP-1000",
              "subcategories": []
            },
            {
              "id": "asphalt-equipment-metalika-basic-line",
              "name": "BASIC LINE",
              "subcategories": []
            },
            {
              "id": "asphalt-equipment-metalika-bs15",
              "name": "BS15",
              "subcategories": []
            },
            {
              "id": "asphalt-equipment-metalika-bs30",
              "name": "BS30",
              "subcategories": []
            },
            {
              "id": "asphalt-equipment-metalika-bs45",
              "name": "BS45",
              "subcategories": []
            },
            {
              "id": "asphalt-equipment-metalika-sb60",
              "name": "SB60",
              "subcategories": []
            },
            {
              "id": "asphalt-equipment-metalika-c1200",
              "name": "C1200",
              "subcategories": []
            },
            {
              "id": "asphalt-equipment-metalika-ck1000",
              "name": "CK1000",
              "subcategories": []
            },
            {
              "id": "asphalt-equipment-metalika-cm",
              "name": "CM",
              "subcategories": []
            },
            {
              "id": "asphalt-equipment-metalika-contimix-40",
              "name": "CONTIMIX 40",
              "subcategories": []
            },
            {
              "id": "asphalt-equipment-metalika-dpal-10",
              "name": "DPAL-10",
              "subcategories": []
            },
            {
              "id": "asphalt-equipment-metalika-finger-car-line",
              "name": "FINGER CAR LINE",
              "subcategories": []
            },
            {
              "id": "asphalt-equipment-metalika-finger-car-system",
              "name": "FINGER CAR SYSTEM",
              "subcategories": []
            },
            {
              "id": "asphalt-equipment-metalika-krs",
              "name": "KRS",
              "subcategories": []
            },
            {
              "id": "asphalt-equipment-metalika-m375",
              "name": "M375",
              "subcategories": []
            },
            {
              "id": "asphalt-equipment-metalika-m500",
              "name": "M500",
              "subcategories": []
            },
            {
              "id": "asphalt-equipment-metalika-m750",
              "name": "M750",
              "subcategories": []
            },
            {
              "id": "asphalt-equipment-metalika-m1000",
              "name": "M1000",
              "subcategories": []
            },
            {
              "id": "asphalt-equipment-metalika-mbt450",
              "name": "MBT450",
              "subcategories": []
            },
            {
              "id": "asphalt-equipment-metalika-mbt500",
              "name": "MBT500",
              "subcategories": []
            },
            {
              "id": "asphalt-equipment-metalika-mbt750",
              "name": "MBT750",
              "subcategories": []
            },
            {
              "id": "asphalt-equipment-metalika-mbt1000",
              "name": "MBT1000",
              "subcategories": []
            },
            {
              "id": "asphalt-equipment-metalika-mp450",
              "name": "MP450",
              "subcategories": []
            },
            {
              "id": "asphalt-equipment-metalika-pp15-400",
              "name": "PP15/400",
              "subcategories": []
            },
            {
              "id": "asphalt-equipment-metalika-pp20",
              "name": "PP20",
              "subcategories": []
            },
            {
              "id": "asphalt-equipment-metalika-pw-1",
              "name": "PW-1",
              "subcategories": []
            },
            {
              "id": "asphalt-equipment-metalika-pw-2",
              "name": "PW-2",
              "subcategories": []
            },
            {
              "id": "asphalt-equipment-metalika-rs-2",
              "name": "RS-2",
              "subcategories": []
            },
            {
              "id": "asphalt-equipment-metalika-rvp2000",
              "name": "RVP2000",
              "subcategories": []
            },
            {
              "id": "asphalt-equipment-metalika-rvp3000",
              "name": "RVP3000",
              "subcategories": []
            },
            {
              "id": "asphalt-equipment-metalika-rvp5000",
              "name": "RVP5000",
              "subcategories": []
            },
            {
              "id": "asphalt-equipment-metalika-s550",
              "name": "S550",
              "subcategories": []
            },
            {
              "id": "asphalt-equipment-metalika-s610",
              "name": "S610",
              "subcategories": []
            },
            {
              "id": "asphalt-equipment-metalika-slp-16",
              "name": "SLP-16",
              "subcategories": []
            },
            {
              "id": "asphalt-equipment-metalika-slpv-2f",
              "name": "SLPV-2F",
              "subcategories": []
            },
            {
              "id": "asphalt-equipment-metalika-sm-15",
              "name": "SM-15",
              "subcategories": []
            },
            {
              "id": "asphalt-equipment-metalika-svp-12",
              "name": "SVP-12",
              "subcategories": []
            },
            {
              "id": "asphalt-equipment-metalika-svp-633",
              "name": "SVP-633",
              "subcategories": []
            },
            {
              "id": "asphalt-equipment-metalika-szp-2h",
              "name": "SZP-2H",
              "subcategories": []
            },
            {
              "id": "asphalt-equipment-metalika-ug5",
              "name": "UG5",
              "subcategories": []
            },
            {
              "id": "asphalt-equipment-metalika-vp-5",
              "name": "VP-5",
              "subcategories": []
            },
            {
              "id": "asphalt-equipment-metalika-vps-1000",
              "name": "VPS-1000",
              "subcategories": []
            },
            {
              "id": "asphalt-equipment-metalika-vps-2000",
              "name": "VPS-2000",
              "subcategories": []
            },
            {
              "id": "asphalt-equipment-metalika-other",
              "name": "OTHER",
              "subcategories": []
            }
          ]
        },
        {
          "id": "asphalt-equipment-midland",
          "name": "Midland",
          "subcategories": [
            {
              "id": "asphalt-equipment-midland-sa",
              "name": "SA",
              "subcategories": []
            },
            {
              "id": "asphalt-equipment-midland-sp",
              "name": "SP",
              "subcategories": []
            },
            {
              "id": "asphalt-equipment-midland-sp-6",
              "name": "SP-6",
              "subcategories": []
            },
            {
              "id": "asphalt-equipment-midland-spd-6",
              "name": "SPD-6",
              "subcategories": []
            },
            {
              "id": "asphalt-equipment-midland-spd-8",
              "name": "SPD-8",
              "subcategories": []
            },
            {
              "id": "asphalt-equipment-midland-spd-10",
              "name": "SPD-10",
              "subcategories": []
            },
            {
              "id": "asphalt-equipment-midland-spd-12",
              "name": "SPD-12",
              "subcategories": []
            },
            {
              "id": "asphalt-equipment-midland-spf-8",
              "name": "SPF-8",
              "subcategories": []
            },
            {
              "id": "asphalt-equipment-midland-spr-6",
              "name": "SPR-6",
              "subcategories": []
            },
            {
              "id": "asphalt-equipment-midland-wa",
              "name": "WA",
              "subcategories": []
            },
            {
              "id": "asphalt-equipment-midland-other",
              "name": "OTHER",
              "subcategories": []
            }
          ]
        },
        {
          "id": "asphalt-equipment-multiquip-whiteman",
          "name": "Multiquip-Whiteman",
          "subcategories": []
        },
        {
          "id": "asphalt-equipment-normet",
          "name": "Normet",
          "subcategories": []
        },
        {
          "id": "asphalt-equipment-power-curbers",
          "name": "Power Curbers",
          "subcategories": []
        },
        {
          "id": "asphalt-equipment-putzmiester",
          "name": "Putzmiester",
          "subcategories": []
        },
        {
          "id": "asphalt-equipment-sami",
          "name": "Sami",
          "subcategories": [
            {
              "id": "asphalt-equipment-sami-eurosilo",
              "name": "EUROSILO",
              "subcategories": []
            },
            {
              "id": "asphalt-equipment-sami-rs1",
              "name": "RS1",
              "subcategories": []
            },
            {
              "id": "asphalt-equipment-sami-rs05",
              "name": "RS05",
              "subcategories": []
            },
            {
              "id": "asphalt-equipment-sami-silmatic",
              "name": "SILMATIC",
              "subcategories": []
            },
            {
              "id": "asphalt-equipment-sami-spf32de",
              "name": "SPF32DE",
              "subcategories": []
            },
            {
              "id": "asphalt-equipment-sami-tecno",
              "name": "TECNO",
              "subcategories": []
            },
            {
              "id": "asphalt-equipment-sami-other",
              "name": "OTHER",
              "subcategories": []
            }
          ]
        },
        {
          "id": "asphalt-equipment-schwing",
          "name": "Schwing",
          "subcategories": [
            {
              "id": "asphalt-equipment-schwing-2525",
              "name": "2525",
              "subcategories": []
            },
            {
              "id": "asphalt-equipment-schwing-bp2000",
              "name": "BP2000",
              "subcategories": []
            },
            {
              "id": "asphalt-equipment-schwing-bp4000",
              "name": "BP4000",
              "subcategories": []
            },
            {
              "id": "asphalt-equipment-schwing-bpl800",
              "name": "BPL800",
              "subcategories": []
            },
            {
              "id": "asphalt-equipment-schwing-bpl801",
              "name": "BPL801",
              "subcategories": []
            },
            {
              "id": "asphalt-equipment-schwing-bpl1200",
              "name": "BPL1200",
              "subcategories": []
            },
            {
              "id": "asphalt-equipment-schwing-bpl2023",
              "name": "BPL2023",
              "subcategories": []
            },
            {
              "id": "asphalt-equipment-schwing-bpl2525",
              "name": "BPL2525",
              "subcategories": []
            },
            {
              "id": "asphalt-equipment-schwing-p88d",
              "name": "P88D",
              "subcategories": []
            },
            {
              "id": "asphalt-equipment-schwing-s36x",
              "name": "S36X",
              "subcategories": []
            },
            {
              "id": "asphalt-equipment-schwing-s43sx",
              "name": "S43SX",
              "subcategories": []
            },
            {
              "id": "asphalt-equipment-schwing-s51sx",
              "name": "S51SX",
              "subcategories": []
            },
            {
              "id": "asphalt-equipment-schwing-sp88",
              "name": "SP88",
              "subcategories": []
            },
            {
              "id": "asphalt-equipment-schwing-sp4800",
              "name": "SP4800",
              "subcategories": []
            },
            {
              "id": "asphalt-equipment-schwing-spb30",
              "name": "SPB30",
              "subcategories": []
            },
            {
              "id": "asphalt-equipment-schwing-wp750",
              "name": "WP750",
              "subcategories": []
            },
            {
              "id": "asphalt-equipment-schwing-other",
              "name": "OTHER",
              "subcategories": []
            }
          ]
        },
        {
          "id": "asphalt-equipment-struemaster",
          "name": "Struemaster",
          "subcategories": []
        },
        {
          "id": "asphalt-equipment-volvo",
          "name": "Volvo",
          "subcategories": [
            {
              "id": "asphalt-equipment-volvo-a25",
              "name": "A25",
              "subcategories": []
            },
            {
              "id": "asphalt-equipment-volvo-ab25",
              "name": "AB25",
              "subcategories": []
            },
            {
              "id": "asphalt-equipment-volvo-abg6820",
              "name": "ABG6820",
              "subcategories": []
            },
            {
              "id": "asphalt-equipment-volvo-abg6870",
              "name": "ABG6870",
              "subcategories": []
            },
            {
              "id": "asphalt-equipment-volvo-abg7620",
              "name": "ABG7620",
              "subcategories": []
            },
            {
              "id": "asphalt-equipment-volvo-abg7820",
              "name": "ABG7820",
              "subcategories": []
            },
            {
              "id": "asphalt-equipment-volvo-abg8820",
              "name": "ABG8820",
              "subcategories": []
            },
            {
              "id": "asphalt-equipment-volvo-abg4820",
              "name": "ABG4820",
              "subcategories": []
            },
            {
              "id": "asphalt-equipment-volvo-abg6820",
              "name": "ABG6820",
              "subcategories": []
            },
            {
              "id": "asphalt-equipment-volvo-abg6870",
              "name": "ABG6870",
              "subcategories": []
            },
            {
              "id": "asphalt-equipment-volvo-abg7820",
              "name": "ABG7820",
              "subcategories": []
            },
            {
              "id": "asphalt-equipment-volvo-p2820",
              "name": "P2820",
              "subcategories": []
            },
            {
              "id": "asphalt-equipment-volvo-p2870",
              "name": "P2870",
              "subcategories": []
            },
            {
              "id": "asphalt-equipment-volvo-p2879",
              "name": "P2879",
              "subcategories": []
            },
            {
              "id": "asphalt-equipment-volvo-p4410",
              "name": "P4410",
              "subcategories": []
            },
            {
              "id": "asphalt-equipment-volvo-p6820",
              "name": "P6820",
              "subcategories": []
            },
            {
              "id": "asphalt-equipment-volvo-p6870",
              "name": "P6870",
              "subcategories": []
            },
            {
              "id": "asphalt-equipment-volvo-p7110",
              "name": "P7110",
              "subcategories": []
            },
            {
              "id": "asphalt-equipment-volvo-p7170",
              "name": "P7170",
              "subcategories": []
            },
            {
              "id": "asphalt-equipment-volvo-p7820",
              "name": "P7820",
              "subcategories": []
            },
            {
              "id": "asphalt-equipment-volvo-pf2181",
              "name": "PF2181",
              "subcategories": []
            },
            {
              "id": "asphalt-equipment-volvo-pf3172",
              "name": "PF3172",
              "subcategories": []
            },
            {
              "id": "asphalt-equipment-volvo-pf4410",
              "name": "PF4410",
              "subcategories": []
            },
            {
              "id": "asphalt-equipment-volvo-pf6110",
              "name": "PF6110",
              "subcategories": []
            },
            {
              "id": "asphalt-equipment-volvo-pf6170",
              "name": "PF6170",
              "subcategories": []
            },
            {
              "id": "asphalt-equipment-volvo-rw195",
              "name": "RW195",
              "subcategories": []
            },
            {
              "id": "asphalt-equipment-volvo-other",
              "name": "OTHER",
              "subcategories": []
            }
          ]
        },
        {
          "id": "asphalt-equipment-wacker-nueson",
          "name": "Wacker Nueson",
          "subcategories": [
            {
              "id": "asphalt-equipment-wacker-nueson-bfs1350",
              "name": "BFS1350",
              "subcategories": []
            },
            {
              "id": "asphalt-equipment-wacker-nueson-crt48",
              "name": "CRT48",
              "subcategories": []
            },
            {
              "id": "asphalt-equipment-wacker-nueson-crt60",
              "name": "CRT60",
              "subcategories": []
            },
            {
              "id": "asphalt-equipment-wacker-nueson-ct24",
              "name": "CT24",
              "subcategories": []
            },
            {
              "id": "asphalt-equipment-wacker-nueson-ct36",
              "name": "CT36",
              "subcategories": []
            },
            {
              "id": "asphalt-equipment-wacker-nueson-ct48",
              "name": "CT48",
              "subcategories": []
            },
            {
              "id": "asphalt-equipment-wacker-nueson-p35",
              "name": "P35",
              "subcategories": []
            },
            {
              "id": "asphalt-equipment-wacker-nueson-other",
              "name": "OTHER",
              "subcategories": []
            }
          ]
        },
        {
          "id": "asphalt-equipment-weiler",
          "name": "Weiler",
          "subcategories": [
            {
              "id": "asphalt-equipment-weiler-1648",
              "name": "1648",
              "subcategories": []
            },
            {
              "id": "asphalt-equipment-weiler-e550",
              "name": "E550",
              "subcategories": []
            },
            {
              "id": "asphalt-equipment-weiler-e1250",
              "name": "E1250",
              "subcategories": []
            },
            {
              "id": "asphalt-equipment-weiler-e1650",
              "name": "E1650",
              "subcategories": []
            },
            {
              "id": "asphalt-equipment-weiler-e2850",
              "name": "E2850",
              "subcategories": []
            },
            {
              "id": "asphalt-equipment-weiler-p65",
              "name": "P65",
              "subcategories": []
            },
            {
              "id": "asphalt-equipment-weiler-p195",
              "name": "P195",
              "subcategories": []
            },
            {
              "id": "asphalt-equipment-weiler-p265",
              "name": "P265",
              "subcategories": []
            },
            {
              "id": "asphalt-equipment-weiler-p285",
              "name": "P285",
              "subcategories": []
            },
            {
              "id": "asphalt-equipment-weiler-p385",
              "name": "P385",
              "subcategories": []
            },
            {
              "id": "asphalt-equipment-weiler-p395",
              "name": "P395",
              "subcategories": []
            },
            {
              "id": "asphalt-equipment-weiler-p1648",
              "name": "P1648",
              "subcategories": []
            },
            {
              "id": "asphalt-equipment-weiler-s200",
              "name": "S200",
              "subcategories": []
            },
            {
              "id": "asphalt-equipment-weiler-w330",
              "name": "W330",
              "subcategories": []
            },
            {
              "id": "asphalt-equipment-weiler-w430",
              "name": "W430",
              "subcategories": []
            },
            {
              "id": "asphalt-equipment-weiler-w530",
              "name": "W530",
              "subcategories": []
            },
            {
              "id": "asphalt-equipment-weiler-other",
              "name": "OTHER",
              "subcategories": []
            }
          ]
        },
        {
          "id": "asphalt-equipment-xcmg",
          "name": "Xcmg",
          "subcategories": [
            {
              "id": "asphalt-equipment-xcmg-g10",
              "name": "G10",
              "subcategories": []
            },
            {
              "id": "asphalt-equipment-xcmg-g12",
              "name": "G12",
              "subcategories": []
            },
            {
              "id": "asphalt-equipment-xcmg-g4804",
              "name": "G4804",
              "subcategories": []
            },
            {
              "id": "asphalt-equipment-xcmg-g4806",
              "name": "G4806",
              "subcategories": []
            },
            {
              "id": "asphalt-equipment-xcmg-hb30",
              "name": "HB30",
              "subcategories": []
            },
            {
              "id": "asphalt-equipment-xcmg-hb37",
              "name": "HB37",
              "subcategories": []
            },
            {
              "id": "asphalt-equipment-xcmg-hb40",
              "name": "HB40",
              "subcategories": []
            },
            {
              "id": "asphalt-equipment-xcmg-hb50",
              "name": "HB50",
              "subcategories": []
            },
            {
              "id": "asphalt-equipment-xcmg-hb52",
              "name": "HB52",
              "subcategories": []
            },
            {
              "id": "asphalt-equipment-xcmg-hb58",
              "name": "HB58",
              "subcategories": []
            },
            {
              "id": "asphalt-equipment-xcmg-hb62",
              "name": "HB62",
              "subcategories": []
            },
            {
              "id": "asphalt-equipment-xcmg-hb67",
              "name": "HB67",
              "subcategories": []
            },
            {
              "id": "asphalt-equipment-xcmg-hbc9018",
              "name": "HBC9018",
              "subcategories": []
            },
            {
              "id": "asphalt-equipment-xcmg-hbc10018",
              "name": "HBC10018",
              "subcategories": []
            },
            {
              "id": "asphalt-equipment-xcmg-hbc10022",
              "name": "HBC10022",
              "subcategories": []
            },
            {
              "id": "asphalt-equipment-xcmg-hbc10040",
              "name": "HBC10040",
              "subcategories": []
            },
            {
              "id": "asphalt-equipment-xcmg-rp453",
              "name": "RP453",
              "subcategories": []
            },
            {
              "id": "asphalt-equipment-xcmg-rp505",
              "name": "RP505",
              "subcategories": []
            },
            {
              "id": "asphalt-equipment-xcmg-rp603",
              "name": "RP603",
              "subcategories": []
            },
            {
              "id": "asphalt-equipment-xcmg-rp605",
              "name": "RP605",
              "subcategories": []
            },
            {
              "id": "asphalt-equipment-xcmg-rp753",
              "name": "RP753",
              "subcategories": []
            },
            {
              "id": "asphalt-equipment-xcmg-rp903",
              "name": "RP903",
              "subcategories": []
            },
            {
              "id": "asphalt-equipment-xcmg-rp905",
              "name": "RP905",
              "subcategories": []
            },
            {
              "id": "asphalt-equipment-xcmg-rp953",
              "name": "RP953",
              "subcategories": []
            },
            {
              "id": "asphalt-equipment-xcmg-rp1655",
              "name": "RP1655",
              "subcategories": []
            },
            {
              "id": "asphalt-equipment-xcmg-slm4000",
              "name": "SLM4000",
              "subcategories": []
            },
            {
              "id": "asphalt-equipment-xcmg-slm2600",
              "name": "SLM2600",
              "subcategories": []
            },
            {
              "id": "asphalt-equipment-xcmg-slm3500",
              "name": "SLM3500",
              "subcategories": []
            },
            {
              "id": "asphalt-equipment-xcmg-xkc183",
              "name": "XKC183",
              "subcategories": []
            },
            {
              "id": "asphalt-equipment-xcmg-xlz2303",
              "name": "XLZ2303",
              "subcategories": []
            },
            {
              "id": "asphalt-equipment-xcmg-xm200",
              "name": "XM200",
              "subcategories": []
            },
            {
              "id": "asphalt-equipment-xcmg-xm405",
              "name": "XM405",
              "subcategories": []
            },
            {
              "id": "asphalt-equipment-xcmg-xm503",
              "name": "XM503",
              "subcategories": []
            },
            {
              "id": "asphalt-equipment-xcmg-xm505",
              "name": "XM505",
              "subcategories": []
            },
            {
              "id": "asphalt-equipment-xcmg-xm1003",
              "name": "XM1003",
              "subcategories": []
            },
            {
              "id": "asphalt-equipment-xcmg-xm1005",
              "name": "XM1005",
              "subcategories": []
            },
            {
              "id": "asphalt-equipment-xcmg-xm2005",
              "name": "XM2005",
              "subcategories": []
            },
            {
              "id": "asphalt-equipment-xcmg-xm2205",
              "name": "XM2205",
              "subcategories": []
            },
            {
              "id": "asphalt-equipment-xcmg-xzj5160",
              "name": "XZJ5160",
              "subcategories": []
            },
            {
              "id": "asphalt-equipment-xcmg-xzs5150",
              "name": "XZS5150",
              "subcategories": []
            },
            {
              "id": "asphalt-equipment-xcmg-xzs5180",
              "name": "XZS5180",
              "subcategories": []
            },
            {
              "id": "asphalt-equipment-xcmg-xzs5316",
              "name": "XZS5316",
              "subcategories": []
            },
            {
              "id": "asphalt-equipment-xcmg-xzs5318",
              "name": "XZS5318",
              "subcategories": []
            },
            {
              "id": "asphalt-equipment-xcmg-xzs5319",
              "name": "XZS5319",
              "subcategories": []
            },
            {
              "id": "asphalt-equipment-xcmg-other",
              "name": "OTHER",
              "subcategories": []
            }
          ]
        },
        {
          "id": "asphalt-equipment-zoomlion",
          "name": "Zoomlion",
          "subcategories": [
            {
              "id": "asphalt-equipment-zoomlion-38x",
              "name": "38X",
              "subcategories": []
            },
            {
              "id": "asphalt-equipment-zoomlion-43x",
              "name": "43X",
              "subcategories": []
            },
            {
              "id": "asphalt-equipment-zoomlion-47x",
              "name": "47X",
              "subcategories": []
            },
            {
              "id": "asphalt-equipment-zoomlion-49x",
              "name": "49X",
              "subcategories": []
            },
            {
              "id": "asphalt-equipment-zoomlion-56x",
              "name": "56X",
              "subcategories": []
            },
            {
              "id": "asphalt-equipment-zoomlion-63x",
              "name": "63X",
              "subcategories": []
            },
            {
              "id": "asphalt-equipment-zoomlion-8jbj",
              "name": "8JBJ",
              "subcategories": []
            },
            {
              "id": "asphalt-equipment-zoomlion-10jbh",
              "name": "10JBH",
              "subcategories": []
            },
            {
              "id": "asphalt-equipment-zoomlion-hbt90",
              "name": "HBT90",
              "subcategories": []
            },
            {
              "id": "asphalt-equipment-zoomlion-zl5419",
              "name": "ZL5419",
              "subcategories": []
            },
            {
              "id": "asphalt-equipment-zoomlion-zlj5296",
              "name": "ZLJ5296",
              "subcategories": []
            },
            {
              "id": "asphalt-equipment-zoomlion-zlj5330",
              "name": "ZLJ5330",
              "subcategories": []
            },
            {
              "id": "asphalt-equipment-zoomlion-zlj5419",
              "name": "ZLJ5419",
              "subcategories": []
            },
            {
              "id": "asphalt-equipment-zoomlion-zlj5550",
              "name": "ZLJ5550",
              "subcategories": []
            },
            {
              "id": "asphalt-equipment-zoomlion-other",
              "name": "OTHER",
              "subcategories": []
            }
          ]
        }
      ]
    },
    {
      "id": "backhoe-loaders",
      "name": "Backhoe Loaders",
      "subcategories": [
        {
          "id": "backhoe-loaders-deere",
          "name": "Deere",
          "subcategories": [
            {
              "id": "backhoe-loaders-deere-110",
              "name": "110",
              "subcategories": []
            },
            {
              "id": "backhoe-loaders-deere-210",
              "name": "210",
              "subcategories": []
            },
            {
              "id": "backhoe-loaders-deere-210c",
              "name": "210C",
              "subcategories": []
            },
            {
              "id": "backhoe-loaders-deere-210l",
              "name": "210L",
              "subcategories": []
            },
            {
              "id": "backhoe-loaders-deere-300",
              "name": "300",
              "subcategories": []
            },
            {
              "id": "backhoe-loaders-deere-300b",
              "name": "300B",
              "subcategories": []
            },
            {
              "id": "backhoe-loaders-deere-300d",
              "name": "300D",
              "subcategories": []
            },
            {
              "id": "backhoe-loaders-deere-310",
              "name": "310",
              "subcategories": []
            },
            {
              "id": "backhoe-loaders-deere-310g",
              "name": "310G",
              "subcategories": []
            },
            {
              "id": "backhoe-loaders-deere-310p",
              "name": "310P",
              "subcategories": []
            },
            {
              "id": "backhoe-loaders-deere-310a",
              "name": "310A",
              "subcategories": []
            },
            {
              "id": "backhoe-loaders-deere-310b",
              "name": "310B",
              "subcategories": []
            },
            {
              "id": "backhoe-loaders-deere-310c",
              "name": "310C",
              "subcategories": []
            },
            {
              "id": "backhoe-loaders-deere-310d",
              "name": "310D",
              "subcategories": []
            },
            {
              "id": "backhoe-loaders-deere-310e",
              "name": "310E",
              "subcategories": []
            },
            {
              "id": "backhoe-loaders-deere-310el",
              "name": "310EL",
              "subcategories": []
            },
            {
              "id": "backhoe-loaders-deere-310g",
              "name": "310G",
              "subcategories": []
            },
            {
              "id": "backhoe-loaders-deere-310j",
              "name": "310J",
              "subcategories": []
            },
            {
              "id": "backhoe-loaders-deere-310k",
              "name": "310K",
              "subcategories": []
            },
            {
              "id": "backhoe-loaders-deere-310k-ep",
              "name": "310K EP",
              "subcategories": []
            },
            {
              "id": "backhoe-loaders-deere-310l",
              "name": "310L",
              "subcategories": []
            },
            {
              "id": "backhoe-loaders-deere-310l-ep",
              "name": "310L EP",
              "subcategories": []
            },
            {
              "id": "backhoe-loaders-deere-310se",
              "name": "310SE",
              "subcategories": []
            },
            {
              "id": "backhoe-loaders-deere-310sg",
              "name": "310SG",
              "subcategories": []
            },
            {
              "id": "backhoe-loaders-deere-310sj",
              "name": "310SJ",
              "subcategories": []
            },
            {
              "id": "backhoe-loaders-deere-310sj-tc",
              "name": "310SJ TC",
              "subcategories": []
            },
            {
              "id": "backhoe-loaders-deere-310sk",
              "name": "310SK",
              "subcategories": []
            },
            {
              "id": "backhoe-loaders-deere-310sl-hl",
              "name": "310SL HL",
              "subcategories": []
            },
            {
              "id": "backhoe-loaders-deere-315sg",
              "name": "315SG",
              "subcategories": []
            },
            {
              "id": "backhoe-loaders-deere-315sj",
              "name": "315SJ",
              "subcategories": []
            },
            {
              "id": "backhoe-loaders-deere-315sl",
              "name": "315SL",
              "subcategories": []
            },
            {
              "id": "backhoe-loaders-deere-320p",
              "name": "320P",
              "subcategories": []
            },
            {
              "id": "backhoe-loaders-deere-410",
              "name": "410",
              "subcategories": []
            },
            {
              "id": "backhoe-loaders-deere-410p",
              "name": "410P",
              "subcategories": []
            },
            {
              "id": "backhoe-loaders-deere-410b",
              "name": "410B",
              "subcategories": []
            },
            {
              "id": "backhoe-loaders-deere-410c",
              "name": "410C",
              "subcategories": []
            },
            {
              "id": "backhoe-loaders-deere-410d",
              "name": "410D",
              "subcategories": []
            },
            {
              "id": "backhoe-loaders-deere-410e",
              "name": "410E",
              "subcategories": []
            },
            {
              "id": "backhoe-loaders-deere-410g",
              "name": "410G",
              "subcategories": []
            },
            {
              "id": "backhoe-loaders-deere-410j",
              "name": "410J",
              "subcategories": []
            },
            {
              "id": "backhoe-loaders-deere-410k",
              "name": "410K",
              "subcategories": []
            },
            {
              "id": "backhoe-loaders-deere-410l",
              "name": "410L",
              "subcategories": []
            },
            {
              "id": "backhoe-loaders-deere-500a",
              "name": "500A",
              "subcategories": []
            },
            {
              "id": "backhoe-loaders-deere-500c",
              "name": "500C",
              "subcategories": []
            },
            {
              "id": "backhoe-loaders-deere-510",
              "name": "510",
              "subcategories": []
            },
            {
              "id": "backhoe-loaders-deere-510b",
              "name": "510B",
              "subcategories": []
            },
            {
              "id": "backhoe-loaders-deere-510c",
              "name": "510C",
              "subcategories": []
            },
            {
              "id": "backhoe-loaders-deere-510d",
              "name": "510D",
              "subcategories": []
            },
            {
              "id": "backhoe-loaders-deere-710p",
              "name": "710P",
              "subcategories": []
            },
            {
              "id": "backhoe-loaders-deere-710b",
              "name": "710B",
              "subcategories": []
            },
            {
              "id": "backhoe-loaders-deere-710c",
              "name": "710C",
              "subcategories": []
            },
            {
              "id": "backhoe-loaders-deere-710d",
              "name": "710D",
              "subcategories": []
            },
            {
              "id": "backhoe-loaders-deere-710g",
              "name": "710G",
              "subcategories": []
            },
            {
              "id": "backhoe-loaders-deere-710j",
              "name": "710J",
              "subcategories": []
            },
            {
              "id": "backhoe-loaders-deere-710k",
              "name": "710K",
              "subcategories": []
            },
            {
              "id": "backhoe-loaders-deere-710l",
              "name": "710L",
              "subcategories": []
            },
            {
              "id": "backhoe-loaders-deere-other",
              "name": "OTHER",
              "subcategories": []
            }
          ]
        },
        {
          "id": "backhoe-loaders-caterpillar",
          "name": "Caterpillar",
          "subcategories": [
            {
              "id": "backhoe-loaders-caterpillar-415",
              "name": "415",
              "subcategories": []
            },
            {
              "id": "backhoe-loaders-caterpillar-415f2",
              "name": "415F2",
              "subcategories": []
            },
            {
              "id": "backhoe-loaders-caterpillar-416",
              "name": "416",
              "subcategories": []
            },
            {
              "id": "backhoe-loaders-caterpillar-416-ii",
              "name": "416 II",
              "subcategories": []
            },
            {
              "id": "backhoe-loaders-caterpillar-416b",
              "name": "416B",
              "subcategories": []
            },
            {
              "id": "backhoe-loaders-caterpillar-416c",
              "name": "416C",
              "subcategories": []
            },
            {
              "id": "backhoe-loaders-caterpillar-416c-it",
              "name": "416C IT",
              "subcategories": []
            },
            {
              "id": "backhoe-loaders-caterpillar-416d",
              "name": "416D",
              "subcategories": []
            },
            {
              "id": "backhoe-loaders-caterpillar-416e",
              "name": "416E",
              "subcategories": []
            },
            {
              "id": "backhoe-loaders-caterpillar-416f",
              "name": "416F",
              "subcategories": []
            },
            {
              "id": "backhoe-loaders-caterpillar-416f2",
              "name": "416F2",
              "subcategories": []
            },
            {
              "id": "backhoe-loaders-caterpillar-416f2-st",
              "name": "416F2 ST",
              "subcategories": []
            },
            {
              "id": "backhoe-loaders-caterpillar-416st-hrc",
              "name": "416ST HRC",
              "subcategories": []
            },
            {
              "id": "backhoe-loaders-caterpillar-420",
              "name": "420",
              "subcategories": []
            },
            {
              "id": "backhoe-loaders-caterpillar-420xe",
              "name": "420XE",
              "subcategories": []
            },
            {
              "id": "backhoe-loaders-caterpillar-420d",
              "name": "420D",
              "subcategories": []
            },
            {
              "id": "backhoe-loaders-caterpillar-420d-it",
              "name": "420D IT",
              "subcategories": []
            },
            {
              "id": "backhoe-loaders-caterpillar-420e",
              "name": "420E",
              "subcategories": []
            },
            {
              "id": "backhoe-loaders-caterpillar-420e-it",
              "name": "420E IT",
              "subcategories": []
            },
            {
              "id": "backhoe-loaders-caterpillar-420e-st",
              "name": "420E ST",
              "subcategories": []
            },
            {
              "id": "backhoe-loaders-caterpillar-420f",
              "name": "420F",
              "subcategories": []
            },
            {
              "id": "backhoe-loaders-caterpillar-420f-it",
              "name": "420F IT",
              "subcategories": []
            },
            {
              "id": "backhoe-loaders-caterpillar-420f-st",
              "name": "420F ST",
              "subcategories": []
            },
            {
              "id": "backhoe-loaders-caterpillar-420f2-it",
              "name": "420F2 IT",
              "subcategories": []
            },
            {
              "id": "backhoe-loaders-caterpillar-420st-hrc",
              "name": "420ST HRC",
              "subcategories": []
            },
            {
              "id": "backhoe-loaders-caterpillar-422f",
              "name": "422F",
              "subcategories": []
            },
            {
              "id": "backhoe-loaders-caterpillar-424",
              "name": "424",
              "subcategories": []
            },
            {
              "id": "backhoe-loaders-caterpillar-424b2",
              "name": "424B2",
              "subcategories": []
            },
            {
              "id": "backhoe-loaders-caterpillar-424d",
              "name": "424D",
              "subcategories": []
            },
            {
              "id": "backhoe-loaders-caterpillar-426",
              "name": "426",
              "subcategories": []
            },
            {
              "id": "backhoe-loaders-caterpillar-426-it",
              "name": "426 IT",
              "subcategories": []
            },
            {
              "id": "backhoe-loaders-caterpillar-426c",
              "name": "426C",
              "subcategories": []
            },
            {
              "id": "backhoe-loaders-caterpillar-426c-it",
              "name": "426C IT",
              "subcategories": []
            },
            {
              "id": "backhoe-loaders-caterpillar-426f2",
              "name": "426F2",
              "subcategories": []
            },
            {
              "id": "backhoe-loaders-caterpillar-427f2",
              "name": "427F2",
              "subcategories": []
            },
            {
              "id": "backhoe-loaders-caterpillar-428",
              "name": "428",
              "subcategories": []
            },
            {
              "id": "backhoe-loaders-caterpillar-428b",
              "name": "428B",
              "subcategories": []
            },
            {
              "id": "backhoe-loaders-caterpillar-428c",
              "name": "428C",
              "subcategories": []
            },
            {
              "id": "backhoe-loaders-caterpillar-428e",
              "name": "428E",
              "subcategories": []
            },
            {
              "id": "backhoe-loaders-caterpillar-428f",
              "name": "428F",
              "subcategories": []
            },
            {
              "id": "backhoe-loaders-caterpillar-428f2",
              "name": "428F2",
              "subcategories": []
            },
            {
              "id": "backhoe-loaders-caterpillar-430",
              "name": "430",
              "subcategories": []
            },
            {
              "id": "backhoe-loaders-caterpillar-430d",
              "name": "430D",
              "subcategories": []
            },
            {
              "id": "backhoe-loaders-caterpillar-430d-it",
              "name": "430D IT",
              "subcategories": []
            },
            {
              "id": "backhoe-loaders-caterpillar-430e",
              "name": "430E",
              "subcategories": []
            },
            {
              "id": "backhoe-loaders-caterpillar-430e-it",
              "name": "430E IT",
              "subcategories": []
            },
            {
              "id": "backhoe-loaders-caterpillar-430e-st",
              "name": "430E ST",
              "subcategories": []
            },
            {
              "id": "backhoe-loaders-caterpillar-430f",
              "name": "430F",
              "subcategories": []
            },
            {
              "id": "backhoe-loaders-caterpillar-430f-it",
              "name": "430F IT",
              "subcategories": []
            },
            {
              "id": "backhoe-loaders-caterpillar-430f2",
              "name": "430F2",
              "subcategories": []
            },
            {
              "id": "backhoe-loaders-caterpillar-430f2-it",
              "name": "430F2 IT",
              "subcategories": []
            },
            {
              "id": "backhoe-loaders-caterpillar-432",
              "name": "432",
              "subcategories": []
            },
            {
              "id": "backhoe-loaders-caterpillar-432d",
              "name": "432D",
              "subcategories": []
            },
            {
              "id": "backhoe-loaders-caterpillar-432e",
              "name": "432E",
              "subcategories": []
            },
            {
              "id": "backhoe-loaders-caterpillar-432f",
              "name": "432F",
              "subcategories": []
            },
            {
              "id": "backhoe-loaders-caterpillar-432f2",
              "name": "432F2",
              "subcategories": []
            },
            {
              "id": "backhoe-loaders-caterpillar-434",
              "name": "434",
              "subcategories": []
            },
            {
              "id": "backhoe-loaders-caterpillar-434f2",
              "name": "434F2",
              "subcategories": []
            },
            {
              "id": "backhoe-loaders-caterpillar-436",
              "name": "436",
              "subcategories": []
            },
            {
              "id": "backhoe-loaders-caterpillar-436b",
              "name": "436B",
              "subcategories": []
            },
            {
              "id": "backhoe-loaders-caterpillar-440",
              "name": "440",
              "subcategories": []
            },
            {
              "id": "backhoe-loaders-caterpillar-444",
              "name": "444",
              "subcategories": []
            },
            {
              "id": "backhoe-loaders-caterpillar-444e",
              "name": "444E",
              "subcategories": []
            },
            {
              "id": "backhoe-loaders-caterpillar-444f",
              "name": "444F",
              "subcategories": []
            },
            {
              "id": "backhoe-loaders-caterpillar-444f2",
              "name": "444F2",
              "subcategories": []
            },
            {
              "id": "backhoe-loaders-caterpillar-446",
              "name": "446",
              "subcategories": []
            },
            {
              "id": "backhoe-loaders-caterpillar-446b",
              "name": "446B",
              "subcategories": []
            },
            {
              "id": "backhoe-loaders-caterpillar-446d",
              "name": "446D",
              "subcategories": []
            },
            {
              "id": "backhoe-loaders-caterpillar-450",
              "name": "450",
              "subcategories": []
            },
            {
              "id": "backhoe-loaders-caterpillar-450e",
              "name": "450E",
              "subcategories": []
            },
            {
              "id": "backhoe-loaders-caterpillar-450f",
              "name": "450F",
              "subcategories": []
            },
            {
              "id": "backhoe-loaders-caterpillar-other",
              "name": "OTHER",
              "subcategories": []
            }
          ]
        },
        {
          "id": "backhoe-loaders-case",
          "name": "Case",
          "subcategories": [
            {
              "id": "backhoe-loaders-case-480",
              "name": "480",
              "subcategories": []
            },
            {
              "id": "backhoe-loaders-case-530",
              "name": "530",
              "subcategories": []
            },
            {
              "id": "backhoe-loaders-case-570sv",
              "name": "570SV",
              "subcategories": []
            },
            {
              "id": "backhoe-loaders-case-570t",
              "name": "570T",
              "subcategories": []
            },
            {
              "id": "backhoe-loaders-case-570v",
              "name": "570V",
              "subcategories": []
            },
            {
              "id": "backhoe-loaders-case-575n-ep",
              "name": "575N EP",
              "subcategories": []
            },
            {
              "id": "backhoe-loaders-case-580",
              "name": "580",
              "subcategories": []
            },
            {
              "id": "backhoe-loaders-case-580b",
              "name": "580B",
              "subcategories": []
            },
            {
              "id": "backhoe-loaders-case-580bck",
              "name": "580BCK",
              "subcategories": []
            },
            {
              "id": "backhoe-loaders-case-580c",
              "name": "580C",
              "subcategories": []
            },
            {
              "id": "backhoe-loaders-case-580d",
              "name": "580D",
              "subcategories": []
            },
            {
              "id": "backhoe-loaders-case-580e",
              "name": "580E",
              "subcategories": []
            },
            {
              "id": "backhoe-loaders-case-580h",
              "name": "580H",
              "subcategories": []
            },
            {
              "id": "backhoe-loaders-case-580k",
              "name": "580K",
              "subcategories": []
            },
            {
              "id": "backhoe-loaders-case-580l",
              "name": "580L",
              "subcategories": []
            },
            {
              "id": "backhoe-loaders-case-580m",
              "name": "580M",
              "subcategories": []
            },
            {
              "id": "backhoe-loaders-case-580m-ii",
              "name": "580M II",
              "subcategories": []
            },
            {
              "id": "backhoe-loaders-case-580m-iii",
              "name": "580M III",
              "subcategories": []
            },
            {
              "id": "backhoe-loaders-case-580m-turbo",
              "name": "580M TURBO",
              "subcategories": []
            },
            {
              "id": "backhoe-loaders-case-580m-turbo-ii",
              "name": "580M TURBO II",
              "subcategories": []
            },
            {
              "id": "backhoe-loaders-case-580n",
              "name": "580N",
              "subcategories": []
            },
            {
              "id": "backhoe-loaders-case-580n-ep",
              "name": "580N EP",
              "subcategories": []
            },
            {
              "id": "backhoe-loaders-case-580sk",
              "name": "580SK",
              "subcategories": []
            },
            {
              "id": "backhoe-loaders-case-580sl",
              "name": "580SL",
              "subcategories": []
            },
            {
              "id": "backhoe-loaders-case-580sl-ii",
              "name": "580SL II",
              "subcategories": []
            },
            {
              "id": "backhoe-loaders-case-580sle",
              "name": "580SLE",
              "subcategories": []
            },
            {
              "id": "backhoe-loaders-case-580sm",
              "name": "580SM",
              "subcategories": []
            },
            {
              "id": "backhoe-loaders-case-580sm-ii",
              "name": "580SM II",
              "subcategories": []
            },
            {
              "id": "backhoe-loaders-case-580sm-iii",
              "name": "580SM III",
              "subcategories": []
            },
            {
              "id": "backhoe-loaders-case-580sm-plus",
              "name": "580SM PLUS",
              "subcategories": []
            },
            {
              "id": "backhoe-loaders-case-580-sm-plus-ii",
              "name": "580 SM PLUS II",
              "subcategories": []
            },
            {
              "id": "backhoe-loaders-case-580sn",
              "name": "580SN",
              "subcategories": []
            },
            {
              "id": "backhoe-loaders-case-580sn-wt",
              "name": "580SN WT",
              "subcategories": []
            },
            {
              "id": "backhoe-loaders-case-580sr",
              "name": "580SR",
              "subcategories": []
            },
            {
              "id": "backhoe-loaders-case-580st",
              "name": "580ST",
              "subcategories": []
            },
            {
              "id": "backhoe-loaders-case-580sv",
              "name": "580SV",
              "subcategories": []
            },
            {
              "id": "backhoe-loaders-case-580t",
              "name": "580T",
              "subcategories": []
            },
            {
              "id": "backhoe-loaders-case-590",
              "name": "590",
              "subcategories": []
            },
            {
              "id": "backhoe-loaders-case-590sl",
              "name": "590SL",
              "subcategories": []
            },
            {
              "id": "backhoe-loaders-case-590sle",
              "name": "590SLE",
              "subcategories": []
            },
            {
              "id": "backhoe-loaders-case-590sm",
              "name": "590SM",
              "subcategories": []
            },
            {
              "id": "backhoe-loaders-case-590sm-ii",
              "name": "590SM II",
              "subcategories": []
            },
            {
              "id": "backhoe-loaders-case-590sm-iii",
              "name": "590SM III",
              "subcategories": []
            },
            {
              "id": "backhoe-loaders-case-590sn",
              "name": "590SN",
              "subcategories": []
            },
            {
              "id": "backhoe-loaders-case-590sr",
              "name": "590SR",
              "subcategories": []
            },
            {
              "id": "backhoe-loaders-case-590st",
              "name": "590ST",
              "subcategories": []
            },
            {
              "id": "backhoe-loaders-case-590sv",
              "name": "590SV",
              "subcategories": []
            },
            {
              "id": "backhoe-loaders-case-680k",
              "name": "680K",
              "subcategories": []
            },
            {
              "id": "backhoe-loaders-case-695sm",
              "name": "695SM",
              "subcategories": []
            },
            {
              "id": "backhoe-loaders-case-695sr",
              "name": "695SR",
              "subcategories": []
            },
            {
              "id": "backhoe-loaders-case-695sr2-4ps",
              "name": "695SR2-4PS",
              "subcategories": []
            },
            {
              "id": "backhoe-loaders-case-695sr-4ps",
              "name": "695SR-4PS",
              "subcategories": []
            },
            {
              "id": "backhoe-loaders-case-695st",
              "name": "695ST",
              "subcategories": []
            },
            {
              "id": "backhoe-loaders-case-695sv",
              "name": "695SV",
              "subcategories": []
            },
            {
              "id": "backhoe-loaders-case-770ex",
              "name": "770EX",
              "subcategories": []
            },
            {
              "id": "backhoe-loaders-case-770ex-magnum",
              "name": "770EX MAGNUM",
              "subcategories": []
            },
            {
              "id": "backhoe-loaders-case-770nx",
              "name": "770NX",
              "subcategories": []
            },
            {
              "id": "backhoe-loaders-case-770nx-magnum",
              "name": "770NX MAGNUM",
              "subcategories": []
            },
            {
              "id": "backhoe-loaders-case-851nx-cp",
              "name": "851NX CP",
              "subcategories": []
            },
            {
              "id": "backhoe-loaders-case-d530",
              "name": "D530",
              "subcategories": []
            },
            {
              "id": "backhoe-loaders-case-288",
              "name": "288",
              "subcategories": []
            },
            {
              "id": "backhoe-loaders-case-other",
              "name": "OTHER",
              "subcategories": []
            }
          ]
        },
        {
          "id": "backhoe-loaders-jcb",
          "name": "Jcb",
          "subcategories": [
            {
              "id": "backhoe-loaders-jcb-1cx",
              "name": "1CX",
              "subcategories": []
            },
            {
              "id": "backhoe-loaders-jcb-1cxt",
              "name": "1CXT",
              "subcategories": []
            },
            {
              "id": "backhoe-loaders-jcb-2cx",
              "name": "2CX",
              "subcategories": []
            },
            {
              "id": "backhoe-loaders-jcb-2cx-streetmstr",
              "name": "2CX STREETMSTR",
              "subcategories": []
            },
            {
              "id": "backhoe-loaders-jcb-2cx12",
              "name": "2CX12",
              "subcategories": []
            },
            {
              "id": "backhoe-loaders-jcb-2cxs",
              "name": "2CXS",
              "subcategories": []
            },
            {
              "id": "backhoe-loaders-jcb-2dx",
              "name": "2DX",
              "subcategories": []
            },
            {
              "id": "backhoe-loaders-jcb-3c",
              "name": "3C",
              "subcategories": []
            },
            {
              "id": "backhoe-loaders-jcb-3c1550",
              "name": "3C1550",
              "subcategories": []
            },
            {
              "id": "backhoe-loaders-jcb-3cx",
              "name": "3CX",
              "subcategories": []
            },
            {
              "id": "backhoe-loaders-jcb-3cx-compact",
              "name": "3CX COMPACT",
              "subcategories": []
            },
            {
              "id": "backhoe-loaders-jcb-3cx-compact-plus",
              "name": "3CX COMPACT PLUS",
              "subcategories": []
            },
            {
              "id": "backhoe-loaders-jcb-3cx-compact-pro",
              "name": "3CX COMPACT PRO",
              "subcategories": []
            },
            {
              "id": "backhoe-loaders-jcb-3cx-contractor",
              "name": "3CX CONTRACTOR",
              "subcategories": []
            },
            {
              "id": "backhoe-loaders-jcb-3cx-contractor-plus",
              "name": "3CX CONTRACTOR PLUS",
              "subcategories": []
            },
            {
              "id": "backhoe-loaders-jcb-3cx-eco",
              "name": "3CX ECO",
              "subcategories": []
            },
            {
              "id": "backhoe-loaders-jcb-3cx-eco-sm",
              "name": "3CX ECO SM",
              "subcategories": []
            },
            {
              "id": "backhoe-loaders-jcb-3cx-plus",
              "name": "3CX PLUS",
              "subcategories": []
            },
            {
              "id": "backhoe-loaders-jcb-3cx-pro",
              "name": "3CX PRO",
              "subcategories": []
            },
            {
              "id": "backhoe-loaders-jcb-3cx-pro-platinum",
              "name": "3CX PRO PLATINUM",
              "subcategories": []
            },
            {
              "id": "backhoe-loaders-jcb-3cx-sm",
              "name": "3CX SM",
              "subcategories": []
            },
            {
              "id": "backhoe-loaders-jcb-3cx-sm4",
              "name": "3CX SM4",
              "subcategories": []
            },
            {
              "id": "backhoe-loaders-jcb-3cx-super",
              "name": "3CX SUPER",
              "subcategories": []
            },
            {
              "id": "backhoe-loaders-jcb-3cx4t",
              "name": "3CX4T",
              "subcategories": []
            },
            {
              "id": "backhoe-loaders-jcb-3cx12",
              "name": "3CX12",
              "subcategories": []
            },
            {
              "id": "backhoe-loaders-jcb-3cxp12",
              "name": "3CXP12",
              "subcategories": []
            },
            {
              "id": "backhoe-loaders-jcb-3dx",
              "name": "3DX",
              "subcategories": []
            },
            {
              "id": "backhoe-loaders-jcb-3dx-plus",
              "name": "3DX PLUS",
              "subcategories": []
            },
            {
              "id": "backhoe-loaders-jcb-3-dx-super",
              "name": "3 DX SUPER",
              "subcategories": []
            },
            {
              "id": "backhoe-loaders-jcb-4c-turbo",
              "name": "4C TURBO",
              "subcategories": []
            },
            {
              "id": "backhoe-loaders-jcb-4cx",
              "name": "4CX",
              "subcategories": []
            },
            {
              "id": "backhoe-loaders-jcb-4cx-eco",
              "name": "4CX ECO",
              "subcategories": []
            },
            {
              "id": "backhoe-loaders-jcb-4cx-po",
              "name": "4CX PO",
              "subcategories": []
            },
            {
              "id": "backhoe-loaders-jcb-4cx-super",
              "name": "4CX SUPER",
              "subcategories": []
            },
            {
              "id": "backhoe-loaders-jcb-4cx14",
              "name": "4CX14",
              "subcategories": []
            },
            {
              "id": "backhoe-loaders-jcb-4cx14-super",
              "name": "4CX14 SUPER",
              "subcategories": []
            },
            {
              "id": "backhoe-loaders-jcb-210s",
              "name": "210S",
              "subcategories": []
            },
            {
              "id": "backhoe-loaders-jcb-212s",
              "name": "212S",
              "subcategories": []
            },
            {
              "id": "backhoe-loaders-jcb-212su",
              "name": "212SU",
              "subcategories": []
            },
            {
              "id": "backhoe-loaders-jcb-214",
              "name": "214",
              "subcategories": []
            },
            {
              "id": "backhoe-loaders-jcb-214ii",
              "name": "214II",
              "subcategories": []
            },
            {
              "id": "backhoe-loaders-jcb-214-iii",
              "name": "214 III",
              "subcategories": []
            },
            {
              "id": "backhoe-loaders-jcb-214-iv",
              "name": "214 IV",
              "subcategories": []
            },
            {
              "id": "backhoe-loaders-jcb-214-sm",
              "name": "214 SM",
              "subcategories": []
            },
            {
              "id": "backhoe-loaders-jcb-214e",
              "name": "214E",
              "subcategories": []
            },
            {
              "id": "backhoe-loaders-jcb-214e-iii",
              "name": "214E III",
              "subcategories": []
            },
            {
              "id": "backhoe-loaders-jcb-214s",
              "name": "214S",
              "subcategories": []
            },
            {
              "id": "backhoe-loaders-jcb-214s-ii",
              "name": "214S II",
              "subcategories": []
            },
            {
              "id": "backhoe-loaders-jcb-214s-iii",
              "name": "214S III",
              "subcategories": []
            },
            {
              "id": "backhoe-loaders-jcb-215",
              "name": "215",
              "subcategories": []
            },
            {
              "id": "backhoe-loaders-jcb-215e",
              "name": "215E",
              "subcategories": []
            },
            {
              "id": "backhoe-loaders-jcb-215s-iii",
              "name": "215S III",
              "subcategories": []
            },
            {
              "id": "backhoe-loaders-jcb-217",
              "name": "217",
              "subcategories": []
            },
            {
              "id": "backhoe-loaders-jcb-217-iii",
              "name": "217 III",
              "subcategories": []
            },
            {
              "id": "backhoe-loaders-jcb-1550",
              "name": "1550",
              "subcategories": []
            },
            {
              "id": "backhoe-loaders-jcb-1550b",
              "name": "1550B",
              "subcategories": []
            },
            {
              "id": "backhoe-loaders-jcb-midi-cx",
              "name": "MIDI CX",
              "subcategories": []
            },
            {
              "id": "backhoe-loaders-jcb-other",
              "name": "OTHER",
              "subcategories": []
            }
          ]
        },
        {
          "id": "backhoe-loaders-komatsu",
          "name": "Komatsu",
          "subcategories": [
            {
              "id": "backhoe-loaders-komatsu-fai264",
              "name": "FAI264",
              "subcategories": []
            },
            {
              "id": "backhoe-loaders-komatsu-wb92a",
              "name": "WB92A",
              "subcategories": []
            },
            {
              "id": "backhoe-loaders-komatsu-wb93r",
              "name": "WB93R",
              "subcategories": []
            },
            {
              "id": "backhoe-loaders-komatsu-wb93r-5",
              "name": "WB93R-5",
              "subcategories": []
            },
            {
              "id": "backhoe-loaders-komatsu-wb93r-5e0",
              "name": "WB93R-5E0",
              "subcategories": []
            },
            {
              "id": "backhoe-loaders-komatsu-wb93r-8",
              "name": "WB93R-8",
              "subcategories": []
            },
            {
              "id": "backhoe-loaders-komatsu-wb93s-5e0",
              "name": "WB93S-5E0",
              "subcategories": []
            },
            {
              "id": "backhoe-loaders-komatsu-wb97r",
              "name": "WB97R",
              "subcategories": []
            },
            {
              "id": "backhoe-loaders-komatsu-wb97r-8",
              "name": "WB97R-8",
              "subcategories": []
            },
            {
              "id": "backhoe-loaders-komatsu-wb97s",
              "name": "WB97S",
              "subcategories": []
            },
            {
              "id": "backhoe-loaders-komatsu-wb97s-5",
              "name": "WB97S-5",
              "subcategories": []
            },
            {
              "id": "backhoe-loaders-komatsu-wb97s-5e0",
              "name": "WB97S-5E0",
              "subcategories": []
            },
            {
              "id": "backhoe-loaders-komatsu-wb97s-8",
              "name": "WB97S-8",
              "subcategories": []
            },
            {
              "id": "backhoe-loaders-komatsu-wb98a-2",
              "name": "WB98A-2",
              "subcategories": []
            },
            {
              "id": "backhoe-loaders-komatsu-wb140",
              "name": "WB140",
              "subcategories": []
            },
            {
              "id": "backhoe-loaders-komatsu-wb140-2",
              "name": "WB140-2",
              "subcategories": []
            },
            {
              "id": "backhoe-loaders-komatsu-wb140-2n",
              "name": "WB140-2N",
              "subcategories": []
            },
            {
              "id": "backhoe-loaders-komatsu-wb140ps-2n",
              "name": "WB140PS-2N",
              "subcategories": []
            },
            {
              "id": "backhoe-loaders-komatsu-wb150",
              "name": "WB150",
              "subcategories": []
            },
            {
              "id": "backhoe-loaders-komatsu-wb150-2",
              "name": "WB150-2",
              "subcategories": []
            },
            {
              "id": "backhoe-loaders-komatsu-wb150aws",
              "name": "WB150AWS",
              "subcategories": []
            },
            {
              "id": "backhoe-loaders-komatsu-other",
              "name": "OTHER",
              "subcategories": []
            }
          ]
        },
        {
          "id": "backhoe-loaders-new-holland",
          "name": "New Holland",
          "subcategories": [
            {
              "id": "backhoe-loaders-new-holland-555e",
              "name": "555E",
              "subcategories": []
            },
            {
              "id": "backhoe-loaders-new-holland-575e",
              "name": "575E",
              "subcategories": []
            },
            {
              "id": "backhoe-loaders-new-holland-655c",
              "name": "655C",
              "subcategories": []
            },
            {
              "id": "backhoe-loaders-new-holland-655e",
              "name": "655E",
              "subcategories": []
            },
            {
              "id": "backhoe-loaders-new-holland-675e",
              "name": "675E",
              "subcategories": []
            },
            {
              "id": "backhoe-loaders-new-holland-b75d",
              "name": "B75D",
              "subcategories": []
            },
            {
              "id": "backhoe-loaders-new-holland-b80b",
              "name": "B80B",
              "subcategories": []
            },
            {
              "id": "backhoe-loaders-new-holland-b90b",
              "name": "B90B",
              "subcategories": []
            },
            {
              "id": "backhoe-loaders-new-holland-b95",
              "name": "B95",
              "subcategories": []
            },
            {
              "id": "backhoe-loaders-new-holland-b95b",
              "name": "B95B",
              "subcategories": []
            },
            {
              "id": "backhoe-loaders-new-holland-b95c",
              "name": "B95C",
              "subcategories": []
            },
            {
              "id": "backhoe-loaders-new-holland-b95c-tc",
              "name": "B95C TC",
              "subcategories": []
            },
            {
              "id": "backhoe-loaders-new-holland-b95clr",
              "name": "B95CLR",
              "subcategories": []
            },
            {
              "id": "backhoe-loaders-new-holland-b95csc",
              "name": "B95CSC",
              "subcategories": []
            },
            {
              "id": "backhoe-loaders-new-holland-b95d",
              "name": "B95D",
              "subcategories": []
            },
            {
              "id": "backhoe-loaders-new-holland-b95d-tc",
              "name": "B95D TC",
              "subcategories": []
            },
            {
              "id": "backhoe-loaders-new-holland-b95lr",
              "name": "B95LR",
              "subcategories": []
            },
            {
              "id": "backhoe-loaders-new-holland-b95tc",
              "name": "B95TC",
              "subcategories": []
            },
            {
              "id": "backhoe-loaders-new-holland-b100c-tc",
              "name": "B100C TC",
              "subcategories": []
            },
            {
              "id": "backhoe-loaders-new-holland-b110",
              "name": "B110",
              "subcategories": []
            },
            {
              "id": "backhoe-loaders-new-holland-b110b",
              "name": "B110B",
              "subcategories": []
            },
            {
              "id": "backhoe-loaders-new-holland-b110b-tc",
              "name": "B110B TC",
              "subcategories": []
            },
            {
              "id": "backhoe-loaders-new-holland-b110c",
              "name": "B110C",
              "subcategories": []
            },
            {
              "id": "backhoe-loaders-new-holland-b110scp",
              "name": "B110SCP",
              "subcategories": []
            },
            {
              "id": "backhoe-loaders-new-holland-b110d",
              "name": "B110D",
              "subcategories": []
            },
            {
              "id": "backhoe-loaders-new-holland-b115",
              "name": "B115",
              "subcategories": []
            },
            {
              "id": "backhoe-loaders-new-holland-b115-4ps",
              "name": "B115-4PS",
              "subcategories": []
            },
            {
              "id": "backhoe-loaders-new-holland-b115b",
              "name": "B115B",
              "subcategories": []
            },
            {
              "id": "backhoe-loaders-new-holland-b115c",
              "name": "B115C",
              "subcategories": []
            },
            {
              "id": "backhoe-loaders-new-holland-lb75",
              "name": "LB75",
              "subcategories": []
            },
            {
              "id": "backhoe-loaders-new-holland-lb75b",
              "name": "LB75B",
              "subcategories": []
            },
            {
              "id": "backhoe-loaders-new-holland-lb75c4",
              "name": "LB75C4",
              "subcategories": []
            },
            {
              "id": "backhoe-loaders-new-holland-lb90",
              "name": "LB90",
              "subcategories": []
            },
            {
              "id": "backhoe-loaders-new-holland-lb95",
              "name": "LB95",
              "subcategories": []
            },
            {
              "id": "backhoe-loaders-new-holland-lb95b-4pt",
              "name": "LB95B-4PT",
              "subcategories": []
            },
            {
              "id": "backhoe-loaders-new-holland-lb110",
              "name": "LB110",
              "subcategories": []
            },
            {
              "id": "backhoe-loaders-new-holland-lb110b",
              "name": "LB110B",
              "subcategories": []
            },
            {
              "id": "backhoe-loaders-new-holland-lb115b",
              "name": "LB115B",
              "subcategories": []
            },
            {
              "id": "backhoe-loaders-new-holland-lb115b-4ps",
              "name": "LB115B-4PS",
              "subcategories": []
            },
            {
              "id": "backhoe-loaders-new-holland-lb5620",
              "name": "LB5620",
              "subcategories": []
            },
            {
              "id": "backhoe-loaders-new-holland-nh95-4ps",
              "name": "NH95-4PS",
              "subcategories": []
            },
            {
              "id": "backhoe-loaders-new-holland-other",
              "name": "OTHER",
              "subcategories": []
            }
          ]
        },
        {
          "id": "backhoe-loaders-ford",
          "name": "Ford",
          "subcategories": [
            {
              "id": "backhoe-loaders-ford-445",
              "name": "445",
              "subcategories": []
            },
            {
              "id": "backhoe-loaders-ford-455c",
              "name": "455C",
              "subcategories": []
            },
            {
              "id": "backhoe-loaders-ford-550",
              "name": "550",
              "subcategories": []
            },
            {
              "id": "backhoe-loaders-ford-555",
              "name": "555",
              "subcategories": []
            },
            {
              "id": "backhoe-loaders-ford-555a",
              "name": "555A",
              "subcategories": []
            },
            {
              "id": "backhoe-loaders-ford-555b",
              "name": "555B",
              "subcategories": []
            },
            {
              "id": "backhoe-loaders-ford-555c",
              "name": "555C",
              "subcategories": []
            },
            {
              "id": "backhoe-loaders-ford-555d",
              "name": "555D",
              "subcategories": []
            },
            {
              "id": "backhoe-loaders-ford-555e",
              "name": "555E",
              "subcategories": []
            },
            {
              "id": "backhoe-loaders-ford-575d",
              "name": "575D",
              "subcategories": []
            },
            {
              "id": "backhoe-loaders-ford-655",
              "name": "655",
              "subcategories": []
            },
            {
              "id": "backhoe-loaders-ford-655a",
              "name": "655A",
              "subcategories": []
            },
            {
              "id": "backhoe-loaders-ford-655d",
              "name": "655D",
              "subcategories": []
            },
            {
              "id": "backhoe-loaders-ford-655e",
              "name": "655E",
              "subcategories": []
            },
            {
              "id": "backhoe-loaders-ford-675d",
              "name": "675D",
              "subcategories": []
            },
            {
              "id": "backhoe-loaders-ford-750",
              "name": "750",
              "subcategories": []
            },
            {
              "id": "backhoe-loaders-ford-755a",
              "name": "755A",
              "subcategories": []
            },
            {
              "id": "backhoe-loaders-ford-755b",
              "name": "755B",
              "subcategories": []
            },
            {
              "id": "backhoe-loaders-ford-3000",
              "name": "3000",
              "subcategories": []
            },
            {
              "id": "backhoe-loaders-ford-3400",
              "name": "3400",
              "subcategories": []
            },
            {
              "id": "backhoe-loaders-ford-4400",
              "name": "4400",
              "subcategories": []
            },
            {
              "id": "backhoe-loaders-ford-5550",
              "name": "5550",
              "subcategories": []
            },
            {
              "id": "backhoe-loaders-ford-other",
              "name": "OTHER",
              "subcategories": []
            }
          ]
        },
        {
          "id": "backhoe-loaders-terex",
          "name": "Terex",
          "subcategories": [
            {
              "id": "backhoe-loaders-terex-760",
              "name": "760",
              "subcategories": []
            },
            {
              "id": "backhoe-loaders-terex-760b",
              "name": "760B",
              "subcategories": []
            },
            {
              "id": "backhoe-loaders-terex-860",
              "name": "860",
              "subcategories": []
            },
            {
              "id": "backhoe-loaders-terex-860elite",
              "name": "860ELITE",
              "subcategories": []
            },
            {
              "id": "backhoe-loaders-terex-880sx",
              "name": "880SX",
              "subcategories": []
            },
            {
              "id": "backhoe-loaders-terex-tlb830",
              "name": "TLB830",
              "subcategories": []
            },
            {
              "id": "backhoe-loaders-terex-tlb840ps",
              "name": "TLB840PS",
              "subcategories": []
            },
            {
              "id": "backhoe-loaders-terex-tlb840r",
              "name": "TLB840R",
              "subcategories": []
            },
            {
              "id": "backhoe-loaders-terex-tlb840sm",
              "name": "TLB840SM",
              "subcategories": []
            },
            {
              "id": "backhoe-loaders-terex-tlb844s",
              "name": "TLB844S",
              "subcategories": []
            },
            {
              "id": "backhoe-loaders-terex-tx760",
              "name": "TX760",
              "subcategories": []
            },
            {
              "id": "backhoe-loaders-terex-tx760b",
              "name": "TX760B",
              "subcategories": []
            },
            {
              "id": "backhoe-loaders-terex-other",
              "name": "OTHER",
              "subcategories": []
            }
          ]
        },
        {
          "id": "backhoe-loaders-delco",
          "name": "Delco",
          "subcategories": [
            {
              "id": "backhoe-loaders-delco-xp95",
              "name": "XP95",
              "subcategories": []
            },
            {
              "id": "backhoe-loaders-delco-xp95-plus",
              "name": "XP95 PLUS",
              "subcategories": []
            },
            {
              "id": "backhoe-loaders-delco-other",
              "name": "OTHER",
              "subcategories": []
            }
          ]
        },
        {
          "id": "backhoe-loaders-bobcat",
          "name": "Bobcat",
          "subcategories": [
            {
              "id": "backhoe-loaders-bobcat-b100",
              "name": "B100",
              "subcategories": []
            },
            {
              "id": "backhoe-loaders-bobcat-b730",
              "name": "B730",
              "subcategories": []
            },
            {
              "id": "backhoe-loaders-bobcat-b760",
              "name": "B760",
              "subcategories": []
            },
            {
              "id": "backhoe-loaders-bobcat-other",
              "name": "OTHER",
              "subcategories": []
            }
          ]
        },
        {
          "id": "backhoe-loaders-xcmg",
          "name": "Xcmg",
          "subcategories": []
        }
      ]
    },
    {
      "id": "compaction-rollers",
      "name": "Compaction/Rollers",
      "subcategories": [
        {
          "id": "compaction-rollers-compaction",
          "name": "Compaction",
          "subcategories": [
            {
              "id": "compaction-rollers-compaction-caterpillar",
              "name": "CATERPILLAR",
              "subcategories": []
            },
            {
              "id": "compaction-rollers-compaction-hamm",
              "name": "HAMM",
              "subcategories": []
            },
            {
              "id": "compaction-rollers-compaction-bomag",
              "name": "BOMAG",
              "subcategories": []
            },
            {
              "id": "compaction-rollers-compaction-dynapac",
              "name": "DYNAPAC",
              "subcategories": []
            },
            {
              "id": "compaction-rollers-compaction-wacker-nueson",
              "name": "WACKER NUESON",
              "subcategories": []
            },
            {
              "id": "compaction-rollers-compaction-volvo",
              "name": "VOLVO",
              "subcategories": []
            },
            {
              "id": "compaction-rollers-compaction-sakai",
              "name": "SAKAI",
              "subcategories": []
            },
            {
              "id": "compaction-rollers-compaction-ammann",
              "name": "AMMANN",
              "subcategories": []
            },
            {
              "id": "compaction-rollers-compaction-xcmg",
              "name": "XCMG",
              "subcategories": []
            },
            {
              "id": "compaction-rollers-compaction-husqvarna",
              "name": "HUSQVARNA",
              "subcategories": []
            },
            {
              "id": "compaction-rollers-compaction-sany",
              "name": "SANY",
              "subcategories": []
            }
          ]
        },
        {
          "id": "compaction-rollers-caterpillar",
          "name": "Caterpillar",
          "subcategories": [
            {
              "id": "compaction-rollers-caterpillar-815",
              "name": "815",
              "subcategories": []
            },
            {
              "id": "compaction-rollers-caterpillar-815a",
              "name": "815A",
              "subcategories": []
            },
            {
              "id": "compaction-rollers-caterpillar-815b",
              "name": "815B",
              "subcategories": []
            },
            {
              "id": "compaction-rollers-caterpillar-815c",
              "name": "815C",
              "subcategories": []
            },
            {
              "id": "compaction-rollers-caterpillar-815f",
              "name": "815F",
              "subcategories": []
            },
            {
              "id": "compaction-rollers-caterpillar-815f2",
              "name": "815F2",
              "subcategories": []
            },
            {
              "id": "compaction-rollers-caterpillar-815k",
              "name": "815K",
              "subcategories": []
            },
            {
              "id": "compaction-rollers-caterpillar-816",
              "name": "816",
              "subcategories": []
            },
            {
              "id": "compaction-rollers-caterpillar-816b",
              "name": "816B",
              "subcategories": []
            },
            {
              "id": "compaction-rollers-caterpillar-816c",
              "name": "816C",
              "subcategories": []
            },
            {
              "id": "compaction-rollers-caterpillar-816f",
              "name": "816F",
              "subcategories": []
            },
            {
              "id": "compaction-rollers-caterpillar-816f2",
              "name": "816F2",
              "subcategories": []
            },
            {
              "id": "compaction-rollers-caterpillar-816k",
              "name": "816K",
              "subcategories": []
            },
            {
              "id": "compaction-rollers-caterpillar-825",
              "name": "825",
              "subcategories": []
            },
            {
              "id": "compaction-rollers-caterpillar-825b",
              "name": "825B",
              "subcategories": []
            },
            {
              "id": "compaction-rollers-caterpillar-825c",
              "name": "825C",
              "subcategories": []
            },
            {
              "id": "compaction-rollers-caterpillar-825g",
              "name": "825G",
              "subcategories": []
            },
            {
              "id": "compaction-rollers-caterpillar-825g2",
              "name": "825G2",
              "subcategories": []
            },
            {
              "id": "compaction-rollers-caterpillar-825h",
              "name": "825H",
              "subcategories": []
            },
            {
              "id": "compaction-rollers-caterpillar-825k",
              "name": "825K",
              "subcategories": []
            },
            {
              "id": "compaction-rollers-caterpillar-826",
              "name": "826",
              "subcategories": []
            },
            {
              "id": "compaction-rollers-caterpillar-826c",
              "name": "826C",
              "subcategories": []
            },
            {
              "id": "compaction-rollers-caterpillar-826g",
              "name": "826G",
              "subcategories": []
            },
            {
              "id": "compaction-rollers-caterpillar-826g2",
              "name": "826G2",
              "subcategories": []
            },
            {
              "id": "compaction-rollers-caterpillar-826h",
              "name": "826H",
              "subcategories": []
            },
            {
              "id": "compaction-rollers-caterpillar-826k",
              "name": "826K",
              "subcategories": []
            },
            {
              "id": "compaction-rollers-caterpillar-836",
              "name": "836",
              "subcategories": []
            },
            {
              "id": "compaction-rollers-caterpillar-836c",
              "name": "836C",
              "subcategories": []
            },
            {
              "id": "compaction-rollers-caterpillar-836g",
              "name": "836G",
              "subcategories": []
            },
            {
              "id": "compaction-rollers-caterpillar-836h",
              "name": "836H",
              "subcategories": []
            },
            {
              "id": "compaction-rollers-caterpillar-836k",
              "name": "836K",
              "subcategories": []
            },
            {
              "id": "compaction-rollers-caterpillar-cb1-7",
              "name": "CB1.7",
              "subcategories": []
            },
            {
              "id": "compaction-rollers-caterpillar-cb1-8",
              "name": "CB1.8",
              "subcategories": []
            },
            {
              "id": "compaction-rollers-caterpillar-cb2-5",
              "name": "CB2.5",
              "subcategories": []
            },
            {
              "id": "compaction-rollers-caterpillar-cb2-7",
              "name": "CB2.7",
              "subcategories": []
            },
            {
              "id": "compaction-rollers-caterpillar-cb4-0",
              "name": "CB4.0",
              "subcategories": []
            },
            {
              "id": "compaction-rollers-caterpillar-cb4-4",
              "name": "CB4.4",
              "subcategories": []
            },
            {
              "id": "compaction-rollers-caterpillar-cb7",
              "name": "CB7",
              "subcategories": []
            },
            {
              "id": "compaction-rollers-caterpillar-cb10",
              "name": "CB10",
              "subcategories": []
            },
            {
              "id": "compaction-rollers-caterpillar-cb13",
              "name": "CB13",
              "subcategories": []
            },
            {
              "id": "compaction-rollers-caterpillar-cb14",
              "name": "CB14",
              "subcategories": []
            },
            {
              "id": "compaction-rollers-caterpillar-cb14b",
              "name": "CB14B",
              "subcategories": []
            },
            {
              "id": "compaction-rollers-caterpillar-cb15",
              "name": "CB15",
              "subcategories": []
            },
            {
              "id": "compaction-rollers-caterpillar-cb16",
              "name": "CB16",
              "subcategories": []
            },
            {
              "id": "compaction-rollers-caterpillar-cb22",
              "name": "CB22",
              "subcategories": []
            },
            {
              "id": "compaction-rollers-caterpillar-cb22b",
              "name": "CB22B",
              "subcategories": []
            },
            {
              "id": "compaction-rollers-caterpillar-cb24",
              "name": "CB24",
              "subcategories": []
            },
            {
              "id": "compaction-rollers-caterpillar-cb24b",
              "name": "CB24B",
              "subcategories": []
            },
            {
              "id": "compaction-rollers-caterpillar-cb24xt",
              "name": "CB24XT",
              "subcategories": []
            },
            {
              "id": "compaction-rollers-caterpillar-cb34",
              "name": "CB34",
              "subcategories": []
            },
            {
              "id": "compaction-rollers-caterpillar-cb34b",
              "name": "CB34B",
              "subcategories": []
            },
            {
              "id": "compaction-rollers-caterpillar-cb34xw",
              "name": "CB34XW",
              "subcategories": []
            },
            {
              "id": "compaction-rollers-caterpillar-cb34xw",
              "name": "CB34XW",
              "subcategories": []
            },
            {
              "id": "compaction-rollers-caterpillar-cb36",
              "name": "CB36",
              "subcategories": []
            },
            {
              "id": "compaction-rollers-caterpillar-cb36b",
              "name": "CB36B",
              "subcategories": []
            },
            {
              "id": "compaction-rollers-caterpillar-cb44",
              "name": "CB44",
              "subcategories": []
            },
            {
              "id": "compaction-rollers-caterpillar-cb44b",
              "name": "CB44B",
              "subcategories": []
            },
            {
              "id": "compaction-rollers-caterpillar-cb54",
              "name": "CB54",
              "subcategories": []
            },
            {
              "id": "compaction-rollers-caterpillar-cb54b",
              "name": "CB54B",
              "subcategories": []
            },
            {
              "id": "compaction-rollers-caterpillar-cb54xw",
              "name": "CB54XW",
              "subcategories": []
            },
            {
              "id": "compaction-rollers-caterpillar-cb64",
              "name": "CB64",
              "subcategories": []
            },
            {
              "id": "compaction-rollers-caterpillar-cb64b",
              "name": "CB64B",
              "subcategories": []
            },
            {
              "id": "compaction-rollers-caterpillar-cb66b",
              "name": "CB66B",
              "subcategories": []
            },
            {
              "id": "compaction-rollers-caterpillar-cb68b",
              "name": "CB68B",
              "subcategories": []
            },
            {
              "id": "compaction-rollers-caterpillar-cb-114",
              "name": "CB-114",
              "subcategories": []
            },
            {
              "id": "compaction-rollers-caterpillar-cb-214c",
              "name": "CB-214C",
              "subcategories": []
            },
            {
              "id": "compaction-rollers-caterpillar-cb-224b",
              "name": "CB-224B",
              "subcategories": []
            },
            {
              "id": "compaction-rollers-caterpillar-cb-224c",
              "name": "CB-224C",
              "subcategories": []
            },
            {
              "id": "compaction-rollers-caterpillar-cb-224e",
              "name": "CB-224E",
              "subcategories": []
            },
            {
              "id": "compaction-rollers-caterpillar-cb-225d",
              "name": "CB-225D",
              "subcategories": []
            },
            {
              "id": "compaction-rollers-caterpillar-cb-225e",
              "name": "CB-225E",
              "subcategories": []
            },
            {
              "id": "compaction-rollers-caterpillar-cb-334d",
              "name": "CB-334D",
              "subcategories": []
            },
            {
              "id": "compaction-rollers-caterpillar-cb-334e",
              "name": "CB-334E",
              "subcategories": []
            },
            {
              "id": "compaction-rollers-caterpillar-cb-335e",
              "name": "CB-335E",
              "subcategories": []
            },
            {
              "id": "compaction-rollers-caterpillar-cb-434",
              "name": "CB-434",
              "subcategories": []
            },
            {
              "id": "compaction-rollers-caterpillar-cb-434c",
              "name": "CB-434C",
              "subcategories": []
            },
            {
              "id": "compaction-rollers-caterpillar-cb-434d",
              "name": "CB-434D",
              "subcategories": []
            },
            {
              "id": "compaction-rollers-caterpillar-cb-514",
              "name": "CB-514",
              "subcategories": []
            },
            {
              "id": "compaction-rollers-caterpillar-cb-534",
              "name": "CB-534",
              "subcategories": []
            },
            {
              "id": "compaction-rollers-caterpillar-cb-534c",
              "name": "CB-534C",
              "subcategories": []
            },
            {
              "id": "compaction-rollers-caterpillar-cb-534d",
              "name": "CB-534D",
              "subcategories": []
            },
            {
              "id": "compaction-rollers-caterpillar-cb-534dxw",
              "name": "CB-534DXW",
              "subcategories": []
            },
            {
              "id": "compaction-rollers-caterpillar-cb-544",
              "name": "CB-544",
              "subcategories": []
            },
            {
              "id": "compaction-rollers-caterpillar-cb-564d",
              "name": "CB-564D",
              "subcategories": []
            },
            {
              "id": "compaction-rollers-caterpillar-cb-634",
              "name": "CB-634",
              "subcategories": []
            },
            {
              "id": "compaction-rollers-caterpillar-cb-634c",
              "name": "CB-634C",
              "subcategories": []
            },
            {
              "id": "compaction-rollers-caterpillar-cb-634d",
              "name": "CB-634D",
              "subcategories": []
            },
            {
              "id": "compaction-rollers-caterpillar-cc2-7",
              "name": "CC2.7",
              "subcategories": []
            },
            {
              "id": "compaction-rollers-caterpillar-cc2-7-gc",
              "name": "CC2.7 GC",
              "subcategories": []
            },
            {
              "id": "compaction-rollers-caterpillar-cc4-0",
              "name": "CC4.0",
              "subcategories": []
            },
            {
              "id": "compaction-rollers-caterpillar-cc24",
              "name": "CC24",
              "subcategories": []
            },
            {
              "id": "compaction-rollers-caterpillar-cc34",
              "name": "CC34",
              "subcategories": []
            },
            {
              "id": "compaction-rollers-caterpillar-cc34b",
              "name": "CC34B",
              "subcategories": []
            },
            {
              "id": "compaction-rollers-caterpillar-ccs9",
              "name": "CCS9",
              "subcategories": []
            },
            {
              "id": "compaction-rollers-caterpillar-cd8",
              "name": "CD8",
              "subcategories": []
            },
            {
              "id": "compaction-rollers-caterpillar-cd54",
              "name": "CD54",
              "subcategories": []
            },
            {
              "id": "compaction-rollers-caterpillar-cd54b",
              "name": "CD54B",
              "subcategories": []
            },
            {
              "id": "compaction-rollers-caterpillar-cp5",
              "name": "CP5",
              "subcategories": []
            },
            {
              "id": "compaction-rollers-caterpillar-cp7",
              "name": "CP7",
              "subcategories": []
            },
            {
              "id": "compaction-rollers-caterpillar-cp11gc",
              "name": "CP11GC",
              "subcategories": []
            },
            {
              "id": "compaction-rollers-caterpillar-cp12gc",
              "name": "CP12GC",
              "subcategories": []
            },
            {
              "id": "compaction-rollers-caterpillar-cp13gc",
              "name": "CP13GC",
              "subcategories": []
            },
            {
              "id": "compaction-rollers-caterpillar-cp16",
              "name": "CP16",
              "subcategories": []
            },
            {
              "id": "compaction-rollers-caterpillar-cp34",
              "name": "CP34",
              "subcategories": []
            },
            {
              "id": "compaction-rollers-caterpillar-cp44",
              "name": "CP44",
              "subcategories": []
            },
            {
              "id": "compaction-rollers-caterpillar-cp44b",
              "name": "CP44B",
              "subcategories": []
            },
            {
              "id": "compaction-rollers-caterpillar-cp54",
              "name": "CP54",
              "subcategories": []
            },
            {
              "id": "compaction-rollers-caterpillar-cp54b",
              "name": "CP54B",
              "subcategories": []
            },
            {
              "id": "compaction-rollers-caterpillar-cp56",
              "name": "CP56",
              "subcategories": []
            },
            {
              "id": "compaction-rollers-caterpillar-cp56b",
              "name": "CP56B",
              "subcategories": []
            },
            {
              "id": "compaction-rollers-caterpillar-cp64",
              "name": "CP64",
              "subcategories": []
            },
            {
              "id": "compaction-rollers-caterpillar-cp68b",
              "name": "CP68B",
              "subcategories": []
            },
            {
              "id": "compaction-rollers-caterpillar-cp74",
              "name": "CP74",
              "subcategories": []
            },
            {
              "id": "compaction-rollers-caterpillar-cp74b",
              "name": "CP74B",
              "subcategories": []
            },
            {
              "id": "compaction-rollers-caterpillar-cp76",
              "name": "CP76",
              "subcategories": []
            },
            {
              "id": "compaction-rollers-caterpillar-cp-323",
              "name": "CP-323",
              "subcategories": []
            },
            {
              "id": "compaction-rollers-caterpillar-cp-323c",
              "name": "CP-323C",
              "subcategories": []
            },
            {
              "id": "compaction-rollers-caterpillar-cp-433b",
              "name": "CP-433B",
              "subcategories": []
            },
            {
              "id": "compaction-rollers-caterpillar-cp-433c",
              "name": "CP-433C",
              "subcategories": []
            },
            {
              "id": "compaction-rollers-caterpillar-cp-433e",
              "name": "CP-433E",
              "subcategories": []
            },
            {
              "id": "compaction-rollers-caterpillar-cp-443b",
              "name": "CP-443B",
              "subcategories": []
            },
            {
              "id": "compaction-rollers-caterpillar-cp-533e",
              "name": "CP-533E",
              "subcategories": []
            },
            {
              "id": "compaction-rollers-caterpillar-cp-563",
              "name": "CP-563",
              "subcategories": []
            },
            {
              "id": "compaction-rollers-caterpillar-cp-563c",
              "name": "CP-563C",
              "subcategories": []
            },
            {
              "id": "compaction-rollers-caterpillar-cp-563d",
              "name": "CP-563D",
              "subcategories": []
            },
            {
              "id": "compaction-rollers-caterpillar-cp-563e",
              "name": "CP-563E",
              "subcategories": []
            },
            {
              "id": "compaction-rollers-caterpillar-cp-573e",
              "name": "CP-573E",
              "subcategories": []
            },
            {
              "id": "compaction-rollers-caterpillar-cs5",
              "name": "CS5",
              "subcategories": []
            },
            {
              "id": "compaction-rollers-caterpillar-cs7",
              "name": "CS7",
              "subcategories": []
            },
            {
              "id": "compaction-rollers-caterpillar-cs10",
              "name": "CS10",
              "subcategories": []
            },
            {
              "id": "compaction-rollers-caterpillar-cs10gc",
              "name": "CS10GC",
              "subcategories": []
            },
            {
              "id": "compaction-rollers-caterpillar-cs11",
              "name": "CS11",
              "subcategories": []
            },
            {
              "id": "compaction-rollers-caterpillar-cs11gc",
              "name": "CS11GC",
              "subcategories": []
            },
            {
              "id": "compaction-rollers-caterpillar-cs12",
              "name": "CS12",
              "subcategories": []
            },
            {
              "id": "compaction-rollers-caterpillar-cs12gc",
              "name": "CS12GC",
              "subcategories": []
            },
            {
              "id": "compaction-rollers-caterpillar-cs13",
              "name": "CS13",
              "subcategories": []
            },
            {
              "id": "compaction-rollers-caterpillar-cs13gc",
              "name": "CS13GC",
              "subcategories": []
            },
            {
              "id": "compaction-rollers-caterpillar-cs14",
              "name": "CS14",
              "subcategories": []
            },
            {
              "id": "compaction-rollers-caterpillar-cs16",
              "name": "CS16",
              "subcategories": []
            },
            {
              "id": "compaction-rollers-caterpillar-cs17",
              "name": "CS17",
              "subcategories": []
            },
            {
              "id": "compaction-rollers-caterpillar-cs34",
              "name": "CS34",
              "subcategories": []
            },
            {
              "id": "compaction-rollers-caterpillar-cs44",
              "name": "CS44",
              "subcategories": []
            },
            {
              "id": "compaction-rollers-caterpillar-cs44b",
              "name": "CS44B",
              "subcategories": []
            },
            {
              "id": "compaction-rollers-caterpillar-cs54",
              "name": "CS54",
              "subcategories": []
            },
            {
              "id": "compaction-rollers-caterpillar-cs54b",
              "name": "CS54B",
              "subcategories": []
            },
            {
              "id": "compaction-rollers-caterpillar-cs56",
              "name": "CS56",
              "subcategories": []
            },
            {
              "id": "compaction-rollers-caterpillar-cs56b",
              "name": "CS56B",
              "subcategories": []
            },
            {
              "id": "compaction-rollers-caterpillar-cs64",
              "name": "CS64",
              "subcategories": []
            },
            {
              "id": "compaction-rollers-caterpillar-cs64b",
              "name": "CS64B",
              "subcategories": []
            },
            {
              "id": "compaction-rollers-caterpillar-cs66b",
              "name": "CS66B",
              "subcategories": []
            },
            {
              "id": "compaction-rollers-caterpillar-cs68b",
              "name": "CS68B",
              "subcategories": []
            },
            {
              "id": "compaction-rollers-caterpillar-cs74",
              "name": "CS74",
              "subcategories": []
            },
            {
              "id": "compaction-rollers-caterpillar-cs74b",
              "name": "CS74B",
              "subcategories": []
            },
            {
              "id": "compaction-rollers-caterpillar-cs76",
              "name": "CS76",
              "subcategories": []
            },
            {
              "id": "compaction-rollers-caterpillar-cs76-xt",
              "name": "CS76 XT",
              "subcategories": []
            },
            {
              "id": "compaction-rollers-caterpillar-cs76b",
              "name": "CS76B",
              "subcategories": []
            },
            {
              "id": "compaction-rollers-caterpillar-cs78b",
              "name": "CS78B",
              "subcategories": []
            },
            {
              "id": "compaction-rollers-caterpillar-cs-323c",
              "name": "CS-323C",
              "subcategories": []
            },
            {
              "id": "compaction-rollers-caterpillar-cs-423e",
              "name": "CS-423E",
              "subcategories": []
            },
            {
              "id": "compaction-rollers-caterpillar-cs-433b",
              "name": "CS-433B",
              "subcategories": []
            },
            {
              "id": "compaction-rollers-caterpillar-cs-433c",
              "name": "CS-433C",
              "subcategories": []
            },
            {
              "id": "compaction-rollers-caterpillar-cs-433e",
              "name": "CS-433E",
              "subcategories": []
            },
            {
              "id": "compaction-rollers-caterpillar-cs-531c",
              "name": "CS-531C",
              "subcategories": []
            },
            {
              "id": "compaction-rollers-caterpillar-cs-533",
              "name": "CS-533",
              "subcategories": []
            },
            {
              "id": "compaction-rollers-caterpillar-cs-533c",
              "name": "CS-533C",
              "subcategories": []
            },
            {
              "id": "compaction-rollers-caterpillar-cs-533e",
              "name": "CS-533E",
              "subcategories": []
            },
            {
              "id": "compaction-rollers-caterpillar-cs-533e-xt",
              "name": "CS-533E XT",
              "subcategories": []
            },
            {
              "id": "compaction-rollers-caterpillar-cs-563",
              "name": "CS-563",
              "subcategories": []
            },
            {
              "id": "compaction-rollers-caterpillar-cs-563c",
              "name": "CS-563C",
              "subcategories": []
            },
            {
              "id": "compaction-rollers-caterpillar-cs-563d",
              "name": "CS-563D",
              "subcategories": []
            },
            {
              "id": "compaction-rollers-caterpillar-cs-563daw",
              "name": "CS-563DAW",
              "subcategories": []
            },
            {
              "id": "compaction-rollers-caterpillar-cs-563e",
              "name": "CS-563E",
              "subcategories": []
            },
            {
              "id": "compaction-rollers-caterpillar-cs-573e",
              "name": "CS-573E",
              "subcategories": []
            },
            {
              "id": "compaction-rollers-caterpillar-cs-583c",
              "name": "CS-583C",
              "subcategories": []
            },
            {
              "id": "compaction-rollers-caterpillar-cs-583d",
              "name": "CS-583D",
              "subcategories": []
            },
            {
              "id": "compaction-rollers-caterpillar-cs-583e",
              "name": "CS-583E",
              "subcategories": []
            },
            {
              "id": "compaction-rollers-caterpillar-cs-663e",
              "name": "CS-663E",
              "subcategories": []
            },
            {
              "id": "compaction-rollers-caterpillar-cs-683e",
              "name": "CS-683E",
              "subcategories": []
            },
            {
              "id": "compaction-rollers-caterpillar-cw14",
              "name": "CW14",
              "subcategories": []
            },
            {
              "id": "compaction-rollers-caterpillar-cw16",
              "name": "CW16",
              "subcategories": []
            },
            {
              "id": "compaction-rollers-caterpillar-cw34",
              "name": "CW34",
              "subcategories": []
            },
            {
              "id": "compaction-rollers-caterpillar-pf-300",
              "name": "PF-300",
              "subcategories": []
            },
            {
              "id": "compaction-rollers-caterpillar-ps-130",
              "name": "PS-130",
              "subcategories": []
            },
            {
              "id": "compaction-rollers-caterpillar-ps-150",
              "name": "PS-150",
              "subcategories": []
            },
            {
              "id": "compaction-rollers-caterpillar-ps-300",
              "name": "PS-300",
              "subcategories": []
            },
            {
              "id": "compaction-rollers-caterpillar-ps-360",
              "name": "PS-360",
              "subcategories": []
            },
            {
              "id": "compaction-rollers-caterpillar-other",
              "name": "OTHER",
              "subcategories": []
            }
          ]
        },
        {
          "id": "compaction-rollers-hamm",
          "name": "Hamm",
          "subcategories": [
            {
              "id": "compaction-rollers-hamm-311",
              "name": "311",
              "subcategories": []
            },
            {
              "id": "compaction-rollers-hamm-320",
              "name": "320",
              "subcategories": []
            },
            {
              "id": "compaction-rollers-hamm-2210",
              "name": "2210",
              "subcategories": []
            },
            {
              "id": "compaction-rollers-hamm-2310",
              "name": "2310",
              "subcategories": []
            },
            {
              "id": "compaction-rollers-hamm-2311",
              "name": "2311",
              "subcategories": []
            },
            {
              "id": "compaction-rollers-hamm-2320",
              "name": "2320",
              "subcategories": []
            },
            {
              "id": "compaction-rollers-hamm-2420",
              "name": "2420",
              "subcategories": []
            },
            {
              "id": "compaction-rollers-hamm-2422",
              "name": "2422",
              "subcategories": []
            },
            {
              "id": "compaction-rollers-hamm-3012",
              "name": "3012",
              "subcategories": []
            },
            {
              "id": "compaction-rollers-hamm-3205",
              "name": "3205",
              "subcategories": []
            },
            {
              "id": "compaction-rollers-hamm-3307",
              "name": "3307",
              "subcategories": []
            },
            {
              "id": "compaction-rollers-hamm-3410",
              "name": "3410",
              "subcategories": []
            },
            {
              "id": "compaction-rollers-hamm-3411",
              "name": "3411",
              "subcategories": []
            },
            {
              "id": "compaction-rollers-hamm-3412",
              "name": "3412",
              "subcategories": []
            },
            {
              "id": "compaction-rollers-hamm-3414",
              "name": "3414",
              "subcategories": []
            },
            {
              "id": "compaction-rollers-hamm-3518",
              "name": "3518",
              "subcategories": []
            },
            {
              "id": "compaction-rollers-hamm-3520",
              "name": "3520",
              "subcategories": []
            },
            {
              "id": "compaction-rollers-hamm-3625",
              "name": "3625",
              "subcategories": []
            },
            {
              "id": "compaction-rollers-hamm-dv06",
              "name": "DV06",
              "subcategories": []
            },
            {
              "id": "compaction-rollers-hamm-dv3",
              "name": "DV3",
              "subcategories": []
            },
            {
              "id": "compaction-rollers-hamm-dv6",
              "name": "DV6",
              "subcategories": []
            },
            {
              "id": "compaction-rollers-hamm-dv8",
              "name": "DV8",
              "subcategories": []
            },
            {
              "id": "compaction-rollers-hamm-dv65",
              "name": "DV65",
              "subcategories": []
            },
            {
              "id": "compaction-rollers-hamm-dv70",
              "name": "DV70",
              "subcategories": []
            },
            {
              "id": "compaction-rollers-hamm-dv-70",
              "name": "DV+70",
              "subcategories": []
            },
            {
              "id": "compaction-rollers-hamm-dv85",
              "name": "DV85",
              "subcategories": []
            },
            {
              "id": "compaction-rollers-hamm-dv90",
              "name": "DV90",
              "subcategories": []
            },
            {
              "id": "compaction-rollers-hamm-dv-90",
              "name": "DV+90",
              "subcategories": []
            },
            {
              "id": "compaction-rollers-hamm-grw5",
              "name": "GRW5",
              "subcategories": []
            },
            {
              "id": "compaction-rollers-hamm-grw10",
              "name": "GRW10",
              "subcategories": []
            },
            {
              "id": "compaction-rollers-hamm-grw15",
              "name": "GRW15",
              "subcategories": []
            },
            {
              "id": "compaction-rollers-hamm-grw18",
              "name": "GRW18",
              "subcategories": []
            },
            {
              "id": "compaction-rollers-hamm-grw180i",
              "name": "GRW180I",
              "subcategories": []
            },
            {
              "id": "compaction-rollers-hamm-grw280",
              "name": "GRW280",
              "subcategories": []
            },
            {
              "id": "compaction-rollers-hamm-grw280i",
              "name": "GRW280I",
              "subcategories": []
            },
            {
              "id": "compaction-rollers-hamm-h5",
              "name": "H5",
              "subcategories": []
            },
            {
              "id": "compaction-rollers-hamm-h7",
              "name": "H7",
              "subcategories": []
            },
            {
              "id": "compaction-rollers-hamm-h10",
              "name": "H10",
              "subcategories": []
            },
            {
              "id": "compaction-rollers-hamm-h11",
              "name": "H11",
              "subcategories": []
            },
            {
              "id": "compaction-rollers-hamm-h12",
              "name": "H12",
              "subcategories": []
            },
            {
              "id": "compaction-rollers-hamm-h13",
              "name": "H13",
              "subcategories": []
            },
            {
              "id": "compaction-rollers-hamm-h14",
              "name": "H14",
              "subcategories": []
            },
            {
              "id": "compaction-rollers-hamm-h16",
              "name": "H16",
              "subcategories": []
            },
            {
              "id": "compaction-rollers-hamm-h18",
              "name": "H18",
              "subcategories": []
            },
            {
              "id": "compaction-rollers-hamm-h20",
              "name": "H20",
              "subcategories": []
            },
            {
              "id": "compaction-rollers-hamm-h25",
              "name": "H25",
              "subcategories": []
            },
            {
              "id": "compaction-rollers-hamm-h200",
              "name": "H200",
              "subcategories": []
            },
            {
              "id": "compaction-rollers-hamm-hc50",
              "name": "HC50",
              "subcategories": []
            },
            {
              "id": "compaction-rollers-hamm-hc70",
              "name": "HC70",
              "subcategories": []
            },
            {
              "id": "compaction-rollers-hamm-hc100",
              "name": "HC100",
              "subcategories": []
            },
            {
              "id": "compaction-rollers-hamm-hc120",
              "name": "HC120",
              "subcategories": []
            },
            {
              "id": "compaction-rollers-hamm-hc130",
              "name": "HC130",
              "subcategories": []
            },
            {
              "id": "compaction-rollers-hamm-hc160",
              "name": "HC160",
              "subcategories": []
            },
            {
              "id": "compaction-rollers-hamm-hc180",
              "name": "HC180",
              "subcategories": []
            },
            {
              "id": "compaction-rollers-hamm-hc200",
              "name": "HC200",
              "subcategories": []
            },
            {
              "id": "compaction-rollers-hamm-hd8",
              "name": "HD8",
              "subcategories": []
            },
            {
              "id": "compaction-rollers-hamm-hd9",
              "name": "HD9",
              "subcategories": []
            },
            {
              "id": "compaction-rollers-hamm-hd10",
              "name": "HD10",
              "subcategories": []
            },
            {
              "id": "compaction-rollers-hamm-hd12",
              "name": "HD12",
              "subcategories": []
            },
            {
              "id": "compaction-rollers-hamm-hd13",
              "name": "HD13",
              "subcategories": []
            },
            {
              "id": "compaction-rollers-hamm-hd14",
              "name": "HD14",
              "subcategories": []
            },
            {
              "id": "compaction-rollers-hamm-hd70",
              "name": "HD70",
              "subcategories": []
            },
            {
              "id": "compaction-rollers-hamm-hd75",
              "name": "HD75",
              "subcategories": []
            },
            {
              "id": "compaction-rollers-hamm-hd85",
              "name": "HD85",
              "subcategories": []
            },
            {
              "id": "compaction-rollers-hamm-hd90",
              "name": "HD90",
              "subcategories": []
            },
            {
              "id": "compaction-rollers-hamm-hd110",
              "name": "HD110",
              "subcategories": []
            },
            {
              "id": "compaction-rollers-hamm-hd120",
              "name": "HD120",
              "subcategories": []
            },
            {
              "id": "compaction-rollers-hamm-hd128",
              "name": "HD128",
              "subcategories": []
            },
            {
              "id": "compaction-rollers-hamm-hd130",
              "name": "HD130",
              "subcategories": []
            },
            {
              "id": "compaction-rollers-hamm-hc119",
              "name": "HC119",
              "subcategories": []
            },
            {
              "id": "compaction-rollers-hamm-hd138",
              "name": "HD138",
              "subcategories": []
            },
            {
              "id": "compaction-rollers-hamm-hd140",
              "name": "HD140",
              "subcategories": []
            },
            {
              "id": "compaction-rollers-hamm-hdo120",
              "name": "HDO120",
              "subcategories": []
            },
            {
              "id": "compaction-rollers-hamm-hd-70",
              "name": "HD+70",
              "subcategories": []
            },
            {
              "id": "compaction-rollers-hamm-hd-80",
              "name": "HD+80",
              "subcategories": []
            },
            {
              "id": "compaction-rollers-hamm-hd-90",
              "name": "HD+90",
              "subcategories": []
            },
            {
              "id": "compaction-rollers-hamm-hd-110",
              "name": "HD+110",
              "subcategories": []
            },
            {
              "id": "compaction-rollers-hamm-hd-120",
              "name": "HD+120",
              "subcategories": []
            },
            {
              "id": "compaction-rollers-hamm-hd-120i",
              "name": "HD+120I",
              "subcategories": []
            },
            {
              "id": "compaction-rollers-hamm-hd-140",
              "name": "HD+140",
              "subcategories": []
            },
            {
              "id": "compaction-rollers-hamm-hp100",
              "name": "HP100",
              "subcategories": []
            },
            {
              "id": "compaction-rollers-hamm-hp180",
              "name": "HP180",
              "subcategories": []
            },
            {
              "id": "compaction-rollers-hamm-hp280",
              "name": "HP280",
              "subcategories": []
            },
            {
              "id": "compaction-rollers-hamm-htc15",
              "name": "HTC15",
              "subcategories": []
            },
            {
              "id": "compaction-rollers-hamm-hw90",
              "name": "HW90",
              "subcategories": []
            },
            {
              "id": "compaction-rollers-hamm-hw2304",
              "name": "HW2304",
              "subcategories": []
            },
            {
              "id": "compaction-rollers-hamm-hx70iov",
              "name": "HX70IOV",
              "subcategories": []
            },
            {
              "id": "compaction-rollers-hamm-hx90",
              "name": "HX90",
              "subcategories": []
            },
            {
              "id": "compaction-rollers-hamm-other",
              "name": "OTHER",
              "subcategories": []
            }
          ]
        },
        {
          "id": "compaction-rollers-bomag",
          "name": "Bomag",
          "subcategories": [
            {
              "id": "compaction-rollers-bomag-bc473",
              "name": "BC473",
              "subcategories": []
            },
            {
              "id": "compaction-rollers-bomag-bc571",
              "name": "BC571",
              "subcategories": []
            },
            {
              "id": "compaction-rollers-bomag-bc572",
              "name": "BC572",
              "subcategories": []
            },
            {
              "id": "compaction-rollers-bomag-bc601",
              "name": "BC601",
              "subcategories": []
            },
            {
              "id": "compaction-rollers-bomag-bc671",
              "name": "BC671",
              "subcategories": []
            },
            {
              "id": "compaction-rollers-bomag-bc672",
              "name": "BC672",
              "subcategories": []
            },
            {
              "id": "compaction-rollers-bomag-bc772",
              "name": "BC772",
              "subcategories": []
            },
            {
              "id": "compaction-rollers-bomag-bc972",
              "name": "BC972",
              "subcategories": []
            },
            {
              "id": "compaction-rollers-bomag-bc1172",
              "name": "BC1172",
              "subcategories": []
            },
            {
              "id": "compaction-rollers-bomag-bmp851",
              "name": "BMP851",
              "subcategories": []
            },
            {
              "id": "compaction-rollers-bomag-bmp8500",
              "name": "BMP8500",
              "subcategories": []
            },
            {
              "id": "compaction-rollers-bomag-bp10",
              "name": "BP10",
              "subcategories": []
            },
            {
              "id": "compaction-rollers-bomag-bp12",
              "name": "BP12",
              "subcategories": []
            },
            {
              "id": "compaction-rollers-bomag-bp15",
              "name": "BP15",
              "subcategories": []
            },
            {
              "id": "compaction-rollers-bomag-bp20",
              "name": "BP20",
              "subcategories": []
            },
            {
              "id": "compaction-rollers-bomag-bp25",
              "name": "BP25",
              "subcategories": []
            },
            {
              "id": "compaction-rollers-bomag-bph80",
              "name": "BPH80",
              "subcategories": []
            },
            {
              "id": "compaction-rollers-bomag-bpr25",
              "name": "BPR25",
              "subcategories": []
            },
            {
              "id": "compaction-rollers-bomag-bpr30",
              "name": "BPR30",
              "subcategories": []
            },
            {
              "id": "compaction-rollers-bomag-bpr35",
              "name": "BPR35",
              "subcategories": []
            },
            {
              "id": "compaction-rollers-bomag-bpr45",
              "name": "BPR45",
              "subcategories": []
            },
            {
              "id": "compaction-rollers-bomag-bpr50",
              "name": "BPR50",
              "subcategories": []
            },
            {
              "id": "compaction-rollers-bomag-bpr55",
              "name": "BPR55",
              "subcategories": []
            },
            {
              "id": "compaction-rollers-bomag-bpr60",
              "name": "BPR60",
              "subcategories": []
            },
            {
              "id": "compaction-rollers-bomag-bpr70",
              "name": "BPR70",
              "subcategories": []
            },
            {
              "id": "compaction-rollers-bomag-bpr100",
              "name": "BPR100",
              "subcategories": []
            },
            {
              "id": "compaction-rollers-bomag-bpr95",
              "name": "BPR95",
              "subcategories": []
            },
            {
              "id": "compaction-rollers-bomag-bt50",
              "name": "BT50",
              "subcategories": []
            },
            {
              "id": "compaction-rollers-bomag-bt60",
              "name": "BT60",
              "subcategories": []
            },
            {
              "id": "compaction-rollers-bomag-bt65",
              "name": "BT65",
              "subcategories": []
            },
            {
              "id": "compaction-rollers-bomag-bvp10",
              "name": "BVP10",
              "subcategories": []
            },
            {
              "id": "compaction-rollers-bomag-bvp12",
              "name": "BVP12",
              "subcategories": []
            },
            {
              "id": "compaction-rollers-bomag-bvp18",
              "name": "BVP18",
              "subcategories": []
            },
            {
              "id": "compaction-rollers-bomag-bvt65",
              "name": "BVT65",
              "subcategories": []
            },
            {
              "id": "compaction-rollers-bomag-bw4",
              "name": "BW4",
              "subcategories": []
            },
            {
              "id": "compaction-rollers-bomag-bw6",
              "name": "BW6",
              "subcategories": []
            },
            {
              "id": "compaction-rollers-bomag-bw9",
              "name": "BW9",
              "subcategories": []
            },
            {
              "id": "compaction-rollers-bomag-bw11",
              "name": "BW11",
              "subcategories": []
            },
            {
              "id": "compaction-rollers-bomag-bw12",
              "name": "BW12",
              "subcategories": []
            },
            {
              "id": "compaction-rollers-bomag-bw24",
              "name": "BW24",
              "subcategories": []
            },
            {
              "id": "compaction-rollers-bomag-bw25",
              "name": "BW25",
              "subcategories": []
            },
            {
              "id": "compaction-rollers-bomag-bw27",
              "name": "BW27",
              "subcategories": []
            },
            {
              "id": "compaction-rollers-bomag-bw28",
              "name": "BW28",
              "subcategories": []
            },
            {
              "id": "compaction-rollers-bomag-bw55",
              "name": "BW55",
              "subcategories": []
            },
            {
              "id": "compaction-rollers-bomag-bw60",
              "name": "BW60",
              "subcategories": []
            },
            {
              "id": "compaction-rollers-bomag-bw65",
              "name": "BW65",
              "subcategories": []
            },
            {
              "id": "compaction-rollers-bomag-bw71",
              "name": "BW71",
              "subcategories": []
            },
            {
              "id": "compaction-rollers-bomag-bw75",
              "name": "BW75",
              "subcategories": []
            },
            {
              "id": "compaction-rollers-bomag-bw76",
              "name": "BW76",
              "subcategories": []
            },
            {
              "id": "compaction-rollers-bomag-bw80",
              "name": "BW80",
              "subcategories": []
            },
            {
              "id": "compaction-rollers-bomag-bw90",
              "name": "BW90",
              "subcategories": []
            },
            {
              "id": "compaction-rollers-bomag-bw100",
              "name": "BW100",
              "subcategories": []
            },
            {
              "id": "compaction-rollers-bomag-bw120",
              "name": "BW120",
              "subcategories": []
            },
            {
              "id": "compaction-rollers-bomag-bw122",
              "name": "BW122",
              "subcategories": []
            },
            {
              "id": "compaction-rollers-bomag-bw124",
              "name": "BW124",
              "subcategories": []
            },
            {
              "id": "compaction-rollers-bomag-bw125",
              "name": "BW125",
              "subcategories": []
            },
            {
              "id": "compaction-rollers-bomag-bw130",
              "name": "BW130",
              "subcategories": []
            },
            {
              "id": "compaction-rollers-bomag-bw131",
              "name": "BW131",
              "subcategories": []
            },
            {
              "id": "compaction-rollers-bomag-bw135",
              "name": "BW135",
              "subcategories": []
            },
            {
              "id": "compaction-rollers-bomag-bw137",
              "name": "BW137",
              "subcategories": []
            },
            {
              "id": "compaction-rollers-bomag-bw138",
              "name": "BW138",
              "subcategories": []
            },
            {
              "id": "compaction-rollers-bomag-bw141",
              "name": "BW141",
              "subcategories": []
            },
            {
              "id": "compaction-rollers-bomag-bw144",
              "name": "BW144",
              "subcategories": []
            },
            {
              "id": "compaction-rollers-bomag-bw145",
              "name": "BW145",
              "subcategories": []
            },
            {
              "id": "compaction-rollers-bomag-bw151",
              "name": "BW151",
              "subcategories": []
            },
            {
              "id": "compaction-rollers-bomag-bw154",
              "name": "BW154",
              "subcategories": []
            },
            {
              "id": "compaction-rollers-bomag-bw160",
              "name": "BW160",
              "subcategories": []
            },
            {
              "id": "compaction-rollers-bomag-bw161",
              "name": "BW161",
              "subcategories": []
            },
            {
              "id": "compaction-rollers-bomag-bw164",
              "name": "BW164",
              "subcategories": []
            },
            {
              "id": "compaction-rollers-bomag-bw170",
              "name": "BW170",
              "subcategories": []
            },
            {
              "id": "compaction-rollers-bomag-bw172",
              "name": "BW172",
              "subcategories": []
            },
            {
              "id": "compaction-rollers-bomag-bw174",
              "name": "BW174",
              "subcategories": []
            },
            {
              "id": "compaction-rollers-bomag-bw177",
              "name": "BW177",
              "subcategories": []
            },
            {
              "id": "compaction-rollers-bomag-bw178",
              "name": "BW178",
              "subcategories": []
            },
            {
              "id": "compaction-rollers-bomag-bw179",
              "name": "BW179",
              "subcategories": []
            },
            {
              "id": "compaction-rollers-bomag-bw184",
              "name": "BW184",
              "subcategories": []
            },
            {
              "id": "compaction-rollers-bomag-bw190",
              "name": "BW190",
              "subcategories": []
            },
            {
              "id": "compaction-rollers-bomag-bw191",
              "name": "BW191",
              "subcategories": []
            },
            {
              "id": "compaction-rollers-bomag-bw200",
              "name": "BW200",
              "subcategories": []
            },
            {
              "id": "compaction-rollers-bomag-bw201",
              "name": "BW201",
              "subcategories": []
            },
            {
              "id": "compaction-rollers-bomag-bw202",
              "name": "BW202",
              "subcategories": []
            },
            {
              "id": "compaction-rollers-bomag-bw203",
              "name": "BW203",
              "subcategories": []
            },
            {
              "id": "compaction-rollers-bomag-bw205",
              "name": "BW205",
              "subcategories": []
            },
            {
              "id": "compaction-rollers-bomag-bw206",
              "name": "BW206",
              "subcategories": []
            },
            {
              "id": "compaction-rollers-bomag-bw211",
              "name": "BW211",
              "subcategories": []
            },
            {
              "id": "compaction-rollers-bomag-bw212",
              "name": "BW212",
              "subcategories": []
            },
            {
              "id": "compaction-rollers-bomag-bw213",
              "name": "BW213",
              "subcategories": []
            },
            {
              "id": "compaction-rollers-bomag-bw216",
              "name": "BW216",
              "subcategories": []
            },
            {
              "id": "compaction-rollers-bomag-bw217",
              "name": "BW217",
              "subcategories": []
            },
            {
              "id": "compaction-rollers-bomag-bw219",
              "name": "BW219",
              "subcategories": []
            },
            {
              "id": "compaction-rollers-bomag-bw226",
              "name": "BW226",
              "subcategories": []
            },
            {
              "id": "compaction-rollers-bomag-bw266",
              "name": "BW266",
              "subcategories": []
            },
            {
              "id": "compaction-rollers-bomag-bw278",
              "name": "BW278",
              "subcategories": []
            },
            {
              "id": "compaction-rollers-bomag-bw284",
              "name": "BW284",
              "subcategories": []
            },
            {
              "id": "compaction-rollers-bomag-bw600",
              "name": "BW600",
              "subcategories": []
            },
            {
              "id": "compaction-rollers-bomag-bw850",
              "name": "BW850",
              "subcategories": []
            },
            {
              "id": "compaction-rollers-bomag-bw900",
              "name": "BW900",
              "subcategories": []
            },
            {
              "id": "compaction-rollers-bomag-k300",
              "name": "K300",
              "subcategories": []
            },
            {
              "id": "compaction-rollers-bomag-k351",
              "name": "K351",
              "subcategories": []
            },
            {
              "id": "compaction-rollers-bomag-other",
              "name": "OTHER",
              "subcategories": []
            }
          ]
        },
        {
          "id": "compaction-rollers-dynapac",
          "name": "Dynapac",
          "subcategories": [
            {
              "id": "compaction-rollers-dynapac-ca15",
              "name": "CA15",
              "subcategories": []
            },
            {
              "id": "compaction-rollers-dynapac-ca25",
              "name": "CA25",
              "subcategories": []
            },
            {
              "id": "compaction-rollers-dynapac-ca30",
              "name": "CA30",
              "subcategories": []
            },
            {
              "id": "compaction-rollers-dynapac-ca55",
              "name": "CA55",
              "subcategories": []
            },
            {
              "id": "compaction-rollers-dynapac-ca121",
              "name": "CA121",
              "subcategories": []
            },
            {
              "id": "compaction-rollers-dynapac-ca134",
              "name": "CA134",
              "subcategories": []
            },
            {
              "id": "compaction-rollers-dynapac-ca150",
              "name": "CA150",
              "subcategories": []
            },
            {
              "id": "compaction-rollers-dynapac-ca151",
              "name": "CA151",
              "subcategories": []
            },
            {
              "id": "compaction-rollers-dynapac-ca152",
              "name": "CA152",
              "subcategories": []
            },
            {
              "id": "compaction-rollers-dynapac-ca250",
              "name": "CA250",
              "subcategories": []
            },
            {
              "id": "compaction-rollers-dynapac-ca251",
              "name": "CA251",
              "subcategories": []
            },
            {
              "id": "compaction-rollers-dynapac-ca252",
              "name": "CA252",
              "subcategories": []
            },
            {
              "id": "compaction-rollers-dynapac-ca255",
              "name": "CA255",
              "subcategories": []
            },
            {
              "id": "compaction-rollers-dynapac-ca260",
              "name": "CA260",
              "subcategories": []
            },
            {
              "id": "compaction-rollers-dynapac-ca262",
              "name": "CA262",
              "subcategories": []
            },
            {
              "id": "compaction-rollers-dynapac-ca301",
              "name": "CA301",
              "subcategories": []
            },
            {
              "id": "compaction-rollers-dynapac-ca302",
              "name": "CA302",
              "subcategories": []
            },
            {
              "id": "compaction-rollers-dynapac-ca305",
              "name": "CA305",
              "subcategories": []
            },
            {
              "id": "compaction-rollers-dynapac-ca362",
              "name": "CA362",
              "subcategories": []
            },
            {
              "id": "compaction-rollers-dynapac-ca511",
              "name": "CA511",
              "subcategories": []
            },
            {
              "id": "compaction-rollers-dynapac-ca512",
              "name": "CA512",
              "subcategories": []
            },
            {
              "id": "compaction-rollers-dynapac-ca602",
              "name": "CA602",
              "subcategories": []
            },
            {
              "id": "compaction-rollers-dynapac-ca612",
              "name": "CA612",
              "subcategories": []
            },
            {
              "id": "compaction-rollers-dynapac-ca1300",
              "name": "CA1300",
              "subcategories": []
            },
            {
              "id": "compaction-rollers-dynapac-ca1400",
              "name": "CA1400",
              "subcategories": []
            },
            {
              "id": "compaction-rollers-dynapac-ca1500",
              "name": "CA1500",
              "subcategories": []
            },
            {
              "id": "compaction-rollers-dynapac-ca2500",
              "name": "CA2500",
              "subcategories": []
            },
            {
              "id": "compaction-rollers-dynapac-ca2800",
              "name": "CA2800",
              "subcategories": []
            },
            {
              "id": "compaction-rollers-dynapac-ca3500",
              "name": "CA3500",
              "subcategories": []
            },
            {
              "id": "compaction-rollers-dynapac-ca4000",
              "name": "CA4000",
              "subcategories": []
            },
            {
              "id": "compaction-rollers-dynapac-ca4600",
              "name": "CA4600",
              "subcategories": []
            },
            {
              "id": "compaction-rollers-dynapac-ca5000",
              "name": "CA5000",
              "subcategories": []
            },
            {
              "id": "compaction-rollers-dynapac-ca6000",
              "name": "CA6000",
              "subcategories": []
            },
            {
              "id": "compaction-rollers-dynapac-ca6500",
              "name": "CA6500",
              "subcategories": []
            },
            {
              "id": "compaction-rollers-dynapac-cc41",
              "name": "CC41",
              "subcategories": []
            },
            {
              "id": "compaction-rollers-dynapac-cc42",
              "name": "CC42",
              "subcategories": []
            },
            {
              "id": "compaction-rollers-dynapac-cc50",
              "name": "CC50",
              "subcategories": []
            },
            {
              "id": "compaction-rollers-dynapac-cc82",
              "name": "CC82",
              "subcategories": []
            },
            {
              "id": "compaction-rollers-dynapac-cc92",
              "name": "CC92",
              "subcategories": []
            },
            {
              "id": "compaction-rollers-dynapac-cc101",
              "name": "CC101",
              "subcategories": []
            },
            {
              "id": "compaction-rollers-dynapac-cc122",
              "name": "CC122",
              "subcategories": []
            },
            {
              "id": "compaction-rollers-dynapac-cc125",
              "name": "CC125",
              "subcategories": []
            },
            {
              "id": "compaction-rollers-dynapac-cc142",
              "name": "CC142",
              "subcategories": []
            },
            {
              "id": "compaction-rollers-dynapac-cc143",
              "name": "CC143",
              "subcategories": []
            },
            {
              "id": "compaction-rollers-dynapac-cc211",
              "name": "CC211",
              "subcategories": []
            },
            {
              "id": "compaction-rollers-dynapac-cc222",
              "name": "CC222",
              "subcategories": []
            },
            {
              "id": "compaction-rollers-dynapac-cc224",
              "name": "CC224",
              "subcategories": []
            },
            {
              "id": "compaction-rollers-dynapac-cc232",
              "name": "CC232",
              "subcategories": []
            },
            {
              "id": "compaction-rollers-dynapac-cc234",
              "name": "CC234",
              "subcategories": []
            },
            {
              "id": "compaction-rollers-dynapac-cc322",
              "name": "CC322",
              "subcategories": []
            },
            {
              "id": "compaction-rollers-dynapac-cc384",
              "name": "CC384",
              "subcategories": []
            },
            {
              "id": "compaction-rollers-dynapac-cc412",
              "name": "CC412",
              "subcategories": []
            },
            {
              "id": "compaction-rollers-dynapac-cc421",
              "name": "CC421",
              "subcategories": []
            },
            {
              "id": "compaction-rollers-dynapac-cc422",
              "name": "CC422",
              "subcategories": []
            },
            {
              "id": "compaction-rollers-dynapac-cc424",
              "name": "CC424",
              "subcategories": []
            },
            {
              "id": "compaction-rollers-dynapac-cc425",
              "name": "CC425",
              "subcategories": []
            },
            {
              "id": "compaction-rollers-dynapac-cc501",
              "name": "CC501",
              "subcategories": []
            },
            {
              "id": "compaction-rollers-dynapac-cc522",
              "name": "CC522",
              "subcategories": []
            },
            {
              "id": "compaction-rollers-dynapac-cc524",
              "name": "CC524",
              "subcategories": []
            },
            {
              "id": "compaction-rollers-dynapac-cc622",
              "name": "CC622",
              "subcategories": []
            },
            {
              "id": "compaction-rollers-dynapac-cc722",
              "name": "CC722",
              "subcategories": []
            },
            {
              "id": "compaction-rollers-dynapac-cc800",
              "name": "CC800",
              "subcategories": []
            },
            {
              "id": "compaction-rollers-dynapac-cc900",
              "name": "CC900",
              "subcategories": []
            },
            {
              "id": "compaction-rollers-dynapac-cc950",
              "name": "CC950",
              "subcategories": []
            },
            {
              "id": "compaction-rollers-dynapac-cc1000",
              "name": "CC1000",
              "subcategories": []
            },
            {
              "id": "compaction-rollers-dynapac-cc1100",
              "name": "CC1100",
              "subcategories": []
            },
            {
              "id": "compaction-rollers-dynapac-cc1200",
              "name": "CC1200",
              "subcategories": []
            },
            {
              "id": "compaction-rollers-dynapac-cc1300",
              "name": "CC1300",
              "subcategories": []
            },
            {
              "id": "compaction-rollers-dynapac-cc1400",
              "name": "CC1400",
              "subcategories": []
            },
            {
              "id": "compaction-rollers-dynapac-cc2200",
              "name": "CC2200",
              "subcategories": []
            },
            {
              "id": "compaction-rollers-dynapac-cc2300",
              "name": "CC2300",
              "subcategories": []
            },
            {
              "id": "compaction-rollers-dynapac-cc3200",
              "name": "CC3200",
              "subcategories": []
            },
            {
              "id": "compaction-rollers-dynapac-cc4200",
              "name": "CC4200",
              "subcategories": []
            },
            {
              "id": "compaction-rollers-dynapac-cc5200",
              "name": "CC5200",
              "subcategories": []
            },
            {
              "id": "compaction-rollers-dynapac-cc6200",
              "name": "CC6200",
              "subcategories": []
            },
            {
              "id": "compaction-rollers-dynapac-cc7200",
              "name": "CC7200",
              "subcategories": []
            },
            {
              "id": "compaction-rollers-dynapac-co4200",
              "name": "CO4200",
              "subcategories": []
            },
            {
              "id": "compaction-rollers-dynapac-co5200",
              "name": "CO5200",
              "subcategories": []
            },
            {
              "id": "compaction-rollers-dynapac-cp132",
              "name": "CP132",
              "subcategories": []
            },
            {
              "id": "compaction-rollers-dynapac-cp142",
              "name": "CP142",
              "subcategories": []
            },
            {
              "id": "compaction-rollers-dynapac-cp215",
              "name": "CP215",
              "subcategories": []
            },
            {
              "id": "compaction-rollers-dynapac-cp221",
              "name": "CP221",
              "subcategories": []
            },
            {
              "id": "compaction-rollers-dynapac-cp224",
              "name": "CP224",
              "subcategories": []
            },
            {
              "id": "compaction-rollers-dynapac-cp271",
              "name": "CP271",
              "subcategories": []
            },
            {
              "id": "compaction-rollers-dynapac-cp274",
              "name": "CP274",
              "subcategories": []
            },
            {
              "id": "compaction-rollers-dynapac-cp1200",
              "name": "CP1200",
              "subcategories": []
            },
            {
              "id": "compaction-rollers-dynapac-cp2100",
              "name": "CP2100",
              "subcategories": []
            },
            {
              "id": "compaction-rollers-dynapac-cp2700",
              "name": "CP2700",
              "subcategories": []
            },
            {
              "id": "compaction-rollers-dynapac-cs12",
              "name": "CS12",
              "subcategories": []
            },
            {
              "id": "compaction-rollers-dynapac-cs141",
              "name": "CS141",
              "subcategories": []
            },
            {
              "id": "compaction-rollers-dynapac-cs142",
              "name": "CS142",
              "subcategories": []
            },
            {
              "id": "compaction-rollers-dynapac-ct25",
              "name": "CT25",
              "subcategories": []
            },
            {
              "id": "compaction-rollers-dynapac-ct260",
              "name": "CT260",
              "subcategories": []
            },
            {
              "id": "compaction-rollers-dynapac-ct262",
              "name": "CT262",
              "subcategories": []
            },
            {
              "id": "compaction-rollers-dynapac-ct3000",
              "name": "CT3000",
              "subcategories": []
            },
            {
              "id": "compaction-rollers-dynapac-d-one",
              "name": "D.ONE",
              "subcategories": []
            },
            {
              "id": "compaction-rollers-dynapac-dfp7",
              "name": "DFP7",
              "subcategories": []
            },
            {
              "id": "compaction-rollers-dynapac-dfp9",
              "name": "DFP9",
              "subcategories": []
            },
            {
              "id": "compaction-rollers-dynapac-dfp10",
              "name": "DFP10",
              "subcategories": []
            },
            {
              "id": "compaction-rollers-dynapac-dr6",
              "name": "DR6",
              "subcategories": []
            },
            {
              "id": "compaction-rollers-dynapac-dr7",
              "name": "DR7",
              "subcategories": []
            },
            {
              "id": "compaction-rollers-dynapac-drp25",
              "name": "DRP25",
              "subcategories": []
            },
            {
              "id": "compaction-rollers-dynapac-drp45",
              "name": "DRP45",
              "subcategories": []
            },
            {
              "id": "compaction-rollers-dynapac-drp60",
              "name": "DRP60",
              "subcategories": []
            },
            {
              "id": "compaction-rollers-dynapac-drp70",
              "name": "DRP70",
              "subcategories": []
            },
            {
              "id": "compaction-rollers-dynapac-drq15",
              "name": "DRQ15",
              "subcategories": []
            },
            {
              "id": "compaction-rollers-dynapac-lf70",
              "name": "LF70",
              "subcategories": []
            },
            {
              "id": "compaction-rollers-dynapac-lg200",
              "name": "LG200",
              "subcategories": []
            },
            {
              "id": "compaction-rollers-dynapac-lg500",
              "name": "LG500",
              "subcategories": []
            },
            {
              "id": "compaction-rollers-dynapac-lp750",
              "name": "LP750",
              "subcategories": []
            },
            {
              "id": "compaction-rollers-dynapac-lp8500",
              "name": "LP8500",
              "subcategories": []
            },
            {
              "id": "compaction-rollers-dynapac-sr130",
              "name": "SR130",
              "subcategories": []
            },
            {
              "id": "compaction-rollers-dynapac-other",
              "name": "OTHER",
              "subcategories": []
            }
          ]
        },
        {
          "id": "compaction-rollers-wacker-nueson",
          "name": "Wacker Nueson",
          "subcategories": [
            {
              "id": "compaction-rollers-wacker-nueson-ap1840",
              "name": "AP1840",
              "subcategories": []
            },
            {
              "id": "compaction-rollers-wacker-nueson-ap1850",
              "name": "AP1850",
              "subcategories": []
            },
            {
              "id": "compaction-rollers-wacker-nueson-aps",
              "name": "APS",
              "subcategories": []
            },
            {
              "id": "compaction-rollers-wacker-nueson-apu3050",
              "name": "APU3050",
              "subcategories": []
            },
            {
              "id": "compaction-rollers-wacker-nueson-as50",
              "name": "AS50",
              "subcategories": []
            },
            {
              "id": "compaction-rollers-wacker-nueson-as60",
              "name": "AS60",
              "subcategories": []
            },
            {
              "id": "compaction-rollers-wacker-nueson-bps1030",
              "name": "BPS1030",
              "subcategories": []
            },
            {
              "id": "compaction-rollers-wacker-nueson-bps1135",
              "name": "BPS1135",
              "subcategories": []
            },
            {
              "id": "compaction-rollers-wacker-nueson-bps1340",
              "name": "BPS1340",
              "subcategories": []
            },
            {
              "id": "compaction-rollers-wacker-nueson-bps1550",
              "name": "BPS1550",
              "subcategories": []
            },
            {
              "id": "compaction-rollers-wacker-nueson-bpu2540",
              "name": "BPU2540",
              "subcategories": []
            },
            {
              "id": "compaction-rollers-wacker-nueson-bpu3050",
              "name": "BPU3050",
              "subcategories": []
            },
            {
              "id": "compaction-rollers-wacker-nueson-bpu3750",
              "name": "BPU3750",
              "subcategories": []
            },
            {
              "id": "compaction-rollers-wacker-nueson-bpu4045",
              "name": "BPU4045",
              "subcategories": []
            },
            {
              "id": "compaction-rollers-wacker-nueson-bpu5260",
              "name": "BPU5260",
              "subcategories": []
            },
            {
              "id": "compaction-rollers-wacker-nueson-bpu5545",
              "name": "BPU5545",
              "subcategories": []
            },
            {
              "id": "compaction-rollers-wacker-nueson-bs50",
              "name": "BS50",
              "subcategories": []
            },
            {
              "id": "compaction-rollers-wacker-nueson-bs60",
              "name": "BS60",
              "subcategories": []
            },
            {
              "id": "compaction-rollers-wacker-nueson-bs62",
              "name": "BS62",
              "subcategories": []
            },
            {
              "id": "compaction-rollers-wacker-nueson-bs68",
              "name": "BS68",
              "subcategories": []
            },
            {
              "id": "compaction-rollers-wacker-nueson-bs70",
              "name": "BS70",
              "subcategories": []
            },
            {
              "id": "compaction-rollers-wacker-nueson-dpu40",
              "name": "DPU40",
              "subcategories": []
            },
            {
              "id": "compaction-rollers-wacker-nueson-dpu45",
              "name": "DPU45",
              "subcategories": []
            },
            {
              "id": "compaction-rollers-wacker-nueson-dpu80",
              "name": "DPU80",
              "subcategories": []
            },
            {
              "id": "compaction-rollers-wacker-nueson-dpu90",
              "name": "DPU90",
              "subcategories": []
            },
            {
              "id": "compaction-rollers-wacker-nueson-dpu100",
              "name": "DPU100",
              "subcategories": []
            },
            {
              "id": "compaction-rollers-wacker-nueson-dpu110",
              "name": "DPU110",
              "subcategories": []
            },
            {
              "id": "compaction-rollers-wacker-nueson-dpu130",
              "name": "DPU130",
              "subcategories": []
            },
            {
              "id": "compaction-rollers-wacker-nueson-dpu2950",
              "name": "DPU2950",
              "subcategories": []
            },
            {
              "id": "compaction-rollers-wacker-nueson-dpu3050",
              "name": "DPU3050",
              "subcategories": []
            },
            {
              "id": "compaction-rollers-wacker-nueson-dpu4045",
              "name": "DPU4045",
              "subcategories": []
            },
            {
              "id": "compaction-rollers-wacker-nueson-dpu4545",
              "name": "DPU4545",
              "subcategories": []
            },
            {
              "id": "compaction-rollers-wacker-nueson-dpu5545",
              "name": "DPU5545",
              "subcategories": []
            },
            {
              "id": "compaction-rollers-wacker-nueson-dpu6055",
              "name": "DPU6055",
              "subcategories": []
            },
            {
              "id": "compaction-rollers-wacker-nueson-dpu6555",
              "name": "DPU6555",
              "subcategories": []
            },
            {
              "id": "compaction-rollers-wacker-nueson-rc50",
              "name": "RC50",
              "subcategories": []
            },
            {
              "id": "compaction-rollers-wacker-nueson-rc70",
              "name": "RC70",
              "subcategories": []
            },
            {
              "id": "compaction-rollers-wacker-nueson-rc110",
              "name": "RC110",
              "subcategories": []
            },
            {
              "id": "compaction-rollers-wacker-nueson-rd7",
              "name": "RD7",
              "subcategories": []
            },
            {
              "id": "compaction-rollers-wacker-nueson-rd11",
              "name": "RD11",
              "subcategories": []
            },
            {
              "id": "compaction-rollers-wacker-nueson-rd12",
              "name": "RD12",
              "subcategories": []
            },
            {
              "id": "compaction-rollers-wacker-nueson-rd12",
              "name": "RD12",
              "subcategories": []
            },
            {
              "id": "compaction-rollers-wacker-nueson-rd16",
              "name": "RD16",
              "subcategories": []
            },
            {
              "id": "compaction-rollers-wacker-nueson-rd18",
              "name": "RD18",
              "subcategories": []
            },
            {
              "id": "compaction-rollers-wacker-nueson-rd24",
              "name": "RD24",
              "subcategories": []
            },
            {
              "id": "compaction-rollers-wacker-nueson-rd25",
              "name": "RD25",
              "subcategories": []
            },
            {
              "id": "compaction-rollers-wacker-nueson-rd27",
              "name": "RD27",
              "subcategories": []
            },
            {
              "id": "compaction-rollers-wacker-nueson-rd28",
              "name": "RD28",
              "subcategories": []
            },
            {
              "id": "compaction-rollers-wacker-nueson-rd40",
              "name": "RD40",
              "subcategories": []
            },
            {
              "id": "compaction-rollers-wacker-nueson-rd45",
              "name": "RD45",
              "subcategories": []
            },
            {
              "id": "compaction-rollers-wacker-nueson-rd880",
              "name": "RD880",
              "subcategories": []
            },
            {
              "id": "compaction-rollers-wacker-nueson-rt",
              "name": "RT",
              "subcategories": []
            },
            {
              "id": "compaction-rollers-wacker-nueson-rt560",
              "name": "RT560",
              "subcategories": []
            },
            {
              "id": "compaction-rollers-wacker-nueson-rt820",
              "name": "RT820",
              "subcategories": []
            },
            {
              "id": "compaction-rollers-wacker-nueson-rt825",
              "name": "RT825",
              "subcategories": []
            },
            {
              "id": "compaction-rollers-wacker-nueson-rtdsc4",
              "name": "RTDSC4",
              "subcategories": []
            },
            {
              "id": "compaction-rollers-wacker-nueson-rtsc",
              "name": "RTSC",
              "subcategories": []
            },
            {
              "id": "compaction-rollers-wacker-nueson-rtx",
              "name": "RTX",
              "subcategories": []
            },
            {
              "id": "compaction-rollers-wacker-nueson-rw25",
              "name": "RW25",
              "subcategories": []
            },
            {
              "id": "compaction-rollers-wacker-nueson-vp1135",
              "name": "VP1135",
              "subcategories": []
            },
            {
              "id": "compaction-rollers-wacker-nueson-vp1550",
              "name": "VP1550",
              "subcategories": []
            },
            {
              "id": "compaction-rollers-wacker-nueson-vp2050",
              "name": "VP2050",
              "subcategories": []
            },
            {
              "id": "compaction-rollers-wacker-nueson-w65",
              "name": "W65",
              "subcategories": []
            },
            {
              "id": "compaction-rollers-wacker-nueson-wp1550",
              "name": "WP1550",
              "subcategories": []
            },
            {
              "id": "compaction-rollers-wacker-nueson-wpu1550",
              "name": "WPU1550",
              "subcategories": []
            },
            {
              "id": "compaction-rollers-wacker-nueson-other",
              "name": "OTHER",
              "subcategories": []
            }
          ]
        },
        {
          "id": "compaction-rollers-volvo",
          "name": "Volvo",
          "subcategories": [
            {
              "id": "compaction-rollers-volvo-cr30",
              "name": "CR30",
              "subcategories": []
            },
            {
              "id": "compaction-rollers-volvo-cr35",
              "name": "CR35",
              "subcategories": []
            },
            {
              "id": "compaction-rollers-volvo-dd15",
              "name": "DD15",
              "subcategories": []
            },
            {
              "id": "compaction-rollers-volvo-dd16",
              "name": "DD16",
              "subcategories": []
            },
            {
              "id": "compaction-rollers-volvo-dd22",
              "name": "DD22",
              "subcategories": []
            },
            {
              "id": "compaction-rollers-volvo-dd24",
              "name": "DD24",
              "subcategories": []
            },
            {
              "id": "compaction-rollers-volvo-dd25",
              "name": "DD25",
              "subcategories": []
            },
            {
              "id": "compaction-rollers-volvo-dd29",
              "name": "DD29",
              "subcategories": []
            },
            {
              "id": "compaction-rollers-volvo-dd30",
              "name": "DD30",
              "subcategories": []
            },
            {
              "id": "compaction-rollers-volvo-dd31",
              "name": "DD31",
              "subcategories": []
            },
            {
              "id": "compaction-rollers-volvo-dd35",
              "name": "DD35",
              "subcategories": []
            },
            {
              "id": "compaction-rollers-volvo-dd70",
              "name": "DD70",
              "subcategories": []
            },
            {
              "id": "compaction-rollers-volvo-dd90",
              "name": "DD90",
              "subcategories": []
            },
            {
              "id": "compaction-rollers-volvo-dd105",
              "name": "DD105",
              "subcategories": []
            },
            {
              "id": "compaction-rollers-volvo-dd110",
              "name": "DD110",
              "subcategories": []
            },
            {
              "id": "compaction-rollers-volvo-dd112",
              "name": "DD112",
              "subcategories": []
            },
            {
              "id": "compaction-rollers-volvo-dd118",
              "name": "DD118",
              "subcategories": []
            },
            {
              "id": "compaction-rollers-volvo-dd120",
              "name": "DD120",
              "subcategories": []
            },
            {
              "id": "compaction-rollers-volvo-dd128",
              "name": "DD128",
              "subcategories": []
            },
            {
              "id": "compaction-rollers-volvo-dd132",
              "name": "DD132",
              "subcategories": []
            },
            {
              "id": "compaction-rollers-volvo-dd138",
              "name": "DD138",
              "subcategories": []
            },
            {
              "id": "compaction-rollers-volvo-dd140",
              "name": "DD140",
              "subcategories": []
            },
            {
              "id": "compaction-rollers-volvo-lc450",
              "name": "LC450",
              "subcategories": []
            },
            {
              "id": "compaction-rollers-volvo-pt125",
              "name": "PT125",
              "subcategories": []
            },
            {
              "id": "compaction-rollers-volvo-pt240",
              "name": "PT240",
              "subcategories": []
            },
            {
              "id": "compaction-rollers-volvo-sd25",
              "name": "SD25",
              "subcategories": []
            },
            {
              "id": "compaction-rollers-volvo-sd45",
              "name": "SD45",
              "subcategories": []
            },
            {
              "id": "compaction-rollers-volvo-sd70",
              "name": "SD70",
              "subcategories": []
            },
            {
              "id": "compaction-rollers-volvo-sd75",
              "name": "SD75",
              "subcategories": []
            },
            {
              "id": "compaction-rollers-volvo-sd77",
              "name": "SD77",
              "subcategories": []
            },
            {
              "id": "compaction-rollers-volvo-sd100",
              "name": "SD100",
              "subcategories": []
            },
            {
              "id": "compaction-rollers-volvo-sd105",
              "name": "SD105",
              "subcategories": []
            },
            {
              "id": "compaction-rollers-volvo-sd110",
              "name": "SD110",
              "subcategories": []
            },
            {
              "id": "compaction-rollers-volvo-sd115",
              "name": "SD115",
              "subcategories": []
            },
            {
              "id": "compaction-rollers-volvo-sd116",
              "name": "SD116",
              "subcategories": []
            },
            {
              "id": "compaction-rollers-volvo-sd122",
              "name": "SD122",
              "subcategories": []
            },
            {
              "id": "compaction-rollers-volvo-sd135",
              "name": "SD135",
              "subcategories": []
            },
            {
              "id": "compaction-rollers-volvo-sd160",
              "name": "SD160",
              "subcategories": []
            },
            {
              "id": "compaction-rollers-volvo-sd200",
              "name": "SD200",
              "subcategories": []
            },
            {
              "id": "compaction-rollers-volvo-other",
              "name": "OTHER",
              "subcategories": []
            }
          ]
        },
        {
          "id": "compaction-rollers-sakai",
          "name": "Sakai",
          "subcategories": [
            {
              "id": "compaction-rollers-sakai-cr270",
              "name": "CR270",
              "subcategories": []
            },
            {
              "id": "compaction-rollers-sakai-cr271",
              "name": "CR271",
              "subcategories": []
            },
            {
              "id": "compaction-rollers-sakai-cv550",
              "name": "CV550",
              "subcategories": []
            },
            {
              "id": "compaction-rollers-sakai-gw750",
              "name": "GW750",
              "subcategories": []
            },
            {
              "id": "compaction-rollers-sakai-gw751",
              "name": "GW751",
              "subcategories": []
            },
            {
              "id": "compaction-rollers-sakai-gw754",
              "name": "GW754",
              "subcategories": []
            },
            {
              "id": "compaction-rollers-sakai-hd67",
              "name": "HD67",
              "subcategories": []
            },
            {
              "id": "compaction-rollers-sakai-pc600",
              "name": "PC600",
              "subcategories": []
            },
            {
              "id": "compaction-rollers-sakai-pc800",
              "name": "PC800",
              "subcategories": []
            },
            {
              "id": "compaction-rollers-sakai-pf150",
              "name": "PF150",
              "subcategories": []
            },
            {
              "id": "compaction-rollers-sakai-r2",
              "name": "R2",
              "subcategories": []
            },
            {
              "id": "compaction-rollers-sakai-rs65",
              "name": "RS65",
              "subcategories": []
            },
            {
              "id": "compaction-rollers-sakai-rs75",
              "name": "RS75",
              "subcategories": []
            },
            {
              "id": "compaction-rollers-sakai-sa33",
              "name": "SA33",
              "subcategories": []
            },
            {
              "id": "compaction-rollers-sakai-sv70",
              "name": "SV70",
              "subcategories": []
            },
            {
              "id": "compaction-rollers-sakai-sv91",
              "name": "SV91",
              "subcategories": []
            },
            {
              "id": "compaction-rollers-sakai-sv201",
              "name": "SV201",
              "subcategories": []
            },
            {
              "id": "compaction-rollers-sakai-sv204",
              "name": "SV204",
              "subcategories": []
            },
            {
              "id": "compaction-rollers-sakai-sv400",
              "name": "SV400",
              "subcategories": []
            },
            {
              "id": "compaction-rollers-sakai-sv410",
              "name": "SV410",
              "subcategories": []
            },
            {
              "id": "compaction-rollers-sakai-sv412",
              "name": "SV412",
              "subcategories": []
            },
            {
              "id": "compaction-rollers-sakai-sv414",
              "name": "SV414",
              "subcategories": []
            },
            {
              "id": "compaction-rollers-sakai-sv500",
              "name": "SV500",
              "subcategories": []
            },
            {
              "id": "compaction-rollers-sakai-sv505",
              "name": "SV505",
              "subcategories": []
            },
            {
              "id": "compaction-rollers-sakai-sv510",
              "name": "SV510",
              "subcategories": []
            },
            {
              "id": "compaction-rollers-sakai-sv513",
              "name": "SV513",
              "subcategories": []
            },
            {
              "id": "compaction-rollers-sakai-sv540",
              "name": "SV540",
              "subcategories": []
            },
            {
              "id": "compaction-rollers-sakai-sv544",
              "name": "SV544",
              "subcategories": []
            },
            {
              "id": "compaction-rollers-sakai-sv640",
              "name": "SV640",
              "subcategories": []
            },
            {
              "id": "compaction-rollers-sakai-sw250",
              "name": "SW250",
              "subcategories": []
            },
            {
              "id": "compaction-rollers-sakai-sw320",
              "name": "SW320",
              "subcategories": []
            },
            {
              "id": "compaction-rollers-sakai-sw330",
              "name": "SW330",
              "subcategories": []
            },
            {
              "id": "compaction-rollers-sakai-sw352",
              "name": "SW352",
              "subcategories": []
            },
            {
              "id": "compaction-rollers-sakai-sw354",
              "name": "SW354",
              "subcategories": []
            },
            {
              "id": "compaction-rollers-sakai-sw502",
              "name": "SW502",
              "subcategories": []
            },
            {
              "id": "compaction-rollers-sakai-sw504",
              "name": "SW504",
              "subcategories": []
            },
            {
              "id": "compaction-rollers-sakai-sw654",
              "name": "SW654",
              "subcategories": []
            },
            {
              "id": "compaction-rollers-sakai-sw770",
              "name": "SW770",
              "subcategories": []
            },
            {
              "id": "compaction-rollers-sakai-sw774",
              "name": "SW774",
              "subcategories": []
            },
            {
              "id": "compaction-rollers-sakai-sw800",
              "name": "SW800",
              "subcategories": []
            },
            {
              "id": "compaction-rollers-sakai-sw850",
              "name": "SW850",
              "subcategories": []
            },
            {
              "id": "compaction-rollers-sakai-sw880",
              "name": "SW880",
              "subcategories": []
            },
            {
              "id": "compaction-rollers-sakai-sw884",
              "name": "SW884",
              "subcategories": []
            },
            {
              "id": "compaction-rollers-sakai-sw900",
              "name": "SW900",
              "subcategories": []
            },
            {
              "id": "compaction-rollers-sakai-sw990",
              "name": "SW990",
              "subcategories": []
            },
            {
              "id": "compaction-rollers-sakai-sw994",
              "name": "SW994",
              "subcategories": []
            },
            {
              "id": "compaction-rollers-sakai-t2",
              "name": "T2",
              "subcategories": []
            },
            {
              "id": "compaction-rollers-sakai-ts31",
              "name": "TS31",
              "subcategories": []
            },
            {
              "id": "compaction-rollers-sakai-ts160",
              "name": "TS160",
              "subcategories": []
            },
            {
              "id": "compaction-rollers-sakai-ts200",
              "name": "TS200",
              "subcategories": []
            },
            {
              "id": "compaction-rollers-sakai-ts7409",
              "name": "TS7409",
              "subcategories": []
            },
            {
              "id": "compaction-rollers-sakai-tw70",
              "name": "TW70",
              "subcategories": []
            },
            {
              "id": "compaction-rollers-sakai-tw100",
              "name": "TW100",
              "subcategories": []
            },
            {
              "id": "compaction-rollers-sakai-tw330",
              "name": "TW330",
              "subcategories": []
            },
            {
              "id": "compaction-rollers-sakai-tw354",
              "name": "TW354",
              "subcategories": []
            },
            {
              "id": "compaction-rollers-sakai-tw500",
              "name": "TW500",
              "subcategories": []
            },
            {
              "id": "compaction-rollers-sakai-tw504",
              "name": "TW504",
              "subcategories": []
            },
            {
              "id": "compaction-rollers-sakai-other",
              "name": "OTHER",
              "subcategories": []
            }
          ]
        },
        {
          "id": "compaction-rollers-ammann",
          "name": "Ammann",
          "subcategories": [
            {
              "id": "compaction-rollers-ammann-ac90",
              "name": "AC90",
              "subcategories": []
            },
            {
              "id": "compaction-rollers-ammann-acr68",
              "name": "ACR68",
              "subcategories": []
            },
            {
              "id": "compaction-rollers-ammann-acr70",
              "name": "ACR70",
              "subcategories": []
            },
            {
              "id": "compaction-rollers-ammann-ap240",
              "name": "AP240",
              "subcategories": []
            },
            {
              "id": "compaction-rollers-ammann-apf1033",
              "name": "APF1033",
              "subcategories": []
            },
            {
              "id": "compaction-rollers-ammann-apf1240",
              "name": "APF1240",
              "subcategories": []
            },
            {
              "id": "compaction-rollers-ammann-apf1540",
              "name": "APF1540",
              "subcategories": []
            },
            {
              "id": "compaction-rollers-ammann-apf1550",
              "name": "APF1550",
              "subcategories": []
            },
            {
              "id": "compaction-rollers-ammann-apf2050",
              "name": "APF2050",
              "subcategories": []
            },
            {
              "id": "compaction-rollers-ammann-aph5020",
              "name": "APH5020",
              "subcategories": []
            },
            {
              "id": "compaction-rollers-ammann-aph5030",
              "name": "APH5030",
              "subcategories": []
            },
            {
              "id": "compaction-rollers-ammann-aph6530",
              "name": "APH6530",
              "subcategories": []
            },
            {
              "id": "compaction-rollers-ammann-aph6585",
              "name": "APH6585",
              "subcategories": []
            },
            {
              "id": "compaction-rollers-ammann-apr2240",
              "name": "APR2240",
              "subcategories": []
            },
            {
              "id": "compaction-rollers-ammann-apr2550",
              "name": "APR2550",
              "subcategories": []
            },
            {
              "id": "compaction-rollers-ammann-apr3020",
              "name": "APR3020",
              "subcategories": []
            },
            {
              "id": "compaction-rollers-ammann-apr3050",
              "name": "APR3050",
              "subcategories": []
            },
            {
              "id": "compaction-rollers-ammann-apr3060",
              "name": "APR3060",
              "subcategories": []
            },
            {
              "id": "compaction-rollers-ammann-apr4920",
              "name": "APR4920",
              "subcategories": []
            },
            {
              "id": "compaction-rollers-ammann-apr5920",
              "name": "APR5920",
              "subcategories": []
            },
            {
              "id": "compaction-rollers-ammann-arp95",
              "name": "ARP95",
              "subcategories": []
            },
            {
              "id": "compaction-rollers-ammann-arr1575",
              "name": "ARR1575",
              "subcategories": []
            },
            {
              "id": "compaction-rollers-ammann-arr1585",
              "name": "ARR1585",
              "subcategories": []
            },
            {
              "id": "compaction-rollers-ammann-ars30",
              "name": "ARS30",
              "subcategories": []
            },
            {
              "id": "compaction-rollers-ammann-ars50",
              "name": "ARS50",
              "subcategories": []
            },
            {
              "id": "compaction-rollers-ammann-ars70",
              "name": "ARS70",
              "subcategories": []
            },
            {
              "id": "compaction-rollers-ammann-ars110",
              "name": "ARS110",
              "subcategories": []
            },
            {
              "id": "compaction-rollers-ammann-ars110-2",
              "name": "ARS110.2",
              "subcategories": []
            },
            {
              "id": "compaction-rollers-ammann-ars122",
              "name": "ARS122",
              "subcategories": []
            },
            {
              "id": "compaction-rollers-ammann-ars130",
              "name": "ARS130",
              "subcategories": []
            },
            {
              "id": "compaction-rollers-ammann-ars200",
              "name": "ARS200",
              "subcategories": []
            },
            {
              "id": "compaction-rollers-ammann-art35",
              "name": "ART35",
              "subcategories": []
            },
            {
              "id": "compaction-rollers-ammann-art240",
              "name": "ART240",
              "subcategories": []
            },
            {
              "id": "compaction-rollers-ammann-art280",
              "name": "ART280",
              "subcategories": []
            },
            {
              "id": "compaction-rollers-ammann-arw65",
              "name": "ARW65",
              "subcategories": []
            },
            {
              "id": "compaction-rollers-ammann-arx10-1",
              "name": "ARX10.1",
              "subcategories": []
            },
            {
              "id": "compaction-rollers-ammann-arx12",
              "name": "ARX12",
              "subcategories": []
            },
            {
              "id": "compaction-rollers-ammann-arx16",
              "name": "ARX16",
              "subcategories": []
            },
            {
              "id": "compaction-rollers-ammann-arx20",
              "name": "ARX20",
              "subcategories": []
            },
            {
              "id": "compaction-rollers-ammann-arx23",
              "name": "ARX23",
              "subcategories": []
            },
            {
              "id": "compaction-rollers-ammann-arx26",
              "name": "ARX26",
              "subcategories": []
            },
            {
              "id": "compaction-rollers-ammann-arx36",
              "name": "ARX36",
              "subcategories": []
            },
            {
              "id": "compaction-rollers-ammann-arx40",
              "name": "ARX40",
              "subcategories": []
            },
            {
              "id": "compaction-rollers-ammann-arx45",
              "name": "ARX45",
              "subcategories": []
            },
            {
              "id": "compaction-rollers-ammann-arx90",
              "name": "ARX90",
              "subcategories": []
            },
            {
              "id": "compaction-rollers-ammann-arx140",
              "name": "ARX140",
              "subcategories": []
            },
            {
              "id": "compaction-rollers-ammann-asc30",
              "name": "ASC30",
              "subcategories": []
            },
            {
              "id": "compaction-rollers-ammann-asc70",
              "name": "ASC70",
              "subcategories": []
            },
            {
              "id": "compaction-rollers-ammann-asc100",
              "name": "ASC100",
              "subcategories": []
            },
            {
              "id": "compaction-rollers-ammann-asc110",
              "name": "ASC110",
              "subcategories": []
            },
            {
              "id": "compaction-rollers-ammann-asc130",
              "name": "ASC130",
              "subcategories": []
            },
            {
              "id": "compaction-rollers-ammann-asc150",
              "name": "ASC150",
              "subcategories": []
            },
            {
              "id": "compaction-rollers-ammann-asc200",
              "name": "ASC200",
              "subcategories": []
            },
            {
              "id": "compaction-rollers-ammann-atr60",
              "name": "ATR60",
              "subcategories": []
            },
            {
              "id": "compaction-rollers-ammann-atr68",
              "name": "ATR68",
              "subcategories": []
            },
            {
              "id": "compaction-rollers-ammann-av12",
              "name": "AV12",
              "subcategories": []
            },
            {
              "id": "compaction-rollers-ammann-av16",
              "name": "AV16",
              "subcategories": []
            },
            {
              "id": "compaction-rollers-ammann-av26",
              "name": "AV26",
              "subcategories": []
            },
            {
              "id": "compaction-rollers-ammann-av70",
              "name": "AV70",
              "subcategories": []
            },
            {
              "id": "compaction-rollers-ammann-av85",
              "name": "AV85",
              "subcategories": []
            },
            {
              "id": "compaction-rollers-ammann-av95",
              "name": "AV95",
              "subcategories": []
            },
            {
              "id": "compaction-rollers-ammann-av130",
              "name": "AV130",
              "subcategories": []
            },
            {
              "id": "compaction-rollers-ammann-avh5020",
              "name": "AVH5020",
              "subcategories": []
            },
            {
              "id": "compaction-rollers-ammann-avp1240",
              "name": "AVP1240",
              "subcategories": []
            },
            {
              "id": "compaction-rollers-ammann-avp1850",
              "name": "AVP1850",
              "subcategories": []
            },
            {
              "id": "compaction-rollers-ammann-dt200",
              "name": "DT200",
              "subcategories": []
            },
            {
              "id": "compaction-rollers-ammann-dtv143",
              "name": "DTV143",
              "subcategories": []
            },
            {
              "id": "compaction-rollers-ammann-dtv903",
              "name": "DTV903",
              "subcategories": []
            },
            {
              "id": "compaction-rollers-ammann-earx26-2",
              "name": "EARX26-2",
              "subcategories": []
            },
            {
              "id": "compaction-rollers-ammann-rw1800",
              "name": "RW1800",
              "subcategories": []
            },
            {
              "id": "compaction-rollers-ammann-rammax",
              "name": "RAMMAX",
              "subcategories": []
            },
            {
              "id": "compaction-rollers-ammann-sv216",
              "name": "SV216",
              "subcategories": []
            },
            {
              "id": "compaction-rollers-ammann-vp2400",
              "name": "VP2400",
              "subcategories": []
            },
            {
              "id": "compaction-rollers-ammann-other",
              "name": "OTHER",
              "subcategories": []
            }
          ]
        },
        {
          "id": "compaction-rollers-xcmg",
          "name": "Xcmg",
          "subcategories": [
            {
              "id": "compaction-rollers-xcmg-2y103",
              "name": "2Y103",
              "subcategories": []
            },
            {
              "id": "compaction-rollers-xcmg-3y223",
              "name": "3Y223",
              "subcategories": []
            },
            {
              "id": "compaction-rollers-xcmg-3y252",
              "name": "3Y252",
              "subcategories": []
            },
            {
              "id": "compaction-rollers-xcmg-3y263",
              "name": "3Y263",
              "subcategories": []
            },
            {
              "id": "compaction-rollers-xcmg-cv83",
              "name": "CV83",
              "subcategories": []
            },
            {
              "id": "compaction-rollers-xcmg-cv122",
              "name": "CV122",
              "subcategories": []
            },
            {
              "id": "compaction-rollers-xcmg-cv123",
              "name": "CV123",
              "subcategories": []
            },
            {
              "id": "compaction-rollers-xcmg-xd80",
              "name": "XD80",
              "subcategories": []
            },
            {
              "id": "compaction-rollers-xcmg-xd83",
              "name": "XD83",
              "subcategories": []
            },
            {
              "id": "compaction-rollers-xcmg-xd90",
              "name": "XD90",
              "subcategories": []
            },
            {
              "id": "compaction-rollers-xcmg-xd100",
              "name": "XD100",
              "subcategories": []
            },
            {
              "id": "compaction-rollers-xcmg-xd103",
              "name": "XD103",
              "subcategories": []
            },
            {
              "id": "compaction-rollers-xcmg-xd120",
              "name": "XD120",
              "subcategories": []
            },
            {
              "id": "compaction-rollers-xcmg-xd130",
              "name": "XD130",
              "subcategories": []
            },
            {
              "id": "compaction-rollers-xcmg-xd133",
              "name": "XD133",
              "subcategories": []
            },
            {
              "id": "compaction-rollers-xcmg-xd140",
              "name": "XD140",
              "subcategories": []
            },
            {
              "id": "compaction-rollers-xcmg-xd143",
              "name": "XD143",
              "subcategories": []
            },
            {
              "id": "compaction-rollers-xcmg-xh283",
              "name": "XH283",
              "subcategories": []
            },
            {
              "id": "compaction-rollers-xcmg-xhmr170",
              "name": "XHMR170",
              "subcategories": []
            },
            {
              "id": "compaction-rollers-xcmg-xmr030",
              "name": "XMR030",
              "subcategories": []
            },
            {
              "id": "compaction-rollers-xcmg-xmr050",
              "name": "XMR050",
              "subcategories": []
            },
            {
              "id": "compaction-rollers-xcmg-xmr083",
              "name": "XMR083",
              "subcategories": []
            },
            {
              "id": "compaction-rollers-xcmg-xmr30",
              "name": "XMR30",
              "subcategories": []
            },
            {
              "id": "compaction-rollers-xcmg-xmr110",
              "name": "XMR110",
              "subcategories": []
            },
            {
              "id": "compaction-rollers-xcmg-xmr203",
              "name": "XMR203",
              "subcategories": []
            },
            {
              "id": "compaction-rollers-xcmg-xmr303",
              "name": "XMR303",
              "subcategories": []
            },
            {
              "id": "compaction-rollers-xcmg-xmr403",
              "name": "XMR403",
              "subcategories": []
            },
            {
              "id": "compaction-rollers-xcmg-xp163",
              "name": "XP163",
              "subcategories": []
            },
            {
              "id": "compaction-rollers-xcmg-xp165",
              "name": "XP165",
              "subcategories": []
            },
            {
              "id": "compaction-rollers-xcmg-xp263",
              "name": "XP263",
              "subcategories": []
            },
            {
              "id": "compaction-rollers-xcmg-xp265",
              "name": "XP265",
              "subcategories": []
            },
            {
              "id": "compaction-rollers-xcmg-xp301",
              "name": "XP301",
              "subcategories": []
            },
            {
              "id": "compaction-rollers-xcmg-xp302",
              "name": "XP302",
              "subcategories": []
            },
            {
              "id": "compaction-rollers-xcmg-xp303",
              "name": "XP303",
              "subcategories": []
            },
            {
              "id": "compaction-rollers-xcmg-xp305",
              "name": "XP305",
              "subcategories": []
            },
            {
              "id": "compaction-rollers-xcmg-xs83",
              "name": "XS83",
              "subcategories": []
            },
            {
              "id": "compaction-rollers-xcmg-xs103",
              "name": "XS103",
              "subcategories": []
            },
            {
              "id": "compaction-rollers-xcmg-xs113",
              "name": "XS113",
              "subcategories": []
            },
            {
              "id": "compaction-rollers-xcmg-xs115",
              "name": "XS115",
              "subcategories": []
            },
            {
              "id": "compaction-rollers-xcmg-xs123",
              "name": "XS123",
              "subcategories": []
            },
            {
              "id": "compaction-rollers-xcmg-xs125",
              "name": "XS125",
              "subcategories": []
            },
            {
              "id": "compaction-rollers-xcmg-xs143",
              "name": "XS143",
              "subcategories": []
            },
            {
              "id": "compaction-rollers-xcmg-xs163",
              "name": "XS163",
              "subcategories": []
            },
            {
              "id": "compaction-rollers-xcmg-xs165",
              "name": "XS165",
              "subcategories": []
            },
            {
              "id": "compaction-rollers-xcmg-xs183",
              "name": "XS183",
              "subcategories": []
            },
            {
              "id": "compaction-rollers-xcmg-xs185",
              "name": "XS185",
              "subcategories": []
            },
            {
              "id": "compaction-rollers-xcmg-xs202",
              "name": "XS202",
              "subcategories": []
            },
            {
              "id": "compaction-rollers-xcmg-xs203",
              "name": "XS203",
              "subcategories": []
            },
            {
              "id": "compaction-rollers-xcmg-xs205",
              "name": "XS205",
              "subcategories": []
            },
            {
              "id": "compaction-rollers-xcmg-xs222",
              "name": "XS222",
              "subcategories": []
            },
            {
              "id": "compaction-rollers-xcmg-xs223",
              "name": "XS223",
              "subcategories": []
            },
            {
              "id": "compaction-rollers-xcmg-xs225",
              "name": "XS225",
              "subcategories": []
            },
            {
              "id": "compaction-rollers-xcmg-xs263",
              "name": "XS263",
              "subcategories": []
            },
            {
              "id": "compaction-rollers-xcmg-xs265",
              "name": "XS265",
              "subcategories": []
            },
            {
              "id": "compaction-rollers-xcmg-xs335",
              "name": "XS335",
              "subcategories": []
            },
            {
              "id": "compaction-rollers-xcmg-xs400",
              "name": "XS400",
              "subcategories": []
            },
            {
              "id": "compaction-rollers-xcmg-xs600",
              "name": "XS600",
              "subcategories": []
            },
            {
              "id": "compaction-rollers-xcmg-xs803",
              "name": "XS803",
              "subcategories": []
            },
            {
              "id": "compaction-rollers-xcmg-yz14",
              "name": "YZ14",
              "subcategories": []
            },
            {
              "id": "compaction-rollers-xcmg-other",
              "name": "OTHER",
              "subcategories": []
            }
          ]
        },
        {
          "id": "compaction-rollers-husqvarna",
          "name": "Husqvarna",
          "subcategories": [
            {
              "id": "compaction-rollers-husqvarna-lf50",
              "name": "LF50",
              "subcategories": []
            },
            {
              "id": "compaction-rollers-husqvarna-lf60",
              "name": "LF60",
              "subcategories": []
            },
            {
              "id": "compaction-rollers-husqvarna-lf75",
              "name": "LF75",
              "subcategories": []
            },
            {
              "id": "compaction-rollers-husqvarna-lf80",
              "name": "LF80",
              "subcategories": []
            },
            {
              "id": "compaction-rollers-husqvarna-lf100",
              "name": "LF100",
              "subcategories": []
            },
            {
              "id": "compaction-rollers-husqvarna-lg164",
              "name": "LG164",
              "subcategories": []
            },
            {
              "id": "compaction-rollers-husqvarna-lg204",
              "name": "LG204",
              "subcategories": []
            },
            {
              "id": "compaction-rollers-husqvarna-lg300",
              "name": "LG300",
              "subcategories": []
            },
            {
              "id": "compaction-rollers-husqvarna-lg400",
              "name": "LG400",
              "subcategories": []
            },
            {
              "id": "compaction-rollers-husqvarna-lg504",
              "name": "LG504",
              "subcategories": []
            },
            {
              "id": "compaction-rollers-husqvarna-lh700",
              "name": "LH700",
              "subcategories": []
            },
            {
              "id": "compaction-rollers-husqvarna-lh804",
              "name": "LH804",
              "subcategories": []
            },
            {
              "id": "compaction-rollers-husqvarna-lp6505",
              "name": "LP6505",
              "subcategories": []
            },
            {
              "id": "compaction-rollers-husqvarna-lp9505",
              "name": "LP9505",
              "subcategories": []
            },
            {
              "id": "compaction-rollers-husqvarna-lt5005",
              "name": "LT5005",
              "subcategories": []
            },
            {
              "id": "compaction-rollers-husqvarna-lt6005",
              "name": "LT6005",
              "subcategories": []
            },
            {
              "id": "compaction-rollers-husqvarna-lt8005",
              "name": "LT8005",
              "subcategories": []
            },
            {
              "id": "compaction-rollers-husqvarna-rvl300",
              "name": "RVL300",
              "subcategories": []
            },
            {
              "id": "compaction-rollers-husqvarna-other",
              "name": "OTHER",
              "subcategories": []
            }
          ]
        },
        {
          "id": "compaction-rollers-sany",
          "name": "Sany",
          "subcategories": [
            {
              "id": "compaction-rollers-sany-ssr80",
              "name": "SSR80",
              "subcategories": []
            },
            {
              "id": "compaction-rollers-sany-ssr120",
              "name": "SSR120",
              "subcategories": []
            },
            {
              "id": "compaction-rollers-sany-ssr150",
              "name": "SSR150",
              "subcategories": []
            },
            {
              "id": "compaction-rollers-sany-ssr180",
              "name": "SSR180",
              "subcategories": []
            },
            {
              "id": "compaction-rollers-sany-ssr260",
              "name": "SSR260",
              "subcategories": []
            },
            {
              "id": "compaction-rollers-sany-str30",
              "name": "STR30",
              "subcategories": []
            },
            {
              "id": "compaction-rollers-sany-other",
              "name": "OTHER",
              "subcategories": []
            }
          ]
        }
      ]
    },
    {
      "id": "cranes",
      "name": "Cranes",
      "subcategories": [
        {
          "id": "cranes-altec",
          "name": "Altec",
          "subcategories": [
            {
              "id": "cranes-altec-a40",
              "name": "A40",
              "subcategories": []
            },
            {
              "id": "cranes-altec-a55",
              "name": "A55",
              "subcategories": []
            },
            {
              "id": "cranes-altec-a65",
              "name": "A65",
              "subcategories": []
            },
            {
              "id": "cranes-altec-a35",
              "name": "A35",
              "subcategories": []
            },
            {
              "id": "cranes-altec-a72",
              "name": "A72",
              "subcategories": []
            },
            {
              "id": "cranes-altec-a75",
              "name": "A75",
              "subcategories": []
            },
            {
              "id": "cranes-altec-a77",
              "name": "A77",
              "subcategories": []
            },
            {
              "id": "cranes-altec-a470",
              "name": "A470",
              "subcategories": []
            },
            {
              "id": "cranes-altec-a771",
              "name": "A771",
              "subcategories": []
            },
            {
              "id": "cranes-altec-aa28",
              "name": "AA28",
              "subcategories": []
            },
            {
              "id": "cranes-altec-aa55",
              "name": "AA55",
              "subcategories": []
            },
            {
              "id": "cranes-altec-aa60",
              "name": "AA60",
              "subcategories": []
            },
            {
              "id": "cranes-altec-aa77",
              "name": "AA77",
              "subcategories": []
            },
            {
              "id": "cranes-altec-aa280",
              "name": "AA280",
              "subcategories": []
            },
            {
              "id": "cranes-altec-aa600",
              "name": "AA600",
              "subcategories": []
            },
            {
              "id": "cranes-altec-aa755",
              "name": "AA755",
              "subcategories": []
            },
            {
              "id": "cranes-altec-ac18",
              "name": "AC18",
              "subcategories": []
            },
            {
              "id": "cranes-altec-ac23",
              "name": "AC23",
              "subcategories": []
            },
            {
              "id": "cranes-altec-ac26",
              "name": "AC26",
              "subcategories": []
            },
            {
              "id": "cranes-altec-ac30",
              "name": "AC30",
              "subcategories": []
            },
            {
              "id": "cranes-altec-ac38",
              "name": "AC38",
              "subcategories": []
            },
            {
              "id": "cranes-altec-ac40",
              "name": "AC40",
              "subcategories": []
            },
            {
              "id": "cranes-altec-ac45",
              "name": "AC45",
              "subcategories": []
            },
            {
              "id": "cranes-altec-ah85",
              "name": "AH85",
              "subcategories": []
            },
            {
              "id": "cranes-altec-ah100",
              "name": "AH100",
              "subcategories": []
            },
            {
              "id": "cranes-altec-ah125",
              "name": "AH125",
              "subcategories": []
            },
            {
              "id": "cranes-altec-am50",
              "name": "AM50",
              "subcategories": []
            },
            {
              "id": "cranes-altec-am55",
              "name": "AM55",
              "subcategories": []
            },
            {
              "id": "cranes-altec-am60",
              "name": "AM60",
              "subcategories": []
            },
            {
              "id": "cranes-altec-am450",
              "name": "AM450",
              "subcategories": []
            },
            {
              "id": "cranes-altec-am650",
              "name": "AM650",
              "subcategories": []
            },
            {
              "id": "cranes-altec-am855",
              "name": "AM855",
              "subcategories": []
            },
            {
              "id": "cranes-altec-am900",
              "name": "AM900",
              "subcategories": []
            },
            {
              "id": "cranes-altec-an55",
              "name": "AN55",
              "subcategories": []
            },
            {
              "id": "cranes-altec-an67",
              "name": "AN67",
              "subcategories": []
            },
            {
              "id": "cranes-altec-an546",
              "name": "AN546",
              "subcategories": []
            },
            {
              "id": "cranes-altec-an652",
              "name": "AN652",
              "subcategories": []
            },
            {
              "id": "cranes-altec-sn50",
              "name": "SN50",
              "subcategories": []
            },
            {
              "id": "cranes-altec-sn55",
              "name": "SN55",
              "subcategories": []
            },
            {
              "id": "cranes-altec-an67",
              "name": "AN67",
              "subcategories": []
            },
            {
              "id": "cranes-altec-an546",
              "name": "AN546",
              "subcategories": []
            },
            {
              "id": "cranes-altec-an652",
              "name": "AN652",
              "subcategories": []
            },
            {
              "id": "cranes-altec-ap36",
              "name": "AP36",
              "subcategories": []
            },
            {
              "id": "cranes-altec-ap40",
              "name": "AP40",
              "subcategories": []
            },
            {
              "id": "cranes-altec-at35",
              "name": "AT35",
              "subcategories": []
            },
            {
              "id": "cranes-altec-at37",
              "name": "AT37",
              "subcategories": []
            },
            {
              "id": "cranes-altec-at40",
              "name": "AT40",
              "subcategories": []
            },
            {
              "id": "cranes-altec-at41",
              "name": "AT41",
              "subcategories": []
            },
            {
              "id": "cranes-altec-at48",
              "name": "AT48",
              "subcategories": []
            },
            {
              "id": "cranes-altec-at200",
              "name": "AT200",
              "subcategories": []
            },
            {
              "id": "cranes-altec-at235",
              "name": "AT235",
              "subcategories": []
            },
            {
              "id": "cranes-altec-at237",
              "name": "AT237",
              "subcategories": []
            },
            {
              "id": "cranes-altec-at238",
              "name": "AT238",
              "subcategories": []
            },
            {
              "id": "cranes-altec-at248",
              "name": "AT248",
              "subcategories": []
            },
            {
              "id": "cranes-altec-d820",
              "name": "D820",
              "subcategories": []
            },
            {
              "id": "cranes-altec-d842",
              "name": "D842",
              "subcategories": []
            },
            {
              "id": "cranes-altec-d845",
              "name": "D845",
              "subcategories": []
            },
            {
              "id": "cranes-altec-d945",
              "name": "D945",
              "subcategories": []
            },
            {
              "id": "cranes-altec-d947",
              "name": "D947",
              "subcategories": []
            },
            {
              "id": "cranes-altec-d1000",
              "name": "D1000",
              "subcategories": []
            },
            {
              "id": "cranes-altec-d2045",
              "name": "D2045",
              "subcategories": []
            },
            {
              "id": "cranes-altec-d2050",
              "name": "D2050",
              "subcategories": []
            },
            {
              "id": "cranes-altec-d2055",
              "name": "D2055",
              "subcategories": []
            },
            {
              "id": "cranes-altec-d3050",
              "name": "D3050",
              "subcategories": []
            },
            {
              "id": "cranes-altec-d3055",
              "name": "D3055",
              "subcategories": []
            },
            {
              "id": "cranes-altec-d3060",
              "name": "D3060",
              "subcategories": []
            },
            {
              "id": "cranes-altec-d4050",
              "name": "D4050",
              "subcategories": []
            },
            {
              "id": "cranes-altec-d4060",
              "name": "D4060",
              "subcategories": []
            },
            {
              "id": "cranes-altec-d4065",
              "name": "D4065",
              "subcategories": []
            },
            {
              "id": "cranes-altec-db35",
              "name": "DB35",
              "subcategories": []
            },
            {
              "id": "cranes-altec-db37",
              "name": "DB37",
              "subcategories": []
            },
            {
              "id": "cranes-altec-db41",
              "name": "DB41",
              "subcategories": []
            },
            {
              "id": "cranes-altec-dc45",
              "name": "DC45",
              "subcategories": []
            },
            {
              "id": "cranes-altec-dc47",
              "name": "DC47",
              "subcategories": []
            },
            {
              "id": "cranes-altec-dl42",
              "name": "DL42",
              "subcategories": []
            },
            {
              "id": "cranes-altec-dl45",
              "name": "DL45",
              "subcategories": []
            },
            {
              "id": "cranes-altec-dm45",
              "name": "DM45",
              "subcategories": []
            },
            {
              "id": "cranes-altec-dm47",
              "name": "DM47",
              "subcategories": []
            },
            {
              "id": "cranes-altec-dt65",
              "name": "DT65",
              "subcategories": []
            },
            {
              "id": "cranes-altec-dt80",
              "name": "DT80",
              "subcategories": []
            },
            {
              "id": "cranes-altec-dt105",
              "name": "DT105",
              "subcategories": []
            },
            {
              "id": "cranes-altec-entergy-at37",
              "name": "ENTERGY AT37",
              "subcategories": []
            },
            {
              "id": "cranes-altec-hl125",
              "name": "HL125",
              "subcategories": []
            },
            {
              "id": "cranes-altec-l36",
              "name": "L36",
              "subcategories": []
            },
            {
              "id": "cranes-altec-l37",
              "name": "L37",
              "subcategories": []
            },
            {
              "id": "cranes-altec-l42",
              "name": "L42",
              "subcategories": []
            },
            {
              "id": "cranes-altec-l44",
              "name": "L44",
              "subcategories": []
            },
            {
              "id": "cranes-altec-l45",
              "name": "L45",
              "subcategories": []
            },
            {
              "id": "cranes-altec-lr7",
              "name": "LR7",
              "subcategories": []
            },
            {
              "id": "cranes-altec-lr760",
              "name": "LR760",
              "subcategories": []
            },
            {
              "id": "cranes-altec-lriii55",
              "name": "LRIII55",
              "subcategories": []
            },
            {
              "id": "cranes-altec-lrv55",
              "name": "LRV55",
              "subcategories": []
            },
            {
              "id": "cranes-altec-lrv56",
              "name": "LRV56",
              "subcategories": []
            },
            {
              "id": "cranes-altec-lrv57",
              "name": "LRV57",
              "subcategories": []
            },
            {
              "id": "cranes-altec-lrv58",
              "name": "LRV58",
              "subcategories": []
            },
            {
              "id": "cranes-altec-lrv60",
              "name": "LRV60",
              "subcategories": []
            },
            {
              "id": "cranes-altec-ls40",
              "name": "LS40",
              "subcategories": []
            },
            {
              "id": "cranes-altec-ls49",
              "name": "LS49",
              "subcategories": []
            },
            {
              "id": "cranes-altec-ls60",
              "name": "LS60",
              "subcategories": []
            },
            {
              "id": "cranes-altec-ls87",
              "name": "LS87",
              "subcategories": []
            },
            {
              "id": "cranes-altec-ls63",
              "name": "LS63",
              "subcategories": []
            },
            {
              "id": "cranes-altec-t40",
              "name": "T40",
              "subcategories": []
            },
            {
              "id": "cranes-altec-ta37",
              "name": "TA37",
              "subcategories": []
            },
            {
              "id": "cranes-altec-ta40",
              "name": "TA40",
              "subcategories": []
            },
            {
              "id": "cranes-altec-ta41",
              "name": "TA41",
              "subcategories": []
            },
            {
              "id": "cranes-altec-ta45",
              "name": "TA45",
              "subcategories": []
            },
            {
              "id": "cranes-altec-ta50",
              "name": "TA50",
              "subcategories": []
            },
            {
              "id": "cranes-altec-ta60",
              "name": "TA60",
              "subcategories": []
            },
            {
              "id": "cranes-altec-other",
              "name": "OTHER",
              "subcategories": []
            }
          ]
        },
        {
          "id": "cranes-terex",
          "name": "Terex",
          "subcategories": [
            {
              "id": "cranes-terex-5tc-55",
              "name": "5TC-55",
              "subcategories": []
            },
            {
              "id": "cranes-terex-ac30",
              "name": "AC30",
              "subcategories": []
            },
            {
              "id": "cranes-terex-ac35",
              "name": "AC35",
              "subcategories": []
            },
            {
              "id": "cranes-terex-ac40",
              "name": "AC40",
              "subcategories": []
            },
            {
              "id": "cranes-terex-ac40-2",
              "name": "AC40/2",
              "subcategories": []
            },
            {
              "id": "cranes-terex-ac50",
              "name": "AC50",
              "subcategories": []
            },
            {
              "id": "cranes-terex-ac55",
              "name": "AC55",
              "subcategories": []
            },
            {
              "id": "cranes-terex-ac60",
              "name": "AC60",
              "subcategories": []
            },
            {
              "id": "cranes-terex-ac70",
              "name": "AC70",
              "subcategories": []
            },
            {
              "id": "cranes-terex-ac100",
              "name": "AC100",
              "subcategories": []
            },
            {
              "id": "cranes-terex-ac200",
              "name": "AC200",
              "subcategories": []
            },
            {
              "id": "cranes-terex-ac350",
              "name": "AC350",
              "subcategories": []
            },
            {
              "id": "cranes-terex-ac500",
              "name": "AC500",
              "subcategories": []
            },
            {
              "id": "cranes-terex-at15",
              "name": "AT15",
              "subcategories": []
            },
            {
              "id": "cranes-terex-at20",
              "name": "AT20",
              "subcategories": []
            },
            {
              "id": "cranes-terex-at40",
              "name": "AT40",
              "subcategories": []
            },
            {
              "id": "cranes-terex-att400",
              "name": "ATT400",
              "subcategories": []
            },
            {
              "id": "cranes-terex-att1300",
              "name": "ATT1300",
              "subcategories": []
            },
            {
              "id": "cranes-terex-bt2047",
              "name": "BT2047",
              "subcategories": []
            },
            {
              "id": "cranes-terex-bt3060",
              "name": "BT3060",
              "subcategories": []
            },
            {
              "id": "cranes-terex-bt3400",
              "name": "BT3400",
              "subcategories": []
            },
            {
              "id": "cranes-terex-bt3470",
              "name": "BT3470",
              "subcategories": []
            },
            {
              "id": "cranes-terex-bt3870",
              "name": "BT3870",
              "subcategories": []
            },
            {
              "id": "cranes-terex-bt3874",
              "name": "BT3874",
              "subcategories": []
            },
            {
              "id": "cranes-terex-bt4772",
              "name": "BT4772",
              "subcategories": []
            },
            {
              "id": "cranes-terex-bt4792",
              "name": "BT4792",
              "subcategories": []
            },
            {
              "id": "cranes-terex-bt5092",
              "name": "BT5092",
              "subcategories": []
            },
            {
              "id": "cranes-terex-bt28106",
              "name": "BT28106",
              "subcategories": []
            },
            {
              "id": "cranes-terex-cbr36",
              "name": "CBR36",
              "subcategories": []
            },
            {
              "id": "cranes-terex-cbr40",
              "name": "CBR40",
              "subcategories": []
            },
            {
              "id": "cranes-terex-cc400",
              "name": "CC400",
              "subcategories": []
            },
            {
              "id": "cranes-terex-cc2500",
              "name": "CC2500",
              "subcategories": []
            },
            {
              "id": "cranes-terex-cc2800",
              "name": "CC2800",
              "subcategories": []
            },
            {
              "id": "cranes-terex-cc3800",
              "name": "CC3800",
              "subcategories": []
            },
            {
              "id": "cranes-terex-cd225",
              "name": "CD225",
              "subcategories": []
            },
            {
              "id": "cranes-terex-challenger-3160",
              "name": "CHALLENGER 3160",
              "subcategories": []
            },
            {
              "id": "cranes-terex-commander-4040",
              "name": "COMMANDER 4040",
              "subcategories": []
            },
            {
              "id": "cranes-terex-commander-4042",
              "name": "COMMANDER 4042",
              "subcategories": []
            },
            {
              "id": "cranes-terex-commander-4045",
              "name": "COMMANDER 4045",
              "subcategories": []
            },
            {
              "id": "cranes-terex-commander-4047",
              "name": "COMMANDER 4047",
              "subcategories": []
            },
            {
              "id": "cranes-terex-commander-4050",
              "name": "COMMANDER 4050",
              "subcategories": []
            },
            {
              "id": "cranes-terex-commander-5045",
              "name": "COMMANDER 5045",
              "subcategories": []
            },
            {
              "id": "cranes-terex-commander-5048",
              "name": "COMMANDER 5048",
              "subcategories": []
            },
            {
              "id": "cranes-terex-commander-5050",
              "name": "COMMANDER 5050",
              "subcategories": []
            },
            {
              "id": "cranes-terex-commander-5052",
              "name": "COMMANDER 5052",
              "subcategories": []
            },
            {
              "id": "cranes-terex-commander-6000",
              "name": "COMMANDER 6000",
              "subcategories": []
            },
            {
              "id": "cranes-terex-commander-6054",
              "name": "COMMANDER 6054",
              "subcategories": []
            },
            {
              "id": "cranes-terex-commander-6060",
              "name": "COMMANDER 6060",
              "subcategories": []
            },
            {
              "id": "cranes-terex-commander-7000",
              "name": "COMMANDER 7000",
              "subcategories": []
            },
            {
              "id": "cranes-terex-crossover-4500",
              "name": "CROSSOVER 4500",
              "subcategories": []
            },
            {
              "id": "cranes-terex-crossover-6000",
              "name": "CROSSOVER 6000",
              "subcategories": []
            },
            {
              "id": "cranes-terex-crossover-8000",
              "name": "CROSSOVER 8000",
              "subcategories": []
            },
            {
              "id": "cranes-terex-ctl140",
              "name": "CTL140",
              "subcategories": []
            },
            {
              "id": "cranes-terex-ctl-260",
              "name": "CTL 260",
              "subcategories": []
            },
            {
              "id": "cranes-terex-ctyl-430",
              "name": "CTYL 430",
              "subcategories": []
            },
            {
              "id": "cranes-terex-ctl-630",
              "name": "CTL 630",
              "subcategories": []
            },
            {
              "id": "cranes-terex-ctt121",
              "name": "CTT121",
              "subcategories": []
            },
            {
              "id": "cranes-terex-ctt132",
              "name": "CTT132",
              "subcategories": []
            },
            {
              "id": "cranes-terex-ctt172",
              "name": "CTT172",
              "subcategories": []
            },
            {
              "id": "cranes-terex-ctt181",
              "name": "CTT181",
              "subcategories": []
            },
            {
              "id": "cranes-terex-ctt182",
              "name": "CTT182",
              "subcategories": []
            },
            {
              "id": "cranes-terex-ctt202",
              "name": "CTT202",
              "subcategories": []
            },
            {
              "id": "cranes-terex-ctt331",
              "name": "CTT331",
              "subcategories": []
            },
            {
              "id": "cranes-terex-ct332",
              "name": "CT332",
              "subcategories": []
            },
            {
              "id": "cranes-terex-ctt531",
              "name": "CTT531",
              "subcategories": []
            },
            {
              "id": "cranes-terex-ctt561",
              "name": "CTT561",
              "subcategories": []
            },
            {
              "id": "cranes-terex-ctt321",
              "name": "CTT321",
              "subcategories": []
            },
            {
              "id": "cranes-terex-explorer-5500",
              "name": "EXPLORER 5500",
              "subcategories": []
            },
            {
              "id": "cranes-terex-explorer-5800",
              "name": "EXPLORER 5800",
              "subcategories": []
            },
            {
              "id": "cranes-terex-general-54",
              "name": "GENERAL 54",
              "subcategories": []
            },
            {
              "id": "cranes-terex-general-65",
              "name": "GENERAL 65",
              "subcategories": []
            },
            {
              "id": "cranes-terex-general-80",
              "name": "GENERAL 80",
              "subcategories": []
            },
            {
              "id": "cranes-terex-hc80",
              "name": "HC80",
              "subcategories": []
            },
            {
              "id": "cranes-terex-hc110",
              "name": "HC110",
              "subcategories": []
            },
            {
              "id": "cranes-terex-hc120",
              "name": "HC120",
              "subcategories": []
            },
            {
              "id": "cranes-terex-hc230",
              "name": "HC230",
              "subcategories": []
            },
            {
              "id": "cranes-terex-hc275",
              "name": "HC275",
              "subcategories": []
            },
            {
              "id": "cranes-terex-hc285",
              "name": "HC285",
              "subcategories": []
            },
            {
              "id": "cranes-terex-hi-ranger-6tc-65",
              "name": "HI RANGER 6TC-65",
              "subcategories": []
            },
            {
              "id": "cranes-terex-hr37",
              "name": "HR37",
              "subcategories": []
            },
            {
              "id": "cranes-terex-hr40",
              "name": "HR40",
              "subcategories": []
            },
            {
              "id": "cranes-terex-hr46",
              "name": "HR46",
              "subcategories": []
            },
            {
              "id": "cranes-terex-hr50",
              "name": "HR50",
              "subcategories": []
            },
            {
              "id": "cranes-terex-hr55",
              "name": "HR55",
              "subcategories": []
            },
            {
              "id": "cranes-terex-hr5tc",
              "name": "HR5TC",
              "subcategories": []
            },
            {
              "id": "cranes-terex-hrx52",
              "name": "HRX52",
              "subcategories": []
            },
            {
              "id": "cranes-terex-hrx55",
              "name": "HRX55",
              "subcategories": []
            },
            {
              "id": "cranes-terex-hiranger-5fc-60",
              "name": "HIRANGER 5FC-60",
              "subcategories": []
            },
            {
              "id": "cranes-terex-hiranger-5tc-52",
              "name": "HIRANGER 5TC-52",
              "subcategories": []
            },
            {
              "id": "cranes-terex-hiranger-5tc-55",
              "name": "HIRANGER 5TC-55",
              "subcategories": []
            },
            {
              "id": "cranes-terex-hiranger-50m",
              "name": "HIRANGER 50M",
              "subcategories": []
            },
            {
              "id": "cranes-terex-hiranger",
              "name": "HIRANGER",
              "subcategories": []
            },
            {
              "id": "cranes-terex-hr46m",
              "name": "HR46M",
              "subcategories": []
            },
            {
              "id": "cranes-terex-hiranger-52m",
              "name": "HIRANGER 52M",
              "subcategories": []
            },
            {
              "id": "cranes-terex-hiranger-hrx-60",
              "name": "HIRANGER HRX-60",
              "subcategories": []
            },
            {
              "id": "cranes-terex-hiranger-lt40",
              "name": "HIRANGER LT40",
              "subcategories": []
            },
            {
              "id": "cranes-terex-hiranger-tc55",
              "name": "HIRANGER TC55",
              "subcategories": []
            },
            {
              "id": "cranes-terex-hiranger-hrx-60",
              "name": "HIRANGER HRX-60",
              "subcategories": []
            },
            {
              "id": "cranes-terex-hiranger-lt40",
              "name": "HIRANGER LT40",
              "subcategories": []
            },
            {
              "id": "cranes-terex-hiranger-tc55",
              "name": "HIRANGER TC55",
              "subcategories": []
            },
            {
              "id": "cranes-terex-hiranger-tl37m",
              "name": "HIRANGER TL37M",
              "subcategories": []
            },
            {
              "id": "cranes-terex-hiranger-tl45",
              "name": "HIRANGER TL45",
              "subcategories": []
            },
            {
              "id": "cranes-terex-hiranger-tl55",
              "name": "HIRANGER TL55",
              "subcategories": []
            },
            {
              "id": "cranes-terex-hiranger-xt55",
              "name": "HIRANGER XT55",
              "subcategories": []
            },
            {
              "id": "cranes-terex-hiranger-xt60",
              "name": "HIRANGER XT60",
              "subcategories": []
            },
            {
              "id": "cranes-terex-l4040",
              "name": "L4040",
              "subcategories": []
            },
            {
              "id": "cranes-terex-lrt110",
              "name": "LRT110",
              "subcategories": []
            },
            {
              "id": "cranes-terex-lt38",
              "name": "LT38",
              "subcategories": []
            },
            {
              "id": "cranes-terex-lt40",
              "name": "LT40",
              "subcategories": []
            },
            {
              "id": "cranes-terex-ltm40",
              "name": "LTM40",
              "subcategories": []
            },
            {
              "id": "cranes-terex-mac-25",
              "name": "MAC 25",
              "subcategories": []
            },
            {
              "id": "cranes-terex-nt29",
              "name": "NT29",
              "subcategories": []
            },
            {
              "id": "cranes-terex-optima-hrx55",
              "name": "OPTIMA HRX55",
              "subcategories": []
            },
            {
              "id": "cranes-terex-optima-tc55",
              "name": "OPTIMA TC55",
              "subcategories": []
            },
            {
              "id": "cranes-terex-optima-tcx55",
              "name": "OPTIMA TCX55",
              "subcategories": []
            },
            {
              "id": "cranes-terex-powerlift-1000",
              "name": "POWERLIFT 1000",
              "subcategories": []
            },
            {
              "id": "cranes-terex-quadstar-1065",
              "name": "QUADSTAR 1065",
              "subcategories": []
            },
            {
              "id": "cranes-terex-quadstar-1075",
              "name": "QUADSTAR 1075",
              "subcategories": []
            },
            {
              "id": "cranes-terex-quadstar-1100",
              "name": "QUADSTAR 1100",
              "subcategories": []
            },
            {
              "id": "cranes-terex-rc30",
              "name": "RC30",
              "subcategories": []
            },
            {
              "id": "cranes-terex-rm75-100",
              "name": "RM75/100",
              "subcategories": []
            },
            {
              "id": "cranes-terex-rm4792",
              "name": "RM4792",
              "subcategories": []
            },
            {
              "id": "cranes-terex-rs600",
              "name": "RS600",
              "subcategories": []
            },
            {
              "id": "cranes-terex-rs70100",
              "name": "RS70100",
              "subcategories": []
            },
            {
              "id": "cranes-terex-rt90",
              "name": "RT90",
              "subcategories": []
            },
            {
              "id": "cranes-terex-rt100",
              "name": "RT100",
              "subcategories": []
            },
            {
              "id": "cranes-terex-rt130",
              "name": "RT130",
              "subcategories": []
            },
            {
              "id": "cranes-terex-rt160",
              "name": "RT160",
              "subcategories": []
            },
            {
              "id": "cranes-terex-rt190",
              "name": "RT190",
              "subcategories": []
            },
            {
              "id": "cranes-terex-rt230",
              "name": "RT230",
              "subcategories": []
            },
            {
              "id": "cranes-terex-rt335",
              "name": "RT335",
              "subcategories": []
            },
            {
              "id": "cranes-terex-rt345",
              "name": "RT345",
              "subcategories": []
            },
            {
              "id": "cranes-terex-rt445",
              "name": "RT445",
              "subcategories": []
            },
            {
              "id": "cranes-terex-rt555",
              "name": "RT555",
              "subcategories": []
            },
            {
              "id": "cranes-terex-rt665",
              "name": "RT665",
              "subcategories": []
            },
            {
              "id": "cranes-terex-rt670",
              "name": "RT670",
              "subcategories": []
            },
            {
              "id": "cranes-terex-rt780",
              "name": "RT780",
              "subcategories": []
            },
            {
              "id": "cranes-terex-sc45",
              "name": "SC45",
              "subcategories": []
            },
            {
              "id": "cranes-terex-sk415",
              "name": "SK415",
              "subcategories": []
            },
            {
              "id": "cranes-terex-sk575",
              "name": "SK575",
              "subcategories": []
            },
            {
              "id": "cranes-terex-sw35",
              "name": "SW35",
              "subcategories": []
            },
            {
              "id": "cranes-terex-t230",
              "name": "T230",
              "subcategories": []
            },
            {
              "id": "cranes-terex-t292",
              "name": "T292",
              "subcategories": []
            },
            {
              "id": "cranes-terex-t335",
              "name": "T335",
              "subcategories": []
            },
            {
              "id": "cranes-terex-t340",
              "name": "T340",
              "subcategories": []
            },
            {
              "id": "cranes-terex-t550",
              "name": "T550",
              "subcategories": []
            },
            {
              "id": "cranes-terex-t560",
              "name": "T560",
              "subcategories": []
            },
            {
              "id": "cranes-terex-t775",
              "name": "T775",
              "subcategories": []
            },
            {
              "id": "cranes-terex-t780",
              "name": "T780",
              "subcategories": []
            },
            {
              "id": "cranes-terex-tc40",
              "name": "TC40",
              "subcategories": []
            },
            {
              "id": "cranes-terex-tc55",
              "name": "TC55",
              "subcategories": []
            },
            {
              "id": "cranes-terex-tc2863",
              "name": "TC2863",
              "subcategories": []
            },
            {
              "id": "cranes-terex-tc3063",
              "name": "TC3063",
              "subcategories": []
            },
            {
              "id": "cranes-terex-tc3470",
              "name": "TC3470",
              "subcategories": []
            },
            {
              "id": "cranes-terex-tc3874",
              "name": "TC3874",
              "subcategories": []
            },
            {
              "id": "cranes-terex-tcx55",
              "name": "TCX55",
              "subcategories": []
            },
            {
              "id": "cranes-terex-tcx65-100",
              "name": "TCX65/100",
              "subcategories": []
            },
            {
              "id": "cranes-terex-texoma-650",
              "name": "TEXOMA 650",
              "subcategories": []
            },
            {
              "id": "cranes-terex-tl37",
              "name": "TL37",
              "subcategories": []
            },
            {
              "id": "cranes-terex-tl38",
              "name": "TL38",
              "subcategories": []
            },
            {
              "id": "cranes-terex-tl41",
              "name": "TL41",
              "subcategories": []
            },
            {
              "id": "cranes-terex-tl50",
              "name": "TL50",
              "subcategories": []
            },
            {
              "id": "cranes-terex-tm100",
              "name": "TM100",
              "subcategories": []
            },
            {
              "id": "cranes-terex-tm105",
              "name": "TM105",
              "subcategories": []
            },
            {
              "id": "cranes-terex-tm125",
              "name": "TM125",
              "subcategories": []
            },
            {
              "id": "cranes-terex-tm3851",
              "name": "TM3851",
              "subcategories": []
            },
            {
              "id": "cranes-terex-trt40",
              "name": "TRT40",
              "subcategories": []
            },
            {
              "id": "cranes-terex-trt55",
              "name": "TRT55",
              "subcategories": []
            },
            {
              "id": "cranes-terex-trt70",
              "name": "TRT70",
              "subcategories": []
            },
            {
              "id": "cranes-terex-trt80",
              "name": "TRT80",
              "subcategories": []
            },
            {
              "id": "cranes-terex-trt100",
              "name": "TRT100",
              "subcategories": []
            },
            {
              "id": "cranes-terex-xl4045",
              "name": "XL4045",
              "subcategories": []
            },
            {
              "id": "cranes-terex-xm55",
              "name": "XM55",
              "subcategories": []
            },
            {
              "id": "cranes-terex-xt-pro-56",
              "name": "XT PRO 56",
              "subcategories": []
            },
            {
              "id": "cranes-terex-xt-prto-60",
              "name": "XT PRTO 60",
              "subcategories": []
            },
            {
              "id": "cranes-terex-xt-pro-60-70",
              "name": "XT PRO 60/70",
              "subcategories": []
            },
            {
              "id": "cranes-terex-other",
              "name": "OTHER",
              "subcategories": []
            }
          ]
        },
        {
          "id": "cranes-grove",
          "name": "Grove",
          "subcategories": [
            {
              "id": "cranes-grove-68",
              "name": "68",
              "subcategories": []
            },
            {
              "id": "cranes-grove-315",
              "name": "315",
              "subcategories": []
            },
            {
              "id": "cranes-grove-ap206",
              "name": "AP206",
              "subcategories": []
            },
            {
              "id": "cranes-grove-ap308",
              "name": "AP308",
              "subcategories": []
            },
            {
              "id": "cranes-grove-at633",
              "name": "AT633",
              "subcategories": []
            },
            {
              "id": "cranes-grove-at700",
              "name": "AT700",
              "subcategories": []
            },
            {
              "id": "cranes-grove-at735",
              "name": "AT735",
              "subcategories": []
            },
            {
              "id": "cranes-grove-at750",
              "name": "AT750",
              "subcategories": []
            },
            {
              "id": "cranes-grove-gcd09",
              "name": "GCD09",
              "subcategories": []
            },
            {
              "id": "cranes-grove-gcd15",
              "name": "GCD15",
              "subcategories": []
            },
            {
              "id": "cranes-grove-gcd20",
              "name": "GCD20",
              "subcategories": []
            },
            {
              "id": "cranes-grove-gcd25",
              "name": "GCD25",
              "subcategories": []
            },
            {
              "id": "cranes-grove-gck3045",
              "name": "GCK3045",
              "subcategories": []
            },
            {
              "id": "cranes-grove-ghc55",
              "name": "GHC55",
              "subcategories": []
            },
            {
              "id": "cranes-grove-ghc75",
              "name": "GHC75",
              "subcategories": []
            },
            {
              "id": "cranes-grove-ghc85",
              "name": "GHC85",
              "subcategories": []
            },
            {
              "id": "cranes-grove-ghc110",
              "name": "GHC110",
              "subcategories": []
            },
            {
              "id": "cranes-grove-ghc130",
              "name": "GHC130",
              "subcategories": []
            },
            {
              "id": "cranes-grove-ghc140",
              "name": "GHC140",
              "subcategories": []
            },
            {
              "id": "cranes-grove-gmk2035",
              "name": "GMK2035",
              "subcategories": []
            },
            {
              "id": "cranes-grove-gmk3050",
              "name": "GMK3050",
              "subcategories": []
            },
            {
              "id": "cranes-grove-gmk3055",
              "name": "GMK3055",
              "subcategories": []
            },
            {
              "id": "cranes-grove-gmk3060",
              "name": "GMK3060",
              "subcategories": []
            },
            {
              "id": "cranes-grove-gmk4075",
              "name": "GMK4075",
              "subcategories": []
            },
            {
              "id": "cranes-grove-gmk4080",
              "name": "GMK4080",
              "subcategories": []
            },
            {
              "id": "cranes-grove-gmk4090",
              "name": "GMK4090",
              "subcategories": []
            },
            {
              "id": "cranes-grove-gmk4100",
              "name": "GMK4100",
              "subcategories": []
            },
            {
              "id": "cranes-grove-gmk4115",
              "name": "GMK4115",
              "subcategories": []
            },
            {
              "id": "cranes-grove-gmk5090",
              "name": "GMK5090",
              "subcategories": []
            },
            {
              "id": "cranes-grove-gmk5095",
              "name": "GMK5095",
              "subcategories": []
            },
            {
              "id": "cranes-grove-gmk5100",
              "name": "GMK5100",
              "subcategories": []
            },
            {
              "id": "cranes-grove-gmk5110",
              "name": "GMK5110",
              "subcategories": []
            },
            {
              "id": "cranes-grove-gmk5120",
              "name": "GMK5120",
              "subcategories": []
            },
            {
              "id": "cranes-grove-gmk5130",
              "name": "GMK5130",
              "subcategories": []
            },
            {
              "id": "cranes-grove-gmk5150",
              "name": "GMK5150",
              "subcategories": []
            },
            {
              "id": "cranes-grove-gmk5160",
              "name": "GMK5160",
              "subcategories": []
            },
            {
              "id": "cranes-grove-gmk5165",
              "name": "GMK5165",
              "subcategories": []
            },
            {
              "id": "cranes-grove-gmk5175",
              "name": "GMK5175",
              "subcategories": []
            },
            {
              "id": "cranes-grove-gmk5180",
              "name": "GMK5180",
              "subcategories": []
            },
            {
              "id": "cranes-grove-gmk5200",
              "name": "GMK5200",
              "subcategories": []
            },
            {
              "id": "cranes-grove-gmk5210",
              "name": "GMK5210",
              "subcategories": []
            },
            {
              "id": "cranes-grove-gmk5220",
              "name": "GMK5220",
              "subcategories": []
            },
            {
              "id": "cranes-grove-gmk5225",
              "name": "GMK5225",
              "subcategories": []
            },
            {
              "id": "cranes-grove-gmk5240",
              "name": "GMK5240",
              "subcategories": []
            },
            {
              "id": "cranes-grove-gmk5250",
              "name": "GMK5250",
              "subcategories": []
            },
            {
              "id": "cranes-grove-gmk5275",
              "name": "GMK5275",
              "subcategories": []
            },
            {
              "id": "cranes-grove-gmk6220",
              "name": "GMK6220",
              "subcategories": []
            },
            {
              "id": "cranes-grove-gmk6250",
              "name": "GMK6250",
              "subcategories": []
            },
            {
              "id": "cranes-grove-gmk6300",
              "name": "GMK6300",
              "subcategories": []
            },
            {
              "id": "cranes-grove-gmk6350",
              "name": "GMK6350",
              "subcategories": []
            },
            {
              "id": "cranes-grove-gmk6400",
              "name": "GMK6400",
              "subcategories": []
            },
            {
              "id": "cranes-grove-gmk6450",
              "name": "GMK6450",
              "subcategories": []
            },
            {
              "id": "cranes-grove-gmk7450",
              "name": "GMK7450",
              "subcategories": []
            },
            {
              "id": "cranes-grove-gmk7550",
              "name": "GMK7550",
              "subcategories": []
            },
            {
              "id": "cranes-grove-grt650",
              "name": "GRT650",
              "subcategories": []
            },
            {
              "id": "cranes-grove-grt655",
              "name": "GRT655",
              "subcategories": []
            },
            {
              "id": "cranes-grove-grt765",
              "name": "GRT765",
              "subcategories": []
            },
            {
              "id": "cranes-grove-grt780",
              "name": "GRT780",
              "subcategories": []
            },
            {
              "id": "cranes-grove-grt880",
              "name": "GRT880",
              "subcategories": []
            },
            {
              "id": "cranes-grove-grt8090",
              "name": "GRT8090",
              "subcategories": []
            },
            {
              "id": "cranes-grove-grt8100",
              "name": "GRT8100",
              "subcategories": []
            },
            {
              "id": "cranes-grove-grt8120",
              "name": "GRT8120",
              "subcategories": []
            },
            {
              "id": "cranes-grove-grt9165",
              "name": "GRT9165",
              "subcategories": []
            },
            {
              "id": "cranes-grove-hl150",
              "name": "HL150",
              "subcategories": []
            },
            {
              "id": "cranes-grove-ind24",
              "name": "IND24",
              "subcategories": []
            },
            {
              "id": "cranes-grove-ind36",
              "name": "IND36",
              "subcategories": []
            },
            {
              "id": "cranes-grove-mlc150",
              "name": "MLC150",
              "subcategories": []
            },
            {
              "id": "cranes-grove-rt58",
              "name": "RT58",
              "subcategories": []
            },
            {
              "id": "cranes-grove-rt59",
              "name": "RT59",
              "subcategories": []
            },
            {
              "id": "cranes-grove-rt60",
              "name": "RT60",
              "subcategories": []
            },
            {
              "id": "cranes-grove-rt65",
              "name": "RT65",
              "subcategories": []
            },
            {
              "id": "cranes-grove-rt75",
              "name": "RT75",
              "subcategories": []
            },
            {
              "id": "cranes-grove-rt422",
              "name": "RT422",
              "subcategories": []
            },
            {
              "id": "cranes-grove-rt500",
              "name": "RT500",
              "subcategories": []
            },
            {
              "id": "cranes-grove-rt518",
              "name": "RT518",
              "subcategories": []
            },
            {
              "id": "cranes-grove-rt522",
              "name": "RT522",
              "subcategories": []
            },
            {
              "id": "cranes-grove-rt525",
              "name": "RT525",
              "subcategories": []
            },
            {
              "id": "cranes-grove-rt528",
              "name": "RT528",
              "subcategories": []
            },
            {
              "id": "cranes-grove-rt530",
              "name": "RT530",
              "subcategories": []
            },
            {
              "id": "cranes-grove-rt535",
              "name": "RT535",
              "subcategories": []
            },
            {
              "id": "cranes-grove-rt540",
              "name": "RT540",
              "subcategories": []
            },
            {
              "id": "cranes-grove-rt550",
              "name": "RT550",
              "subcategories": []
            },
            {
              "id": "cranes-grove-rt600",
              "name": "RT600",
              "subcategories": []
            },
            {
              "id": "cranes-grove-rt620",
              "name": "RT620",
              "subcategories": []
            },
            {
              "id": "cranes-grove-rt625",
              "name": "RT625",
              "subcategories": []
            },
            {
              "id": "cranes-grove-rt630",
              "name": "RT630",
              "subcategories": []
            },
            {
              "id": "cranes-grove-rt635",
              "name": "RT635",
              "subcategories": []
            },
            {
              "id": "cranes-grove-rt640",
              "name": "RT640",
              "subcategories": []
            },
            {
              "id": "cranes-grove-rt650",
              "name": "RT650",
              "subcategories": []
            },
            {
              "id": "cranes-grove-rt700",
              "name": "RT700",
              "subcategories": []
            },
            {
              "id": "cranes-grove-rt740",
              "name": "RT740",
              "subcategories": []
            },
            {
              "id": "cranes-grove-rt745",
              "name": "RT745",
              "subcategories": []
            },
            {
              "id": "cranes-grove-rt750",
              "name": "RT750",
              "subcategories": []
            },
            {
              "id": "cranes-grove-rt760",
              "name": "RT760",
              "subcategories": []
            },
            {
              "id": "cranes-grove-rt765",
              "name": "RT765",
              "subcategories": []
            },
            {
              "id": "cranes-grove-rt770",
              "name": "RT770",
              "subcategories": []
            },
            {
              "id": "cranes-grove-rt800",
              "name": "RT800",
              "subcategories": []
            },
            {
              "id": "cranes-grove-rt855",
              "name": "RT855",
              "subcategories": []
            },
            {
              "id": "cranes-grove-rt865",
              "name": "RT865",
              "subcategories": []
            },
            {
              "id": "cranes-grove-rt870",
              "name": "RT870",
              "subcategories": []
            },
            {
              "id": "cranes-grove-rt875",
              "name": "RT875",
              "subcategories": []
            },
            {
              "id": "cranes-grove-rt880",
              "name": "RT880",
              "subcategories": []
            },
            {
              "id": "cranes-grove-rt890",
              "name": "RT890",
              "subcategories": []
            },
            {
              "id": "cranes-grove-rt980",
              "name": "RT980",
              "subcategories": []
            },
            {
              "id": "cranes-grove-rt9100",
              "name": "RT9100",
              "subcategories": []
            },
            {
              "id": "cranes-grove-rt9130",
              "name": "RT9130",
              "subcategories": []
            },
            {
              "id": "cranes-grove-rt9150",
              "name": "RT9150",
              "subcategories": []
            },
            {
              "id": "cranes-grove-td180",
              "name": "TD180",
              "subcategories": []
            },
            {
              "id": "cranes-grove-tm80-88t",
              "name": "TM80/88T",
              "subcategories": []
            },
            {
              "id": "cranes-grove-tm150",
              "name": "TM150",
              "subcategories": []
            },
            {
              "id": "cranes-grove-tm500",
              "name": "TM500",
              "subcategories": []
            },
            {
              "id": "cranes-grove-tm550",
              "name": "TM550",
              "subcategories": []
            },
            {
              "id": "cranes-grove-tm750",
              "name": "TM750",
              "subcategories": []
            },
            {
              "id": "cranes-grove-tm800",
              "name": "TM800",
              "subcategories": []
            },
            {
              "id": "cranes-grove-tm890",
              "name": "TM890",
              "subcategories": []
            },
            {
              "id": "cranes-grove-tm1150",
              "name": "TM1150",
              "subcategories": []
            },
            {
              "id": "cranes-grove-tm1275",
              "name": "TM1275",
              "subcategories": []
            },
            {
              "id": "cranes-grove-tmss225",
              "name": "TMSS225",
              "subcategories": []
            },
            {
              "id": "cranes-grove-tms250",
              "name": "TMS250",
              "subcategories": []
            },
            {
              "id": "cranes-grove-tms300",
              "name": "TMS300",
              "subcategories": []
            },
            {
              "id": "cranes-grove-tms375",
              "name": "TMS375",
              "subcategories": []
            },
            {
              "id": "cranes-grove-tms475",
              "name": "TMS475",
              "subcategories": []
            },
            {
              "id": "cranes-grove-tms500",
              "name": "TMS500",
              "subcategories": []
            },
            {
              "id": "cranes-grove-tms520",
              "name": "TMS520",
              "subcategories": []
            },
            {
              "id": "cranes-grove-tms635",
              "name": "TMS635",
              "subcategories": []
            },
            {
              "id": "cranes-grove-tms640",
              "name": "TMS640",
              "subcategories": []
            },
            {
              "id": "cranes-grove-tms700",
              "name": "TMS700",
              "subcategories": []
            },
            {
              "id": "cranes-grove-tms760",
              "name": "TMS760",
              "subcategories": []
            },
            {
              "id": "cranes-grove-tms800",
              "name": "TMS800",
              "subcategories": []
            },
            {
              "id": "cranes-grove-tms870",
              "name": "TMS870",
              "subcategories": []
            },
            {
              "id": "cranes-grove-tms880",
              "name": "TMS880",
              "subcategories": []
            },
            {
              "id": "cranes-grove-tms900",
              "name": "TMS900",
              "subcategories": []
            },
            {
              "id": "cranes-grove-tms9000",
              "name": "TMS9000",
              "subcategories": []
            },
            {
              "id": "cranes-grove-tts870",
              "name": "TTS870",
              "subcategories": []
            },
            {
              "id": "cranes-grove-yb4409",
              "name": "YB4409",
              "subcategories": []
            },
            {
              "id": "cranes-grove-yb4410",
              "name": "YB4410",
              "subcategories": []
            },
            {
              "id": "cranes-grove-yb4411",
              "name": "YB4411",
              "subcategories": []
            },
            {
              "id": "cranes-grove-yb5515",
              "name": "YB5515",
              "subcategories": []
            },
            {
              "id": "cranes-grove-yb7725",
              "name": "YB7725",
              "subcategories": []
            },
            {
              "id": "cranes-grove-other",
              "name": "OTHER",
              "subcategories": []
            }
          ]
        },
        {
          "id": "cranes-xcmg",
          "name": "Xcmg",
          "subcategories": [
            {
              "id": "cranes-xcmg-apc6013",
              "name": "APC6013",
              "subcategories": []
            },
            {
              "id": "cranes-xcmg-gks28",
              "name": "GKS28",
              "subcategories": []
            },
            {
              "id": "cranes-xcmg-gsqs200",
              "name": "GSQS200",
              "subcategories": []
            },
            {
              "id": "cranes-xcmg-gsqs300",
              "name": "GSQS300",
              "subcategories": []
            },
            {
              "id": "cranes-xcmg-gsqs350",
              "name": "GSQS350",
              "subcategories": []
            },
            {
              "id": "cranes-xcmg-gsqs400",
              "name": "GSQS400",
              "subcategories": []
            },
            {
              "id": "cranes-xcmg-qay-160",
              "name": "QAY 160",
              "subcategories": []
            },
            {
              "id": "cranes-xcmg-qay-200",
              "name": "QAY 200",
              "subcategories": []
            },
            {
              "id": "cranes-xcmg-qay-240",
              "name": "QAY 240",
              "subcategories": []
            },
            {
              "id": "cranes-xcmg-qay-260",
              "name": "QAY 260",
              "subcategories": []
            },
            {
              "id": "cranes-xcmg-qay-300",
              "name": "QAY 300",
              "subcategories": []
            },
            {
              "id": "cranes-xcmg-qay-400",
              "name": "QAY 400",
              "subcategories": []
            },
            {
              "id": "cranes-xcmg-qay-500",
              "name": "QAY 500",
              "subcategories": []
            },
            {
              "id": "cranes-xcmg-qay-650",
              "name": "QAY 650",
              "subcategories": []
            },
            {
              "id": "cranes-xcmg-qay-800",
              "name": "QAY 800",
              "subcategories": []
            },
            {
              "id": "cranes-xcmg-qay-1000",
              "name": "QAY 1000",
              "subcategories": []
            },
            {
              "id": "cranes-xcmg-qay-1200",
              "name": "QAY 1200",
              "subcategories": []
            },
            {
              "id": "cranes-xcmg-qtz63",
              "name": "QTZ63",
              "subcategories": []
            },
            {
              "id": "cranes-xcmg-quy55",
              "name": "QUY55",
              "subcategories": []
            },
            {
              "id": "cranes-xcmg-quy80",
              "name": "QUY80",
              "subcategories": []
            },
            {
              "id": "cranes-xcmg-quy500",
              "name": "QUY500",
              "subcategories": []
            },
            {
              "id": "cranes-xcmg-qy12",
              "name": "QY12",
              "subcategories": []
            },
            {
              "id": "cranes-xcmg-qy16",
              "name": "QY16",
              "subcategories": []
            },
            {
              "id": "cranes-xcmg-qy20",
              "name": "QY20",
              "subcategories": []
            },
            {
              "id": "cranes-xcmg-qy25",
              "name": "QY25",
              "subcategories": []
            },
            {
              "id": "cranes-xcmg-qy30",
              "name": "QY30",
              "subcategories": []
            },
            {
              "id": "cranes-xcmg-qy35",
              "name": "QY35",
              "subcategories": []
            },
            {
              "id": "cranes-xcmg-qy40",
              "name": "QY40",
              "subcategories": []
            },
            {
              "id": "cranes-xcmg-qy50",
              "name": "QY50",
              "subcategories": []
            },
            {
              "id": "cranes-xcmg-qy55",
              "name": "QY55",
              "subcategories": []
            },
            {
              "id": "cranes-xcmg-qy60",
              "name": "QY60",
              "subcategories": []
            },
            {
              "id": "cranes-xcmg-qy70",
              "name": "QY70",
              "subcategories": []
            },
            {
              "id": "cranes-xcmg-qy75",
              "name": "QY75",
              "subcategories": []
            },
            {
              "id": "cranes-xcmg-qy80",
              "name": "QY80",
              "subcategories": []
            },
            {
              "id": "cranes-xcmg-qy95",
              "name": "QY95",
              "subcategories": []
            },
            {
              "id": "cranes-xcmg-qy100",
              "name": "QY100",
              "subcategories": []
            },
            {
              "id": "cranes-xcmg-qy110",
              "name": "QY110",
              "subcategories": []
            },
            {
              "id": "cranes-xcmg-qy130",
              "name": "QY130",
              "subcategories": []
            },
            {
              "id": "cranes-xcmg-qy180",
              "name": "QY180",
              "subcategories": []
            },
            {
              "id": "cranes-xcmg-sqs300",
              "name": "SQS300",
              "subcategories": []
            },
            {
              "id": "cranes-xcmg-sqs350",
              "name": "SQS350",
              "subcategories": []
            },
            {
              "id": "cranes-xcmg-tsq3sk2q",
              "name": "TSQ3SK2Q",
              "subcategories": []
            },
            {
              "id": "cranes-xcmg-xca40",
              "name": "XCA40",
              "subcategories": []
            },
            {
              "id": "cranes-xcmg-xca60",
              "name": "XCA60",
              "subcategories": []
            },
            {
              "id": "cranes-xcmg-xca80",
              "name": "XCA80",
              "subcategories": []
            },
            {
              "id": "cranes-xcmg-xca100",
              "name": "XCA100",
              "subcategories": []
            },
            {
              "id": "cranes-xcmg-xca130",
              "name": "XCA130",
              "subcategories": []
            },
            {
              "id": "cranes-xcmg-xca160",
              "name": "XCA160",
              "subcategories": []
            },
            {
              "id": "cranes-xcmg-xca180",
              "name": "XCA180",
              "subcategories": []
            },
            {
              "id": "cranes-xcmg-xca200",
              "name": "XCA200",
              "subcategories": []
            },
            {
              "id": "cranes-xcmg-xca220",
              "name": "XCA220",
              "subcategories": []
            },
            {
              "id": "cranes-xcmg-xca230",
              "name": "XCA230",
              "subcategories": []
            },
            {
              "id": "cranes-xcmg-xca250",
              "name": "XCA250",
              "subcategories": []
            },
            {
              "id": "cranes-xcmg-xca260",
              "name": "XCA260",
              "subcategories": []
            },
            {
              "id": "cranes-xcmg-xca300",
              "name": "XCA300",
              "subcategories": []
            },
            {
              "id": "cranes-xcmg-xca350",
              "name": "XCA350",
              "subcategories": []
            },
            {
              "id": "cranes-xcmg-xca460",
              "name": "XCA460",
              "subcategories": []
            },
            {
              "id": "cranes-xcmg-xca500",
              "name": "XCA500",
              "subcategories": []
            },
            {
              "id": "cranes-xcmg-xca550",
              "name": "XCA550",
              "subcategories": []
            },
            {
              "id": "cranes-xcmg-xca600",
              "name": "XCA600",
              "subcategories": []
            },
            {
              "id": "cranes-xcmg-xca700",
              "name": "XCA700",
              "subcategories": []
            },
            {
              "id": "cranes-xcmg-xca750",
              "name": "XCA750",
              "subcategories": []
            },
            {
              "id": "cranes-xcmg-xca1200",
              "name": "XCA1200",
              "subcategories": []
            },
            {
              "id": "cranes-xcmg-xca1600",
              "name": "XCA1600",
              "subcategories": []
            },
            {
              "id": "cranes-xcmg-xcp330",
              "name": "XCP330",
              "subcategories": []
            },
            {
              "id": "cranes-xcmg-xcr25",
              "name": "XCR25",
              "subcategories": []
            },
            {
              "id": "cranes-xcmg-xcr30",
              "name": "XCR30",
              "subcategories": []
            },
            {
              "id": "cranes-xcmg-xcr40",
              "name": "XCR40",
              "subcategories": []
            },
            {
              "id": "cranes-xcmg-xcr50",
              "name": "XCR50",
              "subcategories": []
            },
            {
              "id": "cranes-xcmg-xcr55",
              "name": "XCR55",
              "subcategories": []
            },
            {
              "id": "cranes-xcmg-xcr60",
              "name": "XCR60",
              "subcategories": []
            },
            {
              "id": "cranes-xcmg-xcr70",
              "name": "XCR70",
              "subcategories": []
            },
            {
              "id": "cranes-xcmg-xcr90",
              "name": "XCR90",
              "subcategories": []
            },
            {
              "id": "cranes-xcmg-xcr90",
              "name": "XCR90",
              "subcategories": []
            },
            {
              "id": "cranes-xcmg-xcr100",
              "name": "XCR100",
              "subcategories": []
            },
            {
              "id": "cranes-xcmg-xcr130",
              "name": "XCR130",
              "subcategories": []
            },
            {
              "id": "cranes-xcmg-xct12",
              "name": "XCT12",
              "subcategories": []
            },
            {
              "id": "cranes-xcmg-xct16",
              "name": "XCT16",
              "subcategories": []
            },
            {
              "id": "cranes-xcmg-xct20",
              "name": "XCT20",
              "subcategories": []
            },
            {
              "id": "cranes-xcmg-xct25",
              "name": "XCT25",
              "subcategories": []
            },
            {
              "id": "cranes-xcmg-xct45",
              "name": "XCT45",
              "subcategories": []
            },
            {
              "id": "cranes-xcmg-xct80",
              "name": "XCT80",
              "subcategories": []
            },
            {
              "id": "cranes-xcmg-xct95",
              "name": "XCT95",
              "subcategories": []
            },
            {
              "id": "cranes-xcmg-xct100",
              "name": "XCT100",
              "subcategories": []
            },
            {
              "id": "cranes-xcmg-xct110",
              "name": "XCT110",
              "subcategories": []
            },
            {
              "id": "cranes-xcmg-xct30",
              "name": "XCT30",
              "subcategories": []
            },
            {
              "id": "cranes-xcmg-xct35",
              "name": "XCT35",
              "subcategories": []
            },
            {
              "id": "cranes-xcmg-xct40",
              "name": "XCT40",
              "subcategories": []
            },
            {
              "id": "cranes-xcmg-xct50",
              "name": "XCT50",
              "subcategories": []
            },
            {
              "id": "cranes-xcmg-xct55",
              "name": "XCT55",
              "subcategories": []
            },
            {
              "id": "cranes-xcmg-xct60",
              "name": "XCT60",
              "subcategories": []
            },
            {
              "id": "cranes-xcmg-xct70",
              "name": "XCT70",
              "subcategories": []
            },
            {
              "id": "cranes-xcmg-xct75",
              "name": "XCT75",
              "subcategories": []
            },
            {
              "id": "cranes-xcmg-xct85",
              "name": "XCT85",
              "subcategories": []
            },
            {
              "id": "cranes-xcmg-xct90",
              "name": "XCT90",
              "subcategories": []
            },
            {
              "id": "cranes-xcmg-xct100",
              "name": "XCT100",
              "subcategories": []
            },
            {
              "id": "cranes-xcmg-xct130",
              "name": "XCT130",
              "subcategories": []
            },
            {
              "id": "cranes-xcmg-xga5610",
              "name": "XGA5610",
              "subcategories": []
            },
            {
              "id": "cranes-xcmg-xga6012",
              "name": "XGA6012",
              "subcategories": []
            },
            {
              "id": "cranes-xcmg-xga6013",
              "name": "XGA6013",
              "subcategories": []
            },
            {
              "id": "cranes-xcmg-xgc25",
              "name": "XGC25",
              "subcategories": []
            },
            {
              "id": "cranes-xcmg-xgc30",
              "name": "XGC30",
              "subcategories": []
            },
            {
              "id": "cranes-xcmg-xgc40",
              "name": "XGC40",
              "subcategories": []
            },
            {
              "id": "cranes-xcmg-xgc55",
              "name": "XGC55",
              "subcategories": []
            },
            {
              "id": "cranes-xcmg-xgc75",
              "name": "XGC75",
              "subcategories": []
            },
            {
              "id": "cranes-xcmg-xgc85",
              "name": "XGC85",
              "subcategories": []
            },
            {
              "id": "cranes-xcmg-xgc100",
              "name": "XGC100",
              "subcategories": []
            },
            {
              "id": "cranes-xcmg-xgc130",
              "name": "XGC130",
              "subcategories": []
            },
            {
              "id": "cranes-xcmg-xgc150",
              "name": "XGC150",
              "subcategories": []
            },
            {
              "id": "cranes-xcmg-xgc180",
              "name": "XGC180",
              "subcategories": []
            },
            {
              "id": "cranes-xcmg-xgc260",
              "name": "XGC260",
              "subcategories": []
            },
            {
              "id": "cranes-xcmg-xgc300",
              "name": "XGC300",
              "subcategories": []
            },
            {
              "id": "cranes-xcmg-xgc400",
              "name": "XGC400",
              "subcategories": []
            },
            {
              "id": "cranes-xcmg-xgc500",
              "name": "XGC500",
              "subcategories": []
            },
            {
              "id": "cranes-xcmg-xgc650",
              "name": "XGC650",
              "subcategories": []
            },
            {
              "id": "cranes-xcmg-xgc800",
              "name": "XGC800",
              "subcategories": []
            },
            {
              "id": "cranes-xcmg-xgc2100",
              "name": "XGC2100",
              "subcategories": []
            },
            {
              "id": "cranes-xcmg-xgc11000",
              "name": "XGC11000",
              "subcategories": []
            },
            {
              "id": "cranes-xcmg-xgc12000",
              "name": "XGC12000",
              "subcategories": []
            },
            {
              "id": "cranes-xcmg-xgc15000",
              "name": "XGC15000",
              "subcategories": []
            },
            {
              "id": "cranes-xcmg-xgc16000",
              "name": "XGC16000",
              "subcategories": []
            },
            {
              "id": "cranes-xcmg-xgc28000",
              "name": "XGC28000",
              "subcategories": []
            },
            {
              "id": "cranes-xcmg-xgt360",
              "name": "XGT360",
              "subcategories": []
            },
            {
              "id": "cranes-xcmg-xgt600",
              "name": "XGT600",
              "subcategories": []
            },
            {
              "id": "cranes-xcmg-xgt1350",
              "name": "XGT1350",
              "subcategories": []
            },
            {
              "id": "cranes-xcmg-xgt5610",
              "name": "XGT5610",
              "subcategories": []
            },
            {
              "id": "cranes-xcmg-xgt6010",
              "name": "XGT6010",
              "subcategories": []
            },
            {
              "id": "cranes-xcmg-xgt6013",
              "name": "XGT6013",
              "subcategories": []
            },
            {
              "id": "cranes-xcmg-xgt6015",
              "name": "XGT6015",
              "subcategories": []
            },
            {
              "id": "cranes-xcmg-xgt6018",
              "name": "XGT6018",
              "subcategories": []
            },
            {
              "id": "cranes-xcmg-xgt6513",
              "name": "XGT6513",
              "subcategories": []
            },
            {
              "id": "cranes-xcmg-xgt6515",
              "name": "XGT6515",
              "subcategories": []
            },
            {
              "id": "cranes-xcmg-xgt6522",
              "name": "XGT6522",
              "subcategories": []
            },
            {
              "id": "cranes-xcmg-xgt7020",
              "name": "XGT7020",
              "subcategories": []
            },
            {
              "id": "cranes-xcmg-xgt7022",
              "name": "XGT7022",
              "subcategories": []
            },
            {
              "id": "cranes-xcmg-xgt7026",
              "name": "XGT7026",
              "subcategories": []
            },
            {
              "id": "cranes-xcmg-xgt7528",
              "name": "XGT7528",
              "subcategories": []
            },
            {
              "id": "cranes-xcmg-xgtl120",
              "name": "XGTL120",
              "subcategories": []
            },
            {
              "id": "cranes-xcmg-xlc260m",
              "name": "XLC260M",
              "subcategories": []
            },
            {
              "id": "cranes-xcmg-xzj5290",
              "name": "XZJ5290",
              "subcategories": []
            },
            {
              "id": "cranes-xcmg-other",
              "name": "OTHER",
              "subcategories": []
            }
          ]
        },
        {
          "id": "cranes-liebherr",
          "name": "Liebherr",
          "subcategories": [
            {
              "id": "cranes-liebherr-20k",
              "name": "20K",
              "subcategories": []
            },
            {
              "id": "cranes-liebherr-24k",
              "name": "24K",
              "subcategories": []
            },
            {
              "id": "cranes-liebherr-56k",
              "name": "56K",
              "subcategories": []
            },
            {
              "id": "cranes-liebherr-81k",
              "name": "81K",
              "subcategories": []
            },
            {
              "id": "cranes-liebherr-112k",
              "name": "112K",
              "subcategories": []
            },
            {
              "id": "cranes-liebherr-120k",
              "name": "120K",
              "subcategories": []
            },
            {
              "id": "cranes-liebherr-200",
              "name": "200",
              "subcategories": []
            },
            {
              "id": "cranes-liebherr-245",
              "name": "245",
              "subcategories": []
            },
            {
              "id": "cranes-liebherr-290",
              "name": "290",
              "subcategories": []
            },
            {
              "id": "cranes-liebherr-355",
              "name": "355",
              "subcategories": []
            },
            {
              "id": "cranes-liebherr-357",
              "name": "357",
              "subcategories": []
            },
            {
              "id": "cranes-liebherr-420",
              "name": "420",
              "subcategories": []
            },
            {
              "id": "cranes-liebherr-550",
              "name": "550",
              "subcategories": []
            },
            {
              "id": "cranes-liebherr-710",
              "name": "710",
              "subcategories": []
            },
            {
              "id": "cranes-liebherr-hs841",
              "name": "HS841",
              "subcategories": []
            },
            {
              "id": "cranes-liebherr-hs842",
              "name": "HS842",
              "subcategories": []
            },
            {
              "id": "cranes-liebherr-hs843",
              "name": "HS843",
              "subcategories": []
            },
            {
              "id": "cranes-liebherr-hs845",
              "name": "HS845",
              "subcategories": []
            },
            {
              "id": "cranes-liebherr-hs853",
              "name": "HS853",
              "subcategories": []
            },
            {
              "id": "cranes-liebherr-hs855",
              "name": "HS855",
              "subcategories": []
            },
            {
              "id": "cranes-liebherr-hs872",
              "name": "HS872",
              "subcategories": []
            },
            {
              "id": "cranes-liebherr-hs873",
              "name": "HS873",
              "subcategories": []
            },
            {
              "id": "cranes-liebherr-hs875",
              "name": "HS875",
              "subcategories": []
            },
            {
              "id": "cranes-liebherr-hs883",
              "name": "HS883",
              "subcategories": []
            },
            {
              "id": "cranes-liebherr-hs885",
              "name": "HS885",
              "subcategories": []
            },
            {
              "id": "cranes-liebherr-hs8100",
              "name": "HS8100",
              "subcategories": []
            },
            {
              "id": "cranes-liebherr-hs8130",
              "name": "HS8130",
              "subcategories": []
            },
            {
              "id": "cranes-liebherr-hs8200",
              "name": "HS8200",
              "subcategories": []
            },
            {
              "id": "cranes-liebherr-lg1550",
              "name": "LG1550",
              "subcategories": []
            },
            {
              "id": "cranes-liebherr-lg1750",
              "name": "LG1750",
              "subcategories": []
            },
            {
              "id": "cranes-liebherr-lgd1550",
              "name": "LGD1550",
              "subcategories": []
            },
            {
              "id": "cranes-liebherr-lgd1800",
              "name": "LGD1800",
              "subcategories": []
            },
            {
              "id": "cranes-liebherr-lhm250",
              "name": "LHM250",
              "subcategories": []
            },
            {
              "id": "cranes-liebherr-lhm400",
              "name": "LHM400",
              "subcategories": []
            },
            {
              "id": "cranes-liebherr-lhm1200",
              "name": "LHM1200",
              "subcategories": []
            },
            {
              "id": "cranes-liebherr-lhm1300",
              "name": "LHM1300",
              "subcategories": []
            },
            {
              "id": "cranes-liebherr-lr1100",
              "name": "LR1100",
              "subcategories": []
            },
            {
              "id": "cranes-liebherr-lr1110",
              "name": "LR1110",
              "subcategories": []
            },
            {
              "id": "cranes-liebherr-lr1130",
              "name": "LR1130",
              "subcategories": []
            },
            {
              "id": "cranes-liebherr-lr1140",
              "name": "LR1140",
              "subcategories": []
            },
            {
              "id": "cranes-liebherr-lr1160",
              "name": "LR1160",
              "subcategories": []
            },
            {
              "id": "cranes-liebherr-lr1200",
              "name": "LR1200",
              "subcategories": []
            },
            {
              "id": "cranes-liebherr-lr1250",
              "name": "LR1250",
              "subcategories": []
            },
            {
              "id": "cranes-liebherr-lr1280",
              "name": "LR1280",
              "subcategories": []
            },
            {
              "id": "cranes-liebherr-lr1300",
              "name": "LR1300",
              "subcategories": []
            },
            {
              "id": "cranes-liebherr-lr1350",
              "name": "LR1350",
              "subcategories": []
            },
            {
              "id": "cranes-liebherr-lr1400",
              "name": "LR1400",
              "subcategories": []
            },
            {
              "id": "cranes-liebherr-lr1500",
              "name": "LR1500",
              "subcategories": []
            },
            {
              "id": "cranes-liebherr-lr1550",
              "name": "LR1550",
              "subcategories": []
            },
            {
              "id": "cranes-liebherr-lr1600",
              "name": "LR1600",
              "subcategories": []
            },
            {
              "id": "cranes-liebherr-lr1650",
              "name": "LR1650",
              "subcategories": []
            },
            {
              "id": "cranes-liebherr-lr1750",
              "name": "LR1750",
              "subcategories": []
            },
            {
              "id": "cranes-liebherr-lr1800",
              "name": "LR1800",
              "subcategories": []
            },
            {
              "id": "cranes-liebherr-lr11000",
              "name": "LR11000",
              "subcategories": []
            },
            {
              "id": "cranes-liebherr-ltr11350",
              "name": "LTR11350",
              "subcategories": []
            },
            {
              "id": "cranes-liebherr-lrt1090",
              "name": "LRT1090",
              "subcategories": []
            },
            {
              "id": "cranes-liebherr-lrt1100",
              "name": "LRT1100",
              "subcategories": []
            },
            {
              "id": "cranes-liebherr-lt1055",
              "name": "LT1055",
              "subcategories": []
            },
            {
              "id": "cranes-liebherr-ltc1045",
              "name": "LTC1045",
              "subcategories": []
            },
            {
              "id": "cranes-liebherr-ltc1050",
              "name": "LTC1050",
              "subcategories": []
            },
            {
              "id": "cranes-liebherr-ltc1055",
              "name": "LTC1055",
              "subcategories": []
            },
            {
              "id": "cranes-liebherr-ltf1035",
              "name": "LTF1035",
              "subcategories": []
            },
            {
              "id": "cranes-liebherr-ltf1045",
              "name": "LTF1045",
              "subcategories": []
            },
            {
              "id": "cranes-liebherr-ltl1030",
              "name": "LTL1030",
              "subcategories": []
            },
            {
              "id": "cranes-liebherr-ltm1025",
              "name": "LTM1025",
              "subcategories": []
            },
            {
              "id": "cranes-liebherr-ltm1030",
              "name": "LTM1030",
              "subcategories": []
            },
            {
              "id": "cranes-liebherr-ltm1035",
              "name": "LTM1035",
              "subcategories": []
            },
            {
              "id": "cranes-liebherr-ltm1040",
              "name": "LTM1040",
              "subcategories": []
            },
            {
              "id": "cranes-liebherr-ltm1045",
              "name": "LTM1045",
              "subcategories": []
            },
            {
              "id": "cranes-liebherr-ltm1050",
              "name": "LTM1050",
              "subcategories": []
            },
            {
              "id": "cranes-liebherr-ltm1055",
              "name": "LTM1055",
              "subcategories": []
            },
            {
              "id": "cranes-liebherr-ltm1060",
              "name": "LTM1060",
              "subcategories": []
            },
            {
              "id": "cranes-liebherr-ltm1070",
              "name": "LTM1070",
              "subcategories": []
            },
            {
              "id": "cranes-liebherr-ltm1080",
              "name": "LTM1080",
              "subcategories": []
            },
            {
              "id": "cranes-liebherr-ltm1090",
              "name": "LTM1090",
              "subcategories": []
            },
            {
              "id": "cranes-liebherr-ltm1095",
              "name": "LTM1095",
              "subcategories": []
            },
            {
              "id": "cranes-liebherr-ltm1100",
              "name": "LTM1100",
              "subcategories": []
            },
            {
              "id": "cranes-liebherr-ltm1110",
              "name": "LTM1110",
              "subcategories": []
            },
            {
              "id": "cranes-liebherr-ltm1120",
              "name": "LTM1120",
              "subcategories": []
            },
            {
              "id": "cranes-liebherr-ltm1130",
              "name": "LTM1130",
              "subcategories": []
            },
            {
              "id": "cranes-liebherr-ltm1150",
              "name": "LTM1150",
              "subcategories": []
            },
            {
              "id": "cranes-liebherr-ltm1160",
              "name": "LTM1160",
              "subcategories": []
            },
            {
              "id": "cranes-liebherr-ltm1200",
              "name": "LTM1200",
              "subcategories": []
            },
            {
              "id": "cranes-liebherr-ltm1220",
              "name": "LTM1220",
              "subcategories": []
            },
            {
              "id": "cranes-liebherr-ltm1225",
              "name": "LTM1225",
              "subcategories": []
            },
            {
              "id": "cranes-liebherr-ltm1230",
              "name": "LTM1230",
              "subcategories": []
            },
            {
              "id": "cranes-liebherr-ltm1250",
              "name": "LTM1250",
              "subcategories": []
            },
            {
              "id": "cranes-liebherr-ltm1300",
              "name": "LTM1300",
              "subcategories": []
            },
            {
              "id": "cranes-liebherr-ltm1350",
              "name": "LTM1350",
              "subcategories": []
            },
            {
              "id": "cranes-liebherr-ltm1400",
              "name": "LTM1400",
              "subcategories": []
            },
            {
              "id": "cranes-liebherr-ltm1450",
              "name": "LTM1450",
              "subcategories": []
            },
            {
              "id": "cranes-liebherr-ltm1500",
              "name": "LTM1500",
              "subcategories": []
            },
            {
              "id": "cranes-liebherr-ltm1650",
              "name": "LTM1650",
              "subcategories": []
            },
            {
              "id": "cranes-liebherr-ltm1750",
              "name": "LTM1750",
              "subcategories": []
            },
            {
              "id": "cranes-liebherr-ltm1800",
              "name": "LTM1800",
              "subcategories": []
            },
            {
              "id": "cranes-liebherr-ltm11200",
              "name": "LTM11200",
              "subcategories": []
            },
            {
              "id": "cranes-liebherr-ltr1060",
              "name": "LTR1060",
              "subcategories": []
            },
            {
              "id": "cranes-liebherr-ltr1100",
              "name": "LTR1100",
              "subcategories": []
            },
            {
              "id": "cranes-liebherr-ltr1150",
              "name": "LTR1150",
              "subcategories": []
            },
            {
              "id": "cranes-liebherr-ltr1220",
              "name": "LTR1220",
              "subcategories": []
            },
            {
              "id": "cranes-liebherr-ltr11200",
              "name": "LTR11200",
              "subcategories": []
            },
            {
              "id": "cranes-liebherr-mk63",
              "name": "MK63",
              "subcategories": []
            },
            {
              "id": "cranes-liebherr-mk88",
              "name": "MK88",
              "subcategories": []
            },
            {
              "id": "cranes-liebherr-mk100",
              "name": "MK100",
              "subcategories": []
            },
            {
              "id": "cranes-liebherr-mk140",
              "name": "MK140",
              "subcategories": []
            },
            {
              "id": "cranes-liebherr-other",
              "name": "OTHER",
              "subcategories": []
            }
          ]
        },
        {
          "id": "cranes-tadano",
          "name": "Tadano",
          "subcategories": [
            {
              "id": "cranes-tadano-ac2",
              "name": "AC2",
              "subcategories": []
            },
            {
              "id": "cranes-tadano-ac3",
              "name": "AC3",
              "subcategories": []
            },
            {
              "id": "cranes-tadano-ac4",
              "name": "AC4",
              "subcategories": []
            },
            {
              "id": "cranes-tadano-ac5",
              "name": "AC5",
              "subcategories": []
            },
            {
              "id": "cranes-tadano-ac6",
              "name": "AC6",
              "subcategories": []
            },
            {
              "id": "cranes-tadano-ac7",
              "name": "AC7",
              "subcategories": []
            },
            {
              "id": "cranes-tadano-ac8",
              "name": "AC8",
              "subcategories": []
            },
            {
              "id": "cranes-tadano-ar1000",
              "name": "AR1000",
              "subcategories": []
            },
            {
              "id": "cranes-tadano-at250",
              "name": "AT250",
              "subcategories": []
            },
            {
              "id": "cranes-tadano-atf40",
              "name": "ATF40",
              "subcategories": []
            },
            {
              "id": "cranes-tadano-atf45",
              "name": "ATF45",
              "subcategories": []
            },
            {
              "id": "cranes-tadano-atf50",
              "name": "ATF50",
              "subcategories": []
            },
            {
              "id": "cranes-tadano-atf60",
              "name": "ATF60",
              "subcategories": []
            },
            {
              "id": "cranes-tadano-atf65",
              "name": "ATF65",
              "subcategories": []
            },
            {
              "id": "cranes-tadano-atf70",
              "name": "ATF70",
              "subcategories": []
            },
            {
              "id": "cranes-tadano-atf80",
              "name": "ATF80",
              "subcategories": []
            },
            {
              "id": "cranes-tadano-atf100",
              "name": "ATF100",
              "subcategories": []
            },
            {
              "id": "cranes-tadano-atf110",
              "name": "ATF110",
              "subcategories": []
            },
            {
              "id": "cranes-tadano-atf130",
              "name": "ATF130",
              "subcategories": []
            },
            {
              "id": "cranes-tadano-atf160",
              "name": "ATF160",
              "subcategories": []
            },
            {
              "id": "cranes-tadano-atf200",
              "name": "ATF200",
              "subcategories": []
            },
            {
              "id": "cranes-tadano-atf220",
              "name": "ATF220",
              "subcategories": []
            },
            {
              "id": "cranes-tadano-atf400",
              "name": "ATF400",
              "subcategories": []
            },
            {
              "id": "cranes-tadano-atf500",
              "name": "ATF500",
              "subcategories": []
            },
            {
              "id": "cranes-tadano-cc24",
              "name": "CC24",
              "subcategories": []
            },
            {
              "id": "cranes-tadano-cc28",
              "name": "CC28",
              "subcategories": []
            },
            {
              "id": "cranes-tadano-cc38",
              "name": "CC38",
              "subcategories": []
            },
            {
              "id": "cranes-tadano-cc68",
              "name": "CC68",
              "subcategories": []
            },
            {
              "id": "cranes-tadano-cc88",
              "name": "CC88",
              "subcategories": []
            },
            {
              "id": "cranes-tadano-egr100",
              "name": "EGR100",
              "subcategories": []
            },
            {
              "id": "cranes-tadano-gr120",
              "name": "GR120",
              "subcategories": []
            },
            {
              "id": "cranes-tadano-gr150",
              "name": "GR150",
              "subcategories": []
            },
            {
              "id": "cranes-tadano-gr160",
              "name": "GR160",
              "subcategories": []
            },
            {
              "id": "cranes-tadano-gr250",
              "name": "GR250",
              "subcategories": []
            },
            {
              "id": "cranes-tadano-gr300",
              "name": "GR300",
              "subcategories": []
            },
            {
              "id": "cranes-tadano-gr350",
              "name": "GR350",
              "subcategories": []
            },
            {
              "id": "cranes-tadano-gr500",
              "name": "GR500",
              "subcategories": []
            },
            {
              "id": "cranes-tadano-gr550",
              "name": "GR550",
              "subcategories": []
            },
            {
              "id": "cranes-tadano-gr600",
              "name": "GR600",
              "subcategories": []
            },
            {
              "id": "cranes-tadano-gr700",
              "name": "GR700",
              "subcategories": []
            },
            {
              "id": "cranes-tadano-gr750",
              "name": "GR750",
              "subcategories": []
            },
            {
              "id": "cranes-tadano-gr800",
              "name": "GR800",
              "subcategories": []
            },
            {
              "id": "cranes-tadano-gr900",
              "name": "GR900",
              "subcategories": []
            },
            {
              "id": "cranes-tadano-gr1000",
              "name": "GR1000",
              "subcategories": []
            },
            {
              "id": "cranes-tadano-gr1200",
              "name": "GR1200",
              "subcategories": []
            },
            {
              "id": "cranes-tadano-gr1300",
              "name": "GR1300",
              "subcategories": []
            },
            {
              "id": "cranes-tadano-gr1600",
              "name": "GR1600",
              "subcategories": []
            },
            {
              "id": "cranes-tadano-gt350",
              "name": "GT350",
              "subcategories": []
            },
            {
              "id": "cranes-tadano-gt800",
              "name": "GT800",
              "subcategories": []
            },
            {
              "id": "cranes-tadano-gt900",
              "name": "GT900",
              "subcategories": []
            },
            {
              "id": "cranes-tadano-gt1200",
              "name": "GT1200",
              "subcategories": []
            },
            {
              "id": "cranes-tadano-gtc350",
              "name": "GTC350",
              "subcategories": []
            },
            {
              "id": "cranes-tadano-gtc550",
              "name": "GTC550",
              "subcategories": []
            },
            {
              "id": "cranes-tadano-gtc600",
              "name": "GTC600",
              "subcategories": []
            },
            {
              "id": "cranes-tadano-gtc700",
              "name": "GTC700",
              "subcategories": []
            },
            {
              "id": "cranes-tadano-gtc900",
              "name": "GTC900",
              "subcategories": []
            },
            {
              "id": "cranes-tadano-gtc1300",
              "name": "GTC1300",
              "subcategories": []
            },
            {
              "id": "cranes-tadano-gtc1600",
              "name": "GTC1600",
              "subcategories": []
            },
            {
              "id": "cranes-tadano-gtc2000",
              "name": "GTC2000",
              "subcategories": []
            },
            {
              "id": "cranes-tadano-hk40",
              "name": "HK40",
              "subcategories": []
            },
            {
              "id": "cranes-tadano-hk70",
              "name": "HK70",
              "subcategories": []
            },
            {
              "id": "cranes-tadano-tg80",
              "name": "TG80",
              "subcategories": []
            },
            {
              "id": "cranes-tadano-tg500",
              "name": "TG500",
              "subcategories": []
            },
            {
              "id": "cranes-tadano-tg1000",
              "name": "TG1000",
              "subcategories": []
            },
            {
              "id": "cranes-tadano-tg1500",
              "name": "TG1500",
              "subcategories": []
            },
            {
              "id": "cranes-tadano-tgl300",
              "name": "TGL300",
              "subcategories": []
            },
            {
              "id": "cranes-tadano-tl250",
              "name": "TL250",
              "subcategories": []
            },
            {
              "id": "cranes-tadano-tl300",
              "name": "TL300",
              "subcategories": []
            },
            {
              "id": "cranes-tadano-tm1882",
              "name": "TM1882",
              "subcategories": []
            },
            {
              "id": "cranes-tadano-tmzr505",
              "name": "TMZR505",
              "subcategories": []
            },
            {
              "id": "cranes-tadano-tr80",
              "name": "TR80",
              "subcategories": []
            },
            {
              "id": "cranes-tadano-tr100",
              "name": "TR100",
              "subcategories": []
            },
            {
              "id": "cranes-tadano-tr160",
              "name": "TR160",
              "subcategories": []
            },
            {
              "id": "cranes-tadano-tr200",
              "name": "TR200",
              "subcategories": []
            },
            {
              "id": "cranes-tadano-tr250",
              "name": "TR250",
              "subcategories": []
            },
            {
              "id": "cranes-tadano-tr300",
              "name": "TR300",
              "subcategories": []
            },
            {
              "id": "cranes-tadano-tr350",
              "name": "TR350",
              "subcategories": []
            },
            {
              "id": "cranes-tadano-tr450",
              "name": "TR450",
              "subcategories": []
            },
            {
              "id": "cranes-tadano-tr500",
              "name": "TR500",
              "subcategories": []
            },
            {
              "id": "cranes-tadano-tr600",
              "name": "TR600",
              "subcategories": []
            },
            {
              "id": "cranes-tadano-tr800",
              "name": "TR800",
              "subcategories": []
            },
            {
              "id": "cranes-tadano-ts7",
              "name": "TS7",
              "subcategories": []
            },
            {
              "id": "cranes-tadano-tt300",
              "name": "TT300",
              "subcategories": []
            },
            {
              "id": "cranes-tadano-tt600",
              "name": "TT600",
              "subcategories": []
            },
            {
              "id": "cranes-tadano-other",
              "name": "OTHER",
              "subcategories": []
            }
          ]
        },
        {
          "id": "cranes-link-belt",
          "name": "Link-Belt",
          "subcategories": [
            {
              "id": "cranes-link-belt-65",
              "name": "65",
              "subcategories": []
            },
            {
              "id": "cranes-link-belt-75",
              "name": "75",
              "subcategories": []
            },
            {
              "id": "cranes-link-belt-80",
              "name": "80",
              "subcategories": []
            },
            {
              "id": "cranes-link-belt-85",
              "name": "85",
              "subcategories": []
            },
            {
              "id": "cranes-link-belt-90",
              "name": "90",
              "subcategories": []
            },
            {
              "id": "cranes-link-belt-100",
              "name": "100",
              "subcategories": []
            },
            {
              "id": "cranes-link-belt-110",
              "name": "110",
              "subcategories": []
            },
            {
              "id": "cranes-link-belt-120",
              "name": "120",
              "subcategories": []
            },
            {
              "id": "cranes-link-belt-138",
              "name": "138",
              "subcategories": []
            },
            {
              "id": "cranes-link-belt-175",
              "name": "175",
              "subcategories": []
            },
            {
              "id": "cranes-link-belt-218",
              "name": "218",
              "subcategories": []
            },
            {
              "id": "cranes-link-belt-228",
              "name": "228",
              "subcategories": []
            },
            {
              "id": "cranes-link-belt-238",
              "name": "238",
              "subcategories": []
            },
            {
              "id": "cranes-link-belt-248",
              "name": "248",
              "subcategories": []
            },
            {
              "id": "cranes-link-belt-298",
              "name": "298",
              "subcategories": []
            },
            {
              "id": "cranes-link-belt-300",
              "name": "300",
              "subcategories": []
            },
            {
              "id": "cranes-link-belt-348",
              "name": "348",
              "subcategories": []
            },
            {
              "id": "cranes-link-belt-atc822",
              "name": "ATC822",
              "subcategories": []
            },
            {
              "id": "cranes-link-belt-atc3210",
              "name": "ATC3210",
              "subcategories": []
            },
            {
              "id": "cranes-link-belt-atc3250",
              "name": "ATC3250",
              "subcategories": []
            },
            {
              "id": "cranes-link-belt-atc3275",
              "name": "ATC3275",
              "subcategories": []
            },
            {
              "id": "cranes-link-belt-hc108",
              "name": "HC108",
              "subcategories": []
            },
            {
              "id": "cranes-link-belt-hc138",
              "name": "HC138",
              "subcategories": []
            },
            {
              "id": "cranes-link-belt-hc218",
              "name": "HC218",
              "subcategories": []
            },
            {
              "id": "cranes-link-belt-hc228",
              "name": "HC228",
              "subcategories": []
            },
            {
              "id": "cranes-link-belt-hc238",
              "name": "HC238",
              "subcategories": []
            },
            {
              "id": "cranes-link-belt-hc258",
              "name": "HC258",
              "subcategories": []
            },
            {
              "id": "cranes-link-belt-hc268",
              "name": "HC268",
              "subcategories": []
            },
            {
              "id": "cranes-link-belt-hc278",
              "name": "HC278",
              "subcategories": []
            },
            {
              "id": "cranes-link-belt-hc518",
              "name": "HC518",
              "subcategories": []
            },
            {
              "id": "cranes-link-belt-hsp25",
              "name": "HSP25",
              "subcategories": []
            },
            {
              "id": "cranes-link-belt-hsp4035",
              "name": "HSP4035",
              "subcategories": []
            },
            {
              "id": "cranes-link-belt-hsp8018",
              "name": "HSP8018",
              "subcategories": []
            },
            {
              "id": "cranes-link-belt-hsp8030",
              "name": "HSP8030",
              "subcategories": []
            },
            {
              "id": "cranes-link-belt-hsp8040",
              "name": "HSP8040",
              "subcategories": []
            },
            {
              "id": "cranes-link-belt-hsp8050",
              "name": "HSP8050",
              "subcategories": []
            },
            {
              "id": "cranes-link-belt-hsp8055",
              "name": "HSP8055",
              "subcategories": []
            },
            {
              "id": "cranes-link-belt-hsp8060",
              "name": "HSP8060",
              "subcategories": []
            },
            {
              "id": "cranes-link-belt-ht300",
              "name": "HT300",
              "subcategories": []
            },
            {
              "id": "cranes-link-belt-ht400",
              "name": "HT400",
              "subcategories": []
            },
            {
              "id": "cranes-link-belt-htc14",
              "name": "HTC14",
              "subcategories": []
            },
            {
              "id": "cranes-link-belt-htc25",
              "name": "HTC25",
              "subcategories": []
            },
            {
              "id": "cranes-link-belt-htc35",
              "name": "HTC35",
              "subcategories": []
            },
            {
              "id": "cranes-link-belt-htc50",
              "name": "HTC50",
              "subcategories": []
            },
            {
              "id": "cranes-link-belt-htc835",
              "name": "HTC835",
              "subcategories": []
            },
            {
              "id": "cranes-link-belt-htc850",
              "name": "HTC850",
              "subcategories": []
            },
            {
              "id": "cranes-link-belt-htc867",
              "name": "HTC867",
              "subcategories": []
            },
            {
              "id": "cranes-link-belt-htc1040",
              "name": "HTC1040",
              "subcategories": []
            },
            {
              "id": "cranes-link-belt-htc3140",
              "name": "HTC3140",
              "subcategories": []
            },
            {
              "id": "cranes-link-belt-htc8040",
              "name": "HTC8040",
              "subcategories": []
            },
            {
              "id": "cranes-link-belt-htc83635",
              "name": "HTC83635",
              "subcategories": []
            },
            {
              "id": "cranes-link-belt-htc8640",
              "name": "HTC8640",
              "subcategories": []
            },
            {
              "id": "cranes-link-belt-htc8650",
              "name": "HTC8650",
              "subcategories": []
            },
            {
              "id": "cranes-link-belt-htc8660",
              "name": "HTC8660",
              "subcategories": []
            },
            {
              "id": "cranes-link-belt-htc8670",
              "name": "HTC8670",
              "subcategories": []
            },
            {
              "id": "cranes-link-belt-htc8675",
              "name": "HTC8675",
              "subcategories": []
            },
            {
              "id": "cranes-link-belt-htc8690",
              "name": "HTC8690",
              "subcategories": []
            },
            {
              "id": "cranes-link-belt-htc11100",
              "name": "HTC11100",
              "subcategories": []
            },
            {
              "id": "cranes-link-belt-htc86100",
              "name": "HTC86100",
              "subcategories": []
            },
            {
              "id": "cranes-link-belt-htc86110",
              "name": "HTC86110",
              "subcategories": []
            },
            {
              "id": "cranes-link-belt-htt8675",
              "name": "HTT8675",
              "subcategories": []
            },
            {
              "id": "cranes-link-belt-htt86100",
              "name": "HTT86100",
              "subcategories": []
            },
            {
              "id": "cranes-link-belt-ls78",
              "name": "LS78",
              "subcategories": []
            },
            {
              "id": "cranes-link-belt-ls98",
              "name": "LS98",
              "subcategories": []
            },
            {
              "id": "cranes-link-belt-ls108",
              "name": "LS108",
              "subcategories": []
            },
            {
              "id": "cranes-link-belt-ls118",
              "name": "LS118",
              "subcategories": []
            },
            {
              "id": "cranes-link-belt-ls128",
              "name": "LS128",
              "subcategories": []
            },
            {
              "id": "cranes-link-belt-ls138",
              "name": "LS138",
              "subcategories": []
            },
            {
              "id": "cranes-link-belt-ls218",
              "name": "LS218",
              "subcategories": []
            },
            {
              "id": "cranes-link-belt-ls238",
              "name": "LS238",
              "subcategories": []
            },
            {
              "id": "cranes-link-belt-ls248",
              "name": "LS248",
              "subcategories": []
            },
            {
              "id": "cranes-link-belt-ls278",
              "name": "LS278",
              "subcategories": []
            },
            {
              "id": "cranes-link-belt-ls318",
              "name": "LS318",
              "subcategories": []
            },
            {
              "id": "cranes-link-belt-ls338",
              "name": "LS338",
              "subcategories": []
            },
            {
              "id": "cranes-link-belt-ls348",
              "name": "LS348",
              "subcategories": []
            },
            {
              "id": "cranes-link-belt-ls408",
              "name": "LS408",
              "subcategories": []
            },
            {
              "id": "cranes-link-belt-ls418",
              "name": "LS418",
              "subcategories": []
            },
            {
              "id": "cranes-link-belt-ls518",
              "name": "LS518",
              "subcategories": []
            },
            {
              "id": "cranes-link-belt-ls718",
              "name": "LS718",
              "subcategories": []
            },
            {
              "id": "cranes-link-belt-rtc8030",
              "name": "RTC8030",
              "subcategories": []
            },
            {
              "id": "cranes-link-belt-rtc8035",
              "name": "RTC8035",
              "subcategories": []
            },
            {
              "id": "cranes-link-belt-rtyc8040",
              "name": "RTYC8040",
              "subcategories": []
            },
            {
              "id": "cranes-link-belt-rtc8050",
              "name": "RTC8050",
              "subcategories": []
            },
            {
              "id": "cranes-link-belt-rtc8060",
              "name": "RTC8060",
              "subcategories": []
            },
            {
              "id": "cranes-link-belt-rtc8065",
              "name": "RTC8065",
              "subcategories": []
            },
            {
              "id": "cranes-link-belt-rtc8070",
              "name": "RTC8070",
              "subcategories": []
            },
            {
              "id": "cranes-link-belt-rtc8075",
              "name": "RTC8075",
              "subcategories": []
            },
            {
              "id": "cranes-link-belt-rtc8080",
              "name": "RTC8080",
              "subcategories": []
            },
            {
              "id": "cranes-link-belt-rtc8090",
              "name": "RTC8090",
              "subcategories": []
            },
            {
              "id": "cranes-link-belt-rtc80100",
              "name": "RTC80100",
              "subcategories": []
            },
            {
              "id": "cranes-link-belt-rtc80110",
              "name": "RTC80110",
              "subcategories": []
            },
            {
              "id": "cranes-link-belt-rtc80130",
              "name": "RTC80130",
              "subcategories": []
            },
            {
              "id": "cranes-link-belt-rtc80150",
              "name": "RTC80150",
              "subcategories": []
            },
            {
              "id": "cranes-link-belt-rtc80160",
              "name": "RTC80160",
              "subcategories": []
            },
            {
              "id": "cranes-link-belt-tcc450",
              "name": "TCC450",
              "subcategories": []
            },
            {
              "id": "cranes-link-belt-tcc500",
              "name": "TCC500",
              "subcategories": []
            },
            {
              "id": "cranes-link-belt-tcc550",
              "name": "TCC550",
              "subcategories": []
            },
            {
              "id": "cranes-link-belt-tcc800",
              "name": "TCC800",
              "subcategories": []
            },
            {
              "id": "cranes-link-belt-tcc750",
              "name": "TCC750",
              "subcategories": []
            },
            {
              "id": "cranes-link-belt-tcc1100",
              "name": "TCC1100",
              "subcategories": []
            },
            {
              "id": "cranes-link-belt-tcc1200",
              "name": "TCC1200",
              "subcategories": []
            },
            {
              "id": "cranes-link-belt-tc1400",
              "name": "TC1400",
              "subcategories": []
            },
            {
              "id": "cranes-link-belt-tcc2500",
              "name": "TCC2500",
              "subcategories": []
            },
            {
              "id": "cranes-link-belt-uc108",
              "name": "UC108",
              "subcategories": []
            },
            {
              "id": "cranes-link-belt-other",
              "name": "OTHER",
              "subcategories": []
            }
          ]
        },
        {
          "id": "cranes-versalift",
          "name": "Versalift",
          "subcategories": [
            {
              "id": "cranes-versalift-cta130",
              "name": "CTA130",
              "subcategories": []
            },
            {
              "id": "cranes-versalift-et25",
              "name": "ET25",
              "subcategories": []
            },
            {
              "id": "cranes-versalift-et32",
              "name": "ET32",
              "subcategories": []
            },
            {
              "id": "cranes-versalift-phx",
              "name": "PHX",
              "subcategories": []
            },
            {
              "id": "cranes-versalift-shv28",
              "name": "SHV28",
              "subcategories": []
            },
            {
              "id": "cranes-versalift-shv35",
              "name": "SHV35",
              "subcategories": []
            },
            {
              "id": "cranes-versalift-sst36",
              "name": "SST36",
              "subcategories": []
            },
            {
              "id": "cranes-versalift-sst37",
              "name": "SST37",
              "subcategories": []
            },
            {
              "id": "cranes-versalift-sst40",
              "name": "SST40",
              "subcategories": []
            },
            {
              "id": "cranes-versalift-stp36",
              "name": "STP36",
              "subcategories": []
            },
            {
              "id": "cranes-versalift-t34i",
              "name": "T34I",
              "subcategories": []
            },
            {
              "id": "cranes-versalift-tel29",
              "name": "TEL29",
              "subcategories": []
            },
            {
              "id": "cranes-versalift-tel35",
              "name": "TEL35",
              "subcategories": []
            },
            {
              "id": "cranes-versalift-tm3000",
              "name": "TM3000",
              "subcategories": []
            },
            {
              "id": "cranes-versalift-tm3045",
              "name": "TM3045",
              "subcategories": []
            },
            {
              "id": "cranes-versalift-tmd2047",
              "name": "TMD2047",
              "subcategories": []
            },
            {
              "id": "cranes-versalift-tmd2050",
              "name": "TMD2050",
              "subcategories": []
            },
            {
              "id": "cranes-versalift-tmd4060",
              "name": "TMD4060",
              "subcategories": []
            },
            {
              "id": "cranes-versalift-v0270",
              "name": "V0270",
              "subcategories": []
            },
            {
              "id": "cranes-versalift-van-tel-29",
              "name": "VAN TEL 29",
              "subcategories": []
            },
            {
              "id": "cranes-versalift-vn50i05",
              "name": "VN50I05",
              "subcategories": []
            },
            {
              "id": "cranes-versalift-vn555mhi",
              "name": "VN555MHI",
              "subcategories": []
            },
            {
              "id": "cranes-versalift-vo29",
              "name": "VO29",
              "subcategories": []
            },
            {
              "id": "cranes-versalift-vo32",
              "name": "VO32",
              "subcategories": []
            },
            {
              "id": "cranes-versalift-vo40",
              "name": "VO40",
              "subcategories": []
            },
            {
              "id": "cranes-versalift-vo42",
              "name": "VO42",
              "subcategories": []
            },
            {
              "id": "cranes-versalift-vo43",
              "name": "VO43",
              "subcategories": []
            },
            {
              "id": "cranes-versalift-vo50",
              "name": "VO50",
              "subcategories": []
            },
            {
              "id": "cranes-versalift-vo55",
              "name": "VO55",
              "subcategories": []
            },
            {
              "id": "cranes-versalift-vo260",
              "name": "VO260",
              "subcategories": []
            },
            {
              "id": "cranes-versalift-v0270",
              "name": "V0270",
              "subcategories": []
            },
            {
              "id": "cranes-versalift-vo350",
              "name": "VO350",
              "subcategories": []
            },
            {
              "id": "cranes-versalift-vo355",
              "name": "VO355",
              "subcategories": []
            },
            {
              "id": "cranes-versalift-vo360",
              "name": "VO360",
              "subcategories": []
            },
            {
              "id": "cranes-versalift-vo455",
              "name": "VO455",
              "subcategories": []
            },
            {
              "id": "cranes-versalift-vo460",
              "name": "VO460",
              "subcategories": []
            },
            {
              "id": "cranes-versalift-vst40",
              "name": "VST40",
              "subcategories": []
            },
            {
              "id": "cranes-versalift-vst43",
              "name": "VST43",
              "subcategories": []
            },
            {
              "id": "cranes-versalift-vst47",
              "name": "VST47",
              "subcategories": []
            },
            {
              "id": "cranes-versalift-vst50",
              "name": "VST50",
              "subcategories": []
            },
            {
              "id": "cranes-versalift-vst52",
              "name": "VST52",
              "subcategories": []
            },
            {
              "id": "cranes-versalift-vst55",
              "name": "VST55",
              "subcategories": []
            },
            {
              "id": "cranes-versalift-vst240",
              "name": "VST240",
              "subcategories": []
            },
            {
              "id": "cranes-versalift-vst5000",
              "name": "VST5000",
              "subcategories": []
            },
            {
              "id": "cranes-versalift-vst5500",
              "name": "VST5500",
              "subcategories": []
            },
            {
              "id": "cranes-versalift-vst6000",
              "name": "VST6000",
              "subcategories": []
            },
            {
              "id": "cranes-versalift-vst7100",
              "name": "VST7100",
              "subcategories": []
            },
            {
              "id": "cranes-versalift-vst7500",
              "name": "VST7500",
              "subcategories": []
            },
            {
              "id": "cranes-versalift-vst9000",
              "name": "VST9000",
              "subcategories": []
            },
            {
              "id": "cranes-versalift-vst9500",
              "name": "VST9500",
              "subcategories": []
            },
            {
              "id": "cranes-versalift-vt28",
              "name": "VT28",
              "subcategories": []
            },
            {
              "id": "cranes-versalift-vt29",
              "name": "VT29",
              "subcategories": []
            },
            {
              "id": "cranes-versalift-vtp40",
              "name": "VTP40",
              "subcategories": []
            },
            {
              "id": "cranes-versalift-vxd47",
              "name": "VXD47",
              "subcategories": []
            }
          ]
        },
        {
          "id": "cranes-manitex",
          "name": "Manitex",
          "subcategories": [
            {
              "id": "cranes-manitex-102",
              "name": "102",
              "subcategories": []
            },
            {
              "id": "cranes-manitex-124",
              "name": "124",
              "subcategories": []
            },
            {
              "id": "cranes-manitex-1161",
              "name": "1161",
              "subcategories": []
            },
            {
              "id": "cranes-manitex-1970",
              "name": "1970",
              "subcategories": []
            },
            {
              "id": "cranes-manitex-2250",
              "name": "2250",
              "subcategories": []
            },
            {
              "id": "cranes-manitex-2281",
              "name": "2281",
              "subcategories": []
            },
            {
              "id": "cranes-manitex-2892",
              "name": "2892",
              "subcategories": []
            },
            {
              "id": "cranes-manitex-3051",
              "name": "3051",
              "subcategories": []
            },
            {
              "id": "cranes-manitex-3071",
              "name": "3071",
              "subcategories": []
            },
            {
              "id": "cranes-manitex-4596",
              "name": "4596",
              "subcategories": []
            },
            {
              "id": "cranes-manitex-22101",
              "name": "22101",
              "subcategories": []
            },
            {
              "id": "cranes-manitex-26101",
              "name": "26101",
              "subcategories": []
            },
            {
              "id": "cranes-manitex-28100",
              "name": "28100",
              "subcategories": []
            },
            {
              "id": "cranes-manitex-30100",
              "name": "30100",
              "subcategories": []
            },
            {
              "id": "cranes-manitex-30102",
              "name": "30102",
              "subcategories": []
            },
            {
              "id": "cranes-manitex-30112",
              "name": "30112",
              "subcategories": []
            },
            {
              "id": "cranes-manitex-35124",
              "name": "35124",
              "subcategories": []
            },
            {
              "id": "cranes-manitex-38124",
              "name": "38124",
              "subcategories": []
            },
            {
              "id": "cranes-manitex-40124",
              "name": "40124",
              "subcategories": []
            },
            {
              "id": "cranes-manitex-45110",
              "name": "45110",
              "subcategories": []
            },
            {
              "id": "cranes-manitex-50110",
              "name": "50110",
              "subcategories": []
            },
            {
              "id": "cranes-manitex-50128",
              "name": "50128",
              "subcategories": []
            },
            {
              "id": "cranes-manitex-50155",
              "name": "50155",
              "subcategories": []
            },
            {
              "id": "cranes-manitex-a62",
              "name": "A62",
              "subcategories": []
            },
            {
              "id": "cranes-manitex-cd110",
              "name": "CD110",
              "subcategories": []
            },
            {
              "id": "cranes-manitex-cd4430",
              "name": "CD4430",
              "subcategories": []
            },
            {
              "id": "cranes-manitex-m150",
              "name": "M150",
              "subcategories": []
            },
            {
              "id": "cranes-manitex-m300",
              "name": "M300",
              "subcategories": []
            },
            {
              "id": "cranes-manitex-m2592",
              "name": "M2592",
              "subcategories": []
            },
            {
              "id": "cranes-manitex-mac-15525",
              "name": "MAC 15525",
              "subcategories": []
            },
            {
              "id": "cranes-manitex-pl74",
              "name": "PL74",
              "subcategories": []
            },
            {
              "id": "cranes-manitex-sc62",
              "name": "SC62",
              "subcategories": []
            },
            {
              "id": "cranes-manitex-sc75",
              "name": "SC75",
              "subcategories": []
            },
            {
              "id": "cranes-manitex-tc700",
              "name": "TC700",
              "subcategories": []
            },
            {
              "id": "cranes-manitex-tc400",
              "name": "TC400",
              "subcategories": []
            },
            {
              "id": "cranes-manitex-tc450",
              "name": "TC450",
              "subcategories": []
            },
            {
              "id": "cranes-manitex-tc500",
              "name": "TC500",
              "subcategories": []
            },
            {
              "id": "cranes-manitex-tc650",
              "name": "TC650",
              "subcategories": []
            },
            {
              "id": "cranes-manitex-tm200",
              "name": "TM200",
              "subcategories": []
            },
            {
              "id": "cranes-manitex-tm240",
              "name": "TM240",
              "subcategories": []
            },
            {
              "id": "cranes-manitex-other",
              "name": "OTHER",
              "subcategories": []
            }
          ]
        },
        {
          "id": "cranes-national",
          "name": "National",
          "subcategories": [
            {
              "id": "cranes-national-6t",
              "name": "6T",
              "subcategories": []
            },
            {
              "id": "cranes-national-300",
              "name": "300",
              "subcategories": []
            },
            {
              "id": "cranes-national-400",
              "name": "400",
              "subcategories": []
            },
            {
              "id": "cranes-national-500",
              "name": "500",
              "subcategories": []
            },
            {
              "id": "cranes-national-600",
              "name": "600",
              "subcategories": []
            },
            {
              "id": "cranes-national-800",
              "name": "800",
              "subcategories": []
            },
            {
              "id": "cranes-national-880",
              "name": "880",
              "subcategories": []
            },
            {
              "id": "cranes-national-900",
              "name": "900",
              "subcategories": []
            },
            {
              "id": "cranes-national-1100",
              "name": "1100",
              "subcategories": []
            },
            {
              "id": "cranes-national-1200",
              "name": "1200",
              "subcategories": []
            },
            {
              "id": "cranes-national-1300",
              "name": "1300",
              "subcategories": []
            },
            {
              "id": "cranes-national-1400",
              "name": "1400",
              "subcategories": []
            },
            {
              "id": "cranes-national-1500",
              "name": "1500",
              "subcategories": []
            },
            {
              "id": "cranes-national-1800",
              "name": "1800",
              "subcategories": []
            },
            {
              "id": "cranes-national-8000",
              "name": "8000",
              "subcategories": []
            },
            {
              "id": "cranes-national-8100",
              "name": "8100",
              "subcategories": []
            },
            {
              "id": "cranes-national-9000",
              "name": "9000",
              "subcategories": []
            },
            {
              "id": "cranes-national-9100",
              "name": "9100",
              "subcategories": []
            },
            {
              "id": "cranes-national-13000",
              "name": "13000",
              "subcategories": []
            },
            {
              "id": "cranes-national-14000",
              "name": "14000",
              "subcategories": []
            },
            {
              "id": "cranes-national-18000",
              "name": "18000",
              "subcategories": []
            },
            {
              "id": "cranes-national-n50",
              "name": "N50",
              "subcategories": []
            },
            {
              "id": "cranes-national-n65",
              "name": "N65",
              "subcategories": []
            },
            {
              "id": "cranes-national-n80",
              "name": "N80",
              "subcategories": []
            },
            {
              "id": "cranes-national-n85",
              "name": "N85",
              "subcategories": []
            },
            {
              "id": "cranes-national-n95",
              "name": "N95",
              "subcategories": []
            },
            {
              "id": "cranes-national-n160",
              "name": "N160",
              "subcategories": []
            },
            {
              "id": "cranes-national-n205",
              "name": "N205",
              "subcategories": []
            },
            {
              "id": "cranes-national-nbt14",
              "name": "NBT14",
              "subcategories": []
            },
            {
              "id": "cranes-national-nbt16",
              "name": "NBT16",
              "subcategories": []
            },
            {
              "id": "cranes-national-nbt30",
              "name": "NBT30",
              "subcategories": []
            },
            {
              "id": "cranes-national-nbt36",
              "name": "NBT36",
              "subcategories": []
            },
            {
              "id": "cranes-national-nbt40",
              "name": "NBT40",
              "subcategories": []
            },
            {
              "id": "cranes-national-nbt45",
              "name": "NBT45",
              "subcategories": []
            },
            {
              "id": "cranes-national-nbt50",
              "name": "NBT50",
              "subcategories": []
            },
            {
              "id": "cranes-national-nbt55",
              "name": "NBT55",
              "subcategories": []
            },
            {
              "id": "cranes-national-nbt60",
              "name": "NBT60",
              "subcategories": []
            },
            {
              "id": "cranes-national-ntc55",
              "name": "NTC55",
              "subcategories": []
            },
            {
              "id": "cranes-national-ntc45",
              "name": "NTC45",
              "subcategories": []
            },
            {
              "id": "cranes-national-ntc60",
              "name": "NTC60",
              "subcategories": []
            },
            {
              "id": "cranes-national-other",
              "name": "OTHER",
              "subcategories": []
            }
          ]
        },
        {
          "id": "cranes-american",
          "name": "American",
          "subcategories": [
            {
              "id": "cranes-american-595",
              "name": "595",
              "subcategories": []
            },
            {
              "id": "cranes-american-597",
              "name": "597",
              "subcategories": []
            },
            {
              "id": "cranes-american-599",
              "name": "599",
              "subcategories": []
            },
            {
              "id": "cranes-american-797",
              "name": "797",
              "subcategories": []
            },
            {
              "id": "cranes-american-850",
              "name": "850",
              "subcategories": []
            },
            {
              "id": "cranes-american-998",
              "name": "998",
              "subcategories": []
            },
            {
              "id": "cranes-american-999",
              "name": "999",
              "subcategories": []
            },
            {
              "id": "cranes-american-4250",
              "name": "4250",
              "subcategories": []
            },
            {
              "id": "cranes-american-4260",
              "name": "4260",
              "subcategories": []
            },
            {
              "id": "cranes-american-4460",
              "name": "4460",
              "subcategories": []
            },
            {
              "id": "cranes-american-5030",
              "name": "5030",
              "subcategories": []
            },
            {
              "id": "cranes-american-5220",
              "name": "5220",
              "subcategories": []
            },
            {
              "id": "cranes-american-5299",
              "name": "5299",
              "subcategories": []
            },
            {
              "id": "cranes-american-5300",
              "name": "5300",
              "subcategories": []
            },
            {
              "id": "cranes-american-5530",
              "name": "5530",
              "subcategories": []
            },
            {
              "id": "cranes-american-5680",
              "name": "5680",
              "subcategories": []
            },
            {
              "id": "cranes-american-7150",
              "name": "7150",
              "subcategories": []
            },
            {
              "id": "cranes-american-7220",
              "name": "7220",
              "subcategories": []
            },
            {
              "id": "cranes-american-7250",
              "name": "7250",
              "subcategories": []
            },
            {
              "id": "cranes-american-7260",
              "name": "7260",
              "subcategories": []
            },
            {
              "id": "cranes-american-7460",
              "name": "7460",
              "subcategories": []
            },
            {
              "id": "cranes-american-7510",
              "name": "7510",
              "subcategories": []
            },
            {
              "id": "cranes-american-7530",
              "name": "7530",
              "subcategories": []
            },
            {
              "id": "cranes-american-8460",
              "name": "8460",
              "subcategories": []
            },
            {
              "id": "cranes-american-8470",
              "name": "8470",
              "subcategories": []
            },
            {
              "id": "cranes-american-9260",
              "name": "9260",
              "subcategories": []
            },
            {
              "id": "cranes-american-9299",
              "name": "9299",
              "subcategories": []
            },
            {
              "id": "cranes-american-9310",
              "name": "9310",
              "subcategories": []
            },
            {
              "id": "cranes-american-9320",
              "name": "9320",
              "subcategories": []
            },
            {
              "id": "cranes-american-9520",
              "name": "9520",
              "subcategories": []
            },
            {
              "id": "cranes-american-9750",
              "name": "9750",
              "subcategories": []
            },
            {
              "id": "cranes-american-11320",
              "name": "11320",
              "subcategories": []
            },
            {
              "id": "cranes-american-a100",
              "name": "A100",
              "subcategories": []
            },
            {
              "id": "cranes-american-a1500",
              "name": "A1500",
              "subcategories": []
            },
            {
              "id": "cranes-american-hc80",
              "name": "HC80",
              "subcategories": []
            },
            {
              "id": "cranes-american-hc110",
              "name": "HC110",
              "subcategories": []
            },
            {
              "id": "cranes-american-other",
              "name": "OTHER",
              "subcategories": []
            }
          ]
        },
        {
          "id": "cranes-auto-crane",
          "name": "Auto Crane",
          "subcategories": [
            {
              "id": "cranes-auto-crane-3200",
              "name": "3200",
              "subcategories": []
            },
            {
              "id": "cranes-auto-crane-3203",
              "name": "3203",
              "subcategories": []
            },
            {
              "id": "cranes-auto-crane-4004",
              "name": "4004",
              "subcategories": []
            },
            {
              "id": "cranes-auto-crane-6006",
              "name": "6006",
              "subcategories": []
            },
            {
              "id": "cranes-auto-crane-a72a",
              "name": "A72A",
              "subcategories": []
            },
            {
              "id": "cranes-auto-crane-ehc32",
              "name": "EHC32",
              "subcategories": []
            },
            {
              "id": "cranes-auto-crane-ehc-4-20",
              "name": "EHC-4 20",
              "subcategories": []
            },
            {
              "id": "cranes-auto-crane-hc6",
              "name": "HC6",
              "subcategories": []
            },
            {
              "id": "cranes-auto-crane-hc7",
              "name": "HC7",
              "subcategories": []
            },
            {
              "id": "cranes-auto-crane-hc8",
              "name": "HC8",
              "subcategories": []
            },
            {
              "id": "cranes-auto-crane-hc10",
              "name": "HC10",
              "subcategories": []
            },
            {
              "id": "cranes-auto-crane-hc12",
              "name": "HC12",
              "subcategories": []
            },
            {
              "id": "cranes-auto-crane-titan-38",
              "name": "TITAN 38",
              "subcategories": []
            },
            {
              "id": "cranes-auto-crane-other",
              "name": "OTHER",
              "subcategories": []
            }
          ]
        },
        {
          "id": "cranes-bik",
          "name": "Bik",
          "subcategories": [
            {
              "id": "cranes-bik-65",
              "name": "65",
              "subcategories": []
            },
            {
              "id": "cranes-bik-70",
              "name": "70",
              "subcategories": []
            },
            {
              "id": "cranes-bik-fc67",
              "name": "FC67",
              "subcategories": []
            },
            {
              "id": "cranes-bik-fc70",
              "name": "FC70",
              "subcategories": []
            },
            {
              "id": "cranes-bik-fc75",
              "name": "FC75",
              "subcategories": []
            },
            {
              "id": "cranes-bik-fc76",
              "name": "FC76",
              "subcategories": []
            },
            {
              "id": "cranes-bik-fc81",
              "name": "FC81",
              "subcategories": []
            },
            {
              "id": "cranes-bik-fc92",
              "name": "FC92",
              "subcategories": []
            },
            {
              "id": "cranes-bik-fc110",
              "name": "FC110",
              "subcategories": []
            },
            {
              "id": "cranes-bik-hl40",
              "name": "HL40",
              "subcategories": []
            },
            {
              "id": "cranes-bik-hl45",
              "name": "HL45",
              "subcategories": []
            },
            {
              "id": "cranes-bik-hl58",
              "name": "HL58",
              "subcategories": []
            },
            {
              "id": "cranes-bik-hl86",
              "name": "HL86",
              "subcategories": []
            },
            {
              "id": "cranes-bik-hl100",
              "name": "HL100",
              "subcategories": []
            },
            {
              "id": "cranes-bik-rc31",
              "name": "RC31",
              "subcategories": []
            },
            {
              "id": "cranes-bik-rc41",
              "name": "RC41",
              "subcategories": []
            },
            {
              "id": "cranes-bik-tc70",
              "name": "TC70",
              "subcategories": []
            },
            {
              "id": "cranes-bik-tc78",
              "name": "TC78",
              "subcategories": []
            },
            {
              "id": "cranes-bik-tc92",
              "name": "TC92",
              "subcategories": []
            },
            {
              "id": "cranes-bik-tc98",
              "name": "TC98",
              "subcategories": []
            },
            {
              "id": "cranes-bik-tc104",
              "name": "TC104",
              "subcategories": []
            },
            {
              "id": "cranes-bik-tc106",
              "name": "TC106",
              "subcategories": []
            },
            {
              "id": "cranes-bik-tc118",
              "name": "TC118",
              "subcategories": []
            },
            {
              "id": "cranes-bik-tc124",
              "name": "TC124",
              "subcategories": []
            },
            {
              "id": "cranes-bik-tc126",
              "name": "TC126",
              "subcategories": []
            },
            {
              "id": "cranes-bik-tc170",
              "name": "TC170",
              "subcategories": []
            },
            {
              "id": "cranes-bik-wc75",
              "name": "WC75",
              "subcategories": []
            },
            {
              "id": "cranes-bik-other",
              "name": "OTHER",
              "subcategories": []
            }
          ]
        },
        {
          "id": "cranes-broderson",
          "name": "Broderson",
          "subcategories": [
            {
              "id": "cranes-broderson-ic20",
              "name": "IC20",
              "subcategories": []
            },
            {
              "id": "cranes-broderson-ic35",
              "name": "IC35",
              "subcategories": []
            },
            {
              "id": "cranes-broderson-ic40",
              "name": "IC40",
              "subcategories": []
            },
            {
              "id": "cranes-broderson-ic80",
              "name": "IC80",
              "subcategories": []
            },
            {
              "id": "cranes-broderson-ic100",
              "name": "IC100",
              "subcategories": []
            },
            {
              "id": "cranes-broderson-ic200",
              "name": "IC200",
              "subcategories": []
            },
            {
              "id": "cranes-broderson-ic250",
              "name": "IC250",
              "subcategories": []
            },
            {
              "id": "cranes-broderson-ic280",
              "name": "IC280",
              "subcategories": []
            },
            {
              "id": "cranes-broderson-ic400",
              "name": "IC400",
              "subcategories": []
            },
            {
              "id": "cranes-broderson-rt200",
              "name": "RT200",
              "subcategories": []
            },
            {
              "id": "cranes-broderson-rt300",
              "name": "RT300",
              "subcategories": []
            },
            {
              "id": "cranes-broderson-rt400",
              "name": "RT400",
              "subcategories": []
            },
            {
              "id": "cranes-broderson-other",
              "name": "OTHER",
              "subcategories": []
            }
          ]
        },
        {
          "id": "cranes-cormach",
          "name": "Cormach",
          "subcategories": [
            {
              "id": "cranes-cormach-6800",
              "name": "6800",
              "subcategories": []
            },
            {
              "id": "cranes-cormach-110000",
              "name": "110000",
              "subcategories": []
            },
            {
              "id": "cranes-cormach-12000",
              "name": "12000",
              "subcategories": []
            },
            {
              "id": "cranes-cormach-14000",
              "name": "14000",
              "subcategories": []
            },
            {
              "id": "cranes-cormach-16600",
              "name": "16600",
              "subcategories": []
            },
            {
              "id": "cranes-cormach-19000",
              "name": "19000",
              "subcategories": []
            },
            {
              "id": "cranes-cormach-22500",
              "name": "22500",
              "subcategories": []
            },
            {
              "id": "cranes-cormach-28000",
              "name": "28000",
              "subcategories": []
            },
            {
              "id": "cranes-cormach-28200",
              "name": "28200",
              "subcategories": []
            },
            {
              "id": "cranes-cormach-30000",
              "name": "30000",
              "subcategories": []
            },
            {
              "id": "cranes-cormach-34000",
              "name": "34000",
              "subcategories": []
            },
            {
              "id": "cranes-cormach-39000",
              "name": "39000",
              "subcategories": []
            },
            {
              "id": "cranes-cormach-40400",
              "name": "40400",
              "subcategories": []
            },
            {
              "id": "cranes-cormach-50000",
              "name": "50000",
              "subcategories": []
            },
            {
              "id": "cranes-cormach-51800",
              "name": "51800",
              "subcategories": []
            },
            {
              "id": "cranes-cormach-60000",
              "name": "60000",
              "subcategories": []
            },
            {
              "id": "cranes-cormach-75000",
              "name": "75000",
              "subcategories": []
            },
            {
              "id": "cranes-cormach-95000",
              "name": "95000",
              "subcategories": []
            },
            {
              "id": "cranes-cormach-150000",
              "name": "150000",
              "subcategories": []
            },
            {
              "id": "cranes-cormach-185000",
              "name": "185000",
              "subcategories": []
            },
            {
              "id": "cranes-cormach-240000",
              "name": "240000",
              "subcategories": []
            },
            {
              "id": "cranes-cormach-575000",
              "name": "575000",
              "subcategories": []
            },
            {
              "id": "cranes-cormach-other",
              "name": "OTHER",
              "subcategories": []
            }
          ]
        },
        {
          "id": "cranes-dall-aglio-newcranes",
          "name": "Dall'Aglio Newcranes",
          "subcategories": [
            {
              "id": "cranes-dall-aglio-newcranes-dn2-7",
              "name": "DN2.7",
              "subcategories": []
            },
            {
              "id": "cranes-dall-aglio-newcranes-dn3-0",
              "name": "DN3.0",
              "subcategories": []
            },
            {
              "id": "cranes-dall-aglio-newcranes-dn3-6",
              "name": "DN3.6",
              "subcategories": []
            },
            {
              "id": "cranes-dall-aglio-newcranes-dn4-0",
              "name": "DN4.0",
              "subcategories": []
            },
            {
              "id": "cranes-dall-aglio-newcranes-dn5-0",
              "name": "DN5.0",
              "subcategories": []
            },
            {
              "id": "cranes-dall-aglio-newcranes-dn6-0",
              "name": "DN6.0",
              "subcategories": []
            },
            {
              "id": "cranes-dall-aglio-newcranes-dn7-0",
              "name": "DN7.0",
              "subcategories": []
            },
            {
              "id": "cranes-dall-aglio-newcranes-dn7-7",
              "name": "DN7.7",
              "subcategories": []
            },
            {
              "id": "cranes-dall-aglio-newcranes-dn8-7",
              "name": "DN8.7",
              "subcategories": []
            },
            {
              "id": "cranes-dall-aglio-newcranes-dn9-7",
              "name": "DN9.7",
              "subcategories": []
            },
            {
              "id": "cranes-dall-aglio-newcranes-dn9-7",
              "name": "DN9.7",
              "subcategories": []
            },
            {
              "id": "cranes-dall-aglio-newcranes-dn12-0",
              "name": "DN12.0",
              "subcategories": []
            },
            {
              "id": "cranes-dall-aglio-newcranes-dn13-0",
              "name": "DN13.0",
              "subcategories": []
            },
            {
              "id": "cranes-dall-aglio-newcranes-dn15-0",
              "name": "DN15.0",
              "subcategories": []
            },
            {
              "id": "cranes-dall-aglio-newcranes-dn17-0",
              "name": "DN17.0",
              "subcategories": []
            },
            {
              "id": "cranes-dall-aglio-newcranes-dn19-0",
              "name": "DN19.0",
              "subcategories": []
            },
            {
              "id": "cranes-dall-aglio-newcranes-dn22-0",
              "name": "DN22.0",
              "subcategories": []
            },
            {
              "id": "cranes-dall-aglio-newcranes-dn243-0",
              "name": "DN243.0",
              "subcategories": []
            },
            {
              "id": "cranes-dall-aglio-newcranes-dn24-0",
              "name": "DN24.0",
              "subcategories": []
            },
            {
              "id": "cranes-dall-aglio-newcranes-dn27-0",
              "name": "DN27.0",
              "subcategories": []
            },
            {
              "id": "cranes-dall-aglio-newcranes-dn30-0",
              "name": "DN30.0",
              "subcategories": []
            },
            {
              "id": "cranes-dall-aglio-newcranes-dn33-0",
              "name": "DN33.0",
              "subcategories": []
            },
            {
              "id": "cranes-dall-aglio-newcranes-dn37-0",
              "name": "DN37.0",
              "subcategories": []
            },
            {
              "id": "cranes-dall-aglio-newcranes-dn44-0",
              "name": "DN44.0",
              "subcategories": []
            },
            {
              "id": "cranes-dall-aglio-newcranes-dnm1-1",
              "name": "DNM1.1",
              "subcategories": []
            },
            {
              "id": "cranes-dall-aglio-newcranes-dnm1-4",
              "name": "DNM1.4",
              "subcategories": []
            },
            {
              "id": "cranes-dall-aglio-newcranes-dnm1-9",
              "name": "DNM1.9",
              "subcategories": []
            },
            {
              "id": "cranes-dall-aglio-newcranes-dnm2-2",
              "name": "DNM2.2",
              "subcategories": []
            },
            {
              "id": "cranes-dall-aglio-newcranes-dnm2-7",
              "name": "DNM2.7",
              "subcategories": []
            },
            {
              "id": "cranes-dall-aglio-newcranes-dnm3-3",
              "name": "DNM3.3",
              "subcategories": []
            },
            {
              "id": "cranes-dall-aglio-newcranes-dnm3-8",
              "name": "DNM3.8",
              "subcategories": []
            },
            {
              "id": "cranes-dall-aglio-newcranes-dnm4-3",
              "name": "DNM4.3",
              "subcategories": []
            },
            {
              "id": "cranes-dall-aglio-newcranes-other",
              "name": "OTHER",
              "subcategories": []
            }
          ]
        },
        {
          "id": "cranes-demag",
          "name": "Demag",
          "subcategories": [
            {
              "id": "cranes-demag-5t",
              "name": "5T",
              "subcategories": []
            },
            {
              "id": "cranes-demag-ac25",
              "name": "AC25",
              "subcategories": []
            },
            {
              "id": "cranes-demag-ac30",
              "name": "AC30",
              "subcategories": []
            },
            {
              "id": "cranes-demag-ac40",
              "name": "AC40",
              "subcategories": []
            },
            {
              "id": "cranes-demag-ac50",
              "name": "AC50",
              "subcategories": []
            },
            {
              "id": "cranes-demag-ac55",
              "name": "AC55",
              "subcategories": []
            },
            {
              "id": "cranes-demag-ac60",
              "name": "AC60",
              "subcategories": []
            },
            {
              "id": "cranes-demag-ac70",
              "name": "AC70",
              "subcategories": []
            },
            {
              "id": "cranes-demag-ac80",
              "name": "AC80",
              "subcategories": []
            },
            {
              "id": "cranes-demag-ac100",
              "name": "AC100",
              "subcategories": []
            },
            {
              "id": "cranes-demag-ac120",
              "name": "AC120",
              "subcategories": []
            },
            {
              "id": "cranes-demag-ac140",
              "name": "AC140",
              "subcategories": []
            },
            {
              "id": "cranes-demag-ac160",
              "name": "AC160",
              "subcategories": []
            },
            {
              "id": "cranes-demag-ac180",
              "name": "AC180",
              "subcategories": []
            },
            {
              "id": "cranes-demag-ac200",
              "name": "AC200",
              "subcategories": []
            },
            {
              "id": "cranes-demag-ac205",
              "name": "AC205",
              "subcategories": []
            },
            {
              "id": "cranes-demag-ac220",
              "name": "AC220",
              "subcategories": []
            },
            {
              "id": "cranes-demag-ac250",
              "name": "AC250",
              "subcategories": []
            },
            {
              "id": "cranes-demag-ac300",
              "name": "AC300",
              "subcategories": []
            },
            {
              "id": "cranes-demag-ac350",
              "name": "AC350",
              "subcategories": []
            },
            {
              "id": "cranes-demag-ac500",
              "name": "AC500",
              "subcategories": []
            },
            {
              "id": "cranes-demag-ac535",
              "name": "AC535",
              "subcategories": []
            },
            {
              "id": "cranes-demag-ac700",
              "name": "AC700",
              "subcategories": []
            },
            {
              "id": "cranes-demag-ac1000",
              "name": "AC1000",
              "subcategories": []
            },
            {
              "id": "cranes-demag-ac1200",
              "name": "AC1200",
              "subcategories": []
            },
            {
              "id": "cranes-demag-ac1300",
              "name": "AC1300",
              "subcategories": []
            },
            {
              "id": "cranes-demag-cc280",
              "name": "CC280",
              "subcategories": []
            },
            {
              "id": "cranes-demag-cc300",
              "name": "CC300",
              "subcategories": []
            },
            {
              "id": "cranes-demag-cc600",
              "name": "CC600",
              "subcategories": []
            },
            {
              "id": "cranes-demag-cc1100",
              "name": "CC1100",
              "subcategories": []
            },
            {
              "id": "cranes-demag-cc1800",
              "name": "CC1800",
              "subcategories": []
            },
            {
              "id": "cranes-demag-cc2200",
              "name": "CC2200",
              "subcategories": []
            },
            {
              "id": "cranes-demag-cc2400",
              "name": "CC2400",
              "subcategories": []
            },
            {
              "id": "cranes-demag-cc2500",
              "name": "CC2500",
              "subcategories": []
            },
            {
              "id": "cranes-demag-cc2600",
              "name": "CC2600",
              "subcategories": []
            },
            {
              "id": "cranes-demag-cc2800",
              "name": "CC2800",
              "subcategories": []
            },
            {
              "id": "cranes-demag-cc3800",
              "name": "CC3800",
              "subcategories": []
            },
            {
              "id": "cranes-demag-cc4800",
              "name": "CC4800",
              "subcategories": []
            },
            {
              "id": "cranes-demag-cc6800",
              "name": "CC6800",
              "subcategories": []
            },
            {
              "id": "cranes-demag-cc8800",
              "name": "CC8800",
              "subcategories": []
            },
            {
              "id": "cranes-demag-mhc360",
              "name": "MHC360",
              "subcategories": []
            },
            {
              "id": "cranes-demag-tc2600",
              "name": "TC2600",
              "subcategories": []
            },
            {
              "id": "cranes-demag-tc2800",
              "name": "TC2800",
              "subcategories": []
            },
            {
              "id": "cranes-demag-tc3200",
              "name": "TC3200",
              "subcategories": []
            },
            {
              "id": "cranes-demag-other",
              "name": "OTHER",
              "subcategories": []
            }
          ]
        },
        {
          "id": "cranes-dur-a-lift",
          "name": "Dur-A-Lift",
          "subcategories": [
            {
              "id": "cranes-dur-a-lift-dcp36",
              "name": "DCP36",
              "subcategories": []
            },
            {
              "id": "cranes-dur-a-lift-dht34",
              "name": "DHT34",
              "subcategories": []
            },
            {
              "id": "cranes-dur-a-lift-dlt2",
              "name": "DLT2",
              "subcategories": []
            },
            {
              "id": "cranes-dur-a-lift-do32",
              "name": "DO32",
              "subcategories": []
            },
            {
              "id": "cranes-dur-a-lift-do36",
              "name": "DO36",
              "subcategories": []
            },
            {
              "id": "cranes-dur-a-lift-dpm2",
              "name": "DPM2",
              "subcategories": []
            },
            {
              "id": "cranes-dur-a-lift-dpm52",
              "name": "DPM52",
              "subcategories": []
            },
            {
              "id": "cranes-dur-a-lift-dta2",
              "name": "DTA2",
              "subcategories": []
            },
            {
              "id": "cranes-dur-a-lift-dt29",
              "name": "DT29",
              "subcategories": []
            },
            {
              "id": "cranes-dur-a-lift-dta35",
              "name": "DTA35",
              "subcategories": []
            },
            {
              "id": "cranes-dur-a-lift-dtas35",
              "name": "DTAS35",
              "subcategories": []
            },
            {
              "id": "cranes-dur-a-lift-dtaxs39",
              "name": "DTAXS39",
              "subcategories": []
            },
            {
              "id": "cranes-dur-a-lift-dtax2",
              "name": "DTAX2",
              "subcategories": []
            },
            {
              "id": "cranes-dur-a-lift-dtax39",
              "name": "DTAX39",
              "subcategories": []
            },
            {
              "id": "cranes-dur-a-lift-dts29",
              "name": "DTS29",
              "subcategories": []
            },
            {
              "id": "cranes-dur-a-lift-dvs29",
              "name": "DVS29",
              "subcategories": []
            },
            {
              "id": "cranes-dur-a-lift-dvt29",
              "name": "DVT29",
              "subcategories": []
            },
            {
              "id": "cranes-dur-a-lift-v34",
              "name": "V34",
              "subcategories": []
            },
            {
              "id": "cranes-dur-a-lift-other",
              "name": "OTHER",
              "subcategories": []
            }
          ]
        },
        {
          "id": "cranes-elliot",
          "name": "Elliot",
          "subcategories": [
            {
              "id": "cranes-elliot-1056",
              "name": "1056",
              "subcategories": []
            },
            {
              "id": "cranes-elliot-1860",
              "name": "1860",
              "subcategories": []
            },
            {
              "id": "cranes-elliot-1870",
              "name": "1870",
              "subcategories": []
            },
            {
              "id": "cranes-elliot-1881",
              "name": "1881",
              "subcategories": []
            },
            {
              "id": "cranes-elliot-2695",
              "name": "2695",
              "subcategories": []
            },
            {
              "id": "cranes-elliot-26105",
              "name": "26105",
              "subcategories": []
            },
            {
              "id": "cranes-elliot-30105",
              "name": "30105",
              "subcategories": []
            },
            {
              "id": "cranes-elliot-32105",
              "name": "32105",
              "subcategories": []
            },
            {
              "id": "cranes-elliot-36127",
              "name": "36127",
              "subcategories": []
            },
            {
              "id": "cranes-elliot-40105",
              "name": "40105",
              "subcategories": []
            },
            {
              "id": "cranes-elliot-40142",
              "name": "40142",
              "subcategories": []
            },
            {
              "id": "cranes-elliot-45127",
              "name": "45127",
              "subcategories": []
            },
            {
              "id": "cranes-elliot-45142",
              "name": "45142",
              "subcategories": []
            },
            {
              "id": "cranes-elliot-a41",
              "name": "A41",
              "subcategories": []
            },
            {
              "id": "cranes-elliot-d86",
              "name": "D86",
              "subcategories": []
            },
            {
              "id": "cranes-elliot-d100",
              "name": "D100",
              "subcategories": []
            },
            {
              "id": "cranes-elliot-d105",
              "name": "D105",
              "subcategories": []
            },
            {
              "id": "cranes-elliot-e145",
              "name": "E145",
              "subcategories": []
            },
            {
              "id": "cranes-elliot-e160",
              "name": "E160",
              "subcategories": []
            },
            {
              "id": "cranes-elliot-eca411",
              "name": "ECA411",
              "subcategories": []
            },
            {
              "id": "cranes-elliot-ece3",
              "name": "ECE3",
              "subcategories": []
            },
            {
              "id": "cranes-elliot-eci3",
              "name": "ECI3",
              "subcategories": []
            },
            {
              "id": "cranes-elliot-g85",
              "name": "G85",
              "subcategories": []
            },
            {
              "id": "cranes-elliot-h57",
              "name": "H57",
              "subcategories": []
            },
            {
              "id": "cranes-elliot-h60",
              "name": "H60",
              "subcategories": []
            },
            {
              "id": "cranes-elliot-h70",
              "name": "H70",
              "subcategories": []
            },
            {
              "id": "cranes-elliot-h110",
              "name": "H110",
              "subcategories": []
            },
            {
              "id": "cranes-elliot-i50",
              "name": "I50",
              "subcategories": []
            },
            {
              "id": "cranes-elliot-l50",
              "name": "L50",
              "subcategories": []
            },
            {
              "id": "cranes-elliot-l55",
              "name": "L55",
              "subcategories": []
            },
            {
              "id": "cranes-elliot-l60",
              "name": "L60",
              "subcategories": []
            },
            {
              "id": "cranes-elliot-l65",
              "name": "L65",
              "subcategories": []
            },
            {
              "id": "cranes-elliot-m43",
              "name": "M43",
              "subcategories": []
            },
            {
              "id": "cranes-elliot-m87",
              "name": "M87",
              "subcategories": []
            },
            {
              "id": "cranes-elliot-uc40142",
              "name": "UC40142",
              "subcategories": []
            },
            {
              "id": "cranes-elliot-v60",
              "name": "V60",
              "subcategories": []
            },
            {
              "id": "cranes-elliot-v63",
              "name": "V63",
              "subcategories": []
            },
            {
              "id": "cranes-elliot-other",
              "name": "OTHER",
              "subcategories": []
            }
          ]
        },
        {
          "id": "cranes-eti",
          "name": "Eti",
          "subcategories": [
            {
              "id": "cranes-eti-eta37",
              "name": "ETA37",
              "subcategories": []
            },
            {
              "id": "cranes-eti-etc35snt",
              "name": "ETC35SNT",
              "subcategories": []
            },
            {
              "id": "cranes-eti-etc37ih",
              "name": "ETC37IH",
              "subcategories": []
            },
            {
              "id": "cranes-eti-etc40ih",
              "name": "ETC40IH",
              "subcategories": []
            },
            {
              "id": "cranes-eti-etc",
              "name": "ETC",
              "subcategories": []
            },
            {
              "id": "cranes-eti-etcmh",
              "name": "ETCMH",
              "subcategories": []
            },
            {
              "id": "cranes-eti-etomh",
              "name": "ETOMH",
              "subcategories": []
            },
            {
              "id": "cranes-eti-ett29",
              "name": "ETT29",
              "subcategories": []
            },
            {
              "id": "cranes-eti-other",
              "name": "OTHER",
              "subcategories": []
            }
          ]
        },
        {
          "id": "cranes-fassi",
          "name": "Fassi",
          "subcategories": [
            {
              "id": "cranes-fassi-f26",
              "name": "F26",
              "subcategories": []
            },
            {
              "id": "cranes-fassi-f32",
              "name": "F32",
              "subcategories": []
            },
            {
              "id": "cranes-fassi-f50",
              "name": "F50",
              "subcategories": []
            },
            {
              "id": "cranes-fassi-f40",
              "name": "F40",
              "subcategories": []
            },
            {
              "id": "cranes-fassi-f60",
              "name": "F60",
              "subcategories": []
            },
            {
              "id": "cranes-fassi-f65",
              "name": "F65",
              "subcategories": []
            },
            {
              "id": "cranes-fassi-f85",
              "name": "F85",
              "subcategories": []
            },
            {
              "id": "cranes-fassi-f95",
              "name": "F95",
              "subcategories": []
            },
            {
              "id": "cranes-fassi-f110",
              "name": "F110",
              "subcategories": []
            },
            {
              "id": "cranes-fassi-f115",
              "name": "F115",
              "subcategories": []
            },
            {
              "id": "cranes-fassi-f130",
              "name": "F130",
              "subcategories": []
            },
            {
              "id": "cranes-fassi-f135",
              "name": "F135",
              "subcategories": []
            },
            {
              "id": "cranes-fassi-f145",
              "name": "F145",
              "subcategories": []
            },
            {
              "id": "cranes-fassi-f155",
              "name": "F155",
              "subcategories": []
            },
            {
              "id": "cranes-fassi-f165",
              "name": "F165",
              "subcategories": []
            },
            {
              "id": "cranes-fassi-f170",
              "name": "F170",
              "subcategories": []
            },
            {
              "id": "cranes-fassi-f185",
              "name": "F185",
              "subcategories": []
            },
            {
              "id": "cranes-fassi-f190",
              "name": "F190",
              "subcategories": []
            },
            {
              "id": "cranes-fassi-f195",
              "name": "F195",
              "subcategories": []
            },
            {
              "id": "cranes-fassi-f200",
              "name": "F200",
              "subcategories": []
            },
            {
              "id": "cranes-fassi-f215",
              "name": "F215",
              "subcategories": []
            },
            {
              "id": "cranes-fassi-f230",
              "name": "F230",
              "subcategories": []
            },
            {
              "id": "cranes-fassi-f235",
              "name": "F235",
              "subcategories": []
            },
            {
              "id": "cranes-fassi-f240",
              "name": "F240",
              "subcategories": []
            },
            {
              "id": "cranes-fassi-f245",
              "name": "F245",
              "subcategories": []
            },
            {
              "id": "cranes-fassi-f250",
              "name": "F250",
              "subcategories": []
            },
            {
              "id": "cranes-fassi-f255",
              "name": "F255",
              "subcategories": []
            },
            {
              "id": "cranes-fassi-f260",
              "name": "F260",
              "subcategories": []
            },
            {
              "id": "cranes-fassi-f270",
              "name": "F270",
              "subcategories": []
            },
            {
              "id": "cranes-fassi-f275",
              "name": "F275",
              "subcategories": []
            },
            {
              "id": "cranes-fassi-f280",
              "name": "F280",
              "subcategories": []
            },
            {
              "id": "cranes-fassi-f290",
              "name": "F290",
              "subcategories": []
            },
            {
              "id": "cranes-fassi-f295",
              "name": "F295",
              "subcategories": []
            },
            {
              "id": "cranes-fassi-f315",
              "name": "F315",
              "subcategories": []
            },
            {
              "id": "cranes-fassi-f330",
              "name": "F330",
              "subcategories": []
            },
            {
              "id": "cranes-fassi-f335",
              "name": "F335",
              "subcategories": []
            },
            {
              "id": "cranes-fassi-f340",
              "name": "F340",
              "subcategories": []
            },
            {
              "id": "cranes-fassi-f345",
              "name": "F345",
              "subcategories": []
            },
            {
              "id": "cranes-fassi-f360",
              "name": "F360",
              "subcategories": []
            },
            {
              "id": "cranes-fassi-f365",
              "name": "F365",
              "subcategories": []
            },
            {
              "id": "cranes-fassi-f375",
              "name": "F375",
              "subcategories": []
            },
            {
              "id": "cranes-fassi-f385",
              "name": "F385",
              "subcategories": []
            },
            {
              "id": "cranes-fassi-f390",
              "name": "F390",
              "subcategories": []
            },
            {
              "id": "cranes-fassi-f420",
              "name": "F420",
              "subcategories": []
            },
            {
              "id": "cranes-fassi-f425",
              "name": "F425",
              "subcategories": []
            },
            {
              "id": "cranes-fassi-f450",
              "name": "F450",
              "subcategories": []
            },
            {
              "id": "cranes-fassi-f455",
              "name": "F455",
              "subcategories": []
            },
            {
              "id": "cranes-fassi-f485",
              "name": "F485",
              "subcategories": []
            },
            {
              "id": "cranes-fassi-f545",
              "name": "F545",
              "subcategories": []
            },
            {
              "id": "cranes-fassi-f660",
              "name": "F660",
              "subcategories": []
            },
            {
              "id": "cranes-fassi-f805",
              "name": "F805",
              "subcategories": []
            },
            {
              "id": "cranes-fassi-f905",
              "name": "F905",
              "subcategories": []
            },
            {
              "id": "cranes-fassi-f1050",
              "name": "F1050",
              "subcategories": []
            },
            {
              "id": "cranes-fassi-f1150",
              "name": "F1150",
              "subcategories": []
            },
            {
              "id": "cranes-fassi-f1250",
              "name": "F1250",
              "subcategories": []
            },
            {
              "id": "cranes-fassi-f1950",
              "name": "F1950",
              "subcategories": []
            },
            {
              "id": "cranes-fassi-f2350",
              "name": "F2350",
              "subcategories": []
            },
            {
              "id": "cranes-fassi-micro-m10",
              "name": "MICRO M10",
              "subcategories": []
            },
            {
              "id": "cranes-fassi-micro-m20",
              "name": "MICRO M20",
              "subcategories": []
            },
            {
              "id": "cranes-fassi-micro-m25",
              "name": "MICRO M25",
              "subcategories": []
            },
            {
              "id": "cranes-fassi-micro-m30",
              "name": "MICRO M30",
              "subcategories": []
            },
            {
              "id": "cranes-fassi-other",
              "name": "OTHER",
              "subcategories": []
            }
          ]
        },
        {
          "id": "cranes-hiab",
          "name": "Hiab",
          "subcategories": [
            {
              "id": "cranes-hiab-007",
              "name": "007",
              "subcategories": []
            },
            {
              "id": "cranes-hiab-045",
              "name": "045",
              "subcategories": []
            },
            {
              "id": "cranes-hiab-060",
              "name": "060",
              "subcategories": []
            },
            {
              "id": "cranes-hiab-070",
              "name": "070",
              "subcategories": []
            },
            {
              "id": "cranes-hiab-071",
              "name": "071",
              "subcategories": []
            },
            {
              "id": "cranes-hiab-077",
              "name": "077",
              "subcategories": []
            },
            {
              "id": "cranes-hiab-081",
              "name": "081",
              "subcategories": []
            },
            {
              "id": "cranes-hiab-090",
              "name": "090",
              "subcategories": []
            },
            {
              "id": "cranes-hiab-095",
              "name": "095",
              "subcategories": []
            },
            {
              "id": "cranes-hiab-105",
              "name": "105",
              "subcategories": []
            },
            {
              "id": "cranes-hiab-111",
              "name": "111",
              "subcategories": []
            },
            {
              "id": "cranes-hiab-122",
              "name": "122",
              "subcategories": []
            },
            {
              "id": "cranes-hiab-125",
              "name": "125",
              "subcategories": []
            },
            {
              "id": "cranes-hiab-135",
              "name": "135",
              "subcategories": []
            },
            {
              "id": "cranes-hiab-144",
              "name": "144",
              "subcategories": []
            },
            {
              "id": "cranes-hiab-166",
              "name": "166",
              "subcategories": []
            },
            {
              "id": "cranes-hiab-175",
              "name": "175",
              "subcategories": []
            },
            {
              "id": "cranes-hiab-200",
              "name": "200",
              "subcategories": []
            },
            {
              "id": "cranes-hiab-225",
              "name": "225",
              "subcategories": []
            },
            {
              "id": "cranes-hiab-244",
              "name": "244",
              "subcategories": []
            },
            {
              "id": "cranes-hiab-250",
              "name": "250",
              "subcategories": []
            },
            {
              "id": "cranes-hiab-255",
              "name": "255",
              "subcategories": []
            },
            {
              "id": "cranes-hiab-288",
              "name": "288",
              "subcategories": []
            },
            {
              "id": "cranes-hiab-300",
              "name": "300",
              "subcategories": []
            },
            {
              "id": "cranes-hiab-335",
              "name": "335",
              "subcategories": []
            },
            {
              "id": "cranes-hiab-1100",
              "name": "1100",
              "subcategories": []
            },
            {
              "id": "cranes-hiab-2650",
              "name": "2650",
              "subcategories": []
            },
            {
              "id": "cranes-hiab-j145",
              "name": "J145",
              "subcategories": []
            },
            {
              "id": "cranes-hiab-j245",
              "name": "J245",
              "subcategories": []
            },
            {
              "id": "cranes-hiab-joeboy",
              "name": "JOEBOY",
              "subcategories": []
            },
            {
              "id": "cranes-hiab-k-hipro-425",
              "name": "K-HIPRO 425",
              "subcategories": []
            },
            {
              "id": "cranes-hiab-k-hipro-505",
              "name": "K-HIPRO 505",
              "subcategories": []
            },
            {
              "id": "cranes-hiab-l-hipro-235",
              "name": "L-HIPRO 235",
              "subcategories": []
            },
            {
              "id": "cranes-hiab-r240",
              "name": "R240",
              "subcategories": []
            },
            {
              "id": "cranes-hiab-r300",
              "name": "R300",
              "subcategories": []
            },
            {
              "id": "cranes-hiab-s-clx-100-d-2",
              "name": "S-CLX 100 D-2",
              "subcategories": []
            },
            {
              "id": "cranes-hiab-x-clx-128",
              "name": "X-CLX 128",
              "subcategories": []
            },
            {
              "id": "cranes-hiab-x-duo-078",
              "name": "X-DUO 078",
              "subcategories": []
            },
            {
              "id": "cranes-hiab-x-duo-102",
              "name": "X-DUO 102",
              "subcategories": []
            },
            {
              "id": "cranes-hiab-x-duo-128",
              "name": "X-DUO 128",
              "subcategories": []
            },
            {
              "id": "cranes-hiab-x-duo-178",
              "name": "X-DUO 178",
              "subcategories": []
            },
            {
              "id": "cranes-hiab-x-hiduo-082",
              "name": "X-HIDUO 082",
              "subcategories": []
            },
            {
              "id": "cranes-hiab-x-hiduo-118",
              "name": "X-HIDUO 118",
              "subcategories": []
            },
            {
              "id": "cranes-hiab-x-hiduo-138",
              "name": "X-HIDUO 138",
              "subcategories": []
            },
            {
              "id": "cranes-hiab-x-hiduo-158",
              "name": "X-HIDUO 158",
              "subcategories": []
            },
            {
              "id": "cranes-hiab-x-hiduo-258",
              "name": "X-HIDUO 258",
              "subcategories": []
            },
            {
              "id": "cranes-hiab-x-hiduo-232",
              "name": "X-HIDUO 232",
              "subcategories": []
            },
            {
              "id": "cranes-hiab-x-hipro-352",
              "name": "X-HIPRO 352",
              "subcategories": []
            },
            {
              "id": "cranes-hiab-x-hipro-358",
              "name": "X-HIPRO 358",
              "subcategories": []
            },
            {
              "id": "cranes-hiab-x-hipro-418",
              "name": "X-HIPRO 418",
              "subcategories": []
            },
            {
              "id": "cranes-hiab-x-hipro-558",
              "name": "X-HIPRO 558",
              "subcategories": []
            },
            {
              "id": "cranes-hiab-xs033",
              "name": "XS033",
              "subcategories": []
            },
            {
              "id": "cranes-hiab-xs055",
              "name": "XS055",
              "subcategories": []
            },
            {
              "id": "cranes-hiab-xs099",
              "name": "XS099",
              "subcategories": []
            },
            {
              "id": "cranes-hiab-xs122",
              "name": "XS122",
              "subcategories": []
            },
            {
              "id": "cranes-hiab-xs111",
              "name": "XS111",
              "subcategories": []
            },
            {
              "id": "cranes-hiab-xs144",
              "name": "XS144",
              "subcategories": []
            },
            {
              "id": "cranes-hiab-xs166",
              "name": "XS166",
              "subcategories": []
            },
            {
              "id": "cranes-hiab-xs211",
              "name": "XS211",
              "subcategories": []
            },
            {
              "id": "cranes-hiab-xs244",
              "name": "XS244",
              "subcategories": []
            },
            {
              "id": "cranes-hiab-xs255",
              "name": "XS255",
              "subcategories": []
            },
            {
              "id": "cranes-hiab-xs288",
              "name": "XS288",
              "subcategories": []
            },
            {
              "id": "cranes-hiab-xs322",
              "name": "XS322",
              "subcategories": []
            },
            {
              "id": "cranes-hiab-xs335",
              "name": "XS335",
              "subcategories": []
            },
            {
              "id": "cranes-hiab-xs377",
              "name": "XS377",
              "subcategories": []
            },
            {
              "id": "cranes-hiab-xs422",
              "name": "XS422",
              "subcategories": []
            },
            {
              "id": "cranes-hiab-xs477",
              "name": "XS477",
              "subcategories": []
            },
            {
              "id": "cranes-hiab-xs600",
              "name": "XS600",
              "subcategories": []
            },
            {
              "id": "cranes-hiab-other",
              "name": "OTHER",
              "subcategories": []
            }
          ]
        },
        {
          "id": "cranes-hitachi",
          "name": "Hitachi",
          "subcategories": [
            {
              "id": "cranes-hitachi-fk150",
              "name": "FK150",
              "subcategories": []
            },
            {
              "id": "cranes-hitachi-fk300",
              "name": "FK300",
              "subcategories": []
            },
            {
              "id": "cranes-hitachi-kh100",
              "name": "KH100",
              "subcategories": []
            },
            {
              "id": "cranes-hitachi-kh125",
              "name": "KH125",
              "subcategories": []
            },
            {
              "id": "cranes-hitachi-kh150",
              "name": "KH150",
              "subcategories": []
            },
            {
              "id": "cranes-hitachi-kh180",
              "name": "KH180",
              "subcategories": []
            },
            {
              "id": "cranes-hitachi-kh230",
              "name": "KH230",
              "subcategories": []
            },
            {
              "id": "cranes-hitachi-kh300",
              "name": "KH300",
              "subcategories": []
            },
            {
              "id": "cranes-hitachi-kh500",
              "name": "KH500",
              "subcategories": []
            },
            {
              "id": "cranes-hitachi-kh700",
              "name": "KH700",
              "subcategories": []
            },
            {
              "id": "cranes-hitachi-kh850",
              "name": "KH850",
              "subcategories": []
            },
            {
              "id": "cranes-hitachi-kh1000",
              "name": "KH1000",
              "subcategories": []
            },
            {
              "id": "cranes-hitachi-pd135",
              "name": "PD135",
              "subcategories": []
            },
            {
              "id": "cranes-hitachi-other",
              "name": "OTHER",
              "subcategories": []
            }
          ]
        },
        {
          "id": "cranes-horyong",
          "name": "Horyong",
          "subcategories": [
            {
              "id": "cranes-horyong-mr450a",
              "name": "MR450A",
              "subcategories": []
            },
            {
              "id": "cranes-horyong-sky450",
              "name": "SKY450",
              "subcategories": []
            },
            {
              "id": "cranes-horyong-sky600",
              "name": "SKY600",
              "subcategories": []
            },
            {
              "id": "cranes-horyong-sky750",
              "name": "SKY750",
              "subcategories": []
            },
            {
              "id": "cranes-horyong-sky2804",
              "name": "SKY2804",
              "subcategories": []
            },
            {
              "id": "cranes-horyong-sky3004",
              "name": "SKY3004",
              "subcategories": []
            },
            {
              "id": "cranes-horyong-other",
              "name": "OTHER",
              "subcategories": []
            }
          ]
        },
        {
          "id": "cranes-imt",
          "name": "Imt",
          "subcategories": [
            {
              "id": "cranes-imt-2-5-18",
              "name": "2.5/18",
              "subcategories": []
            },
            {
              "id": "cranes-imt-10-65",
              "name": "10/65",
              "subcategories": []
            },
            {
              "id": "cranes-imt-11-76",
              "name": "11/76",
              "subcategories": []
            },
            {
              "id": "cranes-imt-12-86",
              "name": "12/86",
              "subcategories": []
            },
            {
              "id": "cranes-imt-14-98",
              "name": "14/98",
              "subcategories": []
            },
            {
              "id": "cranes-imt-15-105",
              "name": "15/105",
              "subcategories": []
            },
            {
              "id": "cranes-imt-16-117",
              "name": "16/117",
              "subcategories": []
            },
            {
              "id": "cranes-imt-32-222",
              "name": "32/222",
              "subcategories": []
            },
            {
              "id": "cranes-imt-40-275",
              "name": "40/275",
              "subcategories": []
            },
            {
              "id": "cranes-imt-50-345",
              "name": "50/345",
              "subcategories": []
            },
            {
              "id": "cranes-imt-425",
              "name": "425",
              "subcategories": []
            },
            {
              "id": "cranes-imt-810",
              "name": "810",
              "subcategories": []
            },
            {
              "id": "cranes-imt-1030",
              "name": "1030",
              "subcategories": []
            },
            {
              "id": "cranes-imt-1123",
              "name": "1123",
              "subcategories": []
            },
            {
              "id": "cranes-imt-1610",
              "name": "1610",
              "subcategories": []
            },
            {
              "id": "cranes-imt-1730",
              "name": "1730",
              "subcategories": []
            },
            {
              "id": "cranes-imt-2020",
              "name": "2020",
              "subcategories": []
            },
            {
              "id": "cranes-imt-2530",
              "name": "2530",
              "subcategories": []
            },
            {
              "id": "cranes-imt-2820",
              "name": "2820",
              "subcategories": []
            },
            {
              "id": "cranes-imt-3203",
              "name": "3203",
              "subcategories": []
            },
            {
              "id": "cranes-imt-3820",
              "name": "3820",
              "subcategories": []
            },
            {
              "id": "cranes-imt-4004",
              "name": "4004",
              "subcategories": []
            },
            {
              "id": "cranes-imt-4300",
              "name": "4300",
              "subcategories": []
            },
            {
              "id": "cranes-imt-5200",
              "name": "5200",
              "subcategories": []
            },
            {
              "id": "cranes-imt-6025",
              "name": "6025",
              "subcategories": []
            },
            {
              "id": "cranes-imt-7500",
              "name": "7500",
              "subcategories": []
            },
            {
              "id": "cranes-imt-9600",
              "name": "9600",
              "subcategories": []
            },
            {
              "id": "cranes-imt-9500",
              "name": "9500",
              "subcategories": []
            },
            {
              "id": "cranes-imt-10000",
              "name": "10000",
              "subcategories": []
            },
            {
              "id": "cranes-imt-12000",
              "name": "12000",
              "subcategories": []
            },
            {
              "id": "cranes-imt-16000",
              "name": "16000",
              "subcategories": []
            },
            {
              "id": "cranes-imt-20017",
              "name": "20017",
              "subcategories": []
            },
            {
              "id": "cranes-imt-24562",
              "name": "24562",
              "subcategories": []
            },
            {
              "id": "cranes-imt-28562",
              "name": "28562",
              "subcategories": []
            },
            {
              "id": "cranes-imt-42684",
              "name": "42684",
              "subcategories": []
            },
            {
              "id": "cranes-imt-dominator-ii",
              "name": "DOMINATOR II",
              "subcategories": []
            },
            {
              "id": "cranes-imt-ez300",
              "name": "EZ300",
              "subcategories": []
            },
            {
              "id": "cranes-imt-other",
              "name": "OTHER",
              "subcategories": []
            }
          ]
        },
        {
          "id": "cranes-jekko",
          "name": "Jekko",
          "subcategories": [
            {
              "id": "cranes-jekko-jf235",
              "name": "JF235",
              "subcategories": []
            },
            {
              "id": "cranes-jekko-jf545",
              "name": "JF545",
              "subcategories": []
            },
            {
              "id": "cranes-jekko-jf990",
              "name": "JF990",
              "subcategories": []
            },
            {
              "id": "cranes-jekko-jvm800",
              "name": "JVM800",
              "subcategories": []
            },
            {
              "id": "cranes-jekko-mpk06",
              "name": "MPK06",
              "subcategories": []
            },
            {
              "id": "cranes-jekko-mpk06-2",
              "name": "MPK06.2",
              "subcategories": []
            },
            {
              "id": "cranes-jekko-mpk10",
              "name": "MPK10",
              "subcategories": []
            },
            {
              "id": "cranes-jekko-mpk20",
              "name": "MPK20",
              "subcategories": []
            },
            {
              "id": "cranes-jekko-mpk50",
              "name": "MPK50",
              "subcategories": []
            },
            {
              "id": "cranes-jekko-spb209",
              "name": "SPB209",
              "subcategories": []
            },
            {
              "id": "cranes-jekko-spd360",
              "name": "SPD360",
              "subcategories": []
            },
            {
              "id": "cranes-jekko-spk60",
              "name": "SPK60",
              "subcategories": []
            },
            {
              "id": "cranes-jekko-spx309",
              "name": "SPX309",
              "subcategories": []
            },
            {
              "id": "cranes-jekko-spx312",
              "name": "SPX312",
              "subcategories": []
            },
            {
              "id": "cranes-jekko-spx328",
              "name": "SPX328",
              "subcategories": []
            },
            {
              "id": "cranes-jekko-spx424",
              "name": "SPX424",
              "subcategories": []
            },
            {
              "id": "cranes-jekko-spx509",
              "name": "SPX509",
              "subcategories": []
            },
            {
              "id": "cranes-jekko-spx527",
              "name": "SPX527",
              "subcategories": []
            },
            {
              "id": "cranes-jekko-spx532",
              "name": "SPX532",
              "subcategories": []
            },
            {
              "id": "cranes-jekko-spx536",
              "name": "SPX536",
              "subcategories": []
            },
            {
              "id": "cranes-jekko-spx650",
              "name": "SPX650",
              "subcategories": []
            },
            {
              "id": "cranes-jekko-spx1040",
              "name": "SPX1040",
              "subcategories": []
            },
            {
              "id": "cranes-jekko-spx1275",
              "name": "SPX1275",
              "subcategories": []
            },
            {
              "id": "cranes-jekko-spx1280",
              "name": "SPX1280",
              "subcategories": []
            },
            {
              "id": "cranes-jekko-other",
              "name": "OTHER",
              "subcategories": []
            }
          ]
        },
        {
          "id": "cranes-kato",
          "name": "Kato",
          "subcategories": [
            {
              "id": "cranes-kato-cch1000",
              "name": "CCH1000",
              "subcategories": []
            },
            {
              "id": "cranes-kato-cr350",
              "name": "CR350",
              "subcategories": []
            },
            {
              "id": "cranes-kato-kr10",
              "name": "KR10",
              "subcategories": []
            },
            {
              "id": "cranes-kato-kr25",
              "name": "KR25",
              "subcategories": []
            },
            {
              "id": "cranes-kato-kr35",
              "name": "KR35",
              "subcategories": []
            },
            {
              "id": "cranes-kato-kr45",
              "name": "KR45",
              "subcategories": []
            },
            {
              "id": "cranes-kato-kr50",
              "name": "KR50",
              "subcategories": []
            },
            {
              "id": "cranes-kato-kr65",
              "name": "KR65",
              "subcategories": []
            },
            {
              "id": "cranes-kato-kr70",
              "name": "KR70",
              "subcategories": []
            },
            {
              "id": "cranes-kato-mr100",
              "name": "MR100",
              "subcategories": []
            },
            {
              "id": "cranes-kato-mr220",
              "name": "MR220",
              "subcategories": []
            },
            {
              "id": "cranes-kato-nk200",
              "name": "NK200",
              "subcategories": []
            },
            {
              "id": "cranes-kato-nk250",
              "name": "NK250",
              "subcategories": []
            },
            {
              "id": "cranes-kato-nk500",
              "name": "NK500",
              "subcategories": []
            },
            {
              "id": "cranes-kato-nk550",
              "name": "NK550",
              "subcategories": []
            },
            {
              "id": "cranes-kato-nk800",
              "name": "NK800",
              "subcategories": []
            },
            {
              "id": "cranes-kato-nk1200",
              "name": "NK1200",
              "subcategories": []
            },
            {
              "id": "cranes-kato-nk1600",
              "name": "NK1600",
              "subcategories": []
            },
            {
              "id": "cranes-kato-ss500spv-1",
              "name": "SS500SPV-1",
              "subcategories": []
            },
            {
              "id": "cranes-kato-sr250",
              "name": "SR250",
              "subcategories": []
            },
            {
              "id": "cranes-kato-ss250",
              "name": "SS250",
              "subcategories": []
            },
            {
              "id": "cranes-kato-ss500",
              "name": "SS500",
              "subcategories": []
            },
            {
              "id": "cranes-kato-other",
              "name": "OTHER",
              "subcategories": []
            }
          ]
        },
        {
          "id": "cranes-kobelco",
          "name": "Kobelco",
          "subcategories": [
            {
              "id": "cranes-kobelco-7035",
              "name": "7035",
              "subcategories": []
            },
            {
              "id": "cranes-kobelco-7055",
              "name": "7055",
              "subcategories": []
            },
            {
              "id": "cranes-kobelco-7065",
              "name": "7065",
              "subcategories": []
            },
            {
              "id": "cranes-kobelco-7080",
              "name": "7080",
              "subcategories": []
            },
            {
              "id": "cranes-kobelco-7100",
              "name": "7100",
              "subcategories": []
            },
            {
              "id": "cranes-kobelco-7120",
              "name": "7120",
              "subcategories": []
            },
            {
              "id": "cranes-kobelco-7150",
              "name": "7150",
              "subcategories": []
            },
            {
              "id": "cranes-kobelco-7200",
              "name": "7200",
              "subcategories": []
            },
            {
              "id": "cranes-kobelco-7250",
              "name": "7250",
              "subcategories": []
            },
            {
              "id": "cranes-kobelco-7300",
              "name": "7300",
              "subcategories": []
            },
            {
              "id": "cranes-kobelco-7450",
              "name": "7450",
              "subcategories": []
            },
            {
              "id": "cranes-kobelco-7800",
              "name": "7800",
              "subcategories": []
            },
            {
              "id": "cranes-kobelco-9170",
              "name": "9170",
              "subcategories": []
            },
            {
              "id": "cranes-kobelco-bm500",
              "name": "BM500",
              "subcategories": []
            },
            {
              "id": "cranes-kobelco-bm600",
              "name": "BM600",
              "subcategories": []
            },
            {
              "id": "cranes-kobelco-bm700",
              "name": "BM700",
              "subcategories": []
            },
            {
              "id": "cranes-kobelco-bm900",
              "name": "BM900",
              "subcategories": []
            },
            {
              "id": "cranes-kobelco-bm1000",
              "name": "BM1000",
              "subcategories": []
            },
            {
              "id": "cranes-kobelco-bm1200",
              "name": "BM1200",
              "subcategories": []
            },
            {
              "id": "cranes-kobelco-bms1000",
              "name": "BMS1000",
              "subcategories": []
            },
            {
              "id": "cranes-kobelco-ck800",
              "name": "CK800",
              "subcategories": []
            },
            {
              "id": "cranes-kobelco-ck850",
              "name": "CK850",
              "subcategories": []
            },
            {
              "id": "cranes-kobelco-ck1000",
              "name": "CK1000",
              "subcategories": []
            },
            {
              "id": "cranes-kobelco-ck1100",
              "name": "CK1100",
              "subcategories": []
            },
            {
              "id": "cranes-kobelco-ck1200",
              "name": "CK1200",
              "subcategories": []
            },
            {
              "id": "cranes-kobelco-ck1600",
              "name": "CK1600",
              "subcategories": []
            },
            {
              "id": "cranes-kobelco-ck2000",
              "name": "CK2000",
              "subcategories": []
            },
            {
              "id": "cranes-kobelco-ck2500",
              "name": "CK2500",
              "subcategories": []
            },
            {
              "id": "cranes-kobelco-ck2750",
              "name": "CK2750",
              "subcategories": []
            },
            {
              "id": "cranes-kobelco-ck3300",
              "name": "CK3300",
              "subcategories": []
            },
            {
              "id": "cranes-kobelco-cke800",
              "name": "CKE800",
              "subcategories": []
            },
            {
              "id": "cranes-kobelco-cke900",
              "name": "CKE900",
              "subcategories": []
            },
            {
              "id": "cranes-kobelco-cke1800",
              "name": "CKE1800",
              "subcategories": []
            },
            {
              "id": "cranes-kobelco-cke2500",
              "name": "CKE2500",
              "subcategories": []
            },
            {
              "id": "cranes-kobelco-cke3000",
              "name": "CKE3000",
              "subcategories": []
            },
            {
              "id": "cranes-kobelco-cke4000",
              "name": "CKE4000",
              "subcategories": []
            },
            {
              "id": "cranes-kobelco-cks800",
              "name": "CKS800",
              "subcategories": []
            },
            {
              "id": "cranes-kobelco-cks1350",
              "name": "CKS1350",
              "subcategories": []
            },
            {
              "id": "cranes-kobelco-cks2500",
              "name": "CKS2500",
              "subcategories": []
            },
            {
              "id": "cranes-kobelco-mk500",
              "name": "MK500",
              "subcategories": []
            },
            {
              "id": "cranes-kobelco-rk70",
              "name": "RK70",
              "subcategories": []
            },
            {
              "id": "cranes-kobelco-rk120",
              "name": "RK120",
              "subcategories": []
            },
            {
              "id": "cranes-kobelco-rk250",
              "name": "RK250",
              "subcategories": []
            },
            {
              "id": "cranes-kobelco-rk450",
              "name": "RK450",
              "subcategories": []
            },
            {
              "id": "cranes-kobelco-rk500",
              "name": "RK500",
              "subcategories": []
            },
            {
              "id": "cranes-kobelco-sl4500",
              "name": "SL4500",
              "subcategories": []
            },
            {
              "id": "cranes-kobelco-sl6000",
              "name": "SL6000",
              "subcategories": []
            },
            {
              "id": "cranes-kobelco-tk750",
              "name": "TK750",
              "subcategories": []
            },
            {
              "id": "cranes-kobelco-other",
              "name": "OTHER",
              "subcategories": []
            }
          ]
        },
        {
          "id": "cranes-manitowoc",
          "name": "Manitowoc",
          "subcategories": [
            {
              "id": "cranes-manitowoc-40",
              "name": "40",
              "subcategories": []
            },
            {
              "id": "cranes-manitowoc-60",
              "name": "60",
              "subcategories": []
            },
            {
              "id": "cranes-manitowoc-222",
              "name": "222",
              "subcategories": []
            },
            {
              "id": "cranes-manitowoc-555",
              "name": "555",
              "subcategories": []
            },
            {
              "id": "cranes-manitowoc-777",
              "name": "777",
              "subcategories": []
            },
            {
              "id": "cranes-manitowoc-888",
              "name": "888",
              "subcategories": []
            },
            {
              "id": "cranes-manitowoc-999",
              "name": "999",
              "subcategories": []
            },
            {
              "id": "cranes-manitowoc-2250",
              "name": "2250",
              "subcategories": []
            },
            {
              "id": "cranes-manitowoc-2900",
              "name": "2900",
              "subcategories": []
            },
            {
              "id": "cranes-manitowoc-3339",
              "name": "3339",
              "subcategories": []
            },
            {
              "id": "cranes-manitowoc-3600",
              "name": "3600",
              "subcategories": []
            },
            {
              "id": "cranes-manitowoc-3900",
              "name": "3900",
              "subcategories": []
            },
            {
              "id": "cranes-manitowoc-4000",
              "name": "4000",
              "subcategories": []
            },
            {
              "id": "cranes-manitowoc-4100",
              "name": "4100",
              "subcategories": []
            },
            {
              "id": "cranes-manitowoc-4500",
              "name": "4500",
              "subcategories": []
            },
            {
              "id": "cranes-manitowoc-4600",
              "name": "4600",
              "subcategories": []
            },
            {
              "id": "cranes-manitowoc-8000",
              "name": "8000",
              "subcategories": []
            },
            {
              "id": "cranes-manitowoc-8500",
              "name": "8500",
              "subcategories": []
            },
            {
              "id": "cranes-manitowoc-10000",
              "name": "10000",
              "subcategories": []
            },
            {
              "id": "cranes-manitowoc-11000",
              "name": "11000",
              "subcategories": []
            },
            {
              "id": "cranes-manitowoc-12000",
              "name": "12000",
              "subcategories": []
            },
            {
              "id": "cranes-manitowoc-14000",
              "name": "14000",
              "subcategories": []
            },
            {
              "id": "cranes-manitowoc-15000",
              "name": "15000",
              "subcategories": []
            },
            {
              "id": "cranes-manitowoc-16000",
              "name": "16000",
              "subcategories": []
            },
            {
              "id": "cranes-manitowoc-18000",
              "name": "18000",
              "subcategories": []
            },
            {
              "id": "cranes-manitowoc-21000",
              "name": "21000",
              "subcategories": []
            },
            {
              "id": "cranes-manitowoc-gmk5095",
              "name": "GMK5095",
              "subcategories": []
            },
            {
              "id": "cranes-manitowoc-m250",
              "name": "M250",
              "subcategories": []
            },
            {
              "id": "cranes-manitowoc-mlc80",
              "name": "MLC80",
              "subcategories": []
            },
            {
              "id": "cranes-manitowoc-mlc100",
              "name": "MLC100",
              "subcategories": []
            },
            {
              "id": "cranes-manitowoc-mlc150",
              "name": "MLC150",
              "subcategories": []
            },
            {
              "id": "cranes-manitowoc-mlc165",
              "name": "MLC165",
              "subcategories": []
            },
            {
              "id": "cranes-manitowoc-mlc200",
              "name": "MLC200",
              "subcategories": []
            },
            {
              "id": "cranes-manitowoc-mlc250",
              "name": "MLC250",
              "subcategories": []
            },
            {
              "id": "cranes-manitowoc-mlc300",
              "name": "MLC300",
              "subcategories": []
            },
            {
              "id": "cranes-manitowoc-mlc650",
              "name": "MLC650",
              "subcategories": []
            },
            {
              "id": "cranes-manitowoc-shuttleft-scd09",
              "name": "SHUTTLEFT SCD09",
              "subcategories": []
            },
            {
              "id": "cranes-manitowoc-other",
              "name": "OTHER",
              "subcategories": []
            }
          ]
        },
        {
          "id": "cranes-northwest",
          "name": "Northwest",
          "subcategories": [
            {
              "id": "cranes-northwest-6",
              "name": "6",
              "subcategories": []
            },
            {
              "id": "cranes-northwest-25",
              "name": "25",
              "subcategories": []
            },
            {
              "id": "cranes-northwest-28",
              "name": "28",
              "subcategories": []
            },
            {
              "id": "cranes-northwest-41",
              "name": "41",
              "subcategories": []
            },
            {
              "id": "cranes-northwest-50",
              "name": "50",
              "subcategories": []
            },
            {
              "id": "cranes-northwest-80",
              "name": "80",
              "subcategories": []
            },
            {
              "id": "cranes-northwest-95",
              "name": "95",
              "subcategories": []
            },
            {
              "id": "cranes-northwest-180",
              "name": "180",
              "subcategories": []
            },
            {
              "id": "cranes-northwest-190",
              "name": "190",
              "subcategories": []
            },
            {
              "id": "cranes-northwest-1200",
              "name": "1200",
              "subcategories": []
            },
            {
              "id": "cranes-northwest-5065",
              "name": "5065",
              "subcategories": []
            },
            {
              "id": "cranes-northwest-7060",
              "name": "7060",
              "subcategories": []
            },
            {
              "id": "cranes-northwest-9570",
              "name": "9570",
              "subcategories": []
            },
            {
              "id": "cranes-northwest-other",
              "name": "OTHER",
              "subcategories": []
            }
          ]
        },
        {
          "id": "cranes-palfinger",
          "name": "Palfinger",
          "subcategories": [
            {
              "id": "cranes-palfinger-etc35",
              "name": "ETC35",
              "subcategories": []
            },
            {
              "id": "cranes-palfinger-etc37",
              "name": "ETC37",
              "subcategories": []
            },
            {
              "id": "cranes-palfinger-etc40",
              "name": "ETC40",
              "subcategories": []
            },
            {
              "id": "cranes-palfinger-ett29",
              "name": "ETT29",
              "subcategories": []
            },
            {
              "id": "cranes-palfinger-m100",
              "name": "M100",
              "subcategories": []
            },
            {
              "id": "cranes-palfinger-p250",
              "name": "P250",
              "subcategories": []
            },
            {
              "id": "cranes-palfinger-p280",
              "name": "P280",
              "subcategories": []
            },
            {
              "id": "cranes-palfinger-p300",
              "name": "P300",
              "subcategories": []
            },
            {
              "id": "cranes-palfinger-pbo5548",
              "name": "PBO5548",
              "subcategories": []
            },
            {
              "id": "cranes-palfinger-pk5-001",
              "name": "PK5.001",
              "subcategories": []
            },
            {
              "id": "cranes-palfinger-pk7-001",
              "name": "PK7.001",
              "subcategories": []
            },
            {
              "id": "cranes-palfinger-pk8-501",
              "name": "PK8.501",
              "subcategories": []
            },
            {
              "id": "cranes-palfinger-pk9-501",
              "name": "PK9.501",
              "subcategories": []
            },
            {
              "id": "cranes-palfinger-pk12-501",
              "name": "PK12.501",
              "subcategories": []
            },
            {
              "id": "cranes-palfinger-pk20-501",
              "name": "PK20.501",
              "subcategories": []
            },
            {
              "id": "cranes-palfinger-pk307",
              "name": "PK307",
              "subcategories": []
            },
            {
              "id": "cranes-palfinger-pk2700",
              "name": "PK2700",
              "subcategories": []
            },
            {
              "id": "cranes-palfinger-pk2900",
              "name": "PK2900",
              "subcategories": []
            },
            {
              "id": "cranes-palfinger-pk4200",
              "name": "PK4200",
              "subcategories": []
            },
            {
              "id": "cranes-palfinger-pk4501",
              "name": "PK4501",
              "subcategories": []
            },
            {
              "id": "cranes-palfinger-pk6001",
              "name": "PK6001",
              "subcategories": []
            },
            {
              "id": "cranes-palfinger-pk7501",
              "name": "PK7501",
              "subcategories": []
            },
            {
              "id": "cranes-palfinger-pk8080",
              "name": "PK8080",
              "subcategories": []
            },
            {
              "id": "cranes-palfinger-pk9001",
              "name": "PK9001",
              "subcategories": []
            },
            {
              "id": "cranes-palfinger-pk9501",
              "name": "PK9501",
              "subcategories": []
            },
            {
              "id": "cranes-palfinger-pk9700",
              "name": "PK9700",
              "subcategories": []
            },
            {
              "id": "cranes-palfinger-pk10000",
              "name": "PK10000",
              "subcategories": []
            },
            {
              "id": "cranes-palfinger-pk11000",
              "name": "PK11000",
              "subcategories": []
            },
            {
              "id": "cranes-palfinger-pk11001",
              "name": "PK11001",
              "subcategories": []
            },
            {
              "id": "cranes-palfinger-pk12000",
              "name": "PK12000",
              "subcategories": []
            },
            {
              "id": "cranes-palfinger-pk12002",
              "name": "PK12002",
              "subcategories": []
            },
            {
              "id": "cranes-palfinger-pk13000",
              "name": "PK13000",
              "subcategories": []
            },
            {
              "id": "cranes-palfinger-pk13001",
              "name": "PK13001",
              "subcategories": []
            },
            {
              "id": "cranes-palfinger-pk14002",
              "name": "PK14002",
              "subcategories": []
            },
            {
              "id": "cranes-palfinger-pk15002",
              "name": "PK15002",
              "subcategories": []
            },
            {
              "id": "cranes-palfinger-pk15500",
              "name": "PK15500",
              "subcategories": []
            },
            {
              "id": "cranes-palfinger-pk17502",
              "name": "PK17502",
              "subcategories": []
            },
            {
              "id": "cranes-palfinger-pk18002",
              "name": "PK18002",
              "subcategories": []
            },
            {
              "id": "cranes-palfinger-pk18500",
              "name": "PK18500",
              "subcategories": []
            },
            {
              "id": "cranes-palfinger-pk20002",
              "name": "PK20002",
              "subcategories": []
            },
            {
              "id": "cranes-palfinger-pk21502",
              "name": "PK21502",
              "subcategories": []
            },
            {
              "id": "cranes-palfinger-pk22002",
              "name": "PK22002",
              "subcategories": []
            },
            {
              "id": "cranes-palfinger-pk23002",
              "name": "PK23002",
              "subcategories": []
            },
            {
              "id": "cranes-palfinger-pk23080",
              "name": "PK23080",
              "subcategories": []
            },
            {
              "id": "cranes-palfinger-pk23500",
              "name": "PK23500",
              "subcategories": []
            },
            {
              "id": "cranes-palfinger-pk24001",
              "name": "PK24001",
              "subcategories": []
            },
            {
              "id": "cranes-palfinger-pk26002",
              "name": "PK26002",
              "subcategories": []
            },
            {
              "id": "cranes-palfinger-pk27002",
              "name": "PK27002",
              "subcategories": []
            },
            {
              "id": "cranes-palfinger-pk29002",
              "name": "PK29002",
              "subcategories": []
            },
            {
              "id": "cranes-palfinger-pk30002",
              "name": "PK30002",
              "subcategories": []
            },
            {
              "id": "cranes-palfinger-pk32080",
              "name": "PK32080",
              "subcategories": []
            },
            {
              "id": "cranes-palfinger-pk33002",
              "name": "PK33002",
              "subcategories": []
            },
            {
              "id": "cranes-palfinger-pk34002",
              "name": "PK34002",
              "subcategories": []
            },
            {
              "id": "cranes-palfinger-pk36002",
              "name": "PK36002",
              "subcategories": []
            },
            {
              "id": "cranes-palfinger-pk40002",
              "name": "PK40002",
              "subcategories": []
            },
            {
              "id": "cranes-palfinger-pk41002",
              "name": "PK41002",
              "subcategories": []
            },
            {
              "id": "cranes-palfinger-pk42002",
              "name": "PK42002",
              "subcategories": []
            },
            {
              "id": "cranes-palfinger-pk42502",
              "name": "PK42502",
              "subcategories": []
            },
            {
              "id": "cranes-palfinger-pk50002",
              "name": "PK50002",
              "subcategories": []
            },
            {
              "id": "cranes-palfinger-pk53002",
              "name": "PK53002",
              "subcategories": []
            },
            {
              "id": "cranes-palfinger-pk54000",
              "name": "PK54000",
              "subcategories": []
            },
            {
              "id": "cranes-palfinger-pk60002",
              "name": "PK60002",
              "subcategories": []
            },
            {
              "id": "cranes-palfinger-pk74002",
              "name": "PK74002",
              "subcategories": []
            },
            {
              "id": "cranes-palfinger-pk85002",
              "name": "PK85002",
              "subcategories": []
            },
            {
              "id": "cranes-palfinger-pk100002",
              "name": "PK100002",
              "subcategories": []
            },
            {
              "id": "cranes-palfinger-pk200002",
              "name": "PK200002",
              "subcategories": []
            },
            {
              "id": "cranes-palfinger-pkg12001",
              "name": "PKG12001",
              "subcategories": []
            },
            {
              "id": "cranes-palfinger-prl260",
              "name": "PRL260",
              "subcategories": []
            },
            {
              "id": "cranes-palfinger-psc3216",
              "name": "PSC3216",
              "subcategories": []
            },
            {
              "id": "cranes-palfinger-psc4329",
              "name": "PSC4329",
              "subcategories": []
            },
            {
              "id": "cranes-palfinger-psc5025",
              "name": "PSC5025",
              "subcategories": []
            },
            {
              "id": "cranes-palfinger-psc6025",
              "name": "PSC6025",
              "subcategories": []
            },
            {
              "id": "cranes-palfinger-psc6229",
              "name": "PSC6229",
              "subcategories": []
            },
            {
              "id": "cranes-palfinger-psc8029",
              "name": "PSC8029",
              "subcategories": []
            },
            {
              "id": "cranes-palfinger-psc10829",
              "name": "PSC10829",
              "subcategories": []
            },
            {
              "id": "cranes-palfinger-pw325",
              "name": "PW325",
              "subcategories": []
            },
            {
              "id": "cranes-palfinger-pw360",
              "name": "PW360",
              "subcategories": []
            },
            {
              "id": "cranes-palfinger-pw400",
              "name": "PW400",
              "subcategories": []
            },
            {
              "id": "cranes-palfinger-pw35001",
              "name": "PW35001",
              "subcategories": []
            },
            {
              "id": "cranes-palfinger-pw32001",
              "name": "PW32001",
              "subcategories": []
            },
            {
              "id": "cranes-palfinger-pw38001",
              "name": "PW38001",
              "subcategories": []
            },
            {
              "id": "cranes-palfinger-pw42001",
              "name": "PW42001",
              "subcategories": []
            },
            {
              "id": "cranes-palfinger-other",
              "name": "OTHER",
              "subcategories": []
            }
          ]
        },
        {
          "id": "cranes-pm",
          "name": "Pm",
          "subcategories": [
            {
              "id": "cranes-pm-2",
              "name": "2",
              "subcategories": []
            },
            {
              "id": "cranes-pm-3",
              "name": "3",
              "subcategories": []
            },
            {
              "id": "cranes-pm-6",
              "name": "6",
              "subcategories": []
            },
            {
              "id": "cranes-pm-8",
              "name": "8",
              "subcategories": []
            },
            {
              "id": "cranes-pm-9-5",
              "name": "9.5",
              "subcategories": []
            },
            {
              "id": "cranes-pm-10",
              "name": "10",
              "subcategories": []
            },
            {
              "id": "cranes-pm-11",
              "name": "11",
              "subcategories": []
            },
            {
              "id": "cranes-pm-11-5",
              "name": "11.5",
              "subcategories": []
            },
            {
              "id": "cranes-pm-12",
              "name": "12",
              "subcategories": []
            },
            {
              "id": "cranes-pm-14",
              "name": "14",
              "subcategories": []
            },
            {
              "id": "cranes-pm-15-5",
              "name": "15.5",
              "subcategories": []
            },
            {
              "id": "cranes-pm-16",
              "name": "16",
              "subcategories": []
            },
            {
              "id": "cranes-pm-16-5",
              "name": "16.5",
              "subcategories": []
            },
            {
              "id": "cranes-pm-18",
              "name": "18",
              "subcategories": []
            },
            {
              "id": "cranes-pm-20",
              "name": "20",
              "subcategories": []
            },
            {
              "id": "cranes-pm-21",
              "name": "21",
              "subcategories": []
            },
            {
              "id": "cranes-pm-21-5",
              "name": "21.5",
              "subcategories": []
            },
            {
              "id": "cranes-pm-23-5",
              "name": "23.5",
              "subcategories": []
            },
            {
              "id": "cranes-pm-26-5",
              "name": "26.5",
              "subcategories": []
            },
            {
              "id": "cranes-pm-27-5",
              "name": "27.5",
              "subcategories": []
            },
            {
              "id": "cranes-pm-28-5",
              "name": "28.5",
              "subcategories": []
            },
            {
              "id": "cranes-pm-32",
              "name": "32",
              "subcategories": []
            },
            {
              "id": "cranes-pm-34",
              "name": "34",
              "subcategories": []
            },
            {
              "id": "cranes-pm-38-5",
              "name": "38.5",
              "subcategories": []
            },
            {
              "id": "cranes-pm-40",
              "name": "40",
              "subcategories": []
            },
            {
              "id": "cranes-pm-41",
              "name": "41",
              "subcategories": []
            },
            {
              "id": "cranes-pm-43",
              "name": "43",
              "subcategories": []
            },
            {
              "id": "cranes-pm-45",
              "name": "45",
              "subcategories": []
            },
            {
              "id": "cranes-pm-47-5",
              "name": "47.5",
              "subcategories": []
            },
            {
              "id": "cranes-pm-48",
              "name": "48",
              "subcategories": []
            },
            {
              "id": "cranes-pm-50",
              "name": "50",
              "subcategories": []
            },
            {
              "id": "cranes-pm-63",
              "name": "63",
              "subcategories": []
            },
            {
              "id": "cranes-pm-65",
              "name": "65",
              "subcategories": []
            },
            {
              "id": "cranes-pm-100",
              "name": "100",
              "subcategories": []
            },
            {
              "id": "cranes-pm-150",
              "name": "150",
              "subcategories": []
            },
            {
              "id": "cranes-pm-210",
              "name": "210",
              "subcategories": []
            },
            {
              "id": "cranes-pm-450",
              "name": "450",
              "subcategories": []
            },
            {
              "id": "cranes-pm-pl74",
              "name": "PL74",
              "subcategories": []
            },
            {
              "id": "cranes-pm-wb60",
              "name": "WB60",
              "subcategories": []
            },
            {
              "id": "cranes-pm-other",
              "name": "OTHER",
              "subcategories": []
            }
          ]
        },
        {
          "id": "cranes-potain",
          "name": "Potain",
          "subcategories": [
            {
              "id": "cranes-potain-325",
              "name": "325",
              "subcategories": []
            },
            {
              "id": "cranes-potain-evy",
              "name": "EVY",
              "subcategories": []
            },
            {
              "id": "cranes-potain-gtmr",
              "name": "GTMR",
              "subcategories": []
            },
            {
              "id": "cranes-potain-hd40",
              "name": "HD40",
              "subcategories": []
            },
            {
              "id": "cranes-potain-hdt80",
              "name": "HDT80",
              "subcategories": []
            },
            {
              "id": "cranes-potain-hup",
              "name": "HUP",
              "subcategories": []
            },
            {
              "id": "cranes-potain-igo15",
              "name": "IGO15",
              "subcategories": []
            },
            {
              "id": "cranes-potain-igo32",
              "name": "IGO32",
              "subcategories": []
            },
            {
              "id": "cranes-potain-igo50",
              "name": "IGO50",
              "subcategories": []
            },
            {
              "id": "cranes-potain-igo-ma21",
              "name": "IGO MA21",
              "subcategories": []
            },
            {
              "id": "cranes-potain-igo-t85",
              "name": "IGO T85",
              "subcategories": []
            },
            {
              "id": "cranes-potain-igo-t99",
              "name": "IGO T99",
              "subcategories": []
            },
            {
              "id": "cranes-potain-igo-t130",
              "name": "IGO T130",
              "subcategories": []
            },
            {
              "id": "cranes-potain-mc85",
              "name": "MC85",
              "subcategories": []
            },
            {
              "id": "cranes-potain-mc230",
              "name": "MC230",
              "subcategories": []
            },
            {
              "id": "cranes-potain-mc310",
              "name": "MC310",
              "subcategories": []
            },
            {
              "id": "cranes-potain-mc475",
              "name": "MC475",
              "subcategories": []
            },
            {
              "id": "cranes-potain-mcr225",
              "name": "MCR225",
              "subcategories": []
            },
            {
              "id": "cranes-potain-mct88",
              "name": "MCT88",
              "subcategories": []
            },
            {
              "id": "cranes-potain-mct188",
              "name": "MCT188",
              "subcategories": []
            },
            {
              "id": "cranes-potain-mct200",
              "name": "MCT200",
              "subcategories": []
            },
            {
              "id": "cranes-potain-mct385",
              "name": "MCT385",
              "subcategories": []
            },
            {
              "id": "cranes-potain-md175",
              "name": "MD175",
              "subcategories": []
            },
            {
              "id": "cranes-potain-md208",
              "name": "MD208",
              "subcategories": []
            },
            {
              "id": "cranes-potain-md265",
              "name": "MD265",
              "subcategories": []
            },
            {
              "id": "cranes-potain-md345",
              "name": "MD345",
              "subcategories": []
            },
            {
              "id": "cranes-potain-md485",
              "name": "MD485",
              "subcategories": []
            },
            {
              "id": "cranes-potain-md509",
              "name": "MD509",
              "subcategories": []
            },
            {
              "id": "cranes-potain-md560",
              "name": "MD560",
              "subcategories": []
            },
            {
              "id": "cranes-potain-md569",
              "name": "MD569",
              "subcategories": []
            },
            {
              "id": "cranes-potain-md689",
              "name": "MD689",
              "subcategories": []
            },
            {
              "id": "cranes-potain-mdt98",
              "name": "MDT98",
              "subcategories": []
            },
            {
              "id": "cranes-potain-mdt109",
              "name": "MDT109",
              "subcategories": []
            },
            {
              "id": "cranes-potain-mdt178",
              "name": "MDT178",
              "subcategories": []
            },
            {
              "id": "cranes-potain-mdt219",
              "name": "MDT219",
              "subcategories": []
            },
            {
              "id": "cranes-potain-mdt302",
              "name": "MDT302",
              "subcategories": []
            },
            {
              "id": "cranes-potain-mdt319",
              "name": "MDT319",
              "subcategories": []
            },
            {
              "id": "cranes-potain-mdt389",
              "name": "MDT389",
              "subcategories": []
            },
            {
              "id": "cranes-potain-mr90",
              "name": "MR90",
              "subcategories": []
            },
            {
              "id": "cranes-potain-mr418",
              "name": "MR418",
              "subcategories": []
            },
            {
              "id": "cranes-potain-mr608",
              "name": "MR608",
              "subcategories": []
            },
            {
              "id": "cranes-potain-mr615",
              "name": "MR615",
              "subcategories": []
            },
            {
              "id": "cranes-potain-other",
              "name": "OTHER",
              "subcategories": []
            }
          ]
        },
        {
          "id": "cranes-sany",
          "name": "Sany",
          "subcategories": [
            {
              "id": "cranes-sany-qy25",
              "name": "QY25",
              "subcategories": []
            },
            {
              "id": "cranes-sany-qy50",
              "name": "QY50",
              "subcategories": []
            },
            {
              "id": "cranes-sany-qy100",
              "name": "QY100",
              "subcategories": []
            },
            {
              "id": "cranes-sany-sac600",
              "name": "SAC600",
              "subcategories": []
            },
            {
              "id": "cranes-sany-sac1300",
              "name": "SAC1300",
              "subcategories": []
            },
            {
              "id": "cranes-sany-sac1600",
              "name": "SAC1600",
              "subcategories": []
            },
            {
              "id": "cranes-sany-sac2200",
              "name": "SAC2200",
              "subcategories": []
            },
            {
              "id": "cranes-sany-sac2600",
              "name": "SAC2600",
              "subcategories": []
            },
            {
              "id": "cranes-sany-sac3000",
              "name": "SAC3000",
              "subcategories": []
            },
            {
              "id": "cranes-sany-sac3500",
              "name": "SAC3500",
              "subcategories": []
            },
            {
              "id": "cranes-sany-sac4500",
              "name": "SAC4500",
              "subcategories": []
            },
            {
              "id": "cranes-sany-sac5000",
              "name": "SAC5000",
              "subcategories": []
            },
            {
              "id": "cranes-sany-sac6000",
              "name": "SAC6000",
              "subcategories": []
            },
            {
              "id": "cranes-sany-sac7000",
              "name": "SAC7000",
              "subcategories": []
            },
            {
              "id": "cranes-sany-sac8000",
              "name": "SAC8000",
              "subcategories": []
            },
            {
              "id": "cranes-sany-sca9000",
              "name": "SCA9000",
              "subcategories": []
            },
            {
              "id": "cranes-sany-sca1000",
              "name": "SCA1000",
              "subcategories": []
            },
            {
              "id": "cranes-sany-sca1100",
              "name": "SCA1100",
              "subcategories": []
            },
            {
              "id": "cranes-sany-sca1350",
              "name": "SCA1350",
              "subcategories": []
            },
            {
              "id": "cranes-sany-sca1600",
              "name": "SCA1600",
              "subcategories": []
            },
            {
              "id": "cranes-sany-sca2600",
              "name": "SCA2600",
              "subcategories": []
            },
            {
              "id": "cranes-sany-sca4000",
              "name": "SCA4000",
              "subcategories": []
            },
            {
              "id": "cranes-sany-scc500",
              "name": "SCC500",
              "subcategories": []
            },
            {
              "id": "cranes-sany-scc550",
              "name": "SCC550",
              "subcategories": []
            },
            {
              "id": "cranes-sany-scc600",
              "name": "SCC600",
              "subcategories": []
            },
            {
              "id": "cranes-sany-scc750",
              "name": "SCC750",
              "subcategories": []
            },
            {
              "id": "cranes-sany-scc800",
              "name": "SCC800",
              "subcategories": []
            },
            {
              "id": "cranes-sany-scc850",
              "name": "SCC850",
              "subcategories": []
            },
            {
              "id": "cranes-sany-scc900",
              "name": "SCC900",
              "subcategories": []
            },
            {
              "id": "cranes-sany-scc1000",
              "name": "SCC1000",
              "subcategories": []
            },
            {
              "id": "cranes-sany-scc1350",
              "name": "SCC1350",
              "subcategories": []
            },
            {
              "id": "cranes-sany-scc1500",
              "name": "SCC1500",
              "subcategories": []
            },
            {
              "id": "cranes-sany-scc2000",
              "name": "SCC2000",
              "subcategories": []
            },
            {
              "id": "cranes-sany-scc2500",
              "name": "SCC2500",
              "subcategories": []
            },
            {
              "id": "cranes-sany-scc3500",
              "name": "SCC3500",
              "subcategories": []
            },
            {
              "id": "cranes-sany-scc6500",
              "name": "SCC6500",
              "subcategories": []
            },
            {
              "id": "cranes-sany-scc8000",
              "name": "SCC8000",
              "subcategories": []
            },
            {
              "id": "cranes-sany-scc8100",
              "name": "SCC8100",
              "subcategories": []
            },
            {
              "id": "cranes-sany-scc8300",
              "name": "SCC8300",
              "subcategories": []
            },
            {
              "id": "cranes-sany-scc19000",
              "name": "SCC19000",
              "subcategories": []
            },
            {
              "id": "cranes-sany-scd150",
              "name": "SCD150",
              "subcategories": []
            },
            {
              "id": "cranes-sany-sce600",
              "name": "SCE600",
              "subcategories": []
            },
            {
              "id": "cranes-sany-sce800",
              "name": "SCE800",
              "subcategories": []
            },
            {
              "id": "cranes-sany-sce1000",
              "name": "SCE1000",
              "subcategories": []
            },
            {
              "id": "cranes-sany-sce1500",
              "name": "SCE1500",
              "subcategories": []
            },
            {
              "id": "cranes-sany-sce2600",
              "name": "SCE2600",
              "subcategories": []
            },
            {
              "id": "cranes-sany-sra350",
              "name": "SRA350",
              "subcategories": []
            },
            {
              "id": "cranes-sany-sra550",
              "name": "SRA550",
              "subcategories": []
            },
            {
              "id": "cranes-sany-sra750",
              "name": "SRA750",
              "subcategories": []
            },
            {
              "id": "cranes-sany-sra1000",
              "name": "SRA1000",
              "subcategories": []
            },
            {
              "id": "cranes-sany-sra1200",
              "name": "SRA1200",
              "subcategories": []
            },
            {
              "id": "cranes-sany-src650",
              "name": "SRC650",
              "subcategories": []
            },
            {
              "id": "cranes-sany-src840",
              "name": "SRC840",
              "subcategories": []
            },
            {
              "id": "cranes-sany-src865",
              "name": "SRC865",
              "subcategories": []
            },
            {
              "id": "cranes-sany-src885",
              "name": "SRC885",
              "subcategories": []
            },
            {
              "id": "cranes-sany-sre600",
              "name": "SRE600",
              "subcategories": []
            },
            {
              "id": "cranes-sany-stb500",
              "name": "STB500",
              "subcategories": []
            },
            {
              "id": "cranes-sany-stc120",
              "name": "STC120",
              "subcategories": []
            },
            {
              "id": "cranes-sany-stc250",
              "name": "STC250",
              "subcategories": []
            },
            {
              "id": "cranes-sany-stc300",
              "name": "STC300",
              "subcategories": []
            },
            {
              "id": "cranes-sany-stc500",
              "name": "STC500",
              "subcategories": []
            },
            {
              "id": "cranes-sany-stc550",
              "name": "STC550",
              "subcategories": []
            },
            {
              "id": "cranes-sany-stc600",
              "name": "STC600",
              "subcategories": []
            },
            {
              "id": "cranes-sany-stc700",
              "name": "STC700",
              "subcategories": []
            },
            {
              "id": "cranes-sany-stc750",
              "name": "STC750",
              "subcategories": []
            },
            {
              "id": "cranes-sany-stc800",
              "name": "STC800",
              "subcategories": []
            },
            {
              "id": "cranes-sany-stc1000",
              "name": "STC1000",
              "subcategories": []
            },
            {
              "id": "cranes-sany-stc1250",
              "name": "STC1250",
              "subcategories": []
            },
            {
              "id": "cranes-sany-stc1300",
              "name": "STC1300",
              "subcategories": []
            },
            {
              "id": "cranes-sany-stc1600",
              "name": "STC1600",
              "subcategories": []
            },
            {
              "id": "cranes-sany-sym5405",
              "name": "SYM5405",
              "subcategories": []
            },
            {
              "id": "cranes-sany-other",
              "name": "OTHER",
              "subcategories": []
            }
          ]
        },
        {
          "id": "cranes-stellar",
          "name": "Stellar",
          "subcategories": [
            {
              "id": "cranes-stellar-4500",
              "name": "4500",
              "subcategories": []
            },
            {
              "id": "cranes-stellar-5520",
              "name": "5520",
              "subcategories": []
            },
            {
              "id": "cranes-stellar-5521",
              "name": "5521",
              "subcategories": []
            },
            {
              "id": "cranes-stellar-6000",
              "name": "6000",
              "subcategories": []
            },
            {
              "id": "cranes-stellar-7621",
              "name": "7621",
              "subcategories": []
            },
            {
              "id": "cranes-stellar-7630",
              "name": "7630",
              "subcategories": []
            },
            {
              "id": "cranes-stellar-8621",
              "name": "8621",
              "subcategories": []
            },
            {
              "id": "cranes-stellar-8630",
              "name": "8630",
              "subcategories": []
            },
            {
              "id": "cranes-stellar-12621",
              "name": "12621",
              "subcategories": []
            },
            {
              "id": "cranes-stellar-12630",
              "name": "12630",
              "subcategories": []
            },
            {
              "id": "cranes-stellar-ec3200",
              "name": "EC3200",
              "subcategories": []
            },
            {
              "id": "cranes-stellar-ec4000",
              "name": "EC4000",
              "subcategories": []
            },
            {
              "id": "cranes-stellar-tmax1-11",
              "name": "TMAX1-11",
              "subcategories": []
            },
            {
              "id": "cranes-stellar-tmax2-11",
              "name": "TMAX2-11",
              "subcategories": []
            },
            {
              "id": "cranes-stellar-tmax2-14",
              "name": "TMAX2-14",
              "subcategories": []
            },
            {
              "id": "cranes-stellar-10621",
              "name": "10621",
              "subcategories": []
            },
            {
              "id": "cranes-stellar-3200",
              "name": "3200",
              "subcategories": []
            },
            {
              "id": "cranes-stellar-other",
              "name": "OTHER",
              "subcategories": []
            }
          ]
        }
      ]
    },
    {
      "id": "crawler-carriers-loader",
      "name": "Crawler Carriers / Loader",
      "subcategories": [
        {
          "id": "crawler-carriers-loader-crawler-carrier-loader",
          "name": "Crawler - Carrier /Loader",
          "subcategories": []
        },
        {
          "id": "crawler-carriers-loader-prinoth",
          "name": "Prinoth",
          "subcategories": [
            {
              "id": "crawler-carriers-loader-prinoth-bison",
              "name": "BISON",
              "subcategories": []
            },
            {
              "id": "crawler-carriers-loader-prinoth-go-tract-3000",
              "name": "GO-TRACT 3000",
              "subcategories": []
            },
            {
              "id": "crawler-carriers-loader-prinoth-gt1200",
              "name": "GT1200",
              "subcategories": []
            },
            {
              "id": "crawler-carriers-loader-prinoth-gt2000",
              "name": "GT2000",
              "subcategories": []
            },
            {
              "id": "crawler-carriers-loader-prinoth-gt3000",
              "name": "GT3000",
              "subcategories": []
            },
            {
              "id": "crawler-carriers-loader-prinoth-gt3000hy",
              "name": "GT3000HY",
              "subcategories": []
            },
            {
              "id": "crawler-carriers-loader-prinoth-gt4500",
              "name": "GT4500",
              "subcategories": []
            },
            {
              "id": "crawler-carriers-loader-prinoth-panther",
              "name": "PANTHER",
              "subcategories": []
            },
            {
              "id": "crawler-carriers-loader-prinoth-panther-t6",
              "name": "PANTHER T6",
              "subcategories": []
            },
            {
              "id": "crawler-carriers-loader-prinoth-panthert7r",
              "name": "PANTHERT7R",
              "subcategories": []
            },
            {
              "id": "crawler-carriers-loader-prinoth-panther-t8",
              "name": "PANTHER T8",
              "subcategories": []
            },
            {
              "id": "crawler-carriers-loader-prinoth-panther-t9r",
              "name": "PANTHER T9R",
              "subcategories": []
            },
            {
              "id": "crawler-carriers-loader-prinoth-panther-t12",
              "name": "PANTHER T12",
              "subcategories": []
            },
            {
              "id": "crawler-carriers-loader-prinoth-panther-t14r",
              "name": "PANTHER T14R",
              "subcategories": []
            },
            {
              "id": "crawler-carriers-loader-prinoth-panther-t16",
              "name": "PANTHER T16",
              "subcategories": []
            },
            {
              "id": "crawler-carriers-loader-prinoth-other",
              "name": "OTHER",
              "subcategories": []
            }
          ]
        },
        {
          "id": "crawler-carriers-loader-morooka",
          "name": "Morooka",
          "subcategories": [
            {
              "id": "crawler-carriers-loader-morooka-mst40cr",
              "name": "MST40CR",
              "subcategories": []
            },
            {
              "id": "crawler-carriers-loader-morooka-mst80",
              "name": "MST80",
              "subcategories": []
            },
            {
              "id": "crawler-carriers-loader-morooka-mst110",
              "name": "MST110",
              "subcategories": []
            },
            {
              "id": "crawler-carriers-loader-morooka-mst200",
              "name": "MST200",
              "subcategories": []
            },
            {
              "id": "crawler-carriers-loader-morooka-mst300",
              "name": "MST300",
              "subcategories": []
            },
            {
              "id": "crawler-carriers-loader-morooka-mst600",
              "name": "MST600",
              "subcategories": []
            },
            {
              "id": "crawler-carriers-loader-morooka-mst660",
              "name": "MST660",
              "subcategories": []
            },
            {
              "id": "crawler-carriers-loader-morooka-mst700",
              "name": "MST700",
              "subcategories": []
            },
            {
              "id": "crawler-carriers-loader-morooka-mst800",
              "name": "MST800",
              "subcategories": []
            },
            {
              "id": "crawler-carriers-loader-morooka-mst1000",
              "name": "MST1000",
              "subcategories": []
            },
            {
              "id": "crawler-carriers-loader-morooka-mst1100",
              "name": "MST1100",
              "subcategories": []
            },
            {
              "id": "crawler-carriers-loader-morooka-mst1500",
              "name": "MST1500",
              "subcategories": []
            },
            {
              "id": "crawler-carriers-loader-morooka-mst2000",
              "name": "MST2000",
              "subcategories": []
            },
            {
              "id": "crawler-carriers-loader-morooka-mst2200",
              "name": "MST2200",
              "subcategories": []
            },
            {
              "id": "crawler-carriers-loader-morooka-mst2300",
              "name": "MST2300",
              "subcategories": []
            },
            {
              "id": "crawler-carriers-loader-morooka-mst2500",
              "name": "MST2500",
              "subcategories": []
            },
            {
              "id": "crawler-carriers-loader-morooka-mst3000",
              "name": "MST3000",
              "subcategories": []
            },
            {
              "id": "crawler-carriers-loader-morooka-mst4000",
              "name": "MST4000",
              "subcategories": []
            },
            {
              "id": "crawler-carriers-loader-morooka-other",
              "name": "OTHER",
              "subcategories": []
            }
          ]
        },
        {
          "id": "crawler-carriers-loader-terramac",
          "name": "Terramac",
          "subcategories": [
            {
              "id": "crawler-carriers-loader-terramac-rt6",
              "name": "RT6",
              "subcategories": []
            },
            {
              "id": "crawler-carriers-loader-terramac-rt7",
              "name": "RT7",
              "subcategories": []
            },
            {
              "id": "crawler-carriers-loader-terramac-rt9",
              "name": "RT9",
              "subcategories": []
            },
            {
              "id": "crawler-carriers-loader-terramac-rt14",
              "name": "RT14",
              "subcategories": []
            },
            {
              "id": "crawler-carriers-loader-terramac-other",
              "name": "OTHER",
              "subcategories": []
            }
          ]
        },
        {
          "id": "crawler-carriers-loader-yanmar",
          "name": "Yanmar",
          "subcategories": [
            {
              "id": "crawler-carriers-loader-yanmar-c12",
              "name": "C12",
              "subcategories": []
            },
            {
              "id": "crawler-carriers-loader-yanmar-c30",
              "name": "C30",
              "subcategories": []
            },
            {
              "id": "crawler-carriers-loader-yanmar-c50",
              "name": "C50",
              "subcategories": []
            },
            {
              "id": "crawler-carriers-loader-yanmar-c60",
              "name": "C60",
              "subcategories": []
            },
            {
              "id": "crawler-carriers-loader-yanmar-c120",
              "name": "C120",
              "subcategories": []
            },
            {
              "id": "crawler-carriers-loader-yanmar-other",
              "name": "OTHER",
              "subcategories": []
            }
          ]
        },
        {
          "id": "crawler-carriers-loader-ihi",
          "name": "Ihi",
          "subcategories": [
            {
              "id": "crawler-carriers-loader-ihi-ic35",
              "name": "IC35",
              "subcategories": []
            },
            {
              "id": "crawler-carriers-loader-ihi-ic45",
              "name": "IC45",
              "subcategories": []
            },
            {
              "id": "crawler-carriers-loader-ihi-ic50",
              "name": "IC50",
              "subcategories": []
            },
            {
              "id": "crawler-carriers-loader-ihi-ic55",
              "name": "IC55",
              "subcategories": []
            },
            {
              "id": "crawler-carriers-loader-ihi-ic70",
              "name": "IC70",
              "subcategories": []
            },
            {
              "id": "crawler-carriers-loader-ihi-ic75",
              "name": "IC75",
              "subcategories": []
            },
            {
              "id": "crawler-carriers-loader-ihi-ic100",
              "name": "IC100",
              "subcategories": []
            },
            {
              "id": "crawler-carriers-loader-ihi-ic120",
              "name": "IC120",
              "subcategories": []
            },
            {
              "id": "crawler-carriers-loader-ihi-other",
              "name": "OTHER",
              "subcategories": []
            }
          ]
        },
        {
          "id": "crawler-carriers-loader-almacrawler",
          "name": "Almacrawler",
          "subcategories": [
            {
              "id": "crawler-carriers-loader-almacrawler-ml1-5",
              "name": "ML1.5",
              "subcategories": []
            },
            {
              "id": "crawler-carriers-loader-almacrawler-ml3-0",
              "name": "ML3.0",
              "subcategories": []
            },
            {
              "id": "crawler-carriers-loader-almacrawler-ml6-0",
              "name": "ML6.0",
              "subcategories": []
            },
            {
              "id": "crawler-carriers-loader-almacrawler-other",
              "name": "OTHER",
              "subcategories": []
            }
          ]
        },
        {
          "id": "crawler-carriers-loader-kato",
          "name": "Kato",
          "subcategories": [
            {
              "id": "crawler-carriers-loader-kato-ic37",
              "name": "IC37",
              "subcategories": []
            },
            {
              "id": "crawler-carriers-loader-kato-ic55",
              "name": "IC55",
              "subcategories": []
            },
            {
              "id": "crawler-carriers-loader-kato-ic70",
              "name": "IC70",
              "subcategories": []
            },
            {
              "id": "crawler-carriers-loader-kato-ic75",
              "name": "IC75",
              "subcategories": []
            },
            {
              "id": "crawler-carriers-loader-kato-ic100",
              "name": "IC100",
              "subcategories": []
            },
            {
              "id": "crawler-carriers-loader-kato-ic110",
              "name": "IC110",
              "subcategories": []
            },
            {
              "id": "crawler-carriers-loader-kato-ic120",
              "name": "IC120",
              "subcategories": []
            },
            {
              "id": "crawler-carriers-loader-kato-other",
              "name": "OTHER",
              "subcategories": []
            }
          ]
        },
        {
          "id": "crawler-carriers-loader-bell",
          "name": "Bell",
          "subcategories": [
            {
              "id": "crawler-carriers-loader-bell-tc7",
              "name": "TC7",
              "subcategories": []
            },
            {
              "id": "crawler-carriers-loader-bell-tc11",
              "name": "TC11",
              "subcategories": []
            },
            {
              "id": "crawler-carriers-loader-bell-other",
              "name": "OTHER",
              "subcategories": []
            }
          ]
        },
        {
          "id": "crawler-carriers-loader-bergman",
          "name": "Bergman",
          "subcategories": [
            {
              "id": "crawler-carriers-loader-bergman-4010",
              "name": "4010",
              "subcategories": []
            },
            {
              "id": "crawler-carriers-loader-bergman-c912",
              "name": "C912",
              "subcategories": []
            },
            {
              "id": "crawler-carriers-loader-bergman-other",
              "name": "OTHER",
              "subcategories": []
            }
          ]
        },
        {
          "id": "crawler-carriers-loader-superior",
          "name": "Superior",
          "subcategories": [
            {
              "id": "crawler-carriers-loader-superior-srt155",
              "name": "SRT155",
              "subcategories": []
            },
            {
              "id": "crawler-carriers-loader-superior-srt180",
              "name": "SRT180",
              "subcategories": []
            },
            {
              "id": "crawler-carriers-loader-superior-st150",
              "name": "ST150",
              "subcategories": []
            },
            {
              "id": "crawler-carriers-loader-superior-st220",
              "name": "ST220",
              "subcategories": []
            },
            {
              "id": "crawler-carriers-loader-superior-st300",
              "name": "ST300",
              "subcategories": []
            },
            {
              "id": "crawler-carriers-loader-superior-other",
              "name": "OTHER",
              "subcategories": []
            }
          ]
        },
        {
          "id": "crawler-carriers-loader-allis-chalmers",
          "name": "Allis Chalmers",
          "subcategories": []
        },
        {
          "id": "crawler-carriers-loader-case",
          "name": "Case",
          "subcategories": [
            {
              "id": "crawler-carriers-loader-case-350",
              "name": "350",
              "subcategories": []
            },
            {
              "id": "crawler-carriers-loader-case-455",
              "name": "455",
              "subcategories": []
            },
            {
              "id": "crawler-carriers-loader-case-455c",
              "name": "455C",
              "subcategories": []
            },
            {
              "id": "crawler-carriers-loader-case-1150",
              "name": "1150",
              "subcategories": []
            },
            {
              "id": "crawler-carriers-loader-case-1150g",
              "name": "1150G",
              "subcategories": []
            },
            {
              "id": "crawler-carriers-loader-case-1155",
              "name": "1155",
              "subcategories": []
            },
            {
              "id": "crawler-carriers-loader-case-1450",
              "name": "1450",
              "subcategories": []
            },
            {
              "id": "crawler-carriers-loader-case-d310",
              "name": "D310",
              "subcategories": []
            },
            {
              "id": "crawler-carriers-loader-case-other",
              "name": "OTHER",
              "subcategories": []
            }
          ]
        },
        {
          "id": "crawler-carriers-loader-caterpillar",
          "name": "Caterpillar",
          "subcategories": [
            {
              "id": "crawler-carriers-loader-caterpillar-931",
              "name": "931",
              "subcategories": []
            },
            {
              "id": "crawler-carriers-loader-caterpillar-931b",
              "name": "931B",
              "subcategories": []
            },
            {
              "id": "crawler-carriers-loader-caterpillar-931b-lgp",
              "name": "931B LGP",
              "subcategories": []
            },
            {
              "id": "crawler-carriers-loader-caterpillar-933",
              "name": "933",
              "subcategories": []
            },
            {
              "id": "crawler-carriers-loader-caterpillar-933-traxcavator",
              "name": "933 TRAXCAVATOR",
              "subcategories": []
            },
            {
              "id": "crawler-carriers-loader-caterpillar-933f",
              "name": "933F",
              "subcategories": []
            },
            {
              "id": "crawler-carriers-loader-caterpillar-935c",
              "name": "935C",
              "subcategories": []
            },
            {
              "id": "crawler-carriers-loader-caterpillar-935c-ii",
              "name": "935C II",
              "subcategories": []
            },
            {
              "id": "crawler-carriers-loader-caterpillar-939",
              "name": "939",
              "subcategories": []
            },
            {
              "id": "crawler-carriers-loader-caterpillar-939c",
              "name": "939C",
              "subcategories": []
            },
            {
              "id": "crawler-carriers-loader-caterpillar-939c-hst",
              "name": "939C HST",
              "subcategories": []
            },
            {
              "id": "crawler-carriers-loader-caterpillar-941",
              "name": "941",
              "subcategories": []
            },
            {
              "id": "crawler-carriers-loader-caterpillar-941b",
              "name": "941B",
              "subcategories": []
            },
            {
              "id": "crawler-carriers-loader-caterpillar-943",
              "name": "943",
              "subcategories": []
            },
            {
              "id": "crawler-carriers-loader-caterpillar-951",
              "name": "951",
              "subcategories": []
            },
            {
              "id": "crawler-carriers-loader-caterpillar-951c",
              "name": "951C",
              "subcategories": []
            },
            {
              "id": "crawler-carriers-loader-caterpillar-953",
              "name": "953",
              "subcategories": []
            },
            {
              "id": "crawler-carriers-loader-caterpillar-953b",
              "name": "953B",
              "subcategories": []
            },
            {
              "id": "crawler-carriers-loader-caterpillar-953c",
              "name": "953C",
              "subcategories": []
            },
            {
              "id": "crawler-carriers-loader-caterpillar-953c-lgp",
              "name": "953C LGP",
              "subcategories": []
            },
            {
              "id": "crawler-carriers-loader-caterpillar-953d",
              "name": "953D",
              "subcategories": []
            },
            {
              "id": "crawler-carriers-loader-caterpillar-953k",
              "name": "953K",
              "subcategories": []
            },
            {
              "id": "crawler-carriers-loader-caterpillar-955h",
              "name": "955H",
              "subcategories": []
            },
            {
              "id": "crawler-carriers-loader-caterpillar-955k",
              "name": "955K",
              "subcategories": []
            },
            {
              "id": "crawler-carriers-loader-caterpillar-955l",
              "name": "955L",
              "subcategories": []
            },
            {
              "id": "crawler-carriers-loader-caterpillar-963",
              "name": "963",
              "subcategories": []
            },
            {
              "id": "crawler-carriers-loader-caterpillar-963-lgp",
              "name": "963 LGP",
              "subcategories": []
            },
            {
              "id": "crawler-carriers-loader-caterpillar-963-wh",
              "name": "963 WH",
              "subcategories": []
            },
            {
              "id": "crawler-carriers-loader-caterpillar-963b",
              "name": "963B",
              "subcategories": []
            },
            {
              "id": "crawler-carriers-loader-caterpillar-963c",
              "name": "963C",
              "subcategories": []
            },
            {
              "id": "crawler-carriers-loader-caterpillar-963c-ii",
              "name": "963C II",
              "subcategories": []
            },
            {
              "id": "crawler-carriers-loader-caterpillar-963d",
              "name": "963D",
              "subcategories": []
            },
            {
              "id": "crawler-carriers-loader-caterpillar-963k",
              "name": "963K",
              "subcategories": []
            },
            {
              "id": "crawler-carriers-loader-caterpillar-973",
              "name": "973",
              "subcategories": []
            },
            {
              "id": "crawler-carriers-loader-caterpillar-973-lgp",
              "name": "973 LGP",
              "subcategories": []
            },
            {
              "id": "crawler-carriers-loader-caterpillar-973c",
              "name": "973C",
              "subcategories": []
            },
            {
              "id": "crawler-carriers-loader-caterpillar-973-wh",
              "name": "973 WH",
              "subcategories": []
            },
            {
              "id": "crawler-carriers-loader-caterpillar-973d",
              "name": "973D",
              "subcategories": []
            },
            {
              "id": "crawler-carriers-loader-caterpillar-973k",
              "name": "973K",
              "subcategories": []
            },
            {
              "id": "crawler-carriers-loader-caterpillar-977e",
              "name": "977E",
              "subcategories": []
            },
            {
              "id": "crawler-carriers-loader-caterpillar-977k",
              "name": "977K",
              "subcategories": []
            },
            {
              "id": "crawler-carriers-loader-caterpillar-977l",
              "name": "977L",
              "subcategories": []
            },
            {
              "id": "crawler-carriers-loader-caterpillar-d6c",
              "name": "D6C",
              "subcategories": []
            },
            {
              "id": "crawler-carriers-loader-caterpillar-ht4",
              "name": "HT4",
              "subcategories": []
            },
            {
              "id": "crawler-carriers-loader-caterpillar-other",
              "name": "OTHER",
              "subcategories": []
            }
          ]
        },
        {
          "id": "crawler-carriers-loader-deere",
          "name": "Deere",
          "subcategories": [
            {
              "id": "crawler-carriers-loader-deere-350",
              "name": "350",
              "subcategories": []
            },
            {
              "id": "crawler-carriers-loader-deere-350b",
              "name": "350B",
              "subcategories": []
            },
            {
              "id": "crawler-carriers-loader-deere-350c",
              "name": "350C",
              "subcategories": []
            },
            {
              "id": "crawler-carriers-loader-deere-450",
              "name": "450",
              "subcategories": []
            },
            {
              "id": "crawler-carriers-loader-deere-450c",
              "name": "450C",
              "subcategories": []
            },
            {
              "id": "crawler-carriers-loader-deere-455",
              "name": "455",
              "subcategories": []
            },
            {
              "id": "crawler-carriers-loader-deere-455g",
              "name": "455G",
              "subcategories": []
            },
            {
              "id": "crawler-carriers-loader-deere-455g-iv",
              "name": "455G IV",
              "subcategories": []
            },
            {
              "id": "crawler-carriers-loader-deere-550",
              "name": "550",
              "subcategories": []
            },
            {
              "id": "crawler-carriers-loader-deere-550g",
              "name": "550G",
              "subcategories": []
            },
            {
              "id": "crawler-carriers-loader-deere-555",
              "name": "555",
              "subcategories": []
            },
            {
              "id": "crawler-carriers-loader-deere-555a",
              "name": "555A",
              "subcategories": []
            },
            {
              "id": "crawler-carriers-loader-deere-555g",
              "name": "555G",
              "subcategories": []
            },
            {
              "id": "crawler-carriers-loader-deere-555g-iv",
              "name": "555G IV",
              "subcategories": []
            },
            {
              "id": "crawler-carriers-loader-deere-605",
              "name": "605",
              "subcategories": []
            },
            {
              "id": "crawler-carriers-loader-deere-605c",
              "name": "605C",
              "subcategories": []
            },
            {
              "id": "crawler-carriers-loader-deere-655c",
              "name": "655C",
              "subcategories": []
            },
            {
              "id": "crawler-carriers-loader-deere-655c-ii",
              "name": "655C II",
              "subcategories": []
            },
            {
              "id": "crawler-carriers-loader-deere-655k",
              "name": "655K",
              "subcategories": []
            },
            {
              "id": "crawler-carriers-loader-deere-755",
              "name": "755",
              "subcategories": []
            },
            {
              "id": "crawler-carriers-loader-deere-755c",
              "name": "755C",
              "subcategories": []
            },
            {
              "id": "crawler-carriers-loader-deere-755k",
              "name": "755K",
              "subcategories": []
            },
            {
              "id": "crawler-carriers-loader-deere-e7450",
              "name": "E7450",
              "subcategories": []
            }
          ]
        },
        {
          "id": "crawler-carriers-loader-dresser",
          "name": "Dresser",
          "subcategories": []
        },
        {
          "id": "crawler-carriers-loader-fiatallis",
          "name": "Fiatallis",
          "subcategories": []
        },
        {
          "id": "crawler-carriers-loader-international",
          "name": "International",
          "subcategories": [
            {
              "id": "crawler-carriers-loader-international-125",
              "name": "125",
              "subcategories": []
            },
            {
              "id": "crawler-carriers-loader-international-500",
              "name": "500",
              "subcategories": []
            },
            {
              "id": "crawler-carriers-loader-international-other",
              "name": "OTHER",
              "subcategories": []
            }
          ]
        },
        {
          "id": "crawler-carriers-loader-komatsu",
          "name": "Komatsu",
          "subcategories": [
            {
              "id": "crawler-carriers-loader-komatsu-d53",
              "name": "D53",
              "subcategories": []
            },
            {
              "id": "crawler-carriers-loader-komatsu-d60",
              "name": "D60",
              "subcategories": []
            },
            {
              "id": "crawler-carriers-loader-komatsu-d66",
              "name": "D66",
              "subcategories": []
            },
            {
              "id": "crawler-carriers-loader-komatsu-d75",
              "name": "D75",
              "subcategories": []
            },
            {
              "id": "crawler-carriers-loader-komatsu-other",
              "name": "OTHER",
              "subcategories": []
            }
          ]
        },
        {
          "id": "crawler-carriers-loader-liebherr",
          "name": "Liebherr",
          "subcategories": [
            {
              "id": "crawler-carriers-loader-liebherr-lr611",
              "name": "LR611",
              "subcategories": []
            },
            {
              "id": "crawler-carriers-loader-liebherr-lr621",
              "name": "LR621",
              "subcategories": []
            },
            {
              "id": "crawler-carriers-loader-liebherr-lr621c",
              "name": "LR621C",
              "subcategories": []
            },
            {
              "id": "crawler-carriers-loader-liebherr-lr622",
              "name": "LR622",
              "subcategories": []
            },
            {
              "id": "crawler-carriers-loader-liebherr-lr622-litronic",
              "name": "LR622 LITRONIC",
              "subcategories": []
            },
            {
              "id": "crawler-carriers-loader-liebherr-lr622b",
              "name": "LR622B",
              "subcategories": []
            },
            {
              "id": "crawler-carriers-loader-liebherr-lr624",
              "name": "LR624",
              "subcategories": []
            },
            {
              "id": "crawler-carriers-loader-liebherr-lr626",
              "name": "LR626",
              "subcategories": []
            },
            {
              "id": "crawler-carriers-loader-liebherr-lr631",
              "name": "LR631",
              "subcategories": []
            },
            {
              "id": "crawler-carriers-loader-liebherr-lr632",
              "name": "LR632",
              "subcategories": []
            },
            {
              "id": "crawler-carriers-loader-liebherr-lr634",
              "name": "LR634",
              "subcategories": []
            },
            {
              "id": "crawler-carriers-loader-liebherr-lr636",
              "name": "LR636",
              "subcategories": []
            },
            {
              "id": "crawler-carriers-loader-liebherr-lr641",
              "name": "LR641",
              "subcategories": []
            },
            {
              "id": "crawler-carriers-loader-liebherr-other",
              "name": "OTHER",
              "subcategories": []
            }
          ]
        },
        {
          "id": "crawler-carriers-loader-liugong",
          "name": "Liugong",
          "subcategories": []
        },
        {
          "id": "crawler-carriers-loader-movex",
          "name": "Movex",
          "subcategories": []
        },
        {
          "id": "crawler-carriers-loader-oliver",
          "name": "Oliver",
          "subcategories": []
        }
      ]
    },
    {
      "id": "dozers",
      "name": "Dozers",
      "subcategories": [
        {
          "id": "dozers-caterillar",
          "name": "Caterillar",
          "subcategories": []
        },
        {
          "id": "dozers-deere",
          "name": "Deere",
          "subcategories": [
            {
              "id": "dozers-deere-40c",
              "name": "40C",
              "subcategories": []
            },
            {
              "id": "dozers-deere-350",
              "name": "350",
              "subcategories": []
            },
            {
              "id": "dozers-deere-350b",
              "name": "350B",
              "subcategories": []
            },
            {
              "id": "dozers-deere-350be",
              "name": "350BE",
              "subcategories": []
            },
            {
              "id": "dozers-deere-350c",
              "name": "350C",
              "subcategories": []
            },
            {
              "id": "dozers-deere-350ce",
              "name": "350CE",
              "subcategories": []
            },
            {
              "id": "dozers-deere-450",
              "name": "450",
              "subcategories": []
            },
            {
              "id": "dozers-deere-450-lgp",
              "name": "450 LGP",
              "subcategories": []
            },
            {
              "id": "dozers-deere-450b",
              "name": "450B",
              "subcategories": []
            },
            {
              "id": "dozers-deere-450bc",
              "name": "450BC",
              "subcategories": []
            },
            {
              "id": "dozers-deere-450c",
              "name": "450C",
              "subcategories": []
            },
            {
              "id": "dozers-deere-450e",
              "name": "450E",
              "subcategories": []
            },
            {
              "id": "dozers-deere-450g",
              "name": "450G",
              "subcategories": []
            },
            {
              "id": "dozers-deere-450g-iv",
              "name": "450G IV",
              "subcategories": []
            },
            {
              "id": "dozers-deere-450g-lgp",
              "name": "450G LGP",
              "subcategories": []
            },
            {
              "id": "dozers-deere-450g-lt-iv",
              "name": "450G LT IV",
              "subcategories": []
            },
            {
              "id": "dozers-deere-450g-tc",
              "name": "450G TC",
              "subcategories": []
            },
            {
              "id": "dozers-deere-450h",
              "name": "450H",
              "subcategories": []
            },
            {
              "id": "dozers-deere-450h-lgp",
              "name": "450H LGP",
              "subcategories": []
            },
            {
              "id": "dozers-deere-450h-lt",
              "name": "450H LT",
              "subcategories": []
            },
            {
              "id": "dozers-deere-450j",
              "name": "450J",
              "subcategories": []
            },
            {
              "id": "dozers-deere-450j-lgp",
              "name": "450J LGP",
              "subcategories": []
            },
            {
              "id": "dozers-deere-450j-lt",
              "name": "450J LT",
              "subcategories": []
            },
            {
              "id": "dozers-deere-450k",
              "name": "450K",
              "subcategories": []
            },
            {
              "id": "dozers-deere-450k-lgp",
              "name": "450K LGP",
              "subcategories": []
            },
            {
              "id": "dozers-deere-450k-lt",
              "name": "450K LT",
              "subcategories": []
            },
            {
              "id": "dozers-deere-450p",
              "name": "450P",
              "subcategories": []
            },
            {
              "id": "dozers-deere-450p-lgp",
              "name": "450P LGP",
              "subcategories": []
            },
            {
              "id": "dozers-deere-450p-xlt",
              "name": "450P XLT",
              "subcategories": []
            },
            {
              "id": "dozers-deere-550",
              "name": "550",
              "subcategories": []
            },
            {
              "id": "dozers-deere-550b",
              "name": "550B",
              "subcategories": []
            },
            {
              "id": "dozers-deere-550g",
              "name": "550G",
              "subcategories": []
            },
            {
              "id": "dozers-deere-550g-lgp",
              "name": "550G LGP",
              "subcategories": []
            },
            {
              "id": "dozers-deere-550g-lt",
              "name": "550G LT",
              "subcategories": []
            },
            {
              "id": "dozers-deere-550g-lt-iv",
              "name": "550G LT IV",
              "subcategories": []
            },
            {
              "id": "dozers-deere-550h",
              "name": "550H",
              "subcategories": []
            },
            {
              "id": "dozers-deere-550h-lgp",
              "name": "550H LGP",
              "subcategories": []
            },
            {
              "id": "dozers-deere-550h-lt",
              "name": "550H LT",
              "subcategories": []
            },
            {
              "id": "dozers-deere-550j",
              "name": "550J",
              "subcategories": []
            },
            {
              "id": "dozers-deere-550j-lgp",
              "name": "550J LGP",
              "subcategories": []
            },
            {
              "id": "dozers-deere-550j-lt",
              "name": "550J LT",
              "subcategories": []
            },
            {
              "id": "dozers-deere-550k",
              "name": "550K",
              "subcategories": []
            },
            {
              "id": "dozers-deere-550k-lgp",
              "name": "550K LGP",
              "subcategories": []
            },
            {
              "id": "dozers-deere-550k-xlt",
              "name": "550K XLT",
              "subcategories": []
            },
            {
              "id": "dozers-deere-550p",
              "name": "550P",
              "subcategories": []
            },
            {
              "id": "dozers-deere-550p-lgp",
              "name": "550P LGP",
              "subcategories": []
            },
            {
              "id": "dozers-deere-550p-xlt",
              "name": "550P XLT",
              "subcategories": []
            },
            {
              "id": "dozers-deere-650",
              "name": "650",
              "subcategories": []
            },
            {
              "id": "dozers-deere-650-lgp",
              "name": "650 LGP",
              "subcategories": []
            },
            {
              "id": "dozers-deere-650-lgp-iv",
              "name": "650 LGP IV",
              "subcategories": []
            },
            {
              "id": "dozers-deere-650g",
              "name": "650G",
              "subcategories": []
            },
            {
              "id": "dozers-deere-650g-iv",
              "name": "650G IV",
              "subcategories": []
            },
            {
              "id": "dozers-deere-650g-lgp",
              "name": "650G LGP",
              "subcategories": []
            },
            {
              "id": "dozers-deere-650g-lgp-iv",
              "name": "650G LGP IV",
              "subcategories": []
            },
            {
              "id": "dozers-deere-650g-lgp-tc",
              "name": "650G LGP TC",
              "subcategories": []
            },
            {
              "id": "dozers-deere-650g-tc-iv",
              "name": "650G TC IV",
              "subcategories": []
            },
            {
              "id": "dozers-deere-650h",
              "name": "650H",
              "subcategories": []
            },
            {
              "id": "dozers-deere-650h-lgp",
              "name": "650H LGP",
              "subcategories": []
            },
            {
              "id": "dozers-deere-650h-lt",
              "name": "650H LT",
              "subcategories": []
            },
            {
              "id": "dozers-deere-650h-xlt",
              "name": "650H XLT",
              "subcategories": []
            },
            {
              "id": "dozers-deere-650j",
              "name": "650J",
              "subcategories": []
            },
            {
              "id": "dozers-deere-650j-lgp",
              "name": "650J LGP",
              "subcategories": []
            },
            {
              "id": "dozers-deere-650j-lt",
              "name": "650J LT",
              "subcategories": []
            },
            {
              "id": "dozers-deere-650j-xlt",
              "name": "650J XLT",
              "subcategories": []
            },
            {
              "id": "dozers-deere-650k",
              "name": "650K",
              "subcategories": []
            },
            {
              "id": "dozers-deere-650k-lgp",
              "name": "650K LGP",
              "subcategories": []
            },
            {
              "id": "dozers-deere-650k-xlt",
              "name": "650K XLT",
              "subcategories": []
            },
            {
              "id": "dozers-deere-650p",
              "name": "650P",
              "subcategories": []
            },
            {
              "id": "dozers-deere-650p-lgp",
              "name": "650P LGP",
              "subcategories": []
            },
            {
              "id": "dozers-deere-650p-xlt",
              "name": "650P XLT",
              "subcategories": []
            },
            {
              "id": "dozers-deere-700h",
              "name": "700H",
              "subcategories": []
            },
            {
              "id": "dozers-deere-700h-lgp",
              "name": "700H LGP",
              "subcategories": []
            },
            {
              "id": "dozers-deere-700h-lt",
              "name": "700H LT",
              "subcategories": []
            },
            {
              "id": "dozers-deere-700j",
              "name": "700J",
              "subcategories": []
            },
            {
              "id": "dozers-deere-700j-ii",
              "name": "700J II",
              "subcategories": []
            },
            {
              "id": "dozers-deere-700j-lgp",
              "name": "700J LGP",
              "subcategories": []
            },
            {
              "id": "dozers-deere-700j-lt",
              "name": "700J LT",
              "subcategories": []
            },
            {
              "id": "dozers-deere-700j-xlt",
              "name": "700J XLT",
              "subcategories": []
            },
            {
              "id": "dozers-deere-700k",
              "name": "700K",
              "subcategories": []
            },
            {
              "id": "dozers-deere-700k-xlt",
              "name": "700K XLT",
              "subcategories": []
            },
            {
              "id": "dozers-deere-700k-xlt",
              "name": "700K XLT",
              "subcategories": []
            },
            {
              "id": "dozers-deere-700l-lgp",
              "name": "700L LGP",
              "subcategories": []
            },
            {
              "id": "dozers-deere-700l-xlt",
              "name": "700L XLT",
              "subcategories": []
            },
            {
              "id": "dozers-deere-700p",
              "name": "700P",
              "subcategories": []
            },
            {
              "id": "dozers-deere-750",
              "name": "750",
              "subcategories": []
            },
            {
              "id": "dozers-deere-750b-lt",
              "name": "750B LT",
              "subcategories": []
            },
            {
              "id": "dozers-deere-750c",
              "name": "750C",
              "subcategories": []
            },
            {
              "id": "dozers-deere-750c-i",
              "name": "750C I",
              "subcategories": []
            },
            {
              "id": "dozers-deere-750c-lgp",
              "name": "750C LGP",
              "subcategories": []
            },
            {
              "id": "dozers-deere-750c-lgp-ii",
              "name": "750C LGP II",
              "subcategories": []
            },
            {
              "id": "dozers-deere-750c-lt",
              "name": "750C LT",
              "subcategories": []
            },
            {
              "id": "dozers-deere-750e",
              "name": "750E",
              "subcategories": []
            },
            {
              "id": "dozers-deere-750j",
              "name": "750J",
              "subcategories": []
            },
            {
              "id": "dozers-deere-750j-lgp",
              "name": "750J LGP",
              "subcategories": []
            },
            {
              "id": "dozers-deere-750j-lt",
              "name": "750J LT",
              "subcategories": []
            },
            {
              "id": "dozers-deere-750j-xlt",
              "name": "750J XLT",
              "subcategories": []
            },
            {
              "id": "dozers-deere-750k",
              "name": "750K",
              "subcategories": []
            },
            {
              "id": "dozers-deere-750k-lgp",
              "name": "750K LGP",
              "subcategories": []
            },
            {
              "id": "dozers-deere-750k-xlt",
              "name": "750K XLT",
              "subcategories": []
            },
            {
              "id": "dozers-deere-750l",
              "name": "750L",
              "subcategories": []
            },
            {
              "id": "dozers-deere-750l-lgp",
              "name": "750L LGP",
              "subcategories": []
            },
            {
              "id": "dozers-deere-750l-xlt",
              "name": "750L XLT",
              "subcategories": []
            },
            {
              "id": "dozers-deere-764-hsd",
              "name": "764 HSD",
              "subcategories": []
            },
            {
              "id": "dozers-deere-850",
              "name": "850",
              "subcategories": []
            },
            {
              "id": "dozers-deere-850-lgp",
              "name": "850 LGP",
              "subcategories": []
            },
            {
              "id": "dozers-deere-850b",
              "name": "850B",
              "subcategories": []
            },
            {
              "id": "dozers-deere-850b-lgp",
              "name": "850B LGP",
              "subcategories": []
            },
            {
              "id": "dozers-deere-850c",
              "name": "850C",
              "subcategories": []
            },
            {
              "id": "dozers-deere-850c-ii",
              "name": "850C II",
              "subcategories": []
            },
            {
              "id": "dozers-deere-850c-lgp",
              "name": "850C LGP",
              "subcategories": []
            },
            {
              "id": "dozers-deere-850c-wt-ii",
              "name": "850C WT II",
              "subcategories": []
            },
            {
              "id": "dozers-deere-850j",
              "name": "850J",
              "subcategories": []
            },
            {
              "id": "dozers-deere-850j-ii",
              "name": "850J II",
              "subcategories": []
            },
            {
              "id": "dozers-deere-850j-lgp",
              "name": "850J LGP",
              "subcategories": []
            },
            {
              "id": "dozers-deere-850j-lt",
              "name": "850J LT",
              "subcategories": []
            },
            {
              "id": "dozers-deere-850j-wlt",
              "name": "850J WLT",
              "subcategories": []
            },
            {
              "id": "dozers-deere-850j-wt",
              "name": "850J WT",
              "subcategories": []
            },
            {
              "id": "dozers-deere-850jr",
              "name": "850JR",
              "subcategories": []
            },
            {
              "id": "dozers-deere-850k",
              "name": "850K",
              "subcategories": []
            },
            {
              "id": "dozers-deere-850k-lgp",
              "name": "850K LGP",
              "subcategories": []
            },
            {
              "id": "dozers-deere-850k-lt",
              "name": "850K LT",
              "subcategories": []
            },
            {
              "id": "dozers-deere-850k-wh",
              "name": "850K WH",
              "subcategories": []
            },
            {
              "id": "dozers-deere-850k-wlt",
              "name": "850K WLT",
              "subcategories": []
            },
            {
              "id": "dozers-deere-850k-wt",
              "name": "850K WT",
              "subcategories": []
            },
            {
              "id": "dozers-deere-850k-xlt",
              "name": "850K XLT",
              "subcategories": []
            },
            {
              "id": "dozers-deere-850l",
              "name": "850L",
              "subcategories": []
            },
            {
              "id": "dozers-deere-850l-lgp",
              "name": "850L LGP",
              "subcategories": []
            },
            {
              "id": "dozers-deere-850l-wlt",
              "name": "850L WLT",
              "subcategories": []
            },
            {
              "id": "dozers-deere-850l-xlt",
              "name": "850L XLT",
              "subcategories": []
            },
            {
              "id": "dozers-deere-950j",
              "name": "950J",
              "subcategories": []
            },
            {
              "id": "dozers-deere-950k",
              "name": "950K",
              "subcategories": []
            },
            {
              "id": "dozers-deere-950k-lgp",
              "name": "950K LGP",
              "subcategories": []
            },
            {
              "id": "dozers-deere-1050j",
              "name": "1050J",
              "subcategories": []
            },
            {
              "id": "dozers-deere-1050k",
              "name": "1050K",
              "subcategories": []
            },
            {
              "id": "dozers-deere-1050k-wh",
              "name": "1050K WH",
              "subcategories": []
            },
            {
              "id": "dozers-deere-1050p",
              "name": "1050P",
              "subcategories": []
            },
            {
              "id": "dozers-deere-mc",
              "name": "MC",
              "subcategories": []
            },
            {
              "id": "dozers-deere-other",
              "name": "OTHER",
              "subcategories": []
            }
          ]
        },
        {
          "id": "dozers-komatsu",
          "name": "Komatsu",
          "subcategories": [
            {
              "id": "dozers-komatsu-d20pl-7",
              "name": "D20PL-7",
              "subcategories": []
            },
            {
              "id": "dozers-komatsu-d21a-7",
              "name": "D21A-7",
              "subcategories": []
            },
            {
              "id": "dozers-komatsu-d21a-8eo",
              "name": "D21A-8EO",
              "subcategories": []
            },
            {
              "id": "dozers-komatsu-d21p-5",
              "name": "D21P-5",
              "subcategories": []
            },
            {
              "id": "dozers-komatsu-d21p-8",
              "name": "D21P-8",
              "subcategories": []
            },
            {
              "id": "dozers-komatsu-d21p-8e0",
              "name": "D21P-8E0",
              "subcategories": []
            },
            {
              "id": "dozers-komatsu-d21pl-7e",
              "name": "D21PL-7E",
              "subcategories": []
            },
            {
              "id": "dozers-komatsu-d31e-20",
              "name": "D31E-20",
              "subcategories": []
            },
            {
              "id": "dozers-komatsu-d31ex-21",
              "name": "D31EX-21",
              "subcategories": []
            },
            {
              "id": "dozers-komatsu-d31ex-22",
              "name": "D31EX-22",
              "subcategories": []
            },
            {
              "id": "dozers-komatsu-d31p-18",
              "name": "D31P-18",
              "subcategories": []
            },
            {
              "id": "dozers-komatsu-d31px-21",
              "name": "D31PX-21",
              "subcategories": []
            },
            {
              "id": "dozers-komatsu-d31px-22",
              "name": "D31PX-22",
              "subcategories": []
            },
            {
              "id": "dozers-komatsu-d37e-5",
              "name": "D37E-5",
              "subcategories": []
            },
            {
              "id": "dozers-komatsu-d37ex",
              "name": "D37EX",
              "subcategories": []
            },
            {
              "id": "dozers-komatsu-d37ex-21",
              "name": "D37EX-21",
              "subcategories": []
            },
            {
              "id": "dozers-komatsu-d37ex-21a",
              "name": "D37EX-21A",
              "subcategories": []
            },
            {
              "id": "dozers-komatsu-d37ex-22",
              "name": "D37EX-22",
              "subcategories": []
            },
            {
              "id": "dozers-komatsu-d37ex-24",
              "name": "D37EX-24",
              "subcategories": []
            },
            {
              "id": "dozers-komatsu-d37p-5",
              "name": "D37P-5",
              "subcategories": []
            },
            {
              "id": "dozers-komatsu-d37px",
              "name": "D37PX",
              "subcategories": []
            },
            {
              "id": "dozers-komatsu-d37px-22",
              "name": "D37PX-22",
              "subcategories": []
            },
            {
              "id": "dozers-komatsu-d37px-23",
              "name": "D37PX-23",
              "subcategories": []
            },
            {
              "id": "dozers-komatsu-d37px-24",
              "name": "D37PX-24",
              "subcategories": []
            },
            {
              "id": "dozers-komatsu-d37pxi-23",
              "name": "D37PXI-23",
              "subcategories": []
            },
            {
              "id": "dozers-komatsu-d37pxi-24",
              "name": "D37PXI-24",
              "subcategories": []
            },
            {
              "id": "dozers-komatsu-d38e",
              "name": "D38E",
              "subcategories": []
            },
            {
              "id": "dozers-komatsu-d38e-1",
              "name": "D38E-1",
              "subcategories": []
            },
            {
              "id": "dozers-komatsu-d38p-1-lgp",
              "name": "D38P-1 LGP",
              "subcategories": []
            },
            {
              "id": "dozers-komatsu-d39e",
              "name": "D39E",
              "subcategories": []
            },
            {
              "id": "dozers-komatsu-d39e-1",
              "name": "D39E-1",
              "subcategories": []
            },
            {
              "id": "dozers-komatsu-d39ex",
              "name": "D39EX",
              "subcategories": []
            },
            {
              "id": "dozers-komatsu-d39ex-21",
              "name": "D39EX-21",
              "subcategories": []
            },
            {
              "id": "dozers-komatsu-d39ex-21a",
              "name": "D39EX-21A",
              "subcategories": []
            },
            {
              "id": "dozers-komatsu-d39ex-22",
              "name": "D39EX-22",
              "subcategories": []
            },
            {
              "id": "dozers-komatsu-d39ex-23",
              "name": "D39EX-23",
              "subcategories": []
            },
            {
              "id": "dozers-komatsu-d39ex-24",
              "name": "D39EX-24",
              "subcategories": []
            },
            {
              "id": "dozers-komatsu-d39-1",
              "name": "D39-1",
              "subcategories": []
            },
            {
              "id": "dozers-komatsu-d39px",
              "name": "D39PX",
              "subcategories": []
            },
            {
              "id": "dozers-komatsu-d39px-21",
              "name": "D39PX-21",
              "subcategories": []
            },
            {
              "id": "dozers-komatsu-d39px-22",
              "name": "D39PX-22",
              "subcategories": []
            },
            {
              "id": "dozers-komatsu-d39px-23",
              "name": "D39PX-23",
              "subcategories": []
            },
            {
              "id": "dozers-komatsu-d39px-24",
              "name": "D39PX-24",
              "subcategories": []
            },
            {
              "id": "dozers-komatsu-d39pxi-23",
              "name": "D39PXI-23",
              "subcategories": []
            },
            {
              "id": "dozers-komatsu-d39pxi-24",
              "name": "D39PXI-24",
              "subcategories": []
            },
            {
              "id": "dozers-komatsu-d41e",
              "name": "D41E",
              "subcategories": []
            },
            {
              "id": "dozers-komatsu-d41e-6",
              "name": "D41E-6",
              "subcategories": []
            },
            {
              "id": "dozers-komatsu-d41e-6a",
              "name": "D41E-6A",
              "subcategories": []
            },
            {
              "id": "dozers-komatsu-d41p-3-lgp",
              "name": "D41P-3 LGP",
              "subcategories": []
            },
            {
              "id": "dozers-komatsu-d41p-6",
              "name": "D41P-6",
              "subcategories": []
            },
            {
              "id": "dozers-komatsu-d50a-15",
              "name": "D50A-15",
              "subcategories": []
            },
            {
              "id": "dozers-komatsu-d51ex-22",
              "name": "D51EX-22",
              "subcategories": []
            },
            {
              "id": "dozers-komatsu-d51ex-24",
              "name": "D51EX-24",
              "subcategories": []
            },
            {
              "id": "dozers-komatsu-d51exi-24",
              "name": "D51EXI-24",
              "subcategories": []
            },
            {
              "id": "dozers-komatsu-d51px",
              "name": "D51PX",
              "subcategories": []
            },
            {
              "id": "dozers-komatsu-d51px-22",
              "name": "D51PX-22",
              "subcategories": []
            },
            {
              "id": "dozers-komatsu-d51px-24",
              "name": "D51PX-24",
              "subcategories": []
            },
            {
              "id": "dozers-komatsu-d51pxi-22",
              "name": "D51PXI-22",
              "subcategories": []
            },
            {
              "id": "dozers-komatsu-d51pxi-24",
              "name": "D51PXI-24",
              "subcategories": []
            },
            {
              "id": "dozers-komatsu-d51pxi-24eo",
              "name": "D51PXI-24EO",
              "subcategories": []
            },
            {
              "id": "dozers-komatsu-d53a-16",
              "name": "D53A-16",
              "subcategories": []
            },
            {
              "id": "dozers-komatsu-d53a-17",
              "name": "D53A-17",
              "subcategories": []
            },
            {
              "id": "dozers-komatsu-d53a-18",
              "name": "D53A-18",
              "subcategories": []
            },
            {
              "id": "dozers-komatsu-d58e-1",
              "name": "D58E-1",
              "subcategories": []
            },
            {
              "id": "dozers-komatsu-d58p-1",
              "name": "D58P-1",
              "subcategories": []
            },
            {
              "id": "dozers-komatsu-d60-6",
              "name": "D60-6",
              "subcategories": []
            },
            {
              "id": "dozers-komatsu-d60e-6",
              "name": "D60E-6",
              "subcategories": []
            },
            {
              "id": "dozers-komatsu-d61ex-12",
              "name": "D61EX-12",
              "subcategories": []
            },
            {
              "id": "dozers-komatsu-d61ex-15",
              "name": "D61EX-15",
              "subcategories": []
            },
            {
              "id": "dozers-komatsu-d61ex-23",
              "name": "D61EX-23",
              "subcategories": []
            },
            {
              "id": "dozers-komatsu-d61ex-24",
              "name": "D61EX-24",
              "subcategories": []
            },
            {
              "id": "dozers-komatsu-d61exi-23",
              "name": "D61EXI-23",
              "subcategories": []
            },
            {
              "id": "dozers-komatsu-d61exi-24",
              "name": "D61EXI-24",
              "subcategories": []
            },
            {
              "id": "dozers-komatsu-d61px",
              "name": "D61PX",
              "subcategories": []
            },
            {
              "id": "dozers-komatsu-d61px-12",
              "name": "D61PX-12",
              "subcategories": []
            },
            {
              "id": "dozers-komatsu-d61px-15",
              "name": "D61PX-15",
              "subcategories": []
            },
            {
              "id": "dozers-komatsu-d61px-15e0",
              "name": "D61PX-15E0",
              "subcategories": []
            },
            {
              "id": "dozers-komatsu-d61px-23",
              "name": "D61PX-23",
              "subcategories": []
            },
            {
              "id": "dozers-komatsu-d61px-24",
              "name": "D61PX-24",
              "subcategories": []
            },
            {
              "id": "dozers-komatsu-d61pxi",
              "name": "D61PXI",
              "subcategories": []
            },
            {
              "id": "dozers-komatsu-d61pxi-23",
              "name": "D61PXI-23",
              "subcategories": []
            },
            {
              "id": "dozers-komatsu-d61pxi-24",
              "name": "D61PXI-24",
              "subcategories": []
            },
            {
              "id": "dozers-komatsu-d61pxi-24e0",
              "name": "D61PXI-24E0",
              "subcategories": []
            },
            {
              "id": "dozers-komatsu-d65a-8",
              "name": "D65A-8",
              "subcategories": []
            },
            {
              "id": "dozers-komatsu-d65e",
              "name": "D65E",
              "subcategories": []
            },
            {
              "id": "dozers-komatsu-d65e-8",
              "name": "D65E-8",
              "subcategories": []
            },
            {
              "id": "dozers-komatsu-d65e-12",
              "name": "D65E-12",
              "subcategories": []
            },
            {
              "id": "dozers-komatsu-d65ex",
              "name": "D65EX",
              "subcategories": []
            },
            {
              "id": "dozers-komatsu-d65ex-1",
              "name": "D65EX-1",
              "subcategories": []
            },
            {
              "id": "dozers-komatsu-d65ex-12",
              "name": "D65EX-12",
              "subcategories": []
            },
            {
              "id": "dozers-komatsu-d65ex-15",
              "name": "D65EX-15",
              "subcategories": []
            },
            {
              "id": "dozers-komatsu-d65ex-15eo",
              "name": "D65EX-15EO",
              "subcategories": []
            },
            {
              "id": "dozers-komatsu-d65ex-16",
              "name": "D65EX-16",
              "subcategories": []
            },
            {
              "id": "dozers-komatsu-d65ex-17",
              "name": "D65EX-17",
              "subcategories": []
            },
            {
              "id": "dozers-komatsu-d65ex-18",
              "name": "D65EX-18",
              "subcategories": []
            },
            {
              "id": "dozers-komatsu-d65exi-18",
              "name": "D65EXI-18",
              "subcategories": []
            },
            {
              "id": "dozers-komatsu-d65p-7",
              "name": "D65P-7",
              "subcategories": []
            },
            {
              "id": "dozers-komatsu-d65p-12",
              "name": "D65P-12",
              "subcategories": []
            },
            {
              "id": "dozers-komatsu-d65px",
              "name": "D65PX",
              "subcategories": []
            },
            {
              "id": "dozers-komatsu-d65px-12",
              "name": "D65PX-12",
              "subcategories": []
            },
            {
              "id": "dozers-komatsu-d65px-12-lgp",
              "name": "D65PX-12 LGP",
              "subcategories": []
            },
            {
              "id": "dozers-komatsu-d65px-12e",
              "name": "D65PX-12E",
              "subcategories": []
            },
            {
              "id": "dozers-komatsu-d65px-15",
              "name": "D65PX-15",
              "subcategories": []
            },
            {
              "id": "dozers-komatsu-d65px-15e0",
              "name": "D65PX-15E0",
              "subcategories": []
            },
            {
              "id": "dozers-komatsu-d65px-16",
              "name": "D65PX-16",
              "subcategories": []
            },
            {
              "id": "dozers-komatsu-d65px-17",
              "name": "D65PX-17",
              "subcategories": []
            },
            {
              "id": "dozers-komatsu-d65px-18",
              "name": "D65PX-18",
              "subcategories": []
            },
            {
              "id": "dozers-komatsu-d65px-18e0",
              "name": "D65PX-18E0",
              "subcategories": []
            },
            {
              "id": "dozers-komatsu-d65pxi-18",
              "name": "D65PXI-18",
              "subcategories": []
            },
            {
              "id": "dozers-komatsu-d65pxi-18e0",
              "name": "D65PXI-18E0",
              "subcategories": []
            },
            {
              "id": "dozers-komatsu-d65wx-16",
              "name": "D65WX-16",
              "subcategories": []
            },
            {
              "id": "dozers-komatsu-d65wx-17",
              "name": "D65WX-17",
              "subcategories": []
            },
            {
              "id": "dozers-komatsu-d65wx-18",
              "name": "D65WX-18",
              "subcategories": []
            },
            {
              "id": "dozers-komatsu-d71ex-24",
              "name": "D71EX-24",
              "subcategories": []
            },
            {
              "id": "dozers-komatsu-d71exi-24",
              "name": "D71EXI-24",
              "subcategories": []
            },
            {
              "id": "dozers-komatsu-d71px-24",
              "name": "D71PX-24",
              "subcategories": []
            },
            {
              "id": "dozers-komatsu-d71pxi-24",
              "name": "D71PXI-24",
              "subcategories": []
            },
            {
              "id": "dozers-komatsu-d71pxi-24e0",
              "name": "D71PXI-24E0",
              "subcategories": []
            },
            {
              "id": "dozers-komatsu-d85-12",
              "name": "D85-12",
              "subcategories": []
            },
            {
              "id": "dozers-komatsu-d85-18",
              "name": "D85-18",
              "subcategories": []
            },
            {
              "id": "dozers-komatsu-d85a",
              "name": "D85A",
              "subcategories": []
            },
            {
              "id": "dozers-komatsu-d85a-21",
              "name": "D85A-21",
              "subcategories": []
            },
            {
              "id": "dozers-komatsu-d85e-18",
              "name": "D85E-18",
              "subcategories": []
            },
            {
              "id": "dozers-komatsu-d85ess-1",
              "name": "D85ESS-1",
              "subcategories": []
            },
            {
              "id": "dozers-komatsu-d85ess-2",
              "name": "D85ESS-2",
              "subcategories": []
            },
            {
              "id": "dozers-komatsu-d85ex",
              "name": "D85EX",
              "subcategories": []
            },
            {
              "id": "dozers-komatsu-d85ex-15",
              "name": "D85EX-15",
              "subcategories": []
            },
            {
              "id": "dozers-komatsu-d85ex-15e0",
              "name": "D85EX-15E0",
              "subcategories": []
            },
            {
              "id": "dozers-komatsu-d85ex-15r",
              "name": "D85EX-15R",
              "subcategories": []
            },
            {
              "id": "dozers-komatsu-d85exi-18",
              "name": "D85EXI-18",
              "subcategories": []
            },
            {
              "id": "dozers-komatsu-d85p-18",
              "name": "D85P-18",
              "subcategories": []
            },
            {
              "id": "dozers-komatsu-d85p-21",
              "name": "D85P-21",
              "subcategories": []
            },
            {
              "id": "dozers-komatsu-d85px",
              "name": "D85PX",
              "subcategories": []
            },
            {
              "id": "dozers-komatsu-d85px-15",
              "name": "D85PX-15",
              "subcategories": []
            },
            {
              "id": "dozers-komatsu-d85px-15e0",
              "name": "D85PX-15E0",
              "subcategories": []
            },
            {
              "id": "dozers-komatsu-d85px-18",
              "name": "D85PX-18",
              "subcategories": []
            },
            {
              "id": "dozers-komatsu-d85px-18e0",
              "name": "D85PX-18E0",
              "subcategories": []
            },
            {
              "id": "dozers-komatsu-d85pxi-18",
              "name": "D85PXI-18",
              "subcategories": []
            },
            {
              "id": "dozers-komatsu-d155-1",
              "name": "D155-1",
              "subcategories": []
            },
            {
              "id": "dozers-komatsu-d155a",
              "name": "D155A",
              "subcategories": []
            },
            {
              "id": "dozers-komatsu-d155a-1",
              "name": "D155A-1",
              "subcategories": []
            },
            {
              "id": "dozers-komatsu-d155a-2",
              "name": "D155A-2",
              "subcategories": []
            },
            {
              "id": "dozers-komatsu-d155a-3",
              "name": "D155A-3",
              "subcategories": []
            },
            {
              "id": "dozers-komatsu-d155a-5",
              "name": "D155A-5",
              "subcategories": []
            },
            {
              "id": "dozers-komatsu-d155a-6",
              "name": "D155A-6",
              "subcategories": []
            },
            {
              "id": "dozers-komatsu-d155a-6r",
              "name": "D155A-6R",
              "subcategories": []
            },
            {
              "id": "dozers-komatsu-d155ax",
              "name": "D155AX",
              "subcategories": []
            },
            {
              "id": "dozers-komatsu-d155ax-5",
              "name": "D155AX-5",
              "subcategories": []
            },
            {
              "id": "dozers-komatsu-d155ax-6",
              "name": "D155AX-6",
              "subcategories": []
            },
            {
              "id": "dozers-komatsu-d155ax-7",
              "name": "D155AX-7",
              "subcategories": []
            },
            {
              "id": "dozers-komatsu-d155ax-8",
              "name": "D155AX-8",
              "subcategories": []
            },
            {
              "id": "dozers-komatsu-d155axi-8",
              "name": "D155AXI-8",
              "subcategories": []
            },
            {
              "id": "dozers-komatsu-d155px-8-lgp",
              "name": "D155PX-8 LGP",
              "subcategories": []
            },
            {
              "id": "dozers-komatsu-d275a-2",
              "name": "D275A-2",
              "subcategories": []
            },
            {
              "id": "dozers-komatsu-d275ax",
              "name": "D275AX",
              "subcategories": []
            },
            {
              "id": "dozers-komatsu-d275ax-5",
              "name": "D275AX-5",
              "subcategories": []
            },
            {
              "id": "dozers-komatsu-d275ax-5eo",
              "name": "D275AX-5EO",
              "subcategories": []
            },
            {
              "id": "dozers-komatsu-d355-5",
              "name": "D355-5",
              "subcategories": []
            },
            {
              "id": "dozers-komatsu-d355a-3",
              "name": "D355A-3",
              "subcategories": []
            },
            {
              "id": "dozers-komatsu-d375",
              "name": "D375",
              "subcategories": []
            },
            {
              "id": "dozers-komatsu-d375-1",
              "name": "D375-1",
              "subcategories": []
            },
            {
              "id": "dozers-komatsu-d375-5",
              "name": "D375-5",
              "subcategories": []
            },
            {
              "id": "dozers-komatsu-d375a",
              "name": "D375A",
              "subcategories": []
            },
            {
              "id": "dozers-komatsu-d375a-1",
              "name": "D375A-1",
              "subcategories": []
            },
            {
              "id": "dozers-komatsu-d375a-2",
              "name": "D375A-2",
              "subcategories": []
            },
            {
              "id": "dozers-komatsu-d375a-3",
              "name": "D375A-3",
              "subcategories": []
            },
            {
              "id": "dozers-komatsu-d375a-5",
              "name": "D375A-5",
              "subcategories": []
            },
            {
              "id": "dozers-komatsu-d375a-5e0",
              "name": "D375A-5E0",
              "subcategories": []
            },
            {
              "id": "dozers-komatsu-d375a-6",
              "name": "D375A-6",
              "subcategories": []
            },
            {
              "id": "dozers-komatsu-d375-6r",
              "name": "D375-6R",
              "subcategories": []
            },
            {
              "id": "dozers-komatsu-d375a-8",
              "name": "D375A-8",
              "subcategories": []
            },
            {
              "id": "dozers-komatsu-d455a-1",
              "name": "D455A-1",
              "subcategories": []
            },
            {
              "id": "dozers-komatsu-d475a-1",
              "name": "D475A-1",
              "subcategories": []
            },
            {
              "id": "dozers-komatsu-d475a-2",
              "name": "D475A-2",
              "subcategories": []
            },
            {
              "id": "dozers-komatsu-d475a-3",
              "name": "D475A-3",
              "subcategories": []
            },
            {
              "id": "dozers-komatsu-d475a-5",
              "name": "D475A-5",
              "subcategories": []
            },
            {
              "id": "dozers-komatsu-d475a-5e0",
              "name": "D475A-5E0",
              "subcategories": []
            },
            {
              "id": "dozers-komatsu-d475a-5sd",
              "name": "D475A-5SD",
              "subcategories": []
            },
            {
              "id": "dozers-komatsu-d475a-8",
              "name": "D475A-8",
              "subcategories": []
            },
            {
              "id": "dozers-komatsu-d575",
              "name": "D575",
              "subcategories": []
            },
            {
              "id": "dozers-komatsu-d575a-3",
              "name": "D575A-3",
              "subcategories": []
            },
            {
              "id": "dozers-komatsu-wd500-3",
              "name": "WD500-3",
              "subcategories": []
            },
            {
              "id": "dozers-komatsu-wd600",
              "name": "WD600",
              "subcategories": []
            },
            {
              "id": "dozers-komatsu-wd600-1",
              "name": "WD600-1",
              "subcategories": []
            },
            {
              "id": "dozers-komatsu-wd600-3",
              "name": "WD600-3",
              "subcategories": []
            },
            {
              "id": "dozers-komatsu-wd600-6",
              "name": "WD600-6",
              "subcategories": []
            },
            {
              "id": "dozers-komatsu-wd900",
              "name": "WD900",
              "subcategories": []
            },
            {
              "id": "dozers-komatsu-other",
              "name": "OTHER",
              "subcategories": []
            }
          ]
        },
        {
          "id": "dozers-case",
          "name": "Case",
          "subcategories": [
            {
              "id": "dozers-case-310",
              "name": "310",
              "subcategories": []
            },
            {
              "id": "dozers-case-350",
              "name": "350",
              "subcategories": []
            },
            {
              "id": "dozers-case-450",
              "name": "450",
              "subcategories": []
            },
            {
              "id": "dozers-case-450b",
              "name": "450B",
              "subcategories": []
            },
            {
              "id": "dozers-case-450c",
              "name": "450C",
              "subcategories": []
            },
            {
              "id": "dozers-case-550",
              "name": "550",
              "subcategories": []
            },
            {
              "id": "dozers-case-550-lt",
              "name": "550 LT",
              "subcategories": []
            },
            {
              "id": "dozers-case-550e",
              "name": "550E",
              "subcategories": []
            },
            {
              "id": "dozers-case-550e-lt",
              "name": "550E LT",
              "subcategories": []
            },
            {
              "id": "dozers-case-550g",
              "name": "550G",
              "subcategories": []
            },
            {
              "id": "dozers-case-550g-lt",
              "name": "550G LT",
              "subcategories": []
            },
            {
              "id": "dozers-case-550h",
              "name": "550H",
              "subcategories": []
            },
            {
              "id": "dozers-case-550h-lt",
              "name": "550H LT",
              "subcategories": []
            },
            {
              "id": "dozers-case-650",
              "name": "650",
              "subcategories": []
            },
            {
              "id": "dozers-case-650h",
              "name": "650H",
              "subcategories": []
            },
            {
              "id": "dozers-case-650k",
              "name": "650K",
              "subcategories": []
            },
            {
              "id": "dozers-case-650k-3",
              "name": "650K 3",
              "subcategories": []
            },
            {
              "id": "dozers-case-650l",
              "name": "650L",
              "subcategories": []
            },
            {
              "id": "dozers-case-650l-lgp",
              "name": "650L LGP",
              "subcategories": []
            },
            {
              "id": "dozers-case-650l-wt",
              "name": "650L WT",
              "subcategories": []
            },
            {
              "id": "dozers-case-650m",
              "name": "650M",
              "subcategories": []
            },
            {
              "id": "dozers-case-650m-lgp",
              "name": "650M LGP",
              "subcategories": []
            },
            {
              "id": "dozers-case-650m-lt",
              "name": "650M LT",
              "subcategories": []
            },
            {
              "id": "dozers-case-650m-wt",
              "name": "650M WT",
              "subcategories": []
            },
            {
              "id": "dozers-case-750k",
              "name": "750K",
              "subcategories": []
            },
            {
              "id": "dozers-case-750m",
              "name": "750M",
              "subcategories": []
            },
            {
              "id": "dozers-case-750m-lgp",
              "name": "750M LGP",
              "subcategories": []
            },
            {
              "id": "dozers-case-750m-lt",
              "name": "750M LT",
              "subcategories": []
            },
            {
              "id": "dozers-case-750m-wt",
              "name": "750M WT",
              "subcategories": []
            },
            {
              "id": "dozers-case-850",
              "name": "850",
              "subcategories": []
            },
            {
              "id": "dozers-case-850-lt",
              "name": "850 LT",
              "subcategories": []
            },
            {
              "id": "dozers-case-850b",
              "name": "850B",
              "subcategories": []
            },
            {
              "id": "dozers-case-850c",
              "name": "850C",
              "subcategories": []
            },
            {
              "id": "dozers-case-850d",
              "name": "850D",
              "subcategories": []
            },
            {
              "id": "dozers-case-850d-lt",
              "name": "850D LT",
              "subcategories": []
            },
            {
              "id": "dozers-case-850e",
              "name": "850E",
              "subcategories": []
            },
            {
              "id": "dozers-case-850e-lt",
              "name": "850E LT",
              "subcategories": []
            },
            {
              "id": "dozers-case-850g",
              "name": "850G",
              "subcategories": []
            },
            {
              "id": "dozers-case-850g-lt",
              "name": "850G LT",
              "subcategories": []
            },
            {
              "id": "dozers-case-850h",
              "name": "850H",
              "subcategories": []
            },
            {
              "id": "dozers-case-850k",
              "name": "850K",
              "subcategories": []
            },
            {
              "id": "dozers-case-850k-2lgp",
              "name": "850K 2LGP",
              "subcategories": []
            },
            {
              "id": "dozers-case-850k-2xlt",
              "name": "850K 2XLT",
              "subcategories": []
            },
            {
              "id": "dozers-case-850k-xlt",
              "name": "850K XLT",
              "subcategories": []
            },
            {
              "id": "dozers-case-850l",
              "name": "850L",
              "subcategories": []
            },
            {
              "id": "dozers-case-850l-xlt",
              "name": "850L XLT",
              "subcategories": []
            },
            {
              "id": "dozers-case-850m",
              "name": "850M",
              "subcategories": []
            },
            {
              "id": "dozers-case-850m-lgp",
              "name": "850M LGP",
              "subcategories": []
            },
            {
              "id": "dozers-case-850m-wt",
              "name": "850M WT",
              "subcategories": []
            },
            {
              "id": "dozers-case-1150",
              "name": "1150",
              "subcategories": []
            },
            {
              "id": "dozers-case-1150c",
              "name": "1150C",
              "subcategories": []
            },
            {
              "id": "dozers-case-1150e",
              "name": "1150E",
              "subcategories": []
            },
            {
              "id": "dozers-case-1150e-lt",
              "name": "1150E LT",
              "subcategories": []
            },
            {
              "id": "dozers-case-1150g",
              "name": "1150G",
              "subcategories": []
            },
            {
              "id": "dozers-case-1150g-lgp",
              "name": "1150G LGP",
              "subcategories": []
            },
            {
              "id": "dozers-case-1150g-lt",
              "name": "1150G LT",
              "subcategories": []
            },
            {
              "id": "dozers-case-1150h",
              "name": "1150H",
              "subcategories": []
            },
            {
              "id": "dozers-case-1150h-lt",
              "name": "1150H LT",
              "subcategories": []
            },
            {
              "id": "dozers-case-1150h-wt",
              "name": "1150H WT",
              "subcategories": []
            },
            {
              "id": "dozers-case-1150k",
              "name": "1150K",
              "subcategories": []
            },
            {
              "id": "dozers-case-1150k-xlt",
              "name": "1150K XLT",
              "subcategories": []
            },
            {
              "id": "dozers-case-1150m",
              "name": "1150M",
              "subcategories": []
            },
            {
              "id": "dozers-case-1150m-lgp",
              "name": "1150M LGP",
              "subcategories": []
            },
            {
              "id": "dozers-case-1150m-lt",
              "name": "1150M LT",
              "subcategories": []
            },
            {
              "id": "dozers-case-1150m-wt",
              "name": "1150M WT",
              "subcategories": []
            },
            {
              "id": "dozers-case-1450b",
              "name": "1450B",
              "subcategories": []
            },
            {
              "id": "dozers-case-1650k",
              "name": "1650K",
              "subcategories": []
            },
            {
              "id": "dozers-case-1650k-lgp",
              "name": "1650K LGP",
              "subcategories": []
            },
            {
              "id": "dozers-case-1650l",
              "name": "1650L",
              "subcategories": []
            },
            {
              "id": "dozers-case-1650l-lgp",
              "name": "1650L LGP",
              "subcategories": []
            },
            {
              "id": "dozers-case-1650m",
              "name": "1650M",
              "subcategories": []
            },
            {
              "id": "dozers-case-1650m-lgp",
              "name": "1650M LGP",
              "subcategories": []
            },
            {
              "id": "dozers-case-1650m-wt",
              "name": "1650M WT",
              "subcategories": []
            },
            {
              "id": "dozers-case-1650m-xlt",
              "name": "1650M XLT",
              "subcategories": []
            },
            {
              "id": "dozers-case-1850k",
              "name": "1850K",
              "subcategories": []
            },
            {
              "id": "dozers-case-1850k-lgp",
              "name": "1850K LGP",
              "subcategories": []
            },
            {
              "id": "dozers-case-1850m",
              "name": "1850M",
              "subcategories": []
            },
            {
              "id": "dozers-case-1850m-l-gp",
              "name": "1850M L;GP",
              "subcategories": []
            },
            {
              "id": "dozers-case-2050m",
              "name": "2050M",
              "subcategories": []
            },
            {
              "id": "dozers-case-2050m-lgp",
              "name": "2050M LGP",
              "subcategories": []
            },
            {
              "id": "dozers-case-2050m-wt",
              "name": "2050M WT",
              "subcategories": []
            },
            {
              "id": "dozers-case-2050m-xlt",
              "name": "2050M XLT",
              "subcategories": []
            },
            {
              "id": "dozers-case-d350",
              "name": "D350",
              "subcategories": []
            },
            {
              "id": "dozers-case-d450",
              "name": "D450",
              "subcategories": []
            },
            {
              "id": "dozers-case-d3550",
              "name": "D3550",
              "subcategories": []
            },
            {
              "id": "dozers-case-g301c",
              "name": "G301C",
              "subcategories": []
            },
            {
              "id": "dozers-case-other",
              "name": "OTHER",
              "subcategories": []
            }
          ]
        },
        {
          "id": "dozers-shantui",
          "name": "Shantui",
          "subcategories": [
            {
              "id": "dozers-shantui-dh08",
              "name": "DH08",
              "subcategories": []
            },
            {
              "id": "dozers-shantui-dh10",
              "name": "DH10",
              "subcategories": []
            },
            {
              "id": "dozers-shantui-dh13",
              "name": "DH13",
              "subcategories": []
            },
            {
              "id": "dozers-shantui-dh16",
              "name": "DH16",
              "subcategories": []
            },
            {
              "id": "dozers-shantui-dh17",
              "name": "DH17",
              "subcategories": []
            },
            {
              "id": "dozers-shantui-dh20",
              "name": "DH20",
              "subcategories": []
            },
            {
              "id": "dozers-shantui-dh24",
              "name": "DH24",
              "subcategories": []
            },
            {
              "id": "dozers-shantui-dh36",
              "name": "DH36",
              "subcategories": []
            },
            {
              "id": "dozers-shantui-dh46",
              "name": "DH46",
              "subcategories": []
            },
            {
              "id": "dozers-shantui-sd13",
              "name": "SD13",
              "subcategories": []
            },
            {
              "id": "dozers-shantui-sd16",
              "name": "SD16",
              "subcategories": []
            },
            {
              "id": "dozers-shantui-sd22",
              "name": "SD22",
              "subcategories": []
            },
            {
              "id": "dozers-shantui-sd23",
              "name": "SD23",
              "subcategories": []
            },
            {
              "id": "dozers-shantui-sd32",
              "name": "SD32",
              "subcategories": []
            },
            {
              "id": "dozers-shantui-other",
              "name": "OTHER",
              "subcategories": []
            }
          ]
        },
        {
          "id": "dozers-liehberr",
          "name": "Liehberr",
          "subcategories": []
        },
        {
          "id": "dozers-develon",
          "name": "Develon",
          "subcategories": [
            {
              "id": "dozers-develon-dd100",
              "name": "DD100",
              "subcategories": []
            },
            {
              "id": "dozers-develon-dd130",
              "name": "DD130",
              "subcategories": []
            },
            {
              "id": "dozers-develon-other",
              "name": "OTHER",
              "subcategories": []
            }
          ]
        },
        {
          "id": "dozers-dressta",
          "name": "Dressta",
          "subcategories": [
            {
              "id": "dozers-dressta-td7",
              "name": "TD7",
              "subcategories": []
            },
            {
              "id": "dozers-dressta-td8",
              "name": "TD8",
              "subcategories": []
            },
            {
              "id": "dozers-dressta-td9",
              "name": "TD9",
              "subcategories": []
            },
            {
              "id": "dozers-dressta-td10",
              "name": "TD10",
              "subcategories": []
            },
            {
              "id": "dozers-dressta-td14",
              "name": "TD14",
              "subcategories": []
            },
            {
              "id": "dozers-dressta-td15",
              "name": "TD15",
              "subcategories": []
            },
            {
              "id": "dozers-dressta-td16",
              "name": "TD16",
              "subcategories": []
            },
            {
              "id": "dozers-dressta-td25",
              "name": "TD25",
              "subcategories": []
            },
            {
              "id": "dozers-dressta-td40",
              "name": "TD40",
              "subcategories": []
            },
            {
              "id": "dozers-dressta-other",
              "name": "OTHER",
              "subcategories": []
            }
          ]
        },
        {
          "id": "dozers-hyundai",
          "name": "Hyundai",
          "subcategories": [
            {
              "id": "dozers-hyundai-h70",
              "name": "H70",
              "subcategories": []
            },
            {
              "id": "dozers-hyundai-hd100",
              "name": "HD100",
              "subcategories": []
            },
            {
              "id": "dozers-hyundai-hd130",
              "name": "HD130",
              "subcategories": []
            },
            {
              "id": "dozers-hyundai-other",
              "name": "OTHER",
              "subcategories": []
            }
          ]
        },
        {
          "id": "dozers-dresser",
          "name": "Dresser",
          "subcategories": [
            {
              "id": "dozers-dresser-td6",
              "name": "TD6",
              "subcategories": []
            },
            {
              "id": "dozers-dresser-td7",
              "name": "TD7",
              "subcategories": []
            },
            {
              "id": "dozers-dresser-td8",
              "name": "TD8",
              "subcategories": []
            },
            {
              "id": "dozers-dresser-td9",
              "name": "TD9",
              "subcategories": []
            },
            {
              "id": "dozers-dresser-td15",
              "name": "TD15",
              "subcategories": []
            },
            {
              "id": "dozers-dresser-td20",
              "name": "TD20",
              "subcategories": []
            },
            {
              "id": "dozers-dresser-td25",
              "name": "TD25",
              "subcategories": []
            },
            {
              "id": "dozers-dresser-td40",
              "name": "TD40",
              "subcategories": []
            },
            {
              "id": "dozers-dresser-other",
              "name": "OTHER",
              "subcategories": []
            }
          ]
        },
        {
          "id": "dozers-allis-chalmers",
          "name": "Allis Chalmers",
          "subcategories": []
        },
        {
          "id": "dozers-develon",
          "name": "Develon",
          "subcategories": [
            {
              "id": "dozers-develon-dd100",
              "name": "DD100",
              "subcategories": []
            },
            {
              "id": "dozers-develon-dd130",
              "name": "DD130",
              "subcategories": []
            },
            {
              "id": "dozers-develon-other",
              "name": "OTHER",
              "subcategories": []
            }
          ]
        },
        {
          "id": "dozers-doosan",
          "name": "Doosan",
          "subcategories": []
        },
        {
          "id": "dozers-dresta",
          "name": "Dresta",
          "subcategories": []
        },
        {
          "id": "dozers-fiatallis",
          "name": "Fiatallis",
          "subcategories": []
        },
        {
          "id": "dozers-hyundai",
          "name": "Hyundai",
          "subcategories": [
            {
              "id": "dozers-hyundai-h70",
              "name": "H70",
              "subcategories": []
            },
            {
              "id": "dozers-hyundai-hd100",
              "name": "HD100",
              "subcategories": []
            },
            {
              "id": "dozers-hyundai-hd130",
              "name": "HD130",
              "subcategories": []
            },
            {
              "id": "dozers-hyundai-other",
              "name": "OTHER",
              "subcategories": []
            }
          ]
        },
        {
          "id": "dozers-international",
          "name": "International",
          "subcategories": [
            {
              "id": "dozers-international-500",
              "name": "500",
              "subcategories": []
            },
            {
              "id": "dozers-international-t20",
              "name": "T20",
              "subcategories": []
            },
            {
              "id": "dozers-international-t340",
              "name": "T340",
              "subcategories": []
            },
            {
              "id": "dozers-international-td6",
              "name": "TD6",
              "subcategories": []
            },
            {
              "id": "dozers-international-td7",
              "name": "TD7",
              "subcategories": []
            },
            {
              "id": "dozers-international-td8",
              "name": "TD8",
              "subcategories": []
            },
            {
              "id": "dozers-international-td9",
              "name": "TD9",
              "subcategories": []
            },
            {
              "id": "dozers-international-td14",
              "name": "TD14",
              "subcategories": []
            },
            {
              "id": "dozers-international-td15",
              "name": "TD15",
              "subcategories": []
            },
            {
              "id": "dozers-international-td20",
              "name": "TD20",
              "subcategories": []
            },
            {
              "id": "dozers-international-td25",
              "name": "TD25",
              "subcategories": []
            },
            {
              "id": "dozers-international-td40",
              "name": "TD40",
              "subcategories": []
            },
            {
              "id": "dozers-international-other",
              "name": "OTHER",
              "subcategories": []
            }
          ]
        },
        {
          "id": "dozers-mitsubishi",
          "name": "Mitsubishi",
          "subcategories": [
            {
              "id": "dozers-mitsubishi-bd2g",
              "name": "BD2G",
              "subcategories": []
            },
            {
              "id": "dozers-mitsubishi-bd2j",
              "name": "BD2J",
              "subcategories": []
            },
            {
              "id": "dozers-mitsubishi-bd2j-2",
              "name": "BD2J-2",
              "subcategories": []
            },
            {
              "id": "dozers-mitsubishi-other",
              "name": "OTHER",
              "subcategories": []
            }
          ]
        },
        {
          "id": "dozers-new-holland",
          "name": "New Holland",
          "subcategories": [
            {
              "id": "dozers-new-holland-d150",
              "name": "D150",
              "subcategories": []
            },
            {
              "id": "dozers-new-holland-d180",
              "name": "D180",
              "subcategories": []
            },
            {
              "id": "dozers-new-holland-other",
              "name": "OTHER",
              "subcategories": []
            }
          ]
        },
        {
          "id": "dozers-sem",
          "name": "Sem",
          "subcategories": [
            {
              "id": "dozers-sem-816",
              "name": "816",
              "subcategories": []
            },
            {
              "id": "dozers-sem-816d",
              "name": "816D",
              "subcategories": []
            },
            {
              "id": "dozers-sem-816f",
              "name": "816F",
              "subcategories": []
            },
            {
              "id": "dozers-sem-818f",
              "name": "818F",
              "subcategories": []
            },
            {
              "id": "dozers-sem-822",
              "name": "822",
              "subcategories": []
            },
            {
              "id": "dozers-sem-822lgp",
              "name": "822LGP",
              "subcategories": []
            },
            {
              "id": "dozers-sem-822d",
              "name": "822D",
              "subcategories": []
            },
            {
              "id": "dozers-sem-824f",
              "name": "824F",
              "subcategories": []
            },
            {
              "id": "dozers-sem-826d",
              "name": "826D",
              "subcategories": []
            },
            {
              "id": "dozers-sem-other",
              "name": "OTHER",
              "subcategories": []
            }
          ]
        },
        {
          "id": "dozers-xcmg",
          "name": "Xcmg",
          "subcategories": [
            {
              "id": "dozers-xcmg-d170",
              "name": "D170",
              "subcategories": []
            },
            {
              "id": "dozers-xcmg-d200",
              "name": "D200",
              "subcategories": []
            },
            {
              "id": "dozers-xcmg-d260",
              "name": "D260",
              "subcategories": []
            },
            {
              "id": "dozers-xcmg-d360",
              "name": "D360",
              "subcategories": []
            },
            {
              "id": "dozers-xcmg-ty230",
              "name": "TY230",
              "subcategories": []
            },
            {
              "id": "dozers-xcmg-other",
              "name": "OTHER",
              "subcategories": []
            }
          ]
        }
      ]
    },
    {
      "id": "drills-piling",
      "name": "Drills & Piling",
      "subcategories": [
        {
          "id": "drills-piling-drills",
          "name": "Drills",
          "subcategories": []
        },
        {
          "id": "drills-piling-vermeer",
          "name": "Vermeer",
          "subcategories": [
            {
              "id": "drills-piling-vermeer-c430",
              "name": "C430",
              "subcategories": []
            },
            {
              "id": "drills-piling-vermeer-dt750",
              "name": "DT750",
              "subcategories": []
            },
            {
              "id": "drills-piling-vermeer-mx125",
              "name": "MX125",
              "subcategories": []
            },
            {
              "id": "drills-piling-vermeer-mx240",
              "name": "MX240",
              "subcategories": []
            },
            {
              "id": "drills-piling-vermeer-mx300",
              "name": "MX300",
              "subcategories": []
            },
            {
              "id": "drills-piling-vermeer-navigator-6",
              "name": "NAVIGATOR 6",
              "subcategories": []
            },
            {
              "id": "drills-piling-vermeer-navigator-d6x6",
              "name": "NAVIGATOR D6X6",
              "subcategories": []
            },
            {
              "id": "drills-piling-vermeer-navigator-d7x11-series-ii",
              "name": "NAVIGATOR D7X11 SERIES II",
              "subcategories": []
            },
            {
              "id": "drills-piling-vermeer-navigator-d7x11a",
              "name": "NAVIGATOR D7X11A",
              "subcategories": []
            },
            {
              "id": "drills-piling-vermeer-navigator-d8x12",
              "name": "NAVIGATOR D8X12",
              "subcategories": []
            },
            {
              "id": "drills-piling-vermeer-navigator-d9x13-series-ii",
              "name": "NAVIGATOR D9X13 SERIES II",
              "subcategories": []
            },
            {
              "id": "drills-piling-vermeer-navigator-d9x13-series-iii",
              "name": "NAVIGATOR D9X13 SERIES III",
              "subcategories": []
            },
            {
              "id": "drills-piling-vermeer-navigator-10x15",
              "name": "NAVIGATOR 10X15",
              "subcategories": []
            },
            {
              "id": "drills-piling-vermeer-navigator-10x15-series-iii",
              "name": "NAVIGATOR 10X15 SERIES III",
              "subcategories": []
            },
            {
              "id": "drills-piling-vermeer-navigator-16x20a",
              "name": "NAVIGATOR 16X20A",
              "subcategories": []
            },
            {
              "id": "drills-piling-vermeer-navigator-d20x22-s3",
              "name": "NAVIGATOR D20X22 S3",
              "subcategories": []
            },
            {
              "id": "drills-piling-vermeer-navigator-20x22-series-ii",
              "name": "NAVIGATOR 20X22 SERIES II",
              "subcategories": []
            },
            {
              "id": "drills-piling-vermeer-navigator-20x22-series-iii",
              "name": "NAVIGATOR 20X22 SERIES III",
              "subcategories": []
            },
            {
              "id": "drills-piling-vermeer-navigator-20x22fx-series-ii",
              "name": "NAVIGATOR 20X22FX SERIES II",
              "subcategories": []
            },
            {
              "id": "drills-piling-vermeer-navigator-d23x30-s3",
              "name": "NAVIGATOR D23X30 S3",
              "subcategories": []
            },
            {
              "id": "drills-piling-vermeer-navigator-23x30dr-s3",
              "name": "NAVIGATOR 23X30DR S3",
              "subcategories": []
            },
            {
              "id": "drills-piling-vermeer-navigator-d24x33",
              "name": "NAVIGATOR D24X33",
              "subcategories": []
            },
            {
              "id": "drills-piling-vermeer-navigator-24x40",
              "name": "NAVIGATOR 24X40",
              "subcategories": []
            },
            {
              "id": "drills-piling-vermeer-navigator-d24x40-series-ii",
              "name": "NAVIGATOR D24X40 SERIES II",
              "subcategories": []
            },
            {
              "id": "drills-piling-vermeer-navigator-d24x40-series-iii",
              "name": "NAVIGATOR D24X40 SERIES III",
              "subcategories": []
            },
            {
              "id": "drills-piling-vermeer-navigator-d24x40a",
              "name": "NAVIGATOR D24X40A",
              "subcategories": []
            },
            {
              "id": "drills-piling-vermeer-navigator-d33x44",
              "name": "NAVIGATOR D33X44",
              "subcategories": []
            },
            {
              "id": "drills-piling-vermeer-navigator-d36x50-series-ii",
              "name": "NAVIGATOR D36X50 SERIES II",
              "subcategories": []
            },
            {
              "id": "drills-piling-vermeer-navigator-d36x50dr-series-ii",
              "name": "NAVIGATOR D36X50DR SERIES II",
              "subcategories": []
            },
            {
              "id": "drills-piling-vermeer-navigator-d40x55-series-iii",
              "name": "NAVIGATOR D40X55 SERIES III",
              "subcategories": []
            },
            {
              "id": "drills-piling-vermeer-navigator-d40x55dr-series-iii",
              "name": "NAVIGATOR D40X55DR SERIES III",
              "subcategories": []
            },
            {
              "id": "drills-piling-vermeer-navigator-50x100",
              "name": "NAVIGATOR 50X100",
              "subcategories": []
            },
            {
              "id": "drills-piling-vermeer-navigator-d50x100a",
              "name": "NAVIGATOR D50X100A",
              "subcategories": []
            },
            {
              "id": "drills-piling-vermeer-navigator-d55x100",
              "name": "NAVIGATOR D55X100",
              "subcategories": []
            },
            {
              "id": "drills-piling-vermeer-navigator-60x90",
              "name": "NAVIGATOR 60X90",
              "subcategories": []
            },
            {
              "id": "drills-piling-vermeer-navigator-d60x90-series-iii",
              "name": "NAVIGATOR D60X90 SERIES III",
              "subcategories": []
            },
            {
              "id": "drills-piling-vermeer-navigator-80x100",
              "name": "NAVIGATOR 80X100",
              "subcategories": []
            },
            {
              "id": "drills-piling-vermeer-navigator-d80x100-series-ii",
              "name": "NAVIGATOR D80X100 SERIES II",
              "subcategories": []
            },
            {
              "id": "drills-piling-vermeer-navigator-d80x120-series-ii",
              "name": "NAVIGATOR D80X120 SERIES II",
              "subcategories": []
            },
            {
              "id": "drills-piling-vermeer-navigator-d100x140",
              "name": "NAVIGATOR D100X140",
              "subcategories": []
            },
            {
              "id": "drills-piling-vermeer-navigator-d100x140-series-iii",
              "name": "NAVIGATOR D100X140 SERIES III",
              "subcategories": []
            },
            {
              "id": "drills-piling-vermeer-navigator-d130x150",
              "name": "NAVIGATOR D130X150",
              "subcategories": []
            },
            {
              "id": "drills-piling-vermeer-navigator-d220x300-series-iii",
              "name": "NAVIGATOR D220X300 SERIES III",
              "subcategories": []
            },
            {
              "id": "drills-piling-vermeer-navigator-d330x500",
              "name": "NAVIGATOR D330X500",
              "subcategories": []
            },
            {
              "id": "drills-piling-vermeer-navigator-d750x900",
              "name": "NAVIGATOR D750X900",
              "subcategories": []
            },
            {
              "id": "drills-piling-vermeer-navigator-v400",
              "name": "NAVIGATOR V400",
              "subcategories": []
            },
            {
              "id": "drills-piling-vermeer-navigator-v500",
              "name": "NAVIGATOR V500",
              "subcategories": []
            },
            {
              "id": "drills-piling-vermeer-pd5",
              "name": "PD5",
              "subcategories": []
            },
            {
              "id": "drills-piling-vermeer-pd10",
              "name": "PD10",
              "subcategories": []
            },
            {
              "id": "drills-piling-vermeer-r9x12t",
              "name": "R9X12T",
              "subcategories": []
            },
            {
              "id": "drills-piling-vermeer-r250c",
              "name": "R250C",
              "subcategories": []
            },
            {
              "id": "drills-piling-vermeer-st500",
              "name": "ST500",
              "subcategories": []
            },
            {
              "id": "drills-piling-vermeer-st750",
              "name": "ST750",
              "subcategories": []
            },
            {
              "id": "drills-piling-vermeer-other",
              "name": "OTHER",
              "subcategories": []
            }
          ]
        },
        {
          "id": "drills-piling-ditch-witch",
          "name": "Ditch Witch",
          "subcategories": [
            {
              "id": "drills-piling-ditch-witch-at30",
              "name": "AT30",
              "subcategories": []
            },
            {
              "id": "drills-piling-ditch-witch-at32",
              "name": "AT32",
              "subcategories": []
            },
            {
              "id": "drills-piling-ditch-witch-at40",
              "name": "AT40",
              "subcategories": []
            },
            {
              "id": "drills-piling-ditch-witch-at120",
              "name": "AT120",
              "subcategories": []
            },
            {
              "id": "drills-piling-ditch-witch-fm5",
              "name": "FM5",
              "subcategories": []
            },
            {
              "id": "drills-piling-ditch-witch-fm13",
              "name": "FM13",
              "subcategories": []
            },
            {
              "id": "drills-piling-ditch-witch-fm25",
              "name": "FM25",
              "subcategories": []
            },
            {
              "id": "drills-piling-ditch-witch-jt520",
              "name": "JT520",
              "subcategories": []
            },
            {
              "id": "drills-piling-ditch-witch-jt9",
              "name": "JT9",
              "subcategories": []
            },
            {
              "id": "drills-piling-ditch-witch-jt10",
              "name": "JT10",
              "subcategories": []
            },
            {
              "id": "drills-piling-ditch-witch-jt20",
              "name": "JT20",
              "subcategories": []
            },
            {
              "id": "drills-piling-ditch-witch-jt24",
              "name": "JT24",
              "subcategories": []
            },
            {
              "id": "drills-piling-ditch-witch-jt25",
              "name": "JT25",
              "subcategories": []
            },
            {
              "id": "drills-piling-ditch-witch-jt28",
              "name": "JT28",
              "subcategories": []
            },
            {
              "id": "drills-piling-ditch-witch-jt30",
              "name": "JT30",
              "subcategories": []
            },
            {
              "id": "drills-piling-ditch-witch-jt30at",
              "name": "JT30AT",
              "subcategories": []
            },
            {
              "id": "drills-piling-ditch-witch-jt32",
              "name": "JT32",
              "subcategories": []
            },
            {
              "id": "drills-piling-ditch-witch-jt40",
              "name": "JT40",
              "subcategories": []
            },
            {
              "id": "drills-piling-ditch-witch-jt60",
              "name": "JT60",
              "subcategories": []
            },
            {
              "id": "drills-piling-ditch-witch-jt100",
              "name": "JT100",
              "subcategories": []
            },
            {
              "id": "drills-piling-ditch-witch-jt520",
              "name": "JT520",
              "subcategories": []
            },
            {
              "id": "drills-piling-ditch-witch-jt860",
              "name": "JT860",
              "subcategories": []
            },
            {
              "id": "drills-piling-ditch-witch-jt921",
              "name": "JT921",
              "subcategories": []
            },
            {
              "id": "drills-piling-ditch-witch-jt922",
              "name": "JT922",
              "subcategories": []
            },
            {
              "id": "drills-piling-ditch-witch-jt1220",
              "name": "JT1220",
              "subcategories": []
            },
            {
              "id": "drills-piling-ditch-witch-jt1720",
              "name": "JT1720",
              "subcategories": []
            },
            {
              "id": "drills-piling-ditch-witch-jt2020",
              "name": "JT2020",
              "subcategories": []
            },
            {
              "id": "drills-piling-ditch-witch-jt2321",
              "name": "JT2321",
              "subcategories": []
            },
            {
              "id": "drills-piling-ditch-witch-jt2720",
              "name": "JT2720",
              "subcategories": []
            },
            {
              "id": "drills-piling-ditch-witch-jt3020",
              "name": "JT3020",
              "subcategories": []
            },
            {
              "id": "drills-piling-ditch-witch-jt4020",
              "name": "JT4020",
              "subcategories": []
            },
            {
              "id": "drills-piling-ditch-witch-jt21",
              "name": "JT21",
              "subcategories": []
            },
            {
              "id": "drills-piling-ditch-witch-mm5",
              "name": "MM5",
              "subcategories": []
            },
            {
              "id": "drills-piling-ditch-witch-mm9",
              "name": "MM9",
              "subcategories": []
            },
            {
              "id": "drills-piling-ditch-witch-mr90",
              "name": "MR90",
              "subcategories": []
            },
            {
              "id": "drills-piling-ditch-witch-other",
              "name": "OTHER",
              "subcategories": []
            }
          ]
        },
        {
          "id": "drills-piling-atlas-copco",
          "name": "Atlas Copco",
          "subcategories": [
            {
              "id": "drills-piling-atlas-copco-748",
              "name": "748",
              "subcategories": []
            },
            {
              "id": "drills-piling-atlas-copco-boltec",
              "name": "BOLTEC",
              "subcategories": []
            },
            {
              "id": "drills-piling-atlas-copco-boomer-281",
              "name": "BOOMER 281",
              "subcategories": []
            },
            {
              "id": "drills-piling-atlas-copco-boomer282",
              "name": "BOOMER282",
              "subcategories": []
            },
            {
              "id": "drills-piling-atlas-copco-boomer-e2c",
              "name": "BOOMER E2C",
              "subcategories": []
            },
            {
              "id": "drills-piling-atlas-copco-boomer-h104",
              "name": "BOOMER H104",
              "subcategories": []
            },
            {
              "id": "drills-piling-atlas-copco-boomer-l2c",
              "name": "BOOMER L2C",
              "subcategories": []
            },
            {
              "id": "drills-piling-atlas-copco-boomer-l2d",
              "name": "BOOMER L2D",
              "subcategories": []
            },
            {
              "id": "drills-piling-atlas-copco-boomer-m2d",
              "name": "BOOMER M2D",
              "subcategories": []
            },
            {
              "id": "drills-piling-atlas-copco-boomer-s1d",
              "name": "BOOMER S1D",
              "subcategories": []
            },
            {
              "id": "drills-piling-atlas-copco-boomer-we3-c30",
              "name": "BOOMER WE3 C30",
              "subcategories": []
            },
            {
              "id": "drills-piling-atlas-copco-boomer-xe3c",
              "name": "BOOMER XE3C",
              "subcategories": []
            },
            {
              "id": "drills-piling-atlas-copco-boomer-xe3c",
              "name": "BOOMER XE3C",
              "subcategories": []
            },
            {
              "id": "drills-piling-atlas-copco-boomer-xl3d",
              "name": "BOOMER XL3D",
              "subcategories": []
            },
            {
              "id": "drills-piling-atlas-copco-cdh831",
              "name": "CDH831",
              "subcategories": []
            },
            {
              "id": "drills-piling-atlas-copco-cm470",
              "name": "CM470",
              "subcategories": []
            },
            {
              "id": "drills-piling-atlas-copco-cm760",
              "name": "CM760",
              "subcategories": []
            },
            {
              "id": "drills-piling-atlas-copco-cm780",
              "name": "CM780",
              "subcategories": []
            },
            {
              "id": "drills-piling-atlas-copco-dm30",
              "name": "DM30",
              "subcategories": []
            },
            {
              "id": "drills-piling-atlas-copco-dm45",
              "name": "DM45",
              "subcategories": []
            },
            {
              "id": "drills-piling-atlas-copco-dm50",
              "name": "DM50",
              "subcategories": []
            },
            {
              "id": "drills-piling-atlas-copco-dm75",
              "name": "DM75",
              "subcategories": []
            },
            {
              "id": "drills-piling-atlas-copco-dml",
              "name": "DML",
              "subcategories": []
            },
            {
              "id": "drills-piling-atlas-copco-ecm585",
              "name": "ECM585",
              "subcategories": []
            },
            {
              "id": "drills-piling-atlas-copco-ecm590",
              "name": "ECM590",
              "subcategories": []
            },
            {
              "id": "drills-piling-atlas-copco-ecm660",
              "name": "ECM660",
              "subcategories": []
            },
            {
              "id": "drills-piling-atlas-copco-ecm720",
              "name": "ECM720",
              "subcategories": []
            },
            {
              "id": "drills-piling-atlas-copco-flexiroc-d55",
              "name": "FLEXIROC D55",
              "subcategories": []
            },
            {
              "id": "drills-piling-atlas-copco-flexiroc-d60",
              "name": "FLEXIROC D60",
              "subcategories": []
            },
            {
              "id": "drills-piling-atlas-copco-flexiroc-d65",
              "name": "FLEXIROC D65",
              "subcategories": []
            },
            {
              "id": "drills-piling-atlas-copco-flexiroc-t15r",
              "name": "FLEXIROC T15R",
              "subcategories": []
            },
            {
              "id": "drills-piling-atlas-copco-flexiroc-t20r",
              "name": "FLEXIROC T20R",
              "subcategories": []
            },
            {
              "id": "drills-piling-atlas-copco-flexiroc-t30r",
              "name": "FLEXIROC T30R",
              "subcategories": []
            },
            {
              "id": "drills-piling-atlas-copco-flexiroc-t35-11",
              "name": "FLEXIROC T35-11",
              "subcategories": []
            },
            {
              "id": "drills-piling-atlas-copco-flexiroc-t35r-01",
              "name": "FLEXIROC T35R-01",
              "subcategories": []
            },
            {
              "id": "drills-piling-atlas-copco-flexiroc-t40",
              "name": "FLEXIROC T40",
              "subcategories": []
            },
            {
              "id": "drills-piling-atlas-copco-flexiroc-t45",
              "name": "FLEXIROC T45",
              "subcategories": []
            },
            {
              "id": "drills-piling-atlas-copco-flexiroc-t50",
              "name": "FLEXIROC T50",
              "subcategories": []
            },
            {
              "id": "drills-piling-atlas-copco-h104",
              "name": "H104",
              "subcategories": []
            },
            {
              "id": "drills-piling-atlas-copco-h351",
              "name": "H351",
              "subcategories": []
            },
            {
              "id": "drills-piling-atlas-copco-mustang-5ph",
              "name": "MUSTANG 5PH",
              "subcategories": []
            },
            {
              "id": "drills-piling-atlas-copco-mustang-13f3",
              "name": "MUSTANG 13F3",
              "subcategories": []
            },
            {
              "id": "drills-piling-atlas-copco-powerroc-t25",
              "name": "POWERROC T25",
              "subcategories": []
            },
            {
              "id": "drills-piling-atlas-copco-powerroc-t30",
              "name": "POWERROC T30",
              "subcategories": []
            },
            {
              "id": "drills-piling-atlas-copco-powerroc-t35",
              "name": "POWERROC T35",
              "subcategories": []
            },
            {
              "id": "drills-piling-atlas-copco-powerroc-t40",
              "name": "POWERROC T40",
              "subcategories": []
            },
            {
              "id": "drills-piling-atlas-copco-powerroc-t45",
              "name": "POWERROC T45",
              "subcategories": []
            },
            {
              "id": "drills-piling-atlas-copco-pv271",
              "name": "PV271",
              "subcategories": []
            },
            {
              "id": "drills-piling-atlas-copco-pv275",
              "name": "PV275",
              "subcategories": []
            },
            {
              "id": "drills-piling-atlas-copco-rd20",
              "name": "RD20",
              "subcategories": []
            },
            {
              "id": "drills-piling-atlas-copco-roc612",
              "name": "ROC612",
              "subcategories": []
            },
            {
              "id": "drills-piling-atlas-copco-roc642",
              "name": "ROC642",
              "subcategories": []
            },
            {
              "id": "drills-piling-atlas-copco-roc712",
              "name": "ROC712",
              "subcategories": []
            },
            {
              "id": "drills-piling-atlas-copco-roc860",
              "name": "ROC860",
              "subcategories": []
            },
            {
              "id": "drills-piling-atlas-copco-roc-d3",
              "name": "ROC D3",
              "subcategories": []
            },
            {
              "id": "drills-piling-atlas-copco-roc-d5",
              "name": "ROC D5",
              "subcategories": []
            },
            {
              "id": "drills-piling-atlas-copco-roc-d7",
              "name": "ROC D7",
              "subcategories": []
            },
            {
              "id": "drills-piling-atlas-copco-roc-d9",
              "name": "ROC D9",
              "subcategories": []
            },
            {
              "id": "drills-piling-atlas-copco-roc-f6",
              "name": "ROC F6",
              "subcategories": []
            },
            {
              "id": "drills-piling-atlas-copco-roc-f7",
              "name": "ROC F7",
              "subcategories": []
            },
            {
              "id": "drills-piling-atlas-copco-roc-f9",
              "name": "ROC F9",
              "subcategories": []
            },
            {
              "id": "drills-piling-atlas-copco-roc-l6",
              "name": "ROC L6",
              "subcategories": []
            },
            {
              "id": "drills-piling-atlas-copco-roc-l7",
              "name": "ROC L7",
              "subcategories": []
            },
            {
              "id": "drills-piling-atlas-copco-roc-l8",
              "name": "ROC L8",
              "subcategories": []
            },
            {
              "id": "drills-piling-atlas-copco-roc-t15",
              "name": "ROC T15",
              "subcategories": []
            },
            {
              "id": "drills-piling-atlas-copco-rocket-boomer-352",
              "name": "ROCKET BOOMER 352",
              "subcategories": []
            },
            {
              "id": "drills-piling-atlas-copco-rocket-boom-l1c",
              "name": "ROCKET BOOM L1C",
              "subcategories": []
            },
            {
              "id": "drills-piling-atlas-copco-rocket-boom-l2c",
              "name": "ROCKET BOOM L2C",
              "subcategories": []
            },
            {
              "id": "drills-piling-atlas-copco-rocket-boomer-wl3c",
              "name": "ROCKET BOOMER WL3C",
              "subcategories": []
            },
            {
              "id": "drills-piling-atlas-copco-rocket-boom-wl4-c30",
              "name": "ROCKET BOOM WL4 C30",
              "subcategories": []
            },
            {
              "id": "drills-piling-atlas-copco-rocket-boomer-xl3c",
              "name": "ROCKET BOOMER XL3C",
              "subcategories": []
            },
            {
              "id": "drills-piling-atlas-copco-simba-m7c",
              "name": "SIMBA M7C",
              "subcategories": []
            },
            {
              "id": "drills-piling-atlas-copco-smartroc-c50",
              "name": "SMARTROC C50",
              "subcategories": []
            },
            {
              "id": "drills-piling-atlas-copco-smartroc-d65-10lf",
              "name": "SMARTROC D65-10LF",
              "subcategories": []
            },
            {
              "id": "drills-piling-atlas-copco-smartroc-t35-11",
              "name": "SMARTROC T35-11",
              "subcategories": []
            },
            {
              "id": "drills-piling-atlas-copco-smartroc-t40",
              "name": "SMARTROC T40",
              "subcategories": []
            },
            {
              "id": "drills-piling-atlas-copco-smartroc-t445",
              "name": "SMARTROC T445",
              "subcategories": []
            },
            {
              "id": "drills-piling-atlas-copco-t4",
              "name": "T4",
              "subcategories": []
            },
            {
              "id": "drills-piling-atlas-copco-t35",
              "name": "T35",
              "subcategories": []
            },
            {
              "id": "drills-piling-atlas-copco-xl660",
              "name": "XL660",
              "subcategories": []
            },
            {
              "id": "drills-piling-atlas-copco-other",
              "name": "OTHER",
              "subcategories": []
            }
          ]
        },
        {
          "id": "drills-piling-sandvik",
          "name": "Sandvik",
          "subcategories": [
            {
              "id": "drills-piling-sandvik-1175",
              "name": "1175",
              "subcategories": []
            },
            {
              "id": "drills-piling-sandvik-axer-7-260",
              "name": "AXER 7-260",
              "subcategories": []
            },
            {
              "id": "drills-piling-sandvik-commando-dc125r",
              "name": "COMMANDO DC125R",
              "subcategories": []
            },
            {
              "id": "drills-piling-sandvik-cth14",
              "name": "CTH14",
              "subcategories": []
            },
            {
              "id": "drills-piling-sandvik-d25",
              "name": "D25",
              "subcategories": []
            },
            {
              "id": "drills-piling-sandvik-d45",
              "name": "D45",
              "subcategories": []
            },
            {
              "id": "drills-piling-sandvik-d50",
              "name": "D50",
              "subcategories": []
            },
            {
              "id": "drills-piling-sandvik-d75",
              "name": "D75",
              "subcategories": []
            },
            {
              "id": "drills-piling-sandvik-d90",
              "name": "D90",
              "subcategories": []
            },
            {
              "id": "drills-piling-sandvik-d55",
              "name": "D55",
              "subcategories": []
            },
            {
              "id": "drills-piling-sandvik-d245",
              "name": "D245",
              "subcategories": []
            },
            {
              "id": "drills-piling-sandvik-dc122",
              "name": "DC122",
              "subcategories": []
            },
            {
              "id": "drills-piling-sandvik-dc130",
              "name": "DC130",
              "subcategories": []
            },
            {
              "id": "drills-piling-sandvik-dc300",
              "name": "DC300",
              "subcategories": []
            },
            {
              "id": "drills-piling-sandvik-dc302",
              "name": "DC302",
              "subcategories": []
            },
            {
              "id": "drills-piling-sandvik-dc400",
              "name": "DC400",
              "subcategories": []
            },
            {
              "id": "drills-piling-sandvik-dc560",
              "name": "DC560",
              "subcategories": []
            },
            {
              "id": "drills-piling-sandvik-dc700",
              "name": "DC700",
              "subcategories": []
            },
            {
              "id": "drills-piling-sandvik-dd310",
              "name": "DD310",
              "subcategories": []
            },
            {
              "id": "drills-piling-sandvik-dd311",
              "name": "DD311",
              "subcategories": []
            },
            {
              "id": "drills-piling-sandvik-dd321",
              "name": "DD321",
              "subcategories": []
            },
            {
              "id": "drills-piling-sandvik-dd420",
              "name": "DD420",
              "subcategories": []
            },
            {
              "id": "drills-piling-sandvik-dd421",
              "name": "DD421",
              "subcategories": []
            },
            {
              "id": "drills-piling-sandvik-dd422",
              "name": "DD422",
              "subcategories": []
            },
            {
              "id": "drills-piling-sandvik-dd2710",
              "name": "DD2710",
              "subcategories": []
            },
            {
              "id": "drills-piling-sandvik-di200",
              "name": "DI200",
              "subcategories": []
            },
            {
              "id": "drills-piling-sandvik-di450",
              "name": "DI450",
              "subcategories": []
            },
            {
              "id": "drills-piling-sandvik-di550",
              "name": "DI550",
              "subcategories": []
            },
            {
              "id": "drills-piling-sandvik-dino-dc400ri",
              "name": "DINO DC400RI",
              "subcategories": []
            },
            {
              "id": "drills-piling-sandvik-dl311",
              "name": "DL311",
              "subcategories": []
            },
            {
              "id": "drills-piling-sandvik-dl2710",
              "name": "DL2710",
              "subcategories": []
            },
            {
              "id": "drills-piling-sandvik-dp900",
              "name": "DP900",
              "subcategories": []
            },
            {
              "id": "drills-piling-sandvik-dp1100",
              "name": "DP1100",
              "subcategories": []
            },
            {
              "id": "drills-piling-sandvik-dp1500",
              "name": "DP1500",
              "subcategories": []
            },
            {
              "id": "drills-piling-sandvik-dr560",
              "name": "DR560",
              "subcategories": []
            },
            {
              "id": "drills-piling-sandvik-dr580",
              "name": "DR580",
              "subcategories": []
            },
            {
              "id": "drills-piling-sandvik-ds310",
              "name": "DS310",
              "subcategories": []
            },
            {
              "id": "drills-piling-sandvik-ds411",
              "name": "DS411",
              "subcategories": []
            },
            {
              "id": "drills-piling-sandvik-ds511",
              "name": "DS511",
              "subcategories": []
            },
            {
              "id": "drills-piling-sandvik-ds520",
              "name": "DS520",
              "subcategories": []
            },
            {
              "id": "drills-piling-sandvik-dt820",
              "name": "DT820",
              "subcategories": []
            },
            {
              "id": "drills-piling-sandvik-dt821",
              "name": "DT821",
              "subcategories": []
            },
            {
              "id": "drills-piling-sandvik-dt920",
              "name": "DT920",
              "subcategories": []
            },
            {
              "id": "drills-piling-sandvik-dt922",
              "name": "DT922",
              "subcategories": []
            },
            {
              "id": "drills-piling-sandvik-dt923",
              "name": "DT923",
              "subcategories": []
            },
            {
              "id": "drills-piling-sandvik-dt1130",
              "name": "DT1130",
              "subcategories": []
            },
            {
              "id": "drills-piling-sandvik-dt1131",
              "name": "DT1131",
              "subcategories": []
            },
            {
              "id": "drills-piling-sandvik-dt1132",
              "name": "DT1132",
              "subcategories": []
            },
            {
              "id": "drills-piling-sandvik-dx700",
              "name": "DX700",
              "subcategories": []
            },
            {
              "id": "drills-piling-sandvik-dx780",
              "name": "DX780",
              "subcategories": []
            },
            {
              "id": "drills-piling-sandvik-dx800",
              "name": "DX800",
              "subcategories": []
            },
            {
              "id": "drills-piling-sandvik-di650",
              "name": "DI650",
              "subcategories": []
            },
            {
              "id": "drills-piling-sandvik-pantera-di6400",
              "name": "PANTERA DI6400",
              "subcategories": []
            },
            {
              "id": "drills-piling-sandvik-pantera-dp1500i",
              "name": "PANTERA DP1500I",
              "subcategories": []
            },
            {
              "id": "drills-piling-sandvik-pantera-dp1600i",
              "name": "PANTERA DP1600I",
              "subcategories": []
            },
            {
              "id": "drills-piling-sandvik-ranger-dx800",
              "name": "RANGER DX800",
              "subcategories": []
            },
            {
              "id": "drills-piling-sandvik-ranger-dx900i",
              "name": "RANGER DX900I",
              "subcategories": []
            },
            {
              "id": "drills-piling-sandvik-t1000",
              "name": "T1000",
              "subcategories": []
            },
            {
              "id": "drills-piling-sandvik-titon-300",
              "name": "TITON 300",
              "subcategories": []
            },
            {
              "id": "drills-piling-sandvik-titon-400",
              "name": "TITON 400",
              "subcategories": []
            },
            {
              "id": "drills-piling-sandvik-udr650",
              "name": "UDR650",
              "subcategories": []
            },
            {
              "id": "drills-piling-sandvik-udr1000",
              "name": "UDR1000",
              "subcategories": []
            },
            {
              "id": "drills-piling-sandvik-other",
              "name": "OTHER",
              "subcategories": []
            }
          ]
        },
        {
          "id": "drills-piling-ingersol-rand",
          "name": "Ingersol Rand",
          "subcategories": [
            {
              "id": "drills-piling-ingersol-rand-cm150",
              "name": "CM150",
              "subcategories": []
            },
            {
              "id": "drills-piling-ingersol-rand-cm351",
              "name": "CM351",
              "subcategories": []
            },
            {
              "id": "drills-piling-ingersol-rand-cm470",
              "name": "CM470",
              "subcategories": []
            },
            {
              "id": "drills-piling-ingersol-rand-cm580",
              "name": "CM580",
              "subcategories": []
            },
            {
              "id": "drills-piling-ingersol-rand-cm672",
              "name": "CM672",
              "subcategories": []
            },
            {
              "id": "drills-piling-ingersol-rand-cm695",
              "name": "CM695",
              "subcategories": []
            },
            {
              "id": "drills-piling-ingersol-rand-cm760",
              "name": "CM760",
              "subcategories": []
            },
            {
              "id": "drills-piling-ingersol-rand-cm780",
              "name": "CM780",
              "subcategories": []
            },
            {
              "id": "drills-piling-ingersol-rand-dm30",
              "name": "DM30",
              "subcategories": []
            },
            {
              "id": "drills-piling-ingersol-rand-dm45",
              "name": "DM45",
              "subcategories": []
            },
            {
              "id": "drills-piling-ingersol-rand-dm50",
              "name": "DM50",
              "subcategories": []
            },
            {
              "id": "drills-piling-ingersol-rand-dml",
              "name": "DML",
              "subcategories": []
            },
            {
              "id": "drills-piling-ingersol-rand-dml45",
              "name": "DML45",
              "subcategories": []
            },
            {
              "id": "drills-piling-ingersol-rand-dml1200",
              "name": "DML1200",
              "subcategories": []
            },
            {
              "id": "drills-piling-ingersol-rand-dmlsp",
              "name": "DMLSP",
              "subcategories": []
            },
            {
              "id": "drills-piling-ingersol-rand-dmlhp1250",
              "name": "DMLHP1250",
              "subcategories": []
            },
            {
              "id": "drills-piling-ingersol-rand-dmlxl-1200",
              "name": "DMLXL 1200",
              "subcategories": []
            },
            {
              "id": "drills-piling-ingersol-rand-dmm3",
              "name": "DMM3",
              "subcategories": []
            },
            {
              "id": "drills-piling-ingersol-rand-ecm350",
              "name": "ECM350",
              "subcategories": []
            },
            {
              "id": "drills-piling-ingersol-rand-ecm370",
              "name": "ECM370",
              "subcategories": []
            },
            {
              "id": "drills-piling-ingersol-rand-ecm490",
              "name": "ECM490",
              "subcategories": []
            },
            {
              "id": "drills-piling-ingersol-rand-ecm570",
              "name": "ECM570",
              "subcategories": []
            },
            {
              "id": "drills-piling-ingersol-rand-ecm580",
              "name": "ECM580",
              "subcategories": []
            },
            {
              "id": "drills-piling-ingersol-rand-ecm585",
              "name": "ECM585",
              "subcategories": []
            },
            {
              "id": "drills-piling-ingersol-rand-ecm590",
              "name": "ECM590",
              "subcategories": []
            },
            {
              "id": "drills-piling-ingersol-rand-ecm660",
              "name": "ECM660",
              "subcategories": []
            },
            {
              "id": "drills-piling-ingersol-rand-ecm670",
              "name": "ECM670",
              "subcategories": []
            },
            {
              "id": "drills-piling-ingersol-rand-ecm680",
              "name": "ECM680",
              "subcategories": []
            },
            {
              "id": "drills-piling-ingersol-rand-ecm690",
              "name": "ECM690",
              "subcategories": []
            },
            {
              "id": "drills-piling-ingersol-rand-ecm720",
              "name": "ECM720",
              "subcategories": []
            },
            {
              "id": "drills-piling-ingersol-rand-lm100",
              "name": "LM100",
              "subcategories": []
            },
            {
              "id": "drills-piling-ingersol-rand-lm500",
              "name": "LM500",
              "subcategories": []
            },
            {
              "id": "drills-piling-ingersol-rand-lme500",
              "name": "LME500",
              "subcategories": []
            },
            {
              "id": "drills-piling-ingersol-rand-r10071",
              "name": "R10071",
              "subcategories": []
            },
            {
              "id": "drills-piling-ingersol-rand-t4",
              "name": "T4",
              "subcategories": []
            },
            {
              "id": "drills-piling-ingersol-rand-th60",
              "name": "TH60",
              "subcategories": []
            },
            {
              "id": "drills-piling-ingersol-rand-th75",
              "name": "TH75",
              "subcategories": []
            },
            {
              "id": "drills-piling-ingersol-rand-other",
              "name": "OTHER",
              "subcategories": []
            }
          ]
        },
        {
          "id": "drills-piling-xcmg",
          "name": "Xcmg",
          "subcategories": [
            {
              "id": "drills-piling-xcmg-xc-95",
              "name": "XC-95",
              "subcategories": []
            },
            {
              "id": "drills-piling-xcmg-xg700",
              "name": "XG700",
              "subcategories": []
            },
            {
              "id": "drills-piling-xcmg-xr80",
              "name": "XR80",
              "subcategories": []
            },
            {
              "id": "drills-piling-xcmg-xr130",
              "name": "XR130",
              "subcategories": []
            },
            {
              "id": "drills-piling-xcmg-xr150",
              "name": "XR150",
              "subcategories": []
            },
            {
              "id": "drills-piling-xcmg-xr160",
              "name": "XR160",
              "subcategories": []
            },
            {
              "id": "drills-piling-xcmg-xr180",
              "name": "XR180",
              "subcategories": []
            },
            {
              "id": "drills-piling-xcmg-xr200",
              "name": "XR200",
              "subcategories": []
            },
            {
              "id": "drills-piling-xcmg-xr220",
              "name": "XR220",
              "subcategories": []
            },
            {
              "id": "drills-piling-xcmg-xr240",
              "name": "XR240",
              "subcategories": []
            },
            {
              "id": "drills-piling-xcmg-xr280",
              "name": "XR280",
              "subcategories": []
            },
            {
              "id": "drills-piling-xcmg-xr320",
              "name": "XR320",
              "subcategories": []
            },
            {
              "id": "drills-piling-xcmg-xr360",
              "name": "XR360",
              "subcategories": []
            },
            {
              "id": "drills-piling-xcmg-xr400",
              "name": "XR400",
              "subcategories": []
            },
            {
              "id": "drills-piling-xcmg-xr460",
              "name": "XR460",
              "subcategories": []
            },
            {
              "id": "drills-piling-xcmg-xrs1050",
              "name": "XRS1050",
              "subcategories": []
            },
            {
              "id": "drills-piling-xcmg-xz200",
              "name": "XZ200",
              "subcategories": []
            },
            {
              "id": "drills-piling-xcmg-xz320",
              "name": "XZ320",
              "subcategories": []
            },
            {
              "id": "drills-piling-xcmg-xz360",
              "name": "XZ360",
              "subcategories": []
            },
            {
              "id": "drills-piling-xcmg-xz450",
              "name": "XZ450",
              "subcategories": []
            },
            {
              "id": "drills-piling-xcmg-xz680",
              "name": "XZ680",
              "subcategories": []
            },
            {
              "id": "drills-piling-xcmg-xz1350",
              "name": "XZ1350",
              "subcategories": []
            },
            {
              "id": "drills-piling-xcmg-xz2025",
              "name": "XZ2025",
              "subcategories": []
            },
            {
              "id": "drills-piling-xcmg-other",
              "name": "OTHER",
              "subcategories": []
            }
          ]
        },
        {
          "id": "drills-piling-epiroc",
          "name": "Epiroc",
          "subcategories": [
            {
              "id": "drills-piling-epiroc-airroc-d35",
              "name": "AIRROC D35",
              "subcategories": []
            },
            {
              "id": "drills-piling-epiroc-airroc-d40",
              "name": "AIRROC D40",
              "subcategories": []
            },
            {
              "id": "drills-piling-epiroc-boltec-235",
              "name": "BOLTEC 235",
              "subcategories": []
            },
            {
              "id": "drills-piling-epiroc-boltec-e",
              "name": "BOLTEC E",
              "subcategories": []
            },
            {
              "id": "drills-piling-epiroc-boltec-s",
              "name": "BOLTEC S",
              "subcategories": []
            },
            {
              "id": "drills-piling-epiroc-boltec-s10",
              "name": "BOLTEC S10",
              "subcategories": []
            },
            {
              "id": "drills-piling-epiroc-boomer-282",
              "name": "BOOMER 282",
              "subcategories": []
            },
            {
              "id": "drills-piling-epiroc-boomer-292",
              "name": "BOOMER 292",
              "subcategories": []
            },
            {
              "id": "drills-piling-epiroc-boomer-e2-c",
              "name": "BOOMER E2 C",
              "subcategories": []
            },
            {
              "id": "drills-piling-epiroc-boomer-l2",
              "name": "BOOMER L2",
              "subcategories": []
            },
            {
              "id": "drills-piling-epiroc-boomer-m1",
              "name": "BOOMER M1",
              "subcategories": []
            },
            {
              "id": "drills-piling-epiroc-boomer-s1-dh",
              "name": "BOOMER S1 DH",
              "subcategories": []
            },
            {
              "id": "drills-piling-epiroc-boomer-s2",
              "name": "BOOMER S2",
              "subcategories": []
            },
            {
              "id": "drills-piling-epiroc-boomer-s10-s",
              "name": "BOOMER S10 S",
              "subcategories": []
            },
            {
              "id": "drills-piling-epiroc-boomer-xe3",
              "name": "BOOMER XE3",
              "subcategories": []
            },
            {
              "id": "drills-piling-epiroc-boomer-291",
              "name": "BOOMER 291",
              "subcategories": []
            },
            {
              "id": "drills-piling-epiroc-boomer-e20",
              "name": "BOOMER E20",
              "subcategories": []
            },
            {
              "id": "drills-piling-epiroc-boomer-k41",
              "name": "BOOMER K41",
              "subcategories": []
            },
            {
              "id": "drills-piling-epiroc-boomer-k111",
              "name": "BOOMER K111",
              "subcategories": []
            },
            {
              "id": "drills-piling-epiroc-cabletec-m",
              "name": "CABLETEC M",
              "subcategories": []
            },
            {
              "id": "drills-piling-epiroc-dm30",
              "name": "DM30",
              "subcategories": []
            },
            {
              "id": "drills-piling-epiroc-dm45",
              "name": "DM45",
              "subcategories": []
            },
            {
              "id": "drills-piling-epiroc-dm75",
              "name": "DM75",
              "subcategories": []
            },
            {
              "id": "drills-piling-epiroc-dml",
              "name": "DML",
              "subcategories": []
            },
            {
              "id": "drills-piling-epiroc-flexiroc-d50",
              "name": "FLEXIROC D50",
              "subcategories": []
            },
            {
              "id": "drills-piling-epiroc-flexiroc-d60",
              "name": "FLEXIROC D60",
              "subcategories": []
            },
            {
              "id": "drills-piling-epiroc-flexiroc-d65",
              "name": "FLEXIROC D65",
              "subcategories": []
            },
            {
              "id": "drills-piling-epiroc-flexiroc-t15r",
              "name": "FLEXIROC T15R",
              "subcategories": []
            },
            {
              "id": "drills-piling-epiroc-flexiroc-t30r-03",
              "name": "FLEXIROC T30R-03",
              "subcategories": []
            },
            {
              "id": "drills-piling-epiroc-flexiroc-t35",
              "name": "FLEXIROC T35",
              "subcategories": []
            },
            {
              "id": "drills-piling-epiroc-flexiroc-t45",
              "name": "FLEXIROC T45",
              "subcategories": []
            },
            {
              "id": "drills-piling-epiroc-flexiroc-t50",
              "name": "FLEXIROC T50",
              "subcategories": []
            },
            {
              "id": "drills-piling-epiroc-powerroc-d45",
              "name": "POWERROC D45",
              "subcategories": []
            },
            {
              "id": "drills-piling-epiroc-powerroc-d55",
              "name": "POWERROC D55",
              "subcategories": []
            },
            {
              "id": "drills-piling-epiroc-powerroc-d60",
              "name": "POWERROC D60",
              "subcategories": []
            },
            {
              "id": "drills-piling-epiroc-powerroc-t35",
              "name": "POWERROC T35",
              "subcategories": []
            },
            {
              "id": "drills-piling-epiroc-powerroc-t45",
              "name": "POWERROC T45",
              "subcategories": []
            },
            {
              "id": "drills-piling-epiroc-powerroc-t50",
              "name": "POWERROC T50",
              "subcategories": []
            },
            {
              "id": "drills-piling-epiroc-pv271",
              "name": "PV271",
              "subcategories": []
            },
            {
              "id": "drills-piling-epiroc-simba-1354",
              "name": "SIMBA 1354",
              "subcategories": []
            },
            {
              "id": "drills-piling-epiroc-smartroc-d50",
              "name": "SMARTROC D50",
              "subcategories": []
            },
            {
              "id": "drills-piling-epiroc-smartroc-d60",
              "name": "SMARTROC D60",
              "subcategories": []
            },
            {
              "id": "drills-piling-epiroc-smartroc-d65",
              "name": "SMARTROC D65",
              "subcategories": []
            },
            {
              "id": "drills-piling-epiroc-smartroc-t35",
              "name": "SMARTROC T35",
              "subcategories": []
            },
            {
              "id": "drills-piling-epiroc-smartroc-t40",
              "name": "SMARTROC T40",
              "subcategories": []
            },
            {
              "id": "drills-piling-epiroc-smartroc-t40-11",
              "name": "SMARTROC T40-11",
              "subcategories": []
            },
            {
              "id": "drills-piling-epiroc-smartroc-t45",
              "name": "SMARTROC T45",
              "subcategories": []
            },
            {
              "id": "drills-piling-epiroc-smartroc-t45-10sf",
              "name": "SMARTROC T45-10SF",
              "subcategories": []
            },
            {
              "id": "drills-piling-epiroc-smartroc-t45-11sf",
              "name": "SMARTROC T45-11SF",
              "subcategories": []
            },
            {
              "id": "drills-piling-epiroc-smartroc-d65",
              "name": "SMARTROC D65",
              "subcategories": []
            },
            {
              "id": "drills-piling-epiroc-speedroc-3f",
              "name": "SPEEDROC 3F",
              "subcategories": []
            },
            {
              "id": "drills-piling-epiroc-other",
              "name": "OTHER",
              "subcategories": []
            }
          ]
        },
        {
          "id": "drills-piling-soilmec",
          "name": "Soilmec",
          "subcategories": [
            {
              "id": "drills-piling-soilmec-psm16",
              "name": "PSM16",
              "subcategories": []
            },
            {
              "id": "drills-piling-soilmec-psm20",
              "name": "PSM20",
              "subcategories": []
            },
            {
              "id": "drills-piling-soilmec-psm1350",
              "name": "PSM1350",
              "subcategories": []
            },
            {
              "id": "drills-piling-soilmec-r210",
              "name": "R210",
              "subcategories": []
            },
            {
              "id": "drills-piling-soilmec-r312",
              "name": "R312",
              "subcategories": []
            },
            {
              "id": "drills-piling-soilmec-r515",
              "name": "R515",
              "subcategories": []
            },
            {
              "id": "drills-piling-soilmec-r625",
              "name": "R625",
              "subcategories": []
            },
            {
              "id": "drills-piling-soilmec-r825",
              "name": "R825",
              "subcategories": []
            },
            {
              "id": "drills-piling-soilmec-sc130",
              "name": "SC130",
              "subcategories": []
            },
            {
              "id": "drills-piling-soilmec-sc135",
              "name": "SC135",
              "subcategories": []
            },
            {
              "id": "drills-piling-soilmec-sf50",
              "name": "SF50",
              "subcategories": []
            },
            {
              "id": "drills-piling-soilmec-sf55",
              "name": "SF55",
              "subcategories": []
            },
            {
              "id": "drills-piling-soilmec-sf65",
              "name": "SF65",
              "subcategories": []
            },
            {
              "id": "drills-piling-soilmec-sf70",
              "name": "SF70",
              "subcategories": []
            },
            {
              "id": "drills-piling-soilmec-sm4",
              "name": "SM4",
              "subcategories": []
            },
            {
              "id": "drills-piling-soilmec-sm8",
              "name": "SM8",
              "subcategories": []
            },
            {
              "id": "drills-piling-soilmec-sm14",
              "name": "SM14",
              "subcategories": []
            },
            {
              "id": "drills-piling-soilmec-sm21",
              "name": "SM21",
              "subcategories": []
            },
            {
              "id": "drills-piling-soilmec-sm22",
              "name": "SM22",
              "subcategories": []
            },
            {
              "id": "drills-piling-soilmec-sm28",
              "name": "SM28",
              "subcategories": []
            },
            {
              "id": "drills-piling-soilmec-sm401",
              "name": "SM401",
              "subcategories": []
            },
            {
              "id": "drills-piling-soilmec-sr30",
              "name": "SR30",
              "subcategories": []
            },
            {
              "id": "drills-piling-soilmec-sr40",
              "name": "SR40",
              "subcategories": []
            },
            {
              "id": "drills-piling-soilmec-sr45",
              "name": "SR45",
              "subcategories": []
            },
            {
              "id": "drills-piling-soilmec-sr50",
              "name": "SR50",
              "subcategories": []
            },
            {
              "id": "drills-piling-soilmec-sr65",
              "name": "SR65",
              "subcategories": []
            },
            {
              "id": "drills-piling-soilmec-sr70",
              "name": "SR70",
              "subcategories": []
            },
            {
              "id": "drills-piling-soilmec-sr75",
              "name": "SR75",
              "subcategories": []
            },
            {
              "id": "drills-piling-soilmec-sr80",
              "name": "SR80",
              "subcategories": []
            },
            {
              "id": "drills-piling-soilmec-sr90",
              "name": "SR90",
              "subcategories": []
            },
            {
              "id": "drills-piling-soilmec-sr95",
              "name": "SR95",
              "subcategories": []
            },
            {
              "id": "drills-piling-soilmec-sr100",
              "name": "SR100",
              "subcategories": []
            },
            {
              "id": "drills-piling-soilmec-st20",
              "name": "ST20",
              "subcategories": []
            },
            {
              "id": "drills-piling-soilmec-other",
              "name": "OTHER",
              "subcategories": []
            }
          ]
        },
        {
          "id": "drills-piling-tamrock",
          "name": "Tamrock",
          "subcategories": [
            {
              "id": "drills-piling-tamrock-axera-t08",
              "name": "AXERA T08",
              "subcategories": []
            },
            {
              "id": "drills-piling-tamrock-axera-t11",
              "name": "AXERA T11",
              "subcategories": []
            },
            {
              "id": "drills-piling-tamrock-cabolt-520",
              "name": "CABOLT 520",
              "subcategories": []
            },
            {
              "id": "drills-piling-tamrock-cha700",
              "name": "CHA700",
              "subcategories": []
            },
            {
              "id": "drills-piling-tamrock-cha1000",
              "name": "CHA1000",
              "subcategories": []
            },
            {
              "id": "drills-piling-tamrock-cha1100",
              "name": "CHA1100",
              "subcategories": []
            },
            {
              "id": "drills-piling-tamrock-commando-120",
              "name": "COMMANDO 120",
              "subcategories": []
            },
            {
              "id": "drills-piling-tamrock-commando-120r",
              "name": "COMMANDO 120R",
              "subcategories": []
            },
            {
              "id": "drills-piling-tamrock-commando-300",
              "name": "COMMANDO 300",
              "subcategories": []
            },
            {
              "id": "drills-piling-tamrock-dha400",
              "name": "DHA400",
              "subcategories": []
            },
            {
              "id": "drills-piling-tamrock-dha550",
              "name": "DHA550",
              "subcategories": []
            },
            {
              "id": "drills-piling-tamrock-dino-500",
              "name": "DINO 500",
              "subcategories": []
            },
            {
              "id": "drills-piling-tamrock-dino-560",
              "name": "DINO 560",
              "subcategories": []
            },
            {
              "id": "drills-piling-tamrock-hs205",
              "name": "HS205",
              "subcategories": []
            },
            {
              "id": "drills-piling-tamrock-hpp5",
              "name": "HPP5",
              "subcategories": []
            },
            {
              "id": "drills-piling-tamrock-pantera-900",
              "name": "PANTERA 900",
              "subcategories": []
            },
            {
              "id": "drills-piling-tamrock-pantera-1100",
              "name": "PANTERA 1100",
              "subcategories": []
            },
            {
              "id": "drills-piling-tamrock-pantera-1500",
              "name": "PANTERA 1500",
              "subcategories": []
            },
            {
              "id": "drills-piling-tamrock-ranger-500",
              "name": "RANGER 500",
              "subcategories": []
            },
            {
              "id": "drills-piling-tamrock-ranger-700",
              "name": "RANGER 700",
              "subcategories": []
            },
            {
              "id": "drills-piling-tamrock-ranger-800",
              "name": "RANGER 800",
              "subcategories": []
            },
            {
              "id": "drills-piling-tamrock-ranger-k5",
              "name": "RANGER K5",
              "subcategories": []
            },
            {
              "id": "drills-piling-tamrock-rhino-100hf",
              "name": "RHINO 100HF",
              "subcategories": []
            },
            {
              "id": "drills-piling-tamrock-robolt-06",
              "name": "ROBOLT 06",
              "subcategories": []
            },
            {
              "id": "drills-piling-tamrock-scout-700-2",
              "name": "SCOUT 700-2",
              "subcategories": []
            },
            {
              "id": "drills-piling-tamrock-super-316g",
              "name": "SUPER 316G",
              "subcategories": []
            },
            {
              "id": "drills-piling-tamrock-supermatic-315-150",
              "name": "SUPERMATIC 315-150",
              "subcategories": []
            },
            {
              "id": "drills-piling-tamrock-titon-600",
              "name": "TITON 600",
              "subcategories": []
            },
            {
              "id": "drills-piling-tamrock-zru700",
              "name": "ZRU700",
              "subcategories": []
            },
            {
              "id": "drills-piling-tamrock-other",
              "name": "OTHER",
              "subcategories": []
            }
          ]
        },
        {
          "id": "drills-piling-furukawa",
          "name": "Furukawa",
          "subcategories": [
            {
              "id": "drills-piling-furukawa-1500",
              "name": "1500",
              "subcategories": []
            },
            {
              "id": "drills-piling-furukawa-dcr20",
              "name": "DCR20",
              "subcategories": []
            },
            {
              "id": "drills-piling-furukawa-dcr22",
              "name": "DCR22",
              "subcategories": []
            },
            {
              "id": "drills-piling-furukawa-hcr9",
              "name": "HCR9",
              "subcategories": []
            },
            {
              "id": "drills-piling-furukawa-hcr10",
              "name": "HCR10",
              "subcategories": []
            },
            {
              "id": "drills-piling-furukawa-hcr1200",
              "name": "HCR1200",
              "subcategories": []
            },
            {
              "id": "drills-piling-furukawa-hcr900",
              "name": "HCR900",
              "subcategories": []
            },
            {
              "id": "drills-piling-furukawa-hcr910",
              "name": "HCR910",
              "subcategories": []
            },
            {
              "id": "drills-piling-furukawa-hcr950",
              "name": "HCR950",
              "subcategories": []
            },
            {
              "id": "drills-piling-furukawa-hcr1000",
              "name": "HCR1000",
              "subcategories": []
            },
            {
              "id": "drills-piling-furukawa-hcr1100",
              "name": "HCR1100",
              "subcategories": []
            },
            {
              "id": "drills-piling-furukawa-hcr1200",
              "name": "HCR1200",
              "subcategories": []
            },
            {
              "id": "drills-piling-furukawa-hcr1450",
              "name": "HCR1450",
              "subcategories": []
            },
            {
              "id": "drills-piling-furukawa-hcr1500",
              "name": "HCR1500",
              "subcategories": []
            },
            {
              "id": "drills-piling-furukawa-hcr1800",
              "name": "HCR1800",
              "subcategories": []
            },
            {
              "id": "drills-piling-furukawa-hcr-l110",
              "name": "HCR L110",
              "subcategories": []
            },
            {
              "id": "drills-piling-furukawa-hcrc300",
              "name": "HCRC300",
              "subcategories": []
            },
            {
              "id": "drills-piling-furukawa-jth1",
              "name": "JTH1",
              "subcategories": []
            },
            {
              "id": "drills-piling-furukawa-other",
              "name": "OTHER",
              "subcategories": []
            }
          ]
        },
        {
          "id": "drills-piling-american-augers",
          "name": "American Augers",
          "subcategories": [
            {
              "id": "drills-piling-american-augers-dd110",
              "name": "DD110",
              "subcategories": []
            },
            {
              "id": "drills-piling-american-augers-dd220",
              "name": "DD220",
              "subcategories": []
            },
            {
              "id": "drills-piling-american-augers-dd240",
              "name": "DD240",
              "subcategories": []
            },
            {
              "id": "drills-piling-american-augers-dd330",
              "name": "DD330",
              "subcategories": []
            },
            {
              "id": "drills-piling-american-augers-dd440",
              "name": "DD440",
              "subcategories": []
            },
            {
              "id": "drills-piling-american-augers-m200",
              "name": "M200",
              "subcategories": []
            },
            {
              "id": "drills-piling-american-augers-mcm2000",
              "name": "MCM2000",
              "subcategories": []
            },
            {
              "id": "drills-piling-american-augers-other",
              "name": "OTHER",
              "subcategories": []
            }
          ]
        },
        {
          "id": "drills-piling-bauer",
          "name": "Bauer",
          "subcategories": [
            {
              "id": "drills-piling-bauer-bc30",
              "name": "BC30",
              "subcategories": []
            },
            {
              "id": "drills-piling-bauer-bc40",
              "name": "BC40",
              "subcategories": []
            },
            {
              "id": "drills-piling-bauer-bcm5",
              "name": "BCM5",
              "subcategories": []
            },
            {
              "id": "drills-piling-bauer-bcs40",
              "name": "BCS40",
              "subcategories": []
            },
            {
              "id": "drills-piling-bauer-bg9",
              "name": "BG9",
              "subcategories": []
            },
            {
              "id": "drills-piling-bauer-bg12",
              "name": "BG12",
              "subcategories": []
            },
            {
              "id": "drills-piling-bauer-bg15",
              "name": "BG15",
              "subcategories": []
            },
            {
              "id": "drills-piling-bauer-bg18",
              "name": "BG18",
              "subcategories": []
            },
            {
              "id": "drills-piling-bauer-bg20",
              "name": "BG20",
              "subcategories": []
            },
            {
              "id": "drills-piling-bauer-bg22",
              "name": "BG22",
              "subcategories": []
            },
            {
              "id": "drills-piling-bauer-bg23h",
              "name": "BG23H",
              "subcategories": []
            },
            {
              "id": "drills-piling-bauer-bg24",
              "name": "BG24",
              "subcategories": []
            },
            {
              "id": "drills-piling-bauer-bg26",
              "name": "BG26",
              "subcategories": []
            },
            {
              "id": "drills-piling-bauer-bg28",
              "name": "BG28",
              "subcategories": []
            },
            {
              "id": "drills-piling-bauer-bg30",
              "name": "BG30",
              "subcategories": []
            },
            {
              "id": "drills-piling-bauer-bg38",
              "name": "BG38",
              "subcategories": []
            },
            {
              "id": "drills-piling-bauer-bg48",
              "name": "BG48",
              "subcategories": []
            },
            {
              "id": "drills-piling-bauer-hd470",
              "name": "HD470",
              "subcategories": []
            },
            {
              "id": "drills-piling-bauer-mc128",
              "name": "MC128",
              "subcategories": []
            },
            {
              "id": "drills-piling-bauer-rtg-rg16t",
              "name": "RTG RG16T",
              "subcategories": []
            },
            {
              "id": "drills-piling-bauer-rtg-rg23s",
              "name": "RTG RG23S",
              "subcategories": []
            },
            {
              "id": "drills-piling-bauer-rtg-rg25s",
              "name": "RTG RG25S",
              "subcategories": []
            },
            {
              "id": "drills-piling-bauer-other",
              "name": "OTHER",
              "subcategories": []
            }
          ]
        },
        {
          "id": "drills-piling-bay-shore",
          "name": "Bay Shore",
          "subcategories": [
            {
              "id": "drills-piling-bay-shore-lm-50",
              "name": "LM-50",
              "subcategories": []
            },
            {
              "id": "drills-piling-bay-shore-lodril-dh20",
              "name": "LODRIL DH20",
              "subcategories": []
            },
            {
              "id": "drills-piling-bay-shore-lodril-dh40",
              "name": "LODRIL DH40",
              "subcategories": []
            },
            {
              "id": "drills-piling-bay-shore-lodril-lm60",
              "name": "LODRIL LM60",
              "subcategories": []
            },
            {
              "id": "drills-piling-bay-shore-tr25",
              "name": "TR25",
              "subcategories": []
            },
            {
              "id": "drills-piling-bay-shore-tr40",
              "name": "TR40",
              "subcategories": []
            },
            {
              "id": "drills-piling-bay-shore-tr50",
              "name": "TR50",
              "subcategories": []
            },
            {
              "id": "drills-piling-bay-shore-tr60",
              "name": "TR60",
              "subcategories": []
            },
            {
              "id": "drills-piling-bay-shore-tr80",
              "name": "TR80",
              "subcategories": []
            },
            {
              "id": "drills-piling-bay-shore-tr150",
              "name": "TR150",
              "subcategories": []
            },
            {
              "id": "drills-piling-bay-shore-tr180",
              "name": "TR180",
              "subcategories": []
            },
            {
              "id": "drills-piling-bay-shore-tr95",
              "name": "TR95",
              "subcategories": []
            },
            {
              "id": "drills-piling-bay-shore-other",
              "name": "OTHER",
              "subcategories": []
            }
          ]
        },
        {
          "id": "drills-piling-casagrande",
          "name": "Casagrande",
          "subcategories": [
            {
              "id": "drills-piling-casagrande-b125",
              "name": "B125",
              "subcategories": []
            },
            {
              "id": "drills-piling-casagrande-b160",
              "name": "B160",
              "subcategories": []
            },
            {
              "id": "drills-piling-casagrande-b175",
              "name": "B175",
              "subcategories": []
            },
            {
              "id": "drills-piling-casagrande-b180",
              "name": "B180",
              "subcategories": []
            },
            {
              "id": "drills-piling-casagrande-b200",
              "name": "B200",
              "subcategories": []
            },
            {
              "id": "drills-piling-casagrande-b250",
              "name": "B250",
              "subcategories": []
            },
            {
              "id": "drills-piling-casagrande-b300",
              "name": "B300",
              "subcategories": []
            },
            {
              "id": "drills-piling-casagrande-b400",
              "name": "B400",
              "subcategories": []
            },
            {
              "id": "drills-piling-casagrande-b470",
              "name": "B470",
              "subcategories": []
            },
            {
              "id": "drills-piling-casagrande-c4",
              "name": "C4",
              "subcategories": []
            },
            {
              "id": "drills-piling-casagrande-c6",
              "name": "C6",
              "subcategories": []
            },
            {
              "id": "drills-piling-casagrande-c7",
              "name": "C7",
              "subcategories": []
            },
            {
              "id": "drills-piling-casagrande-c8",
              "name": "C8",
              "subcategories": []
            },
            {
              "id": "drills-piling-casagrande-c14",
              "name": "C14",
              "subcategories": []
            },
            {
              "id": "drills-piling-casagrande-c30",
              "name": "C30",
              "subcategories": []
            },
            {
              "id": "drills-piling-casagrande-c900",
              "name": "C900",
              "subcategories": []
            },
            {
              "id": "drills-piling-casagrande-other",
              "name": "OTHER",
              "subcategories": []
            }
          ]
        },
        {
          "id": "drills-piling-caterpillar",
          "name": "Caterpillar",
          "subcategories": [
            {
              "id": "drills-piling-caterpillar-320",
              "name": "320",
              "subcategories": []
            },
            {
              "id": "drills-piling-caterpillar-325",
              "name": "325",
              "subcategories": []
            },
            {
              "id": "drills-piling-caterpillar-330",
              "name": "330",
              "subcategories": []
            },
            {
              "id": "drills-piling-caterpillar-md5050",
              "name": "MD5050",
              "subcategories": []
            },
            {
              "id": "drills-piling-caterpillar-md5090",
              "name": "MD5090",
              "subcategories": []
            },
            {
              "id": "drills-piling-caterpillar-md5125",
              "name": "MD5125",
              "subcategories": []
            },
            {
              "id": "drills-piling-caterpillar-md6200",
              "name": "MD6200",
              "subcategories": []
            },
            {
              "id": "drills-piling-caterpillar-md6240",
              "name": "MD6240",
              "subcategories": []
            },
            {
              "id": "drills-piling-caterpillar-md6290",
              "name": "MD6290",
              "subcategories": []
            },
            {
              "id": "drills-piling-caterpillar-md6420",
              "name": "MD6420",
              "subcategories": []
            },
            {
              "id": "drills-piling-caterpillar-other",
              "name": "OTHER",
              "subcategories": []
            }
          ]
        },
        {
          "id": "drills-piling-comacchio",
          "name": "Comacchio",
          "subcategories": [
            {
              "id": "drills-piling-comacchio-ch300",
              "name": "CH300",
              "subcategories": []
            },
            {
              "id": "drills-piling-comacchio-ch450",
              "name": "CH450",
              "subcategories": []
            },
            {
              "id": "drills-piling-comacchio-geo205",
              "name": "GEO205",
              "subcategories": []
            },
            {
              "id": "drills-piling-comacchio-geo700",
              "name": "GEO700",
              "subcategories": []
            },
            {
              "id": "drills-piling-comacchio-geo900",
              "name": "GEO900",
              "subcategories": []
            },
            {
              "id": "drills-piling-comacchio-geo500",
              "name": "GEO500",
              "subcategories": []
            },
            {
              "id": "drills-piling-comacchio-mc5",
              "name": "MC5",
              "subcategories": []
            },
            {
              "id": "drills-piling-comacchio-mc6",
              "name": "MC6",
              "subcategories": []
            },
            {
              "id": "drills-piling-comacchio-mc8",
              "name": "MC8",
              "subcategories": []
            },
            {
              "id": "drills-piling-comacchio-mc28",
              "name": "MC28",
              "subcategories": []
            },
            {
              "id": "drills-piling-comacchio-mc235",
              "name": "MC235",
              "subcategories": []
            },
            {
              "id": "drills-piling-comacchio-mc300",
              "name": "MC300",
              "subcategories": []
            },
            {
              "id": "drills-piling-comacchio-mc305",
              "name": "MC305",
              "subcategories": []
            },
            {
              "id": "drills-piling-comacchio-mc400",
              "name": "MC400",
              "subcategories": []
            },
            {
              "id": "drills-piling-comacchio-mc401",
              "name": "MC401",
              "subcategories": []
            },
            {
              "id": "drills-piling-comacchio-mc450",
              "name": "MC450",
              "subcategories": []
            },
            {
              "id": "drills-piling-comacchio-mc600",
              "name": "MC600",
              "subcategories": []
            },
            {
              "id": "drills-piling-comacchio-mc800",
              "name": "MC800",
              "subcategories": []
            },
            {
              "id": "drills-piling-comacchio-mc900",
              "name": "MC900",
              "subcategories": []
            },
            {
              "id": "drills-piling-comacchio-mc1200",
              "name": "MC1200",
              "subcategories": []
            },
            {
              "id": "drills-piling-comacchio-mcf04",
              "name": "MCF04",
              "subcategories": []
            },
            {
              "id": "drills-piling-comacchio-other",
              "name": "OTHER",
              "subcategories": []
            }
          ]
        },
        {
          "id": "drills-piling-driltech",
          "name": "Driltech",
          "subcategories": [
            {
              "id": "drills-piling-driltech-c25k",
              "name": "C25K",
              "subcategories": []
            },
            {
              "id": "drills-piling-driltech-c45k",
              "name": "C45K",
              "subcategories": []
            },
            {
              "id": "drills-piling-driltech-d25",
              "name": "D25",
              "subcategories": []
            },
            {
              "id": "drills-piling-driltech-d40",
              "name": "D40",
              "subcategories": []
            },
            {
              "id": "drills-piling-driltech-d45",
              "name": "D45",
              "subcategories": []
            },
            {
              "id": "drills-piling-driltech-d50",
              "name": "D50",
              "subcategories": []
            },
            {
              "id": "drills-piling-driltech-d55",
              "name": "D55",
              "subcategories": []
            },
            {
              "id": "drills-piling-driltech-t40",
              "name": "T40",
              "subcategories": []
            },
            {
              "id": "drills-piling-driltech-other",
              "name": "OTHER",
              "subcategories": []
            }
          ]
        },
        {
          "id": "drills-piling-hutte-bohrtechnik",
          "name": "Hutte Bohrtechnik",
          "subcategories": [
            {
              "id": "drills-piling-hutte-bohrtechnik-hbr202",
              "name": "HBR202",
              "subcategories": []
            },
            {
              "id": "drills-piling-hutte-bohrtechnik-hbr203",
              "name": "HBR203",
              "subcategories": []
            },
            {
              "id": "drills-piling-hutte-bohrtechnik-hbr204",
              "name": "HBR204",
              "subcategories": []
            },
            {
              "id": "drills-piling-hutte-bohrtechnik-hbr205",
              "name": "HBR205",
              "subcategories": []
            },
            {
              "id": "drills-piling-hutte-bohrtechnik-hbr206",
              "name": "HBR206",
              "subcategories": []
            },
            {
              "id": "drills-piling-hutte-bohrtechnik-hbr207",
              "name": "HBR207",
              "subcategories": []
            },
            {
              "id": "drills-piling-hutte-bohrtechnik-hbr502",
              "name": "HBR502",
              "subcategories": []
            },
            {
              "id": "drills-piling-hutte-bohrtechnik-hbr504",
              "name": "HBR504",
              "subcategories": []
            },
            {
              "id": "drills-piling-hutte-bohrtechnik-hbr505",
              "name": "HBR505",
              "subcategories": []
            },
            {
              "id": "drills-piling-hutte-bohrtechnik-hbr605",
              "name": "HBR605",
              "subcategories": []
            },
            {
              "id": "drills-piling-hutte-bohrtechnik-hbr610",
              "name": "HBR610",
              "subcategories": []
            },
            {
              "id": "drills-piling-hutte-bohrtechnik-other",
              "name": "OTHER",
              "subcategories": []
            }
          ]
        },
        {
          "id": "drills-piling-klemm",
          "name": "Klemm",
          "subcategories": [
            {
              "id": "drills-piling-klemm-kr702",
              "name": "KR702",
              "subcategories": []
            },
            {
              "id": "drills-piling-klemm-kr707",
              "name": "KR707",
              "subcategories": []
            },
            {
              "id": "drills-piling-klemm-kr708",
              "name": "KR708",
              "subcategories": []
            },
            {
              "id": "drills-piling-klemm-kr709",
              "name": "KR709",
              "subcategories": []
            },
            {
              "id": "drills-piling-klemm-kr802",
              "name": "KR802",
              "subcategories": []
            },
            {
              "id": "drills-piling-klemm-kr803",
              "name": "KR803",
              "subcategories": []
            },
            {
              "id": "drills-piling-klemm-kr805",
              "name": "KR805",
              "subcategories": []
            },
            {
              "id": "drills-piling-klemm-kr806",
              "name": "KR806",
              "subcategories": []
            },
            {
              "id": "drills-piling-klemm-kr807",
              "name": "KR807",
              "subcategories": []
            },
            {
              "id": "drills-piling-klemm-other",
              "name": "OTHER",
              "subcategories": []
            }
          ]
        },
        {
          "id": "drills-piling-liebherr",
          "name": "Liebherr",
          "subcategories": [
            {
              "id": "drills-piling-liebherr-lb16",
              "name": "LB16",
              "subcategories": []
            },
            {
              "id": "drills-piling-liebherr-lb28",
              "name": "LB28",
              "subcategories": []
            },
            {
              "id": "drills-piling-liebherr-lb36",
              "name": "LB36",
              "subcategories": []
            },
            {
              "id": "drills-piling-liebherr-lrb125",
              "name": "LRB125",
              "subcategories": []
            },
            {
              "id": "drills-piling-liebherr-lrb155",
              "name": "LRB155",
              "subcategories": []
            },
            {
              "id": "drills-piling-liebherr-lrb255",
              "name": "LRB255",
              "subcategories": []
            },
            {
              "id": "drills-piling-liebherr-lrh100",
              "name": "LRH100",
              "subcategories": []
            },
            {
              "id": "drills-piling-liebherr-other",
              "name": "OTHER",
              "subcategories": []
            }
          ]
        },
        {
          "id": "drills-piling-mait",
          "name": "Mait",
          "subcategories": [
            {
              "id": "drills-piling-mait-cfa24",
              "name": "CFA24",
              "subcategories": []
            },
            {
              "id": "drills-piling-mait-hr45",
              "name": "HR45",
              "subcategories": []
            },
            {
              "id": "drills-piling-mait-hr120",
              "name": "HR120",
              "subcategories": []
            },
            {
              "id": "drills-piling-mait-hr130",
              "name": "HR130",
              "subcategories": []
            },
            {
              "id": "drills-piling-mait-hr130",
              "name": "HR130",
              "subcategories": []
            },
            {
              "id": "drills-piling-mait-hr260",
              "name": "HR260",
              "subcategories": []
            },
            {
              "id": "drills-piling-mait-q2525",
              "name": "Q2525",
              "subcategories": []
            },
            {
              "id": "drills-piling-mait-other",
              "name": "OTHER",
              "subcategories": []
            }
          ]
        },
        {
          "id": "drills-piling-patriot",
          "name": "Patriot",
          "subcategories": [
            {
              "id": "drills-piling-patriot-p1",
              "name": "P1",
              "subcategories": []
            },
            {
              "id": "drills-piling-patriot-other",
              "name": "OTHER",
              "subcategories": []
            }
          ]
        },
        {
          "id": "drills-piling-reedill",
          "name": "Reedill",
          "subcategories": []
        },
        {
          "id": "drills-piling-schram",
          "name": "Schram",
          "subcategories": []
        },
        {
          "id": "drills-piling-tescar",
          "name": "Tescar",
          "subcategories": [
            {
              "id": "drills-piling-tescar-cf2-5",
              "name": "CF2.5",
              "subcategories": []
            },
            {
              "id": "drills-piling-tescar-cf2-5a",
              "name": "CF2.5A",
              "subcategories": []
            },
            {
              "id": "drills-piling-tescar-cf3",
              "name": "CF3",
              "subcategories": []
            },
            {
              "id": "drills-piling-tescar-cf3s",
              "name": "CF3S",
              "subcategories": []
            },
            {
              "id": "drills-piling-tescar-cf6",
              "name": "CF6",
              "subcategories": []
            },
            {
              "id": "drills-piling-tescar-other",
              "name": "OTHER",
              "subcategories": []
            }
          ]
        },
        {
          "id": "drills-piling-texoma",
          "name": "Texoma",
          "subcategories": [
            {
              "id": "drills-piling-texoma-270",
              "name": "270",
              "subcategories": []
            },
            {
              "id": "drills-piling-texoma-330",
              "name": "330",
              "subcategories": []
            },
            {
              "id": "drills-piling-texoma-800",
              "name": "800",
              "subcategories": []
            },
            {
              "id": "drills-piling-texoma-900",
              "name": "900",
              "subcategories": []
            },
            {
              "id": "drills-piling-texoma-taurus-xlt",
              "name": "TAURUS XLT",
              "subcategories": []
            },
            {
              "id": "drills-piling-texoma-other",
              "name": "OTHER",
              "subcategories": []
            }
          ]
        },
        {
          "id": "drills-piling-watson",
          "name": "Watson",
          "subcategories": [
            {
              "id": "drills-piling-watson-1100tm",
              "name": "1100TM",
              "subcategories": []
            },
            {
              "id": "drills-piling-watson-2000",
              "name": "2000",
              "subcategories": []
            },
            {
              "id": "drills-piling-watson-2200tm",
              "name": "2200TM",
              "subcategories": []
            },
            {
              "id": "drills-piling-watson-2500",
              "name": "2500",
              "subcategories": []
            },
            {
              "id": "drills-piling-watson-3100",
              "name": "3100",
              "subcategories": []
            },
            {
              "id": "drills-piling-watson-4400",
              "name": "4400",
              "subcategories": []
            },
            {
              "id": "drills-piling-watson-other",
              "name": "OTHER",
              "subcategories": []
            }
          ]
        }
      ]
    },
    {
      "id": "dump-trucks-artic-rigid",
      "name": "Dump Trucks - Artic/Rigid",
      "subcategories": [
        {
          "id": "dump-trucks-artic-rigid-dump-trucks",
          "name": "Dump Trucks",
          "subcategories": [
            {
              "id": "dump-trucks-artic-rigid-dump-trucks-caterpillar",
              "name": "CATERPILLAR",
              "subcategories": []
            },
            {
              "id": "dump-trucks-artic-rigid-dump-trucks-volvo",
              "name": "VOLVO",
              "subcategories": []
            },
            {
              "id": "dump-trucks-artic-rigid-dump-trucks-bell",
              "name": "BELL",
              "subcategories": []
            },
            {
              "id": "dump-trucks-artic-rigid-dump-trucks-komatsu",
              "name": "KOMATSU",
              "subcategories": []
            },
            {
              "id": "dump-trucks-artic-rigid-dump-trucks-deere",
              "name": "DEERE",
              "subcategories": []
            },
            {
              "id": "dump-trucks-artic-rigid-dump-trucks-terex",
              "name": "TEREX",
              "subcategories": []
            },
            {
              "id": "dump-trucks-artic-rigid-dump-trucks-hydrema",
              "name": "HYDREMA",
              "subcategories": []
            },
            {
              "id": "dump-trucks-artic-rigid-dump-trucks-rokbak",
              "name": "ROKBAK",
              "subcategories": []
            },
            {
              "id": "dump-trucks-artic-rigid-dump-trucks-holmes",
              "name": "HOLMES",
              "subcategories": []
            },
            {
              "id": "dump-trucks-artic-rigid-dump-trucks-hyundai",
              "name": "HYUNDAI",
              "subcategories": []
            },
            {
              "id": "dump-trucks-artic-rigid-dump-trucks-develon",
              "name": "DEVELON",
              "subcategories": []
            },
            {
              "id": "dump-trucks-artic-rigid-dump-trucks-doosan",
              "name": "DOOSAN",
              "subcategories": []
            },
            {
              "id": "dump-trucks-artic-rigid-dump-trucks-euclid",
              "name": "EUCLID",
              "subcategories": []
            },
            {
              "id": "dump-trucks-artic-rigid-dump-trucks-hitachi",
              "name": "HITACHI",
              "subcategories": []
            },
            {
              "id": "dump-trucks-artic-rigid-dump-trucks-liebherr",
              "name": "LIEBHERR",
              "subcategories": []
            },
            {
              "id": "dump-trucks-artic-rigid-dump-trucks-moxy",
              "name": "MOXY",
              "subcategories": []
            },
            {
              "id": "dump-trucks-artic-rigid-dump-trucks-perlini",
              "name": "PERLINI",
              "subcategories": []
            },
            {
              "id": "dump-trucks-artic-rigid-dump-trucks-sandvik",
              "name": "SANDVIK",
              "subcategories": []
            },
            {
              "id": "dump-trucks-artic-rigid-dump-trucks-xcmg",
              "name": "XCMG",
              "subcategories": []
            }
          ]
        },
        {
          "id": "dump-trucks-artic-rigid-caterpillar",
          "name": "Caterpillar",
          "subcategories": [
            {
              "id": "dump-trucks-artic-rigid-caterpillar-725",
              "name": "725",
              "subcategories": []
            },
            {
              "id": "dump-trucks-artic-rigid-caterpillar-725c",
              "name": "725C",
              "subcategories": []
            },
            {
              "id": "dump-trucks-artic-rigid-caterpillar-725c2",
              "name": "725C2",
              "subcategories": []
            },
            {
              "id": "dump-trucks-artic-rigid-caterpillar-730",
              "name": "730",
              "subcategories": []
            },
            {
              "id": "dump-trucks-artic-rigid-caterpillar-730ej",
              "name": "730EJ",
              "subcategories": []
            },
            {
              "id": "dump-trucks-artic-rigid-caterpillar-730c",
              "name": "730C",
              "subcategories": []
            },
            {
              "id": "dump-trucks-artic-rigid-caterpillar-730c2",
              "name": "730C2",
              "subcategories": []
            },
            {
              "id": "dump-trucks-artic-rigid-caterpillar-735",
              "name": "735",
              "subcategories": []
            },
            {
              "id": "dump-trucks-artic-rigid-caterpillar-735b",
              "name": "735B",
              "subcategories": []
            },
            {
              "id": "dump-trucks-artic-rigid-caterpillar-735c",
              "name": "735C",
              "subcategories": []
            },
            {
              "id": "dump-trucks-artic-rigid-caterpillar-740",
              "name": "740",
              "subcategories": []
            },
            {
              "id": "dump-trucks-artic-rigid-caterpillar-740ej",
              "name": "740EJ",
              "subcategories": []
            },
            {
              "id": "dump-trucks-artic-rigid-caterpillar-740-gc",
              "name": "740 GC",
              "subcategories": []
            },
            {
              "id": "dump-trucks-artic-rigid-caterpillar-740b",
              "name": "740B",
              "subcategories": []
            },
            {
              "id": "dump-trucks-artic-rigid-caterpillar-740b-ej",
              "name": "740B EJ",
              "subcategories": []
            },
            {
              "id": "dump-trucks-artic-rigid-caterpillar-740c-ej",
              "name": "740C EJ",
              "subcategories": []
            },
            {
              "id": "dump-trucks-artic-rigid-caterpillar-745",
              "name": "745",
              "subcategories": []
            },
            {
              "id": "dump-trucks-artic-rigid-caterpillar-745c",
              "name": "745C",
              "subcategories": []
            },
            {
              "id": "dump-trucks-artic-rigid-caterpillar-769",
              "name": "769",
              "subcategories": []
            },
            {
              "id": "dump-trucks-artic-rigid-caterpillar-769b",
              "name": "769B",
              "subcategories": []
            },
            {
              "id": "dump-trucks-artic-rigid-caterpillar-769c",
              "name": "769C",
              "subcategories": []
            },
            {
              "id": "dump-trucks-artic-rigid-caterpillar-769d",
              "name": "769D",
              "subcategories": []
            },
            {
              "id": "dump-trucks-artic-rigid-caterpillar-770",
              "name": "770",
              "subcategories": []
            },
            {
              "id": "dump-trucks-artic-rigid-caterpillar-770g",
              "name": "770G",
              "subcategories": []
            },
            {
              "id": "dump-trucks-artic-rigid-caterpillar-771",
              "name": "771",
              "subcategories": []
            },
            {
              "id": "dump-trucks-artic-rigid-caterpillar-771d",
              "name": "771D",
              "subcategories": []
            },
            {
              "id": "dump-trucks-artic-rigid-caterpillar-772",
              "name": "772",
              "subcategories": []
            },
            {
              "id": "dump-trucks-artic-rigid-caterpillar-772g",
              "name": "772G",
              "subcategories": []
            },
            {
              "id": "dump-trucks-artic-rigid-caterpillar-773",
              "name": "773",
              "subcategories": []
            },
            {
              "id": "dump-trucks-artic-rigid-caterpillar-773a",
              "name": "773A",
              "subcategories": []
            },
            {
              "id": "dump-trucks-artic-rigid-caterpillar-773b",
              "name": "773B",
              "subcategories": []
            },
            {
              "id": "dump-trucks-artic-rigid-caterpillar-773d",
              "name": "773D",
              "subcategories": []
            },
            {
              "id": "dump-trucks-artic-rigid-caterpillar-773e",
              "name": "773E",
              "subcategories": []
            },
            {
              "id": "dump-trucks-artic-rigid-caterpillar-773f",
              "name": "773F",
              "subcategories": []
            },
            {
              "id": "dump-trucks-artic-rigid-caterpillar-773g",
              "name": "773G",
              "subcategories": []
            },
            {
              "id": "dump-trucks-artic-rigid-caterpillar-775",
              "name": "775",
              "subcategories": []
            },
            {
              "id": "dump-trucks-artic-rigid-caterpillar-775d",
              "name": "775D",
              "subcategories": []
            },
            {
              "id": "dump-trucks-artic-rigid-caterpillar-775e",
              "name": "775E",
              "subcategories": []
            },
            {
              "id": "dump-trucks-artic-rigid-caterpillar-775f",
              "name": "775F",
              "subcategories": []
            },
            {
              "id": "dump-trucks-artic-rigid-caterpillar-775g",
              "name": "775G",
              "subcategories": []
            },
            {
              "id": "dump-trucks-artic-rigid-caterpillar-777",
              "name": "777",
              "subcategories": []
            },
            {
              "id": "dump-trucks-artic-rigid-caterpillar-777a",
              "name": "777A",
              "subcategories": []
            },
            {
              "id": "dump-trucks-artic-rigid-caterpillar-777b",
              "name": "777B",
              "subcategories": []
            },
            {
              "id": "dump-trucks-artic-rigid-caterpillar-777c",
              "name": "777C",
              "subcategories": []
            },
            {
              "id": "dump-trucks-artic-rigid-caterpillar-777d",
              "name": "777D",
              "subcategories": []
            },
            {
              "id": "dump-trucks-artic-rigid-caterpillar-777e",
              "name": "777E",
              "subcategories": []
            },
            {
              "id": "dump-trucks-artic-rigid-caterpillar-777f",
              "name": "777F",
              "subcategories": []
            },
            {
              "id": "dump-trucks-artic-rigid-caterpillar-777g",
              "name": "777G",
              "subcategories": []
            },
            {
              "id": "dump-trucks-artic-rigid-caterpillar-784",
              "name": "784",
              "subcategories": []
            },
            {
              "id": "dump-trucks-artic-rigid-caterpillar-784b",
              "name": "784B",
              "subcategories": []
            },
            {
              "id": "dump-trucks-artic-rigid-caterpillar-785",
              "name": "785",
              "subcategories": []
            },
            {
              "id": "dump-trucks-artic-rigid-caterpillar-785a",
              "name": "785A",
              "subcategories": []
            },
            {
              "id": "dump-trucks-artic-rigid-caterpillar-785b",
              "name": "785B",
              "subcategories": []
            },
            {
              "id": "dump-trucks-artic-rigid-caterpillar-785c",
              "name": "785C",
              "subcategories": []
            },
            {
              "id": "dump-trucks-artic-rigid-caterpillar-785d",
              "name": "785D",
              "subcategories": []
            },
            {
              "id": "dump-trucks-artic-rigid-caterpillar-789",
              "name": "789",
              "subcategories": []
            },
            {
              "id": "dump-trucks-artic-rigid-caterpillar-789a",
              "name": "789A",
              "subcategories": []
            },
            {
              "id": "dump-trucks-artic-rigid-caterpillar-789b",
              "name": "789B",
              "subcategories": []
            },
            {
              "id": "dump-trucks-artic-rigid-caterpillar-789c",
              "name": "789C",
              "subcategories": []
            },
            {
              "id": "dump-trucks-artic-rigid-caterpillar-789d",
              "name": "789D",
              "subcategories": []
            },
            {
              "id": "dump-trucks-artic-rigid-caterpillar-793",
              "name": "793",
              "subcategories": []
            },
            {
              "id": "dump-trucks-artic-rigid-caterpillar-793c",
              "name": "793C",
              "subcategories": []
            },
            {
              "id": "dump-trucks-artic-rigid-caterpillar-793d",
              "name": "793D",
              "subcategories": []
            },
            {
              "id": "dump-trucks-artic-rigid-caterpillar-793f",
              "name": "793F",
              "subcategories": []
            },
            {
              "id": "dump-trucks-artic-rigid-caterpillar-ad30",
              "name": "AD30",
              "subcategories": []
            },
            {
              "id": "dump-trucks-artic-rigid-caterpillar-ad45",
              "name": "AD45",
              "subcategories": []
            },
            {
              "id": "dump-trucks-artic-rigid-caterpillar-ad45b",
              "name": "AD45B",
              "subcategories": []
            },
            {
              "id": "dump-trucks-artic-rigid-caterpillar-ad55",
              "name": "AD55",
              "subcategories": []
            },
            {
              "id": "dump-trucks-artic-rigid-caterpillar-ad55b",
              "name": "AD55B",
              "subcategories": []
            },
            {
              "id": "dump-trucks-artic-rigid-caterpillar-ad60",
              "name": "AD60",
              "subcategories": []
            },
            {
              "id": "dump-trucks-artic-rigid-caterpillar-ae40",
              "name": "AE40",
              "subcategories": []
            },
            {
              "id": "dump-trucks-artic-rigid-caterpillar-ae40-ii",
              "name": "AE40 II",
              "subcategories": []
            },
            {
              "id": "dump-trucks-artic-rigid-caterpillar-d25",
              "name": "D25",
              "subcategories": []
            },
            {
              "id": "dump-trucks-artic-rigid-caterpillar-d25c",
              "name": "D25C",
              "subcategories": []
            },
            {
              "id": "dump-trucks-artic-rigid-caterpillar-d25d",
              "name": "D25D",
              "subcategories": []
            },
            {
              "id": "dump-trucks-artic-rigid-caterpillar-d30",
              "name": "D30",
              "subcategories": []
            },
            {
              "id": "dump-trucks-artic-rigid-caterpillar-d30d",
              "name": "D30D",
              "subcategories": []
            },
            {
              "id": "dump-trucks-artic-rigid-caterpillar-d35",
              "name": "D35",
              "subcategories": []
            },
            {
              "id": "dump-trucks-artic-rigid-caterpillar-d35",
              "name": "D35",
              "subcategories": []
            },
            {
              "id": "dump-trucks-artic-rigid-caterpillar-d35c",
              "name": "D35C",
              "subcategories": []
            },
            {
              "id": "dump-trucks-artic-rigid-caterpillar-d250d",
              "name": "D250D",
              "subcategories": []
            },
            {
              "id": "dump-trucks-artic-rigid-caterpillar-d250e",
              "name": "D250E",
              "subcategories": []
            },
            {
              "id": "dump-trucks-artic-rigid-caterpillar-d250e-ii",
              "name": "D250E II",
              "subcategories": []
            },
            {
              "id": "dump-trucks-artic-rigid-caterpillar-d300",
              "name": "D300",
              "subcategories": []
            },
            {
              "id": "dump-trucks-artic-rigid-caterpillar-d300b",
              "name": "D300B",
              "subcategories": []
            },
            {
              "id": "dump-trucks-artic-rigid-caterpillar-d300e",
              "name": "D300E",
              "subcategories": []
            },
            {
              "id": "dump-trucks-artic-rigid-caterpillar-d350d",
              "name": "D350D",
              "subcategories": []
            },
            {
              "id": "dump-trucks-artic-rigid-caterpillar-d350e",
              "name": "D350E",
              "subcategories": []
            },
            {
              "id": "dump-trucks-artic-rigid-caterpillar-d350e-ii",
              "name": "D350E II",
              "subcategories": []
            },
            {
              "id": "dump-trucks-artic-rigid-caterpillar-d400",
              "name": "D400",
              "subcategories": []
            },
            {
              "id": "dump-trucks-artic-rigid-caterpillar-d400d",
              "name": "D400D",
              "subcategories": []
            },
            {
              "id": "dump-trucks-artic-rigid-caterpillar-d400e",
              "name": "D400E",
              "subcategories": []
            },
            {
              "id": "dump-trucks-artic-rigid-caterpillar-d400e-ii",
              "name": "D400E II",
              "subcategories": []
            },
            {
              "id": "dump-trucks-artic-rigid-caterpillar-other",
              "name": "OTHER",
              "subcategories": []
            }
          ]
        },
        {
          "id": "dump-trucks-artic-rigid-volvo",
          "name": "Volvo",
          "subcategories": [
            {
              "id": "dump-trucks-artic-rigid-volvo-540",
              "name": "540",
              "subcategories": []
            },
            {
              "id": "dump-trucks-artic-rigid-volvo-861",
              "name": "861",
              "subcategories": []
            },
            {
              "id": "dump-trucks-artic-rigid-volvo-a20",
              "name": "A20",
              "subcategories": []
            },
            {
              "id": "dump-trucks-artic-rigid-volvo-a20c",
              "name": "A20C",
              "subcategories": []
            },
            {
              "id": "dump-trucks-artic-rigid-volvo-a25",
              "name": "A25",
              "subcategories": []
            },
            {
              "id": "dump-trucks-artic-rigid-volvo-a25b",
              "name": "A25B",
              "subcategories": []
            },
            {
              "id": "dump-trucks-artic-rigid-volvo-a25c",
              "name": "A25C",
              "subcategories": []
            },
            {
              "id": "dump-trucks-artic-rigid-volvo-a25d",
              "name": "A25D",
              "subcategories": []
            },
            {
              "id": "dump-trucks-artic-rigid-volvo-a25e",
              "name": "A25E",
              "subcategories": []
            },
            {
              "id": "dump-trucks-artic-rigid-volvo-a25f",
              "name": "A25F",
              "subcategories": []
            },
            {
              "id": "dump-trucks-artic-rigid-volvo-a25g",
              "name": "A25G",
              "subcategories": []
            },
            {
              "id": "dump-trucks-artic-rigid-volvo-a30",
              "name": "A30",
              "subcategories": []
            },
            {
              "id": "dump-trucks-artic-rigid-volvo-a30b",
              "name": "A30B",
              "subcategories": []
            },
            {
              "id": "dump-trucks-artic-rigid-volvo-a30c",
              "name": "A30C",
              "subcategories": []
            },
            {
              "id": "dump-trucks-artic-rigid-volvo-a30d",
              "name": "A30D",
              "subcategories": []
            },
            {
              "id": "dump-trucks-artic-rigid-volvo-a30e",
              "name": "A30E",
              "subcategories": []
            },
            {
              "id": "dump-trucks-artic-rigid-volvo-a30f",
              "name": "A30F",
              "subcategories": []
            },
            {
              "id": "dump-trucks-artic-rigid-volvo-a30g",
              "name": "A30G",
              "subcategories": []
            },
            {
              "id": "dump-trucks-artic-rigid-volvo-a30j",
              "name": "A30J",
              "subcategories": []
            },
            {
              "id": "dump-trucks-artic-rigid-volvo-a35",
              "name": "A35",
              "subcategories": []
            },
            {
              "id": "dump-trucks-artic-rigid-volvo-a35c",
              "name": "A35C",
              "subcategories": []
            },
            {
              "id": "dump-trucks-artic-rigid-volvo-a35d",
              "name": "A35D",
              "subcategories": []
            },
            {
              "id": "dump-trucks-artic-rigid-volvo-a35e",
              "name": "A35E",
              "subcategories": []
            },
            {
              "id": "dump-trucks-artic-rigid-volvo-a35e-fs",
              "name": "A35E FS",
              "subcategories": []
            },
            {
              "id": "dump-trucks-artic-rigid-volvo-a35f",
              "name": "A35F",
              "subcategories": []
            },
            {
              "id": "dump-trucks-artic-rigid-volvo-a35g",
              "name": "A35G",
              "subcategories": []
            },
            {
              "id": "dump-trucks-artic-rigid-volvo-a40",
              "name": "A40",
              "subcategories": []
            },
            {
              "id": "dump-trucks-artic-rigid-volvo-a40c",
              "name": "A40C",
              "subcategories": []
            },
            {
              "id": "dump-trucks-artic-rigid-volvo-a40d",
              "name": "A40D",
              "subcategories": []
            },
            {
              "id": "dump-trucks-artic-rigid-volvo-a40e",
              "name": "A40E",
              "subcategories": []
            },
            {
              "id": "dump-trucks-artic-rigid-volvo-a40f",
              "name": "A40F",
              "subcategories": []
            },
            {
              "id": "dump-trucks-artic-rigid-volvo-a40g",
              "name": "A40G",
              "subcategories": []
            },
            {
              "id": "dump-trucks-artic-rigid-volvo-a40g-fs",
              "name": "A40G FS",
              "subcategories": []
            },
            {
              "id": "dump-trucks-artic-rigid-volvo-a40j",
              "name": "A40J",
              "subcategories": []
            },
            {
              "id": "dump-trucks-artic-rigid-volvo-a45g",
              "name": "A45G",
              "subcategories": []
            },
            {
              "id": "dump-trucks-artic-rigid-volvo-a45g-fs",
              "name": "A45G FS",
              "subcategories": []
            },
            {
              "id": "dump-trucks-artic-rigid-volvo-a45j",
              "name": "A45J",
              "subcategories": []
            },
            {
              "id": "dump-trucks-artic-rigid-volvo-a50",
              "name": "A50",
              "subcategories": []
            },
            {
              "id": "dump-trucks-artic-rigid-volvo-a60",
              "name": "A60",
              "subcategories": []
            },
            {
              "id": "dump-trucks-artic-rigid-volvo-a60h",
              "name": "A60H",
              "subcategories": []
            },
            {
              "id": "dump-trucks-artic-rigid-volvo-r60",
              "name": "R60",
              "subcategories": []
            },
            {
              "id": "dump-trucks-artic-rigid-volvo-r60d",
              "name": "R60D",
              "subcategories": []
            },
            {
              "id": "dump-trucks-artic-rigid-volvo-r100e",
              "name": "R100E",
              "subcategories": []
            },
            {
              "id": "dump-trucks-artic-rigid-volvo-t450",
              "name": "T450",
              "subcategories": []
            },
            {
              "id": "dump-trucks-artic-rigid-volvo-t450d",
              "name": "T450D",
              "subcategories": []
            },
            {
              "id": "dump-trucks-artic-rigid-volvo-other",
              "name": "OTHER",
              "subcategories": []
            }
          ]
        },
        {
          "id": "dump-trucks-artic-rigid-bell",
          "name": "Bell",
          "subcategories": [
            {
              "id": "dump-trucks-artic-rigid-bell-b16b",
              "name": "B16B",
              "subcategories": []
            },
            {
              "id": "dump-trucks-artic-rigid-bell-b17",
              "name": "B17",
              "subcategories": []
            },
            {
              "id": "dump-trucks-artic-rigid-bell-b18d",
              "name": "B18D",
              "subcategories": []
            },
            {
              "id": "dump-trucks-artic-rigid-bell-b18e",
              "name": "B18E",
              "subcategories": []
            },
            {
              "id": "dump-trucks-artic-rigid-bell-b20d",
              "name": "B20D",
              "subcategories": []
            },
            {
              "id": "dump-trucks-artic-rigid-bell-b20e",
              "name": "B20E",
              "subcategories": []
            },
            {
              "id": "dump-trucks-artic-rigid-bell-b25b",
              "name": "B25B",
              "subcategories": []
            },
            {
              "id": "dump-trucks-artic-rigid-bell-b25c",
              "name": "B25C",
              "subcategories": []
            },
            {
              "id": "dump-trucks-artic-rigid-bell-b25d",
              "name": "B25D",
              "subcategories": []
            },
            {
              "id": "dump-trucks-artic-rigid-bell-b25e",
              "name": "B25E",
              "subcategories": []
            },
            {
              "id": "dump-trucks-artic-rigid-bell-b30",
              "name": "B30",
              "subcategories": []
            },
            {
              "id": "dump-trucks-artic-rigid-bell-b30d",
              "name": "B30D",
              "subcategories": []
            },
            {
              "id": "dump-trucks-artic-rigid-bell-b30e",
              "name": "B30E",
              "subcategories": []
            },
            {
              "id": "dump-trucks-artic-rigid-bell-b35d",
              "name": "B35D",
              "subcategories": []
            },
            {
              "id": "dump-trucks-artic-rigid-bell-b40",
              "name": "B40",
              "subcategories": []
            },
            {
              "id": "dump-trucks-artic-rigid-bell-b40d",
              "name": "B40D",
              "subcategories": []
            },
            {
              "id": "dump-trucks-artic-rigid-bell-b40e",
              "name": "B40E",
              "subcategories": []
            },
            {
              "id": "dump-trucks-artic-rigid-bell-b45d",
              "name": "B45D",
              "subcategories": []
            },
            {
              "id": "dump-trucks-artic-rigid-bell-b45e",
              "name": "B45E",
              "subcategories": []
            },
            {
              "id": "dump-trucks-artic-rigid-bell-b50d",
              "name": "B50D",
              "subcategories": []
            },
            {
              "id": "dump-trucks-artic-rigid-bell-b50e",
              "name": "B50E",
              "subcategories": []
            },
            {
              "id": "dump-trucks-artic-rigid-bell-b60e",
              "name": "B60E",
              "subcategories": []
            },
            {
              "id": "dump-trucks-artic-rigid-bell-other",
              "name": "OTHER",
              "subcategories": []
            }
          ]
        },
        {
          "id": "dump-trucks-artic-rigid-komatsu",
          "name": "Komatsu",
          "subcategories": [
            {
              "id": "dump-trucks-artic-rigid-komatsu-210",
              "name": "210",
              "subcategories": []
            },
            {
              "id": "dump-trucks-artic-rigid-komatsu-630",
              "name": "630",
              "subcategories": []
            },
            {
              "id": "dump-trucks-artic-rigid-komatsu-630e",
              "name": "630E",
              "subcategories": []
            },
            {
              "id": "dump-trucks-artic-rigid-komatsu-730",
              "name": "730",
              "subcategories": []
            },
            {
              "id": "dump-trucks-artic-rigid-komatsu-730e",
              "name": "730E",
              "subcategories": []
            },
            {
              "id": "dump-trucks-artic-rigid-komatsu-730e-7",
              "name": "730E-7",
              "subcategories": []
            },
            {
              "id": "dump-trucks-artic-rigid-komatsu-830",
              "name": "830",
              "subcategories": []
            },
            {
              "id": "dump-trucks-artic-rigid-komatsu-830e",
              "name": "830E",
              "subcategories": []
            },
            {
              "id": "dump-trucks-artic-rigid-komatsu-830e-5",
              "name": "830E-5",
              "subcategories": []
            },
            {
              "id": "dump-trucks-artic-rigid-komatsu-930",
              "name": "930",
              "subcategories": []
            },
            {
              "id": "dump-trucks-artic-rigid-komatsu-930e",
              "name": "930E",
              "subcategories": []
            },
            {
              "id": "dump-trucks-artic-rigid-komatsu-930e-3",
              "name": "930E-3",
              "subcategories": []
            },
            {
              "id": "dump-trucks-artic-rigid-komatsu-930e-4",
              "name": "930E-4",
              "subcategories": []
            },
            {
              "id": "dump-trucks-artic-rigid-komatsu-930e-5",
              "name": "930E-5",
              "subcategories": []
            },
            {
              "id": "dump-trucks-artic-rigid-komatsu-ha270",
              "name": "HA270",
              "subcategories": []
            },
            {
              "id": "dump-trucks-artic-rigid-komatsu-ha270-3",
              "name": "HA270-3",
              "subcategories": []
            },
            {
              "id": "dump-trucks-artic-rigid-komatsu-hd325",
              "name": "HD325",
              "subcategories": []
            },
            {
              "id": "dump-trucks-artic-rigid-komatsu-hd325-5",
              "name": "HD325-5",
              "subcategories": []
            },
            {
              "id": "dump-trucks-artic-rigid-komatsu-hd325-6",
              "name": "HD325-6",
              "subcategories": []
            },
            {
              "id": "dump-trucks-artic-rigid-komatsu-hd325-7",
              "name": "HD325-7",
              "subcategories": []
            },
            {
              "id": "dump-trucks-artic-rigid-komatsu-hd325-8",
              "name": "HD325-8",
              "subcategories": []
            },
            {
              "id": "dump-trucks-artic-rigid-komatsu-hd405",
              "name": "HD405",
              "subcategories": []
            },
            {
              "id": "dump-trucks-artic-rigid-komatsu-hd405-6",
              "name": "HD405-6",
              "subcategories": []
            },
            {
              "id": "dump-trucks-artic-rigid-komatsu-hd405-7",
              "name": "HD405-7",
              "subcategories": []
            },
            {
              "id": "dump-trucks-artic-rigid-komatsu-hd405-8",
              "name": "HD405-8",
              "subcategories": []
            },
            {
              "id": "dump-trucks-artic-rigid-komatsu-hd465",
              "name": "HD465",
              "subcategories": []
            },
            {
              "id": "dump-trucks-artic-rigid-komatsu-hd465-5",
              "name": "HD465-5",
              "subcategories": []
            },
            {
              "id": "dump-trucks-artic-rigid-komatsu-hd465-7",
              "name": "HD465-7",
              "subcategories": []
            },
            {
              "id": "dump-trucks-artic-rigid-komatsu-hd465-7eo",
              "name": "HD465-7EO",
              "subcategories": []
            },
            {
              "id": "dump-trucks-artic-rigid-komatsu-hd465-7r",
              "name": "HD465-7R",
              "subcategories": []
            },
            {
              "id": "dump-trucks-artic-rigid-komatsu-hd605",
              "name": "HD605",
              "subcategories": []
            },
            {
              "id": "dump-trucks-artic-rigid-komatsu-hd605-5",
              "name": "HD605-5",
              "subcategories": []
            },
            {
              "id": "dump-trucks-artic-rigid-komatsu-hd605-7",
              "name": "HD605-7",
              "subcategories": []
            },
            {
              "id": "dump-trucks-artic-rigid-komatsu-hd785",
              "name": "HD785",
              "subcategories": []
            },
            {
              "id": "dump-trucks-artic-rigid-komatsu-hd785-3",
              "name": "HD785-3",
              "subcategories": []
            },
            {
              "id": "dump-trucks-artic-rigid-komatsu-hd785-5",
              "name": "HD785-5",
              "subcategories": []
            },
            {
              "id": "dump-trucks-artic-rigid-komatsu-hd785-7",
              "name": "HD785-7",
              "subcategories": []
            },
            {
              "id": "dump-trucks-artic-rigid-komatsu-hd985",
              "name": "HD985",
              "subcategories": []
            },
            {
              "id": "dump-trucks-artic-rigid-komatsu-hd985-3",
              "name": "HD985-3",
              "subcategories": []
            },
            {
              "id": "dump-trucks-artic-rigid-komatsu-hd1500",
              "name": "HD1500",
              "subcategories": []
            },
            {
              "id": "dump-trucks-artic-rigid-komatsu-hd1500-5",
              "name": "HD1500-5",
              "subcategories": []
            },
            {
              "id": "dump-trucks-artic-rigid-komatsu-hd1500-7",
              "name": "HD1500-7",
              "subcategories": []
            },
            {
              "id": "dump-trucks-artic-rigid-komatsu-hm300",
              "name": "HM300",
              "subcategories": []
            },
            {
              "id": "dump-trucks-artic-rigid-komatsu-hm300-1",
              "name": "HM300-1",
              "subcategories": []
            },
            {
              "id": "dump-trucks-artic-rigid-komatsu-hm300-1l",
              "name": "HM300-1L",
              "subcategories": []
            },
            {
              "id": "dump-trucks-artic-rigid-komatsu-hm300-2",
              "name": "HM300-2",
              "subcategories": []
            },
            {
              "id": "dump-trucks-artic-rigid-komatsu-hm300-3",
              "name": "HM300-3",
              "subcategories": []
            },
            {
              "id": "dump-trucks-artic-rigid-komatsu-hm300-5",
              "name": "HM300-5",
              "subcategories": []
            },
            {
              "id": "dump-trucks-artic-rigid-komatsu-hm300-5eo",
              "name": "HM300-5EO",
              "subcategories": []
            },
            {
              "id": "dump-trucks-artic-rigid-komatsu-hm350",
              "name": "HM350",
              "subcategories": []
            },
            {
              "id": "dump-trucks-artic-rigid-komatsu-hm350-1",
              "name": "HM350-1",
              "subcategories": []
            },
            {
              "id": "dump-trucks-artic-rigid-komatsu-hm350-2",
              "name": "HM350-2",
              "subcategories": []
            },
            {
              "id": "dump-trucks-artic-rigid-komatsu-hm400",
              "name": "HM400",
              "subcategories": []
            },
            {
              "id": "dump-trucks-artic-rigid-komatsu-hm400-1",
              "name": "HM400-1",
              "subcategories": []
            },
            {
              "id": "dump-trucks-artic-rigid-komatsu-hm400-1l",
              "name": "HM400-1L",
              "subcategories": []
            },
            {
              "id": "dump-trucks-artic-rigid-komatsu-hm400-2",
              "name": "HM400-2",
              "subcategories": []
            },
            {
              "id": "dump-trucks-artic-rigid-komatsu-hm400-3",
              "name": "HM400-3",
              "subcategories": []
            },
            {
              "id": "dump-trucks-artic-rigid-komatsu-hm400-3m0",
              "name": "HM400-3M0",
              "subcategories": []
            },
            {
              "id": "dump-trucks-artic-rigid-komatsu-hm400-3r",
              "name": "HM400-3R",
              "subcategories": []
            },
            {
              "id": "dump-trucks-artic-rigid-komatsu-hm400-5",
              "name": "HM400-5",
              "subcategories": []
            },
            {
              "id": "dump-trucks-artic-rigid-komatsu-other",
              "name": "OTHER",
              "subcategories": []
            }
          ]
        },
        {
          "id": "dump-trucks-artic-rigid-deere",
          "name": "Deere",
          "subcategories": [
            {
              "id": "dump-trucks-artic-rigid-deere-250",
              "name": "250",
              "subcategories": []
            },
            {
              "id": "dump-trucks-artic-rigid-deere-250d",
              "name": "250D",
              "subcategories": []
            },
            {
              "id": "dump-trucks-artic-rigid-deere-250d-ii",
              "name": "250D II",
              "subcategories": []
            },
            {
              "id": "dump-trucks-artic-rigid-deere-260",
              "name": "260",
              "subcategories": []
            },
            {
              "id": "dump-trucks-artic-rigid-deere-260p",
              "name": "260P",
              "subcategories": []
            },
            {
              "id": "dump-trucks-artic-rigid-deere-260e",
              "name": "260E",
              "subcategories": []
            },
            {
              "id": "dump-trucks-artic-rigid-deere-300",
              "name": "300",
              "subcategories": []
            },
            {
              "id": "dump-trucks-artic-rigid-deere-300d",
              "name": "300D",
              "subcategories": []
            },
            {
              "id": "dump-trucks-artic-rigid-deere-300d-ii",
              "name": "300D II",
              "subcategories": []
            },
            {
              "id": "dump-trucks-artic-rigid-deere-310",
              "name": "310",
              "subcategories": []
            },
            {
              "id": "dump-trucks-artic-rigid-deere-310p",
              "name": "310P",
              "subcategories": []
            },
            {
              "id": "dump-trucks-artic-rigid-deere-310e",
              "name": "310E",
              "subcategories": []
            },
            {
              "id": "dump-trucks-artic-rigid-deere-350",
              "name": "350",
              "subcategories": []
            },
            {
              "id": "dump-trucks-artic-rigid-deere-350d",
              "name": "350D",
              "subcategories": []
            },
            {
              "id": "dump-trucks-artic-rigid-deere-370",
              "name": "370",
              "subcategories": []
            },
            {
              "id": "dump-trucks-artic-rigid-deere-370e",
              "name": "370E",
              "subcategories": []
            },
            {
              "id": "dump-trucks-artic-rigid-deere-400",
              "name": "400",
              "subcategories": []
            },
            {
              "id": "dump-trucks-artic-rigid-deere-400d",
              "name": "400D",
              "subcategories": []
            },
            {
              "id": "dump-trucks-artic-rigid-deere-410",
              "name": "410",
              "subcategories": []
            },
            {
              "id": "dump-trucks-artic-rigid-deere-410p",
              "name": "410P",
              "subcategories": []
            },
            {
              "id": "dump-trucks-artic-rigid-deere-410e",
              "name": "410E",
              "subcategories": []
            },
            {
              "id": "dump-trucks-artic-rigid-deere-410e-ii",
              "name": "410E II",
              "subcategories": []
            },
            {
              "id": "dump-trucks-artic-rigid-deere-460",
              "name": "460",
              "subcategories": []
            },
            {
              "id": "dump-trucks-artic-rigid-deere-460p",
              "name": "460P",
              "subcategories": []
            },
            {
              "id": "dump-trucks-artic-rigid-deere-460e",
              "name": "460E",
              "subcategories": []
            },
            {
              "id": "dump-trucks-artic-rigid-deere-460e-ii",
              "name": "460E II",
              "subcategories": []
            },
            {
              "id": "dump-trucks-artic-rigid-deere-460et",
              "name": "460ET",
              "subcategories": []
            },
            {
              "id": "dump-trucks-artic-rigid-deere-other",
              "name": "OTHER",
              "subcategories": []
            }
          ]
        },
        {
          "id": "dump-trucks-artic-rigid-terex",
          "name": "Terex",
          "subcategories": [
            {
              "id": "dump-trucks-artic-rigid-terex-2364",
              "name": "2364",
              "subcategories": []
            },
            {
              "id": "dump-trucks-artic-rigid-terex-2366",
              "name": "2366",
              "subcategories": []
            },
            {
              "id": "dump-trucks-artic-rigid-terex-2566",
              "name": "2566",
              "subcategories": []
            },
            {
              "id": "dump-trucks-artic-rigid-terex-2566b",
              "name": "2566B",
              "subcategories": []
            },
            {
              "id": "dump-trucks-artic-rigid-terex-2566c",
              "name": "2566C",
              "subcategories": []
            },
            {
              "id": "dump-trucks-artic-rigid-terex-2766",
              "name": "2766",
              "subcategories": []
            },
            {
              "id": "dump-trucks-artic-rigid-terex-2766c",
              "name": "2766C",
              "subcategories": []
            },
            {
              "id": "dump-trucks-artic-rigid-terex-3305",
              "name": "3305",
              "subcategories": []
            },
            {
              "id": "dump-trucks-artic-rigid-terex-3305f",
              "name": "3305F",
              "subcategories": []
            },
            {
              "id": "dump-trucks-artic-rigid-terex-3307",
              "name": "3307",
              "subcategories": []
            },
            {
              "id": "dump-trucks-artic-rigid-terex-3308",
              "name": "3308",
              "subcategories": []
            },
            {
              "id": "dump-trucks-artic-rigid-terex-3308e",
              "name": "3308E",
              "subcategories": []
            },
            {
              "id": "dump-trucks-artic-rigid-terex-3310",
              "name": "3310",
              "subcategories": []
            },
            {
              "id": "dump-trucks-artic-rigid-terex-3310e",
              "name": "3310E",
              "subcategories": []
            },
            {
              "id": "dump-trucks-artic-rigid-terex-3340",
              "name": "3340",
              "subcategories": []
            },
            {
              "id": "dump-trucks-artic-rigid-terex-3345",
              "name": "3345",
              "subcategories": []
            },
            {
              "id": "dump-trucks-artic-rigid-terex-4066",
              "name": "4066",
              "subcategories": []
            },
            {
              "id": "dump-trucks-artic-rigid-terex-4066c",
              "name": "4066C",
              "subcategories": []
            },
            {
              "id": "dump-trucks-artic-rigid-terex-mt3300",
              "name": "MT3300",
              "subcategories": []
            },
            {
              "id": "dump-trucks-artic-rigid-terex-mt330ac",
              "name": "MT330AC",
              "subcategories": []
            },
            {
              "id": "dump-trucks-artic-rigid-terex-mt4400",
              "name": "MT4400",
              "subcategories": []
            },
            {
              "id": "dump-trucks-artic-rigid-terex-mt4400ac",
              "name": "MT4400AC",
              "subcategories": []
            },
            {
              "id": "dump-trucks-artic-rigid-terex-ta25",
              "name": "TA25",
              "subcategories": []
            },
            {
              "id": "dump-trucks-artic-rigid-terex-ta27",
              "name": "TA27",
              "subcategories": []
            },
            {
              "id": "dump-trucks-artic-rigid-terex-ta30",
              "name": "TA30",
              "subcategories": []
            },
            {
              "id": "dump-trucks-artic-rigid-terex-ta40",
              "name": "TA40",
              "subcategories": []
            },
            {
              "id": "dump-trucks-artic-rigid-terex-ta300",
              "name": "TA300",
              "subcategories": []
            },
            {
              "id": "dump-trucks-artic-rigid-terex-ta400",
              "name": "TA400",
              "subcategories": []
            },
            {
              "id": "dump-trucks-artic-rigid-terex-tr45",
              "name": "TR45",
              "subcategories": []
            },
            {
              "id": "dump-trucks-artic-rigid-terex-tr50",
              "name": "TR50",
              "subcategories": []
            },
            {
              "id": "dump-trucks-artic-rigid-terex-tr60",
              "name": "TR60",
              "subcategories": []
            },
            {
              "id": "dump-trucks-artic-rigid-terex-tr70",
              "name": "TR70",
              "subcategories": []
            },
            {
              "id": "dump-trucks-artic-rigid-terex-tr100",
              "name": "TR100",
              "subcategories": []
            },
            {
              "id": "dump-trucks-artic-rigid-terex-other",
              "name": "OTHER",
              "subcategories": []
            }
          ]
        },
        {
          "id": "dump-trucks-artic-rigid-hydrema",
          "name": "Hydrema",
          "subcategories": [
            {
              "id": "dump-trucks-artic-rigid-hydrema-910",
              "name": "910",
              "subcategories": []
            },
            {
              "id": "dump-trucks-artic-rigid-hydrema-912",
              "name": "912",
              "subcategories": []
            },
            {
              "id": "dump-trucks-artic-rigid-hydrema-912c",
              "name": "912C",
              "subcategories": []
            },
            {
              "id": "dump-trucks-artic-rigid-hydrema-912d",
              "name": "912D",
              "subcategories": []
            },
            {
              "id": "dump-trucks-artic-rigid-hydrema-912ds",
              "name": "912DS",
              "subcategories": []
            },
            {
              "id": "dump-trucks-artic-rigid-hydrema-912e",
              "name": "912E",
              "subcategories": []
            },
            {
              "id": "dump-trucks-artic-rigid-hydrema-912es",
              "name": "912ES",
              "subcategories": []
            },
            {
              "id": "dump-trucks-artic-rigid-hydrema-912f",
              "name": "912F",
              "subcategories": []
            },
            {
              "id": "dump-trucks-artic-rigid-hydrema-912fs",
              "name": "912FS",
              "subcategories": []
            },
            {
              "id": "dump-trucks-artic-rigid-hydrema-912g",
              "name": "912G",
              "subcategories": []
            },
            {
              "id": "dump-trucks-artic-rigid-hydrema-912gs",
              "name": "912GS",
              "subcategories": []
            },
            {
              "id": "dump-trucks-artic-rigid-hydrema-920g",
              "name": "920G",
              "subcategories": []
            },
            {
              "id": "dump-trucks-artic-rigid-hydrema-922c",
              "name": "922C",
              "subcategories": []
            },
            {
              "id": "dump-trucks-artic-rigid-hydrema-922d",
              "name": "922D",
              "subcategories": []
            },
            {
              "id": "dump-trucks-artic-rigid-hydrema-922f",
              "name": "922F",
              "subcategories": []
            },
            {
              "id": "dump-trucks-artic-rigid-hydrema-922g",
              "name": "922G",
              "subcategories": []
            },
            {
              "id": "dump-trucks-artic-rigid-hydrema-922hm",
              "name": "922HM",
              "subcategories": []
            },
            {
              "id": "dump-trucks-artic-rigid-hydrema-dt6",
              "name": "DT6",
              "subcategories": []
            },
            {
              "id": "dump-trucks-artic-rigid-hydrema-other",
              "name": "OTHER",
              "subcategories": []
            }
          ]
        },
        {
          "id": "dump-trucks-artic-rigid-rokbak",
          "name": "Rokbak",
          "subcategories": [
            {
              "id": "dump-trucks-artic-rigid-rokbak-ra30",
              "name": "RA30",
              "subcategories": []
            },
            {
              "id": "dump-trucks-artic-rigid-rokbak-ra40",
              "name": "RA40",
              "subcategories": []
            },
            {
              "id": "dump-trucks-artic-rigid-rokbak-other",
              "name": "OTHER",
              "subcategories": []
            }
          ]
        },
        {
          "id": "dump-trucks-artic-rigid-holmes",
          "name": "Holmes",
          "subcategories": [
            {
              "id": "dump-trucks-artic-rigid-holmes-25t",
              "name": "25T",
              "subcategories": []
            },
            {
              "id": "dump-trucks-artic-rigid-holmes-27t",
              "name": "27T",
              "subcategories": []
            },
            {
              "id": "dump-trucks-artic-rigid-holmes-30t",
              "name": "30T",
              "subcategories": []
            },
            {
              "id": "dump-trucks-artic-rigid-holmes-35t",
              "name": "35T",
              "subcategories": []
            },
            {
              "id": "dump-trucks-artic-rigid-holmes-40t",
              "name": "40T",
              "subcategories": []
            },
            {
              "id": "dump-trucks-artic-rigid-holmes-tundra-lgp",
              "name": "TUNDRA LGP",
              "subcategories": []
            },
            {
              "id": "dump-trucks-artic-rigid-holmes-45tx-lgp",
              "name": "45TX LGP",
              "subcategories": []
            },
            {
              "id": "dump-trucks-artic-rigid-holmes-other",
              "name": "OTHER",
              "subcategories": []
            }
          ]
        },
        {
          "id": "dump-trucks-artic-rigid-hyundai",
          "name": "Hyundai",
          "subcategories": [
            {
              "id": "dump-trucks-artic-rigid-hyundai-ha30",
              "name": "HA30",
              "subcategories": []
            },
            {
              "id": "dump-trucks-artic-rigid-hyundai-ha45",
              "name": "HA45",
              "subcategories": []
            },
            {
              "id": "dump-trucks-artic-rigid-hyundai-other",
              "name": "OTHER",
              "subcategories": []
            }
          ]
        },
        {
          "id": "dump-trucks-artic-rigid-develon",
          "name": "Develon",
          "subcategories": [
            {
              "id": "dump-trucks-artic-rigid-develon-da30",
              "name": "DA30",
              "subcategories": []
            },
            {
              "id": "dump-trucks-artic-rigid-develon-da45",
              "name": "DA45",
              "subcategories": []
            },
            {
              "id": "dump-trucks-artic-rigid-develon-other",
              "name": "OTHER",
              "subcategories": []
            }
          ]
        },
        {
          "id": "dump-trucks-artic-rigid-doosan",
          "name": "Doosan",
          "subcategories": [
            {
              "id": "dump-trucks-artic-rigid-doosan-da30",
              "name": "DA30",
              "subcategories": []
            },
            {
              "id": "dump-trucks-artic-rigid-doosan-da40",
              "name": "DA40",
              "subcategories": []
            },
            {
              "id": "dump-trucks-artic-rigid-doosan-da45",
              "name": "DA45",
              "subcategories": []
            },
            {
              "id": "dump-trucks-artic-rigid-doosan-dt90",
              "name": "DT90",
              "subcategories": []
            },
            {
              "id": "dump-trucks-artic-rigid-doosan-other",
              "name": "OTHER",
              "subcategories": []
            }
          ]
        },
        {
          "id": "dump-trucks-artic-rigid-euclid",
          "name": "Euclid",
          "subcategories": [
            {
              "id": "dump-trucks-artic-rigid-euclid-301td",
              "name": "301TD",
              "subcategories": []
            },
            {
              "id": "dump-trucks-artic-rigid-euclid-301tdt",
              "name": "301TDT",
              "subcategories": []
            },
            {
              "id": "dump-trucks-artic-rigid-euclid-b30",
              "name": "B30",
              "subcategories": []
            },
            {
              "id": "dump-trucks-artic-rigid-euclid-r20",
              "name": "R20",
              "subcategories": []
            },
            {
              "id": "dump-trucks-artic-rigid-euclid-r30",
              "name": "R30",
              "subcategories": []
            },
            {
              "id": "dump-trucks-artic-rigid-euclid-r35",
              "name": "R35",
              "subcategories": []
            },
            {
              "id": "dump-trucks-artic-rigid-euclid-r40",
              "name": "R40",
              "subcategories": []
            },
            {
              "id": "dump-trucks-artic-rigid-euclid-r50",
              "name": "R50",
              "subcategories": []
            },
            {
              "id": "dump-trucks-artic-rigid-euclid-r60",
              "name": "R60",
              "subcategories": []
            },
            {
              "id": "dump-trucks-artic-rigid-euclid-r85",
              "name": "R85",
              "subcategories": []
            },
            {
              "id": "dump-trucks-artic-rigid-euclid-other",
              "name": "OTHER",
              "subcategories": []
            }
          ]
        },
        {
          "id": "dump-trucks-artic-rigid-hitachi",
          "name": "Hitachi",
          "subcategories": [
            {
              "id": "dump-trucks-artic-rigid-hitachi-ah400",
              "name": "AH400",
              "subcategories": []
            },
            {
              "id": "dump-trucks-artic-rigid-hitachi-ah500",
              "name": "AH500",
              "subcategories": []
            },
            {
              "id": "dump-trucks-artic-rigid-hitachi-eh700",
              "name": "EH700",
              "subcategories": []
            },
            {
              "id": "dump-trucks-artic-rigid-hitachi-eh1100",
              "name": "EH1100",
              "subcategories": []
            },
            {
              "id": "dump-trucks-artic-rigid-hitachi-eh1700",
              "name": "EH1700",
              "subcategories": []
            },
            {
              "id": "dump-trucks-artic-rigid-hitachi-eh3500",
              "name": "EH3500",
              "subcategories": []
            },
            {
              "id": "dump-trucks-artic-rigid-hitachi-eh4000",
              "name": "EH4000",
              "subcategories": []
            },
            {
              "id": "dump-trucks-artic-rigid-hitachi-other",
              "name": "OTHER",
              "subcategories": []
            }
          ]
        },
        {
          "id": "dump-trucks-artic-rigid-liebherr",
          "name": "Liebherr",
          "subcategories": [
            {
              "id": "dump-trucks-artic-rigid-liebherr-ta230",
              "name": "TA230",
              "subcategories": []
            },
            {
              "id": "dump-trucks-artic-rigid-liebherr-other",
              "name": "OTHER",
              "subcategories": []
            }
          ]
        },
        {
          "id": "dump-trucks-artic-rigid-moxy",
          "name": "Moxy",
          "subcategories": [
            {
              "id": "dump-trucks-artic-rigid-moxy-6200",
              "name": "6200",
              "subcategories": []
            },
            {
              "id": "dump-trucks-artic-rigid-moxy-7235",
              "name": "7235",
              "subcategories": []
            },
            {
              "id": "dump-trucks-artic-rigid-moxy-mt26",
              "name": "MT26",
              "subcategories": []
            },
            {
              "id": "dump-trucks-artic-rigid-moxy-mt27",
              "name": "MT27",
              "subcategories": []
            },
            {
              "id": "dump-trucks-artic-rigid-moxy-mt30",
              "name": "MT30",
              "subcategories": []
            },
            {
              "id": "dump-trucks-artic-rigid-moxy-mt30r",
              "name": "MT30R",
              "subcategories": []
            },
            {
              "id": "dump-trucks-artic-rigid-moxy-mt30s",
              "name": "MT30S",
              "subcategories": []
            },
            {
              "id": "dump-trucks-artic-rigid-moxy-mt31",
              "name": "MT31",
              "subcategories": []
            },
            {
              "id": "dump-trucks-artic-rigid-moxy-mt36",
              "name": "MT36",
              "subcategories": []
            },
            {
              "id": "dump-trucks-artic-rigid-moxy-mt36-ii",
              "name": "MT36 II",
              "subcategories": []
            },
            {
              "id": "dump-trucks-artic-rigid-moxy-mt40b",
              "name": "MT40B",
              "subcategories": []
            },
            {
              "id": "dump-trucks-artic-rigid-moxy-mt41",
              "name": "MT41",
              "subcategories": []
            },
            {
              "id": "dump-trucks-artic-rigid-moxy-other",
              "name": "OTHER",
              "subcategories": []
            }
          ]
        },
        {
          "id": "dump-trucks-artic-rigid-perlini",
          "name": "Perlini",
          "subcategories": [
            {
              "id": "dump-trucks-artic-rigid-perlini-dp205",
              "name": "DP205",
              "subcategories": []
            },
            {
              "id": "dump-trucks-artic-rigid-perlini-dp255",
              "name": "DP255",
              "subcategories": []
            },
            {
              "id": "dump-trucks-artic-rigid-perlini-dp366",
              "name": "DP366",
              "subcategories": []
            },
            {
              "id": "dump-trucks-artic-rigid-perlini-dp405",
              "name": "DP405",
              "subcategories": []
            },
            {
              "id": "dump-trucks-artic-rigid-perlini-dp655",
              "name": "DP655",
              "subcategories": []
            },
            {
              "id": "dump-trucks-artic-rigid-perlini-dp705",
              "name": "DP705",
              "subcategories": []
            },
            {
              "id": "dump-trucks-artic-rigid-perlini-t15",
              "name": "T15",
              "subcategories": []
            },
            {
              "id": "dump-trucks-artic-rigid-perlini-t20",
              "name": "T20",
              "subcategories": []
            },
            {
              "id": "dump-trucks-artic-rigid-perlini-t40",
              "name": "T40",
              "subcategories": []
            },
            {
              "id": "dump-trucks-artic-rigid-perlini-other",
              "name": "OTHER",
              "subcategories": []
            }
          ]
        },
        {
          "id": "dump-trucks-artic-rigid-sandvik",
          "name": "Sandvik",
          "subcategories": [
            {
              "id": "dump-trucks-artic-rigid-sandvik-ejc30sx",
              "name": "EJC30SX",
              "subcategories": []
            },
            {
              "id": "dump-trucks-artic-rigid-sandvik-ejc210",
              "name": "EJC210",
              "subcategories": []
            },
            {
              "id": "dump-trucks-artic-rigid-sandvik-ejc533",
              "name": "EJC533",
              "subcategories": []
            },
            {
              "id": "dump-trucks-artic-rigid-sandvik-th430",
              "name": "TH430",
              "subcategories": []
            },
            {
              "id": "dump-trucks-artic-rigid-sandvik-th433",
              "name": "TH433",
              "subcategories": []
            },
            {
              "id": "dump-trucks-artic-rigid-sandvik-th663",
              "name": "TH663",
              "subcategories": []
            },
            {
              "id": "dump-trucks-artic-rigid-sandvik-toro-50",
              "name": "TORO 50",
              "subcategories": []
            },
            {
              "id": "dump-trucks-artic-rigid-sandvik-toro-50d",
              "name": "TORO 50D",
              "subcategories": []
            },
            {
              "id": "dump-trucks-artic-rigid-sandvik-other",
              "name": "OTHER",
              "subcategories": []
            }
          ]
        },
        {
          "id": "dump-trucks-artic-rigid-xcmg",
          "name": "Xcmg",
          "subcategories": [
            {
              "id": "dump-trucks-artic-rigid-xcmg-xda30",
              "name": "XDA30",
              "subcategories": []
            },
            {
              "id": "dump-trucks-artic-rigid-xcmg-xda40",
              "name": "XDA40",
              "subcategories": []
            },
            {
              "id": "dump-trucks-artic-rigid-xcmg-xda45",
              "name": "XDA45",
              "subcategories": []
            },
            {
              "id": "dump-trucks-artic-rigid-xcmg-xde130",
              "name": "XDE130",
              "subcategories": []
            },
            {
              "id": "dump-trucks-artic-rigid-xcmg-xde150",
              "name": "XDE150",
              "subcategories": []
            },
            {
              "id": "dump-trucks-artic-rigid-xcmg-xde200",
              "name": "XDE200",
              "subcategories": []
            },
            {
              "id": "dump-trucks-artic-rigid-xcmg-xde240",
              "name": "XDE240",
              "subcategories": []
            },
            {
              "id": "dump-trucks-artic-rigid-xcmg-xde260",
              "name": "XDE260",
              "subcategories": []
            },
            {
              "id": "dump-trucks-artic-rigid-xcmg-xde320",
              "name": "XDE320",
              "subcategories": []
            },
            {
              "id": "dump-trucks-artic-rigid-xcmg-xdm80",
              "name": "XDM80",
              "subcategories": []
            },
            {
              "id": "dump-trucks-artic-rigid-xcmg-xdr70t",
              "name": "XDR70T",
              "subcategories": []
            },
            {
              "id": "dump-trucks-artic-rigid-xcmg-xdr80t",
              "name": "XDR80T",
              "subcategories": []
            },
            {
              "id": "dump-trucks-artic-rigid-xcmg-xdr85t",
              "name": "XDR85T",
              "subcategories": []
            },
            {
              "id": "dump-trucks-artic-rigid-xcmg-xdr90t",
              "name": "XDR90T",
              "subcategories": []
            },
            {
              "id": "dump-trucks-artic-rigid-xcmg-xdr100",
              "name": "XDR100",
              "subcategories": []
            },
            {
              "id": "dump-trucks-artic-rigid-xcmg-xga5904d3t",
              "name": "XGA5904D3T",
              "subcategories": []
            },
            {
              "id": "dump-trucks-artic-rigid-xcmg-xkt105a",
              "name": "XKT105A",
              "subcategories": []
            },
            {
              "id": "dump-trucks-artic-rigid-xcmg-other",
              "name": "OTHER",
              "subcategories": []
            }
          ]
        }
      ]
    },
    {
      "id": "excavators",
      "name": "Excavators",
      "subcategories": [
        {
          "id": "excavators-caterpillar",
          "name": "Caterpillar",
          "subcategories": [
            {
              "id": "excavators-caterpillar-206",
              "name": "206",
              "subcategories": []
            },
            {
              "id": "excavators-caterpillar-206bft",
              "name": "206BFT",
              "subcategories": []
            },
            {
              "id": "excavators-caterpillar-211",
              "name": "211",
              "subcategories": []
            },
            {
              "id": "excavators-caterpillar-211lc",
              "name": "211LC",
              "subcategories": []
            },
            {
              "id": "excavators-caterpillar-212",
              "name": "212",
              "subcategories": []
            },
            {
              "id": "excavators-caterpillar-212b",
              "name": "212B",
              "subcategories": []
            },
            {
              "id": "excavators-caterpillar-212b-ft",
              "name": "212B FT",
              "subcategories": []
            },
            {
              "id": "excavators-caterpillar-214b",
              "name": "214B",
              "subcategories": []
            },
            {
              "id": "excavators-caterpillar-214bft",
              "name": "214BFT",
              "subcategories": []
            },
            {
              "id": "excavators-caterpillar-215",
              "name": "215",
              "subcategories": []
            },
            {
              "id": "excavators-caterpillar-215dlc",
              "name": "215DLC",
              "subcategories": []
            },
            {
              "id": "excavators-caterpillar-219d",
              "name": "219D",
              "subcategories": []
            },
            {
              "id": "excavators-caterpillar-225",
              "name": "225",
              "subcategories": []
            },
            {
              "id": "excavators-caterpillar-225lc",
              "name": "225LC",
              "subcategories": []
            },
            {
              "id": "excavators-caterpillar-225b",
              "name": "225B",
              "subcategories": []
            },
            {
              "id": "excavators-caterpillar-225b-lc",
              "name": "225B LC",
              "subcategories": []
            },
            {
              "id": "excavators-caterpillar-225d-lc",
              "name": "225D LC",
              "subcategories": []
            },
            {
              "id": "excavators-caterpillar-229",
              "name": "229",
              "subcategories": []
            },
            {
              "id": "excavators-caterpillar-235",
              "name": "235",
              "subcategories": []
            },
            {
              "id": "excavators-caterpillar-235b",
              "name": "235B",
              "subcategories": []
            },
            {
              "id": "excavators-caterpillar-235bh",
              "name": "235BH",
              "subcategories": []
            },
            {
              "id": "excavators-caterpillar-235c",
              "name": "235C",
              "subcategories": []
            },
            {
              "id": "excavators-caterpillar-235d",
              "name": "235D",
              "subcategories": []
            },
            {
              "id": "excavators-caterpillar-245",
              "name": "245",
              "subcategories": []
            },
            {
              "id": "excavators-caterpillar-245b",
              "name": "245B",
              "subcategories": []
            },
            {
              "id": "excavators-caterpillar-245d",
              "name": "245D",
              "subcategories": []
            },
            {
              "id": "excavators-caterpillar-245fds",
              "name": "245FDS",
              "subcategories": []
            },
            {
              "id": "excavators-caterpillar-300-9d",
              "name": "300.9D",
              "subcategories": []
            },
            {
              "id": "excavators-caterpillar-301-4c",
              "name": "301.4C",
              "subcategories": []
            },
            {
              "id": "excavators-caterpillar-301-5",
              "name": "301.5",
              "subcategories": []
            },
            {
              "id": "excavators-caterpillar-301-5cr",
              "name": "301.5CR",
              "subcategories": []
            },
            {
              "id": "excavators-caterpillar-301-6",
              "name": "301.6",
              "subcategories": []
            },
            {
              "id": "excavators-caterpillar-301-6c",
              "name": "301.6C",
              "subcategories": []
            },
            {
              "id": "excavators-caterpillar-301-7cr",
              "name": "301.7CR",
              "subcategories": []
            },
            {
              "id": "excavators-caterpillar-301-7d",
              "name": "301.7D",
              "subcategories": []
            },
            {
              "id": "excavators-caterpillar-301-7d-cr",
              "name": "301.7D CR",
              "subcategories": []
            },
            {
              "id": "excavators-caterpillar-301-8",
              "name": "301.8",
              "subcategories": []
            },
            {
              "id": "excavators-caterpillar-301-8c",
              "name": "301.8C",
              "subcategories": []
            },
            {
              "id": "excavators-caterpillar-302c-cr",
              "name": "302C CR",
              "subcategories": []
            },
            {
              "id": "excavators-caterpillar-302cr",
              "name": "302CR",
              "subcategories": []
            },
            {
              "id": "excavators-caterpillar-302-2d",
              "name": "302.2D",
              "subcategories": []
            },
            {
              "id": "excavators-caterpillar-302-4d",
              "name": "302.4D",
              "subcategories": []
            },
            {
              "id": "excavators-caterpillar-302-5",
              "name": "302.5",
              "subcategories": []
            },
            {
              "id": "excavators-caterpillar-302-5c",
              "name": "302.5C",
              "subcategories": []
            },
            {
              "id": "excavators-caterpillar-302-5e-sr",
              "name": "302.5E SR",
              "subcategories": []
            },
            {
              "id": "excavators-caterpillar-302-7cr",
              "name": "302.7CR",
              "subcategories": []
            },
            {
              "id": "excavators-caterpillar-302-7d",
              "name": "302.7D",
              "subcategories": []
            },
            {
              "id": "excavators-caterpillar-302-7d-cr",
              "name": "302.7D CR",
              "subcategories": []
            },
            {
              "id": "excavators-caterpillar-303c-cr",
              "name": "303C CR",
              "subcategories": []
            },
            {
              "id": "excavators-caterpillar-303cr",
              "name": "303CR",
              "subcategories": []
            },
            {
              "id": "excavators-caterpillar-303e-cr",
              "name": "303E CR",
              "subcategories": []
            },
            {
              "id": "excavators-caterpillar-303gr",
              "name": "303GR",
              "subcategories": []
            },
            {
              "id": "excavators-caterpillar-303-5",
              "name": "303.5",
              "subcategories": []
            },
            {
              "id": "excavators-caterpillar-303-5c",
              "name": "303.5C",
              "subcategories": []
            },
            {
              "id": "excavators-caterpillar-303-5c-cr",
              "name": "303.5C CR",
              "subcategories": []
            },
            {
              "id": "excavators-caterpillar-303-5cr",
              "name": "303.5CR",
              "subcategories": []
            },
            {
              "id": "excavators-caterpillar-303-5d-cr",
              "name": "303.5D CR",
              "subcategories": []
            },
            {
              "id": "excavators-caterpillar-303-5e-cr",
              "name": "303.5E CR",
              "subcategories": []
            },
            {
              "id": "excavators-caterpillar-303-5e2-cr",
              "name": "303.5E2 CR",
              "subcategories": []
            },
            {
              "id": "excavators-caterpillar-304",
              "name": "304",
              "subcategories": []
            },
            {
              "id": "excavators-caterpillar-304c",
              "name": "304C",
              "subcategories": []
            },
            {
              "id": "excavators-caterpillar-304c-cr",
              "name": "304C CR",
              "subcategories": []
            },
            {
              "id": "excavators-caterpillar-304cr",
              "name": "304CR",
              "subcategories": []
            },
            {
              "id": "excavators-caterpillar-304d-cr",
              "name": "304D CR",
              "subcategories": []
            },
            {
              "id": "excavators-caterpillar-304e-cr",
              "name": "304E CR",
              "subcategories": []
            },
            {
              "id": "excavators-caterpillar-304e2-cr",
              "name": "304E2 CR",
              "subcategories": []
            },
            {
              "id": "excavators-caterpillar-304-5",
              "name": "304.5",
              "subcategories": []
            },
            {
              "id": "excavators-caterpillar-305",
              "name": "305",
              "subcategories": []
            },
            {
              "id": "excavators-caterpillar-305c",
              "name": "305C",
              "subcategories": []
            },
            {
              "id": "excavators-caterpillar-305c-cr",
              "name": "305C CR",
              "subcategories": []
            },
            {
              "id": "excavators-caterpillar-305cr",
              "name": "305CR",
              "subcategories": []
            },
            {
              "id": "excavators-caterpillar-305d",
              "name": "305D",
              "subcategories": []
            },
            {
              "id": "excavators-caterpillar-305d-cr",
              "name": "305D CR",
              "subcategories": []
            },
            {
              "id": "excavators-caterpillar-305e-cr",
              "name": "305E CR",
              "subcategories": []
            },
            {
              "id": "excavators-caterpillar-305e2",
              "name": "305E2",
              "subcategories": []
            },
            {
              "id": "excavators-caterpillar-305e2-cr",
              "name": "305E2 CR",
              "subcategories": []
            },
            {
              "id": "excavators-caterpillar-305sr",
              "name": "305SR",
              "subcategories": []
            },
            {
              "id": "excavators-caterpillar-305-5",
              "name": "305.5",
              "subcategories": []
            },
            {
              "id": "excavators-caterpillar-305-5d-cr",
              "name": "305.5D CR",
              "subcategories": []
            },
            {
              "id": "excavators-caterpillar-305-5e",
              "name": "305.5E",
              "subcategories": []
            },
            {
              "id": "excavators-caterpillar-305-5e-cr",
              "name": "305.5E CR",
              "subcategories": []
            },
            {
              "id": "excavators-caterpillar-305-5",
              "name": "305.5",
              "subcategories": []
            },
            {
              "id": "excavators-caterpillar-305-5e-cr",
              "name": "305.5E CR",
              "subcategories": []
            },
            {
              "id": "excavators-caterpillar-305-5e2",
              "name": "305.5E2",
              "subcategories": []
            },
            {
              "id": "excavators-caterpillar-305-5e2-cr",
              "name": "305.5E2 CR",
              "subcategories": []
            },
            {
              "id": "excavators-caterpillar-306",
              "name": "306",
              "subcategories": []
            },
            {
              "id": "excavators-caterpillar-306cr",
              "name": "306CR",
              "subcategories": []
            },
            {
              "id": "excavators-caterpillar-306d",
              "name": "306D",
              "subcategories": []
            },
            {
              "id": "excavators-caterpillar-306e",
              "name": "306E",
              "subcategories": []
            },
            {
              "id": "excavators-caterpillar-306-5",
              "name": "306.5",
              "subcategories": []
            },
            {
              "id": "excavators-caterpillar-307",
              "name": "307",
              "subcategories": []
            },
            {
              "id": "excavators-caterpillar-307b",
              "name": "307B",
              "subcategories": []
            },
            {
              "id": "excavators-caterpillar-307c",
              "name": "307C",
              "subcategories": []
            },
            {
              "id": "excavators-caterpillar-307d",
              "name": "307D",
              "subcategories": []
            },
            {
              "id": "excavators-caterpillar-307e",
              "name": "307E",
              "subcategories": []
            },
            {
              "id": "excavators-caterpillar-307eii",
              "name": "307EII",
              "subcategories": []
            },
            {
              "id": "excavators-caterpillar-307ssr",
              "name": "307SSR",
              "subcategories": []
            },
            {
              "id": "excavators-caterpillar-307-5",
              "name": "307.5",
              "subcategories": []
            },
            {
              "id": "excavators-caterpillar-308-cr",
              "name": "308 CR",
              "subcategories": []
            },
            {
              "id": "excavators-caterpillar-308b-cr",
              "name": "308B CR",
              "subcategories": []
            },
            {
              "id": "excavators-caterpillar-308c",
              "name": "308C",
              "subcategories": []
            },
            {
              "id": "excavators-caterpillar-308c-cr",
              "name": "308C CR",
              "subcategories": []
            },
            {
              "id": "excavators-caterpillar-308d",
              "name": "308D",
              "subcategories": []
            },
            {
              "id": "excavators-caterpillar-308d-cr",
              "name": "308D CR",
              "subcategories": []
            },
            {
              "id": "excavators-caterpillar-308e",
              "name": "308E",
              "subcategories": []
            },
            {
              "id": "excavators-caterpillar-308e-cr",
              "name": "308E CR",
              "subcategories": []
            },
            {
              "id": "excavators-caterpillar-308e-sr",
              "name": "308E SR",
              "subcategories": []
            },
            {
              "id": "excavators-caterpillar-308e2",
              "name": "308E2",
              "subcategories": []
            },
            {
              "id": "excavators-caterpillar-308e2-cr",
              "name": "308E2 CR",
              "subcategories": []
            },
            {
              "id": "excavators-caterpillar-308-5",
              "name": "308.5",
              "subcategories": []
            },
            {
              "id": "excavators-caterpillar-308-5e2",
              "name": "308.5E2",
              "subcategories": []
            },
            {
              "id": "excavators-caterpillar-309cr",
              "name": "309CR",
              "subcategories": []
            },
            {
              "id": "excavators-caterpillar-310",
              "name": "310",
              "subcategories": []
            },
            {
              "id": "excavators-caterpillar-311",
              "name": "311",
              "subcategories": []
            },
            {
              "id": "excavators-caterpillar-311b",
              "name": "311B",
              "subcategories": []
            },
            {
              "id": "excavators-caterpillar-311c",
              "name": "311C",
              "subcategories": []
            },
            {
              "id": "excavators-caterpillar-311c-u",
              "name": "311C U",
              "subcategories": []
            },
            {
              "id": "excavators-caterpillar-311d",
              "name": "311D",
              "subcategories": []
            },
            {
              "id": "excavators-caterpillar-311dlrr",
              "name": "311DLRR",
              "subcategories": []
            },
            {
              "id": "excavators-caterpillar-311f-rr",
              "name": "311F RR",
              "subcategories": []
            },
            {
              "id": "excavators-caterpillar-311flrr",
              "name": "311FLRR",
              "subcategories": []
            },
            {
              "id": "excavators-caterpillar-312",
              "name": "312",
              "subcategories": []
            },
            {
              "id": "excavators-caterpillar-312b",
              "name": "312B",
              "subcategories": []
            },
            {
              "id": "excavators-caterpillar-312bl",
              "name": "312BL",
              "subcategories": []
            },
            {
              "id": "excavators-caterpillar-312c",
              "name": "312C",
              "subcategories": []
            },
            {
              "id": "excavators-caterpillar-312cl",
              "name": "312CL",
              "subcategories": []
            },
            {
              "id": "excavators-caterpillar-312d",
              "name": "312D",
              "subcategories": []
            },
            {
              "id": "excavators-caterpillar-312d2",
              "name": "312D2",
              "subcategories": []
            },
            {
              "id": "excavators-caterpillar-312d2-gc",
              "name": "312D2 GC",
              "subcategories": []
            },
            {
              "id": "excavators-caterpillar-312dl",
              "name": "312DL",
              "subcategories": []
            },
            {
              "id": "excavators-caterpillar-312e",
              "name": "312E",
              "subcategories": []
            },
            {
              "id": "excavators-caterpillar-312el",
              "name": "312EL",
              "subcategories": []
            },
            {
              "id": "excavators-caterpillar-312f",
              "name": "312F",
              "subcategories": []
            },
            {
              "id": "excavators-caterpillar-312fgc",
              "name": "312FGC",
              "subcategories": []
            },
            {
              "id": "excavators-caterpillar-312gc",
              "name": "312GC",
              "subcategories": []
            },
            {
              "id": "excavators-caterpillar-313",
              "name": "313",
              "subcategories": []
            },
            {
              "id": "excavators-caterpillar-313b-cr",
              "name": "313B CR",
              "subcategories": []
            },
            {
              "id": "excavators-caterpillar-313c",
              "name": "313C",
              "subcategories": []
            },
            {
              "id": "excavators-caterpillar-313csr",
              "name": "313CSR",
              "subcategories": []
            },
            {
              "id": "excavators-caterpillar-313d",
              "name": "313D",
              "subcategories": []
            },
            {
              "id": "excavators-caterpillar-313d-cr",
              "name": "313D CR",
              "subcategories": []
            },
            {
              "id": "excavators-caterpillar-313d2",
              "name": "313D2",
              "subcategories": []
            },
            {
              "id": "excavators-caterpillar-313d2-gc",
              "name": "313D2 GC",
              "subcategories": []
            },
            {
              "id": "excavators-caterpillar-313d2-l",
              "name": "313D2 L",
              "subcategories": []
            },
            {
              "id": "excavators-caterpillar-313fl",
              "name": "313FL",
              "subcategories": []
            },
            {
              "id": "excavators-caterpillar-313flgc",
              "name": "313FLGC",
              "subcategories": []
            },
            {
              "id": "excavators-caterpillar-313gc",
              "name": "313GC",
              "subcategories": []
            },
            {
              "id": "excavators-caterpillar-314c",
              "name": "314C",
              "subcategories": []
            },
            {
              "id": "excavators-caterpillar-314c-cr",
              "name": "314C CR",
              "subcategories": []
            },
            {
              "id": "excavators-caterpillar-314c-lcr",
              "name": "314C LCR",
              "subcategories": []
            },
            {
              "id": "excavators-caterpillar-314d-lcr",
              "name": "314D LCR",
              "subcategories": []
            },
            {
              "id": "excavators-caterpillar-314e-cr",
              "name": "314E CR",
              "subcategories": []
            },
            {
              "id": "excavators-caterpillar-314e-lcr",
              "name": "314E LCR",
              "subcategories": []
            },
            {
              "id": "excavators-caterpillar-314e-sr",
              "name": "314E SR",
              "subcategories": []
            },
            {
              "id": "excavators-caterpillar-314el",
              "name": "314EL",
              "subcategories": []
            },
            {
              "id": "excavators-caterpillar-314f",
              "name": "314F",
              "subcategories": []
            },
            {
              "id": "excavators-caterpillar-314f-cr",
              "name": "314F CR",
              "subcategories": []
            },
            {
              "id": "excavators-caterpillar-315",
              "name": "315",
              "subcategories": []
            },
            {
              "id": "excavators-caterpillar-315gc",
              "name": "315GC",
              "subcategories": []
            },
            {
              "id": "excavators-caterpillar-315bl",
              "name": "315BL",
              "subcategories": []
            },
            {
              "id": "excavators-caterpillar-315c",
              "name": "315C",
              "subcategories": []
            },
            {
              "id": "excavators-caterpillar-315cl",
              "name": "315CL",
              "subcategories": []
            },
            {
              "id": "excavators-caterpillar-315d",
              "name": "315D",
              "subcategories": []
            },
            {
              "id": "excavators-caterpillar-315d2-gc",
              "name": "315D2 GC",
              "subcategories": []
            },
            {
              "id": "excavators-caterpillar-315d2l",
              "name": "315D2L",
              "subcategories": []
            },
            {
              "id": "excavators-caterpillar-315dl",
              "name": "315DL",
              "subcategories": []
            },
            {
              "id": "excavators-caterpillar-315f",
              "name": "315F",
              "subcategories": []
            },
            {
              "id": "excavators-caterpillar-315f-lcr",
              "name": "315F LCR",
              "subcategories": []
            },
            {
              "id": "excavators-caterpillar-315fl",
              "name": "315FL",
              "subcategories": []
            },
            {
              "id": "excavators-caterpillar-315l",
              "name": "315L",
              "subcategories": []
            },
            {
              "id": "excavators-caterpillar-315d2",
              "name": "315D2",
              "subcategories": []
            },
            {
              "id": "excavators-caterpillar-315e",
              "name": "315E",
              "subcategories": []
            },
            {
              "id": "excavators-caterpillar-316e",
              "name": "316E",
              "subcategories": []
            },
            {
              "id": "excavators-caterpillar-316el",
              "name": "316EL",
              "subcategories": []
            },
            {
              "id": "excavators-caterpillar-316fl",
              "name": "316FL",
              "subcategories": []
            },
            {
              "id": "excavators-caterpillar-316gc",
              "name": "316GC",
              "subcategories": []
            },
            {
              "id": "excavators-caterpillar-317",
              "name": "317",
              "subcategories": []
            },
            {
              "id": "excavators-caterpillar-317b",
              "name": "317B",
              "subcategories": []
            },
            {
              "id": "excavators-caterpillar-317bl",
              "name": "317BL",
              "subcategories": []
            },
            {
              "id": "excavators-caterpillar-317gc",
              "name": "317GC",
              "subcategories": []
            },
            {
              "id": "excavators-caterpillar-318b",
              "name": "318B",
              "subcategories": []
            },
            {
              "id": "excavators-caterpillar-318c",
              "name": "318C",
              "subcategories": []
            },
            {
              "id": "excavators-caterpillar-318cl",
              "name": "318CL",
              "subcategories": []
            },
            {
              "id": "excavators-caterpillar-318cn",
              "name": "318CN",
              "subcategories": []
            },
            {
              "id": "excavators-caterpillar-318d",
              "name": "318D",
              "subcategories": []
            },
            {
              "id": "excavators-caterpillar-318d2l",
              "name": "318D2L",
              "subcategories": []
            },
            {
              "id": "excavators-caterpillar-318dl",
              "name": "318DL",
              "subcategories": []
            },
            {
              "id": "excavators-caterpillar-318el",
              "name": "318EL",
              "subcategories": []
            },
            {
              "id": "excavators-caterpillar-318fl",
              "name": "318FL",
              "subcategories": []
            },
            {
              "id": "excavators-caterpillar-319cln",
              "name": "319CLN",
              "subcategories": []
            },
            {
              "id": "excavators-caterpillar-319d",
              "name": "319D",
              "subcategories": []
            },
            {
              "id": "excavators-caterpillar-319dl",
              "name": "319DL",
              "subcategories": []
            },
            {
              "id": "excavators-caterpillar-320",
              "name": "320",
              "subcategories": []
            },
            {
              "id": "excavators-caterpillar-320b",
              "name": "320B",
              "subcategories": []
            },
            {
              "id": "excavators-caterpillar-320bl",
              "name": "320BL",
              "subcategories": []
            },
            {
              "id": "excavators-caterpillar-320c",
              "name": "320C",
              "subcategories": []
            },
            {
              "id": "excavators-caterpillar-320c-fm",
              "name": "320C FM",
              "subcategories": []
            },
            {
              "id": "excavators-caterpillar-320c-lc",
              "name": "320C LC",
              "subcategories": []
            },
            {
              "id": "excavators-caterpillar-320c-lu",
              "name": "320C LU",
              "subcategories": []
            },
            {
              "id": "excavators-caterpillar-320cl",
              "name": "320CL",
              "subcategories": []
            },
            {
              "id": "excavators-caterpillar-320cln",
              "name": "320CLN",
              "subcategories": []
            },
            {
              "id": "excavators-caterpillar-320d",
              "name": "320D",
              "subcategories": []
            },
            {
              "id": "excavators-caterpillar-320d-fm",
              "name": "320D FM",
              "subcategories": []
            },
            {
              "id": "excavators-caterpillar-320d2",
              "name": "320D2",
              "subcategories": []
            },
            {
              "id": "excavators-caterpillar-320d2-gc",
              "name": "320D2 GC",
              "subcategories": []
            },
            {
              "id": "excavators-caterpillar-320d2l",
              "name": "320D2L",
              "subcategories": []
            },
            {
              "id": "excavators-caterpillar-320d3dc",
              "name": "320D3DC",
              "subcategories": []
            },
            {
              "id": "excavators-caterpillar-320d3gc",
              "name": "320D3GC",
              "subcategories": []
            },
            {
              "id": "excavators-caterpillar-320dl",
              "name": "320DL",
              "subcategories": []
            },
            {
              "id": "excavators-caterpillar-320dlrr",
              "name": "320DLRR",
              "subcategories": []
            },
            {
              "id": "excavators-caterpillar-320e",
              "name": "320E",
              "subcategories": []
            },
            {
              "id": "excavators-caterpillar-320el",
              "name": "320EL",
              "subcategories": []
            },
            {
              "id": "excavators-caterpillar-320el-cf",
              "name": "320EL CF",
              "subcategories": []
            },
            {
              "id": "excavators-caterpillar-320elrr",
              "name": "320ELRR",
              "subcategories": []
            },
            {
              "id": "excavators-caterpillar-320err",
              "name": "320ERR",
              "subcategories": []
            },
            {
              "id": "excavators-caterpillar-320fl",
              "name": "320FL",
              "subcategories": []
            },
            {
              "id": "excavators-caterpillar-320gc",
              "name": "320GC",
              "subcategories": []
            },
            {
              "id": "excavators-caterpillar-320gc",
              "name": "320GC",
              "subcategories": []
            },
            {
              "id": "excavators-caterpillar-320gx",
              "name": "320GX",
              "subcategories": []
            },
            {
              "id": "excavators-caterpillar-320l",
              "name": "320L",
              "subcategories": []
            },
            {
              "id": "excavators-caterpillar-321",
              "name": "321",
              "subcategories": []
            },
            {
              "id": "excavators-caterpillar-321b-lcr",
              "name": "321B LCR",
              "subcategories": []
            },
            {
              "id": "excavators-caterpillar-321c",
              "name": "321C",
              "subcategories": []
            },
            {
              "id": "excavators-caterpillar-321c-lcr",
              "name": "321C LCR",
              "subcategories": []
            },
            {
              "id": "excavators-caterpillar-321d-cr",
              "name": "321D CR",
              "subcategories": []
            },
            {
              "id": "excavators-caterpillar-321d-lcr",
              "name": "321D LCR",
              "subcategories": []
            },
            {
              "id": "excavators-caterpillar-322b",
              "name": "322B",
              "subcategories": []
            },
            {
              "id": "excavators-caterpillar-322bl",
              "name": "322BL",
              "subcategories": []
            },
            {
              "id": "excavators-caterpillar-322c",
              "name": "322C",
              "subcategories": []
            },
            {
              "id": "excavators-caterpillar-322cl",
              "name": "322CL",
              "subcategories": []
            },
            {
              "id": "excavators-caterpillar-322l",
              "name": "322L",
              "subcategories": []
            },
            {
              "id": "excavators-caterpillar-323",
              "name": "323",
              "subcategories": []
            },
            {
              "id": "excavators-caterpillar-323d",
              "name": "323D",
              "subcategories": []
            },
            {
              "id": "excavators-caterpillar-323d2",
              "name": "323D2",
              "subcategories": []
            },
            {
              "id": "excavators-caterpillar-323d2l",
              "name": "323D2L",
              "subcategories": []
            },
            {
              "id": "excavators-caterpillar-323d3",
              "name": "323D3",
              "subcategories": []
            },
            {
              "id": "excavators-caterpillar-323dl",
              "name": "323DL",
              "subcategories": []
            },
            {
              "id": "excavators-caterpillar-323dl-me",
              "name": "323DL ME",
              "subcategories": []
            },
            {
              "id": "excavators-caterpillar-323dln",
              "name": "323DLN",
              "subcategories": []
            },
            {
              "id": "excavators-caterpillar-323el",
              "name": "323EL",
              "subcategories": []
            },
            {
              "id": "excavators-caterpillar-323eln",
              "name": "323ELN",
              "subcategories": []
            },
            {
              "id": "excavators-caterpillar-323esa",
              "name": "323ESA",
              "subcategories": []
            },
            {
              "id": "excavators-caterpillar-323f-sa",
              "name": "323F SA",
              "subcategories": []
            },
            {
              "id": "excavators-caterpillar-323fl",
              "name": "323FL",
              "subcategories": []
            },
            {
              "id": "excavators-caterpillar-323gc",
              "name": "323GC",
              "subcategories": []
            },
            {
              "id": "excavators-caterpillar-323gx",
              "name": "323GX",
              "subcategories": []
            },
            {
              "id": "excavators-caterpillar-324",
              "name": "324",
              "subcategories": []
            },
            {
              "id": "excavators-caterpillar-324d",
              "name": "324D",
              "subcategories": []
            },
            {
              "id": "excavators-caterpillar-324d-fm",
              "name": "324D FM",
              "subcategories": []
            },
            {
              "id": "excavators-caterpillar-324d2",
              "name": "324D2",
              "subcategories": []
            },
            {
              "id": "excavators-caterpillar-324d2l",
              "name": "324D2L",
              "subcategories": []
            },
            {
              "id": "excavators-caterpillar-324dl",
              "name": "324DL",
              "subcategories": []
            },
            {
              "id": "excavators-caterpillar-324dln",
              "name": "324DLN",
              "subcategories": []
            },
            {
              "id": "excavators-caterpillar-324e",
              "name": "324E",
              "subcategories": []
            },
            {
              "id": "excavators-caterpillar-324el",
              "name": "324EL",
              "subcategories": []
            },
            {
              "id": "excavators-caterpillar-324eln",
              "name": "324ELN",
              "subcategories": []
            },
            {
              "id": "excavators-caterpillar-325",
              "name": "325",
              "subcategories": []
            },
            {
              "id": "excavators-caterpillar-325b",
              "name": "325B",
              "subcategories": []
            },
            {
              "id": "excavators-caterpillar-325bl",
              "name": "325BL",
              "subcategories": []
            },
            {
              "id": "excavators-caterpillar-325c",
              "name": "325C",
              "subcategories": []
            },
            {
              "id": "excavators-caterpillar-325c-cr",
              "name": "325C CR",
              "subcategories": []
            },
            {
              "id": "excavators-caterpillar-325c-lcr",
              "name": "325C LCR",
              "subcategories": []
            },
            {
              "id": "excavators-caterpillar-325cl",
              "name": "325CL",
              "subcategories": []
            },
            {
              "id": "excavators-caterpillar-325cln",
              "name": "325CLN",
              "subcategories": []
            },
            {
              "id": "excavators-caterpillar-325d",
              "name": "325D",
              "subcategories": []
            },
            {
              "id": "excavators-caterpillar-325d2",
              "name": "325D2",
              "subcategories": []
            },
            {
              "id": "excavators-caterpillar-325d2l",
              "name": "325D2L",
              "subcategories": []
            },
            {
              "id": "excavators-caterpillar-325dl",
              "name": "325DL",
              "subcategories": []
            },
            {
              "id": "excavators-caterpillar-325dln",
              "name": "325DLN",
              "subcategories": []
            },
            {
              "id": "excavators-caterpillar-325fl",
              "name": "325FL",
              "subcategories": []
            },
            {
              "id": "excavators-caterpillar-325flcr",
              "name": "325FLCR",
              "subcategories": []
            },
            {
              "id": "excavators-caterpillar-325l",
              "name": "325L",
              "subcategories": []
            },
            {
              "id": "excavators-caterpillar-326",
              "name": "326",
              "subcategories": []
            },
            {
              "id": "excavators-caterpillar-326d2",
              "name": "326D2",
              "subcategories": []
            },
            {
              "id": "excavators-caterpillar-326d2l",
              "name": "326D2L",
              "subcategories": []
            },
            {
              "id": "excavators-caterpillar-326f",
              "name": "326F",
              "subcategories": []
            },
            {
              "id": "excavators-caterpillar-326fl",
              "name": "326FL",
              "subcategories": []
            },
            {
              "id": "excavators-caterpillar-326fln",
              "name": "326FLN",
              "subcategories": []
            },
            {
              "id": "excavators-caterpillar-326gc",
              "name": "326GC",
              "subcategories": []
            },
            {
              "id": "excavators-caterpillar-328d",
              "name": "328D",
              "subcategories": []
            },
            {
              "id": "excavators-caterpillar-328d-lcr",
              "name": "328D LCR",
              "subcategories": []
            },
            {
              "id": "excavators-caterpillar-329d",
              "name": "329D",
              "subcategories": []
            },
            {
              "id": "excavators-caterpillar-329d2",
              "name": "329D2",
              "subcategories": []
            },
            {
              "id": "excavators-caterpillar-329d2l",
              "name": "329D2L",
              "subcategories": []
            },
            {
              "id": "excavators-caterpillar-329dl",
              "name": "329DL",
              "subcategories": []
            },
            {
              "id": "excavators-caterpillar-329dl-me",
              "name": "329DL ME",
              "subcategories": []
            },
            {
              "id": "excavators-caterpillar-329dln",
              "name": "329DLN",
              "subcategories": []
            },
            {
              "id": "excavators-caterpillar-329e",
              "name": "329E",
              "subcategories": []
            },
            {
              "id": "excavators-caterpillar-329el",
              "name": "329EL",
              "subcategories": []
            },
            {
              "id": "excavators-caterpillar-329eln",
              "name": "329ELN",
              "subcategories": []
            },
            {
              "id": "excavators-caterpillar-329f",
              "name": "329F",
              "subcategories": []
            },
            {
              "id": "excavators-caterpillar-329fl",
              "name": "329FL",
              "subcategories": []
            },
            {
              "id": "excavators-caterpillar-330",
              "name": "330",
              "subcategories": []
            },
            {
              "id": "excavators-caterpillar-330-lc",
              "name": "330 LC",
              "subcategories": []
            },
            {
              "id": "excavators-caterpillar-330b",
              "name": "330B",
              "subcategories": []
            },
            {
              "id": "excavators-caterpillar-330bl",
              "name": "330BL",
              "subcategories": []
            },
            {
              "id": "excavators-caterpillar-330bl-uhd",
              "name": "330BL UHD",
              "subcategories": []
            },
            {
              "id": "excavators-caterpillar-330bln",
              "name": "330BLN",
              "subcategories": []
            },
            {
              "id": "excavators-caterpillar-330c",
              "name": "330C",
              "subcategories": []
            },
            {
              "id": "excavators-caterpillar-330cl",
              "name": "330CL",
              "subcategories": []
            },
            {
              "id": "excavators-caterpillar-330cl-uhd",
              "name": "330CL UHD",
              "subcategories": []
            },
            {
              "id": "excavators-caterpillar-330cln",
              "name": "330CLN",
              "subcategories": []
            },
            {
              "id": "excavators-caterpillar-330d",
              "name": "330D",
              "subcategories": []
            },
            {
              "id": "excavators-caterpillar-330d2",
              "name": "330D2",
              "subcategories": []
            },
            {
              "id": "excavators-caterpillar-330d2l",
              "name": "330D2L",
              "subcategories": []
            },
            {
              "id": "excavators-caterpillar-330dl",
              "name": "330DL",
              "subcategories": []
            },
            {
              "id": "excavators-caterpillar-330dl-uhd",
              "name": "330DL UHD",
              "subcategories": []
            },
            {
              "id": "excavators-caterpillar-330f",
              "name": "330F",
              "subcategories": []
            },
            {
              "id": "excavators-caterpillar-330fl",
              "name": "330FL",
              "subcategories": []
            },
            {
              "id": "excavators-caterpillar-330fln",
              "name": "330FLN",
              "subcategories": []
            },
            {
              "id": "excavators-caterpillar-330gc",
              "name": "330GC",
              "subcategories": []
            },
            {
              "id": "excavators-caterpillar-330l",
              "name": "330L",
              "subcategories": []
            },
            {
              "id": "excavators-caterpillar-330-uhd",
              "name": "330 UHD",
              "subcategories": []
            },
            {
              "id": "excavators-caterpillar-333",
              "name": "333",
              "subcategories": []
            },
            {
              "id": "excavators-caterpillar-335",
              "name": "335",
              "subcategories": []
            },
            {
              "id": "excavators-caterpillar-335f-lcr",
              "name": "335F LCR",
              "subcategories": []
            },
            {
              "id": "excavators-caterpillar-335fl",
              "name": "335FL",
              "subcategories": []
            },
            {
              "id": "excavators-caterpillar-336",
              "name": "336",
              "subcategories": []
            },
            {
              "id": "excavators-caterpillar-336d",
              "name": "336D",
              "subcategories": []
            },
            {
              "id": "excavators-caterpillar-336d2",
              "name": "336D2",
              "subcategories": []
            },
            {
              "id": "excavators-caterpillar-336d2-lme",
              "name": "336D2 LME",
              "subcategories": []
            },
            {
              "id": "excavators-caterpillar-336d2l",
              "name": "336D2L",
              "subcategories": []
            },
            {
              "id": "excavators-caterpillar-336dl",
              "name": "336DL",
              "subcategories": []
            },
            {
              "id": "excavators-caterpillar-336dl-me",
              "name": "336DL ME",
              "subcategories": []
            },
            {
              "id": "excavators-caterpillar-336dln",
              "name": "336DLN",
              "subcategories": []
            },
            {
              "id": "excavators-caterpillar-336e",
              "name": "336E",
              "subcategories": []
            },
            {
              "id": "excavators-caterpillar-336eh",
              "name": "336EH",
              "subcategories": []
            },
            {
              "id": "excavators-caterpillar-336el",
              "name": "336EL",
              "subcategories": []
            },
            {
              "id": "excavators-caterpillar-336el-h",
              "name": "336EL H",
              "subcategories": []
            },
            {
              "id": "excavators-caterpillar-336eln",
              "name": "336ELN",
              "subcategories": []
            },
            {
              "id": "excavators-caterpillar-336f",
              "name": "336F",
              "subcategories": []
            },
            {
              "id": "excavators-caterpillar-336f-l-me",
              "name": "336F L ME",
              "subcategories": []
            },
            {
              "id": "excavators-caterpillar-336f-l-xe",
              "name": "336F L XE",
              "subcategories": []
            },
            {
              "id": "excavators-caterpillar-336fl",
              "name": "336FL",
              "subcategories": []
            },
            {
              "id": "excavators-caterpillar-336fln",
              "name": "336FLN",
              "subcategories": []
            },
            {
              "id": "excavators-caterpillar-336gc",
              "name": "336GC",
              "subcategories": []
            },
            {
              "id": "excavators-caterpillar-340",
              "name": "340",
              "subcategories": []
            },
            {
              "id": "excavators-caterpillar-340d",
              "name": "340D",
              "subcategories": []
            },
            {
              "id": "excavators-caterpillar-340d2l",
              "name": "340D2L",
              "subcategories": []
            },
            {
              "id": "excavators-caterpillar-340dl",
              "name": "340DL",
              "subcategories": []
            },
            {
              "id": "excavators-caterpillar-340f",
              "name": "340F",
              "subcategories": []
            },
            {
              "id": "excavators-caterpillar-345",
              "name": "345",
              "subcategories": []
            },
            {
              "id": "excavators-caterpillar-345b",
              "name": "345B",
              "subcategories": []
            },
            {
              "id": "excavators-caterpillar-345b-ii",
              "name": "345B II",
              "subcategories": []
            },
            {
              "id": "excavators-caterpillar-345bl",
              "name": "345BL",
              "subcategories": []
            },
            {
              "id": "excavators-caterpillar-345bl-ii",
              "name": "345BL II",
              "subcategories": []
            },
            {
              "id": "excavators-caterpillar-345bl-me",
              "name": "345BL ME",
              "subcategories": []
            },
            {
              "id": "excavators-caterpillar-345bl-uhd",
              "name": "345BL UHD",
              "subcategories": []
            },
            {
              "id": "excavators-caterpillar-345cl",
              "name": "345CL",
              "subcategories": []
            },
            {
              "id": "excavators-caterpillar-345d",
              "name": "345D",
              "subcategories": []
            },
            {
              "id": "excavators-caterpillar-345dl",
              "name": "345DL",
              "subcategories": []
            },
            {
              "id": "excavators-caterpillar-345dl-me",
              "name": "345DL ME",
              "subcategories": []
            },
            {
              "id": "excavators-caterpillar-345gc",
              "name": "345GC",
              "subcategories": []
            },
            {
              "id": "excavators-caterpillar-349",
              "name": "349",
              "subcategories": []
            },
            {
              "id": "excavators-caterpillar-349d",
              "name": "349D",
              "subcategories": []
            },
            {
              "id": "excavators-caterpillar-349d-lme",
              "name": "349D LME",
              "subcategories": []
            },
            {
              "id": "excavators-caterpillar-349d2",
              "name": "349D2",
              "subcategories": []
            },
            {
              "id": "excavators-caterpillar-349d2l",
              "name": "349D2L",
              "subcategories": []
            },
            {
              "id": "excavators-caterpillar-349dl",
              "name": "349DL",
              "subcategories": []
            },
            {
              "id": "excavators-caterpillar-349e",
              "name": "349E",
              "subcategories": []
            },
            {
              "id": "excavators-caterpillar-349e-lme",
              "name": "349E LME",
              "subcategories": []
            },
            {
              "id": "excavators-caterpillar-349el",
              "name": "349EL",
              "subcategories": []
            },
            {
              "id": "excavators-caterpillar-349el-vg",
              "name": "349EL VG",
              "subcategories": []
            },
            {
              "id": "excavators-caterpillar-349f",
              "name": "349F",
              "subcategories": []
            },
            {
              "id": "excavators-caterpillar-349f-l-xe",
              "name": "349F L XE",
              "subcategories": []
            },
            {
              "id": "excavators-caterpillar-349fl",
              "name": "349FL",
              "subcategories": []
            },
            {
              "id": "excavators-caterpillar-350",
              "name": "350",
              "subcategories": []
            },
            {
              "id": "excavators-caterpillar-350l",
              "name": "350L",
              "subcategories": []
            },
            {
              "id": "excavators-caterpillar-352",
              "name": "352",
              "subcategories": []
            },
            {
              "id": "excavators-caterpillar-352f",
              "name": "352F",
              "subcategories": []
            },
            {
              "id": "excavators-caterpillar-352fxe",
              "name": "352FXE",
              "subcategories": []
            },
            {
              "id": "excavators-caterpillar-352fl",
              "name": "352FL",
              "subcategories": []
            },
            {
              "id": "excavators-caterpillar-355",
              "name": "355",
              "subcategories": []
            },
            {
              "id": "excavators-caterpillar-365",
              "name": "365",
              "subcategories": []
            },
            {
              "id": "excavators-caterpillar-365bl",
              "name": "365BL",
              "subcategories": []
            },
            {
              "id": "excavators-caterpillar-365bl-ii",
              "name": "365BL II",
              "subcategories": []
            },
            {
              "id": "excavators-caterpillar-365c",
              "name": "365C",
              "subcategories": []
            },
            {
              "id": "excavators-caterpillar-365cl",
              "name": "365CL",
              "subcategories": []
            },
            {
              "id": "excavators-caterpillar-365cl-me",
              "name": "365CL ME",
              "subcategories": []
            },
            {
              "id": "excavators-caterpillar-374",
              "name": "374",
              "subcategories": []
            },
            {
              "id": "excavators-caterpillar-374d",
              "name": "374D",
              "subcategories": []
            },
            {
              "id": "excavators-caterpillar-374dl",
              "name": "374DL",
              "subcategories": []
            },
            {
              "id": "excavators-caterpillar-374d-lme",
              "name": "374D LME",
              "subcategories": []
            },
            {
              "id": "excavators-caterpillar-374f",
              "name": "374F",
              "subcategories": []
            },
            {
              "id": "excavators-caterpillar-374f-l-me",
              "name": "374F L ME",
              "subcategories": []
            },
            {
              "id": "excavators-caterpillar-374fl",
              "name": "374FL",
              "subcategories": []
            },
            {
              "id": "excavators-caterpillar-375",
              "name": "375",
              "subcategories": []
            },
            {
              "id": "excavators-caterpillar-375-me",
              "name": "375 ME",
              "subcategories": []
            },
            {
              "id": "excavators-caterpillar-375l",
              "name": "375L",
              "subcategories": []
            },
            {
              "id": "excavators-caterpillar-375l-me",
              "name": "375L ME",
              "subcategories": []
            },
            {
              "id": "excavators-caterpillar-385b",
              "name": "385B",
              "subcategories": []
            },
            {
              "id": "excavators-caterpillar-385bl",
              "name": "385BL",
              "subcategories": []
            },
            {
              "id": "excavators-caterpillar-385c",
              "name": "385C",
              "subcategories": []
            },
            {
              "id": "excavators-caterpillar-385cl",
              "name": "385CL",
              "subcategories": []
            },
            {
              "id": "excavators-caterpillar-385cl-me",
              "name": "385CL ME",
              "subcategories": []
            },
            {
              "id": "excavators-caterpillar-390d",
              "name": "390D",
              "subcategories": []
            },
            {
              "id": "excavators-caterpillar-390dl",
              "name": "390DL",
              "subcategories": []
            },
            {
              "id": "excavators-caterpillar-390dl-me",
              "name": "390DL ME",
              "subcategories": []
            },
            {
              "id": "excavators-caterpillar-390f",
              "name": "390F",
              "subcategories": []
            },
            {
              "id": "excavators-caterpillar-390f-l-me",
              "name": "390F L ME",
              "subcategories": []
            },
            {
              "id": "excavators-caterpillar-390fl",
              "name": "390FL",
              "subcategories": []
            },
            {
              "id": "excavators-caterpillar-395",
              "name": "395",
              "subcategories": []
            },
            {
              "id": "excavators-caterpillar-538",
              "name": "538",
              "subcategories": []
            },
            {
              "id": "excavators-caterpillar-538gf",
              "name": "538GF",
              "subcategories": []
            },
            {
              "id": "excavators-caterpillar-548gf",
              "name": "548GF",
              "subcategories": []
            },
            {
              "id": "excavators-caterpillar-558",
              "name": "558",
              "subcategories": []
            },
            {
              "id": "excavators-caterpillar-568",
              "name": "568",
              "subcategories": []
            },
            {
              "id": "excavators-caterpillar-5080",
              "name": "5080",
              "subcategories": []
            },
            {
              "id": "excavators-caterpillar-5130",
              "name": "5130",
              "subcategories": []
            },
            {
              "id": "excavators-caterpillar-5230",
              "name": "5230",
              "subcategories": []
            },
            {
              "id": "excavators-caterpillar-6015",
              "name": "6015",
              "subcategories": []
            },
            {
              "id": "excavators-caterpillar-6015b",
              "name": "6015B",
              "subcategories": []
            },
            {
              "id": "excavators-caterpillar-6015fs",
              "name": "6015FS",
              "subcategories": []
            },
            {
              "id": "excavators-caterpillar-6018acfs",
              "name": "6018ACFS",
              "subcategories": []
            },
            {
              "id": "excavators-caterpillar-6020b",
              "name": "6020B",
              "subcategories": []
            },
            {
              "id": "excavators-caterpillar-6030",
              "name": "6030",
              "subcategories": []
            },
            {
              "id": "excavators-caterpillar-6040",
              "name": "6040",
              "subcategories": []
            },
            {
              "id": "excavators-caterpillar-6040acfs",
              "name": "6040ACFS",
              "subcategories": []
            },
            {
              "id": "excavators-caterpillar-6040fs",
              "name": "6040FS",
              "subcategories": []
            },
            {
              "id": "excavators-caterpillar-6060",
              "name": "6060",
              "subcategories": []
            },
            {
              "id": "excavators-caterpillar-6060fs",
              "name": "6060FS",
              "subcategories": []
            },
            {
              "id": "excavators-caterpillar-e70b",
              "name": "E70B",
              "subcategories": []
            },
            {
              "id": "excavators-caterpillar-e120",
              "name": "E120",
              "subcategories": []
            },
            {
              "id": "excavators-caterpillar-e120b",
              "name": "E120B",
              "subcategories": []
            },
            {
              "id": "excavators-caterpillar-e200b",
              "name": "E200B",
              "subcategories": []
            },
            {
              "id": "excavators-caterpillar-el180",
              "name": "EL180",
              "subcategories": []
            },
            {
              "id": "excavators-caterpillar-el200b",
              "name": "EL200B",
              "subcategories": []
            },
            {
              "id": "excavators-caterpillar-el240b",
              "name": "EL240B",
              "subcategories": []
            },
            {
              "id": "excavators-caterpillar-el300",
              "name": "EL300",
              "subcategories": []
            },
            {
              "id": "excavators-caterpillar-m312",
              "name": "M312",
              "subcategories": []
            },
            {
              "id": "excavators-caterpillar-m131c",
              "name": "M131C",
              "subcategories": []
            },
            {
              "id": "excavators-caterpillar-m313d",
              "name": "M313D",
              "subcategories": []
            },
            {
              "id": "excavators-caterpillar-m314",
              "name": "M314",
              "subcategories": []
            },
            {
              "id": "excavators-caterpillar-m314f",
              "name": "M314F",
              "subcategories": []
            },
            {
              "id": "excavators-caterpillar-m315",
              "name": "M315",
              "subcategories": []
            },
            {
              "id": "excavators-caterpillar-m315c",
              "name": "M315C",
              "subcategories": []
            },
            {
              "id": "excavators-caterpillar-m315d",
              "name": "M315D",
              "subcategories": []
            },
            {
              "id": "excavators-caterpillar-m315d2",
              "name": "M315D2",
              "subcategories": []
            },
            {
              "id": "excavators-caterpillar-m315f",
              "name": "M315F",
              "subcategories": []
            },
            {
              "id": "excavators-caterpillar-m315gc",
              "name": "M315GC",
              "subcategories": []
            },
            {
              "id": "excavators-caterpillar-m316",
              "name": "M316",
              "subcategories": []
            },
            {
              "id": "excavators-caterpillar-m316c",
              "name": "M316C",
              "subcategories": []
            },
            {
              "id": "excavators-caterpillar-m316d",
              "name": "M316D",
              "subcategories": []
            },
            {
              "id": "excavators-caterpillar-m316f",
              "name": "M316F",
              "subcategories": []
            },
            {
              "id": "excavators-caterpillar-m317f",
              "name": "M317F",
              "subcategories": []
            },
            {
              "id": "excavators-caterpillar-m318",
              "name": "M318",
              "subcategories": []
            },
            {
              "id": "excavators-caterpillar-m318c",
              "name": "M318C",
              "subcategories": []
            },
            {
              "id": "excavators-caterpillar-m318d",
              "name": "M318D",
              "subcategories": []
            },
            {
              "id": "excavators-caterpillar-m318f",
              "name": "M318F",
              "subcategories": []
            },
            {
              "id": "excavators-caterpillar-m319",
              "name": "M319",
              "subcategories": []
            },
            {
              "id": "excavators-caterpillar-m320",
              "name": "M320",
              "subcategories": []
            },
            {
              "id": "excavators-caterpillar-m320d2",
              "name": "M320D2",
              "subcategories": []
            },
            {
              "id": "excavators-caterpillar-m320f",
              "name": "M320F",
              "subcategories": []
            },
            {
              "id": "excavators-caterpillar-m322",
              "name": "M322",
              "subcategories": []
            },
            {
              "id": "excavators-caterpillar-m322c",
              "name": "M322C",
              "subcategories": []
            },
            {
              "id": "excavators-caterpillar-m322d",
              "name": "M322D",
              "subcategories": []
            },
            {
              "id": "excavators-caterpillar-m322f",
              "name": "M322F",
              "subcategories": []
            },
            {
              "id": "excavators-caterpillar-m323f",
              "name": "M323F",
              "subcategories": []
            },
            {
              "id": "excavators-caterpillar-other",
              "name": "OTHER",
              "subcategories": []
            }
          ]
        },
        {
          "id": "excavators-deere",
          "name": "Deere",
          "subcategories": [
            {
              "id": "excavators-deere-17p",
              "name": "17P",
              "subcategories": []
            },
            {
              "id": "excavators-deere-17d",
              "name": "17D",
              "subcategories": []
            },
            {
              "id": "excavators-deere-17g",
              "name": "17G",
              "subcategories": []
            },
            {
              "id": "excavators-deere-26g",
              "name": "26G",
              "subcategories": []
            },
            {
              "id": "excavators-deere-26p",
              "name": "26P",
              "subcategories": []
            },
            {
              "id": "excavators-deere-27c-zts",
              "name": "27C ZTS",
              "subcategories": []
            },
            {
              "id": "excavators-deere-27d",
              "name": "27D",
              "subcategories": []
            },
            {
              "id": "excavators-deere-27d-zts",
              "name": "27D ZTS",
              "subcategories": []
            },
            {
              "id": "excavators-deere-27zts",
              "name": "27ZTS",
              "subcategories": []
            },
            {
              "id": "excavators-deere-30",
              "name": "30",
              "subcategories": []
            },
            {
              "id": "excavators-deere-30p",
              "name": "30P",
              "subcategories": []
            },
            {
              "id": "excavators-deere-30g",
              "name": "30G",
              "subcategories": []
            },
            {
              "id": "excavators-deere-35p",
              "name": "35P",
              "subcategories": []
            },
            {
              "id": "excavators-deere-35c",
              "name": "35C",
              "subcategories": []
            },
            {
              "id": "excavators-deere-35d",
              "name": "35D",
              "subcategories": []
            },
            {
              "id": "excavators-deere-35g",
              "name": "35G",
              "subcategories": []
            },
            {
              "id": "excavators-deere-35zts",
              "name": "35ZTS",
              "subcategories": []
            },
            {
              "id": "excavators-deere-50p",
              "name": "50P",
              "subcategories": []
            },
            {
              "id": "excavators-deere-50c",
              "name": "50C",
              "subcategories": []
            },
            {
              "id": "excavators-deere-50d",
              "name": "50D",
              "subcategories": []
            },
            {
              "id": "excavators-deere-50d-zts",
              "name": "50D ZTS",
              "subcategories": []
            },
            {
              "id": "excavators-deere-50g",
              "name": "50G",
              "subcategories": []
            },
            {
              "id": "excavators-deere-60p",
              "name": "60P",
              "subcategories": []
            },
            {
              "id": "excavators-deere-60d",
              "name": "60D",
              "subcategories": []
            },
            {
              "id": "excavators-deere-60g",
              "name": "60G",
              "subcategories": []
            },
            {
              "id": "excavators-deere-70",
              "name": "70",
              "subcategories": []
            },
            {
              "id": "excavators-deere-75p",
              "name": "75P",
              "subcategories": []
            },
            {
              "id": "excavators-deere-75d",
              "name": "75D",
              "subcategories": []
            },
            {
              "id": "excavators-deere-75g",
              "name": "75G",
              "subcategories": []
            },
            {
              "id": "excavators-deere-80c",
              "name": "80C",
              "subcategories": []
            },
            {
              "id": "excavators-deere-85p",
              "name": "85P",
              "subcategories": []
            },
            {
              "id": "excavators-deere-85d",
              "name": "85D",
              "subcategories": []
            },
            {
              "id": "excavators-deere-85g",
              "name": "85G",
              "subcategories": []
            },
            {
              "id": "excavators-deere-110",
              "name": "110",
              "subcategories": []
            },
            {
              "id": "excavators-deere-120",
              "name": "120",
              "subcategories": []
            },
            {
              "id": "excavators-deere-120c",
              "name": "120C",
              "subcategories": []
            },
            {
              "id": "excavators-deere-120c-lc",
              "name": "120C LC",
              "subcategories": []
            },
            {
              "id": "excavators-deere-120d",
              "name": "120D",
              "subcategories": []
            },
            {
              "id": "excavators-deere-130p",
              "name": "130P",
              "subcategories": []
            },
            {
              "id": "excavators-deere-130g",
              "name": "130G",
              "subcategories": []
            },
            {
              "id": "excavators-deere-135p",
              "name": "135P",
              "subcategories": []
            },
            {
              "id": "excavators-deere-135c",
              "name": "135C",
              "subcategories": []
            },
            {
              "id": "excavators-deere-135d",
              "name": "135D",
              "subcategories": []
            },
            {
              "id": "excavators-deere-135dx",
              "name": "135DX",
              "subcategories": []
            },
            {
              "id": "excavators-deere-135g",
              "name": "135G",
              "subcategories": []
            },
            {
              "id": "excavators-deere-160lc",
              "name": "160LC",
              "subcategories": []
            },
            {
              "id": "excavators-deere-160p",
              "name": "160P",
              "subcategories": []
            },
            {
              "id": "excavators-deere-160c-lc",
              "name": "160C LC",
              "subcategories": []
            },
            {
              "id": "excavators-deere-160d-lc",
              "name": "160D LC",
              "subcategories": []
            },
            {
              "id": "excavators-deere-160g",
              "name": "160G",
              "subcategories": []
            },
            {
              "id": "excavators-deere-160g-lc",
              "name": "160G LC",
              "subcategories": []
            },
            {
              "id": "excavators-deere-180c-w",
              "name": "180C W",
              "subcategories": []
            },
            {
              "id": "excavators-deere-180g-lc",
              "name": "180G LC",
              "subcategories": []
            },
            {
              "id": "excavators-deere-190dw",
              "name": "190DW",
              "subcategories": []
            },
            {
              "id": "excavators-deere-190e",
              "name": "190E",
              "subcategories": []
            },
            {
              "id": "excavators-deere-190g-w",
              "name": "190G W",
              "subcategories": []
            },
            {
              "id": "excavators-deere-200g",
              "name": "200G",
              "subcategories": []
            },
            {
              "id": "excavators-deere-200-lc",
              "name": "200 LC",
              "subcategories": []
            },
            {
              "id": "excavators-deere-200c-lc",
              "name": "200C LC",
              "subcategories": []
            },
            {
              "id": "excavators-deere-200d",
              "name": "200D",
              "subcategories": []
            },
            {
              "id": "excavators-deere-200d-lc",
              "name": "200D LC",
              "subcategories": []
            },
            {
              "id": "excavators-deere-200g",
              "name": "200G",
              "subcategories": []
            },
            {
              "id": "excavators-deere-210p",
              "name": "210P",
              "subcategories": []
            },
            {
              "id": "excavators-deere-210g",
              "name": "210G",
              "subcategories": []
            },
            {
              "id": "excavators-deere-210glc",
              "name": "210GLC",
              "subcategories": []
            },
            {
              "id": "excavators-deere-225c-lc",
              "name": "225C LC",
              "subcategories": []
            },
            {
              "id": "excavators-deere-225d-lc",
              "name": "225D LC",
              "subcategories": []
            },
            {
              "id": "excavators-deere-230-lc",
              "name": "230 LC",
              "subcategories": []
            },
            {
              "id": "excavators-deere-230c-lc",
              "name": "230C LC",
              "subcategories": []
            },
            {
              "id": "excavators-deere-230g-w",
              "name": "230G W",
              "subcategories": []
            },
            {
              "id": "excavators-deere-240d-lc",
              "name": "240D LC",
              "subcategories": []
            },
            {
              "id": "excavators-deere-245p",
              "name": "245P",
              "subcategories": []
            },
            {
              "id": "excavators-deere-245g-lc",
              "name": "245G LC",
              "subcategories": []
            },
            {
              "id": "excavators-deere-250p",
              "name": "250P",
              "subcategories": []
            },
            {
              "id": "excavators-deere-250g-lc",
              "name": "250G LC",
              "subcategories": []
            },
            {
              "id": "excavators-deere-270-lc",
              "name": "270 LC",
              "subcategories": []
            },
            {
              "id": "excavators-deere-270c-lc",
              "name": "270C LC",
              "subcategories": []
            },
            {
              "id": "excavators-deere-270d-lc",
              "name": "270D LC",
              "subcategories": []
            },
            {
              "id": "excavators-deere-290g-lc",
              "name": "290G LC",
              "subcategories": []
            },
            {
              "id": "excavators-deere-300p",
              "name": "300P",
              "subcategories": []
            },
            {
              "id": "excavators-deere-300g-lc",
              "name": "300G LC",
              "subcategories": []
            },
            {
              "id": "excavators-deere-330-lc",
              "name": "330 LC",
              "subcategories": []
            },
            {
              "id": "excavators-deere-330c-lc",
              "name": "330C LC",
              "subcategories": []
            },
            {
              "id": "excavators-deere-345p",
              "name": "345P",
              "subcategories": []
            },
            {
              "id": "excavators-deere-345g-lc",
              "name": "345G LC",
              "subcategories": []
            },
            {
              "id": "excavators-deere-350p",
              "name": "350P",
              "subcategories": []
            },
            {
              "id": "excavators-deere-350d-lc",
              "name": "350D LC",
              "subcategories": []
            },
            {
              "id": "excavators-deere-350g-lc",
              "name": "350G LC",
              "subcategories": []
            },
            {
              "id": "excavators-deere-380p",
              "name": "380P",
              "subcategories": []
            },
            {
              "id": "excavators-deere-380g",
              "name": "380G",
              "subcategories": []
            },
            {
              "id": "excavators-deere-380g-lc",
              "name": "380G LC",
              "subcategories": []
            },
            {
              "id": "excavators-deere-450-lc",
              "name": "450 LC",
              "subcategories": []
            },
            {
              "id": "excavators-deere-450c-lc",
              "name": "450C LC",
              "subcategories": []
            },
            {
              "id": "excavators-deere-450d-lc",
              "name": "450D LC",
              "subcategories": []
            },
            {
              "id": "excavators-deere-470p",
              "name": "470P",
              "subcategories": []
            },
            {
              "id": "excavators-deere-470g-lc",
              "name": "470G LC",
              "subcategories": []
            },
            {
              "id": "excavators-deere-490d",
              "name": "490D",
              "subcategories": []
            },
            {
              "id": "excavators-deere-490e",
              "name": "490E",
              "subcategories": []
            },
            {
              "id": "excavators-deere-550-lc",
              "name": "550 LC",
              "subcategories": []
            },
            {
              "id": "excavators-deere-590d",
              "name": "590D",
              "subcategories": []
            },
            {
              "id": "excavators-deere-600c-lc",
              "name": "600C LC",
              "subcategories": []
            },
            {
              "id": "excavators-deere-650d-lc",
              "name": "650D LC",
              "subcategories": []
            },
            {
              "id": "excavators-deere-670p",
              "name": "670P",
              "subcategories": []
            },
            {
              "id": "excavators-deere-670g-lc",
              "name": "670G LC",
              "subcategories": []
            },
            {
              "id": "excavators-deere-690b",
              "name": "690B",
              "subcategories": []
            },
            {
              "id": "excavators-deere-690d",
              "name": "690D",
              "subcategories": []
            },
            {
              "id": "excavators-deere-690d-lc",
              "name": "690D LC",
              "subcategories": []
            },
            {
              "id": "excavators-deere-690e",
              "name": "690E",
              "subcategories": []
            },
            {
              "id": "excavators-deere-690e-lc",
              "name": "690E LC",
              "subcategories": []
            },
            {
              "id": "excavators-deere-750",
              "name": "750",
              "subcategories": []
            },
            {
              "id": "excavators-deere-790d-lc",
              "name": "790D LC",
              "subcategories": []
            },
            {
              "id": "excavators-deere-790e-lc",
              "name": "790E LC",
              "subcategories": []
            },
            {
              "id": "excavators-deere-792d-lc",
              "name": "792D LC",
              "subcategories": []
            },
            {
              "id": "excavators-deere-800",
              "name": "800",
              "subcategories": []
            },
            {
              "id": "excavators-deere-800c",
              "name": "800C",
              "subcategories": []
            },
            {
              "id": "excavators-deere-800c-lc",
              "name": "800C LC",
              "subcategories": []
            },
            {
              "id": "excavators-deere-850",
              "name": "850",
              "subcategories": []
            },
            {
              "id": "excavators-deere-870",
              "name": "870",
              "subcategories": []
            },
            {
              "id": "excavators-deere-870p",
              "name": "870P",
              "subcategories": []
            },
            {
              "id": "excavators-deere-870g-lc",
              "name": "870G LC",
              "subcategories": []
            },
            {
              "id": "excavators-deere-892",
              "name": "892",
              "subcategories": []
            },
            {
              "id": "excavators-deere-892d-lc",
              "name": "892D LC",
              "subcategories": []
            },
            {
              "id": "excavators-deere-892e-lc",
              "name": "892E LC",
              "subcategories": []
            },
            {
              "id": "excavators-deere-992",
              "name": "992",
              "subcategories": []
            },
            {
              "id": "excavators-deere-992d",
              "name": "992D",
              "subcategories": []
            },
            {
              "id": "excavators-deere-2554",
              "name": "2554",
              "subcategories": []
            },
            {
              "id": "excavators-deere-3154g",
              "name": "3154G",
              "subcategories": []
            },
            {
              "id": "excavators-deere-3754d",
              "name": "3754D",
              "subcategories": []
            },
            {
              "id": "excavators-deere-3754g",
              "name": "3754G",
              "subcategories": []
            },
            {
              "id": "excavators-deere-3756",
              "name": "3756",
              "subcategories": []
            },
            {
              "id": "excavators-deere-e210",
              "name": "E210",
              "subcategories": []
            },
            {
              "id": "excavators-deere-e210-lc",
              "name": "E210 LC",
              "subcategories": []
            },
            {
              "id": "excavators-deere-other",
              "name": "OTHER",
              "subcategories": []
            }
          ]
        },
        {
          "id": "excavators-komatsu",
          "name": "Komatsu",
          "subcategories": [
            {
              "id": "excavators-komatsu-hb215",
              "name": "HB215",
              "subcategories": []
            },
            {
              "id": "excavators-komatsu-hb365",
              "name": "HB365",
              "subcategories": []
            },
            {
              "id": "excavators-komatsu-pc05",
              "name": "PC05",
              "subcategories": []
            },
            {
              "id": "excavators-komatsu-pc07",
              "name": "PC07",
              "subcategories": []
            },
            {
              "id": "excavators-komatsu-pc09",
              "name": "PC09",
              "subcategories": []
            },
            {
              "id": "excavators-komatsu-pc16",
              "name": "PC16",
              "subcategories": []
            },
            {
              "id": "excavators-komatsu-pc17",
              "name": "PC17",
              "subcategories": []
            },
            {
              "id": "excavators-komatsu-pc18",
              "name": "PC18",
              "subcategories": []
            },
            {
              "id": "excavators-komatsu-pc20",
              "name": "PC20",
              "subcategories": []
            },
            {
              "id": "excavators-komatsu-pc24",
              "name": "PC24",
              "subcategories": []
            },
            {
              "id": "excavators-komatsu-pc26",
              "name": "PC26",
              "subcategories": []
            },
            {
              "id": "excavators-komatsu-pc27",
              "name": "PC27",
              "subcategories": []
            },
            {
              "id": "excavators-komatsu-pc30",
              "name": "PC30",
              "subcategories": []
            },
            {
              "id": "excavators-komatsu-pc33",
              "name": "PC33",
              "subcategories": []
            },
            {
              "id": "excavators-komatsu-pc35",
              "name": "PC35",
              "subcategories": []
            },
            {
              "id": "excavators-komatsu-pc40",
              "name": "PC40",
              "subcategories": []
            },
            {
              "id": "excavators-komatsu-pc45",
              "name": "PC45",
              "subcategories": []
            },
            {
              "id": "excavators-komatsu-pc50",
              "name": "PC50",
              "subcategories": []
            },
            {
              "id": "excavators-komatsu-pc55",
              "name": "PC55",
              "subcategories": []
            },
            {
              "id": "excavators-komatsu-pc56",
              "name": "PC56",
              "subcategories": []
            },
            {
              "id": "excavators-komatsu-pc58",
              "name": "PC58",
              "subcategories": []
            },
            {
              "id": "excavators-komatsu-pc60",
              "name": "PC60",
              "subcategories": []
            },
            {
              "id": "excavators-komatsu-pc70",
              "name": "PC70",
              "subcategories": []
            },
            {
              "id": "excavators-komatsu-pc75",
              "name": "PC75",
              "subcategories": []
            },
            {
              "id": "excavators-komatsu-pc78",
              "name": "PC78",
              "subcategories": []
            },
            {
              "id": "excavators-komatsu-pc80",
              "name": "PC80",
              "subcategories": []
            },
            {
              "id": "excavators-komatsu-pc88",
              "name": "PC88",
              "subcategories": []
            },
            {
              "id": "excavators-komatsu-pc95",
              "name": "PC95",
              "subcategories": []
            },
            {
              "id": "excavators-komatsu-pc110",
              "name": "PC110",
              "subcategories": []
            },
            {
              "id": "excavators-komatsu-pc120",
              "name": "PC120",
              "subcategories": []
            },
            {
              "id": "excavators-komatsu-pc128",
              "name": "PC128",
              "subcategories": []
            },
            {
              "id": "excavators-komatsu-pc130",
              "name": "PC130",
              "subcategories": []
            },
            {
              "id": "excavators-komatsu-pc138",
              "name": "PC138",
              "subcategories": []
            },
            {
              "id": "excavators-komatsu-pc150",
              "name": "PC150",
              "subcategories": []
            },
            {
              "id": "excavators-komatsu-pc160",
              "name": "PC160",
              "subcategories": []
            },
            {
              "id": "excavators-komatsu-pc170",
              "name": "PC170",
              "subcategories": []
            },
            {
              "id": "excavators-komatsu-pc180",
              "name": "PC180",
              "subcategories": []
            },
            {
              "id": "excavators-komatsu-pc190",
              "name": "PC190",
              "subcategories": []
            },
            {
              "id": "excavators-komatsu-pc195",
              "name": "PC195",
              "subcategories": []
            },
            {
              "id": "excavators-komatsu-pc200",
              "name": "PC200",
              "subcategories": []
            },
            {
              "id": "excavators-komatsu-pc210",
              "name": "PC210",
              "subcategories": []
            },
            {
              "id": "excavators-komatsu-pc215",
              "name": "PC215",
              "subcategories": []
            },
            {
              "id": "excavators-komatsu-pc220",
              "name": "PC220",
              "subcategories": []
            },
            {
              "id": "excavators-komatsu-pc228",
              "name": "PC228",
              "subcategories": []
            },
            {
              "id": "excavators-komatsu-pc238",
              "name": "PC238",
              "subcategories": []
            },
            {
              "id": "excavators-komatsu-pc240",
              "name": "PC240",
              "subcategories": []
            },
            {
              "id": "excavators-komatsu-pc250",
              "name": "PC250",
              "subcategories": []
            },
            {
              "id": "excavators-komatsu-pc270",
              "name": "PC270",
              "subcategories": []
            },
            {
              "id": "excavators-komatsu-pc290",
              "name": "PC290",
              "subcategories": []
            },
            {
              "id": "excavators-komatsu-pc300",
              "name": "PC300",
              "subcategories": []
            },
            {
              "id": "excavators-komatsu-pc308",
              "name": "PC308",
              "subcategories": []
            },
            {
              "id": "excavators-komatsu-pc340",
              "name": "PC340",
              "subcategories": []
            },
            {
              "id": "excavators-komatsu-pc350",
              "name": "PC350",
              "subcategories": []
            },
            {
              "id": "excavators-komatsu-pc360",
              "name": "PC360",
              "subcategories": []
            },
            {
              "id": "excavators-komatsu-pc380",
              "name": "PC380",
              "subcategories": []
            },
            {
              "id": "excavators-komatsu-pc390",
              "name": "PC390",
              "subcategories": []
            },
            {
              "id": "excavators-komatsu-pc400",
              "name": "PC400",
              "subcategories": []
            },
            {
              "id": "excavators-komatsu-pc430",
              "name": "PC430",
              "subcategories": []
            },
            {
              "id": "excavators-komatsu-pc450",
              "name": "PC450",
              "subcategories": []
            },
            {
              "id": "excavators-komatsu-pc460",
              "name": "PC460",
              "subcategories": []
            },
            {
              "id": "excavators-komatsu-pc490",
              "name": "PC490",
              "subcategories": []
            },
            {
              "id": "excavators-komatsu-pc500",
              "name": "PC500",
              "subcategories": []
            },
            {
              "id": "excavators-komatsu-pc600",
              "name": "PC600",
              "subcategories": []
            },
            {
              "id": "excavators-komatsu-pc650",
              "name": "PC650",
              "subcategories": []
            },
            {
              "id": "excavators-komatsu-pc700",
              "name": "PC700",
              "subcategories": []
            },
            {
              "id": "excavators-komatsu-pc750",
              "name": "PC750",
              "subcategories": []
            },
            {
              "id": "excavators-komatsu-pc800",
              "name": "PC800",
              "subcategories": []
            },
            {
              "id": "excavators-komatsu-pc850",
              "name": "PC850",
              "subcategories": []
            },
            {
              "id": "excavators-komatsu-pc1000",
              "name": "PC1000",
              "subcategories": []
            },
            {
              "id": "excavators-komatsu-pc1100",
              "name": "PC1100",
              "subcategories": []
            },
            {
              "id": "excavators-komatsu-pc1250",
              "name": "PC1250",
              "subcategories": []
            },
            {
              "id": "excavators-komatsu-pc1600",
              "name": "PC1600",
              "subcategories": []
            },
            {
              "id": "excavators-komatsu-pc2000",
              "name": "PC2000",
              "subcategories": []
            },
            {
              "id": "excavators-komatsu-pc3000",
              "name": "PC3000",
              "subcategories": []
            },
            {
              "id": "excavators-komatsu-pc4000",
              "name": "PC4000",
              "subcategories": []
            },
            {
              "id": "excavators-komatsu-pc5500",
              "name": "PC5500",
              "subcategories": []
            },
            {
              "id": "excavators-komatsu-pc8000",
              "name": "PC8000",
              "subcategories": []
            },
            {
              "id": "excavators-komatsu-pf55",
              "name": "PF55",
              "subcategories": []
            },
            {
              "id": "excavators-komatsu-pw95",
              "name": "PW95",
              "subcategories": []
            },
            {
              "id": "excavators-komatsu-pw98",
              "name": "PW98",
              "subcategories": []
            },
            {
              "id": "excavators-komatsu-pw118",
              "name": "PW118",
              "subcategories": []
            },
            {
              "id": "excavators-komatsu-pw130",
              "name": "PW130",
              "subcategories": []
            },
            {
              "id": "excavators-komatsu-pw138",
              "name": "PW138",
              "subcategories": []
            },
            {
              "id": "excavators-komatsu-pw140",
              "name": "PW140",
              "subcategories": []
            },
            {
              "id": "excavators-komatsu-pw148",
              "name": "PW148",
              "subcategories": []
            },
            {
              "id": "excavators-komatsu-pw150",
              "name": "PW150",
              "subcategories": []
            },
            {
              "id": "excavators-komatsu-pw158",
              "name": "PW158",
              "subcategories": []
            },
            {
              "id": "excavators-komatsu-pw160",
              "name": "PW160",
              "subcategories": []
            },
            {
              "id": "excavators-komatsu-pw170",
              "name": "PW170",
              "subcategories": []
            },
            {
              "id": "excavators-komatsu-pw180",
              "name": "PW180",
              "subcategories": []
            },
            {
              "id": "excavators-komatsu-pw200",
              "name": "PW200",
              "subcategories": []
            },
            {
              "id": "excavators-komatsu-other",
              "name": "OTHER",
              "subcategories": []
            }
          ]
        },
        {
          "id": "excavators-hitachi",
          "name": "Hitachi",
          "subcategories": [
            {
              "id": "excavators-hitachi-35us",
              "name": "35US",
              "subcategories": []
            },
            {
              "id": "excavators-hitachi-ex16",
              "name": "EX16",
              "subcategories": []
            },
            {
              "id": "excavators-hitachi-ex30",
              "name": "EX30",
              "subcategories": []
            },
            {
              "id": "excavators-hitachi-ex40",
              "name": "EX40",
              "subcategories": []
            },
            {
              "id": "excavators-hitachi-ex40-2",
              "name": "EX40-2",
              "subcategories": []
            },
            {
              "id": "excavators-hitachi-ex50",
              "name": "EX50",
              "subcategories": []
            },
            {
              "id": "excavators-hitachi-ex60",
              "name": "EX60",
              "subcategories": []
            },
            {
              "id": "excavators-hitachi-ex60-5",
              "name": "EX60-5",
              "subcategories": []
            },
            {
              "id": "excavators-hitachi-ex60g",
              "name": "EX60G",
              "subcategories": []
            },
            {
              "id": "excavators-hitachi-ex75us",
              "name": "EX75US",
              "subcategories": []
            },
            {
              "id": "excavators-hitachi-ex80",
              "name": "EX80",
              "subcategories": []
            },
            {
              "id": "excavators-hitachi-ex100",
              "name": "EX100",
              "subcategories": []
            },
            {
              "id": "excavators-hitachi-ex120",
              "name": "EX120",
              "subcategories": []
            },
            {
              "id": "excavators-hitachi-ex120lc-2",
              "name": "EX120LC-2",
              "subcategories": []
            },
            {
              "id": "excavators-hitachi-ex120-2",
              "name": "EX120-2",
              "subcategories": []
            },
            {
              "id": "excavators-hitachi-ex120-5",
              "name": "EX120-5",
              "subcategories": []
            },
            {
              "id": "excavators-hitachi-ex120-5e",
              "name": "EX120-5E",
              "subcategories": []
            },
            {
              "id": "excavators-hitachi-ex135",
              "name": "EX135",
              "subcategories": []
            },
            {
              "id": "excavators-hitachi-ex150",
              "name": "EX150",
              "subcategories": []
            },
            {
              "id": "excavators-hitachi-ex160",
              "name": "EX160",
              "subcategories": []
            },
            {
              "id": "excavators-hitachi-ex165",
              "name": "EX165",
              "subcategories": []
            },
            {
              "id": "excavators-hitachi-ex200",
              "name": "EX200",
              "subcategories": []
            },
            {
              "id": "excavators-hitachi-ex200-lc",
              "name": "EX200 LC",
              "subcategories": []
            },
            {
              "id": "excavators-hitachi-ex200-lc-1",
              "name": "EX200 LC-1",
              "subcategories": []
            },
            {
              "id": "excavators-hitachi-ex200-lc-2",
              "name": "EX200 LC-2",
              "subcategories": []
            },
            {
              "id": "excavators-hitachi-ex200-lc-3",
              "name": "EX200 LC-3",
              "subcategories": []
            },
            {
              "id": "excavators-hitachi-ex200-lc-5",
              "name": "EX200 LC-5",
              "subcategories": []
            },
            {
              "id": "excavators-hitachi-ex210",
              "name": "EX210",
              "subcategories": []
            },
            {
              "id": "excavators-hitachi-ex220",
              "name": "EX220",
              "subcategories": []
            },
            {
              "id": "excavators-hitachi-ex220-lc-2",
              "name": "EX220 LC-2",
              "subcategories": []
            },
            {
              "id": "excavators-hitachi-ex220-lc-3",
              "name": "EX220 LC-3",
              "subcategories": []
            },
            {
              "id": "excavators-hitachi-ex220-lc-5",
              "name": "EX220 LC-5",
              "subcategories": []
            },
            {
              "id": "excavators-hitachi-ex225",
              "name": "EX225",
              "subcategories": []
            },
            {
              "id": "excavators-hitachi-ex230",
              "name": "EX230",
              "subcategories": []
            },
            {
              "id": "excavators-hitachi-ex270",
              "name": "EX270",
              "subcategories": []
            },
            {
              "id": "excavators-hitachi-ex300",
              "name": "EX300",
              "subcategories": []
            },
            {
              "id": "excavators-hitachi-ex345",
              "name": "EX345",
              "subcategories": []
            },
            {
              "id": "excavators-hitachi-ex350",
              "name": "EX350",
              "subcategories": []
            },
            {
              "id": "excavators-hitachi-ex400",
              "name": "EX400",
              "subcategories": []
            },
            {
              "id": "excavators-hitachi-ex450",
              "name": "EX450",
              "subcategories": []
            },
            {
              "id": "excavators-hitachi-ex455",
              "name": "EX455",
              "subcategories": []
            },
            {
              "id": "excavators-hitachi-ex550",
              "name": "EX550",
              "subcategories": []
            },
            {
              "id": "excavators-hitachi-ex600",
              "name": "EX600",
              "subcategories": []
            },
            {
              "id": "excavators-hitachi-ex700",
              "name": "EX700",
              "subcategories": []
            },
            {
              "id": "excavators-hitachi-ex750",
              "name": "EX750",
              "subcategories": []
            },
            {
              "id": "excavators-hitachi-ex800",
              "name": "EX800",
              "subcategories": []
            },
            {
              "id": "excavators-hitachi-ex1100",
              "name": "EX1100",
              "subcategories": []
            },
            {
              "id": "excavators-hitachi-ex1200",
              "name": "EX1200",
              "subcategories": []
            },
            {
              "id": "excavators-hitachi-ex1800",
              "name": "EX1800",
              "subcategories": []
            },
            {
              "id": "excavators-hitachi-ex1900",
              "name": "EX1900",
              "subcategories": []
            },
            {
              "id": "excavators-hitachi-ex2500",
              "name": "EX2500",
              "subcategories": []
            },
            {
              "id": "excavators-hitachi-ex2600",
              "name": "EX2600",
              "subcategories": []
            },
            {
              "id": "excavators-hitachi-ex3600",
              "name": "EX3600",
              "subcategories": []
            },
            {
              "id": "excavators-hitachi-ex5500",
              "name": "EX5500",
              "subcategories": []
            },
            {
              "id": "excavators-hitachi-ex5600",
              "name": "EX5600",
              "subcategories": []
            },
            {
              "id": "excavators-hitachi-ex8000",
              "name": "EX8000",
              "subcategories": []
            },
            {
              "id": "excavators-hitachi-fh130",
              "name": "FH130",
              "subcategories": []
            },
            {
              "id": "excavators-hitachi-uh033",
              "name": "UH033",
              "subcategories": []
            },
            {
              "id": "excavators-hitachi-uh081",
              "name": "UH081",
              "subcategories": []
            },
            {
              "id": "excavators-hitachi-uh083",
              "name": "UH083",
              "subcategories": []
            },
            {
              "id": "excavators-hitachi-uh103",
              "name": "UH103",
              "subcategories": []
            },
            {
              "id": "excavators-hitachi-uh181",
              "name": "UH181",
              "subcategories": []
            },
            {
              "id": "excavators-hitachi-zx8",
              "name": "ZX8",
              "subcategories": []
            },
            {
              "id": "excavators-hitachi-zx10",
              "name": "ZX10",
              "subcategories": []
            },
            {
              "id": "excavators-hitachi-zx17",
              "name": "ZX17",
              "subcategories": []
            },
            {
              "id": "excavators-hitachi-zx17u",
              "name": "ZX17U",
              "subcategories": []
            },
            {
              "id": "excavators-hitachi-zx18",
              "name": "ZX18",
              "subcategories": []
            },
            {
              "id": "excavators-hitachi-zx19",
              "name": "ZX19",
              "subcategories": []
            },
            {
              "id": "excavators-hitachi-zx20",
              "name": "ZX20",
              "subcategories": []
            },
            {
              "id": "excavators-hitachi-zx22",
              "name": "ZX22",
              "subcategories": []
            },
            {
              "id": "excavators-hitachi-zx25",
              "name": "ZX25",
              "subcategories": []
            },
            {
              "id": "excavators-hitachi-zx26",
              "name": "ZX26",
              "subcategories": []
            },
            {
              "id": "excavators-hitachi-zx27",
              "name": "ZX27",
              "subcategories": []
            },
            {
              "id": "excavators-hitachi-zx29",
              "name": "ZX29",
              "subcategories": []
            },
            {
              "id": "excavators-hitachi-zx30",
              "name": "ZX30",
              "subcategories": []
            },
            {
              "id": "excavators-hitachi-zx33",
              "name": "ZX33",
              "subcategories": []
            },
            {
              "id": "excavators-hitachi-zx35",
              "name": "ZX35",
              "subcategories": []
            },
            {
              "id": "excavators-hitachi-zx38",
              "name": "ZX38",
              "subcategories": []
            },
            {
              "id": "excavators-hitachi-zx40",
              "name": "ZX40",
              "subcategories": []
            },
            {
              "id": "excavators-hitachi-zx48",
              "name": "ZX48",
              "subcategories": []
            },
            {
              "id": "excavators-hitachi-zx50",
              "name": "ZX50",
              "subcategories": []
            },
            {
              "id": "excavators-hitachi-zx520",
              "name": "ZX520",
              "subcategories": []
            },
            {
              "id": "excavators-hitachi-zx55",
              "name": "ZX55",
              "subcategories": []
            },
            {
              "id": "excavators-hitachi-zx60",
              "name": "ZX60",
              "subcategories": []
            },
            {
              "id": "excavators-hitachi-zx65",
              "name": "ZX65",
              "subcategories": []
            },
            {
              "id": "excavators-hitachi-zx70",
              "name": "ZX70",
              "subcategories": []
            },
            {
              "id": "excavators-hitachi-zx75",
              "name": "ZX75",
              "subcategories": []
            },
            {
              "id": "excavators-hitachi-zx80",
              "name": "ZX80",
              "subcategories": []
            },
            {
              "id": "excavators-hitachi-zx85",
              "name": "ZX85",
              "subcategories": []
            },
            {
              "id": "excavators-hitachi-zx95",
              "name": "ZX95",
              "subcategories": []
            },
            {
              "id": "excavators-hitachi-zx120",
              "name": "ZX120",
              "subcategories": []
            },
            {
              "id": "excavators-hitachi-zx125",
              "name": "ZX125",
              "subcategories": []
            },
            {
              "id": "excavators-hitachi-zx130",
              "name": "ZX130",
              "subcategories": []
            },
            {
              "id": "excavators-hitachi-zx135",
              "name": "ZX135",
              "subcategories": []
            },
            {
              "id": "excavators-hitachi-zx140",
              "name": "ZX140",
              "subcategories": []
            },
            {
              "id": "excavators-hitachi-zx145",
              "name": "ZX145",
              "subcategories": []
            },
            {
              "id": "excavators-hitachi-zx150",
              "name": "ZX150",
              "subcategories": []
            },
            {
              "id": "excavators-hitachi-zx155",
              "name": "ZX155",
              "subcategories": []
            },
            {
              "id": "excavators-hitachi-zx160",
              "name": "ZX160",
              "subcategories": []
            },
            {
              "id": "excavators-hitachi-zx170",
              "name": "ZX170",
              "subcategories": []
            },
            {
              "id": "excavators-hitachi-zx175",
              "name": "ZX175",
              "subcategories": []
            },
            {
              "id": "excavators-hitachi-zx180",
              "name": "ZX180",
              "subcategories": []
            },
            {
              "id": "excavators-hitachi-zx190",
              "name": "ZX190",
              "subcategories": []
            },
            {
              "id": "excavators-hitachi-zx200",
              "name": "ZX200",
              "subcategories": []
            },
            {
              "id": "excavators-hitachi-zx210",
              "name": "ZX210",
              "subcategories": []
            },
            {
              "id": "excavators-hitachi-zx220",
              "name": "ZX220",
              "subcategories": []
            },
            {
              "id": "excavators-hitachi-zx225",
              "name": "ZX225",
              "subcategories": []
            },
            {
              "id": "excavators-hitachi-zx230",
              "name": "ZX230",
              "subcategories": []
            },
            {
              "id": "excavators-hitachi-zx240",
              "name": "ZX240",
              "subcategories": []
            },
            {
              "id": "excavators-hitachi-zx245",
              "name": "ZX245",
              "subcategories": []
            },
            {
              "id": "excavators-hitachi-zx250",
              "name": "ZX250",
              "subcategories": []
            },
            {
              "id": "excavators-hitachi-zx270",
              "name": "ZX270",
              "subcategories": []
            },
            {
              "id": "excavators-hitachi-zx280",
              "name": "ZX280",
              "subcategories": []
            },
            {
              "id": "excavators-hitachi-zx290",
              "name": "ZX290",
              "subcategories": []
            },
            {
              "id": "excavators-hitachi-zx300",
              "name": "ZX300",
              "subcategories": []
            },
            {
              "id": "excavators-hitachi-zx330",
              "name": "ZX330",
              "subcategories": []
            },
            {
              "id": "excavators-hitachi-zx345",
              "name": "ZX345",
              "subcategories": []
            },
            {
              "id": "excavators-hitachi-zx350",
              "name": "ZX350",
              "subcategories": []
            },
            {
              "id": "excavators-hitachi-zx360",
              "name": "ZX360",
              "subcategories": []
            },
            {
              "id": "excavators-hitachi-zx370",
              "name": "ZX370",
              "subcategories": []
            },
            {
              "id": "excavators-hitachi-zx380",
              "name": "ZX380",
              "subcategories": []
            },
            {
              "id": "excavators-hitachi-zx400",
              "name": "ZX400",
              "subcategories": []
            },
            {
              "id": "excavators-hitachi-zx450",
              "name": "ZX450",
              "subcategories": []
            },
            {
              "id": "excavators-hitachi-zx470",
              "name": "ZX470",
              "subcategories": []
            },
            {
              "id": "excavators-hitachi-zx480",
              "name": "ZX480",
              "subcategories": []
            },
            {
              "id": "excavators-hitachi-zx490",
              "name": "ZX490",
              "subcategories": []
            },
            {
              "id": "excavators-hitachi-zx500",
              "name": "ZX500",
              "subcategories": []
            },
            {
              "id": "excavators-hitachi-zx520",
              "name": "ZX520",
              "subcategories": []
            },
            {
              "id": "excavators-hitachi-zx530",
              "name": "ZX530",
              "subcategories": []
            },
            {
              "id": "excavators-hitachi-zx600",
              "name": "ZX600",
              "subcategories": []
            },
            {
              "id": "excavators-hitachi-zx650",
              "name": "ZX650",
              "subcategories": []
            },
            {
              "id": "excavators-hitachi-zx670",
              "name": "ZX670",
              "subcategories": []
            },
            {
              "id": "excavators-hitachi-zx690",
              "name": "ZX690",
              "subcategories": []
            },
            {
              "id": "excavators-hitachi-zx800",
              "name": "ZX800",
              "subcategories": []
            },
            {
              "id": "excavators-hitachi-zx850",
              "name": "ZX850",
              "subcategories": []
            },
            {
              "id": "excavators-hitachi-zx870",
              "name": "ZX870",
              "subcategories": []
            },
            {
              "id": "excavators-hitachi-zx890",
              "name": "ZX890",
              "subcategories": []
            },
            {
              "id": "excavators-hitachi-zx1200",
              "name": "ZX1200",
              "subcategories": []
            },
            {
              "id": "excavators-hitachi-zx1600",
              "name": "ZX1600",
              "subcategories": []
            },
            {
              "id": "excavators-hitachi-zx1800",
              "name": "ZX1800",
              "subcategories": []
            },
            {
              "id": "excavators-hitachi-other",
              "name": "OTHER",
              "subcategories": []
            }
          ]
        },
        {
          "id": "excavators-kubota",
          "name": "Kubota",
          "subcategories": [
            {
              "id": "excavators-kubota-k008",
              "name": "K008",
              "subcategories": []
            },
            {
              "id": "excavators-kubota-kh007",
              "name": "KH007",
              "subcategories": []
            },
            {
              "id": "excavators-kubota-kh-26",
              "name": "KH-26",
              "subcategories": []
            },
            {
              "id": "excavators-kubota-kx008",
              "name": "KX008",
              "subcategories": []
            },
            {
              "id": "excavators-kubota-kx08",
              "name": "KX08",
              "subcategories": []
            },
            {
              "id": "excavators-kubota-kx015",
              "name": "KX015",
              "subcategories": []
            },
            {
              "id": "excavators-kubota-kx016",
              "name": "KX016",
              "subcategories": []
            },
            {
              "id": "excavators-kubota-kx018",
              "name": "KX018",
              "subcategories": []
            },
            {
              "id": "excavators-kubota-kx019",
              "name": "KX019",
              "subcategories": []
            },
            {
              "id": "excavators-kubota-kx021",
              "name": "KX021",
              "subcategories": []
            },
            {
              "id": "excavators-kubota-kx027",
              "name": "KX027",
              "subcategories": []
            },
            {
              "id": "excavators-kubota-kx030",
              "name": "KX030",
              "subcategories": []
            },
            {
              "id": "excavators-kubota-kx033",
              "name": "KX033",
              "subcategories": []
            },
            {
              "id": "excavators-kubota-kx037",
              "name": "KX037",
              "subcategories": []
            },
            {
              "id": "excavators-kubota-kx040",
              "name": "KX040",
              "subcategories": []
            },
            {
              "id": "excavators-kubota-kx042",
              "name": "KX042",
              "subcategories": []
            },
            {
              "id": "excavators-kubota-kx057",
              "name": "KX057",
              "subcategories": []
            },
            {
              "id": "excavators-kubota-kx060",
              "name": "KX060",
              "subcategories": []
            },
            {
              "id": "excavators-kubota-kx071",
              "name": "KX071",
              "subcategories": []
            },
            {
              "id": "excavators-kubota-kx080",
              "name": "KX080",
              "subcategories": []
            },
            {
              "id": "excavators-kubota-kx085",
              "name": "KX085",
              "subcategories": []
            },
            {
              "id": "excavators-kubota-kx36",
              "name": "KX36",
              "subcategories": []
            },
            {
              "id": "excavators-kubota-kx41",
              "name": "KX41",
              "subcategories": []
            },
            {
              "id": "excavators-kubota-kx57",
              "name": "KX57",
              "subcategories": []
            },
            {
              "id": "excavators-kubota-kx61",
              "name": "KX61",
              "subcategories": []
            },
            {
              "id": "excavators-kubota-kx71",
              "name": "KX71",
              "subcategories": []
            },
            {
              "id": "excavators-kubota-kx91",
              "name": "KX91",
              "subcategories": []
            },
            {
              "id": "excavators-kubota-kx101",
              "name": "KX101",
              "subcategories": []
            },
            {
              "id": "excavators-kubota-kx121",
              "name": "KX121",
              "subcategories": []
            },
            {
              "id": "excavators-kubota-kx135",
              "name": "KX135",
              "subcategories": []
            },
            {
              "id": "excavators-kubota-kx155",
              "name": "KX155",
              "subcategories": []
            },
            {
              "id": "excavators-kubota-kx161",
              "name": "KX161",
              "subcategories": []
            },
            {
              "id": "excavators-kubota-kx163",
              "name": "KX163",
              "subcategories": []
            },
            {
              "id": "excavators-kubota-kx165",
              "name": "KX165",
              "subcategories": []
            },
            {
              "id": "excavators-kubota-kx175",
              "name": "KX175",
              "subcategories": []
            },
            {
              "id": "excavators-kubota-kx183",
              "name": "KX183",
              "subcategories": []
            },
            {
              "id": "excavators-kubota-kx185",
              "name": "KX185",
              "subcategories": []
            },
            {
              "id": "excavators-kubota-kx251",
              "name": "KX251",
              "subcategories": []
            },
            {
              "id": "excavators-kubota-rx50",
              "name": "RX50",
              "subcategories": []
            },
            {
              "id": "excavators-kubota-rx-503",
              "name": "RX-503",
              "subcategories": []
            },
            {
              "id": "excavators-kubota-u-008",
              "name": "U-008",
              "subcategories": []
            },
            {
              "id": "excavators-kubota-kx",
              "name": "KX",
              "subcategories": []
            },
            {
              "id": "excavators-kubota-u10",
              "name": "U10",
              "subcategories": []
            },
            {
              "id": "excavators-kubota-u15",
              "name": "U15",
              "subcategories": []
            },
            {
              "id": "excavators-kubota-u17",
              "name": "U17",
              "subcategories": []
            },
            {
              "id": "excavators-kubota-u20",
              "name": "U20",
              "subcategories": []
            },
            {
              "id": "excavators-kubota-u25",
              "name": "U25",
              "subcategories": []
            },
            {
              "id": "excavators-kubota-u27",
              "name": "U27",
              "subcategories": []
            },
            {
              "id": "excavators-kubota-u30",
              "name": "U30",
              "subcategories": []
            },
            {
              "id": "excavators-kubota-u35",
              "name": "U35",
              "subcategories": []
            },
            {
              "id": "excavators-kubota-u36",
              "name": "U36",
              "subcategories": []
            },
            {
              "id": "excavators-kubota-u40",
              "name": "U40",
              "subcategories": []
            },
            {
              "id": "excavators-kubota-u48",
              "name": "U48",
              "subcategories": []
            },
            {
              "id": "excavators-kubota-u50",
              "name": "U50",
              "subcategories": []
            },
            {
              "id": "excavators-kubota-u55",
              "name": "U55",
              "subcategories": []
            },
            {
              "id": "excavators-kubota-u56",
              "name": "U56",
              "subcategories": []
            },
            {
              "id": "excavators-kubota-other",
              "name": "OTHER",
              "subcategories": []
            }
          ]
        },
        {
          "id": "excavators-hyundai",
          "name": "Hyundai",
          "subcategories": [
            {
              "id": "excavators-hyundai-225lc",
              "name": "225LC",
              "subcategories": []
            },
            {
              "id": "excavators-hyundai-hw60",
              "name": "HW60",
              "subcategories": []
            },
            {
              "id": "excavators-hyundai-hw65",
              "name": "HW65",
              "subcategories": []
            },
            {
              "id": "excavators-hyundai-hw100",
              "name": "HW100",
              "subcategories": []
            },
            {
              "id": "excavators-hyundai-hw140",
              "name": "HW140",
              "subcategories": []
            },
            {
              "id": "excavators-hyundai-hw145",
              "name": "HW145",
              "subcategories": []
            },
            {
              "id": "excavators-hyundai-hw150",
              "name": "HW150",
              "subcategories": []
            },
            {
              "id": "excavators-hyundai-hw160",
              "name": "HW160",
              "subcategories": []
            },
            {
              "id": "excavators-hyundai-hw170",
              "name": "HW170",
              "subcategories": []
            },
            {
              "id": "excavators-hyundai-hw180",
              "name": "HW180",
              "subcategories": []
            },
            {
              "id": "excavators-hyundai-hw210",
              "name": "HW210",
              "subcategories": []
            },
            {
              "id": "excavators-hyundai-hx10",
              "name": "HX10",
              "subcategories": []
            },
            {
              "id": "excavators-hyundai-hx17",
              "name": "HX17",
              "subcategories": []
            },
            {
              "id": "excavators-hyundai-hx27",
              "name": "HX27",
              "subcategories": []
            },
            {
              "id": "excavators-hyundai-hx35",
              "name": "HX35",
              "subcategories": []
            },
            {
              "id": "excavators-hyundai-hx40",
              "name": "HX40",
              "subcategories": []
            },
            {
              "id": "excavators-hyundai-hx48",
              "name": "HX48",
              "subcategories": []
            },
            {
              "id": "excavators-hyundai-hx55",
              "name": "HX55",
              "subcategories": []
            },
            {
              "id": "excavators-hyundai-hx60",
              "name": "HX60",
              "subcategories": []
            },
            {
              "id": "excavators-hyundai-hx80",
              "name": "HX80",
              "subcategories": []
            },
            {
              "id": "excavators-hyundai-hx85",
              "name": "HX85",
              "subcategories": []
            },
            {
              "id": "excavators-hyundai-hx90",
              "name": "HX90",
              "subcategories": []
            },
            {
              "id": "excavators-hyundai-hx130",
              "name": "HX130",
              "subcategories": []
            },
            {
              "id": "excavators-hyundai-hx140",
              "name": "HX140",
              "subcategories": []
            },
            {
              "id": "excavators-hyundai-hx145",
              "name": "HX145",
              "subcategories": []
            },
            {
              "id": "excavators-hyundai-hx160",
              "name": "HX160",
              "subcategories": []
            },
            {
              "id": "excavators-hyundai-hx180",
              "name": "HX180",
              "subcategories": []
            },
            {
              "id": "excavators-hyundai-hx210",
              "name": "HX210",
              "subcategories": []
            },
            {
              "id": "excavators-hyundai-hx220",
              "name": "HX220",
              "subcategories": []
            },
            {
              "id": "excavators-hyundai-hx225",
              "name": "HX225",
              "subcategories": []
            },
            {
              "id": "excavators-hyundai-hx235",
              "name": "HX235",
              "subcategories": []
            },
            {
              "id": "excavators-hyundai-hx260",
              "name": "HX260",
              "subcategories": []
            },
            {
              "id": "excavators-hyundai-hx300",
              "name": "HX300",
              "subcategories": []
            },
            {
              "id": "excavators-hyundai-hx320",
              "name": "HX320",
              "subcategories": []
            },
            {
              "id": "excavators-hyundai-hx330",
              "name": "HX330",
              "subcategories": []
            },
            {
              "id": "excavators-hyundai-hx340",
              "name": "HX340",
              "subcategories": []
            },
            {
              "id": "excavators-hyundai-hx350",
              "name": "HX350",
              "subcategories": []
            },
            {
              "id": "excavators-hyundai-hx355",
              "name": "HX355",
              "subcategories": []
            },
            {
              "id": "excavators-hyundai-hx360",
              "name": "HX360",
              "subcategories": []
            },
            {
              "id": "excavators-hyundai-hx380",
              "name": "HX380",
              "subcategories": []
            },
            {
              "id": "excavators-hyundai-hx400",
              "name": "HX400",
              "subcategories": []
            },
            {
              "id": "excavators-hyundai-hx430",
              "name": "HX430",
              "subcategories": []
            },
            {
              "id": "excavators-hyundai-hx480",
              "name": "HX480",
              "subcategories": []
            },
            {
              "id": "excavators-hyundai-hx520",
              "name": "HX520",
              "subcategories": []
            },
            {
              "id": "excavators-hyundai-hk900",
              "name": "HK900",
              "subcategories": []
            },
            {
              "id": "excavators-hyundai-hx3026",
              "name": "HX3026",
              "subcategories": []
            },
            {
              "id": "excavators-hyundai-robex-16",
              "name": "ROBEX 16",
              "subcategories": []
            },
            {
              "id": "excavators-hyundai-robex-17",
              "name": "ROBEX 17",
              "subcategories": []
            },
            {
              "id": "excavators-hyundai-robex-18",
              "name": "ROBEX 18",
              "subcategories": []
            },
            {
              "id": "excavators-hyundai-robex-25",
              "name": "ROBEX 25",
              "subcategories": []
            },
            {
              "id": "excavators-hyundai-robex-27",
              "name": "ROBEX 27",
              "subcategories": []
            },
            {
              "id": "excavators-hyundai-robex-30",
              "name": "ROBEX 30",
              "subcategories": []
            },
            {
              "id": "excavators-hyundai-robex-35",
              "name": "ROBEX 35",
              "subcategories": []
            },
            {
              "id": "excavators-hyundai-robex-55",
              "name": "ROBEX 55",
              "subcategories": []
            },
            {
              "id": "excavators-hyundai-robex-60",
              "name": "ROBEX 60",
              "subcategories": []
            },
            {
              "id": "excavators-hyundai-robex-80",
              "name": "ROBEX 80",
              "subcategories": []
            },
            {
              "id": "excavators-hyundai-robex-110",
              "name": "ROBEX 110",
              "subcategories": []
            },
            {
              "id": "excavators-hyundai-robex-125",
              "name": "ROBEX 125",
              "subcategories": []
            },
            {
              "id": "excavators-hyundai-robex-140",
              "name": "ROBEX 140",
              "subcategories": []
            },
            {
              "id": "excavators-hyundai-robex-145",
              "name": "ROBEX 145",
              "subcategories": []
            },
            {
              "id": "excavators-hyundai-robex-150",
              "name": "ROBEX 150",
              "subcategories": []
            },
            {
              "id": "excavators-hyundai-robex-160",
              "name": "ROBEX 160",
              "subcategories": []
            },
            {
              "id": "excavators-hyundai-robex-170",
              "name": "ROBEX 170",
              "subcategories": []
            },
            {
              "id": "excavators-hyundai-robex-180",
              "name": "ROBEX 180",
              "subcategories": []
            },
            {
              "id": "excavators-hyundai-robex-200",
              "name": "ROBEX 200",
              "subcategories": []
            },
            {
              "id": "excavators-hyundai-robex-210",
              "name": "ROBEX 210",
              "subcategories": []
            },
            {
              "id": "excavators-hyundai-robex-215",
              "name": "ROBEX 215",
              "subcategories": []
            },
            {
              "id": "excavators-hyundai-robex-220",
              "name": "ROBEX 220",
              "subcategories": []
            },
            {
              "id": "excavators-hyundai-robex-225",
              "name": "ROBEX 225",
              "subcategories": []
            },
            {
              "id": "excavators-hyundai-robex-235",
              "name": "ROBEX 235",
              "subcategories": []
            },
            {
              "id": "excavators-hyundai-robex-245",
              "name": "ROBEX 245",
              "subcategories": []
            },
            {
              "id": "excavators-hyundai-robex-250",
              "name": "ROBEX 250",
              "subcategories": []
            },
            {
              "id": "excavators-hyundai-robex-260",
              "name": "ROBEX 260",
              "subcategories": []
            },
            {
              "id": "excavators-hyundai-robex-290",
              "name": "ROBEX 290",
              "subcategories": []
            },
            {
              "id": "excavators-hyundai-robex-300",
              "name": "ROBEX 300",
              "subcategories": []
            },
            {
              "id": "excavators-hyundai-robex-305",
              "name": "ROBEX 305",
              "subcategories": []
            },
            {
              "id": "excavators-hyundai-robex-320",
              "name": "ROBEX 320",
              "subcategories": []
            },
            {
              "id": "excavators-hyundai-robex-330",
              "name": "ROBEX 330",
              "subcategories": []
            },
            {
              "id": "excavators-hyundai-robex-335",
              "name": "ROBEX 335",
              "subcategories": []
            },
            {
              "id": "excavators-hyundai-robex-340",
              "name": "ROBEX 340",
              "subcategories": []
            },
            {
              "id": "excavators-hyundai-robex-350",
              "name": "ROBEX 350",
              "subcategories": []
            },
            {
              "id": "excavators-hyundai-robex-360",
              "name": "ROBEX 360",
              "subcategories": []
            },
            {
              "id": "excavators-hyundai-robex-380",
              "name": "ROBEX 380",
              "subcategories": []
            },
            {
              "id": "excavators-hyundai-robex-385",
              "name": "ROBEX 385",
              "subcategories": []
            },
            {
              "id": "excavators-hyundai-robex-430",
              "name": "ROBEX 430",
              "subcategories": []
            },
            {
              "id": "excavators-hyundai-robex-450",
              "name": "ROBEX 450",
              "subcategories": []
            },
            {
              "id": "excavators-hyundai-robex-480",
              "name": "ROBEX 480",
              "subcategories": []
            },
            {
              "id": "excavators-hyundai-robex-485",
              "name": "ROBEX 485",
              "subcategories": []
            },
            {
              "id": "excavators-hyundai-robex-495",
              "name": "ROBEX 495",
              "subcategories": []
            },
            {
              "id": "excavators-hyundai-robex-500",
              "name": "ROBEX 500",
              "subcategories": []
            },
            {
              "id": "excavators-hyundai-robex-520",
              "name": "ROBEX 520",
              "subcategories": []
            },
            {
              "id": "excavators-hyundai-robex-555",
              "name": "ROBEX 555",
              "subcategories": []
            },
            {
              "id": "excavators-hyundai-robex-800",
              "name": "ROBEX 800",
              "subcategories": []
            },
            {
              "id": "excavators-hyundai-robex-1200",
              "name": "ROBEX 1200",
              "subcategories": []
            },
            {
              "id": "excavators-hyundai-robex-1400",
              "name": "ROBEX 1400",
              "subcategories": []
            },
            {
              "id": "excavators-hyundai-robex-2000",
              "name": "ROBEX 2000",
              "subcategories": []
            },
            {
              "id": "excavators-hyundai-robex-2900",
              "name": "ROBEX 2900",
              "subcategories": []
            },
            {
              "id": "excavators-hyundai-robex-3000",
              "name": "ROBEX 3000",
              "subcategories": []
            },
            {
              "id": "excavators-hyundai-robex-3700",
              "name": "ROBEX 3700",
              "subcategories": []
            },
            {
              "id": "excavators-hyundai-robex-4700",
              "name": "ROBEX 4700",
              "subcategories": []
            },
            {
              "id": "excavators-hyundai-robex-8000",
              "name": "ROBEX 8000",
              "subcategories": []
            },
            {
              "id": "excavators-hyundai-other",
              "name": "OTHER",
              "subcategories": []
            }
          ]
        },
        {
          "id": "excavators-sany",
          "name": "Sany",
          "subcategories": [
            {
              "id": "excavators-sany-sy16",
              "name": "SY16",
              "subcategories": []
            },
            {
              "id": "excavators-sany-sy18",
              "name": "SY18",
              "subcategories": []
            },
            {
              "id": "excavators-sany-sy19",
              "name": "SY19",
              "subcategories": []
            },
            {
              "id": "excavators-sany-sy20",
              "name": "SY20",
              "subcategories": []
            },
            {
              "id": "excavators-sany-sy26",
              "name": "SY26",
              "subcategories": []
            },
            {
              "id": "excavators-sany-sy35",
              "name": "SY35",
              "subcategories": []
            },
            {
              "id": "excavators-sany-sy50",
              "name": "SY50",
              "subcategories": []
            },
            {
              "id": "excavators-sany-sy55",
              "name": "SY55",
              "subcategories": []
            },
            {
              "id": "excavators-sany-sy60",
              "name": "SY60",
              "subcategories": []
            },
            {
              "id": "excavators-sany-sy65",
              "name": "SY65",
              "subcategories": []
            },
            {
              "id": "excavators-sany-sy70",
              "name": "SY70",
              "subcategories": []
            },
            {
              "id": "excavators-sany-sy75",
              "name": "SY75",
              "subcategories": []
            },
            {
              "id": "excavators-sany-sy80",
              "name": "SY80",
              "subcategories": []
            },
            {
              "id": "excavators-sany-sy85",
              "name": "SY85",
              "subcategories": []
            },
            {
              "id": "excavators-sany-sy95",
              "name": "SY95",
              "subcategories": []
            },
            {
              "id": "excavators-sany-sy115",
              "name": "SY115",
              "subcategories": []
            },
            {
              "id": "excavators-sany-sy125",
              "name": "SY125",
              "subcategories": []
            },
            {
              "id": "excavators-sany-sy135",
              "name": "SY135",
              "subcategories": []
            },
            {
              "id": "excavators-sany-sy140",
              "name": "SY140",
              "subcategories": []
            },
            {
              "id": "excavators-sany-sy155",
              "name": "SY155",
              "subcategories": []
            },
            {
              "id": "excavators-sany-sy200",
              "name": "SY200",
              "subcategories": []
            },
            {
              "id": "excavators-sany-sy205",
              "name": "SY205",
              "subcategories": []
            },
            {
              "id": "excavators-sany-sy210",
              "name": "SY210",
              "subcategories": []
            },
            {
              "id": "excavators-sany-sy215",
              "name": "SY215",
              "subcategories": []
            },
            {
              "id": "excavators-sany-sy220",
              "name": "SY220",
              "subcategories": []
            },
            {
              "id": "excavators-sany-sy225",
              "name": "SY225",
              "subcategories": []
            },
            {
              "id": "excavators-sany-sy235",
              "name": "SY235",
              "subcategories": []
            },
            {
              "id": "excavators-sany-sy240",
              "name": "SY240",
              "subcategories": []
            },
            {
              "id": "excavators-sany-sy245",
              "name": "SY245",
              "subcategories": []
            },
            {
              "id": "excavators-sany-sy265",
              "name": "SY265",
              "subcategories": []
            },
            {
              "id": "excavators-sany-sy285",
              "name": "SY285",
              "subcategories": []
            },
            {
              "id": "excavators-sany-sy305",
              "name": "SY305",
              "subcategories": []
            },
            {
              "id": "excavators-sany-sy310",
              "name": "SY310",
              "subcategories": []
            },
            {
              "id": "excavators-sany-sy335",
              "name": "SY335",
              "subcategories": []
            },
            {
              "id": "excavators-sany-sy365",
              "name": "SY365",
              "subcategories": []
            },
            {
              "id": "excavators-sany-sy375",
              "name": "SY375",
              "subcategories": []
            },
            {
              "id": "excavators-sany-sy385",
              "name": "SY385",
              "subcategories": []
            },
            {
              "id": "excavators-sany-sy390",
              "name": "SY390",
              "subcategories": []
            },
            {
              "id": "excavators-sany-sy415",
              "name": "SY415",
              "subcategories": []
            },
            {
              "id": "excavators-sany-sy475",
              "name": "SY475",
              "subcategories": []
            },
            {
              "id": "excavators-sany-sy485",
              "name": "SY485",
              "subcategories": []
            },
            {
              "id": "excavators-sany-sy500",
              "name": "SY500",
              "subcategories": []
            },
            {
              "id": "excavators-sany-sy550",
              "name": "SY550",
              "subcategories": []
            },
            {
              "id": "excavators-sany-sy750",
              "name": "SY750",
              "subcategories": []
            },
            {
              "id": "excavators-sany-sy870",
              "name": "SY870",
              "subcategories": []
            },
            {
              "id": "excavators-sany-sy980",
              "name": "SY980",
              "subcategories": []
            },
            {
              "id": "excavators-sany-syc6028",
              "name": "SYC6028",
              "subcategories": []
            },
            {
              "id": "excavators-sany-other",
              "name": "OTHER",
              "subcategories": []
            }
          ]
        },
        {
          "id": "excavators-volvo",
          "name": "Volvo",
          "subcategories": [
            {
              "id": "excavators-volvo-ec15",
              "name": "EC15",
              "subcategories": []
            },
            {
              "id": "excavators-volvo-ec18",
              "name": "EC18",
              "subcategories": []
            },
            {
              "id": "excavators-volvo-ec20",
              "name": "EC20",
              "subcategories": []
            },
            {
              "id": "excavators-volvo-ec25",
              "name": "EC25",
              "subcategories": []
            },
            {
              "id": "excavators-volvo-ec27",
              "name": "EC27",
              "subcategories": []
            },
            {
              "id": "excavators-volvo-ec30",
              "name": "EC30",
              "subcategories": []
            },
            {
              "id": "excavators-volvo-ec35",
              "name": "EC35",
              "subcategories": []
            },
            {
              "id": "excavators-volvo-ec37",
              "name": "EC37",
              "subcategories": []
            },
            {
              "id": "excavators-volvo-ec55",
              "name": "EC55",
              "subcategories": []
            },
            {
              "id": "excavators-volvo-ec60",
              "name": "EC60",
              "subcategories": []
            },
            {
              "id": "excavators-volvo-ec80",
              "name": "EC80",
              "subcategories": []
            },
            {
              "id": "excavators-volvo-ec120",
              "name": "EC120",
              "subcategories": []
            },
            {
              "id": "excavators-volvo-ec140",
              "name": "EC140",
              "subcategories": []
            },
            {
              "id": "excavators-volvo-ec160",
              "name": "EC160",
              "subcategories": []
            },
            {
              "id": "excavators-volvo-ec180",
              "name": "EC180",
              "subcategories": []
            },
            {
              "id": "excavators-volvo-ec200",
              "name": "EC200",
              "subcategories": []
            },
            {
              "id": "excavators-volvo-ec210",
              "name": "EC210",
              "subcategories": []
            },
            {
              "id": "excavators-volvo-ec220",
              "name": "EC220",
              "subcategories": []
            },
            {
              "id": "excavators-volvo-ec230",
              "name": "EC230",
              "subcategories": []
            },
            {
              "id": "excavators-volvo-ec240",
              "name": "EC240",
              "subcategories": []
            },
            {
              "id": "excavators-volvo-ec250",
              "name": "EC250",
              "subcategories": []
            },
            {
              "id": "excavators-volvo-ec280",
              "name": "EC280",
              "subcategories": []
            },
            {
              "id": "excavators-volvo-ec290",
              "name": "EC290",
              "subcategories": []
            },
            {
              "id": "excavators-volvo-ec300",
              "name": "EC300",
              "subcategories": []
            },
            {
              "id": "excavators-volvo-ec330",
              "name": "EC330",
              "subcategories": []
            },
            {
              "id": "excavators-volvo-ec340",
              "name": "EC340",
              "subcategories": []
            },
            {
              "id": "excavators-volvo-ec350",
              "name": "EC350",
              "subcategories": []
            },
            {
              "id": "excavators-volvo-ec360",
              "name": "EC360",
              "subcategories": []
            },
            {
              "id": "excavators-volvo-ec370",
              "name": "EC370",
              "subcategories": []
            },
            {
              "id": "excavators-volvo-ec380",
              "name": "EC380",
              "subcategories": []
            },
            {
              "id": "excavators-volvo-ec400",
              "name": "EC400",
              "subcategories": []
            },
            {
              "id": "excavators-volvo-ec450",
              "name": "EC450",
              "subcategories": []
            },
            {
              "id": "excavators-volvo-ec460",
              "name": "EC460",
              "subcategories": []
            },
            {
              "id": "excavators-volvo-ec480",
              "name": "EC480",
              "subcategories": []
            },
            {
              "id": "excavators-volvo-ec500",
              "name": "EC500",
              "subcategories": []
            },
            {
              "id": "excavators-volvo-ec530",
              "name": "EC530",
              "subcategories": []
            },
            {
              "id": "excavators-volvo-ec550",
              "name": "EC550",
              "subcategories": []
            },
            {
              "id": "excavators-volvo-ec700",
              "name": "EC700",
              "subcategories": []
            },
            {
              "id": "excavators-volvo-ec750",
              "name": "EC750",
              "subcategories": []
            },
            {
              "id": "excavators-volvo-ec950",
              "name": "EC950",
              "subcategories": []
            },
            {
              "id": "excavators-volvo-ecr18",
              "name": "ECR18",
              "subcategories": []
            },
            {
              "id": "excavators-volvo-ecr25",
              "name": "ECR25",
              "subcategories": []
            },
            {
              "id": "excavators-volvo-ecr28",
              "name": "ECR28",
              "subcategories": []
            },
            {
              "id": "excavators-volvo-ecr35",
              "name": "ECR35",
              "subcategories": []
            },
            {
              "id": "excavators-volvo-ecr38",
              "name": "ECR38",
              "subcategories": []
            },
            {
              "id": "excavators-volvo-ecr40",
              "name": "ECR40",
              "subcategories": []
            },
            {
              "id": "excavators-volvo-ecr48",
              "name": "ECR48",
              "subcategories": []
            },
            {
              "id": "excavators-volvo-ecr50",
              "name": "ECR50",
              "subcategories": []
            },
            {
              "id": "excavators-volvo-ecr58",
              "name": "ECR58",
              "subcategories": []
            },
            {
              "id": "excavators-volvo-ecr88",
              "name": "ECR88",
              "subcategories": []
            },
            {
              "id": "excavators-volvo-ecr145",
              "name": "ECR145",
              "subcategories": []
            },
            {
              "id": "excavators-volvo-ecr235",
              "name": "ECR235",
              "subcategories": []
            },
            {
              "id": "excavators-volvo-ecr305",
              "name": "ECR305",
              "subcategories": []
            },
            {
              "id": "excavators-volvo-ecr355",
              "name": "ECR355",
              "subcategories": []
            },
            {
              "id": "excavators-volvo-ew55",
              "name": "EW55",
              "subcategories": []
            },
            {
              "id": "excavators-volvo-ew60",
              "name": "EW60",
              "subcategories": []
            },
            {
              "id": "excavators-volvo-ew140",
              "name": "EW140",
              "subcategories": []
            },
            {
              "id": "excavators-volvo-ew145",
              "name": "EW145",
              "subcategories": []
            },
            {
              "id": "excavators-volvo-ew160",
              "name": "EW160",
              "subcategories": []
            },
            {
              "id": "excavators-volvo-ew170",
              "name": "EW170",
              "subcategories": []
            },
            {
              "id": "excavators-volvo-ew180",
              "name": "EW180",
              "subcategories": []
            },
            {
              "id": "excavators-volvo-ew200",
              "name": "EW200",
              "subcategories": []
            },
            {
              "id": "excavators-volvo-ew205",
              "name": "EW205",
              "subcategories": []
            },
            {
              "id": "excavators-volvo-ew210",
              "name": "EW210",
              "subcategories": []
            },
            {
              "id": "excavators-volvo-ew220",
              "name": "EW220",
              "subcategories": []
            },
            {
              "id": "excavators-volvo-ew240",
              "name": "EW240",
              "subcategories": []
            },
            {
              "id": "excavators-volvo-ewr130",
              "name": "EWR130",
              "subcategories": []
            },
            {
              "id": "excavators-volvo-ewr150",
              "name": "EWR150",
              "subcategories": []
            },
            {
              "id": "excavators-volvo-ewr170",
              "name": "EWR170",
              "subcategories": []
            },
            {
              "id": "excavators-volvo-lg670",
              "name": "LG670",
              "subcategories": []
            },
            {
              "id": "excavators-volvo-mx465",
              "name": "MX465",
              "subcategories": []
            },
            {
              "id": "excavators-volvo-se460",
              "name": "SE460",
              "subcategories": []
            },
            {
              "id": "excavators-volvo-other",
              "name": "OTHER",
              "subcategories": []
            }
          ]
        },
        {
          "id": "excavators-bobcat",
          "name": "Bobcat",
          "subcategories": [
            {
              "id": "excavators-bobcat-220",
              "name": "220",
              "subcategories": []
            },
            {
              "id": "excavators-bobcat-319",
              "name": "319",
              "subcategories": []
            },
            {
              "id": "excavators-bobcat-320",
              "name": "320",
              "subcategories": []
            },
            {
              "id": "excavators-bobcat-322",
              "name": "322",
              "subcategories": []
            },
            {
              "id": "excavators-bobcat-323",
              "name": "323",
              "subcategories": []
            },
            {
              "id": "excavators-bobcat-324",
              "name": "324",
              "subcategories": []
            },
            {
              "id": "excavators-bobcat-325",
              "name": "325",
              "subcategories": []
            },
            {
              "id": "excavators-bobcat-328",
              "name": "328",
              "subcategories": []
            },
            {
              "id": "excavators-bobcat-329",
              "name": "329",
              "subcategories": []
            },
            {
              "id": "excavators-bobcat-331",
              "name": "331",
              "subcategories": []
            },
            {
              "id": "excavators-bobcat-334",
              "name": "334",
              "subcategories": []
            },
            {
              "id": "excavators-bobcat-335",
              "name": "335",
              "subcategories": []
            },
            {
              "id": "excavators-bobcat-337",
              "name": "337",
              "subcategories": []
            },
            {
              "id": "excavators-bobcat-341",
              "name": "341",
              "subcategories": []
            },
            {
              "id": "excavators-bobcat-418",
              "name": "418",
              "subcategories": []
            },
            {
              "id": "excavators-bobcat-425",
              "name": "425",
              "subcategories": []
            },
            {
              "id": "excavators-bobcat-430",
              "name": "430",
              "subcategories": []
            },
            {
              "id": "excavators-bobcat-435",
              "name": "435",
              "subcategories": []
            },
            {
              "id": "excavators-bobcat-442",
              "name": "442",
              "subcategories": []
            },
            {
              "id": "excavators-bobcat-e08",
              "name": "E08",
              "subcategories": []
            },
            {
              "id": "excavators-bobcat-e10",
              "name": "E10",
              "subcategories": []
            },
            {
              "id": "excavators-bobcat-e14",
              "name": "E14",
              "subcategories": []
            },
            {
              "id": "excavators-bobcat-e16",
              "name": "E16",
              "subcategories": []
            },
            {
              "id": "excavators-bobcat-e17",
              "name": "E17",
              "subcategories": []
            },
            {
              "id": "excavators-bobcat-e19",
              "name": "E19",
              "subcategories": []
            },
            {
              "id": "excavators-bobcat-e20",
              "name": "E20",
              "subcategories": []
            },
            {
              "id": "excavators-bobcat-e26",
              "name": "E26",
              "subcategories": []
            },
            {
              "id": "excavators-bobcat-e27",
              "name": "E27",
              "subcategories": []
            },
            {
              "id": "excavators-bobcat-e32",
              "name": "E32",
              "subcategories": []
            },
            {
              "id": "excavators-bobcat-e34",
              "name": "E34",
              "subcategories": []
            },
            {
              "id": "excavators-bobcat-e35",
              "name": "E35",
              "subcategories": []
            },
            {
              "id": "excavators-bobcat-e38",
              "name": "E38",
              "subcategories": []
            },
            {
              "id": "excavators-bobcat-e40",
              "name": "E40",
              "subcategories": []
            },
            {
              "id": "excavators-bobcat-e42",
              "name": "E42",
              "subcategories": []
            },
            {
              "id": "excavators-bobcat-e45",
              "name": "E45",
              "subcategories": []
            },
            {
              "id": "excavators-bobcat-e48",
              "name": "E48",
              "subcategories": []
            },
            {
              "id": "excavators-bobcat-e50",
              "name": "E50",
              "subcategories": []
            },
            {
              "id": "excavators-bobcat-e55",
              "name": "E55",
              "subcategories": []
            },
            {
              "id": "excavators-bobcat-e57",
              "name": "E57",
              "subcategories": []
            },
            {
              "id": "excavators-bobcat-e60",
              "name": "E60",
              "subcategories": []
            },
            {
              "id": "excavators-bobcat-e62",
              "name": "E62",
              "subcategories": []
            },
            {
              "id": "excavators-bobcat-e63",
              "name": "E63",
              "subcategories": []
            },
            {
              "id": "excavators-bobcat-e80",
              "name": "E80",
              "subcategories": []
            },
            {
              "id": "excavators-bobcat-e85",
              "name": "E85",
              "subcategories": []
            },
            {
              "id": "excavators-bobcat-e88",
              "name": "E88",
              "subcategories": []
            },
            {
              "id": "excavators-bobcat-e145",
              "name": "E145",
              "subcategories": []
            },
            {
              "id": "excavators-bobcat-e165",
              "name": "E165",
              "subcategories": []
            },
            {
              "id": "excavators-bobcat-e220",
              "name": "E220",
              "subcategories": []
            },
            {
              "id": "excavators-bobcat-x231",
              "name": "X231",
              "subcategories": []
            },
            {
              "id": "excavators-bobcat-x331",
              "name": "X331",
              "subcategories": []
            },
            {
              "id": "excavators-bobcat-other",
              "name": "OTHER",
              "subcategories": []
            }
          ]
        },
        {
          "id": "excavators-yanmar",
          "name": "Yanmar",
          "subcategories": [
            {
              "id": "excavators-yanmar-b2",
              "name": "B2",
              "subcategories": []
            },
            {
              "id": "excavators-yanmar-b3",
              "name": "B3",
              "subcategories": []
            },
            {
              "id": "excavators-yanmar-b4",
              "name": "B4",
              "subcategories": []
            },
            {
              "id": "excavators-yanmar-b5",
              "name": "B5",
              "subcategories": []
            },
            {
              "id": "excavators-yanmar-b6",
              "name": "B6",
              "subcategories": []
            },
            {
              "id": "excavators-yanmar-b7",
              "name": "B7",
              "subcategories": []
            },
            {
              "id": "excavators-yanmar-b12",
              "name": "B12",
              "subcategories": []
            },
            {
              "id": "excavators-yanmar-b27",
              "name": "B27",
              "subcategories": []
            },
            {
              "id": "excavators-yanmar-b30",
              "name": "B30",
              "subcategories": []
            },
            {
              "id": "excavators-yanmar-b50",
              "name": "B50",
              "subcategories": []
            },
            {
              "id": "excavators-yanmar-b75",
              "name": "B75",
              "subcategories": []
            },
            {
              "id": "excavators-yanmar-b95",
              "name": "B95",
              "subcategories": []
            },
            {
              "id": "excavators-yanmar-sv08",
              "name": "SV08",
              "subcategories": []
            },
            {
              "id": "excavators-yanmar-sv15",
              "name": "SV15",
              "subcategories": []
            },
            {
              "id": "excavators-yanmar-sv16",
              "name": "SV16",
              "subcategories": []
            },
            {
              "id": "excavators-yanmar-sv17",
              "name": "SV17",
              "subcategories": []
            },
            {
              "id": "excavators-yanmar-sv18",
              "name": "SV18",
              "subcategories": []
            },
            {
              "id": "excavators-yanmar-sv19",
              "name": "SV19",
              "subcategories": []
            },
            {
              "id": "excavators-yanmar-sv22",
              "name": "SV22",
              "subcategories": []
            },
            {
              "id": "excavators-yanmar-sv26",
              "name": "SV26",
              "subcategories": []
            },
            {
              "id": "excavators-yanmar-sv40",
              "name": "SV40",
              "subcategories": []
            },
            {
              "id": "excavators-yanmar-sv60",
              "name": "SV60",
              "subcategories": []
            },
            {
              "id": "excavators-yanmar-sv86",
              "name": "SV86",
              "subcategories": []
            },
            {
              "id": "excavators-yanmar-sv100",
              "name": "SV100",
              "subcategories": []
            },
            {
              "id": "excavators-yanmar-sv120",
              "name": "SV120",
              "subcategories": []
            },
            {
              "id": "excavators-yanmar-vio10",
              "name": "VIO10",
              "subcategories": []
            },
            {
              "id": "excavators-yanmar-vio12",
              "name": "VIO12",
              "subcategories": []
            },
            {
              "id": "excavators-yanmar-vio15",
              "name": "VIO15",
              "subcategories": []
            },
            {
              "id": "excavators-yanmar-vio17",
              "name": "VIO17",
              "subcategories": []
            },
            {
              "id": "excavators-yanmar-vio20",
              "name": "VIO20",
              "subcategories": []
            },
            {
              "id": "excavators-yanmar-vio22",
              "name": "VIO22",
              "subcategories": []
            },
            {
              "id": "excavators-yanmar-vio23",
              "name": "VIO23",
              "subcategories": []
            },
            {
              "id": "excavators-yanmar-vio25",
              "name": "VIO25",
              "subcategories": []
            },
            {
              "id": "excavators-yanmar-vio26",
              "name": "VIO26",
              "subcategories": []
            },
            {
              "id": "excavators-yanmar-vio27",
              "name": "VIO27",
              "subcategories": []
            },
            {
              "id": "excavators-yanmar-vio30",
              "name": "VIO30",
              "subcategories": []
            },
            {
              "id": "excavators-yanmar-vio33",
              "name": "VIO33",
              "subcategories": []
            },
            {
              "id": "excavators-yanmar-vio35",
              "name": "VIO35",
              "subcategories": []
            },
            {
              "id": "excavators-yanmar-vio38",
              "name": "VIO38",
              "subcategories": []
            },
            {
              "id": "excavators-yanmar-vio40",
              "name": "VIO40",
              "subcategories": []
            },
            {
              "id": "excavators-yanmar-vio45",
              "name": "VIO45",
              "subcategories": []
            },
            {
              "id": "excavators-yanmar-vio50",
              "name": "VIO50",
              "subcategories": []
            },
            {
              "id": "excavators-yanmar-vio55",
              "name": "VIO55",
              "subcategories": []
            },
            {
              "id": "excavators-yanmar-vio57",
              "name": "VIO57",
              "subcategories": []
            },
            {
              "id": "excavators-yanmar-vio70",
              "name": "VIO70",
              "subcategories": []
            },
            {
              "id": "excavators-yanmar-vio75",
              "name": "VIO75",
              "subcategories": []
            },
            {
              "id": "excavators-yanmar-vio80",
              "name": "VIO80",
              "subcategories": []
            },
            {
              "id": "excavators-yanmar-vio82",
              "name": "VIO82",
              "subcategories": []
            },
            {
              "id": "excavators-yanmar-vio85",
              "name": "VIO85",
              "subcategories": []
            },
            {
              "id": "excavators-yanmar-yb101",
              "name": "YB101",
              "subcategories": []
            },
            {
              "id": "excavators-yanmar-yb401",
              "name": "YB401",
              "subcategories": []
            },
            {
              "id": "excavators-yanmar-other",
              "name": "OTHER",
              "subcategories": []
            }
          ]
        },
        {
          "id": "excavators-takeuchi",
          "name": "Takeuchi",
          "subcategories": [
            {
              "id": "excavators-takeuchi-tb014",
              "name": "TB014",
              "subcategories": []
            },
            {
              "id": "excavators-takeuchi-tb016",
              "name": "TB016",
              "subcategories": []
            },
            {
              "id": "excavators-takeuchi-tb025",
              "name": "TB025",
              "subcategories": []
            },
            {
              "id": "excavators-takeuchi-tb070",
              "name": "TB070",
              "subcategories": []
            },
            {
              "id": "excavators-takeuchi-tb20",
              "name": "TB20",
              "subcategories": []
            },
            {
              "id": "excavators-takeuchi-tb23",
              "name": "TB23",
              "subcategories": []
            },
            {
              "id": "excavators-takeuchi-tb53",
              "name": "TB53",
              "subcategories": []
            },
            {
              "id": "excavators-takeuchi-tb108",
              "name": "TB108",
              "subcategories": []
            },
            {
              "id": "excavators-takeuchi-tb125",
              "name": "TB125",
              "subcategories": []
            },
            {
              "id": "excavators-takeuchi-tb135",
              "name": "TB135",
              "subcategories": []
            },
            {
              "id": "excavators-takeuchi-tb138",
              "name": "TB138",
              "subcategories": []
            },
            {
              "id": "excavators-takeuchi-tb145",
              "name": "TB145",
              "subcategories": []
            },
            {
              "id": "excavators-takeuchi-tb150",
              "name": "TB150",
              "subcategories": []
            },
            {
              "id": "excavators-takeuchi-tb153",
              "name": "TB153",
              "subcategories": []
            },
            {
              "id": "excavators-takeuchi-tb175",
              "name": "TB175",
              "subcategories": []
            },
            {
              "id": "excavators-takeuchi-tb180",
              "name": "TB180",
              "subcategories": []
            },
            {
              "id": "excavators-takeuchi-tb210",
              "name": "TB210",
              "subcategories": []
            },
            {
              "id": "excavators-takeuchi-tb215",
              "name": "TB215",
              "subcategories": []
            },
            {
              "id": "excavators-takeuchi-tb216",
              "name": "TB216",
              "subcategories": []
            },
            {
              "id": "excavators-takeuchi-tb217",
              "name": "TB217",
              "subcategories": []
            },
            {
              "id": "excavators-takeuchi-tb219",
              "name": "TB219",
              "subcategories": []
            },
            {
              "id": "excavators-takeuchi-tb225",
              "name": "TB225",
              "subcategories": []
            },
            {
              "id": "excavators-takeuchi-tb228",
              "name": "TB228",
              "subcategories": []
            },
            {
              "id": "excavators-takeuchi-tb230",
              "name": "TB230",
              "subcategories": []
            },
            {
              "id": "excavators-takeuchi-tb235",
              "name": "TB235",
              "subcategories": []
            },
            {
              "id": "excavators-takeuchi-tb240",
              "name": "TB240",
              "subcategories": []
            },
            {
              "id": "excavators-takeuchi-tb250",
              "name": "TB250",
              "subcategories": []
            },
            {
              "id": "excavators-takeuchi-tb257",
              "name": "TB257",
              "subcategories": []
            },
            {
              "id": "excavators-takeuchi-tb260",
              "name": "TB260",
              "subcategories": []
            },
            {
              "id": "excavators-takeuchi-tb280",
              "name": "TB280",
              "subcategories": []
            },
            {
              "id": "excavators-takeuchi-tb285",
              "name": "TB285",
              "subcategories": []
            },
            {
              "id": "excavators-takeuchi-tb290",
              "name": "TB290",
              "subcategories": []
            },
            {
              "id": "excavators-takeuchi-tb295",
              "name": "TB295",
              "subcategories": []
            },
            {
              "id": "excavators-takeuchi-tb325",
              "name": "TB325",
              "subcategories": []
            },
            {
              "id": "excavators-takeuchi-tb335",
              "name": "TB335",
              "subcategories": []
            },
            {
              "id": "excavators-takeuchi-tb350",
              "name": "TB350",
              "subcategories": []
            },
            {
              "id": "excavators-takeuchi-tb370",
              "name": "TB370",
              "subcategories": []
            },
            {
              "id": "excavators-takeuchi-tb395",
              "name": "TB395",
              "subcategories": []
            },
            {
              "id": "excavators-takeuchi-tb1140",
              "name": "TB1140",
              "subcategories": []
            },
            {
              "id": "excavators-takeuchi-tb1160",
              "name": "TB1160",
              "subcategories": []
            },
            {
              "id": "excavators-takeuchi-tb2150",
              "name": "TB2150",
              "subcategories": []
            },
            {
              "id": "excavators-takeuchi-other",
              "name": "OTHER",
              "subcategories": []
            }
          ]
        },
        {
          "id": "excavators-xcmg",
          "name": "Xcmg",
          "subcategories": [
            {
              "id": "excavators-xcmg-xe10",
              "name": "XE10",
              "subcategories": []
            },
            {
              "id": "excavators-xcmg-xe17",
              "name": "XE17",
              "subcategories": []
            },
            {
              "id": "excavators-xcmg-xe18",
              "name": "XE18",
              "subcategories": []
            },
            {
              "id": "excavators-xcmg-xe19",
              "name": "XE19",
              "subcategories": []
            },
            {
              "id": "excavators-xcmg-xe20",
              "name": "XE20",
              "subcategories": []
            },
            {
              "id": "excavators-xcmg-xe26",
              "name": "XE26",
              "subcategories": []
            },
            {
              "id": "excavators-xcmg-xe27",
              "name": "XE27",
              "subcategories": []
            },
            {
              "id": "excavators-xcmg-xe30",
              "name": "XE30",
              "subcategories": []
            },
            {
              "id": "excavators-xcmg-xe35",
              "name": "XE35",
              "subcategories": []
            },
            {
              "id": "excavators-xcmg-xe45",
              "name": "XE45",
              "subcategories": []
            },
            {
              "id": "excavators-xcmg-xe55",
              "name": "XE55",
              "subcategories": []
            },
            {
              "id": "excavators-xcmg-xe60",
              "name": "XE60",
              "subcategories": []
            },
            {
              "id": "excavators-xcmg-xe75",
              "name": "XE75",
              "subcategories": []
            },
            {
              "id": "excavators-xcmg-xe80",
              "name": "XE80",
              "subcategories": []
            },
            {
              "id": "excavators-xcmg-xe85",
              "name": "XE85",
              "subcategories": []
            },
            {
              "id": "excavators-xcmg-xe90",
              "name": "XE90",
              "subcategories": []
            },
            {
              "id": "excavators-xcmg-xe105",
              "name": "XE105",
              "subcategories": []
            },
            {
              "id": "excavators-xcmg-xe115",
              "name": "XE115",
              "subcategories": []
            },
            {
              "id": "excavators-xcmg-xe135",
              "name": "XE135",
              "subcategories": []
            },
            {
              "id": "excavators-xcmg-xe150",
              "name": "XE150",
              "subcategories": []
            },
            {
              "id": "excavators-xcmg-xe155",
              "name": "XE155",
              "subcategories": []
            },
            {
              "id": "excavators-xcmg-xe160",
              "name": "XE160",
              "subcategories": []
            },
            {
              "id": "excavators-xcmg-xe200",
              "name": "XE200",
              "subcategories": []
            },
            {
              "id": "excavators-xcmg-xe205",
              "name": "XE205",
              "subcategories": []
            },
            {
              "id": "excavators-xcmg-xe210",
              "name": "XE210",
              "subcategories": []
            },
            {
              "id": "excavators-xcmg-xe215",
              "name": "XE215",
              "subcategories": []
            },
            {
              "id": "excavators-xcmg-xe220",
              "name": "XE220",
              "subcategories": []
            },
            {
              "id": "excavators-xcmg-xe225",
              "name": "XE225",
              "subcategories": []
            },
            {
              "id": "excavators-xcmg-xe230",
              "name": "XE230",
              "subcategories": []
            },
            {
              "id": "excavators-xcmg-xe235",
              "name": "XE235",
              "subcategories": []
            },
            {
              "id": "excavators-xcmg-xe245",
              "name": "XE245",
              "subcategories": []
            },
            {
              "id": "excavators-xcmg-xe250",
              "name": "XE250",
              "subcategories": []
            },
            {
              "id": "excavators-xcmg-xe260",
              "name": "XE260",
              "subcategories": []
            },
            {
              "id": "excavators-xcmg-xe265",
              "name": "XE265",
              "subcategories": []
            },
            {
              "id": "excavators-xcmg-xe270",
              "name": "XE270",
              "subcategories": []
            },
            {
              "id": "excavators-xcmg-xe300",
              "name": "XE300",
              "subcategories": []
            },
            {
              "id": "excavators-xcmg-xe305",
              "name": "XE305",
              "subcategories": []
            },
            {
              "id": "excavators-xcmg-xe310",
              "name": "XE310",
              "subcategories": []
            },
            {
              "id": "excavators-xcmg-xe335",
              "name": "XE335",
              "subcategories": []
            },
            {
              "id": "excavators-xcmg-xe360",
              "name": "XE360",
              "subcategories": []
            },
            {
              "id": "excavators-xcmg-xe370",
              "name": "XE370",
              "subcategories": []
            },
            {
              "id": "excavators-xcmg-xe380",
              "name": "XE380",
              "subcategories": []
            },
            {
              "id": "excavators-xcmg-xe390",
              "name": "XE390",
              "subcategories": []
            },
            {
              "id": "excavators-xcmg-xe470",
              "name": "XE470",
              "subcategories": []
            },
            {
              "id": "excavators-xcmg-xe490",
              "name": "XE490",
              "subcategories": []
            },
            {
              "id": "excavators-xcmg-xe500",
              "name": "XE500",
              "subcategories": []
            },
            {
              "id": "excavators-xcmg-xe550",
              "name": "XE550",
              "subcategories": []
            },
            {
              "id": "excavators-xcmg-xe580",
              "name": "XE580",
              "subcategories": []
            },
            {
              "id": "excavators-xcmg-xe600",
              "name": "XE600",
              "subcategories": []
            },
            {
              "id": "excavators-xcmg-xe650",
              "name": "XE650",
              "subcategories": []
            },
            {
              "id": "excavators-xcmg-xe690",
              "name": "XE690",
              "subcategories": []
            },
            {
              "id": "excavators-xcmg-xe700",
              "name": "XE700",
              "subcategories": []
            },
            {
              "id": "excavators-xcmg-xe800",
              "name": "XE800",
              "subcategories": []
            },
            {
              "id": "excavators-xcmg-xe900",
              "name": "XE900",
              "subcategories": []
            },
            {
              "id": "excavators-xcmg-xe950",
              "name": "XE950",
              "subcategories": []
            },
            {
              "id": "excavators-xcmg-xe1050",
              "name": "XE1050",
              "subcategories": []
            },
            {
              "id": "excavators-xcmg-xe1250",
              "name": "XE1250",
              "subcategories": []
            },
            {
              "id": "excavators-xcmg-xe1300",
              "name": "XE1300",
              "subcategories": []
            },
            {
              "id": "excavators-xcmg-xe1350",
              "name": "XE1350",
              "subcategories": []
            },
            {
              "id": "excavators-xcmg-xe2000",
              "name": "XE2000",
              "subcategories": []
            },
            {
              "id": "excavators-xcmg-xe3000",
              "name": "XE3000",
              "subcategories": []
            },
            {
              "id": "excavators-xcmg-xe4000",
              "name": "XE4000",
              "subcategories": []
            },
            {
              "id": "excavators-xcmg-xe5600",
              "name": "XE5600",
              "subcategories": []
            },
            {
              "id": "excavators-xcmg-xe7000",
              "name": "XE7000",
              "subcategories": []
            },
            {
              "id": "excavators-xcmg-xmh70",
              "name": "XMH70",
              "subcategories": []
            },
            {
              "id": "excavators-xcmg-xe600",
              "name": "XE600",
              "subcategories": []
            },
            {
              "id": "excavators-xcmg-other",
              "name": "OTHER",
              "subcategories": []
            }
          ]
        },
        {
          "id": "excavators-new-hoplland",
          "name": "New Hoplland",
          "subcategories": []
        },
        {
          "id": "excavators-link-belt",
          "name": "Link Belt",
          "subcategories": [
            {
              "id": "excavators-link-belt-75",
              "name": "75",
              "subcategories": []
            },
            {
              "id": "excavators-link-belt-80",
              "name": "80",
              "subcategories": []
            },
            {
              "id": "excavators-link-belt-130",
              "name": "130",
              "subcategories": []
            },
            {
              "id": "excavators-link-belt-135",
              "name": "135",
              "subcategories": []
            },
            {
              "id": "excavators-link-belt-145",
              "name": "145",
              "subcategories": []
            },
            {
              "id": "excavators-link-belt-160",
              "name": "160",
              "subcategories": []
            },
            {
              "id": "excavators-link-belt-170",
              "name": "170",
              "subcategories": []
            },
            {
              "id": "excavators-link-belt-190",
              "name": "190",
              "subcategories": []
            },
            {
              "id": "excavators-link-belt-210",
              "name": "210",
              "subcategories": []
            },
            {
              "id": "excavators-link-belt-220",
              "name": "220",
              "subcategories": []
            },
            {
              "id": "excavators-link-belt-225",
              "name": "225",
              "subcategories": []
            },
            {
              "id": "excavators-link-belt-235",
              "name": "235",
              "subcategories": []
            },
            {
              "id": "excavators-link-belt-240",
              "name": "240",
              "subcategories": []
            },
            {
              "id": "excavators-link-belt-245",
              "name": "245",
              "subcategories": []
            },
            {
              "id": "excavators-link-belt-250",
              "name": "250",
              "subcategories": []
            },
            {
              "id": "excavators-link-belt-260",
              "name": "260",
              "subcategories": []
            },
            {
              "id": "excavators-link-belt-290",
              "name": "290",
              "subcategories": []
            },
            {
              "id": "excavators-link-belt-300",
              "name": "300",
              "subcategories": []
            },
            {
              "id": "excavators-link-belt-324",
              "name": "324",
              "subcategories": []
            },
            {
              "id": "excavators-link-belt-330",
              "name": "330",
              "subcategories": []
            },
            {
              "id": "excavators-link-belt-350",
              "name": "350",
              "subcategories": []
            },
            {
              "id": "excavators-link-belt-355",
              "name": "355",
              "subcategories": []
            },
            {
              "id": "excavators-link-belt-370",
              "name": "370",
              "subcategories": []
            },
            {
              "id": "excavators-link-belt-460",
              "name": "460",
              "subcategories": []
            },
            {
              "id": "excavators-link-belt-470",
              "name": "470",
              "subcategories": []
            },
            {
              "id": "excavators-link-belt-490",
              "name": "490",
              "subcategories": []
            },
            {
              "id": "excavators-link-belt-700",
              "name": "700",
              "subcategories": []
            },
            {
              "id": "excavators-link-belt-750",
              "name": "750",
              "subcategories": []
            },
            {
              "id": "excavators-link-belt-800",
              "name": "800",
              "subcategories": []
            },
            {
              "id": "excavators-link-belt-2800",
              "name": "2800",
              "subcategories": []
            },
            {
              "id": "excavators-link-belt-3400",
              "name": "3400",
              "subcategories": []
            },
            {
              "id": "excavators-link-belt-3740",
              "name": "3740",
              "subcategories": []
            },
            {
              "id": "excavators-link-belt-4040",
              "name": "4040",
              "subcategories": []
            },
            {
              "id": "excavators-link-belt-4300",
              "name": "4300",
              "subcategories": []
            },
            {
              "id": "excavators-link-belt-5800",
              "name": "5800",
              "subcategories": []
            },
            {
              "id": "excavators-link-belt-ls2800",
              "name": "LS2800",
              "subcategories": []
            },
            {
              "id": "excavators-link-belt-ls43000",
              "name": "LS43000",
              "subcategories": []
            },
            {
              "id": "excavators-link-belt-ls5800",
              "name": "LS5800",
              "subcategories": []
            },
            {
              "id": "excavators-link-belt-other",
              "name": "OTHER",
              "subcategories": []
            }
          ]
        },
        {
          "id": "excavators-liebherr",
          "name": "Liebherr",
          "subcategories": [
            {
              "id": "excavators-liebherr-a308",
              "name": "A308",
              "subcategories": []
            },
            {
              "id": "excavators-liebherr-a309",
              "name": "A309",
              "subcategories": []
            },
            {
              "id": "excavators-liebherr-a310",
              "name": "A310",
              "subcategories": []
            },
            {
              "id": "excavators-liebherr-a311",
              "name": "A311",
              "subcategories": []
            },
            {
              "id": "excavators-liebherr-a312",
              "name": "A312",
              "subcategories": []
            },
            {
              "id": "excavators-liebherr-a314",
              "name": "A314",
              "subcategories": []
            },
            {
              "id": "excavators-liebherr-a316",
              "name": "A316",
              "subcategories": []
            },
            {
              "id": "excavators-liebherr-a900",
              "name": "A900",
              "subcategories": []
            },
            {
              "id": "excavators-liebherr-a901",
              "name": "A901",
              "subcategories": []
            },
            {
              "id": "excavators-liebherr-a902",
              "name": "A902",
              "subcategories": []
            },
            {
              "id": "excavators-liebherr-a904",
              "name": "A904",
              "subcategories": []
            },
            {
              "id": "excavators-liebherr-a910",
              "name": "A910",
              "subcategories": []
            },
            {
              "id": "excavators-liebherr-a913",
              "name": "A913",
              "subcategories": []
            },
            {
              "id": "excavators-liebherr-a914",
              "name": "A914",
              "subcategories": []
            },
            {
              "id": "excavators-liebherr-a916",
              "name": "A916",
              "subcategories": []
            },
            {
              "id": "excavators-liebherr-a918",
              "name": "A918",
              "subcategories": []
            },
            {
              "id": "excavators-liebherr-a920",
              "name": "A920",
              "subcategories": []
            },
            {
              "id": "excavators-liebherr-a922",
              "name": "A922",
              "subcategories": []
            },
            {
              "id": "excavators-liebherr-a924",
              "name": "A924",
              "subcategories": []
            },
            {
              "id": "excavators-liebherr-a934",
              "name": "A934",
              "subcategories": []
            },
            {
              "id": "excavators-liebherr-a944",
              "name": "A944",
              "subcategories": []
            },
            {
              "id": "excavators-liebherr-a954",
              "name": "A954",
              "subcategories": []
            },
            {
              "id": "excavators-liebherr-lh30",
              "name": "LH30",
              "subcategories": []
            },
            {
              "id": "excavators-liebherr-r317",
              "name": "R317",
              "subcategories": []
            },
            {
              "id": "excavators-liebherr-r900",
              "name": "R900",
              "subcategories": []
            },
            {
              "id": "excavators-liebherr-r906",
              "name": "R906",
              "subcategories": []
            },
            {
              "id": "excavators-liebherr-r912",
              "name": "R912",
              "subcategories": []
            },
            {
              "id": "excavators-liebherr-r914",
              "name": "R914",
              "subcategories": []
            },
            {
              "id": "excavators-liebherr-r916",
              "name": "R916",
              "subcategories": []
            },
            {
              "id": "excavators-liebherr-r920",
              "name": "R920",
              "subcategories": []
            },
            {
              "id": "excavators-liebherr-r921",
              "name": "R921",
              "subcategories": []
            },
            {
              "id": "excavators-liebherr-r922",
              "name": "R922",
              "subcategories": []
            },
            {
              "id": "excavators-liebherr-r924",
              "name": "R924",
              "subcategories": []
            },
            {
              "id": "excavators-liebherr-r926",
              "name": "R926",
              "subcategories": []
            },
            {
              "id": "excavators-liebherr-r930",
              "name": "R930",
              "subcategories": []
            },
            {
              "id": "excavators-liebherr-r932",
              "name": "R932",
              "subcategories": []
            },
            {
              "id": "excavators-liebherr-r934",
              "name": "R934",
              "subcategories": []
            },
            {
              "id": "excavators-liebherr-r936",
              "name": "R936",
              "subcategories": []
            },
            {
              "id": "excavators-liebherr-r938",
              "name": "R938",
              "subcategories": []
            },
            {
              "id": "excavators-liebherr-r942",
              "name": "R942",
              "subcategories": []
            },
            {
              "id": "excavators-liebherr-r944",
              "name": "R944",
              "subcategories": []
            },
            {
              "id": "excavators-liebherr-r945",
              "name": "R945",
              "subcategories": []
            },
            {
              "id": "excavators-liebherr-r946",
              "name": "R946",
              "subcategories": []
            },
            {
              "id": "excavators-liebherr-r950",
              "name": "R950",
              "subcategories": []
            },
            {
              "id": "excavators-liebherr-r952",
              "name": "R952",
              "subcategories": []
            },
            {
              "id": "excavators-liebherr-r954",
              "name": "R954",
              "subcategories": []
            },
            {
              "id": "excavators-liebherr-r956",
              "name": "R956",
              "subcategories": []
            },
            {
              "id": "excavators-liebherr-r960",
              "name": "R960",
              "subcategories": []
            },
            {
              "id": "excavators-liebherr-r962",
              "name": "R962",
              "subcategories": []
            },
            {
              "id": "excavators-liebherr-r964",
              "name": "R964",
              "subcategories": []
            },
            {
              "id": "excavators-liebherr-r966",
              "name": "R966",
              "subcategories": []
            },
            {
              "id": "excavators-liebherr-r974",
              "name": "R974",
              "subcategories": []
            },
            {
              "id": "excavators-liebherr-r976",
              "name": "R976",
              "subcategories": []
            },
            {
              "id": "excavators-liebherr-r980",
              "name": "R980",
              "subcategories": []
            },
            {
              "id": "excavators-liebherr-r984",
              "name": "R984",
              "subcategories": []
            },
            {
              "id": "excavators-liebherr-r994",
              "name": "R994",
              "subcategories": []
            },
            {
              "id": "excavators-liebherr-r996",
              "name": "R996",
              "subcategories": []
            },
            {
              "id": "excavators-liebherr-r9100",
              "name": "R9100",
              "subcategories": []
            },
            {
              "id": "excavators-liebherr-r9150",
              "name": "R9150",
              "subcategories": []
            },
            {
              "id": "excavators-liebherr-r9200",
              "name": "R9200",
              "subcategories": []
            },
            {
              "id": "excavators-liebherr-r9350",
              "name": "R9350",
              "subcategories": []
            },
            {
              "id": "excavators-liebherr-other",
              "name": "OTHER",
              "subcategories": []
            }
          ]
        },
        {
          "id": "excavators-case",
          "name": "Case",
          "subcategories": [
            {
              "id": "excavators-case-16",
              "name": "16",
              "subcategories": []
            },
            {
              "id": "excavators-case-31",
              "name": "31",
              "subcategories": []
            },
            {
              "id": "excavators-case-788",
              "name": "788",
              "subcategories": []
            },
            {
              "id": "excavators-case-880",
              "name": "880",
              "subcategories": []
            },
            {
              "id": "excavators-case-888",
              "name": "888",
              "subcategories": []
            },
            {
              "id": "excavators-case-1088",
              "name": "1088",
              "subcategories": []
            },
            {
              "id": "excavators-case-1188",
              "name": "1188",
              "subcategories": []
            },
            {
              "id": "excavators-case-1288",
              "name": "1288",
              "subcategories": []
            },
            {
              "id": "excavators-case-9007",
              "name": "9007",
              "subcategories": []
            },
            {
              "id": "excavators-case-9010",
              "name": "9010",
              "subcategories": []
            },
            {
              "id": "excavators-case-9020",
              "name": "9020",
              "subcategories": []
            },
            {
              "id": "excavators-case-9021",
              "name": "9021",
              "subcategories": []
            },
            {
              "id": "excavators-case-9030",
              "name": "9030",
              "subcategories": []
            },
            {
              "id": "excavators-case-9040",
              "name": "9040",
              "subcategories": []
            },
            {
              "id": "excavators-case-9046",
              "name": "9046",
              "subcategories": []
            },
            {
              "id": "excavators-case-9050",
              "name": "9050",
              "subcategories": []
            },
            {
              "id": "excavators-case-cx12",
              "name": "CX12",
              "subcategories": []
            },
            {
              "id": "excavators-case-cx14",
              "name": "CX14",
              "subcategories": []
            },
            {
              "id": "excavators-case-cx15",
              "name": "CX15",
              "subcategories": []
            },
            {
              "id": "excavators-case-cx17",
              "name": "CX17",
              "subcategories": []
            },
            {
              "id": "excavators-case-cx18",
              "name": "CX18",
              "subcategories": []
            },
            {
              "id": "excavators-case-cx19",
              "name": "CX19",
              "subcategories": []
            },
            {
              "id": "excavators-case-cx20",
              "name": "CX20",
              "subcategories": []
            },
            {
              "id": "excavators-case-cx22",
              "name": "CX22",
              "subcategories": []
            },
            {
              "id": "excavators-case-cx23",
              "name": "CX23",
              "subcategories": []
            },
            {
              "id": "excavators-case-cx25",
              "name": "CX25",
              "subcategories": []
            },
            {
              "id": "excavators-case-cx26",
              "name": "CX26",
              "subcategories": []
            },
            {
              "id": "excavators-case-cx27",
              "name": "CX27",
              "subcategories": []
            },
            {
              "id": "excavators-case-cx30",
              "name": "CX30",
              "subcategories": []
            },
            {
              "id": "excavators-case-cx31",
              "name": "CX31",
              "subcategories": []
            },
            {
              "id": "excavators-case-cx33",
              "name": "CX33",
              "subcategories": []
            },
            {
              "id": "excavators-case-cx34",
              "name": "CX34",
              "subcategories": []
            },
            {
              "id": "excavators-case-cx35",
              "name": "CX35",
              "subcategories": []
            },
            {
              "id": "excavators-case-cx36",
              "name": "CX36",
              "subcategories": []
            },
            {
              "id": "excavators-case-cx37",
              "name": "CX37",
              "subcategories": []
            },
            {
              "id": "excavators-case-cx38",
              "name": "CX38",
              "subcategories": []
            },
            {
              "id": "excavators-case-cx42",
              "name": "CX42",
              "subcategories": []
            },
            {
              "id": "excavators-case-cx45",
              "name": "CX45",
              "subcategories": []
            },
            {
              "id": "excavators-case-cx50",
              "name": "CX50",
              "subcategories": []
            },
            {
              "id": "excavators-case-cx55",
              "name": "CX55",
              "subcategories": []
            },
            {
              "id": "excavators-case-cx57",
              "name": "CX57",
              "subcategories": []
            },
            {
              "id": "excavators-case-cx60",
              "name": "CX60",
              "subcategories": []
            },
            {
              "id": "excavators-case-cx65",
              "name": "CX65",
              "subcategories": []
            },
            {
              "id": "excavators-case-cx70",
              "name": "CX70",
              "subcategories": []
            },
            {
              "id": "excavators-case-cx75",
              "name": "CX75",
              "subcategories": []
            },
            {
              "id": "excavators-case-cx80",
              "name": "CX80",
              "subcategories": []
            },
            {
              "id": "excavators-case-cx85",
              "name": "CX85",
              "subcategories": []
            },
            {
              "id": "excavators-case-cx90",
              "name": "CX90",
              "subcategories": []
            },
            {
              "id": "excavators-case-cx130",
              "name": "CX130",
              "subcategories": []
            },
            {
              "id": "excavators-case-cx140",
              "name": "CX140",
              "subcategories": []
            },
            {
              "id": "excavators-case-cx145",
              "name": "CX145",
              "subcategories": []
            },
            {
              "id": "excavators-case-cx160",
              "name": "CX160",
              "subcategories": []
            },
            {
              "id": "excavators-case-cx170",
              "name": "CX170",
              "subcategories": []
            },
            {
              "id": "excavators-case-cx180",
              "name": "CX180",
              "subcategories": []
            },
            {
              "id": "excavators-case-cx190",
              "name": "CX190",
              "subcategories": []
            },
            {
              "id": "excavators-case-cx210",
              "name": "CX210",
              "subcategories": []
            },
            {
              "id": "excavators-case-cx220",
              "name": "CX220",
              "subcategories": []
            },
            {
              "id": "excavators-case-cx225",
              "name": "CX225",
              "subcategories": []
            },
            {
              "id": "excavators-case-cx235",
              "name": "CX235",
              "subcategories": []
            },
            {
              "id": "excavators-case-cx240",
              "name": "CX240",
              "subcategories": []
            },
            {
              "id": "excavators-case-cx245",
              "name": "CX245",
              "subcategories": []
            },
            {
              "id": "excavators-case-cx250",
              "name": "CX250",
              "subcategories": []
            },
            {
              "id": "excavators-case-cx260",
              "name": "CX260",
              "subcategories": []
            },
            {
              "id": "excavators-case-cx290",
              "name": "CX290",
              "subcategories": []
            },
            {
              "id": "excavators-case-cx300",
              "name": "CX300",
              "subcategories": []
            },
            {
              "id": "excavators-case-cx330",
              "name": "CX330",
              "subcategories": []
            },
            {
              "id": "excavators-case-cx350",
              "name": "CX350",
              "subcategories": []
            },
            {
              "id": "excavators-case-cx365",
              "name": "CX365",
              "subcategories": []
            },
            {
              "id": "excavators-case-cx370",
              "name": "CX370",
              "subcategories": []
            },
            {
              "id": "excavators-case-cx380",
              "name": "CX380",
              "subcategories": []
            },
            {
              "id": "excavators-case-cx460",
              "name": "CX460",
              "subcategories": []
            },
            {
              "id": "excavators-case-cx470",
              "name": "CX470",
              "subcategories": []
            },
            {
              "id": "excavators-case-cx490",
              "name": "CX490",
              "subcategories": []
            },
            {
              "id": "excavators-case-cx500",
              "name": "CX500",
              "subcategories": []
            },
            {
              "id": "excavators-case-cx750",
              "name": "CX750",
              "subcategories": []
            },
            {
              "id": "excavators-case-wx95",
              "name": "WX95",
              "subcategories": []
            },
            {
              "id": "excavators-case-wx125",
              "name": "WX125",
              "subcategories": []
            },
            {
              "id": "excavators-case-wx140",
              "name": "WX140",
              "subcategories": []
            },
            {
              "id": "excavators-case-wx145",
              "name": "WX145",
              "subcategories": []
            },
            {
              "id": "excavators-case-wx150",
              "name": "WX150",
              "subcategories": []
            },
            {
              "id": "excavators-case-wx155",
              "name": "WX155",
              "subcategories": []
            },
            {
              "id": "excavators-case-wx160",
              "name": "WX160",
              "subcategories": []
            },
            {
              "id": "excavators-case-wx165",
              "name": "WX165",
              "subcategories": []
            },
            {
              "id": "excavators-case-wx175",
              "name": "WX175",
              "subcategories": []
            },
            {
              "id": "excavators-case-wx200",
              "name": "WX200",
              "subcategories": []
            },
            {
              "id": "excavators-case-wx210",
              "name": "WX210",
              "subcategories": []
            },
            {
              "id": "excavators-case-other",
              "name": "OTHER",
              "subcategories": []
            }
          ]
        },
        {
          "id": "excavators-develon",
          "name": "Develon",
          "subcategories": [
            {
              "id": "excavators-develon-dx10",
              "name": "DX10",
              "subcategories": []
            },
            {
              "id": "excavators-develon-dx17",
              "name": "DX17",
              "subcategories": []
            },
            {
              "id": "excavators-develon-dx19",
              "name": "DX19",
              "subcategories": []
            },
            {
              "id": "excavators-develon-dx20",
              "name": "DX20",
              "subcategories": []
            },
            {
              "id": "excavators-develon-dx27",
              "name": "DX27",
              "subcategories": []
            },
            {
              "id": "excavators-develon-dx32",
              "name": "DX32",
              "subcategories": []
            },
            {
              "id": "excavators-develon-dx35",
              "name": "DX35",
              "subcategories": []
            },
            {
              "id": "excavators-develon-dx42",
              "name": "DX42",
              "subcategories": []
            },
            {
              "id": "excavators-develon-dx50",
              "name": "DX50",
              "subcategories": []
            },
            {
              "id": "excavators-develon-dx55",
              "name": "DX55",
              "subcategories": []
            },
            {
              "id": "excavators-develon-dx60",
              "name": "DX60",
              "subcategories": []
            },
            {
              "id": "excavators-develon-dx62",
              "name": "DX62",
              "subcategories": []
            },
            {
              "id": "excavators-develon-dx63",
              "name": "DX63",
              "subcategories": []
            },
            {
              "id": "excavators-develon-dx75",
              "name": "DX75",
              "subcategories": []
            },
            {
              "id": "excavators-develon-dx80",
              "name": "DX80",
              "subcategories": []
            },
            {
              "id": "excavators-develon-dx85",
              "name": "DX85",
              "subcategories": []
            },
            {
              "id": "excavators-develon-dx89",
              "name": "DX89",
              "subcategories": []
            },
            {
              "id": "excavators-develon-dx100",
              "name": "DX100",
              "subcategories": []
            },
            {
              "id": "excavators-develon-dx125",
              "name": "DX125",
              "subcategories": []
            },
            {
              "id": "excavators-develon-dx140",
              "name": "DX140",
              "subcategories": []
            },
            {
              "id": "excavators-develon-dx150",
              "name": "DX150",
              "subcategories": []
            },
            {
              "id": "excavators-develon-dx160",
              "name": "DX160",
              "subcategories": []
            },
            {
              "id": "excavators-develon-dx170",
              "name": "DX170",
              "subcategories": []
            },
            {
              "id": "excavators-develon-dx180",
              "name": "DX180",
              "subcategories": []
            },
            {
              "id": "excavators-develon-dx190",
              "name": "DX190",
              "subcategories": []
            },
            {
              "id": "excavators-develon-dx200",
              "name": "DX200",
              "subcategories": []
            },
            {
              "id": "excavators-develon-dx205",
              "name": "DX205",
              "subcategories": []
            },
            {
              "id": "excavators-develon-dx210",
              "name": "DX210",
              "subcategories": []
            },
            {
              "id": "excavators-develon-dx215",
              "name": "DX215",
              "subcategories": []
            },
            {
              "id": "excavators-develon-dx220",
              "name": "DX220",
              "subcategories": []
            },
            {
              "id": "excavators-develon-dx225",
              "name": "DX225",
              "subcategories": []
            },
            {
              "id": "excavators-develon-dx235",
              "name": "DX235",
              "subcategories": []
            },
            {
              "id": "excavators-develon-dx245",
              "name": "DX245",
              "subcategories": []
            },
            {
              "id": "excavators-develon-dx255",
              "name": "DX255",
              "subcategories": []
            },
            {
              "id": "excavators-develon-dx300",
              "name": "DX300",
              "subcategories": []
            },
            {
              "id": "excavators-develon-dx350",
              "name": "DX350",
              "subcategories": []
            },
            {
              "id": "excavators-develon-dx350",
              "name": "DX350",
              "subcategories": []
            },
            {
              "id": "excavators-develon-dx360",
              "name": "DX360",
              "subcategories": []
            },
            {
              "id": "excavators-develon-dx380",
              "name": "DX380",
              "subcategories": []
            },
            {
              "id": "excavators-develon-dx420",
              "name": "DX420",
              "subcategories": []
            },
            {
              "id": "excavators-develon-dx490",
              "name": "DX490",
              "subcategories": []
            },
            {
              "id": "excavators-develon-dx530",
              "name": "DX530",
              "subcategories": []
            },
            {
              "id": "excavators-develon-other",
              "name": "OTHER",
              "subcategories": []
            }
          ]
        },
        {
          "id": "excavators-doosan",
          "name": "Doosan",
          "subcategories": [
            {
              "id": "excavators-doosan-dh55",
              "name": "DH55",
              "subcategories": []
            },
            {
              "id": "excavators-doosan-dh60",
              "name": "DH60",
              "subcategories": []
            },
            {
              "id": "excavators-doosan-dh80",
              "name": "DH80",
              "subcategories": []
            },
            {
              "id": "excavators-doosan-dh150",
              "name": "DH150",
              "subcategories": []
            },
            {
              "id": "excavators-doosan-dh210",
              "name": "DH210",
              "subcategories": []
            },
            {
              "id": "excavators-doosan-dh215",
              "name": "DH215",
              "subcategories": []
            },
            {
              "id": "excavators-doosan-dh220",
              "name": "DH220",
              "subcategories": []
            },
            {
              "id": "excavators-doosan-dh225",
              "name": "DH225",
              "subcategories": []
            },
            {
              "id": "excavators-doosan-dh300",
              "name": "DH300",
              "subcategories": []
            },
            {
              "id": "excavators-doosan-dh420",
              "name": "DH420",
              "subcategories": []
            },
            {
              "id": "excavators-doosan-dx10",
              "name": "DX10",
              "subcategories": []
            },
            {
              "id": "excavators-doosan-dx17",
              "name": "DX17",
              "subcategories": []
            },
            {
              "id": "excavators-doosan-dx19",
              "name": "DX19",
              "subcategories": []
            },
            {
              "id": "excavators-doosan-dx27",
              "name": "DX27",
              "subcategories": []
            },
            {
              "id": "excavators-doosan-dx35",
              "name": "DX35",
              "subcategories": []
            },
            {
              "id": "excavators-doosan-dx42",
              "name": "DX42",
              "subcategories": []
            },
            {
              "id": "excavators-doosan-dx50",
              "name": "DX50",
              "subcategories": []
            },
            {
              "id": "excavators-doosan-dx55",
              "name": "DX55",
              "subcategories": []
            },
            {
              "id": "excavators-doosan-dx57",
              "name": "DX57",
              "subcategories": []
            },
            {
              "id": "excavators-doosan-dx60",
              "name": "DX60",
              "subcategories": []
            },
            {
              "id": "excavators-doosan-dx62",
              "name": "DX62",
              "subcategories": []
            },
            {
              "id": "excavators-doosan-dx63",
              "name": "DX63",
              "subcategories": []
            },
            {
              "id": "excavators-doosan-dx65",
              "name": "DX65",
              "subcategories": []
            },
            {
              "id": "excavators-doosan-dx75",
              "name": "DX75",
              "subcategories": []
            },
            {
              "id": "excavators-doosan-dx80",
              "name": "DX80",
              "subcategories": []
            },
            {
              "id": "excavators-doosan-dx85",
              "name": "DX85",
              "subcategories": []
            },
            {
              "id": "excavators-doosan-dx89",
              "name": "DX89",
              "subcategories": []
            },
            {
              "id": "excavators-doosan-dx100",
              "name": "DX100",
              "subcategories": []
            },
            {
              "id": "excavators-doosan-dx120",
              "name": "DX120",
              "subcategories": []
            },
            {
              "id": "excavators-doosan-dx140",
              "name": "DX140",
              "subcategories": []
            },
            {
              "id": "excavators-doosan-dx150",
              "name": "DX150",
              "subcategories": []
            },
            {
              "id": "excavators-doosan-dx160",
              "name": "DX160",
              "subcategories": []
            },
            {
              "id": "excavators-doosan-dx165",
              "name": "DX165",
              "subcategories": []
            },
            {
              "id": "excavators-doosan-dx170",
              "name": "DX170",
              "subcategories": []
            },
            {
              "id": "excavators-doosan-dx180",
              "name": "DX180",
              "subcategories": []
            },
            {
              "id": "excavators-doosan-dx190",
              "name": "DX190",
              "subcategories": []
            },
            {
              "id": "excavators-doosan-dx210",
              "name": "DX210",
              "subcategories": []
            },
            {
              "id": "excavators-doosan-dx220",
              "name": "DX220",
              "subcategories": []
            },
            {
              "id": "excavators-doosan-dx225",
              "name": "DX225",
              "subcategories": []
            },
            {
              "id": "excavators-doosan-dx235",
              "name": "DX235",
              "subcategories": []
            },
            {
              "id": "excavators-doosan-dx240",
              "name": "DX240",
              "subcategories": []
            },
            {
              "id": "excavators-doosan-dx255",
              "name": "DX255",
              "subcategories": []
            },
            {
              "id": "excavators-doosan-dx260",
              "name": "DX260",
              "subcategories": []
            },
            {
              "id": "excavators-doosan-dx300",
              "name": "DX300",
              "subcategories": []
            },
            {
              "id": "excavators-doosan-dx305",
              "name": "DX305",
              "subcategories": []
            },
            {
              "id": "excavators-doosan-dx340",
              "name": "DX340",
              "subcategories": []
            },
            {
              "id": "excavators-doosan-dx345",
              "name": "DX345",
              "subcategories": []
            },
            {
              "id": "excavators-doosan-dx350",
              "name": "DX350",
              "subcategories": []
            },
            {
              "id": "excavators-doosan-dx360",
              "name": "DX360",
              "subcategories": []
            },
            {
              "id": "excavators-doosan-dx380",
              "name": "DX380",
              "subcategories": []
            },
            {
              "id": "excavators-doosan-dx400",
              "name": "DX400",
              "subcategories": []
            },
            {
              "id": "excavators-doosan-dx420",
              "name": "DX420",
              "subcategories": []
            },
            {
              "id": "excavators-doosan-dx480",
              "name": "DX480",
              "subcategories": []
            },
            {
              "id": "excavators-doosan-dx490",
              "name": "DX490",
              "subcategories": []
            },
            {
              "id": "excavators-doosan-dx500",
              "name": "DX500",
              "subcategories": []
            },
            {
              "id": "excavators-doosan-dx530",
              "name": "DX530",
              "subcategories": []
            },
            {
              "id": "excavators-doosan-dx550",
              "name": "DX550",
              "subcategories": []
            },
            {
              "id": "excavators-doosan-dx700",
              "name": "DX700",
              "subcategories": []
            },
            {
              "id": "excavators-doosan-dx800",
              "name": "DX800",
              "subcategories": []
            },
            {
              "id": "excavators-doosan-solar-55",
              "name": "SOLAR 55",
              "subcategories": []
            },
            {
              "id": "excavators-doosan-solar-75",
              "name": "SOLAR 75",
              "subcategories": []
            },
            {
              "id": "excavators-doosan-solar-175",
              "name": "SOLAR 175",
              "subcategories": []
            },
            {
              "id": "excavators-doosan-solar-220",
              "name": "SOLAR 220",
              "subcategories": []
            },
            {
              "id": "excavators-doosan-solar-225",
              "name": "SOLAR 225",
              "subcategories": []
            },
            {
              "id": "excavators-doosan-solar-300",
              "name": "SOLAR 300",
              "subcategories": []
            },
            {
              "id": "excavators-doosan-other",
              "name": "OTHER",
              "subcategories": []
            }
          ]
        }
      ]
    },
    {
      "id": "forklifts",
      "name": "Forklifts",
      "subcategories": [
        {
          "id": "forklifts-toyota",
          "name": "Toyota",
          "subcategories": [
            {
              "id": "forklifts-toyota-02fg",
              "name": "02FG",
              "subcategories": []
            },
            {
              "id": "forklifts-toyota-022fd",
              "name": "022FD",
              "subcategories": []
            },
            {
              "id": "forklifts-toyota-022fg",
              "name": "022FG",
              "subcategories": []
            },
            {
              "id": "forklifts-toyota-025fd",
              "name": "025FD",
              "subcategories": []
            },
            {
              "id": "forklifts-toyota-025fg",
              "name": "025FG",
              "subcategories": []
            },
            {
              "id": "forklifts-toyota-026fd",
              "name": "026FD",
              "subcategories": []
            },
            {
              "id": "forklifts-toyota-026fdf",
              "name": "026FDF",
              "subcategories": []
            },
            {
              "id": "forklifts-toyota-027fd",
              "name": "027FD",
              "subcategories": []
            },
            {
              "id": "forklifts-toyota-027fdf",
              "name": "027FDF",
              "subcategories": []
            },
            {
              "id": "forklifts-toyota-027fg",
              "name": "027FG",
              "subcategories": []
            },
            {
              "id": "forklifts-toyota-028fdf",
              "name": "028FDF",
              "subcategories": []
            },
            {
              "id": "forklifts-toyota-028fgf",
              "name": "028FGF",
              "subcategories": []
            },
            {
              "id": "forklifts-toyota-028fgjf",
              "name": "028FGJF",
              "subcategories": []
            },
            {
              "id": "forklifts-toyota-028fgk",
              "name": "028FGK",
              "subcategories": []
            },
            {
              "id": "forklifts-toyota-tonero",
              "name": "TONERO",
              "subcategories": []
            },
            {
              "id": "forklifts-toyota-2fb",
              "name": "2FB",
              "subcategories": []
            },
            {
              "id": "forklifts-toyota-2fd",
              "name": "2FD",
              "subcategories": []
            },
            {
              "id": "forklifts-toyota-2fg",
              "name": "2FG",
              "subcategories": []
            },
            {
              "id": "forklifts-toyota-2fgc",
              "name": "2FGC",
              "subcategories": []
            },
            {
              "id": "forklifts-toyota-2thd",
              "name": "2THD",
              "subcategories": []
            },
            {
              "id": "forklifts-toyota-3fb",
              "name": "3FB",
              "subcategories": []
            },
            {
              "id": "forklifts-toyota-3fd",
              "name": "3FD",
              "subcategories": []
            },
            {
              "id": "forklifts-toyota-4fg",
              "name": "4FG",
              "subcategories": []
            },
            {
              "id": "forklifts-toyota-5fbcu",
              "name": "5FBCU",
              "subcategories": []
            },
            {
              "id": "forklifts-toyota-5fbe",
              "name": "5FBE",
              "subcategories": []
            },
            {
              "id": "forklifts-toyota-5fd",
              "name": "5FD",
              "subcategories": []
            },
            {
              "id": "forklifts-toyota-5fgc",
              "name": "5FGC",
              "subcategories": []
            },
            {
              "id": "forklifts-toyota-5fgc",
              "name": "5FGC",
              "subcategories": []
            },
            {
              "id": "forklifts-toyota-6bncu",
              "name": "6BNCU",
              "subcategories": []
            },
            {
              "id": "forklifts-toyota-6bpu",
              "name": "6BPU",
              "subcategories": []
            },
            {
              "id": "forklifts-toyota-6bru",
              "name": "6BRU",
              "subcategories": []
            },
            {
              "id": "forklifts-toyota-6bwc",
              "name": "6BWC",
              "subcategories": []
            },
            {
              "id": "forklifts-toyota-6wbr",
              "name": "6WBR",
              "subcategories": []
            },
            {
              "id": "forklifts-toyota-6bwr",
              "name": "6BWR",
              "subcategories": []
            },
            {
              "id": "forklifts-toyota-6bws",
              "name": "6BWS",
              "subcategories": []
            },
            {
              "id": "forklifts-toyota-6fbre",
              "name": "6FBRE",
              "subcategories": []
            },
            {
              "id": "forklifts-toyota-6fdf",
              "name": "6FDF",
              "subcategories": []
            },
            {
              "id": "forklifts-toyota-6fgc",
              "name": "6FGC",
              "subcategories": []
            },
            {
              "id": "forklifts-toyota-6fgu",
              "name": "6FGU",
              "subcategories": []
            },
            {
              "id": "forklifts-toyota-7bncu",
              "name": "7BNCU",
              "subcategories": []
            },
            {
              "id": "forklifts-toyota-7bpue",
              "name": "7BPUE",
              "subcategories": []
            },
            {
              "id": "forklifts-toyota-7bru",
              "name": "7BRU",
              "subcategories": []
            },
            {
              "id": "forklifts-toyota-7fbef",
              "name": "7FBEF",
              "subcategories": []
            },
            {
              "id": "forklifts-toyota-7fb",
              "name": "7FB",
              "subcategories": []
            },
            {
              "id": "forklifts-toyota-7fbcu",
              "name": "7FBCU",
              "subcategories": []
            },
            {
              "id": "forklifts-toyota-7fbe",
              "name": "7FBE",
              "subcategories": []
            },
            {
              "id": "forklifts-toyota-7fbef",
              "name": "7FBEF",
              "subcategories": []
            },
            {
              "id": "forklifts-toyota-7fbeu",
              "name": "7FBEU",
              "subcategories": []
            },
            {
              "id": "forklifts-toyota-7fbh",
              "name": "7FBH",
              "subcategories": []
            },
            {
              "id": "forklifts-toyota-7fbmf",
              "name": "7FBMF",
              "subcategories": []
            },
            {
              "id": "forklifts-toyota-7fbr",
              "name": "7FBR",
              "subcategories": []
            },
            {
              "id": "forklifts-toyota-7fd",
              "name": "7FD",
              "subcategories": []
            },
            {
              "id": "forklifts-toyota-7fda",
              "name": "7FDA",
              "subcategories": []
            },
            {
              "id": "forklifts-toyota-7fdku",
              "name": "7FDKU",
              "subcategories": []
            },
            {
              "id": "forklifts-toyota-7fdn",
              "name": "7FDN",
              "subcategories": []
            },
            {
              "id": "forklifts-toyota-7fdu",
              "name": "7FDU",
              "subcategories": []
            },
            {
              "id": "forklifts-toyota-7fg",
              "name": "7FG",
              "subcategories": []
            },
            {
              "id": "forklifts-toyota-7fgau",
              "name": "7FGAU",
              "subcategories": []
            },
            {
              "id": "forklifts-toyota-7fgcu",
              "name": "7FGCU",
              "subcategories": []
            },
            {
              "id": "forklifts-toyota-7fgcsu20",
              "name": "7FGCSU20",
              "subcategories": []
            },
            {
              "id": "forklifts-toyota-7gfku",
              "name": "7GFKU",
              "subcategories": []
            },
            {
              "id": "forklifts-toyota-7gfl",
              "name": "7GFL",
              "subcategories": []
            },
            {
              "id": "forklifts-toyota-7fgu",
              "name": "7FGU",
              "subcategories": []
            },
            {
              "id": "forklifts-toyota-7hbw23",
              "name": "7HBW23",
              "subcategories": []
            },
            {
              "id": "forklifts-toyota-8bdru",
              "name": "8BDRU",
              "subcategories": []
            },
            {
              "id": "forklifts-toyota-8bncu",
              "name": "8BNCU",
              "subcategories": []
            },
            {
              "id": "forklifts-toyota-8bpue",
              "name": "8BPUE",
              "subcategories": []
            },
            {
              "id": "forklifts-toyota-8bru",
              "name": "8BRU",
              "subcategories": []
            },
            {
              "id": "forklifts-toyota-8bws",
              "name": "8BWS",
              "subcategories": []
            },
            {
              "id": "forklifts-toyota-8fb",
              "name": "8FB",
              "subcategories": []
            },
            {
              "id": "forklifts-toyota-8fbc",
              "name": "8FBC",
              "subcategories": []
            },
            {
              "id": "forklifts-toyota-8fbchu",
              "name": "8FBCHU",
              "subcategories": []
            },
            {
              "id": "forklifts-toyota-8fbcu",
              "name": "8FBCU",
              "subcategories": []
            },
            {
              "id": "forklifts-toyota-8fbe",
              "name": "8FBE",
              "subcategories": []
            },
            {
              "id": "forklifts-toyota-8fbek",
              "name": "8FBEK",
              "subcategories": []
            },
            {
              "id": "forklifts-toyota-8fbet",
              "name": "8FBET",
              "subcategories": []
            },
            {
              "id": "forklifts-toyota-8fbm",
              "name": "8FBM",
              "subcategories": []
            },
            {
              "id": "forklifts-toyota-8fbmkt",
              "name": "8FBMKT",
              "subcategories": []
            },
            {
              "id": "forklifts-toyota-8fbmt",
              "name": "8FBMT",
              "subcategories": []
            },
            {
              "id": "forklifts-toyota-8fd",
              "name": "8FD",
              "subcategories": []
            },
            {
              "id": "forklifts-toyota-8fdf",
              "name": "8FDF",
              "subcategories": []
            },
            {
              "id": "forklifts-toyota-8fdu",
              "name": "8FDU",
              "subcategories": []
            },
            {
              "id": "forklifts-toyota-8fgc",
              "name": "8FGC",
              "subcategories": []
            },
            {
              "id": "forklifts-toyota-8fgcu",
              "name": "8FGCU",
              "subcategories": []
            },
            {
              "id": "forklifts-toyota-8fgu",
              "name": "8FGU",
              "subcategories": []
            },
            {
              "id": "forklifts-toyota-8hbc",
              "name": "8HBC",
              "subcategories": []
            },
            {
              "id": "forklifts-toyota-8hbe",
              "name": "8HBE",
              "subcategories": []
            },
            {
              "id": "forklifts-toyota-8hbw",
              "name": "8HBW",
              "subcategories": []
            },
            {
              "id": "forklifts-toyota-9bdru",
              "name": "9BDRU",
              "subcategories": []
            },
            {
              "id": "forklifts-toyota-9bru",
              "name": "9BRU",
              "subcategories": []
            },
            {
              "id": "forklifts-toyota-9fbh",
              "name": "9FBH",
              "subcategories": []
            },
            {
              "id": "forklifts-toyota-9fbm",
              "name": "9FBM",
              "subcategories": []
            },
            {
              "id": "forklifts-toyota-305fbcu25",
              "name": "305FBCU25",
              "subcategories": []
            },
            {
              "id": "forklifts-toyota-307fbcu",
              "name": "307FBCU",
              "subcategories": []
            },
            {
              "id": "forklifts-toyota-328fg",
              "name": "328FG",
              "subcategories": []
            },
            {
              "id": "forklifts-toyota-408fd",
              "name": "408FD",
              "subcategories": []
            },
            {
              "id": "forklifts-toyota-424fg",
              "name": "424FG",
              "subcategories": []
            },
            {
              "id": "forklifts-toyota-425fg",
              "name": "425FG",
              "subcategories": []
            },
            {
              "id": "forklifts-toyota-425fgf",
              "name": "425FGF",
              "subcategories": []
            },
            {
              "id": "forklifts-toyota-426fg",
              "name": "426FG",
              "subcategories": []
            },
            {
              "id": "forklifts-toyota-426fgcu",
              "name": "426FGCU",
              "subcategories": []
            },
            {
              "id": "forklifts-toyota-426fgu",
              "name": "426FGU",
              "subcategories": []
            },
            {
              "id": "forklifts-toyota-427fd",
              "name": "427FD",
              "subcategories": []
            },
            {
              "id": "forklifts-toyota-427fg",
              "name": "427FG",
              "subcategories": []
            },
            {
              "id": "forklifts-toyota-505fd60",
              "name": "505FD60",
              "subcategories": []
            },
            {
              "id": "forklifts-toyota-508fgcu",
              "name": "508FGCU",
              "subcategories": []
            },
            {
              "id": "forklifts-toyota-508fgu",
              "name": "508FGU",
              "subcategories": []
            },
            {
              "id": "forklifts-toyota-526fgcu",
              "name": "526FGCU",
              "subcategories": []
            },
            {
              "id": "forklifts-toyota-526fgu",
              "name": "526FGU",
              "subcategories": []
            },
            {
              "id": "forklifts-toyota-528fdf",
              "name": "528FDF",
              "subcategories": []
            },
            {
              "id": "forklifts-toyota-528fdjf",
              "name": "528FDJF",
              "subcategories": []
            },
            {
              "id": "forklifts-toyota-626fdf",
              "name": "626FDF",
              "subcategories": []
            },
            {
              "id": "forklifts-toyota-626fdf",
              "name": "626FDF",
              "subcategories": []
            },
            {
              "id": "forklifts-toyota-627fdf",
              "name": "627FDF",
              "subcategories": []
            },
            {
              "id": "forklifts-toyota-628fd",
              "name": "628FD",
              "subcategories": []
            },
            {
              "id": "forklifts-toyota-728fd30",
              "name": "728FD30",
              "subcategories": []
            },
            {
              "id": "forklifts-toyota-bt",
              "name": "BT",
              "subcategories": []
            },
            {
              "id": "forklifts-toyota-fbmf",
              "name": "FBMF",
              "subcategories": []
            },
            {
              "id": "forklifts-toyota-fd",
              "name": "FD",
              "subcategories": []
            },
            {
              "id": "forklifts-toyota-fdzn30",
              "name": "FDZN30",
              "subcategories": []
            },
            {
              "id": "forklifts-toyota-fg",
              "name": "FG",
              "subcategories": []
            },
            {
              "id": "forklifts-toyota-fgc35",
              "name": "FGC35",
              "subcategories": []
            },
            {
              "id": "forklifts-toyota-geneo",
              "name": "GENEO",
              "subcategories": []
            },
            {
              "id": "forklifts-toyota-kx5h54",
              "name": "KX5H54",
              "subcategories": []
            },
            {
              "id": "forklifts-toyota-lhe130",
              "name": "LHE130",
              "subcategories": []
            },
            {
              "id": "forklifts-toyota-lpe200",
              "name": "LPE200",
              "subcategories": []
            },
            {
              "id": "forklifts-toyota-rf1-bh",
              "name": "RF1-BH",
              "subcategories": []
            },
            {
              "id": "forklifts-toyota-rre",
              "name": "RRE",
              "subcategories": []
            },
            {
              "id": "forklifts-toyota-sll",
              "name": "SLL",
              "subcategories": []
            },
            {
              "id": "forklifts-toyota-spe",
              "name": "SPE",
              "subcategories": []
            },
            {
              "id": "forklifts-toyota-swe",
              "name": "SWE",
              "subcategories": []
            },
            {
              "id": "forklifts-toyota-thd",
              "name": "THD",
              "subcategories": []
            },
            {
              "id": "forklifts-toyota-thda",
              "name": "THDA",
              "subcategories": []
            },
            {
              "id": "forklifts-toyota-thdc",
              "name": "THDC",
              "subcategories": []
            },
            {
              "id": "forklifts-toyota-thdm",
              "name": "THDM",
              "subcategories": []
            },
            {
              "id": "forklifts-toyota-toramax",
              "name": "TORAMAX",
              "subcategories": []
            },
            {
              "id": "forklifts-toyota-other",
              "name": "OTHER",
              "subcategories": []
            }
          ]
        },
        {
          "id": "forklifts-hyster",
          "name": "Hyster",
          "subcategories": [
            {
              "id": "forklifts-hyster-30tx",
              "name": "30TX",
              "subcategories": []
            },
            {
              "id": "forklifts-hyster-50lp",
              "name": "50LP",
              "subcategories": []
            },
            {
              "id": "forklifts-hyster-a1",
              "name": "A1",
              "subcategories": []
            },
            {
              "id": "forklifts-hyster-a24",
              "name": "A24",
              "subcategories": []
            },
            {
              "id": "forklifts-hyster-b60",
              "name": "B60",
              "subcategories": []
            },
            {
              "id": "forklifts-hyster-b80",
              "name": "B80",
              "subcategories": []
            },
            {
              "id": "forklifts-hyster-be80zhd",
              "name": "BE80ZHD",
              "subcategories": []
            },
            {
              "id": "forklifts-hyster-be100zhd",
              "name": "BE100ZHD",
              "subcategories": []
            },
            {
              "id": "forklifts-hyster-c1-5",
              "name": "C1.5",
              "subcategories": []
            },
            {
              "id": "forklifts-hyster-challenger-80",
              "name": "CHALLENGER 80",
              "subcategories": []
            },
            {
              "id": "forklifts-hyster-challenger-150",
              "name": "CHALLENGER 150",
              "subcategories": []
            },
            {
              "id": "forklifts-hyster-e1-75",
              "name": "E1.75",
              "subcategories": []
            },
            {
              "id": "forklifts-hyster-e2-50",
              "name": "E2.50",
              "subcategories": []
            },
            {
              "id": "forklifts-hyster-e2-5",
              "name": "E2.5",
              "subcategories": []
            },
            {
              "id": "forklifts-hyster-e3-2",
              "name": "E3.2",
              "subcategories": []
            },
            {
              "id": "forklifts-hyster-e5-5",
              "name": "E5.5",
              "subcategories": []
            },
            {
              "id": "forklifts-hyster-e5-50",
              "name": "E5.50",
              "subcategories": []
            },
            {
              "id": "forklifts-hyster-e25",
              "name": "E25",
              "subcategories": []
            },
            {
              "id": "forklifts-hyster-e30",
              "name": "E30",
              "subcategories": []
            },
            {
              "id": "forklifts-hyster-e35",
              "name": "E35",
              "subcategories": []
            },
            {
              "id": "forklifts-hyster-e40",
              "name": "E40",
              "subcategories": []
            },
            {
              "id": "forklifts-hyster-e45",
              "name": "E45",
              "subcategories": []
            },
            {
              "id": "forklifts-hyster-e50",
              "name": "E50",
              "subcategories": []
            },
            {
              "id": "forklifts-hyster-e55",
              "name": "E55",
              "subcategories": []
            },
            {
              "id": "forklifts-hyster-e60",
              "name": "E60",
              "subcategories": []
            },
            {
              "id": "forklifts-hyster-e65",
              "name": "E65",
              "subcategories": []
            },
            {
              "id": "forklifts-hyster-e70",
              "name": "E70",
              "subcategories": []
            },
            {
              "id": "forklifts-hyster-e80",
              "name": "E80",
              "subcategories": []
            },
            {
              "id": "forklifts-hyster-e100",
              "name": "E100",
              "subcategories": []
            },
            {
              "id": "forklifts-hyster-e120",
              "name": "E120",
              "subcategories": []
            },
            {
              "id": "forklifts-hyster-h1-25",
              "name": "H1.25",
              "subcategories": []
            },
            {
              "id": "forklifts-hyster-h1-8",
              "name": "H1.8",
              "subcategories": []
            },
            {
              "id": "forklifts-hyster-h2-0",
              "name": "H2.0",
              "subcategories": []
            },
            {
              "id": "forklifts-hyster-h2-5",
              "name": "H2.5",
              "subcategories": []
            },
            {
              "id": "forklifts-hyster-h2-50",
              "name": "H2.50",
              "subcategories": []
            },
            {
              "id": "forklifts-hyster-h3-0",
              "name": "H3.0",
              "subcategories": []
            },
            {
              "id": "forklifts-hyster-h3-00",
              "name": "H3.00",
              "subcategories": []
            },
            {
              "id": "forklifts-hyster-h3-20",
              "name": "H3.20",
              "subcategories": []
            },
            {
              "id": "forklifts-hyster-h3-5",
              "name": "H3.5",
              "subcategories": []
            },
            {
              "id": "forklifts-hyster-h4-00",
              "name": "H4.00",
              "subcategories": []
            },
            {
              "id": "forklifts-hyster-h4-0",
              "name": "H4.0",
              "subcategories": []
            },
            {
              "id": "forklifts-hyster-h4-5",
              "name": "H4.5",
              "subcategories": []
            },
            {
              "id": "forklifts-hyster-h5-00",
              "name": "H5.00",
              "subcategories": []
            },
            {
              "id": "forklifts-hyster-h5-0",
              "name": "H5.0",
              "subcategories": []
            },
            {
              "id": "forklifts-hyster-h5-50",
              "name": "H5.50",
              "subcategories": []
            },
            {
              "id": "forklifts-hyster-h5-5",
              "name": "H5.5",
              "subcategories": []
            },
            {
              "id": "forklifts-hyster-h6-0",
              "name": "H6.0",
              "subcategories": []
            },
            {
              "id": "forklifts-hyster-h7-0",
              "name": "H7.0",
              "subcategories": []
            },
            {
              "id": "forklifts-hyster-h7-00",
              "name": "H7.00",
              "subcategories": []
            },
            {
              "id": "forklifts-hyster-h8-0",
              "name": "H8.0",
              "subcategories": []
            },
            {
              "id": "forklifts-hyster-h8-00",
              "name": "H8.00",
              "subcategories": []
            },
            {
              "id": "forklifts-hyster-h10-00",
              "name": "H10.00",
              "subcategories": []
            },
            {
              "id": "forklifts-hyster-h12",
              "name": "H12",
              "subcategories": []
            },
            {
              "id": "forklifts-hyster-h12-00",
              "name": "H12.00",
              "subcategories": []
            },
            {
              "id": "forklifts-hyster-h14-00",
              "name": "H14.00",
              "subcategories": []
            },
            {
              "id": "forklifts-hyster-h15-00",
              "name": "H15.00",
              "subcategories": []
            },
            {
              "id": "forklifts-hyster-h16-00",
              "name": "H16.00",
              "subcategories": []
            },
            {
              "id": "forklifts-hyster-h16",
              "name": "H16",
              "subcategories": []
            },
            {
              "id": "forklifts-hyster-h18",
              "name": "H18",
              "subcategories": []
            },
            {
              "id": "forklifts-hyster-h20",
              "name": "H20",
              "subcategories": []
            },
            {
              "id": "forklifts-hyster-h25",
              "name": "H25",
              "subcategories": []
            },
            {
              "id": "forklifts-hyster-h30",
              "name": "H30",
              "subcategories": []
            },
            {
              "id": "forklifts-hyster-h32-00",
              "name": "H32.00",
              "subcategories": []
            },
            {
              "id": "forklifts-hyster-h32",
              "name": "H32",
              "subcategories": []
            },
            {
              "id": "forklifts-hyster-h35",
              "name": "H35",
              "subcategories": []
            },
            {
              "id": "forklifts-hyster-h40-00",
              "name": "H40.00",
              "subcategories": []
            },
            {
              "id": "forklifts-hyster-h40",
              "name": "H40",
              "subcategories": []
            },
            {
              "id": "forklifts-hyster-h48-00",
              "name": "H48.00",
              "subcategories": []
            },
            {
              "id": "forklifts-hyster-h50",
              "name": "H50",
              "subcategories": []
            },
            {
              "id": "forklifts-hyster-h60",
              "name": "H60",
              "subcategories": []
            },
            {
              "id": "forklifts-hyster-h65",
              "name": "H65",
              "subcategories": []
            },
            {
              "id": "forklifts-hyster-h70",
              "name": "H70",
              "subcategories": []
            },
            {
              "id": "forklifts-hyster-h80",
              "name": "H80",
              "subcategories": []
            },
            {
              "id": "forklifts-hyster-h90",
              "name": "H90",
              "subcategories": []
            },
            {
              "id": "forklifts-hyster-h100",
              "name": "H100",
              "subcategories": []
            },
            {
              "id": "forklifts-hyster-h110",
              "name": "H110",
              "subcategories": []
            },
            {
              "id": "forklifts-hyster-h120",
              "name": "H120",
              "subcategories": []
            },
            {
              "id": "forklifts-hyster-h135",
              "name": "H135",
              "subcategories": []
            },
            {
              "id": "forklifts-hyster-h150",
              "name": "H150",
              "subcategories": []
            },
            {
              "id": "forklifts-hyster-h155",
              "name": "H155",
              "subcategories": []
            },
            {
              "id": "forklifts-hyster-h165",
              "name": "H165",
              "subcategories": []
            },
            {
              "id": "forklifts-hyster-h170",
              "name": "H170",
              "subcategories": []
            },
            {
              "id": "forklifts-hyster-h175",
              "name": "H175",
              "subcategories": []
            },
            {
              "id": "forklifts-hyster-h180",
              "name": "H180",
              "subcategories": []
            },
            {
              "id": "forklifts-hyster-h190",
              "name": "H190",
              "subcategories": []
            },
            {
              "id": "forklifts-hyster-h200",
              "name": "H200",
              "subcategories": []
            },
            {
              "id": "forklifts-hyster-h210",
              "name": "H210",
              "subcategories": []
            },
            {
              "id": "forklifts-hyster-h230",
              "name": "H230",
              "subcategories": []
            },
            {
              "id": "forklifts-hyster-h250",
              "name": "H250",
              "subcategories": []
            },
            {
              "id": "forklifts-hyster-h280",
              "name": "H280",
              "subcategories": []
            },
            {
              "id": "forklifts-hyster-h300",
              "name": "H300",
              "subcategories": []
            },
            {
              "id": "forklifts-hyster-h330",
              "name": "H330",
              "subcategories": []
            },
            {
              "id": "forklifts-hyster-h350",
              "name": "H350",
              "subcategories": []
            },
            {
              "id": "forklifts-hyster-h360",
              "name": "H360",
              "subcategories": []
            },
            {
              "id": "forklifts-hyster-h400",
              "name": "H400",
              "subcategories": []
            },
            {
              "id": "forklifts-hyster-h440",
              "name": "H440",
              "subcategories": []
            },
            {
              "id": "forklifts-hyster-h450",
              "name": "H450",
              "subcategories": []
            },
            {
              "id": "forklifts-hyster-h520",
              "name": "H520",
              "subcategories": []
            },
            {
              "id": "forklifts-hyster-h550",
              "name": "H550",
              "subcategories": []
            },
            {
              "id": "forklifts-hyster-h620",
              "name": "H620",
              "subcategories": []
            },
            {
              "id": "forklifts-hyster-h650",
              "name": "H650",
              "subcategories": []
            },
            {
              "id": "forklifts-hyster-h700",
              "name": "H700",
              "subcategories": []
            },
            {
              "id": "forklifts-hyster-h800",
              "name": "H800",
              "subcategories": []
            },
            {
              "id": "forklifts-hyster-h1050",
              "name": "H1050",
              "subcategories": []
            },
            {
              "id": "forklifts-hyster-hy55",
              "name": "HY55",
              "subcategories": []
            },
            {
              "id": "forklifts-hyster-j1-5",
              "name": "J1.5",
              "subcategories": []
            },
            {
              "id": "forklifts-hyster-j1-6",
              "name": "J1.6",
              "subcategories": []
            },
            {
              "id": "forklifts-hyster-j1-60",
              "name": "J1.60",
              "subcategories": []
            },
            {
              "id": "forklifts-hyster-j1-80",
              "name": "J1.80",
              "subcategories": []
            },
            {
              "id": "forklifts-hyster-j1-8",
              "name": "J1.8",
              "subcategories": []
            },
            {
              "id": "forklifts-hyster-j2-0",
              "name": "J2.0",
              "subcategories": []
            },
            {
              "id": "forklifts-hyster-j2-00",
              "name": "J2.00",
              "subcategories": []
            },
            {
              "id": "forklifts-hyster-j2-5",
              "name": "J2.5",
              "subcategories": []
            },
            {
              "id": "forklifts-hyster-j2-50",
              "name": "J2.50",
              "subcategories": []
            },
            {
              "id": "forklifts-hyster-j3-0",
              "name": "J3.0",
              "subcategories": []
            },
            {
              "id": "forklifts-hyster-j3-00",
              "name": "J3.00",
              "subcategories": []
            },
            {
              "id": "forklifts-hyster-j30",
              "name": "J30",
              "subcategories": []
            },
            {
              "id": "forklifts-hyster-j35",
              "name": "J35",
              "subcategories": []
            },
            {
              "id": "forklifts-hyster-j40",
              "name": "J40",
              "subcategories": []
            },
            {
              "id": "forklifts-hyster-j45",
              "name": "J45",
              "subcategories": []
            },
            {
              "id": "forklifts-hyster-j50",
              "name": "J50",
              "subcategories": []
            },
            {
              "id": "forklifts-hyster-j60",
              "name": "J60",
              "subcategories": []
            },
            {
              "id": "forklifts-hyster-lo",
              "name": "LO",
              "subcategories": []
            },
            {
              "id": "forklifts-hyster-n30",
              "name": "N30",
              "subcategories": []
            },
            {
              "id": "forklifts-hyster-n35",
              "name": "N35",
              "subcategories": []
            },
            {
              "id": "forklifts-hyster-n40",
              "name": "N40",
              "subcategories": []
            },
            {
              "id": "forklifts-hyster-n45",
              "name": "N45",
              "subcategories": []
            },
            {
              "id": "forklifts-hyster-p2-0",
              "name": "P2.0",
              "subcategories": []
            },
            {
              "id": "forklifts-hyster-p150",
              "name": "P150",
              "subcategories": []
            },
            {
              "id": "forklifts-hyster-r1-6",
              "name": "R1.6",
              "subcategories": []
            },
            {
              "id": "forklifts-hyster-r2-5",
              "name": "R2.5",
              "subcategories": []
            },
            {
              "id": "forklifts-hyster-r30",
              "name": "R30",
              "subcategories": []
            },
            {
              "id": "forklifts-hyster-s1-5",
              "name": "S1.5",
              "subcategories": []
            },
            {
              "id": "forklifts-hyster-s2-0",
              "name": "S2.0",
              "subcategories": []
            },
            {
              "id": "forklifts-hyster-s3-0",
              "name": "S3.0",
              "subcategories": []
            },
            {
              "id": "forklifts-hyster-s6-00",
              "name": "S6.00",
              "subcategories": []
            },
            {
              "id": "forklifts-hyster-s7-0",
              "name": "S7.0",
              "subcategories": []
            },
            {
              "id": "forklifts-hyster-s7-00",
              "name": "S7.00",
              "subcategories": []
            },
            {
              "id": "forklifts-hyster-s25",
              "name": "S25",
              "subcategories": []
            },
            {
              "id": "forklifts-hyster-s30",
              "name": "S30",
              "subcategories": []
            },
            {
              "id": "forklifts-hyster-s35",
              "name": "S35",
              "subcategories": []
            },
            {
              "id": "forklifts-hyster-s40",
              "name": "S40",
              "subcategories": []
            },
            {
              "id": "forklifts-hyster-s50",
              "name": "S50",
              "subcategories": []
            },
            {
              "id": "forklifts-hyster-s55",
              "name": "S55",
              "subcategories": []
            },
            {
              "id": "forklifts-hyster-s60",
              "name": "S60",
              "subcategories": []
            },
            {
              "id": "forklifts-hyster-s70",
              "name": "S70",
              "subcategories": []
            },
            {
              "id": "forklifts-hyster-s80",
              "name": "S80",
              "subcategories": []
            },
            {
              "id": "forklifts-hyster-s100",
              "name": "S100",
              "subcategories": []
            },
            {
              "id": "forklifts-hyster-s120",
              "name": "S120",
              "subcategories": []
            },
            {
              "id": "forklifts-hyster-s125",
              "name": "S125",
              "subcategories": []
            },
            {
              "id": "forklifts-hyster-s135",
              "name": "S135",
              "subcategories": []
            },
            {
              "id": "forklifts-hyster-s150",
              "name": "S150",
              "subcategories": []
            },
            {
              "id": "forklifts-hyster-s155",
              "name": "S155",
              "subcategories": []
            },
            {
              "id": "forklifts-hyster-s180",
              "name": "S180",
              "subcategories": []
            },
            {
              "id": "forklifts-hyster-s200",
              "name": "S200",
              "subcategories": []
            },
            {
              "id": "forklifts-hyster-v35",
              "name": "V35",
              "subcategories": []
            },
            {
              "id": "forklifts-hyster-w20",
              "name": "W20",
              "subcategories": []
            },
            {
              "id": "forklifts-hyster-w25",
              "name": "W25",
              "subcategories": []
            },
            {
              "id": "forklifts-hyster-w30",
              "name": "W30",
              "subcategories": []
            },
            {
              "id": "forklifts-hyster-w40",
              "name": "W40",
              "subcategories": []
            },
            {
              "id": "forklifts-hyster-w45",
              "name": "W45",
              "subcategories": []
            },
            {
              "id": "forklifts-hyster-w80",
              "name": "W80",
              "subcategories": []
            },
            {
              "id": "forklifts-hyster-h48",
              "name": "H48",
              "subcategories": []
            },
            {
              "id": "forklifts-hyster-other",
              "name": "OTHER",
              "subcategories": []
            }
          ]
        },
        {
          "id": "forklifts-yale",
          "name": "Yale",
          "subcategories": [
            {
              "id": "forklifts-yale-11fg25pve",
              "name": "11FG25PVE",
              "subcategories": []
            },
            {
              "id": "forklifts-yale-d3p220",
              "name": "D3P220",
              "subcategories": []
            },
            {
              "id": "forklifts-yale-d3v200",
              "name": "D3V200",
              "subcategories": []
            },
            {
              "id": "forklifts-yale-erc040",
              "name": "ERC040",
              "subcategories": []
            },
            {
              "id": "forklifts-yale-erc045",
              "name": "ERC045",
              "subcategories": []
            },
            {
              "id": "forklifts-yale-erc050",
              "name": "ERC050",
              "subcategories": []
            },
            {
              "id": "forklifts-yale-erc060",
              "name": "ERC060",
              "subcategories": []
            },
            {
              "id": "forklifts-yale-erc065",
              "name": "ERC065",
              "subcategories": []
            },
            {
              "id": "forklifts-yale-erc070",
              "name": "ERC070",
              "subcategories": []
            },
            {
              "id": "forklifts-yale-erc080",
              "name": "ERC080",
              "subcategories": []
            },
            {
              "id": "forklifts-yale-erc25",
              "name": "ERC25",
              "subcategories": []
            },
            {
              "id": "forklifts-yale-erc40",
              "name": "ERC40",
              "subcategories": []
            },
            {
              "id": "forklifts-yale-erc100",
              "name": "ERC100",
              "subcategories": []
            },
            {
              "id": "forklifts-yale-erc120",
              "name": "ERC120",
              "subcategories": []
            },
            {
              "id": "forklifts-yale-erp025",
              "name": "ERP025",
              "subcategories": []
            },
            {
              "id": "forklifts-yale-erp030",
              "name": "ERP030",
              "subcategories": []
            },
            {
              "id": "forklifts-yale-erp035",
              "name": "ERP035",
              "subcategories": []
            },
            {
              "id": "forklifts-yale-erp040",
              "name": "ERP040",
              "subcategories": []
            },
            {
              "id": "forklifts-yale-erp050",
              "name": "ERP050",
              "subcategories": []
            },
            {
              "id": "forklifts-yale-erp060",
              "name": "ERP060",
              "subcategories": []
            },
            {
              "id": "forklifts-yale-erp070",
              "name": "ERP070",
              "subcategories": []
            },
            {
              "id": "forklifts-yale-erp080",
              "name": "ERP080",
              "subcategories": []
            },
            {
              "id": "forklifts-yale-erp16",
              "name": "ERP16",
              "subcategories": []
            },
            {
              "id": "forklifts-yale-erp18",
              "name": "ERP18",
              "subcategories": []
            },
            {
              "id": "forklifts-yale-erp20",
              "name": "ERP20",
              "subcategories": []
            },
            {
              "id": "forklifts-yale-erp25",
              "name": "ERP25",
              "subcategories": []
            },
            {
              "id": "forklifts-yale-erp30",
              "name": "ERP30",
              "subcategories": []
            },
            {
              "id": "forklifts-yale-erp35",
              "name": "ERP35",
              "subcategories": []
            },
            {
              "id": "forklifts-yale-erp40",
              "name": "ERP40",
              "subcategories": []
            },
            {
              "id": "forklifts-yale-esc030",
              "name": "ESC030",
              "subcategories": []
            },
            {
              "id": "forklifts-yale-esc035",
              "name": "ESC035",
              "subcategories": []
            },
            {
              "id": "forklifts-yale-esc040",
              "name": "ESC040",
              "subcategories": []
            },
            {
              "id": "forklifts-yale-g51c",
              "name": "G51C",
              "subcategories": []
            },
            {
              "id": "forklifts-yale-g51p",
              "name": "G51P",
              "subcategories": []
            },
            {
              "id": "forklifts-yale-g83p",
              "name": "G83P",
              "subcategories": []
            },
            {
              "id": "forklifts-yale-gc030",
              "name": "GC030",
              "subcategories": []
            },
            {
              "id": "forklifts-yale-gc040",
              "name": "GC040",
              "subcategories": []
            },
            {
              "id": "forklifts-yale-gc050",
              "name": "GC050",
              "subcategories": []
            },
            {
              "id": "forklifts-yale-gc060",
              "name": "GC060",
              "subcategories": []
            },
            {
              "id": "forklifts-yale-gc080",
              "name": "GC080",
              "subcategories": []
            },
            {
              "id": "forklifts-yale-gc100",
              "name": "GC100",
              "subcategories": []
            },
            {
              "id": "forklifts-yale-gc120",
              "name": "GC120",
              "subcategories": []
            },
            {
              "id": "forklifts-yale-gc155",
              "name": "GC155",
              "subcategories": []
            },
            {
              "id": "forklifts-yale-gdc155",
              "name": "GDC155",
              "subcategories": []
            },
            {
              "id": "forklifts-yale-gdp030",
              "name": "GDP030",
              "subcategories": []
            },
            {
              "id": "forklifts-yale-gdp040",
              "name": "GDP040",
              "subcategories": []
            },
            {
              "id": "forklifts-yale-gdp050",
              "name": "GDP050",
              "subcategories": []
            },
            {
              "id": "forklifts-yale-gdp060",
              "name": "GDP060",
              "subcategories": []
            },
            {
              "id": "forklifts-yale-gdp070",
              "name": "GDP070",
              "subcategories": []
            },
            {
              "id": "forklifts-yale-gdp080",
              "name": "GDP080",
              "subcategories": []
            },
            {
              "id": "forklifts-yale-gdp090",
              "name": "GDP090",
              "subcategories": []
            },
            {
              "id": "forklifts-yale-gdp16",
              "name": "GDP16",
              "subcategories": []
            },
            {
              "id": "forklifts-yale-gdp20",
              "name": "GDP20",
              "subcategories": []
            },
            {
              "id": "forklifts-yale-gdp25",
              "name": "GDP25",
              "subcategories": []
            },
            {
              "id": "forklifts-yale-gdp30",
              "name": "GDP30",
              "subcategories": []
            },
            {
              "id": "forklifts-yale-gdp35",
              "name": "GDP35",
              "subcategories": []
            },
            {
              "id": "forklifts-yale-gdp360",
              "name": "GDP360",
              "subcategories": []
            },
            {
              "id": "forklifts-yale-gdp45",
              "name": "GDP45",
              "subcategories": []
            },
            {
              "id": "forklifts-yale-gdp80",
              "name": "GDP80",
              "subcategories": []
            },
            {
              "id": "forklifts-yale-gdp100",
              "name": "GDP100",
              "subcategories": []
            },
            {
              "id": "forklifts-yale-gdp110",
              "name": "GDP110",
              "subcategories": []
            },
            {
              "id": "forklifts-yale-gdp120",
              "name": "GDP120",
              "subcategories": []
            },
            {
              "id": "forklifts-yale-gdp135",
              "name": "GDP135",
              "subcategories": []
            },
            {
              "id": "forklifts-yale-gdp155",
              "name": "GDP155",
              "subcategories": []
            },
            {
              "id": "forklifts-yale-gdp160",
              "name": "GDP160",
              "subcategories": []
            },
            {
              "id": "forklifts-yale-gdp170",
              "name": "GDP170",
              "subcategories": []
            },
            {
              "id": "forklifts-yale-gdp190",
              "name": "GDP190",
              "subcategories": []
            },
            {
              "id": "forklifts-yale-gdp210",
              "name": "GDP210",
              "subcategories": []
            },
            {
              "id": "forklifts-yale-gdp230",
              "name": "GDP230",
              "subcategories": []
            },
            {
              "id": "forklifts-yale-gdp280",
              "name": "GDP280",
              "subcategories": []
            },
            {
              "id": "forklifts-yale-gdp300",
              "name": "GDP300",
              "subcategories": []
            },
            {
              "id": "forklifts-yale-gdp330",
              "name": "GDP330",
              "subcategories": []
            },
            {
              "id": "forklifts-yale-gl83",
              "name": "GL83",
              "subcategories": []
            },
            {
              "id": "forklifts-yale-glc030",
              "name": "GLC030",
              "subcategories": []
            },
            {
              "id": "forklifts-yale-glc035",
              "name": "GLC035",
              "subcategories": []
            },
            {
              "id": "forklifts-yale-glc040",
              "name": "GLC040",
              "subcategories": []
            },
            {
              "id": "forklifts-yale-glc050",
              "name": "GLC050",
              "subcategories": []
            },
            {
              "id": "forklifts-yale-glc060",
              "name": "GLC060",
              "subcategories": []
            },
            {
              "id": "forklifts-yale-glc070",
              "name": "GLC070",
              "subcategories": []
            },
            {
              "id": "forklifts-yale-glc080",
              "name": "GLC080",
              "subcategories": []
            },
            {
              "id": "forklifts-yale-glc100",
              "name": "GLC100",
              "subcategories": []
            },
            {
              "id": "forklifts-yale-glc120",
              "name": "GLC120",
              "subcategories": []
            },
            {
              "id": "forklifts-yale-glc135",
              "name": "GLC135",
              "subcategories": []
            },
            {
              "id": "forklifts-yale-glc155",
              "name": "GLC155",
              "subcategories": []
            },
            {
              "id": "forklifts-yale-glc200",
              "name": "GLC200",
              "subcategories": []
            },
            {
              "id": "forklifts-yale-glp030",
              "name": "GLP030",
              "subcategories": []
            },
            {
              "id": "forklifts-yale-glp035",
              "name": "GLP035",
              "subcategories": []
            },
            {
              "id": "forklifts-yale-glp040",
              "name": "GLP040",
              "subcategories": []
            },
            {
              "id": "forklifts-yale-glp050",
              "name": "GLP050",
              "subcategories": []
            },
            {
              "id": "forklifts-yale-glp060",
              "name": "GLP060",
              "subcategories": []
            },
            {
              "id": "forklifts-yale-glp070",
              "name": "GLP070",
              "subcategories": []
            },
            {
              "id": "forklifts-yale-glp080",
              "name": "GLP080",
              "subcategories": []
            },
            {
              "id": "forklifts-yale-glp090",
              "name": "GLP090",
              "subcategories": []
            },
            {
              "id": "forklifts-yale-glp16",
              "name": "GLP16",
              "subcategories": []
            },
            {
              "id": "forklifts-yale-glp18",
              "name": "GLP18",
              "subcategories": []
            },
            {
              "id": "forklifts-yale-glp20",
              "name": "GLP20",
              "subcategories": []
            },
            {
              "id": "forklifts-yale-glp25",
              "name": "GLP25",
              "subcategories": []
            },
            {
              "id": "forklifts-yale-glp30",
              "name": "GLP30",
              "subcategories": []
            },
            {
              "id": "forklifts-yale-glp35",
              "name": "GLP35",
              "subcategories": []
            },
            {
              "id": "forklifts-yale-glp50",
              "name": "GLP50",
              "subcategories": []
            },
            {
              "id": "forklifts-yale-glp60",
              "name": "GLP60",
              "subcategories": []
            },
            {
              "id": "forklifts-yale-glp100",
              "name": "GLP100",
              "subcategories": []
            },
            {
              "id": "forklifts-yale-glp120",
              "name": "GLP120",
              "subcategories": []
            },
            {
              "id": "forklifts-yale-glp155",
              "name": "GLP155",
              "subcategories": []
            },
            {
              "id": "forklifts-yale-glp175",
              "name": "GLP175",
              "subcategories": []
            },
            {
              "id": "forklifts-yale-glp300",
              "name": "GLP300",
              "subcategories": []
            },
            {
              "id": "forklifts-yale-gp030",
              "name": "GP030",
              "subcategories": []
            },
            {
              "id": "forklifts-yale-gp040",
              "name": "GP040",
              "subcategories": []
            },
            {
              "id": "forklifts-yale-gp050",
              "name": "GP050",
              "subcategories": []
            },
            {
              "id": "forklifts-yale-gp060",
              "name": "GP060",
              "subcategories": []
            },
            {
              "id": "forklifts-yale-gp080",
              "name": "GP080",
              "subcategories": []
            },
            {
              "id": "forklifts-yale-gp30x",
              "name": "GP30X",
              "subcategories": []
            },
            {
              "id": "forklifts-yale-gp40",
              "name": "GP40",
              "subcategories": []
            },
            {
              "id": "forklifts-yale-gp60",
              "name": "GP60",
              "subcategories": []
            },
            {
              "id": "forklifts-yale-gp120",
              "name": "GP120",
              "subcategories": []
            },
            {
              "id": "forklifts-yale-gp155",
              "name": "GP155",
              "subcategories": []
            },
            {
              "id": "forklifts-yale-gp170",
              "name": "GP170",
              "subcategories": []
            },
            {
              "id": "forklifts-yale-gtp18",
              "name": "GTP18",
              "subcategories": []
            },
            {
              "id": "forklifts-yale-gtp35",
              "name": "GTP35",
              "subcategories": []
            },
            {
              "id": "forklifts-yale-gtp050",
              "name": "GTP050",
              "subcategories": []
            },
            {
              "id": "forklifts-yale-gtp060",
              "name": "GTP060",
              "subcategories": []
            },
            {
              "id": "forklifts-yale-gtp070",
              "name": "GTP070",
              "subcategories": []
            },
            {
              "id": "forklifts-yale-gtp080",
              "name": "GTP080",
              "subcategories": []
            },
            {
              "id": "forklifts-yale-gtp100",
              "name": "GTP100",
              "subcategories": []
            },
            {
              "id": "forklifts-yale-k51at40",
              "name": "K51AT40",
              "subcategories": []
            },
            {
              "id": "forklifts-yale-l83p04osw086",
              "name": "L83P04OSW086",
              "subcategories": []
            },
            {
              "id": "forklifts-yale-mcw025",
              "name": "MCW025",
              "subcategories": []
            },
            {
              "id": "forklifts-yale-mcw040",
              "name": "MCW040",
              "subcategories": []
            },
            {
              "id": "forklifts-yale-mo",
              "name": "MO",
              "subcategories": []
            },
            {
              "id": "forklifts-yale-mpo",
              "name": "MPO",
              "subcategories": []
            },
            {
              "id": "forklifts-yale-mpb040",
              "name": "MPB040",
              "subcategories": []
            },
            {
              "id": "forklifts-yale-mpb045",
              "name": "MPB045",
              "subcategories": []
            },
            {
              "id": "forklifts-yale-mpe060",
              "name": "MPE060",
              "subcategories": []
            },
            {
              "id": "forklifts-yale-mpe080",
              "name": "MPE080",
              "subcategories": []
            },
            {
              "id": "forklifts-yale-mpr080",
              "name": "MPR080",
              "subcategories": []
            },
            {
              "id": "forklifts-yale-mpw050",
              "name": "MPW050",
              "subcategories": []
            },
            {
              "id": "forklifts-yale-mpw060",
              "name": "MPW060",
              "subcategories": []
            },
            {
              "id": "forklifts-yale-mr16",
              "name": "MR16",
              "subcategories": []
            },
            {
              "id": "forklifts-yale-mr20",
              "name": "MR20",
              "subcategories": []
            },
            {
              "id": "forklifts-yale-mrw030",
              "name": "MRW030",
              "subcategories": []
            },
            {
              "id": "forklifts-yale-ms040",
              "name": "MS040",
              "subcategories": []
            },
            {
              "id": "forklifts-yale-ms10",
              "name": "MS10",
              "subcategories": []
            },
            {
              "id": "forklifts-yale-msw025",
              "name": "MSW025",
              "subcategories": []
            },
            {
              "id": "forklifts-yale-msw030",
              "name": "MSW030",
              "subcategories": []
            },
            {
              "id": "forklifts-yale-msw040",
              "name": "MSW040",
              "subcategories": []
            },
            {
              "id": "forklifts-yale-ndr030",
              "name": "NDR030",
              "subcategories": []
            },
            {
              "id": "forklifts-yale-ndr035",
              "name": "NDR035",
              "subcategories": []
            },
            {
              "id": "forklifts-yale-nr035",
              "name": "NR035",
              "subcategories": []
            },
            {
              "id": "forklifts-yale-nr040",
              "name": "NR040",
              "subcategories": []
            },
            {
              "id": "forklifts-yale-nr045",
              "name": "NR045",
              "subcategories": []
            },
            {
              "id": "forklifts-yale-nta030",
              "name": "NTA030",
              "subcategories": []
            },
            {
              "id": "forklifts-yale-os030",
              "name": "OS030",
              "subcategories": []
            },
            {
              "id": "forklifts-yale-ya55",
              "name": "YA55",
              "subcategories": []
            },
            {
              "id": "forklifts-yale-other",
              "name": "OTHER",
              "subcategories": []
            }
          ]
        },
        {
          "id": "forklifts-caterpillar",
          "name": "Caterpillar",
          "subcategories": [
            {
              "id": "forklifts-caterpillar-2c",
              "name": "2C",
              "subcategories": []
            },
            {
              "id": "forklifts-caterpillar-2c6004",
              "name": "2C6004",
              "subcategories": []
            },
            {
              "id": "forklifts-caterpillar-2ec",
              "name": "2EC",
              "subcategories": []
            },
            {
              "id": "forklifts-caterpillar-2ep",
              "name": "2EP",
              "subcategories": []
            },
            {
              "id": "forklifts-caterpillar-2epc",
              "name": "2EPC",
              "subcategories": []
            },
            {
              "id": "forklifts-caterpillar-2et",
              "name": "2ET",
              "subcategories": []
            },
            {
              "id": "forklifts-caterpillar-2p",
              "name": "2P",
              "subcategories": []
            },
            {
              "id": "forklifts-caterpillar-2pd",
              "name": "2PD",
              "subcategories": []
            },
            {
              "id": "forklifts-caterpillar-ah40",
              "name": "AH40",
              "subcategories": []
            },
            {
              "id": "forklifts-caterpillar-ah60",
              "name": "AH60",
              "subcategories": []
            },
            {
              "id": "forklifts-caterpillar-b10",
              "name": "B10",
              "subcategories": []
            },
            {
              "id": "forklifts-caterpillar-c3000",
              "name": "C3000",
              "subcategories": []
            },
            {
              "id": "forklifts-caterpillar-c3500",
              "name": "C3500",
              "subcategories": []
            },
            {
              "id": "forklifts-caterpillar-c4000",
              "name": "C4000",
              "subcategories": []
            },
            {
              "id": "forklifts-caterpillar-c5000",
              "name": "C5000",
              "subcategories": []
            },
            {
              "id": "forklifts-caterpillar-c6000",
              "name": "C6000",
              "subcategories": []
            },
            {
              "id": "forklifts-caterpillar-c6500",
              "name": "C6500",
              "subcategories": []
            },
            {
              "id": "forklifts-caterpillar-cc4000",
              "name": "CC4000",
              "subcategories": []
            },
            {
              "id": "forklifts-caterpillar-dp15",
              "name": "DP15",
              "subcategories": []
            },
            {
              "id": "forklifts-caterpillar-dp18",
              "name": "DP18",
              "subcategories": []
            },
            {
              "id": "forklifts-caterpillar-dp20",
              "name": "DP20",
              "subcategories": []
            },
            {
              "id": "forklifts-caterpillar-dp25",
              "name": "DP25",
              "subcategories": []
            },
            {
              "id": "forklifts-caterpillar-dp30",
              "name": "DP30",
              "subcategories": []
            },
            {
              "id": "forklifts-caterpillar-dp33",
              "name": "DP33",
              "subcategories": []
            },
            {
              "id": "forklifts-caterpillar-dp35",
              "name": "DP35",
              "subcategories": []
            },
            {
              "id": "forklifts-caterpillar-dp40",
              "name": "DP40",
              "subcategories": []
            },
            {
              "id": "forklifts-caterpillar-dp45",
              "name": "DP45",
              "subcategories": []
            },
            {
              "id": "forklifts-caterpillar-dp50",
              "name": "DP50",
              "subcategories": []
            },
            {
              "id": "forklifts-caterpillar-dp55",
              "name": "DP55",
              "subcategories": []
            },
            {
              "id": "forklifts-caterpillar-dp70",
              "name": "DP70",
              "subcategories": []
            },
            {
              "id": "forklifts-caterpillar-dp80",
              "name": "DP80",
              "subcategories": []
            },
            {
              "id": "forklifts-caterpillar-dp90",
              "name": "DP90",
              "subcategories": []
            },
            {
              "id": "forklifts-caterpillar-dp100",
              "name": "DP100",
              "subcategories": []
            },
            {
              "id": "forklifts-caterpillar-dp115",
              "name": "DP115",
              "subcategories": []
            },
            {
              "id": "forklifts-caterpillar-dp120",
              "name": "DP120",
              "subcategories": []
            },
            {
              "id": "forklifts-caterpillar-dp135",
              "name": "DP135",
              "subcategories": []
            },
            {
              "id": "forklifts-caterpillar-dp150",
              "name": "DP150",
              "subcategories": []
            },
            {
              "id": "forklifts-caterpillar-e3000",
              "name": "E3000",
              "subcategories": []
            },
            {
              "id": "forklifts-caterpillar-e3500",
              "name": "E3500",
              "subcategories": []
            },
            {
              "id": "forklifts-caterpillar-e4000",
              "name": "E4000",
              "subcategories": []
            },
            {
              "id": "forklifts-caterpillar-e5000",
              "name": "E5000",
              "subcategories": []
            },
            {
              "id": "forklifts-caterpillar-e5500",
              "name": "E5500",
              "subcategories": []
            },
            {
              "id": "forklifts-caterpillar-e6000",
              "name": "E6000",
              "subcategories": []
            },
            {
              "id": "forklifts-caterpillar-e6500",
              "name": "E6500",
              "subcategories": []
            },
            {
              "id": "forklifts-caterpillar-e12000",
              "name": "E12000",
              "subcategories": []
            },
            {
              "id": "forklifts-caterpillar-ec25",
              "name": "EC25",
              "subcategories": []
            },
            {
              "id": "forklifts-caterpillar-ec30",
              "name": "EC30",
              "subcategories": []
            },
            {
              "id": "forklifts-caterpillar-ec4000",
              "name": "EC4000",
              "subcategories": []
            },
            {
              "id": "forklifts-caterpillar-ep12",
              "name": "EP12",
              "subcategories": []
            },
            {
              "id": "forklifts-caterpillar-ep15",
              "name": "EP15",
              "subcategories": []
            },
            {
              "id": "forklifts-caterpillar-ep16",
              "name": "EP16",
              "subcategories": []
            },
            {
              "id": "forklifts-caterpillar-ep18",
              "name": "EP18",
              "subcategories": []
            },
            {
              "id": "forklifts-caterpillar-ep20",
              "name": "EP20",
              "subcategories": []
            },
            {
              "id": "forklifts-caterpillar-ep25",
              "name": "EP25",
              "subcategories": []
            },
            {
              "id": "forklifts-caterpillar-ep30",
              "name": "EP30",
              "subcategories": []
            },
            {
              "id": "forklifts-caterpillar-ep3000",
              "name": "EP3000",
              "subcategories": []
            },
            {
              "id": "forklifts-caterpillar-ex5000",
              "name": "EX5000",
              "subcategories": []
            },
            {
              "id": "forklifts-caterpillar-f30",
              "name": "F30",
              "subcategories": []
            },
            {
              "id": "forklifts-caterpillar-f35",
              "name": "F35",
              "subcategories": []
            },
            {
              "id": "forklifts-caterpillar-fg25",
              "name": "FG25",
              "subcategories": []
            },
            {
              "id": "forklifts-caterpillar-fg35",
              "name": "FG35",
              "subcategories": []
            },
            {
              "id": "forklifts-caterpillar-fgc25n",
              "name": "FGC25N",
              "subcategories": []
            },
            {
              "id": "forklifts-caterpillar-gc15",
              "name": "GC15",
              "subcategories": []
            },
            {
              "id": "forklifts-caterpillar-gc18",
              "name": "GC18",
              "subcategories": []
            },
            {
              "id": "forklifts-caterpillar-gc25",
              "name": "GC25",
              "subcategories": []
            },
            {
              "id": "forklifts-caterpillar-gc30",
              "name": "GC30",
              "subcategories": []
            },
            {
              "id": "forklifts-caterpillar-gc35",
              "name": "GC35",
              "subcategories": []
            },
            {
              "id": "forklifts-caterpillar-gc40",
              "name": "GC40",
              "subcategories": []
            },
            {
              "id": "forklifts-caterpillar-gc45",
              "name": "GC45",
              "subcategories": []
            },
            {
              "id": "forklifts-caterpillar-gc55",
              "name": "GC55",
              "subcategories": []
            },
            {
              "id": "forklifts-caterpillar-gc60",
              "name": "GC60",
              "subcategories": []
            },
            {
              "id": "forklifts-caterpillar-gc70",
              "name": "GC70",
              "subcategories": []
            },
            {
              "id": "forklifts-caterpillar-gp10",
              "name": "GP10",
              "subcategories": []
            },
            {
              "id": "forklifts-caterpillar-gp15",
              "name": "GP15",
              "subcategories": []
            },
            {
              "id": "forklifts-caterpillar-gp18",
              "name": "GP18",
              "subcategories": []
            },
            {
              "id": "forklifts-caterpillar-gp20",
              "name": "GP20",
              "subcategories": []
            },
            {
              "id": "forklifts-caterpillar-gp25",
              "name": "GP25",
              "subcategories": []
            },
            {
              "id": "forklifts-caterpillar-gp30",
              "name": "GP30",
              "subcategories": []
            },
            {
              "id": "forklifts-caterpillar-gp35",
              "name": "GP35",
              "subcategories": []
            },
            {
              "id": "forklifts-caterpillar-gp40",
              "name": "GP40",
              "subcategories": []
            },
            {
              "id": "forklifts-caterpillar-gp45",
              "name": "GP45",
              "subcategories": []
            },
            {
              "id": "forklifts-caterpillar-gp50",
              "name": "GP50",
              "subcategories": []
            },
            {
              "id": "forklifts-caterpillar-gp55",
              "name": "GP55",
              "subcategories": []
            },
            {
              "id": "forklifts-caterpillar-gpl40",
              "name": "GPL40",
              "subcategories": []
            },
            {
              "id": "forklifts-caterpillar-m50",
              "name": "M50",
              "subcategories": []
            },
            {
              "id": "forklifts-caterpillar-m100",
              "name": "M100",
              "subcategories": []
            },
            {
              "id": "forklifts-caterpillar-mc30",
              "name": "MC30",
              "subcategories": []
            },
            {
              "id": "forklifts-caterpillar-n020",
              "name": "N020",
              "subcategories": []
            },
            {
              "id": "forklifts-caterpillar-nor22",
              "name": "NOR22",
              "subcategories": []
            },
            {
              "id": "forklifts-caterpillar-nor30",
              "name": "NOR30",
              "subcategories": []
            },
            {
              "id": "forklifts-caterpillar-npp16",
              "name": "NPP16",
              "subcategories": []
            },
            {
              "id": "forklifts-caterpillar-npp20",
              "name": "NPP20",
              "subcategories": []
            },
            {
              "id": "forklifts-caterpillar-npp60",
              "name": "NPP60",
              "subcategories": []
            },
            {
              "id": "forklifts-caterpillar-npv20",
              "name": "NPV20",
              "subcategories": []
            },
            {
              "id": "forklifts-caterpillar-npv60",
              "name": "NPV60",
              "subcategories": []
            },
            {
              "id": "forklifts-caterpillar-nr14",
              "name": "NR14",
              "subcategories": []
            },
            {
              "id": "forklifts-caterpillar-nr16",
              "name": "NR16",
              "subcategories": []
            },
            {
              "id": "forklifts-caterpillar-nr20",
              "name": "NR20",
              "subcategories": []
            },
            {
              "id": "forklifts-caterpillar-nr25",
              "name": "NR25",
              "subcategories": []
            },
            {
              "id": "forklifts-caterpillar-nr3000",
              "name": "NR3000",
              "subcategories": []
            },
            {
              "id": "forklifts-caterpillar-nr4000",
              "name": "NR4000",
              "subcategories": []
            },
            {
              "id": "forklifts-caterpillar-nr4500",
              "name": "NR4500",
              "subcategories": []
            },
            {
              "id": "forklifts-caterpillar-nsp12",
              "name": "NSP12",
              "subcategories": []
            },
            {
              "id": "forklifts-caterpillar-nsp16",
              "name": "NSP16",
              "subcategories": []
            },
            {
              "id": "forklifts-caterpillar-p3000",
              "name": "P3000",
              "subcategories": []
            },
            {
              "id": "forklifts-caterpillar-p5000",
              "name": "P5000",
              "subcategories": []
            },
            {
              "id": "forklifts-caterpillar-p6000",
              "name": "P6000",
              "subcategories": []
            },
            {
              "id": "forklifts-caterpillar-p6500",
              "name": "P6500",
              "subcategories": []
            },
            {
              "id": "forklifts-caterpillar-p7000",
              "name": "P7000",
              "subcategories": []
            },
            {
              "id": "forklifts-caterpillar-p8000",
              "name": "P8000",
              "subcategories": []
            },
            {
              "id": "forklifts-caterpillar-p9000",
              "name": "P9000",
              "subcategories": []
            },
            {
              "id": "forklifts-caterpillar-p10000",
              "name": "P10000",
              "subcategories": []
            },
            {
              "id": "forklifts-caterpillar-p11000",
              "name": "P11000",
              "subcategories": []
            },
            {
              "id": "forklifts-caterpillar-p12000",
              "name": "P12000",
              "subcategories": []
            },
            {
              "id": "forklifts-caterpillar-p33000",
              "name": "P33000",
              "subcategories": []
            },
            {
              "id": "forklifts-caterpillar-p36000",
              "name": "P36000",
              "subcategories": []
            },
            {
              "id": "forklifts-caterpillar-pd9000",
              "name": "PD9000",
              "subcategories": []
            },
            {
              "id": "forklifts-caterpillar-pd11000",
              "name": "PD11000",
              "subcategories": []
            },
            {
              "id": "forklifts-caterpillar-pd12000",
              "name": "PD12000",
              "subcategories": []
            },
            {
              "id": "forklifts-caterpillar-r80",
              "name": "R80",
              "subcategories": []
            },
            {
              "id": "forklifts-caterpillar-rc60",
              "name": "RC60",
              "subcategories": []
            },
            {
              "id": "forklifts-caterpillar-t30",
              "name": "T30",
              "subcategories": []
            },
            {
              "id": "forklifts-caterpillar-t35",
              "name": "T35",
              "subcategories": []
            },
            {
              "id": "forklifts-caterpillar-t40",
              "name": "T40",
              "subcategories": []
            },
            {
              "id": "forklifts-caterpillar-t50",
              "name": "T50",
              "subcategories": []
            },
            {
              "id": "forklifts-caterpillar-t80",
              "name": "T80",
              "subcategories": []
            },
            {
              "id": "forklifts-caterpillar-t125",
              "name": "T125",
              "subcategories": []
            },
            {
              "id": "forklifts-caterpillar-t250",
              "name": "T250",
              "subcategories": []
            },
            {
              "id": "forklifts-caterpillar-t300",
              "name": "T300",
              "subcategories": []
            },
            {
              "id": "forklifts-caterpillar-tc30",
              "name": "TC30",
              "subcategories": []
            },
            {
              "id": "forklifts-caterpillar-tc60",
              "name": "TC60",
              "subcategories": []
            },
            {
              "id": "forklifts-caterpillar-v40",
              "name": "V40",
              "subcategories": []
            },
            {
              "id": "forklifts-caterpillar-v50",
              "name": "V50",
              "subcategories": []
            },
            {
              "id": "forklifts-caterpillar-v80",
              "name": "V80",
              "subcategories": []
            },
            {
              "id": "forklifts-caterpillar-v90",
              "name": "V90",
              "subcategories": []
            },
            {
              "id": "forklifts-caterpillar-v140",
              "name": "V140",
              "subcategories": []
            },
            {
              "id": "forklifts-caterpillar-v150",
              "name": "V150",
              "subcategories": []
            },
            {
              "id": "forklifts-caterpillar-v180",
              "name": "V180",
              "subcategories": []
            },
            {
              "id": "forklifts-caterpillar-v200",
              "name": "V200",
              "subcategories": []
            },
            {
              "id": "forklifts-caterpillar-v225",
              "name": "V225",
              "subcategories": []
            },
            {
              "id": "forklifts-caterpillar-v250",
              "name": "V250",
              "subcategories": []
            },
            {
              "id": "forklifts-caterpillar-v300",
              "name": "V300",
              "subcategories": []
            },
            {
              "id": "forklifts-caterpillar-v330",
              "name": "V330",
              "subcategories": []
            },
            {
              "id": "forklifts-caterpillar-v550",
              "name": "V550",
              "subcategories": []
            },
            {
              "id": "forklifts-caterpillar-v900",
              "name": "V900",
              "subcategories": []
            },
            {
              "id": "forklifts-caterpillar-vc60",
              "name": "VC60",
              "subcategories": []
            },
            {
              "id": "forklifts-caterpillar-other",
              "name": "OTHER",
              "subcategories": []
            }
          ]
        },
        {
          "id": "forklifts-raymond",
          "name": "Raymond",
          "subcategories": [
            {
              "id": "forklifts-raymond-2014dr40tn",
              "name": "2014DR40TN",
              "subcategories": []
            },
            {
              "id": "forklifts-raymond-80csr40",
              "name": "80CSR40",
              "subcategories": []
            },
            {
              "id": "forklifts-raymond-102tf45",
              "name": "102TF45",
              "subcategories": []
            },
            {
              "id": "forklifts-raymond-112tmfre60",
              "name": "112TMFRE60",
              "subcategories": []
            },
            {
              "id": "forklifts-raymond-1520pc",
              "name": "1520PC",
              "subcategories": []
            },
            {
              "id": "forklifts-raymond-26iopc30",
              "name": "26IOPC30",
              "subcategories": []
            },
            {
              "id": "forklifts-raymond-415c30",
              "name": "415C30",
              "subcategories": []
            },
            {
              "id": "forklifts-raymond-415c35",
              "name": "415C35",
              "subcategories": []
            },
            {
              "id": "forklifts-raymond-420c40",
              "name": "420C40",
              "subcategories": []
            },
            {
              "id": "forklifts-raymond-425c30",
              "name": "425C30",
              "subcategories": []
            },
            {
              "id": "forklifts-raymond-425c35",
              "name": "425C35",
              "subcategories": []
            },
            {
              "id": "forklifts-raymond-425c40",
              "name": "425C40",
              "subcategories": []
            },
            {
              "id": "forklifts-raymond-425c50",
              "name": "425C50",
              "subcategories": []
            },
            {
              "id": "forklifts-raymond-445c35",
              "name": "445C35",
              "subcategories": []
            },
            {
              "id": "forklifts-raymond-445c40",
              "name": "445C40",
              "subcategories": []
            },
            {
              "id": "forklifts-raymond-520opc30",
              "name": "520OPC30",
              "subcategories": []
            },
            {
              "id": "forklifts-raymond-530opc",
              "name": "530OPC",
              "subcategories": []
            },
            {
              "id": "forklifts-raymond-540opc30",
              "name": "540OPC30",
              "subcategories": []
            },
            {
              "id": "forklifts-raymond-550opc30",
              "name": "550OPC30",
              "subcategories": []
            },
            {
              "id": "forklifts-raymond-560opc30",
              "name": "560OPC30",
              "subcategories": []
            },
            {
              "id": "forklifts-raymond-720r",
              "name": "720R",
              "subcategories": []
            },
            {
              "id": "forklifts-raymond-730dr",
              "name": "730DR",
              "subcategories": []
            },
            {
              "id": "forklifts-raymond-730r",
              "name": "730R",
              "subcategories": []
            },
            {
              "id": "forklifts-raymond-740dr",
              "name": "740DR",
              "subcategories": []
            },
            {
              "id": "forklifts-raymond-740r",
              "name": "740R",
              "subcategories": []
            },
            {
              "id": "forklifts-raymond-742dr",
              "name": "742DR",
              "subcategories": []
            },
            {
              "id": "forklifts-raymond-750dr",
              "name": "750DR",
              "subcategories": []
            },
            {
              "id": "forklifts-raymond-750r",
              "name": "750R",
              "subcategories": []
            },
            {
              "id": "forklifts-raymond-752dr",
              "name": "752DR",
              "subcategories": []
            },
            {
              "id": "forklifts-raymond-752r",
              "name": "752R",
              "subcategories": []
            },
            {
              "id": "forklifts-raymond-760r",
              "name": "760R",
              "subcategories": []
            },
            {
              "id": "forklifts-raymond-770r",
              "name": "770R",
              "subcategories": []
            },
            {
              "id": "forklifts-raymond-960csr30",
              "name": "960CSR30",
              "subcategories": []
            },
            {
              "id": "forklifts-raymond-970csr30",
              "name": "970CSR30",
              "subcategories": []
            },
            {
              "id": "forklifts-raymond-3030",
              "name": "3030",
              "subcategories": []
            },
            {
              "id": "forklifts-raymond-4250",
              "name": "4250",
              "subcategories": []
            },
            {
              "id": "forklifts-raymond-4460c30",
              "name": "4460C30",
              "subcategories": []
            },
            {
              "id": "forklifts-raymond-4460c35",
              "name": "4460C35",
              "subcategories": []
            },
            {
              "id": "forklifts-raymond-4460c40",
              "name": "4460C40",
              "subcategories": []
            },
            {
              "id": "forklifts-raymond-4700c40",
              "name": "4700C40",
              "subcategories": []
            },
            {
              "id": "forklifts-raymond-4700c50hm",
              "name": "4700C50HM",
              "subcategories": []
            },
            {
              "id": "forklifts-raymond-4700c60",
              "name": "4700C60",
              "subcategories": []
            },
            {
              "id": "forklifts-raymond-4750c50s",
              "name": "4750C50S",
              "subcategories": []
            },
            {
              "id": "forklifts-raymond-4750c60",
              "name": "4750C60",
              "subcategories": []
            },
            {
              "id": "forklifts-raymond-4750c50s",
              "name": "4750C50S",
              "subcategories": []
            },
            {
              "id": "forklifts-raymond-4750c50l",
              "name": "4750C50L",
              "subcategories": []
            },
            {
              "id": "forklifts-raymond-6210",
              "name": "6210",
              "subcategories": []
            },
            {
              "id": "forklifts-raymond-7310",
              "name": "7310",
              "subcategories": []
            },
            {
              "id": "forklifts-raymond-8210",
              "name": "8210",
              "subcategories": []
            },
            {
              "id": "forklifts-raymond-8250",
              "name": "8250",
              "subcategories": []
            },
            {
              "id": "forklifts-raymond-8400",
              "name": "8400",
              "subcategories": []
            },
            {
              "id": "forklifts-raymond-8410",
              "name": "8410",
              "subcategories": []
            },
            {
              "id": "forklifts-raymond-8500",
              "name": "8500",
              "subcategories": []
            },
            {
              "id": "forklifts-raymond-8510",
              "name": "8510",
              "subcategories": []
            },
            {
              "id": "forklifts-raymond-8900",
              "name": "8900",
              "subcategories": []
            },
            {
              "id": "forklifts-raymond-9800",
              "name": "9800",
              "subcategories": []
            },
            {
              "id": "forklifts-raymond-easi-4dr45tt",
              "name": "EASI 4DR45TT",
              "subcategories": []
            },
            {
              "id": "forklifts-raymond-easi-dr25tt",
              "name": "EASI DR25TT",
              "subcategories": []
            },
            {
              "id": "forklifts-raymond-easi-dr30tt",
              "name": "EASI DR30TT",
              "subcategories": []
            },
            {
              "id": "forklifts-raymond-easi-opc30tt",
              "name": "EASI OPC30TT",
              "subcategories": []
            },
            {
              "id": "forklifts-raymond-easi-r30tt",
              "name": "EASI R30TT",
              "subcategories": []
            },
            {
              "id": "forklifts-raymond-easi-r35tt",
              "name": "EASI R35TT",
              "subcategories": []
            },
            {
              "id": "forklifts-raymond-easi-r40tt",
              "name": "EASI R40TT",
              "subcategories": []
            },
            {
              "id": "forklifts-raymond-easi-r45tt",
              "name": "EASI R45TT",
              "subcategories": []
            },
            {
              "id": "forklifts-raymond-r30c30",
              "name": "R30C30",
              "subcategories": []
            },
            {
              "id": "forklifts-raymond-r30tt",
              "name": "R30TT",
              "subcategories": []
            },
            {
              "id": "forklifts-raymond-r40c40",
              "name": "R40C40",
              "subcategories": []
            },
            {
              "id": "forklifts-raymond-ras25",
              "name": "RAS25",
              "subcategories": []
            },
            {
              "id": "forklifts-raymond-rrs30",
              "name": "RRS30",
              "subcategories": []
            },
            {
              "id": "forklifts-raymond-rss22",
              "name": "RSS22",
              "subcategories": []
            },
            {
              "id": "forklifts-raymond-rss30",
              "name": "RSS30",
              "subcategories": []
            },
            {
              "id": "forklifts-raymond-rss40",
              "name": "RSS40",
              "subcategories": []
            },
            {
              "id": "forklifts-raymond-sacsr",
              "name": "SACSR",
              "subcategories": []
            },
            {
              "id": "forklifts-raymond-sb-csr30t",
              "name": "SB-CSR30T",
              "subcategories": []
            },
            {
              "id": "forklifts-raymond-other",
              "name": "OTHER",
              "subcategories": []
            }
          ]
        },
        {
          "id": "forklifts-linde",
          "name": "Linde",
          "subcategories": [
            {
              "id": "forklifts-linde-d06",
              "name": "D06",
              "subcategories": []
            },
            {
              "id": "forklifts-linde-d14",
              "name": "D14",
              "subcategories": []
            },
            {
              "id": "forklifts-linde-e12",
              "name": "E12",
              "subcategories": []
            },
            {
              "id": "forklifts-linde-e14",
              "name": "E14",
              "subcategories": []
            },
            {
              "id": "forklifts-linde-e15",
              "name": "E15",
              "subcategories": []
            },
            {
              "id": "forklifts-linde-e16",
              "name": "E16",
              "subcategories": []
            },
            {
              "id": "forklifts-linde-e18",
              "name": "E18",
              "subcategories": []
            },
            {
              "id": "forklifts-linde-e18-02",
              "name": "E18-02",
              "subcategories": []
            },
            {
              "id": "forklifts-linde-e20",
              "name": "E20",
              "subcategories": []
            },
            {
              "id": "forklifts-linde-e25",
              "name": "E25",
              "subcategories": []
            },
            {
              "id": "forklifts-linde-e30",
              "name": "E30",
              "subcategories": []
            },
            {
              "id": "forklifts-linde-e32",
              "name": "E32",
              "subcategories": []
            },
            {
              "id": "forklifts-linde-e35",
              "name": "E35",
              "subcategories": []
            },
            {
              "id": "forklifts-linde-e40",
              "name": "E40",
              "subcategories": []
            },
            {
              "id": "forklifts-linde-e45",
              "name": "E45",
              "subcategories": []
            },
            {
              "id": "forklifts-linde-e48",
              "name": "E48",
              "subcategories": []
            },
            {
              "id": "forklifts-linde-e50",
              "name": "E50",
              "subcategories": []
            },
            {
              "id": "forklifts-linde-e80",
              "name": "E80",
              "subcategories": []
            },
            {
              "id": "forklifts-linde-ew30",
              "name": "EW30",
              "subcategories": []
            },
            {
              "id": "forklifts-linde-ew80",
              "name": "EW80",
              "subcategories": []
            },
            {
              "id": "forklifts-linde-ewr30",
              "name": "EWR30",
              "subcategories": []
            },
            {
              "id": "forklifts-linde-ewr36",
              "name": "EWR36",
              "subcategories": []
            },
            {
              "id": "forklifts-linde-ewr40",
              "name": "EWR40",
              "subcategories": []
            },
            {
              "id": "forklifts-linde-ewr60",
              "name": "EWR60",
              "subcategories": []
            },
            {
              "id": "forklifts-linde-ews",
              "name": "EWS",
              "subcategories": []
            },
            {
              "id": "forklifts-linde-h12",
              "name": "H12",
              "subcategories": []
            },
            {
              "id": "forklifts-linde-h15",
              "name": "H15",
              "subcategories": []
            },
            {
              "id": "forklifts-linde-h16",
              "name": "H16",
              "subcategories": []
            },
            {
              "id": "forklifts-linde-h18",
              "name": "H18",
              "subcategories": []
            },
            {
              "id": "forklifts-linde-h20",
              "name": "H20",
              "subcategories": []
            },
            {
              "id": "forklifts-linde-h25",
              "name": "H25",
              "subcategories": []
            },
            {
              "id": "forklifts-linde-h27",
              "name": "H27",
              "subcategories": []
            },
            {
              "id": "forklifts-linde-h30",
              "name": "H30",
              "subcategories": []
            },
            {
              "id": "forklifts-linde-h32",
              "name": "H32",
              "subcategories": []
            },
            {
              "id": "forklifts-linde-h35",
              "name": "H35",
              "subcategories": []
            },
            {
              "id": "forklifts-linde-h40",
              "name": "H40",
              "subcategories": []
            },
            {
              "id": "forklifts-linde-h45",
              "name": "H45",
              "subcategories": []
            },
            {
              "id": "forklifts-linde-h50",
              "name": "H50",
              "subcategories": []
            },
            {
              "id": "forklifts-linde-h60",
              "name": "H60",
              "subcategories": []
            },
            {
              "id": "forklifts-linde-h70",
              "name": "H70",
              "subcategories": []
            },
            {
              "id": "forklifts-linde-h80",
              "name": "H80",
              "subcategories": []
            },
            {
              "id": "forklifts-linde-h100",
              "name": "H100",
              "subcategories": []
            },
            {
              "id": "forklifts-linde-h120",
              "name": "H120",
              "subcategories": []
            },
            {
              "id": "forklifts-linde-h140",
              "name": "H140",
              "subcategories": []
            },
            {
              "id": "forklifts-linde-h150",
              "name": "H150",
              "subcategories": []
            },
            {
              "id": "forklifts-linde-h160",
              "name": "H160",
              "subcategories": []
            },
            {
              "id": "forklifts-linde-h320",
              "name": "H320",
              "subcategories": []
            },
            {
              "id": "forklifts-linde-h420",
              "name": "H420",
              "subcategories": []
            },
            {
              "id": "forklifts-linde-ht25",
              "name": "HT25",
              "subcategories": []
            },
            {
              "id": "forklifts-linde-ht27",
              "name": "HT27",
              "subcategories": []
            },
            {
              "id": "forklifts-linde-ht30",
              "name": "HT30",
              "subcategories": []
            },
            {
              "id": "forklifts-linde-ht32",
              "name": "HT32",
              "subcategories": []
            },
            {
              "id": "forklifts-linde-ht120",
              "name": "HT120",
              "subcategories": []
            },
            {
              "id": "forklifts-linde-ht160",
              "name": "HT160",
              "subcategories": []
            },
            {
              "id": "forklifts-linde-k",
              "name": "K",
              "subcategories": []
            },
            {
              "id": "forklifts-linde-l10",
              "name": "L10",
              "subcategories": []
            },
            {
              "id": "forklifts-linde-l12",
              "name": "L12",
              "subcategories": []
            },
            {
              "id": "forklifts-linde-l14",
              "name": "L14",
              "subcategories": []
            },
            {
              "id": "forklifts-linde-l16",
              "name": "L16",
              "subcategories": []
            },
            {
              "id": "forklifts-linde-l20",
              "name": "L20",
              "subcategories": []
            },
            {
              "id": "forklifts-linde-mt12",
              "name": "MT12",
              "subcategories": []
            },
            {
              "id": "forklifts-linde-mt15",
              "name": "MT15",
              "subcategories": []
            },
            {
              "id": "forklifts-linde-mt18",
              "name": "MT18",
              "subcategories": []
            },
            {
              "id": "forklifts-linde-mt20",
              "name": "MT20",
              "subcategories": []
            },
            {
              "id": "forklifts-linde-mt22",
              "name": "MT22",
              "subcategories": []
            },
            {
              "id": "forklifts-linde-mv05",
              "name": "MV05",
              "subcategories": []
            },
            {
              "id": "forklifts-linde-r10",
              "name": "R10",
              "subcategories": []
            },
            {
              "id": "forklifts-linde-r12",
              "name": "R12",
              "subcategories": []
            },
            {
              "id": "forklifts-linde-r14",
              "name": "R14",
              "subcategories": []
            },
            {
              "id": "forklifts-linde-r16",
              "name": "R16",
              "subcategories": []
            },
            {
              "id": "forklifts-linde-r20",
              "name": "R20",
              "subcategories": []
            },
            {
              "id": "forklifts-linde-r22",
              "name": "R22",
              "subcategories": []
            },
            {
              "id": "forklifts-linde-r25",
              "name": "R25",
              "subcategories": []
            },
            {
              "id": "forklifts-linde-rx60",
              "name": "RX60",
              "subcategories": []
            },
            {
              "id": "forklifts-linde-s40",
              "name": "S40",
              "subcategories": []
            },
            {
              "id": "forklifts-linde-s50",
              "name": "S50",
              "subcategories": []
            },
            {
              "id": "forklifts-linde-t16",
              "name": "T16",
              "subcategories": []
            },
            {
              "id": "forklifts-linde-t18",
              "name": "T18",
              "subcategories": []
            },
            {
              "id": "forklifts-linde-t20",
              "name": "T20",
              "subcategories": []
            },
            {
              "id": "forklifts-linde-v",
              "name": "V",
              "subcategories": []
            },
            {
              "id": "forklifts-linde-v10-02",
              "name": "V10-02",
              "subcategories": []
            },
            {
              "id": "forklifts-linde-v11",
              "name": "V11",
              "subcategories": []
            },
            {
              "id": "forklifts-linde-v12",
              "name": "V12",
              "subcategories": []
            },
            {
              "id": "forklifts-linde-v15",
              "name": "V15",
              "subcategories": []
            },
            {
              "id": "forklifts-linde-x30",
              "name": "X30",
              "subcategories": []
            },
            {
              "id": "forklifts-linde-k5231",
              "name": "K5231",
              "subcategories": []
            },
            {
              "id": "forklifts-linde-other",
              "name": "OTHER",
              "subcategories": []
            }
          ]
        },
        {
          "id": "forklifts-clark",
          "name": "Clark",
          "subcategories": [
            {
              "id": "forklifts-clark-c5",
              "name": "C5",
              "subcategories": []
            },
            {
              "id": "forklifts-clark-c15",
              "name": "C15",
              "subcategories": []
            },
            {
              "id": "forklifts-clark-c18",
              "name": "C18",
              "subcategories": []
            },
            {
              "id": "forklifts-clark-c20",
              "name": "C20",
              "subcategories": []
            },
            {
              "id": "forklifts-clark-c25",
              "name": "C25",
              "subcategories": []
            },
            {
              "id": "forklifts-clark-c30",
              "name": "C30",
              "subcategories": []
            },
            {
              "id": "forklifts-clark-c32",
              "name": "C32",
              "subcategories": []
            },
            {
              "id": "forklifts-clark-c35",
              "name": "C35",
              "subcategories": []
            },
            {
              "id": "forklifts-clark-c40",
              "name": "C40",
              "subcategories": []
            },
            {
              "id": "forklifts-clark-c45",
              "name": "C45",
              "subcategories": []
            },
            {
              "id": "forklifts-clark-c50",
              "name": "C50",
              "subcategories": []
            },
            {
              "id": "forklifts-clark-c55",
              "name": "C55",
              "subcategories": []
            },
            {
              "id": "forklifts-clark-c60",
              "name": "C60",
              "subcategories": []
            },
            {
              "id": "forklifts-clark-c70",
              "name": "C70",
              "subcategories": []
            },
            {
              "id": "forklifts-clark-c75",
              "name": "C75",
              "subcategories": []
            },
            {
              "id": "forklifts-clark-c500",
              "name": "C500",
              "subcategories": []
            },
            {
              "id": "forklifts-clark-cdp140",
              "name": "CDP140",
              "subcategories": []
            },
            {
              "id": "forklifts-clark-cgc20",
              "name": "CGC20",
              "subcategories": []
            },
            {
              "id": "forklifts-clark-cgc25",
              "name": "CGC25",
              "subcategories": []
            },
            {
              "id": "forklifts-clark-cgc30",
              "name": "CGC30",
              "subcategories": []
            },
            {
              "id": "forklifts-clark-cgc40",
              "name": "CGC40",
              "subcategories": []
            },
            {
              "id": "forklifts-clark-cgc50",
              "name": "CGC50",
              "subcategories": []
            },
            {
              "id": "forklifts-clark-cgc55",
              "name": "CGC55",
              "subcategories": []
            },
            {
              "id": "forklifts-clark-cgc60",
              "name": "CGC60",
              "subcategories": []
            },
            {
              "id": "forklifts-clark-cgc70",
              "name": "CGC70",
              "subcategories": []
            },
            {
              "id": "forklifts-clark-cgp25",
              "name": "CGP25",
              "subcategories": []
            },
            {
              "id": "forklifts-clark-cgp30",
              "name": "CGP30",
              "subcategories": []
            },
            {
              "id": "forklifts-clark-cgp40",
              "name": "CGP40",
              "subcategories": []
            },
            {
              "id": "forklifts-clark-ch60",
              "name": "CH60",
              "subcategories": []
            },
            {
              "id": "forklifts-clark-chy160",
              "name": "CHY160",
              "subcategories": []
            },
            {
              "id": "forklifts-clark-chj55",
              "name": "CHJ55",
              "subcategories": []
            },
            {
              "id": "forklifts-clark-cmp25",
              "name": "CMP25",
              "subcategories": []
            },
            {
              "id": "forklifts-clark-cmp40",
              "name": "CMP40",
              "subcategories": []
            },
            {
              "id": "forklifts-clark-cmp45",
              "name": "CMP45",
              "subcategories": []
            },
            {
              "id": "forklifts-clark-cmp50",
              "name": "CMP50",
              "subcategories": []
            },
            {
              "id": "forklifts-clark-cmp70",
              "name": "CMP70",
              "subcategories": []
            },
            {
              "id": "forklifts-clark-cps12",
              "name": "CPS12",
              "subcategories": []
            },
            {
              "id": "forklifts-clark-ctm16",
              "name": "CTM16",
              "subcategories": []
            },
            {
              "id": "forklifts-clark-cy40",
              "name": "CY40",
              "subcategories": []
            },
            {
              "id": "forklifts-clark-cy50",
              "name": "CY50",
              "subcategories": []
            },
            {
              "id": "forklifts-clark-cy60",
              "name": "CY60",
              "subcategories": []
            },
            {
              "id": "forklifts-clark-cy300",
              "name": "CY300",
              "subcategories": []
            },
            {
              "id": "forklifts-clark-cy800",
              "name": "CY800",
              "subcategories": []
            },
            {
              "id": "forklifts-clark-cys250",
              "name": "CYS250",
              "subcategories": []
            },
            {
              "id": "forklifts-clark-dpl60",
              "name": "DPL60",
              "subcategories": []
            },
            {
              "id": "forklifts-clark-ec25",
              "name": "EC25",
              "subcategories": []
            },
            {
              "id": "forklifts-clark-ecg25",
              "name": "ECG25",
              "subcategories": []
            },
            {
              "id": "forklifts-clark-ecg30",
              "name": "ECG30",
              "subcategories": []
            },
            {
              "id": "forklifts-clark-ecx20",
              "name": "ECX20",
              "subcategories": []
            },
            {
              "id": "forklifts-clark-ecx25",
              "name": "ECX25",
              "subcategories": []
            },
            {
              "id": "forklifts-clark-ecx30",
              "name": "ECX30",
              "subcategories": []
            },
            {
              "id": "forklifts-clark-ecx32",
              "name": "ECX32",
              "subcategories": []
            },
            {
              "id": "forklifts-clark-esx15",
              "name": "ESX15",
              "subcategories": []
            },
            {
              "id": "forklifts-clark-esx20",
              "name": "ESX20",
              "subcategories": []
            },
            {
              "id": "forklifts-clark-esx25",
              "name": "ESX25",
              "subcategories": []
            },
            {
              "id": "forklifts-clark-gcs17",
              "name": "GCS17",
              "subcategories": []
            },
            {
              "id": "forklifts-clark-gcs25",
              "name": "GCS25",
              "subcategories": []
            },
            {
              "id": "forklifts-clark-gcs40",
              "name": "GCS40",
              "subcategories": []
            },
            {
              "id": "forklifts-clark-gcx40",
              "name": "GCX40",
              "subcategories": []
            },
            {
              "id": "forklifts-clark-gcx50",
              "name": "GCX50",
              "subcategories": []
            },
            {
              "id": "forklifts-clark-gex18",
              "name": "GEX18",
              "subcategories": []
            },
            {
              "id": "forklifts-clark-gex20",
              "name": "GEX20",
              "subcategories": []
            },
            {
              "id": "forklifts-clark-gex25",
              "name": "GEX25",
              "subcategories": []
            },
            {
              "id": "forklifts-clark-gpm20",
              "name": "GPM20",
              "subcategories": []
            },
            {
              "id": "forklifts-clark-gpm25",
              "name": "GPM25",
              "subcategories": []
            },
            {
              "id": "forklifts-clark-gps15",
              "name": "GPS15",
              "subcategories": []
            },
            {
              "id": "forklifts-clark-gps20",
              "name": "GPS20",
              "subcategories": []
            },
            {
              "id": "forklifts-clark-gps25",
              "name": "GPS25",
              "subcategories": []
            },
            {
              "id": "forklifts-clark-gps30",
              "name": "GPS30",
              "subcategories": []
            },
            {
              "id": "forklifts-clark-gpx20",
              "name": "GPX20",
              "subcategories": []
            },
            {
              "id": "forklifts-clark-gpx25",
              "name": "GPX25",
              "subcategories": []
            },
            {
              "id": "forklifts-clark-gpx30",
              "name": "GPX30",
              "subcategories": []
            },
            {
              "id": "forklifts-clark-gpx35",
              "name": "GPX35",
              "subcategories": []
            },
            {
              "id": "forklifts-clark-gpx40",
              "name": "GPX40",
              "subcategories": []
            },
            {
              "id": "forklifts-clark-gts20",
              "name": "GTS20",
              "subcategories": []
            },
            {
              "id": "forklifts-clark-gts25",
              "name": "GTS25",
              "subcategories": []
            },
            {
              "id": "forklifts-clark-gts30",
              "name": "GTS30",
              "subcategories": []
            },
            {
              "id": "forklifts-clark-gts33",
              "name": "GTS33",
              "subcategories": []
            },
            {
              "id": "forklifts-clark-gtx18",
              "name": "GTX18",
              "subcategories": []
            },
            {
              "id": "forklifts-clark-gtx20",
              "name": "GTX20",
              "subcategories": []
            },
            {
              "id": "forklifts-clark-hwx",
              "name": "HWX",
              "subcategories": []
            },
            {
              "id": "forklifts-clark-hwxe",
              "name": "HWXE",
              "subcategories": []
            },
            {
              "id": "forklifts-clark-l35",
              "name": "L35",
              "subcategories": []
            },
            {
              "id": "forklifts-clark-lwio15",
              "name": "LWIO15",
              "subcategories": []
            },
            {
              "id": "forklifts-clark-np300",
              "name": "NP300",
              "subcategories": []
            },
            {
              "id": "forklifts-clark-npr15",
              "name": "NPR15",
              "subcategories": []
            },
            {
              "id": "forklifts-clark-npr17",
              "name": "NPR17",
              "subcategories": []
            },
            {
              "id": "forklifts-clark-npr20",
              "name": "NPR20",
              "subcategories": []
            },
            {
              "id": "forklifts-clark-npr22",
              "name": "NPR22",
              "subcategories": []
            },
            {
              "id": "forklifts-clark-npx15",
              "name": "NPX15",
              "subcategories": []
            },
            {
              "id": "forklifts-clark-npx17",
              "name": "NPX17",
              "subcategories": []
            },
            {
              "id": "forklifts-clark-npx20",
              "name": "NPX20",
              "subcategories": []
            },
            {
              "id": "forklifts-clark-op15",
              "name": "OP15",
              "subcategories": []
            },
            {
              "id": "forklifts-clark-osq192",
              "name": "OSQ192",
              "subcategories": []
            },
            {
              "id": "forklifts-clark-osx15",
              "name": "OSX15",
              "subcategories": []
            },
            {
              "id": "forklifts-clark-pwx30",
              "name": "PWX30",
              "subcategories": []
            },
            {
              "id": "forklifts-clark-rhy",
              "name": "RHY",
              "subcategories": []
            },
            {
              "id": "forklifts-clark-s20",
              "name": "S20",
              "subcategories": []
            },
            {
              "id": "forklifts-clark-s25",
              "name": "S25",
              "subcategories": []
            },
            {
              "id": "forklifts-clark-s30",
              "name": "S30",
              "subcategories": []
            },
            {
              "id": "forklifts-clark-s32",
              "name": "S32",
              "subcategories": []
            },
            {
              "id": "forklifts-clark-s35",
              "name": "S35",
              "subcategories": []
            },
            {
              "id": "forklifts-clark-s40",
              "name": "S40",
              "subcategories": []
            },
            {
              "id": "forklifts-clark-s60",
              "name": "S60",
              "subcategories": []
            },
            {
              "id": "forklifts-clark-sec",
              "name": "SEC",
              "subcategories": []
            },
            {
              "id": "forklifts-clark-ses",
              "name": "SES",
              "subcategories": []
            },
            {
              "id": "forklifts-clark-ss",
              "name": "SS",
              "subcategories": []
            },
            {
              "id": "forklifts-clark-tm15",
              "name": "TM15",
              "subcategories": []
            },
            {
              "id": "forklifts-clark-tmg15",
              "name": "TMG15",
              "subcategories": []
            },
            {
              "id": "forklifts-clark-tmg20",
              "name": "TMG20",
              "subcategories": []
            },
            {
              "id": "forklifts-clark-tmx15",
              "name": "TMX15",
              "subcategories": []
            },
            {
              "id": "forklifts-clark-tmx17",
              "name": "TMX17",
              "subcategories": []
            },
            {
              "id": "forklifts-clark-tmx20",
              "name": "TMX20",
              "subcategories": []
            },
            {
              "id": "forklifts-clark-tmx25",
              "name": "TMX25",
              "subcategories": []
            },
            {
              "id": "forklifts-clark-tw25",
              "name": "TW25",
              "subcategories": []
            },
            {
              "id": "forklifts-clark-twli20",
              "name": "TWLI20",
              "subcategories": []
            },
            {
              "id": "forklifts-clark-ut20",
              "name": "UT20",
              "subcategories": []
            },
            {
              "id": "forklifts-clark-wm10",
              "name": "WM10",
              "subcategories": []
            },
            {
              "id": "forklifts-clark-wpl25",
              "name": "WPL25",
              "subcategories": []
            },
            {
              "id": "forklifts-clark-wpl40",
              "name": "WPL40",
              "subcategories": []
            },
            {
              "id": "forklifts-clark-wpx45",
              "name": "WPX45",
              "subcategories": []
            },
            {
              "id": "forklifts-clark-wsrx30",
              "name": "WSRX30",
              "subcategories": []
            },
            {
              "id": "forklifts-clark-other",
              "name": "OTHER",
              "subcategories": []
            }
          ]
        },
        {
          "id": "forklifts-doosan",
          "name": "Doosan",
          "subcategories": [
            {
              "id": "forklifts-doosan-b15",
              "name": "B15",
              "subcategories": []
            },
            {
              "id": "forklifts-doosan-b18",
              "name": "B18",
              "subcategories": []
            },
            {
              "id": "forklifts-doosan-b20",
              "name": "B20",
              "subcategories": []
            },
            {
              "id": "forklifts-doosan-b20t",
              "name": "B20T",
              "subcategories": []
            },
            {
              "id": "forklifts-doosan-b25",
              "name": "B25",
              "subcategories": []
            },
            {
              "id": "forklifts-doosan-b30",
              "name": "B30",
              "subcategories": []
            },
            {
              "id": "forklifts-doosan-b35",
              "name": "B35",
              "subcategories": []
            },
            {
              "id": "forklifts-doosan-b50",
              "name": "B50",
              "subcategories": []
            },
            {
              "id": "forklifts-doosan-bc15",
              "name": "BC15",
              "subcategories": []
            },
            {
              "id": "forklifts-doosan-bc18",
              "name": "BC18",
              "subcategories": []
            },
            {
              "id": "forklifts-doosan-bc25",
              "name": "BC25",
              "subcategories": []
            },
            {
              "id": "forklifts-doosan-bc30",
              "name": "BC30",
              "subcategories": []
            },
            {
              "id": "forklifts-doosan-bc32",
              "name": "BC32",
              "subcategories": []
            },
            {
              "id": "forklifts-doosan-ber30",
              "name": "BER30",
              "subcategories": []
            },
            {
              "id": "forklifts-doosan-bop15",
              "name": "BOP15",
              "subcategories": []
            },
            {
              "id": "forklifts-doosan-br18",
              "name": "BR18",
              "subcategories": []
            },
            {
              "id": "forklifts-doosan-br20",
              "name": "BR20",
              "subcategories": []
            },
            {
              "id": "forklifts-doosan-bsl16",
              "name": "BSL16",
              "subcategories": []
            },
            {
              "id": "forklifts-doosan-bw23",
              "name": "BW23",
              "subcategories": []
            },
            {
              "id": "forklifts-doosan-bwp17",
              "name": "BWP17",
              "subcategories": []
            },
            {
              "id": "forklifts-doosan-bws17",
              "name": "BWS17",
              "subcategories": []
            },
            {
              "id": "forklifts-doosan-d15",
              "name": "D15",
              "subcategories": []
            },
            {
              "id": "forklifts-doosan-d20",
              "name": "D20",
              "subcategories": []
            },
            {
              "id": "forklifts-doosan-d25",
              "name": "D25",
              "subcategories": []
            },
            {
              "id": "forklifts-doosan-d30",
              "name": "D30",
              "subcategories": []
            },
            {
              "id": "forklifts-doosan-d33",
              "name": "D33",
              "subcategories": []
            },
            {
              "id": "forklifts-doosan-d35",
              "name": "D35",
              "subcategories": []
            },
            {
              "id": "forklifts-doosan-d40",
              "name": "D40",
              "subcategories": []
            },
            {
              "id": "forklifts-doosan-d45",
              "name": "D45",
              "subcategories": []
            },
            {
              "id": "forklifts-doosan-d50",
              "name": "D50",
              "subcategories": []
            },
            {
              "id": "forklifts-doosan-d55",
              "name": "D55",
              "subcategories": []
            },
            {
              "id": "forklifts-doosan-d60",
              "name": "D60",
              "subcategories": []
            },
            {
              "id": "forklifts-doosan-d70",
              "name": "D70",
              "subcategories": []
            },
            {
              "id": "forklifts-doosan-d80",
              "name": "D80",
              "subcategories": []
            },
            {
              "id": "forklifts-doosan-d90",
              "name": "D90",
              "subcategories": []
            },
            {
              "id": "forklifts-doosan-d100",
              "name": "D100",
              "subcategories": []
            },
            {
              "id": "forklifts-doosan-d110",
              "name": "D110",
              "subcategories": []
            },
            {
              "id": "forklifts-doosan-d120",
              "name": "D120",
              "subcategories": []
            },
            {
              "id": "forklifts-doosan-d130",
              "name": "D130",
              "subcategories": []
            },
            {
              "id": "forklifts-doosan-d140",
              "name": "D140",
              "subcategories": []
            },
            {
              "id": "forklifts-doosan-d160",
              "name": "D160",
              "subcategories": []
            },
            {
              "id": "forklifts-doosan-dv180",
              "name": "DV180",
              "subcategories": []
            },
            {
              "id": "forklifts-doosan-dv250",
              "name": "DV250",
              "subcategories": []
            },
            {
              "id": "forklifts-doosan-g15",
              "name": "G15",
              "subcategories": []
            },
            {
              "id": "forklifts-doosan-g18",
              "name": "G18",
              "subcategories": []
            },
            {
              "id": "forklifts-doosan-g20",
              "name": "G20",
              "subcategories": []
            },
            {
              "id": "forklifts-doosan-g25",
              "name": "G25",
              "subcategories": []
            },
            {
              "id": "forklifts-doosan-g30",
              "name": "G30",
              "subcategories": []
            },
            {
              "id": "forklifts-doosan-g30",
              "name": "G30",
              "subcategories": []
            },
            {
              "id": "forklifts-doosan-g33",
              "name": "G33",
              "subcategories": []
            },
            {
              "id": "forklifts-doosan-g35",
              "name": "G35",
              "subcategories": []
            },
            {
              "id": "forklifts-doosan-g40",
              "name": "G40",
              "subcategories": []
            },
            {
              "id": "forklifts-doosan-g45",
              "name": "G45",
              "subcategories": []
            },
            {
              "id": "forklifts-doosan-g50",
              "name": "G50",
              "subcategories": []
            },
            {
              "id": "forklifts-doosan-g55",
              "name": "G55",
              "subcategories": []
            },
            {
              "id": "forklifts-doosan-g70",
              "name": "G70",
              "subcategories": []
            },
            {
              "id": "forklifts-doosan-gc15",
              "name": "GC15",
              "subcategories": []
            },
            {
              "id": "forklifts-doosan-gc18",
              "name": "GC18",
              "subcategories": []
            },
            {
              "id": "forklifts-doosan-gc20",
              "name": "GC20",
              "subcategories": []
            },
            {
              "id": "forklifts-doosan-gc25",
              "name": "GC25",
              "subcategories": []
            },
            {
              "id": "forklifts-doosan-gc30",
              "name": "GC30",
              "subcategories": []
            },
            {
              "id": "forklifts-doosan-gc33",
              "name": "GC33",
              "subcategories": []
            },
            {
              "id": "forklifts-doosan-gc35",
              "name": "GC35",
              "subcategories": []
            },
            {
              "id": "forklifts-doosan-gc40",
              "name": "GC40",
              "subcategories": []
            },
            {
              "id": "forklifts-doosan-gc45",
              "name": "GC45",
              "subcategories": []
            },
            {
              "id": "forklifts-doosan-gc55",
              "name": "GC55",
              "subcategories": []
            },
            {
              "id": "forklifts-doosan-other",
              "name": "OTHER",
              "subcategories": []
            }
          ]
        },
        {
          "id": "forklifts-hangcha",
          "name": "Hangcha",
          "subcategories": [
            {
              "id": "forklifts-hangcha-cbd15",
              "name": "CBD15",
              "subcategories": []
            },
            {
              "id": "forklifts-hangcha-cbd30",
              "name": "CBD30",
              "subcategories": []
            },
            {
              "id": "forklifts-hangcha-cdd12",
              "name": "CDD12",
              "subcategories": []
            },
            {
              "id": "forklifts-hangcha-cdd16",
              "name": "CDD16",
              "subcategories": []
            },
            {
              "id": "forklifts-hangcha-cdd20",
              "name": "CDD20",
              "subcategories": []
            },
            {
              "id": "forklifts-hangcha-cjd13",
              "name": "CJD13",
              "subcategories": []
            },
            {
              "id": "forklifts-hangcha-cpcd25",
              "name": "CPCD25",
              "subcategories": []
            },
            {
              "id": "forklifts-hangcha-cpcd30",
              "name": "CPCD30",
              "subcategories": []
            },
            {
              "id": "forklifts-hangcha-cpcd35",
              "name": "CPCD35",
              "subcategories": []
            },
            {
              "id": "forklifts-hangcha-cpcd40",
              "name": "CPCD40",
              "subcategories": []
            },
            {
              "id": "forklifts-hangcha-cpcd50",
              "name": "CPCD50",
              "subcategories": []
            },
            {
              "id": "forklifts-hangcha-cpcd55",
              "name": "CPCD55",
              "subcategories": []
            },
            {
              "id": "forklifts-hangcha-cpcd70",
              "name": "CPCD70",
              "subcategories": []
            },
            {
              "id": "forklifts-hangcha-cpcd100",
              "name": "CPCD100",
              "subcategories": []
            },
            {
              "id": "forklifts-hangcha-cpcd160",
              "name": "CPCD160",
              "subcategories": []
            },
            {
              "id": "forklifts-hangcha-cpd25",
              "name": "CPD25",
              "subcategories": []
            },
            {
              "id": "forklifts-hangcha-cpd32",
              "name": "CPD32",
              "subcategories": []
            },
            {
              "id": "forklifts-hangcha-cpd35",
              "name": "CPD35",
              "subcategories": []
            },
            {
              "id": "forklifts-hangcha-cpd38",
              "name": "CPD38",
              "subcategories": []
            },
            {
              "id": "forklifts-hangcha-cpd50",
              "name": "CPD50",
              "subcategories": []
            },
            {
              "id": "forklifts-hangcha-cpd53",
              "name": "CPD53",
              "subcategories": []
            },
            {
              "id": "forklifts-hangcha-cpd80",
              "name": "CPD80",
              "subcategories": []
            },
            {
              "id": "forklifts-hangcha-cpdb18",
              "name": "CPDB18",
              "subcategories": []
            },
            {
              "id": "forklifts-hangcha-cpdb20",
              "name": "CPDB20",
              "subcategories": []
            },
            {
              "id": "forklifts-hangcha-cpds18",
              "name": "CPDS18",
              "subcategories": []
            },
            {
              "id": "forklifts-hangcha-cpds20",
              "name": "CPDS20",
              "subcategories": []
            },
            {
              "id": "forklifts-hangcha-cpqd15",
              "name": "CPQD15",
              "subcategories": []
            },
            {
              "id": "forklifts-hangcha-cpqd25",
              "name": "CPQD25",
              "subcategories": []
            },
            {
              "id": "forklifts-hangcha-cpqd30",
              "name": "CPQD30",
              "subcategories": []
            },
            {
              "id": "forklifts-hangcha-cpqyd25",
              "name": "CPQYD25",
              "subcategories": []
            },
            {
              "id": "forklifts-hangcha-cpqyd30",
              "name": "CPQYD30",
              "subcategories": []
            },
            {
              "id": "forklifts-hangcha-cpqyd40",
              "name": "CPQYD40",
              "subcategories": []
            },
            {
              "id": "forklifts-hangcha-cpqyd70",
              "name": "CPQYD70",
              "subcategories": []
            },
            {
              "id": "forklifts-hangcha-cpyd18",
              "name": "CPYD18",
              "subcategories": []
            },
            {
              "id": "forklifts-hangcha-cpyd25",
              "name": "CPYD25",
              "subcategories": []
            },
            {
              "id": "forklifts-hangcha-cpyd30",
              "name": "CPYD30",
              "subcategories": []
            },
            {
              "id": "forklifts-hangcha-cpyd32",
              "name": "CPYD32",
              "subcategories": []
            },
            {
              "id": "forklifts-hangcha-cpyd35",
              "name": "CPYD35",
              "subcategories": []
            },
            {
              "id": "forklifts-hangcha-cpyd40",
              "name": "CPYD40",
              "subcategories": []
            },
            {
              "id": "forklifts-hangcha-cpyd45",
              "name": "CPYD45",
              "subcategories": []
            },
            {
              "id": "forklifts-hangcha-cpyd50",
              "name": "CPYD50",
              "subcategories": []
            },
            {
              "id": "forklifts-hangcha-cpyd55",
              "name": "CPYD55",
              "subcategories": []
            },
            {
              "id": "forklifts-hangcha-cpyd70",
              "name": "CPYD70",
              "subcategories": []
            },
            {
              "id": "forklifts-hangcha-cqd14",
              "name": "CQD14",
              "subcategories": []
            },
            {
              "id": "forklifts-hangcha-cqdb14",
              "name": "CQDB14",
              "subcategories": []
            },
            {
              "id": "forklifts-hangcha-ctd12",
              "name": "CTD12",
              "subcategories": []
            },
            {
              "id": "forklifts-hangcha-fp25",
              "name": "FP25",
              "subcategories": []
            },
            {
              "id": "forklifts-hangcha-fp70",
              "name": "FP70",
              "subcategories": []
            },
            {
              "id": "forklifts-hangcha-r50",
              "name": "R50",
              "subcategories": []
            },
            {
              "id": "forklifts-hangcha-rt25",
              "name": "RT25",
              "subcategories": []
            },
            {
              "id": "forklifts-hangcha-rt35",
              "name": "RT35",
              "subcategories": []
            },
            {
              "id": "forklifts-hangcha-xf25",
              "name": "XF25",
              "subcategories": []
            },
            {
              "id": "forklifts-hangcha-xf30",
              "name": "XF30",
              "subcategories": []
            },
            {
              "id": "forklifts-hangcha-other",
              "name": "OTHER",
              "subcategories": []
            }
          ]
        },
        {
          "id": "forklifts-mitsubishi",
          "name": "Mitsubishi",
          "subcategories": [
            {
              "id": "forklifts-mitsubishi-2fbc",
              "name": "2FBC",
              "subcategories": []
            },
            {
              "id": "forklifts-mitsubishi-edr15",
              "name": "EDR15",
              "subcategories": []
            },
            {
              "id": "forklifts-mitsubishi-eop15",
              "name": "EOP15",
              "subcategories": []
            },
            {
              "id": "forklifts-mitsubishi-esr15",
              "name": "ESR15",
              "subcategories": []
            },
            {
              "id": "forklifts-mitsubishi-esr18",
              "name": "ESR18",
              "subcategories": []
            },
            {
              "id": "forklifts-mitsubishi-esr20",
              "name": "ESR20",
              "subcategories": []
            },
            {
              "id": "forklifts-mitsubishi-f25b-15",
              "name": "F25B-15",
              "subcategories": []
            },
            {
              "id": "forklifts-mitsubishi-fb15",
              "name": "FB15",
              "subcategories": []
            },
            {
              "id": "forklifts-mitsubishi-fb16",
              "name": "FB16",
              "subcategories": []
            },
            {
              "id": "forklifts-mitsubishi-fb18",
              "name": "FB18",
              "subcategories": []
            },
            {
              "id": "forklifts-mitsubishi-fb20",
              "name": "FB20",
              "subcategories": []
            },
            {
              "id": "forklifts-mitsubishi-fb25",
              "name": "FB25",
              "subcategories": []
            },
            {
              "id": "forklifts-mitsubishi-fb45",
              "name": "FB45",
              "subcategories": []
            },
            {
              "id": "forklifts-mitsubishi-fbc15",
              "name": "FBC15",
              "subcategories": []
            },
            {
              "id": "forklifts-mitsubishi-fbc18",
              "name": "FBC18",
              "subcategories": []
            },
            {
              "id": "forklifts-mitsubishi-fbc25",
              "name": "FBC25",
              "subcategories": []
            },
            {
              "id": "forklifts-mitsubishi-fbc30",
              "name": "FBC30",
              "subcategories": []
            },
            {
              "id": "forklifts-mitsubishi-fbcs",
              "name": "FBCS",
              "subcategories": []
            },
            {
              "id": "forklifts-mitsubishi-fd18",
              "name": "FD18",
              "subcategories": []
            },
            {
              "id": "forklifts-mitsubishi-fd20",
              "name": "FD20",
              "subcategories": []
            },
            {
              "id": "forklifts-mitsubishi-fd25",
              "name": "FD25",
              "subcategories": []
            },
            {
              "id": "forklifts-mitsubishi-fd30",
              "name": "FD30",
              "subcategories": []
            },
            {
              "id": "forklifts-mitsubishi-fd33",
              "name": "FD33",
              "subcategories": []
            },
            {
              "id": "forklifts-mitsubishi-fd35",
              "name": "FD35",
              "subcategories": []
            },
            {
              "id": "forklifts-mitsubishi-fd40",
              "name": "FD40",
              "subcategories": []
            },
            {
              "id": "forklifts-mitsubishi-fd45",
              "name": "FD45",
              "subcategories": []
            },
            {
              "id": "forklifts-mitsubishi-fd50",
              "name": "FD50",
              "subcategories": []
            },
            {
              "id": "forklifts-mitsubishi-fd60",
              "name": "FD60",
              "subcategories": []
            },
            {
              "id": "forklifts-mitsubishi-fd70",
              "name": "FD70",
              "subcategories": []
            },
            {
              "id": "forklifts-mitsubishi-fd100",
              "name": "FD100",
              "subcategories": []
            },
            {
              "id": "forklifts-mitsubishi-fd120",
              "name": "FD120",
              "subcategories": []
            },
            {
              "id": "forklifts-mitsubishi-fd150",
              "name": "FD150",
              "subcategories": []
            },
            {
              "id": "forklifts-mitsubishi-fd160",
              "name": "FD160",
              "subcategories": []
            },
            {
              "id": "forklifts-mitsubishi-fd250",
              "name": "FD250",
              "subcategories": []
            },
            {
              "id": "forklifts-mitsubishi-fd300",
              "name": "FD300",
              "subcategories": []
            },
            {
              "id": "forklifts-mitsubishi-fg15",
              "name": "FG15",
              "subcategories": []
            },
            {
              "id": "forklifts-mitsubishi-fg18",
              "name": "FG18",
              "subcategories": []
            },
            {
              "id": "forklifts-mitsubishi-fg20",
              "name": "FG20",
              "subcategories": []
            },
            {
              "id": "forklifts-mitsubishi-fg25",
              "name": "FG25",
              "subcategories": []
            },
            {
              "id": "forklifts-mitsubishi-fg30",
              "name": "FG30",
              "subcategories": []
            },
            {
              "id": "forklifts-mitsubishi-fg33",
              "name": "FG33",
              "subcategories": []
            },
            {
              "id": "forklifts-mitsubishi-fg35",
              "name": "FG35",
              "subcategories": []
            },
            {
              "id": "forklifts-mitsubishi-fg40",
              "name": "FG40",
              "subcategories": []
            },
            {
              "id": "forklifts-mitsubishi-fg45",
              "name": "FG45",
              "subcategories": []
            },
            {
              "id": "forklifts-mitsubishi-fg50",
              "name": "FG50",
              "subcategories": []
            },
            {
              "id": "forklifts-mitsubishi-fg55",
              "name": "FG55",
              "subcategories": []
            },
            {
              "id": "forklifts-mitsubishi-fgc15",
              "name": "FGC15",
              "subcategories": []
            },
            {
              "id": "forklifts-mitsubishi-fgc18",
              "name": "FGC18",
              "subcategories": []
            },
            {
              "id": "forklifts-mitsubishi-fgc20",
              "name": "FGC20",
              "subcategories": []
            },
            {
              "id": "forklifts-mitsubishi-fgc25",
              "name": "FGC25",
              "subcategories": []
            },
            {
              "id": "forklifts-mitsubishi-fgc30",
              "name": "FGC30",
              "subcategories": []
            },
            {
              "id": "forklifts-mitsubishi-fgc33",
              "name": "FGC33",
              "subcategories": []
            },
            {
              "id": "forklifts-mitsubishi-fgc40",
              "name": "FGC40",
              "subcategories": []
            },
            {
              "id": "forklifts-mitsubishi-fgc45",
              "name": "FGC45",
              "subcategories": []
            },
            {
              "id": "forklifts-mitsubishi-fgc55",
              "name": "FGC55",
              "subcategories": []
            },
            {
              "id": "forklifts-mitsubishi-fgc55",
              "name": "FGC55",
              "subcategories": []
            },
            {
              "id": "forklifts-mitsubishi-fgc70",
              "name": "FGC70",
              "subcategories": []
            },
            {
              "id": "forklifts-mitsubishi-fgce25p",
              "name": "FGCE25P",
              "subcategories": []
            },
            {
              "id": "forklifts-mitsubishi-pw23",
              "name": "PW23",
              "subcategories": []
            },
            {
              "id": "forklifts-mitsubishi-pwr30",
              "name": "PWR30",
              "subcategories": []
            },
            {
              "id": "forklifts-mitsubishi-rbm25",
              "name": "RBM25",
              "subcategories": []
            },
            {
              "id": "forklifts-mitsubishi-v70b45",
              "name": "V70B45",
              "subcategories": []
            },
            {
              "id": "forklifts-mitsubishi-other",
              "name": "OTHER",
              "subcategories": []
            }
          ]
        },
        {
          "id": "forklifts-aisle-master",
          "name": "Aisle Master",
          "subcategories": [
            {
              "id": "forklifts-aisle-master-15",
              "name": "15",
              "subcategories": []
            },
            {
              "id": "forklifts-aisle-master-20",
              "name": "20",
              "subcategories": []
            },
            {
              "id": "forklifts-aisle-master-33",
              "name": "33",
              "subcategories": []
            },
            {
              "id": "forklifts-aisle-master-44",
              "name": "44",
              "subcategories": []
            },
            {
              "id": "forklifts-aisle-master-ame-op",
              "name": "AME-OP",
              "subcategories": []
            },
            {
              "id": "forklifts-aisle-master-other",
              "name": "OTHER",
              "subcategories": []
            }
          ]
        },
        {
          "id": "forklifts-ausa",
          "name": "Ausa",
          "subcategories": [
            {
              "id": "forklifts-ausa-c11",
              "name": "C11",
              "subcategories": []
            },
            {
              "id": "forklifts-ausa-c150",
              "name": "C150",
              "subcategories": []
            },
            {
              "id": "forklifts-ausa-c200",
              "name": "C200",
              "subcategories": []
            },
            {
              "id": "forklifts-ausa-c201",
              "name": "C201",
              "subcategories": []
            },
            {
              "id": "forklifts-ausa-c250",
              "name": "C250",
              "subcategories": []
            },
            {
              "id": "forklifts-ausa-c251",
              "name": "C251",
              "subcategories": []
            },
            {
              "id": "forklifts-ausa-c350",
              "name": "C350",
              "subcategories": []
            },
            {
              "id": "forklifts-ausa-c351",
              "name": "C351",
              "subcategories": []
            },
            {
              "id": "forklifts-ausa-c400",
              "name": "C400",
              "subcategories": []
            },
            {
              "id": "forklifts-ausa-c401",
              "name": "C401",
              "subcategories": []
            },
            {
              "id": "forklifts-ausa-c500",
              "name": "C500",
              "subcategories": []
            },
            {
              "id": "forklifts-ausa-c501",
              "name": "C501",
              "subcategories": []
            },
            {
              "id": "forklifts-ausa-ce11",
              "name": "CE11",
              "subcategories": []
            },
            {
              "id": "forklifts-ausa-cv20",
              "name": "CV20",
              "subcategories": []
            },
            {
              "id": "forklifts-ausa-other",
              "name": "OTHER",
              "subcategories": []
            }
          ]
        },
        {
          "id": "forklifts-baoli",
          "name": "Baoli",
          "subcategories": [
            {
              "id": "forklifts-baoli-kb35",
              "name": "KB35",
              "subcategories": []
            },
            {
              "id": "forklifts-baoli-kbd",
              "name": "KBD",
              "subcategories": []
            },
            {
              "id": "forklifts-baoli-kbe25",
              "name": "KBE25",
              "subcategories": []
            },
            {
              "id": "forklifts-baoli-kbe30",
              "name": "KBE30",
              "subcategories": []
            },
            {
              "id": "forklifts-baoli-kbe35",
              "name": "KBE35",
              "subcategories": []
            },
            {
              "id": "forklifts-baoli-kbet18",
              "name": "KBET18",
              "subcategories": []
            },
            {
              "id": "forklifts-baoli-kbg25",
              "name": "KBG25",
              "subcategories": []
            },
            {
              "id": "forklifts-baoli-kbg30",
              "name": "KBG30",
              "subcategories": []
            },
            {
              "id": "forklifts-baoli-kbg35",
              "name": "KBG35",
              "subcategories": []
            },
            {
              "id": "forklifts-baoli-other",
              "name": "OTHER",
              "subcategories": []
            }
          ]
        },
        {
          "id": "forklifts-bendi",
          "name": "Bendi",
          "subcategories": [
            {
              "id": "forklifts-bendi-b3-30",
              "name": "B3/30",
              "subcategories": []
            },
            {
              "id": "forklifts-bendi-b30",
              "name": "B30",
              "subcategories": []
            },
            {
              "id": "forklifts-bendi-b35-42",
              "name": "B35/42",
              "subcategories": []
            },
            {
              "id": "forklifts-bendi-b40",
              "name": "B40",
              "subcategories": []
            },
            {
              "id": "forklifts-bendi-b4015",
              "name": "B4015",
              "subcategories": []
            },
            {
              "id": "forklifts-bendi-b45",
              "name": "B45",
              "subcategories": []
            },
            {
              "id": "forklifts-bendi-b50",
              "name": "B50",
              "subcategories": []
            },
            {
              "id": "forklifts-bendi-b55",
              "name": "B55",
              "subcategories": []
            },
            {
              "id": "forklifts-bendi-be4082xss",
              "name": "BE4082XSS",
              "subcategories": []
            },
            {
              "id": "forklifts-bendi-be4077",
              "name": "BE4077",
              "subcategories": []
            },
            {
              "id": "forklifts-bendi-other",
              "name": "OTHER",
              "subcategories": []
            }
          ]
        },
        {
          "id": "forklifts-big-joe",
          "name": "Big Joe",
          "subcategories": [
            {
              "id": "forklifts-big-joe-cb22",
              "name": "CB22",
              "subcategories": []
            },
            {
              "id": "forklifts-big-joe-cb33",
              "name": "CB33",
              "subcategories": []
            },
            {
              "id": "forklifts-big-joe-d40",
              "name": "D40",
              "subcategories": []
            },
            {
              "id": "forklifts-big-joe-e30",
              "name": "E30",
              "subcategories": []
            },
            {
              "id": "forklifts-big-joe-j0",
              "name": "J0",
              "subcategories": []
            },
            {
              "id": "forklifts-big-joe-j1",
              "name": "J1",
              "subcategories": []
            },
            {
              "id": "forklifts-big-joe-j2",
              "name": "J2",
              "subcategories": []
            },
            {
              "id": "forklifts-big-joe-lpe60",
              "name": "LPE60",
              "subcategories": []
            },
            {
              "id": "forklifts-big-joe-lpt33",
              "name": "LPT33",
              "subcategories": []
            },
            {
              "id": "forklifts-big-joe-lpt40",
              "name": "LPT40",
              "subcategories": []
            },
            {
              "id": "forklifts-big-joe-lxe37",
              "name": "LXE37",
              "subcategories": []
            },
            {
              "id": "forklifts-big-joe-lxe40",
              "name": "LXE40",
              "subcategories": []
            },
            {
              "id": "forklifts-big-joe-lxe50",
              "name": "LXE50",
              "subcategories": []
            },
            {
              "id": "forklifts-big-joe-m22",
              "name": "M22",
              "subcategories": []
            },
            {
              "id": "forklifts-big-joe-pdm30",
              "name": "PDM30",
              "subcategories": []
            },
            {
              "id": "forklifts-big-joe-pds30",
              "name": "PDS30",
              "subcategories": []
            },
            {
              "id": "forklifts-big-joe-pdsr30",
              "name": "PDSR30",
              "subcategories": []
            },
            {
              "id": "forklifts-big-joe-ptw4048",
              "name": "PTW4048",
              "subcategories": []
            },
            {
              "id": "forklifts-big-joe-wpt45",
              "name": "WPT45",
              "subcategories": []
            },
            {
              "id": "forklifts-big-joe-wrt60",
              "name": "WRT60",
              "subcategories": []
            },
            {
              "id": "forklifts-big-joe-other",
              "name": "OTHER",
              "subcategories": []
            }
          ]
        },
        {
          "id": "forklifts-btlifts",
          "name": "Btlifts",
          "subcategories": [
            {
              "id": "forklifts-btlifts-c3e150",
              "name": "C3E150",
              "subcategories": []
            },
            {
              "id": "forklifts-btlifts-c3e160",
              "name": "C3E160",
              "subcategories": []
            },
            {
              "id": "forklifts-btlifts-cbe",
              "name": "CBE",
              "subcategories": []
            },
            {
              "id": "forklifts-btlifts-cbg30",
              "name": "CBG30",
              "subcategories": []
            },
            {
              "id": "forklifts-btlifts-csx",
              "name": "CSX",
              "subcategories": []
            },
            {
              "id": "forklifts-btlifts-fre270",
              "name": "FRE270",
              "subcategories": []
            },
            {
              "id": "forklifts-btlifts-lpe200",
              "name": "LPE200",
              "subcategories": []
            },
            {
              "id": "forklifts-btlifts-lpe240",
              "name": "LPE240",
              "subcategories": []
            },
            {
              "id": "forklifts-btlifts-lwe180",
              "name": "LWE180",
              "subcategories": []
            },
            {
              "id": "forklifts-btlifts-lwe200",
              "name": "LWE200",
              "subcategories": []
            },
            {
              "id": "forklifts-btlifts-ome100",
              "name": "OME100",
              "subcategories": []
            },
            {
              "id": "forklifts-btlifts-op1000",
              "name": "OP1000",
              "subcategories": []
            },
            {
              "id": "forklifts-btlifts-rrb3",
              "name": "RRB3",
              "subcategories": []
            },
            {
              "id": "forklifts-btlifts-rre2",
              "name": "RRE2",
              "subcategories": []
            },
            {
              "id": "forklifts-btlifts-rre140",
              "name": "RRE140",
              "subcategories": []
            },
            {
              "id": "forklifts-btlifts-spe125",
              "name": "SPE125",
              "subcategories": []
            },
            {
              "id": "forklifts-btlifts-spe140",
              "name": "SPE140",
              "subcategories": []
            },
            {
              "id": "forklifts-btlifts-spe160",
              "name": "SPE160",
              "subcategories": []
            },
            {
              "id": "forklifts-btlifts-spe200",
              "name": "SPE200",
              "subcategories": []
            },
            {
              "id": "forklifts-btlifts-swe080",
              "name": "SWE080",
              "subcategories": []
            },
            {
              "id": "forklifts-btlifts-swe100",
              "name": "SWE100",
              "subcategories": []
            },
            {
              "id": "forklifts-btlifts-swe140",
              "name": "SWE140",
              "subcategories": []
            },
            {
              "id": "forklifts-btlifts-swe160",
              "name": "SWE160",
              "subcategories": []
            },
            {
              "id": "forklifts-btlifts-swe200",
              "name": "SWE200",
              "subcategories": []
            },
            {
              "id": "forklifts-btlifts-other",
              "name": "OTHER",
              "subcategories": []
            }
          ]
        },
        {
          "id": "forklifts-byd",
          "name": "Byd",
          "subcategories": [
            {
              "id": "forklifts-byd-cpd20",
              "name": "CPD20",
              "subcategories": []
            },
            {
              "id": "forklifts-byd-ecb18",
              "name": "ECB18",
              "subcategories": []
            },
            {
              "id": "forklifts-byd-ecb25",
              "name": "ECB25",
              "subcategories": []
            },
            {
              "id": "forklifts-byd-ecb27",
              "name": "ECB27",
              "subcategories": []
            },
            {
              "id": "forklifts-byd-ecb35",
              "name": "ECB35",
              "subcategories": []
            },
            {
              "id": "forklifts-byd-eccc27",
              "name": "ECCC27",
              "subcategories": []
            },
            {
              "id": "forklifts-byd-p20jw",
              "name": "P20JW",
              "subcategories": []
            },
            {
              "id": "forklifts-byd-pmw20",
              "name": "PMW20",
              "subcategories": []
            },
            {
              "id": "forklifts-byd-ptw20",
              "name": "PTW20",
              "subcategories": []
            },
            {
              "id": "forklifts-byd-other",
              "name": "OTHER",
              "subcategories": []
            }
          ]
        },
        {
          "id": "forklifts-case",
          "name": "Case",
          "subcategories": [
            {
              "id": "forklifts-case-580",
              "name": "580",
              "subcategories": []
            },
            {
              "id": "forklifts-case-580c",
              "name": "580C",
              "subcategories": []
            },
            {
              "id": "forklifts-case-584",
              "name": "584",
              "subcategories": []
            },
            {
              "id": "forklifts-case-584c",
              "name": "584C",
              "subcategories": []
            },
            {
              "id": "forklifts-case-585",
              "name": "585",
              "subcategories": []
            },
            {
              "id": "forklifts-case-585c",
              "name": "585C",
              "subcategories": []
            },
            {
              "id": "forklifts-case-585d",
              "name": "585D",
              "subcategories": []
            },
            {
              "id": "forklifts-case-585e",
              "name": "585E",
              "subcategories": []
            },
            {
              "id": "forklifts-case-585g",
              "name": "585G",
              "subcategories": []
            },
            {
              "id": "forklifts-case-586",
              "name": "586",
              "subcategories": []
            },
            {
              "id": "forklifts-case-586d",
              "name": "586D",
              "subcategories": []
            },
            {
              "id": "forklifts-case-586e",
              "name": "586E",
              "subcategories": []
            },
            {
              "id": "forklifts-case-586g",
              "name": "586G",
              "subcategories": []
            },
            {
              "id": "forklifts-case-586h",
              "name": "586H",
              "subcategories": []
            },
            {
              "id": "forklifts-case-588",
              "name": "588",
              "subcategories": []
            },
            {
              "id": "forklifts-case-588g",
              "name": "588G",
              "subcategories": []
            },
            {
              "id": "forklifts-case-588h",
              "name": "588H",
              "subcategories": []
            },
            {
              "id": "forklifts-case-m4k",
              "name": "M4K",
              "subcategories": []
            },
            {
              "id": "forklifts-case-other",
              "name": "OTHER",
              "subcategories": []
            }
          ]
        },
        {
          "id": "forklifts-castle-equipment",
          "name": "Castle Equipment",
          "subcategories": []
        },
        {
          "id": "forklifts-chl",
          "name": "Chl",
          "subcategories": [
            {
              "id": "forklifts-chl-cbd35",
              "name": "CBD35",
              "subcategories": []
            },
            {
              "id": "forklifts-chl-cdd12",
              "name": "CDD12",
              "subcategories": []
            },
            {
              "id": "forklifts-chl-cpcd25",
              "name": "CPCD25",
              "subcategories": []
            },
            {
              "id": "forklifts-chl-cpcd35",
              "name": "CPCD35",
              "subcategories": []
            },
            {
              "id": "forklifts-chl-cpd20",
              "name": "CPD20",
              "subcategories": []
            },
            {
              "id": "forklifts-chl-cpd25",
              "name": "CPD25",
              "subcategories": []
            },
            {
              "id": "forklifts-chl-cpd35",
              "name": "CPD35",
              "subcategories": []
            },
            {
              "id": "forklifts-chl-cpdsr20",
              "name": "CPDSR20",
              "subcategories": []
            },
            {
              "id": "forklifts-chl-cpqd15",
              "name": "CPQD15",
              "subcategories": []
            },
            {
              "id": "forklifts-chl-cpqd25",
              "name": "CPQD25",
              "subcategories": []
            },
            {
              "id": "forklifts-chl-cpqd30",
              "name": "CPQD30",
              "subcategories": []
            },
            {
              "id": "forklifts-chl-cpqyd40",
              "name": "CPQYD40",
              "subcategories": []
            },
            {
              "id": "forklifts-chl-cpyd25",
              "name": "CPYD25",
              "subcategories": []
            },
            {
              "id": "forklifts-chl-cpyd30",
              "name": "CPYD30",
              "subcategories": []
            },
            {
              "id": "forklifts-chl-cpyd35",
              "name": "CPYD35",
              "subcategories": []
            },
            {
              "id": "forklifts-chl-cpyd50",
              "name": "CPYD50",
              "subcategories": []
            },
            {
              "id": "forklifts-chl-ops15",
              "name": "OPS15",
              "subcategories": []
            },
            {
              "id": "forklifts-chl-other",
              "name": "OTHER",
              "subcategories": []
            }
          ]
        },
        {
          "id": "forklifts-combilift",
          "name": "Combilift",
          "subcategories": [
            {
              "id": "forklifts-combilift-20s",
              "name": "20S",
              "subcategories": []
            },
            {
              "id": "forklifts-combilift-c2500",
              "name": "C2500",
              "subcategories": []
            },
            {
              "id": "forklifts-combilift-c3000",
              "name": "C3000",
              "subcategories": []
            },
            {
              "id": "forklifts-combilift-c3500",
              "name": "C3500",
              "subcategories": []
            },
            {
              "id": "forklifts-combilift-c4000",
              "name": "C4000",
              "subcategories": []
            },
            {
              "id": "forklifts-combilift-c5000",
              "name": "C5000",
              "subcategories": []
            },
            {
              "id": "forklifts-combilift-c6000",
              "name": "C6000",
              "subcategories": []
            },
            {
              "id": "forklifts-combilift-c7000",
              "name": "C7000",
              "subcategories": []
            },
            {
              "id": "forklifts-combilift-c8000",
              "name": "C8000",
              "subcategories": []
            },
            {
              "id": "forklifts-combilift-c10000",
              "name": "C10000",
              "subcategories": []
            },
            {
              "id": "forklifts-combilift-c11000",
              "name": "C11000",
              "subcategories": []
            },
            {
              "id": "forklifts-combilift-c12000",
              "name": "C12000",
              "subcategories": []
            },
            {
              "id": "forklifts-combilift-c14000",
              "name": "C14000",
              "subcategories": []
            },
            {
              "id": "forklifts-combilift-c15000",
              "name": "C15000",
              "subcategories": []
            },
            {
              "id": "forklifts-combilift-c17300",
              "name": "C17300",
              "subcategories": []
            },
            {
              "id": "forklifts-combilift-c20000",
              "name": "C20000",
              "subcategories": []
            },
            {
              "id": "forklifts-combilift-c25000",
              "name": "C25000",
              "subcategories": []
            },
            {
              "id": "forklifts-combilift-c26000",
              "name": "C26000",
              "subcategories": []
            },
            {
              "id": "forklifts-combilift-c30000",
              "name": "C30000",
              "subcategories": []
            },
            {
              "id": "forklifts-combilift-cb6000",
              "name": "CB6000",
              "subcategories": []
            },
            {
              "id": "forklifts-combilift-cb6600",
              "name": "CB6600",
              "subcategories": []
            },
            {
              "id": "forklifts-combilift-cb8000",
              "name": "CB8000",
              "subcategories": []
            },
            {
              "id": "forklifts-combilift-cbe6000",
              "name": "CBE6000",
              "subcategories": []
            },
            {
              "id": "forklifts-combilift-combi-cre8",
              "name": "COMBI CRE8",
              "subcategories": []
            },
            {
              "id": "forklifts-combilift-combi-rt",
              "name": "COMBI RT",
              "subcategories": []
            },
            {
              "id": "forklifts-combilift-combi-sc3t",
              "name": "COMBI SC3T",
              "subcategories": []
            },
            {
              "id": "forklifts-combilift-combi-wr4",
              "name": "COMBI WR4",
              "subcategories": []
            },
            {
              "id": "forklifts-combilift-sc",
              "name": "SC",
              "subcategories": []
            },
            {
              "id": "forklifts-combilift-other",
              "name": "OTHER",
              "subcategories": []
            }
          ]
        },
        {
          "id": "forklifts-crown",
          "name": "Crown",
          "subcategories": [
            {
              "id": "forklifts-crown-20mt",
              "name": "20MT",
              "subcategories": []
            },
            {
              "id": "forklifts-crown-30sc",
              "name": "30SC",
              "subcategories": []
            },
            {
              "id": "forklifts-crown-30wb",
              "name": "30WB",
              "subcategories": []
            },
            {
              "id": "forklifts-crown-30wr",
              "name": "30WR",
              "subcategories": []
            },
            {
              "id": "forklifts-crown-40wb",
              "name": "40WB",
              "subcategories": []
            },
            {
              "id": "forklifts-crown-60fptt",
              "name": "60FPTT",
              "subcategories": []
            },
            {
              "id": "forklifts-crown-c5",
              "name": "C5",
              "subcategories": []
            },
            {
              "id": "forklifts-crown-cd80",
              "name": "CD80",
              "subcategories": []
            },
            {
              "id": "forklifts-crown-cg30",
              "name": "CG30",
              "subcategories": []
            },
            {
              "id": "forklifts-crown-cg70",
              "name": "CG70",
              "subcategories": []
            },
            {
              "id": "forklifts-crown-cgc20",
              "name": "CGC20",
              "subcategories": []
            },
            {
              "id": "forklifts-crown-es4000",
              "name": "ES4000",
              "subcategories": []
            },
            {
              "id": "forklifts-crown-esr5000",
              "name": "ESR5000",
              "subcategories": []
            },
            {
              "id": "forklifts-crown-esr5240",
              "name": "ESR5240",
              "subcategories": []
            },
            {
              "id": "forklifts-crown-et4000",
              "name": "ET4000",
              "subcategories": []
            },
            {
              "id": "forklifts-crown-fc4010",
              "name": "FC4010",
              "subcategories": []
            },
            {
              "id": "forklifts-crown-fc4020",
              "name": "FC4020",
              "subcategories": []
            },
            {
              "id": "forklifts-crown-fc4510",
              "name": "FC4510",
              "subcategories": []
            },
            {
              "id": "forklifts-crown-fc4525",
              "name": "FC4525",
              "subcategories": []
            },
            {
              "id": "forklifts-crown-fc4545",
              "name": "FC4545",
              "subcategories": []
            },
            {
              "id": "forklifts-crown-fc5215",
              "name": "FC5215",
              "subcategories": []
            },
            {
              "id": "forklifts-crown-fc5225",
              "name": "FC5225",
              "subcategories": []
            },
            {
              "id": "forklifts-crown-lp3520",
              "name": "LP3520",
              "subcategories": []
            },
            {
              "id": "forklifts-crown-pc4500",
              "name": "PC4500",
              "subcategories": []
            },
            {
              "id": "forklifts-crown-pe3540",
              "name": "PE3540",
              "subcategories": []
            },
            {
              "id": "forklifts-crown-pe4000",
              "name": "PE4000",
              "subcategories": []
            },
            {
              "id": "forklifts-crown-pe4500",
              "name": "PE4500",
              "subcategories": []
            },
            {
              "id": "forklifts-crown-pr3040",
              "name": "PR3040",
              "subcategories": []
            },
            {
              "id": "forklifts-crown-pr4500",
              "name": "PR4500",
              "subcategories": []
            },
            {
              "id": "forklifts-crown-pw3520",
              "name": "PW3520",
              "subcategories": []
            },
            {
              "id": "forklifts-crown-rc3020",
              "name": "RC3020",
              "subcategories": []
            },
            {
              "id": "forklifts-crown-rc5510",
              "name": "RC5510",
              "subcategories": []
            },
            {
              "id": "forklifts-crown-rc5525",
              "name": "RC5525",
              "subcategories": []
            },
            {
              "id": "forklifts-crown-rc5530",
              "name": "RC5530",
              "subcategories": []
            },
            {
              "id": "forklifts-crown-rc5535",
              "name": "RC5535",
              "subcategories": []
            },
            {
              "id": "forklifts-crown-rc5545",
              "name": "RC5545",
              "subcategories": []
            },
            {
              "id": "forklifts-crown-rc5725",
              "name": "RC5725",
              "subcategories": []
            },
            {
              "id": "forklifts-crown-rd5220",
              "name": "RD5220",
              "subcategories": []
            },
            {
              "id": "forklifts-crown-rd5225",
              "name": "RD5225",
              "subcategories": []
            },
            {
              "id": "forklifts-crown-rd5280",
              "name": "RD5280",
              "subcategories": []
            },
            {
              "id": "forklifts-crown-rd5725",
              "name": "RD5725",
              "subcategories": []
            },
            {
              "id": "forklifts-crown-rd5795",
              "name": "RD5795",
              "subcategories": []
            },
            {
              "id": "forklifts-crown-rm6025",
              "name": "RM6025",
              "subcategories": []
            },
            {
              "id": "forklifts-crown-rm6095",
              "name": "RM6095",
              "subcategories": []
            },
            {
              "id": "forklifts-crown-rmd6025",
              "name": "RMD6025",
              "subcategories": []
            },
            {
              "id": "forklifts-crown-rmd6095",
              "name": "RMD6095",
              "subcategories": []
            },
            {
              "id": "forklifts-crown-rr3020",
              "name": "RR3020",
              "subcategories": []
            },
            {
              "id": "forklifts-crown-rr5010",
              "name": "RR5010",
              "subcategories": []
            },
            {
              "id": "forklifts-crown-rr5020",
              "name": "RR5020",
              "subcategories": []
            },
            {
              "id": "forklifts-crown-rr5210",
              "name": "RR5210",
              "subcategories": []
            },
            {
              "id": "forklifts-crown-rr5220",
              "name": "RR5220",
              "subcategories": []
            },
            {
              "id": "forklifts-crown-rr5225",
              "name": "RR5225",
              "subcategories": []
            },
            {
              "id": "forklifts-crown-rr5715",
              "name": "RR5715",
              "subcategories": []
            },
            {
              "id": "forklifts-crown-rr5725",
              "name": "RR5725",
              "subcategories": []
            },
            {
              "id": "forklifts-crown-sc3013",
              "name": "SC3013",
              "subcategories": []
            },
            {
              "id": "forklifts-crown-sc4010",
              "name": "SC4010",
              "subcategories": []
            },
            {
              "id": "forklifts-crown-sc4020",
              "name": "SC4020",
              "subcategories": []
            },
            {
              "id": "forklifts-crown-sc4040",
              "name": "SC4040",
              "subcategories": []
            },
            {
              "id": "forklifts-crown-sc4240",
              "name": "SC4240",
              "subcategories": []
            },
            {
              "id": "forklifts-crown-sc4510",
              "name": "SC4510",
              "subcategories": []
            },
            {
              "id": "forklifts-crown-sc4540",
              "name": "SC4540",
              "subcategories": []
            },
            {
              "id": "forklifts-crown-sc5210",
              "name": "SC5210",
              "subcategories": []
            },
            {
              "id": "forklifts-crown-sc5215",
              "name": "SC5215",
              "subcategories": []
            },
            {
              "id": "forklifts-crown-sc5225",
              "name": "SC5225",
              "subcategories": []
            },
            {
              "id": "forklifts-crown-sc5245",
              "name": "SC5245",
              "subcategories": []
            },
            {
              "id": "forklifts-crown-sct6010",
              "name": "SCT6010",
              "subcategories": []
            },
            {
              "id": "forklifts-crown-sh5520",
              "name": "SH5520",
              "subcategories": []
            },
            {
              "id": "forklifts-crown-shr5520",
              "name": "SHR5520",
              "subcategories": []
            },
            {
              "id": "forklifts-crown-sp1510",
              "name": "SP1510",
              "subcategories": []
            },
            {
              "id": "forklifts-crown-sp3010",
              "name": "SP3010",
              "subcategories": []
            },
            {
              "id": "forklifts-crown-sp3020",
              "name": "SP3020",
              "subcategories": []
            },
            {
              "id": "forklifts-crown-sp3210",
              "name": "SP3210",
              "subcategories": []
            },
            {
              "id": "forklifts-crown-sp3405",
              "name": "SP3405",
              "subcategories": []
            },
            {
              "id": "forklifts-crown-sp3410",
              "name": "SP3410",
              "subcategories": []
            },
            {
              "id": "forklifts-crown-sp3420",
              "name": "SP3420",
              "subcategories": []
            },
            {
              "id": "forklifts-crown-sp3500",
              "name": "SP3500",
              "subcategories": []
            },
            {
              "id": "forklifts-crown-sp3505",
              "name": "SP3505",
              "subcategories": []
            },
            {
              "id": "forklifts-crown-sp3510",
              "name": "SP3510",
              "subcategories": []
            },
            {
              "id": "forklifts-crown-sp3520",
              "name": "SP3520",
              "subcategories": []
            },
            {
              "id": "forklifts-crown-sp3570",
              "name": "SP3570",
              "subcategories": []
            },
            {
              "id": "forklifts-crown-sp4050",
              "name": "SP4050",
              "subcategories": []
            },
            {
              "id": "forklifts-crown-sx3000",
              "name": "SX3000",
              "subcategories": []
            },
            {
              "id": "forklifts-crown-tsp6000",
              "name": "TSP6000",
              "subcategories": []
            },
            {
              "id": "forklifts-crown-tsp6500",
              "name": "TSP6500",
              "subcategories": []
            },
            {
              "id": "forklifts-crown-wav50",
              "name": "WAV50",
              "subcategories": []
            },
            {
              "id": "forklifts-crown-wav60",
              "name": "WAV60",
              "subcategories": []
            },
            {
              "id": "forklifts-crown-we2300",
              "name": "WE2300",
              "subcategories": []
            },
            {
              "id": "forklifts-crown-wp2345",
              "name": "WP2345",
              "subcategories": []
            },
            {
              "id": "forklifts-crown-wp3035",
              "name": "WP3035",
              "subcategories": []
            },
            {
              "id": "forklifts-crown-wp3045",
              "name": "WP3045",
              "subcategories": []
            },
            {
              "id": "forklifts-crown-ws2300",
              "name": "WS2300",
              "subcategories": []
            },
            {
              "id": "forklifts-crown-other",
              "name": "OTHER",
              "subcategories": []
            }
          ]
        },
        {
          "id": "forklifts-daewoo",
          "name": "Daewoo",
          "subcategories": [
            {
              "id": "forklifts-daewoo-bc18",
              "name": "BC18",
              "subcategories": []
            },
            {
              "id": "forklifts-daewoo-bc20",
              "name": "BC20",
              "subcategories": []
            },
            {
              "id": "forklifts-daewoo-bc25",
              "name": "BC25",
              "subcategories": []
            },
            {
              "id": "forklifts-daewoo-d20",
              "name": "D20",
              "subcategories": []
            },
            {
              "id": "forklifts-daewoo-d30",
              "name": "D30",
              "subcategories": []
            },
            {
              "id": "forklifts-daewoo-d35",
              "name": "D35",
              "subcategories": []
            },
            {
              "id": "forklifts-daewoo-d70",
              "name": "D70",
              "subcategories": []
            },
            {
              "id": "forklifts-daewoo-d100",
              "name": "D100",
              "subcategories": []
            },
            {
              "id": "forklifts-daewoo-g20",
              "name": "G20",
              "subcategories": []
            },
            {
              "id": "forklifts-daewoo-g25",
              "name": "G25",
              "subcategories": []
            },
            {
              "id": "forklifts-daewoo-g30",
              "name": "G30",
              "subcategories": []
            },
            {
              "id": "forklifts-daewoo-g32",
              "name": "G32",
              "subcategories": []
            },
            {
              "id": "forklifts-daewoo-g35",
              "name": "G35",
              "subcategories": []
            },
            {
              "id": "forklifts-daewoo-g305",
              "name": "G305",
              "subcategories": []
            },
            {
              "id": "forklifts-daewoo-gc25",
              "name": "GC25",
              "subcategories": []
            },
            {
              "id": "forklifts-daewoo-other",
              "name": "OTHER",
              "subcategories": []
            }
          ]
        },
        {
          "id": "forklifts-drexel",
          "name": "Drexel",
          "subcategories": [
            {
              "id": "forklifts-drexel-fl40",
              "name": "FL40",
              "subcategories": []
            },
            {
              "id": "forklifts-drexel-fl60",
              "name": "FL60",
              "subcategories": []
            },
            {
              "id": "forklifts-drexel-r40",
              "name": "R40",
              "subcategories": []
            },
            {
              "id": "forklifts-drexel-r6015",
              "name": "R6015",
              "subcategories": []
            },
            {
              "id": "forklifts-drexel-sl35",
              "name": "SL35",
              "subcategories": []
            },
            {
              "id": "forklifts-drexel-sl40",
              "name": "SL40",
              "subcategories": []
            },
            {
              "id": "forklifts-drexel-sl50",
              "name": "SL50",
              "subcategories": []
            },
            {
              "id": "forklifts-drexel-sl60",
              "name": "SL60",
              "subcategories": []
            },
            {
              "id": "forklifts-drexel-sl80",
              "name": "SL80",
              "subcategories": []
            },
            {
              "id": "forklifts-drexel-sl120",
              "name": "SL120",
              "subcategories": []
            },
            {
              "id": "forklifts-drexel-slt30",
              "name": "SLT30",
              "subcategories": []
            },
            {
              "id": "forklifts-drexel-slt35",
              "name": "SLT35",
              "subcategories": []
            },
            {
              "id": "forklifts-drexel-other",
              "name": "OTHER",
              "subcategories": []
            }
          ]
        },
        {
          "id": "forklifts-ekko",
          "name": "Ekko",
          "subcategories": [
            {
              "id": "forklifts-ekko-eb13",
              "name": "EB13",
              "subcategories": []
            },
            {
              "id": "forklifts-ekko-ek14",
              "name": "EK14",
              "subcategories": []
            },
            {
              "id": "forklifts-ekko-eh15",
              "name": "EH15",
              "subcategories": []
            },
            {
              "id": "forklifts-ekko-ek07",
              "name": "EK07",
              "subcategories": []
            },
            {
              "id": "forklifts-ekko-ek13",
              "name": "EK13",
              "subcategories": []
            },
            {
              "id": "forklifts-ekko-ek15",
              "name": "EK15",
              "subcategories": []
            },
            {
              "id": "forklifts-ekko-ek16",
              "name": "EK16",
              "subcategories": []
            },
            {
              "id": "forklifts-ekko-ek18",
              "name": "EK18",
              "subcategories": []
            },
            {
              "id": "forklifts-ekko-ek20",
              "name": "EK20",
              "subcategories": []
            },
            {
              "id": "forklifts-ekko-ek22",
              "name": "EK22",
              "subcategories": []
            },
            {
              "id": "forklifts-ekko-ek25",
              "name": "EK25",
              "subcategories": []
            },
            {
              "id": "forklifts-ekko-ek30",
              "name": "EK30",
              "subcategories": []
            },
            {
              "id": "forklifts-ekko-ek50",
              "name": "EK50",
              "subcategories": []
            },
            {
              "id": "forklifts-ekko-eop68",
              "name": "EOP68",
              "subcategories": []
            },
            {
              "id": "forklifts-ekko-eop70",
              "name": "EOP70",
              "subcategories": []
            },
            {
              "id": "forklifts-ekko-epe15",
              "name": "EPE15",
              "subcategories": []
            },
            {
              "id": "forklifts-ekko-er15",
              "name": "ER15",
              "subcategories": []
            },
            {
              "id": "forklifts-ekko-other",
              "name": "OTHER",
              "subcategories": []
            }
          ]
        },
        {
          "id": "forklifts-eurotrac",
          "name": "Eurotrac",
          "subcategories": []
        },
        {
          "id": "forklifts-flexi",
          "name": "Flexi",
          "subcategories": [
            {
              "id": "forklifts-flexi-ac1000",
              "name": "AC1000",
              "subcategories": []
            },
            {
              "id": "forklifts-flexi-ac1200",
              "name": "AC1200",
              "subcategories": []
            },
            {
              "id": "forklifts-flexi-ec20",
              "name": "EC20",
              "subcategories": []
            },
            {
              "id": "forklifts-flexi-euroac",
              "name": "EUROAC",
              "subcategories": []
            },
            {
              "id": "forklifts-flexi-g3",
              "name": "G3",
              "subcategories": []
            },
            {
              "id": "forklifts-flexi-g4",
              "name": "G4",
              "subcategories": []
            },
            {
              "id": "forklifts-flexi-other",
              "name": "OTHER",
              "subcategories": []
            }
          ]
        },
        {
          "id": "forklifts-genie",
          "name": "Genie",
          "subcategories": [
            {
              "id": "forklifts-genie-gh3-8",
              "name": "GH3.8",
              "subcategories": []
            },
            {
              "id": "forklifts-genie-gh5-6",
              "name": "GH5.6",
              "subcategories": []
            },
            {
              "id": "forklifts-genie-gl4",
              "name": "GL4",
              "subcategories": []
            },
            {
              "id": "forklifts-genie-gl8",
              "name": "GL8",
              "subcategories": []
            },
            {
              "id": "forklifts-genie-gl10",
              "name": "GL10",
              "subcategories": []
            },
            {
              "id": "forklifts-genie-gl12",
              "name": "GL12",
              "subcategories": []
            },
            {
              "id": "forklifts-genie-sla5",
              "name": "SLA5",
              "subcategories": []
            },
            {
              "id": "forklifts-genie-sla10",
              "name": "SLA10",
              "subcategories": []
            },
            {
              "id": "forklifts-genie-sla15",
              "name": "SLA15",
              "subcategories": []
            },
            {
              "id": "forklifts-genie-sla20",
              "name": "SLA20",
              "subcategories": []
            },
            {
              "id": "forklifts-genie-sla25",
              "name": "SLA25",
              "subcategories": []
            },
            {
              "id": "forklifts-genie-slc12",
              "name": "SLC12",
              "subcategories": []
            },
            {
              "id": "forklifts-genie-slc18",
              "name": "SLC18",
              "subcategories": []
            },
            {
              "id": "forklifts-genie-slc24",
              "name": "SLC24",
              "subcategories": []
            },
            {
              "id": "forklifts-genie-other",
              "name": "OTHER",
              "subcategories": []
            }
          ]
        },
        {
          "id": "forklifts-harlo",
          "name": "Harlo",
          "subcategories": [
            {
              "id": "forklifts-harlo-h300b",
              "name": "H300B",
              "subcategories": []
            },
            {
              "id": "forklifts-harlo-hd4500",
              "name": "HD4500",
              "subcategories": []
            },
            {
              "id": "forklifts-harlo-hf456",
              "name": "HF456",
              "subcategories": []
            },
            {
              "id": "forklifts-harlo-hp5000",
              "name": "HP5000",
              "subcategories": []
            },
            {
              "id": "forklifts-harlo-hp6500",
              "name": "HP6500",
              "subcategories": []
            },
            {
              "id": "forklifts-harlo-hp8500",
              "name": "HP8500",
              "subcategories": []
            },
            {
              "id": "forklifts-harlo-hp10500",
              "name": "HP10500",
              "subcategories": []
            },
            {
              "id": "forklifts-harlo-hp12500",
              "name": "HP12500",
              "subcategories": []
            },
            {
              "id": "forklifts-harlo-other",
              "name": "OTHER",
              "subcategories": []
            }
          ]
        },
        {
          "id": "forklifts-hoist",
          "name": "Hoist",
          "subcategories": [
            {
              "id": "forklifts-hoist-e300",
              "name": "E300",
              "subcategories": []
            },
            {
              "id": "forklifts-hoist-e350",
              "name": "E350",
              "subcategories": []
            },
            {
              "id": "forklifts-hoist-e400",
              "name": "E400",
              "subcategories": []
            },
            {
              "id": "forklifts-hoist-f180",
              "name": "F180",
              "subcategories": []
            },
            {
              "id": "forklifts-hoist-f220",
              "name": "F220",
              "subcategories": []
            },
            {
              "id": "forklifts-hoist-f250",
              "name": "F250",
              "subcategories": []
            },
            {
              "id": "forklifts-hoist-f300",
              "name": "F300",
              "subcategories": []
            },
            {
              "id": "forklifts-hoist-f350",
              "name": "F350",
              "subcategories": []
            },
            {
              "id": "forklifts-hoist-f400",
              "name": "F400",
              "subcategories": []
            },
            {
              "id": "forklifts-hoist-f500",
              "name": "F500",
              "subcategories": []
            },
            {
              "id": "forklifts-hoist-f600",
              "name": "F600",
              "subcategories": []
            },
            {
              "id": "forklifts-hoist-fke10",
              "name": "FKE10",
              "subcategories": []
            },
            {
              "id": "forklifts-hoist-fks13",
              "name": "FKS13",
              "subcategories": []
            },
            {
              "id": "forklifts-hoist-fks15",
              "name": "FKS15",
              "subcategories": []
            },
            {
              "id": "forklifts-hoist-fks20",
              "name": "FKS20",
              "subcategories": []
            },
            {
              "id": "forklifts-hoist-fr25",
              "name": "FR25",
              "subcategories": []
            },
            {
              "id": "forklifts-hoist-fr40",
              "name": "FR40",
              "subcategories": []
            },
            {
              "id": "forklifts-hoist-fr60",
              "name": "FR60",
              "subcategories": []
            },
            {
              "id": "forklifts-hoist-m75",
              "name": "M75",
              "subcategories": []
            },
            {
              "id": "forklifts-hoist-m200",
              "name": "M200",
              "subcategories": []
            },
            {
              "id": "forklifts-hoist-m250",
              "name": "M250",
              "subcategories": []
            },
            {
              "id": "forklifts-hoist-m350",
              "name": "M350",
              "subcategories": []
            },
            {
              "id": "forklifts-hoist-m370",
              "name": "M370",
              "subcategories": []
            },
            {
              "id": "forklifts-hoist-p220",
              "name": "P220",
              "subcategories": []
            },
            {
              "id": "forklifts-hoist-p300",
              "name": "P300",
              "subcategories": []
            },
            {
              "id": "forklifts-hoist-p360",
              "name": "P360",
              "subcategories": []
            },
            {
              "id": "forklifts-hoist-p550",
              "name": "P550",
              "subcategories": []
            },
            {
              "id": "forklifts-hoist-p650",
              "name": "P650",
              "subcategories": []
            },
            {
              "id": "forklifts-hoist-p800",
              "name": "P800",
              "subcategories": []
            },
            {
              "id": "forklifts-hoist-p925",
              "name": "P925",
              "subcategories": []
            },
            {
              "id": "forklifts-hoist-p1050",
              "name": "P1050",
              "subcategories": []
            },
            {
              "id": "forklifts-hoist-pv3000",
              "name": "PV3000",
              "subcategories": []
            },
            {
              "id": "forklifts-hoist-other",
              "name": "OTHER",
              "subcategories": []
            }
          ]
        },
        {
          "id": "forklifts-jcb",
          "name": "Jcb",
          "subcategories": [
            {
              "id": "forklifts-jcb-926",
              "name": "926",
              "subcategories": []
            },
            {
              "id": "forklifts-jcb-930",
              "name": "930",
              "subcategories": []
            },
            {
              "id": "forklifts-jcb-940",
              "name": "940",
              "subcategories": []
            },
            {
              "id": "forklifts-jcb-950",
              "name": "950",
              "subcategories": []
            },
            {
              "id": "forklifts-jcb-other",
              "name": "OTHER",
              "subcategories": []
            }
          ]
        },
        {
          "id": "forklifts-hyundai",
          "name": "Hyundai",
          "subcategories": [
            {
              "id": "forklifts-hyundai-10-00-800",
              "name": "10.00-800",
              "subcategories": []
            },
            {
              "id": "forklifts-hyundai-10btr",
              "name": "10BTR",
              "subcategories": []
            },
            {
              "id": "forklifts-hyundai-12lpt-i",
              "name": "12LPT-I",
              "subcategories": []
            },
            {
              "id": "forklifts-hyundai-13bop-7",
              "name": "13BOP-7",
              "subcategories": []
            },
            {
              "id": "forklifts-hyundai-13bop-9",
              "name": "13BOP-9",
              "subcategories": []
            },
            {
              "id": "forklifts-hyundai-15brp-7",
              "name": "15BRP-7",
              "subcategories": []
            },
            {
              "id": "forklifts-hyundai-15bt",
              "name": "15BT",
              "subcategories": []
            },
            {
              "id": "forklifts-hyundai-15l",
              "name": "15L",
              "subcategories": []
            },
            {
              "id": "forklifts-hyundai-15lc",
              "name": "15LC",
              "subcategories": []
            },
            {
              "id": "forklifts-hyundai-18bcs",
              "name": "18BCS",
              "subcategories": []
            },
            {
              "id": "forklifts-hyundai-18brp",
              "name": "18BRP",
              "subcategories": []
            },
            {
              "id": "forklifts-hyundai-18bt",
              "name": "18BT",
              "subcategories": []
            },
            {
              "id": "forklifts-hyundai-18l",
              "name": "18L",
              "subcategories": []
            },
            {
              "id": "forklifts-hyundai-18lc",
              "name": "18LC",
              "subcategories": []
            },
            {
              "id": "forklifts-hyundai-20b",
              "name": "20B",
              "subcategories": []
            },
            {
              "id": "forklifts-hyundai-20bt",
              "name": "20BT",
              "subcategories": []
            },
            {
              "id": "forklifts-hyundai-20brp",
              "name": "20BRP",
              "subcategories": []
            },
            {
              "id": "forklifts-hyundai-20d",
              "name": "20D",
              "subcategories": []
            },
            {
              "id": "forklifts-hyundai-20da",
              "name": "20DA",
              "subcategories": []
            },
            {
              "id": "forklifts-hyundai-20l",
              "name": "20L",
              "subcategories": []
            },
            {
              "id": "forklifts-hyundai-25b",
              "name": "25B",
              "subcategories": []
            },
            {
              "id": "forklifts-hyundai-25bc",
              "name": "25BC",
              "subcategories": []
            },
            {
              "id": "forklifts-hyundai-25bh",
              "name": "25BH",
              "subcategories": []
            },
            {
              "id": "forklifts-hyundai-25d",
              "name": "25D",
              "subcategories": []
            },
            {
              "id": "forklifts-hyundai-25g",
              "name": "25G",
              "subcategories": []
            },
            {
              "id": "forklifts-hyundai-25l",
              "name": "25L",
              "subcategories": []
            },
            {
              "id": "forklifts-hyundai-25lc",
              "name": "25LC",
              "subcategories": []
            },
            {
              "id": "forklifts-hyundai-25le",
              "name": "25LE",
              "subcategories": []
            },
            {
              "id": "forklifts-hyundai-30b-9u",
              "name": "30B-9U",
              "subcategories": []
            },
            {
              "id": "forklifts-hyundai-30b-x",
              "name": "30B-X",
              "subcategories": []
            },
            {
              "id": "forklifts-hyundai-30bc",
              "name": "30BC",
              "subcategories": []
            },
            {
              "id": "forklifts-hyundai-30d",
              "name": "30D",
              "subcategories": []
            },
            {
              "id": "forklifts-hyundai-30g",
              "name": "30G",
              "subcategories": []
            },
            {
              "id": "forklifts-hyundai-30l",
              "name": "30L",
              "subcategories": []
            },
            {
              "id": "forklifts-hyundai-30lc",
              "name": "30LC",
              "subcategories": []
            },
            {
              "id": "forklifts-hyundai-33d",
              "name": "33D",
              "subcategories": []
            },
            {
              "id": "forklifts-hyundai-35b",
              "name": "35B",
              "subcategories": []
            },
            {
              "id": "forklifts-hyundai-35d",
              "name": "35D",
              "subcategories": []
            },
            {
              "id": "forklifts-hyundai-35da",
              "name": "35DA",
              "subcategories": []
            },
            {
              "id": "forklifts-hyundai-35de",
              "name": "35DE",
              "subcategories": []
            },
            {
              "id": "forklifts-hyundai-35ds",
              "name": "35DS",
              "subcategories": []
            },
            {
              "id": "forklifts-hyundai-35l",
              "name": "35L",
              "subcategories": []
            },
            {
              "id": "forklifts-hyundai-35le",
              "name": "35LE",
              "subcategories": []
            },
            {
              "id": "forklifts-hyundai-40d",
              "name": "40D",
              "subcategories": []
            },
            {
              "id": "forklifts-hyundai-40ds",
              "name": "40DS",
              "subcategories": []
            },
            {
              "id": "forklifts-hyundai-40l",
              "name": "40L",
              "subcategories": []
            },
            {
              "id": "forklifts-hyundai-45d",
              "name": "45D",
              "subcategories": []
            },
            {
              "id": "forklifts-hyundai-45ds",
              "name": "45DS",
              "subcategories": []
            },
            {
              "id": "forklifts-hyundai-45l",
              "name": "45L",
              "subcategories": []
            },
            {
              "id": "forklifts-hyundai-50d",
              "name": "50D",
              "subcategories": []
            },
            {
              "id": "forklifts-hyundai-50da",
              "name": "50DA",
              "subcategories": []
            },
            {
              "id": "forklifts-hyundai-50l",
              "name": "50L",
              "subcategories": []
            },
            {
              "id": "forklifts-hyundai-60l",
              "name": "60L",
              "subcategories": []
            },
            {
              "id": "forklifts-hyundai-70d",
              "name": "70D",
              "subcategories": []
            },
            {
              "id": "forklifts-hyundai-70ds",
              "name": "70DS",
              "subcategories": []
            },
            {
              "id": "forklifts-hyundai-80d",
              "name": "80D",
              "subcategories": []
            },
            {
              "id": "forklifts-hyundai-110d",
              "name": "110D",
              "subcategories": []
            },
            {
              "id": "forklifts-hyundai-130d",
              "name": "130D",
              "subcategories": []
            },
            {
              "id": "forklifts-hyundai-160d",
              "name": "160D",
              "subcategories": []
            },
            {
              "id": "forklifts-hyundai-180d",
              "name": "180D",
              "subcategories": []
            },
            {
              "id": "forklifts-hyundai-250d",
              "name": "250D",
              "subcategories": []
            },
            {
              "id": "forklifts-hyundai-cpcd30",
              "name": "CPCD30",
              "subcategories": []
            },
            {
              "id": "forklifts-hyundai-hbf18",
              "name": "HBF18",
              "subcategories": []
            },
            {
              "id": "forklifts-hyundai-hbf25",
              "name": "HBF25",
              "subcategories": []
            },
            {
              "id": "forklifts-hyundai-hbf30",
              "name": "HBF30",
              "subcategories": []
            },
            {
              "id": "forklifts-hyundai-hlf25",
              "name": "HLF25",
              "subcategories": []
            },
            {
              "id": "forklifts-hyundai-pf75",
              "name": "PF75",
              "subcategories": []
            },
            {
              "id": "forklifts-hyundai-other",
              "name": "OTHER",
              "subcategories": []
            }
          ]
        },
        {
          "id": "forklifts-jungerich",
          "name": "Jungerich",
          "subcategories": [
            {
              "id": "forklifts-jungerich-869efg310s",
              "name": "869EFG310S",
              "subcategories": []
            },
            {
              "id": "forklifts-jungerich-dfg25",
              "name": "DFG25",
              "subcategories": []
            },
            {
              "id": "forklifts-jungerich-dfg40",
              "name": "DFG40",
              "subcategories": []
            },
            {
              "id": "forklifts-jungerich-dfg316",
              "name": "DFG316",
              "subcategories": []
            },
            {
              "id": "forklifts-jungerich-dfg425dfg430",
              "name": "DFG425DFG430",
              "subcategories": []
            },
            {
              "id": "forklifts-jungerich-dfg430",
              "name": "DFG430",
              "subcategories": []
            },
            {
              "id": "forklifts-jungerich-dfg435",
              "name": "DFG435",
              "subcategories": []
            },
            {
              "id": "forklifts-jungerich-dfg660",
              "name": "DFG660",
              "subcategories": []
            },
            {
              "id": "forklifts-jungerich-ece225",
              "name": "ECE225",
              "subcategories": []
            },
            {
              "id": "forklifts-jungerich-ecr327",
              "name": "ECR327",
              "subcategories": []
            },
            {
              "id": "forklifts-jungerich-ecr336",
              "name": "ECR336",
              "subcategories": []
            },
            {
              "id": "forklifts-jungerich-efgc23",
              "name": "EFGC23",
              "subcategories": []
            },
            {
              "id": "forklifts-jungerich-efg110",
              "name": "EFG110",
              "subcategories": []
            },
            {
              "id": "forklifts-jungerich-efg112",
              "name": "EFG112",
              "subcategories": []
            },
            {
              "id": "forklifts-jungerich-efg113",
              "name": "EFG113",
              "subcategories": []
            },
            {
              "id": "forklifts-jungerich-efg115",
              "name": "EFG115",
              "subcategories": []
            },
            {
              "id": "forklifts-jungerich-efg213",
              "name": "EFG213",
              "subcategories": []
            },
            {
              "id": "forklifts-jungerich-efg215",
              "name": "EFG215",
              "subcategories": []
            },
            {
              "id": "forklifts-jungerich-efg216",
              "name": "EFG216",
              "subcategories": []
            },
            {
              "id": "forklifts-jungerich-efg218",
              "name": "EFG218",
              "subcategories": []
            },
            {
              "id": "forklifts-jungerich-efg220",
              "name": "EFG220",
              "subcategories": []
            },
            {
              "id": "forklifts-jungerich-efg316",
              "name": "EFG316",
              "subcategories": []
            },
            {
              "id": "forklifts-jungerich-efg318",
              "name": "EFG318",
              "subcategories": []
            },
            {
              "id": "forklifts-jungerich-efg320",
              "name": "EFG320",
              "subcategories": []
            },
            {
              "id": "forklifts-jungerich-efg425",
              "name": "EFG425",
              "subcategories": []
            },
            {
              "id": "forklifts-jungerich-efg430",
              "name": "EFG430",
              "subcategories": []
            },
            {
              "id": "forklifts-jungerich-efg535",
              "name": "EFG535",
              "subcategories": []
            },
            {
              "id": "forklifts-jungerich-efg545",
              "name": "EFG545",
              "subcategories": []
            },
            {
              "id": "forklifts-jungerich-efgc25",
              "name": "EFGC25",
              "subcategories": []
            },
            {
              "id": "forklifts-jungerich-efg550",
              "name": "EFG550",
              "subcategories": []
            },
            {
              "id": "forklifts-jungerich-efgc25",
              "name": "EFGC25",
              "subcategories": []
            },
            {
              "id": "forklifts-jungerich-efgmc320",
              "name": "EFGMC320",
              "subcategories": []
            },
            {
              "id": "forklifts-jungerich-efgs30",
              "name": "EFGS30",
              "subcategories": []
            },
            {
              "id": "forklifts-jungerich-efgvac20",
              "name": "EFGVAC20",
              "subcategories": []
            },
            {
              "id": "forklifts-jungerich-efgvac25",
              "name": "EFGVAC25",
              "subcategories": []
            },
            {
              "id": "forklifts-jungerich-efx413",
              "name": "EFX413",
              "subcategories": []
            },
            {
              "id": "forklifts-jungerich-ejc112",
              "name": "EJC112",
              "subcategories": []
            },
            {
              "id": "forklifts-jungerich-ejc212",
              "name": "EJC212",
              "subcategories": []
            },
            {
              "id": "forklifts-jungerich-ejc214",
              "name": "EJC214",
              "subcategories": []
            },
            {
              "id": "forklifts-jungerich-ejc216",
              "name": "EJC216",
              "subcategories": []
            },
            {
              "id": "forklifts-jungerich-ejcm10",
              "name": "EJCM10",
              "subcategories": []
            },
            {
              "id": "forklifts-jungerich-ejcz16",
              "name": "EJCZ16",
              "subcategories": []
            },
            {
              "id": "forklifts-jungerich-eje116",
              "name": "EJE116",
              "subcategories": []
            },
            {
              "id": "forklifts-jungerich-eje120",
              "name": "EJE120",
              "subcategories": []
            },
            {
              "id": "forklifts-jungerich-ejem13",
              "name": "EJEM13",
              "subcategories": []
            },
            {
              "id": "forklifts-jungerich-ejg212",
              "name": "EJG212",
              "subcategories": []
            },
            {
              "id": "forklifts-jungerich-eks110",
              "name": "EKS110",
              "subcategories": []
            },
            {
              "id": "forklifts-jungerich-eks208",
              "name": "EKS208",
              "subcategories": []
            },
            {
              "id": "forklifts-jungerich-eks308",
              "name": "EKS308",
              "subcategories": []
            },
            {
              "id": "forklifts-jungerich-eks314",
              "name": "EKS314",
              "subcategories": []
            },
            {
              "id": "forklifts-jungerich-ekx410",
              "name": "EKX410",
              "subcategories": []
            },
            {
              "id": "forklifts-jungerich-ekx514",
              "name": "EKX514",
              "subcategories": []
            },
            {
              "id": "forklifts-jungerich-emc110",
              "name": "EMC110",
              "subcategories": []
            },
            {
              "id": "forklifts-jungerich-erc214",
              "name": "ERC214",
              "subcategories": []
            },
            {
              "id": "forklifts-jungerich-erd20",
              "name": "ERD20",
              "subcategories": []
            },
            {
              "id": "forklifts-jungerich-erd220",
              "name": "ERD220",
              "subcategories": []
            },
            {
              "id": "forklifts-jungerich-erv308",
              "name": "ERV308",
              "subcategories": []
            },
            {
              "id": "forklifts-jungerich-esc216",
              "name": "ESC216",
              "subcategories": []
            },
            {
              "id": "forklifts-jungerich-etg214",
              "name": "ETG214",
              "subcategories": []
            },
            {
              "id": "forklifts-jungerich-etg216",
              "name": "ETG216",
              "subcategories": []
            },
            {
              "id": "forklifts-jungerich-etg230",
              "name": "ETG230",
              "subcategories": []
            },
            {
              "id": "forklifts-jungerich-etg235",
              "name": "ETG235",
              "subcategories": []
            },
            {
              "id": "forklifts-jungerich-etg318",
              "name": "ETG318",
              "subcategories": []
            },
            {
              "id": "forklifts-jungerich-etg340",
              "name": "ETG340",
              "subcategories": []
            },
            {
              "id": "forklifts-jungerich-etg350",
              "name": "ETG350",
              "subcategories": []
            },
            {
              "id": "forklifts-jungerich-etg355",
              "name": "ETG355",
              "subcategories": []
            },
            {
              "id": "forklifts-jungerich-etr230",
              "name": "ETR230",
              "subcategories": []
            },
            {
              "id": "forklifts-jungerich-etr235",
              "name": "ETR235",
              "subcategories": []
            },
            {
              "id": "forklifts-jungerich-etr316",
              "name": "ETR316",
              "subcategories": []
            },
            {
              "id": "forklifts-jungerich-etr320",
              "name": "ETR320",
              "subcategories": []
            },
            {
              "id": "forklifts-jungerich-etr335",
              "name": "ETR335",
              "subcategories": []
            },
            {
              "id": "forklifts-jungerich-etr340",
              "name": "ETR340",
              "subcategories": []
            },
            {
              "id": "forklifts-jungerich-etr345",
              "name": "ETR345",
              "subcategories": []
            },
            {
              "id": "forklifts-jungerich-etv110",
              "name": "ETV110",
              "subcategories": []
            },
            {
              "id": "forklifts-jungerich-etv112",
              "name": "ETV112",
              "subcategories": []
            },
            {
              "id": "forklifts-jungerich-etv114",
              "name": "ETV114",
              "subcategories": []
            },
            {
              "id": "forklifts-jungerich-etv116",
              "name": "ETV116",
              "subcategories": []
            },
            {
              "id": "forklifts-jungerich-etv214",
              "name": "ETV214",
              "subcategories": []
            },
            {
              "id": "forklifts-jungerich-etv216",
              "name": "ETV216",
              "subcategories": []
            },
            {
              "id": "forklifts-jungerich-etva10",
              "name": "ETVA10",
              "subcategories": []
            },
            {
              "id": "forklifts-jungerich-etvc16",
              "name": "ETVC16",
              "subcategories": []
            },
            {
              "id": "forklifts-jungerich-etvc20",
              "name": "ETVC20",
              "subcategories": []
            },
            {
              "id": "forklifts-jungerich-etvq25",
              "name": "ETVQ25",
              "subcategories": []
            },
            {
              "id": "forklifts-jungerich-etx513",
              "name": "ETX513",
              "subcategories": []
            },
            {
              "id": "forklifts-jungerich-glp25tf",
              "name": "GLP25TF",
              "subcategories": []
            },
            {
              "id": "forklifts-jungerich-pte1-3",
              "name": "PTE1.3",
              "subcategories": []
            },
            {
              "id": "forklifts-jungerich-sh40",
              "name": "SH40",
              "subcategories": []
            },
            {
              "id": "forklifts-jungerich-tfg316",
              "name": "TFG316",
              "subcategories": []
            },
            {
              "id": "forklifts-jungerich-tfg425",
              "name": "TFG425",
              "subcategories": []
            },
            {
              "id": "forklifts-jungerich-tfg430",
              "name": "TFG430",
              "subcategories": []
            },
            {
              "id": "forklifts-jungerich-tfg435",
              "name": "TFG435",
              "subcategories": []
            },
            {
              "id": "forklifts-jungerich-other",
              "name": "OTHER",
              "subcategories": []
            }
          ]
        },
        {
          "id": "forklifts-kalmar",
          "name": "Kalmar",
          "subcategories": [
            {
              "id": "forklifts-kalmar-4-5-500",
              "name": "4.5-500",
              "subcategories": []
            },
            {
              "id": "forklifts-kalmar-c50",
              "name": "C50",
              "subcategories": []
            },
            {
              "id": "forklifts-kalmar-csc",
              "name": "CSC",
              "subcategories": []
            },
            {
              "id": "forklifts-kalmar-db7-600",
              "name": "DB7-600",
              "subcategories": []
            },
            {
              "id": "forklifts-kalmar-dc5-5-600",
              "name": "DC5.5-600",
              "subcategories": []
            },
            {
              "id": "forklifts-kalmar-dc5-5-600",
              "name": "DC5.5-600",
              "subcategories": []
            },
            {
              "id": "forklifts-kalmar-dc7",
              "name": "DC7",
              "subcategories": []
            },
            {
              "id": "forklifts-kalmar-dc9",
              "name": "DC9",
              "subcategories": []
            },
            {
              "id": "forklifts-kalmar-dc15",
              "name": "DC15",
              "subcategories": []
            },
            {
              "id": "forklifts-kalmar-dc20",
              "name": "DC20",
              "subcategories": []
            },
            {
              "id": "forklifts-kalmar-dc25",
              "name": "DC25",
              "subcategories": []
            },
            {
              "id": "forklifts-kalmar-dc32",
              "name": "DC32",
              "subcategories": []
            },
            {
              "id": "forklifts-kalmar-dcb32",
              "name": "DCB32",
              "subcategories": []
            },
            {
              "id": "forklifts-kalmar-dcd70",
              "name": "DCD70",
              "subcategories": []
            },
            {
              "id": "forklifts-kalmar-dcd75",
              "name": "DCD75",
              "subcategories": []
            },
            {
              "id": "forklifts-kalmar-dcd80",
              "name": "DCD80",
              "subcategories": []
            },
            {
              "id": "forklifts-kalmar-dcd160",
              "name": "DCD160",
              "subcategories": []
            },
            {
              "id": "forklifts-kalmar-dcd200",
              "name": "DCD200",
              "subcategories": []
            },
            {
              "id": "forklifts-kalmar-dcd250",
              "name": "DCD250",
              "subcategories": []
            },
            {
              "id": "forklifts-kalmar-dcd300",
              "name": "DCD300",
              "subcategories": []
            },
            {
              "id": "forklifts-kalmar-dcd320",
              "name": "DCD320",
              "subcategories": []
            },
            {
              "id": "forklifts-kalmar-dcd370",
              "name": "DCD370",
              "subcategories": []
            },
            {
              "id": "forklifts-kalmar-dcd420",
              "name": "DCD420",
              "subcategories": []
            },
            {
              "id": "forklifts-kalmar-dcd450",
              "name": "DCD450",
              "subcategories": []
            },
            {
              "id": "forklifts-kalmar-dcd500",
              "name": "DCD500",
              "subcategories": []
            },
            {
              "id": "forklifts-kalmar-dce55",
              "name": "DCE55",
              "subcategories": []
            },
            {
              "id": "forklifts-kalmar-dce80-9",
              "name": "DCE80-9",
              "subcategories": []
            },
            {
              "id": "forklifts-kalmar-dcf80-9",
              "name": "DCF80-9",
              "subcategories": []
            },
            {
              "id": "forklifts-kalmar-dce100",
              "name": "DCE100",
              "subcategories": []
            },
            {
              "id": "forklifts-kalmar-dce120",
              "name": "DCE120",
              "subcategories": []
            },
            {
              "id": "forklifts-kalmar-dce140",
              "name": "DCE140",
              "subcategories": []
            },
            {
              "id": "forklifts-kalmar-dce150",
              "name": "DCE150",
              "subcategories": []
            },
            {
              "id": "forklifts-kalmar-dce160",
              "name": "DCE160",
              "subcategories": []
            },
            {
              "id": "forklifts-kalmar-dce330",
              "name": "DCE330",
              "subcategories": []
            },
            {
              "id": "forklifts-kalmar-dcf220",
              "name": "DCF220",
              "subcategories": []
            },
            {
              "id": "forklifts-kalmar-dcf250",
              "name": "DCF250",
              "subcategories": []
            },
            {
              "id": "forklifts-kalmar-dcf280",
              "name": "DCF280",
              "subcategories": []
            },
            {
              "id": "forklifts-kalmar-dcf300",
              "name": "DCF300",
              "subcategories": []
            },
            {
              "id": "forklifts-kalmar-dcf370",
              "name": "DCF370",
              "subcategories": []
            },
            {
              "id": "forklifts-kalmar-dcf420",
              "name": "DCF420",
              "subcategories": []
            },
            {
              "id": "forklifts-kalmar-dcf450",
              "name": "DCF450",
              "subcategories": []
            },
            {
              "id": "forklifts-kalmar-dcf500",
              "name": "DCF500",
              "subcategories": []
            },
            {
              "id": "forklifts-kalmar-dcg90",
              "name": "DCG90",
              "subcategories": []
            },
            {
              "id": "forklifts-kalmar-dcg100",
              "name": "DCG100",
              "subcategories": []
            },
            {
              "id": "forklifts-kalmar-dcg120",
              "name": "DCG120",
              "subcategories": []
            },
            {
              "id": "forklifts-kalmar-dcg127",
              "name": "DCG127",
              "subcategories": []
            },
            {
              "id": "forklifts-kalmar-dcg140",
              "name": "DCG140",
              "subcategories": []
            },
            {
              "id": "forklifts-kalmar-dcg150",
              "name": "DCG150",
              "subcategories": []
            },
            {
              "id": "forklifts-kalmar-dcg160",
              "name": "DCG160",
              "subcategories": []
            },
            {
              "id": "forklifts-kalmar-dcg180",
              "name": "DCG180",
              "subcategories": []
            },
            {
              "id": "forklifts-kalmar-dcg250",
              "name": "DCG250",
              "subcategories": []
            },
            {
              "id": "forklifts-kalmar-dcg300",
              "name": "DCG300",
              "subcategories": []
            },
            {
              "id": "forklifts-kalmar-dcg330",
              "name": "DCG330",
              "subcategories": []
            },
            {
              "id": "forklifts-kalmar-dfq50",
              "name": "DFQ50",
              "subcategories": []
            },
            {
              "id": "forklifts-kalmar-e200zp",
              "name": "E200ZP",
              "subcategories": []
            },
            {
              "id": "forklifts-kalmar-ecg80",
              "name": "ECG80",
              "subcategories": []
            },
            {
              "id": "forklifts-kalmar-ecg100",
              "name": "ECG100",
              "subcategories": []
            },
            {
              "id": "forklifts-kalmar-ecg160",
              "name": "ECG160",
              "subcategories": []
            },
            {
              "id": "forklifts-kalmar-lt15-600",
              "name": "LT15.600",
              "subcategories": []
            },
            {
              "id": "forklifts-kalmar-p220",
              "name": "P220",
              "subcategories": []
            },
            {
              "id": "forklifts-kalmar-lt15-900",
              "name": "LT15.900",
              "subcategories": []
            },
            {
              "id": "forklifts-kalmar-other",
              "name": "OTHER",
              "subcategories": []
            }
          ]
        },
        {
          "id": "forklifts-komatsu",
          "name": "Komatsu",
          "subcategories": [
            {
              "id": "forklifts-komatsu-2501",
              "name": "2501",
              "subcategories": []
            },
            {
              "id": "forklifts-komatsu-fb15",
              "name": "FB15",
              "subcategories": []
            },
            {
              "id": "forklifts-komatsu-fb16",
              "name": "FB16",
              "subcategories": []
            },
            {
              "id": "forklifts-komatsu-fb18",
              "name": "FB18",
              "subcategories": []
            },
            {
              "id": "forklifts-komatsu-fb20",
              "name": "FB20",
              "subcategories": []
            },
            {
              "id": "forklifts-komatsu-fb25",
              "name": "FB25",
              "subcategories": []
            },
            {
              "id": "forklifts-komatsu-fd20",
              "name": "FD20",
              "subcategories": []
            },
            {
              "id": "forklifts-komatsu-fd25",
              "name": "FD25",
              "subcategories": []
            },
            {
              "id": "forklifts-komatsu-fd30",
              "name": "FD30",
              "subcategories": []
            },
            {
              "id": "forklifts-komatsu-fd50",
              "name": "FD50",
              "subcategories": []
            },
            {
              "id": "forklifts-komatsu-fd60",
              "name": "FD60",
              "subcategories": []
            },
            {
              "id": "forklifts-komatsu-fd70",
              "name": "FD70",
              "subcategories": []
            },
            {
              "id": "forklifts-komatsu-fd80",
              "name": "FD80",
              "subcategories": []
            },
            {
              "id": "forklifts-komatsu-fd100",
              "name": "FD100",
              "subcategories": []
            },
            {
              "id": "forklifts-komatsu-fd115",
              "name": "FD115",
              "subcategories": []
            },
            {
              "id": "forklifts-komatsu-fd135",
              "name": "FD135",
              "subcategories": []
            },
            {
              "id": "forklifts-komatsu-fd150",
              "name": "FD150",
              "subcategories": []
            },
            {
              "id": "forklifts-komatsu-fd160",
              "name": "FD160",
              "subcategories": []
            },
            {
              "id": "forklifts-komatsu-fd200",
              "name": "FD200",
              "subcategories": []
            },
            {
              "id": "forklifts-komatsu-fd400",
              "name": "FD400",
              "subcategories": []
            },
            {
              "id": "forklifts-komatsu-fg15",
              "name": "FG15",
              "subcategories": []
            },
            {
              "id": "forklifts-komatsu-fg18",
              "name": "FG18",
              "subcategories": []
            },
            {
              "id": "forklifts-komatsu-fg20",
              "name": "FG20",
              "subcategories": []
            },
            {
              "id": "forklifts-komatsu-fg25",
              "name": "FG25",
              "subcategories": []
            },
            {
              "id": "forklifts-komatsu-fg30",
              "name": "FG30",
              "subcategories": []
            },
            {
              "id": "forklifts-komatsu-fg35",
              "name": "FG35",
              "subcategories": []
            },
            {
              "id": "forklifts-komatsu-fg40",
              "name": "FG40",
              "subcategories": []
            },
            {
              "id": "forklifts-komatsu-fg45",
              "name": "FG45",
              "subcategories": []
            },
            {
              "id": "forklifts-komatsu-fg50",
              "name": "FG50",
              "subcategories": []
            },
            {
              "id": "forklifts-komatsu-fg70",
              "name": "FG70",
              "subcategories": []
            },
            {
              "id": "forklifts-komatsu-fh40",
              "name": "FH40",
              "subcategories": []
            },
            {
              "id": "forklifts-komatsu-fh45",
              "name": "FH45",
              "subcategories": []
            },
            {
              "id": "forklifts-komatsu-fh70",
              "name": "FH70",
              "subcategories": []
            },
            {
              "id": "forklifts-komatsu-fr18",
              "name": "FR18",
              "subcategories": []
            },
            {
              "id": "forklifts-komatsu-mpf15",
              "name": "MPF15",
              "subcategories": []
            },
            {
              "id": "forklifts-komatsu-mws14",
              "name": "MWS14",
              "subcategories": []
            },
            {
              "id": "forklifts-komatsu-mws20",
              "name": "MWS20",
              "subcategories": []
            },
            {
              "id": "forklifts-komatsu-other",
              "name": "OTHER",
              "subcategories": []
            }
          ]
        },
        {
          "id": "forklifts-lift-hero",
          "name": "Lift Hero",
          "subcategories": [
            {
              "id": "forklifts-lift-hero-cbd20",
              "name": "CBD20",
              "subcategories": []
            },
            {
              "id": "forklifts-lift-hero-cdd15",
              "name": "CDD15",
              "subcategories": []
            },
            {
              "id": "forklifts-lift-hero-cl1325",
              "name": "CL1325",
              "subcategories": []
            },
            {
              "id": "forklifts-lift-hero-cl1335",
              "name": "CL1335",
              "subcategories": []
            },
            {
              "id": "forklifts-lift-hero-cpd20",
              "name": "CPD20",
              "subcategories": []
            },
            {
              "id": "forklifts-lift-hero-cpd25",
              "name": "CPD25",
              "subcategories": []
            },
            {
              "id": "forklifts-lift-hero-cpd30",
              "name": "CPD30",
              "subcategories": []
            },
            {
              "id": "forklifts-lift-hero-cpd35",
              "name": "CPD35",
              "subcategories": []
            },
            {
              "id": "forklifts-lift-hero-cpd50",
              "name": "CPD50",
              "subcategories": []
            },
            {
              "id": "forklifts-lift-hero-cpd85",
              "name": "CPD85",
              "subcategories": []
            },
            {
              "id": "forklifts-lift-hero-cpd100",
              "name": "CPD100",
              "subcategories": []
            },
            {
              "id": "forklifts-lift-hero-cpd38",
              "name": "CPD38",
              "subcategories": []
            },
            {
              "id": "forklifts-lift-hero-cpds10",
              "name": "CPDS10",
              "subcategories": []
            },
            {
              "id": "forklifts-lift-hero-lg16",
              "name": "LG16",
              "subcategories": []
            },
            {
              "id": "forklifts-lift-hero-lg18",
              "name": "LG18",
              "subcategories": []
            },
            {
              "id": "forklifts-lift-hero-lg20",
              "name": "LG20",
              "subcategories": []
            },
            {
              "id": "forklifts-lift-hero-lg25",
              "name": "LG25",
              "subcategories": []
            },
            {
              "id": "forklifts-lift-hero-lg30",
              "name": "LG30",
              "subcategories": []
            },
            {
              "id": "forklifts-lift-hero-lg35",
              "name": "LG35",
              "subcategories": []
            },
            {
              "id": "forklifts-lift-hero-lg50",
              "name": "LG50",
              "subcategories": []
            },
            {
              "id": "forklifts-lift-hero-sl20l3",
              "name": "SL20L3",
              "subcategories": []
            },
            {
              "id": "forklifts-lift-hero-other",
              "name": "OTHER",
              "subcategories": []
            }
          ]
        },
        {
          "id": "forklifts-liugong",
          "name": "Liugong",
          "subcategories": []
        },
        {
          "id": "forklifts-load-lifter",
          "name": "Load Lifter",
          "subcategories": [
            {
              "id": "forklifts-load-lifter-2214",
              "name": "2214",
              "subcategories": []
            },
            {
              "id": "forklifts-load-lifter-2410",
              "name": "2410",
              "subcategories": []
            },
            {
              "id": "forklifts-load-lifter-2412",
              "name": "2412",
              "subcategories": []
            },
            {
              "id": "forklifts-load-lifter-2422",
              "name": "2422",
              "subcategories": []
            },
            {
              "id": "forklifts-load-lifter-2428",
              "name": "2428",
              "subcategories": []
            },
            {
              "id": "forklifts-load-lifter-4400",
              "name": "4400",
              "subcategories": []
            },
            {
              "id": "forklifts-load-lifter-4414",
              "name": "4414",
              "subcategories": []
            },
            {
              "id": "forklifts-load-lifter-4415",
              "name": "4415",
              "subcategories": []
            },
            {
              "id": "forklifts-load-lifter-4416",
              "name": "4416",
              "subcategories": []
            },
            {
              "id": "forklifts-load-lifter-4428",
              "name": "4428",
              "subcategories": []
            },
            {
              "id": "forklifts-load-lifter-laborer-6000",
              "name": "LABORER 6000",
              "subcategories": []
            },
            {
              "id": "forklifts-load-lifter-laborer-8000",
              "name": "LABORER 8000",
              "subcategories": []
            },
            {
              "id": "forklifts-load-lifter-laborer-10000",
              "name": "LABORER 10000",
              "subcategories": []
            },
            {
              "id": "forklifts-load-lifter-other",
              "name": "OTHER",
              "subcategories": []
            }
          ]
        },
        {
          "id": "forklifts-manitou",
          "name": "Manitou",
          "subcategories": [
            {
              "id": "forklifts-manitou-ep15",
              "name": "EP15",
              "subcategories": []
            },
            {
              "id": "forklifts-manitou-ep22",
              "name": "EP22",
              "subcategories": []
            },
            {
              "id": "forklifts-manitou-er16",
              "name": "ER16",
              "subcategories": []
            },
            {
              "id": "forklifts-manitou-m26",
              "name": "M26",
              "subcategories": []
            },
            {
              "id": "forklifts-manitou-m30",
              "name": "M30",
              "subcategories": []
            },
            {
              "id": "forklifts-manitou-m40",
              "name": "M40",
              "subcategories": []
            },
            {
              "id": "forklifts-manitou-m50",
              "name": "M50",
              "subcategories": []
            },
            {
              "id": "forklifts-manitou-m70",
              "name": "M70",
              "subcategories": []
            },
            {
              "id": "forklifts-manitou-m226",
              "name": "M226",
              "subcategories": []
            },
            {
              "id": "forklifts-manitou-m426",
              "name": "M426",
              "subcategories": []
            },
            {
              "id": "forklifts-manitou-mb26",
              "name": "MB26",
              "subcategories": []
            },
            {
              "id": "forklifts-manitou-mb60",
              "name": "MB60",
              "subcategories": []
            },
            {
              "id": "forklifts-manitou-mc18",
              "name": "MC18",
              "subcategories": []
            },
            {
              "id": "forklifts-manitou-mc20",
              "name": "MC20",
              "subcategories": []
            },
            {
              "id": "forklifts-manitou-mc25",
              "name": "MC25",
              "subcategories": []
            },
            {
              "id": "forklifts-manitou-mc30",
              "name": "MC30",
              "subcategories": []
            },
            {
              "id": "forklifts-manitou-mc50",
              "name": "MC50",
              "subcategories": []
            },
            {
              "id": "forklifts-manitou-mc70",
              "name": "MC70",
              "subcategories": []
            },
            {
              "id": "forklifts-manitou-me316",
              "name": "ME316",
              "subcategories": []
            },
            {
              "id": "forklifts-manitou-me318",
              "name": "ME318",
              "subcategories": []
            },
            {
              "id": "forklifts-manitou-me320",
              "name": "ME320",
              "subcategories": []
            },
            {
              "id": "forklifts-manitou-me420",
              "name": "ME420",
              "subcategories": []
            },
            {
              "id": "forklifts-manitou-me425",
              "name": "ME425",
              "subcategories": []
            },
            {
              "id": "forklifts-manitou-me430",
              "name": "ME430",
              "subcategories": []
            },
            {
              "id": "forklifts-manitou-mh25",
              "name": "MH25",
              "subcategories": []
            },
            {
              "id": "forklifts-manitou-mi15",
              "name": "MI15",
              "subcategories": []
            },
            {
              "id": "forklifts-manitou-mi18",
              "name": "MI18",
              "subcategories": []
            },
            {
              "id": "forklifts-manitou-mi25",
              "name": "MI25",
              "subcategories": []
            },
            {
              "id": "forklifts-manitou-mi30",
              "name": "MI30",
              "subcategories": []
            },
            {
              "id": "forklifts-manitou-mi35",
              "name": "MI35",
              "subcategories": []
            },
            {
              "id": "forklifts-manitou-mi40",
              "name": "MI40",
              "subcategories": []
            },
            {
              "id": "forklifts-manitou-mi45",
              "name": "MI45",
              "subcategories": []
            },
            {
              "id": "forklifts-manitou-mi50",
              "name": "MI50",
              "subcategories": []
            },
            {
              "id": "forklifts-manitou-mi55",
              "name": "MI55",
              "subcategories": []
            },
            {
              "id": "forklifts-manitou-mi60",
              "name": "MI60",
              "subcategories": []
            },
            {
              "id": "forklifts-manitou-mi70",
              "name": "MI70",
              "subcategories": []
            },
            {
              "id": "forklifts-manitou-mi80",
              "name": "MI80",
              "subcategories": []
            },
            {
              "id": "forklifts-manitou-mi100",
              "name": "MI100",
              "subcategories": []
            },
            {
              "id": "forklifts-manitou-mi125",
              "name": "MI125",
              "subcategories": []
            },
            {
              "id": "forklifts-manitou-msi25",
              "name": "MSI25",
              "subcategories": []
            },
            {
              "id": "forklifts-manitou-msi30",
              "name": "MSI30",
              "subcategories": []
            },
            {
              "id": "forklifts-manitou-msi35",
              "name": "MSI35",
              "subcategories": []
            },
            {
              "id": "forklifts-manitou-msi40",
              "name": "MSI40",
              "subcategories": []
            },
            {
              "id": "forklifts-manitou-msi50",
              "name": "MSI50",
              "subcategories": []
            },
            {
              "id": "forklifts-manitou-mx30",
              "name": "MX30",
              "subcategories": []
            },
            {
              "id": "forklifts-manitou-mx50",
              "name": "MX50",
              "subcategories": []
            },
            {
              "id": "forklifts-manitou-p450h",
              "name": "P450H",
              "subcategories": []
            },
            {
              "id": "forklifts-manitou-t604",
              "name": "T604",
              "subcategories": []
            },
            {
              "id": "forklifts-manitou-t1002",
              "name": "T1002",
              "subcategories": []
            },
            {
              "id": "forklifts-manitou-tmm45",
              "name": "TMM45",
              "subcategories": []
            },
            {
              "id": "forklifts-manitou-tmt25",
              "name": "TMT25",
              "subcategories": []
            },
            {
              "id": "forklifts-manitou-tmt27",
              "name": "TMT27",
              "subcategories": []
            },
            {
              "id": "forklifts-manitou-tmt55",
              "name": "TMT55",
              "subcategories": []
            },
            {
              "id": "forklifts-manitou-tmt320",
              "name": "TMT320",
              "subcategories": []
            },
            {
              "id": "forklifts-manitou-tmt325",
              "name": "TMT325",
              "subcategories": []
            },
            {
              "id": "forklifts-manitou-tmv55",
              "name": "TMV55",
              "subcategories": []
            },
            {
              "id": "forklifts-manitou-other",
              "name": "OTHER",
              "subcategories": []
            }
          ]
        },
        {
          "id": "forklifts-mitsubishi",
          "name": "Mitsubishi",
          "subcategories": [
            {
              "id": "forklifts-mitsubishi-2fbc",
              "name": "2FBC",
              "subcategories": []
            },
            {
              "id": "forklifts-mitsubishi-edr15",
              "name": "EDR15",
              "subcategories": []
            },
            {
              "id": "forklifts-mitsubishi-eop15",
              "name": "EOP15",
              "subcategories": []
            },
            {
              "id": "forklifts-mitsubishi-esr15",
              "name": "ESR15",
              "subcategories": []
            },
            {
              "id": "forklifts-mitsubishi-esr18",
              "name": "ESR18",
              "subcategories": []
            },
            {
              "id": "forklifts-mitsubishi-esr20",
              "name": "ESR20",
              "subcategories": []
            },
            {
              "id": "forklifts-mitsubishi-f25b-15",
              "name": "F25B-15",
              "subcategories": []
            },
            {
              "id": "forklifts-mitsubishi-fb15",
              "name": "FB15",
              "subcategories": []
            },
            {
              "id": "forklifts-mitsubishi-fb16",
              "name": "FB16",
              "subcategories": []
            },
            {
              "id": "forklifts-mitsubishi-fb18",
              "name": "FB18",
              "subcategories": []
            },
            {
              "id": "forklifts-mitsubishi-fb20",
              "name": "FB20",
              "subcategories": []
            },
            {
              "id": "forklifts-mitsubishi-fb25",
              "name": "FB25",
              "subcategories": []
            },
            {
              "id": "forklifts-mitsubishi-fb45",
              "name": "FB45",
              "subcategories": []
            },
            {
              "id": "forklifts-mitsubishi-fbc15",
              "name": "FBC15",
              "subcategories": []
            },
            {
              "id": "forklifts-mitsubishi-fbc18",
              "name": "FBC18",
              "subcategories": []
            },
            {
              "id": "forklifts-mitsubishi-fbc25",
              "name": "FBC25",
              "subcategories": []
            },
            {
              "id": "forklifts-mitsubishi-fbc30",
              "name": "FBC30",
              "subcategories": []
            },
            {
              "id": "forklifts-mitsubishi-fbcs",
              "name": "FBCS",
              "subcategories": []
            },
            {
              "id": "forklifts-mitsubishi-fd18",
              "name": "FD18",
              "subcategories": []
            },
            {
              "id": "forklifts-mitsubishi-fd20",
              "name": "FD20",
              "subcategories": []
            },
            {
              "id": "forklifts-mitsubishi-fd25",
              "name": "FD25",
              "subcategories": []
            },
            {
              "id": "forklifts-mitsubishi-fd30",
              "name": "FD30",
              "subcategories": []
            },
            {
              "id": "forklifts-mitsubishi-fd33",
              "name": "FD33",
              "subcategories": []
            },
            {
              "id": "forklifts-mitsubishi-fd35",
              "name": "FD35",
              "subcategories": []
            },
            {
              "id": "forklifts-mitsubishi-fd40",
              "name": "FD40",
              "subcategories": []
            },
            {
              "id": "forklifts-mitsubishi-fd45",
              "name": "FD45",
              "subcategories": []
            },
            {
              "id": "forklifts-mitsubishi-fd50",
              "name": "FD50",
              "subcategories": []
            },
            {
              "id": "forklifts-mitsubishi-fd60",
              "name": "FD60",
              "subcategories": []
            },
            {
              "id": "forklifts-mitsubishi-fd70",
              "name": "FD70",
              "subcategories": []
            },
            {
              "id": "forklifts-mitsubishi-fd100",
              "name": "FD100",
              "subcategories": []
            },
            {
              "id": "forklifts-mitsubishi-fd120",
              "name": "FD120",
              "subcategories": []
            },
            {
              "id": "forklifts-mitsubishi-fd150",
              "name": "FD150",
              "subcategories": []
            },
            {
              "id": "forklifts-mitsubishi-fd160",
              "name": "FD160",
              "subcategories": []
            },
            {
              "id": "forklifts-mitsubishi-fd250",
              "name": "FD250",
              "subcategories": []
            },
            {
              "id": "forklifts-mitsubishi-fd300",
              "name": "FD300",
              "subcategories": []
            },
            {
              "id": "forklifts-mitsubishi-fg15",
              "name": "FG15",
              "subcategories": []
            },
            {
              "id": "forklifts-mitsubishi-fg18",
              "name": "FG18",
              "subcategories": []
            },
            {
              "id": "forklifts-mitsubishi-fg20",
              "name": "FG20",
              "subcategories": []
            },
            {
              "id": "forklifts-mitsubishi-fg25",
              "name": "FG25",
              "subcategories": []
            },
            {
              "id": "forklifts-mitsubishi-fg30",
              "name": "FG30",
              "subcategories": []
            },
            {
              "id": "forklifts-mitsubishi-fg33",
              "name": "FG33",
              "subcategories": []
            },
            {
              "id": "forklifts-mitsubishi-fg35",
              "name": "FG35",
              "subcategories": []
            },
            {
              "id": "forklifts-mitsubishi-fg40",
              "name": "FG40",
              "subcategories": []
            },
            {
              "id": "forklifts-mitsubishi-fg45",
              "name": "FG45",
              "subcategories": []
            },
            {
              "id": "forklifts-mitsubishi-fg50",
              "name": "FG50",
              "subcategories": []
            },
            {
              "id": "forklifts-mitsubishi-fg55",
              "name": "FG55",
              "subcategories": []
            },
            {
              "id": "forklifts-mitsubishi-fgc15",
              "name": "FGC15",
              "subcategories": []
            },
            {
              "id": "forklifts-mitsubishi-fgc18",
              "name": "FGC18",
              "subcategories": []
            },
            {
              "id": "forklifts-mitsubishi-fgc20",
              "name": "FGC20",
              "subcategories": []
            },
            {
              "id": "forklifts-mitsubishi-fgc25",
              "name": "FGC25",
              "subcategories": []
            },
            {
              "id": "forklifts-mitsubishi-fgc30",
              "name": "FGC30",
              "subcategories": []
            },
            {
              "id": "forklifts-mitsubishi-fgc33",
              "name": "FGC33",
              "subcategories": []
            },
            {
              "id": "forklifts-mitsubishi-fgc40",
              "name": "FGC40",
              "subcategories": []
            },
            {
              "id": "forklifts-mitsubishi-fgc45",
              "name": "FGC45",
              "subcategories": []
            },
            {
              "id": "forklifts-mitsubishi-fgc55",
              "name": "FGC55",
              "subcategories": []
            },
            {
              "id": "forklifts-mitsubishi-fgc55",
              "name": "FGC55",
              "subcategories": []
            },
            {
              "id": "forklifts-mitsubishi-fgc70",
              "name": "FGC70",
              "subcategories": []
            },
            {
              "id": "forklifts-mitsubishi-fgce25p",
              "name": "FGCE25P",
              "subcategories": []
            },
            {
              "id": "forklifts-mitsubishi-pw23",
              "name": "PW23",
              "subcategories": []
            },
            {
              "id": "forklifts-mitsubishi-pwr30",
              "name": "PWR30",
              "subcategories": []
            },
            {
              "id": "forklifts-mitsubishi-rbm25",
              "name": "RBM25",
              "subcategories": []
            },
            {
              "id": "forklifts-mitsubishi-v70b45",
              "name": "V70B45",
              "subcategories": []
            },
            {
              "id": "forklifts-mitsubishi-other",
              "name": "OTHER",
              "subcategories": []
            }
          ]
        },
        {
          "id": "forklifts-moffett",
          "name": "Moffett",
          "subcategories": [
            {
              "id": "forklifts-moffett-e4",
              "name": "E4",
              "subcategories": []
            },
            {
              "id": "forklifts-moffett-e4-20-1",
              "name": "E4 20.1",
              "subcategories": []
            },
            {
              "id": "forklifts-moffett-lp5500",
              "name": "LP5500",
              "subcategories": []
            },
            {
              "id": "forklifts-moffett-m4",
              "name": "M4",
              "subcategories": []
            },
            {
              "id": "forklifts-moffett-m5",
              "name": "M5",
              "subcategories": []
            },
            {
              "id": "forklifts-moffett-m7",
              "name": "M7",
              "subcategories": []
            },
            {
              "id": "forklifts-moffett-m8",
              "name": "M8",
              "subcategories": []
            },
            {
              "id": "forklifts-moffett-m9",
              "name": "M9",
              "subcategories": []
            },
            {
              "id": "forklifts-moffett-m45",
              "name": "M45",
              "subcategories": []
            },
            {
              "id": "forklifts-moffett-m50",
              "name": "M50",
              "subcategories": []
            },
            {
              "id": "forklifts-moffett-m55",
              "name": "M55",
              "subcategories": []
            },
            {
              "id": "forklifts-moffett-m70",
              "name": "M70",
              "subcategories": []
            },
            {
              "id": "forklifts-moffett-m80",
              "name": "M80",
              "subcategories": []
            },
            {
              "id": "forklifts-moffett-m2703",
              "name": "M2703",
              "subcategories": []
            },
            {
              "id": "forklifts-moffett-m5000",
              "name": "M5000",
              "subcategories": []
            },
            {
              "id": "forklifts-moffett-m5500",
              "name": "M5500",
              "subcategories": []
            },
            {
              "id": "forklifts-moffett-m7000",
              "name": "M7000",
              "subcategories": []
            },
            {
              "id": "forklifts-moffett-m8000",
              "name": "M8000",
              "subcategories": []
            },
            {
              "id": "forklifts-moffett-m6000",
              "name": "M6000",
              "subcategories": []
            },
            {
              "id": "forklifts-moffett-tm55-4",
              "name": "TM55.4",
              "subcategories": []
            },
            {
              "id": "forklifts-moffett-tm50-3",
              "name": "TM50.3",
              "subcategories": []
            },
            {
              "id": "forklifts-moffett-other",
              "name": "OTHER",
              "subcategories": []
            }
          ]
        },
        {
          "id": "forklifts-navigator",
          "name": "Navigator",
          "subcategories": [
            {
              "id": "forklifts-navigator-dt4500",
              "name": "DT4500",
              "subcategories": []
            },
            {
              "id": "forklifts-navigator-rt4000",
              "name": "RT4000",
              "subcategories": []
            },
            {
              "id": "forklifts-navigator-rt4500",
              "name": "RT4500",
              "subcategories": []
            },
            {
              "id": "forklifts-navigator-rt5000",
              "name": "RT5000",
              "subcategories": []
            },
            {
              "id": "forklifts-navigator-rt5500",
              "name": "RT5500",
              "subcategories": []
            },
            {
              "id": "forklifts-navigator-rt6500",
              "name": "RT6500",
              "subcategories": []
            },
            {
              "id": "forklifts-navigator-rt7000",
              "name": "RT7000",
              "subcategories": []
            },
            {
              "id": "forklifts-navigator-other",
              "name": "OTHER",
              "subcategories": []
            }
          ]
        },
        {
          "id": "forklifts-new-holland",
          "name": "New Holland",
          "subcategories": [
            {
              "id": "forklifts-new-holland-f50",
              "name": "F50",
              "subcategories": []
            },
            {
              "id": "forklifts-new-holland-other",
              "name": "OTHER",
              "subcategories": []
            }
          ]
        },
        {
          "id": "forklifts-nissan",
          "name": "Nissan",
          "subcategories": [
            {
              "id": "forklifts-nissan-1n1l",
              "name": "1N1L",
              "subcategories": []
            },
            {
              "id": "forklifts-nissan-1q2l25",
              "name": "1Q2L25",
              "subcategories": []
            },
            {
              "id": "forklifts-nissan-1s1l15",
              "name": "1S1L15",
              "subcategories": []
            },
            {
              "id": "forklifts-nissan-1s1l20",
              "name": "1S1L20",
              "subcategories": []
            },
            {
              "id": "forklifts-nissan-257h",
              "name": "257H",
              "subcategories": []
            },
            {
              "id": "forklifts-nissan-ah01a15",
              "name": "AH01A15",
              "subcategories": []
            },
            {
              "id": "forklifts-nissan-aph02a25",
              "name": "APH02A25",
              "subcategories": []
            },
            {
              "id": "forklifts-nissan-bf03a35",
              "name": "BF03A35",
              "subcategories": []
            },
            {
              "id": "forklifts-nissan-bgf03",
              "name": "BGF03",
              "subcategories": []
            },
            {
              "id": "forklifts-nissan-cf01a15",
              "name": "CF01A15",
              "subcategories": []
            },
            {
              "id": "forklifts-nissan-chgp02l35",
              "name": "CHGP02L35",
              "subcategories": []
            },
            {
              "id": "forklifts-nissan-ck1b1l18",
              "name": "CK1B1L18",
              "subcategories": []
            },
            {
              "id": "forklifts-nissan-cp1b2l25",
              "name": "CP1B2L25",
              "subcategories": []
            },
            {
              "id": "forklifts-nissan-cp1f2",
              "name": "CP1F2",
              "subcategories": []
            },
            {
              "id": "forklifts-nissan-cph01a15",
              "name": "CPH01A15",
              "subcategories": []
            },
            {
              "id": "forklifts-nissan-cph02a25",
              "name": "CPH02A25",
              "subcategories": []
            },
            {
              "id": "forklifts-nissan-cpj01a15",
              "name": "CPJ01A15",
              "subcategories": []
            },
            {
              "id": "forklifts-nissan-cpj01a18",
              "name": "CPJ01A18",
              "subcategories": []
            },
            {
              "id": "forklifts-nissan-cpj02a25",
              "name": "CPJ02A25",
              "subcategories": []
            },
            {
              "id": "forklifts-nissan-csp01l15",
              "name": "CSP01L15",
              "subcategories": []
            },
            {
              "id": "forklifts-nissan-cwgp02l30",
              "name": "CWGP02L30",
              "subcategories": []
            },
            {
              "id": "forklifts-nissan-cygm02l28s",
              "name": "CYGM02L28S",
              "subcategories": []
            },
            {
              "id": "forklifts-nissan-df05n70",
              "name": "DF05N70",
              "subcategories": []
            },
            {
              "id": "forklifts-nissan-eh02",
              "name": "EH02",
              "subcategories": []
            },
            {
              "id": "forklifts-nissan-f04b40",
              "name": "F04B40",
              "subcategories": []
            },
            {
              "id": "forklifts-nissan-f04b45",
              "name": "F04B45",
              "subcategories": []
            },
            {
              "id": "forklifts-nissan-f04l500",
              "name": "F04L500",
              "subcategories": []
            },
            {
              "id": "forklifts-nissan-fd01a15",
              "name": "FD01A15",
              "subcategories": []
            },
            {
              "id": "forklifts-nissan-fd02a20",
              "name": "FD02A20",
              "subcategories": []
            },
            {
              "id": "forklifts-nissan-fd02a25",
              "name": "FD02A25",
              "subcategories": []
            },
            {
              "id": "forklifts-nissan-fgd02a30",
              "name": "FGD02A30",
              "subcategories": []
            },
            {
              "id": "forklifts-nissan-fj02a25",
              "name": "FJ02A25",
              "subcategories": []
            },
            {
              "id": "forklifts-nissan-g1n1l",
              "name": "G1N1L",
              "subcategories": []
            },
            {
              "id": "forklifts-nissan-gq02l30",
              "name": "GQ02L30",
              "subcategories": []
            },
            {
              "id": "forklifts-nissan-gx50",
              "name": "GX50",
              "subcategories": []
            },
            {
              "id": "forklifts-nissan-h01a15",
              "name": "H01A15",
              "subcategories": []
            },
            {
              "id": "forklifts-nissan-j01a18",
              "name": "J01A18",
              "subcategories": []
            },
            {
              "id": "forklifts-nissan-jhc01l18hu",
              "name": "JHC01L18HU",
              "subcategories": []
            },
            {
              "id": "forklifts-nissan-kcph01a15",
              "name": "KCPH01A15",
              "subcategories": []
            },
            {
              "id": "forklifts-nissan-kcph02a20",
              "name": "KCPH02A20",
              "subcategories": []
            },
            {
              "id": "forklifts-nissan-kcph02a25",
              "name": "KCPH02A25",
              "subcategories": []
            },
            {
              "id": "forklifts-nissan-m01l15",
              "name": "M01L15",
              "subcategories": []
            },
            {
              "id": "forklifts-nissan-map1f1a15",
              "name": "MAP1F1A15",
              "subcategories": []
            },
            {
              "id": "forklifts-nissan-map1f2a25",
              "name": "MAP1F2A25",
              "subcategories": []
            },
            {
              "id": "forklifts-nissan-mck1b1l15",
              "name": "MCK1B1L15",
              "subcategories": []
            },
            {
              "id": "forklifts-nissan-mcp1b2l25",
              "name": "MCP1B2L25",
              "subcategories": []
            },
            {
              "id": "forklifts-nissan-mcp1f1a15",
              "name": "MCP1F1A15",
              "subcategories": []
            },
            {
              "id": "forklifts-nissan-mcp1f1a18",
              "name": "MCP1F1A18",
              "subcategories": []
            },
            {
              "id": "forklifts-nissan-mcp1f2a20",
              "name": "MCP1F2A20",
              "subcategories": []
            },
            {
              "id": "forklifts-nissan-mcp1f2a25",
              "name": "MCP1F2A25",
              "subcategories": []
            },
            {
              "id": "forklifts-nissan-mcpl01a15",
              "name": "MCPL01A15",
              "subcategories": []
            },
            {
              "id": "forklifts-nissan-mcppl02a25",
              "name": "MCPPL02A25",
              "subcategories": []
            },
            {
              "id": "forklifts-nissan-mct1b2l20",
              "name": "MCT1B2L20",
              "subcategories": []
            },
            {
              "id": "forklifts-nissan-mct1b2l25",
              "name": "MCT1B2L25",
              "subcategories": []
            },
            {
              "id": "forklifts-nissan-mctg1b2l",
              "name": "MCTG1B2L",
              "subcategories": []
            },
            {
              "id": "forklifts-nissan-mcu1f2a25",
              "name": "MCU1F2A25",
              "subcategories": []
            },
            {
              "id": "forklifts-nissan-mcu1f2a30",
              "name": "MCU1F2A30",
              "subcategories": []
            },
            {
              "id": "forklifts-nissan-mcug1f2f30",
              "name": "MCUG1F2F30",
              "subcategories": []
            },
            {
              "id": "forklifts-nissan-mcug1f2f36",
              "name": "MCUG1F2F36",
              "subcategories": []
            },
            {
              "id": "forklifts-nissan-mcugl02f36",
              "name": "MCUGL02F36",
              "subcategories": []
            },
            {
              "id": "forklifts-nissan-mcul02a28",
              "name": "MCUL02A28",
              "subcategories": []
            },
            {
              "id": "forklifts-nissan-mj1f4a35",
              "name": "MJ1F4A35",
              "subcategories": []
            },
            {
              "id": "forklifts-nissan-mj1f4a40",
              "name": "MJ1F4A40",
              "subcategories": []
            },
            {
              "id": "forklifts-nissan-mj1f4a45",
              "name": "MJ1F4A45",
              "subcategories": []
            },
            {
              "id": "forklifts-nissan-mj1f4a50",
              "name": "MJ1F4A50",
              "subcategories": []
            },
            {
              "id": "forklifts-nissan-mp1f1a18",
              "name": "MP1F1A18",
              "subcategories": []
            },
            {
              "id": "forklifts-nissan-mp1f2a20",
              "name": "MP1F2A20",
              "subcategories": []
            },
            {
              "id": "forklifts-nissan-mp1f2a25",
              "name": "MP1F2A25",
              "subcategories": []
            },
            {
              "id": "forklifts-nissan-mpl02a15",
              "name": "MPL02A15",
              "subcategories": []
            },
            {
              "id": "forklifts-nissan-mpl02a25",
              "name": "MPL02A25",
              "subcategories": []
            },
            {
              "id": "forklifts-nissan-mu1f2a25",
              "name": "MU1F2A25",
              "subcategories": []
            },
            {
              "id": "forklifts-nissan-mug1f2a30",
              "name": "MUG1F2A30",
              "subcategories": []
            },
            {
              "id": "forklifts-nissan-mugl02a30",
              "name": "MUGL02A30",
              "subcategories": []
            },
            {
              "id": "forklifts-nissan-mw1f4a45",
              "name": "MW1F4A45",
              "subcategories": []
            },
            {
              "id": "forklifts-nissan-mwg1f4a50",
              "name": "MWG1F4A50",
              "subcategories": []
            },
            {
              "id": "forklifts-nissan-myg1f2a30",
              "name": "MYG1F2A30",
              "subcategories": []
            },
            {
              "id": "forklifts-nissan-myg1f2a35",
              "name": "MYG1F2A35",
              "subcategories": []
            },
            {
              "id": "forklifts-nissan-nh01a15",
              "name": "NH01A15",
              "subcategories": []
            },
            {
              "id": "forklifts-nissan-nh01m15",
              "name": "NH01M15",
              "subcategories": []
            },
            {
              "id": "forklifts-nissan-nh02m20",
              "name": "NH02M20",
              "subcategories": []
            },
            {
              "id": "forklifts-nissan-nja01a15",
              "name": "NJA01A15",
              "subcategories": []
            },
            {
              "id": "forklifts-nissan-p1d1a15",
              "name": "P1D1A15",
              "subcategories": []
            },
            {
              "id": "forklifts-nissan-p50",
              "name": "P50",
              "subcategories": []
            },
            {
              "id": "forklifts-nissan-pd01a15",
              "name": "PD01A15",
              "subcategories": []
            },
            {
              "id": "forklifts-nissan-pd90",
              "name": "PD90",
              "subcategories": []
            },
            {
              "id": "forklifts-nissan-pf02",
              "name": "PF02",
              "subcategories": []
            },
            {
              "id": "forklifts-nissan-pf02a20",
              "name": "PF02A20",
              "subcategories": []
            },
            {
              "id": "forklifts-nissan-pf02a25",
              "name": "PF02A25",
              "subcategories": []
            },
            {
              "id": "forklifts-nissan-ph02a25",
              "name": "PH02A25",
              "subcategories": []
            },
            {
              "id": "forklifts-nissan-ph02m25",
              "name": "PH02M25",
              "subcategories": []
            },
            {
              "id": "forklifts-nissan-pj01a15",
              "name": "PJ01A15",
              "subcategories": []
            },
            {
              "id": "forklifts-nissan-pj02a20",
              "name": "PJ02A20",
              "subcategories": []
            },
            {
              "id": "forklifts-nissan-pj0a25",
              "name": "PJ0A25",
              "subcategories": []
            },
            {
              "id": "forklifts-nissan-q02l25",
              "name": "Q02L25",
              "subcategories": []
            },
            {
              "id": "forklifts-nissan-rgh02a25",
              "name": "RGH02A25",
              "subcategories": []
            },
            {
              "id": "forklifts-nissan-rpxt2w2g60",
              "name": "RPXT2W2G60",
              "subcategories": []
            },
            {
              "id": "forklifts-nissan-sm1h235",
              "name": "SM1H235",
              "subcategories": []
            },
            {
              "id": "forklifts-nissan-u1d2a20",
              "name": "U1D2A20",
              "subcategories": []
            },
            {
              "id": "forklifts-nissan-u1d2a25",
              "name": "U1D2A25",
              "subcategories": []
            },
            {
              "id": "forklifts-nissan-ugj02a30",
              "name": "UGJ02A30",
              "subcategories": []
            },
            {
              "id": "forklifts-nissan-vf05h70",
              "name": "VF05H70",
              "subcategories": []
            },
            {
              "id": "forklifts-nissan-wgf03a40",
              "name": "WGF03A40",
              "subcategories": []
            },
            {
              "id": "forklifts-nissan-y1d2a25",
              "name": "Y1D2A25",
              "subcategories": []
            },
            {
              "id": "forklifts-nissan-y1f2a25",
              "name": "Y1F2A25",
              "subcategories": []
            },
            {
              "id": "forklifts-nissan-yg1d2a30",
              "name": "YG1D2A30",
              "subcategories": []
            },
            {
              "id": "forklifts-nissan-other",
              "name": "OTHER",
              "subcategories": []
            }
          ]
        },
        {
          "id": "forklifts-noblelift",
          "name": "Noblelift",
          "subcategories": [
            {
              "id": "forklifts-noblelift-ac55",
              "name": "AC55",
              "subcategories": []
            },
            {
              "id": "forklifts-noblelift-ecl22m-126",
              "name": "ECL22M-126",
              "subcategories": []
            },
            {
              "id": "forklifts-noblelift-fd2rt",
              "name": "FD2RT",
              "subcategories": []
            },
            {
              "id": "forklifts-noblelift-fd4p",
              "name": "FD4P",
              "subcategories": []
            },
            {
              "id": "forklifts-noblelift-fe3d",
              "name": "FE3D",
              "subcategories": []
            },
            {
              "id": "forklifts-noblelift-fe3r",
              "name": "FE3R",
              "subcategories": []
            },
            {
              "id": "forklifts-noblelift-fe4p16",
              "name": "FE4P16",
              "subcategories": []
            },
            {
              "id": "forklifts-noblelift-fe4p50",
              "name": "FE4P50",
              "subcategories": []
            },
            {
              "id": "forklifts-noblelift-fe4p60",
              "name": "FE4P60",
              "subcategories": []
            },
            {
              "id": "forklifts-noblelift-fe4p55",
              "name": "FE4P55",
              "subcategories": []
            },
            {
              "id": "forklifts-noblelift-fe4p70",
              "name": "FE4P70",
              "subcategories": []
            },
            {
              "id": "forklifts-noblelift-fl4p70",
              "name": "FL4P70",
              "subcategories": []
            },
            {
              "id": "forklifts-noblelift-fl4p50",
              "name": "FL4P50",
              "subcategories": []
            },
            {
              "id": "forklifts-noblelift-fl4p60",
              "name": "FL4P60",
              "subcategories": []
            },
            {
              "id": "forklifts-noblelift-op8-5",
              "name": "OP8.5",
              "subcategories": []
            },
            {
              "id": "forklifts-noblelift-ps30",
              "name": "PS30",
              "subcategories": []
            },
            {
              "id": "forklifts-noblelift-ps33",
              "name": "PS33",
              "subcategories": []
            },
            {
              "id": "forklifts-noblelift-ps35",
              "name": "PS35",
              "subcategories": []
            },
            {
              "id": "forklifts-noblelift-ps40",
              "name": "PS40",
              "subcategories": []
            },
            {
              "id": "forklifts-noblelift-pse26n",
              "name": "PSE26N",
              "subcategories": []
            },
            {
              "id": "forklifts-noblelift-pt",
              "name": "PT",
              "subcategories": []
            },
            {
              "id": "forklifts-noblelift-pte33",
              "name": "PTE33",
              "subcategories": []
            },
            {
              "id": "forklifts-noblelift-pte4",
              "name": "PTE4",
              "subcategories": []
            },
            {
              "id": "forklifts-noblelift-rt35",
              "name": "RT35",
              "subcategories": []
            },
            {
              "id": "forklifts-noblelift-rt44",
              "name": "RT44",
              "subcategories": []
            },
            {
              "id": "forklifts-noblelift-other",
              "name": "OTHER",
              "subcategories": []
            }
          ]
        },
        {
          "id": "forklifts-octane",
          "name": "Octane",
          "subcategories": [
            {
              "id": "forklifts-octane-fb15",
              "name": "FB15",
              "subcategories": []
            },
            {
              "id": "forklifts-octane-fb16",
              "name": "FB16",
              "subcategories": []
            },
            {
              "id": "forklifts-octane-fb20",
              "name": "FB20",
              "subcategories": []
            },
            {
              "id": "forklifts-octane-fb25",
              "name": "FB25",
              "subcategories": []
            },
            {
              "id": "forklifts-octane-fb30",
              "name": "FB30",
              "subcategories": []
            },
            {
              "id": "forklifts-octane-fb35",
              "name": "FB35",
              "subcategories": []
            },
            {
              "id": "forklifts-octane-fb40",
              "name": "FB40",
              "subcategories": []
            },
            {
              "id": "forklifts-octane-fb50",
              "name": "FB50",
              "subcategories": []
            },
            {
              "id": "forklifts-octane-fb60",
              "name": "FB60",
              "subcategories": []
            },
            {
              "id": "forklifts-octane-fb120",
              "name": "FB120",
              "subcategories": []
            },
            {
              "id": "forklifts-octane-fbpd18",
              "name": "FBPD18",
              "subcategories": []
            },
            {
              "id": "forklifts-octane-fbr15",
              "name": "FBR15",
              "subcategories": []
            },
            {
              "id": "forklifts-octane-fbr20",
              "name": "FBR20",
              "subcategories": []
            },
            {
              "id": "forklifts-octane-fd20",
              "name": "FD20",
              "subcategories": []
            },
            {
              "id": "forklifts-octane-fd25",
              "name": "FD25",
              "subcategories": []
            },
            {
              "id": "forklifts-octane-fd30",
              "name": "FD30",
              "subcategories": []
            },
            {
              "id": "forklifts-octane-fd35",
              "name": "FD35",
              "subcategories": []
            },
            {
              "id": "forklifts-octane-fd40",
              "name": "FD40",
              "subcategories": []
            },
            {
              "id": "forklifts-octane-fd45",
              "name": "FD45",
              "subcategories": []
            },
            {
              "id": "forklifts-octane-fd50",
              "name": "FD50",
              "subcategories": []
            },
            {
              "id": "forklifts-octane-fd70",
              "name": "FD70",
              "subcategories": []
            },
            {
              "id": "forklifts-octane-fd80",
              "name": "FD80",
              "subcategories": []
            },
            {
              "id": "forklifts-octane-fd100",
              "name": "FD100",
              "subcategories": []
            },
            {
              "id": "forklifts-octane-fd120",
              "name": "FD120",
              "subcategories": []
            },
            {
              "id": "forklifts-octane-fd160",
              "name": "FD160",
              "subcategories": []
            },
            {
              "id": "forklifts-octane-fl20",
              "name": "FL20",
              "subcategories": []
            },
            {
              "id": "forklifts-octane-fl25",
              "name": "FL25",
              "subcategories": []
            },
            {
              "id": "forklifts-octane-fy15",
              "name": "FY15",
              "subcategories": []
            },
            {
              "id": "forklifts-octane-fy20",
              "name": "FY20",
              "subcategories": []
            },
            {
              "id": "forklifts-octane-fy25",
              "name": "FY25",
              "subcategories": []
            },
            {
              "id": "forklifts-octane-fy30",
              "name": "FY30",
              "subcategories": []
            },
            {
              "id": "forklifts-octane-fy35",
              "name": "FY35",
              "subcategories": []
            },
            {
              "id": "forklifts-octane-fy40",
              "name": "FY40",
              "subcategories": []
            },
            {
              "id": "forklifts-octane-fy50",
              "name": "FY50",
              "subcategories": []
            },
            {
              "id": "forklifts-octane-fy60",
              "name": "FY60",
              "subcategories": []
            },
            {
              "id": "forklifts-octane-fy70",
              "name": "FY70",
              "subcategories": []
            },
            {
              "id": "forklifts-octane-rtd30",
              "name": "RTD30",
              "subcategories": []
            },
            {
              "id": "forklifts-octane-rtd35",
              "name": "RTD35",
              "subcategories": []
            },
            {
              "id": "forklifts-octane-rtd50",
              "name": "RTD50",
              "subcategories": []
            },
            {
              "id": "forklifts-octane-ws12",
              "name": "WS12",
              "subcategories": []
            },
            {
              "id": "forklifts-octane-other",
              "name": "OTHER",
              "subcategories": []
            }
          ]
        },
        {
          "id": "forklifts-palfinger",
          "name": "Palfinger",
          "subcategories": [
            {
              "id": "forklifts-palfinger-cr50",
              "name": "CR50",
              "subcategories": []
            },
            {
              "id": "forklifts-palfinger-cr253",
              "name": "CR253",
              "subcategories": []
            },
            {
              "id": "forklifts-palfinger-crayler-bu553",
              "name": "CRAYLER BU553",
              "subcategories": []
            },
            {
              "id": "forklifts-palfinger-crayler-cr50",
              "name": "CRAYLER CR50",
              "subcategories": []
            },
            {
              "id": "forklifts-palfinger-crayler-cr55",
              "name": "CRAYLER CR55",
              "subcategories": []
            },
            {
              "id": "forklifts-palfinger-crayler-cr55-4-way",
              "name": "CRAYLER CR55 4-WAY",
              "subcategories": []
            },
            {
              "id": "forklifts-palfinger-fhs55",
              "name": "FHS55",
              "subcategories": []
            },
            {
              "id": "forklifts-palfinger-fhs554",
              "name": "FHS554",
              "subcategories": []
            },
            {
              "id": "forklifts-palfinger-gt55",
              "name": "GT55",
              "subcategories": []
            },
            {
              "id": "forklifts-palfinger-other",
              "name": "OTHER",
              "subcategories": []
            }
          ]
        },
        {
          "id": "forklifts-pettibone",
          "name": "Pettibone",
          "subcategories": [
            {
              "id": "forklifts-pettibone-cary-lift-154",
              "name": "CARY LIFT 154",
              "subcategories": []
            },
            {
              "id": "forklifts-pettibone-cary-lift-204",
              "name": "CARY LIFT 204",
              "subcategories": []
            },
            {
              "id": "forklifts-pettibone-cray-lift-254",
              "name": "CRAY LIFT 254",
              "subcategories": []
            },
            {
              "id": "forklifts-pettibone-cary-lift-304",
              "name": "CARY LIFT 304",
              "subcategories": []
            },
            {
              "id": "forklifts-pettibone-cary-lift-super-20",
              "name": "CARY LIFT SUPER 20",
              "subcategories": []
            },
            {
              "id": "forklifts-pettibone-other",
              "name": "OTHER",
              "subcategories": []
            }
          ]
        },
        {
          "id": "forklifts-princeton",
          "name": "Princeton",
          "subcategories": [
            {
              "id": "forklifts-princeton-d45",
              "name": "D45",
              "subcategories": []
            },
            {
              "id": "forklifts-princeton-d50",
              "name": "D50",
              "subcategories": []
            },
            {
              "id": "forklifts-princeton-d4500",
              "name": "D4500",
              "subcategories": []
            },
            {
              "id": "forklifts-princeton-d5000",
              "name": "D5000",
              "subcategories": []
            },
            {
              "id": "forklifts-princeton-e2-3",
              "name": "E2-3",
              "subcategories": []
            },
            {
              "id": "forklifts-princeton-e50",
              "name": "E50",
              "subcategories": []
            },
            {
              "id": "forklifts-princeton-pb36",
              "name": "PB36",
              "subcategories": []
            },
            {
              "id": "forklifts-princeton-pb45",
              "name": "PB45",
              "subcategories": []
            },
            {
              "id": "forklifts-princeton-pb50",
              "name": "PB50",
              "subcategories": []
            },
            {
              "id": "forklifts-princeton-pb55",
              "name": "PB55",
              "subcategories": []
            },
            {
              "id": "forklifts-princeton-pb70",
              "name": "PB70",
              "subcategories": []
            },
            {
              "id": "forklifts-princeton-pb80",
              "name": "PB80",
              "subcategories": []
            },
            {
              "id": "forklifts-princeton-pbx",
              "name": "PBX",
              "subcategories": []
            },
            {
              "id": "forklifts-princeton-z2-3x",
              "name": "Z2-3X",
              "subcategories": []
            },
            {
              "id": "forklifts-princeton-other",
              "name": "OTHER",
              "subcategories": []
            }
          ]
        },
        {
          "id": "forklifts-sellick",
          "name": "Sellick",
          "subcategories": [
            {
              "id": "forklifts-sellick-s60",
              "name": "S60",
              "subcategories": []
            },
            {
              "id": "forklifts-sellick-s80",
              "name": "S80",
              "subcategories": []
            },
            {
              "id": "forklifts-sellick-s100",
              "name": "S100",
              "subcategories": []
            },
            {
              "id": "forklifts-sellick-s120",
              "name": "S120",
              "subcategories": []
            },
            {
              "id": "forklifts-sellick-s160",
              "name": "S160",
              "subcategories": []
            },
            {
              "id": "forklifts-sellick-sd80",
              "name": "SD80",
              "subcategories": []
            },
            {
              "id": "forklifts-sellick-sd100",
              "name": "SD100",
              "subcategories": []
            },
            {
              "id": "forklifts-sellick-sg60",
              "name": "SG60",
              "subcategories": []
            },
            {
              "id": "forklifts-sellick-slp60",
              "name": "SLP60",
              "subcategories": []
            },
            {
              "id": "forklifts-sellick-stm55",
              "name": "STM55",
              "subcategories": []
            },
            {
              "id": "forklifts-sellick-tmf55",
              "name": "TMF55",
              "subcategories": []
            },
            {
              "id": "forklifts-sellick-other",
              "name": "OTHER",
              "subcategories": []
            }
          ]
        },
        {
          "id": "forklifts-still",
          "name": "Still",
          "subcategories": [
            {
              "id": "forklifts-still-cs20",
              "name": "CS20",
              "subcategories": []
            },
            {
              "id": "forklifts-still-dfg4",
              "name": "DFG4",
              "subcategories": []
            },
            {
              "id": "forklifts-still-ech15",
              "name": "ECH15",
              "subcategories": []
            },
            {
              "id": "forklifts-still-ecu16",
              "name": "ECU16",
              "subcategories": []
            },
            {
              "id": "forklifts-still-efsm125",
              "name": "EFSM125",
              "subcategories": []
            },
            {
              "id": "forklifts-still-egv12",
              "name": "EGV12",
              "subcategories": []
            },
            {
              "id": "forklifts-still-egv14",
              "name": "EGV14",
              "subcategories": []
            },
            {
              "id": "forklifts-still-egv16",
              "name": "EGV16",
              "subcategories": []
            },
            {
              "id": "forklifts-still-esm10",
              "name": "ESM10",
              "subcategories": []
            },
            {
              "id": "forklifts-still-exd-s20",
              "name": "EXD-S20",
              "subcategories": []
            },
            {
              "id": "forklifts-still-exu18",
              "name": "EXU18",
              "subcategories": []
            },
            {
              "id": "forklifts-still-exu20",
              "name": "EXU20",
              "subcategories": []
            },
            {
              "id": "forklifts-still-exu22",
              "name": "EXU22",
              "subcategories": []
            },
            {
              "id": "forklifts-still-exus22",
              "name": "EXUS22",
              "subcategories": []
            },
            {
              "id": "forklifts-still-exus24",
              "name": "EXUS24",
              "subcategories": []
            },
            {
              "id": "forklifts-still-exv10",
              "name": "EXV10",
              "subcategories": []
            },
            {
              "id": "forklifts-still-exv12",
              "name": "EXV12",
              "subcategories": []
            },
            {
              "id": "forklifts-still-exv14",
              "name": "EXV14",
              "subcategories": []
            },
            {
              "id": "forklifts-still-exv20",
              "name": "EXV20",
              "subcategories": []
            },
            {
              "id": "forklifts-still-fm12",
              "name": "FM12",
              "subcategories": []
            },
            {
              "id": "forklifts-still-fm20",
              "name": "FM20",
              "subcategories": []
            },
            {
              "id": "forklifts-still-fm20i",
              "name": "FM20I",
              "subcategories": []
            },
            {
              "id": "forklifts-still-fmx14",
              "name": "FMX14",
              "subcategories": []
            },
            {
              "id": "forklifts-still-fmx17",
              "name": "FMX17",
              "subcategories": []
            },
            {
              "id": "forklifts-still-fmx20",
              "name": "FMX20",
              "subcategories": []
            },
            {
              "id": "forklifts-still-fmx25",
              "name": "FMX25",
              "subcategories": []
            },
            {
              "id": "forklifts-still-fvx16",
              "name": "FVX16",
              "subcategories": []
            },
            {
              "id": "forklifts-still-fxv",
              "name": "FXV",
              "subcategories": []
            },
            {
              "id": "forklifts-still-gx",
              "name": "GX",
              "subcategories": []
            },
            {
              "id": "forklifts-still-r20",
              "name": "R20",
              "subcategories": []
            },
            {
              "id": "forklifts-still-r50",
              "name": "R50",
              "subcategories": []
            },
            {
              "id": "forklifts-still-r60",
              "name": "R60",
              "subcategories": []
            },
            {
              "id": "forklifts-still-r60",
              "name": "R60",
              "subcategories": []
            },
            {
              "id": "forklifts-still-r70",
              "name": "R70",
              "subcategories": []
            },
            {
              "id": "forklifts-still-rc40",
              "name": "RC40",
              "subcategories": []
            },
            {
              "id": "forklifts-still-rc42",
              "name": "RC42",
              "subcategories": []
            },
            {
              "id": "forklifts-still-rce35",
              "name": "RCE35",
              "subcategories": []
            },
            {
              "id": "forklifts-still-rcg20",
              "name": "RCG20",
              "subcategories": []
            },
            {
              "id": "forklifts-still-rx20-16",
              "name": "RX20-16",
              "subcategories": []
            },
            {
              "id": "forklifts-still-rx20-20",
              "name": "RX20-20",
              "subcategories": []
            },
            {
              "id": "forklifts-still-rx50-10",
              "name": "RX50-10",
              "subcategories": []
            },
            {
              "id": "forklifts-still-rx50-15",
              "name": "RX50-15",
              "subcategories": []
            },
            {
              "id": "forklifts-still-rx50-16",
              "name": "RX50-16",
              "subcategories": []
            },
            {
              "id": "forklifts-still-rx60-25",
              "name": "RX60-25",
              "subcategories": []
            },
            {
              "id": "forklifts-still-rx60-30",
              "name": "RX60-30",
              "subcategories": []
            },
            {
              "id": "forklifts-still-rx60-35",
              "name": "RX60-35",
              "subcategories": []
            },
            {
              "id": "forklifts-still-rx60-40",
              "name": "RX60-40",
              "subcategories": []
            },
            {
              "id": "forklifts-still-rx60-45",
              "name": "RX60-45",
              "subcategories": []
            },
            {
              "id": "forklifts-still-rx60-45-600",
              "name": "RX60-45/600",
              "subcategories": []
            },
            {
              "id": "forklifts-still-rx60-50",
              "name": "RX60-50",
              "subcategories": []
            },
            {
              "id": "forklifts-still-rx60-50-600",
              "name": "RX60-50/600",
              "subcategories": []
            },
            {
              "id": "forklifts-still-rx60-80-900",
              "name": "RX60-80/900",
              "subcategories": []
            },
            {
              "id": "forklifts-still-rx70",
              "name": "RX70",
              "subcategories": []
            },
            {
              "id": "forklifts-still-other",
              "name": "OTHER",
              "subcategories": []
            }
          ]
        },
        {
          "id": "forklifts-tailift",
          "name": "Tailift",
          "subcategories": [
            {
              "id": "forklifts-tailift-dv8r",
              "name": "DV8R",
              "subcategories": []
            },
            {
              "id": "forklifts-tailift-efg25c",
              "name": "EFG25C",
              "subcategories": []
            },
            {
              "id": "forklifts-tailift-fd25",
              "name": "FD25",
              "subcategories": []
            },
            {
              "id": "forklifts-tailift-fd35",
              "name": "FD35",
              "subcategories": []
            },
            {
              "id": "forklifts-tailift-fd40",
              "name": "FD40",
              "subcategories": []
            },
            {
              "id": "forklifts-tailift-fg25",
              "name": "FG25",
              "subcategories": []
            },
            {
              "id": "forklifts-tailift-pfd25",
              "name": "PFD25",
              "subcategories": []
            },
            {
              "id": "forklifts-tailift-pfd30",
              "name": "PFD30",
              "subcategories": []
            },
            {
              "id": "forklifts-tailift-pfd36",
              "name": "PFD36",
              "subcategories": []
            },
            {
              "id": "forklifts-tailift-pfg18",
              "name": "PFG18",
              "subcategories": []
            },
            {
              "id": "forklifts-tailift-pfg25",
              "name": "PFG25",
              "subcategories": []
            },
            {
              "id": "forklifts-tailift-pfg30",
              "name": "PFG30",
              "subcategories": []
            },
            {
              "id": "forklifts-tailift-pfg36",
              "name": "PFG36",
              "subcategories": []
            },
            {
              "id": "forklifts-tailift-pfg45",
              "name": "PFG45",
              "subcategories": []
            },
            {
              "id": "forklifts-tailift-zfd25",
              "name": "ZFD25",
              "subcategories": []
            },
            {
              "id": "forklifts-tailift-zfg25",
              "name": "ZFG25",
              "subcategories": []
            },
            {
              "id": "forklifts-tailift-zfg30",
              "name": "ZFG30",
              "subcategories": []
            },
            {
              "id": "forklifts-tailift-other",
              "name": "OTHER",
              "subcategories": []
            }
          ]
        },
        {
          "id": "forklifts-taylor",
          "name": "Taylor",
          "subcategories": [
            {
              "id": "forklifts-taylor-gt50",
              "name": "GT50",
              "subcategories": []
            },
            {
              "id": "forklifts-taylor-gt60",
              "name": "GT60",
              "subcategories": []
            },
            {
              "id": "forklifts-taylor-gt80",
              "name": "GT80",
              "subcategories": []
            },
            {
              "id": "forklifts-taylor-gt90",
              "name": "GT90",
              "subcategories": []
            },
            {
              "id": "forklifts-taylor-gt100",
              "name": "GT100",
              "subcategories": []
            },
            {
              "id": "forklifts-taylor-gt120",
              "name": "GT120",
              "subcategories": []
            },
            {
              "id": "forklifts-taylor-gt180",
              "name": "GT180",
              "subcategories": []
            },
            {
              "id": "forklifts-taylor-gt360",
              "name": "GT360",
              "subcategories": []
            },
            {
              "id": "forklifts-taylor-gtr90",
              "name": "GTR90",
              "subcategories": []
            },
            {
              "id": "forklifts-taylor-pt550",
              "name": "PT550",
              "subcategories": []
            },
            {
              "id": "forklifts-taylor-t220",
              "name": "T220",
              "subcategories": []
            },
            {
              "id": "forklifts-taylor-t250",
              "name": "T250",
              "subcategories": []
            },
            {
              "id": "forklifts-taylor-t300",
              "name": "T300",
              "subcategories": []
            },
            {
              "id": "forklifts-taylor-t330",
              "name": "T330",
              "subcategories": []
            },
            {
              "id": "forklifts-taylor-t360",
              "name": "T360",
              "subcategories": []
            },
            {
              "id": "forklifts-taylor-t520",
              "name": "T520",
              "subcategories": []
            },
            {
              "id": "forklifts-taylor-t650",
              "name": "T650",
              "subcategories": []
            },
            {
              "id": "forklifts-taylor-tb300",
              "name": "TB300",
              "subcategories": []
            },
            {
              "id": "forklifts-taylor-tc230",
              "name": "TC230",
              "subcategories": []
            },
            {
              "id": "forklifts-taylor-te180",
              "name": "TE180",
              "subcategories": []
            },
            {
              "id": "forklifts-taylor-te250",
              "name": "TE250",
              "subcategories": []
            },
            {
              "id": "forklifts-taylor-te275",
              "name": "TE275",
              "subcategories": []
            },
            {
              "id": "forklifts-taylor-te300",
              "name": "TE300",
              "subcategories": []
            },
            {
              "id": "forklifts-taylor-te330",
              "name": "TE330",
              "subcategories": []
            },
            {
              "id": "forklifts-taylor-te360",
              "name": "TE360",
              "subcategories": []
            },
            {
              "id": "forklifts-taylor-te520",
              "name": "TE520",
              "subcategories": []
            },
            {
              "id": "forklifts-taylor-te650",
              "name": "TE650",
              "subcategories": []
            },
            {
              "id": "forklifts-taylor-te800",
              "name": "TE800",
              "subcategories": []
            },
            {
              "id": "forklifts-taylor-te925",
              "name": "TE925",
              "subcategories": []
            },
            {
              "id": "forklifts-taylor-te1100",
              "name": "TE1100",
              "subcategories": []
            },
            {
              "id": "forklifts-taylor-th350",
              "name": "TH350",
              "subcategories": []
            },
            {
              "id": "forklifts-taylor-thb250",
              "name": "THB250",
              "subcategories": []
            },
            {
              "id": "forklifts-taylor-thb300",
              "name": "THB300",
              "subcategories": []
            },
            {
              "id": "forklifts-taylor-thc300",
              "name": "THC300",
              "subcategories": []
            },
            {
              "id": "forklifts-taylor-thc400",
              "name": "THC400",
              "subcategories": []
            },
            {
              "id": "forklifts-taylor-thc800",
              "name": "THC800",
              "subcategories": []
            },
            {
              "id": "forklifts-taylor-thd160",
              "name": "THD160",
              "subcategories": []
            },
            {
              "id": "forklifts-taylor-thd300",
              "name": "THD300",
              "subcategories": []
            },
            {
              "id": "forklifts-taylor-thd360",
              "name": "THD360",
              "subcategories": []
            },
            {
              "id": "forklifts-taylor-tn520",
              "name": "TN520",
              "subcategories": []
            },
            {
              "id": "forklifts-taylor-tx4",
              "name": "TX4",
              "subcategories": []
            },
            {
              "id": "forklifts-taylor-tx160",
              "name": "TX160",
              "subcategories": []
            },
            {
              "id": "forklifts-taylor-tx175",
              "name": "TX175",
              "subcategories": []
            },
            {
              "id": "forklifts-taylor-tx220",
              "name": "TX220",
              "subcategories": []
            },
            {
              "id": "forklifts-taylor-tx250",
              "name": "TX250",
              "subcategories": []
            },
            {
              "id": "forklifts-taylor-tx280",
              "name": "TX280",
              "subcategories": []
            },
            {
              "id": "forklifts-taylor-tx300",
              "name": "TX300",
              "subcategories": []
            },
            {
              "id": "forklifts-taylor-tx330",
              "name": "TX330",
              "subcategories": []
            },
            {
              "id": "forklifts-taylor-tx360",
              "name": "TX360",
              "subcategories": []
            },
            {
              "id": "forklifts-taylor-tx520",
              "name": "TX520",
              "subcategories": []
            },
            {
              "id": "forklifts-taylor-tx550",
              "name": "TX550",
              "subcategories": []
            },
            {
              "id": "forklifts-taylor-tx650",
              "name": "TX650",
              "subcategories": []
            },
            {
              "id": "forklifts-taylor-tx800",
              "name": "TX800",
              "subcategories": []
            },
            {
              "id": "forklifts-taylor-tx925",
              "name": "TX925",
              "subcategories": []
            },
            {
              "id": "forklifts-taylor-txb180",
              "name": "TXB180",
              "subcategories": []
            },
            {
              "id": "forklifts-taylor-txb350",
              "name": "TXB350",
              "subcategories": []
            },
            {
              "id": "forklifts-taylor-txi520",
              "name": "TXI520",
              "subcategories": []
            },
            {
              "id": "forklifts-taylor-txi650",
              "name": "TXI650",
              "subcategories": []
            },
            {
              "id": "forklifts-taylor-txi700",
              "name": "TXI700",
              "subcategories": []
            },
            {
              "id": "forklifts-taylor-tyb220",
              "name": "TYB220",
              "subcategories": []
            },
            {
              "id": "forklifts-taylor-wpy",
              "name": "WPY",
              "subcategories": []
            },
            {
              "id": "forklifts-taylor-x160",
              "name": "X160",
              "subcategories": []
            },
            {
              "id": "forklifts-taylor-x175",
              "name": "X175",
              "subcategories": []
            },
            {
              "id": "forklifts-taylor-x180",
              "name": "X180",
              "subcategories": []
            },
            {
              "id": "forklifts-taylor-x200",
              "name": "X200",
              "subcategories": []
            },
            {
              "id": "forklifts-taylor-x220",
              "name": "X220",
              "subcategories": []
            },
            {
              "id": "forklifts-taylor-x250",
              "name": "X250",
              "subcategories": []
            },
            {
              "id": "forklifts-taylor-x280",
              "name": "X280",
              "subcategories": []
            },
            {
              "id": "forklifts-taylor-x300",
              "name": "X300",
              "subcategories": []
            },
            {
              "id": "forklifts-taylor-x330",
              "name": "X330",
              "subcategories": []
            },
            {
              "id": "forklifts-taylor-x360",
              "name": "X360",
              "subcategories": []
            },
            {
              "id": "forklifts-taylor-x500",
              "name": "X500",
              "subcategories": []
            },
            {
              "id": "forklifts-taylor-x550",
              "name": "X550",
              "subcategories": []
            },
            {
              "id": "forklifts-taylor-x650",
              "name": "X650",
              "subcategories": []
            },
            {
              "id": "forklifts-taylor-x700",
              "name": "X700",
              "subcategories": []
            },
            {
              "id": "forklifts-taylor-xb",
              "name": "XB",
              "subcategories": []
            },
            {
              "id": "forklifts-taylor-xc220",
              "name": "XC220",
              "subcategories": []
            },
            {
              "id": "forklifts-taylor-xc250",
              "name": "XC250",
              "subcategories": []
            },
            {
              "id": "forklifts-taylor-xc300",
              "name": "XC300",
              "subcategories": []
            },
            {
              "id": "forklifts-taylor-xe4060",
              "name": "XE4060",
              "subcategories": []
            },
            {
              "id": "forklifts-taylor-xh180",
              "name": "XH180",
              "subcategories": []
            },
            {
              "id": "forklifts-taylor-xh350",
              "name": "XH350",
              "subcategories": []
            },
            {
              "id": "forklifts-taylor-xh360",
              "name": "XH360",
              "subcategories": []
            },
            {
              "id": "forklifts-taylor-xh370",
              "name": "XH370",
              "subcategories": []
            },
            {
              "id": "forklifts-taylor-xh400",
              "name": "XH400",
              "subcategories": []
            },
            {
              "id": "forklifts-taylor-xh550",
              "name": "XH550",
              "subcategories": []
            },
            {
              "id": "forklifts-taylor-xh700",
              "name": "XH700",
              "subcategories": []
            },
            {
              "id": "forklifts-taylor-xhc",
              "name": "XHC",
              "subcategories": []
            },
            {
              "id": "forklifts-taylor-y18",
              "name": "Y18",
              "subcategories": []
            },
            {
              "id": "forklifts-taylor-y24",
              "name": "Y24",
              "subcategories": []
            },
            {
              "id": "forklifts-taylor-other",
              "name": "OTHER",
              "subcategories": []
            }
          ]
        },
        {
          "id": "forklifts-tcm",
          "name": "Tcm",
          "subcategories": [
            {
              "id": "forklifts-tcm-fa20",
              "name": "FA20",
              "subcategories": []
            },
            {
              "id": "forklifts-tcm-fa30",
              "name": "FA30",
              "subcategories": []
            },
            {
              "id": "forklifts-tcm-fb15",
              "name": "FB15",
              "subcategories": []
            },
            {
              "id": "forklifts-tcm-fb25",
              "name": "FB25",
              "subcategories": []
            },
            {
              "id": "forklifts-tcm-fb30",
              "name": "FB30",
              "subcategories": []
            },
            {
              "id": "forklifts-tcm-fcb25",
              "name": "FCB25",
              "subcategories": []
            },
            {
              "id": "forklifts-tcm-fcb30",
              "name": "FCB30",
              "subcategories": []
            },
            {
              "id": "forklifts-tcm-fcg15",
              "name": "FCG15",
              "subcategories": []
            },
            {
              "id": "forklifts-tcm-fcg25",
              "name": "FCG25",
              "subcategories": []
            },
            {
              "id": "forklifts-tcm-fcg36",
              "name": "FCG36",
              "subcategories": []
            },
            {
              "id": "forklifts-tcm-fd25",
              "name": "FD25",
              "subcategories": []
            },
            {
              "id": "forklifts-tcm-fd30",
              "name": "FD30",
              "subcategories": []
            },
            {
              "id": "forklifts-tcm-fd35",
              "name": "FD35",
              "subcategories": []
            },
            {
              "id": "forklifts-tcm-fd40",
              "name": "FD40",
              "subcategories": []
            },
            {
              "id": "forklifts-tcm-fd45",
              "name": "FD45",
              "subcategories": []
            },
            {
              "id": "forklifts-tcm-fd60",
              "name": "FD60",
              "subcategories": []
            },
            {
              "id": "forklifts-tcm-fd70",
              "name": "FD70",
              "subcategories": []
            },
            {
              "id": "forklifts-tcm-fd80",
              "name": "FD80",
              "subcategories": []
            },
            {
              "id": "forklifts-tcm-fd100",
              "name": "FD100",
              "subcategories": []
            },
            {
              "id": "forklifts-tcm-fd120",
              "name": "FD120",
              "subcategories": []
            },
            {
              "id": "forklifts-tcm-fd135",
              "name": "FD135",
              "subcategories": []
            },
            {
              "id": "forklifts-tcm-fd180",
              "name": "FD180",
              "subcategories": []
            },
            {
              "id": "forklifts-tcm-fd200",
              "name": "FD200",
              "subcategories": []
            },
            {
              "id": "forklifts-tcm-fd250",
              "name": "FD250",
              "subcategories": []
            },
            {
              "id": "forklifts-tcm-fd300",
              "name": "FD300",
              "subcategories": []
            },
            {
              "id": "forklifts-tcm-fg15",
              "name": "FG15",
              "subcategories": []
            },
            {
              "id": "forklifts-tcm-fg20",
              "name": "FG20",
              "subcategories": []
            },
            {
              "id": "forklifts-tcm-fg25",
              "name": "FG25",
              "subcategories": []
            },
            {
              "id": "forklifts-tcm-fg30",
              "name": "FG30",
              "subcategories": []
            },
            {
              "id": "forklifts-tcm-fg40",
              "name": "FG40",
              "subcategories": []
            },
            {
              "id": "forklifts-tcm-fge20",
              "name": "FGE20",
              "subcategories": []
            },
            {
              "id": "forklifts-tcm-fge25",
              "name": "FGE25",
              "subcategories": []
            },
            {
              "id": "forklifts-tcm-fhb30",
              "name": "FHB30",
              "subcategories": []
            },
            {
              "id": "forklifts-tcm-fhd15",
              "name": "FHD15",
              "subcategories": []
            },
            {
              "id": "forklifts-tcm-fhd30",
              "name": "FHD30",
              "subcategories": []
            },
            {
              "id": "forklifts-tcm-fhd35",
              "name": "FHD35",
              "subcategories": []
            },
            {
              "id": "forklifts-tcm-fhd36",
              "name": "FHD36",
              "subcategories": []
            },
            {
              "id": "forklifts-tcm-fhg25",
              "name": "FHG25",
              "subcategories": []
            },
            {
              "id": "forklifts-tcm-fhg30",
              "name": "FHG30",
              "subcategories": []
            },
            {
              "id": "forklifts-tcm-ftb18",
              "name": "FTB18",
              "subcategories": []
            },
            {
              "id": "forklifts-tcm-fvd20",
              "name": "FVD20",
              "subcategories": []
            },
            {
              "id": "forklifts-tcm-prog25",
              "name": "PROG25",
              "subcategories": []
            },
            {
              "id": "forklifts-tcm-other",
              "name": "OTHER",
              "subcategories": []
            }
          ]
        },
        {
          "id": "forklifts-uhi",
          "name": "Uhi",
          "subcategories": [
            {
              "id": "forklifts-uhi-cpd25",
              "name": "CPD25",
              "subcategories": []
            },
            {
              "id": "forklifts-uhi-cpcd35",
              "name": "CPCD35",
              "subcategories": []
            },
            {
              "id": "forklifts-uhi-fd25",
              "name": "FD25",
              "subcategories": []
            },
            {
              "id": "forklifts-uhi-fr35",
              "name": "FR35",
              "subcategories": []
            },
            {
              "id": "forklifts-uhi-other",
              "name": "OTHER",
              "subcategories": []
            }
          ]
        },
        {
          "id": "forklifts-unicarriers",
          "name": "Unicarriers",
          "subcategories": [
            {
              "id": "forklifts-unicarriers-1s1l20nv",
              "name": "1S1L20NV",
              "subcategories": []
            },
            {
              "id": "forklifts-unicarriers-a1n1l",
              "name": "A1N1L",
              "subcategories": []
            },
            {
              "id": "forklifts-unicarriers-af30",
              "name": "AF30",
              "subcategories": []
            },
            {
              "id": "forklifts-unicarriers-af35",
              "name": "AF35",
              "subcategories": []
            },
            {
              "id": "forklifts-unicarriers-af50",
              "name": "AF50",
              "subcategories": []
            },
            {
              "id": "forklifts-unicarriers-bxc30",
              "name": "BXC30",
              "subcategories": []
            },
            {
              "id": "forklifts-unicarriers-bxc35",
              "name": "BXC35",
              "subcategories": []
            },
            {
              "id": "forklifts-unicarriers-bxc40",
              "name": "BXC40",
              "subcategories": []
            },
            {
              "id": "forklifts-unicarriers-bxc50",
              "name": "BXC50",
              "subcategories": []
            },
            {
              "id": "forklifts-unicarriers-bxc60",
              "name": "BXC60",
              "subcategories": []
            },
            {
              "id": "forklifts-unicarriers-bxc80",
              "name": "BXC80",
              "subcategories": []
            },
            {
              "id": "forklifts-unicarriers-bxp30",
              "name": "BXP30",
              "subcategories": []
            },
            {
              "id": "forklifts-unicarriers-cf30",
              "name": "CF30",
              "subcategories": []
            },
            {
              "id": "forklifts-unicarriers-cf35",
              "name": "CF35",
              "subcategories": []
            },
            {
              "id": "forklifts-unicarriers-cf40",
              "name": "CF40",
              "subcategories": []
            },
            {
              "id": "forklifts-unicarriers-cf50",
              "name": "CF50",
              "subcategories": []
            },
            {
              "id": "forklifts-unicarriers-cf60",
              "name": "CF60",
              "subcategories": []
            },
            {
              "id": "forklifts-unicarriers-cf70",
              "name": "CF70",
              "subcategories": []
            },
            {
              "id": "forklifts-unicarriers-cf80",
              "name": "CF80",
              "subcategories": []
            },
            {
              "id": "forklifts-unicarriers-cf100",
              "name": "CF100",
              "subcategories": []
            },
            {
              "id": "forklifts-unicarriers-cf120",
              "name": "CF120",
              "subcategories": []
            },
            {
              "id": "forklifts-unicarriers-cf155",
              "name": "CF155",
              "subcategories": []
            },
            {
              "id": "forklifts-unicarriers-cfs40",
              "name": "CFS40",
              "subcategories": []
            },
            {
              "id": "forklifts-unicarriers-cfs65",
              "name": "CFS65",
              "subcategories": []
            },
            {
              "id": "forklifts-unicarriers-cfs85",
              "name": "CFS85",
              "subcategories": []
            },
            {
              "id": "forklifts-unicarriers-cfu50",
              "name": "CFU50",
              "subcategories": []
            },
            {
              "id": "forklifts-unicarriers-fcg25",
              "name": "FCG25",
              "subcategories": []
            },
            {
              "id": "forklifts-unicarriers-fcg30",
              "name": "FCG30",
              "subcategories": []
            },
            {
              "id": "forklifts-unicarriers-fg25",
              "name": "FG25",
              "subcategories": []
            },
            {
              "id": "forklifts-unicarriers-fhd30",
              "name": "FHD30",
              "subcategories": []
            },
            {
              "id": "forklifts-unicarriers-fhd35",
              "name": "FHD35",
              "subcategories": []
            },
            {
              "id": "forklifts-unicarriers-l1f6f70v",
              "name": "L1F6F70V",
              "subcategories": []
            },
            {
              "id": "forklifts-unicarriers-mctg1b2l",
              "name": "MCTG1B2L",
              "subcategories": []
            },
            {
              "id": "forklifts-unicarriers-mj1f4",
              "name": "MJ1F4",
              "subcategories": []
            },
            {
              "id": "forklifts-unicarriers-mw1f4a45v",
              "name": "MW1F4A45V",
              "subcategories": []
            },
            {
              "id": "forklifts-unicarriers-mxs3",
              "name": "MXS3",
              "subcategories": []
            },
            {
              "id": "forklifts-unicarriers-mxs20",
              "name": "MXS20",
              "subcategories": []
            },
            {
              "id": "forklifts-unicarriers-pf30",
              "name": "PF30",
              "subcategories": []
            },
            {
              "id": "forklifts-unicarriers-pf35",
              "name": "PF35",
              "subcategories": []
            },
            {
              "id": "forklifts-unicarriers-pf40",
              "name": "PF40",
              "subcategories": []
            },
            {
              "id": "forklifts-unicarriers-pf50",
              "name": "PF50",
              "subcategories": []
            },
            {
              "id": "forklifts-unicarriers-pf55",
              "name": "PF55",
              "subcategories": []
            },
            {
              "id": "forklifts-unicarriers-pf60",
              "name": "PF60",
              "subcategories": []
            },
            {
              "id": "forklifts-unicarriers-pf70",
              "name": "PF70",
              "subcategories": []
            },
            {
              "id": "forklifts-unicarriers-pf80",
              "name": "PF80",
              "subcategories": []
            },
            {
              "id": "forklifts-unicarriers-pf90",
              "name": "PF90",
              "subcategories": []
            },
            {
              "id": "forklifts-unicarriers-pf100",
              "name": "PF100",
              "subcategories": []
            },
            {
              "id": "forklifts-unicarriers-pfd40",
              "name": "PFD40",
              "subcategories": []
            },
            {
              "id": "forklifts-unicarriers-pfd60",
              "name": "PFD60",
              "subcategories": []
            },
            {
              "id": "forklifts-unicarriers-pfd70",
              "name": "PFD70",
              "subcategories": []
            },
            {
              "id": "forklifts-unicarriers-pfd110",
              "name": "PFD110",
              "subcategories": []
            },
            {
              "id": "forklifts-unicarriers-fd45",
              "name": "FD45",
              "subcategories": []
            },
            {
              "id": "forklifts-unicarriers-pfd155",
              "name": "PFD155",
              "subcategories": []
            },
            {
              "id": "forklifts-unicarriers-pfd175",
              "name": "PFD175",
              "subcategories": []
            },
            {
              "id": "forklifts-unicarriers-pfu50",
              "name": "PFU50",
              "subcategories": []
            },
            {
              "id": "forklifts-unicarriers-rpx60",
              "name": "RPX60",
              "subcategories": []
            },
            {
              "id": "forklifts-unicarriers-scx40",
              "name": "SCX40",
              "subcategories": []
            },
            {
              "id": "forklifts-unicarriers-srx30",
              "name": "SRX30",
              "subcategories": []
            },
            {
              "id": "forklifts-unicarriers-srx35",
              "name": "SRX35",
              "subcategories": []
            },
            {
              "id": "forklifts-unicarriers-srx45",
              "name": "SRX45",
              "subcategories": []
            },
            {
              "id": "forklifts-unicarriers-tx30",
              "name": "TX30",
              "subcategories": []
            },
            {
              "id": "forklifts-unicarriers-tx35",
              "name": "TX35",
              "subcategories": []
            },
            {
              "id": "forklifts-unicarriers-tx40",
              "name": "TX40",
              "subcategories": []
            },
            {
              "id": "forklifts-unicarriers-wlx45",
              "name": "WLX45",
              "subcategories": []
            },
            {
              "id": "forklifts-unicarriers-wpx60",
              "name": "WPX60",
              "subcategories": []
            },
            {
              "id": "forklifts-unicarriers-y1d1a15q",
              "name": "Y1D1A15Q",
              "subcategories": []
            },
            {
              "id": "forklifts-unicarriers-y1d1a18q",
              "name": "Y1D1A18Q",
              "subcategories": []
            },
            {
              "id": "forklifts-unicarriers-mjg1f4a50lv",
              "name": "MJG1F4A50LV",
              "subcategories": []
            },
            {
              "id": "forklifts-unicarriers-other",
              "name": "OTHER",
              "subcategories": []
            }
          ]
        },
        {
          "id": "forklifts-versa-lift",
          "name": "Versa-Lift",
          "subcategories": [
            {
              "id": "forklifts-versa-lift-25-35",
              "name": "25/35",
              "subcategories": []
            },
            {
              "id": "forklifts-versa-lift-40-60",
              "name": "40/60",
              "subcategories": []
            },
            {
              "id": "forklifts-versa-lift-60-80",
              "name": "60/80",
              "subcategories": []
            },
            {
              "id": "forklifts-versa-lift-100-140",
              "name": "100/140",
              "subcategories": []
            },
            {
              "id": "forklifts-versa-lift-other",
              "name": "OTHER",
              "subcategories": []
            }
          ]
        },
        {
          "id": "forklifts-viper",
          "name": "Viper",
          "subcategories": [
            {
              "id": "forklifts-viper-fb15",
              "name": "FB15",
              "subcategories": []
            },
            {
              "id": "forklifts-viper-fb16",
              "name": "FB16",
              "subcategories": []
            },
            {
              "id": "forklifts-viper-fb25",
              "name": "FB25",
              "subcategories": []
            },
            {
              "id": "forklifts-viper-fb30",
              "name": "FB30",
              "subcategories": []
            },
            {
              "id": "forklifts-viper-fb35",
              "name": "FB35",
              "subcategories": []
            },
            {
              "id": "forklifts-viper-fb50",
              "name": "FB50",
              "subcategories": []
            },
            {
              "id": "forklifts-viper-fd25",
              "name": "FD25",
              "subcategories": []
            },
            {
              "id": "forklifts-viper-fd30",
              "name": "FD30",
              "subcategories": []
            },
            {
              "id": "forklifts-viper-fd35",
              "name": "FD35",
              "subcategories": []
            },
            {
              "id": "forklifts-viper-fd45",
              "name": "FD45",
              "subcategories": []
            },
            {
              "id": "forklifts-viper-fd50",
              "name": "FD50",
              "subcategories": []
            },
            {
              "id": "forklifts-viper-fd60",
              "name": "FD60",
              "subcategories": []
            },
            {
              "id": "forklifts-viper-fd70",
              "name": "FD70",
              "subcategories": []
            },
            {
              "id": "forklifts-viper-fd80",
              "name": "FD80",
              "subcategories": []
            },
            {
              "id": "forklifts-viper-fd100",
              "name": "FD100",
              "subcategories": []
            },
            {
              "id": "forklifts-viper-fy15",
              "name": "FY15",
              "subcategories": []
            },
            {
              "id": "forklifts-viper-fy18",
              "name": "FY18",
              "subcategories": []
            },
            {
              "id": "forklifts-viper-fy20",
              "name": "FY20",
              "subcategories": []
            },
            {
              "id": "forklifts-viper-fd20",
              "name": "FD20",
              "subcategories": []
            },
            {
              "id": "forklifts-viper-fy25",
              "name": "FY25",
              "subcategories": []
            },
            {
              "id": "forklifts-viper-fy30",
              "name": "FY30",
              "subcategories": []
            },
            {
              "id": "forklifts-viper-fy32",
              "name": "FY32",
              "subcategories": []
            },
            {
              "id": "forklifts-viper-fy35",
              "name": "FY35",
              "subcategories": []
            },
            {
              "id": "forklifts-viper-fy45",
              "name": "FY45",
              "subcategories": []
            },
            {
              "id": "forklifts-viper-fy50",
              "name": "FY50",
              "subcategories": []
            },
            {
              "id": "forklifts-viper-fy70",
              "name": "FY70",
              "subcategories": []
            },
            {
              "id": "forklifts-viper-rt80",
              "name": "RT80",
              "subcategories": []
            },
            {
              "id": "forklifts-viper-rt110",
              "name": "RT110",
              "subcategories": []
            },
            {
              "id": "forklifts-viper-rtd25",
              "name": "RTD25",
              "subcategories": []
            },
            {
              "id": "forklifts-viper-rtd30",
              "name": "RTD30",
              "subcategories": []
            },
            {
              "id": "forklifts-viper-rtd35",
              "name": "RTD35",
              "subcategories": []
            },
            {
              "id": "forklifts-viper-vcps30-40",
              "name": "VCPS30-40",
              "subcategories": []
            },
            {
              "id": "forklifts-viper-vcws25-35",
              "name": "VCWS25-35",
              "subcategories": []
            },
            {
              "id": "forklifts-viper-vrt40-50s",
              "name": "VRT40-50S",
              "subcategories": []
            },
            {
              "id": "forklifts-viper-vps40-40s",
              "name": "VPS40-40S",
              "subcategories": []
            },
            {
              "id": "forklifts-viper-vpt60",
              "name": "VPT60",
              "subcategories": []
            },
            {
              "id": "forklifts-viper-vp30x-50s",
              "name": "VP30X-50S",
              "subcategories": []
            },
            {
              "id": "forklifts-viper-other",
              "name": "OTHER",
              "subcategories": []
            }
          ]
        },
        {
          "id": "forklifts-xcmg",
          "name": "Xcmg",
          "subcategories": [
            {
              "id": "forklifts-xcmg-fd25",
              "name": "FD25",
              "subcategories": []
            },
            {
              "id": "forklifts-xcmg-fd35",
              "name": "FD35",
              "subcategories": []
            },
            {
              "id": "forklifts-xcmg-fd50",
              "name": "FD50",
              "subcategories": []
            },
            {
              "id": "forklifts-xcmg-fd70",
              "name": "FD70",
              "subcategories": []
            },
            {
              "id": "forklifts-xcmg-fgl25",
              "name": "FGL25",
              "subcategories": []
            },
            {
              "id": "forklifts-xcmg-fgl50",
              "name": "FGL50",
              "subcategories": []
            },
            {
              "id": "forklifts-xcmg-xcb30",
              "name": "XCB30",
              "subcategories": []
            },
            {
              "id": "forklifts-xcmg-xcb-d",
              "name": "XCB-D",
              "subcategories": []
            },
            {
              "id": "forklifts-xcmg-xcb",
              "name": "XCB",
              "subcategories": []
            },
            {
              "id": "forklifts-xcmg-xcb-p",
              "name": "XCB-P",
              "subcategories": []
            },
            {
              "id": "forklifts-xcmg-xcb-t",
              "name": "XCB-T",
              "subcategories": []
            },
            {
              "id": "forklifts-xcmg-xcf30kt",
              "name": "XCF30KT",
              "subcategories": []
            },
            {
              "id": "forklifts-xcmg-xcf50kt",
              "name": "XCF50KT",
              "subcategories": []
            },
            {
              "id": "forklifts-xcmg-xcf",
              "name": "XCF",
              "subcategories": []
            },
            {
              "id": "forklifts-xcmg-xvb50-t",
              "name": "XVB50-T",
              "subcategories": []
            },
            {
              "id": "forklifts-xcmg-other",
              "name": "OTHER",
              "subcategories": []
            }
          ]
        }
      ]
    },
    {
      "id": "motor-graders",
      "name": "Motor Graders",
      "subcategories": [
        {
          "id": "motor-graders-caterpillar",
          "name": "Caterpillar",
          "subcategories": [
            {
              "id": "motor-graders-caterpillar-12",
              "name": "12",
              "subcategories": []
            },
            {
              "id": "motor-graders-caterpillar-12e",
              "name": "12E",
              "subcategories": []
            },
            {
              "id": "motor-graders-caterpillar-12f",
              "name": "12F",
              "subcategories": []
            },
            {
              "id": "motor-graders-caterpillar-12g",
              "name": "12G",
              "subcategories": []
            },
            {
              "id": "motor-graders-caterpillar-12h",
              "name": "12H",
              "subcategories": []
            },
            {
              "id": "motor-graders-caterpillar-12h-vhp-plus",
              "name": "12H VHP PLUS",
              "subcategories": []
            },
            {
              "id": "motor-graders-caterpillar-12hes",
              "name": "12HES",
              "subcategories": []
            },
            {
              "id": "motor-graders-caterpillar-12k",
              "name": "12K",
              "subcategories": []
            },
            {
              "id": "motor-graders-caterpillar-12m",
              "name": "12M",
              "subcategories": []
            },
            {
              "id": "motor-graders-caterpillar-12m-vhp",
              "name": "12M VHP",
              "subcategories": []
            },
            {
              "id": "motor-graders-caterpillar-12m-vhp-plus",
              "name": "12M VHP PLUS",
              "subcategories": []
            },
            {
              "id": "motor-graders-caterpillar-12m2",
              "name": "12M2",
              "subcategories": []
            },
            {
              "id": "motor-graders-caterpillar-12m2-awd",
              "name": "12M2 AWD",
              "subcategories": []
            },
            {
              "id": "motor-graders-caterpillar-12m2-vhp-plus",
              "name": "12M2 VHP PLUS",
              "subcategories": []
            },
            {
              "id": "motor-graders-caterpillar-12m3",
              "name": "12M3",
              "subcategories": []
            },
            {
              "id": "motor-graders-caterpillar-12m3-awd",
              "name": "12M3 AWD",
              "subcategories": []
            },
            {
              "id": "motor-graders-caterpillar-14",
              "name": "14",
              "subcategories": []
            },
            {
              "id": "motor-graders-caterpillar-14e",
              "name": "14E",
              "subcategories": []
            },
            {
              "id": "motor-graders-caterpillar-14g",
              "name": "14G",
              "subcategories": []
            },
            {
              "id": "motor-graders-caterpillar-14h",
              "name": "14H",
              "subcategories": []
            },
            {
              "id": "motor-graders-caterpillar-14h-ii",
              "name": "14H II",
              "subcategories": []
            },
            {
              "id": "motor-graders-caterpillar-14h-vhp",
              "name": "14H VHP",
              "subcategories": []
            },
            {
              "id": "motor-graders-caterpillar-14m",
              "name": "14M",
              "subcategories": []
            },
            {
              "id": "motor-graders-caterpillar-14m-vhp",
              "name": "14M VHP",
              "subcategories": []
            },
            {
              "id": "motor-graders-caterpillar-14m-vhp-plus",
              "name": "14M VHP PLUS",
              "subcategories": []
            },
            {
              "id": "motor-graders-caterpillar-14m3",
              "name": "14M3",
              "subcategories": []
            },
            {
              "id": "motor-graders-caterpillar-16",
              "name": "16",
              "subcategories": []
            },
            {
              "id": "motor-graders-caterpillar-16g",
              "name": "16G",
              "subcategories": []
            },
            {
              "id": "motor-graders-caterpillar-16h",
              "name": "16H",
              "subcategories": []
            },
            {
              "id": "motor-graders-caterpillar-16h-vhp",
              "name": "16H VHP",
              "subcategories": []
            },
            {
              "id": "motor-graders-caterpillar-16m",
              "name": "16M",
              "subcategories": []
            },
            {
              "id": "motor-graders-caterpillar-16m-vhp",
              "name": "16M VHP",
              "subcategories": []
            },
            {
              "id": "motor-graders-caterpillar-16m3",
              "name": "16M3",
              "subcategories": []
            },
            {
              "id": "motor-graders-caterpillar-16gc",
              "name": "16GC",
              "subcategories": []
            },
            {
              "id": "motor-graders-caterpillar-18",
              "name": "18",
              "subcategories": []
            },
            {
              "id": "motor-graders-caterpillar-24h",
              "name": "24H",
              "subcategories": []
            },
            {
              "id": "motor-graders-caterpillar-24m",
              "name": "24M",
              "subcategories": []
            },
            {
              "id": "motor-graders-caterpillar-112f",
              "name": "112F",
              "subcategories": []
            },
            {
              "id": "motor-graders-caterpillar-120",
              "name": "120",
              "subcategories": []
            },
            {
              "id": "motor-graders-caterpillar-120-awd",
              "name": "120 AWD",
              "subcategories": []
            },
            {
              "id": "motor-graders-caterpillar-120g",
              "name": "120G",
              "subcategories": []
            },
            {
              "id": "motor-graders-caterpillar-120h",
              "name": "120H",
              "subcategories": []
            },
            {
              "id": "motor-graders-caterpillar-120h-vhp",
              "name": "120H VHP",
              "subcategories": []
            },
            {
              "id": "motor-graders-caterpillar-120k",
              "name": "120K",
              "subcategories": []
            },
            {
              "id": "motor-graders-caterpillar-120m",
              "name": "120M",
              "subcategories": []
            },
            {
              "id": "motor-graders-caterpillar-120m-awd",
              "name": "120M AWD",
              "subcategories": []
            },
            {
              "id": "motor-graders-caterpillar-120m-awd-plus",
              "name": "120M AWD PLUS",
              "subcategories": []
            },
            {
              "id": "motor-graders-caterpillar-120m2",
              "name": "120M2",
              "subcategories": []
            },
            {
              "id": "motor-graders-caterpillar-120m2-awd",
              "name": "120M2 AWD",
              "subcategories": []
            },
            {
              "id": "motor-graders-caterpillar-120m2-awd-vhp-plus",
              "name": "120M2 AWD VHP PLUS",
              "subcategories": []
            },
            {
              "id": "motor-graders-caterpillar-120m2",
              "name": "120M2",
              "subcategories": []
            },
            {
              "id": "motor-graders-caterpillar-120m2-awd",
              "name": "120M2 AWD",
              "subcategories": []
            },
            {
              "id": "motor-graders-caterpillar-120m2-vhp-plus",
              "name": "120M2 VHP PLUS",
              "subcategories": []
            },
            {
              "id": "motor-graders-caterpillar-130g",
              "name": "130G",
              "subcategories": []
            },
            {
              "id": "motor-graders-caterpillar-135h",
              "name": "135H",
              "subcategories": []
            },
            {
              "id": "motor-graders-caterpillar-140",
              "name": "140",
              "subcategories": []
            },
            {
              "id": "motor-graders-caterpillar-140-awd",
              "name": "140 AWD",
              "subcategories": []
            },
            {
              "id": "motor-graders-caterpillar-140g",
              "name": "140G",
              "subcategories": []
            },
            {
              "id": "motor-graders-caterpillar-140g-awd",
              "name": "140G AWD",
              "subcategories": []
            },
            {
              "id": "motor-graders-caterpillar-140g-vhp",
              "name": "140G VHP",
              "subcategories": []
            },
            {
              "id": "motor-graders-caterpillar-140gc",
              "name": "140GC",
              "subcategories": []
            },
            {
              "id": "motor-graders-caterpillar-140gc-awd",
              "name": "140GC AWD",
              "subcategories": []
            },
            {
              "id": "motor-graders-caterpillar-140h",
              "name": "140H",
              "subcategories": []
            },
            {
              "id": "motor-graders-caterpillar-140h-vhp",
              "name": "140H VHP",
              "subcategories": []
            },
            {
              "id": "motor-graders-caterpillar-140h-vhp-plus",
              "name": "140H VHP PLUS",
              "subcategories": []
            },
            {
              "id": "motor-graders-caterpillar-140k",
              "name": "140K",
              "subcategories": []
            },
            {
              "id": "motor-graders-caterpillar-140k2",
              "name": "140K2",
              "subcategories": []
            },
            {
              "id": "motor-graders-caterpillar-140m",
              "name": "140M",
              "subcategories": []
            },
            {
              "id": "motor-graders-caterpillar-140m-awd",
              "name": "140M AWD",
              "subcategories": []
            },
            {
              "id": "motor-graders-caterpillar-140m-awd",
              "name": "140M AWD",
              "subcategories": []
            },
            {
              "id": "motor-graders-caterpillar-140m-awd-vhp-plus",
              "name": "140M AWD VHP PLUS",
              "subcategories": []
            },
            {
              "id": "motor-graders-caterpillar-140m-vhp",
              "name": "140M VHP",
              "subcategories": []
            },
            {
              "id": "motor-graders-caterpillar-140m-vhp-plus",
              "name": "140M VHP PLUS",
              "subcategories": []
            },
            {
              "id": "motor-graders-caterpillar-140m2",
              "name": "140M2",
              "subcategories": []
            },
            {
              "id": "motor-graders-caterpillar-140m2-awd",
              "name": "140M2 AWD",
              "subcategories": []
            },
            {
              "id": "motor-graders-caterpillar-140m2-awd-vhp-plus",
              "name": "140M2 AWD VHP PLUS",
              "subcategories": []
            },
            {
              "id": "motor-graders-caterpillar-140m2-vhp",
              "name": "140M2 VHP",
              "subcategories": []
            },
            {
              "id": "motor-graders-caterpillar-140m2-vhp-plus",
              "name": "140M2 VHP PLUS",
              "subcategories": []
            },
            {
              "id": "motor-graders-caterpillar-140m3",
              "name": "140M3",
              "subcategories": []
            },
            {
              "id": "motor-graders-caterpillar-140m3-awd",
              "name": "140M3 AWD",
              "subcategories": []
            },
            {
              "id": "motor-graders-caterpillar-143h",
              "name": "143H",
              "subcategories": []
            },
            {
              "id": "motor-graders-caterpillar-150",
              "name": "150",
              "subcategories": []
            },
            {
              "id": "motor-graders-caterpillar-150-awd",
              "name": "150 AWD",
              "subcategories": []
            },
            {
              "id": "motor-graders-caterpillar-160",
              "name": "160",
              "subcategories": []
            },
            {
              "id": "motor-graders-caterpillar-160-awd",
              "name": "160 AWD",
              "subcategories": []
            },
            {
              "id": "motor-graders-caterpillar-160g",
              "name": "160G",
              "subcategories": []
            },
            {
              "id": "motor-graders-caterpillar-160h",
              "name": "160H",
              "subcategories": []
            },
            {
              "id": "motor-graders-caterpillar-160h-vhp",
              "name": "160H VHP",
              "subcategories": []
            },
            {
              "id": "motor-graders-caterpillar-160h-vhp-plus",
              "name": "160H VHP PLUS",
              "subcategories": []
            },
            {
              "id": "motor-graders-caterpillar-160k",
              "name": "160K",
              "subcategories": []
            },
            {
              "id": "motor-graders-caterpillar-160m",
              "name": "160M",
              "subcategories": []
            },
            {
              "id": "motor-graders-caterpillar-160m-awd",
              "name": "160M AWD",
              "subcategories": []
            },
            {
              "id": "motor-graders-caterpillar-160m-awd-vhp-plus",
              "name": "160M AWD VHP PLUS",
              "subcategories": []
            },
            {
              "id": "motor-graders-caterpillar-160m-vhp-plus",
              "name": "160M VHP PLUS",
              "subcategories": []
            },
            {
              "id": "motor-graders-caterpillar-160m2-awd",
              "name": "160M2 AWD",
              "subcategories": []
            },
            {
              "id": "motor-graders-caterpillar-160m2-vhp-plus",
              "name": "160M2 VHP PLUS",
              "subcategories": []
            },
            {
              "id": "motor-graders-caterpillar-160m3",
              "name": "160M3",
              "subcategories": []
            },
            {
              "id": "motor-graders-caterpillar-160m3-awd",
              "name": "160M3 AWD",
              "subcategories": []
            },
            {
              "id": "motor-graders-caterpillar-163h",
              "name": "163H",
              "subcategories": []
            },
            {
              "id": "motor-graders-caterpillar-163h-vhp-plus",
              "name": "163H VHP PLUS",
              "subcategories": []
            },
            {
              "id": "motor-graders-caterpillar-other",
              "name": "OTHER",
              "subcategories": []
            }
          ]
        },
        {
          "id": "motor-graders-deere",
          "name": "Deere",
          "subcategories": [
            {
              "id": "motor-graders-deere-570",
              "name": "570",
              "subcategories": []
            },
            {
              "id": "motor-graders-deere-570a",
              "name": "570A",
              "subcategories": []
            },
            {
              "id": "motor-graders-deere-570b",
              "name": "570B",
              "subcategories": []
            },
            {
              "id": "motor-graders-deere-620g",
              "name": "620G",
              "subcategories": []
            },
            {
              "id": "motor-graders-deere-620gp",
              "name": "620GP",
              "subcategories": []
            },
            {
              "id": "motor-graders-deere-622g",
              "name": "622G",
              "subcategories": []
            },
            {
              "id": "motor-graders-deere-622gp",
              "name": "622GP",
              "subcategories": []
            },
            {
              "id": "motor-graders-deere-670",
              "name": "670",
              "subcategories": []
            },
            {
              "id": "motor-graders-deere-670a",
              "name": "670A",
              "subcategories": []
            },
            {
              "id": "motor-graders-deere-670b",
              "name": "670B",
              "subcategories": []
            },
            {
              "id": "motor-graders-deere-670c",
              "name": "670C",
              "subcategories": []
            },
            {
              "id": "motor-graders-deere-670c-ii",
              "name": "670C II",
              "subcategories": []
            },
            {
              "id": "motor-graders-deere-670ch",
              "name": "670CH",
              "subcategories": []
            },
            {
              "id": "motor-graders-deere-670chii",
              "name": "670CHII",
              "subcategories": []
            },
            {
              "id": "motor-graders-deere-670d",
              "name": "670D",
              "subcategories": []
            },
            {
              "id": "motor-graders-deere-670g",
              "name": "670G",
              "subcategories": []
            },
            {
              "id": "motor-graders-deere-670gp",
              "name": "670GP",
              "subcategories": []
            },
            {
              "id": "motor-graders-deere-672a",
              "name": "672A",
              "subcategories": []
            },
            {
              "id": "motor-graders-deere-672b",
              "name": "672B",
              "subcategories": []
            },
            {
              "id": "motor-graders-deere-672ch",
              "name": "672CH",
              "subcategories": []
            },
            {
              "id": "motor-graders-deere-672d",
              "name": "672D",
              "subcategories": []
            },
            {
              "id": "motor-graders-deere-672g",
              "name": "672G",
              "subcategories": []
            },
            {
              "id": "motor-graders-deere-672gp",
              "name": "672GP",
              "subcategories": []
            },
            {
              "id": "motor-graders-deere-770",
              "name": "770",
              "subcategories": []
            },
            {
              "id": "motor-graders-deere-770a",
              "name": "770A",
              "subcategories": []
            },
            {
              "id": "motor-graders-deere-770b",
              "name": "770B",
              "subcategories": []
            },
            {
              "id": "motor-graders-deere-770bh",
              "name": "770BH",
              "subcategories": []
            },
            {
              "id": "motor-graders-deere-770c",
              "name": "770C",
              "subcategories": []
            },
            {
              "id": "motor-graders-deere-770ch",
              "name": "770CH",
              "subcategories": []
            },
            {
              "id": "motor-graders-deere-770ch-ii",
              "name": "770CH II",
              "subcategories": []
            },
            {
              "id": "motor-graders-deere-770d",
              "name": "770D",
              "subcategories": []
            },
            {
              "id": "motor-graders-deere-770gp",
              "name": "770GP",
              "subcategories": []
            },
            {
              "id": "motor-graders-deere-770gp",
              "name": "770GP",
              "subcategories": []
            },
            {
              "id": "motor-graders-deere-772",
              "name": "772",
              "subcategories": []
            },
            {
              "id": "motor-graders-deere-772a",
              "name": "772A",
              "subcategories": []
            },
            {
              "id": "motor-graders-deere-772ah",
              "name": "772AH",
              "subcategories": []
            },
            {
              "id": "motor-graders-deere-772b",
              "name": "772B",
              "subcategories": []
            },
            {
              "id": "motor-graders-deere-772bh",
              "name": "772BH",
              "subcategories": []
            },
            {
              "id": "motor-graders-deere-772ch",
              "name": "772CH",
              "subcategories": []
            },
            {
              "id": "motor-graders-deere-772ch-ii",
              "name": "772CH II",
              "subcategories": []
            },
            {
              "id": "motor-graders-deere-772d",
              "name": "772D",
              "subcategories": []
            },
            {
              "id": "motor-graders-deere-772g",
              "name": "772G",
              "subcategories": []
            },
            {
              "id": "motor-graders-deere-772gp",
              "name": "772GP",
              "subcategories": []
            },
            {
              "id": "motor-graders-deere-870d",
              "name": "870D",
              "subcategories": []
            },
            {
              "id": "motor-graders-deere-870g",
              "name": "870G",
              "subcategories": []
            },
            {
              "id": "motor-graders-deere-870gp",
              "name": "870GP",
              "subcategories": []
            },
            {
              "id": "motor-graders-deere-872d",
              "name": "872D",
              "subcategories": []
            },
            {
              "id": "motor-graders-deere-872g",
              "name": "872G",
              "subcategories": []
            },
            {
              "id": "motor-graders-deere-872gp",
              "name": "872GP",
              "subcategories": []
            },
            {
              "id": "motor-graders-deere-other",
              "name": "OTHER",
              "subcategories": []
            }
          ]
        },
        {
          "id": "motor-graders-xcmg",
          "name": "Xcmg",
          "subcategories": [
            {
              "id": "motor-graders-xcmg-gr165",
              "name": "GR165",
              "subcategories": []
            },
            {
              "id": "motor-graders-xcmg-gr180",
              "name": "GR180",
              "subcategories": []
            },
            {
              "id": "motor-graders-xcmg-gr185",
              "name": "GR185",
              "subcategories": []
            },
            {
              "id": "motor-graders-xcmg-gr215",
              "name": "GR215",
              "subcategories": []
            },
            {
              "id": "motor-graders-xcmg-gr1003",
              "name": "GR1003",
              "subcategories": []
            },
            {
              "id": "motor-graders-xcmg-gr1653",
              "name": "GR1653",
              "subcategories": []
            },
            {
              "id": "motor-graders-xcmg-gr1803",
              "name": "GR1803",
              "subcategories": []
            },
            {
              "id": "motor-graders-xcmg-gr1805",
              "name": "GR1805",
              "subcategories": []
            },
            {
              "id": "motor-graders-xcmg-gr1805t3",
              "name": "GR1805T3",
              "subcategories": []
            },
            {
              "id": "motor-graders-xcmg-gr2153",
              "name": "GR2153",
              "subcategories": []
            },
            {
              "id": "motor-graders-xcmg-gr2153a",
              "name": "GR2153A",
              "subcategories": []
            },
            {
              "id": "motor-graders-xcmg-gr2205",
              "name": "GR2205",
              "subcategories": []
            },
            {
              "id": "motor-graders-xcmg-gr2205at",
              "name": "GR2205AT",
              "subcategories": []
            },
            {
              "id": "motor-graders-xcmg-gr2205t",
              "name": "GR2205T",
              "subcategories": []
            },
            {
              "id": "motor-graders-xcmg-gr2405t-pro",
              "name": "GR2405T PRO",
              "subcategories": []
            },
            {
              "id": "motor-graders-xcmg-gr2605",
              "name": "GR2605",
              "subcategories": []
            },
            {
              "id": "motor-graders-xcmg-gr2605at",
              "name": "GR2605AT",
              "subcategories": []
            },
            {
              "id": "motor-graders-xcmg-gr2605t-pro",
              "name": "GR2605T PRO",
              "subcategories": []
            },
            {
              "id": "motor-graders-xcmg-gr2805t-pro",
              "name": "GR2805T PRO",
              "subcategories": []
            },
            {
              "id": "motor-graders-xcmg-gr3005t-pro",
              "name": "GR3005T PRO",
              "subcategories": []
            },
            {
              "id": "motor-graders-xcmg-gr5505t-pro",
              "name": "GR5505T PRO",
              "subcategories": []
            },
            {
              "id": "motor-graders-xcmg-gr35-5t-pro",
              "name": "GR35-5T PRO",
              "subcategories": []
            },
            {
              "id": "motor-graders-xcmg-gr55-5t-pro",
              "name": "GR55-5T PRO",
              "subcategories": []
            },
            {
              "id": "motor-graders-xcmg-other",
              "name": "OTHER",
              "subcategories": []
            }
          ]
        },
        {
          "id": "motor-graders-volvo",
          "name": "Volvo",
          "subcategories": [
            {
              "id": "motor-graders-volvo-730a",
              "name": "730A",
              "subcategories": []
            },
            {
              "id": "motor-graders-volvo-g80",
              "name": "G80",
              "subcategories": []
            },
            {
              "id": "motor-graders-volvo-g86",
              "name": "G86",
              "subcategories": []
            },
            {
              "id": "motor-graders-volvo-g710",
              "name": "G710",
              "subcategories": []
            },
            {
              "id": "motor-graders-volvo-g710b",
              "name": "G710B",
              "subcategories": []
            },
            {
              "id": "motor-graders-volvo-g720-vhp",
              "name": "G720 VHP",
              "subcategories": []
            },
            {
              "id": "motor-graders-volvo-g720b",
              "name": "G720B",
              "subcategories": []
            },
            {
              "id": "motor-graders-volvo-g726b",
              "name": "G726B",
              "subcategories": []
            },
            {
              "id": "motor-graders-volvo-g730-vhp",
              "name": "G730 VHP",
              "subcategories": []
            },
            {
              "id": "motor-graders-volvo-g730b",
              "name": "G730B",
              "subcategories": []
            },
            {
              "id": "motor-graders-volvo-g740-vhp",
              "name": "G740 VHP",
              "subcategories": []
            },
            {
              "id": "motor-graders-volvo-g740b",
              "name": "G740B",
              "subcategories": []
            },
            {
              "id": "motor-graders-volvo-g930",
              "name": "G930",
              "subcategories": []
            },
            {
              "id": "motor-graders-volvo-g930b",
              "name": "G930B",
              "subcategories": []
            },
            {
              "id": "motor-graders-volvo-g940",
              "name": "G940",
              "subcategories": []
            },
            {
              "id": "motor-graders-volvo-g940b",
              "name": "G940B",
              "subcategories": []
            },
            {
              "id": "motor-graders-volvo-g940c",
              "name": "G940C",
              "subcategories": []
            },
            {
              "id": "motor-graders-volvo-g946",
              "name": "G946",
              "subcategories": []
            },
            {
              "id": "motor-graders-volvo-g946b",
              "name": "G946B",
              "subcategories": []
            },
            {
              "id": "motor-graders-volvo-g960",
              "name": "G960",
              "subcategories": []
            },
            {
              "id": "motor-graders-volvo-g960b",
              "name": "G960B",
              "subcategories": []
            },
            {
              "id": "motor-graders-volvo-g970",
              "name": "G970",
              "subcategories": []
            },
            {
              "id": "motor-graders-volvo-g976",
              "name": "G976",
              "subcategories": []
            },
            {
              "id": "motor-graders-volvo-g990",
              "name": "G990",
              "subcategories": []
            },
            {
              "id": "motor-graders-volvo-other",
              "name": "OTHER",
              "subcategories": []
            }
          ]
        },
        {
          "id": "motor-graders-champion",
          "name": "Champion",
          "subcategories": [
            {
              "id": "motor-graders-champion-100t",
              "name": "100T",
              "subcategories": []
            },
            {
              "id": "motor-graders-champion-560",
              "name": "560",
              "subcategories": []
            },
            {
              "id": "motor-graders-champion-562b",
              "name": "562B",
              "subcategories": []
            },
            {
              "id": "motor-graders-champion-710a",
              "name": "710A",
              "subcategories": []
            },
            {
              "id": "motor-graders-champion-710a-iii",
              "name": "710A III",
              "subcategories": []
            },
            {
              "id": "motor-graders-champion-710r",
              "name": "710R",
              "subcategories": []
            },
            {
              "id": "motor-graders-champion-716a",
              "name": "716A",
              "subcategories": []
            },
            {
              "id": "motor-graders-champion-720",
              "name": "720",
              "subcategories": []
            },
            {
              "id": "motor-graders-champion-720a",
              "name": "720A",
              "subcategories": []
            },
            {
              "id": "motor-graders-champion-720a-iii",
              "name": "720A III",
              "subcategories": []
            },
            {
              "id": "motor-graders-champion-720a-vhp",
              "name": "720A VHP",
              "subcategories": []
            },
            {
              "id": "motor-graders-champion-726a",
              "name": "726A",
              "subcategories": []
            },
            {
              "id": "motor-graders-champion-726a-vhp",
              "name": "726A VHP",
              "subcategories": []
            },
            {
              "id": "motor-graders-champion-730a",
              "name": "730A",
              "subcategories": []
            },
            {
              "id": "motor-graders-champion-730a-iii",
              "name": "730A III",
              "subcategories": []
            },
            {
              "id": "motor-graders-champion-740",
              "name": "740",
              "subcategories": []
            },
            {
              "id": "motor-graders-champion-740-iii",
              "name": "740 III",
              "subcategories": []
            },
            {
              "id": "motor-graders-champion-740-iv",
              "name": "740 IV",
              "subcategories": []
            },
            {
              "id": "motor-graders-champion-740a",
              "name": "740A",
              "subcategories": []
            },
            {
              "id": "motor-graders-champion-740a-vhp",
              "name": "740A VHP",
              "subcategories": []
            },
            {
              "id": "motor-graders-champion-760",
              "name": "760",
              "subcategories": []
            },
            {
              "id": "motor-graders-champion-780a-iii",
              "name": "780A III",
              "subcategories": []
            },
            {
              "id": "motor-graders-champion-c70a26",
              "name": "C70A26",
              "subcategories": []
            },
            {
              "id": "motor-graders-champion-c70a27",
              "name": "C70A27",
              "subcategories": []
            },
            {
              "id": "motor-graders-champion-c80c",
              "name": "C80C",
              "subcategories": []
            },
            {
              "id": "motor-graders-champion-d565t",
              "name": "D565T",
              "subcategories": []
            },
            {
              "id": "motor-graders-champion-d715a",
              "name": "D715A",
              "subcategories": []
            },
            {
              "id": "motor-graders-champion-d740",
              "name": "D740",
              "subcategories": []
            },
            {
              "id": "motor-graders-champion-other",
              "name": "OTHER",
              "subcategories": []
            }
          ]
        },
        {
          "id": "motor-graders-komatsu",
          "name": "Komatsu",
          "subcategories": [
            {
              "id": "motor-graders-komatsu-gd511a",
              "name": "GD511A",
              "subcategories": []
            },
            {
              "id": "motor-graders-komatsu-gd511a-1",
              "name": "GD511A-1",
              "subcategories": []
            },
            {
              "id": "motor-graders-komatsu-gd555-3",
              "name": "GD555-3",
              "subcategories": []
            },
            {
              "id": "motor-graders-komatsu-gd555-3a",
              "name": "GD555-3A",
              "subcategories": []
            },
            {
              "id": "motor-graders-komatsu-gd555-5",
              "name": "GD555-5",
              "subcategories": []
            },
            {
              "id": "motor-graders-komatsu-gd623a",
              "name": "GD623A",
              "subcategories": []
            },
            {
              "id": "motor-graders-komatsu-gd623a-1",
              "name": "GD623A-1",
              "subcategories": []
            },
            {
              "id": "motor-graders-komatsu-gd650",
              "name": "GD650",
              "subcategories": []
            },
            {
              "id": "motor-graders-komatsu-gd650a",
              "name": "GD650A",
              "subcategories": []
            },
            {
              "id": "motor-graders-komatsu-gd650a-2cy",
              "name": "GD650A-2CY",
              "subcategories": []
            },
            {
              "id": "motor-graders-komatsu-gd650aw-2cy",
              "name": "GD650AW-2CY",
              "subcategories": []
            },
            {
              "id": "motor-graders-komatsu-gd655",
              "name": "GD655",
              "subcategories": []
            },
            {
              "id": "motor-graders-komatsu-gd655-3",
              "name": "GD655-3",
              "subcategories": []
            },
            {
              "id": "motor-graders-komatsu-gd655-3a",
              "name": "GD655-3A",
              "subcategories": []
            },
            {
              "id": "motor-graders-komatsu-gd655-3e0",
              "name": "GD655-3E0",
              "subcategories": []
            },
            {
              "id": "motor-graders-komatsu-gd655-5",
              "name": "GD655-5",
              "subcategories": []
            },
            {
              "id": "motor-graders-komatsu-gd655-6",
              "name": "GD655-6",
              "subcategories": []
            },
            {
              "id": "motor-graders-komatsu-gd655-7",
              "name": "GD655-7",
              "subcategories": []
            },
            {
              "id": "motor-graders-komatsu-gd663a-2",
              "name": "GD663A-2",
              "subcategories": []
            },
            {
              "id": "motor-graders-komatsu-gd670a-2cy",
              "name": "GD670A-2CY",
              "subcategories": []
            },
            {
              "id": "motor-graders-komatsu-gd675-5",
              "name": "GD675-5",
              "subcategories": []
            },
            {
              "id": "motor-graders-komatsu-gd705-5",
              "name": "GD705-5",
              "subcategories": []
            },
            {
              "id": "motor-graders-komatsu-gd705a",
              "name": "GD705A",
              "subcategories": []
            },
            {
              "id": "motor-graders-komatsu-gd705a-2",
              "name": "GD705A-2",
              "subcategories": []
            },
            {
              "id": "motor-graders-komatsu-gd825",
              "name": "GD825",
              "subcategories": []
            },
            {
              "id": "motor-graders-komatsu-gd825a-2",
              "name": "GD825A-2",
              "subcategories": []
            },
            {
              "id": "motor-graders-komatsu-gd955-7",
              "name": "GD955-7",
              "subcategories": []
            },
            {
              "id": "motor-graders-komatsu-other",
              "name": "OTHER",
              "subcategories": []
            }
          ]
        },
        {
          "id": "motor-graders-uhi",
          "name": "Uhi",
          "subcategories": [
            {
              "id": "motor-graders-uhi-sg15",
              "name": "SG15",
              "subcategories": []
            },
            {
              "id": "motor-graders-uhi-sg17",
              "name": "SG17",
              "subcategories": []
            },
            {
              "id": "motor-graders-uhi-sg19",
              "name": "SG19",
              "subcategories": []
            },
            {
              "id": "motor-graders-uhi-sg21",
              "name": "SG21",
              "subcategories": []
            },
            {
              "id": "motor-graders-uhi-other",
              "name": "OTHER",
              "subcategories": []
            }
          ]
        },
        {
          "id": "motor-graders-sany",
          "name": "Sany",
          "subcategories": [
            {
              "id": "motor-graders-sany-smg200",
              "name": "SMG200",
              "subcategories": []
            },
            {
              "id": "motor-graders-sany-smg200-c-8",
              "name": "SMG200-C-8",
              "subcategories": []
            },
            {
              "id": "motor-graders-sany-smg200awd",
              "name": "SMG200AWD",
              "subcategories": []
            },
            {
              "id": "motor-graders-sany-stg190-8s",
              "name": "STG190-8S",
              "subcategories": []
            },
            {
              "id": "motor-graders-sany-stg230c-10s",
              "name": "STG230C-10S",
              "subcategories": []
            },
            {
              "id": "motor-graders-sany-stg335c-10",
              "name": "STG335C-10",
              "subcategories": []
            },
            {
              "id": "motor-graders-sany-other",
              "name": "OTHER",
              "subcategories": []
            }
          ]
        },
        {
          "id": "motor-graders-leeboy",
          "name": "Leeboy",
          "subcategories": [
            {
              "id": "motor-graders-leeboy-685",
              "name": "685",
              "subcategories": []
            },
            {
              "id": "motor-graders-leeboy-685b",
              "name": "685B",
              "subcategories": []
            },
            {
              "id": "motor-graders-leeboy-385c",
              "name": "385C",
              "subcategories": []
            },
            {
              "id": "motor-graders-leeboy-685d",
              "name": "685D",
              "subcategories": []
            },
            {
              "id": "motor-graders-leeboy-695",
              "name": "695",
              "subcategories": []
            },
            {
              "id": "motor-graders-leeboy-695b",
              "name": "695B",
              "subcategories": []
            },
            {
              "id": "motor-graders-leeboy-g220",
              "name": "G220",
              "subcategories": []
            },
            {
              "id": "motor-graders-leeboy-g700",
              "name": "G700",
              "subcategories": []
            },
            {
              "id": "motor-graders-leeboy-g700b",
              "name": "G700B",
              "subcategories": []
            },
            {
              "id": "motor-graders-leeboy-other",
              "name": "OTHER",
              "subcategories": []
            }
          ]
        },
        {
          "id": "motor-graders-sem",
          "name": "Sem",
          "subcategories": [
            {
              "id": "motor-graders-sem-919",
              "name": "919",
              "subcategories": []
            },
            {
              "id": "motor-graders-sem-919f",
              "name": "919F",
              "subcategories": []
            },
            {
              "id": "motor-graders-sem-920f",
              "name": "920F",
              "subcategories": []
            },
            {
              "id": "motor-graders-sem-922f",
              "name": "922F",
              "subcategories": []
            },
            {
              "id": "motor-graders-sem-other",
              "name": "OTHER",
              "subcategories": []
            }
          ]
        },
        {
          "id": "motor-graders-case",
          "name": "Case",
          "subcategories": [
            {
              "id": "motor-graders-case-836c",
              "name": "836C",
              "subcategories": []
            },
            {
              "id": "motor-graders-case-836c-awd-vhp",
              "name": "836C AWD VHP",
              "subcategories": []
            },
            {
              "id": "motor-graders-case-836d",
              "name": "836D",
              "subcategories": []
            },
            {
              "id": "motor-graders-case-856c",
              "name": "856C",
              "subcategories": []
            },
            {
              "id": "motor-graders-case-856c-awd-vhp",
              "name": "856C AWD VHP",
              "subcategories": []
            },
            {
              "id": "motor-graders-case-865",
              "name": "865",
              "subcategories": []
            },
            {
              "id": "motor-graders-case-865b",
              "name": "865B",
              "subcategories": []
            },
            {
              "id": "motor-graders-case-865b-vhp",
              "name": "865B VHP",
              "subcategories": []
            },
            {
              "id": "motor-graders-case-865c",
              "name": "865C",
              "subcategories": []
            },
            {
              "id": "motor-graders-case-885",
              "name": "885",
              "subcategories": []
            },
            {
              "id": "motor-graders-case-885b",
              "name": "885B",
              "subcategories": []
            },
            {
              "id": "motor-graders-case-other",
              "name": "OTHER",
              "subcategories": []
            }
          ]
        },
        {
          "id": "motor-graders-new-holland",
          "name": "New Holland",
          "subcategories": [
            {
              "id": "motor-graders-new-holland-f106-6",
              "name": "F106.6",
              "subcategories": []
            },
            {
              "id": "motor-graders-new-holland-f106-6a",
              "name": "F106.6A",
              "subcategories": []
            },
            {
              "id": "motor-graders-new-holland-f156-6",
              "name": "F156.6",
              "subcategories": []
            },
            {
              "id": "motor-graders-new-holland-f156-6a",
              "name": "F156.6A",
              "subcategories": []
            },
            {
              "id": "motor-graders-new-holland-f156-7a",
              "name": "F156.7A",
              "subcategories": []
            },
            {
              "id": "motor-graders-new-holland-rg100",
              "name": "RG100",
              "subcategories": []
            },
            {
              "id": "motor-graders-new-holland-rg170",
              "name": "RG170",
              "subcategories": []
            },
            {
              "id": "motor-graders-new-holland-other",
              "name": "OTHER",
              "subcategories": []
            }
          ]
        },
        {
          "id": "motor-graders-noram",
          "name": "Noram",
          "subcategories": [
            {
              "id": "motor-graders-noram-65e",
              "name": "65E",
              "subcategories": []
            },
            {
              "id": "motor-graders-noram-65et",
              "name": "65ET",
              "subcategories": []
            },
            {
              "id": "motor-graders-noram-85e",
              "name": "85E",
              "subcategories": []
            },
            {
              "id": "motor-graders-noram-85et",
              "name": "85ET",
              "subcategories": []
            }
          ]
        },
        {
          "id": "motor-graders-galion",
          "name": "Galion",
          "subcategories": [
            {
              "id": "motor-graders-galion-104b",
              "name": "104B",
              "subcategories": []
            },
            {
              "id": "motor-graders-galion-118c",
              "name": "118C",
              "subcategories": []
            },
            {
              "id": "motor-graders-galion-303",
              "name": "303",
              "subcategories": []
            },
            {
              "id": "motor-graders-galion-503",
              "name": "503",
              "subcategories": []
            },
            {
              "id": "motor-graders-galion-503a",
              "name": "503A",
              "subcategories": []
            },
            {
              "id": "motor-graders-galion-503h",
              "name": "503H",
              "subcategories": []
            },
            {
              "id": "motor-graders-galion-830",
              "name": "830",
              "subcategories": []
            },
            {
              "id": "motor-graders-galion-830b",
              "name": "830B",
              "subcategories": []
            },
            {
              "id": "motor-graders-galion-850",
              "name": "850",
              "subcategories": []
            },
            {
              "id": "motor-graders-galion-850c",
              "name": "850C",
              "subcategories": []
            },
            {
              "id": "motor-graders-galion-850rl",
              "name": "850RL",
              "subcategories": []
            },
            {
              "id": "motor-graders-galion-870c",
              "name": "870C",
              "subcategories": []
            },
            {
              "id": "motor-graders-galion-a450e",
              "name": "A450E",
              "subcategories": []
            },
            {
              "id": "motor-graders-galion-a500",
              "name": "A500",
              "subcategories": []
            },
            {
              "id": "motor-graders-galion-t500",
              "name": "T500",
              "subcategories": []
            },
            {
              "id": "motor-graders-galion-t500a",
              "name": "T500A",
              "subcategories": []
            },
            {
              "id": "motor-graders-galion-t500c",
              "name": "T500C",
              "subcategories": []
            },
            {
              "id": "motor-graders-galion-t500d",
              "name": "T500D",
              "subcategories": []
            },
            {
              "id": "motor-graders-galion-t500l",
              "name": "T500L",
              "subcategories": []
            },
            {
              "id": "motor-graders-galion-t500m",
              "name": "T500M",
              "subcategories": []
            },
            {
              "id": "motor-graders-galion-other",
              "name": "OTHER",
              "subcategories": []
            }
          ]
        }
      ]
    },
    {
      "id": "scraper",
      "name": "Scraper",
      "subcategories": [
        {
          "id": "scraper-scrapers",
          "name": "Scrapers",
          "subcategories": [
            {
              "id": "scraper-scrapers-caterpillar",
              "name": "CATERPILLAR",
              "subcategories": []
            },
            {
              "id": "scraper-scrapers-k-tec",
              "name": "K-TEC",
              "subcategories": []
            },
            {
              "id": "scraper-scrapers-ashland",
              "name": "ASHLAND",
              "subcategories": []
            },
            {
              "id": "scraper-scrapers-deere",
              "name": "DEERE",
              "subcategories": []
            },
            {
              "id": "scraper-scrapers-reynolds",
              "name": "REYNOLDS",
              "subcategories": []
            },
            {
              "id": "scraper-scrapers-rome",
              "name": "ROME",
              "subcategories": []
            },
            {
              "id": "scraper-scrapers-orthman",
              "name": "ORTHMAN",
              "subcategories": []
            },
            {
              "id": "scraper-scrapers-mobile-track-solutions",
              "name": "MOBILE TRACK SOLUTIONS",
              "subcategories": []
            },
            {
              "id": "scraper-scrapers-rowse",
              "name": "ROWSE",
              "subcategories": []
            },
            {
              "id": "scraper-scrapers-toreq",
              "name": "TOREQ",
              "subcategories": []
            },
            {
              "id": "scraper-scrapers-big-dog",
              "name": "BIG DOG",
              "subcategories": []
            },
            {
              "id": "scraper-scrapers-durabilt",
              "name": "DURABILT",
              "subcategories": []
            },
            {
              "id": "scraper-scrapers-eversman",
              "name": "EVERSMAN",
              "subcategories": []
            },
            {
              "id": "scraper-scrapers-garfield",
              "name": "GARFIELD",
              "subcategories": []
            },
            {
              "id": "scraper-scrapers-holcomb",
              "name": "HOLCOMB",
              "subcategories": []
            },
            {
              "id": "scraper-scrapers-humdinger",
              "name": "HUMDINGER",
              "subcategories": []
            },
            {
              "id": "scraper-scrapers-icon",
              "name": "ICON",
              "subcategories": []
            },
            {
              "id": "scraper-scrapers-landoll-icon",
              "name": "LANDOLL ICON",
              "subcategories": []
            },
            {
              "id": "scraper-scrapers-noble",
              "name": "NOBLE",
              "subcategories": []
            },
            {
              "id": "scraper-scrapers-terex",
              "name": "TEREX",
              "subcategories": []
            }
          ]
        },
        {
          "id": "scraper-caterpillar",
          "name": "Caterpillar",
          "subcategories": [
            {
              "id": "scraper-caterpillar-40",
              "name": "40",
              "subcategories": []
            },
            {
              "id": "scraper-caterpillar-60",
              "name": "60",
              "subcategories": []
            },
            {
              "id": "scraper-caterpillar-70",
              "name": "70",
              "subcategories": []
            },
            {
              "id": "scraper-caterpillar-80",
              "name": "80",
              "subcategories": []
            },
            {
              "id": "scraper-caterpillar-463",
              "name": "463",
              "subcategories": []
            },
            {
              "id": "scraper-caterpillar-613",
              "name": "613",
              "subcategories": []
            },
            {
              "id": "scraper-caterpillar-613a",
              "name": "613A",
              "subcategories": []
            },
            {
              "id": "scraper-caterpillar-613b",
              "name": "613B",
              "subcategories": []
            },
            {
              "id": "scraper-caterpillar-613c",
              "name": "613C",
              "subcategories": []
            },
            {
              "id": "scraper-caterpillar-613c-ii",
              "name": "613C II",
              "subcategories": []
            },
            {
              "id": "scraper-caterpillar-615",
              "name": "615",
              "subcategories": []
            },
            {
              "id": "scraper-caterpillar-615c",
              "name": "615C",
              "subcategories": []
            },
            {
              "id": "scraper-caterpillar-615c-ii",
              "name": "615C II",
              "subcategories": []
            },
            {
              "id": "scraper-caterpillar-621",
              "name": "621",
              "subcategories": []
            },
            {
              "id": "scraper-caterpillar-621b",
              "name": "621B",
              "subcategories": []
            },
            {
              "id": "scraper-caterpillar-621e",
              "name": "621E",
              "subcategories": []
            },
            {
              "id": "scraper-caterpillar-621f",
              "name": "621F",
              "subcategories": []
            },
            {
              "id": "scraper-caterpillar-621g",
              "name": "621G",
              "subcategories": []
            },
            {
              "id": "scraper-caterpillar-621h",
              "name": "621H",
              "subcategories": []
            },
            {
              "id": "scraper-caterpillar-621k",
              "name": "621K",
              "subcategories": []
            },
            {
              "id": "scraper-caterpillar-623",
              "name": "623",
              "subcategories": []
            },
            {
              "id": "scraper-caterpillar-623b",
              "name": "623B",
              "subcategories": []
            },
            {
              "id": "scraper-caterpillar-623e",
              "name": "623E",
              "subcategories": []
            },
            {
              "id": "scraper-caterpillar-623f",
              "name": "623F",
              "subcategories": []
            },
            {
              "id": "scraper-caterpillar-623f-ii",
              "name": "623F II",
              "subcategories": []
            },
            {
              "id": "scraper-caterpillar-623g",
              "name": "623G",
              "subcategories": []
            },
            {
              "id": "scraper-caterpillar-623h",
              "name": "623H",
              "subcategories": []
            },
            {
              "id": "scraper-caterpillar-623k",
              "name": "623K",
              "subcategories": []
            },
            {
              "id": "scraper-caterpillar-627",
              "name": "627",
              "subcategories": []
            },
            {
              "id": "scraper-caterpillar-627b",
              "name": "627B",
              "subcategories": []
            },
            {
              "id": "scraper-caterpillar-627e",
              "name": "627E",
              "subcategories": []
            },
            {
              "id": "scraper-caterpillar-627f",
              "name": "627F",
              "subcategories": []
            },
            {
              "id": "scraper-caterpillar-627g",
              "name": "627G",
              "subcategories": []
            },
            {
              "id": "scraper-caterpillar-627h",
              "name": "627H",
              "subcategories": []
            },
            {
              "id": "scraper-caterpillar-627k",
              "name": "627K",
              "subcategories": []
            },
            {
              "id": "scraper-caterpillar-631",
              "name": "631",
              "subcategories": []
            },
            {
              "id": "scraper-caterpillar-631b",
              "name": "631B",
              "subcategories": []
            },
            {
              "id": "scraper-caterpillar-631c",
              "name": "631C",
              "subcategories": []
            },
            {
              "id": "scraper-caterpillar-631d",
              "name": "631D",
              "subcategories": []
            },
            {
              "id": "scraper-caterpillar-631e",
              "name": "631E",
              "subcategories": []
            },
            {
              "id": "scraper-caterpillar-631e-ii",
              "name": "631E II",
              "subcategories": []
            },
            {
              "id": "scraper-caterpillar-631f",
              "name": "631F",
              "subcategories": []
            },
            {
              "id": "scraper-caterpillar-631g",
              "name": "631G",
              "subcategories": []
            },
            {
              "id": "scraper-caterpillar-631k",
              "name": "631K",
              "subcategories": []
            },
            {
              "id": "scraper-caterpillar-633",
              "name": "633",
              "subcategories": []
            },
            {
              "id": "scraper-caterpillar-633c",
              "name": "633C",
              "subcategories": []
            },
            {
              "id": "scraper-caterpillar-633d",
              "name": "633D",
              "subcategories": []
            },
            {
              "id": "scraper-caterpillar-637",
              "name": "637",
              "subcategories": []
            },
            {
              "id": "scraper-caterpillar-637c",
              "name": "637C",
              "subcategories": []
            },
            {
              "id": "scraper-caterpillar-637d",
              "name": "637D",
              "subcategories": []
            },
            {
              "id": "scraper-caterpillar-637e",
              "name": "637E",
              "subcategories": []
            },
            {
              "id": "scraper-caterpillar-637g",
              "name": "637G",
              "subcategories": []
            },
            {
              "id": "scraper-caterpillar-637k",
              "name": "637K",
              "subcategories": []
            },
            {
              "id": "scraper-caterpillar-641",
              "name": "641",
              "subcategories": []
            },
            {
              "id": "scraper-caterpillar-641b",
              "name": "641B",
              "subcategories": []
            },
            {
              "id": "scraper-caterpillar-651",
              "name": "651",
              "subcategories": []
            },
            {
              "id": "scraper-caterpillar-651b",
              "name": "651B",
              "subcategories": []
            },
            {
              "id": "scraper-caterpillar-651e",
              "name": "651E",
              "subcategories": []
            },
            {
              "id": "scraper-caterpillar-657",
              "name": "657",
              "subcategories": []
            },
            {
              "id": "scraper-caterpillar-dw20",
              "name": "DW20",
              "subcategories": []
            },
            {
              "id": "scraper-caterpillar-other",
              "name": "OTHER",
              "subcategories": []
            }
          ]
        },
        {
          "id": "scraper-k-tec",
          "name": "K-Tec",
          "subcategories": [
            {
              "id": "scraper-k-tec-1030",
              "name": "1030",
              "subcategories": []
            },
            {
              "id": "scraper-k-tec-1228",
              "name": "1228",
              "subcategories": []
            },
            {
              "id": "scraper-k-tec-1228-train",
              "name": "1228 TRAIN",
              "subcategories": []
            },
            {
              "id": "scraper-k-tec-1228-adt",
              "name": "1228 ADT",
              "subcategories": []
            },
            {
              "id": "scraper-k-tec-1230",
              "name": "1230",
              "subcategories": []
            },
            {
              "id": "scraper-k-tec-1233",
              "name": "1233",
              "subcategories": []
            },
            {
              "id": "scraper-k-tec-1233-adt",
              "name": "1233 ADT",
              "subcategories": []
            },
            {
              "id": "scraper-k-tec-1233-train",
              "name": "1233 TRAIN",
              "subcategories": []
            },
            {
              "id": "scraper-k-tec-1236",
              "name": "1236",
              "subcategories": []
            },
            {
              "id": "scraper-k-tec-1237",
              "name": "1237",
              "subcategories": []
            },
            {
              "id": "scraper-k-tec-1237-adt",
              "name": "1237 ADT",
              "subcategories": []
            },
            {
              "id": "scraper-k-tec-1243",
              "name": "1243",
              "subcategories": []
            },
            {
              "id": "scraper-k-tec-1243-adt",
              "name": "1243 ADT",
              "subcategories": []
            },
            {
              "id": "scraper-k-tec-1613",
              "name": "1613",
              "subcategories": []
            },
            {
              "id": "scraper-k-tec-2016-flex",
              "name": "2016 FLEX",
              "subcategories": []
            },
            {
              "id": "scraper-k-tec-2822",
              "name": "2822",
              "subcategories": []
            },
            {
              "id": "scraper-k-tec-3100",
              "name": "3100",
              "subcategories": []
            },
            {
              "id": "scraper-k-tec-rl12",
              "name": "RL12",
              "subcategories": []
            },
            {
              "id": "scraper-k-tec-other",
              "name": "OTHER",
              "subcategories": []
            }
          ]
        },
        {
          "id": "scraper-ashland",
          "name": "Ashland",
          "subcategories": [
            {
              "id": "scraper-ashland-35",
              "name": "35",
              "subcategories": []
            },
            {
              "id": "scraper-ashland-50",
              "name": "50",
              "subcategories": []
            },
            {
              "id": "scraper-ashland-61",
              "name": "61",
              "subcategories": []
            },
            {
              "id": "scraper-ashland-140",
              "name": "140",
              "subcategories": []
            },
            {
              "id": "scraper-ashland-155",
              "name": "155",
              "subcategories": []
            },
            {
              "id": "scraper-ashland-175",
              "name": "175",
              "subcategories": []
            },
            {
              "id": "scraper-ashland-220",
              "name": "220",
              "subcategories": []
            },
            {
              "id": "scraper-ashland-500",
              "name": "500",
              "subcategories": []
            },
            {
              "id": "scraper-ashland-950",
              "name": "950",
              "subcategories": []
            },
            {
              "id": "scraper-ashland-1410",
              "name": "1410",
              "subcategories": []
            },
            {
              "id": "scraper-ashland-1509",
              "name": "1509",
              "subcategories": []
            },
            {
              "id": "scraper-ashland-1812",
              "name": "1812",
              "subcategories": []
            },
            {
              "id": "scraper-ashland-2012",
              "name": "2012",
              "subcategories": []
            },
            {
              "id": "scraper-ashland-2114",
              "name": "2114",
              "subcategories": []
            },
            {
              "id": "scraper-ashland-2311",
              "name": "2311",
              "subcategories": []
            },
            {
              "id": "scraper-ashland-2411",
              "name": "2411",
              "subcategories": []
            },
            {
              "id": "scraper-ashland-2811",
              "name": "2811",
              "subcategories": []
            },
            {
              "id": "scraper-ashland-3013",
              "name": "3013",
              "subcategories": []
            },
            {
              "id": "scraper-ashland-3250",
              "name": "3250",
              "subcategories": []
            },
            {
              "id": "scraper-ashland-3413",
              "name": "3413",
              "subcategories": []
            },
            {
              "id": "scraper-ashland-b300",
              "name": "B300",
              "subcategories": []
            },
            {
              "id": "scraper-ashland-cs18",
              "name": "CS18",
              "subcategories": []
            },
            {
              "id": "scraper-ashland-i-100",
              "name": "I-100",
              "subcategories": []
            },
            {
              "id": "scraper-ashland-i-130",
              "name": "I-130",
              "subcategories": []
            },
            {
              "id": "scraper-ashland-i-140",
              "name": "I-140",
              "subcategories": []
            },
            {
              "id": "scraper-ashland-i-155",
              "name": "I-155",
              "subcategories": []
            },
            {
              "id": "scraper-ashland-i-180",
              "name": "I-180",
              "subcategories": []
            },
            {
              "id": "scraper-ashland-i-900",
              "name": "I-900",
              "subcategories": []
            },
            {
              "id": "scraper-ashland-i-950",
              "name": "I-950",
              "subcategories": []
            },
            {
              "id": "scraper-ashland-other",
              "name": "OTHER",
              "subcategories": []
            }
          ]
        },
        {
          "id": "scraper-deere",
          "name": "Deere",
          "subcategories": [
            {
              "id": "scraper-deere-650",
              "name": "650",
              "subcategories": []
            },
            {
              "id": "scraper-deere-700",
              "name": "700",
              "subcategories": []
            },
            {
              "id": "scraper-deere-760",
              "name": "760",
              "subcategories": []
            },
            {
              "id": "scraper-deere-760a",
              "name": "760A",
              "subcategories": []
            },
            {
              "id": "scraper-deere-762",
              "name": "762",
              "subcategories": []
            },
            {
              "id": "scraper-deere-762a",
              "name": "762A",
              "subcategories": []
            },
            {
              "id": "scraper-deere-762b",
              "name": "762B",
              "subcategories": []
            },
            {
              "id": "scraper-deere-762b-ii",
              "name": "762B II",
              "subcategories": []
            },
            {
              "id": "scraper-deere-840",
              "name": "840",
              "subcategories": []
            },
            {
              "id": "scraper-deere-860",
              "name": "860",
              "subcategories": []
            },
            {
              "id": "scraper-deere-860a",
              "name": "860A",
              "subcategories": []
            },
            {
              "id": "scraper-deere-862",
              "name": "862",
              "subcategories": []
            },
            {
              "id": "scraper-deere-862b",
              "name": "862B",
              "subcategories": []
            },
            {
              "id": "scraper-deere-862b-ii",
              "name": "862B II",
              "subcategories": []
            },
            {
              "id": "scraper-deere-1312",
              "name": "1312",
              "subcategories": []
            },
            {
              "id": "scraper-deere-1312c",
              "name": "1312C",
              "subcategories": []
            },
            {
              "id": "scraper-deere-1510",
              "name": "1510",
              "subcategories": []
            },
            {
              "id": "scraper-deere-1510c",
              "name": "1510C",
              "subcategories": []
            },
            {
              "id": "scraper-deere-1510dc",
              "name": "1510DC",
              "subcategories": []
            },
            {
              "id": "scraper-deere-1512",
              "name": "1512",
              "subcategories": []
            },
            {
              "id": "scraper-deere-1612",
              "name": "1612",
              "subcategories": []
            },
            {
              "id": "scraper-deere-1612de",
              "name": "1612DE",
              "subcategories": []
            },
            {
              "id": "scraper-deere-1810",
              "name": "1810",
              "subcategories": []
            },
            {
              "id": "scraper-deere-1810e",
              "name": "1810E",
              "subcategories": []
            },
            {
              "id": "scraper-deere-1812",
              "name": "1812",
              "subcategories": []
            },
            {
              "id": "scraper-deere-1812c",
              "name": "1812C",
              "subcategories": []
            },
            {
              "id": "scraper-deere-1812dc",
              "name": "1812DC",
              "subcategories": []
            },
            {
              "id": "scraper-deere-1814",
              "name": "1814",
              "subcategories": []
            },
            {
              "id": "scraper-deere-1814c",
              "name": "1814C",
              "subcategories": []
            },
            {
              "id": "scraper-deere-2010",
              "name": "2010",
              "subcategories": []
            },
            {
              "id": "scraper-deere-2010de",
              "name": "2010DE",
              "subcategories": []
            },
            {
              "id": "scraper-deere-2112",
              "name": "2112",
              "subcategories": []
            },
            {
              "id": "scraper-deere-2112c",
              "name": "2112C",
              "subcategories": []
            },
            {
              "id": "scraper-deere-2112dc",
              "name": "2112DC",
              "subcategories": []
            },
            {
              "id": "scraper-deere-2112e",
              "name": "2112E",
              "subcategories": []
            },
            {
              "id": "scraper-deere-2412",
              "name": "2412",
              "subcategories": []
            },
            {
              "id": "scraper-deere-2412de",
              "name": "2412DE",
              "subcategories": []
            },
            {
              "id": "scraper-deere-2412e",
              "name": "2412E",
              "subcategories": []
            },
            {
              "id": "scraper-deere-other",
              "name": "OTHER",
              "subcategories": []
            }
          ]
        },
        {
          "id": "scraper-reynolds",
          "name": "Reynolds",
          "subcategories": [
            {
              "id": "scraper-reynolds-6c",
              "name": "6C",
              "subcategories": []
            },
            {
              "id": "scraper-reynolds-8c",
              "name": "8C",
              "subcategories": []
            },
            {
              "id": "scraper-reynolds-8tf",
              "name": "8TF",
              "subcategories": []
            },
            {
              "id": "scraper-reynolds-9c",
              "name": "9C",
              "subcategories": []
            },
            {
              "id": "scraper-reynolds-9cb",
              "name": "9CB",
              "subcategories": []
            },
            {
              "id": "scraper-reynolds-10c",
              "name": "10C",
              "subcategories": []
            },
            {
              "id": "scraper-reynolds-10p",
              "name": "10P",
              "subcategories": []
            },
            {
              "id": "scraper-reynolds-12c",
              "name": "12C",
              "subcategories": []
            },
            {
              "id": "scraper-reynolds-12c10",
              "name": "12C10",
              "subcategories": []
            },
            {
              "id": "scraper-reynolds-12c12",
              "name": "12C12",
              "subcategories": []
            },
            {
              "id": "scraper-reynolds-12cfbr",
              "name": "12CFBR",
              "subcategories": []
            },
            {
              "id": "scraper-reynolds-12cr",
              "name": "12CR",
              "subcategories": []
            },
            {
              "id": "scraper-reynolds-12p",
              "name": "12P",
              "subcategories": []
            },
            {
              "id": "scraper-reynolds-12-5",
              "name": "12.5",
              "subcategories": []
            },
            {
              "id": "scraper-reynolds-13p",
              "name": "13P",
              "subcategories": []
            },
            {
              "id": "scraper-reynolds-14c",
              "name": "14C",
              "subcategories": []
            },
            {
              "id": "scraper-reynolds-14c10-lgp",
              "name": "14C10 LGP",
              "subcategories": []
            },
            {
              "id": "scraper-reynolds-14e",
              "name": "14E",
              "subcategories": []
            },
            {
              "id": "scraper-reynolds-15c",
              "name": "15C",
              "subcategories": []
            },
            {
              "id": "scraper-reynolds-15-5",
              "name": "15.5",
              "subcategories": []
            },
            {
              "id": "scraper-reynolds-16c",
              "name": "16C",
              "subcategories": []
            },
            {
              "id": "scraper-reynolds-16e",
              "name": "16E",
              "subcategories": []
            },
            {
              "id": "scraper-reynolds-17c",
              "name": "17C",
              "subcategories": []
            },
            {
              "id": "scraper-reynolds-17e",
              "name": "17E",
              "subcategories": []
            },
            {
              "id": "scraper-reynolds-18c",
              "name": "18C",
              "subcategories": []
            },
            {
              "id": "scraper-reynolds-20e",
              "name": "20E",
              "subcategories": []
            },
            {
              "id": "scraper-reynolds-484",
              "name": "484",
              "subcategories": []
            },
            {
              "id": "scraper-reynolds-672a",
              "name": "672A",
              "subcategories": []
            },
            {
              "id": "scraper-reynolds-c14e",
              "name": "C14E",
              "subcategories": []
            },
            {
              "id": "scraper-reynolds-lse12",
              "name": "LSE12",
              "subcategories": []
            },
            {
              "id": "scraper-reynolds-other",
              "name": "OTHER",
              "subcategories": []
            }
          ]
        },
        {
          "id": "scraper-rome",
          "name": "Rome",
          "subcategories": [
            {
              "id": "scraper-rome-14c",
              "name": "14C",
              "subcategories": []
            },
            {
              "id": "scraper-rome-18e14-5",
              "name": "18E14.5",
              "subcategories": []
            },
            {
              "id": "scraper-rome-ag12",
              "name": "AG12",
              "subcategories": []
            },
            {
              "id": "scraper-rome-c14",
              "name": "C14",
              "subcategories": []
            },
            {
              "id": "scraper-rome-gk12",
              "name": "GK12",
              "subcategories": []
            },
            {
              "id": "scraper-rome-gk16",
              "name": "GK16",
              "subcategories": []
            },
            {
              "id": "scraper-rome-gkcsp10",
              "name": "GKCSP10",
              "subcategories": []
            },
            {
              "id": "scraper-rome-gkcsp16",
              "name": "GKCSP16",
              "subcategories": []
            },
            {
              "id": "scraper-rome-pg12",
              "name": "PG12",
              "subcategories": []
            },
            {
              "id": "scraper-rome-pg16",
              "name": "PG16",
              "subcategories": []
            },
            {
              "id": "scraper-rome-r56h",
              "name": "R56H",
              "subcategories": []
            },
            {
              "id": "scraper-rome-rafs20",
              "name": "RAFS20",
              "subcategories": []
            },
            {
              "id": "scraper-rome-rafs20ep",
              "name": "RAFS20EP",
              "subcategories": []
            },
            {
              "id": "scraper-rome-rafs24",
              "name": "RAFS24",
              "subcategories": []
            },
            {
              "id": "scraper-rome-rafs24ep",
              "name": "RAFS24EP",
              "subcategories": []
            },
            {
              "id": "scraper-rome-rals16",
              "name": "RALS16",
              "subcategories": []
            },
            {
              "id": "scraper-rome-ralse16",
              "name": "RALSE16",
              "subcategories": []
            },
            {
              "id": "scraper-rome-rc150",
              "name": "RC150",
              "subcategories": []
            },
            {
              "id": "scraper-rome-rls10",
              "name": "RLS10",
              "subcategories": []
            },
            {
              "id": "scraper-rome-rls12",
              "name": "RLS12",
              "subcategories": []
            },
            {
              "id": "scraper-rome-rls14",
              "name": "RLS14",
              "subcategories": []
            },
            {
              "id": "scraper-rome-rls16",
              "name": "RLS16",
              "subcategories": []
            },
            {
              "id": "scraper-rome-rls18",
              "name": "RLS18",
              "subcategories": []
            },
            {
              "id": "scraper-rome-rp16e14",
              "name": "RP16E14",
              "subcategories": []
            },
            {
              "id": "scraper-rome-rp17-5e14",
              "name": "RP17.5E14",
              "subcategories": []
            },
            {
              "id": "scraper-rome-rp18",
              "name": "RP18",
              "subcategories": []
            },
            {
              "id": "scraper-rome-rp90",
              "name": "RP90",
              "subcategories": []
            },
            {
              "id": "scraper-rome-rp120",
              "name": "RP120",
              "subcategories": []
            },
            {
              "id": "scraper-rome-rp150",
              "name": "RP150",
              "subcategories": []
            },
            {
              "id": "scraper-rome-rp175",
              "name": "RP175",
              "subcategories": []
            },
            {
              "id": "scraper-rome-rp180",
              "name": "RP180",
              "subcategories": []
            },
            {
              "id": "scraper-rome-rp190",
              "name": "RP190",
              "subcategories": []
            },
            {
              "id": "scraper-rome-rp212hde",
              "name": "RP212HDE",
              "subcategories": []
            },
            {
              "id": "scraper-rome-rp21e15",
              "name": "RP21E15",
              "subcategories": []
            },
            {
              "id": "scraper-rome-rp2412hde",
              "name": "RP2412HDE",
              "subcategories": []
            },
            {
              "id": "scraper-rome-rp2812hde",
              "name": "RP2812HDE",
              "subcategories": []
            },
            {
              "id": "scraper-rome-p3612hde",
              "name": "P3612HDE",
              "subcategories": []
            },
            {
              "id": "scraper-rome-other",
              "name": "OTHER",
              "subcategories": []
            }
          ]
        },
        {
          "id": "scraper-orthman",
          "name": "Orthman",
          "subcategories": [
            {
              "id": "scraper-orthman-ps",
              "name": "PS",
              "subcategories": []
            },
            {
              "id": "scraper-orthman-sm50",
              "name": "SM50",
              "subcategories": []
            },
            {
              "id": "scraper-orthman-sm850",
              "name": "SM850",
              "subcategories": []
            },
            {
              "id": "scraper-orthman-soilmover-10",
              "name": "SOILMOVER 10",
              "subcategories": []
            },
            {
              "id": "scraper-orthman-soilmover-10ro",
              "name": "SOILMOVER 10RO",
              "subcategories": []
            },
            {
              "id": "scraper-orthman-soilmover-15ro",
              "name": "SOILMOVER 15RO",
              "subcategories": []
            },
            {
              "id": "scraper-orthman-soilmover-21r",
              "name": "SOILMOVER 21R",
              "subcategories": []
            },
            {
              "id": "scraper-orthman-soilmover-25r",
              "name": "SOILMOVER 25R",
              "subcategories": []
            },
            {
              "id": "scraper-orthman-soilmover-30rf",
              "name": "SOILMOVER 30RF",
              "subcategories": []
            },
            {
              "id": "scraper-orthman-soilmover-50rf",
              "name": "SOILMOVER 50RF",
              "subcategories": []
            },
            {
              "id": "scraper-orthman-soilmover-101s",
              "name": "SOILMOVER 101S",
              "subcategories": []
            },
            {
              "id": "scraper-orthman-soilmover-425rf",
              "name": "SOILMOVER 425RF",
              "subcategories": []
            },
            {
              "id": "scraper-orthman-soilmover-625rf",
              "name": "SOILMOVER 625RF",
              "subcategories": []
            },
            {
              "id": "scraper-orthman-soilmover-700",
              "name": "SOILMOVER 700",
              "subcategories": []
            },
            {
              "id": "scraper-orthman-soilmover-700rf",
              "name": "SOILMOVER 700RF",
              "subcategories": []
            },
            {
              "id": "scraper-orthman-soilmover-fe775",
              "name": "SOILMOVER FE775",
              "subcategories": []
            },
            {
              "id": "scraper-orthman-soilmover-7521",
              "name": "SOILMOVER 7521",
              "subcategories": []
            },
            {
              "id": "scraper-orthman-soilmover-7522",
              "name": "SOILMOVER 7522",
              "subcategories": []
            },
            {
              "id": "scraper-orthman-soilmover-8120",
              "name": "SOILMOVER 8120",
              "subcategories": []
            },
            {
              "id": "scraper-orthman-soilmover-fx775",
              "name": "SOILMOVER FX775",
              "subcategories": []
            },
            {
              "id": "scraper-orthman-soilmover-sm75",
              "name": "SOILMOVER SM75",
              "subcategories": []
            },
            {
              "id": "scraper-orthman-soilmover-sm850rf",
              "name": "SOILMOVER SM850RF",
              "subcategories": []
            },
            {
              "id": "scraper-orthman-other",
              "name": "OTHER",
              "subcategories": []
            }
          ]
        },
        {
          "id": "scraper-mobile-track-solutions",
          "name": "Mobile Track Solutions",
          "subcategories": [
            {
              "id": "scraper-mobile-track-solutions-mt-14",
              "name": "MT-14",
              "subcategories": []
            },
            {
              "id": "scraper-mobile-track-solutions-mt-23",
              "name": "MT-23",
              "subcategories": []
            },
            {
              "id": "scraper-mobile-track-solutions-mt-28",
              "name": "MT-28",
              "subcategories": []
            },
            {
              "id": "scraper-mobile-track-solutions-mt-30",
              "name": "MT-30",
              "subcategories": []
            },
            {
              "id": "scraper-mobile-track-solutions-mt-33",
              "name": "MT-33",
              "subcategories": []
            },
            {
              "id": "scraper-mobile-track-solutions-mt-35",
              "name": "MT-35",
              "subcategories": []
            },
            {
              "id": "scraper-mobile-track-solutions-mt-42",
              "name": "MT-42",
              "subcategories": []
            },
            {
              "id": "scraper-mobile-track-solutions-other",
              "name": "OTHER",
              "subcategories": []
            }
          ]
        },
        {
          "id": "scraper-rowse",
          "name": "Rowse",
          "subcategories": [
            {
              "id": "scraper-rowse-500",
              "name": "500",
              "subcategories": []
            },
            {
              "id": "scraper-rowse-700",
              "name": "700",
              "subcategories": []
            },
            {
              "id": "scraper-rowse-3002",
              "name": "3002",
              "subcategories": []
            },
            {
              "id": "scraper-rowse-5002",
              "name": "5002",
              "subcategories": []
            },
            {
              "id": "scraper-rowse-5004",
              "name": "5004",
              "subcategories": []
            },
            {
              "id": "scraper-rowse-7002",
              "name": "7002",
              "subcategories": []
            },
            {
              "id": "scraper-rowse-7004",
              "name": "7004",
              "subcategories": []
            },
            {
              "id": "scraper-rowse-other",
              "name": "OTHER",
              "subcategories": []
            }
          ]
        },
        {
          "id": "scraper-toreq",
          "name": "Toreq",
          "subcategories": [
            {
              "id": "scraper-toreq-6000",
              "name": "6000",
              "subcategories": []
            },
            {
              "id": "scraper-toreq-9000",
              "name": "9000",
              "subcategories": []
            },
            {
              "id": "scraper-toreq-10000",
              "name": "10000",
              "subcategories": []
            },
            {
              "id": "scraper-toreq-11500",
              "name": "11500",
              "subcategories": []
            },
            {
              "id": "scraper-toreq-13000",
              "name": "13000",
              "subcategories": []
            },
            {
              "id": "scraper-toreq-14000",
              "name": "14000",
              "subcategories": []
            },
            {
              "id": "scraper-toreq-16000",
              "name": "16000",
              "subcategories": []
            },
            {
              "id": "scraper-toreq-18000",
              "name": "18000",
              "subcategories": []
            },
            {
              "id": "scraper-toreq-other",
              "name": "OTHER",
              "subcategories": []
            }
          ]
        },
        {
          "id": "scraper-big-dog",
          "name": "Big Dog",
          "subcategories": [
            {
              "id": "scraper-big-dog-8-yd",
              "name": "8 YD",
              "subcategories": []
            },
            {
              "id": "scraper-big-dog-s6-5",
              "name": "S6.5",
              "subcategories": []
            },
            {
              "id": "scraper-big-dog-s8",
              "name": "S8",
              "subcategories": []
            },
            {
              "id": "scraper-big-dog-s10",
              "name": "S10",
              "subcategories": []
            },
            {
              "id": "scraper-big-dog-s11",
              "name": "S11",
              "subcategories": []
            },
            {
              "id": "scraper-big-dog-other",
              "name": "OTHER",
              "subcategories": []
            }
          ]
        },
        {
          "id": "scraper-durabilt",
          "name": "Durabilt",
          "subcategories": [
            {
              "id": "scraper-durabilt-dp60",
              "name": "DP60",
              "subcategories": []
            },
            {
              "id": "scraper-durabilt-dp84",
              "name": "DP84",
              "subcategories": []
            },
            {
              "id": "scraper-durabilt-other",
              "name": "OTHER",
              "subcategories": []
            }
          ]
        },
        {
          "id": "scraper-eversman",
          "name": "Eversman",
          "subcategories": [
            {
              "id": "scraper-eversman-2s",
              "name": "2S",
              "subcategories": []
            },
            {
              "id": "scraper-eversman-2sd",
              "name": "2SD",
              "subcategories": []
            },
            {
              "id": "scraper-eversman-25d",
              "name": "25D",
              "subcategories": []
            },
            {
              "id": "scraper-eversman-410",
              "name": "410",
              "subcategories": []
            },
            {
              "id": "scraper-eversman-600",
              "name": "600",
              "subcategories": []
            },
            {
              "id": "scraper-eversman-650",
              "name": "650",
              "subcategories": []
            },
            {
              "id": "scraper-eversman-700",
              "name": "700",
              "subcategories": []
            },
            {
              "id": "scraper-eversman-750",
              "name": "750",
              "subcategories": []
            },
            {
              "id": "scraper-eversman-other",
              "name": "OTHER",
              "subcategories": []
            }
          ]
        },
        {
          "id": "scraper-garfield",
          "name": "Garfield",
          "subcategories": [
            {
              "id": "scraper-garfield-550",
              "name": "550",
              "subcategories": []
            },
            {
              "id": "scraper-garfield-850",
              "name": "850",
              "subcategories": []
            },
            {
              "id": "scraper-garfield-950",
              "name": "950",
              "subcategories": []
            },
            {
              "id": "scraper-garfield-1200",
              "name": "1200",
              "subcategories": []
            },
            {
              "id": "scraper-garfield-1350",
              "name": "1350",
              "subcategories": []
            },
            {
              "id": "scraper-garfield-gca550",
              "name": "GCA550",
              "subcategories": []
            },
            {
              "id": "scraper-garfield-gca550hc",
              "name": "GCA550HC",
              "subcategories": []
            },
            {
              "id": "scraper-garfield-gca950hc",
              "name": "GCA950HC",
              "subcategories": []
            },
            {
              "id": "scraper-garfield-gca1350hc",
              "name": "GCA1350HC",
              "subcategories": []
            },
            {
              "id": "scraper-garfield-ggb1600",
              "name": "GGB1600",
              "subcategories": []
            },
            {
              "id": "scraper-garfield-ghdst16",
              "name": "GHDST16",
              "subcategories": []
            },
            {
              "id": "scraper-garfield-other",
              "name": "OTHER",
              "subcategories": []
            }
          ]
        },
        {
          "id": "scraper-holcomb",
          "name": "Holcomb",
          "subcategories": [
            {
              "id": "scraper-holcomb-800",
              "name": "800",
              "subcategories": []
            },
            {
              "id": "scraper-holcomb-1000",
              "name": "1000",
              "subcategories": []
            },
            {
              "id": "scraper-holcomb-1200",
              "name": "1200",
              "subcategories": []
            },
            {
              "id": "scraper-holcomb-1400",
              "name": "1400",
              "subcategories": []
            },
            {
              "id": "scraper-holcomb-1600",
              "name": "1600",
              "subcategories": []
            },
            {
              "id": "scraper-holcomb-other",
              "name": "OTHER",
              "subcategories": []
            }
          ]
        },
        {
          "id": "scraper-humdinger",
          "name": "Humdinger",
          "subcategories": [
            {
              "id": "scraper-humdinger-622e",
              "name": "622E",
              "subcategories": []
            },
            {
              "id": "scraper-humdinger-628e",
              "name": "628E",
              "subcategories": []
            },
            {
              "id": "scraper-humdinger-631e",
              "name": "631E",
              "subcategories": []
            },
            {
              "id": "scraper-humdinger-631e-adt",
              "name": "631E ADT",
              "subcategories": []
            },
            {
              "id": "scraper-humdinger-h619",
              "name": "H619",
              "subcategories": []
            },
            {
              "id": "scraper-humdinger-h620g",
              "name": "H620G",
              "subcategories": []
            },
            {
              "id": "scraper-humdinger-other",
              "name": "OTHER",
              "subcategories": []
            }
          ]
        },
        {
          "id": "scraper-icon",
          "name": "Icon",
          "subcategories": [
            {
              "id": "scraper-icon-17c",
              "name": "17C",
              "subcategories": []
            },
            {
              "id": "scraper-icon-18d",
              "name": "18D",
              "subcategories": []
            },
            {
              "id": "scraper-icon-19c",
              "name": "19C",
              "subcategories": []
            },
            {
              "id": "scraper-icon-20e",
              "name": "20E",
              "subcategories": []
            },
            {
              "id": "scraper-icon-418",
              "name": "418",
              "subcategories": []
            },
            {
              "id": "scraper-icon-721",
              "name": "721",
              "subcategories": []
            },
            {
              "id": "scraper-icon-821",
              "name": "821",
              "subcategories": []
            },
            {
              "id": "scraper-icon-ag11",
              "name": "AG11",
              "subcategories": []
            },
            {
              "id": "scraper-icon-ag13",
              "name": "AG13",
              "subcategories": []
            },
            {
              "id": "scraper-icon-cem17",
              "name": "CEM17",
              "subcategories": []
            },
            {
              "id": "scraper-icon-other",
              "name": "OTHER",
              "subcategories": []
            }
          ]
        },
        {
          "id": "scraper-landoll-icon",
          "name": "Landoll Icon",
          "subcategories": [
            {
              "id": "scraper-landoll-icon-1230",
              "name": "1230",
              "subcategories": []
            },
            {
              "id": "scraper-landoll-icon-1432",
              "name": "1432",
              "subcategories": []
            },
            {
              "id": "scraper-landoll-icon-1632",
              "name": "1632",
              "subcategories": []
            },
            {
              "id": "scraper-landoll-icon-1642",
              "name": "1642",
              "subcategories": []
            },
            {
              "id": "scraper-landoll-icon-ag10",
              "name": "AG10",
              "subcategories": []
            },
            {
              "id": "scraper-landoll-icon-other",
              "name": "OTHER",
              "subcategories": []
            }
          ]
        },
        {
          "id": "scraper-noble",
          "name": "Noble",
          "subcategories": [
            {
              "id": "scraper-noble-417",
              "name": "417",
              "subcategories": []
            },
            {
              "id": "scraper-noble-other",
              "name": "OTHER",
              "subcategories": []
            }
          ]
        },
        {
          "id": "scraper-terex",
          "name": "Terex",
          "subcategories": [
            {
              "id": "scraper-terex-s11",
              "name": "S11",
              "subcategories": []
            },
            {
              "id": "scraper-terex-s24",
              "name": "S24",
              "subcategories": []
            },
            {
              "id": "scraper-terex-ts14",
              "name": "TS14",
              "subcategories": []
            },
            {
              "id": "scraper-terex-ts14b",
              "name": "TS14B",
              "subcategories": []
            },
            {
              "id": "scraper-terex-ts14c",
              "name": "TS14C",
              "subcategories": []
            },
            {
              "id": "scraper-terex-ts14g",
              "name": "TS14G",
              "subcategories": []
            },
            {
              "id": "scraper-terex-ts14hp",
              "name": "TS14HP",
              "subcategories": []
            },
            {
              "id": "scraper-terex-ts18",
              "name": "TS18",
              "subcategories": []
            },
            {
              "id": "scraper-terex-ts46c",
              "name": "TS46C",
              "subcategories": []
            },
            {
              "id": "scraper-terex-other",
              "name": "OTHER",
              "subcategories": []
            }
          ]
        }
      ]
    },
    {
      "id": "skid-steer-ctl",
      "name": "Skid Steer/Ctl",
      "subcategories": [
        {
          "id": "skid-steer-ctl-skidsteers-ctl",
          "name": "Skidsteers / Ctl",
          "subcategories": []
        },
        {
          "id": "skid-steer-ctl-bobcat",
          "name": "Bobcat",
          "subcategories": [
            {
              "id": "skid-steer-ctl-bobcat-310",
              "name": "310",
              "subcategories": []
            },
            {
              "id": "skid-steer-ctl-bobcat-315",
              "name": "315",
              "subcategories": []
            },
            {
              "id": "skid-steer-ctl-bobcat-371",
              "name": "371",
              "subcategories": []
            },
            {
              "id": "skid-steer-ctl-bobcat-440",
              "name": "440",
              "subcategories": []
            },
            {
              "id": "skid-steer-ctl-bobcat-440b",
              "name": "440B",
              "subcategories": []
            },
            {
              "id": "skid-steer-ctl-bobcat-450",
              "name": "450",
              "subcategories": []
            },
            {
              "id": "skid-steer-ctl-bobcat-450c",
              "name": "450C",
              "subcategories": []
            },
            {
              "id": "skid-steer-ctl-bobcat-453",
              "name": "453",
              "subcategories": []
            },
            {
              "id": "skid-steer-ctl-bobcat-463",
              "name": "463",
              "subcategories": []
            },
            {
              "id": "skid-steer-ctl-bobcat-530",
              "name": "530",
              "subcategories": []
            },
            {
              "id": "skid-steer-ctl-bobcat-540",
              "name": "540",
              "subcategories": []
            },
            {
              "id": "skid-steer-ctl-bobcat-542",
              "name": "542",
              "subcategories": []
            },
            {
              "id": "skid-steer-ctl-bobcat-542b",
              "name": "542B",
              "subcategories": []
            },
            {
              "id": "skid-steer-ctl-bobcat-543",
              "name": "543",
              "subcategories": []
            },
            {
              "id": "skid-steer-ctl-bobcat-553",
              "name": "553",
              "subcategories": []
            },
            {
              "id": "skid-steer-ctl-bobcat-610",
              "name": "610",
              "subcategories": []
            },
            {
              "id": "skid-steer-ctl-bobcat-630",
              "name": "630",
              "subcategories": []
            },
            {
              "id": "skid-steer-ctl-bobcat-632",
              "name": "632",
              "subcategories": []
            },
            {
              "id": "skid-steer-ctl-bobcat-641",
              "name": "641",
              "subcategories": []
            },
            {
              "id": "skid-steer-ctl-bobcat-642",
              "name": "642",
              "subcategories": []
            },
            {
              "id": "skid-steer-ctl-bobcat-642b",
              "name": "642B",
              "subcategories": []
            },
            {
              "id": "skid-steer-ctl-bobcat-643",
              "name": "643",
              "subcategories": []
            },
            {
              "id": "skid-steer-ctl-bobcat-645",
              "name": "645",
              "subcategories": []
            },
            {
              "id": "skid-steer-ctl-bobcat-700",
              "name": "700",
              "subcategories": []
            },
            {
              "id": "skid-steer-ctl-bobcat-720",
              "name": "720",
              "subcategories": []
            },
            {
              "id": "skid-steer-ctl-bobcat-722",
              "name": "722",
              "subcategories": []
            },
            {
              "id": "skid-steer-ctl-bobcat-725",
              "name": "725",
              "subcategories": []
            },
            {
              "id": "skid-steer-ctl-bobcat-742",
              "name": "742",
              "subcategories": []
            },
            {
              "id": "skid-steer-ctl-bobcat-743",
              "name": "743",
              "subcategories": []
            },
            {
              "id": "skid-steer-ctl-bobcat-743b",
              "name": "743B",
              "subcategories": []
            },
            {
              "id": "skid-steer-ctl-bobcat-751",
              "name": "751",
              "subcategories": []
            },
            {
              "id": "skid-steer-ctl-bobcat-753",
              "name": "753",
              "subcategories": []
            },
            {
              "id": "skid-steer-ctl-bobcat-753c",
              "name": "753C",
              "subcategories": []
            },
            {
              "id": "skid-steer-ctl-bobcat-753g",
              "name": "753G",
              "subcategories": []
            },
            {
              "id": "skid-steer-ctl-bobcat-763",
              "name": "763",
              "subcategories": []
            },
            {
              "id": "skid-steer-ctl-bobcat-763c",
              "name": "763C",
              "subcategories": []
            },
            {
              "id": "skid-steer-ctl-bobcat-763f",
              "name": "763F",
              "subcategories": []
            },
            {
              "id": "skid-steer-ctl-bobcat-763h",
              "name": "763H",
              "subcategories": []
            },
            {
              "id": "skid-steer-ctl-bobcat-773",
              "name": "773",
              "subcategories": []
            },
            {
              "id": "skid-steer-ctl-bobcat-773f",
              "name": "773F",
              "subcategories": []
            },
            {
              "id": "skid-steer-ctl-bobcat-773g",
              "name": "773G",
              "subcategories": []
            },
            {
              "id": "skid-steer-ctl-bobcat-773t",
              "name": "773T",
              "subcategories": []
            },
            {
              "id": "skid-steer-ctl-bobcat-825",
              "name": "825",
              "subcategories": []
            },
            {
              "id": "skid-steer-ctl-bobcat-843",
              "name": "843",
              "subcategories": []
            },
            {
              "id": "skid-steer-ctl-bobcat-853",
              "name": "853",
              "subcategories": []
            },
            {
              "id": "skid-steer-ctl-bobcat-853h",
              "name": "853H",
              "subcategories": []
            },
            {
              "id": "skid-steer-ctl-bobcat-863",
              "name": "863",
              "subcategories": []
            },
            {
              "id": "skid-steer-ctl-bobcat-863f",
              "name": "863F",
              "subcategories": []
            },
            {
              "id": "skid-steer-ctl-bobcat-864",
              "name": "864",
              "subcategories": []
            },
            {
              "id": "skid-steer-ctl-bobcat-864g",
              "name": "864G",
              "subcategories": []
            },
            {
              "id": "skid-steer-ctl-bobcat-873",
              "name": "873",
              "subcategories": []
            },
            {
              "id": "skid-steer-ctl-bobcat-873f",
              "name": "873F",
              "subcategories": []
            },
            {
              "id": "skid-steer-ctl-bobcat-873g",
              "name": "873G",
              "subcategories": []
            },
            {
              "id": "skid-steer-ctl-bobcat-883",
              "name": "883",
              "subcategories": []
            },
            {
              "id": "skid-steer-ctl-bobcat-963",
              "name": "963",
              "subcategories": []
            },
            {
              "id": "skid-steer-ctl-bobcat-963g",
              "name": "963G",
              "subcategories": []
            },
            {
              "id": "skid-steer-ctl-bobcat-1080",
              "name": "1080",
              "subcategories": []
            },
            {
              "id": "skid-steer-ctl-bobcat-1213",
              "name": "1213",
              "subcategories": []
            },
            {
              "id": "skid-steer-ctl-bobcat-7753",
              "name": "7753",
              "subcategories": []
            },
            {
              "id": "skid-steer-ctl-bobcat-a220",
              "name": "A220",
              "subcategories": []
            },
            {
              "id": "skid-steer-ctl-bobcat-a300",
              "name": "A300",
              "subcategories": []
            },
            {
              "id": "skid-steer-ctl-bobcat-a770",
              "name": "A770",
              "subcategories": []
            },
            {
              "id": "skid-steer-ctl-bobcat-earthforce-s",
              "name": "EARTHFORCE'S",
              "subcategories": []
            },
            {
              "id": "skid-steer-ctl-bobcat-earthforce-s16",
              "name": "EARTHFORCE S16",
              "subcategories": []
            },
            {
              "id": "skid-steer-ctl-bobcat-earth-force-s18",
              "name": "EARTH FORCE S18",
              "subcategories": []
            },
            {
              "id": "skid-steer-ctl-bobcat-m600",
              "name": "M600",
              "subcategories": []
            },
            {
              "id": "skid-steer-ctl-bobcat-mt50",
              "name": "MT50",
              "subcategories": []
            },
            {
              "id": "skid-steer-ctl-bobcat-mt52",
              "name": "MT52",
              "subcategories": []
            },
            {
              "id": "skid-steer-ctl-bobcat-mt55",
              "name": "MT55",
              "subcategories": []
            },
            {
              "id": "skid-steer-ctl-bobcat-mt85",
              "name": "MT85",
              "subcategories": []
            },
            {
              "id": "skid-steer-ctl-bobcat-mt100",
              "name": "MT100",
              "subcategories": []
            },
            {
              "id": "skid-steer-ctl-bobcat-mt120",
              "name": "MT120",
              "subcategories": []
            },
            {
              "id": "skid-steer-ctl-bobcat-s62",
              "name": "S62",
              "subcategories": []
            },
            {
              "id": "skid-steer-ctl-bobcat-s64",
              "name": "S64",
              "subcategories": []
            },
            {
              "id": "skid-steer-ctl-bobcat-s66",
              "name": "S66",
              "subcategories": []
            },
            {
              "id": "skid-steer-ctl-bobcat-s70",
              "name": "S70",
              "subcategories": []
            },
            {
              "id": "skid-steer-ctl-bobcat-s76",
              "name": "S76",
              "subcategories": []
            },
            {
              "id": "skid-steer-ctl-bobcat-s86",
              "name": "S86",
              "subcategories": []
            },
            {
              "id": "skid-steer-ctl-bobcat-s100",
              "name": "S100",
              "subcategories": []
            },
            {
              "id": "skid-steer-ctl-bobcat-s130",
              "name": "S130",
              "subcategories": []
            },
            {
              "id": "skid-steer-ctl-bobcat-s150",
              "name": "S150",
              "subcategories": []
            },
            {
              "id": "skid-steer-ctl-bobcat-s160",
              "name": "S160",
              "subcategories": []
            },
            {
              "id": "skid-steer-ctl-bobcat-s175",
              "name": "S175",
              "subcategories": []
            },
            {
              "id": "skid-steer-ctl-bobcat-s185",
              "name": "S185",
              "subcategories": []
            },
            {
              "id": "skid-steer-ctl-bobcat-s205",
              "name": "S205",
              "subcategories": []
            },
            {
              "id": "skid-steer-ctl-bobcat-s220",
              "name": "S220",
              "subcategories": []
            },
            {
              "id": "skid-steer-ctl-bobcat-s250",
              "name": "S250",
              "subcategories": []
            },
            {
              "id": "skid-steer-ctl-bobcat-s300",
              "name": "S300",
              "subcategories": []
            },
            {
              "id": "skid-steer-ctl-bobcat-s330",
              "name": "S330",
              "subcategories": []
            },
            {
              "id": "skid-steer-ctl-bobcat-s450",
              "name": "S450",
              "subcategories": []
            },
            {
              "id": "skid-steer-ctl-bobcat-s510",
              "name": "S510",
              "subcategories": []
            },
            {
              "id": "skid-steer-ctl-bobcat-s530",
              "name": "S530",
              "subcategories": []
            },
            {
              "id": "skid-steer-ctl-bobcat-s550",
              "name": "S550",
              "subcategories": []
            },
            {
              "id": "skid-steer-ctl-bobcat-s570",
              "name": "S570",
              "subcategories": []
            },
            {
              "id": "skid-steer-ctl-bobcat-s590",
              "name": "S590",
              "subcategories": []
            },
            {
              "id": "skid-steer-ctl-bobcat-s595",
              "name": "S595",
              "subcategories": []
            },
            {
              "id": "skid-steer-ctl-bobcat-s630",
              "name": "S630",
              "subcategories": []
            },
            {
              "id": "skid-steer-ctl-bobcat-s650",
              "name": "S650",
              "subcategories": []
            },
            {
              "id": "skid-steer-ctl-bobcat-s740",
              "name": "S740",
              "subcategories": []
            },
            {
              "id": "skid-steer-ctl-bobcat-s750",
              "name": "S750",
              "subcategories": []
            },
            {
              "id": "skid-steer-ctl-bobcat-s770",
              "name": "S770",
              "subcategories": []
            },
            {
              "id": "skid-steer-ctl-bobcat-s850",
              "name": "S850",
              "subcategories": []
            },
            {
              "id": "skid-steer-ctl-bobcat-t7x",
              "name": "T7X",
              "subcategories": []
            },
            {
              "id": "skid-steer-ctl-bobcat-t62",
              "name": "T62",
              "subcategories": []
            },
            {
              "id": "skid-steer-ctl-bobcat-t64",
              "name": "T64",
              "subcategories": []
            },
            {
              "id": "skid-steer-ctl-bobcat-t66",
              "name": "T66",
              "subcategories": []
            },
            {
              "id": "skid-steer-ctl-bobcat-t76",
              "name": "T76",
              "subcategories": []
            },
            {
              "id": "skid-steer-ctl-bobcat-t86",
              "name": "T86",
              "subcategories": []
            },
            {
              "id": "skid-steer-ctl-bobcat-t110",
              "name": "T110",
              "subcategories": []
            },
            {
              "id": "skid-steer-ctl-bobcat-t140",
              "name": "T140",
              "subcategories": []
            },
            {
              "id": "skid-steer-ctl-bobcat-t180",
              "name": "T180",
              "subcategories": []
            },
            {
              "id": "skid-steer-ctl-bobcat-t190",
              "name": "T190",
              "subcategories": []
            },
            {
              "id": "skid-steer-ctl-bobcat-t200",
              "name": "T200",
              "subcategories": []
            },
            {
              "id": "skid-steer-ctl-bobcat-t250",
              "name": "T250",
              "subcategories": []
            },
            {
              "id": "skid-steer-ctl-bobcat-t300",
              "name": "T300",
              "subcategories": []
            },
            {
              "id": "skid-steer-ctl-bobcat-t320",
              "name": "T320",
              "subcategories": []
            },
            {
              "id": "skid-steer-ctl-bobcat-t450",
              "name": "T450",
              "subcategories": []
            },
            {
              "id": "skid-steer-ctl-bobcat-t550",
              "name": "T550",
              "subcategories": []
            },
            {
              "id": "skid-steer-ctl-bobcat-t590",
              "name": "T590",
              "subcategories": []
            },
            {
              "id": "skid-steer-ctl-bobcat-t595",
              "name": "T595",
              "subcategories": []
            },
            {
              "id": "skid-steer-ctl-bobcat-t630",
              "name": "T630",
              "subcategories": []
            },
            {
              "id": "skid-steer-ctl-bobcat-t650",
              "name": "T650",
              "subcategories": []
            },
            {
              "id": "skid-steer-ctl-bobcat-t740",
              "name": "T740",
              "subcategories": []
            },
            {
              "id": "skid-steer-ctl-bobcat-t750",
              "name": "T750",
              "subcategories": []
            },
            {
              "id": "skid-steer-ctl-bobcat-t770",
              "name": "T770",
              "subcategories": []
            },
            {
              "id": "skid-steer-ctl-bobcat-t870",
              "name": "T870",
              "subcategories": []
            },
            {
              "id": "skid-steer-ctl-bobcat-other",
              "name": "OTHER",
              "subcategories": []
            }
          ]
        },
        {
          "id": "skid-steer-ctl-deere",
          "name": "Deere",
          "subcategories": [
            {
              "id": "skid-steer-ctl-deere-70",
              "name": "70",
              "subcategories": []
            },
            {
              "id": "skid-steer-ctl-deere-90",
              "name": "90",
              "subcategories": []
            },
            {
              "id": "skid-steer-ctl-deere-125",
              "name": "125",
              "subcategories": []
            },
            {
              "id": "skid-steer-ctl-deere-240",
              "name": "240",
              "subcategories": []
            },
            {
              "id": "skid-steer-ctl-deere-240ii",
              "name": "240II",
              "subcategories": []
            },
            {
              "id": "skid-steer-ctl-deere-250",
              "name": "250",
              "subcategories": []
            },
            {
              "id": "skid-steer-ctl-deere-250ii",
              "name": "250II",
              "subcategories": []
            },
            {
              "id": "skid-steer-ctl-deere-260",
              "name": "260",
              "subcategories": []
            },
            {
              "id": "skid-steer-ctl-deere-260ii",
              "name": "260II",
              "subcategories": []
            },
            {
              "id": "skid-steer-ctl-deere-270",
              "name": "270",
              "subcategories": []
            },
            {
              "id": "skid-steer-ctl-deere-270ii",
              "name": "270II",
              "subcategories": []
            },
            {
              "id": "skid-steer-ctl-deere-312",
              "name": "312",
              "subcategories": []
            },
            {
              "id": "skid-steer-ctl-deere-312gr",
              "name": "312GR",
              "subcategories": []
            },
            {
              "id": "skid-steer-ctl-deere-313",
              "name": "313",
              "subcategories": []
            },
            {
              "id": "skid-steer-ctl-deere-314",
              "name": "314",
              "subcategories": []
            },
            {
              "id": "skid-steer-ctl-deere-315",
              "name": "315",
              "subcategories": []
            },
            {
              "id": "skid-steer-ctl-deere-316",
              "name": "316",
              "subcategories": []
            },
            {
              "id": "skid-steer-ctl-deere-317",
              "name": "317",
              "subcategories": []
            },
            {
              "id": "skid-steer-ctl-deere-317p",
              "name": "317P",
              "subcategories": []
            },
            {
              "id": "skid-steer-ctl-deere-317g",
              "name": "317G",
              "subcategories": []
            },
            {
              "id": "skid-steer-ctl-deere-318p",
              "name": "318P",
              "subcategories": []
            },
            {
              "id": "skid-steer-ctl-deere-318d",
              "name": "318D",
              "subcategories": []
            },
            {
              "id": "skid-steer-ctl-deere-318e",
              "name": "318E",
              "subcategories": []
            },
            {
              "id": "skid-steer-ctl-deere-318g",
              "name": "318G",
              "subcategories": []
            },
            {
              "id": "skid-steer-ctl-deere-319d",
              "name": "319D",
              "subcategories": []
            },
            {
              "id": "skid-steer-ctl-deere-319e",
              "name": "319E",
              "subcategories": []
            },
            {
              "id": "skid-steer-ctl-deere-320",
              "name": "320",
              "subcategories": []
            },
            {
              "id": "skid-steer-ctl-deere-320d",
              "name": "320D",
              "subcategories": []
            },
            {
              "id": "skid-steer-ctl-deere-320e",
              "name": "320E",
              "subcategories": []
            },
            {
              "id": "skid-steer-ctl-deere-320g",
              "name": "320G",
              "subcategories": []
            },
            {
              "id": "skid-steer-ctl-deere-323",
              "name": "323",
              "subcategories": []
            },
            {
              "id": "skid-steer-ctl-deere-323d",
              "name": "323D",
              "subcategories": []
            },
            {
              "id": "skid-steer-ctl-deere-323e",
              "name": "323E",
              "subcategories": []
            },
            {
              "id": "skid-steer-ctl-deere-324",
              "name": "324",
              "subcategories": []
            },
            {
              "id": "skid-steer-ctl-deere-324e",
              "name": "324E",
              "subcategories": []
            },
            {
              "id": "skid-steer-ctl-deere-324g",
              "name": "324G",
              "subcategories": []
            },
            {
              "id": "skid-steer-ctl-deere-325",
              "name": "325",
              "subcategories": []
            },
            {
              "id": "skid-steer-ctl-deere-325g",
              "name": "325G",
              "subcategories": []
            },
            {
              "id": "skid-steer-ctl-deere-326d",
              "name": "326D",
              "subcategories": []
            },
            {
              "id": "skid-steer-ctl-deere-326e",
              "name": "326E",
              "subcategories": []
            },
            {
              "id": "skid-steer-ctl-deere-328",
              "name": "328",
              "subcategories": []
            },
            {
              "id": "skid-steer-ctl-deere-328d",
              "name": "328D",
              "subcategories": []
            },
            {
              "id": "skid-steer-ctl-deere-328e",
              "name": "328E",
              "subcategories": []
            },
            {
              "id": "skid-steer-ctl-deere-329d",
              "name": "329D",
              "subcategories": []
            },
            {
              "id": "skid-steer-ctl-deere-329e",
              "name": "329E",
              "subcategories": []
            },
            {
              "id": "skid-steer-ctl-deere-330",
              "name": "330",
              "subcategories": []
            },
            {
              "id": "skid-steer-ctl-deere-330p",
              "name": "330P",
              "subcategories": []
            },
            {
              "id": "skid-steer-ctl-deere-330g",
              "name": "330G",
              "subcategories": []
            },
            {
              "id": "skid-steer-ctl-deere-331",
              "name": "331",
              "subcategories": []
            },
            {
              "id": "skid-steer-ctl-deere-331p",
              "name": "331P",
              "subcategories": []
            },
            {
              "id": "skid-steer-ctl-deere-331g",
              "name": "331G",
              "subcategories": []
            },
            {
              "id": "skid-steer-ctl-deere-332",
              "name": "332",
              "subcategories": []
            },
            {
              "id": "skid-steer-ctl-deere-332d",
              "name": "332D",
              "subcategories": []
            },
            {
              "id": "skid-steer-ctl-deere-332e",
              "name": "332E",
              "subcategories": []
            },
            {
              "id": "skid-steer-ctl-deere-332g",
              "name": "332G",
              "subcategories": []
            },
            {
              "id": "skid-steer-ctl-deere-333",
              "name": "333",
              "subcategories": []
            },
            {
              "id": "skid-steer-ctl-deere-333p",
              "name": "333P",
              "subcategories": []
            },
            {
              "id": "skid-steer-ctl-deere-333d",
              "name": "333D",
              "subcategories": []
            },
            {
              "id": "skid-steer-ctl-deere-333e",
              "name": "333E",
              "subcategories": []
            },
            {
              "id": "skid-steer-ctl-deere-333g",
              "name": "333G",
              "subcategories": []
            },
            {
              "id": "skid-steer-ctl-deere-334",
              "name": "334",
              "subcategories": []
            },
            {
              "id": "skid-steer-ctl-deere-334p",
              "name": "334P",
              "subcategories": []
            },
            {
              "id": "skid-steer-ctl-deere-335",
              "name": "335",
              "subcategories": []
            },
            {
              "id": "skid-steer-ctl-deere-335p",
              "name": "335P",
              "subcategories": []
            },
            {
              "id": "skid-steer-ctl-deere-375",
              "name": "375",
              "subcategories": []
            },
            {
              "id": "skid-steer-ctl-deere-575",
              "name": "575",
              "subcategories": []
            },
            {
              "id": "skid-steer-ctl-deere-3375",
              "name": "3375",
              "subcategories": []
            },
            {
              "id": "skid-steer-ctl-deere-4475",
              "name": "4475",
              "subcategories": []
            },
            {
              "id": "skid-steer-ctl-deere-5575",
              "name": "5575",
              "subcategories": []
            },
            {
              "id": "skid-steer-ctl-deere-6675",
              "name": "6675",
              "subcategories": []
            },
            {
              "id": "skid-steer-ctl-deere-7775",
              "name": "7775",
              "subcategories": []
            },
            {
              "id": "skid-steer-ctl-deere-8875",
              "name": "8875",
              "subcategories": []
            },
            {
              "id": "skid-steer-ctl-deere-ct322",
              "name": "CT322",
              "subcategories": []
            },
            {
              "id": "skid-steer-ctl-deere-ct332",
              "name": "CT332",
              "subcategories": []
            },
            {
              "id": "skid-steer-ctl-deere-other",
              "name": "OTHER",
              "subcategories": []
            }
          ]
        },
        {
          "id": "skid-steer-ctl-caterpillar",
          "name": "Caterpillar",
          "subcategories": []
        },
        {
          "id": "skid-steer-ctl-new-holland",
          "name": "New Holland",
          "subcategories": [
            {
              "id": "skid-steer-ctl-new-holland-c175",
              "name": "C175",
              "subcategories": []
            },
            {
              "id": "skid-steer-ctl-new-holland-c180",
              "name": "C180",
              "subcategories": []
            },
            {
              "id": "skid-steer-ctl-new-holland-c190",
              "name": "C190",
              "subcategories": []
            },
            {
              "id": "skid-steer-ctl-new-holland-c227",
              "name": "C227",
              "subcategories": []
            },
            {
              "id": "skid-steer-ctl-new-holland-c232",
              "name": "C232",
              "subcategories": []
            },
            {
              "id": "skid-steer-ctl-new-holland-c234",
              "name": "C234",
              "subcategories": []
            },
            {
              "id": "skid-steer-ctl-new-holland-c237",
              "name": "C237",
              "subcategories": []
            },
            {
              "id": "skid-steer-ctl-new-holland-c238",
              "name": "C238",
              "subcategories": []
            },
            {
              "id": "skid-steer-ctl-new-holland-c245",
              "name": "C245",
              "subcategories": []
            },
            {
              "id": "skid-steer-ctl-new-holland-c314",
              "name": "C314",
              "subcategories": []
            },
            {
              "id": "skid-steer-ctl-new-holland-c327",
              "name": "C327",
              "subcategories": []
            },
            {
              "id": "skid-steer-ctl-new-holland-c330",
              "name": "C330",
              "subcategories": []
            },
            {
              "id": "skid-steer-ctl-new-holland-c332",
              "name": "C332",
              "subcategories": []
            },
            {
              "id": "skid-steer-ctl-new-holland-c334",
              "name": "C334",
              "subcategories": []
            },
            {
              "id": "skid-steer-ctl-new-holland-c337",
              "name": "C337",
              "subcategories": []
            },
            {
              "id": "skid-steer-ctl-new-holland-c345",
              "name": "C345",
              "subcategories": []
            },
            {
              "id": "skid-steer-ctl-new-holland-c362",
              "name": "C362",
              "subcategories": []
            },
            {
              "id": "skid-steer-ctl-new-holland-l150",
              "name": "L150",
              "subcategories": []
            },
            {
              "id": "skid-steer-ctl-new-holland-l160",
              "name": "L160",
              "subcategories": []
            },
            {
              "id": "skid-steer-ctl-new-holland-l170",
              "name": "L170",
              "subcategories": []
            },
            {
              "id": "skid-steer-ctl-new-holland-l180",
              "name": "L180",
              "subcategories": []
            },
            {
              "id": "skid-steer-ctl-new-holland-l185",
              "name": "L185",
              "subcategories": []
            },
            {
              "id": "skid-steer-ctl-new-holland-l190",
              "name": "L190",
              "subcategories": []
            },
            {
              "id": "skid-steer-ctl-new-holland-l213",
              "name": "L213",
              "subcategories": []
            },
            {
              "id": "skid-steer-ctl-new-holland-l215",
              "name": "L215",
              "subcategories": []
            },
            {
              "id": "skid-steer-ctl-new-holland-l216",
              "name": "L216",
              "subcategories": []
            },
            {
              "id": "skid-steer-ctl-new-holland-l218",
              "name": "L218",
              "subcategories": []
            },
            {
              "id": "skid-steer-ctl-new-holland-l220",
              "name": "L220",
              "subcategories": []
            },
            {
              "id": "skid-steer-ctl-new-holland-l221",
              "name": "L221",
              "subcategories": []
            },
            {
              "id": "skid-steer-ctl-new-holland-l223",
              "name": "L223",
              "subcategories": []
            },
            {
              "id": "skid-steer-ctl-new-holland-l225",
              "name": "L225",
              "subcategories": []
            },
            {
              "id": "skid-steer-ctl-new-holland-l228",
              "name": "L228",
              "subcategories": []
            },
            {
              "id": "skid-steer-ctl-new-holland-l230",
              "name": "L230",
              "subcategories": []
            },
            {
              "id": "skid-steer-ctl-new-holland-l234",
              "name": "L234",
              "subcategories": []
            },
            {
              "id": "skid-steer-ctl-new-holland-l250",
              "name": "L250",
              "subcategories": []
            },
            {
              "id": "skid-steer-ctl-new-holland-l255",
              "name": "L255",
              "subcategories": []
            },
            {
              "id": "skid-steer-ctl-new-holland-l315",
              "name": "L315",
              "subcategories": []
            },
            {
              "id": "skid-steer-ctl-new-holland-l316",
              "name": "L316",
              "subcategories": []
            },
            {
              "id": "skid-steer-ctl-new-holland-l318",
              "name": "L318",
              "subcategories": []
            },
            {
              "id": "skid-steer-ctl-new-holland-l320",
              "name": "L320",
              "subcategories": []
            },
            {
              "id": "skid-steer-ctl-new-holland-l321",
              "name": "L321",
              "subcategories": []
            },
            {
              "id": "skid-steer-ctl-new-holland-l325",
              "name": "L325",
              "subcategories": []
            },
            {
              "id": "skid-steer-ctl-new-holland-l328",
              "name": "L328",
              "subcategories": []
            },
            {
              "id": "skid-steer-ctl-new-holland-l334",
              "name": "L334",
              "subcategories": []
            },
            {
              "id": "skid-steer-ctl-new-holland-l425",
              "name": "L425",
              "subcategories": []
            },
            {
              "id": "skid-steer-ctl-new-holland-l445",
              "name": "L445",
              "subcategories": []
            },
            {
              "id": "skid-steer-ctl-new-holland-l455",
              "name": "L455",
              "subcategories": []
            },
            {
              "id": "skid-steer-ctl-new-holland-l553",
              "name": "L553",
              "subcategories": []
            },
            {
              "id": "skid-steer-ctl-new-holland-l555",
              "name": "L555",
              "subcategories": []
            },
            {
              "id": "skid-steer-ctl-new-holland-l565",
              "name": "L565",
              "subcategories": []
            },
            {
              "id": "skid-steer-ctl-new-holland-l783",
              "name": "L783",
              "subcategories": []
            },
            {
              "id": "skid-steer-ctl-new-holland-l785",
              "name": "L785",
              "subcategories": []
            },
            {
              "id": "skid-steer-ctl-new-holland-l865",
              "name": "L865",
              "subcategories": []
            },
            {
              "id": "skid-steer-ctl-new-holland-ls120",
              "name": "LS120",
              "subcategories": []
            },
            {
              "id": "skid-steer-ctl-new-holland-ls140",
              "name": "LS140",
              "subcategories": []
            },
            {
              "id": "skid-steer-ctl-new-holland-ls150",
              "name": "LS150",
              "subcategories": []
            },
            {
              "id": "skid-steer-ctl-new-holland-ls160",
              "name": "LS160",
              "subcategories": []
            },
            {
              "id": "skid-steer-ctl-new-holland-ls170",
              "name": "LS170",
              "subcategories": []
            },
            {
              "id": "skid-steer-ctl-new-holland-ls180",
              "name": "LS180",
              "subcategories": []
            },
            {
              "id": "skid-steer-ctl-new-holland-ls180b",
              "name": "LS180B",
              "subcategories": []
            },
            {
              "id": "skid-steer-ctl-new-holland-ls185b",
              "name": "LS185B",
              "subcategories": []
            },
            {
              "id": "skid-steer-ctl-new-holland-ls185b",
              "name": "LS185B",
              "subcategories": []
            },
            {
              "id": "skid-steer-ctl-new-holland-ls190",
              "name": "LS190",
              "subcategories": []
            },
            {
              "id": "skid-steer-ctl-new-holland-ls190b",
              "name": "LS190B",
              "subcategories": []
            },
            {
              "id": "skid-steer-ctl-new-holland-lt185",
              "name": "LT185",
              "subcategories": []
            },
            {
              "id": "skid-steer-ctl-new-holland-lt185b",
              "name": "LT185B",
              "subcategories": []
            },
            {
              "id": "skid-steer-ctl-new-holland-lt190",
              "name": "LT190",
              "subcategories": []
            },
            {
              "id": "skid-steer-ctl-new-holland-lt190b",
              "name": "LT190B",
              "subcategories": []
            },
            {
              "id": "skid-steer-ctl-new-holland-lx485",
              "name": "LX485",
              "subcategories": []
            },
            {
              "id": "skid-steer-ctl-new-holland-lx565",
              "name": "LX565",
              "subcategories": []
            },
            {
              "id": "skid-steer-ctl-new-holland-lx665",
              "name": "LX665",
              "subcategories": []
            },
            {
              "id": "skid-steer-ctl-new-holland-lx865",
              "name": "LX865",
              "subcategories": []
            },
            {
              "id": "skid-steer-ctl-new-holland-lx885",
              "name": "LX885",
              "subcategories": []
            },
            {
              "id": "skid-steer-ctl-new-holland-lx985",
              "name": "LX985",
              "subcategories": []
            },
            {
              "id": "skid-steer-ctl-new-holland-other",
              "name": "OTHER",
              "subcategories": []
            }
          ]
        },
        {
          "id": "skid-steer-ctl-kubota",
          "name": "Kubota",
          "subcategories": [
            {
              "id": "skid-steer-ctl-kubota-scl1000",
              "name": "SCL1000",
              "subcategories": []
            },
            {
              "id": "skid-steer-ctl-kubota-ssv65",
              "name": "SSV65",
              "subcategories": []
            },
            {
              "id": "skid-steer-ctl-kubota-ssv75",
              "name": "SSV75",
              "subcategories": []
            },
            {
              "id": "skid-steer-ctl-kubota-svl65",
              "name": "SVL65",
              "subcategories": []
            },
            {
              "id": "skid-steer-ctl-kubota-svl65-2",
              "name": "SVL65-2",
              "subcategories": []
            },
            {
              "id": "skid-steer-ctl-kubota-svl65-2s",
              "name": "SVL65-2S",
              "subcategories": []
            },
            {
              "id": "skid-steer-ctl-kubota-svl75",
              "name": "SVL75",
              "subcategories": []
            },
            {
              "id": "skid-steer-ctl-kubota-svl75-2",
              "name": "SVL75-2",
              "subcategories": []
            },
            {
              "id": "skid-steer-ctl-kubota-svl75-3",
              "name": "SVL75-3",
              "subcategories": []
            },
            {
              "id": "skid-steer-ctl-kubota-svl90",
              "name": "SVL90",
              "subcategories": []
            },
            {
              "id": "skid-steer-ctl-kubota-svl90-2",
              "name": "SVL90-2",
              "subcategories": []
            },
            {
              "id": "skid-steer-ctl-kubota-sv95-2",
              "name": "SV95-2",
              "subcategories": []
            },
            {
              "id": "skid-steer-ctl-kubota-svl95-2s",
              "name": "SVL95-2S",
              "subcategories": []
            },
            {
              "id": "skid-steer-ctl-kubota-svl97-2",
              "name": "SVL97-2",
              "subcategories": []
            },
            {
              "id": "skid-steer-ctl-kubota-svl97-3",
              "name": "SVL97-3",
              "subcategories": []
            },
            {
              "id": "skid-steer-ctl-kubota-svl110-3",
              "name": "SVL110-3",
              "subcategories": []
            },
            {
              "id": "skid-steer-ctl-kubota-other",
              "name": "OTHER",
              "subcategories": []
            }
          ]
        },
        {
          "id": "skid-steer-ctl-case",
          "name": "Case",
          "subcategories": [
            {
              "id": "skid-steer-ctl-case-40xt",
              "name": "40XT",
              "subcategories": []
            },
            {
              "id": "skid-steer-ctl-case-60xt",
              "name": "60XT",
              "subcategories": []
            },
            {
              "id": "skid-steer-ctl-case-70xt",
              "name": "70XT",
              "subcategories": []
            },
            {
              "id": "skid-steer-ctl-case-75xt",
              "name": "75XT",
              "subcategories": []
            },
            {
              "id": "skid-steer-ctl-case-85xt",
              "name": "85XT",
              "subcategories": []
            },
            {
              "id": "skid-steer-ctl-case-90xt",
              "name": "90XT",
              "subcategories": []
            },
            {
              "id": "skid-steer-ctl-case-410",
              "name": "410",
              "subcategories": []
            },
            {
              "id": "skid-steer-ctl-case-420",
              "name": "420",
              "subcategories": []
            },
            {
              "id": "skid-steer-ctl-case-420-ct",
              "name": "420 CT",
              "subcategories": []
            },
            {
              "id": "skid-steer-ctl-case-420-ct-3",
              "name": "420 CT-3",
              "subcategories": []
            },
            {
              "id": "skid-steer-ctl-case-430",
              "name": "430",
              "subcategories": []
            },
            {
              "id": "skid-steer-ctl-case-435",
              "name": "435",
              "subcategories": []
            },
            {
              "id": "skid-steer-ctl-case-440",
              "name": "440",
              "subcategories": []
            },
            {
              "id": "skid-steer-ctl-case-440ct",
              "name": "440CT",
              "subcategories": []
            },
            {
              "id": "skid-steer-ctl-case-445",
              "name": "445",
              "subcategories": []
            },
            {
              "id": "skid-steer-ctl-case-445ct",
              "name": "445CT",
              "subcategories": []
            },
            {
              "id": "skid-steer-ctl-case-445ct-3",
              "name": "445CT-3",
              "subcategories": []
            },
            {
              "id": "skid-steer-ctl-case-450",
              "name": "450",
              "subcategories": []
            },
            {
              "id": "skid-steer-ctl-case-450ct",
              "name": "450CT",
              "subcategories": []
            },
            {
              "id": "skid-steer-ctl-case-450ct-3",
              "name": "450CT-3",
              "subcategories": []
            },
            {
              "id": "skid-steer-ctl-case-465",
              "name": "465",
              "subcategories": []
            },
            {
              "id": "skid-steer-ctl-case-1537",
              "name": "1537",
              "subcategories": []
            },
            {
              "id": "skid-steer-ctl-case-1737",
              "name": "1737",
              "subcategories": []
            },
            {
              "id": "skid-steer-ctl-case-1816",
              "name": "1816",
              "subcategories": []
            },
            {
              "id": "skid-steer-ctl-case-1816b",
              "name": "1816B",
              "subcategories": []
            },
            {
              "id": "skid-steer-ctl-case-1816c",
              "name": "1816C",
              "subcategories": []
            },
            {
              "id": "skid-steer-ctl-case-1818",
              "name": "1818",
              "subcategories": []
            },
            {
              "id": "skid-steer-ctl-case-1825",
              "name": "1825",
              "subcategories": []
            },
            {
              "id": "skid-steer-ctl-case-1825b",
              "name": "1825B",
              "subcategories": []
            },
            {
              "id": "skid-steer-ctl-case-1830",
              "name": "1830",
              "subcategories": []
            },
            {
              "id": "skid-steer-ctl-case-1835",
              "name": "1835",
              "subcategories": []
            },
            {
              "id": "skid-steer-ctl-case-1835c",
              "name": "1835C",
              "subcategories": []
            },
            {
              "id": "skid-steer-ctl-case-1838",
              "name": "1838",
              "subcategories": []
            },
            {
              "id": "skid-steer-ctl-case-1840",
              "name": "1840",
              "subcategories": []
            },
            {
              "id": "skid-steer-ctl-case-1845",
              "name": "1845",
              "subcategories": []
            },
            {
              "id": "skid-steer-ctl-case-1845b",
              "name": "1845B",
              "subcategories": []
            },
            {
              "id": "skid-steer-ctl-case-1845c",
              "name": "1845C",
              "subcategories": []
            },
            {
              "id": "skid-steer-ctl-case-dl550",
              "name": "DL550",
              "subcategories": []
            },
            {
              "id": "skid-steer-ctl-case-dl550b",
              "name": "DL550B",
              "subcategories": []
            },
            {
              "id": "skid-steer-ctl-case-sr130",
              "name": "SR130",
              "subcategories": []
            },
            {
              "id": "skid-steer-ctl-case-sr130b",
              "name": "SR130B",
              "subcategories": []
            },
            {
              "id": "skid-steer-ctl-case-sr160",
              "name": "SR160",
              "subcategories": []
            },
            {
              "id": "skid-steer-ctl-case-sr160b",
              "name": "SR160B",
              "subcategories": []
            },
            {
              "id": "skid-steer-ctl-case-sr175",
              "name": "SR175",
              "subcategories": []
            },
            {
              "id": "skid-steer-ctl-case-sr175b",
              "name": "SR175B",
              "subcategories": []
            },
            {
              "id": "skid-steer-ctl-case-sr200",
              "name": "SR200",
              "subcategories": []
            },
            {
              "id": "skid-steer-ctl-case-sr200b",
              "name": "SR200B",
              "subcategories": []
            },
            {
              "id": "skid-steer-ctl-case-sr210",
              "name": "SR210",
              "subcategories": []
            },
            {
              "id": "skid-steer-ctl-case-sr210b",
              "name": "SR210B",
              "subcategories": []
            },
            {
              "id": "skid-steer-ctl-case-sr220",
              "name": "SR220",
              "subcategories": []
            },
            {
              "id": "skid-steer-ctl-case-sr240",
              "name": "SR240",
              "subcategories": []
            },
            {
              "id": "skid-steer-ctl-case-sr240b",
              "name": "SR240B",
              "subcategories": []
            },
            {
              "id": "skid-steer-ctl-case-sr250",
              "name": "SR250",
              "subcategories": []
            },
            {
              "id": "skid-steer-ctl-case-sr270",
              "name": "SR270",
              "subcategories": []
            },
            {
              "id": "skid-steer-ctl-case-sr270b",
              "name": "SR270B",
              "subcategories": []
            },
            {
              "id": "skid-steer-ctl-case-sv185",
              "name": "SV185",
              "subcategories": []
            },
            {
              "id": "skid-steer-ctl-case-sv185b",
              "name": "SV185B",
              "subcategories": []
            },
            {
              "id": "skid-steer-ctl-case-sv250",
              "name": "SV250",
              "subcategories": []
            },
            {
              "id": "skid-steer-ctl-case-sv280",
              "name": "SV280",
              "subcategories": []
            },
            {
              "id": "skid-steer-ctl-case-sv280b",
              "name": "SV280B",
              "subcategories": []
            },
            {
              "id": "skid-steer-ctl-case-sv300",
              "name": "SV300",
              "subcategories": []
            },
            {
              "id": "skid-steer-ctl-case-sv340",
              "name": "SV340",
              "subcategories": []
            },
            {
              "id": "skid-steer-ctl-case-sv340b",
              "name": "SV340B",
              "subcategories": []
            },
            {
              "id": "skid-steer-ctl-case-tl100",
              "name": "TL100",
              "subcategories": []
            },
            {
              "id": "skid-steer-ctl-case-tr270",
              "name": "TR270",
              "subcategories": []
            },
            {
              "id": "skid-steer-ctl-case-tr270b",
              "name": "TR270B",
              "subcategories": []
            },
            {
              "id": "skid-steer-ctl-case-tr310",
              "name": "TR310",
              "subcategories": []
            },
            {
              "id": "skid-steer-ctl-case-tr310b",
              "name": "TR310B",
              "subcategories": []
            },
            {
              "id": "skid-steer-ctl-case-tr320",
              "name": "TR320",
              "subcategories": []
            },
            {
              "id": "skid-steer-ctl-case-tr340",
              "name": "TR340",
              "subcategories": []
            },
            {
              "id": "skid-steer-ctl-case-tr340b",
              "name": "TR340B",
              "subcategories": []
            },
            {
              "id": "skid-steer-ctl-case-tv370",
              "name": "TV370",
              "subcategories": []
            },
            {
              "id": "skid-steer-ctl-case-tv370b",
              "name": "TV370B",
              "subcategories": []
            },
            {
              "id": "skid-steer-ctl-case-tv380",
              "name": "TV380",
              "subcategories": []
            },
            {
              "id": "skid-steer-ctl-case-tv450",
              "name": "TV450",
              "subcategories": []
            },
            {
              "id": "skid-steer-ctl-case-tv450b",
              "name": "TV450B",
              "subcategories": []
            },
            {
              "id": "skid-steer-ctl-case-tv620",
              "name": "TV620",
              "subcategories": []
            },
            {
              "id": "skid-steer-ctl-case-tv620b",
              "name": "TV620B",
              "subcategories": []
            },
            {
              "id": "skid-steer-ctl-case-other",
              "name": "OTHER",
              "subcategories": []
            }
          ]
        },
        {
          "id": "skid-steer-ctl-gehl",
          "name": "Gehl",
          "subcategories": [
            {
              "id": "skid-steer-ctl-gehl-1640e",
              "name": "1640E",
              "subcategories": []
            },
            {
              "id": "skid-steer-ctl-gehl-2500",
              "name": "2500",
              "subcategories": []
            },
            {
              "id": "skid-steer-ctl-gehl-2600",
              "name": "2600",
              "subcategories": []
            },
            {
              "id": "skid-steer-ctl-gehl-3310",
              "name": "3310",
              "subcategories": []
            },
            {
              "id": "skid-steer-ctl-gehl-3410",
              "name": "3410",
              "subcategories": []
            },
            {
              "id": "skid-steer-ctl-gehl-3510",
              "name": "3510",
              "subcategories": []
            },
            {
              "id": "skid-steer-ctl-gehl-3610",
              "name": "3610",
              "subcategories": []
            },
            {
              "id": "skid-steer-ctl-gehl-3635",
              "name": "3635",
              "subcategories": []
            },
            {
              "id": "skid-steer-ctl-gehl-3640",
              "name": "3640",
              "subcategories": []
            },
            {
              "id": "skid-steer-ctl-gehl-3640e",
              "name": "3640E",
              "subcategories": []
            },
            {
              "id": "skid-steer-ctl-gehl-3725",
              "name": "3725",
              "subcategories": []
            },
            {
              "id": "skid-steer-ctl-gehl-3825",
              "name": "3825",
              "subcategories": []
            },
            {
              "id": "skid-steer-ctl-gehl-3825sx",
              "name": "3825SX",
              "subcategories": []
            },
            {
              "id": "skid-steer-ctl-gehl-3935",
              "name": "3935",
              "subcategories": []
            },
            {
              "id": "skid-steer-ctl-gehl-4240",
              "name": "4240",
              "subcategories": []
            },
            {
              "id": "skid-steer-ctl-gehl-4240e",
              "name": "4240E",
              "subcategories": []
            },
            {
              "id": "skid-steer-ctl-gehl-4400",
              "name": "4400",
              "subcategories": []
            },
            {
              "id": "skid-steer-ctl-gehl-4500",
              "name": "4500",
              "subcategories": []
            },
            {
              "id": "skid-steer-ctl-gehl-4510",
              "name": "4510",
              "subcategories": []
            },
            {
              "id": "skid-steer-ctl-gehl-4610",
              "name": "4610",
              "subcategories": []
            },
            {
              "id": "skid-steer-ctl-gehl-4615",
              "name": "4615",
              "subcategories": []
            },
            {
              "id": "skid-steer-ctl-gehl-4625",
              "name": "4625",
              "subcategories": []
            },
            {
              "id": "skid-steer-ctl-gehl-4625sx",
              "name": "4625SX",
              "subcategories": []
            },
            {
              "id": "skid-steer-ctl-gehl-4635",
              "name": "4635",
              "subcategories": []
            },
            {
              "id": "skid-steer-ctl-gehl-4635sx",
              "name": "4635SX",
              "subcategories": []
            },
            {
              "id": "skid-steer-ctl-gehl-4640",
              "name": "4640",
              "subcategories": []
            },
            {
              "id": "skid-steer-ctl-gehl-4640e",
              "name": "4640E",
              "subcategories": []
            },
            {
              "id": "skid-steer-ctl-gehl-4835",
              "name": "4835",
              "subcategories": []
            },
            {
              "id": "skid-steer-ctl-gehl-4835sxt",
              "name": "4835SXT",
              "subcategories": []
            },
            {
              "id": "skid-steer-ctl-gehl-4840",
              "name": "4840",
              "subcategories": []
            },
            {
              "id": "skid-steer-ctl-gehl-4840e",
              "name": "4840E",
              "subcategories": []
            },
            {
              "id": "skid-steer-ctl-gehl-5240",
              "name": "5240",
              "subcategories": []
            },
            {
              "id": "skid-steer-ctl-gehl-5240e",
              "name": "5240E",
              "subcategories": []
            },
            {
              "id": "skid-steer-ctl-gehl-5240e-p2",
              "name": "5240E P2",
              "subcategories": []
            },
            {
              "id": "skid-steer-ctl-gehl-5625dx",
              "name": "5625DX",
              "subcategories": []
            },
            {
              "id": "skid-steer-ctl-gehl-5635",
              "name": "5635",
              "subcategories": []
            },
            {
              "id": "skid-steer-ctl-gehl-5635sx",
              "name": "5635SX",
              "subcategories": []
            },
            {
              "id": "skid-steer-ctl-gehl-5635sx-ii",
              "name": "5635SX II",
              "subcategories": []
            },
            {
              "id": "skid-steer-ctl-gehl-5635sxt",
              "name": "5635SXT",
              "subcategories": []
            },
            {
              "id": "skid-steer-ctl-gehl-5635sxt-ii",
              "name": "5635SXT II",
              "subcategories": []
            },
            {
              "id": "skid-steer-ctl-gehl-5640",
              "name": "5640",
              "subcategories": []
            },
            {
              "id": "skid-steer-ctl-gehl-5640e",
              "name": "5640E",
              "subcategories": []
            },
            {
              "id": "skid-steer-ctl-gehl-6635",
              "name": "6635",
              "subcategories": []
            },
            {
              "id": "skid-steer-ctl-gehl-6635dxt",
              "name": "6635DXT",
              "subcategories": []
            },
            {
              "id": "skid-steer-ctl-gehl-6635sxt",
              "name": "6635SXT",
              "subcategories": []
            },
            {
              "id": "skid-steer-ctl-gehl-6635sxt-ii",
              "name": "6635SXT II",
              "subcategories": []
            },
            {
              "id": "skid-steer-ctl-gehl-6640",
              "name": "6640",
              "subcategories": []
            },
            {
              "id": "skid-steer-ctl-gehl-6640e",
              "name": "6640E",
              "subcategories": []
            },
            {
              "id": "skid-steer-ctl-gehl-7600",
              "name": "7600",
              "subcategories": []
            },
            {
              "id": "skid-steer-ctl-gehl-7800",
              "name": "7800",
              "subcategories": []
            },
            {
              "id": "skid-steer-ctl-gehl-7810",
              "name": "7810",
              "subcategories": []
            },
            {
              "id": "skid-steer-ctl-gehl-ctl55",
              "name": "CTL55",
              "subcategories": []
            },
            {
              "id": "skid-steer-ctl-gehl-ctl65",
              "name": "CTL65",
              "subcategories": []
            },
            {
              "id": "skid-steer-ctl-gehl-ctl75",
              "name": "CTL75",
              "subcategories": []
            },
            {
              "id": "skid-steer-ctl-gehl-ctl85",
              "name": "CTL85",
              "subcategories": []
            },
            {
              "id": "skid-steer-ctl-gehl-r105",
              "name": "R105",
              "subcategories": []
            },
            {
              "id": "skid-steer-ctl-gehl-r135",
              "name": "R135",
              "subcategories": []
            },
            {
              "id": "skid-steer-ctl-gehl-r150",
              "name": "R150",
              "subcategories": []
            },
            {
              "id": "skid-steer-ctl-gehl-r165",
              "name": "R165",
              "subcategories": []
            },
            {
              "id": "skid-steer-ctl-gehl-r190",
              "name": "R190",
              "subcategories": []
            },
            {
              "id": "skid-steer-ctl-gehl-r190-gii",
              "name": "R190 GII",
              "subcategories": []
            },
            {
              "id": "skid-steer-ctl-gehl-r220",
              "name": "R220",
              "subcategories": []
            },
            {
              "id": "skid-steer-ctl-gehl-r260",
              "name": "R260",
              "subcategories": []
            },
            {
              "id": "skid-steer-ctl-gehl-rt105",
              "name": "RT105",
              "subcategories": []
            },
            {
              "id": "skid-steer-ctl-gehl-rt135",
              "name": "RT135",
              "subcategories": []
            },
            {
              "id": "skid-steer-ctl-gehl-rt165",
              "name": "RT165",
              "subcategories": []
            },
            {
              "id": "skid-steer-ctl-gehl-rt175",
              "name": "RT175",
              "subcategories": []
            },
            {
              "id": "skid-steer-ctl-gehl-rt185",
              "name": "RT185",
              "subcategories": []
            },
            {
              "id": "skid-steer-ctl-gehl-rt195",
              "name": "RT195",
              "subcategories": []
            },
            {
              "id": "skid-steer-ctl-gehl-rt210",
              "name": "RT210",
              "subcategories": []
            },
            {
              "id": "skid-steer-ctl-gehl-rt215",
              "name": "RT215",
              "subcategories": []
            },
            {
              "id": "skid-steer-ctl-gehl-rt250",
              "name": ".RT250",
              "subcategories": []
            },
            {
              "id": "skid-steer-ctl-gehl-rt255",
              "name": "RT255",
              "subcategories": []
            },
            {
              "id": "skid-steer-ctl-gehl-v210",
              "name": "V210",
              "subcategories": []
            },
            {
              "id": "skid-steer-ctl-gehl-v230",
              "name": "V230",
              "subcategories": []
            },
            {
              "id": "skid-steer-ctl-gehl-v270",
              "name": "V270",
              "subcategories": []
            },
            {
              "id": "skid-steer-ctl-gehl-v275",
              "name": "V275",
              "subcategories": []
            },
            {
              "id": "skid-steer-ctl-gehl-v330",
              "name": "V330",
              "subcategories": []
            },
            {
              "id": "skid-steer-ctl-gehl-v335",
              "name": "V335",
              "subcategories": []
            },
            {
              "id": "skid-steer-ctl-gehl-v360",
              "name": "V360",
              "subcategories": []
            },
            {
              "id": "skid-steer-ctl-gehl-v400",
              "name": "V400",
              "subcategories": []
            },
            {
              "id": "skid-steer-ctl-gehl-v420",
              "name": "V420",
              "subcategories": []
            },
            {
              "id": "skid-steer-ctl-gehl-vt210",
              "name": "VT210",
              "subcategories": []
            },
            {
              "id": "skid-steer-ctl-gehl-vt230",
              "name": "VT230",
              "subcategories": []
            },
            {
              "id": "skid-steer-ctl-gehl-vt275",
              "name": "VT275",
              "subcategories": []
            },
            {
              "id": "skid-steer-ctl-gehl-vt320",
              "name": "VT320",
              "subcategories": []
            },
            {
              "id": "skid-steer-ctl-gehl-vt335",
              "name": "VT335",
              "subcategories": []
            },
            {
              "id": "skid-steer-ctl-gehl-vt360",
              "name": "VT360",
              "subcategories": []
            },
            {
              "id": "skid-steer-ctl-gehl-other",
              "name": "OTHER",
              "subcategories": []
            }
          ]
        },
        {
          "id": "skid-steer-ctl-takeuchi",
          "name": "Takeuchi",
          "subcategories": [
            {
              "id": "skid-steer-ctl-takeuchi-tl6",
              "name": "TL6",
              "subcategories": []
            },
            {
              "id": "skid-steer-ctl-takeuchi-tl6r",
              "name": "TL6R",
              "subcategories": []
            },
            {
              "id": "skid-steer-ctl-takeuchi-tl8",
              "name": "TL8",
              "subcategories": []
            },
            {
              "id": "skid-steer-ctl-takeuchi-tl8r",
              "name": "TL8R",
              "subcategories": []
            },
            {
              "id": "skid-steer-ctl-takeuchi-tl8r2",
              "name": "TL8R2",
              "subcategories": []
            },
            {
              "id": "skid-steer-ctl-takeuchi-tl10",
              "name": "TL10",
              "subcategories": []
            },
            {
              "id": "skid-steer-ctl-takeuchi-tl10v2",
              "name": "TL10V2",
              "subcategories": []
            },
            {
              "id": "skid-steer-ctl-takeuchi-tl11",
              "name": "TL11",
              "subcategories": []
            },
            {
              "id": "skid-steer-ctl-takeuchi-tl11r3",
              "name": "TL11R3",
              "subcategories": []
            },
            {
              "id": "skid-steer-ctl-takeuchi-tl12",
              "name": "TL12",
              "subcategories": []
            },
            {
              "id": "skid-steer-ctl-takeuchi-tl12r2",
              "name": "TL12R2",
              "subcategories": []
            },
            {
              "id": "skid-steer-ctl-takeuchi-tl12v2",
              "name": "TL12V2",
              "subcategories": []
            },
            {
              "id": "skid-steer-ctl-takeuchi-tl26",
              "name": "TL26",
              "subcategories": []
            },
            {
              "id": "skid-steer-ctl-takeuchi-tl130",
              "name": "TL130",
              "subcategories": []
            },
            {
              "id": "skid-steer-ctl-takeuchi-tl140",
              "name": "TL140",
              "subcategories": []
            },
            {
              "id": "skid-steer-ctl-takeuchi-tl150",
              "name": "TL150",
              "subcategories": []
            },
            {
              "id": "skid-steer-ctl-takeuchi-tl230",
              "name": "TL230",
              "subcategories": []
            },
            {
              "id": "skid-steer-ctl-takeuchi-tl230-2",
              "name": "TL230-2",
              "subcategories": []
            },
            {
              "id": "skid-steer-ctl-takeuchi-tl240",
              "name": "TL240",
              "subcategories": []
            },
            {
              "id": "skid-steer-ctl-takeuchi-tl250",
              "name": "TL250",
              "subcategories": []
            },
            {
              "id": "skid-steer-ctl-takeuchi-ts50r",
              "name": "TS50R",
              "subcategories": []
            },
            {
              "id": "skid-steer-ctl-takeuchi-ts50v",
              "name": "TS50V",
              "subcategories": []
            },
            {
              "id": "skid-steer-ctl-takeuchi-ts80r2",
              "name": "TS80R2",
              "subcategories": []
            },
            {
              "id": "skid-steer-ctl-takeuchi-ts80v2",
              "name": "TS80V2",
              "subcategories": []
            },
            {
              "id": "skid-steer-ctl-takeuchi-other",
              "name": "OTHER",
              "subcategories": []
            }
          ]
        },
        {
          "id": "skid-steer-ctl-jcb",
          "name": "Jcb",
          "subcategories": [
            {
              "id": "skid-steer-ctl-jcb-2ts-7t",
              "name": "2TS-7T",
              "subcategories": []
            },
            {
              "id": "skid-steer-ctl-jcb-3ts-8t",
              "name": "3TS-8T",
              "subcategories": []
            },
            {
              "id": "skid-steer-ctl-jcb-3ts-8w",
              "name": "3TS-8W",
              "subcategories": []
            },
            {
              "id": "skid-steer-ctl-jcb-4ts-8t",
              "name": "4TS-8T",
              "subcategories": []
            },
            {
              "id": "skid-steer-ctl-jcb-135hd",
              "name": "135HD",
              "subcategories": []
            },
            {
              "id": "skid-steer-ctl-jcb-155",
              "name": "155",
              "subcategories": []
            },
            {
              "id": "skid-steer-ctl-jcb-155hd",
              "name": "155HD",
              "subcategories": []
            },
            {
              "id": "skid-steer-ctl-jcb-165",
              "name": "165",
              "subcategories": []
            },
            {
              "id": "skid-steer-ctl-jcb-175",
              "name": "175",
              "subcategories": []
            },
            {
              "id": "skid-steer-ctl-jcb-180",
              "name": "180",
              "subcategories": []
            },
            {
              "id": "skid-steer-ctl-jcb-180t",
              "name": "180T",
              "subcategories": []
            },
            {
              "id": "skid-steer-ctl-jcb-185",
              "name": "185",
              "subcategories": []
            },
            {
              "id": "skid-steer-ctl-jcb-190",
              "name": "190",
              "subcategories": []
            },
            {
              "id": "skid-steer-ctl-jcb-190t",
              "name": "190T",
              "subcategories": []
            },
            {
              "id": "skid-steer-ctl-jcb-205",
              "name": "205",
              "subcategories": []
            },
            {
              "id": "skid-steer-ctl-jcb-205t",
              "name": "205T",
              "subcategories": []
            },
            {
              "id": "skid-steer-ctl-jcb-210",
              "name": "210",
              "subcategories": []
            },
            {
              "id": "skid-steer-ctl-jcb-215",
              "name": "215",
              "subcategories": []
            },
            {
              "id": "skid-steer-ctl-jcb-215t",
              "name": "215T",
              "subcategories": []
            },
            {
              "id": "skid-steer-ctl-jcb-225",
              "name": "225",
              "subcategories": []
            },
            {
              "id": "skid-steer-ctl-jcb-250",
              "name": "250",
              "subcategories": []
            },
            {
              "id": "skid-steer-ctl-jcb-250t",
              "name": "250T",
              "subcategories": []
            },
            {
              "id": "skid-steer-ctl-jcb-260",
              "name": "260",
              "subcategories": []
            },
            {
              "id": "skid-steer-ctl-jcb-260t",
              "name": "260T",
              "subcategories": []
            },
            {
              "id": "skid-steer-ctl-jcb-270",
              "name": "270",
              "subcategories": []
            },
            {
              "id": "skid-steer-ctl-jcb-270t",
              "name": "270T",
              "subcategories": []
            },
            {
              "id": "skid-steer-ctl-jcb-300",
              "name": "300",
              "subcategories": []
            },
            {
              "id": "skid-steer-ctl-jcb-300t",
              "name": "300T",
              "subcategories": []
            },
            {
              "id": "skid-steer-ctl-jcb-320",
              "name": "320",
              "subcategories": []
            },
            {
              "id": "skid-steer-ctl-jcb-320t",
              "name": "320T",
              "subcategories": []
            },
            {
              "id": "skid-steer-ctl-jcb-330",
              "name": "330",
              "subcategories": []
            },
            {
              "id": "skid-steer-ctl-jcb-400",
              "name": "400",
              "subcategories": []
            },
            {
              "id": "skid-steer-ctl-jcb-400t",
              "name": "400T",
              "subcategories": []
            },
            {
              "id": "skid-steer-ctl-jcb-robot-160",
              "name": "ROBOT 160",
              "subcategories": []
            },
            {
              "id": "skid-steer-ctl-jcb-robot-190",
              "name": "ROBOT 190",
              "subcategories": []
            },
            {
              "id": "skid-steer-ctl-jcb-robot-190t",
              "name": "ROBOT 190T",
              "subcategories": []
            },
            {
              "id": "skid-steer-ctl-jcb-robot-1105iii",
              "name": "ROBOT 1105III",
              "subcategories": []
            },
            {
              "id": "skid-steer-ctl-jcb-robot-1110",
              "name": "ROBOT 1110",
              "subcategories": []
            },
            {
              "id": "skid-steer-ctl-jcb-robot-1110t",
              "name": "ROBOT 1110T",
              "subcategories": []
            },
            {
              "id": "skid-steer-ctl-jcb-other",
              "name": "OTHER",
              "subcategories": []
            }
          ]
        },
        {
          "id": "skid-steer-ctl-toro",
          "name": "Toro",
          "subcategories": [
            {
              "id": "skid-steer-ctl-toro-dingo-320d",
              "name": "DINGO 320D",
              "subcategories": []
            },
            {
              "id": "skid-steer-ctl-toro-dingo-323",
              "name": "DINGO 323",
              "subcategories": []
            },
            {
              "id": "skid-steer-ctl-toro-dingo-tx413",
              "name": "DINGO TX413",
              "subcategories": []
            },
            {
              "id": "skid-steer-ctl-toro-dingo-tx420",
              "name": "DINGO TX420",
              "subcategories": []
            },
            {
              "id": "skid-steer-ctl-toro-dingo-tx425",
              "name": "DINGO TX425",
              "subcategories": []
            },
            {
              "id": "skid-steer-ctl-toro-dingo-tx427n",
              "name": "DINGO TX427N",
              "subcategories": []
            },
            {
              "id": "skid-steer-ctl-toro-dingo-tx427w",
              "name": "DINGO TX427W",
              "subcategories": []
            },
            {
              "id": "skid-steer-ctl-toro-dingo-tx525n",
              "name": "DINGO TX525N",
              "subcategories": []
            },
            {
              "id": "skid-steer-ctl-toro-dingo-tx525w",
              "name": "DINGO TX525W",
              "subcategories": []
            },
            {
              "id": "skid-steer-ctl-toro-dingo-tx700",
              "name": "DINGO TX700",
              "subcategories": []
            },
            {
              "id": "skid-steer-ctl-toro-dingo-tx700n",
              "name": "DINGO TX700N",
              "subcategories": []
            },
            {
              "id": "skid-steer-ctl-toro-dingo-tx700w",
              "name": "DINGO TX700W",
              "subcategories": []
            },
            {
              "id": "skid-steer-ctl-toro-dingo-tx1000n",
              "name": "DINGO TX1000N",
              "subcategories": []
            },
            {
              "id": "skid-steer-ctl-toro-dingo-tx1000n-turbo",
              "name": "DINGO TX1000N TURBO",
              "subcategories": []
            },
            {
              "id": "skid-steer-ctl-toro-dingo-tx1000w",
              "name": "DINGO TX1000W",
              "subcategories": []
            },
            {
              "id": "skid-steer-ctl-toro-dingo-tx1000w-turbo",
              "name": "DINGO TX1000W TURBO",
              "subcategories": []
            },
            {
              "id": "skid-steer-ctl-toro-dingo-tx1300",
              "name": "DINGO TX1300",
              "subcategories": []
            },
            {
              "id": "skid-steer-ctl-toro-dingo-txl2000",
              "name": "DINGO TXL2000",
              "subcategories": []
            },
            {
              "id": "skid-steer-ctl-toro-dingo-txl200t",
              "name": "DINGO TXL200T",
              "subcategories": []
            },
            {
              "id": "skid-steer-ctl-toro-e-dingo-500",
              "name": "E-DINGO 500",
              "subcategories": []
            },
            {
              "id": "skid-steer-ctl-toro-e-dingo-tx750",
              "name": "E-DINGO TX750",
              "subcategories": []
            },
            {
              "id": "skid-steer-ctl-toro-other",
              "name": "OTHER",
              "subcategories": []
            }
          ]
        },
        {
          "id": "skid-steer-ctl-wacker-neuson",
          "name": "Wacker Neuson",
          "subcategories": []
        },
        {
          "id": "skid-steer-ctl-asv",
          "name": "Asv",
          "subcategories": [
            {
              "id": "skid-steer-ctl-asv-posi-trac-4810",
              "name": "POSI-TRAC 4810",
              "subcategories": []
            },
            {
              "id": "skid-steer-ctl-asv-posi-trac-hd4500",
              "name": "POSI-TRAC HD4500",
              "subcategories": []
            },
            {
              "id": "skid-steer-ctl-asv-posi-trac-r50",
              "name": "POSI-TRAC R50",
              "subcategories": []
            },
            {
              "id": "skid-steer-ctl-asv-posi-trac-rc50",
              "name": "POSI-TRAC RC50",
              "subcategories": []
            },
            {
              "id": "skid-steer-ctl-asv-posi-trac-rc60",
              "name": "POSI-TRAC RC60",
              "subcategories": []
            },
            {
              "id": "skid-steer-ctl-asv-posi-trac-rc85",
              "name": "POSI-TRAC RC85",
              "subcategories": []
            },
            {
              "id": "skid-steer-ctl-asv-posi-trac-rc100",
              "name": "POSI-TRAC RC100",
              "subcategories": []
            },
            {
              "id": "skid-steer-ctl-asv-posi-trac-rcv",
              "name": "POSI-TRAC RCV",
              "subcategories": []
            },
            {
              "id": "skid-steer-ctl-asv-posi-trac-rt25",
              "name": "POSI-TRAC RT25",
              "subcategories": []
            },
            {
              "id": "skid-steer-ctl-asv-posi-trac-rt30",
              "name": "POSI-TRAC RT30",
              "subcategories": []
            },
            {
              "id": "skid-steer-ctl-asv-posi-trac-rt40",
              "name": "POSI-TRAC RT40",
              "subcategories": []
            },
            {
              "id": "skid-steer-ctl-asv-posi-trac-rt50",
              "name": "POSI-TRAC RT50",
              "subcategories": []
            },
            {
              "id": "skid-steer-ctl-asv-posi-trac-rt60",
              "name": "POSI-TRAC RT60",
              "subcategories": []
            },
            {
              "id": "skid-steer-ctl-asv-posi-trac-rt65",
              "name": "POSI-TRAC RT65",
              "subcategories": []
            },
            {
              "id": "skid-steer-ctl-asv-posi-trac-rt65-max",
              "name": "POSI-TRAC RT65 MAX",
              "subcategories": []
            },
            {
              "id": "skid-steer-ctl-asv-posi-trac-rt75",
              "name": "POSI-TRAC RT75",
              "subcategories": []
            },
            {
              "id": "skid-steer-ctl-asv-posi-trac-rt75-max",
              "name": "POSI-TRAC RT75 MAX",
              "subcategories": []
            },
            {
              "id": "skid-steer-ctl-asv-posi-trac-rt75hd",
              "name": "POSI-TRAC RT75HD",
              "subcategories": []
            },
            {
              "id": "skid-steer-ctl-asv-posi-trac-rt75hd-maxc",
              "name": "POSI-TRAC RT75HD MAXC",
              "subcategories": []
            },
            {
              "id": "skid-steer-ctl-asv-posi-trac-rt120",
              "name": "POSI-TRAC RT120",
              "subcategories": []
            },
            {
              "id": "skid-steer-ctl-asv-posi-trac-rt120f",
              "name": "POSI-TRAC RT120F",
              "subcategories": []
            },
            {
              "id": "skid-steer-ctl-asv-posi-trac-rt135",
              "name": "POSI-TRAC RT135",
              "subcategories": []
            },
            {
              "id": "skid-steer-ctl-asv-posi-trac-rt135f",
              "name": "POSI-TRAC RT135F",
              "subcategories": []
            },
            {
              "id": "skid-steer-ctl-asv-posi-trac-sr70",
              "name": "POSI-TRAC SR70",
              "subcategories": []
            },
            {
              "id": "skid-steer-ctl-asv-posi-trac-sr80",
              "name": "POSI-TRAC SR80",
              "subcategories": []
            },
            {
              "id": "skid-steer-ctl-asv-posi-trac-vt70",
              "name": "POSI-TRAC VT70",
              "subcategories": []
            },
            {
              "id": "skid-steer-ctl-asv-posi-trac-vt70ho",
              "name": "POSI-TRAC VT70HO",
              "subcategories": []
            },
            {
              "id": "skid-steer-ctl-asv-posi-trac-vt70ho-max",
              "name": "POSI-TRAC VT70HO MAX",
              "subcategories": []
            },
            {
              "id": "skid-steer-ctl-asv-posi-trac-vt75-max",
              "name": "POSI-TRAC VT75 MAX",
              "subcategories": []
            },
            {
              "id": "skid-steer-ctl-asv-posi-trac-vt80-1c",
              "name": "POSI-TRAC VT80-1C",
              "subcategories": []
            },
            {
              "id": "skid-steer-ctl-asv-posi-trac-vt100-forestry",
              "name": "POSI-TRAC VT100 FORESTRY",
              "subcategories": []
            },
            {
              "id": "skid-steer-ctl-asv-posi-trac-vt100-max",
              "name": "POSI-TRAC VT100 MAX",
              "subcategories": []
            },
            {
              "id": "skid-steer-ctl-asv-posi-trac-vt80",
              "name": "POSI-TRAC VT80",
              "subcategories": []
            },
            {
              "id": "skid-steer-ctl-asv-posi-trac-vt80-forestry",
              "name": "POSI-TRAC VT80 FORESTRY",
              "subcategories": []
            },
            {
              "id": "skid-steer-ctl-asv-pt50",
              "name": "PT50",
              "subcategories": []
            },
            {
              "id": "skid-steer-ctl-asv-pt70",
              "name": "PT70",
              "subcategories": []
            },
            {
              "id": "skid-steer-ctl-asv-pt100",
              "name": "PT100",
              "subcategories": []
            },
            {
              "id": "skid-steer-ctl-asv-rs75",
              "name": "RS75",
              "subcategories": []
            },
            {
              "id": "skid-steer-ctl-asv-sr80",
              "name": "SR80",
              "subcategories": []
            },
            {
              "id": "skid-steer-ctl-asv-vs75",
              "name": "VS75",
              "subcategories": []
            },
            {
              "id": "skid-steer-ctl-asv-other",
              "name": "OTHER",
              "subcategories": []
            }
          ]
        },
        {
          "id": "skid-steer-ctl-ditch-witch",
          "name": "Ditch Witch",
          "subcategories": [
            {
              "id": "skid-steer-ctl-ditch-witch-sk300",
              "name": "SK300",
              "subcategories": []
            },
            {
              "id": "skid-steer-ctl-ditch-witch-sk350",
              "name": "SK350",
              "subcategories": []
            },
            {
              "id": "skid-steer-ctl-ditch-witch-sk500",
              "name": "SK500",
              "subcategories": []
            },
            {
              "id": "skid-steer-ctl-ditch-witch-sk600",
              "name": "SK600",
              "subcategories": []
            },
            {
              "id": "skid-steer-ctl-ditch-witch-sk650",
              "name": "SK650",
              "subcategories": []
            },
            {
              "id": "skid-steer-ctl-ditch-witch-sk750",
              "name": "SK750",
              "subcategories": []
            },
            {
              "id": "skid-steer-ctl-ditch-witch-sk752",
              "name": "SK752",
              "subcategories": []
            },
            {
              "id": "skid-steer-ctl-ditch-witch-sk755",
              "name": "SK755",
              "subcategories": []
            },
            {
              "id": "skid-steer-ctl-ditch-witch-sk800",
              "name": "SK800",
              "subcategories": []
            },
            {
              "id": "skid-steer-ctl-ditch-witch-sk850",
              "name": "SK850",
              "subcategories": []
            },
            {
              "id": "skid-steer-ctl-ditch-witch-sk900",
              "name": "SK900",
              "subcategories": []
            },
            {
              "id": "skid-steer-ctl-ditch-witch-sk1050",
              "name": "SK1050",
              "subcategories": []
            },
            {
              "id": "skid-steer-ctl-ditch-witch-sk1550",
              "name": "SK1550",
              "subcategories": []
            },
            {
              "id": "skid-steer-ctl-ditch-witch-sk3000",
              "name": "SK3000",
              "subcategories": []
            },
            {
              "id": "skid-steer-ctl-ditch-witch-zahn-r300",
              "name": "ZAHN R300",
              "subcategories": []
            },
            {
              "id": "skid-steer-ctl-ditch-witch-other",
              "name": "OTHER",
              "subcategories": []
            }
          ]
        },
        {
          "id": "skid-steer-ctl-vermeer",
          "name": "Vermeer",
          "subcategories": [
            {
              "id": "skid-steer-ctl-vermeer-ctx50",
              "name": "CTX50",
              "subcategories": []
            },
            {
              "id": "skid-steer-ctl-vermeer-ctx100",
              "name": "CTX100",
              "subcategories": []
            },
            {
              "id": "skid-steer-ctl-vermeer-ctx160",
              "name": "CTX160",
              "subcategories": []
            },
            {
              "id": "skid-steer-ctl-vermeer-ft100",
              "name": "FT100",
              "subcategories": []
            },
            {
              "id": "skid-steer-ctl-vermeer-s450",
              "name": "S450",
              "subcategories": []
            },
            {
              "id": "skid-steer-ctl-vermeer-s450tx",
              "name": "S450TX",
              "subcategories": []
            },
            {
              "id": "skid-steer-ctl-vermeer-s600tx",
              "name": "S600TX",
              "subcategories": []
            },
            {
              "id": "skid-steer-ctl-vermeer-s650tx",
              "name": "S650TX",
              "subcategories": []
            },
            {
              "id": "skid-steer-ctl-vermeer-s725tx",
              "name": "S725TX",
              "subcategories": []
            },
            {
              "id": "skid-steer-ctl-vermeer-s800tx",
              "name": "S800TX",
              "subcategories": []
            },
            {
              "id": "skid-steer-ctl-vermeer-s925tx",
              "name": "S925TX",
              "subcategories": []
            },
            {
              "id": "skid-steer-ctl-vermeer-other",
              "name": "OTHER",
              "subcategories": []
            }
          ]
        },
        {
          "id": "skid-steer-ctl-yanmar",
          "name": "Yanmar",
          "subcategories": [
            {
              "id": "skid-steer-ctl-yanmar-s190",
              "name": "S190",
              "subcategories": []
            },
            {
              "id": "skid-steer-ctl-yanmar-s220",
              "name": "S220",
              "subcategories": []
            },
            {
              "id": "skid-steer-ctl-yanmar-s220r",
              "name": "S220R",
              "subcategories": []
            },
            {
              "id": "skid-steer-ctl-yanmar-s270",
              "name": "S270",
              "subcategories": []
            },
            {
              "id": "skid-steer-ctl-yanmar-s270v",
              "name": "S270V",
              "subcategories": []
            },
            {
              "id": "skid-steer-ctl-yanmar-s270v-1",
              "name": "S270V-1",
              "subcategories": []
            },
            {
              "id": "skid-steer-ctl-yanmar-t175",
              "name": "T175",
              "subcategories": []
            },
            {
              "id": "skid-steer-ctl-yanmar-t210",
              "name": "T210",
              "subcategories": []
            },
            {
              "id": "skid-steer-ctl-yanmar-t210-1",
              "name": "T210-1",
              "subcategories": []
            },
            {
              "id": "skid-steer-ctl-yanmar-tl65rs",
              "name": "TL65RS",
              "subcategories": []
            },
            {
              "id": "skid-steer-ctl-yanmar-tl75vs",
              "name": "TL75VS",
              "subcategories": []
            },
            {
              "id": "skid-steer-ctl-yanmar-tl80vs",
              "name": "TL80VS",
              "subcategories": []
            },
            {
              "id": "skid-steer-ctl-yanmar-tl100vs",
              "name": "TL100VS",
              "subcategories": []
            },
            {
              "id": "skid-steer-ctl-yanmar-other",
              "name": "OTHER",
              "subcategories": []
            }
          ]
        },
        {
          "id": "skid-steer-ctl-xcmg",
          "name": "Xcmg",
          "subcategories": [
            {
              "id": "skid-steer-ctl-xcmg-us50t",
              "name": "US50T",
              "subcategories": []
            },
            {
              "id": "skid-steer-ctl-xcmg-xc7-sr07",
              "name": "XC7-SR07",
              "subcategories": []
            },
            {
              "id": "skid-steer-ctl-xcmg-xc7-sr08",
              "name": "XC7-SR08",
              "subcategories": []
            },
            {
              "id": "skid-steer-ctl-xcmg-xc7-sr10",
              "name": "XC7-SR10",
              "subcategories": []
            },
            {
              "id": "skid-steer-ctl-xcmg-xc7-sr12",
              "name": "XC7-SR12",
              "subcategories": []
            },
            {
              "id": "skid-steer-ctl-xcmg-xc7-sv12",
              "name": "XC7-SV12",
              "subcategories": []
            },
            {
              "id": "skid-steer-ctl-xcmg-xc7-tv12",
              "name": "XC7-TV12",
              "subcategories": []
            },
            {
              "id": "skid-steer-ctl-xcmg-xc740k",
              "name": "XC740K",
              "subcategories": []
            },
            {
              "id": "skid-steer-ctl-xcmg-xc750k",
              "name": "XC750K",
              "subcategories": []
            },
            {
              "id": "skid-steer-ctl-xcmg-xc760k",
              "name": "XC760K",
              "subcategories": []
            },
            {
              "id": "skid-steer-ctl-xcmg-xc770k",
              "name": "XC770K",
              "subcategories": []
            },
            {
              "id": "skid-steer-ctl-xcmg-other",
              "name": "OTHER",
              "subcategories": []
            }
          ]
        },
        {
          "id": "skid-steer-ctl-hyundai",
          "name": "Hyundai",
          "subcategories": [
            {
              "id": "skid-steer-ctl-hyundai-hs120v",
              "name": "HS120V",
              "subcategories": []
            },
            {
              "id": "skid-steer-ctl-hyundai-ht38",
              "name": "HT38",
              "subcategories": []
            },
            {
              "id": "skid-steer-ctl-hyundai-ht100v",
              "name": "HT100V",
              "subcategories": []
            },
            {
              "id": "skid-steer-ctl-hyundai-other",
              "name": "OTHER",
              "subcategories": []
            }
          ]
        },
        {
          "id": "skid-steer-ctl-kioti",
          "name": "Kioti",
          "subcategories": [
            {
              "id": "skid-steer-ctl-kioti-sl750",
              "name": "SL750",
              "subcategories": []
            },
            {
              "id": "skid-steer-ctl-kioti-sl750u",
              "name": "SL750U",
              "subcategories": []
            },
            {
              "id": "skid-steer-ctl-kioti-tl750",
              "name": "TL750",
              "subcategories": []
            },
            {
              "id": "skid-steer-ctl-kioti-tl750-flow",
              "name": "TL750 FLOW+",
              "subcategories": []
            },
            {
              "id": "skid-steer-ctl-kioti-other",
              "name": "OTHER",
              "subcategories": []
            }
          ]
        },
        {
          "id": "skid-steer-ctl-manitou",
          "name": "Manitou",
          "subcategories": [
            {
              "id": "skid-steer-ctl-manitou-850r",
              "name": "850R",
              "subcategories": []
            },
            {
              "id": "skid-steer-ctl-manitou-1050r",
              "name": "1050R",
              "subcategories": []
            },
            {
              "id": "skid-steer-ctl-manitou-1050rt",
              "name": "1050RT",
              "subcategories": []
            },
            {
              "id": "skid-steer-ctl-manitou-1350r",
              "name": "1350R",
              "subcategories": []
            },
            {
              "id": "skid-steer-ctl-manitou-1350rt",
              "name": "1350RT",
              "subcategories": []
            },
            {
              "id": "skid-steer-ctl-manitou-1500r",
              "name": "1500R",
              "subcategories": []
            },
            {
              "id": "skid-steer-ctl-manitou-1650r",
              "name": "1650R",
              "subcategories": []
            },
            {
              "id": "skid-steer-ctl-manitou-1650rt",
              "name": "1650RT",
              "subcategories": []
            },
            {
              "id": "skid-steer-ctl-manitou-1850rt",
              "name": "1850RT",
              "subcategories": []
            },
            {
              "id": "skid-steer-ctl-manitou-1900r",
              "name": "1900R",
              "subcategories": []
            },
            {
              "id": "skid-steer-ctl-manitou-1900r-nxt2",
              "name": "1900R NXT2",
              "subcategories": []
            },
            {
              "id": "skid-steer-ctl-manitou-1950rt",
              "name": "1950RT",
              "subcategories": []
            },
            {
              "id": "skid-steer-ctl-manitou-2100v",
              "name": "2100V",
              "subcategories": []
            },
            {
              "id": "skid-steer-ctl-manitou-2100vt",
              "name": "2100VT",
              "subcategories": []
            },
            {
              "id": "skid-steer-ctl-manitou-2150rt",
              "name": "2150RT",
              "subcategories": []
            },
            {
              "id": "skid-steer-ctl-manitou-2200r",
              "name": "2200R",
              "subcategories": []
            },
            {
              "id": "skid-steer-ctl-manitou-2300v",
              "name": "2300V",
              "subcategories": []
            },
            {
              "id": "skid-steer-ctl-manitou-2300vt",
              "name": "2300VT",
              "subcategories": []
            },
            {
              "id": "skid-steer-ctl-manitou-2550rt",
              "name": "2550RT",
              "subcategories": []
            },
            {
              "id": "skid-steer-ctl-manitou-2600r",
              "name": "2600R",
              "subcategories": []
            },
            {
              "id": "skid-steer-ctl-manitou-2700v",
              "name": "2700V",
              "subcategories": []
            },
            {
              "id": "skid-steer-ctl-manitou-2700v-nxt2",
              "name": "2700V NXT2",
              "subcategories": []
            },
            {
              "id": "skid-steer-ctl-manitou-2750v",
              "name": "2750V",
              "subcategories": []
            },
            {
              "id": "skid-steer-ctl-manitou-2750vt",
              "name": "2750VT",
              "subcategories": []
            },
            {
              "id": "skid-steer-ctl-manitou-3200vt",
              "name": "3200VT",
              "subcategories": []
            },
            {
              "id": "skid-steer-ctl-manitou-3250v",
              "name": "3250V",
              "subcategories": []
            },
            {
              "id": "skid-steer-ctl-manitou-3300v",
              "name": "3300V",
              "subcategories": []
            },
            {
              "id": "skid-steer-ctl-manitou-3350v",
              "name": "3350V",
              "subcategories": []
            },
            {
              "id": "skid-steer-ctl-manitou-3350vt",
              "name": "3350VT",
              "subcategories": []
            },
            {
              "id": "skid-steer-ctl-manitou-3600v",
              "name": "3600V",
              "subcategories": []
            },
            {
              "id": "skid-steer-ctl-manitou-3600vt",
              "name": "3600VT",
              "subcategories": []
            },
            {
              "id": "skid-steer-ctl-manitou-other",
              "name": "OTHER",
              "subcategories": []
            }
          ]
        },
        {
          "id": "skid-steer-ctl-uhi",
          "name": "Uhi",
          "subcategories": [
            {
              "id": "skid-steer-ctl-uhi-model",
              "name": "MODEL",
              "subcategories": []
            },
            {
              "id": "skid-steer-ctl-uhi-30d",
              "name": "30D",
              "subcategories": []
            },
            {
              "id": "skid-steer-ctl-uhi-30t",
              "name": "30T",
              "subcategories": []
            },
            {
              "id": "skid-steer-ctl-uhi-cdm303",
              "name": "CDM303",
              "subcategories": []
            },
            {
              "id": "skid-steer-ctl-uhi-cdm308",
              "name": "CDM308",
              "subcategories": []
            },
            {
              "id": "skid-steer-ctl-uhi-cdm311t",
              "name": "CDM311T",
              "subcategories": []
            },
            {
              "id": "skid-steer-ctl-uhi-cdm315t",
              "name": "CDM315T",
              "subcategories": []
            },
            {
              "id": "skid-steer-ctl-uhi-t45",
              "name": "T45",
              "subcategories": []
            },
            {
              "id": "skid-steer-ctl-uhi-t45n",
              "name": "T45N",
              "subcategories": []
            },
            {
              "id": "skid-steer-ctl-uhi-u25tk2",
              "name": "U25TK2",
              "subcategories": []
            },
            {
              "id": "skid-steer-ctl-uhi-ust120w",
              "name": "UST120W",
              "subcategories": []
            },
            {
              "id": "skid-steer-ctl-uhi-other",
              "name": "OTHER",
              "subcategories": []
            }
          ]
        }
      ]
    },
    {
      "id": "telehandlers",
      "name": "Telehandlers",
      "subcategories": [
        {
          "id": "telehandlers-telehandler",
          "name": "Telehandler",
          "subcategories": [
            {
              "id": "telehandlers-telehandler-jcb",
              "name": "JCB",
              "subcategories": []
            },
            {
              "id": "telehandlers-telehandler-sky-trak",
              "name": "SKY TRAK",
              "subcategories": []
            },
            {
              "id": "telehandlers-telehandler-jlg",
              "name": "JLG",
              "subcategories": []
            },
            {
              "id": "telehandlers-telehandler-genie",
              "name": "GENIE",
              "subcategories": []
            },
            {
              "id": "telehandlers-telehandler-manitou",
              "name": "MANITOU",
              "subcategories": []
            },
            {
              "id": "telehandlers-telehandler-gehl",
              "name": "GEHL",
              "subcategories": []
            },
            {
              "id": "telehandlers-telehandler-caterpillar",
              "name": "CATERPILLAR",
              "subcategories": []
            },
            {
              "id": "telehandlers-telehandler-skyjack",
              "name": "SKYJACK",
              "subcategories": []
            },
            {
              "id": "telehandlers-telehandler-merlo",
              "name": "MERLO",
              "subcategories": []
            },
            {
              "id": "telehandlers-telehandler-magni",
              "name": "MAGNI",
              "subcategories": []
            },
            {
              "id": "telehandlers-telehandler-bobcat",
              "name": "BOBCAT",
              "subcategories": []
            },
            {
              "id": "telehandlers-telehandler-dieci",
              "name": "DIECI",
              "subcategories": []
            },
            {
              "id": "telehandlers-telehandler-claas",
              "name": "CLAAS",
              "subcategories": []
            },
            {
              "id": "telehandlers-telehandler-kramer",
              "name": "KRAMER",
              "subcategories": []
            },
            {
              "id": "telehandlers-telehandler-load-lifter",
              "name": "LOAD LIFTER",
              "subcategories": []
            },
            {
              "id": "telehandlers-telehandler-lull",
              "name": "LULL",
              "subcategories": []
            },
            {
              "id": "telehandlers-telehandler-new-holland",
              "name": "NEW HOLLAND",
              "subcategories": []
            },
            {
              "id": "telehandlers-telehandler-pettibone",
              "name": "PETTIBONE",
              "subcategories": []
            },
            {
              "id": "telehandlers-telehandler-sany",
              "name": "SANY",
              "subcategories": []
            }
          ]
        },
        {
          "id": "telehandlers-jcb",
          "name": "Jcb",
          "subcategories": [
            {
              "id": "telehandlers-jcb-25",
              "name": "25",
              "subcategories": []
            },
            {
              "id": "telehandlers-jcb-27",
              "name": "27",
              "subcategories": []
            },
            {
              "id": "telehandlers-jcb-30",
              "name": "30",
              "subcategories": []
            },
            {
              "id": "telehandlers-jcb-35",
              "name": "35",
              "subcategories": []
            },
            {
              "id": "telehandlers-jcb-55",
              "name": "55",
              "subcategories": []
            },
            {
              "id": "telehandlers-jcb-77",
              "name": "77",
              "subcategories": []
            },
            {
              "id": "telehandlers-jcb-504",
              "name": "504",
              "subcategories": []
            },
            {
              "id": "telehandlers-jcb-505",
              "name": "505",
              "subcategories": []
            },
            {
              "id": "telehandlers-jcb-506",
              "name": "506",
              "subcategories": []
            },
            {
              "id": "telehandlers-jcb-507",
              "name": "507",
              "subcategories": []
            },
            {
              "id": "telehandlers-jcb-508",
              "name": "508",
              "subcategories": []
            },
            {
              "id": "telehandlers-jcb-509",
              "name": "509",
              "subcategories": []
            },
            {
              "id": "telehandlers-jcb-510",
              "name": "510",
              "subcategories": []
            },
            {
              "id": "telehandlers-jcb-512",
              "name": "512",
              "subcategories": []
            },
            {
              "id": "telehandlers-jcb-514",
              "name": "514",
              "subcategories": []
            },
            {
              "id": "telehandlers-jcb-515",
              "name": "515",
              "subcategories": []
            },
            {
              "id": "telehandlers-jcb-516",
              "name": "516",
              "subcategories": []
            },
            {
              "id": "telehandlers-jcb-520",
              "name": "520",
              "subcategories": []
            },
            {
              "id": "telehandlers-jcb-524",
              "name": "524",
              "subcategories": []
            },
            {
              "id": "telehandlers-jcb-525",
              "name": "525",
              "subcategories": []
            },
            {
              "id": "telehandlers-jcb-526",
              "name": "526",
              "subcategories": []
            },
            {
              "id": "telehandlers-jcb-527",
              "name": "527",
              "subcategories": []
            },
            {
              "id": "telehandlers-jcb-528",
              "name": "528",
              "subcategories": []
            },
            {
              "id": "telehandlers-jcb-530",
              "name": "530",
              "subcategories": []
            },
            {
              "id": "telehandlers-jcb-531",
              "name": "531",
              "subcategories": []
            },
            {
              "id": "telehandlers-jcb-532",
              "name": "532",
              "subcategories": []
            },
            {
              "id": "telehandlers-jcb-533",
              "name": "533",
              "subcategories": []
            },
            {
              "id": "telehandlers-jcb-535",
              "name": "535",
              "subcategories": []
            },
            {
              "id": "telehandlers-jcb-536",
              "name": "536",
              "subcategories": []
            },
            {
              "id": "telehandlers-jcb-537",
              "name": "537",
              "subcategories": []
            },
            {
              "id": "telehandlers-jcb-538",
              "name": "538",
              "subcategories": []
            },
            {
              "id": "telehandlers-jcb-540",
              "name": "540",
              "subcategories": []
            },
            {
              "id": "telehandlers-jcb-541",
              "name": "541",
              "subcategories": []
            },
            {
              "id": "telehandlers-jcb-542",
              "name": "542",
              "subcategories": []
            },
            {
              "id": "telehandlers-jcb-550",
              "name": "550",
              "subcategories": []
            },
            {
              "id": "telehandlers-jcb-555",
              "name": "555",
              "subcategories": []
            },
            {
              "id": "telehandlers-jcb-560",
              "name": "560",
              "subcategories": []
            },
            {
              "id": "telehandlers-jcb-5508",
              "name": "5508",
              "subcategories": []
            },
            {
              "id": "telehandlers-jcb-tm320",
              "name": "TM320",
              "subcategories": []
            },
            {
              "id": "telehandlers-jcb-other",
              "name": "OTHER",
              "subcategories": []
            }
          ]
        },
        {
          "id": "telehandlers-sky-trak",
          "name": "Sky Trak",
          "subcategories": [
            {
              "id": "telehandlers-sky-trak-3013",
              "name": "3013",
              "subcategories": []
            },
            {
              "id": "telehandlers-sky-trak-3606",
              "name": "3606",
              "subcategories": []
            },
            {
              "id": "telehandlers-sky-trak-5028",
              "name": "5028",
              "subcategories": []
            },
            {
              "id": "telehandlers-sky-trak-6000",
              "name": "6000",
              "subcategories": []
            },
            {
              "id": "telehandlers-sky-trak-6034",
              "name": "6034",
              "subcategories": []
            },
            {
              "id": "telehandlers-sky-trak-6036",
              "name": "6036",
              "subcategories": []
            },
            {
              "id": "telehandlers-sky-trak-6042",
              "name": "6042",
              "subcategories": []
            },
            {
              "id": "telehandlers-sky-trak-7038",
              "name": "7038",
              "subcategories": []
            },
            {
              "id": "telehandlers-sky-trak-8042",
              "name": "8042",
              "subcategories": []
            },
            {
              "id": "telehandlers-sky-trak-9038",
              "name": "9038",
              "subcategories": []
            },
            {
              "id": "telehandlers-sky-trak-10042",
              "name": "10042",
              "subcategories": []
            },
            {
              "id": "telehandlers-sky-trak-10054",
              "name": "10054",
              "subcategories": []
            },
            {
              "id": "telehandlers-sky-trak-12054",
              "name": "12054",
              "subcategories": []
            },
            {
              "id": "telehandlers-sky-trak-g5",
              "name": "G5",
              "subcategories": []
            },
            {
              "id": "telehandlers-sky-trak-mmv",
              "name": "MMV",
              "subcategories": []
            },
            {
              "id": "telehandlers-sky-trak-other",
              "name": "OTHER",
              "subcategories": []
            }
          ]
        },
        {
          "id": "telehandlers-jlg",
          "name": "Jlg",
          "subcategories": [
            {
              "id": "telehandlers-jlg-266",
              "name": "266",
              "subcategories": []
            },
            {
              "id": "telehandlers-jlg-307",
              "name": "307",
              "subcategories": []
            },
            {
              "id": "telehandlers-jlg-313",
              "name": "313",
              "subcategories": []
            },
            {
              "id": "telehandlers-jlg-519",
              "name": "519",
              "subcategories": []
            },
            {
              "id": "telehandlers-jlg-544d",
              "name": "544D",
              "subcategories": []
            },
            {
              "id": "telehandlers-jlg-642",
              "name": "642",
              "subcategories": []
            },
            {
              "id": "telehandlers-jlg-644",
              "name": "644",
              "subcategories": []
            },
            {
              "id": "telehandlers-jlg-742",
              "name": "742",
              "subcategories": []
            },
            {
              "id": "telehandlers-jlg-823",
              "name": "823",
              "subcategories": []
            },
            {
              "id": "telehandlers-jlg-832",
              "name": "832",
              "subcategories": []
            },
            {
              "id": "telehandlers-jlg-925",
              "name": "925",
              "subcategories": []
            },
            {
              "id": "telehandlers-jlg-943",
              "name": "943",
              "subcategories": []
            },
            {
              "id": "telehandlers-jlg-944",
              "name": "944",
              "subcategories": []
            },
            {
              "id": "telehandlers-jlg-1043",
              "name": "1043",
              "subcategories": []
            },
            {
              "id": "telehandlers-jlg-1044",
              "name": "1044",
              "subcategories": []
            },
            {
              "id": "telehandlers-jlg-1055",
              "name": "1055",
              "subcategories": []
            },
            {
              "id": "telehandlers-jlg-1075",
              "name": "1075",
              "subcategories": []
            },
            {
              "id": "telehandlers-jlg-1255",
              "name": "1255",
              "subcategories": []
            },
            {
              "id": "telehandlers-jlg-1644",
              "name": "1644",
              "subcategories": []
            },
            {
              "id": "telehandlers-jlg-1732",
              "name": "1732",
              "subcategories": []
            },
            {
              "id": "telehandlers-jlg-2733",
              "name": "2733",
              "subcategories": []
            },
            {
              "id": "telehandlers-jlg-3509",
              "name": "3509",
              "subcategories": []
            },
            {
              "id": "telehandlers-jlg-3512",
              "name": "3512",
              "subcategories": []
            },
            {
              "id": "telehandlers-jlg-3513",
              "name": "3513",
              "subcategories": []
            },
            {
              "id": "telehandlers-jlg-4009",
              "name": "4009",
              "subcategories": []
            },
            {
              "id": "telehandlers-jlg-4013",
              "name": "4013",
              "subcategories": []
            },
            {
              "id": "telehandlers-jlg-4017",
              "name": "4017",
              "subcategories": []
            },
            {
              "id": "telehandlers-jlg-6042",
              "name": "6042",
              "subcategories": []
            },
            {
              "id": "telehandlers-jlg-ag313",
              "name": "AG313",
              "subcategories": []
            },
            {
              "id": "telehandlers-jlg-ag519",
              "name": "AG519",
              "subcategories": []
            },
            {
              "id": "telehandlers-jlg-ag823",
              "name": "AG823",
              "subcategories": []
            },
            {
              "id": "telehandlers-jlg-ag832",
              "name": "AG832",
              "subcategories": []
            },
            {
              "id": "telehandlers-jlg-ag925",
              "name": "AG925",
              "subcategories": []
            },
            {
              "id": "telehandlers-jlg-e313",
              "name": "E313",
              "subcategories": []
            },
            {
              "id": "telehandlers-jlg-g5",
              "name": "G5",
              "subcategories": []
            },
            {
              "id": "telehandlers-jlg-g6",
              "name": "G6",
              "subcategories": []
            },
            {
              "id": "telehandlers-jlg-g9",
              "name": "G9",
              "subcategories": []
            },
            {
              "id": "telehandlers-jlg-g10",
              "name": "G10",
              "subcategories": []
            },
            {
              "id": "telehandlers-jlg-g12",
              "name": "G12",
              "subcategories": []
            },
            {
              "id": "telehandlers-jlg-g15",
              "name": "G15",
              "subcategories": []
            },
            {
              "id": "telehandlers-jlg-r1370",
              "name": "R1370",
              "subcategories": []
            },
            {
              "id": "telehandlers-jlg-r1385",
              "name": "R1385",
              "subcategories": []
            },
            {
              "id": "telehandlers-jlg-r11100",
              "name": "R11100",
              "subcategories": []
            },
            {
              "id": "telehandlers-jlg-r13100",
              "name": "R13100",
              "subcategories": []
            },
            {
              "id": "telehandlers-jlg-other",
              "name": "OTHER",
              "subcategories": []
            }
          ]
        },
        {
          "id": "telehandlers-genie",
          "name": "Genie",
          "subcategories": [
            {
              "id": "telehandlers-genie-gth007",
              "name": "GTH007",
              "subcategories": []
            },
            {
              "id": "telehandlers-genie-gth636",
              "name": "GTH636",
              "subcategories": []
            },
            {
              "id": "telehandlers-genie-gth644",
              "name": "GTH644",
              "subcategories": []
            },
            {
              "id": "telehandlers-genie-gth842",
              "name": "GTH842",
              "subcategories": []
            },
            {
              "id": "telehandlers-genie-gth844",
              "name": "GTH844",
              "subcategories": []
            },
            {
              "id": "telehandlers-genie-gth1056",
              "name": "GTH1056",
              "subcategories": []
            },
            {
              "id": "telehandlers-genie-gth1256",
              "name": "GTH1256",
              "subcategories": []
            },
            {
              "id": "telehandlers-genie-gth1544",
              "name": "GTH1544",
              "subcategories": []
            },
            {
              "id": "telehandlers-genie-gth2506",
              "name": "GTH2506",
              "subcategories": []
            },
            {
              "id": "telehandlers-genie-gth3007",
              "name": "GTH3007",
              "subcategories": []
            },
            {
              "id": "telehandlers-genie-gth4010",
              "name": "GTH4010",
              "subcategories": []
            },
            {
              "id": "telehandlers-genie-gth4013",
              "name": "GTH4013",
              "subcategories": []
            },
            {
              "id": "telehandlers-genie-gth4014",
              "name": "GTH4014",
              "subcategories": []
            },
            {
              "id": "telehandlers-genie-gth4017",
              "name": "GTH4017",
              "subcategories": []
            },
            {
              "id": "telehandlers-genie-gth4018",
              "name": "GTH4018",
              "subcategories": []
            },
            {
              "id": "telehandlers-genie-gth5022",
              "name": "GTH5022",
              "subcategories": []
            },
            {
              "id": "telehandlers-genie-gth5519",
              "name": "GTH5519",
              "subcategories": []
            },
            {
              "id": "telehandlers-genie-gth6622",
              "name": "GTH6622",
              "subcategories": []
            },
            {
              "id": "telehandlers-genie-other",
              "name": "OTHER",
              "subcategories": []
            }
          ]
        },
        {
          "id": "telehandlers-manitou",
          "name": "Manitou",
          "subcategories": [
            {
              "id": "telehandlers-manitou-bt420",
              "name": "BT420",
              "subcategories": []
            },
            {
              "id": "telehandlers-manitou-bt425",
              "name": "BT425",
              "subcategories": []
            },
            {
              "id": "telehandlers-manitou-mht780",
              "name": "MHT780",
              "subcategories": []
            },
            {
              "id": "telehandlers-manitou-mht790",
              "name": "MHT790",
              "subcategories": []
            },
            {
              "id": "telehandlers-manitou-mht860",
              "name": "MHT860",
              "subcategories": []
            },
            {
              "id": "telehandlers-manitou-mht950",
              "name": "MHT950",
              "subcategories": []
            },
            {
              "id": "telehandlers-manitou-mht1490",
              "name": "MHT1490",
              "subcategories": []
            },
            {
              "id": "telehandlers-manitou-mht10120",
              "name": "MHT10120",
              "subcategories": []
            },
            {
              "id": "telehandlers-manitou-mht10130",
              "name": "MHT10130",
              "subcategories": []
            },
            {
              "id": "telehandlers-manitou-mht10135",
              "name": "MHT10135",
              "subcategories": []
            },
            {
              "id": "telehandlers-manitou-mht10160",
              "name": "MHT10160",
              "subcategories": []
            },
            {
              "id": "telehandlers-manitou-mht10180",
              "name": "MHT10180",
              "subcategories": []
            },
            {
              "id": "telehandlers-manitou-mht10200",
              "name": "MHT10200",
              "subcategories": []
            },
            {
              "id": "telehandlers-manitou-mht10210",
              "name": "MHT10210",
              "subcategories": []
            },
            {
              "id": "telehandlers-manitou-mht10225",
              "name": "MHT10225",
              "subcategories": []
            },
            {
              "id": "telehandlers-manitou-mht10230",
              "name": "MHT10230",
              "subcategories": []
            },
            {
              "id": "telehandlers-manitou-mht11250",
              "name": "MHT11250",
              "subcategories": []
            },
            {
              "id": "telehandlers-manitou-mht12330",
              "name": "MHT12330",
              "subcategories": []
            },
            {
              "id": "telehandlers-manitou-mhtx780",
              "name": "MHTX780",
              "subcategories": []
            },
            {
              "id": "telehandlers-manitou-mhtx790",
              "name": "MHTX790",
              "subcategories": []
            },
            {
              "id": "telehandlers-manitou-mhtx10120",
              "name": "MHTX10120",
              "subcategories": []
            },
            {
              "id": "telehandlers-manitou-mhtx10130",
              "name": "MHTX10130",
              "subcategories": []
            },
            {
              "id": "telehandlers-manitou-mla627",
              "name": "MLA627",
              "subcategories": []
            },
            {
              "id": "telehandlers-manitou-mlt420",
              "name": "MLT420",
              "subcategories": []
            },
            {
              "id": "telehandlers-manitou-mlt523",
              "name": "MLT523",
              "subcategories": []
            },
            {
              "id": "telehandlers-manitou-mlt524",
              "name": "MLT524",
              "subcategories": []
            },
            {
              "id": "telehandlers-manitou-mlt526",
              "name": "MLT526",
              "subcategories": []
            },
            {
              "id": "telehandlers-manitou-mlt625",
              "name": "MLT625",
              "subcategories": []
            },
            {
              "id": "telehandlers-manitou-mlt626",
              "name": "MLT626",
              "subcategories": []
            },
            {
              "id": "telehandlers-manitou-mlt627",
              "name": "MLT627",
              "subcategories": []
            },
            {
              "id": "telehandlers-manitou-mlt629",
              "name": "MLT629",
              "subcategories": []
            },
            {
              "id": "telehandlers-manitou-mlt630",
              "name": "MLT630",
              "subcategories": []
            },
            {
              "id": "telehandlers-manitou-mlt633",
              "name": "MLT633",
              "subcategories": []
            },
            {
              "id": "telehandlers-manitou-mlt634",
              "name": "MLT634",
              "subcategories": []
            },
            {
              "id": "telehandlers-manitou-mlt635",
              "name": "MLT635",
              "subcategories": []
            },
            {
              "id": "telehandlers-manitou-mlt730",
              "name": "MLT730",
              "subcategories": []
            },
            {
              "id": "telehandlers-manitou-mlt731",
              "name": "MLT731",
              "subcategories": []
            },
            {
              "id": "telehandlers-manitou-mlt732",
              "name": "MLT732",
              "subcategories": []
            },
            {
              "id": "telehandlers-manitou-mlt733",
              "name": "MLT733",
              "subcategories": []
            },
            {
              "id": "telehandlers-manitou-mlt735",
              "name": "MLT735",
              "subcategories": []
            },
            {
              "id": "telehandlers-manitou-mlt737",
              "name": "MLT737",
              "subcategories": []
            },
            {
              "id": "telehandlers-manitou-mlt738",
              "name": "MLT738",
              "subcategories": []
            },
            {
              "id": "telehandlers-manitou-mlt741",
              "name": "MLT741",
              "subcategories": []
            },
            {
              "id": "telehandlers-manitou-mlt742",
              "name": "MLT742",
              "subcategories": []
            },
            {
              "id": "telehandlers-manitou-mlt840",
              "name": "MLT840",
              "subcategories": []
            },
            {
              "id": "telehandlers-manitou-mlt841",
              "name": "MLT841",
              "subcategories": []
            },
            {
              "id": "telehandlers-manitou-mlt845",
              "name": "MLT845",
              "subcategories": []
            },
            {
              "id": "telehandlers-manitou-mlt850",
              "name": "MLT850",
              "subcategories": []
            },
            {
              "id": "telehandlers-manitou-mlt935",
              "name": "MLT935",
              "subcategories": []
            },
            {
              "id": "telehandlers-manitou-mlt940",
              "name": "MLT940",
              "subcategories": []
            },
            {
              "id": "telehandlers-manitou-mlt960",
              "name": "MLT960",
              "subcategories": []
            },
            {
              "id": "telehandlers-manitou-mlt961",
              "name": "MLT961",
              "subcategories": []
            },
            {
              "id": "telehandlers-manitou-mlt1035",
              "name": "MLT1035",
              "subcategories": []
            },
            {
              "id": "telehandlers-manitou-mlt1040",
              "name": "MLT1040",
              "subcategories": []
            },
            {
              "id": "telehandlers-manitou-mlt1041",
              "name": "MLT1041",
              "subcategories": []
            },
            {
              "id": "telehandlers-manitou-mltx732",
              "name": "MLTX732",
              "subcategories": []
            },
            {
              "id": "telehandlers-manitou-mltx735",
              "name": "MLTX735",
              "subcategories": []
            },
            {
              "id": "telehandlers-manitou-mltx741",
              "name": "MLTX741",
              "subcategories": []
            },
            {
              "id": "telehandlers-manitou-mltx840",
              "name": "MLTX840",
              "subcategories": []
            },
            {
              "id": "telehandlers-manitou-mrt1432",
              "name": "MRT1432",
              "subcategories": []
            },
            {
              "id": "telehandlers-manitou-mrt1635",
              "name": "MRT1635",
              "subcategories": []
            },
            {
              "id": "telehandlers-manitou-mrt1640",
              "name": "MRT1640",
              "subcategories": []
            },
            {
              "id": "telehandlers-manitou-mrt1742",
              "name": "MRT1742",
              "subcategories": []
            },
            {
              "id": "telehandlers-manitou-mrt1840",
              "name": "MRT1840",
              "subcategories": []
            },
            {
              "id": "telehandlers-manitou-mrt1845",
              "name": "MRT1845",
              "subcategories": []
            },
            {
              "id": "telehandlers-manitou-mrt1850",
              "name": "MRT1850",
              "subcategories": []
            },
            {
              "id": "telehandlers-manitou-mrt2145",
              "name": "MRT2145",
              "subcategories": []
            },
            {
              "id": "telehandlers-manitou-mrt2150",
              "name": "MRT2150",
              "subcategories": []
            },
            {
              "id": "telehandlers-manitou-mrt2260",
              "name": "MRT2260",
              "subcategories": []
            },
            {
              "id": "telehandlers-manitou-mrt2470",
              "name": "MRT2470",
              "subcategories": []
            },
            {
              "id": "telehandlers-manitou-mrt2540",
              "name": "MRT2540",
              "subcategories": []
            },
            {
              "id": "telehandlers-manitou-mrt2545",
              "name": "MRT2545",
              "subcategories": []
            },
            {
              "id": "telehandlers-manitou-mrt2550",
              "name": "MRT2550",
              "subcategories": []
            },
            {
              "id": "telehandlers-manitou-mrt2570",
              "name": "MRT2570",
              "subcategories": []
            },
            {
              "id": "telehandlers-manitou-mrt2660",
              "name": "MRT2660",
              "subcategories": []
            },
            {
              "id": "telehandlers-manitou-mrt3050",
              "name": "MRT3050",
              "subcategories": []
            },
            {
              "id": "telehandlers-manitou-mrt3060",
              "name": "MRT3060",
              "subcategories": []
            },
            {
              "id": "telehandlers-manitou-mrt3255",
              "name": "MRT3255",
              "subcategories": []
            },
            {
              "id": "telehandlers-manitou-mrt3570",
              "name": "MRT3570",
              "subcategories": []
            },
            {
              "id": "telehandlers-manitou-mrtx1840",
              "name": "MRTX1840",
              "subcategories": []
            },
            {
              "id": "telehandlers-manitou-mt420",
              "name": "MT420",
              "subcategories": []
            },
            {
              "id": "telehandlers-manitou-mt425",
              "name": "MT425",
              "subcategories": []
            },
            {
              "id": "telehandlers-manitou-mt430",
              "name": "MT430",
              "subcategories": []
            },
            {
              "id": "telehandlers-manitou-mt523",
              "name": "MT523",
              "subcategories": []
            },
            {
              "id": "telehandlers-manitou-mt625",
              "name": "MT625",
              "subcategories": []
            },
            {
              "id": "telehandlers-manitou-mt703",
              "name": "MT703",
              "subcategories": []
            },
            {
              "id": "telehandlers-manitou-mt730",
              "name": "MT730",
              "subcategories": []
            },
            {
              "id": "telehandlers-manitou-mt732",
              "name": "MT732",
              "subcategories": []
            },
            {
              "id": "telehandlers-manitou-mt733",
              "name": "MT733",
              "subcategories": []
            },
            {
              "id": "telehandlers-manitou-mt735",
              "name": "MT735",
              "subcategories": []
            },
            {
              "id": "telehandlers-manitou-mt835",
              "name": "MT835",
              "subcategories": []
            },
            {
              "id": "telehandlers-manitou-mt840",
              "name": "MT840",
              "subcategories": []
            },
            {
              "id": "telehandlers-manitou-mt930",
              "name": "MT930",
              "subcategories": []
            },
            {
              "id": "telehandlers-manitou-mt932",
              "name": "MT932",
              "subcategories": []
            },
            {
              "id": "telehandlers-manitou-mt933",
              "name": "MT933",
              "subcategories": []
            },
            {
              "id": "telehandlers-manitou-mt935",
              "name": "MT935",
              "subcategories": []
            },
            {
              "id": "telehandlers-manitou-mt1030",
              "name": "MT1030",
              "subcategories": []
            },
            {
              "id": "telehandlers-manitou-mt1033",
              "name": "MT1033",
              "subcategories": []
            },
            {
              "id": "telehandlers-manitou-mt1040",
              "name": "MT1040",
              "subcategories": []
            },
            {
              "id": "telehandlers-manitou-mt1044",
              "name": "MT1044",
              "subcategories": []
            },
            {
              "id": "telehandlers-manitou-mt1058",
              "name": "MT1058",
              "subcategories": []
            },
            {
              "id": "telehandlers-manitou-mt1135",
              "name": "MT1135",
              "subcategories": []
            },
            {
              "id": "telehandlers-manitou-mt1230",
              "name": "MT1230",
              "subcategories": []
            },
            {
              "id": "telehandlers-manitou-mt1232",
              "name": "MT1232",
              "subcategories": []
            },
            {
              "id": "telehandlers-manitou-mt1233",
              "name": "MT1233",
              "subcategories": []
            },
            {
              "id": "telehandlers-manitou-mt1235",
              "name": "MT1235",
              "subcategories": []
            },
            {
              "id": "telehandlers-manitou-mt1240",
              "name": "MT1240",
              "subcategories": []
            },
            {
              "id": "telehandlers-manitou-mt1330",
              "name": "MT1330",
              "subcategories": []
            },
            {
              "id": "telehandlers-manitou-mt1335",
              "name": "MT1335",
              "subcategories": []
            },
            {
              "id": "telehandlers-manitou-mt1337",
              "name": "MT1337",
              "subcategories": []
            },
            {
              "id": "telehandlers-manitou-mt1435",
              "name": "MT1435",
              "subcategories": []
            },
            {
              "id": "telehandlers-manitou-mt1436",
              "name": "MT1436",
              "subcategories": []
            },
            {
              "id": "telehandlers-manitou-mt1440",
              "name": "MT1440",
              "subcategories": []
            },
            {
              "id": "telehandlers-manitou-mt1645",
              "name": "MT1645",
              "subcategories": []
            },
            {
              "id": "telehandlers-manitou-mt1740",
              "name": "MT1740",
              "subcategories": []
            },
            {
              "id": "telehandlers-manitou-mt1745",
              "name": "MT1745",
              "subcategories": []
            },
            {
              "id": "telehandlers-manitou-mt1840",
              "name": "MT1840",
              "subcategories": []
            },
            {
              "id": "telehandlers-manitou-mt5519",
              "name": "MT5519",
              "subcategories": []
            },
            {
              "id": "telehandlers-manitou-mt6034",
              "name": "MT6034",
              "subcategories": []
            },
            {
              "id": "telehandlers-manitou-mt6642",
              "name": "MT6642",
              "subcategories": []
            },
            {
              "id": "telehandlers-manitou-mt1055",
              "name": "MT1055",
              "subcategories": []
            },
            {
              "id": "telehandlers-manitou-mt12042",
              "name": "MT12042",
              "subcategories": []
            },
            {
              "id": "telehandlers-manitou-mta519",
              "name": "MTA519",
              "subcategories": []
            },
            {
              "id": "telehandlers-manitou-mta642",
              "name": "MTA642",
              "subcategories": []
            },
            {
              "id": "telehandlers-manitou-mta842",
              "name": "MTA842",
              "subcategories": []
            },
            {
              "id": "telehandlers-manitou-mta950",
              "name": "MTA950",
              "subcategories": []
            },
            {
              "id": "telehandlers-manitou-mta1055",
              "name": "MTA1055",
              "subcategories": []
            },
            {
              "id": "telehandlers-manitou-mta1242",
              "name": "MTA1242",
              "subcategories": []
            },
            {
              "id": "telehandlers-manitou-mta1255",
              "name": "MTA1255",
              "subcategories": []
            },
            {
              "id": "telehandlers-manitou-mta5519",
              "name": "MTA5519",
              "subcategories": []
            },
            {
              "id": "telehandlers-manitou-mta6034",
              "name": "MTA6034",
              "subcategories": []
            },
            {
              "id": "telehandlers-manitou-mta6642",
              "name": "MTA6642",
              "subcategories": []
            },
            {
              "id": "telehandlers-manitou-mta8044",
              "name": "MTA8044",
              "subcategories": []
            },
            {
              "id": "telehandlers-manitou-mta9050",
              "name": "MTA9050",
              "subcategories": []
            },
            {
              "id": "telehandlers-manitou-mta10055",
              "name": "MTA10055",
              "subcategories": []
            },
            {
              "id": "telehandlers-manitou-mta12055",
              "name": "MTA12055",
              "subcategories": []
            },
            {
              "id": "telehandlers-manitou-mtx625",
              "name": "MTX625",
              "subcategories": []
            },
            {
              "id": "telehandlers-manitou-mtx732",
              "name": "MTX732",
              "subcategories": []
            },
            {
              "id": "telehandlers-manitou-mtx733",
              "name": "MTX733",
              "subcategories": []
            },
            {
              "id": "telehandlers-manitou-mtx1440",
              "name": "MTX1440",
              "subcategories": []
            },
            {
              "id": "telehandlers-manitou-mtx1740",
              "name": "MTX1740",
              "subcategories": []
            },
            {
              "id": "telehandlers-manitou-mvt735",
              "name": "MVT735",
              "subcategories": []
            },
            {
              "id": "telehandlers-manitou-mvt1332",
              "name": "MVT1332",
              "subcategories": []
            },
            {
              "id": "telehandlers-manitou-mxt1740",
              "name": "MXT1740",
              "subcategories": []
            },
            {
              "id": "telehandlers-manitou-slt415",
              "name": "SLT415",
              "subcategories": []
            },
            {
              "id": "telehandlers-manitou-ulm-412",
              "name": "ULM 412",
              "subcategories": []
            },
            {
              "id": "telehandlers-manitou-ulm-415",
              "name": "ULM 415",
              "subcategories": []
            },
            {
              "id": "telehandlers-manitou-mrtx2550",
              "name": "MRTX2550",
              "subcategories": []
            },
            {
              "id": "telehandlers-manitou-other",
              "name": "OTHER",
              "subcategories": []
            }
          ]
        },
        {
          "id": "telehandlers-gehl",
          "name": "Gehl",
          "subcategories": [
            {
              "id": "telehandlers-gehl-533",
              "name": "533",
              "subcategories": []
            },
            {
              "id": "telehandlers-gehl-553",
              "name": "553",
              "subcategories": []
            },
            {
              "id": "telehandlers-gehl-562",
              "name": "562",
              "subcategories": []
            },
            {
              "id": "telehandlers-gehl-663",
              "name": "663",
              "subcategories": []
            },
            {
              "id": "telehandlers-gehl-al730",
              "name": "AL730",
              "subcategories": []
            },
            {
              "id": "telehandlers-gehl-ct5-16",
              "name": "CT5-16",
              "subcategories": []
            },
            {
              "id": "telehandlers-gehl-ct7-23",
              "name": "CT7-23",
              "subcategories": []
            },
            {
              "id": "telehandlers-gehl-dl6",
              "name": "DL6",
              "subcategories": []
            },
            {
              "id": "telehandlers-gehl-dl8",
              "name": "DL8",
              "subcategories": []
            },
            {
              "id": "telehandlers-gehl-dl9",
              "name": "DL9",
              "subcategories": []
            },
            {
              "id": "telehandlers-gehl-dl11",
              "name": "DL11",
              "subcategories": []
            },
            {
              "id": "telehandlers-gehl-dl12",
              "name": "DL12",
              "subcategories": []
            },
            {
              "id": "telehandlers-gehl-gct3",
              "name": "GCT3",
              "subcategories": []
            },
            {
              "id": "telehandlers-gehl-rs4",
              "name": "RS4",
              "subcategories": []
            },
            {
              "id": "telehandlers-gehl-rs5",
              "name": "RS5",
              "subcategories": []
            },
            {
              "id": "telehandlers-gehl-rs6",
              "name": "RS6",
              "subcategories": []
            },
            {
              "id": "telehandlers-gehl-rs8",
              "name": "RS8",
              "subcategories": []
            },
            {
              "id": "telehandlers-gehl-rs10",
              "name": "RS10",
              "subcategories": []
            },
            {
              "id": "telehandlers-gehl-rs12",
              "name": "RS12",
              "subcategories": []
            },
            {
              "id": "telehandlers-gehl-th5-19",
              "name": "TH5-19",
              "subcategories": []
            },
            {
              "id": "telehandlers-gehl-th6-42",
              "name": "TH6-42",
              "subcategories": []
            },
            {
              "id": "telehandlers-gehl-th8-42",
              "name": "TH8-42",
              "subcategories": []
            },
            {
              "id": "telehandlers-gehl-th10-55",
              "name": "TH10-55",
              "subcategories": []
            },
            {
              "id": "telehandlers-gehl-th10-55-m74",
              "name": "TH10-55 M74",
              "subcategories": []
            },
            {
              "id": "telehandlers-gehl-th12-42",
              "name": "TH12-42",
              "subcategories": []
            },
            {
              "id": "telehandlers-gehl-th12-55",
              "name": "TH12-55",
              "subcategories": []
            },
            {
              "id": "telehandlers-gehl-tx-4017",
              "name": "TX-4017",
              "subcategories": []
            },
            {
              "id": "telehandlers-gehl-other",
              "name": "OTHER",
              "subcategories": []
            }
          ]
        },
        {
          "id": "telehandlers-caterpillar",
          "name": "Caterpillar",
          "subcategories": [
            {
              "id": "telehandlers-caterpillar-th62",
              "name": "TH62",
              "subcategories": []
            },
            {
              "id": "telehandlers-caterpillar-th63",
              "name": "TH63",
              "subcategories": []
            },
            {
              "id": "telehandlers-caterpillar-th83",
              "name": "TH83",
              "subcategories": []
            },
            {
              "id": "telehandlers-caterpillar-th103",
              "name": "TH103",
              "subcategories": []
            },
            {
              "id": "telehandlers-caterpillar-th220",
              "name": "TH220",
              "subcategories": []
            },
            {
              "id": "telehandlers-caterpillar-th255",
              "name": "TH255",
              "subcategories": []
            },
            {
              "id": "telehandlers-caterpillar-th314",
              "name": "TH314",
              "subcategories": []
            },
            {
              "id": "telehandlers-caterpillar-th330",
              "name": "TH330",
              "subcategories": []
            },
            {
              "id": "telehandlers-caterpillar-th336",
              "name": "TH336",
              "subcategories": []
            },
            {
              "id": "telehandlers-caterpillar-th337",
              "name": "TH337",
              "subcategories": []
            },
            {
              "id": "telehandlers-caterpillar-th337",
              "name": "TH337",
              "subcategories": []
            },
            {
              "id": "telehandlers-caterpillar-th340",
              "name": "TH340",
              "subcategories": []
            },
            {
              "id": "telehandlers-caterpillar-th350",
              "name": "TH350",
              "subcategories": []
            },
            {
              "id": "telehandlers-caterpillar-th357",
              "name": "TH357",
              "subcategories": []
            },
            {
              "id": "telehandlers-caterpillar-th360",
              "name": "TH360",
              "subcategories": []
            },
            {
              "id": "telehandlers-caterpillar-th406",
              "name": "TH406",
              "subcategories": []
            },
            {
              "id": "telehandlers-caterpillar-th407",
              "name": "TH407",
              "subcategories": []
            },
            {
              "id": "telehandlers-caterpillar-th408",
              "name": "TH408",
              "subcategories": []
            },
            {
              "id": "telehandlers-caterpillar-th414",
              "name": "TH414",
              "subcategories": []
            },
            {
              "id": "telehandlers-caterpillar-th417",
              "name": "TH417",
              "subcategories": []
            },
            {
              "id": "telehandlers-caterpillar-th460",
              "name": "TH460",
              "subcategories": []
            },
            {
              "id": "telehandlers-caterpillar-th514",
              "name": "TH514",
              "subcategories": []
            },
            {
              "id": "telehandlers-caterpillar-th560",
              "name": "TH560",
              "subcategories": []
            },
            {
              "id": "telehandlers-caterpillar-th580",
              "name": "TH580",
              "subcategories": []
            },
            {
              "id": "telehandlers-caterpillar-th3510",
              "name": "TH3510",
              "subcategories": []
            },
            {
              "id": "telehandlers-caterpillar-tl642",
              "name": "TL642",
              "subcategories": []
            },
            {
              "id": "telehandlers-caterpillar-tl943",
              "name": "TL943",
              "subcategories": []
            },
            {
              "id": "telehandlers-caterpillar-tl1055",
              "name": "TL1055",
              "subcategories": []
            },
            {
              "id": "telehandlers-caterpillar-tl1255",
              "name": "TL1255",
              "subcategories": []
            },
            {
              "id": "telehandlers-caterpillar-other",
              "name": "OTHER",
              "subcategories": []
            }
          ]
        },
        {
          "id": "telehandlers-skyjack",
          "name": "Skyjack",
          "subcategories": [
            {
              "id": "telehandlers-skyjack-sj519th",
              "name": "SJ519TH",
              "subcategories": []
            },
            {
              "id": "telehandlers-skyjack-sj643th",
              "name": "SJ643TH",
              "subcategories": []
            },
            {
              "id": "telehandlers-skyjack-sj843th",
              "name": "SJ843TH",
              "subcategories": []
            },
            {
              "id": "telehandlers-skyjack-sj1044th",
              "name": "SJ1044TH",
              "subcategories": []
            },
            {
              "id": "telehandlers-skyjack-sj1056th",
              "name": "SJ1056TH",
              "subcategories": []
            },
            {
              "id": "telehandlers-skyjack-sj1056ths",
              "name": "SJ1056THS",
              "subcategories": []
            },
            {
              "id": "telehandlers-skyjack-sj1256th",
              "name": "SJ1256TH",
              "subcategories": []
            },
            {
              "id": "telehandlers-skyjack-sj1256ths",
              "name": "SJ1256THS",
              "subcategories": []
            },
            {
              "id": "telehandlers-skyjack-vr642d",
              "name": "VR642D",
              "subcategories": []
            },
            {
              "id": "telehandlers-skyjack-vr843d",
              "name": "VR843D",
              "subcategories": []
            },
            {
              "id": "telehandlers-skyjack-vr843e",
              "name": "VR843E",
              "subcategories": []
            },
            {
              "id": "telehandlers-skyjack-vr1056d",
              "name": "VR1056D",
              "subcategories": []
            },
            {
              "id": "telehandlers-skyjack-vr1056e",
              "name": "VR1056E",
              "subcategories": []
            },
            {
              "id": "telehandlers-skyjack-zb2044",
              "name": "ZB2044",
              "subcategories": []
            },
            {
              "id": "telehandlers-skyjack-other",
              "name": "OTHER",
              "subcategories": []
            }
          ]
        },
        {
          "id": "telehandlers-merlo",
          "name": "Merlo",
          "subcategories": [
            {
              "id": "telehandlers-merlo-eworker-25-5-90",
              "name": "EWORKER 25.5-90",
              "subcategories": []
            },
            {
              "id": "telehandlers-merlo-multifarmer-30-6-top2",
              "name": "MULTIFARMER 30.6 TOP2",
              "subcategories": []
            },
            {
              "id": "telehandlers-merlo-multifarmer-34-7-cs",
              "name": "MULTIFARMER 34.7 CS",
              "subcategories": []
            },
            {
              "id": "telehandlers-merlo-multifarmer-34-7-cs-140",
              "name": "MULTIFARMER 34.7 CS 140",
              "subcategories": []
            },
            {
              "id": "telehandlers-merlo-multifarmer-40-7-cs",
              "name": "MULTIFARMER 40.7 CS",
              "subcategories": []
            },
            {
              "id": "telehandlers-merlo-multifarmer-40-9-cs",
              "name": "MULTIFARMER 40.9 CS",
              "subcategories": []
            },
            {
              "id": "telehandlers-merlo-multifarmer-44-9",
              "name": "MULTIFARMER 44.9",
              "subcategories": []
            },
            {
              "id": "telehandlers-merlo-multifarmer-44-9-cs-170-cvt",
              "name": "MULTIFARMER 44.9 CS 170 CVT",
              "subcategories": []
            },
            {
              "id": "telehandlers-merlo-p25",
              "name": "P25",
              "subcategories": []
            },
            {
              "id": "telehandlers-merlo-p26",
              "name": "P26",
              "subcategories": []
            },
            {
              "id": "telehandlers-merlo-p27",
              "name": "P27",
              "subcategories": []
            },
            {
              "id": "telehandlers-merlo-p28",
              "name": "P28",
              "subcategories": []
            },
            {
              "id": "telehandlers-merlo-p30",
              "name": "P30",
              "subcategories": []
            },
            {
              "id": "telehandlers-merlo-p32",
              "name": "P32",
              "subcategories": []
            },
            {
              "id": "telehandlers-merlo-p34",
              "name": "P34",
              "subcategories": []
            },
            {
              "id": "telehandlers-merlo-p35",
              "name": "P35",
              "subcategories": []
            },
            {
              "id": "telehandlers-merlo-p36",
              "name": "P36",
              "subcategories": []
            },
            {
              "id": "telehandlers-merlo-p38",
              "name": "P38",
              "subcategories": []
            },
            {
              "id": "telehandlers-merlo-p40",
              "name": "P40",
              "subcategories": []
            },
            {
              "id": "telehandlers-merlo-p41",
              "name": "P41",
              "subcategories": []
            },
            {
              "id": "telehandlers-merlo-p50",
              "name": "P50",
              "subcategories": []
            },
            {
              "id": "telehandlers-merlo-p55",
              "name": "P55",
              "subcategories": []
            },
            {
              "id": "telehandlers-merlo-p60",
              "name": "P60",
              "subcategories": []
            },
            {
              "id": "telehandlers-merlo-p65",
              "name": "P65",
              "subcategories": []
            },
            {
              "id": "telehandlers-merlo-p72",
              "name": "P72",
              "subcategories": []
            },
            {
              "id": "telehandlers-merlo-p101",
              "name": "P101",
              "subcategories": []
            },
            {
              "id": "telehandlers-merlo-p120",
              "name": "P120",
              "subcategories": []
            },
            {
              "id": "telehandlers-merlo-roto-30-13ev",
              "name": "ROTO 30.13EV",
              "subcategories": []
            },
            {
              "id": "telehandlers-merlo-roto-30-16ev",
              "name": "ROTO 30.16EV",
              "subcategories": []
            },
            {
              "id": "telehandlers-merlo-roto-38-14",
              "name": "ROTO 38.14",
              "subcategories": []
            },
            {
              "id": "telehandlers-merlo-roto-38-14s",
              "name": "ROTO 38.14S",
              "subcategories": []
            },
            {
              "id": "telehandlers-merlo-roto-38-16",
              "name": "ROTO 38.16",
              "subcategories": []
            },
            {
              "id": "telehandlers-merlo-roto-38-16s",
              "name": "ROTO 38.16S",
              "subcategories": []
            },
            {
              "id": "telehandlers-merlo-roto-40-18s",
              "name": "ROTO 40.18S",
              "subcategories": []
            },
            {
              "id": "telehandlers-merlo-roto-40-25-mcss",
              "name": "ROTO 40.25 MCSS",
              "subcategories": []
            },
            {
              "id": "telehandlers-merlo-roto-40-26-mcss",
              "name": "ROTO 40.26 MCSS",
              "subcategories": []
            },
            {
              "id": "telehandlers-merlo-roto-40-30-mcss",
              "name": "ROTO 40.30 MCSS",
              "subcategories": []
            },
            {
              "id": "telehandlers-merlo-roto-45-19-mcss",
              "name": "ROTO 45.19 MCSS",
              "subcategories": []
            },
            {
              "id": "telehandlers-merlo-roto-45-21-ksc",
              "name": "ROTO 45.21 KSC",
              "subcategories": []
            },
            {
              "id": "telehandlers-merlo-roto-45-21-mcss",
              "name": "ROTO 45.21 MCSS",
              "subcategories": []
            },
            {
              "id": "telehandlers-merlo-roto-50-21s",
              "name": "ROTO 50.21S",
              "subcategories": []
            },
            {
              "id": "telehandlers-merlo-roto-50-26s-plus",
              "name": "ROTO 50.26S PLUS",
              "subcategories": []
            },
            {
              "id": "telehandlers-merlo-roto-50-30s-plus",
              "name": "ROTO 50.30S PLUS",
              "subcategories": []
            },
            {
              "id": "telehandlers-merlo-roto-50-35s-plus",
              "name": "ROTO 50.35S PLUS",
              "subcategories": []
            },
            {
              "id": "telehandlers-merlo-roto-60-24-mcss",
              "name": "ROTO 60.24 MCSS",
              "subcategories": []
            },
            {
              "id": "telehandlers-merlo-roto-70-24s-plus",
              "name": "ROTO 70.24S PLUS",
              "subcategories": []
            },
            {
              "id": "telehandlers-merlo-roto-70-28s-plus",
              "name": "ROTO 70.28S PLUS",
              "subcategories": []
            },
            {
              "id": "telehandlers-merlo-tf27-6",
              "name": "TF27.6",
              "subcategories": []
            },
            {
              "id": "telehandlers-merlo-tf30-9",
              "name": "TF30.9",
              "subcategories": []
            },
            {
              "id": "telehandlers-merlo-tf33-7",
              "name": "TF33.7",
              "subcategories": []
            },
            {
              "id": "telehandlers-merlo-tf33-9",
              "name": "TF33.9",
              "subcategories": []
            },
            {
              "id": "telehandlers-merlo-tf35-7",
              "name": "TF35.7",
              "subcategories": []
            },
            {
              "id": "telehandlers-merlo-tf38-7",
              "name": "TF38.7",
              "subcategories": []
            },
            {
              "id": "telehandlers-merlo-tf38-10",
              "name": "TF38.10",
              "subcategories": []
            },
            {
              "id": "telehandlers-merlo-tf42-7",
              "name": "TF42.7",
              "subcategories": []
            },
            {
              "id": "telehandlers-merlo-tf45-11",
              "name": "TF45.11",
              "subcategories": []
            },
            {
              "id": "telehandlers-merlo-tf50-8",
              "name": "TF50.8",
              "subcategories": []
            },
            {
              "id": "telehandlers-merlo-tf65-9",
              "name": "TF65.9",
              "subcategories": []
            },
            {
              "id": "telehandlers-merlo-other",
              "name": "OTHER",
              "subcategories": []
            }
          ]
        },
        {
          "id": "telehandlers-magni",
          "name": "Magni",
          "subcategories": [
            {
              "id": "telehandlers-magni-hth10-10",
              "name": "HTH10.10",
              "subcategories": []
            },
            {
              "id": "telehandlers-magni-hth12-10",
              "name": "HTH12.10",
              "subcategories": []
            },
            {
              "id": "telehandlers-magni-hth16-10",
              "name": "HTH16.10",
              "subcategories": []
            },
            {
              "id": "telehandlers-magni-hth20-10",
              "name": "HTH20.10",
              "subcategories": []
            },
            {
              "id": "telehandlers-magni-hth24-11",
              "name": "HTH24.11",
              "subcategories": []
            },
            {
              "id": "telehandlers-magni-hth25-11",
              "name": "HTH25.11",
              "subcategories": []
            },
            {
              "id": "telehandlers-magni-hth27-11",
              "name": "HTH27.11",
              "subcategories": []
            },
            {
              "id": "telehandlers-magni-hth30-12",
              "name": "HTH30.12",
              "subcategories": []
            },
            {
              "id": "telehandlers-magni-hth35-12",
              "name": "HTH35.12",
              "subcategories": []
            },
            {
              "id": "telehandlers-magni-rth4-18",
              "name": "RTH4.18",
              "subcategories": []
            },
            {
              "id": "telehandlers-magni-rth5-18",
              "name": "RTH5.18",
              "subcategories": []
            },
            {
              "id": "telehandlers-magni-rth5-21",
              "name": "RTH5.21",
              "subcategories": []
            },
            {
              "id": "telehandlers-magni-rth5-23",
              "name": "RTH5.23",
              "subcategories": []
            },
            {
              "id": "telehandlers-magni-rth5-25",
              "name": "RTH5.25",
              "subcategories": []
            },
            {
              "id": "telehandlers-magni-rth5-30",
              "name": "RTH5.30",
              "subcategories": []
            },
            {
              "id": "telehandlers-magni-rth5-35",
              "name": "RTH5.35",
              "subcategories": []
            },
            {
              "id": "telehandlers-magni-rth5-39",
              "name": "RTH5.39",
              "subcategories": []
            },
            {
              "id": "telehandlers-magni-rth6-21",
              "name": "RTH6.21",
              "subcategories": []
            },
            {
              "id": "telehandlers-magni-rth6-22",
              "name": "RTH6.22",
              "subcategories": []
            },
            {
              "id": "telehandlers-magni-rth6-23",
              "name": "RTH6.23",
              "subcategories": []
            },
            {
              "id": "telehandlers-magni-rth6-25",
              "name": "RTH6.25",
              "subcategories": []
            },
            {
              "id": "telehandlers-magni-rth6-26",
              "name": "RTH6.26",
              "subcategories": []
            },
            {
              "id": "telehandlers-magni-rth6-30",
              "name": "RTH6.30",
              "subcategories": []
            },
            {
              "id": "telehandlers-magni-rth6-31",
              "name": "RTH6.31",
              "subcategories": []
            },
            {
              "id": "telehandlers-magni-rth6-35",
              "name": "RTH6.35",
              "subcategories": []
            },
            {
              "id": "telehandlers-magni-rth6-39",
              "name": "RTH6.39",
              "subcategories": []
            },
            {
              "id": "telehandlers-magni-rth6-46",
              "name": "RTH6.46",
              "subcategories": []
            },
            {
              "id": "telehandlers-magni-rth6-51",
              "name": "RTH6.51",
              "subcategories": []
            },
            {
              "id": "telehandlers-magni-rth7-26",
              "name": "RTH7.26",
              "subcategories": []
            },
            {
              "id": "telehandlers-magni-rth8-25",
              "name": "RTH8.25",
              "subcategories": []
            },
            {
              "id": "telehandlers-magni-rth8-27",
              "name": "RTH8.27",
              "subcategories": []
            },
            {
              "id": "telehandlers-magni-rth8-35",
              "name": "RTH8.35",
              "subcategories": []
            },
            {
              "id": "telehandlers-magni-rth8-39",
              "name": "RTH8.39",
              "subcategories": []
            },
            {
              "id": "telehandlers-magni-rth8-46",
              "name": "RTH8.46",
              "subcategories": []
            },
            {
              "id": "telehandlers-magni-rth8-51",
              "name": "RTH8.51",
              "subcategories": []
            },
            {
              "id": "telehandlers-magni-rth10-37",
              "name": "RTH10.37",
              "subcategories": []
            },
            {
              "id": "telehandlers-magni-rth13-26",
              "name": "RTH13.26",
              "subcategories": []
            },
            {
              "id": "telehandlers-magni-th4-5",
              "name": "TH4,5",
              "subcategories": []
            },
            {
              "id": "telehandlers-magni-th5-8",
              "name": "TH5.8",
              "subcategories": []
            },
            {
              "id": "telehandlers-magni-th5-24",
              "name": "TH5.24",
              "subcategories": []
            },
            {
              "id": "telehandlers-magni-th5-5",
              "name": "TH5.,5",
              "subcategories": []
            },
            {
              "id": "telehandlers-magni-th6-10",
              "name": "TH6.10",
              "subcategories": []
            },
            {
              "id": "telehandlers-magni-th6-2",
              "name": "TH6.2",
              "subcategories": []
            },
            {
              "id": "telehandlers-magni-th12-80",
              "name": "TH12.80",
              "subcategories": []
            },
            {
              "id": "telehandlers-magni-other",
              "name": "OTHER",
              "subcategories": []
            }
          ]
        },
        {
          "id": "telehandlers-bobcat",
          "name": "Bobcat",
          "subcategories": [
            {
              "id": "telehandlers-bobcat-t41",
              "name": "T41",
              "subcategories": []
            },
            {
              "id": "telehandlers-bobcat-t2250",
              "name": "T2250",
              "subcategories": []
            },
            {
              "id": "telehandlers-bobcat-t3071",
              "name": "T3071",
              "subcategories": []
            },
            {
              "id": "telehandlers-bobcat-t3571",
              "name": "T3571",
              "subcategories": []
            },
            {
              "id": "telehandlers-bobcat-t35105",
              "name": "T35105",
              "subcategories": []
            },
            {
              "id": "telehandlers-bobcat-t40140",
              "name": "T40140",
              "subcategories": []
            },
            {
              "id": "telehandlers-bobcat-t40150",
              "name": "T40150",
              "subcategories": []
            },
            {
              "id": "telehandlers-bobcat-t40180",
              "name": "T40180",
              "subcategories": []
            },
            {
              "id": "telehandlers-bobcat-td40150",
              "name": "TD40150",
              "subcategories": []
            },
            {
              "id": "telehandlers-bobcat-tl25",
              "name": "TL25",
              "subcategories": []
            },
            {
              "id": "telehandlers-bobcat-tl26",
              "name": "TL26",
              "subcategories": []
            },
            {
              "id": "telehandlers-bobcat-tl30",
              "name": "TL30",
              "subcategories": []
            },
            {
              "id": "telehandlers-bobcat-tl34",
              "name": "TL34",
              "subcategories": []
            },
            {
              "id": "telehandlers-bobcat-tl35",
              "name": "TL35",
              "subcategories": []
            },
            {
              "id": "telehandlers-bobcat-tl38",
              "name": "TL38",
              "subcategories": []
            },
            {
              "id": "telehandlers-bobcat-tl43",
              "name": "TL43",
              "subcategories": []
            },
            {
              "id": "telehandlers-bobcat-tl358",
              "name": "TL358",
              "subcategories": []
            },
            {
              "id": "telehandlers-bobcat-tl360",
              "name": "TL360",
              "subcategories": []
            },
            {
              "id": "telehandlers-bobcat-tl470",
              "name": "TL470",
              "subcategories": []
            },
            {
              "id": "telehandlers-bobcat-tl519",
              "name": "TL519",
              "subcategories": []
            },
            {
              "id": "telehandlers-bobcat-tl619",
              "name": "TL619",
              "subcategories": []
            },
            {
              "id": "telehandlers-bobcat-tl623",
              "name": "TL623",
              "subcategories": []
            },
            {
              "id": "telehandlers-bobcat-tl723",
              "name": "TL723",
              "subcategories": []
            },
            {
              "id": "telehandlers-bobcat-tl923",
              "name": "TL923",
              "subcategories": []
            },
            {
              "id": "telehandlers-bobcat-tr50",
              "name": "TR50",
              "subcategories": []
            },
            {
              "id": "telehandlers-bobcat-v417",
              "name": "V417",
              "subcategories": []
            },
            {
              "id": "telehandlers-bobcat-v518",
              "name": "V518",
              "subcategories": []
            },
            {
              "id": "telehandlers-bobcat-v519",
              "name": "V519",
              "subcategories": []
            },
            {
              "id": "telehandlers-bobcat-v623",
              "name": "V623",
              "subcategories": []
            },
            {
              "id": "telehandlers-bobcat-v723",
              "name": "V723",
              "subcategories": []
            },
            {
              "id": "telehandlers-bobcat-v923",
              "name": "V923",
              "subcategories": []
            },
            {
              "id": "telehandlers-bobcat-other",
              "name": "OTHER",
              "subcategories": []
            }
          ]
        },
        {
          "id": "telehandlers-dieci",
          "name": "Dieci",
          "subcategories": []
        },
        {
          "id": "telehandlers-claas",
          "name": "Claas",
          "subcategories": [
            {
              "id": "telehandlers-claas-scorpion-635",
              "name": "SCORPION 635",
              "subcategories": []
            },
            {
              "id": "telehandlers-claas-scorpion-635-varipower",
              "name": "SCORPION 635 VARIPOWER",
              "subcategories": []
            },
            {
              "id": "telehandlers-claas-scorpion-732-varipower",
              "name": "SCORPION 732 VARIPOWER",
              "subcategories": []
            },
            {
              "id": "telehandlers-claas-scorpion-736",
              "name": "SCORPION 736",
              "subcategories": []
            },
            {
              "id": "telehandlers-claas-scorpion-741-varipower",
              "name": "SCORPION 741 VARIPOWER",
              "subcategories": []
            },
            {
              "id": "telehandlers-claas-scorpion-746-varipower",
              "name": "SCORPION 746 VARIPOWER",
              "subcategories": []
            },
            {
              "id": "telehandlers-claas-scorpion-756-varipower",
              "name": "SCORPION 756 VARIPOWER",
              "subcategories": []
            },
            {
              "id": "telehandlers-claas-scorpion-960-varipower",
              "name": "SCORPION 960 VARIPOWER",
              "subcategories": []
            },
            {
              "id": "telehandlers-claas-scorpion-1033-varipower",
              "name": "SCORPION 1033 VARIPOWER",
              "subcategories": []
            },
            {
              "id": "telehandlers-claas-scorpion-6030",
              "name": "SCORPION 6030",
              "subcategories": []
            },
            {
              "id": "telehandlers-claas-scorpion-6030-varipower",
              "name": "SCORPION 6030 VARIPOWER",
              "subcategories": []
            },
            {
              "id": "telehandlers-claas-scorpion-6030cp",
              "name": "SCORPION 6030CP",
              "subcategories": []
            },
            {
              "id": "telehandlers-claas-scorpion-6035",
              "name": "SCORPION 6035",
              "subcategories": []
            },
            {
              "id": "telehandlers-claas-scorpion-7030",
              "name": "SCORPION 7030",
              "subcategories": []
            },
            {
              "id": "telehandlers-claas-scorpion-7035",
              "name": "SCORPION 7035",
              "subcategories": []
            },
            {
              "id": "telehandlers-claas-scorpion-7040",
              "name": "SCORPION 7040",
              "subcategories": []
            },
            {
              "id": "telehandlers-claas-scorpion-7040-varipower",
              "name": "SCORPION 7040 VARIPOWER",
              "subcategories": []
            },
            {
              "id": "telehandlers-claas-scorpion-7044",
              "name": "SCORPION 7044",
              "subcategories": []
            },
            {
              "id": "telehandlers-claas-scorpion-7044-varipower",
              "name": "SCORPION 7044 VARIPOWER",
              "subcategories": []
            },
            {
              "id": "telehandlers-claas-scorpion-7050",
              "name": "SCORPION 7050",
              "subcategories": []
            },
            {
              "id": "telehandlers-claas-scorpion-7055",
              "name": "SCORPION 7055",
              "subcategories": []
            },
            {
              "id": "telehandlers-claas-scorpion-7055-varipower",
              "name": "SCORPION 7055 VARIPOWER",
              "subcategories": []
            },
            {
              "id": "telehandlers-claas-scorpion-9040",
              "name": "SCORPION 9040",
              "subcategories": []
            },
            {
              "id": "telehandlers-claas-scorpion-9055",
              "name": "SCORPION 9055",
              "subcategories": []
            },
            {
              "id": "telehandlers-claas-targo-c50",
              "name": "TARGO C50",
              "subcategories": []
            },
            {
              "id": "telehandlers-claas-teleporter-925",
              "name": "TELEPORTER 925",
              "subcategories": []
            },
            {
              "id": "telehandlers-claas-other",
              "name": "OTHER",
              "subcategories": []
            }
          ]
        },
        {
          "id": "telehandlers-kramer",
          "name": "Kramer",
          "subcategories": []
        },
        {
          "id": "telehandlers-load-lifter",
          "name": "Load Lifter",
          "subcategories": [
            {
              "id": "telehandlers-load-lifter-518",
              "name": "518",
              "subcategories": []
            },
            {
              "id": "telehandlers-load-lifter-642",
              "name": "642",
              "subcategories": []
            },
            {
              "id": "telehandlers-load-lifter-842",
              "name": "842",
              "subcategories": []
            },
            {
              "id": "telehandlers-load-lifter-1056",
              "name": "1056",
              "subcategories": []
            },
            {
              "id": "telehandlers-load-lifter-other",
              "name": "OTHER",
              "subcategories": []
            }
          ]
        },
        {
          "id": "telehandlers-lull",
          "name": "Lull",
          "subcategories": [
            {
              "id": "telehandlers-lull-6k",
              "name": "6K",
              "subcategories": []
            },
            {
              "id": "telehandlers-lull-7c2",
              "name": "7C2",
              "subcategories": []
            },
            {
              "id": "telehandlers-lull-622",
              "name": "622",
              "subcategories": []
            },
            {
              "id": "telehandlers-lull-644",
              "name": "644",
              "subcategories": []
            },
            {
              "id": "telehandlers-lull-844",
              "name": "844",
              "subcategories": []
            },
            {
              "id": "telehandlers-lull-944",
              "name": "944",
              "subcategories": []
            },
            {
              "id": "telehandlers-lull-1044",
              "name": "1044",
              "subcategories": []
            },
            {
              "id": "telehandlers-lull-ml10k",
              "name": "ML10K",
              "subcategories": []
            },
            {
              "id": "telehandlers-lull-other",
              "name": "OTHER",
              "subcategories": []
            }
          ]
        },
        {
          "id": "telehandlers-new-holland",
          "name": "New Holland",
          "subcategories": [
            {
              "id": "telehandlers-new-holland-lm6",
              "name": "LM6",
              "subcategories": []
            },
            {
              "id": "telehandlers-new-holland-lm7",
              "name": "LM7",
              "subcategories": []
            },
            {
              "id": "telehandlers-new-holland-lm9",
              "name": "LM9",
              "subcategories": []
            },
            {
              "id": "telehandlers-new-holland-lm410",
              "name": "LM410",
              "subcategories": []
            },
            {
              "id": "telehandlers-new-holland-lm425",
              "name": "LM425",
              "subcategories": []
            },
            {
              "id": "telehandlers-new-holland-lm430",
              "name": "LM430",
              "subcategories": []
            },
            {
              "id": "telehandlers-new-holland-lm435",
              "name": "LM435",
              "subcategories": []
            },
            {
              "id": "telehandlers-new-holland-lm840",
              "name": "LM840",
              "subcategories": []
            },
            {
              "id": "telehandlers-new-holland-lm850",
              "name": "LM850",
              "subcategories": []
            },
            {
              "id": "telehandlers-new-holland-lm1445",
              "name": "LM1445",
              "subcategories": []
            },
            {
              "id": "telehandlers-new-holland-lm5020",
              "name": "LM5020",
              "subcategories": []
            },
            {
              "id": "telehandlers-new-holland-lm5030",
              "name": "LM5030",
              "subcategories": []
            },
            {
              "id": "telehandlers-new-holland-lm5060",
              "name": "LM5060",
              "subcategories": []
            },
            {
              "id": "telehandlers-new-holland-m427",
              "name": "M427",
              "subcategories": []
            },
            {
              "id": "telehandlers-new-holland-m459",
              "name": "M459",
              "subcategories": []
            },
            {
              "id": "telehandlers-new-holland-th5-26",
              "name": "TH5.26",
              "subcategories": []
            },
            {
              "id": "telehandlers-new-holland-th6-28",
              "name": "TH6.28",
              "subcategories": []
            },
            {
              "id": "telehandlers-new-holland-th6-32",
              "name": "TH6.32",
              "subcategories": []
            },
            {
              "id": "telehandlers-new-holland-th6-36",
              "name": "TH6.36",
              "subcategories": []
            },
            {
              "id": "telehandlers-new-holland-th7",
              "name": "TH7",
              "subcategories": []
            },
            {
              "id": "telehandlers-new-holland-th9",
              "name": "TH9",
              "subcategories": []
            },
            {
              "id": "telehandlers-new-holland-other",
              "name": "OTHER",
              "subcategories": []
            }
          ]
        },
        {
          "id": "telehandlers-pettibone",
          "name": "Pettibone",
          "subcategories": [
            {
              "id": "telehandlers-pettibone-944",
              "name": "944",
              "subcategories": []
            },
            {
              "id": "telehandlers-pettibone-1042",
              "name": "1042",
              "subcategories": []
            },
            {
              "id": "telehandlers-pettibone-5528",
              "name": "5528",
              "subcategories": []
            },
            {
              "id": "telehandlers-pettibone-6036",
              "name": "6036",
              "subcategories": []
            },
            {
              "id": "telehandlers-pettibone-8042",
              "name": "8042",
              "subcategories": []
            },
            {
              "id": "telehandlers-pettibone-8044",
              "name": "8044",
              "subcategories": []
            },
            {
              "id": "telehandlers-pettibone-10044",
              "name": "10044",
              "subcategories": []
            },
            {
              "id": "telehandlers-pettibone-10056",
              "name": "10056",
              "subcategories": []
            },
            {
              "id": "telehandlers-pettibone-b66",
              "name": "B66",
              "subcategories": []
            },
            {
              "id": "telehandlers-pettibone-b68",
              "name": "B68",
              "subcategories": []
            },
            {
              "id": "telehandlers-pettibone-c8000",
              "name": "C8000",
              "subcategories": []
            },
            {
              "id": "telehandlers-pettibone-extendo-944b",
              "name": "EXTENDO 944B",
              "subcategories": []
            },
            {
              "id": "telehandlers-pettibone-extendo-944x",
              "name": "EXTENDO 944X",
              "subcategories": []
            },
            {
              "id": "telehandlers-pettibone-extendo-1046x",
              "name": "EXTENDO 1046X",
              "subcategories": []
            },
            {
              "id": "telehandlers-pettibone-extendo-1056x",
              "name": "EXTENDO 1056X",
              "subcategories": []
            },
            {
              "id": "telehandlers-pettibone-extendo-1246x",
              "name": "EXTENDO 1246X",
              "subcategories": []
            },
            {
              "id": "telehandlers-pettibone-extendo-1258x",
              "name": "EXTENDO 1258X",
              "subcategories": []
            },
            {
              "id": "telehandlers-pettibone-t8036",
              "name": "T8036",
              "subcategories": []
            },
            {
              "id": "telehandlers-pettibone-t8044",
              "name": "T8044",
              "subcategories": []
            },
            {
              "id": "telehandlers-pettibone-traverse-t944x",
              "name": "TRAVERSE T944X",
              "subcategories": []
            },
            {
              "id": "telehandlers-pettibone-traverse-t1056x",
              "name": "TRAVERSE T1056X",
              "subcategories": []
            },
            {
              "id": "telehandlers-pettibone-traverse-t1246x",
              "name": "TRAVERSE T1246X",
              "subcategories": []
            },
            {
              "id": "telehandlers-pettibone-traverse-t1256x",
              "name": "TRAVERSE T1256X",
              "subcategories": []
            },
            {
              "id": "telehandlers-pettibone-traverse-t1258x",
              "name": "TRAVERSE T1258X",
              "subcategories": []
            },
            {
              "id": "telehandlers-pettibone-extendo-1256x",
              "name": "EXTENDO 1256X",
              "subcategories": []
            },
            {
              "id": "telehandlers-pettibone-other",
              "name": "OTHER",
              "subcategories": []
            }
          ]
        },
        {
          "id": "telehandlers-sany",
          "name": "Sany",
          "subcategories": [
            {
              "id": "telehandlers-sany-sth634",
              "name": "STH634",
              "subcategories": []
            },
            {
              "id": "telehandlers-sany-sth844",
              "name": "STH844",
              "subcategories": []
            },
            {
              "id": "telehandlers-sany-sth1056",
              "name": "STH1056",
              "subcategories": []
            },
            {
              "id": "telehandlers-sany-sth1256",
              "name": "STH1256",
              "subcategories": []
            },
            {
              "id": "telehandlers-sany-sth1440",
              "name": "STH1440",
              "subcategories": []
            },
            {
              "id": "telehandlers-sany-sth1840",
              "name": "STH1840",
              "subcategories": []
            },
            {
              "id": "telehandlers-sany-other",
              "name": "OTHER",
              "subcategories": []
            }
          ]
        }
      ]
    },
    {
      "id": "trenchers",
      "name": "Trenchers",
      "subcategories": [
        {
          "id": "trenchers-trenchers-cable-plows",
          "name": "Trenchers / Cable Plows",
          "subcategories": []
        },
        {
          "id": "trenchers-ditch-witch",
          "name": "Ditch Witch",
          "subcategories": []
        },
        {
          "id": "trenchers-vermeer",
          "name": "Vermeer",
          "subcategories": [
            {
              "id": "trenchers-vermeer-flextrak-75",
              "name": "FLEXTRAK 75",
              "subcategories": []
            },
            {
              "id": "trenchers-vermeer-ftx25",
              "name": "FTX25",
              "subcategories": []
            },
            {
              "id": "trenchers-vermeer-lm40",
              "name": "LM40",
              "subcategories": []
            },
            {
              "id": "trenchers-vermeer-lm42",
              "name": "LM42",
              "subcategories": []
            },
            {
              "id": "trenchers-vermeer-m437",
              "name": "M437",
              "subcategories": []
            },
            {
              "id": "trenchers-vermeer-m455",
              "name": "M455",
              "subcategories": []
            },
            {
              "id": "trenchers-vermeer-m470",
              "name": "M470",
              "subcategories": []
            },
            {
              "id": "trenchers-vermeer-m475",
              "name": "M475",
              "subcategories": []
            },
            {
              "id": "trenchers-vermeer-ptx40",
              "name": "PTX40",
              "subcategories": []
            },
            {
              "id": "trenchers-vermeer-ptx42",
              "name": "PTX42",
              "subcategories": []
            },
            {
              "id": "trenchers-vermeer-ptx44",
              "name": "PTX44",
              "subcategories": []
            },
            {
              "id": "trenchers-vermeer-rt100",
              "name": "RT100",
              "subcategories": []
            },
            {
              "id": "trenchers-vermeer-rt200",
              "name": "RT200",
              "subcategories": []
            },
            {
              "id": "trenchers-vermeer-rt450",
              "name": "RT450",
              "subcategories": []
            },
            {
              "id": "trenchers-vermeer-rt650",
              "name": "RT650",
              "subcategories": []
            },
            {
              "id": "trenchers-vermeer-rt850",
              "name": "RT850",
              "subcategories": []
            },
            {
              "id": "trenchers-vermeer-rt950",
              "name": "RT950",
              "subcategories": []
            },
            {
              "id": "trenchers-vermeer-rt1250",
              "name": "RT1250",
              "subcategories": []
            },
            {
              "id": "trenchers-vermeer-rtx130",
              "name": "RTX130",
              "subcategories": []
            },
            {
              "id": "trenchers-vermeer-rtx150",
              "name": "RTX150",
              "subcategories": []
            },
            {
              "id": "trenchers-vermeer-rtx200",
              "name": "RTX200",
              "subcategories": []
            },
            {
              "id": "trenchers-vermeer-rtx250",
              "name": "RTX250",
              "subcategories": []
            },
            {
              "id": "trenchers-vermeer-rtx450",
              "name": "RTX450",
              "subcategories": []
            },
            {
              "id": "trenchers-vermeer-rtx550",
              "name": "RTX550",
              "subcategories": []
            },
            {
              "id": "trenchers-vermeer-rtx750",
              "name": "RTX750",
              "subcategories": []
            },
            {
              "id": "trenchers-vermeer-rtx1250",
              "name": "RTX1250",
              "subcategories": []
            },
            {
              "id": "trenchers-vermeer-spx25",
              "name": "SPX25",
              "subcategories": []
            },
            {
              "id": "trenchers-vermeer-t200",
              "name": "T200",
              "subcategories": []
            },
            {
              "id": "trenchers-vermeer-t555",
              "name": "T555",
              "subcategories": []
            },
            {
              "id": "trenchers-vermeer-t600",
              "name": "T600",
              "subcategories": []
            },
            {
              "id": "trenchers-vermeer-t650",
              "name": "T650",
              "subcategories": []
            },
            {
              "id": "trenchers-vermeer-t655",
              "name": "T655",
              "subcategories": []
            },
            {
              "id": "trenchers-vermeer-t655-commander-ii",
              "name": "T655 COMMANDER II",
              "subcategories": []
            },
            {
              "id": "trenchers-vermeer-t655-commander-iii",
              "name": "T655 COMMANDER III",
              "subcategories": []
            },
            {
              "id": "trenchers-vermeer-t755-commander",
              "name": "T755 COMMANDER",
              "subcategories": []
            },
            {
              "id": "trenchers-vermeer-t755-commander-ii",
              "name": "T755 COMMANDER II",
              "subcategories": []
            },
            {
              "id": "trenchers-vermeer-t755-commander-iii",
              "name": "T755 COMMANDER III",
              "subcategories": []
            },
            {
              "id": "trenchers-vermeer-t758",
              "name": "T758",
              "subcategories": []
            },
            {
              "id": "trenchers-vermeer-t800",
              "name": "T800",
              "subcategories": []
            },
            {
              "id": "trenchers-vermeer-t850",
              "name": "T850",
              "subcategories": []
            },
            {
              "id": "trenchers-vermeer-t855",
              "name": "T855",
              "subcategories": []
            },
            {
              "id": "trenchers-vermeer-t955",
              "name": "T955",
              "subcategories": []
            },
            {
              "id": "trenchers-vermeer-t1055",
              "name": "T1055",
              "subcategories": []
            },
            {
              "id": "trenchers-vermeer-t1155",
              "name": "T1155",
              "subcategories": []
            },
            {
              "id": "trenchers-vermeer-t1255",
              "name": "T1255",
              "subcategories": []
            },
            {
              "id": "trenchers-vermeer-t1555",
              "name": "T1555",
              "subcategories": []
            },
            {
              "id": "trenchers-vermeer-tc4",
              "name": "TC4",
              "subcategories": []
            },
            {
              "id": "trenchers-vermeer-v120",
              "name": "V120",
              "subcategories": []
            },
            {
              "id": "trenchers-vermeer-v434",
              "name": "V434",
              "subcategories": []
            },
            {
              "id": "trenchers-vermeer-v450",
              "name": "V450",
              "subcategories": []
            },
            {
              "id": "trenchers-vermeer-v1350",
              "name": "V1350",
              "subcategories": []
            },
            {
              "id": "trenchers-vermeer-v2050",
              "name": "V2050",
              "subcategories": []
            },
            {
              "id": "trenchers-vermeer-v3550",
              "name": "V3550",
              "subcategories": []
            },
            {
              "id": "trenchers-vermeer-v4150",
              "name": "V4150",
              "subcategories": []
            },
            {
              "id": "trenchers-vermeer-v5750",
              "name": "V5750",
              "subcategories": []
            },
            {
              "id": "trenchers-vermeer-v5800",
              "name": "V5800",
              "subcategories": []
            },
            {
              "id": "trenchers-vermeer-v6500",
              "name": "V6500",
              "subcategories": []
            },
            {
              "id": "trenchers-vermeer-v8050",
              "name": "V8050",
              "subcategories": []
            },
            {
              "id": "trenchers-vermeer-v8550",
              "name": "V8550",
              "subcategories": []
            },
            {
              "id": "trenchers-vermeer-xts1250",
              "name": "XTS1250",
              "subcategories": []
            },
            {
              "id": "trenchers-vermeer-xts1250i2",
              "name": "XTS1250I2",
              "subcategories": []
            },
            {
              "id": "trenchers-vermeer-other",
              "name": "OTHER",
              "subcategories": []
            }
          ]
        },
        {
          "id": "trenchers-toro",
          "name": "Toro",
          "subcategories": [
            {
              "id": "trenchers-toro-maxi-sneaker-370",
              "name": "MAXI SNEAKER 370",
              "subcategories": []
            },
            {
              "id": "trenchers-toro-pro-sneak-365",
              "name": "PRO SNEAK 365",
              "subcategories": []
            },
            {
              "id": "trenchers-toro-rt600",
              "name": "RT600",
              "subcategories": []
            },
            {
              "id": "trenchers-toro-rt1200",
              "name": "RT1200",
              "subcategories": []
            },
            {
              "id": "trenchers-toro-trx16",
              "name": "TRX16",
              "subcategories": []
            },
            {
              "id": "trenchers-toro-trx20",
              "name": "TRX20",
              "subcategories": []
            },
            {
              "id": "trenchers-toro-trx26",
              "name": "TRX26",
              "subcategories": []
            },
            {
              "id": "trenchers-toro-trx250",
              "name": "TRX250",
              "subcategories": []
            },
            {
              "id": "trenchers-toro-rtx300",
              "name": "RTX300",
              "subcategories": []
            },
            {
              "id": "trenchers-toro-other",
              "name": "OTHER",
              "subcategories": []
            }
          ]
        },
        {
          "id": "trenchers-tesmec",
          "name": "Tesmec",
          "subcategories": [
            {
              "id": "trenchers-tesmec-400mct",
              "name": "400MCT",
              "subcategories": []
            },
            {
              "id": "trenchers-tesmec-755dt",
              "name": "755DT",
              "subcategories": []
            },
            {
              "id": "trenchers-tesmec-885-cs",
              "name": "885 CS",
              "subcategories": []
            },
            {
              "id": "trenchers-tesmec-950r",
              "name": "950R",
              "subcategories": []
            },
            {
              "id": "trenchers-tesmec-1075",
              "name": "1075",
              "subcategories": []
            },
            {
              "id": "trenchers-tesmec-1150-evo",
              "name": "1150 EVO",
              "subcategories": []
            },
            {
              "id": "trenchers-tesmec-1150-evo-dd",
              "name": "1150 EVO DD",
              "subcategories": []
            },
            {
              "id": "trenchers-tesmec-1150xhd",
              "name": "1150XHD",
              "subcategories": []
            },
            {
              "id": "trenchers-tesmec-1475",
              "name": "1475",
              "subcategories": []
            },
            {
              "id": "trenchers-tesmec-city-cleanfast",
              "name": "CITY CLEANFAST",
              "subcategories": []
            },
            {
              "id": "trenchers-tesmec-cleanfast",
              "name": "CLEANFAST",
              "subcategories": []
            },
            {
              "id": "trenchers-tesmec-frb600",
              "name": "FRB600",
              "subcategories": []
            },
            {
              "id": "trenchers-tesmec-m5",
              "name": "M5",
              "subcategories": []
            },
            {
              "id": "trenchers-tesmec-sidecut-sc3c",
              "name": "SIDECUT SC3C",
              "subcategories": []
            },
            {
              "id": "trenchers-tesmec-sidecut-sc4p",
              "name": "SIDECUT SC4P",
              "subcategories": []
            },
            {
              "id": "trenchers-tesmec-tlm60-60",
              "name": "TLM60/60",
              "subcategories": []
            },
            {
              "id": "trenchers-tesmec-trs300",
              "name": "TRS300",
              "subcategories": []
            },
            {
              "id": "trenchers-tesmec-trs785",
              "name": "TRS785",
              "subcategories": []
            },
            {
              "id": "trenchers-tesmec-trs900",
              "name": "TRS900",
              "subcategories": []
            },
            {
              "id": "trenchers-tesmec-trs950",
              "name": "TRS950",
              "subcategories": []
            },
            {
              "id": "trenchers-tesmec-trs985",
              "name": "TRS985",
              "subcategories": []
            },
            {
              "id": "trenchers-tesmec-trs1000",
              "name": "TRS1000",
              "subcategories": []
            },
            {
              "id": "trenchers-tesmec-trs1075",
              "name": "TRS1075",
              "subcategories": []
            },
            {
              "id": "trenchers-tesmec-trs1150",
              "name": "TRS1150",
              "subcategories": []
            },
            {
              "id": "trenchers-tesmec-trs1175",
              "name": "TRS1175",
              "subcategories": []
            },
            {
              "id": "trenchers-tesmec-trs1375",
              "name": "TRS1375",
              "subcategories": []
            },
            {
              "id": "trenchers-tesmec-trs1475",
              "name": "TRS1475",
              "subcategories": []
            },
            {
              "id": "trenchers-tesmec-trs15757",
              "name": "TRS15757",
              "subcategories": []
            },
            {
              "id": "trenchers-tesmec-trs1675",
              "name": "TRS1675",
              "subcategories": []
            },
            {
              "id": "trenchers-tesmec-other",
              "name": "OTHER",
              "subcategories": []
            }
          ]
        },
        {
          "id": "trenchers-barreto",
          "name": "Barreto",
          "subcategories": [
            {
              "id": "trenchers-barreto-13stkh",
              "name": "13STKH",
              "subcategories": []
            },
            {
              "id": "trenchers-barreto-16stkb",
              "name": "16STKB",
              "subcategories": []
            },
            {
              "id": "trenchers-barreto-20rtk",
              "name": "20RTK",
              "subcategories": []
            },
            {
              "id": "trenchers-barreto-23rtk",
              "name": "23RTK",
              "subcategories": []
            },
            {
              "id": "trenchers-barreto-912",
              "name": "912",
              "subcategories": []
            },
            {
              "id": "trenchers-barreto-1324",
              "name": "1324",
              "subcategories": []
            },
            {
              "id": "trenchers-barreto-1624",
              "name": "1624",
              "subcategories": []
            },
            {
              "id": "trenchers-barreto-1824",
              "name": "1824",
              "subcategories": []
            },
            {
              "id": "trenchers-barreto-2036",
              "name": "2036",
              "subcategories": []
            },
            {
              "id": "trenchers-barreto-2324",
              "name": "2324",
              "subcategories": []
            },
            {
              "id": "trenchers-barreto-e924",
              "name": "E924",
              "subcategories": []
            },
            {
              "id": "trenchers-barreto-other",
              "name": "OTHER",
              "subcategories": []
            }
          ]
        },
        {
          "id": "trenchers-kundel",
          "name": "Kundel",
          "subcategories": [
            {
              "id": "trenchers-kundel-4x10",
              "name": "4X10",
              "subcategories": []
            },
            {
              "id": "trenchers-kundel-4x14",
              "name": "4X14",
              "subcategories": []
            },
            {
              "id": "trenchers-kundel-4x24",
              "name": "4X24",
              "subcategories": []
            },
            {
              "id": "trenchers-kundel-8x10",
              "name": "8X10",
              "subcategories": []
            },
            {
              "id": "trenchers-kundel-8x14",
              "name": "8X14",
              "subcategories": []
            },
            {
              "id": "trenchers-kundel-8x16",
              "name": "8X16",
              "subcategories": []
            },
            {
              "id": "trenchers-kundel-8x20",
              "name": "8X20",
              "subcategories": []
            },
            {
              "id": "trenchers-kundel-8x24",
              "name": "8X24",
              "subcategories": []
            },
            {
              "id": "trenchers-kundel-titan-5-lite-4x16",
              "name": "TITAN 5 LITE 4X16",
              "subcategories": []
            },
            {
              "id": "trenchers-kundel-titan-lite-4x20",
              "name": "TITAN LITE 4X20",
              "subcategories": []
            },
            {
              "id": "trenchers-kundel-titan-plus-6-10x24",
              "name": "TITAN PLUS 6 10X24",
              "subcategories": []
            },
            {
              "id": "trenchers-kundel-other",
              "name": "OTHER",
              "subcategories": []
            }
          ]
        },
        {
          "id": "trenchers-case",
          "name": "Case",
          "subcategories": [
            {
              "id": "trenchers-case-60",
              "name": "60",
              "subcategories": []
            },
            {
              "id": "trenchers-case-360",
              "name": "360",
              "subcategories": []
            },
            {
              "id": "trenchers-case-460",
              "name": "460",
              "subcategories": []
            },
            {
              "id": "trenchers-case-560",
              "name": "560",
              "subcategories": []
            },
            {
              "id": "trenchers-case-660",
              "name": "660",
              "subcategories": []
            },
            {
              "id": "trenchers-case-760",
              "name": "760",
              "subcategories": []
            },
            {
              "id": "trenchers-case-860",
              "name": "860",
              "subcategories": []
            },
            {
              "id": "trenchers-case-960",
              "name": "960",
              "subcategories": []
            },
            {
              "id": "trenchers-case-dh4",
              "name": "DH4",
              "subcategories": []
            },
            {
              "id": "trenchers-case-dh5",
              "name": "DH5",
              "subcategories": []
            },
            {
              "id": "trenchers-case-maxi-sneaker",
              "name": "MAXI SNEAKER",
              "subcategories": []
            },
            {
              "id": "trenchers-case-rt660",
              "name": "RT660",
              "subcategories": []
            },
            {
              "id": "trenchers-case-tf300",
              "name": "TF300",
              "subcategories": []
            },
            {
              "id": "trenchers-case-tl100",
              "name": "TL100",
              "subcategories": []
            },
            {
              "id": "trenchers-case-other",
              "name": "OTHER",
              "subcategories": []
            }
          ]
        },
        {
          "id": "trenchers-bron",
          "name": "Bron",
          "subcategories": [
            {
              "id": "trenchers-bron-150",
              "name": "150",
              "subcategories": []
            },
            {
              "id": "trenchers-bron-175",
              "name": "175",
              "subcategories": []
            },
            {
              "id": "trenchers-bron-450",
              "name": "450",
              "subcategories": []
            },
            {
              "id": "trenchers-bron-550",
              "name": "550",
              "subcategories": []
            },
            {
              "id": "trenchers-bron-585",
              "name": "585",
              "subcategories": []
            },
            {
              "id": "trenchers-bron-hs-ii",
              "name": "HS-II",
              "subcategories": []
            },
            {
              "id": "trenchers-bron-v100",
              "name": "V100",
              "subcategories": []
            },
            {
              "id": "trenchers-bron-v250",
              "name": "V250",
              "subcategories": []
            },
            {
              "id": "trenchers-bron-v75-1",
              "name": "V75-1",
              "subcategories": []
            },
            {
              "id": "trenchers-bron-v75-3",
              "name": "V75-3",
              "subcategories": []
            },
            {
              "id": "trenchers-bron-other",
              "name": "OTHER",
              "subcategories": []
            }
          ]
        },
        {
          "id": "trenchers-cleveland",
          "name": "Cleveland",
          "subcategories": [
            {
              "id": "trenchers-cleveland-236",
              "name": "236",
              "subcategories": []
            },
            {
              "id": "trenchers-cleveland-247",
              "name": "247",
              "subcategories": []
            },
            {
              "id": "trenchers-cleveland-320",
              "name": "320",
              "subcategories": []
            },
            {
              "id": "trenchers-cleveland-400",
              "name": "400",
              "subcategories": []
            },
            {
              "id": "trenchers-cleveland-400w",
              "name": "400W",
              "subcategories": []
            },
            {
              "id": "trenchers-cleveland-400w-hd",
              "name": "400W HD",
              "subcategories": []
            },
            {
              "id": "trenchers-cleveland-7036d",
              "name": "7036D",
              "subcategories": []
            },
            {
              "id": "trenchers-cleveland-7648",
              "name": "7648",
              "subcategories": []
            },
            {
              "id": "trenchers-cleveland-j26",
              "name": "J26",
              "subcategories": []
            },
            {
              "id": "trenchers-cleveland-j36",
              "name": "J36",
              "subcategories": []
            },
            {
              "id": "trenchers-cleveland-j46",
              "name": "J46",
              "subcategories": []
            },
            {
              "id": "trenchers-cleveland-js36",
              "name": "JS36",
              "subcategories": []
            },
            {
              "id": "trenchers-cleveland-js36w",
              "name": "JS36W",
              "subcategories": []
            },
            {
              "id": "trenchers-cleveland-v110",
              "name": "V110",
              "subcategories": []
            },
            {
              "id": "trenchers-cleveland-other",
              "name": "OTHER",
              "subcategories": []
            }
          ]
        },
        {
          "id": "trenchers-sherman-reilly",
          "name": "Sherman Reilly",
          "subcategories": [
            {
              "id": "trenchers-sherman-reilly-162c",
              "name": "162C",
              "subcategories": []
            },
            {
              "id": "trenchers-sherman-reilly-bwt1303",
              "name": "BWT1303",
              "subcategories": []
            },
            {
              "id": "trenchers-sherman-reilly-bwt1363",
              "name": "BWT1363",
              "subcategories": []
            },
            {
              "id": "trenchers-sherman-reilly-bwt1584dt",
              "name": "BWT1584DT",
              "subcategories": []
            },
            {
              "id": "trenchers-sherman-reilly-ddh-75t",
              "name": "DDH-75T",
              "subcategories": []
            },
            {
              "id": "trenchers-sherman-reilly-ddh100t",
              "name": "DDH100T",
              "subcategories": []
            },
            {
              "id": "trenchers-sherman-reilly-ddha-75t",
              "name": "DDHA-75T",
              "subcategories": []
            },
            {
              "id": "trenchers-sherman-reilly-ddha-100ddt",
              "name": "DDHA-100DDT",
              "subcategories": []
            },
            {
              "id": "trenchers-sherman-reilly-pt2766b",
              "name": "PT2766B",
              "subcategories": []
            },
            {
              "id": "trenchers-sherman-reilly-pt3000",
              "name": "PT3000",
              "subcategories": []
            },
            {
              "id": "trenchers-sherman-reilly-pt3366",
              "name": "PT3366",
              "subcategories": []
            },
            {
              "id": "trenchers-sherman-reilly-ptr7230",
              "name": "PTR7230",
              "subcategories": []
            },
            {
              "id": "trenchers-sherman-reilly-ptr7230s",
              "name": "PTR7230S",
              "subcategories": []
            },
            {
              "id": "trenchers-sherman-reilly-s785t",
              "name": "S785T",
              "subcategories": []
            },
            {
              "id": "trenchers-sherman-reilly-srp50t",
              "name": "SRP50T",
              "subcategories": []
            },
            {
              "id": "trenchers-sherman-reilly-udh70t",
              "name": "UDH70T",
              "subcategories": []
            },
            {
              "id": "trenchers-sherman-reilly-udha-70-t",
              "name": "UDHA-70-T",
              "subcategories": []
            },
            {
              "id": "trenchers-sherman-reilly-other",
              "name": "OTHER",
              "subcategories": []
            }
          ]
        },
        {
          "id": "trenchers-barber-greene",
          "name": "Barber Greene",
          "subcategories": []
        },
        {
          "id": "trenchers-capitol",
          "name": "Capitol",
          "subcategories": [
            {
              "id": "trenchers-capitol-350",
              "name": "350",
              "subcategories": []
            },
            {
              "id": "trenchers-capitol-750",
              "name": "750",
              "subcategories": []
            },
            {
              "id": "trenchers-capitol-810",
              "name": "810",
              "subcategories": []
            },
            {
              "id": "trenchers-capitol-900",
              "name": "900",
              "subcategories": []
            },
            {
              "id": "trenchers-capitol-1050",
              "name": "1050",
              "subcategories": []
            },
            {
              "id": "trenchers-capitol-other",
              "name": "OTHER",
              "subcategories": []
            }
          ]
        },
        {
          "id": "trenchers-trencor",
          "name": "Trencor",
          "subcategories": []
        },
        {
          "id": "trenchers-trencor-jetco",
          "name": "Trencor Jetco",
          "subcategories": []
        },
        {
          "id": "trenchers-tse",
          "name": "Tse",
          "subcategories": [
            {
              "id": "trenchers-tse-bwpt10060",
              "name": "BWPT10060",
              "subcategories": []
            },
            {
              "id": "trenchers-tse-bwpt12060",
              "name": "BWPT12060",
              "subcategories": []
            },
            {
              "id": "trenchers-tse-dpt30b",
              "name": "DPT30B",
              "subcategories": []
            },
            {
              "id": "trenchers-tse-dpt40b",
              "name": "DPT40B",
              "subcategories": []
            },
            {
              "id": "trenchers-tse-t30-36",
              "name": "T30/36",
              "subcategories": []
            },
            {
              "id": "trenchers-tse-t50-52bwrc",
              "name": "T50/52BWRC",
              "subcategories": []
            },
            {
              "id": "trenchers-tse-td40ah",
              "name": "TD40AH",
              "subcategories": []
            },
            {
              "id": "trenchers-tse-up70",
              "name": "UP70",
              "subcategories": []
            },
            {
              "id": "trenchers-tse-up70b",
              "name": "UP70B",
              "subcategories": []
            },
            {
              "id": "trenchers-tse-up85bd",
              "name": "UP85BD",
              "subcategories": []
            },
            {
              "id": "trenchers-tse-up85d",
              "name": "UP85D",
              "subcategories": []
            },
            {
              "id": "trenchers-tse-other",
              "name": "OTHER",
              "subcategories": []
            }
          ]
        },
        {
          "id": "trenchers-wolfe",
          "name": "Wolfe",
          "subcategories": [
            {
              "id": "trenchers-wolfe-250",
              "name": "250",
              "subcategories": []
            },
            {
              "id": "trenchers-wolfe-400",
              "name": "400",
              "subcategories": []
            },
            {
              "id": "trenchers-wolfe-540",
              "name": "540",
              "subcategories": []
            },
            {
              "id": "trenchers-wolfe-7000",
              "name": "7000",
              "subcategories": []
            },
            {
              "id": "trenchers-wolfe-8000",
              "name": "8000",
              "subcategories": []
            },
            {
              "id": "trenchers-wolfe-ct77040",
              "name": "CT77040",
              "subcategories": []
            },
            {
              "id": "trenchers-wolfe-dwt630",
              "name": "DWT630",
              "subcategories": []
            },
            {
              "id": "trenchers-wolfe-other",
              "name": "OTHER",
              "subcategories": []
            }
          ]
        }
      ]
    },
    {
      "id": "trailers",
      "name": "Trailers",
      "subcategories": [
        {
          "id": "trailers-asphalt-trailers",
          "name": "Asphalt Trailers",
          "subcategories": [
            {
              "id": "trailers-asphalt-trailers-etnyre",
              "name": "ETNYRE",
              "subcategories": []
            },
            {
              "id": "trailers-asphalt-trailers-polar",
              "name": "POLAR",
              "subcategories": []
            },
            {
              "id": "trailers-asphalt-trailers-heil",
              "name": "HEIL",
              "subcategories": []
            },
            {
              "id": "trailers-asphalt-trailers-harmon",
              "name": "HARMON",
              "subcategories": []
            },
            {
              "id": "trailers-asphalt-trailers-fruehauf",
              "name": "FRUEHAUF",
              "subcategories": []
            },
            {
              "id": "trailers-asphalt-trailers-retesa",
              "name": "RETESA",
              "subcategories": []
            },
            {
              "id": "trailers-asphalt-trailers-lbt",
              "name": "LBT",
              "subcategories": []
            },
            {
              "id": "trailers-asphalt-trailers-trailmobile",
              "name": "TRAILMOBILE",
              "subcategories": []
            },
            {
              "id": "trailers-asphalt-trailers-advance",
              "name": "ADVANCE",
              "subcategories": []
            },
            {
              "id": "trailers-asphalt-trailers-brenner",
              "name": "BRENNER",
              "subcategories": []
            },
            {
              "id": "trailers-asphalt-trailers-acro",
              "name": "ACRO",
              "subcategories": []
            },
            {
              "id": "trailers-asphalt-trailers-beall",
              "name": "BEALL",
              "subcategories": []
            },
            {
              "id": "trailers-asphalt-trailers-bell",
              "name": "BELL",
              "subcategories": []
            },
            {
              "id": "trailers-asphalt-trailers-butler",
              "name": "BUTLER",
              "subcategories": []
            },
            {
              "id": "trailers-asphalt-trailers-falcon",
              "name": "FALCON",
              "subcategories": []
            },
            {
              "id": "trailers-asphalt-trailers-jamieson",
              "name": "JAMIESON",
              "subcategories": []
            },
            {
              "id": "trailers-asphalt-trailers-kersten",
              "name": "KERSTEN",
              "subcategories": []
            },
            {
              "id": "trailers-asphalt-trailers-mac-ltt",
              "name": "MAC LTT",
              "subcategories": []
            },
            {
              "id": "trailers-asphalt-trailers-marathon",
              "name": "MARATHON",
              "subcategories": []
            },
            {
              "id": "trailers-asphalt-trailers-penske",
              "name": "PENSKE",
              "subcategories": []
            },
            {
              "id": "trailers-asphalt-trailers-pioneer",
              "name": "PIONEER",
              "subcategories": []
            },
            {
              "id": "trailers-asphalt-trailers-remtec",
              "name": "REMTEC",
              "subcategories": []
            },
            {
              "id": "trailers-asphalt-trailers-tretesa",
              "name": "TRETESA",
              "subcategories": []
            },
            {
              "id": "trailers-asphalt-trailers-rosco",
              "name": "ROSCO",
              "subcategories": []
            },
            {
              "id": "trailers-asphalt-trailers-ste",
              "name": "STE",
              "subcategories": []
            },
            {
              "id": "trailers-asphalt-trailers-trailmaster",
              "name": "TRAILMASTER",
              "subcategories": []
            },
            {
              "id": "trailers-asphalt-trailers-vim",
              "name": "VIM",
              "subcategories": []
            },
            {
              "id": "trailers-asphalt-trailers-westmark",
              "name": "WESTMARK",
              "subcategories": []
            },
            {
              "id": "trailers-asphalt-trailers-other",
              "name": "OTHER",
              "subcategories": []
            }
          ]
        },
        {
          "id": "trailers-beverage-trailers",
          "name": "Beverage Trailers",
          "subcategories": [
            {
              "id": "trailers-beverage-trailers-hackney",
              "name": "HACKNEY",
              "subcategories": []
            },
            {
              "id": "trailers-beverage-trailers-hesse",
              "name": "HESSE",
              "subcategories": []
            },
            {
              "id": "trailers-beverage-trailers-hyundai",
              "name": "HYUNDAI",
              "subcategories": []
            },
            {
              "id": "trailers-beverage-trailers-mickey",
              "name": "MICKEY",
              "subcategories": []
            },
            {
              "id": "trailers-beverage-trailers-parco-hesse",
              "name": "PARCO-HESSE",
              "subcategories": []
            },
            {
              "id": "trailers-beverage-trailers-other",
              "name": "OTHER",
              "subcategories": []
            }
          ]
        },
        {
          "id": "trailers-blade-tower-trailers",
          "name": "Blade / Tower Trailers",
          "subcategories": []
        },
        {
          "id": "trailers-bottom-dump-trailers",
          "name": "Bottom Dump Trailers",
          "subcategories": [
            {
              "id": "trailers-bottom-dump-trailers-ranco",
              "name": "RANCO",
              "subcategories": []
            },
            {
              "id": "trailers-bottom-dump-trailers-armor-lite",
              "name": "ARMOR LITE",
              "subcategories": []
            },
            {
              "id": "trailers-bottom-dump-trailers-cps",
              "name": "CPS",
              "subcategories": []
            },
            {
              "id": "trailers-bottom-dump-trailers-midland",
              "name": "MIDLAND",
              "subcategories": []
            },
            {
              "id": "trailers-bottom-dump-trailers-arnes",
              "name": "ARNES",
              "subcategories": []
            },
            {
              "id": "trailers-bottom-dump-trailers-manac",
              "name": "MANAC",
              "subcategories": []
            },
            {
              "id": "trailers-bottom-dump-trailers-const-trlr-spec",
              "name": "CONST TRLR SPEC",
              "subcategories": []
            },
            {
              "id": "trailers-bottom-dump-trailers-renegade",
              "name": "RENEGADE",
              "subcategories": []
            },
            {
              "id": "trailers-bottom-dump-trailers-dura-hall",
              "name": "DURA HALL",
              "subcategories": []
            },
            {
              "id": "trailers-bottom-dump-trailers-exa",
              "name": "EXA",
              "subcategories": []
            },
            {
              "id": "trailers-bottom-dump-trailers-ace",
              "name": "ACE",
              "subcategories": []
            },
            {
              "id": "trailers-bottom-dump-trailers-beall",
              "name": "BEALL",
              "subcategories": []
            },
            {
              "id": "trailers-bottom-dump-trailers-brazos",
              "name": "BRAZOS",
              "subcategories": []
            },
            {
              "id": "trailers-bottom-dump-trailers-clement",
              "name": "CLEMENT",
              "subcategories": []
            },
            {
              "id": "trailers-bottom-dump-trailers-cross-country",
              "name": "CROSS COUNTRY",
              "subcategories": []
            },
            {
              "id": "trailers-bottom-dump-trailers-custom-built",
              "name": "CUSTOM BUILT",
              "subcategories": []
            },
            {
              "id": "trailers-bottom-dump-trailers-decap",
              "name": "DECAP",
              "subcategories": []
            },
            {
              "id": "trailers-bottom-dump-trailers-doepker",
              "name": "DOEPKER",
              "subcategories": []
            },
            {
              "id": "trailers-bottom-dump-trailers-fruehauf",
              "name": "FRUEHAUF",
              "subcategories": []
            },
            {
              "id": "trailers-bottom-dump-trailers-gallegos",
              "name": "GALLEGOS",
              "subcategories": []
            },
            {
              "id": "trailers-bottom-dump-trailers-hard-core",
              "name": "HARD CORE",
              "subcategories": []
            },
            {
              "id": "trailers-bottom-dump-trailers-iowa-trailer",
              "name": "IOWA TRAILER",
              "subcategories": []
            },
            {
              "id": "trailers-bottom-dump-trailers-iron-lite",
              "name": "IRON LITE",
              "subcategories": []
            },
            {
              "id": "trailers-bottom-dump-trailers-load-king",
              "name": "LOAD KING",
              "subcategories": []
            },
            {
              "id": "trailers-bottom-dump-trailers-loadline",
              "name": "LOADLINE",
              "subcategories": []
            },
            {
              "id": "trailers-bottom-dump-trailers-loewen",
              "name": "LOEWEN",
              "subcategories": []
            },
            {
              "id": "trailers-bottom-dump-trailers-midland",
              "name": "MIDLAND",
              "subcategories": []
            },
            {
              "id": "trailers-bottom-dump-trailers-puma",
              "name": "PUMA",
              "subcategories": []
            },
            {
              "id": "trailers-bottom-dump-trailers-red-river",
              "name": "RED RIVER",
              "subcategories": []
            },
            {
              "id": "trailers-bottom-dump-trailers-r-way",
              "name": "R-WAY",
              "subcategories": []
            },
            {
              "id": "trailers-bottom-dump-trailers-trail-king",
              "name": "TRAIL KING",
              "subcategories": []
            },
            {
              "id": "trailers-bottom-dump-trailers-travis",
              "name": "TRAVIS",
              "subcategories": []
            },
            {
              "id": "trailers-bottom-dump-trailers-ttsa",
              "name": "TTSA",
              "subcategories": []
            },
            {
              "id": "trailers-bottom-dump-trailers-other",
              "name": "OTHER",
              "subcategories": []
            }
          ]
        },
        {
          "id": "trailers-car-carrier-trailers",
          "name": "Car Carrier Trailers",
          "subcategories": [
            {
              "id": "trailers-car-carrier-trailers-cottrell",
              "name": "COTTRELL",
              "subcategories": []
            },
            {
              "id": "trailers-car-carrier-trailers-sun-country",
              "name": "SUN COUNTRY",
              "subcategories": []
            },
            {
              "id": "trailers-car-carrier-trailers-kaufman",
              "name": "KAUFMAN",
              "subcategories": []
            },
            {
              "id": "trailers-car-carrier-trailers-lohr",
              "name": "LOHR",
              "subcategories": []
            },
            {
              "id": "trailers-car-carrier-trailers-buckeye-hauler",
              "name": "BUCKEYE HAULER",
              "subcategories": []
            },
            {
              "id": "trailers-car-carrier-trailers-jj-trailer",
              "name": "JJ TRAILER",
              "subcategories": []
            },
            {
              "id": "trailers-car-carrier-trailers-wally-mo",
              "name": "WALLY-MO",
              "subcategories": []
            },
            {
              "id": "trailers-car-carrier-trailers-kentucky",
              "name": "KENTUCKY",
              "subcategories": []
            },
            {
              "id": "trailers-car-carrier-trailers-sun-valley",
              "name": "SUN VALLEY",
              "subcategories": []
            },
            {
              "id": "trailers-car-carrier-trailers-boydston",
              "name": "BOYDSTON",
              "subcategories": []
            },
            {
              "id": "trailers-car-carrier-trailers-boydstun",
              "name": "BOYDSTUN",
              "subcategories": []
            },
            {
              "id": "trailers-car-carrier-trailers-great-dane",
              "name": "GREAT DANE",
              "subcategories": []
            },
            {
              "id": "trailers-car-carrier-trailers-shop-bilt",
              "name": "SHOP BILT",
              "subcategories": []
            },
            {
              "id": "trailers-car-carrier-trailers-texas-pride",
              "name": "TEXAS PRIDE",
              "subcategories": []
            },
            {
              "id": "trailers-car-carrier-trailers-sun-valley",
              "name": "SUN VALLEY",
              "subcategories": []
            },
            {
              "id": "trailers-car-carrier-trailers-other",
              "name": "OTHER",
              "subcategories": []
            }
          ]
        },
        {
          "id": "trailers-chemical-acid-tank-trailers",
          "name": "Chemical / Acid Tank Trailers",
          "subcategories": []
        },
        {
          "id": "trailers-chip-trailers",
          "name": "Chip Trailers",
          "subcategories": [
            {
              "id": "trailers-chip-trailers-allied",
              "name": "ALLIED",
              "subcategories": []
            },
            {
              "id": "trailers-chip-trailers-alloy",
              "name": "ALLOY",
              "subcategories": []
            },
            {
              "id": "trailers-chip-trailers-barker",
              "name": "BARKER",
              "subcategories": []
            },
            {
              "id": "trailers-chip-trailers-custom",
              "name": "CUSTOM",
              "subcategories": []
            },
            {
              "id": "trailers-chip-trailers-dorsey",
              "name": "DORSEY",
              "subcategories": []
            },
            {
              "id": "trailers-chip-trailers-imco-idaho",
              "name": "IMCO IDAHO",
              "subcategories": []
            },
            {
              "id": "trailers-chip-trailers-iti",
              "name": "ITI",
              "subcategories": []
            },
            {
              "id": "trailers-chip-trailers-kalyan-seibert",
              "name": "KALYAN SEIBERT",
              "subcategories": []
            },
            {
              "id": "trailers-chip-trailers-mac",
              "name": "MAC",
              "subcategories": []
            },
            {
              "id": "trailers-chip-trailers-manac",
              "name": "MANAC",
              "subcategories": []
            },
            {
              "id": "trailers-chip-trailers-nabors",
              "name": "NABORS",
              "subcategories": []
            },
            {
              "id": "trailers-chip-trailers-peerless",
              "name": "PEERLESS",
              "subcategories": []
            },
            {
              "id": "trailers-chip-trailers-beall",
              "name": "BEALL",
              "subcategories": []
            },
            {
              "id": "trailers-chip-trailers-byrne",
              "name": "BYRNE",
              "subcategories": []
            },
            {
              "id": "trailers-chip-trailers-colombia",
              "name": "COLOMBIA",
              "subcategories": []
            },
            {
              "id": "trailers-chip-trailers-frontier",
              "name": "FRONTIER",
              "subcategories": []
            },
            {
              "id": "trailers-chip-trailers-great-dane",
              "name": "GREAT DANE",
              "subcategories": []
            },
            {
              "id": "trailers-chip-trailers-jd-bertolini",
              "name": "JD BERTOLINI",
              "subcategories": []
            },
            {
              "id": "trailers-chip-trailers-pierce",
              "name": "PIERCE",
              "subcategories": []
            },
            {
              "id": "trailers-chip-trailers-pitts",
              "name": "PITTS",
              "subcategories": []
            },
            {
              "id": "trailers-chip-trailers-stoodley",
              "name": "STOODLEY",
              "subcategories": []
            },
            {
              "id": "trailers-chip-trailers-temisko",
              "name": "TEMISKO",
              "subcategories": []
            },
            {
              "id": "trailers-chip-trailers-tycrop",
              "name": "TYCROP",
              "subcategories": []
            },
            {
              "id": "trailers-chip-trailers-other",
              "name": "OTHER",
              "subcategories": []
            }
          ]
        },
        {
          "id": "trailers-crude-oil-tank-trailers",
          "name": "Crude Oil Tank Trailers",
          "subcategories": []
        },
        {
          "id": "trailers-curtain-side-trailers",
          "name": "Curtain Side Trailers",
          "subcategories": []
        },
        {
          "id": "trailers-double-drop-trailers",
          "name": "Double Drop Trailers",
          "subcategories": [
            {
              "id": "trailers-double-drop-trailers-xl-specialized",
              "name": "XL SPECIALIZED",
              "subcategories": []
            },
            {
              "id": "trailers-double-drop-trailers-fontaine",
              "name": "FONTAINE",
              "subcategories": []
            },
            {
              "id": "trailers-double-drop-trailers-trail-king",
              "name": "TRAIL KING",
              "subcategories": []
            },
            {
              "id": "trailers-double-drop-trailers-alpha-hd",
              "name": "ALPHA HD",
              "subcategories": []
            },
            {
              "id": "trailers-double-drop-trailers-brandt",
              "name": "BRANDT",
              "subcategories": []
            },
            {
              "id": "trailers-double-drop-trailers-jet",
              "name": "JET",
              "subcategories": []
            },
            {
              "id": "trailers-double-drop-trailers-kalyn-siebert",
              "name": "KALYN SIEBERT",
              "subcategories": []
            },
            {
              "id": "trailers-double-drop-trailers-manac",
              "name": "MANAC",
              "subcategories": []
            },
            {
              "id": "trailers-double-drop-trailers-muv-all",
              "name": "MUV-ALL",
              "subcategories": []
            },
            {
              "id": "trailers-double-drop-trailers-talbert",
              "name": "TALBERT",
              "subcategories": []
            },
            {
              "id": "trailers-double-drop-trailers-atoka",
              "name": "ATOKA",
              "subcategories": []
            },
            {
              "id": "trailers-double-drop-trailers-bws",
              "name": "BWS",
              "subcategories": []
            },
            {
              "id": "trailers-double-drop-trailers-dorsey",
              "name": "DORSEY",
              "subcategories": []
            },
            {
              "id": "trailers-double-drop-trailers-etnyre",
              "name": "ETNYRE",
              "subcategories": []
            },
            {
              "id": "trailers-double-drop-trailers-extreme",
              "name": "EXTREME",
              "subcategories": []
            },
            {
              "id": "trailers-double-drop-trailers-globe",
              "name": "GLOBE",
              "subcategories": []
            },
            {
              "id": "trailers-double-drop-trailers-kaufman",
              "name": "KAUFMAN",
              "subcategories": []
            },
            {
              "id": "trailers-double-drop-trailers-landoll",
              "name": "LANDOLL",
              "subcategories": []
            },
            {
              "id": "trailers-double-drop-trailers-ledwell",
              "name": "LEDWELL",
              "subcategories": []
            },
            {
              "id": "trailers-double-drop-trailers-overbilt",
              "name": "OVERBILT",
              "subcategories": []
            },
            {
              "id": "trailers-double-drop-trailers-paisano",
              "name": "PAISANO",
              "subcategories": []
            },
            {
              "id": "trailers-double-drop-trailers-talbert",
              "name": "TALBERT",
              "subcategories": []
            },
            {
              "id": "trailers-double-drop-trailers-temisko",
              "name": "TEMISKO",
              "subcategories": []
            },
            {
              "id": "trailers-double-drop-trailers-waltron",
              "name": "WALTRON",
              "subcategories": []
            },
            {
              "id": "trailers-double-drop-trailers-wilson",
              "name": "WILSON",
              "subcategories": []
            },
            {
              "id": "trailers-double-drop-trailers-other",
              "name": "OTHER",
              "subcategories": []
            }
          ]
        },
        {
          "id": "trailers-drop-deck-trailers",
          "name": "Drop Deck Trailers",
          "subcategories": [
            {
              "id": "trailers-drop-deck-trailers-dorsey",
              "name": "DORSEY",
              "subcategories": []
            },
            {
              "id": "trailers-drop-deck-trailers-fontaine",
              "name": "FONTAINE",
              "subcategories": []
            },
            {
              "id": "trailers-drop-deck-trailers-reitnouer",
              "name": "REITNOUER",
              "subcategories": []
            },
            {
              "id": "trailers-drop-deck-trailers-manac",
              "name": "MANAC",
              "subcategories": []
            },
            {
              "id": "trailers-drop-deck-trailers-wabash",
              "name": "WABASH",
              "subcategories": []
            },
            {
              "id": "trailers-drop-deck-trailers-transcraft",
              "name": "TRANSCRAFT",
              "subcategories": []
            },
            {
              "id": "trailers-drop-deck-trailers-doonan",
              "name": "DOONAN",
              "subcategories": []
            },
            {
              "id": "trailers-drop-deck-trailers-neville-built",
              "name": "NEVILLE BUILT",
              "subcategories": []
            },
            {
              "id": "trailers-drop-deck-trailers-doonan-specialized",
              "name": "DOONAN SPECIALIZED",
              "subcategories": []
            },
            {
              "id": "trailers-drop-deck-trailers-demco",
              "name": "DEMCO",
              "subcategories": []
            },
            {
              "id": "trailers-drop-deck-trailers-aaa",
              "name": "AAA",
              "subcategories": []
            },
            {
              "id": "trailers-drop-deck-trailers-ace",
              "name": "ACE",
              "subcategories": []
            },
            {
              "id": "trailers-drop-deck-trailers-behnke",
              "name": "BEHNKE",
              "subcategories": []
            },
            {
              "id": "trailers-drop-deck-trailers-benson",
              "name": "BENSON",
              "subcategories": []
            },
            {
              "id": "trailers-drop-deck-trailers-brazos",
              "name": "BRAZOS",
              "subcategories": []
            },
            {
              "id": "trailers-drop-deck-trailers-bws",
              "name": "BWS",
              "subcategories": []
            },
            {
              "id": "trailers-drop-deck-trailers-demco",
              "name": "DEMCO",
              "subcategories": []
            },
            {
              "id": "trailers-drop-deck-trailers-doepker",
              "name": "DOEPKER",
              "subcategories": []
            },
            {
              "id": "trailers-drop-deck-trailers-dura-hall",
              "name": "DURA HALL",
              "subcategories": []
            },
            {
              "id": "trailers-drop-deck-trailers-east",
              "name": "EAST",
              "subcategories": []
            },
            {
              "id": "trailers-drop-deck-trailers-etnyre",
              "name": "ETNYRE",
              "subcategories": []
            },
            {
              "id": "trailers-drop-deck-trailers-extreme",
              "name": "EXTREME",
              "subcategories": []
            },
            {
              "id": "trailers-drop-deck-trailers-felling",
              "name": "FELLING",
              "subcategories": []
            },
            {
              "id": "trailers-drop-deck-trailers-fruehauf",
              "name": "FRUEHAUF",
              "subcategories": []
            },
            {
              "id": "trailers-drop-deck-trailers-fwr",
              "name": "FWR",
              "subcategories": []
            },
            {
              "id": "trailers-drop-deck-trailers-gincor",
              "name": "GINCOR",
              "subcategories": []
            },
            {
              "id": "trailers-drop-deck-trailers-great-dane",
              "name": "GREAT DANE",
              "subcategories": []
            },
            {
              "id": "trailers-drop-deck-trailers-iron-lite",
              "name": "IRON LITE",
              "subcategories": []
            },
            {
              "id": "trailers-drop-deck-trailers-jamieson",
              "name": "JAMIESON",
              "subcategories": []
            },
            {
              "id": "trailers-drop-deck-trailers-jet",
              "name": "JET",
              "subcategories": []
            },
            {
              "id": "trailers-drop-deck-trailers-kayln-siebert",
              "name": "KAYLN SIEBERT",
              "subcategories": []
            },
            {
              "id": "trailers-drop-deck-trailers-kaufman",
              "name": "KAUFMAN",
              "subcategories": []
            },
            {
              "id": "trailers-drop-deck-trailers-landoll",
              "name": "LANDOLL",
              "subcategories": []
            },
            {
              "id": "trailers-drop-deck-trailers-ledwell",
              "name": "LEDWELL",
              "subcategories": []
            },
            {
              "id": "trailers-drop-deck-trailers-load-king",
              "name": "LOAD KING",
              "subcategories": []
            },
            {
              "id": "trailers-drop-deck-trailers-load-trail",
              "name": "LOAD TRAIL",
              "subcategories": []
            },
            {
              "id": "trailers-drop-deck-trailers-lode-king",
              "name": "LODE KING",
              "subcategories": []
            },
            {
              "id": "trailers-drop-deck-trailers-mac-trlr",
              "name": "MAC TRLR",
              "subcategories": []
            },
            {
              "id": "trailers-drop-deck-trailers-mas-trlr",
              "name": "MAS TRLR",
              "subcategories": []
            },
            {
              "id": "trailers-drop-deck-trailers-maxitrans",
              "name": "MAXITRANS",
              "subcategories": []
            },
            {
              "id": "trailers-drop-deck-trailers-midland",
              "name": "MIDLAND",
              "subcategories": []
            },
            {
              "id": "trailers-drop-deck-trailers-muv-all",
              "name": "MUV-ALL",
              "subcategories": []
            },
            {
              "id": "trailers-drop-deck-trailers-nuttall",
              "name": "NUTTALL",
              "subcategories": []
            },
            {
              "id": "trailers-drop-deck-trailers-overbilt",
              "name": "OVERBILT",
              "subcategories": []
            },
            {
              "id": "trailers-drop-deck-trailers-pitts",
              "name": "PITTS",
              "subcategories": []
            },
            {
              "id": "trailers-drop-deck-trailers-prestige",
              "name": "PRESTIGE",
              "subcategories": []
            },
            {
              "id": "trailers-drop-deck-trailers-raja",
              "name": "RAJA",
              "subcategories": []
            },
            {
              "id": "trailers-drop-deck-trailers-renn",
              "name": "RENN",
              "subcategories": []
            },
            {
              "id": "trailers-drop-deck-trailers-stonestar",
              "name": "STONESTAR",
              "subcategories": []
            },
            {
              "id": "trailers-drop-deck-trailers-talbert",
              "name": "TALBERT",
              "subcategories": []
            },
            {
              "id": "trailers-drop-deck-trailers-trail-king",
              "name": "TRAIL KING",
              "subcategories": []
            },
            {
              "id": "trailers-drop-deck-trailers-trailboss",
              "name": "TRAILBOSS",
              "subcategories": []
            },
            {
              "id": "trailers-drop-deck-trailers-trail-eze",
              "name": "TRAIL-EZE",
              "subcategories": []
            },
            {
              "id": "trailers-drop-deck-trailers-wabash",
              "name": "WABASH",
              "subcategories": []
            },
            {
              "id": "trailers-drop-deck-trailers-viking",
              "name": "VIKING",
              "subcategories": []
            },
            {
              "id": "trailers-drop-deck-trailers-wade",
              "name": "WADE",
              "subcategories": []
            },
            {
              "id": "trailers-drop-deck-trailers-wilson",
              "name": "WILSON",
              "subcategories": []
            },
            {
              "id": "trailers-drop-deck-trailers-xl-specialized",
              "name": "XL SPECIALIZED",
              "subcategories": []
            },
            {
              "id": "trailers-drop-deck-trailers-other",
              "name": "OTHER",
              "subcategories": []
            }
          ]
        },
        {
          "id": "trailers-end-dump-trailers",
          "name": "End Dump Trailers",
          "subcategories": [
            {
              "id": "trailers-end-dump-trailers-mac-trailer-mfg",
              "name": "MAC TRAILER MFG",
              "subcategories": []
            },
            {
              "id": "trailers-end-dump-trailers-east",
              "name": "EAST",
              "subcategories": []
            },
            {
              "id": "trailers-end-dump-trailers-travis",
              "name": "TRAVIS",
              "subcategories": []
            },
            {
              "id": "trailers-end-dump-trailers-clement",
              "name": "CLEMENT",
              "subcategories": []
            },
            {
              "id": "trailers-end-dump-trailers-armor-lite",
              "name": "ARMOR LITE",
              "subcategories": []
            },
            {
              "id": "trailers-end-dump-trailers-trailstar",
              "name": "TRAILSTAR",
              "subcategories": []
            },
            {
              "id": "trailers-end-dump-trailers-arnes",
              "name": "ARNES",
              "subcategories": []
            },
            {
              "id": "trailers-end-dump-trailers-vantage",
              "name": "VANTAGE",
              "subcategories": []
            },
            {
              "id": "trailers-end-dump-trailers-constr-trlr-spec",
              "name": "CONSTR TRLR SPEC",
              "subcategories": []
            },
            {
              "id": "trailers-end-dump-trailers-ranco",
              "name": "RANCO",
              "subcategories": []
            },
            {
              "id": "trailers-end-dump-trailers-afm",
              "name": "AFM",
              "subcategories": []
            },
            {
              "id": "trailers-end-dump-trailers-alfab",
              "name": "ALFAB",
              "subcategories": []
            },
            {
              "id": "trailers-end-dump-trailers-alumatech",
              "name": "ALUMATECH",
              "subcategories": []
            },
            {
              "id": "trailers-end-dump-trailers-apm",
              "name": "APM",
              "subcategories": []
            },
            {
              "id": "trailers-end-dump-trailers-artex",
              "name": "ARTEX",
              "subcategories": []
            },
            {
              "id": "trailers-end-dump-trailers-beall",
              "name": "BEALL",
              "subcategories": []
            },
            {
              "id": "trailers-end-dump-trailers-axle",
              "name": "AXLE",
              "subcategories": []
            },
            {
              "id": "trailers-end-dump-trailers-benson",
              "name": "BENSON",
              "subcategories": []
            },
            {
              "id": "trailers-end-dump-trailers-brazos",
              "name": "BRAZOS",
              "subcategories": []
            },
            {
              "id": "trailers-end-dump-trailers-bte",
              "name": "BTE",
              "subcategories": []
            },
            {
              "id": "trailers-end-dump-trailers-cancade",
              "name": "CANCADE",
              "subcategories": []
            },
            {
              "id": "trailers-end-dump-trailers-canuck",
              "name": "CANUCK",
              "subcategories": []
            },
            {
              "id": "trailers-end-dump-trailers-cbb",
              "name": "CBB",
              "subcategories": []
            },
            {
              "id": "trailers-end-dump-trailers-cmc",
              "name": "CMC",
              "subcategories": []
            },
            {
              "id": "trailers-end-dump-trailers-cobra",
              "name": "COBRA",
              "subcategories": []
            },
            {
              "id": "trailers-end-dump-trailers-coras",
              "name": "CORAS",
              "subcategories": []
            },
            {
              "id": "trailers-end-dump-trailers-cps",
              "name": "CPS",
              "subcategories": []
            },
            {
              "id": "trailers-end-dump-trailers-cross-country",
              "name": "CROSS COUNTRY",
              "subcategories": []
            },
            {
              "id": "trailers-end-dump-trailers-deloupe",
              "name": "DELOUPE",
              "subcategories": []
            },
            {
              "id": "trailers-end-dump-trailers-dierzen",
              "name": "DIERZEN",
              "subcategories": []
            },
            {
              "id": "trailers-end-dump-trailers-doepker",
              "name": "DOEPKER",
              "subcategories": []
            },
            {
              "id": "trailers-end-dump-trailers-dorsey",
              "name": "DORSEY",
              "subcategories": []
            },
            {
              "id": "trailers-end-dump-trailers-dragon-products",
              "name": "DRAGON PRODUCTS",
              "subcategories": []
            },
            {
              "id": "trailers-end-dump-trailers-dura-hall",
              "name": "DURA HALL",
              "subcategories": []
            },
            {
              "id": "trailers-end-dump-trailers-e-pak-mfg",
              "name": "E-PAK MFG",
              "subcategories": []
            },
            {
              "id": "trailers-end-dump-trailers-everlite",
              "name": "EVERLITE",
              "subcategories": []
            },
            {
              "id": "trailers-end-dump-trailers-exa",
              "name": "EXA",
              "subcategories": []
            },
            {
              "id": "trailers-end-dump-trailers-freightmaster",
              "name": "FREIGHTMASTER",
              "subcategories": []
            },
            {
              "id": "trailers-end-dump-trailers-freightmore-trans",
              "name": "FREIGHTMORE TRANS",
              "subcategories": []
            },
            {
              "id": "trailers-end-dump-trailers-fruehauf",
              "name": "FRUEHAUF",
              "subcategories": []
            },
            {
              "id": "trailers-end-dump-trailers-gallegos",
              "name": "GALLEGOS",
              "subcategories": []
            },
            {
              "id": "trailers-end-dump-trailers-gbb",
              "name": "GBB",
              "subcategories": []
            },
            {
              "id": "trailers-end-dump-trailers-globe",
              "name": "GLOBE",
              "subcategories": []
            },
            {
              "id": "trailers-end-dump-trailers-gorski",
              "name": "GORSKI",
              "subcategories": []
            },
            {
              "id": "trailers-end-dump-trailers-gtc",
              "name": "GTC",
              "subcategories": []
            },
            {
              "id": "trailers-end-dump-trailers-h-h-trlr",
              "name": "H&H TRLR",
              "subcategories": []
            },
            {
              "id": "trailers-end-dump-trailers-hahnz",
              "name": "HAHNZ",
              "subcategories": []
            },
            {
              "id": "trailers-end-dump-trailers-hamelex-white",
              "name": "HAMELEX WHITE",
              "subcategories": []
            },
            {
              "id": "trailers-end-dump-trailers-heil",
              "name": "HEIL",
              "subcategories": []
            },
            {
              "id": "trailers-end-dump-trailers-hercules",
              "name": "HERCULES",
              "subcategories": []
            },
            {
              "id": "trailers-end-dump-trailers-hicks",
              "name": "HICKS",
              "subcategories": []
            },
            {
              "id": "trailers-end-dump-trailers-hilbilt",
              "name": "HILBILT",
              "subcategories": []
            },
            {
              "id": "trailers-end-dump-trailers-hitchcock",
              "name": "HITCHCOCK",
              "subcategories": []
            },
            {
              "id": "trailers-end-dump-trailers-hobbs",
              "name": "HOBBS",
              "subcategories": []
            },
            {
              "id": "trailers-end-dump-trailers-iron-lite",
              "name": "IRON LITE",
              "subcategories": []
            },
            {
              "id": "trailers-end-dump-trailers-jamieson",
              "name": "JAMIESON",
              "subcategories": []
            },
            {
              "id": "trailers-end-dump-trailers-kruz",
              "name": "KRUZ",
              "subcategories": []
            },
            {
              "id": "trailers-end-dump-trailers-load-king",
              "name": "LOAD KING",
              "subcategories": []
            },
            {
              "id": "trailers-end-dump-trailers-loadline",
              "name": "LOADLINE",
              "subcategories": []
            },
            {
              "id": "trailers-end-dump-trailers-loewen",
              "name": "LOEWEN",
              "subcategories": []
            },
            {
              "id": "trailers-end-dump-trailers-lufkin",
              "name": "LUFKIN",
              "subcategories": []
            },
            {
              "id": "trailers-end-dump-trailers-lusty",
              "name": "LUSTY",
              "subcategories": []
            },
            {
              "id": "trailers-end-dump-trailers-manac",
              "name": "MANAC",
              "subcategories": []
            },
            {
              "id": "trailers-end-dump-trailers-mars",
              "name": "MARS",
              "subcategories": []
            },
            {
              "id": "trailers-end-dump-trailers-mate",
              "name": "MATE",
              "subcategories": []
            },
            {
              "id": "trailers-end-dump-trailers-maxitran",
              "name": "MAXITRAN",
              "subcategories": []
            },
            {
              "id": "trailers-end-dump-trailers-midland",
              "name": "MIDLAND",
              "subcategories": []
            },
            {
              "id": "trailers-end-dump-trailers-montone",
              "name": "MONTONE",
              "subcategories": []
            },
            {
              "id": "trailers-end-dump-trailers-moore",
              "name": "MOORE",
              "subcategories": []
            },
            {
              "id": "trailers-end-dump-trailers-msr",
              "name": "MSR",
              "subcategories": []
            },
            {
              "id": "trailers-end-dump-trailers-mtm",
              "name": "MTM",
              "subcategories": []
            },
            {
              "id": "trailers-end-dump-trailers-muscat",
              "name": "MUSCAT",
              "subcategories": []
            },
            {
              "id": "trailers-end-dump-trailers-nuestar",
              "name": "NUESTAR",
              "subcategories": []
            },
            {
              "id": "trailers-end-dump-trailers-nuttall",
              "name": "NUTTALL",
              "subcategories": []
            },
            {
              "id": "trailers-end-dump-trailers-palmer",
              "name": "PALMER",
              "subcategories": []
            },
            {
              "id": "trailers-end-dump-trailers-peak",
              "name": "PEAK",
              "subcategories": []
            },
            {
              "id": "trailers-end-dump-trailers-puma",
              "name": "PUMA",
              "subcategories": []
            },
            {
              "id": "trailers-end-dump-trailers-raglan",
              "name": "RAGLAN",
              "subcategories": []
            },
            {
              "id": "trailers-end-dump-trailers-ranco",
              "name": "RANCO",
              "subcategories": []
            },
            {
              "id": "trailers-end-dump-trailers-ravens",
              "name": "RAVENS",
              "subcategories": []
            },
            {
              "id": "trailers-end-dump-trailers-reliance",
              "name": "RELIANCE",
              "subcategories": []
            },
            {
              "id": "trailers-end-dump-trailers-renn",
              "name": "RENN",
              "subcategories": []
            },
            {
              "id": "trailers-end-dump-trailers-rhodes",
              "name": "RHODES",
              "subcategories": []
            },
            {
              "id": "trailers-end-dump-trailers-roughneck",
              "name": "ROUGHNECK",
              "subcategories": []
            },
            {
              "id": "trailers-end-dump-trailers-rtr-mfg",
              "name": "RTR MFG",
              "subcategories": []
            },
            {
              "id": "trailers-end-dump-trailers-schien",
              "name": "SCHIEN",
              "subcategories": []
            },
            {
              "id": "trailers-end-dump-trailers-stargate",
              "name": "STARGATE",
              "subcategories": []
            },
            {
              "id": "trailers-end-dump-trailers-steco",
              "name": "STECO",
              "subcategories": []
            },
            {
              "id": "trailers-end-dump-trailers-stonestar",
              "name": "STONESTAR",
              "subcategories": []
            },
            {
              "id": "trailers-end-dump-trailers-summit",
              "name": "SUMMIT",
              "subcategories": []
            },
            {
              "id": "trailers-end-dump-trailers-superior",
              "name": "SUPERIOR",
              "subcategories": []
            },
            {
              "id": "trailers-end-dump-trailers-tefco",
              "name": "TEFCO",
              "subcategories": []
            },
            {
              "id": "trailers-end-dump-trailers-ti-brook",
              "name": "TI-BROOK",
              "subcategories": []
            },
            {
              "id": "trailers-end-dump-trailers-titan",
              "name": "TITAN",
              "subcategories": []
            },
            {
              "id": "trailers-end-dump-trailers-trail-king",
              "name": "TRAIL KING",
              "subcategories": []
            },
            {
              "id": "trailers-end-dump-trailers-trident",
              "name": "TRIDENT",
              "subcategories": []
            },
            {
              "id": "trailers-end-dump-trailers-warren",
              "name": "WARREN",
              "subcategories": []
            },
            {
              "id": "trailers-end-dump-trailers-other",
              "name": "OTHER",
              "subcategories": []
            }
          ]
        },
        {
          "id": "trailers-flatbed-trailers",
          "name": "Flatbed Trailers",
          "subcategories": [
            {
              "id": "trailers-flatbed-trailers-fontaine",
              "name": "FONTAINE",
              "subcategories": []
            },
            {
              "id": "trailers-flatbed-trailers-reitnouer",
              "name": "REITNOUER",
              "subcategories": []
            },
            {
              "id": "trailers-flatbed-trailers-dorsey",
              "name": "DORSEY",
              "subcategories": []
            },
            {
              "id": "trailers-flatbed-trailers-manac",
              "name": "MANAC",
              "subcategories": []
            },
            {
              "id": "trailers-flatbed-trailers-great-dane",
              "name": "GREAT DANE",
              "subcategories": []
            },
            {
              "id": "trailers-flatbed-trailers-east",
              "name": "EAST",
              "subcategories": []
            },
            {
              "id": "trailers-flatbed-trailers-mac",
              "name": "MAC",
              "subcategories": []
            },
            {
              "id": "trailers-flatbed-trailers-utility",
              "name": "UTILITY",
              "subcategories": []
            },
            {
              "id": "trailers-flatbed-trailers-transcraft",
              "name": "TRANSCRAFT",
              "subcategories": []
            },
            {
              "id": "trailers-flatbed-trailers-wabash",
              "name": "WABASH",
              "subcategories": []
            },
            {
              "id": "trailers-flatbed-trailers-aaa",
              "name": "AAA",
              "subcategories": []
            },
            {
              "id": "trailers-flatbed-trailers-alloy",
              "name": "ALLOY",
              "subcategories": []
            },
            {
              "id": "trailers-flatbed-trailers-alutrec",
              "name": "ALUTREC",
              "subcategories": []
            },
            {
              "id": "trailers-flatbed-trailers-aztec",
              "name": "AZTEC",
              "subcategories": []
            },
            {
              "id": "trailers-flatbed-trailers-barker",
              "name": "BARKER",
              "subcategories": []
            },
            {
              "id": "trailers-flatbed-trailers-benson",
              "name": "BENSON",
              "subcategories": []
            },
            {
              "id": "trailers-flatbed-trailers-berg",
              "name": "BERG",
              "subcategories": []
            },
            {
              "id": "trailers-flatbed-trailers-big-tex",
              "name": "BIG TEX",
              "subcategories": []
            },
            {
              "id": "trailers-flatbed-trailers-brazos",
              "name": "BRAZOS",
              "subcategories": []
            },
            {
              "id": "trailers-flatbed-trailers-chaparral",
              "name": "CHAPARRAL",
              "subcategories": []
            },
            {
              "id": "trailers-flatbed-trailers-clark",
              "name": "CLARK",
              "subcategories": []
            },
            {
              "id": "trailers-flatbed-trailers-custom-built",
              "name": "CUSTOM BUILT",
              "subcategories": []
            },
            {
              "id": "trailers-flatbed-trailers-deloupe",
              "name": "DELOUPE",
              "subcategories": []
            },
            {
              "id": "trailers-flatbed-trailers-direct-trailer",
              "name": "DIRECT TRAILER",
              "subcategories": []
            },
            {
              "id": "trailers-flatbed-trailers-doepker",
              "name": "DOEPKER",
              "subcategories": []
            },
            {
              "id": "trailers-flatbed-trailers-doonan",
              "name": "DOONAN",
              "subcategories": []
            },
            {
              "id": "trailers-flatbed-trailers-dragon-products",
              "name": "DRAGON PRODUCTS",
              "subcategories": []
            },
            {
              "id": "trailers-flatbed-trailers-dynaweld",
              "name": "DYNAWELD",
              "subcategories": []
            },
            {
              "id": "trailers-flatbed-trailers-eager-beaver",
              "name": "EAGER BEAVER",
              "subcategories": []
            },
            {
              "id": "trailers-flatbed-trailers-extreme-trailers",
              "name": "EXTREME TRAILERS",
              "subcategories": []
            },
            {
              "id": "trailers-flatbed-trailers-felling",
              "name": "FELLING",
              "subcategories": []
            },
            {
              "id": "trailers-flatbed-trailers-fruehauf",
              "name": "FRUEHAUF",
              "subcategories": []
            },
            {
              "id": "trailers-flatbed-trailers-fwr",
              "name": "FWR",
              "subcategories": []
            },
            {
              "id": "trailers-flatbed-trailers-gincor",
              "name": "GINCOR",
              "subcategories": []
            },
            {
              "id": "trailers-flatbed-trailers-goldhofer",
              "name": "GOLDHOFER",
              "subcategories": []
            },
            {
              "id": "trailers-flatbed-trailers-haulmark",
              "name": "HAULMARK",
              "subcategories": []
            },
            {
              "id": "trailers-flatbed-trailers-hobbs",
              "name": "HOBBS",
              "subcategories": []
            },
            {
              "id": "trailers-flatbed-trailers-hyundai",
              "name": "HYUNDAI",
              "subcategories": []
            },
            {
              "id": "trailers-flatbed-trailers-j-smith-sons",
              "name": "J SMITH & SONS",
              "subcategories": []
            },
            {
              "id": "trailers-flatbed-trailers-jamieson",
              "name": "JAMIESON",
              "subcategories": []
            },
            {
              "id": "trailers-flatbed-trailers-jj-trlr",
              "name": "JJ TRLR",
              "subcategories": []
            },
            {
              "id": "trailers-flatbed-trailers-kearney",
              "name": "KEARNEY",
              "subcategories": []
            },
            {
              "id": "trailers-flatbed-trailers-krueger",
              "name": "KRUEGER",
              "subcategories": []
            },
            {
              "id": "trailers-flatbed-trailers-kruz",
              "name": "KRUZ",
              "subcategories": []
            },
            {
              "id": "trailers-flatbed-trailers-landoll",
              "name": "LANDOLL",
              "subcategories": []
            },
            {
              "id": "trailers-flatbed-trailers-ledwell",
              "name": "LEDWELL",
              "subcategories": []
            },
            {
              "id": "trailers-flatbed-trailers-load-king",
              "name": "LOAD KING",
              "subcategories": []
            },
            {
              "id": "trailers-flatbed-trailers-load-trail",
              "name": "LOAD TRAIL",
              "subcategories": []
            },
            {
              "id": "trailers-flatbed-trailers-load-max",
              "name": "LOAD MAX",
              "subcategories": []
            },
            {
              "id": "trailers-flatbed-trailers-lode-king",
              "name": "LODE KING",
              "subcategories": []
            },
            {
              "id": "trailers-flatbed-trailers-loughlin",
              "name": "LOUGHLIN",
              "subcategories": []
            },
            {
              "id": "trailers-flatbed-trailers-lufkin",
              "name": "LUFKIN",
              "subcategories": []
            },
            {
              "id": "trailers-flatbed-trailers-maxitrans",
              "name": "MAXITRANS",
              "subcategories": []
            },
            {
              "id": "trailers-flatbed-trailers-midland",
              "name": "MIDLAND",
              "subcategories": []
            },
            {
              "id": "trailers-flatbed-trailers-moore",
              "name": "MOORE",
              "subcategories": []
            },
            {
              "id": "trailers-flatbed-trailers-ophee",
              "name": "OPHEE",
              "subcategories": []
            },
            {
              "id": "trailers-flatbed-trailers-pitts",
              "name": "PITTS",
              "subcategories": []
            },
            {
              "id": "trailers-flatbed-trailers-pj",
              "name": "PJ",
              "subcategories": []
            },
            {
              "id": "trailers-flatbed-trailers-prestige",
              "name": "PRESTIGE",
              "subcategories": []
            },
            {
              "id": "trailers-flatbed-trailers-pro-haul",
              "name": "PRO-HAUL",
              "subcategories": []
            },
            {
              "id": "trailers-flatbed-trailers-raja",
              "name": "RAJA",
              "subcategories": []
            },
            {
              "id": "trailers-flatbed-trailers-ravens",
              "name": "RAVENS",
              "subcategories": []
            },
            {
              "id": "trailers-flatbed-trailers-reinke",
              "name": "REINKE",
              "subcategories": []
            },
            {
              "id": "trailers-flatbed-trailers-reliance",
              "name": "RELIANCE",
              "subcategories": []
            },
            {
              "id": "trailers-flatbed-trailers-renn",
              "name": "RENN",
              "subcategories": []
            },
            {
              "id": "trailers-flatbed-trailers-ruco",
              "name": "RUCO",
              "subcategories": []
            },
            {
              "id": "trailers-flatbed-trailers-stonestar",
              "name": "STONESTAR",
              "subcategories": []
            },
            {
              "id": "trailers-flatbed-trailers-thru-way",
              "name": "THRU-WAY",
              "subcategories": []
            },
            {
              "id": "trailers-flatbed-trailers-titan",
              "name": "TITAN",
              "subcategories": []
            },
            {
              "id": "trailers-flatbed-trailers-trail-king",
              "name": "TRAIL KING",
              "subcategories": []
            },
            {
              "id": "trailers-flatbed-trailers-towmaster",
              "name": "TOWMASTER",
              "subcategories": []
            },
            {
              "id": "trailers-flatbed-trailers-trail-eze",
              "name": "TRAIL-EZE",
              "subcategories": []
            },
            {
              "id": "trailers-flatbed-trailers-trailmobile",
              "name": "TRAILMOBILE",
              "subcategories": []
            },
            {
              "id": "trailers-flatbed-trailers-trail-tech",
              "name": "TRAIL TECH",
              "subcategories": []
            },
            {
              "id": "trailers-flatbed-trailers-vanguard",
              "name": "VANGUARD",
              "subcategories": []
            },
            {
              "id": "trailers-flatbed-trailers-viking",
              "name": "VIKING",
              "subcategories": []
            },
            {
              "id": "trailers-flatbed-trailers-wade",
              "name": "WADE",
              "subcategories": []
            },
            {
              "id": "trailers-flatbed-trailers-western-trlr",
              "name": "WESTERN TRLR",
              "subcategories": []
            },
            {
              "id": "trailers-flatbed-trailers-wilson",
              "name": "WILSON",
              "subcategories": []
            },
            {
              "id": "trailers-flatbed-trailers-xl-specialized",
              "name": "XL SPECIALIZED",
              "subcategories": []
            },
            {
              "id": "trailers-flatbed-trailers-other",
              "name": "OTHER",
              "subcategories": []
            }
          ]
        },
        {
          "id": "trailers-frac-tank-trailers",
          "name": "Frac Tank Trailers",
          "subcategories": []
        },
        {
          "id": "trailers-fuel-lube-trailers",
          "name": "Fuel / Lube Trailers",
          "subcategories": []
        },
        {
          "id": "trailers-fuel-tank-trailers",
          "name": "Fuel Tank Trailers",
          "subcategories": []
        },
        {
          "id": "trailers-hopper-trailers",
          "name": "Hopper Trailers",
          "subcategories": [
            {
              "id": "trailers-hopper-trailers-timpte",
              "name": "TIMPTE",
              "subcategories": []
            },
            {
              "id": "trailers-hopper-trailers-wilson",
              "name": "WILSON",
              "subcategories": []
            },
            {
              "id": "trailers-hopper-trailers-neville-built",
              "name": "NEVILLE BUILT",
              "subcategories": []
            },
            {
              "id": "trailers-hopper-trailers-demco",
              "name": "DEMCO",
              "subcategories": []
            },
            {
              "id": "trailers-hopper-trailers-lode-king",
              "name": "LODE KING",
              "subcategories": []
            },
            {
              "id": "trailers-hopper-trailers-doepker",
              "name": "DOEPKER",
              "subcategories": []
            },
            {
              "id": "trailers-hopper-trailers-jet",
              "name": "JET",
              "subcategories": []
            },
            {
              "id": "trailers-hopper-trailers-cornhusker",
              "name": "CORNHUSKER",
              "subcategories": []
            },
            {
              "id": "trailers-hopper-trailers-meritt",
              "name": "MERITT",
              "subcategories": []
            },
            {
              "id": "trailers-hopper-trailers-stoughton",
              "name": "STOUGHTON",
              "subcategories": []
            },
            {
              "id": "trailers-hopper-trailers-ace",
              "name": "ACE",
              "subcategories": []
            },
            {
              "id": "trailers-hopper-trailers-armor-lite",
              "name": "ARMOR LITE",
              "subcategories": []
            },
            {
              "id": "trailers-hopper-trailers-berg",
              "name": "BERG",
              "subcategories": []
            },
            {
              "id": "trailers-hopper-trailers-constr-trlr-spec",
              "name": "CONSTR TRLR SPEC",
              "subcategories": []
            },
            {
              "id": "trailers-hopper-trailers-cps",
              "name": "CPS",
              "subcategories": []
            },
            {
              "id": "trailers-hopper-trailers-eby",
              "name": "EBY",
              "subcategories": []
            },
            {
              "id": "trailers-hopper-trailers-haul-all",
              "name": "HAUL ALL",
              "subcategories": []
            },
            {
              "id": "trailers-hopper-trailers-itm",
              "name": "ITM",
              "subcategories": []
            },
            {
              "id": "trailers-hopper-trailers-ledwell",
              "name": "LEDWELL",
              "subcategories": []
            },
            {
              "id": "trailers-hopper-trailers-loadline",
              "name": "LOADLINE",
              "subcategories": []
            },
            {
              "id": "trailers-hopper-trailers-magnolia-trlr",
              "name": "MAGNOLIA TRLR",
              "subcategories": []
            },
            {
              "id": "trailers-hopper-trailers-maurer",
              "name": "MAURER",
              "subcategories": []
            },
            {
              "id": "trailers-hopper-trailers-maxxim",
              "name": "MAXXIM",
              "subcategories": []
            },
            {
              "id": "trailers-hopper-trailers-platinum",
              "name": "PLATINUM",
              "subcategories": []
            },
            {
              "id": "trailers-hopper-trailers-prestige",
              "name": "PRESTIGE",
              "subcategories": []
            },
            {
              "id": "trailers-hopper-trailers-star",
              "name": "STAR",
              "subcategories": []
            },
            {
              "id": "trailers-hopper-trailers-taipan",
              "name": "TAIPAN",
              "subcategories": []
            },
            {
              "id": "trailers-hopper-trailers-titan",
              "name": "TITAN",
              "subcategories": []
            },
            {
              "id": "trailers-hopper-trailers-trail-king",
              "name": "TRAIL KING",
              "subcategories": []
            },
            {
              "id": "trailers-hopper-trailers-warren",
              "name": "WARREN",
              "subcategories": []
            },
            {
              "id": "trailers-hopper-trailers-western-trlr",
              "name": "WESTERN TRLR",
              "subcategories": []
            },
            {
              "id": "trailers-hopper-trailers-wheeler",
              "name": "WHEELER",
              "subcategories": []
            },
            {
              "id": "trailers-hopper-trailers-wilkens",
              "name": "WILKENS",
              "subcategories": []
            },
            {
              "id": "trailers-hopper-trailers-other",
              "name": "OTHER",
              "subcategories": []
            }
          ]
        },
        {
          "id": "trailers-horse-trailers",
          "name": "Horse Trailers",
          "subcategories": [
            {
              "id": "trailers-horse-trailers-valley-trailers",
              "name": "VALLEY TRAILERS",
              "subcategories": []
            },
            {
              "id": "trailers-horse-trailers-bison-coach",
              "name": "BISON COACH",
              "subcategories": []
            },
            {
              "id": "trailers-horse-trailers-cimarron",
              "name": "CIMARRON",
              "subcategories": []
            },
            {
              "id": "trailers-horse-trailers-shadow-trailers",
              "name": "SHADOW TRAILERS",
              "subcategories": []
            },
            {
              "id": "trailers-horse-trailers-merhow",
              "name": "MERHOW",
              "subcategories": []
            },
            {
              "id": "trailers-horse-trailers-sundowner",
              "name": "SUNDOWNER",
              "subcategories": []
            },
            {
              "id": "trailers-horse-trailers-bar-m-trailers",
              "name": "BAR M TRAILERS",
              "subcategories": []
            },
            {
              "id": "trailers-horse-trailers-trails-west",
              "name": "TRAILS WEST",
              "subcategories": []
            },
            {
              "id": "trailers-horse-trailers-featherlite",
              "name": "FEATHERLITE",
              "subcategories": []
            },
            {
              "id": "trailers-horse-trailers-hart",
              "name": "HART",
              "subcategories": []
            },
            {
              "id": "trailers-horse-trailers-amacsa",
              "name": "AMACSA",
              "subcategories": []
            },
            {
              "id": "trailers-horse-trailers-barrett",
              "name": "BARRETT",
              "subcategories": []
            },
            {
              "id": "trailers-horse-trailers-bellamy",
              "name": "BELLAMY",
              "subcategories": []
            },
            {
              "id": "trailers-horse-trailers-big-valley",
              "name": "BIG VALLEY",
              "subcategories": []
            },
            {
              "id": "trailers-horse-trailers-bloomer",
              "name": "BLOOMER",
              "subcategories": []
            },
            {
              "id": "trailers-horse-trailers-calico",
              "name": "CALICO",
              "subcategories": []
            },
            {
              "id": "trailers-horse-trailers-charmac",
              "name": "CHARMAC",
              "subcategories": []
            },
            {
              "id": "trailers-horse-trailers-cm-trailers",
              "name": "CM TRAILERS",
              "subcategories": []
            },
            {
              "id": "trailers-horse-trailers-delta",
              "name": "DELTA",
              "subcategories": []
            },
            {
              "id": "trailers-horse-trailers-dixie",
              "name": "DIXIE",
              "subcategories": []
            },
            {
              "id": "trailers-horse-trailers-duralite",
              "name": "DURALITE",
              "subcategories": []
            },
            {
              "id": "trailers-horse-trailers-eclipse",
              "name": "ECLIPSE",
              "subcategories": []
            },
            {
              "id": "trailers-horse-trailers-elite-trailer-mfg",
              "name": "ELITE TRAILER MFG",
              "subcategories": []
            },
            {
              "id": "trailers-horse-trailers-exiss",
              "name": "EXISS",
              "subcategories": []
            },
            {
              "id": "trailers-horse-trailers-frontier",
              "name": "FRONTIER",
              "subcategories": []
            },
            {
              "id": "trailers-horse-trailers-great-dane",
              "name": "GREAT DANE",
              "subcategories": []
            },
            {
              "id": "trailers-horse-trailers-hawk",
              "name": "HAWK",
              "subcategories": []
            },
            {
              "id": "trailers-horse-trailers-hoosier",
              "name": "HOOSIER",
              "subcategories": []
            },
            {
              "id": "trailers-horse-trailers-integrity",
              "name": "INTEGRITY",
              "subcategories": []
            },
            {
              "id": "trailers-horse-trailers-kiefer",
              "name": "KIEFER",
              "subcategories": []
            },
            {
              "id": "trailers-horse-trailers-lakota",
              "name": "LAKOTA",
              "subcategories": []
            },
            {
              "id": "trailers-horse-trailers-legend",
              "name": "LEGEND",
              "subcategories": []
            },
            {
              "id": "trailers-horse-trailers-logan-coach",
              "name": "LOGAN COACH",
              "subcategories": []
            },
            {
              "id": "trailers-horse-trailers-merhow",
              "name": "MERHOW",
              "subcategories": []
            },
            {
              "id": "trailers-horse-trailers-river-valley",
              "name": "RIVER VALLEY",
              "subcategories": []
            },
            {
              "id": "trailers-horse-trailers-s-s-dura-line",
              "name": "S&S DURA LINE",
              "subcategories": []
            },
            {
              "id": "trailers-horse-trailers-shadow-trailers",
              "name": "SHADOW TRAILERS",
              "subcategories": []
            },
            {
              "id": "trailers-horse-trailers-smc-trailers",
              "name": "SMC TRAILERS",
              "subcategories": []
            },
            {
              "id": "trailers-horse-trailers-sooner",
              "name": "SOONER",
              "subcategories": []
            },
            {
              "id": "trailers-horse-trailers-sundowner",
              "name": "SUNDOWNER",
              "subcategories": []
            },
            {
              "id": "trailers-horse-trailers-trails-west",
              "name": "TRAILS WEST",
              "subcategories": []
            },
            {
              "id": "trailers-horse-trailers-unspecified",
              "name": "UNSPECIFIED",
              "subcategories": []
            },
            {
              "id": "trailers-horse-trailers-other",
              "name": "OTHER",
              "subcategories": []
            }
          ]
        },
        {
          "id": "trailers-inustrial-gas-tank-trailers",
          "name": "Inustrial Gas Tank Trailers",
          "subcategories": []
        },
        {
          "id": "trailers-liquid-food-grade-tank-trailers",
          "name": "Liquid Food Grade Tank Trailers",
          "subcategories": []
        },
        {
          "id": "trailers-live-bottom-trailers",
          "name": "Live Bottom Trailers",
          "subcategories": [
            {
              "id": "trailers-live-bottom-trailers-mac-trailer-mfg",
              "name": "MAC TRAILER MFG",
              "subcategories": []
            },
            {
              "id": "trailers-live-bottom-trailers-btr",
              "name": "BTR",
              "subcategories": []
            },
            {
              "id": "trailers-live-bottom-trailers-kayln-siebert",
              "name": "KAYLN SIEBERT",
              "subcategories": []
            },
            {
              "id": "trailers-live-bottom-trailers-wilkens",
              "name": "WILKENS",
              "subcategories": []
            },
            {
              "id": "trailers-live-bottom-trailers-peerless",
              "name": "PEERLESS",
              "subcategories": []
            },
            {
              "id": "trailers-live-bottom-trailers-iti",
              "name": "ITI",
              "subcategories": []
            },
            {
              "id": "trailers-live-bottom-trailers-aulick-ind",
              "name": "AULICK IND",
              "subcategories": []
            },
            {
              "id": "trailers-live-bottom-trailers-dorsey",
              "name": "DORSEY",
              "subcategories": []
            },
            {
              "id": "trailers-live-bottom-trailers-titan",
              "name": "TITAN",
              "subcategories": []
            },
            {
              "id": "trailers-live-bottom-trailers-mas-trailers",
              "name": "MAS TRAILERS",
              "subcategories": []
            },
            {
              "id": "trailers-live-bottom-trailers-abs",
              "name": "ABS",
              "subcategories": []
            },
            {
              "id": "trailers-live-bottom-trailers-artex",
              "name": "ARTEX",
              "subcategories": []
            },
            {
              "id": "trailers-live-bottom-trailers-aulick-ind",
              "name": "AULICK IND",
              "subcategories": []
            },
            {
              "id": "trailers-live-bottom-trailers-barker",
              "name": "BARKER",
              "subcategories": []
            },
            {
              "id": "trailers-live-bottom-trailers-boomer",
              "name": "BOOMER",
              "subcategories": []
            },
            {
              "id": "trailers-live-bottom-trailers-deloupe",
              "name": "DELOUPE",
              "subcategories": []
            },
            {
              "id": "trailers-live-bottom-trailers-east",
              "name": "EAST",
              "subcategories": []
            },
            {
              "id": "trailers-live-bottom-trailers-etnyre",
              "name": "ETNYRE",
              "subcategories": []
            },
            {
              "id": "trailers-live-bottom-trailers-fehr",
              "name": "FEHR",
              "subcategories": []
            },
            {
              "id": "trailers-live-bottom-trailers-gincor",
              "name": "GINCOR",
              "subcategories": []
            },
            {
              "id": "trailers-live-bottom-trailers-h-s",
              "name": "H & S",
              "subcategories": []
            },
            {
              "id": "trailers-live-bottom-trailers-hitch-cock",
              "name": "HITCH COCK",
              "subcategories": []
            },
            {
              "id": "trailers-live-bottom-trailers-imco",
              "name": "IMCO",
              "subcategories": []
            },
            {
              "id": "trailers-live-bottom-trailers-meyer",
              "name": "MEYER",
              "subcategories": []
            },
            {
              "id": "trailers-live-bottom-trailers-rtr",
              "name": "RTR",
              "subcategories": []
            },
            {
              "id": "trailers-live-bottom-trailers-steco",
              "name": "STECO",
              "subcategories": []
            },
            {
              "id": "trailers-live-bottom-trailers-trail-king",
              "name": "TRAIL KING",
              "subcategories": []
            },
            {
              "id": "trailers-live-bottom-trailers-travis",
              "name": "TRAVIS",
              "subcategories": []
            },
            {
              "id": "trailers-live-bottom-trailers-trout-river",
              "name": "TROUT RIVER",
              "subcategories": []
            },
            {
              "id": "trailers-live-bottom-trailers-wilson",
              "name": "WILSON",
              "subcategories": []
            },
            {
              "id": "trailers-live-bottom-trailers-other",
              "name": "OTHER",
              "subcategories": []
            }
          ]
        },
        {
          "id": "trailers-livestock-trailers",
          "name": "Livestock Trailers",
          "subcategories": [
            {
              "id": "trailers-livestock-trailers-eby",
              "name": "EBY",
              "subcategories": []
            },
            {
              "id": "trailers-livestock-trailers-featherlite",
              "name": "FEATHERLITE",
              "subcategories": []
            },
            {
              "id": "trailers-livestock-trailers-wilson",
              "name": "WILSON",
              "subcategories": []
            },
            {
              "id": "trailers-livestock-trailers-corn-pro",
              "name": "CORN PRO",
              "subcategories": []
            },
            {
              "id": "trailers-livestock-trailers-duralite",
              "name": "DURALITE",
              "subcategories": []
            },
            {
              "id": "trailers-livestock-trailers-amacsa",
              "name": "AMACSA",
              "subcategories": []
            },
            {
              "id": "trailers-livestock-trailers-calico",
              "name": "CALICO",
              "subcategories": []
            },
            {
              "id": "trailers-livestock-trailers-valley-trailers",
              "name": "VALLEY TRAILERS",
              "subcategories": []
            },
            {
              "id": "trailers-livestock-trailers-apex",
              "name": "APEX",
              "subcategories": []
            },
            {
              "id": "trailers-livestock-trailers-shadow-trailers-inc",
              "name": "SHADOW TRAILERS INC",
              "subcategories": []
            },
            {
              "id": "trailers-livestock-trailers-arion",
              "name": "ARION",
              "subcategories": []
            },
            {
              "id": "trailers-livestock-trailers-bar-m-trailers",
              "name": "BAR M TRAILERS",
              "subcategories": []
            },
            {
              "id": "trailers-livestock-trailers-barrett",
              "name": "BARRETT",
              "subcategories": []
            },
            {
              "id": "trailers-livestock-trailers-big-bend",
              "name": "BIG BEND",
              "subcategories": []
            },
            {
              "id": "trailers-livestock-trailers-bison",
              "name": "BISON",
              "subcategories": []
            },
            {
              "id": "trailers-livestock-trailers-boss",
              "name": "BOSS",
              "subcategories": []
            },
            {
              "id": "trailers-livestock-trailers-chaparral",
              "name": "CHAPARRAL",
              "subcategories": []
            },
            {
              "id": "trailers-livestock-trailers-cimarron",
              "name": "CIMARRON",
              "subcategories": []
            },
            {
              "id": "trailers-livestock-trailers-circle-d",
              "name": "CIRCLE D",
              "subcategories": []
            },
            {
              "id": "trailers-livestock-trailers-cmi",
              "name": "CMI",
              "subcategories": []
            },
            {
              "id": "trailers-livestock-trailers-corn-pro",
              "name": "CORN PRO",
              "subcategories": []
            },
            {
              "id": "trailers-livestock-trailers-custom-classic",
              "name": "CUSTOM CLASSIC",
              "subcategories": []
            },
            {
              "id": "trailers-livestock-trailers-delco",
              "name": "DELCO",
              "subcategories": []
            },
            {
              "id": "trailers-livestock-trailers-delta",
              "name": "DELTA",
              "subcategories": []
            },
            {
              "id": "trailers-livestock-trailers-duralite",
              "name": "DURALITE",
              "subcategories": []
            },
            {
              "id": "trailers-livestock-trailers-eagle-x",
              "name": "EAGLE X",
              "subcategories": []
            },
            {
              "id": "trailers-livestock-trailers-east-t-exas",
              "name": "EAST T EXAS",
              "subcategories": []
            },
            {
              "id": "trailers-livestock-trailers-exiss",
              "name": "EXISS",
              "subcategories": []
            },
            {
              "id": "trailers-livestock-trailers-frontier",
              "name": "FRONTIER",
              "subcategories": []
            },
            {
              "id": "trailers-livestock-trailers-gooseneck",
              "name": "GOOSENECK",
              "subcategories": []
            },
            {
              "id": "trailers-livestock-trailers-gr-trailers",
              "name": "GR TRAILERS",
              "subcategories": []
            },
            {
              "id": "trailers-livestock-trailers-hillsboro",
              "name": "HILLSBORO",
              "subcategories": []
            },
            {
              "id": "trailers-livestock-trailers-kiefer",
              "name": "KIEFER",
              "subcategories": []
            },
            {
              "id": "trailers-livestock-trailers-kodiak",
              "name": "KODIAK",
              "subcategories": []
            },
            {
              "id": "trailers-livestock-trailers-kpe",
              "name": "KPE",
              "subcategories": []
            },
            {
              "id": "trailers-livestock-trailers-landoll",
              "name": "LANDOLL",
              "subcategories": []
            },
            {
              "id": "trailers-livestock-trailers-merhow",
              "name": "MERHOW",
              "subcategories": []
            },
            {
              "id": "trailers-livestock-trailers-merritt",
              "name": "MERRITT",
              "subcategories": []
            },
            {
              "id": "trailers-livestock-trailers-moritz-intl",
              "name": "MORITZ INTL",
              "subcategories": []
            },
            {
              "id": "trailers-livestock-trailers-neckover",
              "name": "NECKOVER",
              "subcategories": []
            },
            {
              "id": "trailers-livestock-trailers-rawmaxx",
              "name": "RAWMAXX",
              "subcategories": []
            },
            {
              "id": "trailers-livestock-trailers-s-s-duraline",
              "name": "S&S DURALINE",
              "subcategories": []
            },
            {
              "id": "trailers-livestock-trailers-s-s",
              "name": "S&S",
              "subcategories": []
            },
            {
              "id": "trailers-livestock-trailers-shadow-trailers-inc",
              "name": "SHADOW TRAILERS INC",
              "subcategories": []
            },
            {
              "id": "trailers-livestock-trailers-shop-built",
              "name": "SHOP BUILT",
              "subcategories": []
            },
            {
              "id": "trailers-livestock-trailers-stockline",
              "name": "STOCKLINE",
              "subcategories": []
            },
            {
              "id": "trailers-livestock-trailers-stoll",
              "name": "STOLL",
              "subcategories": []
            },
            {
              "id": "trailers-livestock-trailers-sundowner",
              "name": "SUNDOWNER",
              "subcategories": []
            },
            {
              "id": "trailers-livestock-trailers-swift-built",
              "name": "SWIFT BUILT",
              "subcategories": []
            },
            {
              "id": "trailers-livestock-trailers-titan",
              "name": "TITAN",
              "subcategories": []
            },
            {
              "id": "trailers-livestock-trailers-trailmann",
              "name": "TRAILMANN",
              "subcategories": []
            },
            {
              "id": "trailers-livestock-trailers-trails-west",
              "name": "TRAILS WEST",
              "subcategories": []
            },
            {
              "id": "trailers-livestock-trailers-travalong",
              "name": "TRAVALONG",
              "subcategories": []
            },
            {
              "id": "trailers-livestock-trailers-tri-star",
              "name": "TRI STAR",
              "subcategories": []
            },
            {
              "id": "trailers-livestock-trailers-unspecified",
              "name": "UNSPECIFIED",
              "subcategories": []
            },
            {
              "id": "trailers-livestock-trailers-valley-trailers",
              "name": "VALLEY TRAILERS",
              "subcategories": []
            },
            {
              "id": "trailers-livestock-trailers-w-w",
              "name": "W&W",
              "subcategories": []
            },
            {
              "id": "trailers-livestock-trailers-wilson",
              "name": "WILSON",
              "subcategories": []
            },
            {
              "id": "trailers-livestock-trailers-other",
              "name": "OTHER",
              "subcategories": []
            }
          ]
        },
        {
          "id": "trailers-log-trailers",
          "name": "Log Trailers",
          "subcategories": [
            {
              "id": "trailers-log-trailers-pitts",
              "name": "PITTS",
              "subcategories": []
            },
            {
              "id": "trailers-log-trailers-mclendon",
              "name": "MCLENDON",
              "subcategories": []
            },
            {
              "id": "trailers-log-trailers-bws",
              "name": "BWS",
              "subcategories": []
            },
            {
              "id": "trailers-log-trailers-manac",
              "name": "MANAC",
              "subcategories": []
            },
            {
              "id": "trailers-log-trailers-big-john",
              "name": "BIG JOHN",
              "subcategories": []
            },
            {
              "id": "trailers-log-trailers-wallenstein",
              "name": "WALLENSTEIN",
              "subcategories": []
            },
            {
              "id": "trailers-log-trailers-kaufman",
              "name": "KAUFMAN",
              "subcategories": []
            },
            {
              "id": "trailers-log-trailers-deloupe",
              "name": "DELOUPE",
              "subcategories": []
            },
            {
              "id": "trailers-log-trailers-doepker",
              "name": "DOEPKER",
              "subcategories": []
            },
            {
              "id": "trailers-log-trailers-custom-bilt",
              "name": "CUSTOM BILT",
              "subcategories": []
            },
            {
              "id": "trailers-log-trailers-arnes",
              "name": "ARNES",
              "subcategories": []
            },
            {
              "id": "trailers-log-trailers-dorsey",
              "name": "DORSEY",
              "subcategories": []
            },
            {
              "id": "trailers-log-trailers-east",
              "name": "EAST",
              "subcategories": []
            },
            {
              "id": "trailers-log-trailers-elphinstone",
              "name": "ELPHINSTONE",
              "subcategories": []
            },
            {
              "id": "trailers-log-trailers-f-r",
              "name": "F&R",
              "subcategories": []
            },
            {
              "id": "trailers-log-trailers-fontaine",
              "name": "FONTAINE",
              "subcategories": []
            },
            {
              "id": "trailers-log-trailers-freflyt",
              "name": "FREFLYT",
              "subcategories": []
            },
            {
              "id": "trailers-log-trailers-great-lakes",
              "name": "GREAT LAKES",
              "subcategories": []
            },
            {
              "id": "trailers-log-trailers-hrd",
              "name": "HRD",
              "subcategories": []
            },
            {
              "id": "trailers-log-trailers-kaufman",
              "name": "KAUFMAN",
              "subcategories": []
            },
            {
              "id": "trailers-log-trailers-kennedy",
              "name": "KENNEDY",
              "subcategories": []
            },
            {
              "id": "trailers-log-trailers-magnolia",
              "name": "MAGNOLIA",
              "subcategories": []
            },
            {
              "id": "trailers-log-trailers-maxitrans",
              "name": "MAXITRANS",
              "subcategories": []
            },
            {
              "id": "trailers-log-trailers-peerless",
              "name": "PEERLESS",
              "subcategories": []
            },
            {
              "id": "trailers-log-trailers-pelliter",
              "name": "PELLITER",
              "subcategories": []
            },
            {
              "id": "trailers-log-trailers-rotobec",
              "name": "ROTOBEC",
              "subcategories": []
            },
            {
              "id": "trailers-log-trailers-stone-star",
              "name": "STONE STAR",
              "subcategories": []
            },
            {
              "id": "trailers-log-trailers-superior",
              "name": "SUPERIOR",
              "subcategories": []
            },
            {
              "id": "trailers-log-trailers-temisko",
              "name": "TEMISKO",
              "subcategories": []
            },
            {
              "id": "trailers-log-trailers-timmins",
              "name": "TIMMINS",
              "subcategories": []
            },
            {
              "id": "trailers-log-trailers-trail-ex",
              "name": "TRAIL EX",
              "subcategories": []
            },
            {
              "id": "trailers-log-trailers-transport",
              "name": "TRANSPORT",
              "subcategories": []
            },
            {
              "id": "trailers-log-trailers-viking",
              "name": "VIKING",
              "subcategories": []
            },
            {
              "id": "trailers-log-trailers-other",
              "name": "OTHER",
              "subcategories": []
            }
          ]
        },
        {
          "id": "trailers-lowboy-trailers",
          "name": "Lowboy Trailers",
          "subcategories": [
            {
              "id": "trailers-lowboy-trailers-fontaine",
              "name": "FONTAINE",
              "subcategories": []
            },
            {
              "id": "trailers-lowboy-trailers-xl-specialized",
              "name": "XL SPECIALIZED",
              "subcategories": []
            },
            {
              "id": "trailers-lowboy-trailers-pitts",
              "name": "PITTS",
              "subcategories": []
            },
            {
              "id": "trailers-lowboy-trailers-kayln-siebert",
              "name": "KAYLN SIEBERT",
              "subcategories": []
            },
            {
              "id": "trailers-lowboy-trailers-trail-king",
              "name": "TRAIL KING",
              "subcategories": []
            },
            {
              "id": "trailers-lowboy-trailers-talbert",
              "name": "TALBERT",
              "subcategories": []
            },
            {
              "id": "trailers-lowboy-trailers-brandt",
              "name": "BRANDT",
              "subcategories": []
            },
            {
              "id": "trailers-lowboy-trailers-kaufman",
              "name": "KAUFMAN",
              "subcategories": []
            },
            {
              "id": "trailers-lowboy-trailers-alpha-hd",
              "name": "ALPHA HD",
              "subcategories": []
            },
            {
              "id": "trailers-lowboy-trailers-eager-beaver",
              "name": "EAGER BEAVER",
              "subcategories": []
            },
            {
              "id": "trailers-lowboy-trailers-aaa",
              "name": "AAA",
              "subcategories": []
            },
            {
              "id": "trailers-lowboy-trailers-alpha-hd",
              "name": "ALPHA HD",
              "subcategories": []
            },
            {
              "id": "trailers-lowboy-trailers-aspen",
              "name": "ASPEN",
              "subcategories": []
            },
            {
              "id": "trailers-lowboy-trailers-atoka",
              "name": "ATOKA",
              "subcategories": []
            },
            {
              "id": "trailers-lowboy-trailers-brazos",
              "name": "BRAZOS",
              "subcategories": []
            },
            {
              "id": "trailers-lowboy-trailers-bws",
              "name": "BWS",
              "subcategories": []
            },
            {
              "id": "trailers-lowboy-trailers-choice",
              "name": "CHOICE",
              "subcategories": []
            },
            {
              "id": "trailers-lowboy-trailers-cozad",
              "name": "COZAD",
              "subcategories": []
            },
            {
              "id": "trailers-lowboy-trailers-deloupe",
              "name": "DELOUPE",
              "subcategories": []
            },
            {
              "id": "trailers-lowboy-trailers-doepker",
              "name": "DOEPKER",
              "subcategories": []
            },
            {
              "id": "trailers-lowboy-trailers-dorsey",
              "name": "DORSEY",
              "subcategories": []
            },
            {
              "id": "trailers-lowboy-trailers-drake",
              "name": "DRAKE",
              "subcategories": []
            },
            {
              "id": "trailers-lowboy-trailers-dynaweld",
              "name": "DYNAWELD",
              "subcategories": []
            },
            {
              "id": "trailers-lowboy-trailers-etnyre",
              "name": "ETNYRE",
              "subcategories": []
            },
            {
              "id": "trailers-lowboy-trailers-felling",
              "name": "FELLING",
              "subcategories": []
            },
            {
              "id": "trailers-lowboy-trailers-fwr",
              "name": "FWR",
              "subcategories": []
            },
            {
              "id": "trailers-lowboy-trailers-globe",
              "name": "GLOBE",
              "subcategories": []
            },
            {
              "id": "trailers-lowboy-trailers-goldhofer",
              "name": "GOLDHOFER",
              "subcategories": []
            },
            {
              "id": "trailers-lowboy-trailers-hyster",
              "name": "HYSTER",
              "subcategories": []
            },
            {
              "id": "trailers-lowboy-trailers-interstate",
              "name": "INTERSTATE",
              "subcategories": []
            },
            {
              "id": "trailers-lowboy-trailers-jamieson",
              "name": "JAMIESON",
              "subcategories": []
            },
            {
              "id": "trailers-lowboy-trailers-jet",
              "name": "JET",
              "subcategories": []
            },
            {
              "id": "trailers-lowboy-trailers-kaufman",
              "name": "KAUFMAN",
              "subcategories": []
            },
            {
              "id": "trailers-lowboy-trailers-k-line",
              "name": "K-LINE",
              "subcategories": []
            },
            {
              "id": "trailers-lowboy-trailers-landoll",
              "name": "LANDOLL",
              "subcategories": []
            },
            {
              "id": "trailers-lowboy-trailers-ledwell",
              "name": "LEDWELL",
              "subcategories": []
            },
            {
              "id": "trailers-lowboy-trailers-liddell",
              "name": "LIDDELL",
              "subcategories": []
            },
            {
              "id": "trailers-lowboy-trailers-load-king",
              "name": "LOAD KING",
              "subcategories": []
            },
            {
              "id": "trailers-lowboy-trailers-loadcraft",
              "name": "LOADCRAFT",
              "subcategories": []
            },
            {
              "id": "trailers-lowboy-trailers-manac",
              "name": "MANAC",
              "subcategories": []
            },
            {
              "id": "trailers-lowboy-trailers-mclendon",
              "name": "MCLENDON",
              "subcategories": []
            },
            {
              "id": "trailers-lowboy-trailers-midland",
              "name": "MIDLAND",
              "subcategories": []
            },
            {
              "id": "trailers-lowboy-trailers-mte",
              "name": "MTE",
              "subcategories": []
            },
            {
              "id": "trailers-lowboy-trailers-murray",
              "name": "MURRAY",
              "subcategories": []
            },
            {
              "id": "trailers-lowboy-trailers-muv-all",
              "name": "MUV-ALL",
              "subcategories": []
            },
            {
              "id": "trailers-lowboy-trailers-neville-built",
              "name": "NEVILLE BUILT",
              "subcategories": []
            },
            {
              "id": "trailers-lowboy-trailers-nuttall",
              "name": "NUTTALL",
              "subcategories": []
            },
            {
              "id": "trailers-lowboy-trailers-overbilt",
              "name": "OVERBILT",
              "subcategories": []
            },
            {
              "id": "trailers-lowboy-trailers-pacesetter",
              "name": "PACESETTER",
              "subcategories": []
            },
            {
              "id": "trailers-lowboy-trailers-peerless",
              "name": "PEERLESS",
              "subcategories": []
            },
            {
              "id": "trailers-lowboy-trailers-raja",
              "name": "RAJA",
              "subcategories": []
            },
            {
              "id": "trailers-lowboy-trailers-rogers",
              "name": "ROGERS",
              "subcategories": []
            },
            {
              "id": "trailers-lowboy-trailers-siebert",
              "name": "SIEBERT",
              "subcategories": []
            },
            {
              "id": "trailers-lowboy-trailers-stonestar",
              "name": "STONESTAR",
              "subcategories": []
            },
            {
              "id": "trailers-lowboy-trailers-temisko",
              "name": "TEMISKO",
              "subcategories": []
            },
            {
              "id": "trailers-lowboy-trailers-towmaster",
              "name": "TOWMASTER",
              "subcategories": []
            },
            {
              "id": "trailers-lowboy-trailers-trailboss",
              "name": "TRAILBOSS",
              "subcategories": []
            },
            {
              "id": "trailers-lowboy-trailers-trail-eze",
              "name": "TRAIL-EZE",
              "subcategories": []
            },
            {
              "id": "trailers-lowboy-trailers-ttsa",
              "name": "TTSA",
              "subcategories": []
            },
            {
              "id": "trailers-lowboy-trailers-viking",
              "name": "VIKING",
              "subcategories": []
            },
            {
              "id": "trailers-lowboy-trailers-witzco-challenger",
              "name": "WITZCO CHALLENGER",
              "subcategories": []
            },
            {
              "id": "trailers-lowboy-trailers-other",
              "name": "OTHER",
              "subcategories": []
            }
          ]
        },
        {
          "id": "trailers-non-code-tank-trailers",
          "name": "Non Code Tank Trailers",
          "subcategories": [
            {
              "id": "trailers-non-code-tank-trailers-polar",
              "name": "POLAR",
              "subcategories": []
            },
            {
              "id": "trailers-non-code-tank-trailers-walker",
              "name": "WALKER",
              "subcategories": []
            },
            {
              "id": "trailers-non-code-tank-trailers-brenner",
              "name": "BRENNER",
              "subcategories": []
            },
            {
              "id": "trailers-non-code-tank-trailers-heil",
              "name": "HEIL",
              "subcategories": []
            },
            {
              "id": "trailers-non-code-tank-trailers-mac-ltt",
              "name": "MAC LTT",
              "subcategories": []
            },
            {
              "id": "trailers-non-code-tank-trailers-ste",
              "name": "STE",
              "subcategories": []
            },
            {
              "id": "trailers-non-code-tank-trailers-fruehauf",
              "name": "FRUEHAUF",
              "subcategories": []
            },
            {
              "id": "trailers-non-code-tank-trailers-bulk",
              "name": "BULK",
              "subcategories": []
            },
            {
              "id": "trailers-non-code-tank-trailers-beall",
              "name": "BEALL",
              "subcategories": []
            },
            {
              "id": "trailers-non-code-tank-trailers-remtec",
              "name": "REMTEC",
              "subcategories": []
            },
            {
              "id": "trailers-non-code-tank-trailers-acro",
              "name": "ACRO",
              "subcategories": []
            },
            {
              "id": "trailers-non-code-tank-trailers-advance",
              "name": "ADVANCE",
              "subcategories": []
            },
            {
              "id": "trailers-non-code-tank-trailers-bar-bel",
              "name": "BAR-BEL",
              "subcategories": []
            },
            {
              "id": "trailers-non-code-tank-trailers-bedard",
              "name": "BEDARD",
              "subcategories": []
            },
            {
              "id": "trailers-non-code-tank-trailers-butler",
              "name": "BUTLER",
              "subcategories": []
            },
            {
              "id": "trailers-non-code-tank-trailers-cei-pacer",
              "name": "CEI PACER",
              "subcategories": []
            },
            {
              "id": "trailers-non-code-tank-trailers-domatex",
              "name": "DOMATEX",
              "subcategories": []
            },
            {
              "id": "trailers-non-code-tank-trailers-dragon-products",
              "name": "DRAGON PRODUCTS",
              "subcategories": []
            },
            {
              "id": "trailers-non-code-tank-trailers-eastern-tech",
              "name": "EASTERN TECH",
              "subcategories": []
            },
            {
              "id": "trailers-non-code-tank-trailers-etnyre",
              "name": "ETNYRE",
              "subcategories": []
            },
            {
              "id": "trailers-non-code-tank-trailers-karikool",
              "name": "KARIKOOL",
              "subcategories": []
            },
            {
              "id": "trailers-non-code-tank-trailers-krohnert",
              "name": "KROHNERT",
              "subcategories": []
            },
            {
              "id": "trailers-non-code-tank-trailers-lbt",
              "name": "LBT",
              "subcategories": []
            },
            {
              "id": "trailers-non-code-tank-trailers-mueller",
              "name": "MUELLER",
              "subcategories": []
            },
            {
              "id": "trailers-non-code-tank-trailers-neville-built",
              "name": "NEVILLE BUILT",
              "subcategories": []
            },
            {
              "id": "trailers-non-code-tank-trailers-nova",
              "name": "NOVA",
              "subcategories": []
            },
            {
              "id": "trailers-non-code-tank-trailers-overland",
              "name": "OVERLAND",
              "subcategories": []
            },
            {
              "id": "trailers-non-code-tank-trailers-stephens",
              "name": "STEPHENS",
              "subcategories": []
            },
            {
              "id": "trailers-non-code-tank-trailers-tremcar",
              "name": "TREMCAR",
              "subcategories": []
            },
            {
              "id": "trailers-non-code-tank-trailers-wabash",
              "name": "WABASH",
              "subcategories": []
            },
            {
              "id": "trailers-non-code-tank-trailers-westmark",
              "name": "WESTMARK",
              "subcategories": []
            },
            {
              "id": "trailers-non-code-tank-trailers-other",
              "name": "OTHER",
              "subcategories": []
            }
          ]
        },
        {
          "id": "trailers-pnuematic-bulk-tank-trailers",
          "name": "Pnuematic Bulk Tank Trailers",
          "subcategories": []
        },
        {
          "id": "trailers-pole-trailers",
          "name": "Pole Trailers",
          "subcategories": [
            {
              "id": "trailers-pole-trailers-load-king",
              "name": "LOAD KING",
              "subcategories": []
            },
            {
              "id": "trailers-pole-trailers-butler",
              "name": "BUTLER",
              "subcategories": []
            },
            {
              "id": "trailers-pole-trailers-jj-trailer",
              "name": "JJ TRAILER",
              "subcategories": []
            },
            {
              "id": "trailers-pole-trailers-brooks-brother",
              "name": "BROOKS BROTHER",
              "subcategories": []
            },
            {
              "id": "trailers-pole-trailers-challenger",
              "name": "CHALLENGER",
              "subcategories": []
            },
            {
              "id": "trailers-pole-trailers-cz-eng",
              "name": "CZ ENG",
              "subcategories": []
            },
            {
              "id": "trailers-pole-trailers-lane",
              "name": "LANE",
              "subcategories": []
            },
            {
              "id": "trailers-pole-trailers-tuf-mfg",
              "name": "TUF MFG",
              "subcategories": []
            },
            {
              "id": "trailers-pole-trailers-k-dee",
              "name": "K-DEE",
              "subcategories": []
            },
            {
              "id": "trailers-pole-trailers-kiefer",
              "name": "KIEFER",
              "subcategories": []
            },
            {
              "id": "trailers-pole-trailers-big-tex",
              "name": "BIG TEX",
              "subcategories": []
            },
            {
              "id": "trailers-pole-trailers-brooks-brother",
              "name": "BROOKS BROTHER",
              "subcategories": []
            },
            {
              "id": "trailers-pole-trailers-fehr-bros",
              "name": "FEHR BROS",
              "subcategories": []
            },
            {
              "id": "trailers-pole-trailers-felling",
              "name": "FELLING",
              "subcategories": []
            },
            {
              "id": "trailers-pole-trailers-glenn-eng",
              "name": "GLENN ENG",
              "subcategories": []
            },
            {
              "id": "trailers-pole-trailers-hogg-davis",
              "name": "HOGG & DAVIS",
              "subcategories": []
            },
            {
              "id": "trailers-pole-trailers-homemade",
              "name": "HOMEMADE",
              "subcategories": []
            },
            {
              "id": "trailers-pole-trailers-j-j",
              "name": "J&J",
              "subcategories": []
            },
            {
              "id": "trailers-pole-trailers-moran",
              "name": "MORAN",
              "subcategories": []
            },
            {
              "id": "trailers-pole-trailers-overbilt",
              "name": "OVERBILT",
              "subcategories": []
            },
            {
              "id": "trailers-pole-trailers-pitts",
              "name": "PITTS",
              "subcategories": []
            },
            {
              "id": "trailers-pole-trailers-reelstrong",
              "name": "REELSTRONG",
              "subcategories": []
            },
            {
              "id": "trailers-pole-trailers-robcol",
              "name": "ROBCOL",
              "subcategories": []
            },
            {
              "id": "trailers-pole-trailers-shop-built",
              "name": "SHOP BUILT",
              "subcategories": []
            },
            {
              "id": "trailers-pole-trailers-specialty-fleet",
              "name": "SPECIALTY FLEET",
              "subcategories": []
            },
            {
              "id": "trailers-pole-trailers-talbert",
              "name": "TALBERT",
              "subcategories": []
            },
            {
              "id": "trailers-pole-trailers-whites-welding",
              "name": "WHITES WELDING",
              "subcategories": []
            },
            {
              "id": "trailers-pole-trailers-other",
              "name": "OTHER",
              "subcategories": []
            }
          ]
        },
        {
          "id": "trailers-pup-trailers",
          "name": "Pup Trailers",
          "subcategories": [
            {
              "id": "trailers-pup-trailers-midland",
              "name": "MIDLAND",
              "subcategories": []
            },
            {
              "id": "trailers-pup-trailers-gorski",
              "name": "GORSKI",
              "subcategories": []
            },
            {
              "id": "trailers-pup-trailers-hyundai",
              "name": "HYUNDAI",
              "subcategories": []
            },
            {
              "id": "trailers-pup-trailers-wabash",
              "name": "WABASH",
              "subcategories": []
            },
            {
              "id": "trailers-pup-trailers-maxitrans",
              "name": "MAXITRANS",
              "subcategories": []
            },
            {
              "id": "trailers-pup-trailers-fwr",
              "name": "FWR",
              "subcategories": []
            },
            {
              "id": "trailers-pup-trailers-wildhorse",
              "name": "WILDHORSE",
              "subcategories": []
            },
            {
              "id": "trailers-pup-trailers-fruehauf",
              "name": "FRUEHAUF",
              "subcategories": []
            },
            {
              "id": "trailers-pup-trailers-clement",
              "name": "CLEMENT",
              "subcategories": []
            },
            {
              "id": "trailers-pup-trailers-hamelex-white",
              "name": "HAMELEX WHITE",
              "subcategories": []
            },
            {
              "id": "trailers-pup-trailers-beall",
              "name": "BEALL",
              "subcategories": []
            },
            {
              "id": "trailers-pup-trailers-cornhusker",
              "name": "CORNHUSKER",
              "subcategories": []
            },
            {
              "id": "trailers-pup-trailers-custom-bilt",
              "name": "CUSTOM BILT",
              "subcategories": []
            },
            {
              "id": "trailers-pup-trailers-great-dane",
              "name": "GREAT DANE",
              "subcategories": []
            },
            {
              "id": "trailers-pup-trailers-jasper",
              "name": "JASPER",
              "subcategories": []
            },
            {
              "id": "trailers-pup-trailers-muscat",
              "name": "MUSCAT",
              "subcategories": []
            },
            {
              "id": "trailers-pup-trailers-osw",
              "name": "OSW",
              "subcategories": []
            },
            {
              "id": "trailers-pup-trailers-peerless",
              "name": "PEERLESS",
              "subcategories": []
            },
            {
              "id": "trailers-pup-trailers-ranco",
              "name": "RANCO",
              "subcategories": []
            },
            {
              "id": "trailers-pup-trailers-strick",
              "name": "STRICK",
              "subcategories": []
            },
            {
              "id": "trailers-pup-trailers-trailmobile",
              "name": "TRAILMOBILE",
              "subcategories": []
            },
            {
              "id": "trailers-pup-trailers-other",
              "name": "OTHER",
              "subcategories": []
            }
          ]
        },
        {
          "id": "trailers-reel-trailers",
          "name": "Reel Trailers",
          "subcategories": []
        },
        {
          "id": "trailers-refrigerated-trailers",
          "name": "Refrigerated Trailers",
          "subcategories": []
        },
        {
          "id": "trailers-roll-off-trailers",
          "name": "Roll Off Trailers",
          "subcategories": []
        },
        {
          "id": "trailers-sanitary-tank-trailers",
          "name": "Sanitary Tank Trailers",
          "subcategories": []
        },
        {
          "id": "trailers-side-dump-trailers",
          "name": "Side Dump Trailers",
          "subcategories": [
            {
              "id": "trailers-side-dump-trailers-smithco",
              "name": "SMITHCO",
              "subcategories": []
            },
            {
              "id": "trailers-side-dump-trailers-side-dump-ind",
              "name": "SIDE DUMP IND",
              "subcategories": []
            },
            {
              "id": "trailers-side-dump-trailers-jet",
              "name": "JET",
              "subcategories": []
            },
            {
              "id": "trailers-side-dump-trailers-sidumpr",
              "name": "SIDUMPR",
              "subcategories": []
            },
            {
              "id": "trailers-side-dump-trailers-demco",
              "name": "DEMCO",
              "subcategories": []
            },
            {
              "id": "trailers-side-dump-trailers-arnes",
              "name": "ARNES",
              "subcategories": []
            },
            {
              "id": "trailers-side-dump-trailers-cross-country",
              "name": "CROSS COUNTRY",
              "subcategories": []
            },
            {
              "id": "trailers-side-dump-trailers-load-king",
              "name": "LOAD KING",
              "subcategories": []
            },
            {
              "id": "trailers-side-dump-trailers-midland",
              "name": "MIDLAND",
              "subcategories": []
            },
            {
              "id": "trailers-side-dump-trailers-trail-king",
              "name": "TRAIL KING",
              "subcategories": []
            },
            {
              "id": "trailers-side-dump-trailers-aaa",
              "name": "AAA",
              "subcategories": []
            },
            {
              "id": "trailers-side-dump-trailers-azmeb",
              "name": "AZMEB",
              "subcategories": []
            },
            {
              "id": "trailers-side-dump-trailers-bruce-rock",
              "name": "BRUCE ROCK",
              "subcategories": []
            },
            {
              "id": "trailers-side-dump-trailers-canuck",
              "name": "CANUCK",
              "subcategories": []
            },
            {
              "id": "trailers-side-dump-trailers-doepker",
              "name": "DOEPKER",
              "subcategories": []
            },
            {
              "id": "trailers-side-dump-trailers-five-star",
              "name": "FIVE STAR",
              "subcategories": []
            },
            {
              "id": "trailers-side-dump-trailers-freight-west-trlr",
              "name": "FREIGHT WEST TRLR",
              "subcategories": []
            },
            {
              "id": "trailers-side-dump-trailers-freightmore-trans",
              "name": "FREIGHTMORE TRANS",
              "subcategories": []
            },
            {
              "id": "trailers-side-dump-trailers-howard-porter",
              "name": "HOWARD PORTER",
              "subcategories": []
            },
            {
              "id": "trailers-side-dump-trailers-jamieson",
              "name": "JAMIESON",
              "subcategories": []
            },
            {
              "id": "trailers-side-dump-trailers-loadline",
              "name": "LOADLINE",
              "subcategories": []
            },
            {
              "id": "trailers-side-dump-trailers-lusty",
              "name": "LUSTY",
              "subcategories": []
            },
            {
              "id": "trailers-side-dump-trailers-manac",
              "name": "MANAC",
              "subcategories": []
            },
            {
              "id": "trailers-side-dump-trailers-mars",
              "name": "MARS",
              "subcategories": []
            },
            {
              "id": "trailers-side-dump-trailers-moore",
              "name": "MOORE",
              "subcategories": []
            },
            {
              "id": "trailers-side-dump-trailers-ranco",
              "name": "RANCO",
              "subcategories": []
            },
            {
              "id": "trailers-side-dump-trailers-r-way",
              "name": "R-WAY",
              "subcategories": []
            },
            {
              "id": "trailers-side-dump-trailers-trail-king",
              "name": "TRAIL KING",
              "subcategories": []
            },
            {
              "id": "trailers-side-dump-trailers-tristar",
              "name": "TRISTAR",
              "subcategories": []
            },
            {
              "id": "trailers-side-dump-trailers-xl-specialized",
              "name": "XL SPECIALIZED",
              "subcategories": []
            },
            {
              "id": "trailers-side-dump-trailers-other",
              "name": "OTHER",
              "subcategories": []
            }
          ]
        },
        {
          "id": "trailers-tag-trailers",
          "name": "Tag Trailers",
          "subcategories": [
            {
              "id": "trailers-tag-trailers-midland",
              "name": "MIDLAND",
              "subcategories": []
            },
            {
              "id": "trailers-tag-trailers-talbert",
              "name": "TALBERT",
              "subcategories": []
            },
            {
              "id": "trailers-tag-trailers-trailboss",
              "name": "TRAILBOSS",
              "subcategories": []
            },
            {
              "id": "trailers-tag-trailers-fwr",
              "name": "FWR",
              "subcategories": []
            },
            {
              "id": "trailers-tag-trailers-pitts",
              "name": "PITTS",
              "subcategories": []
            },
            {
              "id": "trailers-tag-trailers-trail-king",
              "name": "TRAIL KING",
              "subcategories": []
            },
            {
              "id": "trailers-tag-trailers-eager-beaver",
              "name": "EAGER BEAVER",
              "subcategories": []
            },
            {
              "id": "trailers-tag-trailers-felling",
              "name": "FELLING",
              "subcategories": []
            },
            {
              "id": "trailers-tag-trailers-aaa",
              "name": "AAA",
              "subcategories": []
            },
            {
              "id": "trailers-tag-trailers-interstate",
              "name": "INTERSTATE",
              "subcategories": []
            },
            {
              "id": "trailers-tag-trailers-behnke",
              "name": "BEHNKE",
              "subcategories": []
            },
            {
              "id": "trailers-tag-trailers-brandt",
              "name": "BRANDT",
              "subcategories": []
            },
            {
              "id": "trailers-tag-trailers-bws",
              "name": "BWS",
              "subcategories": []
            },
            {
              "id": "trailers-tag-trailers-cross-country",
              "name": "CROSS COUNTRY",
              "subcategories": []
            },
            {
              "id": "trailers-tag-trailers-dorsey",
              "name": "DORSEY",
              "subcategories": []
            },
            {
              "id": "trailers-tag-trailers-east-texas",
              "name": "EAST TEXAS",
              "subcategories": []
            },
            {
              "id": "trailers-tag-trailers-globe",
              "name": "GLOBE",
              "subcategories": []
            },
            {
              "id": "trailers-tag-trailers-hudson",
              "name": "HUDSON",
              "subcategories": []
            },
            {
              "id": "trailers-tag-trailers-kaufman",
              "name": "KAUFMAN",
              "subcategories": []
            },
            {
              "id": "trailers-tag-trailers-load-trail",
              "name": "LOAD TRAIL",
              "subcategories": []
            },
            {
              "id": "trailers-tag-trailers-lucon",
              "name": "LUCON",
              "subcategories": []
            },
            {
              "id": "trailers-tag-trailers-manac",
              "name": "MANAC",
              "subcategories": []
            },
            {
              "id": "trailers-tag-trailers-norstar",
              "name": "NORSTAR",
              "subcategories": []
            },
            {
              "id": "trailers-tag-trailers-northeast",
              "name": "NORTHEAST",
              "subcategories": []
            },
            {
              "id": "trailers-tag-trailers-olympic",
              "name": "OLYMPIC",
              "subcategories": []
            },
            {
              "id": "trailers-tag-trailers-overbilt",
              "name": "OVERBILT",
              "subcategories": []
            },
            {
              "id": "trailers-tag-trailers-rogers",
              "name": "ROGERS",
              "subcategories": []
            },
            {
              "id": "trailers-tag-trailers-stonestar",
              "name": "STONESTAR",
              "subcategories": []
            },
            {
              "id": "trailers-tag-trailers-towmaster",
              "name": "TOWMASTER",
              "subcategories": []
            },
            {
              "id": "trailers-tag-trailers-trailmax",
              "name": "TRAILMAX",
              "subcategories": []
            },
            {
              "id": "trailers-tag-trailers-utility",
              "name": "UTILITY",
              "subcategories": []
            },
            {
              "id": "trailers-tag-trailers-witzco",
              "name": "WITZCO",
              "subcategories": []
            },
            {
              "id": "trailers-tag-trailers-xl-specialized",
              "name": "XL SPECIALIZED",
              "subcategories": []
            },
            {
              "id": "trailers-tag-trailers-zieman",
              "name": "ZIEMAN",
              "subcategories": []
            },
            {
              "id": "trailers-tag-trailers-other",
              "name": "OTHER",
              "subcategories": []
            }
          ]
        },
        {
          "id": "trailers-tanker-trailers",
          "name": "Tanker Trailers",
          "subcategories": [
            {
              "id": "trailers-tanker-trailers-polar",
              "name": "POLAR",
              "subcategories": []
            },
            {
              "id": "trailers-tanker-trailers-heil",
              "name": "HEIL",
              "subcategories": []
            },
            {
              "id": "trailers-tanker-trailers-brenner",
              "name": "BRENNER",
              "subcategories": []
            },
            {
              "id": "trailers-tanker-trailers-mac-trailer-mfg",
              "name": "MAC TRAILER MFG",
              "subcategories": []
            },
            {
              "id": "trailers-tanker-trailers-walker",
              "name": "WALKER",
              "subcategories": []
            },
            {
              "id": "trailers-tanker-trailers-fruehauf",
              "name": "FRUEHAUF",
              "subcategories": []
            },
            {
              "id": "trailers-tanker-trailers-mac-ltt",
              "name": "MAC LTT",
              "subcategories": []
            },
            {
              "id": "trailers-tanker-trailers-tremcar",
              "name": "TREMCAR",
              "subcategories": []
            },
            {
              "id": "trailers-tanker-trailers-ste",
              "name": "STE",
              "subcategories": []
            },
            {
              "id": "trailers-tanker-trailers-beall",
              "name": "BEALL",
              "subcategories": []
            },
            {
              "id": "trailers-tanker-trailers-aaa",
              "name": "AAA",
              "subcategories": []
            },
            {
              "id": "trailers-tanker-trailers-ace",
              "name": "ACE",
              "subcategories": []
            },
            {
              "id": "trailers-tanker-trailers-acro",
              "name": "ACRO",
              "subcategories": []
            },
            {
              "id": "trailers-tanker-trailers-advance",
              "name": "ADVANCE",
              "subcategories": []
            },
            {
              "id": "trailers-tanker-trailers-aldura",
              "name": "ALDURA",
              "subcategories": []
            },
            {
              "id": "trailers-tanker-trailers-bar-bel",
              "name": "BAR-BEL",
              "subcategories": []
            },
            {
              "id": "trailers-tanker-trailers-bedard",
              "name": "BEDARD",
              "subcategories": []
            },
            {
              "id": "trailers-tanker-trailers-bulk",
              "name": "BULK",
              "subcategories": []
            },
            {
              "id": "trailers-tanker-trailers-butler",
              "name": "BUTLER",
              "subcategories": []
            },
            {
              "id": "trailers-tanker-trailers-colombia",
              "name": "COLOMBIA",
              "subcategories": []
            },
            {
              "id": "trailers-tanker-trailers-comptank",
              "name": "COMPTANK",
              "subcategories": []
            },
            {
              "id": "trailers-tanker-trailers-conquest",
              "name": "CONQUEST",
              "subcategories": []
            },
            {
              "id": "trailers-tanker-trailers-custom",
              "name": "CUSTOM",
              "subcategories": []
            },
            {
              "id": "trailers-tanker-trailers-demco",
              "name": "DEMCO",
              "subcategories": []
            },
            {
              "id": "trailers-tanker-trailers-dragon",
              "name": "DRAGON",
              "subcategories": []
            },
            {
              "id": "trailers-tanker-trailers-etnyre",
              "name": "ETNYRE",
              "subcategories": []
            },
            {
              "id": "trailers-tanker-trailers-exa",
              "name": "EXA",
              "subcategories": []
            },
            {
              "id": "trailers-tanker-trailers-gallegos",
              "name": "GALLEGOS",
              "subcategories": []
            },
            {
              "id": "trailers-tanker-trailers-galyean",
              "name": "GALYEAN",
              "subcategories": []
            },
            {
              "id": "trailers-tanker-trailers-harmon",
              "name": "HARMON",
              "subcategories": []
            },
            {
              "id": "trailers-tanker-trailers-hutchinson",
              "name": "HUTCHINSON",
              "subcategories": []
            },
            {
              "id": "trailers-tanker-trailers-j-l",
              "name": "J & L",
              "subcategories": []
            },
            {
              "id": "trailers-tanker-trailers-jameison",
              "name": "JAMEISON",
              "subcategories": []
            },
            {
              "id": "trailers-tanker-trailers-karikool",
              "name": "KARIKOOL",
              "subcategories": []
            },
            {
              "id": "trailers-tanker-trailers-ledwell",
              "name": "LEDWELL",
              "subcategories": []
            },
            {
              "id": "trailers-tanker-trailers-lubbock",
              "name": "LUBBOCK",
              "subcategories": []
            },
            {
              "id": "trailers-tanker-trailers-marshall-lethlean",
              "name": "MARSHALL LETHLEAN",
              "subcategories": []
            },
            {
              "id": "trailers-tanker-trailers-mississippi",
              "name": "MISSISSIPPI",
              "subcategories": []
            },
            {
              "id": "trailers-tanker-trailers-neville",
              "name": "NEVILLE",
              "subcategories": []
            },
            {
              "id": "trailers-tanker-trailers-remtec",
              "name": "REMTEC",
              "subcategories": []
            },
            {
              "id": "trailers-tanker-trailers-retesa",
              "name": "RETESA",
              "subcategories": []
            },
            {
              "id": "trailers-tanker-trailers-stephens",
              "name": "STEPHENS",
              "subcategories": []
            },
            {
              "id": "trailers-tanker-trailers-stonestar",
              "name": "STONESTAR",
              "subcategories": []
            },
            {
              "id": "trailers-tanker-trailers-trail-king",
              "name": "TRAIL KING",
              "subcategories": []
            },
            {
              "id": "trailers-tanker-trailers-trailmaster",
              "name": "TRAILMASTER",
              "subcategories": []
            },
            {
              "id": "trailers-tanker-trailers-trailmobile",
              "name": "TRAILMOBILE",
              "subcategories": []
            },
            {
              "id": "trailers-tanker-trailers-tramco",
              "name": "TRAMCO",
              "subcategories": []
            },
            {
              "id": "trailers-tanker-trailers-troxell",
              "name": "TROXELL",
              "subcategories": []
            },
            {
              "id": "trailers-tanker-trailers-vantage",
              "name": "VANTAGE",
              "subcategories": []
            },
            {
              "id": "trailers-tanker-trailers-wabash",
              "name": "WABASH",
              "subcategories": []
            },
            {
              "id": "trailers-tanker-trailers-weldit",
              "name": "WELDIT",
              "subcategories": []
            },
            {
              "id": "trailers-tanker-trailers-westmor",
              "name": "WESTMOR",
              "subcategories": []
            },
            {
              "id": "trailers-tanker-trailers-wilco",
              "name": "WILCO",
              "subcategories": []
            },
            {
              "id": "trailers-tanker-trailers-other",
              "name": "OTHER",
              "subcategories": []
            }
          ]
        },
        {
          "id": "trailers-utility-trailers",
          "name": "Utility Trailers",
          "subcategories": [
            {
              "id": "trailers-utility-trailers-aluma",
              "name": "ALUMA",
              "subcategories": []
            },
            {
              "id": "trailers-utility-trailers-mcclain",
              "name": "MCCLAIN",
              "subcategories": []
            },
            {
              "id": "trailers-utility-trailers-sure-trac",
              "name": "SURE-TRAC",
              "subcategories": []
            },
            {
              "id": "trailers-utility-trailers-coastline",
              "name": "COASTLINE",
              "subcategories": []
            },
            {
              "id": "trailers-utility-trailers-diamond-t",
              "name": "DIAMOND T",
              "subcategories": []
            },
            {
              "id": "trailers-utility-trailers-h-h",
              "name": "H&H",
              "subcategories": []
            },
            {
              "id": "trailers-utility-trailers-triton",
              "name": "TRITON",
              "subcategories": []
            },
            {
              "id": "trailers-utility-trailers-taylor-way",
              "name": "TAYLOR-WAY",
              "subcategories": []
            },
            {
              "id": "trailers-utility-trailers-doolittle",
              "name": "DOOLITTLE",
              "subcategories": []
            },
            {
              "id": "trailers-utility-trailers-midsota",
              "name": "MIDSOTA",
              "subcategories": []
            },
            {
              "id": "trailers-utility-trailers-big-tex",
              "name": "BIG TEX",
              "subcategories": []
            },
            {
              "id": "trailers-utility-trailers-can-am",
              "name": "CAN-AM",
              "subcategories": []
            },
            {
              "id": "trailers-utility-trailers-chilton",
              "name": "CHILTON",
              "subcategories": []
            },
            {
              "id": "trailers-utility-trailers-timpte",
              "name": "TIMPTE",
              "subcategories": []
            },
            {
              "id": "trailers-utility-trailers-yacht-club",
              "name": "YACHT CLUB",
              "subcategories": []
            },
            {
              "id": "trailers-utility-trailers-other",
              "name": "OTHER",
              "subcategories": []
            }
          ]
        },
        {
          "id": "trailers-vacuum-trailers",
          "name": "Vacuum Trailers",
          "subcategories": []
        },
        {
          "id": "trailers-van-trailers",
          "name": "Van Trailers",
          "subcategories": [
            {
              "id": "trailers-van-trailers-alloy",
              "name": "ALLOY",
              "subcategories": []
            },
            {
              "id": "trailers-van-trailers-aztec",
              "name": "AZTEC",
              "subcategories": []
            },
            {
              "id": "trailers-van-trailers-budd",
              "name": "BUDD",
              "subcategories": []
            },
            {
              "id": "trailers-van-trailers-can-car",
              "name": "CAN CAR",
              "subcategories": []
            },
            {
              "id": "trailers-van-trailers-comet",
              "name": "COMET",
              "subcategories": []
            },
            {
              "id": "trailers-van-trailers-di-mond",
              "name": "DI-MOND",
              "subcategories": []
            },
            {
              "id": "trailers-van-trailers-dorsey",
              "name": "DORSEY",
              "subcategories": []
            },
            {
              "id": "trailers-van-trailers-fontaine",
              "name": "FONTAINE",
              "subcategories": []
            },
            {
              "id": "trailers-van-trailers-freightliner",
              "name": "FREIGHTLINER",
              "subcategories": []
            },
            {
              "id": "trailers-van-trailers-fruehauf",
              "name": "FRUEHAUF",
              "subcategories": []
            },
            {
              "id": "trailers-van-trailers-gindy",
              "name": "GINDY",
              "subcategories": []
            },
            {
              "id": "trailers-van-trailers-great-dane",
              "name": "GREAT DANE",
              "subcategories": []
            },
            {
              "id": "trailers-van-trailers-haulmark",
              "name": "HAULMARK",
              "subcategories": []
            },
            {
              "id": "trailers-van-trailers-holland",
              "name": "HOLLAND",
              "subcategories": []
            },
            {
              "id": "trailers-van-trailers-hyundai",
              "name": "HYUNDAI",
              "subcategories": []
            },
            {
              "id": "trailers-van-trailers-kent",
              "name": "KENT",
              "subcategories": []
            },
            {
              "id": "trailers-van-trailers-kentucky",
              "name": "KENTUCKY",
              "subcategories": []
            },
            {
              "id": "trailers-van-trailers-lufkin",
              "name": "LUFKIN",
              "subcategories": []
            },
            {
              "id": "trailers-van-trailers-manac",
              "name": "MANAC",
              "subcategories": []
            },
            {
              "id": "trailers-van-trailers-mi-t-m",
              "name": "MI-T-M",
              "subcategories": []
            },
            {
              "id": "trailers-van-trailers-mond",
              "name": "MOND",
              "subcategories": []
            },
            {
              "id": "trailers-van-trailers-monon",
              "name": "MONON",
              "subcategories": []
            },
            {
              "id": "trailers-van-trailers-pine",
              "name": "PINE",
              "subcategories": []
            },
            {
              "id": "trailers-van-trailers-stoughton",
              "name": "STOUGHTON",
              "subcategories": []
            },
            {
              "id": "trailers-van-trailers-strick",
              "name": "STRICK",
              "subcategories": []
            },
            {
              "id": "trailers-van-trailers-trailmobile",
              "name": "TRAILMOBILE",
              "subcategories": []
            },
            {
              "id": "trailers-van-trailers-utility",
              "name": "UTILITY",
              "subcategories": []
            },
            {
              "id": "trailers-van-trailers-vanguard",
              "name": "VANGUARD",
              "subcategories": []
            },
            {
              "id": "trailers-van-trailers-wabash",
              "name": "WABASH",
              "subcategories": []
            },
            {
              "id": "trailers-van-trailers-wanco",
              "name": "WANCO",
              "subcategories": []
            },
            {
              "id": "trailers-van-trailers-wells-cargo",
              "name": "WELLS CARGO",
              "subcategories": []
            },
            {
              "id": "trailers-van-trailers-con-way-mfg",
              "name": "CON-WAY MFG",
              "subcategories": []
            },
            {
              "id": "trailers-van-trailers-atro",
              "name": "ATRO",
              "subcategories": []
            },
            {
              "id": "trailers-van-trailers-other",
              "name": "OTHER",
              "subcategories": []
            }
          ]
        },
        {
          "id": "trailers-waste-sludge-tank-trailers",
          "name": "Waste / Sludge Tank Trailers",
          "subcategories": []
        },
        {
          "id": "trailers-water-tank-trailers",
          "name": "Water Tank Trailers",
          "subcategories": [
            {
              "id": "trailers-water-tank-trailers-demco",
              "name": "DEMCO",
              "subcategories": []
            },
            {
              "id": "trailers-water-tank-trailers-aaa",
              "name": "AAA",
              "subcategories": []
            },
            {
              "id": "trailers-water-tank-trailers-polar",
              "name": "POLAR",
              "subcategories": []
            },
            {
              "id": "trailers-water-tank-trailers-neville-built",
              "name": "NEVILLE BUILT",
              "subcategories": []
            },
            {
              "id": "trailers-water-tank-trailers-marshall-lethlean",
              "name": "MARSHALL LETHLEAN",
              "subcategories": []
            },
            {
              "id": "trailers-water-tank-trailers-stonestar",
              "name": "STONESTAR",
              "subcategories": []
            },
            {
              "id": "trailers-water-tank-trailers-brenner",
              "name": "BRENNER",
              "subcategories": []
            },
            {
              "id": "trailers-water-tank-trailers-walker",
              "name": "WALKER",
              "subcategories": []
            },
            {
              "id": "trailers-water-tank-trailers-fruehauf",
              "name": "FRUEHAUF",
              "subcategories": []
            },
            {
              "id": "trailers-water-tank-trailers-advance",
              "name": "ADVANCE",
              "subcategories": []
            },
            {
              "id": "trailers-water-tank-trailers-beall",
              "name": "BEALL",
              "subcategories": []
            },
            {
              "id": "trailers-water-tank-trailers-custom-bilt",
              "name": "CUSTOM BILT",
              "subcategories": []
            },
            {
              "id": "trailers-water-tank-trailers-duo-lift",
              "name": "DUO LIFT",
              "subcategories": []
            },
            {
              "id": "trailers-water-tank-trailers-freightmore-transport",
              "name": "FREIGHTMORE TRANSPORT",
              "subcategories": []
            },
            {
              "id": "trailers-water-tank-trailers-galyean",
              "name": "GALYEAN",
              "subcategories": []
            },
            {
              "id": "trailers-water-tank-trailers-gte",
              "name": "GTE",
              "subcategories": []
            },
            {
              "id": "trailers-water-tank-trailers-heil",
              "name": "HEIL",
              "subcategories": []
            },
            {
              "id": "trailers-water-tank-trailers-hockney",
              "name": "HOCKNEY",
              "subcategories": []
            },
            {
              "id": "trailers-water-tank-trailers-jamieson",
              "name": "JAMIESON",
              "subcategories": []
            },
            {
              "id": "trailers-water-tank-trailers-kockums",
              "name": "KOCKUMS",
              "subcategories": []
            },
            {
              "id": "trailers-water-tank-trailers-ste",
              "name": "STE",
              "subcategories": []
            },
            {
              "id": "trailers-water-tank-trailers-tieman",
              "name": "TIEMAN",
              "subcategories": []
            },
            {
              "id": "trailers-water-tank-trailers-uta-trailers",
              "name": "UTA TRAILERS",
              "subcategories": []
            },
            {
              "id": "trailers-water-tank-trailers-westank",
              "name": "WESTANK",
              "subcategories": []
            },
            {
              "id": "trailers-water-tank-trailers-westmark",
              "name": "WESTMARK",
              "subcategories": []
            },
            {
              "id": "trailers-water-tank-trailers-other",
              "name": "OTHER",
              "subcategories": []
            }
          ]
        },
        {
          "id": "trailers-other-trailers",
          "name": "Other Trailers",
          "subcategories": []
        }
      ]
    },
    {
      "id": "trucks",
      "name": "Trucks",
      "subcategories": [
        {
          "id": "trucks-ambulance",
          "name": "Ambulance",
          "subcategories": [
            {
              "id": "trucks-ambulance-chevrolet",
              "name": "CHEVROLET",
              "subcategories": []
            },
            {
              "id": "trucks-ambulance-ford",
              "name": "FORD",
              "subcategories": []
            },
            {
              "id": "trucks-ambulance-freightliner",
              "name": "FREIGHTLINER",
              "subcategories": []
            },
            {
              "id": "trucks-ambulance-international",
              "name": "INTERNATIONAL",
              "subcategories": []
            },
            {
              "id": "trucks-ambulance-ram",
              "name": "RAM",
              "subcategories": []
            },
            {
              "id": "trucks-ambulance-spartan",
              "name": "SPARTAN",
              "subcategories": []
            },
            {
              "id": "trucks-ambulance-sterling",
              "name": "STERLING",
              "subcategories": []
            },
            {
              "id": "trucks-ambulance-toyota",
              "name": "TOYOTA",
              "subcategories": []
            },
            {
              "id": "trucks-ambulance-other",
              "name": "OTHER",
              "subcategories": []
            }
          ]
        },
        {
          "id": "trucks-attenuator-trucks",
          "name": "Attenuator Trucks",
          "subcategories": [
            {
              "id": "trucks-attenuator-trucks-ford",
              "name": "FORD",
              "subcategories": []
            },
            {
              "id": "trucks-attenuator-trucks-freightliner",
              "name": "FREIGHTLINER",
              "subcategories": []
            },
            {
              "id": "trucks-attenuator-trucks-gmc",
              "name": "GMC",
              "subcategories": []
            },
            {
              "id": "trucks-attenuator-trucks-hino",
              "name": "HINO",
              "subcategories": []
            },
            {
              "id": "trucks-attenuator-trucks-international",
              "name": "INTERNATIONAL",
              "subcategories": []
            },
            {
              "id": "trucks-attenuator-trucks-kenworth",
              "name": "KENWORTH",
              "subcategories": []
            },
            {
              "id": "trucks-attenuator-trucks-mack",
              "name": "MACK",
              "subcategories": []
            },
            {
              "id": "trucks-attenuator-trucks-other",
              "name": "OTHER",
              "subcategories": []
            }
          ]
        },
        {
          "id": "trucks-beverage-trucks",
          "name": "Beverage Trucks",
          "subcategories": [
            {
              "id": "trucks-beverage-trucks-chevrolet",
              "name": "CHEVROLET",
              "subcategories": []
            },
            {
              "id": "trucks-beverage-trucks-ford",
              "name": "FORD",
              "subcategories": []
            },
            {
              "id": "trucks-beverage-trucks-frightliner",
              "name": "FRIGHTLINER",
              "subcategories": []
            },
            {
              "id": "trucks-beverage-trucks-hino",
              "name": "HINO",
              "subcategories": []
            },
            {
              "id": "trucks-beverage-trucks-international",
              "name": "INTERNATIONAL",
              "subcategories": []
            },
            {
              "id": "trucks-beverage-trucks-isuzu",
              "name": "ISUZU",
              "subcategories": []
            },
            {
              "id": "trucks-beverage-trucks-kenworth",
              "name": "KENWORTH",
              "subcategories": []
            },
            {
              "id": "trucks-beverage-trucks-mack",
              "name": "MACK",
              "subcategories": []
            },
            {
              "id": "trucks-beverage-trucks-peterbilt",
              "name": "PETERBILT",
              "subcategories": []
            },
            {
              "id": "trucks-beverage-trucks-ram",
              "name": "RAM",
              "subcategories": []
            },
            {
              "id": "trucks-beverage-trucks-other",
              "name": "OTHER",
              "subcategories": []
            }
          ]
        },
        {
          "id": "trucks-boom-truck-cranes",
          "name": "Boom Truck Cranes",
          "subcategories": []
        },
        {
          "id": "trucks-mounted",
          "name": "Mounted",
          "subcategories": []
        },
        {
          "id": "trucks-un-mounted",
          "name": "Un-Mounted",
          "subcategories": []
        },
        {
          "id": "trucks-box-trucks",
          "name": "Box Trucks",
          "subcategories": [
            {
              "id": "trucks-box-trucks-freightliner",
              "name": "FREIGHTLINER",
              "subcategories": []
            },
            {
              "id": "trucks-box-trucks-international",
              "name": "INTERNATIONAL",
              "subcategories": []
            },
            {
              "id": "trucks-box-trucks-isuzu",
              "name": "ISUZU",
              "subcategories": []
            },
            {
              "id": "trucks-box-trucks-hino",
              "name": "HINO",
              "subcategories": []
            },
            {
              "id": "trucks-box-trucks-ford",
              "name": "FORD",
              "subcategories": []
            },
            {
              "id": "trucks-box-trucks-gmc",
              "name": "GMC",
              "subcategories": []
            },
            {
              "id": "trucks-box-trucks-chevrolet",
              "name": "CHEVROLET",
              "subcategories": []
            },
            {
              "id": "trucks-box-trucks-kenworth",
              "name": "KENWORTH",
              "subcategories": []
            },
            {
              "id": "trucks-box-trucks-mack",
              "name": "MACK",
              "subcategories": []
            },
            {
              "id": "trucks-box-trucks-peterbilt",
              "name": "PETERBILT",
              "subcategories": []
            },
            {
              "id": "trucks-box-trucks-battle-motors",
              "name": "BATTLE MOTORS",
              "subcategories": []
            },
            {
              "id": "trucks-box-trucks-bollinger",
              "name": "BOLLINGER",
              "subcategories": []
            },
            {
              "id": "trucks-box-trucks-green-power",
              "name": "GREEN POWER",
              "subcategories": []
            },
            {
              "id": "trucks-box-trucks-greenkraft",
              "name": "GREENKRAFT",
              "subcategories": []
            },
            {
              "id": "trucks-box-trucks-mercedes-benz",
              "name": "MERCEDES-BENZ",
              "subcategories": []
            },
            {
              "id": "trucks-box-trucks-mitsubishi",
              "name": "MITSUBISHI",
              "subcategories": []
            },
            {
              "id": "trucks-box-trucks-mullin",
              "name": "MULLIN",
              "subcategories": []
            },
            {
              "id": "trucks-box-trucks-ram",
              "name": "RAM",
              "subcategories": []
            },
            {
              "id": "trucks-box-trucks-rizon",
              "name": "RIZON",
              "subcategories": []
            },
            {
              "id": "trucks-box-trucks-sterling",
              "name": "STERLING",
              "subcategories": []
            },
            {
              "id": "trucks-box-trucks-ud",
              "name": "UD",
              "subcategories": []
            },
            {
              "id": "trucks-box-trucks-volvo",
              "name": "VOLVO",
              "subcategories": []
            },
            {
              "id": "trucks-box-trucks-western-star",
              "name": "WESTERN STAR",
              "subcategories": []
            },
            {
              "id": "trucks-box-trucks-workhorse",
              "name": "WORKHORSE",
              "subcategories": []
            },
            {
              "id": "trucks-box-trucks-other",
              "name": "OTHER",
              "subcategories": []
            }
          ]
        },
        {
          "id": "trucks-cargo-straight",
          "name": "Cargo / Straight",
          "subcategories": []
        },
        {
          "id": "trucks-cutaway-cube",
          "name": "Cutaway-Cube",
          "subcategories": []
        },
        {
          "id": "trucks-moving",
          "name": "Moving",
          "subcategories": []
        },
        {
          "id": "trucks-reefer-refrigerated",
          "name": "Reefer / Refrigerated",
          "subcategories": []
        },
        {
          "id": "trucks-bucket-trucks",
          "name": "Bucket Trucks",
          "subcategories": [
            {
              "id": "trucks-bucket-trucks-altec",
              "name": "ALTEC",
              "subcategories": []
            },
            {
              "id": "trucks-bucket-trucks-versalift",
              "name": "VERSALIFT",
              "subcategories": []
            },
            {
              "id": "trucks-bucket-trucks-terex",
              "name": "TEREX",
              "subcategories": []
            },
            {
              "id": "trucks-bucket-trucks-dur-a-lift",
              "name": "DUR-A-LIFT",
              "subcategories": []
            },
            {
              "id": "trucks-bucket-trucks-eti",
              "name": "ETI",
              "subcategories": []
            },
            {
              "id": "trucks-bucket-trucks-palfinger",
              "name": "PALFINGER",
              "subcategories": []
            },
            {
              "id": "trucks-bucket-trucks-hi-ranger",
              "name": "HI RANGER",
              "subcategories": []
            },
            {
              "id": "trucks-bucket-trucks-posi-plus",
              "name": "POSI-PLUS",
              "subcategories": []
            },
            {
              "id": "trucks-bucket-trucks-utem",
              "name": "UTEM",
              "subcategories": []
            },
            {
              "id": "trucks-bucket-trucks-rh",
              "name": "RH",
              "subcategories": []
            },
            {
              "id": "trucks-bucket-trucks-axionlift",
              "name": "AXIONLIFT",
              "subcategories": []
            },
            {
              "id": "trucks-bucket-trucks-custers",
              "name": "CUSTERS",
              "subcategories": []
            },
            {
              "id": "trucks-bucket-trucks-elliott",
              "name": "ELLIOTT",
              "subcategories": []
            },
            {
              "id": "trucks-bucket-trucks-holan",
              "name": "HOLAN",
              "subcategories": []
            },
            {
              "id": "trucks-bucket-trucks-liftall",
              "name": "LIFTALL",
              "subcategories": []
            },
            {
              "id": "trucks-bucket-trucks-laodking",
              "name": "LAODKING",
              "subcategories": []
            },
            {
              "id": "trucks-bucket-trucks-maintainer",
              "name": "MAINTAINER",
              "subcategories": []
            },
            {
              "id": "trucks-bucket-trucks-mti",
              "name": "MTI",
              "subcategories": []
            },
            {
              "id": "trucks-bucket-trucks-norstar",
              "name": "NORSTAR",
              "subcategories": []
            },
            {
              "id": "trucks-bucket-trucks-simon-telelect",
              "name": "SIMON-TELELECT",
              "subcategories": []
            },
            {
              "id": "trucks-bucket-trucks-skylift",
              "name": "SKYLIFT",
              "subcategories": []
            },
            {
              "id": "trucks-bucket-trucks-skylift-versalift",
              "name": "SKYLIFT/VERSALIFT",
              "subcategories": []
            },
            {
              "id": "trucks-bucket-trucks-skyvan",
              "name": "SKYVAN",
              "subcategories": []
            },
            {
              "id": "trucks-bucket-trucks-svabo-liften",
              "name": "SVABO-LIFTEN",
              "subcategories": []
            },
            {
              "id": "trucks-bucket-trucks-teco",
              "name": "TECO",
              "subcategories": []
            },
            {
              "id": "trucks-bucket-trucks-telelift",
              "name": "TELELIFT",
              "subcategories": []
            },
            {
              "id": "trucks-bucket-trucks-telsta",
              "name": "TELSTA",
              "subcategories": []
            },
            {
              "id": "trucks-bucket-trucks-van-ladder",
              "name": "VAN LADDER",
              "subcategories": []
            },
            {
              "id": "trucks-bucket-trucks-other",
              "name": "OTHER",
              "subcategories": []
            }
          ]
        },
        {
          "id": "trucks-cab-chassis-trucks",
          "name": "Cab & Chassis Trucks",
          "subcategories": []
        },
        {
          "id": "trucks-car-hauler-trucks",
          "name": "Car Hauler Trucks",
          "subcategories": [
            {
              "id": "trucks-car-hauler-trucks-freightliner",
              "name": "FREIGHTLINER",
              "subcategories": []
            },
            {
              "id": "trucks-car-hauler-trucks-hino",
              "name": "HINO",
              "subcategories": []
            },
            {
              "id": "trucks-car-hauler-trucks-international",
              "name": "INTERNATIONAL",
              "subcategories": []
            },
            {
              "id": "trucks-car-hauler-trucks-kenworth",
              "name": "KENWORTH",
              "subcategories": []
            },
            {
              "id": "trucks-car-hauler-trucks-mack",
              "name": "MACK",
              "subcategories": []
            },
            {
              "id": "trucks-car-hauler-trucks-peterbilt",
              "name": "PETERBILT",
              "subcategories": []
            },
            {
              "id": "trucks-car-hauler-trucks-show-hauler",
              "name": "SHOW HAULER",
              "subcategories": []
            },
            {
              "id": "trucks-car-hauler-trucks-sterling",
              "name": "STERLING",
              "subcategories": []
            },
            {
              "id": "trucks-car-hauler-trucks-volvo",
              "name": "VOLVO",
              "subcategories": []
            },
            {
              "id": "trucks-car-hauler-trucks-western-star",
              "name": "WESTERN STAR",
              "subcategories": []
            },
            {
              "id": "trucks-car-hauler-trucks-other",
              "name": "OTHER",
              "subcategories": []
            }
          ]
        },
        {
          "id": "trucks-chipper-trucks",
          "name": "Chipper Trucks",
          "subcategories": [
            {
              "id": "trucks-chipper-trucks-chevrolet",
              "name": "CHEVROLET",
              "subcategories": []
            },
            {
              "id": "trucks-chipper-trucks-ford",
              "name": "FORD",
              "subcategories": []
            },
            {
              "id": "trucks-chipper-trucks-freightliner",
              "name": "FREIGHTLINER",
              "subcategories": []
            },
            {
              "id": "trucks-chipper-trucks-gmc",
              "name": "GMC",
              "subcategories": []
            },
            {
              "id": "trucks-chipper-trucks-hino",
              "name": "HINO",
              "subcategories": []
            },
            {
              "id": "trucks-chipper-trucks-international",
              "name": "INTERNATIONAL",
              "subcategories": []
            },
            {
              "id": "trucks-chipper-trucks-isuzu",
              "name": "ISUZU",
              "subcategories": []
            },
            {
              "id": "trucks-chipper-trucks-kenworth",
              "name": "KENWORTH",
              "subcategories": []
            },
            {
              "id": "trucks-chipper-trucks-mack",
              "name": "MACK",
              "subcategories": []
            },
            {
              "id": "trucks-chipper-trucks-peterbilt",
              "name": "PETERBILT",
              "subcategories": []
            },
            {
              "id": "trucks-chipper-trucks-ram",
              "name": "RAM",
              "subcategories": []
            },
            {
              "id": "trucks-chipper-trucks-scania",
              "name": "SCANIA",
              "subcategories": []
            },
            {
              "id": "trucks-chipper-trucks-sterling",
              "name": "STERLING",
              "subcategories": []
            },
            {
              "id": "trucks-chipper-trucks-other",
              "name": "OTHER",
              "subcategories": []
            }
          ]
        },
        {
          "id": "trucks-concrete-trucks",
          "name": "Concrete Trucks",
          "subcategories": []
        },
        {
          "id": "trucks-curtain-side-trucks",
          "name": "Curtain Side Trucks",
          "subcategories": [
            {
              "id": "trucks-curtain-side-trucks-ford",
              "name": "FORD",
              "subcategories": []
            },
            {
              "id": "trucks-curtain-side-trucks-freightlinerf",
              "name": "FREIGHTLINERF",
              "subcategories": []
            },
            {
              "id": "trucks-curtain-side-trucks-gmc",
              "name": "GMC",
              "subcategories": []
            },
            {
              "id": "trucks-curtain-side-trucks-hino",
              "name": "HINO",
              "subcategories": []
            },
            {
              "id": "trucks-curtain-side-trucks-international",
              "name": "INTERNATIONAL",
              "subcategories": []
            },
            {
              "id": "trucks-curtain-side-trucks-isuzu",
              "name": "ISUZU",
              "subcategories": []
            },
            {
              "id": "trucks-curtain-side-trucks-kenworth",
              "name": "KENWORTH",
              "subcategories": []
            },
            {
              "id": "trucks-curtain-side-trucks-mack",
              "name": "MACK",
              "subcategories": []
            },
            {
              "id": "trucks-curtain-side-trucks-peterbilt",
              "name": "PETERBILT",
              "subcategories": []
            },
            {
              "id": "trucks-curtain-side-trucks-volvo",
              "name": "VOLVO",
              "subcategories": []
            },
            {
              "id": "trucks-curtain-side-trucks-other",
              "name": "OTHER",
              "subcategories": []
            }
          ]
        },
        {
          "id": "trucks-day-cab-trucks",
          "name": "Day Cab Trucks",
          "subcategories": [
            {
              "id": "trucks-day-cab-trucks-freightliner",
              "name": "FREIGHTLINER",
              "subcategories": []
            },
            {
              "id": "trucks-day-cab-trucks-international",
              "name": "INTERNATIONAL",
              "subcategories": []
            },
            {
              "id": "trucks-day-cab-trucks-peterbilt",
              "name": "PETERBILT",
              "subcategories": []
            },
            {
              "id": "trucks-day-cab-trucks-kenworth",
              "name": "KENWORTH",
              "subcategories": []
            },
            {
              "id": "trucks-day-cab-trucks-mack",
              "name": "MACK",
              "subcategories": []
            },
            {
              "id": "trucks-day-cab-trucks-volvo",
              "name": "VOLVO",
              "subcategories": []
            },
            {
              "id": "trucks-day-cab-trucks-western-star",
              "name": "WESTERN STAR",
              "subcategories": []
            },
            {
              "id": "trucks-day-cab-trucks-sterling",
              "name": "STERLING",
              "subcategories": []
            },
            {
              "id": "trucks-day-cab-trucks-ford",
              "name": "FORD",
              "subcategories": []
            },
            {
              "id": "trucks-day-cab-trucks-unspecified",
              "name": "UNSPECIFIED",
              "subcategories": []
            },
            {
              "id": "trucks-day-cab-trucks-am-general",
              "name": "AM GENERAL",
              "subcategories": []
            },
            {
              "id": "trucks-day-cab-trucks-autocar",
              "name": "AUTOCAR",
              "subcategories": []
            },
            {
              "id": "trucks-day-cab-trucks-battle-motors",
              "name": "BATTLE MOTORS",
              "subcategories": []
            },
            {
              "id": "trucks-day-cab-trucks-bmy",
              "name": "BMY",
              "subcategories": []
            },
            {
              "id": "trucks-day-cab-trucks-caterpillar",
              "name": "CATERPILLAR",
              "subcategories": []
            },
            {
              "id": "trucks-day-cab-trucks-chevrolet",
              "name": "CHEVROLET",
              "subcategories": []
            },
            {
              "id": "trucks-day-cab-trucks-cline",
              "name": "CLINE",
              "subcategories": []
            },
            {
              "id": "trucks-day-cab-trucks-kaiser",
              "name": "KAISER",
              "subcategories": []
            },
            {
              "id": "trucks-day-cab-trucks-kizer",
              "name": "KIZER",
              "subcategories": []
            },
            {
              "id": "trucks-day-cab-trucks-man",
              "name": "MAN",
              "subcategories": []
            },
            {
              "id": "trucks-day-cab-trucks-nikola",
              "name": "NIKOLA",
              "subcategories": []
            },
            {
              "id": "trucks-day-cab-trucks-oshkosh",
              "name": "OSHKOSH",
              "subcategories": []
            },
            {
              "id": "trucks-day-cab-trucks-ram",
              "name": "RAM",
              "subcategories": []
            },
            {
              "id": "trucks-day-cab-trucks-sinotruk",
              "name": "SINOTRUK",
              "subcategories": []
            },
            {
              "id": "trucks-day-cab-trucks-white-gmc",
              "name": "WHITE / GMC",
              "subcategories": []
            },
            {
              "id": "trucks-day-cab-trucks-other",
              "name": "OTHER",
              "subcategories": []
            }
          ]
        },
        {
          "id": "trucks-digger-derricks",
          "name": "Digger Derricks",
          "subcategories": [
            {
              "id": "trucks-digger-derricks-altec",
              "name": "ALTEC",
              "subcategories": []
            },
            {
              "id": "trucks-digger-derricks-elliott",
              "name": "ELLIOTT",
              "subcategories": []
            },
            {
              "id": "trucks-digger-derricks-hiab",
              "name": "HIAB",
              "subcategories": []
            },
            {
              "id": "trucks-digger-derricks-imt",
              "name": "IMT",
              "subcategories": []
            },
            {
              "id": "trucks-digger-derricks-national",
              "name": "NATIONAL",
              "subcategories": []
            },
            {
              "id": "trucks-digger-derricks-pitman",
              "name": "PITMAN",
              "subcategories": []
            },
            {
              "id": "trucks-digger-derricks-sdp",
              "name": "SDP",
              "subcategories": []
            },
            {
              "id": "trucks-digger-derricks-simon-telelect",
              "name": "SIMON-TELELECT",
              "subcategories": []
            },
            {
              "id": "trucks-digger-derricks-skylift",
              "name": "SKYLIFT",
              "subcategories": []
            },
            {
              "id": "trucks-digger-derricks-telelect",
              "name": "TELELECT",
              "subcategories": []
            },
            {
              "id": "trucks-digger-derricks-terex",
              "name": "TEREX",
              "subcategories": []
            },
            {
              "id": "trucks-digger-derricks-utv-international",
              "name": "UTV INTERNATIONAL",
              "subcategories": []
            },
            {
              "id": "trucks-digger-derricks-versalift",
              "name": "VERSALIFT",
              "subcategories": []
            },
            {
              "id": "trucks-digger-derricks-other",
              "name": "OTHER",
              "subcategories": []
            }
          ]
        },
        {
          "id": "trucks-track",
          "name": "Track",
          "subcategories": []
        },
        {
          "id": "trucks-truck-mounted",
          "name": "Truck-Mounted",
          "subcategories": []
        },
        {
          "id": "trucks-dump-transfer-trucks",
          "name": "Dump - Transfer Trucks",
          "subcategories": [
            {
              "id": "trucks-dump-transfer-trucks-freightliner",
              "name": "FREIGHTLINER",
              "subcategories": []
            },
            {
              "id": "trucks-dump-transfer-trucks-international",
              "name": "INTERNATIONAL",
              "subcategories": []
            },
            {
              "id": "trucks-dump-transfer-trucks-kenworth",
              "name": "KENWORTH",
              "subcategories": []
            },
            {
              "id": "trucks-dump-transfer-trucks-mack",
              "name": "MACK",
              "subcategories": []
            },
            {
              "id": "trucks-dump-transfer-trucks-peterbilt",
              "name": "PETERBILT",
              "subcategories": []
            },
            {
              "id": "trucks-dump-transfer-trucks-reliance",
              "name": "RELIANCE",
              "subcategories": []
            },
            {
              "id": "trucks-dump-transfer-trucks-sinotruck",
              "name": "SINOTRUCK",
              "subcategories": []
            },
            {
              "id": "trucks-dump-transfer-trucks-volvo",
              "name": "VOLVO",
              "subcategories": []
            },
            {
              "id": "trucks-dump-transfer-trucks-western-star",
              "name": "WESTERN STAR",
              "subcategories": []
            },
            {
              "id": "trucks-dump-transfer-trucks-other",
              "name": "OTHER",
              "subcategories": []
            }
          ]
        },
        {
          "id": "trucks-dump-trucks",
          "name": "Dump Trucks",
          "subcategories": [
            {
              "id": "trucks-dump-trucks-kenworth",
              "name": "KENWORTH",
              "subcategories": []
            },
            {
              "id": "trucks-dump-trucks-peterbilt",
              "name": "PETERBILT",
              "subcategories": []
            },
            {
              "id": "trucks-dump-trucks-mack",
              "name": "MACK",
              "subcategories": []
            },
            {
              "id": "trucks-dump-trucks-ford",
              "name": "FORD",
              "subcategories": []
            },
            {
              "id": "trucks-dump-trucks-freightliner",
              "name": "FREIGHTLINER",
              "subcategories": []
            },
            {
              "id": "trucks-dump-trucks-western-star",
              "name": "WESTERN STAR",
              "subcategories": []
            },
            {
              "id": "trucks-dump-trucks-international",
              "name": "INTERNATIONAL",
              "subcategories": []
            },
            {
              "id": "trucks-dump-trucks-volvo",
              "name": "VOLVO",
              "subcategories": []
            },
            {
              "id": "trucks-dump-trucks-isuzu",
              "name": "ISUZU",
              "subcategories": []
            },
            {
              "id": "trucks-dump-trucks-chevrolet",
              "name": "CHEVROLET",
              "subcategories": []
            },
            {
              "id": "trucks-dump-trucks-am-general",
              "name": "AM GENERAL",
              "subcategories": []
            },
            {
              "id": "trucks-dump-trucks-american-lafrance",
              "name": "AMERICAN LAFRANCE",
              "subcategories": []
            },
            {
              "id": "trucks-dump-trucks-autocar",
              "name": "AUTOCAR",
              "subcategories": []
            },
            {
              "id": "trucks-dump-trucks-battle-motors",
              "name": "BATTLE MOTORS",
              "subcategories": []
            },
            {
              "id": "trucks-dump-trucks-bmy",
              "name": "BMY",
              "subcategories": []
            },
            {
              "id": "trucks-dump-trucks-caterpillar",
              "name": "CATERPILLAR",
              "subcategories": []
            },
            {
              "id": "trucks-dump-trucks-chevrolet",
              "name": "CHEVROLET",
              "subcategories": []
            },
            {
              "id": "trucks-dump-trucks-dodge",
              "name": "DODGE",
              "subcategories": []
            },
            {
              "id": "trucks-dump-trucks-foton",
              "name": "FOTON",
              "subcategories": []
            },
            {
              "id": "trucks-dump-trucks-gmc",
              "name": "GMC",
              "subcategories": []
            },
            {
              "id": "trucks-dump-trucks-hino",
              "name": "HINO",
              "subcategories": []
            },
            {
              "id": "trucks-dump-trucks-howo",
              "name": "HOWO",
              "subcategories": []
            },
            {
              "id": "trucks-dump-trucks-iveco",
              "name": "IVECO",
              "subcategories": []
            },
            {
              "id": "trucks-dump-trucks-kaiser",
              "name": "KAISER",
              "subcategories": []
            },
            {
              "id": "trucks-dump-trucks-man",
              "name": "MAN",
              "subcategories": []
            },
            {
              "id": "trucks-dump-trucks-marmon",
              "name": "MARMON",
              "subcategories": []
            },
            {
              "id": "trucks-dump-trucks-mercedes-benz",
              "name": "MERCEDES-BENZ",
              "subcategories": []
            },
            {
              "id": "trucks-dump-trucks-mitsubishi",
              "name": "MITSUBISHI",
              "subcategories": []
            },
            {
              "id": "trucks-dump-trucks-oshkosh",
              "name": "OSHKOSH",
              "subcategories": []
            },
            {
              "id": "trucks-dump-trucks-ram",
              "name": "RAM",
              "subcategories": []
            },
            {
              "id": "trucks-dump-trucks-rizon",
              "name": "RIZON",
              "subcategories": []
            },
            {
              "id": "trucks-dump-trucks-saic-iveco-hongyan",
              "name": "SAIC IVECO HONGYAN",
              "subcategories": []
            },
            {
              "id": "trucks-dump-trucks-scania",
              "name": "SCANIA",
              "subcategories": []
            },
            {
              "id": "trucks-dump-trucks-shacman",
              "name": "SHACMAN",
              "subcategories": []
            },
            {
              "id": "trucks-dump-trucks-sinotruk",
              "name": "SINOTRUK",
              "subcategories": []
            },
            {
              "id": "trucks-dump-trucks-sterling",
              "name": "STERLING",
              "subcategories": []
            },
            {
              "id": "trucks-dump-trucks-ud",
              "name": "UD",
              "subcategories": []
            },
            {
              "id": "trucks-dump-trucks-white",
              "name": "WHITE",
              "subcategories": []
            },
            {
              "id": "trucks-dump-trucks-white-gmc",
              "name": "WHITE/GMC",
              "subcategories": []
            },
            {
              "id": "trucks-dump-trucks-xcmg",
              "name": "XCMG",
              "subcategories": []
            },
            {
              "id": "trucks-dump-trucks-other",
              "name": "OTHER",
              "subcategories": []
            }
          ]
        },
        {
          "id": "trucks-expeditor-trucks",
          "name": "Expeditor Trucks",
          "subcategories": [
            {
              "id": "trucks-expeditor-trucks-freightliner",
              "name": "FREIGHTLINER",
              "subcategories": []
            },
            {
              "id": "trucks-expeditor-trucks-hino",
              "name": "HINO",
              "subcategories": []
            },
            {
              "id": "trucks-expeditor-trucks-kenworth",
              "name": "KENWORTH",
              "subcategories": []
            },
            {
              "id": "trucks-expeditor-trucks-peterbilt",
              "name": "PETERBILT",
              "subcategories": []
            },
            {
              "id": "trucks-expeditor-trucks-volvo",
              "name": "VOLVO",
              "subcategories": []
            },
            {
              "id": "trucks-expeditor-trucks-western-star",
              "name": "WESTERN STAR",
              "subcategories": []
            },
            {
              "id": "trucks-expeditor-trucks-other",
              "name": "OTHER",
              "subcategories": []
            }
          ]
        },
        {
          "id": "trucks-farm-trucks-grain-truck-s",
          "name": "Farm Trucks / Grain Truck S",
          "subcategories": []
        },
        {
          "id": "trucks-fire-trucks",
          "name": "Fire Trucks",
          "subcategories": [
            {
              "id": "trucks-fire-trucks-international",
              "name": "INTERNATIONAL",
              "subcategories": []
            },
            {
              "id": "trucks-fire-trucks-freightliner",
              "name": "FREIGHTLINER",
              "subcategories": []
            },
            {
              "id": "trucks-fire-trucks-ford",
              "name": "FORD",
              "subcategories": []
            },
            {
              "id": "trucks-fire-trucks-e-one",
              "name": "E-ONE",
              "subcategories": []
            },
            {
              "id": "trucks-fire-trucks-pierce",
              "name": "PIERCE",
              "subcategories": []
            },
            {
              "id": "trucks-fire-trucks-oshkosh",
              "name": "OSHKOSH",
              "subcategories": []
            },
            {
              "id": "trucks-fire-trucks-spartan",
              "name": "SPARTAN",
              "subcategories": []
            },
            {
              "id": "trucks-fire-trucks-american-lafrance",
              "name": "AMERICAN LAFRANCE",
              "subcategories": []
            },
            {
              "id": "trucks-fire-trucks-gmc",
              "name": "GMC",
              "subcategories": []
            },
            {
              "id": "trucks-fire-trucks-kme",
              "name": "KME",
              "subcategories": []
            },
            {
              "id": "trucks-fire-trucks-amertek",
              "name": "AMERTEK",
              "subcategories": []
            },
            {
              "id": "trucks-fire-trucks-chevrolet",
              "name": "CHEVROLET",
              "subcategories": []
            },
            {
              "id": "trucks-fire-trucks-crown",
              "name": "CROWN",
              "subcategories": []
            },
            {
              "id": "trucks-fire-trucks-dodge",
              "name": "DODGE",
              "subcategories": []
            },
            {
              "id": "trucks-fire-trucks-duplex",
              "name": "DUPLEX",
              "subcategories": []
            },
            {
              "id": "trucks-fire-trucks-ferrara",
              "name": "FERRARA",
              "subcategories": []
            },
            {
              "id": "trucks-fire-trucks-grumman",
              "name": "GRUMMAN",
              "subcategories": []
            },
            {
              "id": "trucks-fire-trucks-hme",
              "name": "HME",
              "subcategories": []
            },
            {
              "id": "trucks-fire-trucks-kme",
              "name": "KME",
              "subcategories": []
            },
            {
              "id": "trucks-fire-trucks-mack",
              "name": "MACK",
              "subcategories": []
            },
            {
              "id": "trucks-fire-trucks-mercedes-benz",
              "name": "MERCEDES-BENZ",
              "subcategories": []
            },
            {
              "id": "trucks-fire-trucks-peterbilt",
              "name": "PETERBILT",
              "subcategories": []
            },
            {
              "id": "trucks-fire-trucks-rosenbauer",
              "name": "ROSENBAUER",
              "subcategories": []
            },
            {
              "id": "trucks-fire-trucks-seagrave",
              "name": "SEAGRAVE",
              "subcategories": []
            },
            {
              "id": "trucks-fire-trucks-simon",
              "name": "SIMON",
              "subcategories": []
            },
            {
              "id": "trucks-fire-trucks-sutphen",
              "name": "SUTPHEN",
              "subcategories": []
            },
            {
              "id": "trucks-fire-trucks-toyota",
              "name": "TOYOTA",
              "subcategories": []
            },
            {
              "id": "trucks-fire-trucks-other",
              "name": "OTHER",
              "subcategories": []
            }
          ]
        },
        {
          "id": "trucks-flatbed-trucks",
          "name": "Flatbed Trucks",
          "subcategories": [
            {
              "id": "trucks-flatbed-trucks-freightliner",
              "name": "FREIGHTLINER",
              "subcategories": []
            },
            {
              "id": "trucks-flatbed-trucks-ford",
              "name": "FORD",
              "subcategories": []
            },
            {
              "id": "trucks-flatbed-trucks-international",
              "name": "INTERNATIONAL",
              "subcategories": []
            },
            {
              "id": "trucks-flatbed-trucks-chevrolet",
              "name": "CHEVROLET",
              "subcategories": []
            },
            {
              "id": "trucks-flatbed-trucks-ram",
              "name": "RAM",
              "subcategories": []
            },
            {
              "id": "trucks-flatbed-trucks-peterbilt",
              "name": "PETERBILT",
              "subcategories": []
            },
            {
              "id": "trucks-flatbed-trucks-isuzu",
              "name": "ISUZU",
              "subcategories": []
            },
            {
              "id": "trucks-flatbed-trucks-kenworth",
              "name": "KENWORTH",
              "subcategories": []
            },
            {
              "id": "trucks-flatbed-trucks-hino",
              "name": "HINO",
              "subcategories": []
            },
            {
              "id": "trucks-flatbed-trucks-streling",
              "name": "STRELING",
              "subcategories": []
            },
            {
              "id": "trucks-flatbed-trucks-am-general",
              "name": "AM GENERAL",
              "subcategories": []
            },
            {
              "id": "trucks-flatbed-trucks-autocar",
              "name": "AUTOCAR",
              "subcategories": []
            },
            {
              "id": "trucks-flatbed-trucks-bollinger",
              "name": "BOLLINGER",
              "subcategories": []
            },
            {
              "id": "trucks-flatbed-trucks-changan",
              "name": "CHANGAN",
              "subcategories": []
            },
            {
              "id": "trucks-flatbed-trucks-diamond-reo",
              "name": "DIAMOND REO",
              "subcategories": []
            },
            {
              "id": "trucks-flatbed-trucks-dodge",
              "name": "DODGE",
              "subcategories": []
            },
            {
              "id": "trucks-flatbed-trucks-fabco",
              "name": "FABCO",
              "subcategories": []
            },
            {
              "id": "trucks-flatbed-trucks-mack",
              "name": "MACK",
              "subcategories": []
            },
            {
              "id": "trucks-flatbed-trucks-mitsubishi",
              "name": "MITSUBISHI",
              "subcategories": []
            },
            {
              "id": "trucks-flatbed-trucks-mullen",
              "name": "MULLEN",
              "subcategories": []
            },
            {
              "id": "trucks-flatbed-trucks-nissan",
              "name": "NISSAN",
              "subcategories": []
            },
            {
              "id": "trucks-flatbed-trucks-stewart-stevenson",
              "name": "STEWART - STEVENSON",
              "subcategories": []
            },
            {
              "id": "trucks-flatbed-trucks-studabaker",
              "name": "STUDABAKER",
              "subcategories": []
            },
            {
              "id": "trucks-flatbed-trucks-ud",
              "name": "UD",
              "subcategories": []
            },
            {
              "id": "trucks-flatbed-trucks-volvo",
              "name": "VOLVO",
              "subcategories": []
            },
            {
              "id": "trucks-flatbed-trucks-western-star",
              "name": "WESTERN STAR",
              "subcategories": []
            },
            {
              "id": "trucks-flatbed-trucks-white",
              "name": "WHITE",
              "subcategories": []
            },
            {
              "id": "trucks-flatbed-trucks-white-gmc",
              "name": "WHITE/GMC",
              "subcategories": []
            },
            {
              "id": "trucks-flatbed-trucks-workhorse",
              "name": "WORKHORSE",
              "subcategories": []
            },
            {
              "id": "trucks-flatbed-trucks-other",
              "name": "OTHER",
              "subcategories": []
            }
          ]
        },
        {
          "id": "trucks-flatbed-dump-trucks",
          "name": "Flatbed-Dump Trucks",
          "subcategories": [
            {
              "id": "trucks-flatbed-dump-trucks-chevrolet",
              "name": "CHEVROLET",
              "subcategories": []
            },
            {
              "id": "trucks-flatbed-dump-trucks-ford",
              "name": "FORD",
              "subcategories": []
            },
            {
              "id": "trucks-flatbed-dump-trucks-freightliner",
              "name": "FREIGHTLINER",
              "subcategories": []
            },
            {
              "id": "trucks-flatbed-dump-trucks-gmc",
              "name": "GMC",
              "subcategories": []
            },
            {
              "id": "trucks-flatbed-dump-trucks-hino",
              "name": "HINO",
              "subcategories": []
            },
            {
              "id": "trucks-flatbed-dump-trucks-international",
              "name": "INTERNATIONAL",
              "subcategories": []
            },
            {
              "id": "trucks-flatbed-dump-trucks-isuzu",
              "name": "ISUZU",
              "subcategories": []
            },
            {
              "id": "trucks-flatbed-dump-trucks-kenworth",
              "name": "KENWORTH",
              "subcategories": []
            },
            {
              "id": "trucks-flatbed-dump-trucks-mack",
              "name": "MACK",
              "subcategories": []
            },
            {
              "id": "trucks-flatbed-dump-trucks-peterbilt",
              "name": "PETERBILT",
              "subcategories": []
            },
            {
              "id": "trucks-flatbed-dump-trucks-ram-sterling",
              "name": "RAM STERLING",
              "subcategories": []
            },
            {
              "id": "trucks-flatbed-dump-trucks-western-star",
              "name": "WESTERN STAR",
              "subcategories": []
            },
            {
              "id": "trucks-flatbed-dump-trucks-other",
              "name": "OTHER",
              "subcategories": []
            }
          ]
        },
        {
          "id": "trucks-forestry-bucket-trucks",
          "name": "Forestry Bucket Trucks",
          "subcategories": []
        },
        {
          "id": "trucks-fuel-lube-trucks",
          "name": "Fuel & Lube Trucks",
          "subcategories": [
            {
              "id": "trucks-fuel-lube-trucks-peterbilt",
              "name": "PETERBILT",
              "subcategories": []
            },
            {
              "id": "trucks-fuel-lube-trucks-kenworth",
              "name": "KENWORTH",
              "subcategories": []
            },
            {
              "id": "trucks-fuel-lube-trucks-international",
              "name": "INTERNATIONAL",
              "subcategories": []
            },
            {
              "id": "trucks-fuel-lube-trucks-freightliner",
              "name": "FREIGHTLINER",
              "subcategories": []
            },
            {
              "id": "trucks-fuel-lube-trucks-ford",
              "name": "FORD",
              "subcategories": []
            },
            {
              "id": "trucks-fuel-lube-trucks-mack",
              "name": "MACK",
              "subcategories": []
            },
            {
              "id": "trucks-fuel-lube-trucks-western-star",
              "name": "WESTERN STAR",
              "subcategories": []
            },
            {
              "id": "trucks-fuel-lube-trucks-chevrolet",
              "name": "CHEVROLET",
              "subcategories": []
            },
            {
              "id": "trucks-fuel-lube-trucks-sterling",
              "name": "STERLING",
              "subcategories": []
            },
            {
              "id": "trucks-fuel-lube-trucks-gmc",
              "name": "GMC",
              "subcategories": []
            },
            {
              "id": "trucks-fuel-lube-trucks-am-general",
              "name": "AM GENERAL",
              "subcategories": []
            },
            {
              "id": "trucks-fuel-lube-trucks-carco-industries",
              "name": "CARCO INDUSTRIES",
              "subcategories": []
            },
            {
              "id": "trucks-fuel-lube-trucks-eam",
              "name": "EAM",
              "subcategories": []
            },
            {
              "id": "trucks-fuel-lube-trucks-howo",
              "name": "HOWO",
              "subcategories": []
            },
            {
              "id": "trucks-fuel-lube-trucks-isuzu",
              "name": "ISUZU",
              "subcategories": []
            },
            {
              "id": "trucks-fuel-lube-trucks-oshkosh",
              "name": "OSHKOSH",
              "subcategories": []
            },
            {
              "id": "trucks-fuel-lube-trucks-ram",
              "name": "RAM",
              "subcategories": []
            },
            {
              "id": "trucks-fuel-lube-trucks-volkswagon",
              "name": "VOLKSWAGON",
              "subcategories": []
            },
            {
              "id": "trucks-fuel-lube-trucks-volvo",
              "name": "VOLVO",
              "subcategories": []
            },
            {
              "id": "trucks-fuel-lube-trucks-other",
              "name": "OTHER",
              "subcategories": []
            }
          ]
        },
        {
          "id": "trucks-garbage-trucks",
          "name": "Garbage Trucks",
          "subcategories": [
            {
              "id": "trucks-garbage-trucks-mack",
              "name": "MACK",
              "subcategories": []
            },
            {
              "id": "trucks-garbage-trucks-peterbilt",
              "name": "PETERBILT",
              "subcategories": []
            },
            {
              "id": "trucks-garbage-trucks-kenworth",
              "name": "KENWORTH",
              "subcategories": []
            },
            {
              "id": "trucks-garbage-trucks-freightliner",
              "name": "FREIGHTLINER",
              "subcategories": []
            },
            {
              "id": "trucks-garbage-trucks-international",
              "name": "INTERNATIONAL",
              "subcategories": []
            },
            {
              "id": "trucks-garbage-trucks-autocar",
              "name": "AUTOCAR",
              "subcategories": []
            },
            {
              "id": "trucks-garbage-trucks-western-star",
              "name": "WESTERN STAR",
              "subcategories": []
            },
            {
              "id": "trucks-garbage-trucks-volvo",
              "name": "VOLVO",
              "subcategories": []
            },
            {
              "id": "trucks-garbage-trucks-isuzu",
              "name": "ISUZU",
              "subcategories": []
            },
            {
              "id": "trucks-garbage-trucks-ccc",
              "name": "CCC",
              "subcategories": []
            },
            {
              "id": "trucks-garbage-trucks-american-lafrance",
              "name": "AMERICAN LAFRANCE",
              "subcategories": []
            },
            {
              "id": "trucks-garbage-trucks-battle-motors",
              "name": "BATTLE MOTORS",
              "subcategories": []
            },
            {
              "id": "trucks-garbage-trucks-catrepillar",
              "name": "CATREPILLAR",
              "subcategories": []
            },
            {
              "id": "trucks-garbage-trucks-dennis-eagle",
              "name": "DENNIS EAGLE",
              "subcategories": []
            },
            {
              "id": "trucks-garbage-trucks-ford",
              "name": "FORD",
              "subcategories": []
            },
            {
              "id": "trucks-garbage-trucks-gmc",
              "name": "GMC",
              "subcategories": []
            },
            {
              "id": "trucks-garbage-trucks-hino",
              "name": "HINO",
              "subcategories": []
            },
            {
              "id": "trucks-garbage-trucks-isuzu",
              "name": "ISUZU",
              "subcategories": []
            },
            {
              "id": "trucks-garbage-trucks-loda",
              "name": "LODA",
              "subcategories": []
            },
            {
              "id": "trucks-garbage-trucks-mitsubishi-fuso",
              "name": "MITSUBISHI FUSO",
              "subcategories": []
            },
            {
              "id": "trucks-garbage-trucks-oshkosh",
              "name": "OSHKOSH",
              "subcategories": []
            },
            {
              "id": "trucks-garbage-trucks-ram",
              "name": "RAM",
              "subcategories": []
            },
            {
              "id": "trucks-garbage-trucks-rizon",
              "name": "RIZON",
              "subcategories": []
            },
            {
              "id": "trucks-garbage-trucks-sterling",
              "name": "STERLING",
              "subcategories": []
            },
            {
              "id": "trucks-garbage-trucks-white",
              "name": "WHITE",
              "subcategories": []
            },
            {
              "id": "trucks-garbage-trucks-other",
              "name": "OTHER",
              "subcategories": []
            }
          ]
        },
        {
          "id": "trucks-grapple-trucks",
          "name": "Grapple Trucks",
          "subcategories": [
            {
              "id": "trucks-grapple-trucks-freightliner",
              "name": "FREIGHTLINER",
              "subcategories": []
            },
            {
              "id": "trucks-grapple-trucks-international",
              "name": "INTERNATIONAL",
              "subcategories": []
            },
            {
              "id": "trucks-grapple-trucks-mack",
              "name": "MACK",
              "subcategories": []
            },
            {
              "id": "trucks-grapple-trucks-kenworth",
              "name": "KENWORTH",
              "subcategories": []
            },
            {
              "id": "trucks-grapple-trucks-peterbilt",
              "name": "PETERBILT",
              "subcategories": []
            },
            {
              "id": "trucks-grapple-trucks-western-star",
              "name": "WESTERN STAR",
              "subcategories": []
            },
            {
              "id": "trucks-grapple-trucks-sterling",
              "name": "STERLING",
              "subcategories": []
            },
            {
              "id": "trucks-grapple-trucks-ford",
              "name": "FORD",
              "subcategories": []
            },
            {
              "id": "trucks-grapple-trucks-hino",
              "name": "HINO",
              "subcategories": []
            },
            {
              "id": "trucks-grapple-trucks-volvo",
              "name": "VOLVO",
              "subcategories": []
            },
            {
              "id": "trucks-grapple-trucks-battle-motors",
              "name": "BATTLE MOTORS",
              "subcategories": []
            },
            {
              "id": "trucks-grapple-trucks-caterpillar",
              "name": "CATERPILLAR",
              "subcategories": []
            },
            {
              "id": "trucks-grapple-trucks-chevrolet",
              "name": "CHEVROLET",
              "subcategories": []
            },
            {
              "id": "trucks-grapple-trucks-gmc",
              "name": "GMC",
              "subcategories": []
            },
            {
              "id": "trucks-grapple-trucks-other",
              "name": "OTHER",
              "subcategories": []
            }
          ]
        },
        {
          "id": "trucks-hooklift-trucks",
          "name": "Hooklift Trucks",
          "subcategories": [
            {
              "id": "trucks-hooklift-trucks-kenworth",
              "name": "KENWORTH",
              "subcategories": []
            },
            {
              "id": "trucks-hooklift-trucks-freightliner",
              "name": "FREIGHTLINER",
              "subcategories": []
            },
            {
              "id": "trucks-hooklift-trucks-international",
              "name": "INTERNATIONAL",
              "subcategories": []
            },
            {
              "id": "trucks-hooklift-trucks-peterbilt",
              "name": "PETERBILT",
              "subcategories": []
            },
            {
              "id": "trucks-hooklift-trucks-ford",
              "name": "FORD",
              "subcategories": []
            },
            {
              "id": "trucks-hooklift-trucks-mack",
              "name": "MACK",
              "subcategories": []
            },
            {
              "id": "trucks-hooklift-trucks-isuzu",
              "name": "ISUZU",
              "subcategories": []
            },
            {
              "id": "trucks-hooklift-trucks-hino",
              "name": "HINO",
              "subcategories": []
            },
            {
              "id": "trucks-hooklift-trucks-chevrolet",
              "name": "CHEVROLET",
              "subcategories": []
            },
            {
              "id": "trucks-hooklift-trucks-ram",
              "name": "RAM",
              "subcategories": []
            },
            {
              "id": "trucks-hooklift-trucks-autocar",
              "name": "AUTOCAR",
              "subcategories": []
            },
            {
              "id": "trucks-hooklift-trucks-scania",
              "name": "SCANIA",
              "subcategories": []
            },
            {
              "id": "trucks-hooklift-trucks-sterling",
              "name": "STERLING",
              "subcategories": []
            },
            {
              "id": "trucks-hooklift-trucks-western-star",
              "name": "WESTERN STAR",
              "subcategories": []
            },
            {
              "id": "trucks-hooklift-trucks-other",
              "name": "OTHER",
              "subcategories": []
            }
          ]
        },
        {
          "id": "trucks-hot-shot-trucks",
          "name": "Hot Shot Trucks",
          "subcategories": [
            {
              "id": "trucks-hot-shot-trucks-chevrolet",
              "name": "CHEVROLET",
              "subcategories": []
            },
            {
              "id": "trucks-hot-shot-trucks-ford",
              "name": "FORD",
              "subcategories": []
            },
            {
              "id": "trucks-hot-shot-trucks-freightliner",
              "name": "FREIGHTLINER",
              "subcategories": []
            },
            {
              "id": "trucks-hot-shot-trucks-gmc",
              "name": "GMC",
              "subcategories": []
            },
            {
              "id": "trucks-hot-shot-trucks-international",
              "name": "INTERNATIONAL",
              "subcategories": []
            },
            {
              "id": "trucks-hot-shot-trucks-peterbilt",
              "name": "PETERBILT",
              "subcategories": []
            },
            {
              "id": "trucks-hot-shot-trucks-ram",
              "name": "RAM",
              "subcategories": []
            },
            {
              "id": "trucks-hot-shot-trucks-other",
              "name": "OTHER",
              "subcategories": []
            }
          ]
        },
        {
          "id": "trucks-knuckle-boom-crane-truck-s",
          "name": "Knuckle Boom Crane Truck S",
          "subcategories": []
        },
        {
          "id": "trucks-landscape-trucks",
          "name": "Landscape Trucks",
          "subcategories": [
            {
              "id": "trucks-landscape-trucks-bollinger",
              "name": "BOLLINGER",
              "subcategories": []
            },
            {
              "id": "trucks-landscape-trucks-chevrolet",
              "name": "CHEVROLET",
              "subcategories": []
            },
            {
              "id": "trucks-landscape-trucks-ford",
              "name": "FORD",
              "subcategories": []
            },
            {
              "id": "trucks-landscape-trucks-freightliner",
              "name": "FREIGHTLINER",
              "subcategories": []
            },
            {
              "id": "trucks-landscape-trucks-gmc",
              "name": "GMC",
              "subcategories": []
            },
            {
              "id": "trucks-landscape-trucks-hino",
              "name": "HINO",
              "subcategories": []
            },
            {
              "id": "trucks-landscape-trucks-international",
              "name": "INTERNATIONAL",
              "subcategories": []
            },
            {
              "id": "trucks-landscape-trucks-isuzu",
              "name": "ISUZU",
              "subcategories": []
            },
            {
              "id": "trucks-landscape-trucks-mitsubishi-fuso",
              "name": "MITSUBISHI FUSO",
              "subcategories": []
            },
            {
              "id": "trucks-landscape-trucks-peterbilt",
              "name": "PETERBILT",
              "subcategories": []
            },
            {
              "id": "trucks-landscape-trucks-ram",
              "name": "RAM",
              "subcategories": []
            },
            {
              "id": "trucks-landscape-trucks-rizon",
              "name": "RIZON",
              "subcategories": []
            },
            {
              "id": "trucks-landscape-trucks-ud",
              "name": "UD",
              "subcategories": []
            },
            {
              "id": "trucks-landscape-trucks-other",
              "name": "OTHER",
              "subcategories": []
            }
          ]
        },
        {
          "id": "trucks-logging-trucks",
          "name": "Logging Trucks",
          "subcategories": [
            {
              "id": "trucks-logging-trucks-ford",
              "name": "FORD",
              "subcategories": []
            },
            {
              "id": "trucks-logging-trucks-freightliner",
              "name": "FREIGHTLINER",
              "subcategories": []
            },
            {
              "id": "trucks-logging-trucks-gmc",
              "name": "GMC",
              "subcategories": []
            },
            {
              "id": "trucks-logging-trucks-international",
              "name": "INTERNATIONAL",
              "subcategories": []
            },
            {
              "id": "trucks-logging-trucks-kenworth",
              "name": "KENWORTH",
              "subcategories": []
            },
            {
              "id": "trucks-logging-trucks-mack",
              "name": "MACK",
              "subcategories": []
            },
            {
              "id": "trucks-logging-trucks-peterbilt",
              "name": "PETERBILT",
              "subcategories": []
            },
            {
              "id": "trucks-logging-trucks-sterling",
              "name": "STERLING",
              "subcategories": []
            },
            {
              "id": "trucks-logging-trucks-volvo",
              "name": "VOLVO",
              "subcategories": []
            },
            {
              "id": "trucks-logging-trucks-western-star",
              "name": "WESTERN STAR",
              "subcategories": []
            },
            {
              "id": "trucks-logging-trucks-white-gmc",
              "name": "WHITE/GMC",
              "subcategories": []
            },
            {
              "id": "trucks-logging-trucks-other",
              "name": "OTHER",
              "subcategories": []
            }
          ]
        },
        {
          "id": "trucks-miscellaneous-trucks",
          "name": "Miscellaneous Trucks",
          "subcategories": []
        },
        {
          "id": "trucks-mixer-trucks",
          "name": "Mixer Trucks",
          "subcategories": []
        },
        {
          "id": "trucks-passenger-bus",
          "name": "Passenger Bus",
          "subcategories": [
            {
              "id": "trucks-passenger-bus-ic-bus",
              "name": "IC BUS",
              "subcategories": []
            },
            {
              "id": "trucks-passenger-bus-bluebird",
              "name": "BLUEBIRD",
              "subcategories": []
            },
            {
              "id": "trucks-passenger-bus-international",
              "name": "INTERNATIONAL",
              "subcategories": []
            },
            {
              "id": "trucks-passenger-bus-unspecified",
              "name": "UNSPECIFIED",
              "subcategories": []
            },
            {
              "id": "trucks-passenger-bus-freightliner",
              "name": "FREIGHTLINER",
              "subcategories": []
            },
            {
              "id": "trucks-passenger-bus-thomas-built-buses",
              "name": "THOMAS BUILT BUSES",
              "subcategories": []
            },
            {
              "id": "trucks-passenger-bus-mci",
              "name": "MCI",
              "subcategories": []
            },
            {
              "id": "trucks-passenger-bus-grande-west",
              "name": "GRANDE WEST",
              "subcategories": []
            },
            {
              "id": "trucks-passenger-bus-prevost",
              "name": "PREVOST",
              "subcategories": []
            },
            {
              "id": "trucks-passenger-bus-spartan",
              "name": "SPARTAN",
              "subcategories": []
            },
            {
              "id": "trucks-passenger-bus-caio",
              "name": "CAIO",
              "subcategories": []
            },
            {
              "id": "trucks-passenger-bus-eagle",
              "name": "EAGLE",
              "subcategories": []
            },
            {
              "id": "trucks-passenger-bus-gillig",
              "name": "GILLIG",
              "subcategories": []
            },
            {
              "id": "trucks-passenger-bus-lion",
              "name": "LION",
              "subcategories": []
            },
            {
              "id": "trucks-passenger-bus-temsa",
              "name": "TEMSA",
              "subcategories": []
            },
            {
              "id": "trucks-passenger-bus-volvo",
              "name": "VOLVO",
              "subcategories": []
            },
            {
              "id": "trucks-passenger-bus-other",
              "name": "OTHER",
              "subcategories": []
            }
          ]
        },
        {
          "id": "trucks-pickup-trucks",
          "name": "Pickup Trucks",
          "subcategories": [
            {
              "id": "trucks-pickup-trucks-ford",
              "name": "FORD",
              "subcategories": []
            },
            {
              "id": "trucks-pickup-trucks-chevrolet",
              "name": "CHEVROLET",
              "subcategories": []
            },
            {
              "id": "trucks-pickup-trucks-ram",
              "name": "RAM",
              "subcategories": []
            },
            {
              "id": "trucks-pickup-trucks-gmc",
              "name": "GMC",
              "subcategories": []
            },
            {
              "id": "trucks-pickup-trucks-dodge",
              "name": "DODGE",
              "subcategories": []
            },
            {
              "id": "trucks-pickup-trucks-unspecified",
              "name": "UNSPECIFIED",
              "subcategories": []
            },
            {
              "id": "trucks-pickup-trucks-toyota",
              "name": "TOYOTA",
              "subcategories": []
            },
            {
              "id": "trucks-pickup-trucks-nissan",
              "name": "NISSAN",
              "subcategories": []
            },
            {
              "id": "trucks-pickup-trucks-jeep",
              "name": "JEEP",
              "subcategories": []
            },
            {
              "id": "trucks-pickup-trucks-international",
              "name": "INTERNATIONAL",
              "subcategories": []
            },
            {
              "id": "trucks-pickup-trucks-honda",
              "name": "HONDA",
              "subcategories": []
            },
            {
              "id": "trucks-pickup-trucks-isuzu",
              "name": "ISUZU",
              "subcategories": []
            },
            {
              "id": "trucks-pickup-trucks-sterling",
              "name": "STERLING",
              "subcategories": []
            },
            {
              "id": "trucks-pickup-trucks-tesla",
              "name": "TESLA",
              "subcategories": []
            },
            {
              "id": "trucks-pickup-trucks-other",
              "name": "OTHER",
              "subcategories": []
            }
          ]
        },
        {
          "id": "trucks-1-ton",
          "name": "1 Ton",
          "subcategories": []
        },
        {
          "id": "trucks-3-4-ton",
          "name": "3/4 Ton",
          "subcategories": []
        },
        {
          "id": "trucks-1-2-ton",
          "name": "1/2 Ton",
          "subcategories": []
        },
        {
          "id": "trucks-other",
          "name": "Other",
          "subcategories": []
        },
        {
          "id": "trucks-plow-spreader-trucks",
          "name": "Plow / Spreader Trucks",
          "subcategories": []
        },
        {
          "id": "trucks-recycling-trucks",
          "name": "Recycling Trucks",
          "subcategories": []
        },
        {
          "id": "trucks-rv-hauler-toter-trucks",
          "name": "Rv Hauler / Toter Trucks",
          "subcategories": []
        },
        {
          "id": "trucks-service-trucks-utility-mechanic",
          "name": "Service Trucks / Utility / Mechanic",
          "subcategories": []
        },
        {
          "id": "trucks-shuttle-bus",
          "name": "Shuttle Bus",
          "subcategories": [
            {
              "id": "trucks-shuttle-bus-chevrolet",
              "name": "CHEVROLET",
              "subcategories": []
            },
            {
              "id": "trucks-shuttle-bus-ford",
              "name": "FORD",
              "subcategories": []
            },
            {
              "id": "trucks-shuttle-bus-freightliner",
              "name": "FREIGHTLINER",
              "subcategories": []
            },
            {
              "id": "trucks-shuttle-bus-glaval",
              "name": "GLAVAL",
              "subcategories": []
            },
            {
              "id": "trucks-shuttle-bus-gmc",
              "name": "GMC",
              "subcategories": []
            },
            {
              "id": "trucks-shuttle-bus-green-power",
              "name": "GREEN POWER",
              "subcategories": []
            },
            {
              "id": "trucks-shuttle-bus-ic-bus",
              "name": "IC BUS",
              "subcategories": []
            },
            {
              "id": "trucks-shuttle-bus-international",
              "name": "INTERNATIONAL",
              "subcategories": []
            },
            {
              "id": "trucks-shuttle-bus-micro-bird",
              "name": "MICRO BIRD",
              "subcategories": []
            },
            {
              "id": "trucks-shuttle-bus-startrans-bus",
              "name": "STARTRANS BUS",
              "subcategories": []
            },
            {
              "id": "trucks-shuttle-bus-other",
              "name": "OTHER",
              "subcategories": []
            }
          ]
        },
        {
          "id": "trucks-sleeper-trucks",
          "name": "Sleeper Trucks",
          "subcategories": [
            {
              "id": "trucks-sleeper-trucks-freightliner",
              "name": "FREIGHTLINER",
              "subcategories": []
            },
            {
              "id": "trucks-sleeper-trucks-peterbilt",
              "name": "PETERBILT",
              "subcategories": []
            },
            {
              "id": "trucks-sleeper-trucks-kenworth",
              "name": "KENWORTH",
              "subcategories": []
            },
            {
              "id": "trucks-sleeper-trucks-volvo",
              "name": "VOLVO",
              "subcategories": []
            },
            {
              "id": "trucks-sleeper-trucks-international",
              "name": "INTERNATIONAL",
              "subcategories": []
            },
            {
              "id": "trucks-sleeper-trucks-mack",
              "name": "MACK",
              "subcategories": []
            },
            {
              "id": "trucks-sleeper-trucks-western-star",
              "name": "WESTERN STAR",
              "subcategories": []
            },
            {
              "id": "trucks-sleeper-trucks-unspecified",
              "name": "UNSPECIFIED",
              "subcategories": []
            },
            {
              "id": "trucks-sleeper-trucks-white-gmc",
              "name": "WHITE/GMC",
              "subcategories": []
            },
            {
              "id": "trucks-sleeper-trucks-daf",
              "name": "DAF",
              "subcategories": []
            },
            {
              "id": "trucks-sleeper-trucks-autocar",
              "name": "AUTOCAR",
              "subcategories": []
            },
            {
              "id": "trucks-sleeper-trucks-chevrolet",
              "name": "CHEVROLET",
              "subcategories": []
            },
            {
              "id": "trucks-sleeper-trucks-ford",
              "name": "FORD",
              "subcategories": []
            },
            {
              "id": "trucks-sleeper-trucks-gmc",
              "name": "GMC",
              "subcategories": []
            },
            {
              "id": "trucks-sleeper-trucks-hino",
              "name": "HINO",
              "subcategories": []
            },
            {
              "id": "trucks-sleeper-trucks-iveco",
              "name": "IVECO",
              "subcategories": []
            },
            {
              "id": "trucks-sleeper-trucks-mercedes-benz",
              "name": "MERCEDES-BENZ",
              "subcategories": []
            },
            {
              "id": "trucks-sleeper-trucks-nikola",
              "name": "NIKOLA",
              "subcategories": []
            },
            {
              "id": "trucks-sleeper-trucks-renault",
              "name": "RENAULT",
              "subcategories": []
            },
            {
              "id": "trucks-sleeper-trucks-scania",
              "name": "SCANIA",
              "subcategories": []
            },
            {
              "id": "trucks-sleeper-trucks-shacman",
              "name": "SHACMAN",
              "subcategories": []
            },
            {
              "id": "trucks-sleeper-trucks-sinotruk",
              "name": "SINOTRUK",
              "subcategories": []
            },
            {
              "id": "trucks-sleeper-trucks-sterling",
              "name": "STERLING",
              "subcategories": []
            },
            {
              "id": "trucks-sleeper-trucks-white-gmc",
              "name": "WHITE/GMC",
              "subcategories": []
            },
            {
              "id": "trucks-sleeper-trucks-xcmg",
              "name": "XCMG",
              "subcategories": []
            },
            {
              "id": "trucks-sleeper-trucks-other",
              "name": "OTHER",
              "subcategories": []
            }
          ]
        },
        {
          "id": "trucks-stake-trucks",
          "name": "Stake Trucks",
          "subcategories": []
        },
        {
          "id": "trucks-stone-slinger-trucks",
          "name": "Stone Slinger Trucks",
          "subcategories": [
            {
              "id": "trucks-stone-slinger-trucks-freightliner",
              "name": "FREIGHTLINER",
              "subcategories": []
            },
            {
              "id": "trucks-stone-slinger-trucks-international",
              "name": "INTERNATIONAL",
              "subcategories": []
            },
            {
              "id": "trucks-stone-slinger-trucks-kenworth",
              "name": "KENWORTH",
              "subcategories": []
            },
            {
              "id": "trucks-stone-slinger-trucks-mack",
              "name": "MACK",
              "subcategories": []
            },
            {
              "id": "trucks-stone-slinger-trucks-peterbilt",
              "name": "PETERBILT",
              "subcategories": []
            },
            {
              "id": "trucks-stone-slinger-trucks-sterling",
              "name": "STERLING",
              "subcategories": []
            },
            {
              "id": "trucks-stone-slinger-trucks-volvo",
              "name": "VOLVO",
              "subcategories": []
            },
            {
              "id": "trucks-stone-slinger-trucks-western-star",
              "name": "WESTERN STAR",
              "subcategories": []
            },
            {
              "id": "trucks-stone-slinger-trucks-other",
              "name": "OTHER",
              "subcategories": []
            }
          ]
        },
        {
          "id": "trucks-tank-trucks",
          "name": "Tank Trucks",
          "subcategories": [
            {
              "id": "trucks-tank-trucks-freightliner",
              "name": "FREIGHTLINER",
              "subcategories": []
            },
            {
              "id": "trucks-tank-trucks-international",
              "name": "INTERNATIONAL",
              "subcategories": []
            },
            {
              "id": "trucks-tank-trucks-peterbilt",
              "name": "PETERBILT",
              "subcategories": []
            },
            {
              "id": "trucks-tank-trucks-kenworth",
              "name": "KENWORTH",
              "subcategories": []
            },
            {
              "id": "trucks-tank-trucks-ford",
              "name": "FORD",
              "subcategories": []
            },
            {
              "id": "trucks-tank-trucks-mack",
              "name": "MACK",
              "subcategories": []
            },
            {
              "id": "trucks-tank-trucks-western-star",
              "name": "WESTERN STAR",
              "subcategories": []
            },
            {
              "id": "trucks-tank-trucks-sterling",
              "name": "STERLING",
              "subcategories": []
            },
            {
              "id": "trucks-tank-trucks-hino",
              "name": "HINO",
              "subcategories": []
            },
            {
              "id": "trucks-tank-trucks-volvo",
              "name": "VOLVO",
              "subcategories": []
            },
            {
              "id": "trucks-tank-trucks-am-general",
              "name": "AM GENERAL",
              "subcategories": []
            },
            {
              "id": "trucks-tank-trucks-american-lafrance",
              "name": "AMERICAN LAFRANCE",
              "subcategories": []
            },
            {
              "id": "trucks-tank-trucks-autocar",
              "name": "AUTOCAR",
              "subcategories": []
            },
            {
              "id": "trucks-tank-trucks-bmy",
              "name": "BMY",
              "subcategories": []
            },
            {
              "id": "trucks-tank-trucks-caterpillar",
              "name": "CATERPILLAR",
              "subcategories": []
            },
            {
              "id": "trucks-tank-trucks-chevrolet",
              "name": "CHEVROLET",
              "subcategories": []
            },
            {
              "id": "trucks-tank-trucks-gmc",
              "name": "GMC",
              "subcategories": []
            },
            {
              "id": "trucks-tank-trucks-isuzu",
              "name": "ISUZU",
              "subcategories": []
            },
            {
              "id": "trucks-tank-trucks-man",
              "name": "MAN",
              "subcategories": []
            },
            {
              "id": "trucks-tank-trucks-oshkosh",
              "name": "OSHKOSH",
              "subcategories": []
            },
            {
              "id": "trucks-tank-trucks-ram",
              "name": "RAM",
              "subcategories": []
            },
            {
              "id": "trucks-tank-trucks-sinotruk",
              "name": "SINOTRUK",
              "subcategories": []
            },
            {
              "id": "trucks-tank-trucks-white-gmc",
              "name": "WHITE/GMC",
              "subcategories": []
            },
            {
              "id": "trucks-tank-trucks-other",
              "name": "OTHER",
              "subcategories": []
            }
          ]
        },
        {
          "id": "trucks-asphalt-distributor-hot-oil",
          "name": "Asphalt Distributor / Hot Oil",
          "subcategories": []
        },
        {
          "id": "trucks-chemical-acid",
          "name": "Chemical / Acid",
          "subcategories": []
        },
        {
          "id": "trucks-gasoline-fuel",
          "name": "Gasoline / Fuel",
          "subcategories": []
        },
        {
          "id": "trucks-milk",
          "name": "Milk",
          "subcategories": []
        },
        {
          "id": "trucks-propane",
          "name": "Propane",
          "subcategories": []
        },
        {
          "id": "trucks-septic",
          "name": "Septic",
          "subcategories": []
        },
        {
          "id": "trucks-sewer-cleaning",
          "name": "Sewer Cleaning",
          "subcategories": []
        },
        {
          "id": "trucks-vacuum-industrial",
          "name": "Vacuum / Industrial",
          "subcategories": []
        },
        {
          "id": "trucks-water",
          "name": "Water",
          "subcategories": []
        },
        {
          "id": "trucks-tow-trucks",
          "name": "Tow Trucks",
          "subcategories": [
            {
              "id": "trucks-tow-trucks-international",
              "name": "INTERNATIONAL",
              "subcategories": []
            },
            {
              "id": "trucks-tow-trucks-ram",
              "name": "RAM",
              "subcategories": []
            },
            {
              "id": "trucks-tow-trucks-peterbilt",
              "name": "PETERBILT",
              "subcategories": []
            },
            {
              "id": "trucks-tow-trucks-freightliner",
              "name": "FREIGHTLINER",
              "subcategories": []
            },
            {
              "id": "trucks-tow-trucks-ford",
              "name": "FORD",
              "subcategories": []
            },
            {
              "id": "trucks-tow-trucks-kenworth",
              "name": "KENWORTH",
              "subcategories": []
            },
            {
              "id": "trucks-tow-trucks-hino",
              "name": "HINO",
              "subcategories": []
            },
            {
              "id": "trucks-tow-trucks-mack",
              "name": "MACK",
              "subcategories": []
            },
            {
              "id": "trucks-tow-trucks-chevrolet",
              "name": "CHEVROLET",
              "subcategories": []
            },
            {
              "id": "trucks-tow-trucks-isuzu",
              "name": "ISUZU",
              "subcategories": []
            },
            {
              "id": "trucks-tow-trucks-am-general",
              "name": "AM GENERAL",
              "subcategories": []
            },
            {
              "id": "trucks-tow-trucks-autocar",
              "name": "AUTOCAR",
              "subcategories": []
            },
            {
              "id": "trucks-tow-trucks-bmy",
              "name": "BMY",
              "subcategories": []
            },
            {
              "id": "trucks-tow-trucks-caterpillar",
              "name": "CATERPILLAR",
              "subcategories": []
            },
            {
              "id": "trucks-tow-trucks-dodge",
              "name": "DODGE",
              "subcategories": []
            },
            {
              "id": "trucks-tow-trucks-gmc",
              "name": "GMC",
              "subcategories": []
            },
            {
              "id": "trucks-tow-trucks-hendrickson",
              "name": "HENDRICKSON",
              "subcategories": []
            },
            {
              "id": "trucks-tow-trucks-isuzu",
              "name": "ISUZU",
              "subcategories": []
            },
            {
              "id": "trucks-tow-trucks-sterling",
              "name": "STERLING",
              "subcategories": []
            },
            {
              "id": "trucks-tow-trucks-ud",
              "name": "UD",
              "subcategories": []
            },
            {
              "id": "trucks-tow-trucks-unspecified",
              "name": "UNSPECIFIED",
              "subcategories": []
            },
            {
              "id": "trucks-tow-trucks-volvo",
              "name": "VOLVO",
              "subcategories": []
            },
            {
              "id": "trucks-tow-trucks-western-star",
              "name": "WESTERN STAR",
              "subcategories": []
            },
            {
              "id": "trucks-tow-trucks-white-gmc",
              "name": "WHITE/GMC",
              "subcategories": []
            },
            {
              "id": "trucks-tow-trucks-other",
              "name": "OTHER",
              "subcategories": []
            }
          ]
        },
        {
          "id": "trucks-rollback",
          "name": "Rollback",
          "subcategories": []
        },
        {
          "id": "trucks-wrecker",
          "name": "Wrecker",
          "subcategories": []
        },
        {
          "id": "trucks-truck-bodies",
          "name": "Truck Bodies",
          "subcategories": [
            {
              "id": "trucks-truck-bodies-morgan",
              "name": "MORGAN",
              "subcategories": []
            },
            {
              "id": "trucks-truck-bodies-norstar",
              "name": "NORSTAR",
              "subcategories": []
            },
            {
              "id": "trucks-truck-bodies-bedrock",
              "name": "BEDROCK",
              "subcategories": []
            },
            {
              "id": "trucks-truck-bodies-eby",
              "name": "EBY",
              "subcategories": []
            },
            {
              "id": "trucks-truck-bodies-swaploader",
              "name": "SWAPLOADER",
              "subcategories": []
            },
            {
              "id": "trucks-truck-bodies-cm",
              "name": "CM",
              "subcategories": []
            },
            {
              "id": "trucks-truck-bodies-hillsboro",
              "name": "HILLSBORO",
              "subcategories": []
            },
            {
              "id": "trucks-truck-bodies-super-products",
              "name": "SUPER PRODUCTS",
              "subcategories": []
            },
            {
              "id": "trucks-truck-bodies-crysteel",
              "name": "CRYSTEEL",
              "subcategories": []
            },
            {
              "id": "trucks-truck-bodies-rugby",
              "name": "RUGBY",
              "subcategories": []
            },
            {
              "id": "trucks-truck-bodies-a-m-haire",
              "name": "A.M. HAIRE",
              "subcategories": []
            },
            {
              "id": "trucks-truck-bodies-advance-fab",
              "name": "ADVANCE FAB",
              "subcategories": []
            },
            {
              "id": "trucks-truck-bodies-agassiz",
              "name": "AGASSIZ",
              "subcategories": []
            },
            {
              "id": "trucks-truck-bodies-alfab",
              "name": "ALFAB",
              "subcategories": []
            },
            {
              "id": "trucks-truck-bodies-alfred",
              "name": "ALFRED",
              "subcategories": []
            },
            {
              "id": "trucks-truck-bodies-almac",
              "name": "ALMAC",
              "subcategories": []
            },
            {
              "id": "trucks-truck-bodies-aluma",
              "name": "ALUMA",
              "subcategories": []
            },
            {
              "id": "trucks-truck-bodies-alum-line",
              "name": "ALUM-LINE",
              "subcategories": []
            },
            {
              "id": "trucks-truck-bodies-alvan",
              "name": "ALVAN",
              "subcategories": []
            },
            {
              "id": "trucks-truck-bodies-american-body-works",
              "name": "AMERICAN BODY WORKS",
              "subcategories": []
            },
            {
              "id": "trucks-truck-bodies-american-eagle",
              "name": "AMERICAN EAGLE",
              "subcategories": []
            },
            {
              "id": "trucks-truck-bodies-american-roll-off",
              "name": "AMERICAN ROLL-OFF",
              "subcategories": []
            },
            {
              "id": "trucks-truck-bodies-american-truck-and-trailer",
              "name": "AMERICAN TRUCK AND TRAILER",
              "subcategories": []
            },
            {
              "id": "trucks-truck-bodies-amh",
              "name": "AMH",
              "subcategories": []
            },
            {
              "id": "trucks-truck-bodies-am-tanks",
              "name": "AM-TANKS",
              "subcategories": []
            },
            {
              "id": "trucks-truck-bodies-arbortechs",
              "name": "ARBORTECHS",
              "subcategories": []
            },
            {
              "id": "trucks-truck-bodies-are",
              "name": "ARE",
              "subcategories": []
            },
            {
              "id": "trucks-truck-bodies-arnes",
              "name": "ARNES",
              "subcategories": []
            },
            {
              "id": "trucks-truck-bodies-aulick-ind",
              "name": "AULICK IND",
              "subcategories": []
            },
            {
              "id": "trucks-truck-bodies-auto-crane",
              "name": "AUTO CRANE",
              "subcategories": []
            },
            {
              "id": "trucks-truck-bodies-beall",
              "name": "BEALL",
              "subcategories": []
            },
            {
              "id": "trucks-truck-bodies-beau-roc",
              "name": "BEAU-ROC",
              "subcategories": []
            },
            {
              "id": "trucks-truck-bodies-bedrock",
              "name": "BEDROCK",
              "subcategories": []
            },
            {
              "id": "trucks-truck-bodies-benlee",
              "name": "BENLEE",
              "subcategories": []
            },
            {
              "id": "trucks-truck-bodies-benson",
              "name": "BENSON",
              "subcategories": []
            },
            {
              "id": "trucks-truck-bodies-besler",
              "name": "BESLER",
              "subcategories": []
            },
            {
              "id": "trucks-truck-bodies-nbianchi",
              "name": "NBIANCHI",
              "subcategories": []
            },
            {
              "id": "trucks-truck-bodies-bibeau",
              "name": "BIBEAU",
              "subcategories": []
            },
            {
              "id": "trucks-truck-bodies-bomax",
              "name": "BOMAX",
              "subcategories": []
            },
            {
              "id": "trucks-truck-bodies-boss",
              "name": "BOSS",
              "subcategories": []
            },
            {
              "id": "trucks-truck-bodies-boston-steel",
              "name": "BOSTON STEEL",
              "subcategories": []
            },
            {
              "id": "trucks-truck-bodies-bradford-built",
              "name": "BRADFORD BUILT",
              "subcategories": []
            },
            {
              "id": "trucks-truck-bodies-bramco",
              "name": "BRAMCO",
              "subcategories": []
            },
            {
              "id": "trucks-truck-bodies-brand-fx",
              "name": "BRAND FX",
              "subcategories": []
            },
            {
              "id": "trucks-truck-bodies-brandon",
              "name": "BRANDON",
              "subcategories": []
            },
            {
              "id": "trucks-truck-bodies-brazos",
              "name": "BRAZOS",
              "subcategories": []
            },
            {
              "id": "trucks-truck-bodies-brenner",
              "name": "BRENNER",
              "subcategories": []
            },
            {
              "id": "trucks-truck-bodies-brown",
              "name": "BROWN",
              "subcategories": []
            },
            {
              "id": "trucks-truck-bodies-brown-industriies",
              "name": "BROWN INDUSTRIIES",
              "subcategories": []
            },
            {
              "id": "trucks-truck-bodies-bucks-fab",
              "name": "BUCKS FAB",
              "subcategories": []
            },
            {
              "id": "trucks-truck-bodies-bulldog-bodies",
              "name": "BULLDOG BODIES",
              "subcategories": []
            },
            {
              "id": "trucks-truck-bodies-butler-beds",
              "name": "BUTLER BEDS",
              "subcategories": []
            },
            {
              "id": "trucks-truck-bodies-bwise",
              "name": "BWISE",
              "subcategories": []
            },
            {
              "id": "trucks-truck-bodies-c5-mfg",
              "name": "C5 MFG",
              "subcategories": []
            },
            {
              "id": "trucks-truck-bodies-cactus-dump-bodies",
              "name": "CACTUS DUMP BODIES",
              "subcategories": []
            },
            {
              "id": "trucks-truck-bodies-cadet",
              "name": "CADET",
              "subcategories": []
            },
            {
              "id": "trucks-truck-bodies-cancade",
              "name": "CANCADE",
              "subcategories": []
            },
            {
              "id": "trucks-truck-bodies-canuck",
              "name": "CANUCK",
              "subcategories": []
            },
            {
              "id": "trucks-truck-bodies-apital-city-trlr-inc",
              "name": "APITAL CITY TRLR INC",
              "subcategories": []
            },
            {
              "id": "trucks-truck-bodies-cas",
              "name": "CAS",
              "subcategories": []
            },
            {
              "id": "trucks-truck-bodies-central-truck-body",
              "name": "CENTRAL TRUCK BODY",
              "subcategories": []
            },
            {
              "id": "trucks-truck-bodies-century",
              "name": "CENTURY",
              "subcategories": []
            },
            {
              "id": "trucks-truck-bodies-chevrolet",
              "name": "CHEVROLET",
              "subcategories": []
            },
            {
              "id": "trucks-truck-bodies-chevron",
              "name": "CHEVRON",
              "subcategories": []
            },
            {
              "id": "trucks-truck-bodies-circle-d",
              "name": "CIRCLE D",
              "subcategories": []
            },
            {
              "id": "trucks-truck-bodies-cm",
              "name": "CM",
              "subcategories": []
            },
            {
              "id": "trucks-truck-bodies-cobra",
              "name": "COBRA",
              "subcategories": []
            },
            {
              "id": "trucks-truck-bodies-colt",
              "name": "COLT",
              "subcategories": []
            },
            {
              "id": "trucks-truck-bodies-commercial-babcock",
              "name": "COMMERCIAL BABCOCK",
              "subcategories": []
            },
            {
              "id": "trucks-truck-bodies-complete",
              "name": "COMPLETE",
              "subcategories": []
            },
            {
              "id": "trucks-truck-bodies-conshohocken-steel-products",
              "name": "CONSHOHOCKEN STEEL PRODUCTS",
              "subcategories": []
            },
            {
              "id": "trucks-truck-bodies-conyers-truck-bodies",
              "name": "CONYERS TRUCK BODIES",
              "subcategories": []
            },
            {
              "id": "trucks-truck-bodies-crown-mfg",
              "name": "CROWN MFG",
              "subcategories": []
            },
            {
              "id": "trucks-truck-bodies-crownline",
              "name": "CROWNLINE",
              "subcategories": []
            },
            {
              "id": "trucks-truck-bodies-crysteel",
              "name": "CRYSTEEL",
              "subcategories": []
            },
            {
              "id": "trucks-truck-bodies-curry-supply",
              "name": "CURRY SUPPLY",
              "subcategories": []
            },
            {
              "id": "trucks-truck-bodies-cusco",
              "name": "CUSCO",
              "subcategories": []
            },
            {
              "id": "trucks-truck-bodies-custom",
              "name": "CUSTOM",
              "subcategories": []
            },
            {
              "id": "trucks-truck-bodies-custom-bilt",
              "name": "CUSTOM BILT",
              "subcategories": []
            },
            {
              "id": "trucks-truck-bodies-dadee-mfg",
              "name": "DADEE MFG",
              "subcategories": []
            },
            {
              "id": "trucks-truck-bodies-dakota",
              "name": "DAKOTA",
              "subcategories": []
            },
            {
              "id": "trucks-truck-bodies-dakota-bodies",
              "name": "DAKOTA BODIES",
              "subcategories": []
            },
            {
              "id": "trucks-truck-bodies-daniels",
              "name": "DANIELS",
              "subcategories": []
            },
            {
              "id": "trucks-truck-bodies-delta-stag",
              "name": "DELTA STAG",
              "subcategories": []
            },
            {
              "id": "trucks-truck-bodies-delta-waseca",
              "name": "DELTA WASECA",
              "subcategories": []
            },
            {
              "id": "trucks-truck-bodies-demco",
              "name": "DEMCO",
              "subcategories": []
            },
            {
              "id": "trucks-truck-bodies-demote-fab",
              "name": "DEMOTE FAB",
              "subcategories": []
            },
            {
              "id": "trucks-truck-bodies-demountable-concepts",
              "name": "DEMOUNTABLE CONCEPTS",
              "subcategories": []
            },
            {
              "id": "trucks-truck-bodies-denver-truck-sales",
              "name": "DENVER TRUCK SALES",
              "subcategories": []
            },
            {
              "id": "trucks-truck-bodies-deweze",
              "name": "DEWEZE",
              "subcategories": []
            },
            {
              "id": "trucks-truck-bodies-dodge",
              "name": "DODGE",
              "subcategories": []
            },
            {
              "id": "trucks-truck-bodies-double-l",
              "name": "DOUBLE L",
              "subcategories": []
            },
            {
              "id": "trucks-truck-bodies-dragon",
              "name": "DRAGON",
              "subcategories": []
            },
            {
              "id": "trucks-truck-bodies-dumperdogg",
              "name": "DUMPERDOGG",
              "subcategories": []
            },
            {
              "id": "trucks-truck-bodies-durabody",
              "name": "DURABODY",
              "subcategories": []
            },
            {
              "id": "trucks-truck-bodies-duraclass",
              "name": "DURACLASS",
              "subcategories": []
            },
            {
              "id": "trucks-truck-bodies-duramag",
              "name": "DURAMAG",
              "subcategories": []
            },
            {
              "id": "trucks-truck-bodies-dutec",
              "name": "DUTEC",
              "subcategories": []
            },
            {
              "id": "trucks-truck-bodies-east-eby",
              "name": "EAST EBY",
              "subcategories": []
            },
            {
              "id": "trucks-truck-bodies-emi",
              "name": "EMI",
              "subcategories": []
            },
            {
              "id": "trucks-truck-bodies-erie",
              "name": "ERIE",
              "subcategories": []
            },
            {
              "id": "trucks-truck-bodies-etnyre",
              "name": "ETNYRE",
              "subcategories": []
            },
            {
              "id": "trucks-truck-bodies-etts",
              "name": "ETTS",
              "subcategories": []
            },
            {
              "id": "trucks-truck-bodies-fab-shop",
              "name": "FAB SHOP",
              "subcategories": []
            },
            {
              "id": "trucks-truck-bodies-falkoping",
              "name": "FALKOPING",
              "subcategories": []
            },
            {
              "id": "trucks-truck-bodies-fiberline",
              "name": "FIBERLINE",
              "subcategories": []
            },
            {
              "id": "trucks-truck-bodies-fontaine",
              "name": "FONTAINE",
              "subcategories": []
            },
            {
              "id": "trucks-truck-bodies-ford",
              "name": "FORD",
              "subcategories": []
            },
            {
              "id": "trucks-truck-bodies-fort-fabrication-and-welding",
              "name": "FORT FABRICATION AND WELDING",
              "subcategories": []
            },
            {
              "id": "trucks-truck-bodies-fourgons-leclair",
              "name": "FOURGONS LECLAIR",
              "subcategories": []
            },
            {
              "id": "trucks-truck-bodies-friesens-welding",
              "name": "FRIESENS WELDING",
              "subcategories": []
            },
            {
              "id": "trucks-truck-bodies-frontier",
              "name": "FRONTIER",
              "subcategories": []
            },
            {
              "id": "trucks-truck-bodies-fruehauf",
              "name": "FRUEHAUF",
              "subcategories": []
            },
            {
              "id": "trucks-truck-bodies-future-line",
              "name": "FUTURE LINE",
              "subcategories": []
            },
            {
              "id": "trucks-truck-bodies-galbreath",
              "name": "GALBREATH",
              "subcategories": []
            },
            {
              "id": "trucks-truck-bodies-galion",
              "name": "GALION",
              "subcategories": []
            },
            {
              "id": "trucks-truck-bodies-galion-godwin",
              "name": "GALION GODWIN",
              "subcategories": []
            },
            {
              "id": "trucks-truck-bodies-gapvax",
              "name": "GAPVAX",
              "subcategories": []
            },
            {
              "id": "trucks-truck-bodies-giletta",
              "name": "GILETTA",
              "subcategories": []
            },
            {
              "id": "trucks-truck-bodies-global-exotrans",
              "name": "GLOBAL EXOTRANS",
              "subcategories": []
            },
            {
              "id": "trucks-truck-bodies-gmc",
              "name": "GMC",
              "subcategories": []
            },
            {
              "id": "trucks-truck-bodies-godwin",
              "name": "GODWIN",
              "subcategories": []
            },
            {
              "id": "trucks-truck-bodies-good-guys",
              "name": "GOOD GUYS",
              "subcategories": []
            },
            {
              "id": "trucks-truck-bodies-gooseneck",
              "name": "GOOSENECK",
              "subcategories": []
            },
            {
              "id": "trucks-truck-bodies-gr",
              "name": "GR",
              "subcategories": []
            },
            {
              "id": "trucks-truck-bodies-grain-master",
              "name": "GRAIN MASTER",
              "subcategories": []
            },
            {
              "id": "trucks-truck-bodies-granite-truck-bodies",
              "name": "GRANITE TRUCK BODIES",
              "subcategories": []
            },
            {
              "id": "trucks-truck-bodies-great-dane",
              "name": "GREAT DANE",
              "subcategories": []
            },
            {
              "id": "trucks-truck-bodies-gse-e",
              "name": "GSE & E",
              "subcategories": []
            },
            {
              "id": "trucks-truck-bodies-h-o-i",
              "name": "H.O.I",
              "subcategories": []
            },
            {
              "id": "trucks-truck-bodies-hackney",
              "name": "HACKNEY",
              "subcategories": []
            },
            {
              "id": "trucks-truck-bodies-harbor-truck-van",
              "name": "HARBOR TRUCK VAN",
              "subcategories": []
            },
            {
              "id": "trucks-truck-bodies-heil",
              "name": "HEIL",
              "subcategories": []
            },
            {
              "id": "trucks-truck-bodies-henderson",
              "name": "HENDERSON",
              "subcategories": []
            },
            {
              "id": "trucks-truck-bodies-hercules",
              "name": "HERCULES",
              "subcategories": []
            },
            {
              "id": "trucks-truck-bodies-heritage",
              "name": "HERITAGE",
              "subcategories": []
            },
            {
              "id": "trucks-truck-bodies-hewitt",
              "name": "HEWITT",
              "subcategories": []
            },
            {
              "id": "trucks-truck-bodies-hiab",
              "name": "HIAB",
              "subcategories": []
            },
            {
              "id": "trucks-truck-bodies-highball-fabrications",
              "name": "HIGHBALL FABRICATIONS",
              "subcategories": []
            },
            {
              "id": "trucks-truck-bodies-hillsboro",
              "name": "HILLSBORO",
              "subcategories": []
            },
            {
              "id": "trucks-truck-bodies-hilltip",
              "name": "HILLTIP",
              "subcategories": []
            },
            {
              "id": "trucks-truck-bodies-hippo-mfg",
              "name": "HIPPO MFG",
              "subcategories": []
            },
            {
              "id": "trucks-truck-bodies-hitchcock",
              "name": "HITCHCOCK",
              "subcategories": []
            },
            {
              "id": "trucks-truck-bodies-holmes",
              "name": "HOLMES",
              "subcategories": []
            },
            {
              "id": "trucks-truck-bodies-homemade",
              "name": "HOMEMADE",
              "subcategories": []
            },
            {
              "id": "trucks-truck-bodies-hrg",
              "name": "HRG",
              "subcategories": []
            },
            {
              "id": "trucks-truck-bodies-hutchinson",
              "name": "HUTCHINSON",
              "subcategories": []
            },
            {
              "id": "trucks-truck-bodies-hyundai",
              "name": "HYUNDAI",
              "subcategories": []
            },
            {
              "id": "trucks-truck-bodies-hyva",
              "name": "HYVA",
              "subcategories": []
            },
            {
              "id": "trucks-truck-bodies-imt",
              "name": "IMT",
              "subcategories": []
            },
            {
              "id": "trucks-truck-bodies-iron-ox",
              "name": "IRON OX",
              "subcategories": []
            },
            {
              "id": "trucks-truck-bodies-iron-valley-equipment",
              "name": "IRON VALLEY EQUIPMENT",
              "subcategories": []
            },
            {
              "id": "trucks-truck-bodies-itb",
              "name": "ITB",
              "subcategories": []
            },
            {
              "id": "trucks-truck-bodies-j-i",
              "name": "J & I",
              "subcategories": []
            },
            {
              "id": "trucks-truck-bodies-j-j",
              "name": "J & J",
              "subcategories": []
            },
            {
              "id": "trucks-truck-bodies-j-j-truck-bodies",
              "name": "J & J TRUCK BODIES",
              "subcategories": []
            },
            {
              "id": "trucks-truck-bodies-jaco",
              "name": "JACO",
              "subcategories": []
            },
            {
              "id": "trucks-truck-bodies-jenkins",
              "name": "JENKINS",
              "subcategories": []
            },
            {
              "id": "trucks-truck-bodies-jensen",
              "name": "JENSEN",
              "subcategories": []
            },
            {
              "id": "trucks-truck-bodies-jerr-dan",
              "name": "JERR-DAN",
              "subcategories": []
            },
            {
              "id": "trucks-truck-bodies-johnson",
              "name": "JOHNSON",
              "subcategories": []
            },
            {
              "id": "trucks-truck-bodies-kann",
              "name": "KANN",
              "subcategories": []
            },
            {
              "id": "trucks-truck-bodies-keevac",
              "name": "KEEVAC",
              "subcategories": []
            },
            {
              "id": "trucks-truck-bodies-kentucky",
              "name": "KENTUCKY",
              "subcategories": []
            },
            {
              "id": "trucks-truck-bodies-kenworth",
              "name": "KENWORTH",
              "subcategories": []
            },
            {
              "id": "trucks-truck-bodies-kersten",
              "name": "KERSTEN",
              "subcategories": []
            },
            {
              "id": "trucks-truck-bodies-kidron",
              "name": "KIDRON",
              "subcategories": []
            },
            {
              "id": "trucks-truck-bodies-kleespie",
              "name": "KLEESPIE",
              "subcategories": []
            },
            {
              "id": "trucks-truck-bodies-klein",
              "name": "KLEIN",
              "subcategories": []
            },
            {
              "id": "trucks-truck-bodies-knapheide",
              "name": "KNAPHEIDE",
              "subcategories": []
            },
            {
              "id": "trucks-truck-bodies-k-pac",
              "name": "K-PAC",
              "subcategories": []
            },
            {
              "id": "trucks-truck-bodies-labrie",
              "name": "LABRIE",
              "subcategories": []
            },
            {
              "id": "trucks-truck-bodies-lanau",
              "name": "LANAU",
              "subcategories": []
            },
            {
              "id": "trucks-truck-bodies-laramie",
              "name": "LARAMIE",
              "subcategories": []
            },
            {
              "id": "trucks-truck-bodies-largo-tank",
              "name": "LARGO TANK",
              "subcategories": []
            },
            {
              "id": "trucks-truck-bodies-ledwell",
              "name": "LEDWELL",
              "subcategories": []
            },
            {
              "id": "trucks-truck-bodies-lift-bodies-inc",
              "name": "LIFT BODIES INC",
              "subcategories": []
            },
            {
              "id": "trucks-truck-bodies-liftpro",
              "name": "LIFTPRO",
              "subcategories": []
            },
            {
              "id": "trucks-truck-bodies-load-trail",
              "name": "LOAD TRAIL",
              "subcategories": []
            },
            {
              "id": "trucks-truck-bodies-loadline",
              "name": "LOADLINE",
              "subcategories": []
            },
            {
              "id": "trucks-truck-bodies-loadmaster",
              "name": "LOADMASTER",
              "subcategories": []
            },
            {
              "id": "trucks-truck-bodies-loewen",
              "name": "LOEWEN",
              "subcategories": []
            },
            {
              "id": "trucks-truck-bodies-loewen-built",
              "name": "LOEWEN BUILT",
              "subcategories": []
            },
            {
              "id": "trucks-truck-bodies-logan-farm-equip",
              "name": "LOGAN FARM EQUIP",
              "subcategories": []
            },
            {
              "id": "trucks-truck-bodies-mac-ltt",
              "name": "MAC LTT",
              "subcategories": []
            },
            {
              "id": "trucks-truck-bodies-mac-trailers-mfg",
              "name": "MAC TRAILERS MFG",
              "subcategories": []
            },
            {
              "id": "trucks-truck-bodies-maintainer",
              "name": "MAINTAINER",
              "subcategories": []
            },
            {
              "id": "trucks-truck-bodies-marion",
              "name": "MARION",
              "subcategories": []
            },
            {
              "id": "trucks-truck-bodies-martin",
              "name": "MARTIN",
              "subcategories": []
            },
            {
              "id": "trucks-truck-bodies-maxon",
              "name": "MAXON",
              "subcategories": []
            },
            {
              "id": "trucks-truck-bodies-maxx-dump-bodies",
              "name": "MAXX DUMP BODIES",
              "subcategories": []
            },
            {
              "id": "trucks-truck-bodies-maxxd",
              "name": "MAXXD",
              "subcategories": []
            },
            {
              "id": "trucks-truck-bodies-mcclain-galion",
              "name": "MCCLAIN GALION",
              "subcategories": []
            },
            {
              "id": "trucks-truck-bodies-mcneilus",
              "name": "MCNEILUS",
              "subcategories": []
            },
            {
              "id": "trucks-truck-bodies-metro",
              "name": "METRO",
              "subcategories": []
            },
            {
              "id": "trucks-truck-bodies-mickey",
              "name": "MICKEY",
              "subcategories": []
            },
            {
              "id": "trucks-truck-bodies-minoru",
              "name": "MINORU",
              "subcategories": []
            },
            {
              "id": "trucks-truck-bodies-mitsubishi-fuso",
              "name": "MITSUBISHI FUSO",
              "subcategories": []
            },
            {
              "id": "trucks-truck-bodies-monroe",
              "name": "MONROE",
              "subcategories": []
            },
            {
              "id": "trucks-truck-bodies-morgan",
              "name": "MORGAN",
              "subcategories": []
            },
            {
              "id": "trucks-truck-bodies-moritz-international",
              "name": "MORITZ INTERNATIONAL",
              "subcategories": []
            },
            {
              "id": "trucks-truck-bodies-multi-vans",
              "name": "MULTI VANS",
              "subcategories": []
            },
            {
              "id": "trucks-truck-bodies-multilift",
              "name": "MULTILIFT",
              "subcategories": []
            },
            {
              "id": "trucks-truck-bodies-nahanni-ind",
              "name": "NAHANNI IND",
              "subcategories": []
            },
            {
              "id": "trucks-truck-bodies-nuestar",
              "name": "NUESTAR",
              "subcategories": []
            },
            {
              "id": "trucks-truck-bodies-new-way",
              "name": "NEW WAY",
              "subcategories": []
            },
            {
              "id": "trucks-truck-bodies-norstar",
              "name": "NORSTAR",
              "subcategories": []
            },
            {
              "id": "trucks-truck-bodies-northeast",
              "name": "NORTHEAST",
              "subcategories": []
            },
            {
              "id": "trucks-truck-bodies-northeast-industrial-mfg",
              "name": "NORTHEAST INDUSTRIAL MFG",
              "subcategories": []
            },
            {
              "id": "trucks-truck-bodies-nose-cone",
              "name": "NOSE CONE",
              "subcategories": []
            },
            {
              "id": "trucks-truck-bodies-nrc",
              "name": "NRC",
              "subcategories": []
            },
            {
              "id": "trucks-truck-bodies-ohnsorg",
              "name": "OHNSORG",
              "subcategories": []
            },
            {
              "id": "trucks-truck-bodies-oilmens",
              "name": "OILMENS",
              "subcategories": []
            },
            {
              "id": "trucks-truck-bodies-osco-tank",
              "name": "OSCO TANK",
              "subcategories": []
            },
            {
              "id": "trucks-truck-bodies-ox-bodies",
              "name": "OX BODIES",
              "subcategories": []
            },
            {
              "id": "trucks-truck-bodies-piasano",
              "name": "PIASANO",
              "subcategories": []
            },
            {
              "id": "trucks-truck-bodies-palfinger",
              "name": "PALFINGER",
              "subcategories": []
            },
            {
              "id": "trucks-truck-bodies-parker",
              "name": "PARKER",
              "subcategories": []
            },
            {
              "id": "trucks-truck-bodies-parkhurst",
              "name": "PARKHURST",
              "subcategories": []
            },
            {
              "id": "trucks-truck-bodies-pci",
              "name": "PCI",
              "subcategories": []
            },
            {
              "id": "trucks-truck-bodies-peak",
              "name": "PEAK",
              "subcategories": []
            },
            {
              "id": "trucks-truck-bodies-perkins",
              "name": "PERKINS",
              "subcategories": []
            },
            {
              "id": "trucks-truck-bodies-piedmont",
              "name": "PIEDMONT",
              "subcategories": []
            },
            {
              "id": "trucks-truck-bodies-pj-truck-beds",
              "name": "PJ TRUCK BEDS",
              "subcategories": []
            },
            {
              "id": "trucks-truck-bodies-polar",
              "name": "POLAR",
              "subcategories": []
            },
            {
              "id": "trucks-truck-bodies-premier-truck-bodies",
              "name": "PREMIER TRUCK BODIES",
              "subcategories": []
            },
            {
              "id": "trucks-truck-bodies-presvac",
              "name": "PRESVAC",
              "subcategories": []
            },
            {
              "id": "trucks-truck-bodies-progress",
              "name": "PROGRESS",
              "subcategories": []
            },
            {
              "id": "trucks-truck-bodies-pronghorn",
              "name": "PRONGHORN",
              "subcategories": []
            },
            {
              "id": "trucks-truck-bodies-r-s-godwin",
              "name": "R/S GODWIN",
              "subcategories": []
            },
            {
              "id": "trucks-truck-bodies-ram",
              "name": "RAM",
              "subcategories": []
            },
            {
              "id": "trucks-truck-bodies-ravens",
              "name": "RAVENS",
              "subcategories": []
            },
            {
              "id": "trucks-truck-bodies-reading",
              "name": "READING",
              "subcategories": []
            },
            {
              "id": "trucks-truck-bodies-reed",
              "name": "REED",
              "subcategories": []
            },
            {
              "id": "trucks-truck-bodies-reiten",
              "name": "REITEN",
              "subcategories": []
            },
            {
              "id": "trucks-truck-bodies-reliance",
              "name": "RELIANCE",
              "subcategories": []
            },
            {
              "id": "trucks-truck-bodies-rhodes",
              "name": "RHODES",
              "subcategories": []
            },
            {
              "id": "trucks-truck-bodies-rock-solid-truck-bodies",
              "name": "ROCK SOLID TRUCK BODIES",
              "subcategories": []
            },
            {
              "id": "trucks-truck-bodies-rockport",
              "name": "ROCKPORT",
              "subcategories": []
            },
            {
              "id": "trucks-truck-bodies-roc-tec",
              "name": "ROC-TEC",
              "subcategories": []
            },
            {
              "id": "trucks-truck-bodies-rogers",
              "name": "ROGERS",
              "subcategories": []
            },
            {
              "id": "trucks-truck-bodies-roll-offs-usa",
              "name": "ROLL OFFS USA",
              "subcategories": []
            },
            {
              "id": "trucks-truck-bodies-royal-truck-bodies",
              "name": "ROYAL TRUCK BODIES",
              "subcategories": []
            },
            {
              "id": "trucks-truck-bodies-rtr-mfg",
              "name": "RTR MFG",
              "subcategories": []
            },
            {
              "id": "trucks-truck-bodies-rufnek",
              "name": "RUFNEK",
              "subcategories": []
            },
            {
              "id": "trucks-truck-bodies-rugby",
              "name": "RUGBY",
              "subcategories": []
            },
            {
              "id": "trucks-truck-bodies-r-way",
              "name": "R-WAY",
              "subcategories": []
            },
            {
              "id": "trucks-truck-bodies-rx3",
              "name": "RX3",
              "subcategories": []
            },
            {
              "id": "trucks-truck-bodies-s-h",
              "name": "S&H",
              "subcategories": []
            },
            {
              "id": "trucks-truck-bodies-salt-dog",
              "name": "SALT DOG",
              "subcategories": []
            },
            {
              "id": "trucks-truck-bodies-schien",
              "name": "SCHIEN",
              "subcategories": []
            },
            {
              "id": "trucks-truck-bodies-schmidt",
              "name": "SCHMIDT",
              "subcategories": []
            },
            {
              "id": "trucks-truck-bodies-scott",
              "name": "SCOTT",
              "subcategories": []
            },
            {
              "id": "trucks-truck-bodies-se-inc",
              "name": "SE INC",
              "subcategories": []
            },
            {
              "id": "trucks-truck-bodies-shop-built",
              "name": "SHOP BUILT",
              "subcategories": []
            },
            {
              "id": "trucks-truck-bodies-smyrna",
              "name": "SMYRNA",
              "subcategories": []
            },
            {
              "id": "trucks-truck-bodies-sno-way",
              "name": "SNO-WAY",
              "subcategories": []
            },
            {
              "id": "trucks-truck-bodies-snowex",
              "name": "SNOWEX",
              "subcategories": []
            },
            {
              "id": "trucks-truck-bodies-southco",
              "name": "SOUTHCO",
              "subcategories": []
            },
            {
              "id": "trucks-truck-bodies-spray-king",
              "name": "SPRAY KING",
              "subcategories": []
            },
            {
              "id": "trucks-truck-bodies-stahl",
              "name": "STAHL",
              "subcategories": []
            },
            {
              "id": "trucks-truck-bodies-star-mfg",
              "name": "STAR MFG",
              "subcategories": []
            },
            {
              "id": "trucks-truck-bodies-stellar",
              "name": "STELLAR",
              "subcategories": []
            },
            {
              "id": "trucks-truck-bodies-summit",
              "name": "SUMMIT",
              "subcategories": []
            },
            {
              "id": "trucks-truck-bodies-super-city",
              "name": "SUPER CITY",
              "subcategories": []
            },
            {
              "id": "trucks-truck-bodies-super-products",
              "name": "SUPER PRODUCTS",
              "subcategories": []
            },
            {
              "id": "trucks-truck-bodies-superior",
              "name": "SUPERIOR",
              "subcategories": []
            },
            {
              "id": "trucks-truck-bodies-supreme",
              "name": "SUPREME",
              "subcategories": []
            },
            {
              "id": "trucks-truck-bodies-supreme-corp",
              "name": "SUPREME CORP",
              "subcategories": []
            },
            {
              "id": "trucks-truck-bodies-sure-trac",
              "name": "SURE-TRAC",
              "subcategories": []
            },
            {
              "id": "trucks-truck-bodies-swap-hogg",
              "name": "SWAP HOGG",
              "subcategories": []
            },
            {
              "id": "trucks-truck-bodies-swaploader",
              "name": "SWAPLOADER",
              "subcategories": []
            },
            {
              "id": "trucks-truck-bodies-swenson",
              "name": "SWENSON",
              "subcategories": []
            },
            {
              "id": "trucks-truck-bodies-switch-n-go",
              "name": "SWITCH N GO",
              "subcategories": []
            },
            {
              "id": "trucks-truck-bodies-t-b-water-trucks",
              "name": "T&B WATER TRUCKS",
              "subcategories": []
            },
            {
              "id": "trucks-truck-bodies-tafco",
              "name": "TAFCO",
              "subcategories": []
            },
            {
              "id": "trucks-truck-bodies-teco",
              "name": "TECO",
              "subcategories": []
            },
            {
              "id": "trucks-truck-bodies-tesco",
              "name": "TESCO",
              "subcategories": []
            },
            {
              "id": "trucks-truck-bodies-tfi",
              "name": "TFI",
              "subcategories": []
            },
            {
              "id": "trucks-truck-bodies-tg-mountaineer",
              "name": "TG MOUNTAINEER",
              "subcategories": []
            },
            {
              "id": "trucks-truck-bodies-thermo-king",
              "name": "THERMO KING",
              "subcategories": []
            },
            {
              "id": "trucks-truck-bodies-tiger",
              "name": "TIGER",
              "subcategories": []
            },
            {
              "id": "trucks-truck-bodies-todco",
              "name": "TODCO",
              "subcategories": []
            },
            {
              "id": "trucks-truck-bodies-tpl",
              "name": "TPL",
              "subcategories": []
            },
            {
              "id": "trucks-truck-bodies-trailstar",
              "name": "TRAILSTAR",
              "subcategories": []
            },
            {
              "id": "trucks-truck-bodies-trailtech",
              "name": "TRAILTECH",
              "subcategories": []
            },
            {
              "id": "trucks-truck-bodies-transit",
              "name": "TRANSIT",
              "subcategories": []
            },
            {
              "id": "trucks-truck-bodies-truckcraft",
              "name": "TRUCKCRAFT",
              "subcategories": []
            },
            {
              "id": "trucks-truck-bodies-twin-star-equip",
              "name": "TWIN STAR EQUIP",
              "subcategories": []
            },
            {
              "id": "trucks-truck-bodies-us-tank-industries",
              "name": "US TANK INDUSTRIES",
              "subcategories": []
            },
            {
              "id": "trucks-truck-bodies-unicell",
              "name": "UNICELL",
              "subcategories": []
            },
            {
              "id": "trucks-truck-bodies-unknown",
              "name": "UNKNOWN",
              "subcategories": []
            },
            {
              "id": "trucks-truck-bodies-unspecified",
              "name": "UNSPECIFIED",
              "subcategories": []
            },
            {
              "id": "trucks-truck-bodies-us-truck-body",
              "name": "US TRUCK BODY",
              "subcategories": []
            },
            {
              "id": "trucks-truck-bodies-utilmaster",
              "name": "UTILMASTER",
              "subcategories": []
            },
            {
              "id": "trucks-truck-bodies-utility-body",
              "name": "UTILITY BODY",
              "subcategories": []
            },
            {
              "id": "trucks-truck-bodies-vactor",
              "name": "VACTOR",
              "subcategories": []
            },
            {
              "id": "trucks-truck-bodies-valew",
              "name": "VALEW",
              "subcategories": []
            },
            {
              "id": "trucks-truck-bodies-valley-enterprises",
              "name": "VALLEY ENTERPRISES",
              "subcategories": []
            },
            {
              "id": "trucks-truck-bodies-venco",
              "name": "VENCO",
              "subcategories": []
            },
            {
              "id": "trucks-truck-bodies-ventures-mfg",
              "name": "VENTURES MFG",
              "subcategories": []
            },
            {
              "id": "trucks-truck-bodies-viking-cives",
              "name": "VIKING CIVES",
              "subcategories": []
            },
            {
              "id": "trucks-truck-bodies-virginian",
              "name": "VIRGINIAN",
              "subcategories": []
            },
            {
              "id": "trucks-truck-bodies-voth",
              "name": "VOTH",
              "subcategories": []
            },
            {
              "id": "trucks-truck-bodies-vulcan",
              "name": "VULCAN",
              "subcategories": []
            },
            {
              "id": "trucks-truck-bodies-wabash",
              "name": "WABASH",
              "subcategories": []
            },
            {
              "id": "trucks-truck-bodies-walker",
              "name": "WALKER",
              "subcategories": []
            },
            {
              "id": "trucks-truck-bodies-warner",
              "name": "WARNER",
              "subcategories": []
            },
            {
              "id": "trucks-truck-bodies-warren",
              "name": "WARREN",
              "subcategories": []
            },
            {
              "id": "trucks-truck-bodies-wastequip",
              "name": "WASTEQUIP",
              "subcategories": []
            },
            {
              "id": "trucks-truck-bodies-wayne",
              "name": "WAYNE",
              "subcategories": []
            },
            {
              "id": "trucks-truck-bodies-weldit",
              "name": "WELDIT",
              "subcategories": []
            },
            {
              "id": "trucks-truck-bodies-western",
              "name": "WESTERN",
              "subcategories": []
            },
            {
              "id": "trucks-truck-bodies-western-trailers",
              "name": "WESTERN TRAILERS",
              "subcategories": []
            },
            {
              "id": "trucks-truck-bodies-westmark",
              "name": "WESTMARK",
              "subcategories": []
            },
            {
              "id": "trucks-truck-bodies-wildhorse",
              "name": "WILDHORSE",
              "subcategories": []
            },
            {
              "id": "trucks-truck-bodies-williamsen",
              "name": "WILLIAMSEN",
              "subcategories": []
            },
            {
              "id": "trucks-truck-bodies-wil-ro",
              "name": "WIL-RO",
              "subcategories": []
            },
            {
              "id": "trucks-truck-bodies-young-tanks",
              "name": "YOUNG TANKS",
              "subcategories": []
            },
            {
              "id": "trucks-truck-bodies-zimmerman",
              "name": "ZIMMERMAN",
              "subcategories": []
            },
            {
              "id": "trucks-truck-bodies-other",
              "name": "OTHER",
              "subcategories": []
            }
          ]
        },
        {
          "id": "trucks-dump-bed",
          "name": "Dump Bed",
          "subcategories": []
        },
        {
          "id": "trucks-flat-bed",
          "name": "Flat Bed",
          "subcategories": []
        },
        {
          "id": "trucks-reefer-bed",
          "name": "Reefer Bed",
          "subcategories": []
        },
        {
          "id": "trucks-service-bed",
          "name": "Service Bed",
          "subcategories": []
        },
        {
          "id": "trucks-tank-vac-bed",
          "name": "Tank/Vac Bed",
          "subcategories": []
        },
        {
          "id": "trucks-van-bed",
          "name": "Van Bed",
          "subcategories": []
        },
        {
          "id": "trucks-other",
          "name": "Other",
          "subcategories": []
        },
        {
          "id": "trucks-vans",
          "name": "Vans",
          "subcategories": [
            {
              "id": "trucks-vans-ford",
              "name": "FORD",
              "subcategories": []
            },
            {
              "id": "trucks-vans-mercedes-benz",
              "name": "MERCEDES-BENZ",
              "subcategories": []
            },
            {
              "id": "trucks-vans-freightliner",
              "name": "FREIGHTLINER",
              "subcategories": []
            },
            {
              "id": "trucks-vans-chevrolet",
              "name": "CHEVROLET",
              "subcategories": []
            },
            {
              "id": "trucks-vans-ram",
              "name": "RAM",
              "subcategories": []
            },
            {
              "id": "trucks-vans-gmc",
              "name": "GMC",
              "subcategories": []
            },
            {
              "id": "trucks-vans-nissan",
              "name": "NISSAN",
              "subcategories": []
            },
            {
              "id": "trucks-vans-dodge",
              "name": "DODGE",
              "subcategories": []
            },
            {
              "id": "trucks-vans-chrysler",
              "name": "CHRYSLER",
              "subcategories": []
            },
            {
              "id": "trucks-vans-midwest-auto-design",
              "name": "MIDWEST AUTO DESIGN",
              "subcategories": []
            },
            {
              "id": "trucks-vans-brightdrop",
              "name": "BRIGHTDROP",
              "subcategories": []
            },
            {
              "id": "trucks-vans-collins",
              "name": "COLLINS",
              "subcategories": []
            },
            {
              "id": "trucks-vans-grech-rv",
              "name": "GRECH RV",
              "subcategories": []
            },
            {
              "id": "trucks-vans-harbinger",
              "name": "HARBINGER",
              "subcategories": []
            },
            {
              "id": "trucks-vans-honda",
              "name": "HONDA",
              "subcategories": []
            },
            {
              "id": "trucks-vans-isuzu",
              "name": "ISUZU",
              "subcategories": []
            },
            {
              "id": "trucks-vans-kia",
              "name": "KIA",
              "subcategories": []
            },
            {
              "id": "trucks-vans-la-west-coaches",
              "name": "LA WEST COACHES",
              "subcategories": []
            },
            {
              "id": "trucks-vans-mack",
              "name": "MACK",
              "subcategories": []
            },
            {
              "id": "trucks-vans-micro-bird",
              "name": "MICRO BIRD",
              "subcategories": []
            },
            {
              "id": "trucks-vans-mullen",
              "name": "MULLEN",
              "subcategories": []
            },
            {
              "id": "trucks-vans-ogv",
              "name": "OGV",
              "subcategories": []
            },
            {
              "id": "trucks-vans-pacific",
              "name": "PACIFIC",
              "subcategories": []
            },
            {
              "id": "trucks-vans-renault",
              "name": "RENAULT",
              "subcategories": []
            },
            {
              "id": "trucks-vans-toyota",
              "name": "TOYOTA",
              "subcategories": []
            },
            {
              "id": "trucks-vans-unspecified",
              "name": "UNSPECIFIED",
              "subcategories": []
            },
            {
              "id": "trucks-vans-utilmaster",
              "name": "UTILMASTER",
              "subcategories": []
            },
            {
              "id": "trucks-vans-volswagon",
              "name": "VOLSWAGON",
              "subcategories": []
            },
            {
              "id": "trucks-vans-workhorse",
              "name": "WORKHORSE",
              "subcategories": []
            },
            {
              "id": "trucks-vans-xos",
              "name": "XOS",
              "subcategories": []
            },
            {
              "id": "trucks-vans-other",
              "name": "OTHER",
              "subcategories": []
            }
          ]
        },
        {
          "id": "trucks-cargo",
          "name": "Cargo",
          "subcategories": []
        },
        {
          "id": "trucks-passenger",
          "name": "Passenger",
          "subcategories": []
        },
        {
          "id": "trucks-reefer",
          "name": "Reefer",
          "subcategories": []
        },
        {
          "id": "trucks-service-utility",
          "name": "Service Utility",
          "subcategories": []
        },
        {
          "id": "trucks-step",
          "name": "Step",
          "subcategories": []
        },
        {
          "id": "trucks-winch-oilfield-trucks",
          "name": "Winch / Oilfield Trucks",
          "subcategories": []
        },
        {
          "id": "trucks-yard-spotter-trucks",
          "name": "Yard Spotter Trucks",
          "subcategories": [
            {
              "id": "trucks-yard-spotter-trucks-ottawa",
              "name": "OTTAWA",
              "subcategories": []
            },
            {
              "id": "trucks-yard-spotter-trucks-kalmar",
              "name": "KALMAR",
              "subcategories": []
            },
            {
              "id": "trucks-yard-spotter-trucks-capacity",
              "name": "CAPACITY",
              "subcategories": []
            },
            {
              "id": "trucks-yard-spotter-trucks-autocar",
              "name": "AUTOCAR",
              "subcategories": []
            },
            {
              "id": "trucks-yard-spotter-trucks-tico",
              "name": "TICO",
              "subcategories": []
            },
            {
              "id": "trucks-yard-spotter-trucks-terberg",
              "name": "TERBERG",
              "subcategories": []
            },
            {
              "id": "trucks-yard-spotter-trucks-cargotec",
              "name": "CARGOTEC",
              "subcategories": []
            },
            {
              "id": "trucks-yard-spotter-trucks-lonestar-sv",
              "name": "LONESTAR SV",
              "subcategories": []
            },
            {
              "id": "trucks-yard-spotter-trucks-frieghtliner",
              "name": "FRIEGHTLINER",
              "subcategories": []
            },
            {
              "id": "trucks-yard-spotter-trucks-mafi",
              "name": "MAFI",
              "subcategories": []
            },
            {
              "id": "trucks-yard-spotter-trucks-hoist",
              "name": "HOIST",
              "subcategories": []
            },
            {
              "id": "trucks-yard-spotter-trucks-mafi",
              "name": "MAFI",
              "subcategories": []
            },
            {
              "id": "trucks-yard-spotter-trucks-sisu",
              "name": "SISU",
              "subcategories": []
            },
            {
              "id": "trucks-yard-spotter-trucks-sterling",
              "name": "STERLING",
              "subcategories": []
            },
            {
              "id": "trucks-yard-spotter-trucks-terberg",
              "name": "TERBERG",
              "subcategories": []
            },
            {
              "id": "trucks-yard-spotter-trucks-international",
              "name": "INTERNATIONAL",
              "subcategories": []
            },
            {
              "id": "trucks-yard-spotter-trucks-lonestar-sv",
              "name": "LONESTAR SV",
              "subcategories": []
            },
            {
              "id": "trucks-yard-spotter-trucks-yard-boss",
              "name": "YARD BOSS",
              "subcategories": []
            },
            {
              "id": "trucks-yard-spotter-trucks-other",
              "name": "OTHER",
              "subcategories": []
            }
          ]
        }
      ]
    },
    {
      "id": "wheel-loaders",
      "name": "Wheel Loaders",
      "subcategories": [
        {
          "id": "wheel-loaders-caterpillar",
          "name": "Caterpillar",
          "subcategories": [
            {
              "id": "wheel-loaders-caterpillar-901",
              "name": "901",
              "subcategories": []
            },
            {
              "id": "wheel-loaders-caterpillar-901b",
              "name": "901B",
              "subcategories": []
            },
            {
              "id": "wheel-loaders-caterpillar-902",
              "name": "902",
              "subcategories": []
            },
            {
              "id": "wheel-loaders-caterpillar-902b",
              "name": "902B",
              "subcategories": []
            },
            {
              "id": "wheel-loaders-caterpillar-903",
              "name": "903",
              "subcategories": []
            },
            {
              "id": "wheel-loaders-caterpillar-903b",
              "name": "903B",
              "subcategories": []
            },
            {
              "id": "wheel-loaders-caterpillar-903c",
              "name": "903C",
              "subcategories": []
            },
            {
              "id": "wheel-loaders-caterpillar-903c2",
              "name": "903C2",
              "subcategories": []
            },
            {
              "id": "wheel-loaders-caterpillar-903d",
              "name": "903D",
              "subcategories": []
            },
            {
              "id": "wheel-loaders-caterpillar-904",
              "name": "904",
              "subcategories": []
            },
            {
              "id": "wheel-loaders-caterpillar-904b",
              "name": "904B",
              "subcategories": []
            },
            {
              "id": "wheel-loaders-caterpillar-906",
              "name": "906",
              "subcategories": []
            },
            {
              "id": "wheel-loaders-caterpillar-906h",
              "name": "906H",
              "subcategories": []
            },
            {
              "id": "wheel-loaders-caterpillar-906h2",
              "name": "906H2",
              "subcategories": []
            },
            {
              "id": "wheel-loaders-caterpillar-906m",
              "name": "906M",
              "subcategories": []
            },
            {
              "id": "wheel-loaders-caterpillar-907",
              "name": "907",
              "subcategories": []
            },
            {
              "id": "wheel-loaders-caterpillar-907h",
              "name": "907H",
              "subcategories": []
            },
            {
              "id": "wheel-loaders-caterpillar-907h2",
              "name": "907H2",
              "subcategories": []
            },
            {
              "id": "wheel-loaders-caterpillar-907m",
              "name": "907M",
              "subcategories": []
            },
            {
              "id": "wheel-loaders-caterpillar-908",
              "name": "908",
              "subcategories": []
            },
            {
              "id": "wheel-loaders-caterpillar-908h",
              "name": "908H",
              "subcategories": []
            },
            {
              "id": "wheel-loaders-caterpillar-908h2",
              "name": "908H2",
              "subcategories": []
            },
            {
              "id": "wheel-loaders-caterpillar-908m",
              "name": "908M",
              "subcategories": []
            },
            {
              "id": "wheel-loaders-caterpillar-910",
              "name": "910",
              "subcategories": []
            },
            {
              "id": "wheel-loaders-caterpillar-910f",
              "name": "910F",
              "subcategories": []
            },
            {
              "id": "wheel-loaders-caterpillar-910g",
              "name": "910G",
              "subcategories": []
            },
            {
              "id": "wheel-loaders-caterpillar-910k",
              "name": "910K",
              "subcategories": []
            },
            {
              "id": "wheel-loaders-caterpillar-910m",
              "name": "910M",
              "subcategories": []
            },
            {
              "id": "wheel-loaders-caterpillar-914",
              "name": "914",
              "subcategories": []
            },
            {
              "id": "wheel-loaders-caterpillar-914g",
              "name": "914G",
              "subcategories": []
            },
            {
              "id": "wheel-loaders-caterpillar-914k",
              "name": "914K",
              "subcategories": []
            },
            {
              "id": "wheel-loaders-caterpillar-914m",
              "name": "914M",
              "subcategories": []
            },
            {
              "id": "wheel-loaders-caterpillar-916",
              "name": "916",
              "subcategories": []
            },
            {
              "id": "wheel-loaders-caterpillar-918",
              "name": "918",
              "subcategories": []
            },
            {
              "id": "wheel-loaders-caterpillar-918f",
              "name": "918F",
              "subcategories": []
            },
            {
              "id": "wheel-loaders-caterpillar-918g",
              "name": "918G",
              "subcategories": []
            },
            {
              "id": "wheel-loaders-caterpillar-918h",
              "name": "918H",
              "subcategories": []
            },
            {
              "id": "wheel-loaders-caterpillar-918m",
              "name": "918M",
              "subcategories": []
            },
            {
              "id": "wheel-loaders-caterpillar-920",
              "name": "920",
              "subcategories": []
            },
            {
              "id": "wheel-loaders-caterpillar-922",
              "name": "922",
              "subcategories": []
            },
            {
              "id": "wheel-loaders-caterpillar-922b",
              "name": "922B",
              "subcategories": []
            },
            {
              "id": "wheel-loaders-caterpillar-924",
              "name": "924",
              "subcategories": []
            },
            {
              "id": "wheel-loaders-caterpillar-924f",
              "name": "924F",
              "subcategories": []
            },
            {
              "id": "wheel-loaders-caterpillar-924g",
              "name": "924G",
              "subcategories": []
            },
            {
              "id": "wheel-loaders-caterpillar-924gz",
              "name": "924GZ",
              "subcategories": []
            },
            {
              "id": "wheel-loaders-caterpillar-924h",
              "name": "924H",
              "subcategories": []
            },
            {
              "id": "wheel-loaders-caterpillar-924hz",
              "name": "924HZ",
              "subcategories": []
            },
            {
              "id": "wheel-loaders-caterpillar-924k",
              "name": "924K",
              "subcategories": []
            },
            {
              "id": "wheel-loaders-caterpillar-926",
              "name": "926",
              "subcategories": []
            },
            {
              "id": "wheel-loaders-caterpillar-926e",
              "name": "926E",
              "subcategories": []
            },
            {
              "id": "wheel-loaders-caterpillar-926m",
              "name": "926M",
              "subcategories": []
            },
            {
              "id": "wheel-loaders-caterpillar-928",
              "name": "928",
              "subcategories": []
            },
            {
              "id": "wheel-loaders-caterpillar-928f",
              "name": "928F",
              "subcategories": []
            },
            {
              "id": "wheel-loaders-caterpillar-928g",
              "name": "928G",
              "subcategories": []
            },
            {
              "id": "wheel-loaders-caterpillar-928gz",
              "name": "928GZ",
              "subcategories": []
            },
            {
              "id": "wheel-loaders-caterpillar-928h",
              "name": "928H",
              "subcategories": []
            },
            {
              "id": "wheel-loaders-caterpillar-928hz",
              "name": "928HZ",
              "subcategories": []
            },
            {
              "id": "wheel-loaders-caterpillar-936",
              "name": "936",
              "subcategories": []
            },
            {
              "id": "wheel-loaders-caterpillar-936e",
              "name": "936E",
              "subcategories": []
            },
            {
              "id": "wheel-loaders-caterpillar-936f",
              "name": "936F",
              "subcategories": []
            },
            {
              "id": "wheel-loaders-caterpillar-936g",
              "name": "936G",
              "subcategories": []
            },
            {
              "id": "wheel-loaders-caterpillar-936h",
              "name": "936H",
              "subcategories": []
            },
            {
              "id": "wheel-loaders-caterpillar-936k",
              "name": "936K",
              "subcategories": []
            },
            {
              "id": "wheel-loaders-caterpillar-938",
              "name": "938",
              "subcategories": []
            },
            {
              "id": "wheel-loaders-caterpillar-938f",
              "name": "938F",
              "subcategories": []
            },
            {
              "id": "wheel-loaders-caterpillar-938g",
              "name": "938G",
              "subcategories": []
            },
            {
              "id": "wheel-loaders-caterpillar-938g-ii",
              "name": "938G II",
              "subcategories": []
            },
            {
              "id": "wheel-loaders-caterpillar-938h",
              "name": "938H",
              "subcategories": []
            },
            {
              "id": "wheel-loaders-caterpillar-938k",
              "name": "938K",
              "subcategories": []
            },
            {
              "id": "wheel-loaders-caterpillar-938m",
              "name": "938M",
              "subcategories": []
            },
            {
              "id": "wheel-loaders-caterpillar-944",
              "name": "944",
              "subcategories": []
            },
            {
              "id": "wheel-loaders-caterpillar-950",
              "name": "950",
              "subcategories": []
            },
            {
              "id": "wheel-loaders-caterpillar-950-ii",
              "name": "950 II",
              "subcategories": []
            },
            {
              "id": "wheel-loaders-caterpillar-950b",
              "name": "950B",
              "subcategories": []
            },
            {
              "id": "wheel-loaders-caterpillar-950c",
              "name": "950C",
              "subcategories": []
            },
            {
              "id": "wheel-loaders-caterpillar-950e",
              "name": "950E",
              "subcategories": []
            },
            {
              "id": "wheel-loaders-caterpillar-950f",
              "name": "950F",
              "subcategories": []
            },
            {
              "id": "wheel-loaders-caterpillar-950f-ii",
              "name": "950F II",
              "subcategories": []
            },
            {
              "id": "wheel-loaders-caterpillar-950g",
              "name": "950G",
              "subcategories": []
            },
            {
              "id": "wheel-loaders-caterpillar-950g-ii",
              "name": "950G II",
              "subcategories": []
            },
            {
              "id": "wheel-loaders-caterpillar-950gc",
              "name": "950GC",
              "subcategories": []
            },
            {
              "id": "wheel-loaders-caterpillar-950h",
              "name": "950H",
              "subcategories": []
            },
            {
              "id": "wheel-loaders-caterpillar-950k",
              "name": "950K",
              "subcategories": []
            },
            {
              "id": "wheel-loaders-caterpillar-950l",
              "name": "950L",
              "subcategories": []
            },
            {
              "id": "wheel-loaders-caterpillar-950m",
              "name": "950M",
              "subcategories": []
            },
            {
              "id": "wheel-loaders-caterpillar-950mz",
              "name": "950MZ",
              "subcategories": []
            },
            {
              "id": "wheel-loaders-caterpillar-960",
              "name": "960",
              "subcategories": []
            },
            {
              "id": "wheel-loaders-caterpillar-960f",
              "name": "960F",
              "subcategories": []
            },
            {
              "id": "wheel-loaders-caterpillar-962",
              "name": "962",
              "subcategories": []
            },
            {
              "id": "wheel-loaders-caterpillar-962g",
              "name": "962G",
              "subcategories": []
            },
            {
              "id": "wheel-loaders-caterpillar-962g-ii",
              "name": "962G II",
              "subcategories": []
            },
            {
              "id": "wheel-loaders-caterpillar-962h",
              "name": "962H",
              "subcategories": []
            },
            {
              "id": "wheel-loaders-caterpillar-962k",
              "name": "962K",
              "subcategories": []
            },
            {
              "id": "wheel-loaders-caterpillar-962m",
              "name": "962M",
              "subcategories": []
            },
            {
              "id": "wheel-loaders-caterpillar-966",
              "name": "966",
              "subcategories": []
            },
            {
              "id": "wheel-loaders-caterpillar-966c",
              "name": "966C",
              "subcategories": []
            },
            {
              "id": "wheel-loaders-caterpillar-966d",
              "name": "966D",
              "subcategories": []
            },
            {
              "id": "wheel-loaders-caterpillar-966e",
              "name": "966E",
              "subcategories": []
            },
            {
              "id": "wheel-loaders-caterpillar-966f",
              "name": "966F",
              "subcategories": []
            },
            {
              "id": "wheel-loaders-caterpillar-966f-i",
              "name": "966F I",
              "subcategories": []
            },
            {
              "id": "wheel-loaders-caterpillar-966f-ii",
              "name": "966F II",
              "subcategories": []
            },
            {
              "id": "wheel-loaders-caterpillar-966g",
              "name": "966G",
              "subcategories": []
            },
            {
              "id": "wheel-loaders-caterpillar-966g-ii",
              "name": "966G II",
              "subcategories": []
            },
            {
              "id": "wheel-loaders-caterpillar-966gc",
              "name": "966GC",
              "subcategories": []
            },
            {
              "id": "wheel-loaders-caterpillar-966h",
              "name": "966H",
              "subcategories": []
            },
            {
              "id": "wheel-loaders-caterpillar-966k",
              "name": "966K",
              "subcategories": []
            },
            {
              "id": "wheel-loaders-caterpillar-966l",
              "name": "966L",
              "subcategories": []
            },
            {
              "id": "wheel-loaders-caterpillar-966m",
              "name": "966M",
              "subcategories": []
            },
            {
              "id": "wheel-loaders-caterpillar-966m-xe",
              "name": "966M XE",
              "subcategories": []
            },
            {
              "id": "wheel-loaders-caterpillar-966xe",
              "name": "966XE",
              "subcategories": []
            },
            {
              "id": "wheel-loaders-caterpillar-970",
              "name": "970",
              "subcategories": []
            },
            {
              "id": "wheel-loaders-caterpillar-970f",
              "name": "970F",
              "subcategories": []
            },
            {
              "id": "wheel-loaders-caterpillar-972",
              "name": "972",
              "subcategories": []
            },
            {
              "id": "wheel-loaders-caterpillar-972xe",
              "name": "972XE",
              "subcategories": []
            },
            {
              "id": "wheel-loaders-caterpillar-972g",
              "name": "972G",
              "subcategories": []
            },
            {
              "id": "wheel-loaders-caterpillar-972g-ii",
              "name": "972G II",
              "subcategories": []
            },
            {
              "id": "wheel-loaders-caterpillar-972h",
              "name": "972H",
              "subcategories": []
            },
            {
              "id": "wheel-loaders-caterpillar-972k",
              "name": "972K",
              "subcategories": []
            },
            {
              "id": "wheel-loaders-caterpillar-972m",
              "name": "972M",
              "subcategories": []
            },
            {
              "id": "wheel-loaders-caterpillar-972m-xe",
              "name": "972M XE",
              "subcategories": []
            },
            {
              "id": "wheel-loaders-caterpillar-980",
              "name": "980",
              "subcategories": []
            },
            {
              "id": "wheel-loaders-caterpillar-980b",
              "name": "980B",
              "subcategories": []
            },
            {
              "id": "wheel-loaders-caterpillar-980c",
              "name": "980C",
              "subcategories": []
            },
            {
              "id": "wheel-loaders-caterpillar-980f",
              "name": "980F",
              "subcategories": []
            },
            {
              "id": "wheel-loaders-caterpillar-980f-ii",
              "name": "980F II",
              "subcategories": []
            },
            {
              "id": "wheel-loaders-caterpillar-980g",
              "name": "980G",
              "subcategories": []
            },
            {
              "id": "wheel-loaders-caterpillar-980g-ii",
              "name": "980G II",
              "subcategories": []
            },
            {
              "id": "wheel-loaders-caterpillar-980h",
              "name": "980H",
              "subcategories": []
            },
            {
              "id": "wheel-loaders-caterpillar-980k",
              "name": "980K",
              "subcategories": []
            },
            {
              "id": "wheel-loaders-caterpillar-980l",
              "name": "980L",
              "subcategories": []
            },
            {
              "id": "wheel-loaders-caterpillar-980m",
              "name": "980M",
              "subcategories": []
            },
            {
              "id": "wheel-loaders-caterpillar-980xe",
              "name": "980XE",
              "subcategories": []
            },
            {
              "id": "wheel-loaders-caterpillar-982",
              "name": "982",
              "subcategories": []
            },
            {
              "id": "wheel-loaders-caterpillar-982m",
              "name": "982M",
              "subcategories": []
            },
            {
              "id": "wheel-loaders-caterpillar-982xe",
              "name": "982XE",
              "subcategories": []
            },
            {
              "id": "wheel-loaders-caterpillar-986",
              "name": "986",
              "subcategories": []
            },
            {
              "id": "wheel-loaders-caterpillar-986h",
              "name": "986H",
              "subcategories": []
            },
            {
              "id": "wheel-loaders-caterpillar-986k",
              "name": "986K",
              "subcategories": []
            },
            {
              "id": "wheel-loaders-caterpillar-988",
              "name": "988",
              "subcategories": []
            },
            {
              "id": "wheel-loaders-caterpillar-988a",
              "name": "988A",
              "subcategories": []
            },
            {
              "id": "wheel-loaders-caterpillar-988b",
              "name": "988B",
              "subcategories": []
            },
            {
              "id": "wheel-loaders-caterpillar-988f",
              "name": "988F",
              "subcategories": []
            },
            {
              "id": "wheel-loaders-caterpillar-988f-ii",
              "name": "988F II",
              "subcategories": []
            },
            {
              "id": "wheel-loaders-caterpillar-988g",
              "name": "988G",
              "subcategories": []
            },
            {
              "id": "wheel-loaders-caterpillar-988h",
              "name": "988H",
              "subcategories": []
            },
            {
              "id": "wheel-loaders-caterpillar-988k",
              "name": "988K",
              "subcategories": []
            },
            {
              "id": "wheel-loaders-caterpillar-988k-xe",
              "name": "988K XE",
              "subcategories": []
            },
            {
              "id": "wheel-loaders-caterpillar-990",
              "name": "990",
              "subcategories": []
            },
            {
              "id": "wheel-loaders-caterpillar-990-ii",
              "name": "990 II",
              "subcategories": []
            },
            {
              "id": "wheel-loaders-caterpillar-990h",
              "name": "990H",
              "subcategories": []
            },
            {
              "id": "wheel-loaders-caterpillar-990k",
              "name": "990K",
              "subcategories": []
            },
            {
              "id": "wheel-loaders-caterpillar-992",
              "name": "992",
              "subcategories": []
            },
            {
              "id": "wheel-loaders-caterpillar-992b",
              "name": "992B",
              "subcategories": []
            },
            {
              "id": "wheel-loaders-caterpillar-992c",
              "name": "992C",
              "subcategories": []
            },
            {
              "id": "wheel-loaders-caterpillar-992d",
              "name": "992D",
              "subcategories": []
            },
            {
              "id": "wheel-loaders-caterpillar-992g",
              "name": "992G",
              "subcategories": []
            },
            {
              "id": "wheel-loaders-caterpillar-992k",
              "name": "992K",
              "subcategories": []
            },
            {
              "id": "wheel-loaders-caterpillar-993",
              "name": "993",
              "subcategories": []
            },
            {
              "id": "wheel-loaders-caterpillar-993k",
              "name": "993K",
              "subcategories": []
            },
            {
              "id": "wheel-loaders-caterpillar-994",
              "name": "994",
              "subcategories": []
            },
            {
              "id": "wheel-loaders-caterpillar-994f",
              "name": "994F",
              "subcategories": []
            },
            {
              "id": "wheel-loaders-caterpillar-994h",
              "name": "994H",
              "subcategories": []
            },
            {
              "id": "wheel-loaders-caterpillar-it12",
              "name": "IT12",
              "subcategories": []
            },
            {
              "id": "wheel-loaders-caterpillar-it12f",
              "name": "IT12F",
              "subcategories": []
            },
            {
              "id": "wheel-loaders-caterpillar-it14",
              "name": "IT14",
              "subcategories": []
            },
            {
              "id": "wheel-loaders-caterpillar-it14g",
              "name": "IT14G",
              "subcategories": []
            },
            {
              "id": "wheel-loaders-caterpillar-it14g-ii",
              "name": "IT14G II",
              "subcategories": []
            },
            {
              "id": "wheel-loaders-caterpillar-it18",
              "name": "IT18",
              "subcategories": []
            },
            {
              "id": "wheel-loaders-caterpillar-it18b",
              "name": "IT18B",
              "subcategories": []
            },
            {
              "id": "wheel-loaders-caterpillar-it18f",
              "name": "IT18F",
              "subcategories": []
            },
            {
              "id": "wheel-loaders-caterpillar-it24",
              "name": "IT24",
              "subcategories": []
            },
            {
              "id": "wheel-loaders-caterpillar-it24f",
              "name": "IT24F",
              "subcategories": []
            },
            {
              "id": "wheel-loaders-caterpillar-it28",
              "name": "IT28",
              "subcategories": []
            },
            {
              "id": "wheel-loaders-caterpillar-it28b",
              "name": "IT28B",
              "subcategories": []
            },
            {
              "id": "wheel-loaders-caterpillar-it28f",
              "name": "IT28F",
              "subcategories": []
            },
            {
              "id": "wheel-loaders-caterpillar-it28g",
              "name": "IT28G",
              "subcategories": []
            },
            {
              "id": "wheel-loaders-caterpillar-it38",
              "name": "IT38",
              "subcategories": []
            },
            {
              "id": "wheel-loaders-caterpillar-it38f",
              "name": "IT38F",
              "subcategories": []
            },
            {
              "id": "wheel-loaders-caterpillar-it38g",
              "name": "IT38G",
              "subcategories": []
            },
            {
              "id": "wheel-loaders-caterpillar-it38g-ii",
              "name": "IT38G II",
              "subcategories": []
            },
            {
              "id": "wheel-loaders-caterpillar-it38h",
              "name": "IT38H",
              "subcategories": []
            },
            {
              "id": "wheel-loaders-caterpillar-it62",
              "name": "IT62",
              "subcategories": []
            },
            {
              "id": "wheel-loaders-caterpillar-it62g",
              "name": "IT62G",
              "subcategories": []
            },
            {
              "id": "wheel-loaders-caterpillar-it62g-ii",
              "name": "IT62G II",
              "subcategories": []
            },
            {
              "id": "wheel-loaders-caterpillar-it62h",
              "name": "IT62H",
              "subcategories": []
            },
            {
              "id": "wheel-loaders-caterpillar-r1300",
              "name": "R1300",
              "subcategories": []
            },
            {
              "id": "wheel-loaders-caterpillar-r1300g",
              "name": "R1300G",
              "subcategories": []
            },
            {
              "id": "wheel-loaders-caterpillar-r1300g-ii",
              "name": "R1300G II",
              "subcategories": []
            },
            {
              "id": "wheel-loaders-caterpillar-r1300h",
              "name": "R1300H",
              "subcategories": []
            },
            {
              "id": "wheel-loaders-caterpillar-r1600",
              "name": "R1600",
              "subcategories": []
            },
            {
              "id": "wheel-loaders-caterpillar-r1600g",
              "name": "R1600G",
              "subcategories": []
            },
            {
              "id": "wheel-loaders-caterpillar-r1600g-ii",
              "name": "R1600G II",
              "subcategories": []
            },
            {
              "id": "wheel-loaders-caterpillar-r1600h",
              "name": "R1600H",
              "subcategories": []
            },
            {
              "id": "wheel-loaders-caterpillar-r1700",
              "name": "R1700",
              "subcategories": []
            },
            {
              "id": "wheel-loaders-caterpillar-r1700g",
              "name": "R1700G",
              "subcategories": []
            },
            {
              "id": "wheel-loaders-caterpillar-r1700g-ii",
              "name": "R1700G II",
              "subcategories": []
            },
            {
              "id": "wheel-loaders-caterpillar-r1700h",
              "name": "R1700H",
              "subcategories": []
            },
            {
              "id": "wheel-loaders-caterpillar-r2900",
              "name": "R2900",
              "subcategories": []
            },
            {
              "id": "wheel-loaders-caterpillar-r2900g",
              "name": "R2900G",
              "subcategories": []
            },
            {
              "id": "wheel-loaders-caterpillar-r2900g-ii",
              "name": "R2900G II",
              "subcategories": []
            },
            {
              "id": "wheel-loaders-caterpillar-r2900h",
              "name": "R2900H",
              "subcategories": []
            },
            {
              "id": "wheel-loaders-caterpillar-r3000",
              "name": "R3000",
              "subcategories": []
            },
            {
              "id": "wheel-loaders-caterpillar-r300g",
              "name": "R300G",
              "subcategories": []
            },
            {
              "id": "wheel-loaders-caterpillar-r3000g-ii",
              "name": "R3000G II",
              "subcategories": []
            },
            {
              "id": "wheel-loaders-caterpillar-r3000h",
              "name": "R3000H",
              "subcategories": []
            },
            {
              "id": "wheel-loaders-caterpillar-other",
              "name": "OTHER",
              "subcategories": []
            }
          ]
        },
        {
          "id": "wheel-loaders-deere",
          "name": "Deere",
          "subcategories": [
            {
              "id": "wheel-loaders-deere-110",
              "name": "110",
              "subcategories": []
            },
            {
              "id": "wheel-loaders-deere-184",
              "name": "184",
              "subcategories": []
            },
            {
              "id": "wheel-loaders-deere-184-g",
              "name": "184 G",
              "subcategories": []
            },
            {
              "id": "wheel-loaders-deere-204",
              "name": "204",
              "subcategories": []
            },
            {
              "id": "wheel-loaders-deere-204g",
              "name": "204G",
              "subcategories": []
            },
            {
              "id": "wheel-loaders-deere-204k",
              "name": "204K",
              "subcategories": []
            },
            {
              "id": "wheel-loaders-deere-204l",
              "name": "204L",
              "subcategories": []
            },
            {
              "id": "wheel-loaders-deere-210c",
              "name": "210C",
              "subcategories": []
            },
            {
              "id": "wheel-loaders-deere-210le",
              "name": "210LE",
              "subcategories": []
            },
            {
              "id": "wheel-loaders-deere-244p",
              "name": "244P",
              "subcategories": []
            },
            {
              "id": "wheel-loaders-deere-244h",
              "name": "244H",
              "subcategories": []
            },
            {
              "id": "wheel-loaders-deere-244j",
              "name": "244J",
              "subcategories": []
            },
            {
              "id": "wheel-loaders-deere-244k",
              "name": "244K",
              "subcategories": []
            },
            {
              "id": "wheel-loaders-deere-244k-ii",
              "name": "244K II",
              "subcategories": []
            },
            {
              "id": "wheel-loaders-deere-244l",
              "name": "244L",
              "subcategories": []
            },
            {
              "id": "wheel-loaders-deere-304g",
              "name": "304G",
              "subcategories": []
            },
            {
              "id": "wheel-loaders-deere-304h",
              "name": "304H",
              "subcategories": []
            },
            {
              "id": "wheel-loaders-deere-304j",
              "name": "304J",
              "subcategories": []
            },
            {
              "id": "wheel-loaders-deere-304k",
              "name": "304K",
              "subcategories": []
            },
            {
              "id": "wheel-loaders-deere-304l",
              "name": "304L",
              "subcategories": []
            },
            {
              "id": "wheel-loaders-deere-324p",
              "name": "324P",
              "subcategories": []
            },
            {
              "id": "wheel-loaders-deere-324j",
              "name": "324J",
              "subcategories": []
            },
            {
              "id": "wheel-loaders-deere-324k",
              "name": "324K",
              "subcategories": []
            },
            {
              "id": "wheel-loaders-deere-324l",
              "name": "324L",
              "subcategories": []
            },
            {
              "id": "wheel-loaders-deere-344p",
              "name": "344P",
              "subcategories": []
            },
            {
              "id": "wheel-loaders-deere-344e",
              "name": "344E",
              "subcategories": []
            },
            {
              "id": "wheel-loaders-deere-344h",
              "name": "344H",
              "subcategories": []
            },
            {
              "id": "wheel-loaders-deere-344j",
              "name": "344J",
              "subcategories": []
            },
            {
              "id": "wheel-loaders-deere-344k",
              "name": "344K",
              "subcategories": []
            },
            {
              "id": "wheel-loaders-deere-344l",
              "name": "344L",
              "subcategories": []
            },
            {
              "id": "wheel-loaders-deere-444",
              "name": "444",
              "subcategories": []
            },
            {
              "id": "wheel-loaders-deere-444p",
              "name": "444P",
              "subcategories": []
            },
            {
              "id": "wheel-loaders-deere-444a",
              "name": "444A",
              "subcategories": []
            },
            {
              "id": "wheel-loaders-deere-444b",
              "name": "444B",
              "subcategories": []
            },
            {
              "id": "wheel-loaders-deere-444c",
              "name": "444C",
              "subcategories": []
            },
            {
              "id": "wheel-loaders-deere-444e",
              "name": "444E",
              "subcategories": []
            },
            {
              "id": "wheel-loaders-deere-444g",
              "name": "444G",
              "subcategories": []
            },
            {
              "id": "wheel-loaders-deere-444h",
              "name": "444H",
              "subcategories": []
            },
            {
              "id": "wheel-loaders-deere-444j",
              "name": "444J",
              "subcategories": []
            },
            {
              "id": "wheel-loaders-deere-444k",
              "name": "444K",
              "subcategories": []
            },
            {
              "id": "wheel-loaders-deere-444l",
              "name": "444L",
              "subcategories": []
            },
            {
              "id": "wheel-loaders-deere-524p",
              "name": "524P",
              "subcategories": []
            },
            {
              "id": "wheel-loaders-deere-524k",
              "name": "524K",
              "subcategories": []
            },
            {
              "id": "wheel-loaders-deere-524k-iii",
              "name": "524K III",
              "subcategories": []
            },
            {
              "id": "wheel-loaders-deere-524l",
              "name": "524L",
              "subcategories": []
            },
            {
              "id": "wheel-loaders-deere-544",
              "name": "544",
              "subcategories": []
            },
            {
              "id": "wheel-loaders-deere-544p",
              "name": "544P",
              "subcategories": []
            },
            {
              "id": "wheel-loaders-deere-544g-tier",
              "name": "544G-TIER",
              "subcategories": []
            },
            {
              "id": "wheel-loaders-deere-544b",
              "name": "544B",
              "subcategories": []
            },
            {
              "id": "wheel-loaders-deere-544bd",
              "name": "544BD",
              "subcategories": []
            },
            {
              "id": "wheel-loaders-deere-544c",
              "name": "544C",
              "subcategories": []
            },
            {
              "id": "wheel-loaders-deere-544d",
              "name": "544D",
              "subcategories": []
            },
            {
              "id": "wheel-loaders-deere-544e",
              "name": "544E",
              "subcategories": []
            },
            {
              "id": "wheel-loaders-deere-544e-ll",
              "name": "544E LL",
              "subcategories": []
            },
            {
              "id": "wheel-loaders-deere-544g",
              "name": "544G",
              "subcategories": []
            },
            {
              "id": "wheel-loaders-deere-544g-tc",
              "name": "544G TC",
              "subcategories": []
            },
            {
              "id": "wheel-loaders-deere-544h",
              "name": "544H",
              "subcategories": []
            },
            {
              "id": "wheel-loaders-deere-544j",
              "name": "544J",
              "subcategories": []
            },
            {
              "id": "wheel-loaders-deere-544k",
              "name": "544K",
              "subcategories": []
            },
            {
              "id": "wheel-loaders-deere-544k-ii",
              "name": "544K II",
              "subcategories": []
            },
            {
              "id": "wheel-loaders-deere-544l",
              "name": "544L",
              "subcategories": []
            },
            {
              "id": "wheel-loaders-deere-624",
              "name": "624",
              "subcategories": []
            },
            {
              "id": "wheel-loaders-deere-624p",
              "name": "624P",
              "subcategories": []
            },
            {
              "id": "wheel-loaders-deere-624e",
              "name": "624E",
              "subcategories": []
            },
            {
              "id": "wheel-loaders-deere-624eh",
              "name": "624EH",
              "subcategories": []
            },
            {
              "id": "wheel-loaders-deere-624g",
              "name": "624G",
              "subcategories": []
            },
            {
              "id": "wheel-loaders-deere-624gh",
              "name": "624GH",
              "subcategories": []
            },
            {
              "id": "wheel-loaders-deere-624h",
              "name": "624H",
              "subcategories": []
            },
            {
              "id": "wheel-loaders-deere-624j",
              "name": "624J",
              "subcategories": []
            },
            {
              "id": "wheel-loaders-deere-624k",
              "name": "624K",
              "subcategories": []
            },
            {
              "id": "wheel-loaders-deere-624k-wh",
              "name": "624K WH",
              "subcategories": []
            },
            {
              "id": "wheel-loaders-deere-624k-ii",
              "name": "624K II",
              "subcategories": []
            },
            {
              "id": "wheel-loaders-deere-624l",
              "name": "624L",
              "subcategories": []
            },
            {
              "id": "wheel-loaders-deere-644",
              "name": "644",
              "subcategories": []
            },
            {
              "id": "wheel-loaders-deere-644g-tier",
              "name": "644G-TIER",
              "subcategories": []
            },
            {
              "id": "wheel-loaders-deere-644p",
              "name": "644P",
              "subcategories": []
            },
            {
              "id": "wheel-loaders-deere-644x",
              "name": "644X",
              "subcategories": []
            },
            {
              "id": "wheel-loaders-deere-644a",
              "name": "644A",
              "subcategories": []
            },
            {
              "id": "wheel-loaders-deere-644b",
              "name": "644B",
              "subcategories": []
            },
            {
              "id": "wheel-loaders-deere-644c",
              "name": "644C",
              "subcategories": []
            },
            {
              "id": "wheel-loaders-deere-644cb",
              "name": "644CB",
              "subcategories": []
            },
            {
              "id": "wheel-loaders-deere-644d",
              "name": "644D",
              "subcategories": []
            },
            {
              "id": "wheel-loaders-deere-644e",
              "name": "644E",
              "subcategories": []
            },
            {
              "id": "wheel-loaders-deere-644ez",
              "name": "644EZ",
              "subcategories": []
            },
            {
              "id": "wheel-loaders-deere-644g-tier",
              "name": "644G-TIER",
              "subcategories": []
            },
            {
              "id": "wheel-loaders-deere-644h",
              "name": "644H",
              "subcategories": []
            },
            {
              "id": "wheel-loaders-deere-644j",
              "name": "644J",
              "subcategories": []
            },
            {
              "id": "wheel-loaders-deere-644k",
              "name": "644K",
              "subcategories": []
            },
            {
              "id": "wheel-loaders-deere-644k-hybrid",
              "name": "644K HYBRID",
              "subcategories": []
            },
            {
              "id": "wheel-loaders-deere-644kii",
              "name": "644KII",
              "subcategories": []
            },
            {
              "id": "wheel-loaders-deere-644l",
              "name": "644L",
              "subcategories": []
            },
            {
              "id": "wheel-loaders-deere-646a",
              "name": "646A",
              "subcategories": []
            },
            {
              "id": "wheel-loaders-deere-724p",
              "name": "724P",
              "subcategories": []
            },
            {
              "id": "wheel-loaders-deere-724j",
              "name": "724J",
              "subcategories": []
            },
            {
              "id": "wheel-loaders-deere-724k",
              "name": "724K",
              "subcategories": []
            },
            {
              "id": "wheel-loaders-deere-724l",
              "name": "724L",
              "subcategories": []
            },
            {
              "id": "wheel-loaders-deere-744",
              "name": "744",
              "subcategories": []
            },
            {
              "id": "wheel-loaders-deere-744p",
              "name": "744P",
              "subcategories": []
            },
            {
              "id": "wheel-loaders-deere-744e",
              "name": "744E",
              "subcategories": []
            },
            {
              "id": "wheel-loaders-deere-744h",
              "name": "744H",
              "subcategories": []
            },
            {
              "id": "wheel-loaders-deere-744h-mh",
              "name": "744H MH",
              "subcategories": []
            },
            {
              "id": "wheel-loaders-deere-744j",
              "name": "744J",
              "subcategories": []
            },
            {
              "id": "wheel-loaders-deere-744k",
              "name": "744K",
              "subcategories": []
            },
            {
              "id": "wheel-loaders-deere-744k-ii",
              "name": "744K II",
              "subcategories": []
            },
            {
              "id": "wheel-loaders-deere-744l",
              "name": "744L",
              "subcategories": []
            },
            {
              "id": "wheel-loaders-deere-744x",
              "name": "744X",
              "subcategories": []
            },
            {
              "id": "wheel-loaders-deere-824p",
              "name": "824P",
              "subcategories": []
            },
            {
              "id": "wheel-loaders-deere-824k",
              "name": "824K",
              "subcategories": []
            },
            {
              "id": "wheel-loaders-deere-824k-ii",
              "name": "824K II",
              "subcategories": []
            },
            {
              "id": "wheel-loaders-deere-824l",
              "name": "824L",
              "subcategories": []
            },
            {
              "id": "wheel-loaders-deere-844",
              "name": "844",
              "subcategories": []
            },
            {
              "id": "wheel-loaders-deere-844p",
              "name": "844P",
              "subcategories": []
            },
            {
              "id": "wheel-loaders-deere-844j",
              "name": "844J",
              "subcategories": []
            },
            {
              "id": "wheel-loaders-deere-844k",
              "name": "844K",
              "subcategories": []
            },
            {
              "id": "wheel-loaders-deere-844kii",
              "name": "844KII",
              "subcategories": []
            },
            {
              "id": "wheel-loaders-deere-844kiii",
              "name": "844KIII",
              "subcategories": []
            },
            {
              "id": "wheel-loaders-deere-844kiii-ah",
              "name": "844KIII-AH",
              "subcategories": []
            },
            {
              "id": "wheel-loaders-deere-844l",
              "name": "844L",
              "subcategories": []
            },
            {
              "id": "wheel-loaders-deere-3800",
              "name": "3800",
              "subcategories": []
            },
            {
              "id": "wheel-loaders-deere-tc44",
              "name": "TC44",
              "subcategories": []
            },
            {
              "id": "wheel-loaders-deere-tc44h",
              "name": "TC44H",
              "subcategories": []
            },
            {
              "id": "wheel-loaders-deere-tc54",
              "name": "TC54",
              "subcategories": []
            },
            {
              "id": "wheel-loaders-deere-tc54h",
              "name": "TC54H",
              "subcategories": []
            },
            {
              "id": "wheel-loaders-deere-tc62",
              "name": "TC62",
              "subcategories": []
            },
            {
              "id": "wheel-loaders-deere-tc62h",
              "name": "TC62H",
              "subcategories": []
            },
            {
              "id": "wheel-loaders-deere-wl56",
              "name": "WL56",
              "subcategories": []
            },
            {
              "id": "wheel-loaders-deere-other",
              "name": "OTHER",
              "subcategories": []
            }
          ]
        },
        {
          "id": "wheel-loaders-volvo",
          "name": "Volvo",
          "subcategories": [
            {
              "id": "wheel-loaders-volvo-110h",
              "name": "110H",
              "subcategories": []
            },
            {
              "id": "wheel-loaders-volvo-4200",
              "name": "4200",
              "subcategories": []
            },
            {
              "id": "wheel-loaders-volvo-4200b",
              "name": "4200B",
              "subcategories": []
            },
            {
              "id": "wheel-loaders-volvo-4300",
              "name": "4300",
              "subcategories": []
            },
            {
              "id": "wheel-loaders-volvo-4400",
              "name": "4400",
              "subcategories": []
            },
            {
              "id": "wheel-loaders-volvo-4500",
              "name": "4500",
              "subcategories": []
            },
            {
              "id": "wheel-loaders-volvo-4500b",
              "name": "4500B",
              "subcategories": []
            },
            {
              "id": "wheel-loaders-volvo-l20",
              "name": "L20",
              "subcategories": []
            },
            {
              "id": "wheel-loaders-volvo-l20-elec",
              "name": "L20 ELEC",
              "subcategories": []
            },
            {
              "id": "wheel-loaders-volvo-l20b",
              "name": "L20B",
              "subcategories": []
            },
            {
              "id": "wheel-loaders-volvo-l20f",
              "name": "L20F",
              "subcategories": []
            },
            {
              "id": "wheel-loaders-volvo-l20g",
              "name": "L20G",
              "subcategories": []
            },
            {
              "id": "wheel-loaders-volvo-l20h",
              "name": "L20H",
              "subcategories": []
            },
            {
              "id": "wheel-loaders-volvo-l25",
              "name": "L25",
              "subcategories": []
            },
            {
              "id": "wheel-loaders-volvo-l25-elec",
              "name": "L25 ELEC",
              "subcategories": []
            },
            {
              "id": "wheel-loaders-volvo-l25b",
              "name": "L25B",
              "subcategories": []
            },
            {
              "id": "wheel-loaders-volvo-l25f",
              "name": "L25F",
              "subcategories": []
            },
            {
              "id": "wheel-loaders-volvo-l25g",
              "name": "L25G",
              "subcategories": []
            },
            {
              "id": "wheel-loaders-volvo-l25h",
              "name": "L25H",
              "subcategories": []
            },
            {
              "id": "wheel-loaders-volvo-l30",
              "name": "L30",
              "subcategories": []
            },
            {
              "id": "wheel-loaders-volvo-l30b",
              "name": "L30B",
              "subcategories": []
            },
            {
              "id": "wheel-loaders-volvo-l30b-pro",
              "name": "L30B PRO",
              "subcategories": []
            },
            {
              "id": "wheel-loaders-volvo-l30f",
              "name": "L30F",
              "subcategories": []
            },
            {
              "id": "wheel-loaders-volvo-l30g",
              "name": "L30G",
              "subcategories": []
            },
            {
              "id": "wheel-loaders-volvo-l30h",
              "name": "L30H",
              "subcategories": []
            },
            {
              "id": "wheel-loaders-volvo-l35",
              "name": "L35",
              "subcategories": []
            },
            {
              "id": "wheel-loaders-volvo-l35b",
              "name": "L35B",
              "subcategories": []
            },
            {
              "id": "wheel-loaders-volvo-l35b-pro",
              "name": "L35B PRO",
              "subcategories": []
            },
            {
              "id": "wheel-loaders-volvo-l35f",
              "name": "L35F",
              "subcategories": []
            },
            {
              "id": "wheel-loaders-volvo-l35g",
              "name": "L35G",
              "subcategories": []
            },
            {
              "id": "wheel-loaders-volvo-l35h",
              "name": "L35H",
              "subcategories": []
            },
            {
              "id": "wheel-loaders-volvo-l40",
              "name": "L40",
              "subcategories": []
            },
            {
              "id": "wheel-loaders-volvo-l40b",
              "name": "L40B",
              "subcategories": []
            },
            {
              "id": "wheel-loaders-volvo-l40f",
              "name": "L40F",
              "subcategories": []
            },
            {
              "id": "wheel-loaders-volvo-l40g",
              "name": "L40G",
              "subcategories": []
            },
            {
              "id": "wheel-loaders-volvo-l40h",
              "name": "L40H",
              "subcategories": []
            },
            {
              "id": "wheel-loaders-volvo-l45",
              "name": "L45",
              "subcategories": []
            },
            {
              "id": "wheel-loaders-volvo-l45b",
              "name": "L45B",
              "subcategories": []
            },
            {
              "id": "wheel-loaders-volvo-l45f",
              "name": "L45F",
              "subcategories": []
            },
            {
              "id": "wheel-loaders-volvo-l45g",
              "name": "L45G",
              "subcategories": []
            },
            {
              "id": "wheel-loaders-volvo-l45h",
              "name": "L45H",
              "subcategories": []
            },
            {
              "id": "wheel-loaders-volvo-l50",
              "name": "L50",
              "subcategories": []
            },
            {
              "id": "wheel-loaders-volvo-l50c",
              "name": "L50C",
              "subcategories": []
            },
            {
              "id": "wheel-loaders-volvo-l50f",
              "name": "L50F",
              "subcategories": []
            },
            {
              "id": "wheel-loaders-volvo-l50g",
              "name": "L50G",
              "subcategories": []
            },
            {
              "id": "wheel-loaders-volvo-l50h",
              "name": "L50H",
              "subcategories": []
            },
            {
              "id": "wheel-loaders-volvo-l60",
              "name": "L60",
              "subcategories": []
            },
            {
              "id": "wheel-loaders-volvo-l60e",
              "name": "L60E",
              "subcategories": []
            },
            {
              "id": "wheel-loaders-volvo-l60f",
              "name": "L60F",
              "subcategories": []
            },
            {
              "id": "wheel-loaders-volvo-l60g",
              "name": "L60G",
              "subcategories": []
            },
            {
              "id": "wheel-loaders-volvo-l60h",
              "name": "L60H",
              "subcategories": []
            },
            {
              "id": "wheel-loaders-volvo-l70",
              "name": "L70",
              "subcategories": []
            },
            {
              "id": "wheel-loaders-volvo-l70b",
              "name": "L70B",
              "subcategories": []
            },
            {
              "id": "wheel-loaders-volvo-l70c",
              "name": "L70C",
              "subcategories": []
            },
            {
              "id": "wheel-loaders-volvo-l70d",
              "name": "L70D",
              "subcategories": []
            },
            {
              "id": "wheel-loaders-volvo-l70e",
              "name": "L70E",
              "subcategories": []
            },
            {
              "id": "wheel-loaders-volvo-l70f",
              "name": "L70F",
              "subcategories": []
            },
            {
              "id": "wheel-loaders-volvo-l70g",
              "name": "L70G",
              "subcategories": []
            },
            {
              "id": "wheel-loaders-volvo-l70h",
              "name": "L70H",
              "subcategories": []
            },
            {
              "id": "wheel-loaders-volvo-l90",
              "name": "L90",
              "subcategories": []
            },
            {
              "id": "wheel-loaders-volvo-l90b",
              "name": "L90B",
              "subcategories": []
            },
            {
              "id": "wheel-loaders-volvo-l90c",
              "name": "L90C",
              "subcategories": []
            },
            {
              "id": "wheel-loaders-volvo-l90d",
              "name": "L90D",
              "subcategories": []
            },
            {
              "id": "wheel-loaders-volvo-l90e",
              "name": "L90E",
              "subcategories": []
            },
            {
              "id": "wheel-loaders-volvo-l90f",
              "name": "L90F",
              "subcategories": []
            },
            {
              "id": "wheel-loaders-volvo-l90g",
              "name": "L90G",
              "subcategories": []
            },
            {
              "id": "wheel-loaders-volvo-l90h",
              "name": "L90H",
              "subcategories": []
            },
            {
              "id": "wheel-loaders-volvo-l105",
              "name": "L105",
              "subcategories": []
            },
            {
              "id": "wheel-loaders-volvo-l110",
              "name": "L110",
              "subcategories": []
            },
            {
              "id": "wheel-loaders-volvo-l110e",
              "name": "L110E",
              "subcategories": []
            },
            {
              "id": "wheel-loaders-volvo-l110f",
              "name": "L110F",
              "subcategories": []
            },
            {
              "id": "wheel-loaders-volvo-l110g",
              "name": "L110G",
              "subcategories": []
            },
            {
              "id": "wheel-loaders-volvo-l110h",
              "name": "L110H",
              "subcategories": []
            },
            {
              "id": "wheel-loaders-volvo-l120",
              "name": "L120",
              "subcategories": []
            },
            {
              "id": "wheel-loaders-volvo-l120-elec",
              "name": "L120 ELEC",
              "subcategories": []
            },
            {
              "id": "wheel-loaders-volvo-l120b",
              "name": "L120B",
              "subcategories": []
            },
            {
              "id": "wheel-loaders-volvo-l120c",
              "name": "L120C",
              "subcategories": []
            },
            {
              "id": "wheel-loaders-volvo-l120e",
              "name": "L120E",
              "subcategories": []
            },
            {
              "id": "wheel-loaders-volvo-l120f",
              "name": "L120F",
              "subcategories": []
            },
            {
              "id": "wheel-loaders-volvo-l120g",
              "name": "L120G",
              "subcategories": []
            },
            {
              "id": "wheel-loaders-volvo-l120h",
              "name": "L120H",
              "subcategories": []
            },
            {
              "id": "wheel-loaders-volvo-l140",
              "name": "L140",
              "subcategories": []
            },
            {
              "id": "wheel-loaders-volvo-l150",
              "name": "L150",
              "subcategories": []
            },
            {
              "id": "wheel-loaders-volvo-l150c",
              "name": "L150C",
              "subcategories": []
            },
            {
              "id": "wheel-loaders-volvo-l150e",
              "name": "L150E",
              "subcategories": []
            },
            {
              "id": "wheel-loaders-volvo-l150f",
              "name": "L150F",
              "subcategories": []
            },
            {
              "id": "wheel-loaders-volvo-l150g",
              "name": "L150G",
              "subcategories": []
            },
            {
              "id": "wheel-loaders-volvo-l150h",
              "name": "L150H",
              "subcategories": []
            },
            {
              "id": "wheel-loaders-volvo-l160",
              "name": "L160",
              "subcategories": []
            },
            {
              "id": "wheel-loaders-volvo-l180",
              "name": "L180",
              "subcategories": []
            },
            {
              "id": "wheel-loaders-volvo-l180c",
              "name": "L180C",
              "subcategories": []
            },
            {
              "id": "wheel-loaders-volvo-l180d",
              "name": "L180D",
              "subcategories": []
            },
            {
              "id": "wheel-loaders-volvo-l180e",
              "name": "L180E",
              "subcategories": []
            },
            {
              "id": "wheel-loaders-volvo-l180f",
              "name": "L180F",
              "subcategories": []
            },
            {
              "id": "wheel-loaders-volvo-l180g",
              "name": "L180G",
              "subcategories": []
            },
            {
              "id": "wheel-loaders-volvo-l180h",
              "name": "L180H",
              "subcategories": []
            },
            {
              "id": "wheel-loaders-volvo-l220",
              "name": "L220",
              "subcategories": []
            },
            {
              "id": "wheel-loaders-volvo-l220d",
              "name": "L220D",
              "subcategories": []
            },
            {
              "id": "wheel-loaders-volvo-l220e",
              "name": "L220E",
              "subcategories": []
            },
            {
              "id": "wheel-loaders-volvo-l220f",
              "name": "L220F",
              "subcategories": []
            },
            {
              "id": "wheel-loaders-volvo-l220g",
              "name": "L220G",
              "subcategories": []
            },
            {
              "id": "wheel-loaders-volvo-l220h",
              "name": "L220H",
              "subcategories": []
            },
            {
              "id": "wheel-loaders-volvo-l250",
              "name": "L250",
              "subcategories": []
            },
            {
              "id": "wheel-loaders-volvo-l250g",
              "name": "L250G",
              "subcategories": []
            },
            {
              "id": "wheel-loaders-volvo-l250h",
              "name": "L250H",
              "subcategories": []
            },
            {
              "id": "wheel-loaders-volvo-l260",
              "name": "L260",
              "subcategories": []
            },
            {
              "id": "wheel-loaders-volvo-l260g",
              "name": "L260G",
              "subcategories": []
            },
            {
              "id": "wheel-loaders-volvo-l260h",
              "name": "L260H",
              "subcategories": []
            },
            {
              "id": "wheel-loaders-volvo-l330",
              "name": "L330",
              "subcategories": []
            },
            {
              "id": "wheel-loaders-volvo-l330c",
              "name": "L330C",
              "subcategories": []
            },
            {
              "id": "wheel-loaders-volvo-l330d",
              "name": "L330D",
              "subcategories": []
            },
            {
              "id": "wheel-loaders-volvo-l330e",
              "name": "L330E",
              "subcategories": []
            },
            {
              "id": "wheel-loaders-volvo-l350",
              "name": "L350",
              "subcategories": []
            },
            {
              "id": "wheel-loaders-volvo-l350f",
              "name": "L350F",
              "subcategories": []
            },
            {
              "id": "wheel-loaders-volvo-l350h",
              "name": "L350H",
              "subcategories": []
            },
            {
              "id": "wheel-loaders-volvo-lm640",
              "name": "LM640",
              "subcategories": []
            },
            {
              "id": "wheel-loaders-volvo-lm641",
              "name": "LM641",
              "subcategories": []
            },
            {
              "id": "wheel-loaders-volvo-lm846",
              "name": "LM846",
              "subcategories": []
            },
            {
              "id": "wheel-loaders-volvo-lm1240",
              "name": "LM1240",
              "subcategories": []
            },
            {
              "id": "wheel-loaders-volvo-zl502",
              "name": "ZL502",
              "subcategories": []
            },
            {
              "id": "wheel-loaders-volvo-other",
              "name": "OTHER",
              "subcategories": []
            }
          ]
        },
        {
          "id": "wheel-loaders-komatsu",
          "name": "Komatsu",
          "subcategories": [
            {
              "id": "wheel-loaders-komatsu-530",
              "name": "530",
              "subcategories": []
            },
            {
              "id": "wheel-loaders-komatsu-sd10",
              "name": "SD10",
              "subcategories": []
            },
            {
              "id": "wheel-loaders-komatsu-w40",
              "name": "W40",
              "subcategories": []
            },
            {
              "id": "wheel-loaders-komatsu-w30",
              "name": "W30",
              "subcategories": []
            },
            {
              "id": "wheel-loaders-komatsu-wa20",
              "name": "WA20",
              "subcategories": []
            },
            {
              "id": "wheel-loaders-komatsu-wa30",
              "name": "WA30",
              "subcategories": []
            },
            {
              "id": "wheel-loaders-komatsu-wa50",
              "name": "WA50",
              "subcategories": []
            },
            {
              "id": "wheel-loaders-komatsu-wa65",
              "name": "WA65",
              "subcategories": []
            },
            {
              "id": "wheel-loaders-komatsu-wa70",
              "name": "WA70",
              "subcategories": []
            },
            {
              "id": "wheel-loaders-komatsu-wa75",
              "name": "WA75",
              "subcategories": []
            },
            {
              "id": "wheel-loaders-komatsu-wa80",
              "name": "WA80",
              "subcategories": []
            },
            {
              "id": "wheel-loaders-komatsu-wa95",
              "name": "WA95",
              "subcategories": []
            },
            {
              "id": "wheel-loaders-komatsu-wa100",
              "name": "WA100",
              "subcategories": []
            },
            {
              "id": "wheel-loaders-komatsu-wa120",
              "name": "WA120",
              "subcategories": []
            },
            {
              "id": "wheel-loaders-komatsu-wa150",
              "name": "WA150",
              "subcategories": []
            },
            {
              "id": "wheel-loaders-komatsu-wa180",
              "name": "WA180",
              "subcategories": []
            },
            {
              "id": "wheel-loaders-komatsu-wa200",
              "name": "WA200",
              "subcategories": []
            },
            {
              "id": "wheel-loaders-komatsu-wa250",
              "name": "WA250",
              "subcategories": []
            },
            {
              "id": "wheel-loaders-komatsu-wa270",
              "name": "WA270",
              "subcategories": []
            },
            {
              "id": "wheel-loaders-komatsu-wa300",
              "name": "WA300",
              "subcategories": []
            },
            {
              "id": "wheel-loaders-komatsu-wa320",
              "name": "WA320",
              "subcategories": []
            },
            {
              "id": "wheel-loaders-komatsu-wa350",
              "name": "WA350",
              "subcategories": []
            },
            {
              "id": "wheel-loaders-komatsu-wa360",
              "name": "WA360",
              "subcategories": []
            },
            {
              "id": "wheel-loaders-komatsu-wa380",
              "name": "WA380",
              "subcategories": []
            },
            {
              "id": "wheel-loaders-komatsu-wa400",
              "name": "WA400",
              "subcategories": []
            },
            {
              "id": "wheel-loaders-komatsu-wa420",
              "name": "WA420",
              "subcategories": []
            },
            {
              "id": "wheel-loaders-komatsu-wa430",
              "name": "WA430",
              "subcategories": []
            },
            {
              "id": "wheel-loaders-komatsu-wa450",
              "name": "WA450",
              "subcategories": []
            },
            {
              "id": "wheel-loaders-komatsu-wa470",
              "name": "WA470",
              "subcategories": []
            },
            {
              "id": "wheel-loaders-komatsu-wa475",
              "name": "WA475",
              "subcategories": []
            },
            {
              "id": "wheel-loaders-komatsu-wa480",
              "name": "WA480",
              "subcategories": []
            },
            {
              "id": "wheel-loaders-komatsu-wa485",
              "name": "WA485",
              "subcategories": []
            },
            {
              "id": "wheel-loaders-komatsu-wa500",
              "name": "WA500",
              "subcategories": []
            },
            {
              "id": "wheel-loaders-komatsu-wa600",
              "name": "WA600",
              "subcategories": []
            },
            {
              "id": "wheel-loaders-komatsu-wa700",
              "name": "WA700",
              "subcategories": []
            },
            {
              "id": "wheel-loaders-komatsu-wa800",
              "name": "WA800",
              "subcategories": []
            },
            {
              "id": "wheel-loaders-komatsu-wa900",
              "name": "WA900",
              "subcategories": []
            },
            {
              "id": "wheel-loaders-komatsu-wa1200",
              "name": "WA1200",
              "subcategories": []
            },
            {
              "id": "wheel-loaders-komatsu-other",
              "name": "OTHER",
              "subcategories": []
            }
          ]
        },
        {
          "id": "wheel-loaders-case",
          "name": "Case",
          "subcategories": [
            {
              "id": "wheel-loaders-case-21",
              "name": "21",
              "subcategories": []
            },
            {
              "id": "wheel-loaders-case-21f",
              "name": "21F",
              "subcategories": []
            },
            {
              "id": "wheel-loaders-case-21f-xt",
              "name": "21F XT",
              "subcategories": []
            },
            {
              "id": "wheel-loaders-case-121",
              "name": "121",
              "subcategories": []
            },
            {
              "id": "wheel-loaders-case-121e",
              "name": "121E",
              "subcategories": []
            },
            {
              "id": "wheel-loaders-case-121f",
              "name": "121F",
              "subcategories": []
            },
            {
              "id": "wheel-loaders-case-221",
              "name": "221",
              "subcategories": []
            },
            {
              "id": "wheel-loaders-case-221c",
              "name": "221C",
              "subcategories": []
            },
            {
              "id": "wheel-loaders-case-221d",
              "name": "221D",
              "subcategories": []
            },
            {
              "id": "wheel-loaders-case-221e",
              "name": "221E",
              "subcategories": []
            },
            {
              "id": "wheel-loaders-case-221f",
              "name": "221F",
              "subcategories": []
            },
            {
              "id": "wheel-loaders-case-321",
              "name": "321",
              "subcategories": []
            },
            {
              "id": "wheel-loaders-case-321c",
              "name": "321C",
              "subcategories": []
            },
            {
              "id": "wheel-loaders-case-321d",
              "name": "321D",
              "subcategories": []
            },
            {
              "id": "wheel-loaders-case-321f",
              "name": "321F",
              "subcategories": []
            },
            {
              "id": "wheel-loaders-case-380",
              "name": "380",
              "subcategories": []
            },
            {
              "id": "wheel-loaders-case-380b",
              "name": "380B",
              "subcategories": []
            },
            {
              "id": "wheel-loaders-case-421",
              "name": "421",
              "subcategories": []
            },
            {
              "id": "wheel-loaders-case-421b",
              "name": "421B",
              "subcategories": []
            },
            {
              "id": "wheel-loaders-case-421c",
              "name": "421C",
              "subcategories": []
            },
            {
              "id": "wheel-loaders-case-421d",
              "name": "421D",
              "subcategories": []
            },
            {
              "id": "wheel-loaders-case-421e",
              "name": "421E",
              "subcategories": []
            },
            {
              "id": "wheel-loaders-case-421f",
              "name": "421F",
              "subcategories": []
            },
            {
              "id": "wheel-loaders-case-421g",
              "name": "421G",
              "subcategories": []
            },
            {
              "id": "wheel-loaders-case-521",
              "name": "521",
              "subcategories": []
            },
            {
              "id": "wheel-loaders-case-521b",
              "name": "521B",
              "subcategories": []
            },
            {
              "id": "wheel-loaders-case-521c",
              "name": "521C",
              "subcategories": []
            },
            {
              "id": "wheel-loaders-case-521d",
              "name": "521D",
              "subcategories": []
            },
            {
              "id": "wheel-loaders-case-521e",
              "name": "521E",
              "subcategories": []
            },
            {
              "id": "wheel-loaders-case-521f",
              "name": "521F",
              "subcategories": []
            },
            {
              "id": "wheel-loaders-case-521g",
              "name": "521G",
              "subcategories": []
            },
            {
              "id": "wheel-loaders-case-570",
              "name": "570",
              "subcategories": []
            },
            {
              "id": "wheel-loaders-case-570m-xt",
              "name": "570M XT",
              "subcategories": []
            },
            {
              "id": "wheel-loaders-case-580",
              "name": "580",
              "subcategories": []
            },
            {
              "id": "wheel-loaders-case-580k",
              "name": "580K",
              "subcategories": []
            },
            {
              "id": "wheel-loaders-case-612",
              "name": "612",
              "subcategories": []
            },
            {
              "id": "wheel-loaders-case-612g",
              "name": "612G",
              "subcategories": []
            },
            {
              "id": "wheel-loaders-case-621",
              "name": "621",
              "subcategories": []
            },
            {
              "id": "wheel-loaders-case-621b",
              "name": "621B",
              "subcategories": []
            },
            {
              "id": "wheel-loaders-case-621c",
              "name": "621C",
              "subcategories": []
            },
            {
              "id": "wheel-loaders-case-621d",
              "name": "621D",
              "subcategories": []
            },
            {
              "id": "wheel-loaders-case-621e",
              "name": "621E",
              "subcategories": []
            },
            {
              "id": "wheel-loaders-case-621f",
              "name": "621F",
              "subcategories": []
            },
            {
              "id": "wheel-loaders-case-621g",
              "name": "621G",
              "subcategories": []
            },
            {
              "id": "wheel-loaders-case-621zf",
              "name": "621ZF",
              "subcategories": []
            },
            {
              "id": "wheel-loaders-case-651",
              "name": "651",
              "subcategories": []
            },
            {
              "id": "wheel-loaders-case-651g",
              "name": "651G",
              "subcategories": []
            },
            {
              "id": "wheel-loaders-case-721",
              "name": "721",
              "subcategories": []
            },
            {
              "id": "wheel-loaders-case-721b",
              "name": "721B",
              "subcategories": []
            },
            {
              "id": "wheel-loaders-case-721c",
              "name": "721C",
              "subcategories": []
            },
            {
              "id": "wheel-loaders-case-721d",
              "name": "721D",
              "subcategories": []
            },
            {
              "id": "wheel-loaders-case-721e",
              "name": "721E",
              "subcategories": []
            },
            {
              "id": "wheel-loaders-case-721f",
              "name": "721F",
              "subcategories": []
            },
            {
              "id": "wheel-loaders-case-721g",
              "name": "721G",
              "subcategories": []
            },
            {
              "id": "wheel-loaders-case-821",
              "name": "821",
              "subcategories": []
            },
            {
              "id": "wheel-loaders-case-821b",
              "name": "821B",
              "subcategories": []
            },
            {
              "id": "wheel-loaders-case-821c",
              "name": "821C",
              "subcategories": []
            },
            {
              "id": "wheel-loaders-case-821d",
              "name": "821D",
              "subcategories": []
            },
            {
              "id": "wheel-loaders-case-821e",
              "name": "821E",
              "subcategories": []
            },
            {
              "id": "wheel-loaders-case-821f",
              "name": "821F",
              "subcategories": []
            },
            {
              "id": "wheel-loaders-case-821g",
              "name": "821G",
              "subcategories": []
            },
            {
              "id": "wheel-loaders-case-921",
              "name": "921",
              "subcategories": []
            },
            {
              "id": "wheel-loaders-case-921b",
              "name": "921B",
              "subcategories": []
            },
            {
              "id": "wheel-loaders-case-921c",
              "name": "921C",
              "subcategories": []
            },
            {
              "id": "wheel-loaders-case-921d",
              "name": "921D",
              "subcategories": []
            },
            {
              "id": "wheel-loaders-case-921e",
              "name": "921E",
              "subcategories": []
            },
            {
              "id": "wheel-loaders-case-921f",
              "name": "921F",
              "subcategories": []
            },
            {
              "id": "wheel-loaders-case-921g",
              "name": "921G",
              "subcategories": []
            },
            {
              "id": "wheel-loaders-case-1021",
              "name": "1021",
              "subcategories": []
            },
            {
              "id": "wheel-loaders-case-1021c",
              "name": "1021C",
              "subcategories": []
            },
            {
              "id": "wheel-loaders-case-1021d",
              "name": "1021D",
              "subcategories": []
            },
            {
              "id": "wheel-loaders-case-1021f",
              "name": "1021F",
              "subcategories": []
            },
            {
              "id": "wheel-loaders-case-1021g",
              "name": "1021G",
              "subcategories": []
            },
            {
              "id": "wheel-loaders-case-1121",
              "name": "1121",
              "subcategories": []
            },
            {
              "id": "wheel-loaders-case-1121d",
              "name": "1121D",
              "subcategories": []
            },
            {
              "id": "wheel-loaders-case-1121g",
              "name": "1121G",
              "subcategories": []
            },
            {
              "id": "wheel-loaders-case-1121f",
              "name": "1121F",
              "subcategories": []
            },
            {
              "id": "wheel-loaders-case-1121g",
              "name": "1121G",
              "subcategories": []
            },
            {
              "id": "wheel-loaders-case-1221c",
              "name": "1221C",
              "subcategories": []
            },
            {
              "id": "wheel-loaders-case-1221d",
              "name": "1221D",
              "subcategories": []
            },
            {
              "id": "wheel-loaders-case-1221e",
              "name": "1221E",
              "subcategories": []
            },
            {
              "id": "wheel-loaders-case-1221f",
              "name": "1221F",
              "subcategories": []
            },
            {
              "id": "wheel-loaders-case-1221g",
              "name": "1221G",
              "subcategories": []
            },
            {
              "id": "wheel-loaders-case-mw24c",
              "name": "MW24C",
              "subcategories": []
            },
            {
              "id": "wheel-loaders-case-sl12",
              "name": "SL12",
              "subcategories": []
            },
            {
              "id": "wheel-loaders-case-sl15",
              "name": "SL15",
              "subcategories": []
            },
            {
              "id": "wheel-loaders-case-sl27",
              "name": "SL27",
              "subcategories": []
            },
            {
              "id": "wheel-loaders-case-sl50",
              "name": "SL50",
              "subcategories": []
            },
            {
              "id": "wheel-loaders-case-w11",
              "name": "W11",
              "subcategories": []
            },
            {
              "id": "wheel-loaders-case-w14",
              "name": "W14",
              "subcategories": []
            },
            {
              "id": "wheel-loaders-case-w15",
              "name": "W15",
              "subcategories": []
            },
            {
              "id": "wheel-loaders-case-w20",
              "name": "W20",
              "subcategories": []
            },
            {
              "id": "wheel-loaders-case-w24",
              "name": "W24",
              "subcategories": []
            },
            {
              "id": "wheel-loaders-case-w30",
              "name": "W30",
              "subcategories": []
            },
            {
              "id": "wheel-loaders-case-sl22",
              "name": "SL22",
              "subcategories": []
            },
            {
              "id": "wheel-loaders-case-sl23",
              "name": "SL23",
              "subcategories": []
            },
            {
              "id": "wheel-loaders-case-sl35",
              "name": "SL35",
              "subcategories": []
            },
            {
              "id": "wheel-loaders-case-other",
              "name": "OTHER",
              "subcategories": []
            }
          ]
        },
        {
          "id": "wheel-loaders-hyundai",
          "name": "Hyundai",
          "subcategories": [
            {
              "id": "wheel-loaders-hyundai-hl730",
              "name": "HL730",
              "subcategories": []
            },
            {
              "id": "wheel-loaders-hyundai-hl740",
              "name": "HL740",
              "subcategories": []
            },
            {
              "id": "wheel-loaders-hyundai-hl745",
              "name": "HL745",
              "subcategories": []
            },
            {
              "id": "wheel-loaders-hyundai-hl750",
              "name": "HL750",
              "subcategories": []
            },
            {
              "id": "wheel-loaders-hyundai-hl757",
              "name": "HL757",
              "subcategories": []
            },
            {
              "id": "wheel-loaders-hyundai-hl760",
              "name": "HL760",
              "subcategories": []
            },
            {
              "id": "wheel-loaders-hyundai-hl770",
              "name": "HL770",
              "subcategories": []
            },
            {
              "id": "wheel-loaders-hyundai-hl780",
              "name": "HL780",
              "subcategories": []
            },
            {
              "id": "wheel-loaders-hyundai-hl930",
              "name": "HL930",
              "subcategories": []
            },
            {
              "id": "wheel-loaders-hyundai-hl940",
              "name": "HL940",
              "subcategories": []
            },
            {
              "id": "wheel-loaders-hyundai-hl955",
              "name": "HL955",
              "subcategories": []
            },
            {
              "id": "wheel-loaders-hyundai-hl960",
              "name": "HL960",
              "subcategories": []
            },
            {
              "id": "wheel-loaders-hyundai-hl965",
              "name": "HL965",
              "subcategories": []
            },
            {
              "id": "wheel-loaders-hyundai-hl970",
              "name": "HL970",
              "subcategories": []
            },
            {
              "id": "wheel-loaders-hyundai-hl975",
              "name": "HL975",
              "subcategories": []
            },
            {
              "id": "wheel-loaders-hyundai-hl980",
              "name": "HL980",
              "subcategories": []
            },
            {
              "id": "wheel-loaders-hyundai-hl985",
              "name": "HL985",
              "subcategories": []
            },
            {
              "id": "wheel-loaders-hyundai-other",
              "name": "OTHER",
              "subcategories": []
            }
          ]
        },
        {
          "id": "wheel-loaders-jcb",
          "name": "Jcb",
          "subcategories": [
            {
              "id": "wheel-loaders-jcb-2cx",
              "name": "2CX",
              "subcategories": []
            },
            {
              "id": "wheel-loaders-jcb-3cx",
              "name": "3CX",
              "subcategories": []
            },
            {
              "id": "wheel-loaders-jcb-403",
              "name": "403",
              "subcategories": []
            },
            {
              "id": "wheel-loaders-jcb-406",
              "name": "406",
              "subcategories": []
            },
            {
              "id": "wheel-loaders-jcb-407",
              "name": "407",
              "subcategories": []
            },
            {
              "id": "wheel-loaders-jcb-408",
              "name": "408",
              "subcategories": []
            },
            {
              "id": "wheel-loaders-jcb-409",
              "name": "409",
              "subcategories": []
            },
            {
              "id": "wheel-loaders-jcb-410",
              "name": "410",
              "subcategories": []
            },
            {
              "id": "wheel-loaders-jcb-411",
              "name": "411",
              "subcategories": []
            },
            {
              "id": "wheel-loaders-jcb-414",
              "name": "414",
              "subcategories": []
            },
            {
              "id": "wheel-loaders-jcb-415",
              "name": "415",
              "subcategories": []
            },
            {
              "id": "wheel-loaders-jcb-416",
              "name": "416",
              "subcategories": []
            },
            {
              "id": "wheel-loaders-jcb-417",
              "name": "417",
              "subcategories": []
            },
            {
              "id": "wheel-loaders-jcb-419",
              "name": "419",
              "subcategories": []
            },
            {
              "id": "wheel-loaders-jcb-426",
              "name": "426",
              "subcategories": []
            },
            {
              "id": "wheel-loaders-jcb-427",
              "name": "427",
              "subcategories": []
            },
            {
              "id": "wheel-loaders-jcb-430",
              "name": "430",
              "subcategories": []
            },
            {
              "id": "wheel-loaders-jcb-434",
              "name": "434",
              "subcategories": []
            },
            {
              "id": "wheel-loaders-jcb-435",
              "name": "435",
              "subcategories": []
            },
            {
              "id": "wheel-loaders-jcb-436",
              "name": "436",
              "subcategories": []
            },
            {
              "id": "wheel-loaders-jcb-437",
              "name": "437",
              "subcategories": []
            },
            {
              "id": "wheel-loaders-jcb-455",
              "name": "455",
              "subcategories": []
            },
            {
              "id": "wheel-loaders-jcb-456",
              "name": "456",
              "subcategories": []
            },
            {
              "id": "wheel-loaders-jcb-457",
              "name": "457",
              "subcategories": []
            },
            {
              "id": "wheel-loaders-jcb-467",
              "name": "467",
              "subcategories": []
            },
            {
              "id": "wheel-loaders-jcb-tm110",
              "name": "TM110",
              "subcategories": []
            },
            {
              "id": "wheel-loaders-jcb-tm180",
              "name": "TM180",
              "subcategories": []
            },
            {
              "id": "wheel-loaders-jcb-tm220",
              "name": "TM220",
              "subcategories": []
            },
            {
              "id": "wheel-loaders-jcb-tm270",
              "name": "TM270",
              "subcategories": []
            },
            {
              "id": "wheel-loaders-jcb-tm280",
              "name": "TM280",
              "subcategories": []
            },
            {
              "id": "wheel-loaders-jcb-tm300",
              "name": "TM300",
              "subcategories": []
            },
            {
              "id": "wheel-loaders-jcb-tm310",
              "name": "TM310",
              "subcategories": []
            },
            {
              "id": "wheel-loaders-jcb-tm320",
              "name": "TM320",
              "subcategories": []
            },
            {
              "id": "wheel-loaders-jcb-tm420",
              "name": "TM420",
              "subcategories": []
            },
            {
              "id": "wheel-loaders-jcb-other",
              "name": "OTHER",
              "subcategories": []
            }
          ]
        },
        {
          "id": "wheel-loaders-hitachi",
          "name": "Hitachi",
          "subcategories": [
            {
              "id": "wheel-loaders-hitachi-lx20",
              "name": "LX20",
              "subcategories": []
            },
            {
              "id": "wheel-loaders-hitachi-lx70",
              "name": "LX70",
              "subcategories": []
            },
            {
              "id": "wheel-loaders-hitachi-lx100",
              "name": "LX100",
              "subcategories": []
            },
            {
              "id": "wheel-loaders-hitachi-lx110",
              "name": "LX110",
              "subcategories": []
            },
            {
              "id": "wheel-loaders-hitachi-lx120",
              "name": "LX120",
              "subcategories": []
            },
            {
              "id": "wheel-loaders-hitachi-lx150",
              "name": "LX150",
              "subcategories": []
            },
            {
              "id": "wheel-loaders-hitachi-lx210",
              "name": "LX210",
              "subcategories": []
            },
            {
              "id": "wheel-loaders-hitachi-lx290",
              "name": "LX290",
              "subcategories": []
            },
            {
              "id": "wheel-loaders-hitachi-zw30",
              "name": "ZW30",
              "subcategories": []
            },
            {
              "id": "wheel-loaders-hitachi-zw50",
              "name": "ZW50",
              "subcategories": []
            },
            {
              "id": "wheel-loaders-hitachi-zw65",
              "name": "ZW65",
              "subcategories": []
            },
            {
              "id": "wheel-loaders-hitachi-zw75",
              "name": "ZW75",
              "subcategories": []
            },
            {
              "id": "wheel-loaders-hitachi-zw80",
              "name": "ZW80",
              "subcategories": []
            },
            {
              "id": "wheel-loaders-hitachi-zw95",
              "name": "ZW95",
              "subcategories": []
            },
            {
              "id": "wheel-loaders-hitachi-zw100",
              "name": "ZW100",
              "subcategories": []
            },
            {
              "id": "wheel-loaders-hitachi-zw120",
              "name": "ZW120",
              "subcategories": []
            },
            {
              "id": "wheel-loaders-hitachi-zw140",
              "name": "ZW140",
              "subcategories": []
            },
            {
              "id": "wheel-loaders-hitachi-zw150",
              "name": "ZW150",
              "subcategories": []
            },
            {
              "id": "wheel-loaders-hitachi-zw160",
              "name": "ZW160",
              "subcategories": []
            },
            {
              "id": "wheel-loaders-hitachi-zw180",
              "name": "ZW180",
              "subcategories": []
            },
            {
              "id": "wheel-loaders-hitachi-zw220",
              "name": "ZW220",
              "subcategories": []
            },
            {
              "id": "wheel-loaders-hitachi-zw250",
              "name": "ZW250",
              "subcategories": []
            },
            {
              "id": "wheel-loaders-hitachi-zw310",
              "name": "ZW310",
              "subcategories": []
            },
            {
              "id": "wheel-loaders-hitachi-zw330",
              "name": "ZW330",
              "subcategories": []
            },
            {
              "id": "wheel-loaders-hitachi-zw370",
              "name": "ZW370",
              "subcategories": []
            },
            {
              "id": "wheel-loaders-hitachi-zw550",
              "name": "ZW550",
              "subcategories": []
            },
            {
              "id": "wheel-loaders-hitachi-other",
              "name": "OTHER",
              "subcategories": []
            }
          ]
        },
        {
          "id": "wheel-loaders-xcmg",
          "name": "Xcmg",
          "subcategories": [
            {
              "id": "wheel-loaders-xcmg-lw160",
              "name": "LW160",
              "subcategories": []
            },
            {
              "id": "wheel-loaders-xcmg-lw180",
              "name": "LW180",
              "subcategories": []
            },
            {
              "id": "wheel-loaders-xcmg-lw200",
              "name": "LW200",
              "subcategories": []
            },
            {
              "id": "wheel-loaders-xcmg-lw300",
              "name": "LW300",
              "subcategories": []
            },
            {
              "id": "wheel-loaders-xcmg-lw500",
              "name": "LW500",
              "subcategories": []
            },
            {
              "id": "wheel-loaders-xcmg-lw550",
              "name": "LW550",
              "subcategories": []
            },
            {
              "id": "wheel-loaders-xcmg-lw600",
              "name": "LW600",
              "subcategories": []
            },
            {
              "id": "wheel-loaders-xcmg-lw700",
              "name": "LW700",
              "subcategories": []
            },
            {
              "id": "wheel-loaders-xcmg-lw1200",
              "name": "LW1200",
              "subcategories": []
            },
            {
              "id": "wheel-loaders-xcmg-xc906",
              "name": "XC906",
              "subcategories": []
            },
            {
              "id": "wheel-loaders-xcmg-xc916",
              "name": "XC916",
              "subcategories": []
            },
            {
              "id": "wheel-loaders-xcmg-xc918",
              "name": "XC918",
              "subcategories": []
            },
            {
              "id": "wheel-loaders-xcmg-xc938",
              "name": "XC938",
              "subcategories": []
            },
            {
              "id": "wheel-loaders-xcmg-xc948",
              "name": "XC948",
              "subcategories": []
            },
            {
              "id": "wheel-loaders-xcmg-xc949",
              "name": "XC949",
              "subcategories": []
            },
            {
              "id": "wheel-loaders-xcmg-xc958",
              "name": "XC958",
              "subcategories": []
            },
            {
              "id": "wheel-loaders-xcmg-xc968",
              "name": "XC968",
              "subcategories": []
            },
            {
              "id": "wheel-loaders-xcmg-xc975",
              "name": "XC975",
              "subcategories": []
            },
            {
              "id": "wheel-loaders-xcmg-xc978",
              "name": "XC978",
              "subcategories": []
            },
            {
              "id": "wheel-loaders-xcmg-xc998",
              "name": "XC998",
              "subcategories": []
            },
            {
              "id": "wheel-loaders-xcmg-xc988",
              "name": "XC988",
              "subcategories": []
            },
            {
              "id": "wheel-loaders-xcmg-zl30",
              "name": "ZL30",
              "subcategories": []
            },
            {
              "id": "wheel-loaders-xcmg-zl50",
              "name": "ZL50",
              "subcategories": []
            },
            {
              "id": "wheel-loaders-xcmg-other",
              "name": "OTHER",
              "subcategories": []
            }
          ]
        },
        {
          "id": "wheel-loaders-liebherr",
          "name": "Liebherr",
          "subcategories": [
            {
              "id": "wheel-loaders-liebherr-l504",
              "name": "L504",
              "subcategories": []
            },
            {
              "id": "wheel-loaders-liebherr-l506",
              "name": "L506",
              "subcategories": []
            },
            {
              "id": "wheel-loaders-liebherr-l507",
              "name": "L507",
              "subcategories": []
            },
            {
              "id": "wheel-loaders-liebherr-l509",
              "name": "L509",
              "subcategories": []
            },
            {
              "id": "wheel-loaders-liebherr-l514",
              "name": "L514",
              "subcategories": []
            },
            {
              "id": "wheel-loaders-liebherr-l521",
              "name": "L521",
              "subcategories": []
            },
            {
              "id": "wheel-loaders-liebherr-l524",
              "name": "L524",
              "subcategories": []
            },
            {
              "id": "wheel-loaders-liebherr-l526",
              "name": "L526",
              "subcategories": []
            },
            {
              "id": "wheel-loaders-liebherr-l528",
              "name": "L528",
              "subcategories": []
            },
            {
              "id": "wheel-loaders-liebherr-l531",
              "name": "L531",
              "subcategories": []
            },
            {
              "id": "wheel-loaders-liebherr-l534",
              "name": "L534",
              "subcategories": []
            },
            {
              "id": "wheel-loaders-liebherr-l538",
              "name": "L538",
              "subcategories": []
            },
            {
              "id": "wheel-loaders-liebherr-l541",
              "name": "L541",
              "subcategories": []
            },
            {
              "id": "wheel-loaders-liebherr-l542",
              "name": "L542",
              "subcategories": []
            },
            {
              "id": "wheel-loaders-liebherr-l544",
              "name": "L544",
              "subcategories": []
            },
            {
              "id": "wheel-loaders-liebherr-l544",
              "name": "L544",
              "subcategories": []
            },
            {
              "id": "wheel-loaders-liebherr-l546",
              "name": "L546",
              "subcategories": []
            },
            {
              "id": "wheel-loaders-liebherr-l550",
              "name": "L550",
              "subcategories": []
            },
            {
              "id": "wheel-loaders-liebherr-l551",
              "name": "L551",
              "subcategories": []
            },
            {
              "id": "wheel-loaders-liebherr-l554",
              "name": "L554",
              "subcategories": []
            },
            {
              "id": "wheel-loaders-liebherr-l556",
              "name": "L556",
              "subcategories": []
            },
            {
              "id": "wheel-loaders-liebherr-l564",
              "name": "L564",
              "subcategories": []
            },
            {
              "id": "wheel-loaders-liebherr-l566",
              "name": "L566",
              "subcategories": []
            },
            {
              "id": "wheel-loaders-liebherr-l574",
              "name": "L574",
              "subcategories": []
            },
            {
              "id": "wheel-loaders-liebherr-l576",
              "name": "L576",
              "subcategories": []
            },
            {
              "id": "wheel-loaders-liebherr-l580",
              "name": "L580",
              "subcategories": []
            },
            {
              "id": "wheel-loaders-liebherr-l586",
              "name": "L586",
              "subcategories": []
            },
            {
              "id": "wheel-loaders-liebherr-other",
              "name": "OTHER",
              "subcategories": []
            }
          ]
        },
        {
          "id": "wheel-loaders-bobcat",
          "name": "Bobcat",
          "subcategories": [
            {
              "id": "wheel-loaders-bobcat-1600",
              "name": "1600",
              "subcategories": []
            },
            {
              "id": "wheel-loaders-bobcat-2000",
              "name": "2000",
              "subcategories": []
            },
            {
              "id": "wheel-loaders-bobcat-al3500",
              "name": "AL3500",
              "subcategories": []
            },
            {
              "id": "wheel-loaders-bobcat-l23",
              "name": "L23",
              "subcategories": []
            },
            {
              "id": "wheel-loaders-bobcat-l28",
              "name": "L28",
              "subcategories": []
            },
            {
              "id": "wheel-loaders-bobcat-l35",
              "name": "L35",
              "subcategories": []
            },
            {
              "id": "wheel-loaders-bobcat-l65",
              "name": "L65",
              "subcategories": []
            },
            {
              "id": "wheel-loaders-bobcat-l75",
              "name": "L75",
              "subcategories": []
            },
            {
              "id": "wheel-loaders-bobcat-l85",
              "name": "L85",
              "subcategories": []
            },
            {
              "id": "wheel-loaders-bobcat-l95",
              "name": "L95",
              "subcategories": []
            },
            {
              "id": "wheel-loaders-bobcat-l205",
              "name": "L205",
              "subcategories": []
            },
            {
              "id": "wheel-loaders-bobcat-l235",
              "name": "L235",
              "subcategories": []
            },
            {
              "id": "wheel-loaders-bobcat-l255",
              "name": "L255",
              "subcategories": []
            },
            {
              "id": "wheel-loaders-bobcat-l285",
              "name": "L285",
              "subcategories": []
            },
            {
              "id": "wheel-loaders-bobcat-other",
              "name": "OTHER",
              "subcategories": []
            }
          ]
        },
        {
          "id": "wheel-loaders-develon",
          "name": "Develon",
          "subcategories": [
            {
              "id": "wheel-loaders-develon-dl85",
              "name": "DL85",
              "subcategories": []
            },
            {
              "id": "wheel-loaders-develon-dl200",
              "name": "DL200",
              "subcategories": []
            },
            {
              "id": "wheel-loaders-develon-dl220",
              "name": "DL220",
              "subcategories": []
            },
            {
              "id": "wheel-loaders-develon-dl250",
              "name": "DL250",
              "subcategories": []
            },
            {
              "id": "wheel-loaders-develon-dl280",
              "name": "DL280",
              "subcategories": []
            },
            {
              "id": "wheel-loaders-develon-dl320",
              "name": "DL320",
              "subcategories": []
            },
            {
              "id": "wheel-loaders-develon-dl380",
              "name": "DL380",
              "subcategories": []
            },
            {
              "id": "wheel-loaders-develon-dl420",
              "name": "DL420",
              "subcategories": []
            },
            {
              "id": "wheel-loaders-develon-dl550",
              "name": "DL550",
              "subcategories": []
            },
            {
              "id": "wheel-loaders-develon-dl580",
              "name": "DL580",
              "subcategories": []
            },
            {
              "id": "wheel-loaders-develon-dl667",
              "name": "DL667",
              "subcategories": []
            },
            {
              "id": "wheel-loaders-develon-dl867",
              "name": "DL867",
              "subcategories": []
            },
            {
              "id": "wheel-loaders-develon-sd200",
              "name": "SD200",
              "subcategories": []
            },
            {
              "id": "wheel-loaders-develon-sd300",
              "name": "SD300",
              "subcategories": []
            },
            {
              "id": "wheel-loaders-develon-other",
              "name": "OTHER",
              "subcategories": []
            }
          ]
        },
        {
          "id": "wheel-loaders-doosan",
          "name": "Doosan",
          "subcategories": [
            {
              "id": "wheel-loaders-doosan-dl80",
              "name": "DL80",
              "subcategories": []
            },
            {
              "id": "wheel-loaders-doosan-dl200",
              "name": "DL200",
              "subcategories": []
            },
            {
              "id": "wheel-loaders-doosan-dl220",
              "name": "DL220",
              "subcategories": []
            },
            {
              "id": "wheel-loaders-doosan-dl250",
              "name": "DL250",
              "subcategories": []
            },
            {
              "id": "wheel-loaders-doosan-dl280",
              "name": "DL280",
              "subcategories": []
            },
            {
              "id": "wheel-loaders-doosan-dl300",
              "name": "DL300",
              "subcategories": []
            },
            {
              "id": "wheel-loaders-doosan-dl320",
              "name": "DL320",
              "subcategories": []
            },
            {
              "id": "wheel-loaders-doosan-dl350",
              "name": "DL350",
              "subcategories": []
            },
            {
              "id": "wheel-loaders-doosan-dl380",
              "name": "DL380",
              "subcategories": []
            },
            {
              "id": "wheel-loaders-doosan-dl400",
              "name": "DL400",
              "subcategories": []
            },
            {
              "id": "wheel-loaders-doosan-dl420",
              "name": "DL420",
              "subcategories": []
            },
            {
              "id": "wheel-loaders-doosan-dl450",
              "name": "DL450",
              "subcategories": []
            },
            {
              "id": "wheel-loaders-doosan-dl480",
              "name": "DL480",
              "subcategories": []
            },
            {
              "id": "wheel-loaders-doosan-dl500",
              "name": "DL500",
              "subcategories": []
            },
            {
              "id": "wheel-loaders-doosan-dl503",
              "name": "DL503",
              "subcategories": []
            },
            {
              "id": "wheel-loaders-doosan-dl550",
              "name": "DL550",
              "subcategories": []
            },
            {
              "id": "wheel-loaders-doosan-mega200",
              "name": "MEGA200",
              "subcategories": []
            },
            {
              "id": "wheel-loaders-doosan-mega250",
              "name": "MEGA250",
              "subcategories": []
            },
            {
              "id": "wheel-loaders-doosan-mega400",
              "name": "MEGA400",
              "subcategories": []
            },
            {
              "id": "wheel-loaders-doosan-sd200",
              "name": "SD200",
              "subcategories": []
            },
            {
              "id": "wheel-loaders-doosan-other",
              "name": "OTHER",
              "subcategories": []
            }
          ]
        },
        {
          "id": "wheel-loaders-gehl",
          "name": "Gehl",
          "subcategories": [
            {
              "id": "wheel-loaders-gehl-540",
              "name": "540",
              "subcategories": []
            },
            {
              "id": "wheel-loaders-gehl-650",
              "name": "650",
              "subcategories": []
            },
            {
              "id": "wheel-loaders-gehl-al330",
              "name": "AL330",
              "subcategories": []
            },
            {
              "id": "wheel-loaders-gehl-al530",
              "name": "AL530",
              "subcategories": []
            },
            {
              "id": "wheel-loaders-gehl-al540",
              "name": "AL540",
              "subcategories": []
            },
            {
              "id": "wheel-loaders-gehl-al550",
              "name": "AL550",
              "subcategories": []
            },
            {
              "id": "wheel-loaders-gehl-al650",
              "name": "AL650",
              "subcategories": []
            },
            {
              "id": "wheel-loaders-gehl-al750",
              "name": "AL750",
              "subcategories": []
            },
            {
              "id": "wheel-loaders-gehl-alt750",
              "name": "ALT750",
              "subcategories": []
            },
            {
              "id": "wheel-loaders-gehl-alt950",
              "name": "ALT950",
              "subcategories": []
            },
            {
              "id": "wheel-loaders-gehl-aws46",
              "name": "AWS46",
              "subcategories": []
            },
            {
              "id": "wheel-loaders-gehl-other",
              "name": "OTHER",
              "subcategories": []
            }
          ]
        },
        {
          "id": "wheel-loaders-giant",
          "name": "Giant",
          "subcategories": [
            {
              "id": "wheel-loaders-giant-d254",
              "name": "D254",
              "subcategories": []
            },
            {
              "id": "wheel-loaders-giant-d263",
              "name": "D263",
              "subcategories": []
            },
            {
              "id": "wheel-loaders-giant-g1100",
              "name": "G1100",
              "subcategories": []
            },
            {
              "id": "wheel-loaders-giant-g1200",
              "name": "G1200",
              "subcategories": []
            },
            {
              "id": "wheel-loaders-giant-g1500",
              "name": "G1500",
              "subcategories": []
            },
            {
              "id": "wheel-loaders-giant-g2200",
              "name": "G2200",
              "subcategories": []
            },
            {
              "id": "wheel-loaders-giant-g2300",
              "name": "G2300",
              "subcategories": []
            },
            {
              "id": "wheel-loaders-giant-g2500",
              "name": "G2500",
              "subcategories": []
            },
            {
              "id": "wheel-loaders-giant-g2700",
              "name": "G2700",
              "subcategories": []
            },
            {
              "id": "wheel-loaders-giant-g3500",
              "name": "G3500",
              "subcategories": []
            },
            {
              "id": "wheel-loaders-giant-g5000",
              "name": "G5000",
              "subcategories": []
            },
            {
              "id": "wheel-loaders-giant-v452",
              "name": "V452",
              "subcategories": []
            },
            {
              "id": "wheel-loaders-giant-v6004",
              "name": "V6004",
              "subcategories": []
            },
            {
              "id": "wheel-loaders-giant-other",
              "name": "OTHER",
              "subcategories": []
            }
          ]
        },
        {
          "id": "wheel-loaders-kawasaki",
          "name": "Kawasaki",
          "subcategories": [
            {
              "id": "wheel-loaders-kawasaki-42z",
              "name": "42Z",
              "subcategories": []
            },
            {
              "id": "wheel-loaders-kawasaki-45z",
              "name": "45Z",
              "subcategories": []
            },
            {
              "id": "wheel-loaders-kawasaki-50z",
              "name": "50Z",
              "subcategories": []
            },
            {
              "id": "wheel-loaders-kawasaki-60z",
              "name": "60Z",
              "subcategories": []
            },
            {
              "id": "wheel-loaders-kawasaki-62z",
              "name": "62Z",
              "subcategories": []
            },
            {
              "id": "wheel-loaders-kawasaki-65t",
              "name": "65T",
              "subcategories": []
            },
            {
              "id": "wheel-loaders-kawasaki-65z",
              "name": "65Z",
              "subcategories": []
            },
            {
              "id": "wheel-loaders-kawasaki-67z",
              "name": "67Z",
              "subcategories": []
            },
            {
              "id": "wheel-loaders-kawasaki-70tm",
              "name": "70TM",
              "subcategories": []
            },
            {
              "id": "wheel-loaders-kawasaki-70z",
              "name": "70Z",
              "subcategories": []
            },
            {
              "id": "wheel-loaders-kawasaki-80z",
              "name": "80Z",
              "subcategories": []
            },
            {
              "id": "wheel-loaders-kawasaki-85z",
              "name": "85Z",
              "subcategories": []
            },
            {
              "id": "wheel-loaders-kawasaki-90z",
              "name": "90Z",
              "subcategories": []
            },
            {
              "id": "wheel-loaders-kawasaki-92z",
              "name": "92Z",
              "subcategories": []
            },
            {
              "id": "wheel-loaders-kawasaki-95z",
              "name": "95Z",
              "subcategories": []
            },
            {
              "id": "wheel-loaders-kawasaki-110z",
              "name": "110Z",
              "subcategories": []
            },
            {
              "id": "wheel-loaders-kawasaki-z115z",
              "name": "Z115Z",
              "subcategories": []
            },
            {
              "id": "wheel-loaders-kawasaki-kss95z",
              "name": "KSS95Z",
              "subcategories": []
            },
            {
              "id": "wheel-loaders-kawasaki-other",
              "name": "OTHER",
              "subcategories": []
            }
          ]
        },
        {
          "id": "wheel-loaders-kubota",
          "name": "Kubota",
          "subcategories": [
            {
              "id": "wheel-loaders-kubota-m59",
              "name": "M59",
              "subcategories": []
            },
            {
              "id": "wheel-loaders-kubota-r065",
              "name": "R065",
              "subcategories": []
            },
            {
              "id": "wheel-loaders-kubota-r070",
              "name": "R070",
              "subcategories": []
            },
            {
              "id": "wheel-loaders-kubota-r082",
              "name": "R082",
              "subcategories": []
            },
            {
              "id": "wheel-loaders-kubota-r090",
              "name": "R090",
              "subcategories": []
            },
            {
              "id": "wheel-loaders-kubota-r410",
              "name": "R410",
              "subcategories": []
            },
            {
              "id": "wheel-loaders-kubota-r420",
              "name": "R420",
              "subcategories": []
            },
            {
              "id": "wheel-loaders-kubota-r430",
              "name": "R430",
              "subcategories": []
            },
            {
              "id": "wheel-loaders-kubota-r520",
              "name": "R520",
              "subcategories": []
            },
            {
              "id": "wheel-loaders-kubota-r530",
              "name": "R530",
              "subcategories": []
            },
            {
              "id": "wheel-loaders-kubota-r540",
              "name": "R540",
              "subcategories": []
            },
            {
              "id": "wheel-loaders-kubota-r630",
              "name": "R630",
              "subcategories": []
            },
            {
              "id": "wheel-loaders-kubota-r640",
              "name": "R640",
              "subcategories": []
            },
            {
              "id": "wheel-loaders-kubota-ra401",
              "name": "RA401",
              "subcategories": []
            },
            {
              "id": "wheel-loaders-kubota-rt100",
              "name": "RT100",
              "subcategories": []
            },
            {
              "id": "wheel-loaders-kubota-rt150",
              "name": "RT150",
              "subcategories": []
            },
            {
              "id": "wheel-loaders-kubota-rt210",
              "name": "RT210",
              "subcategories": []
            },
            {
              "id": "wheel-loaders-kubota-rt270",
              "name": "RT270",
              "subcategories": []
            },
            {
              "id": "wheel-loaders-kubota-rt280",
              "name": "RT280",
              "subcategories": []
            },
            {
              "id": "wheel-loaders-kubota-other",
              "name": "OTHER",
              "subcategories": []
            }
          ]
        },
        {
          "id": "wheel-loaders-manitou",
          "name": "Manitou",
          "subcategories": [
            {
              "id": "wheel-loaders-manitou-al85t",
              "name": "AL85T",
              "subcategories": []
            },
            {
              "id": "wheel-loaders-manitou-mla2",
              "name": "MLA2",
              "subcategories": []
            },
            {
              "id": "wheel-loaders-manitou-mla3",
              "name": "MLA3",
              "subcategories": []
            },
            {
              "id": "wheel-loaders-manitou-mla4",
              "name": "MLA4",
              "subcategories": []
            },
            {
              "id": "wheel-loaders-manitou-mla5",
              "name": "MLA5",
              "subcategories": []
            },
            {
              "id": "wheel-loaders-manitou-mla6",
              "name": "MLA6",
              "subcategories": []
            },
            {
              "id": "wheel-loaders-manitou-mla7",
              "name": "MLA7",
              "subcategories": []
            },
            {
              "id": "wheel-loaders-manitou-mla533",
              "name": "MLA533",
              "subcategories": []
            },
            {
              "id": "wheel-loaders-manitou-mla628",
              "name": "MLA628",
              "subcategories": []
            },
            {
              "id": "wheel-loaders-manitou-mla630",
              "name": "MLA630",
              "subcategories": []
            },
            {
              "id": "wheel-loaders-manitou-mlat516",
              "name": "MLAT516",
              "subcategories": []
            },
            {
              "id": "wheel-loaders-manitou-mlat533",
              "name": "MLAT533",
              "subcategories": []
            },
            {
              "id": "wheel-loaders-manitou-mt728",
              "name": "MT728",
              "subcategories": []
            },
            {
              "id": "wheel-loaders-manitou-other",
              "name": "OTHER",
              "subcategories": []
            }
          ]
        },
        {
          "id": "wheel-loaders-new-holland",
          "name": "New Holland",
          "subcategories": [
            {
              "id": "wheel-loaders-new-holland-445",
              "name": "445",
              "subcategories": []
            },
            {
              "id": "wheel-loaders-new-holland-lw90",
              "name": "LW90",
              "subcategories": []
            },
            {
              "id": "wheel-loaders-new-holland-lw110",
              "name": "LW110",
              "subcategories": []
            },
            {
              "id": "wheel-loaders-new-holland-lw170",
              "name": "LW170",
              "subcategories": []
            },
            {
              "id": "wheel-loaders-new-holland-lw230",
              "name": "LW230",
              "subcategories": []
            },
            {
              "id": "wheel-loaders-new-holland-lw270",
              "name": "LW270",
              "subcategories": []
            },
            {
              "id": "wheel-loaders-new-holland-ml12",
              "name": "ML12",
              "subcategories": []
            },
            {
              "id": "wheel-loaders-new-holland-ml15",
              "name": "ML15",
              "subcategories": []
            },
            {
              "id": "wheel-loaders-new-holland-ml23",
              "name": "ML23",
              "subcategories": []
            },
            {
              "id": "wheel-loaders-new-holland-ml27",
              "name": "ML27",
              "subcategories": []
            },
            {
              "id": "wheel-loaders-new-holland-ml35",
              "name": "ML35",
              "subcategories": []
            },
            {
              "id": "wheel-loaders-new-holland-ml50",
              "name": "ML50",
              "subcategories": []
            },
            {
              "id": "wheel-loaders-new-holland-w50",
              "name": "W50",
              "subcategories": []
            },
            {
              "id": "wheel-loaders-new-holland-w60",
              "name": "W60",
              "subcategories": []
            },
            {
              "id": "wheel-loaders-new-holland-w70",
              "name": "W70",
              "subcategories": []
            },
            {
              "id": "wheel-loaders-new-holland-w80",
              "name": "W80",
              "subcategories": []
            },
            {
              "id": "wheel-loaders-new-holland-w100",
              "name": "W100",
              "subcategories": []
            },
            {
              "id": "wheel-loaders-new-holland-w110",
              "name": "W110",
              "subcategories": []
            },
            {
              "id": "wheel-loaders-new-holland-w130",
              "name": "W130",
              "subcategories": []
            },
            {
              "id": "wheel-loaders-new-holland-w170",
              "name": "W170",
              "subcategories": []
            },
            {
              "id": "wheel-loaders-new-holland-w190",
              "name": "W190",
              "subcategories": []
            },
            {
              "id": "wheel-loaders-new-holland-w270",
              "name": "W270",
              "subcategories": []
            },
            {
              "id": "wheel-loaders-new-holland-w271",
              "name": "W271",
              "subcategories": []
            },
            {
              "id": "wheel-loaders-new-holland-other",
              "name": "OTHER",
              "subcategories": []
            }
          ]
        },
        {
          "id": "wheel-loaders-yanmar",
          "name": "Yanmar",
          "subcategories": [
            {
              "id": "wheel-loaders-yanmar-v1",
              "name": "V1",
              "subcategories": []
            },
            {
              "id": "wheel-loaders-yanmar-v2",
              "name": "V2",
              "subcategories": []
            },
            {
              "id": "wheel-loaders-yanmar-v3",
              "name": "V3",
              "subcategories": []
            },
            {
              "id": "wheel-loaders-yanmar-v4",
              "name": "V4",
              "subcategories": []
            },
            {
              "id": "wheel-loaders-yanmar-v7",
              "name": "V7",
              "subcategories": []
            },
            {
              "id": "wheel-loaders-yanmar-v8",
              "name": "V8",
              "subcategories": []
            },
            {
              "id": "wheel-loaders-yanmar-v10",
              "name": "V10",
              "subcategories": []
            },
            {
              "id": "wheel-loaders-yanmar-v12",
              "name": "V12",
              "subcategories": []
            },
            {
              "id": "wheel-loaders-yanmar-v70",
              "name": "V70",
              "subcategories": []
            },
            {
              "id": "wheel-loaders-yanmar-v80",
              "name": "V80",
              "subcategories": []
            },
            {
              "id": "wheel-loaders-yanmar-v100",
              "name": "V100",
              "subcategories": []
            },
            {
              "id": "wheel-loaders-yanmar-v120",
              "name": "V120",
              "subcategories": []
            },
            {
              "id": "wheel-loaders-yanmar-other",
              "name": "OTHER",
              "subcategories": []
            }
          ]
        },
        {
          "id": "wheel-loaders-liugong",
          "name": "Liugong",
          "subcategories": []
        }
      ]
    },
    {
      "id": "attatchments-parts",
      "name": "Attatchments / Parts",
      "subcategories": [
        {
          "id": "attatchments-parts-attachments",
          "name": "Attachments",
          "subcategories": [
            {
              "id": "attatchments-parts-attachments-excavator-parts-attachments",
              "name": "EXCAVATOR - PARTS / ATTACHMENTS",
              "subcategories": []
            },
            {
              "id": "attatchments-parts-attachments-skid-steer-parts-attachments",
              "name": "SKID STEER - PARTS / ATTACHMENTS",
              "subcategories": []
            },
            {
              "id": "attatchments-parts-attachments-wheel-loader-parts-attachments",
              "name": "WHEEL LOADER - PARTS / ATTACHMENTS",
              "subcategories": []
            },
            {
              "id": "attatchments-parts-attachments-dozer-attachments",
              "name": "DOZER ATTACHMENTS",
              "subcategories": []
            },
            {
              "id": "attatchments-parts-attachments-backhoe-attachments",
              "name": "BACKHOE ATTACHMENTS",
              "subcategories": []
            },
            {
              "id": "attatchments-parts-attachments-asphalt-attachments",
              "name": "ASPHALT ATTACHMENTS",
              "subcategories": []
            },
            {
              "id": "attatchments-parts-attachments-crane-attachments",
              "name": "CRANE ATTACHMENTS",
              "subcategories": []
            },
            {
              "id": "attatchments-parts-attachments-dozer-attachments",
              "name": "DOZER ATTACHMENTS",
              "subcategories": []
            },
            {
              "id": "attatchments-parts-attachments-motor-grader-attachments",
              "name": "MOTOR GRADER ATTACHMENTS",
              "subcategories": []
            }
          ]
        },
        {
          "id": "attatchments-parts-excavator-parts-attachments",
          "name": "Excavator - Parts / Attachments",
          "subcategories": []
        },
        {
          "id": "attatchments-parts-skid-steer-parts-attachments",
          "name": "Skid Steer - Parts / Attachments",
          "subcategories": []
        },
        {
          "id": "attatchments-parts-wheel-loader-parts-attachments",
          "name": "Wheel Loader - Parts / Attachments",
          "subcategories": []
        },
        {
          "id": "attatchments-parts-dozer-attachments",
          "name": "Dozer Attachments",
          "subcategories": []
        },
        {
          "id": "attatchments-parts-backhoe-attachments",
          "name": "Backhoe Attachments",
          "subcategories": []
        },
        {
          "id": "attatchments-parts-asphalt-attachments",
          "name": "Asphalt Attachments",
          "subcategories": []
        },
        {
          "id": "attatchments-parts-crane-attachments",
          "name": "Crane Attachments",
          "subcategories": []
        },
        {
          "id": "attatchments-parts-dozer-attachments",
          "name": "Dozer Attachments",
          "subcategories": []
        },
        {
          "id": "attatchments-parts-motor-grader-attachments",
          "name": "Motor Grader Attachments",
          "subcategories": []
        }
      ]
    },
    {
      "id": "support-equipment",
      "name": "Support Equipment",
      "subcategories": [
        {
          "id": "support-equipment-dumpers",
          "name": "Dumpers",
          "subcategories": [
            {
              "id": "support-equipment-dumpers-wacker-nueson",
              "name": "WACKER NUESON",
              "subcategories": []
            },
            {
              "id": "support-equipment-dumpers-thwaites",
              "name": "THWAITES",
              "subcategories": []
            },
            {
              "id": "support-equipment-dumpers-jcb",
              "name": "JCB",
              "subcategories": []
            },
            {
              "id": "support-equipment-dumpers-ausa",
              "name": "AUSA",
              "subcategories": []
            },
            {
              "id": "support-equipment-dumpers-mecalac",
              "name": "MECALAC",
              "subcategories": []
            },
            {
              "id": "support-equipment-dumpers-terex",
              "name": "TEREX",
              "subcategories": []
            },
            {
              "id": "support-equipment-dumpers-messersi",
              "name": "MESSERSI",
              "subcategories": []
            },
            {
              "id": "support-equipment-dumpers-fiori",
              "name": "FIORI",
              "subcategories": []
            },
            {
              "id": "support-equipment-dumpers-sdlanch",
              "name": "SDLANCH",
              "subcategories": []
            },
            {
              "id": "support-equipment-dumpers-cormidi",
              "name": "CORMIDI",
              "subcategories": []
            },
            {
              "id": "support-equipment-dumpers-barford",
              "name": "BARFORD",
              "subcategories": []
            },
            {
              "id": "support-equipment-dumpers-benford",
              "name": "BENFORD",
              "subcategories": []
            },
            {
              "id": "support-equipment-dumpers-bergman",
              "name": "BERGMAN",
              "subcategories": []
            },
            {
              "id": "support-equipment-dumpers-hydrema",
              "name": "HYDREMA",
              "subcategories": []
            },
            {
              "id": "support-equipment-dumpers-kubota",
              "name": "KUBOTA",
              "subcategories": []
            },
            {
              "id": "support-equipment-dumpers-merlo",
              "name": "MERLO",
              "subcategories": []
            },
            {
              "id": "support-equipment-dumpers-nc-engineering",
              "name": "NC ENGINEERING",
              "subcategories": []
            },
            {
              "id": "support-equipment-dumpers-uhi",
              "name": "UHI",
              "subcategories": []
            },
            {
              "id": "support-equipment-dumpers-yanmar",
              "name": "YANMAR",
              "subcategories": []
            },
            {
              "id": "support-equipment-dumpers-other",
              "name": "OTHER",
              "subcategories": []
            }
          ]
        },
        {
          "id": "support-equipment-air-compressors",
          "name": "Air Compressors",
          "subcategories": [
            {
              "id": "support-equipment-air-compressors-atlas-copco",
              "name": "ATLAS COPCO",
              "subcategories": []
            },
            {
              "id": "support-equipment-air-compressors-sullair",
              "name": "SULLAIR",
              "subcategories": []
            },
            {
              "id": "support-equipment-air-compressors-doosan",
              "name": "DOOSAN",
              "subcategories": []
            },
            {
              "id": "support-equipment-air-compressors-ingersoll-rand",
              "name": "INGERSOLL-RAND",
              "subcategories": []
            },
            {
              "id": "support-equipment-air-compressors-sullivan-palatek",
              "name": "SULLIVAN PALATEK",
              "subcategories": []
            },
            {
              "id": "support-equipment-air-compressors-kaeser",
              "name": "KAESER",
              "subcategories": []
            },
            {
              "id": "support-equipment-air-compressors-compare",
              "name": "COMPARE",
              "subcategories": []
            },
            {
              "id": "support-equipment-air-compressors-chi-pnuematic",
              "name": "CHI PNUEMATIC",
              "subcategories": []
            },
            {
              "id": "support-equipment-air-compressors-airman",
              "name": "AIRMAN",
              "subcategories": []
            },
            {
              "id": "support-equipment-air-compressors-bobcat",
              "name": "BOBCAT",
              "subcategories": []
            },
            {
              "id": "support-equipment-air-compressors-gardner-denver",
              "name": "GARDNER-DENVER",
              "subcategories": []
            },
            {
              "id": "support-equipment-air-compressors-multiquip",
              "name": "MULTIQUIP",
              "subcategories": []
            },
            {
              "id": "support-equipment-air-compressors-quincy",
              "name": "QUINCY",
              "subcategories": []
            },
            {
              "id": "support-equipment-air-compressors-rotair",
              "name": "ROTAIR",
              "subcategories": []
            },
            {
              "id": "support-equipment-air-compressors-sullivan",
              "name": "SULLIVAN",
              "subcategories": []
            },
            {
              "id": "support-equipment-air-compressors-winair-compressor",
              "name": "WINAIR COMPRESSOR",
              "subcategories": []
            },
            {
              "id": "support-equipment-air-compressors-other",
              "name": "OTHER",
              "subcategories": []
            }
          ]
        },
        {
          "id": "support-equipment-generators",
          "name": "Generators",
          "subcategories": [
            {
              "id": "support-equipment-generators-caterpillar",
              "name": "CATERPILLAR",
              "subcategories": []
            },
            {
              "id": "support-equipment-generators-multiquip-whisperwatt",
              "name": "MULTIQUIP WHISPERWATT",
              "subcategories": []
            },
            {
              "id": "support-equipment-generators-cummins",
              "name": "CUMMINS",
              "subcategories": []
            },
            {
              "id": "support-equipment-generators-atlas-copco",
              "name": "ATLAS COPCO",
              "subcategories": []
            },
            {
              "id": "support-equipment-generators-generac",
              "name": "GENERAC",
              "subcategories": []
            },
            {
              "id": "support-equipment-generators-wacker-nueson",
              "name": "WACKER NUESON",
              "subcategories": []
            },
            {
              "id": "support-equipment-generators-kohler",
              "name": "KOHLER",
              "subcategories": []
            },
            {
              "id": "support-equipment-generators-doosan",
              "name": "DOOSAN",
              "subcategories": []
            },
            {
              "id": "support-equipment-generators-airman",
              "name": "AIRMAN",
              "subcategories": []
            },
            {
              "id": "support-equipment-generators-miller",
              "name": "MILLER",
              "subcategories": []
            },
            {
              "id": "support-equipment-generators-aksa",
              "name": "AKSA",
              "subcategories": []
            },
            {
              "id": "support-equipment-generators-allmand-bros",
              "name": "ALLMAND BROS",
              "subcategories": []
            },
            {
              "id": "support-equipment-generators-ashita",
              "name": "ASHITA",
              "subcategories": []
            },
            {
              "id": "support-equipment-generators-baldor",
              "name": "BALDOR",
              "subcategories": []
            },
            {
              "id": "support-equipment-generators-baumalight",
              "name": "BAUMALIGHT",
              "subcategories": []
            },
            {
              "id": "support-equipment-generators-be-power-equip",
              "name": "BE POWER EQUIP",
              "subcategories": []
            },
            {
              "id": "support-equipment-generators-briggs-stratton",
              "name": "BRIGGS & STRATTON",
              "subcategories": []
            },
            {
              "id": "support-equipment-generators-champion-power",
              "name": "CHAMPION POWER",
              "subcategories": []
            },
            {
              "id": "support-equipment-generators-chi-pnuematic",
              "name": "CHI PNUEMATIC",
              "subcategories": []
            },
            {
              "id": "support-equipment-generators-ck-p-ower",
              "name": "CK P[OWER",
              "subcategories": []
            },
            {
              "id": "support-equipment-generators-coleman",
              "name": "COLEMAN",
              "subcategories": []
            },
            {
              "id": "support-equipment-generators-deere",
              "name": "DEERE",
              "subcategories": []
            },
            {
              "id": "support-equipment-generators-detroit",
              "name": "DETROIT",
              "subcategories": []
            },
            {
              "id": "support-equipment-generators-deutz",
              "name": "DEUTZ",
              "subcategories": []
            },
            {
              "id": "support-equipment-generators-fg-wilson",
              "name": "FG WILSON",
              "subcategories": []
            },
            {
              "id": "support-equipment-generators-genpower",
              "name": "GENPOWER",
              "subcategories": []
            },
            {
              "id": "support-equipment-generators-giga-power",
              "name": "GIGA POWER",
              "subcategories": []
            },
            {
              "id": "support-equipment-generators-gillette",
              "name": "GILLETTE",
              "subcategories": []
            },
            {
              "id": "support-equipment-generators-himoinsa",
              "name": "HIMOINSA",
              "subcategories": []
            },
            {
              "id": "support-equipment-generators-hipower",
              "name": "HIPOWER",
              "subcategories": []
            },
            {
              "id": "support-equipment-generators-honda",
              "name": "HONDA",
              "subcategories": []
            },
            {
              "id": "support-equipment-generators-hustler",
              "name": "HUSTLER",
              "subcategories": []
            },
            {
              "id": "support-equipment-generators-ingersol-rand",
              "name": "INGERSOL RAND",
              "subcategories": []
            },
            {
              "id": "support-equipment-generators-iveco",
              "name": "IVECO",
              "subcategories": []
            },
            {
              "id": "support-equipment-generators-jcb",
              "name": "JCB",
              "subcategories": []
            },
            {
              "id": "support-equipment-generators-isuzu",
              "name": "ISUZU",
              "subcategories": []
            },
            {
              "id": "support-equipment-generators-jenbacher",
              "name": "JENBACHER",
              "subcategories": []
            },
            {
              "id": "support-equipment-generators-katolight",
              "name": "KATOLIGHT",
              "subcategories": []
            },
            {
              "id": "support-equipment-generators-kubota",
              "name": "KUBOTA",
              "subcategories": []
            },
            {
              "id": "support-equipment-generators-leroy-somer",
              "name": "LEROY SOMER",
              "subcategories": []
            },
            {
              "id": "support-equipment-generators-libby",
              "name": "LIBBY",
              "subcategories": []
            },
            {
              "id": "support-equipment-generators-lincoln-electric",
              "name": "LINCOLN ELECTRIC",
              "subcategories": []
            },
            {
              "id": "support-equipment-generators-magnum",
              "name": "MAGNUM",
              "subcategories": []
            },
            {
              "id": "support-equipment-generators-makinex",
              "name": "MAKINEX",
              "subcategories": []
            },
            {
              "id": "support-equipment-generators-marathon",
              "name": "MARATHON",
              "subcategories": []
            },
            {
              "id": "support-equipment-generators-marelli",
              "name": "MARELLI",
              "subcategories": []
            },
            {
              "id": "support-equipment-generators-miller",
              "name": "MILLER",
              "subcategories": []
            },
            {
              "id": "support-equipment-generators-mosa",
              "name": "MOSA",
              "subcategories": []
            },
            {
              "id": "support-equipment-generators-mps",
              "name": "MPS",
              "subcategories": []
            },
            {
              "id": "support-equipment-generators-multiquip-whisperwatt",
              "name": "MULTIQUIP WHISPERWATT",
              "subcategories": []
            },
            {
              "id": "support-equipment-generators-olympian",
              "name": "OLYMPIAN",
              "subcategories": []
            },
            {
              "id": "support-equipment-generators-onan",
              "name": "ONAN",
              "subcategories": []
            },
            {
              "id": "support-equipment-generators-perkins",
              "name": "PERKINS",
              "subcategories": []
            },
            {
              "id": "support-equipment-generators-powerlink",
              "name": "POWERLINK",
              "subcategories": []
            },
            {
              "id": "support-equipment-generators-powersource",
              "name": "POWERSOURCE",
              "subcategories": []
            },
            {
              "id": "support-equipment-generators-pramac",
              "name": "PRAMAC",
              "subcategories": []
            },
            {
              "id": "support-equipment-generators-rte",
              "name": "RTE",
              "subcategories": []
            },
            {
              "id": "support-equipment-generators-scania",
              "name": "SCANIA",
              "subcategories": []
            },
            {
              "id": "support-equipment-generators-sdmo",
              "name": "SDMO",
              "subcategories": []
            },
            {
              "id": "support-equipment-generators-shindaiwa",
              "name": "SHINDAIWA",
              "subcategories": []
            },
            {
              "id": "support-equipment-generators-spectrum",
              "name": "SPECTRUM",
              "subcategories": []
            },
            {
              "id": "support-equipment-generators-stamford",
              "name": "STAMFORD",
              "subcategories": []
            },
            {
              "id": "support-equipment-generators-taylor-power-sysytems",
              "name": "TAYLOR POWER SYSYTEMS",
              "subcategories": []
            },
            {
              "id": "support-equipment-generators-tecnogen",
              "name": "TECNOGEN",
              "subcategories": []
            },
            {
              "id": "support-equipment-generators-volvo-penta",
              "name": "VOLVO PENTA",
              "subcategories": []
            },
            {
              "id": "support-equipment-generators-wanco",
              "name": "WANCO",
              "subcategories": []
            },
            {
              "id": "support-equipment-generators-waukesha",
              "name": "WAUKESHA",
              "subcategories": []
            },
            {
              "id": "support-equipment-generators-winco",
              "name": "WINCO",
              "subcategories": []
            },
            {
              "id": "support-equipment-generators-winpower",
              "name": "WINPOWER",
              "subcategories": []
            },
            {
              "id": "support-equipment-generators-yamaha",
              "name": "YAMAHA",
              "subcategories": []
            },
            {
              "id": "support-equipment-generators-yamakoyo",
              "name": "YAMAKOYO",
              "subcategories": []
            },
            {
              "id": "support-equipment-generators-yanmar",
              "name": "YANMAR",
              "subcategories": []
            },
            {
              "id": "support-equipment-generators-other",
              "name": "OTHER",
              "subcategories": []
            }
          ]
        },
        {
          "id": "support-equipment-heaters",
          "name": "Heaters",
          "subcategories": [
            {
              "id": "support-equipment-heaters-campco-equipment",
              "name": "CAMPCO EQUIPMENT",
              "subcategories": []
            },
            {
              "id": "support-equipment-heaters-lb-white",
              "name": "LB WHITE",
              "subcategories": []
            },
            {
              "id": "support-equipment-heaters-wacker-nueson",
              "name": "WACKER NUESON",
              "subcategories": []
            },
            {
              "id": "support-equipment-heaters-frost-fighter",
              "name": "FROST FIGHTER",
              "subcategories": []
            },
            {
              "id": "support-equipment-heaters-flagro",
              "name": "FLAGRO",
              "subcategories": []
            },
            {
              "id": "support-equipment-heaters-allmand-bros",
              "name": "ALLMAND BROS",
              "subcategories": []
            },
            {
              "id": "support-equipment-heaters-heat-king",
              "name": "HEAT KING",
              "subcategories": []
            },
            {
              "id": "support-equipment-heaters-dewalt",
              "name": "DEWALT",
              "subcategories": []
            },
            {
              "id": "support-equipment-heaters-generac",
              "name": "GENERAC",
              "subcategories": []
            },
            {
              "id": "support-equipment-heaters-thawzall",
              "name": "THAWZALL",
              "subcategories": []
            },
            {
              "id": "support-equipment-heaters-dryair",
              "name": "DRYAIR",
              "subcategories": []
            },
            {
              "id": "support-equipment-heaters-ground-heater",
              "name": "GROUND HEATER",
              "subcategories": []
            },
            {
              "id": "support-equipment-heaters-quest",
              "name": "QUEST",
              "subcategories": []
            },
            {
              "id": "support-equipment-heaters-sunfire",
              "name": "SUNFIRE",
              "subcategories": []
            },
            {
              "id": "support-equipment-heaters-unspecified",
              "name": "UNSPECIFIED",
              "subcategories": []
            },
            {
              "id": "support-equipment-heaters-other",
              "name": "OTHER",
              "subcategories": []
            }
          ]
        },
        {
          "id": "support-equipment-light-towers",
          "name": "Light Towers",
          "subcategories": [
            {
              "id": "support-equipment-light-towers-magnum",
              "name": "MAGNUM",
              "subcategories": []
            },
            {
              "id": "support-equipment-light-towers-allmand-bros",
              "name": "ALLMAND BROS",
              "subcategories": []
            },
            {
              "id": "support-equipment-light-towers-generac",
              "name": "GENERAC",
              "subcategories": []
            },
            {
              "id": "support-equipment-light-towers-wacker-nueson",
              "name": "WACKER NUESON",
              "subcategories": []
            },
            {
              "id": "support-equipment-light-towers-atlas-copco",
              "name": "ATLAS COPCO",
              "subcategories": []
            },
            {
              "id": "support-equipment-light-towers-wanco",
              "name": "WANCO",
              "subcategories": []
            },
            {
              "id": "support-equipment-light-towers-progress-solar-solutions",
              "name": "PROGRESS SOLAR SOLUTIONS",
              "subcategories": []
            },
            {
              "id": "support-equipment-light-towers-terex",
              "name": "TEREX",
              "subcategories": []
            },
            {
              "id": "support-equipment-light-towers-doosan",
              "name": "DOOSAN",
              "subcategories": []
            },
            {
              "id": "support-equipment-light-towers-uhi",
              "name": "UHI",
              "subcategories": []
            },
            {
              "id": "support-equipment-light-towers-axiom-equip",
              "name": "AXIOM EQUIP",
              "subcategories": []
            },
            {
              "id": "support-equipment-light-towers-bobcat",
              "name": "BOBCAT",
              "subcategories": []
            },
            {
              "id": "support-equipment-light-towers-chi-pnuematic",
              "name": "CHI PNUEMATIC",
              "subcategories": []
            },
            {
              "id": "support-equipment-light-towers-genie",
              "name": "GENIE",
              "subcategories": []
            },
            {
              "id": "support-equipment-light-towers-genmac",
              "name": "GENMAC",
              "subcategories": []
            },
            {
              "id": "support-equipment-light-towers-ingersol-rand",
              "name": "INGERSOL RAND",
              "subcategories": []
            },
            {
              "id": "support-equipment-light-towers-multiquip",
              "name": "MULTIQUIP",
              "subcategories": []
            },
            {
              "id": "support-equipment-light-towers-national-signal",
              "name": "NATIONAL SIGNAL",
              "subcategories": []
            },
            {
              "id": "support-equipment-light-towers-tower-light",
              "name": "TOWER LIGHT",
              "subcategories": []
            },
            {
              "id": "support-equipment-light-towers-trime",
              "name": "TRIME",
              "subcategories": []
            },
            {
              "id": "support-equipment-light-towers-uhi",
              "name": "UHI",
              "subcategories": []
            },
            {
              "id": "support-equipment-light-towers-unspecified",
              "name": "UNSPECIFIED",
              "subcategories": []
            },
            {
              "id": "support-equipment-light-towers-yanmar",
              "name": "YANMAR",
              "subcategories": []
            },
            {
              "id": "support-equipment-light-towers-other",
              "name": "OTHER",
              "subcategories": []
            }
          ]
        },
        {
          "id": "support-equipment-pumps",
          "name": "Pumps",
          "subcategories": [
            {
              "id": "support-equipment-pumps-wacker-nueson",
              "name": "WACKER NUESON",
              "subcategories": []
            },
            {
              "id": "support-equipment-pumps-cornell",
              "name": "CORNELL",
              "subcategories": []
            },
            {
              "id": "support-equipment-pumps-multiquip",
              "name": "MULTIQUIP",
              "subcategories": []
            },
            {
              "id": "support-equipment-pumps-godwin",
              "name": "GODWIN",
              "subcategories": []
            },
            {
              "id": "support-equipment-pumps-be-power-equipment",
              "name": "BE POWER EQUIPMENT",
              "subcategories": []
            },
            {
              "id": "support-equipment-pumps-tsurumi",
              "name": "TSURUMI",
              "subcategories": []
            },
            {
              "id": "support-equipment-pumps-gorman-rupp",
              "name": "GORMAN-RUPP",
              "subcategories": []
            },
            {
              "id": "support-equipment-pumps-unspecified",
              "name": "UNSPECIFIED",
              "subcategories": []
            },
            {
              "id": "support-equipment-pumps-atlas-copco",
              "name": "ATLAS COPCO",
              "subcategories": []
            },
            {
              "id": "support-equipment-pumps-honda",
              "name": "HONDA",
              "subcategories": []
            },
            {
              "id": "support-equipment-pumps-other",
              "name": "OTHER",
              "subcategories": []
            }
          ]
        },
        {
          "id": "support-equipment-vacuum-excavators",
          "name": "Vacuum Excavators",
          "subcategories": []
        },
        {
          "id": "support-equipment-other",
          "name": "Other",
          "subcategories": []
        }
      ]
    },
    {
      "id": "utility-carts",
      "name": "Utility Carts",
      "subcategories": [
        {
          "id": "utility-carts-john-deere",
          "name": "John Deere",
          "subcategories": []
        },
        {
          "id": "utility-carts-kubota",
          "name": "Kubota",
          "subcategories": [
            {
              "id": "utility-carts-kubota-rtv400-a",
              "name": "RTV400-A",
              "subcategories": []
            },
            {
              "id": "utility-carts-kubota-rtv400ci",
              "name": "RTV400CI",
              "subcategories": []
            },
            {
              "id": "utility-carts-kubota-rtv400ci-a",
              "name": "RTV400CI-A",
              "subcategories": []
            },
            {
              "id": "utility-carts-kubota-rtv400ci-h",
              "name": "RTV400CI-H",
              "subcategories": []
            },
            {
              "id": "utility-carts-kubota-rtv400cir-a",
              "name": "RTV400CIR-A",
              "subcategories": []
            },
            {
              "id": "utility-carts-kubota-rtv500",
              "name": "RTV500",
              "subcategories": []
            },
            {
              "id": "utility-carts-kubota-rtv500-h",
              "name": "RTV500-H",
              "subcategories": []
            },
            {
              "id": "utility-carts-kubota-rtv500r-a",
              "name": "RTV500R-A",
              "subcategories": []
            },
            {
              "id": "utility-carts-kubota-rtv520d",
              "name": "RTV520D",
              "subcategories": []
            },
            {
              "id": "utility-carts-kubota-rtv520d-as",
              "name": "RTV520D-AS",
              "subcategories": []
            },
            {
              "id": "utility-carts-kubota-rtv900",
              "name": "RTV900",
              "subcategories": []
            },
            {
              "id": "utility-carts-kubota-rtv900-eu",
              "name": "RTV900-EU",
              "subcategories": []
            },
            {
              "id": "utility-carts-kubota-rtv900g",
              "name": "RTV900G",
              "subcategories": []
            },
            {
              "id": "utility-carts-kubota-rtv900r",
              "name": "RTV900R",
              "subcategories": []
            },
            {
              "id": "utility-carts-kubota-rtv900r6-a",
              "name": "RTV900R6-A",
              "subcategories": []
            },
            {
              "id": "utility-carts-kubota-rtv900w6h",
              "name": "RTV900W6H",
              "subcategories": []
            },
            {
              "id": "utility-carts-kubota-rtv900w9a",
              "name": "RTV900W9A",
              "subcategories": []
            },
            {
              "id": "utility-carts-kubota-rtv900xt",
              "name": "RTV900XT",
              "subcategories": []
            },
            {
              "id": "utility-carts-kubota-rtv900xtr",
              "name": "RTV900XTR",
              "subcategories": []
            },
            {
              "id": "utility-carts-kubota-rtv900xts",
              "name": "RTV900XTS",
              "subcategories": []
            },
            {
              "id": "utility-carts-kubota-rtv900xtw",
              "name": "RTV900XTW",
              "subcategories": []
            },
            {
              "id": "utility-carts-kubota-rtv1100",
              "name": "RTV1100",
              "subcategories": []
            },
            {
              "id": "utility-carts-kubota-rtv1100c",
              "name": "RTV1100C",
              "subcategories": []
            },
            {
              "id": "utility-carts-kubota-rtv1140",
              "name": "RTV1140",
              "subcategories": []
            },
            {
              "id": "utility-carts-kubota-rtv1140cpx",
              "name": "RTV1140CPX",
              "subcategories": []
            },
            {
              "id": "utility-carts-kubota-rtv1140cpx-h",
              "name": "RTV1140CPX-H",
              "subcategories": []
            },
            {
              "id": "utility-carts-kubota-rtv1140pxr-a",
              "name": "RTV1140PXR-A",
              "subcategories": []
            },
            {
              "id": "utility-carts-kubota-rtv1140cpx-uk",
              "name": "RTV1140CPX-UK",
              "subcategories": []
            },
            {
              "id": "utility-carts-kubota-rtv-x",
              "name": "RTV-X",
              "subcategories": []
            },
            {
              "id": "utility-carts-kubota-rtv-x-crew",
              "name": "RTV-X CREW",
              "subcategories": []
            },
            {
              "id": "utility-carts-kubota-rtv-xg850-sidekick",
              "name": "RTV-XG850 SIDEKICK",
              "subcategories": []
            },
            {
              "id": "utility-carts-kubota-rtv-x900",
              "name": "RTV-X900",
              "subcategories": []
            },
            {
              "id": "utility-carts-kubota-rtv-x900g",
              "name": "RTV-X900G",
              "subcategories": []
            },
            {
              "id": "utility-carts-kubota-rtv-x900r",
              "name": "RTV-X900R",
              "subcategories": []
            },
            {
              "id": "utility-carts-kubota-rtv-x900w",
              "name": "RTV-X900W",
              "subcategories": []
            },
            {
              "id": "utility-carts-kubota-rtv-x1110",
              "name": "RTV-X1110",
              "subcategories": []
            },
            {
              "id": "utility-carts-kubota-rtv-x1100c",
              "name": "RTV-X1100C",
              "subcategories": []
            },
            {
              "id": "utility-carts-kubota-rtv-x1100cw-h",
              "name": "RTV-X1100CW-H",
              "subcategories": []
            },
            {
              "id": "utility-carts-kubota-rtv-x1100cr",
              "name": "RTV-X1100CR",
              "subcategories": []
            },
            {
              "id": "utility-carts-kubota-rtv-x1100crl-a",
              "name": "RTV-X1100CRL-A",
              "subcategories": []
            },
            {
              "id": "utility-carts-kubota-rtv-x1100cw",
              "name": "RTV-X1100CW",
              "subcategories": []
            },
            {
              "id": "utility-carts-kubota-rtv-x1100cwl-a",
              "name": "RTV-X1100CWL-A",
              "subcategories": []
            },
            {
              "id": "utility-carts-kubota-rtv-x1120",
              "name": "RTV-X1120",
              "subcategories": []
            },
            {
              "id": "utility-carts-kubota-rtv-x1120d",
              "name": "RTV-X1120D",
              "subcategories": []
            },
            {
              "id": "utility-carts-kubota-rtv-x1120dr",
              "name": "RTV-X1120DR",
              "subcategories": []
            },
            {
              "id": "utility-carts-kubota-rtv-x1120dw",
              "name": "RTV-X1120DW",
              "subcategories": []
            },
            {
              "id": "utility-carts-kubota-rtv-x1120wlh",
              "name": "RTV-X1120WLH",
              "subcategories": []
            },
            {
              "id": "utility-carts-kubota-rtv-x1130",
              "name": "RTV-X1130",
              "subcategories": []
            },
            {
              "id": "utility-carts-kubota-rtv-x1140",
              "name": "RTV-X1140",
              "subcategories": []
            },
            {
              "id": "utility-carts-kubota-rtv-x1140w",
              "name": "RTV-X1140W",
              "subcategories": []
            },
            {
              "id": "utility-carts-kubota-rtv-x-cab",
              "name": "RTV-X CAB",
              "subcategories": []
            },
            {
              "id": "utility-carts-kubota-rtv-x-long-bed",
              "name": "RTV-X LONG BED",
              "subcategories": []
            },
            {
              "id": "utility-carts-kubota-other",
              "name": "OTHER",
              "subcategories": []
            }
          ]
        },
        {
          "id": "utility-carts-polaris",
          "name": "Polaris",
          "subcategories": [
            {
              "id": "utility-carts-polaris-ace-900sp",
              "name": "ACE 900SP",
              "subcategories": []
            },
            {
              "id": "utility-carts-polaris-brutus-hd-pto",
              "name": "BRUTUS HD PTO",
              "subcategories": []
            },
            {
              "id": "utility-carts-polaris-ev-lsv",
              "name": "EV LSV",
              "subcategories": []
            },
            {
              "id": "utility-carts-polaris-gem-e4",
              "name": "GEM E4",
              "subcategories": []
            },
            {
              "id": "utility-carts-polaris-general-1000",
              "name": "GENERAL 1000",
              "subcategories": []
            },
            {
              "id": "utility-carts-polaris-general-1000-deluxe",
              "name": "GENERAL 1000 DELUXE",
              "subcategories": []
            },
            {
              "id": "utility-carts-polaris-general-1000-eps",
              "name": "GENERAL 1000 EPS",
              "subcategories": []
            },
            {
              "id": "utility-carts-polaris-general-1000-eps-deluxe",
              "name": "GENERAL 1000 EPS DELUXE",
              "subcategories": []
            },
            {
              "id": "utility-carts-polaris-general-1000-premium",
              "name": "GENERAL 1000 PREMIUM",
              "subcategories": []
            },
            {
              "id": "utility-carts-polaris-general-1000-sport",
              "name": "GENERAL 1000 SPORT",
              "subcategories": []
            },
            {
              "id": "utility-carts-polaris-general-xp-4-1000-deluxe",
              "name": "GENERAL XP 4 1000 DELUXE",
              "subcategories": []
            },
            {
              "id": "utility-carts-polaris-general-xp-4-premium",
              "name": "GENERAL XP 4 PREMIUM",
              "subcategories": []
            },
            {
              "id": "utility-carts-polaris-general-xp-4-sport",
              "name": "GENERAL XP 4 SPORT",
              "subcategories": []
            },
            {
              "id": "utility-carts-polaris-general-xp-4-ultimate",
              "name": "GENERAL XP 4 ULTIMATE",
              "subcategories": []
            },
            {
              "id": "utility-carts-polaris-general-xp-1000-deluxe",
              "name": "GENERAL XP 1000 DELUXE",
              "subcategories": []
            },
            {
              "id": "utility-carts-polaris-general-xp-1000-premium",
              "name": "GENERAL XP 1000 PREMIUM",
              "subcategories": []
            },
            {
              "id": "utility-carts-polaris-general-xp-1000-sport",
              "name": "GENERAL XP 1000 SPORT",
              "subcategories": []
            },
            {
              "id": "utility-carts-polaris-general-xp-ultimate",
              "name": "GENERAL XP ULTIMATE",
              "subcategories": []
            },
            {
              "id": "utility-carts-polaris-pro-xd-2000d",
              "name": "PRO XD 2000D",
              "subcategories": []
            },
            {
              "id": "utility-carts-polaris-pro-xd-2000g",
              "name": "PRO XD 2000G",
              "subcategories": []
            },
            {
              "id": "utility-carts-polaris-pro-xd-4000d",
              "name": "PRO XD 4000D",
              "subcategories": []
            },
            {
              "id": "utility-carts-polaris-pro-xd-4000g",
              "name": "PRO XD 4000G",
              "subcategories": []
            },
            {
              "id": "utility-carts-polaris-pro-xd-fs-diesel",
              "name": "PRO XD FS DIESEL",
              "subcategories": []
            },
            {
              "id": "utility-carts-polaris-pro-xd-fs-diesel-crew",
              "name": "PRO XD FS DIESEL CREW",
              "subcategories": []
            },
            {
              "id": "utility-carts-polaris-pro-xd-fs-gas",
              "name": "PRO XD FS GAS",
              "subcategories": []
            },
            {
              "id": "utility-carts-polaris-pro-xd-fs-gas-crew",
              "name": "PRO XD FS GAS CREW",
              "subcategories": []
            },
            {
              "id": "utility-carts-polaris-pro-xd-ms-gas",
              "name": "PRO XD MS GAS",
              "subcategories": []
            },
            {
              "id": "utility-carts-polaris-pro-xd-ms-gas-crew",
              "name": "PRO XD MS GAS CREW",
              "subcategories": []
            },
            {
              "id": "utility-carts-polaris-ranger",
              "name": "RANGER",
              "subcategories": []
            },
            {
              "id": "utility-carts-polaris-ranger-6x6",
              "name": "RANGER 6X6",
              "subcategories": []
            },
            {
              "id": "utility-carts-polaris-ranfger-150efi",
              "name": "RANFGER 150EFI",
              "subcategories": []
            },
            {
              "id": "utility-carts-polaris-ranger-400",
              "name": "RANGER 400",
              "subcategories": []
            },
            {
              "id": "utility-carts-polaris-ranger-500",
              "name": "RANGER 500",
              "subcategories": []
            },
            {
              "id": "utility-carts-polaris-ranger-500efi",
              "name": "RANGER 500EFI",
              "subcategories": []
            },
            {
              "id": "utility-carts-polaris-ranger-570",
              "name": "RANGER 570",
              "subcategories": []
            },
            {
              "id": "utility-carts-polaris-ranger-570efi",
              "name": "RANGER 570EFI",
              "subcategories": []
            },
            {
              "id": "utility-carts-polaris-ranger-570eps",
              "name": "RANGER 570EPS",
              "subcategories": []
            },
            {
              "id": "utility-carts-polaris-ranger-570fs",
              "name": "RANGER 570FS",
              "subcategories": []
            },
            {
              "id": "utility-carts-polaris-ranger-570-premium",
              "name": "RANGER 570 PREMIUM",
              "subcategories": []
            },
            {
              "id": "utility-carts-polaris-ranger-700efi",
              "name": "RANGER 700EFI",
              "subcategories": []
            },
            {
              "id": "utility-carts-polaris-ranger-700xp",
              "name": "RANGER 700XP",
              "subcategories": []
            },
            {
              "id": "utility-carts-polaris-ranger-800",
              "name": "RANGER 800",
              "subcategories": []
            },
            {
              "id": "utility-carts-polaris-ranger-800efi",
              "name": "RANGER 800EFI",
              "subcategories": []
            },
            {
              "id": "utility-carts-polaris-ranger-800hd",
              "name": "RANGER 800HD",
              "subcategories": []
            },
            {
              "id": "utility-carts-polaris-ranger-800xp",
              "name": "RANGER 800XP",
              "subcategories": []
            },
            {
              "id": "utility-carts-polaris-ranger-1000",
              "name": "RANGER 1000",
              "subcategories": []
            },
            {
              "id": "utility-carts-polaris-ranger-1000-eps",
              "name": "RANGER 1000 EPS",
              "subcategories": []
            },
            {
              "id": "utility-carts-polaris-ranger-1000-premium",
              "name": "RANGER 1000 PREMIUM",
              "subcategories": []
            },
            {
              "id": "utility-carts-polaris-ranger-1000-xp",
              "name": "RANGER 1000 XP",
              "subcategories": []
            },
            {
              "id": "utility-carts-polaris-ranger-etx",
              "name": "RANGER ETX",
              "subcategories": []
            },
            {
              "id": "utility-carts-polaris-ranger-ev",
              "name": "RANGER EV",
              "subcategories": []
            },
            {
              "id": "utility-carts-polaris-ranger-ev-li-ion",
              "name": "RANGER EV LI-ION",
              "subcategories": []
            },
            {
              "id": "utility-carts-polaris-ranger-sp570",
              "name": "RANGER SP570",
              "subcategories": []
            },
            {
              "id": "utility-carts-polaris-ranger-sp-570-northstar",
              "name": "RANGER SP 570 NORTHSTAR",
              "subcategories": []
            },
            {
              "id": "utility-carts-polaris-ranger-sp-570-premium",
              "name": "RANGER SP 570 PREMIUM",
              "subcategories": []
            },
            {
              "id": "utility-carts-polaris-ranger-tm",
              "name": "RANGER TM",
              "subcategories": []
            },
            {
              "id": "utility-carts-polaris-ranger-xp",
              "name": "RANGER XP",
              "subcategories": []
            },
            {
              "id": "utility-carts-polaris-ranger-xp-700-efi",
              "name": "RANGER XP 700 EFI",
              "subcategories": []
            },
            {
              "id": "utility-carts-polaris-ranger-xp-800-efi",
              "name": "RANGER XP 800 EFI",
              "subcategories": []
            },
            {
              "id": "utility-carts-polaris-ranger-xp-800-eps",
              "name": "RANGER XP 800 EPS",
              "subcategories": []
            },
            {
              "id": "utility-carts-polaris-ranger-xp-900",
              "name": "RANGER XP 900",
              "subcategories": []
            },
            {
              "id": "utility-carts-polaris-ranger-xp-900-efi",
              "name": "RANGER XP 900 EFI",
              "subcategories": []
            },
            {
              "id": "utility-carts-polaris-ranger-xp-900-eps",
              "name": "RANGER XP 900 EPS",
              "subcategories": []
            },
            {
              "id": "utility-carts-polaris-ranger-xp-900-eps-hunter",
              "name": "RANGER XP 900 EPS HUNTER",
              "subcategories": []
            },
            {
              "id": "utility-carts-polaris-ranger-900-eps-le",
              "name": "RANGER 900 EPS LE",
              "subcategories": []
            },
            {
              "id": "utility-carts-polaris-ranger-eps-premium",
              "name": "RANGER EPS PREMIUM",
              "subcategories": []
            },
            {
              "id": "utility-carts-polaris-ranger-xp-900hd",
              "name": "RANGER XP 900HD",
              "subcategories": []
            },
            {
              "id": "utility-carts-polaris-ranger-xp-1000",
              "name": "RANGER XP 1000",
              "subcategories": []
            },
            {
              "id": "utility-carts-polaris-ranger-xp-1000-eps",
              "name": "RANGER XP 1000 EPS",
              "subcategories": []
            },
            {
              "id": "utility-carts-polaris-ranger-xp-1000-eps-back-country-le",
              "name": "RANGER XP 1000 EPS BACK COUNTRY LE",
              "subcategories": []
            },
            {
              "id": "utility-carts-polaris-ranger-xp-1000-eps-high-lifter",
              "name": "RANGER XP 1000 EPS HIGH LIFTER",
              "subcategories": []
            },
            {
              "id": "utility-carts-polaris-ranger-xp-1000-eps-northstar",
              "name": "RANGER XP 1000 EPS NORTHSTAR",
              "subcategories": []
            },
            {
              "id": "utility-carts-polaris-ranger-xp-1000-eps-premium",
              "name": "RANGER XP 1000 EPS PREMIUM",
              "subcategories": []
            },
            {
              "id": "utility-carts-polaris-ranger-xp-1000-eps-ranch",
              "name": "RANGER XP 1000 EPS RANCH",
              "subcategories": []
            },
            {
              "id": "utility-carts-polaris-ranger-xp-1000-northstar-premium",
              "name": "RANGER XP 1000 NORTHSTAR PREMIUM",
              "subcategories": []
            },
            {
              "id": "utility-carts-polaris-ranger-xp-1000-northstar-trail-boss",
              "name": "RANGER XP 1000 NORTHSTAR TRAIL BOSS",
              "subcategories": []
            },
            {
              "id": "utility-carts-polaris-ranger-xp-1000-northstar-ultimate",
              "name": "RANGER XP 1000 NORTHSTAR ULTIMATE",
              "subcategories": []
            },
            {
              "id": "utility-carts-polaris-ranger-xp-1000-premium",
              "name": "RANGER XP 1000 PREMIUM",
              "subcategories": []
            },
            {
              "id": "utility-carts-polaris-ranger-xp-1000-texas",
              "name": "RANGER XP 1000 TEXAS",
              "subcategories": []
            },
            {
              "id": "utility-carts-polaris-ranger-xp-kinetic-premium",
              "name": "RANGER XP KINETIC PREMIUM",
              "subcategories": []
            },
            {
              "id": "utility-carts-polaris-ranger-xp-kinetic-ultimate",
              "name": "RANGER XP KINETIC ULTIMATE",
              "subcategories": []
            },
            {
              "id": "utility-carts-polaris-ranger-crew",
              "name": "RANGER CREW",
              "subcategories": []
            },
            {
              "id": "utility-carts-polaris-ranger-crew-500",
              "name": "RANGER CREW 500",
              "subcategories": []
            },
            {
              "id": "utility-carts-polaris-ranger-crew-570",
              "name": "RANGER CREW 570",
              "subcategories": []
            },
            {
              "id": "utility-carts-polaris-ranger-crew-570efi",
              "name": "RANGER CREW 570EFI",
              "subcategories": []
            },
            {
              "id": "utility-carts-polaris-ranger-crew-570fs",
              "name": "RANGER CREW 570FS",
              "subcategories": []
            },
            {
              "id": "utility-carts-polaris-ranger-crew-570-4",
              "name": "RANGER CREW 570-4",
              "subcategories": []
            },
            {
              "id": "utility-carts-polaris-ranger-crew-800",
              "name": "RANGER CREW 800",
              "subcategories": []
            },
            {
              "id": "utility-carts-polaris-ranger-crew-800efi",
              "name": "RANGER CREW 800EFI",
              "subcategories": []
            },
            {
              "id": "utility-carts-polaris-ranger-crew-900",
              "name": "RANGER CREW 900",
              "subcategories": []
            },
            {
              "id": "utility-carts-polaris-ranger-crew-900-eps",
              "name": "RANGER CREW 900 EPS",
              "subcategories": []
            },
            {
              "id": "utility-carts-polaris-ranger-crew-1000",
              "name": "RANGER CREW 1000",
              "subcategories": []
            },
            {
              "id": "utility-carts-polaris-ranger-crew-1000-eps",
              "name": "RANGER CREW 1000 EPS",
              "subcategories": []
            },
            {
              "id": "utility-carts-polaris-ranger-crew-1000-premium",
              "name": "RANGER CREW 1000 PREMIUM",
              "subcategories": []
            },
            {
              "id": "utility-carts-polaris-ranger-crew-diesel",
              "name": "RANGER CREW DIESEL",
              "subcategories": []
            },
            {
              "id": "utility-carts-polaris-ranger-crew-sp-570",
              "name": "RANGER CREW SP 570",
              "subcategories": []
            },
            {
              "id": "utility-carts-polaris-ranger-crew-sp-570-northstar",
              "name": "RANGER CREW SP 570 NORTHSTAR",
              "subcategories": []
            },
            {
              "id": "utility-carts-polaris-ranger-crew-sp-570-premium",
              "name": "RANGER CREW SP 570 PREMIUM",
              "subcategories": []
            },
            {
              "id": "utility-carts-polaris-ranger-crew",
              "name": "RANGER CREW",
              "subcategories": []
            },
            {
              "id": "utility-carts-polaris-ranger-crew-xp-900-6",
              "name": "RANGER CREW XP 900-6",
              "subcategories": []
            },
            {
              "id": "utility-carts-polaris-ranger-crew-xp-900-eps",
              "name": "RANGER CREW XP 900 EPS",
              "subcategories": []
            },
            {
              "id": "utility-carts-polaris-ranger-crew-xp-1000",
              "name": "RANGER CREW XP 1000",
              "subcategories": []
            },
            {
              "id": "utility-carts-polaris-ranger-crew-xp-1000-eps",
              "name": "RANGER CREW XP 1000 EPS",
              "subcategories": []
            },
            {
              "id": "utility-carts-polaris-ranger-crew-xp-1000-eps-northstar",
              "name": "RANGER CREW XP 1000 EPS NORTHSTAR",
              "subcategories": []
            },
            {
              "id": "utility-carts-polaris-ranger-crew-xp-1000-northstar-premium",
              "name": "RANGER CREW XP 1000 NORTHSTAR PREMIUM",
              "subcategories": []
            },
            {
              "id": "utility-carts-polaris-ranger-crew-xp-1000-northstar-texas-edition",
              "name": "RANGER CREW XP 1000 NORTHSTAR TEXAS EDITION",
              "subcategories": []
            },
            {
              "id": "utility-carts-polaris-ranger-crew-xp-1000-northstar-trail-boss",
              "name": "RANGER CREW XP 1000 NORTHSTAR TRAIL BOSS",
              "subcategories": []
            },
            {
              "id": "utility-carts-polaris-ranger-crew-xp-1000-northstar-ultimate",
              "name": "RANGER CREW XP 1000 NORTHSTAR ULTIMATE",
              "subcategories": []
            },
            {
              "id": "utility-carts-polaris-ranger-crew-xp-1000-premium",
              "name": "RANGER CREW XP 1000 PREMIUM",
              "subcategories": []
            },
            {
              "id": "utility-carts-polaris-ranger-crew-xp-1000-texas-edition",
              "name": "RANGER CREW XP 1000 TEXAS EDITION",
              "subcategories": []
            },
            {
              "id": "utility-carts-polaris-ranger-crew-xd-1500-northstar-premium",
              "name": "RANGER CREW XD 1500 NORTHSTAR PREMIUM",
              "subcategories": []
            },
            {
              "id": "utility-carts-polaris-ranger-crew-xd-1500-northstar-ultimate",
              "name": "RANGER CREW XD 1500 NORTHSTAR ULTIMATE",
              "subcategories": []
            },
            {
              "id": "utility-carts-polaris-ranger-diesel",
              "name": "RANGER DIESEL",
              "subcategories": []
            },
            {
              "id": "utility-carts-polaris-ranger-rzr-170",
              "name": "RANGER RZR 170",
              "subcategories": []
            },
            {
              "id": "utility-carts-polaris-ranger-rzr-570",
              "name": "RANGER RZR 570",
              "subcategories": []
            },
            {
              "id": "utility-carts-polaris-ranger-rzr-800",
              "name": "RANGER RZR 800",
              "subcategories": []
            },
            {
              "id": "utility-carts-polaris-ranger-xd-1500-northstar-premium",
              "name": "RANGER XD 1500 NORTHSTAR PREMIUM",
              "subcategories": []
            },
            {
              "id": "utility-carts-polaris-ranger-xd-1500-northstar-ultimate",
              "name": "RANGER XD 1500 NORTHSTAR ULTIMATE",
              "subcategories": []
            },
            {
              "id": "utility-carts-polaris-ranger-xd-1500-premium",
              "name": "RANGER XD 1500 PREMIUM",
              "subcategories": []
            },
            {
              "id": "utility-carts-polaris-rzr-4-800-eps",
              "name": "RZR 4 800 EPS",
              "subcategories": []
            },
            {
              "id": "utility-carts-polaris-rzr-4-900-eps",
              "name": "RZR 4 900 EPS",
              "subcategories": []
            },
            {
              "id": "utility-carts-polaris-rzr-200-efi",
              "name": "RZR 200 EFI",
              "subcategories": []
            },
            {
              "id": "utility-carts-polaris-rzr-570",
              "name": "RZR 570",
              "subcategories": []
            },
            {
              "id": "utility-carts-polaris-rzr-570-efi",
              "name": "RZR 570 EFI",
              "subcategories": []
            },
            {
              "id": "utility-carts-polaris-rzr-570-eps",
              "name": "RZR 570 EPS",
              "subcategories": []
            },
            {
              "id": "utility-carts-polaris-rzr-800",
              "name": "RZR 800",
              "subcategories": []
            },
            {
              "id": "utility-carts-polaris-rzr-800-eps",
              "name": "RZR 800 EPS",
              "subcategories": []
            },
            {
              "id": "utility-carts-polaris-rzr-900",
              "name": "RZR 900",
              "subcategories": []
            },
            {
              "id": "utility-carts-polaris-rzr-900-eps",
              "name": "RZR 900 EPS",
              "subcategories": []
            },
            {
              "id": "utility-carts-polaris-rzr-900-eps-trail",
              "name": "RZR 900 EPS TRAIL",
              "subcategories": []
            },
            {
              "id": "utility-carts-polaris-rzr-900-eps-xc",
              "name": "RZR 900 EPS XC",
              "subcategories": []
            },
            {
              "id": "utility-carts-polaris-rzr-900-xp",
              "name": "RZR 900 XP",
              "subcategories": []
            },
            {
              "id": "utility-carts-polaris-rzr-rs1",
              "name": "RZR RS1",
              "subcategories": []
            },
            {
              "id": "utility-carts-polaris-rzr-s-800-efi",
              "name": "RZR S 800 EFI",
              "subcategories": []
            },
            {
              "id": "utility-carts-polaris-rzr-s-900",
              "name": "RZR S 900",
              "subcategories": []
            },
            {
              "id": "utility-carts-polaris-rzr-s-900-eps",
              "name": "RZR S 900 EPS",
              "subcategories": []
            },
            {
              "id": "utility-carts-polaris-rzr-s-1000",
              "name": "RZR S 1000",
              "subcategories": []
            },
            {
              "id": "utility-carts-polaris-rzr-s-1000-eps",
              "name": "RZR S 1000 EPS",
              "subcategories": []
            },
            {
              "id": "utility-carts-polaris-rzr-xp-4-1000",
              "name": "RZR XP 4 1000",
              "subcategories": []
            },
            {
              "id": "utility-carts-polaris-rzr-xp-4-1000-premium",
              "name": "RZR XP 4 1000 PREMIUM",
              "subcategories": []
            },
            {
              "id": "utility-carts-polaris-rzr-xp-4-1000-sport",
              "name": "RZR XP 4 1000 SPORT",
              "subcategories": []
            },
            {
              "id": "utility-carts-polaris-rzr-xp-4-1000-ultimate",
              "name": "RZR XP 4 1000 ULTIMATE",
              "subcategories": []
            },
            {
              "id": "utility-carts-polaris-rzr-xp-4-turbo-eps",
              "name": "RZR XP 4 TURBO EPS",
              "subcategories": []
            },
            {
              "id": "utility-carts-polaris-rzr-xp-4-turbo-fox",
              "name": "RZR XP 4 TURBO FOX",
              "subcategories": []
            },
            {
              "id": "utility-carts-polaris-rzr-xp-4-turbo-s",
              "name": "RZR XP 4 TURBO S",
              "subcategories": []
            },
            {
              "id": "utility-carts-polaris-rzr-xp-turbo-s-velocity",
              "name": "RZR XP TURBO S VELOCITY",
              "subcategories": []
            },
            {
              "id": "utility-carts-polaris-rzr-xp-900",
              "name": "RZR XP 900",
              "subcategories": []
            },
            {
              "id": "utility-carts-polaris-rzr-xp-1000",
              "name": "RZR XP 1000",
              "subcategories": []
            },
            {
              "id": "utility-carts-polaris-rzr-xp-1000-eps",
              "name": "RZR XP 1000 EPS",
              "subcategories": []
            },
            {
              "id": "utility-carts-polaris-rzr-xp-1000-sport",
              "name": "RZR XP 1000 SPORT",
              "subcategories": []
            },
            {
              "id": "utility-carts-polaris-rzr-xp-1000-trails-and-rocks",
              "name": "RZR XP 1000 TRAILS AND ROCKS",
              "subcategories": []
            },
            {
              "id": "utility-carts-polaris-rzr-xp-1000-ultimate",
              "name": "RZR XP 1000 ULTIMATE",
              "subcategories": []
            },
            {
              "id": "utility-carts-polaris-rzr-xp-s-4-1000-ultimate",
              "name": "RZR XP S 4 1000 ULTIMATE",
              "subcategories": []
            },
            {
              "id": "utility-carts-polaris-rzr-xp-turbo-s-velocity",
              "name": "RZR XP TURBO S VELOCITY",
              "subcategories": []
            },
            {
              "id": "utility-carts-polaris-rzr-xp-turbo-eps",
              "name": "RZR XP TURBO EPS",
              "subcategories": []
            },
            {
              "id": "utility-carts-polaris-rzr-xp-turbo-s-velocity",
              "name": "RZR XP TURBO S VELOCITY",
              "subcategories": []
            },
            {
              "id": "utility-carts-polaris-rzr-1000",
              "name": "RZR 1000",
              "subcategories": []
            },
            {
              "id": "utility-carts-polaris-rzr-pro-r-4-premium",
              "name": "RZR PRO R 4 PREMIUM",
              "subcategories": []
            },
            {
              "id": "utility-carts-polaris-rzr-pro-r-4-sport",
              "name": "RZR PRO R 4 SPORT",
              "subcategories": []
            },
            {
              "id": "utility-carts-polaris-rzr-pro-r-4-ultimate",
              "name": "RZR PRO R 4 ULTIMATE",
              "subcategories": []
            },
            {
              "id": "utility-carts-polaris-rzr-pro-r-premium",
              "name": "RZR PRO R PREMIUM",
              "subcategories": []
            },
            {
              "id": "utility-carts-polaris-rzr-pro-r-ultimate",
              "name": "RZR PRO R ULTIMATE",
              "subcategories": []
            },
            {
              "id": "utility-carts-polaris-rzr-pro-s-4-premium",
              "name": "RZR PRO S 4 PREMIUM",
              "subcategories": []
            },
            {
              "id": "utility-carts-polaris-rzr-pro-s-4-sport",
              "name": "RZR PRO S 4 SPORT",
              "subcategories": []
            },
            {
              "id": "utility-carts-polaris-rzr-pro-s-4-ultimate",
              "name": "RZR PRO S 4 ULTIMATE",
              "subcategories": []
            },
            {
              "id": "utility-carts-polaris-rzr-pro-s-premium",
              "name": "RZR PRO S PREMIUM",
              "subcategories": []
            },
            {
              "id": "utility-carts-polaris-rzr-pro-s-sport",
              "name": "RZR PRO S SPORT",
              "subcategories": []
            },
            {
              "id": "utility-carts-polaris-rzr-pro-xp",
              "name": "RZR PRO XP",
              "subcategories": []
            },
            {
              "id": "utility-carts-polaris-rzr-pro-xp-4-premium",
              "name": "RZR PRO XP 4 PREMIUM",
              "subcategories": []
            },
            {
              "id": "utility-carts-polaris-rzr-pro-xp-4-sport",
              "name": "RZR PRO XP 4 SPORT",
              "subcategories": []
            },
            {
              "id": "utility-carts-polaris-rzr-pro-xp-4-ultimate",
              "name": "RZR PRO XP 4 ULTIMATE",
              "subcategories": []
            },
            {
              "id": "utility-carts-polaris-rzr-pro-xp-premium",
              "name": "RZR PRO XP PREMIUM",
              "subcategories": []
            },
            {
              "id": "utility-carts-polaris-rzr-pro-xp-sport",
              "name": "RZR PRO XP SPORT",
              "subcategories": []
            },
            {
              "id": "utility-carts-polaris-rzr-pro-xp-ultimate",
              "name": "RZR PRO XP ULTIMATE",
              "subcategories": []
            },
            {
              "id": "utility-carts-polaris-rzr-trail-premium",
              "name": "RZR TRAIL PREMIUM",
              "subcategories": []
            },
            {
              "id": "utility-carts-polaris-rzr-trail-s-1000-premium",
              "name": "RZR TRAIL S 1000 PREMIUM",
              "subcategories": []
            },
            {
              "id": "utility-carts-polaris-rzr-trail-s-1000-ultimate",
              "name": "RZR TRAIL S 1000 ULTIMATE",
              "subcategories": []
            },
            {
              "id": "utility-carts-polaris-rzr-trail-ultimate",
              "name": "RZR TRAIL ULTIMATE",
              "subcategories": []
            },
            {
              "id": "utility-carts-polaris-rzr-turbo-r-4-premium",
              "name": "RZR TURBO R 4 PREMIUM",
              "subcategories": []
            },
            {
              "id": "utility-carts-polaris-rzr-turbo-r-4-ultimate",
              "name": "RZR TURBO R 4 ULTIMATE",
              "subcategories": []
            },
            {
              "id": "utility-carts-polaris-rzr-turbo-r-premium",
              "name": "RZR TURBO R PREMIUM",
              "subcategories": []
            },
            {
              "id": "utility-carts-polaris-rzr-turbo-r-ultimate",
              "name": "RZR TURBO R ULTIMATE",
              "subcategories": []
            },
            {
              "id": "utility-carts-polaris-rzr-turbo-s",
              "name": "RZR TURBO S",
              "subcategories": []
            },
            {
              "id": "utility-carts-polaris-xpedition-adv-5-northstar",
              "name": "XPEDITION ADV 5 NORTHSTAR",
              "subcategories": []
            },
            {
              "id": "utility-carts-polaris-xpedition-adv-5-ultimate",
              "name": "XPEDITION ADV 5 ULTIMATE",
              "subcategories": []
            },
            {
              "id": "utility-carts-polaris-xpedition-adv-northstar",
              "name": "XPEDITION ADV NORTHSTAR",
              "subcategories": []
            },
            {
              "id": "utility-carts-polaris-xpedition-adv-ultimate",
              "name": "XPEDITION ADV ULTIMATE",
              "subcategories": []
            },
            {
              "id": "utility-carts-polaris-xpedition-xp-5-northstar",
              "name": "XPEDITION XP 5 NORTHSTAR",
              "subcategories": []
            },
            {
              "id": "utility-carts-polaris-xpedition-xp-northstar",
              "name": "XPEDITION XP NORTHSTAR",
              "subcategories": []
            },
            {
              "id": "utility-carts-polaris-xpedition-xp-ultimate",
              "name": "XPEDITION XP ULTIMATE",
              "subcategories": []
            },
            {
              "id": "utility-carts-polaris-other",
              "name": "OTHER",
              "subcategories": []
            }
          ]
        },
        {
          "id": "utility-carts-kawasaki",
          "name": "Kawasaki",
          "subcategories": [
            {
              "id": "utility-carts-kawasaki-kaf820fjf",
              "name": "KAF820FJF",
              "subcategories": []
            },
            {
              "id": "utility-carts-kawasaki-kaf950g",
              "name": "KAF950G",
              "subcategories": []
            },
            {
              "id": "utility-carts-kawasaki-mule-500",
              "name": "MULE 500",
              "subcategories": []
            },
            {
              "id": "utility-carts-kawasaki-mule-550",
              "name": "MULE 550",
              "subcategories": []
            },
            {
              "id": "utility-carts-kawasaki-mule-610",
              "name": "MULE 610",
              "subcategories": []
            },
            {
              "id": "utility-carts-kawasaki-mule-610-xc",
              "name": "MULE 610 XC",
              "subcategories": []
            },
            {
              "id": "utility-carts-kawasaki-mule-1000",
              "name": "MULE 1000",
              "subcategories": []
            },
            {
              "id": "utility-carts-kawasaki-mule-2010",
              "name": "MULE 2010",
              "subcategories": []
            },
            {
              "id": "utility-carts-kawasaki-mule-2500",
              "name": "MULE 2500",
              "subcategories": []
            },
            {
              "id": "utility-carts-kawasaki-mule-2510",
              "name": "MULE 2510",
              "subcategories": []
            },
            {
              "id": "utility-carts-kawasaki-mule-3010",
              "name": "MULE 3010",
              "subcategories": []
            },
            {
              "id": "utility-carts-kawasaki-mule-3010-tran-4x4",
              "name": "MULE 3010 TRAN 4X4",
              "subcategories": []
            },
            {
              "id": "utility-carts-kawasaki-mule-4000",
              "name": "MULE 4000",
              "subcategories": []
            },
            {
              "id": "utility-carts-kawasaki-mule-4010-4x4",
              "name": "MULE 4010 4X4",
              "subcategories": []
            },
            {
              "id": "utility-carts-kawasaki-mule-4010-4x4-fe",
              "name": "MULE 4010 4X4 FE",
              "subcategories": []
            },
            {
              "id": "utility-carts-kawasaki-mule-4010-trans-4x4",
              "name": "MULE 4010 TRANS 4X4",
              "subcategories": []
            },
            {
              "id": "utility-carts-kawasaki-mule-4010-trans-4x4-se",
              "name": "MULE 4010 TRANS 4X4 SE",
              "subcategories": []
            },
            {
              "id": "utility-carts-kawasaki-mule-pro-fx-820-eps",
              "name": "MULE PRO FX 820 EPS",
              "subcategories": []
            },
            {
              "id": "utility-carts-kawasaki-mule-pro-dx",
              "name": "MULE PRO DX",
              "subcategories": []
            },
            {
              "id": "utility-carts-kawasaki-mule-pro-dx-eps",
              "name": "MULE PRO DX EPS",
              "subcategories": []
            },
            {
              "id": "utility-carts-kawasaki-mule-pro-dxt",
              "name": "MULE PRO DXT",
              "subcategories": []
            },
            {
              "id": "utility-carts-kawasaki-mule-pro-dxt-eps",
              "name": "MULE PRO DXT EPS",
              "subcategories": []
            },
            {
              "id": "utility-carts-kawasaki-mule-pro-dxt-eps-fe",
              "name": "MULE PRO DXT EPS FE",
              "subcategories": []
            },
            {
              "id": "utility-carts-kawasaki-mule-pro-fx",
              "name": "MULE PRO FX",
              "subcategories": []
            },
            {
              "id": "utility-carts-kawasaki-mule-pro-fx1000-hd",
              "name": "MULE PRO FX1000 HD",
              "subcategories": []
            },
            {
              "id": "utility-carts-kawasaki-mule-pro-fx-eps",
              "name": "MULE PRO FX EPS",
              "subcategories": []
            },
            {
              "id": "utility-carts-kawasaki-mule-pro-fx-eps-le",
              "name": "MULE PRO FX EPS LE",
              "subcategories": []
            },
            {
              "id": "utility-carts-kawasaki-mule-pro-fxr",
              "name": "MULE PRO FXR",
              "subcategories": []
            },
            {
              "id": "utility-carts-kawasaki-mule-pro-fxr-1000",
              "name": "MULE PRO FXR 1000",
              "subcategories": []
            },
            {
              "id": "utility-carts-kawasaki-mul-epro-fxr-1000-le",
              "name": "MUL EPRO FXR 1000 LE",
              "subcategories": []
            },
            {
              "id": "utility-carts-kawasaki-mule-pro-fxr-eps",
              "name": "MULE PRO FXR EPS",
              "subcategories": []
            },
            {
              "id": "utility-carts-kawasaki-mule-pro-fxt",
              "name": "MULE PRO FXT",
              "subcategories": []
            },
            {
              "id": "utility-carts-kawasaki-mule-pro-fxt-820-eps",
              "name": "MULE PRO FXT 820 EPS",
              "subcategories": []
            },
            {
              "id": "utility-carts-kawasaki-mule-pro-fxt-1000-le",
              "name": "MULE PRO FXT 1000 LE",
              "subcategories": []
            },
            {
              "id": "utility-carts-kawasaki-mule-pro-fxt-1000-le-camo",
              "name": "MULE PRO FXT 1000 LE CAMO",
              "subcategories": []
            },
            {
              "id": "utility-carts-kawasaki-mule-pro-fxt-1000-le-ranch",
              "name": "MULE PRO FXT 1000 LE RANCH",
              "subcategories": []
            },
            {
              "id": "utility-carts-kawasaki-mule-pro-fxt-1000-platinum-ranch",
              "name": "MULE PRO FXT 1000 PLATINUM RANCH",
              "subcategories": []
            },
            {
              "id": "utility-carts-kawasaki-mule-pro-fxt-eps",
              "name": "MULE PRO FXT EPS",
              "subcategories": []
            },
            {
              "id": "utility-carts-kawasaki-mul-epro-fxt-eps-le",
              "name": "MUL EPRO FXT EPS LE",
              "subcategories": []
            },
            {
              "id": "utility-carts-kawasaki-mule-pro-fxt-ranch",
              "name": "MULE PRO FXT RANCH",
              "subcategories": []
            },
            {
              "id": "utility-carts-kawasaki-mule-pro-fxt-ranch-platinum",
              "name": "MULE PRO FXT RANCH PLATINUM",
              "subcategories": []
            },
            {
              "id": "utility-carts-kawasaki-mule-pro-mx",
              "name": "MULE PRO MX",
              "subcategories": []
            },
            {
              "id": "utility-carts-kawasaki-mule-pro-mx-eps",
              "name": "MULE PRO MX EPS",
              "subcategories": []
            },
            {
              "id": "utility-carts-kawasaki-mule-pro-mx-le",
              "name": "MULE PRO MX LE",
              "subcategories": []
            },
            {
              "id": "utility-carts-kawasaki-mule-pro-mx-se",
              "name": "MULE PRO MX SE",
              "subcategories": []
            },
            {
              "id": "utility-carts-kawasaki-mule-sx",
              "name": "MULE SX",
              "subcategories": []
            },
            {
              "id": "utility-carts-kawasaki-mule-sx-4x4",
              "name": "MULE SX 4X4",
              "subcategories": []
            },
            {
              "id": "utility-carts-kawasaki-mule-sx-4x4-fe",
              "name": "MULE SX 4X4 FE",
              "subcategories": []
            },
            {
              "id": "utility-carts-kawasaki-mule-sx-4x4-fi",
              "name": "MULE SX 4X4 FI",
              "subcategories": []
            },
            {
              "id": "utility-carts-kawasaki-mule-sx-4x4-xc",
              "name": "MULE SX 4X4 XC",
              "subcategories": []
            },
            {
              "id": "utility-carts-kawasaki-mule-sx-4x4-xc-fi",
              "name": "MULE SX 4X4 XC FI",
              "subcategories": []
            },
            {
              "id": "utility-carts-kawasaki-mule-sx-4x4-xc-le-fi",
              "name": "MULE SX 4X4 XC LE FI",
              "subcategories": []
            },
            {
              "id": "utility-carts-kawasaki-ridge-crew",
              "name": "RIDGE CREW",
              "subcategories": []
            },
            {
              "id": "utility-carts-kawasaki-ridge-crew-hvac",
              "name": "RIDGE CREW HVAC",
              "subcategories": []
            },
            {
              "id": "utility-carts-kawasaki-ridge-crew-platinum-ranch-edition-hvac",
              "name": "RIDGE CREW PLATINUM RANCH EDITION HVAC",
              "subcategories": []
            },
            {
              "id": "utility-carts-kawasaki-ridge-crew-st-hvac",
              "name": "RIDGE CREW ST HVAC",
              "subcategories": []
            },
            {
              "id": "utility-carts-kawasaki-ridge-hvac",
              "name": "RIDGE HVAC",
              "subcategories": []
            },
            {
              "id": "utility-carts-kawasaki-ridge-limited-hvac",
              "name": "RIDGE LIMITED HVAC",
              "subcategories": []
            },
            {
              "id": "utility-carts-kawasaki-ridge-ranch-edition",
              "name": "RIDGE RANCH EDITION",
              "subcategories": []
            },
            {
              "id": "utility-carts-kawasaki-ridge-xr-hvac",
              "name": "RIDGE XR HVAC",
              "subcategories": []
            },
            {
              "id": "utility-carts-kawasaki-ridge-platinum-ranch-edition-hvac",
              "name": "RIDGE PLATINUM RANCH EDITION HVAC",
              "subcategories": []
            },
            {
              "id": "utility-carts-kawasaki-ridge-st-hvac",
              "name": "RIDGE ST HVAC",
              "subcategories": []
            },
            {
              "id": "utility-carts-kawasaki-ridge-xr-crew-hvac",
              "name": "RIDGE XR CREW HVAC",
              "subcategories": []
            },
            {
              "id": "utility-carts-kawasaki-ridge-platinum-ranch-edition-hvac",
              "name": "RIDGE PLATINUM RANCH EDITION HVAC",
              "subcategories": []
            },
            {
              "id": "utility-carts-kawasaki-ridge-st-hvac",
              "name": "RIDGE ST HVAC",
              "subcategories": []
            },
            {
              "id": "utility-carts-kawasaki-ridge-xr-crew-hvac",
              "name": "RIDGE XR CREW HVAC",
              "subcategories": []
            },
            {
              "id": "utility-carts-kawasaki-ridge-xr-crew-limited-hvac",
              "name": "RIDGE XR CREW LIMITED HVAC",
              "subcategories": []
            },
            {
              "id": "utility-carts-kawasaki-ridge-xr-deluxe-hvac",
              "name": "RIDGE XR DELUXE HVAC",
              "subcategories": []
            },
            {
              "id": "utility-carts-kawasaki-teryx",
              "name": "TERYX",
              "subcategories": []
            },
            {
              "id": "utility-carts-kawasaki-teryx-750",
              "name": "TERYX 750",
              "subcategories": []
            },
            {
              "id": "utility-carts-kawasaki-teryx-750-fi",
              "name": "TERYX 750 FI",
              "subcategories": []
            },
            {
              "id": "utility-carts-kawasaki-teryx-750-le",
              "name": "TERYX 750 LE",
              "subcategories": []
            },
            {
              "id": "utility-carts-kawasaki-teryx-800-eps",
              "name": "TERYX 800 EPS",
              "subcategories": []
            },
            {
              "id": "utility-carts-kawasaki-teryx-800eps-le",
              "name": "TERYX 800EPS LE",
              "subcategories": []
            },
            {
              "id": "utility-carts-kawasaki-teryx-krx-4-1000",
              "name": "TERYX KRX 4 1000",
              "subcategories": []
            },
            {
              "id": "utility-carts-kawasaki-teryx-krx-4-1000-lifted-edition",
              "name": "TERYX KRX 4 1000 LIFTED EDITION",
              "subcategories": []
            },
            {
              "id": "utility-carts-kawasaki-teryx-krx1000",
              "name": "TERYX KRX1000",
              "subcategories": []
            },
            {
              "id": "utility-carts-kawasaki-teryx-krx1000-es",
              "name": "TERYX KRX1000 ES",
              "subcategories": []
            },
            {
              "id": "utility-carts-kawasaki-teryx-krx1000-se",
              "name": "TERYX KRX1000 SE",
              "subcategories": []
            },
            {
              "id": "utility-carts-kawasaki-teryx-le",
              "name": "TERYX LE",
              "subcategories": []
            },
            {
              "id": "utility-carts-kawasaki-teryx-s-le",
              "name": "TERYX S LE",
              "subcategories": []
            },
            {
              "id": "utility-carts-kawasaki-teryx4",
              "name": "TERYX4",
              "subcategories": []
            },
            {
              "id": "utility-carts-kawasaki-teryx4-800-le",
              "name": "TERYX4 800 LE",
              "subcategories": []
            },
            {
              "id": "utility-carts-kawasaki-teryx4-s-le",
              "name": "TERYX4 S LE",
              "subcategories": []
            },
            {
              "id": "utility-carts-kawasaki-teryx4-h2",
              "name": "TERYX4 H2",
              "subcategories": []
            },
            {
              "id": "utility-carts-kawasaki-teryx-h2-deluxe-es",
              "name": "TERYX H2 DELUXE ES",
              "subcategories": []
            },
            {
              "id": "utility-carts-kawasaki-teryx-5-h2",
              "name": "TERYX 5 H2",
              "subcategories": []
            },
            {
              "id": "utility-carts-kawasaki-teryx-h2-deluxe-es",
              "name": "TERYX H2 DELUXE ES",
              "subcategories": []
            },
            {
              "id": "utility-carts-kawasaki-other",
              "name": "OTHER",
              "subcategories": []
            }
          ]
        },
        {
          "id": "utility-carts-bobcat",
          "name": "Bobcat",
          "subcategories": [
            {
              "id": "utility-carts-bobcat-2100",
              "name": "2100",
              "subcategories": []
            },
            {
              "id": "utility-carts-bobcat-2200",
              "name": "2200",
              "subcategories": []
            },
            {
              "id": "utility-carts-bobcat-2200d",
              "name": "2200D",
              "subcategories": []
            },
            {
              "id": "utility-carts-bobcat-2200g",
              "name": "2200G",
              "subcategories": []
            },
            {
              "id": "utility-carts-bobcat-3400",
              "name": "3400",
              "subcategories": []
            },
            {
              "id": "utility-carts-bobcat-3400d",
              "name": "3400D",
              "subcategories": []
            },
            {
              "id": "utility-carts-bobcat-3400g",
              "name": "3400G",
              "subcategories": []
            },
            {
              "id": "utility-carts-bobcat-3400xl",
              "name": "3400XL",
              "subcategories": []
            },
            {
              "id": "utility-carts-bobcat-3400xd",
              "name": "3400XD",
              "subcategories": []
            },
            {
              "id": "utility-carts-bobcat-3450",
              "name": "3450",
              "subcategories": []
            },
            {
              "id": "utility-carts-bobcat-3600",
              "name": "3600",
              "subcategories": []
            },
            {
              "id": "utility-carts-bobcat-3650",
              "name": "3650",
              "subcategories": []
            },
            {
              "id": "utility-carts-bobcat-toolcat-5600",
              "name": "TOOLCAT 5600",
              "subcategories": []
            },
            {
              "id": "utility-carts-bobcat-toolcat-5610",
              "name": "TOOLCAT 5610",
              "subcategories": []
            },
            {
              "id": "utility-carts-bobcat-toolcat-uw53",
              "name": "TOOLCAT UW53",
              "subcategories": []
            },
            {
              "id": "utility-carts-bobcat-toolcat-uw56",
              "name": "TOOLCAT UW56",
              "subcategories": []
            },
            {
              "id": "utility-carts-bobcat-uv34",
              "name": "UV34",
              "subcategories": []
            },
            {
              "id": "utility-carts-bobcat-uv34d",
              "name": "UV34D",
              "subcategories": []
            },
            {
              "id": "utility-carts-bobcat-uv34g",
              "name": "UV34G",
              "subcategories": []
            },
            {
              "id": "utility-carts-bobcat-uv34xld",
              "name": "UV34XLD",
              "subcategories": []
            },
            {
              "id": "utility-carts-bobcat-uv34xlg",
              "name": "UV34XLG",
              "subcategories": []
            },
            {
              "id": "utility-carts-bobcat-uv34xl",
              "name": "UV34XL",
              "subcategories": []
            },
            {
              "id": "utility-carts-bobcat-other",
              "name": "OTHER",
              "subcategories": []
            }
          ]
        },
        {
          "id": "utility-carts-can-am",
          "name": "Can-Am",
          "subcategories": []
        },
        {
          "id": "utility-carts-cfmoto",
          "name": "Cfmoto",
          "subcategories": []
        },
        {
          "id": "utility-carts-toro",
          "name": "Toro",
          "subcategories": [
            {
              "id": "utility-carts-toro-workman-1100",
              "name": "WORKMAN 1100",
              "subcategories": []
            },
            {
              "id": "utility-carts-toro-workman-2100",
              "name": "WORKMAN 2100",
              "subcategories": []
            },
            {
              "id": "utility-carts-toro-workman-3100",
              "name": "WORKMAN 3100",
              "subcategories": []
            },
            {
              "id": "utility-carts-toro-workman-3200",
              "name": "WORKMAN 3200",
              "subcategories": []
            },
            {
              "id": "utility-carts-toro-workman-3300",
              "name": "WORKMAN 3300",
              "subcategories": []
            },
            {
              "id": "utility-carts-toro-workman-3300d",
              "name": "WORKMAN 3300D",
              "subcategories": []
            },
            {
              "id": "utility-carts-toro-workman-4200",
              "name": "WORKMAN 4200",
              "subcategories": []
            },
            {
              "id": "utility-carts-toro-workman-4300d",
              "name": "WORKMAN 4300D",
              "subcategories": []
            },
            {
              "id": "utility-carts-toro-workman-e2605",
              "name": "WORKMAN E2605",
              "subcategories": []
            },
            {
              "id": "utility-carts-toro-workman-gtx",
              "name": "WORKMAN GTX",
              "subcategories": []
            },
            {
              "id": "utility-carts-toro-workman-hd",
              "name": "WORKMAN HD",
              "subcategories": []
            },
            {
              "id": "utility-carts-toro-workman-hdx",
              "name": "WORKMAN HDX",
              "subcategories": []
            },
            {
              "id": "utility-carts-toro-workman-hdx-auto",
              "name": "WORKMAN HDX AUTO",
              "subcategories": []
            },
            {
              "id": "utility-carts-toro-workman-hdxd",
              "name": "WORKMAN HDXD",
              "subcategories": []
            },
            {
              "id": "utility-carts-toro-workman-md",
              "name": "WORKMAN MD",
              "subcategories": []
            },
            {
              "id": "utility-carts-toro-workman-mde",
              "name": "WORKMAN MDE",
              "subcategories": []
            },
            {
              "id": "utility-carts-toro-workman-mdx",
              "name": "WORKMAN MDX",
              "subcategories": []
            },
            {
              "id": "utility-carts-toro-workman-utx-2-pass",
              "name": "WORKMAN UTX 2-PASS",
              "subcategories": []
            },
            {
              "id": "utility-carts-toro-workman-utx-4-pass",
              "name": "WORKMAN UTX 4-PASS",
              "subcategories": []
            },
            {
              "id": "utility-carts-toro-other",
              "name": "OTHER",
              "subcategories": []
            }
          ]
        },
        {
          "id": "utility-carts-club-car",
          "name": "Club Car",
          "subcategories": [
            {
              "id": "utility-carts-club-car-411",
              "name": "411",
              "subcategories": []
            },
            {
              "id": "utility-carts-club-car-1200",
              "name": "1200",
              "subcategories": []
            },
            {
              "id": "utility-carts-club-car-carryall-1",
              "name": "CARRYALL 1",
              "subcategories": []
            },
            {
              "id": "utility-carts-club-car-carryall-2",
              "name": "CARRYALL 2",
              "subcategories": []
            },
            {
              "id": "utility-carts-club-car-carryall-6",
              "name": "CARRYALL 6",
              "subcategories": []
            },
            {
              "id": "utility-carts-club-car-carryall-252",
              "name": "CARRYALL 252",
              "subcategories": []
            },
            {
              "id": "utility-carts-club-car-carryall-272",
              "name": "CARRYALL 272",
              "subcategories": []
            },
            {
              "id": "utility-carts-club-car-carryall-300",
              "name": "CARRYALL 300",
              "subcategories": []
            },
            {
              "id": "utility-carts-club-car-carryall-500",
              "name": "CARRYALL 500",
              "subcategories": []
            },
            {
              "id": "utility-carts-club-car-carryall-502",
              "name": "CARRYALL 502",
              "subcategories": []
            },
            {
              "id": "utility-carts-club-car-carryall-1500",
              "name": "CARRYALL 1500",
              "subcategories": []
            },
            {
              "id": "utility-carts-club-car-carryall-1700",
              "name": "CARRYALL 1700",
              "subcategories": []
            },
            {
              "id": "utility-carts-club-car-caryall-100",
              "name": "CARYALL 100",
              "subcategories": []
            },
            {
              "id": "utility-carts-club-car-carryall-411",
              "name": "CARRYALL 411",
              "subcategories": []
            },
            {
              "id": "utility-carts-club-car-carryall-700",
              "name": "CARRYALL 700",
              "subcategories": []
            },
            {
              "id": "utility-carts-club-car-urban-l7e",
              "name": "URBAN L7E",
              "subcategories": []
            },
            {
              "id": "utility-carts-club-car-urban-lsv",
              "name": "URBAN LSV",
              "subcategories": []
            },
            {
              "id": "utility-carts-club-car-urban-n1",
              "name": "URBAN N1",
              "subcategories": []
            },
            {
              "id": "utility-carts-club-car-xrt-950",
              "name": "XRT 950",
              "subcategories": []
            },
            {
              "id": "utility-carts-club-car-xrt-1500",
              "name": "XRT 1500",
              "subcategories": []
            },
            {
              "id": "utility-carts-club-car-xrt-1550",
              "name": "XRT 1550",
              "subcategories": []
            },
            {
              "id": "utility-carts-club-car-other",
              "name": "OTHER",
              "subcategories": []
            }
          ]
        },
        {
          "id": "utility-carts-honda",
          "name": "Honda",
          "subcategories": [
            {
              "id": "utility-carts-honda-big-red",
              "name": "BIG RED",
              "subcategories": []
            },
            {
              "id": "utility-carts-honda-muv700",
              "name": "MUV700",
              "subcategories": []
            },
            {
              "id": "utility-carts-honda-pioneer-500",
              "name": "PIONEER 500",
              "subcategories": []
            },
            {
              "id": "utility-carts-honda-pioneer-520",
              "name": "PIONEER 520",
              "subcategories": []
            },
            {
              "id": "utility-carts-honda-pioneer-700",
              "name": "PIONEER 700",
              "subcategories": []
            },
            {
              "id": "utility-carts-honda-pioneer-700-deluxe",
              "name": "PIONEER 700 DELUXE",
              "subcategories": []
            },
            {
              "id": "utility-carts-honda-pioneer-700-forest",
              "name": "PIONEER 700 FOREST",
              "subcategories": []
            },
            {
              "id": "utility-carts-honda-pioneer-700-4",
              "name": "PIONEER 700-4",
              "subcategories": []
            },
            {
              "id": "utility-carts-honda-pioneer-700-4-deluxe",
              "name": "PIONEER 700-4 DELUXE",
              "subcategories": []
            },
            {
              "id": "utility-carts-honda-pioneer-700-4-forest",
              "name": "PIONEER 700-4 FOREST",
              "subcategories": []
            },
            {
              "id": "utility-carts-honda-pioneer-1000",
              "name": "PIONEER 1000",
              "subcategories": []
            },
            {
              "id": "utility-carts-honda-pioneer-1000-deluxe",
              "name": "PIONEER 1000 DELUXE",
              "subcategories": []
            },
            {
              "id": "utility-carts-honda-pioneer-1000-eps",
              "name": "PIONEER 1000 EPS",
              "subcategories": []
            },
            {
              "id": "utility-carts-honda-pioneer-1000-forest",
              "name": "PIONEER 1000 FOREST",
              "subcategories": []
            },
            {
              "id": "utility-carts-honda-pioneer-1000-le",
              "name": "PIONEER 1000 LE",
              "subcategories": []
            },
            {
              "id": "utility-carts-honda-pioneer-1000-5",
              "name": "PIONEER 1000-5",
              "subcategories": []
            },
            {
              "id": "utility-carts-honda-pioneer-1000-5-deluxe",
              "name": "PIONEER 1000-5 DELUXE",
              "subcategories": []
            },
            {
              "id": "utility-carts-honda-pioneer-1000-5-le",
              "name": "PIONEER 1000-5 LE",
              "subcategories": []
            },
            {
              "id": "utility-carts-honda-pioneer-1000-5-special-edition",
              "name": "PIONEER 1000-5 SPECIAL EDITION",
              "subcategories": []
            },
            {
              "id": "utility-carts-honda-pioneer-1000-5trail-special-edition",
              "name": "PIONEER 1000-5TRAIL SPECIAL EDITION",
              "subcategories": []
            },
            {
              "id": "utility-carts-honda-pioneer-1000-6-deluxe-crew",
              "name": "PIONEER 1000-6 DELUXE CREW",
              "subcategories": []
            },
            {
              "id": "utility-carts-honda-talon-1000r-fox-live-valve",
              "name": "TALON 1000R FOX LIVE VALVE",
              "subcategories": []
            },
            {
              "id": "utility-carts-honda-talon-1000r-4-fox-live-valve",
              "name": "TALON 1000R-4 FOX LIVE VALVE",
              "subcategories": []
            },
            {
              "id": "utility-carts-honda-talon-1000rs",
              "name": "TALON 1000RS",
              "subcategories": []
            },
            {
              "id": "utility-carts-honda-talon-1000x",
              "name": "TALON 1000X",
              "subcategories": []
            },
            {
              "id": "utility-carts-honda-talon-1000x-fox-live-valve",
              "name": "TALON 1000X FOX LIVE VALVE",
              "subcategories": []
            },
            {
              "id": "utility-carts-honda-talon-1000x-4",
              "name": "TALON 1000X-4",
              "subcategories": []
            },
            {
              "id": "utility-carts-honda-talon-1000x-4-fox-live-valve",
              "name": "TALON 1000X-4 FOX LIVE VALVE",
              "subcategories": []
            },
            {
              "id": "utility-carts-honda-other",
              "name": "OTHER",
              "subcategories": []
            }
          ]
        },
        {
          "id": "utility-carts-american-landmaster",
          "name": "American Landmaster",
          "subcategories": [
            {
              "id": "utility-carts-american-landmaster-amp-4x2",
              "name": "AMP 4X2",
              "subcategories": []
            },
            {
              "id": "utility-carts-american-landmaster-amp-4x4",
              "name": "AMP 4X4",
              "subcategories": []
            },
            {
              "id": "utility-carts-american-landmaster-amp-crew-4x4",
              "name": "AMP CREW 4X4",
              "subcategories": []
            },
            {
              "id": "utility-carts-american-landmaster-amd-hd",
              "name": "AMD HD",
              "subcategories": []
            },
            {
              "id": "utility-carts-american-landmaster-ev-4x2",
              "name": "EV 4X2",
              "subcategories": []
            },
            {
              "id": "utility-carts-american-landmaster-ev-4x4",
              "name": "EV 4X4",
              "subcategories": []
            },
            {
              "id": "utility-carts-american-landmaster-l4-4x2",
              "name": "L4 4X2",
              "subcategories": []
            },
            {
              "id": "utility-carts-american-landmaster-l4-4x4",
              "name": "L4 4X4",
              "subcategories": []
            },
            {
              "id": "utility-carts-american-landmaster-l5",
              "name": "L5",
              "subcategories": []
            },
            {
              "id": "utility-carts-american-landmaster-l5w",
              "name": "L5W",
              "subcategories": []
            },
            {
              "id": "utility-carts-american-landmaster-l7",
              "name": "L7",
              "subcategories": []
            },
            {
              "id": "utility-carts-american-landmaster-l7-untamed",
              "name": "L7 UNTAMED",
              "subcategories": []
            },
            {
              "id": "utility-carts-american-landmaster-l7-crew",
              "name": "L7 CREW",
              "subcategories": []
            },
            {
              "id": "utility-carts-american-landmaster-l7x",
              "name": "L7X",
              "subcategories": []
            },
            {
              "id": "utility-carts-american-landmaster-ls350",
              "name": "LS350",
              "subcategories": []
            },
            {
              "id": "utility-carts-american-landmaster-n6",
              "name": "N6",
              "subcategories": []
            },
            {
              "id": "utility-carts-american-landmaster-n7",
              "name": "N7",
              "subcategories": []
            },
            {
              "id": "utility-carts-american-landmaster-n7-crew",
              "name": "N7 CREW",
              "subcategories": []
            },
            {
              "id": "utility-carts-american-landmaster-other",
              "name": "OTHER",
              "subcategories": []
            }
          ]
        },
        {
          "id": "utility-carts-arctic-cat",
          "name": "Arctic Cat",
          "subcategories": [
            {
              "id": "utility-carts-arctic-cat-700xt",
              "name": "700XT",
              "subcategories": []
            },
            {
              "id": "utility-carts-arctic-cat-hd500xt",
              "name": "HD500XT",
              "subcategories": []
            },
            {
              "id": "utility-carts-arctic-cat-hdx700-efi",
              "name": "HDX700 EFI",
              "subcategories": []
            },
            {
              "id": "utility-carts-arctic-cat-hdx-700-xt",
              "name": "HDX 700 XT",
              "subcategories": []
            },
            {
              "id": "utility-carts-arctic-cat-prowler-500-hdx-xt",
              "name": "PROWLER 500 HDX XT",
              "subcategories": []
            },
            {
              "id": "utility-carts-arctic-cat-prowler-650-xt",
              "name": "PROWLER 650 XT",
              "subcategories": []
            },
            {
              "id": "utility-carts-arctic-cat-prowler-700-hdx",
              "name": "PROWLER 700 HDX",
              "subcategories": []
            },
            {
              "id": "utility-carts-arctic-cat-prowler-700-xtx-efi",
              "name": "PROWLER 700 XTX EFI",
              "subcategories": []
            },
            {
              "id": "utility-carts-arctic-cat-prowler-1000-xtzprowler-pro",
              "name": "PROWLER 1000 XTZPROWLER PRO",
              "subcategories": []
            },
            {
              "id": "utility-carts-arctic-cat-prowler-pro",
              "name": "PROWLER PRO",
              "subcategories": []
            },
            {
              "id": "utility-carts-arctic-cat-prowler-pro-crew",
              "name": "PROWLER PRO CREW",
              "subcategories": []
            },
            {
              "id": "utility-carts-arctic-cat-prowler-pro-crew-xt",
              "name": "PROWLER PRO CREW XT",
              "subcategories": []
            },
            {
              "id": "utility-carts-arctic-cat-prowler-pro-ranch",
              "name": "PROWLER PRO RANCH",
              "subcategories": []
            },
            {
              "id": "utility-carts-arctic-cat-prowler-pro-xt",
              "name": "PROWLER PRO XT",
              "subcategories": []
            },
            {
              "id": "utility-carts-arctic-cat-wildcat-x",
              "name": "WILDCAT X",
              "subcategories": []
            },
            {
              "id": "utility-carts-arctic-cat-wildcat-xx",
              "name": "WILDCAT XX",
              "subcategories": []
            },
            {
              "id": "utility-carts-arctic-cat-other",
              "name": "OTHER",
              "subcategories": []
            }
          ]
        },
        {
          "id": "utility-carts-argo",
          "name": "Argo",
          "subcategories": [
            {
              "id": "utility-carts-argo-750hdi",
              "name": "750HDI",
              "subcategories": []
            },
            {
              "id": "utility-carts-argo-aurora-800sx",
              "name": "AURORA 800SX",
              "subcategories": []
            },
            {
              "id": "utility-carts-argo-aurora-800-sx-hunt-master",
              "name": "AURORA 800 SX HUNT MASTER",
              "subcategories": []
            },
            {
              "id": "utility-carts-argo-aurora-850",
              "name": "AURORA 850",
              "subcategories": []
            },
            {
              "id": "utility-carts-argo-aurora-850sx-r",
              "name": "AURORA 850SX-R",
              "subcategories": []
            },
            {
              "id": "utility-carts-argo-aurora-950",
              "name": "AURORA 950",
              "subcategories": []
            },
            {
              "id": "utility-carts-argo-aurora-950-sx",
              "name": "AURORA 950 SX",
              "subcategories": []
            },
            {
              "id": "utility-carts-argo-aurora-950-sar-8x8",
              "name": "AURORA 950 SAR 8X8",
              "subcategories": []
            },
            {
              "id": "utility-carts-argo-aurora-pro-950-xt-8x8",
              "name": "AURORA PRO 950 XT 8X8",
              "subcategories": []
            },
            {
              "id": "utility-carts-argo-avenger-8x8-750-efi",
              "name": "AVENGER 8X8 750 EFI",
              "subcategories": []
            },
            {
              "id": "utility-carts-argo-avenger-8x8-stx",
              "name": "AVENGER 8X8 STX",
              "subcategories": []
            },
            {
              "id": "utility-carts-argo-avenger-750efi",
              "name": "AVENGER 750EFI",
              "subcategories": []
            },
            {
              "id": "utility-carts-argo-conquest-8x8",
              "name": "CONQUEST 8X8",
              "subcategories": []
            },
            {
              "id": "utility-carts-argo-frontier-650ho-8x8-scout",
              "name": "FRONTIER 650HO 8X8 SCOUT",
              "subcategories": []
            },
            {
              "id": "utility-carts-argo-frontier-700-scout",
              "name": "FRONTIER 700 SCOUT",
              "subcategories": []
            },
            {
              "id": "utility-carts-argo-frontier-pro-700-xt-6x6",
              "name": "FRONTIER PRO 700 XT 6X6",
              "subcategories": []
            },
            {
              "id": "utility-carts-argo-magnum-xf-500-le",
              "name": "MAGNUM XF 500 LE",
              "subcategories": []
            },
            {
              "id": "utility-carts-argo-sasquatch-xtx",
              "name": "SASQUATCH XTX",
              "subcategories": []
            },
            {
              "id": "utility-carts-argo-xti",
              "name": "XTI",
              "subcategories": []
            },
            {
              "id": "utility-carts-argo-other",
              "name": "OTHER",
              "subcategories": []
            }
          ]
        },
        {
          "id": "utility-carts-bad-boy",
          "name": "Bad Boy",
          "subcategories": [
            {
              "id": "utility-carts-bad-boy-bandit-550",
              "name": "BANDIT 550",
              "subcategories": []
            },
            {
              "id": "utility-carts-bad-boy-bandit-750",
              "name": "BANDIT 750",
              "subcategories": []
            },
            {
              "id": "utility-carts-bad-boy-stampede-900-eps",
              "name": "STAMPEDE 900 EPS",
              "subcategories": []
            },
            {
              "id": "utility-carts-bad-boy-other",
              "name": "OTHER",
              "subcategories": []
            }
          ]
        },
        {
          "id": "utility-carts-bennche",
          "name": "Bennche",
          "subcategories": [
            {
              "id": "utility-carts-bennche-tboss-420",
              "name": "TBOSS 420",
              "subcategories": []
            },
            {
              "id": "utility-carts-bennche-tboss-750",
              "name": "TBOSS 750",
              "subcategories": []
            },
            {
              "id": "utility-carts-bennche-other",
              "name": "OTHER",
              "subcategories": []
            }
          ]
        },
        {
          "id": "utility-carts-big-horn",
          "name": "Big Horn",
          "subcategories": [
            {
              "id": "utility-carts-big-horn-200-vxl-t-df-efi",
              "name": "200 VXL-T DF EFI",
              "subcategories": []
            },
            {
              "id": "utility-carts-big-horn-450-crew-efi",
              "name": "450 CREW EFI",
              "subcategories": []
            },
            {
              "id": "utility-carts-big-horn-450-promax",
              "name": "450 PROMAX",
              "subcategories": []
            },
            {
              "id": "utility-carts-big-horn-450vxl-t-efi",
              "name": "450VXL-T EFI",
              "subcategories": []
            },
            {
              "id": "utility-carts-big-horn-550dx",
              "name": "550DX",
              "subcategories": []
            },
            {
              "id": "utility-carts-big-horn-550-vxl-t-efi",
              "name": "550 VXL-T EFI",
              "subcategories": []
            },
            {
              "id": "utility-carts-big-horn-other",
              "name": "OTHER",
              "subcategories": []
            }
          ]
        },
        {
          "id": "utility-carts-corvus",
          "name": "Corvus",
          "subcategories": [
            {
              "id": "utility-carts-corvus-terrain-dx4",
              "name": "TERRAIN DX4",
              "subcategories": []
            },
            {
              "id": "utility-carts-corvus-terrain-dx4-cab",
              "name": "TERRAIN DX4 CAB",
              "subcategories": []
            },
            {
              "id": "utility-carts-corvus-terraion-dx4-pro",
              "name": "TERRAION DX4 PRO",
              "subcategories": []
            },
            {
              "id": "utility-carts-corvus-terrain-ex4",
              "name": "TERRAIN EX4",
              "subcategories": []
            },
            {
              "id": "utility-carts-corvus-other",
              "name": "OTHER",
              "subcategories": []
            }
          ]
        },
        {
          "id": "utility-carts-cub-cadet",
          "name": "Cub Cadet",
          "subcategories": [
            {
              "id": "utility-carts-cub-cadet-big-country",
              "name": "BIG COUNTRY",
              "subcategories": []
            },
            {
              "id": "utility-carts-cub-cadet-challenger-400",
              "name": "CHALLENGER 400",
              "subcategories": []
            },
            {
              "id": "utility-carts-cub-cadet-challenger-700",
              "name": "CHALLENGER 700",
              "subcategories": []
            },
            {
              "id": "utility-carts-cub-cadet-challenger-750",
              "name": "CHALLENGER 750",
              "subcategories": []
            },
            {
              "id": "utility-carts-cub-cadet-challenger-750eps",
              "name": "CHALLENGER 750EPS",
              "subcategories": []
            },
            {
              "id": "utility-carts-cub-cadet-challenger-m750-eps",
              "name": "CHALLENGER M750 EPS",
              "subcategories": []
            },
            {
              "id": "utility-carts-cub-cadet-challenger-mx-750",
              "name": "CHALLENGER MX 750",
              "subcategories": []
            },
            {
              "id": "utility-carts-cub-cadet-challenger-mx-750-eps",
              "name": "CHALLENGER MX 750 EPS",
              "subcategories": []
            },
            {
              "id": "utility-carts-cub-cadet-volunteer",
              "name": "VOLUNTEER",
              "subcategories": []
            },
            {
              "id": "utility-carts-cub-cadet-volunteer-4x4-efi",
              "name": "VOLUNTEER 4X4 EFI",
              "subcategories": []
            },
            {
              "id": "utility-carts-cub-cadet-other",
              "name": "OTHER",
              "subcategories": []
            }
          ]
        },
        {
          "id": "utility-carts-cushman",
          "name": "Cushman",
          "subcategories": [
            {
              "id": "utility-carts-cushman-1600xd",
              "name": "1600XD",
              "subcategories": []
            },
            {
              "id": "utility-carts-cushman-hauler-4x4",
              "name": "HAULER 4X4",
              "subcategories": []
            },
            {
              "id": "utility-carts-cushman-hauler-800x",
              "name": "HAULER 800X",
              "subcategories": []
            },
            {
              "id": "utility-carts-cushman-hauler-1200",
              "name": "HAULER 1200",
              "subcategories": []
            },
            {
              "id": "utility-carts-cushman-truckster-xd",
              "name": "TRUCKSTER XD",
              "subcategories": []
            },
            {
              "id": "utility-carts-cushman-turf-truckster",
              "name": "TURF-TRUCKSTER",
              "subcategories": []
            },
            {
              "id": "utility-carts-cushman-turf-truckster-s660-efi-4wd",
              "name": "TURF-TRUCKSTER S660 EFI 4WD",
              "subcategories": []
            },
            {
              "id": "utility-carts-cushman-other",
              "name": "OTHER",
              "subcategories": []
            }
          ]
        },
        {
          "id": "utility-carts-e-z-go",
          "name": "E-Z-Go",
          "subcategories": [
            {
              "id": "utility-carts-e-z-go-gxt7",
              "name": "GXT7",
              "subcategories": []
            },
            {
              "id": "utility-carts-e-z-go-mpt800",
              "name": "MPT800",
              "subcategories": []
            },
            {
              "id": "utility-carts-e-z-go-mpt1000e",
              "name": "MPT1000E",
              "subcategories": []
            },
            {
              "id": "utility-carts-e-z-go-mpt1200",
              "name": "MPT1200",
              "subcategories": []
            },
            {
              "id": "utility-carts-e-z-go-mpt1200g",
              "name": "MPT1200G",
              "subcategories": []
            },
            {
              "id": "utility-carts-e-z-go-terrain-250",
              "name": "TERRAIN 250",
              "subcategories": []
            },
            {
              "id": "utility-carts-e-z-go-other",
              "name": "OTHER",
              "subcategories": []
            }
          ]
        },
        {
          "id": "utility-carts-gravely",
          "name": "Gravely",
          "subcategories": [
            {
              "id": "utility-carts-gravely-atlas-jsv-3400sd",
              "name": "ATLAS JSV 3400SD",
              "subcategories": []
            },
            {
              "id": "utility-carts-gravely-atlas-jsv-6400",
              "name": "ATLAS JSV 6400",
              "subcategories": []
            },
            {
              "id": "utility-carts-gravely-atlas-jsv3400",
              "name": "ATLAS JSV3400",
              "subcategories": []
            },
            {
              "id": "utility-carts-gravely-treker-440rx",
              "name": "TREKER 440RX",
              "subcategories": []
            },
            {
              "id": "utility-carts-gravely-other",
              "name": "OTHER",
              "subcategories": []
            }
          ]
        },
        {
          "id": "utility-carts-greenworks",
          "name": "Greenworks",
          "subcategories": [
            {
              "id": "utility-carts-greenworks-cu400w",
              "name": "CU400W",
              "subcategories": []
            },
            {
              "id": "utility-carts-greenworks-cu500sb",
              "name": "CU500SB",
              "subcategories": []
            },
            {
              "id": "utility-carts-greenworks-cu800sb",
              "name": "CU800SB",
              "subcategories": []
            },
            {
              "id": "utility-carts-greenworks-cu800sc",
              "name": "CU800SC",
              "subcategories": []
            },
            {
              "id": "utility-carts-greenworks-other",
              "name": "OTHER",
              "subcategories": []
            }
          ]
        },
        {
          "id": "utility-carts-hisun",
          "name": "Hisun",
          "subcategories": [
            {
              "id": "utility-carts-hisun-axis-700",
              "name": "AXIS 700",
              "subcategories": []
            },
            {
              "id": "utility-carts-hisun-hs400",
              "name": "HS400",
              "subcategories": []
            },
            {
              "id": "utility-carts-hisun-sector-250",
              "name": "SECTOR 250",
              "subcategories": []
            },
            {
              "id": "utility-carts-hisun-sector-550",
              "name": "SECTOR 550",
              "subcategories": []
            },
            {
              "id": "utility-carts-hisun-sector-750",
              "name": "SECTOR 750",
              "subcategories": []
            },
            {
              "id": "utility-carts-hisun-sector-750-crew-eps",
              "name": "SECTOR 750 CREW EPS",
              "subcategories": []
            },
            {
              "id": "utility-carts-hisun-sector-1000",
              "name": "SECTOR 1000",
              "subcategories": []
            },
            {
              "id": "utility-carts-hisun-sector-e1",
              "name": "SECTOR E1",
              "subcategories": []
            },
            {
              "id": "utility-carts-hisun-vector-500",
              "name": "VECTOR 500",
              "subcategories": []
            },
            {
              "id": "utility-carts-hisun-other",
              "name": "OTHER",
              "subcategories": []
            }
          ]
        },
        {
          "id": "utility-carts-huntve",
          "name": "Huntve",
          "subcategories": [
            {
              "id": "utility-carts-huntve-game-changer",
              "name": "GAME CHANGER",
              "subcategories": []
            },
            {
              "id": "utility-carts-huntve-game-changer-electric",
              "name": "GAME CHANGER ELECTRIC",
              "subcategories": []
            },
            {
              "id": "utility-carts-huntve-terlingua",
              "name": "TERLINGUA",
              "subcategories": []
            },
            {
              "id": "utility-carts-huntve-other",
              "name": "OTHER",
              "subcategories": []
            }
          ]
        },
        {
          "id": "utility-carts-intimadator",
          "name": "Intimadator",
          "subcategories": []
        },
        {
          "id": "utility-carts-ir",
          "name": "Ir",
          "subcategories": [
            {
              "id": "utility-carts-ir-iret13",
              "name": "IRET13",
              "subcategories": []
            },
            {
              "id": "utility-carts-ir-other",
              "name": "OTHER",
              "subcategories": []
            }
          ]
        },
        {
          "id": "utility-carts-kioti",
          "name": "Kioti",
          "subcategories": [
            {
              "id": "utility-carts-kioti-k9-2400",
              "name": "K9 2400",
              "subcategories": []
            },
            {
              "id": "utility-carts-kioti-k9-2410",
              "name": "K9 2410",
              "subcategories": []
            },
            {
              "id": "utility-carts-kioti-k9-2440",
              "name": "K9 2440",
              "subcategories": []
            },
            {
              "id": "utility-carts-kioti-mechron-2200",
              "name": "MECHRON 2200",
              "subcategories": []
            },
            {
              "id": "utility-carts-kioti-mechron-2210",
              "name": "MECHRON 2210",
              "subcategories": []
            },
            {
              "id": "utility-carts-kioti-other",
              "name": "OTHER",
              "subcategories": []
            }
          ]
        },
        {
          "id": "utility-carts-mahindra",
          "name": "Mahindra",
          "subcategories": [
            {
              "id": "utility-carts-mahindra-impact-xtv-750b",
              "name": "IMPACT XTV 750B",
              "subcategories": []
            },
            {
              "id": "utility-carts-mahindra-impact-xtv-750c",
              "name": "IMPACT XTV 750C",
              "subcategories": []
            },
            {
              "id": "utility-carts-mahindra-impact-xtv-750s-flexhauler",
              "name": "IMPACT XTV 750S FLEXHAULER",
              "subcategories": []
            },
            {
              "id": "utility-carts-mahindra-impact-xtv-1000s",
              "name": "IMPACT XTV 1000S",
              "subcategories": []
            },
            {
              "id": "utility-carts-mahindra-impact-xtv-1000s-flexhauler",
              "name": "IMPACT XTV 1000S FLEXHAULER",
              "subcategories": []
            },
            {
              "id": "utility-carts-mahindra-retriever-1000",
              "name": "RETRIEVER 1000",
              "subcategories": []
            },
            {
              "id": "utility-carts-mahindra-retriever-1000-flexhauler",
              "name": "RETRIEVER 1000 FLEXHAULER",
              "subcategories": []
            },
            {
              "id": "utility-carts-mahindra-roxor",
              "name": "ROXOR",
              "subcategories": []
            },
            {
              "id": "utility-carts-mahindra-roxor-all-weather",
              "name": "ROXOR ALL WEATHER",
              "subcategories": []
            },
            {
              "id": "utility-carts-mahindra-roxor-hd",
              "name": "ROXOR HD",
              "subcategories": []
            },
            {
              "id": "utility-carts-mahindra-roxor-hd-all-weather",
              "name": "ROXOR HD ALL WEATHER",
              "subcategories": []
            },
            {
              "id": "utility-carts-mahindra-other",
              "name": "OTHER",
              "subcategories": []
            }
          ]
        },
        {
          "id": "utility-carts-new-holland",
          "name": "New Holland",
          "subcategories": [
            {
              "id": "utility-carts-new-holland-rustler-115",
              "name": "RUSTLER 115",
              "subcategories": []
            },
            {
              "id": "utility-carts-new-holland-rustler-120",
              "name": "RUSTLER 120",
              "subcategories": []
            },
            {
              "id": "utility-carts-new-holland-rustler-125",
              "name": "RUSTLER 125",
              "subcategories": []
            },
            {
              "id": "utility-carts-new-holland-other",
              "name": "OTHER",
              "subcategories": []
            }
          ]
        },
        {
          "id": "utility-carts-sdlanch",
          "name": "Sdlanch",
          "subcategories": [
            {
              "id": "utility-carts-sdlanch-iret-13",
              "name": "IRET 13",
              "subcategories": []
            },
            {
              "id": "utility-carts-sdlanch-other",
              "name": "OTHER",
              "subcategories": []
            }
          ]
        },
        {
          "id": "utility-carts-scherp",
          "name": "Scherp",
          "subcategories": [
            {
              "id": "utility-carts-scherp-n1200",
              "name": "N1200",
              "subcategories": []
            },
            {
              "id": "utility-carts-scherp-pro-1000",
              "name": "PRO 1000",
              "subcategories": []
            },
            {
              "id": "utility-carts-scherp-other",
              "name": "OTHER",
              "subcategories": []
            }
          ]
        },
        {
          "id": "utility-carts-subaru",
          "name": "Subaru",
          "subcategories": []
        },
        {
          "id": "utility-carts-suzuki",
          "name": "Suzuki",
          "subcategories": [
            {
              "id": "utility-carts-suzuki-carry",
              "name": "CARRY",
              "subcategories": []
            },
            {
              "id": "utility-carts-suzuki-ebd-da65t",
              "name": "EBD-DA65T",
              "subcategories": []
            },
            {
              "id": "utility-carts-suzuki-q-u-v",
              "name": "Q.U.V.",
              "subcategories": []
            },
            {
              "id": "utility-carts-suzuki-other",
              "name": "OTHER",
              "subcategories": []
            }
          ]
        },
        {
          "id": "utility-carts-taylor-dunn",
          "name": "Taylor Dunn",
          "subcategories": []
        },
        {
          "id": "utility-carts-tuatara",
          "name": "Tuatara",
          "subcategories": [
            {
              "id": "utility-carts-tuatara-1000-efi",
              "name": "1000 EFI",
              "subcategories": []
            },
            {
              "id": "utility-carts-tuatara-1500e",
              "name": "1500E",
              "subcategories": []
            },
            {
              "id": "utility-carts-tuatara-other",
              "name": "OTHER",
              "subcategories": []
            }
          ]
        },
        {
          "id": "utility-carts-vitacci",
          "name": "Vitacci",
          "subcategories": [
            {
              "id": "utility-carts-vitacci-blade-fx250",
              "name": "BLADE FX250",
              "subcategories": []
            },
            {
              "id": "utility-carts-vitacci-conqueror-100dlx",
              "name": "CONQUEROR 100DLX",
              "subcategories": []
            },
            {
              "id": "utility-carts-vitacci-maximus-800-efi",
              "name": "MAXIMUS 800 EFI",
              "subcategories": []
            },
            {
              "id": "utility-carts-vitacci-rover-electric",
              "name": "ROVER ELECTRIC",
              "subcategories": []
            },
            {
              "id": "utility-carts-vitacci-victory-450-pro",
              "name": "VICTORY 450 PRO",
              "subcategories": []
            },
            {
              "id": "utility-carts-vitacci-other",
              "name": "OTHER",
              "subcategories": []
            }
          ]
        },
        {
          "id": "utility-carts-yamaha",
          "name": "Yamaha",
          "subcategories": [
            {
              "id": "utility-carts-yamaha-rhino-450",
              "name": "RHINO 450",
              "subcategories": []
            },
            {
              "id": "utility-carts-yamaha-rhino-660",
              "name": "RHINO 660",
              "subcategories": []
            },
            {
              "id": "utility-carts-yamaha-rhino-660se",
              "name": "RHINO 660SE",
              "subcategories": []
            },
            {
              "id": "utility-carts-yamaha-rhino-700",
              "name": "RHINO 700",
              "subcategories": []
            },
            {
              "id": "utility-carts-yamaha-umax-one-efi",
              "name": "UMAX ONE EFI",
              "subcategories": []
            },
            {
              "id": "utility-carts-yamaha-umx-ac",
              "name": "UMX AC",
              "subcategories": []
            },
            {
              "id": "utility-carts-yamaha-viking",
              "name": "VIKING",
              "subcategories": []
            },
            {
              "id": "utility-carts-yamaha-viking-700",
              "name": "VIKING 700",
              "subcategories": []
            },
            {
              "id": "utility-carts-yamaha-viking-eps",
              "name": "VIKING EPS",
              "subcategories": []
            },
            {
              "id": "utility-carts-yamaha-viking-eps-ranch",
              "name": "VIKING EPS RANCH",
              "subcategories": []
            },
            {
              "id": "utility-carts-yamaha-viking-vi",
              "name": "VIKING VI",
              "subcategories": []
            },
            {
              "id": "utility-carts-yamaha-wolverine",
              "name": "WOLVERINE",
              "subcategories": []
            },
            {
              "id": "utility-carts-yamaha-wolverine-rmax2-1000-r-spec",
              "name": "WOLVERINE RMAX2 1000 R-SPEC",
              "subcategories": []
            },
            {
              "id": "utility-carts-yamaha-wolverine-rmax2-1000-sport",
              "name": "WOLVERINE RMAX2 1000 SPORT",
              "subcategories": []
            },
            {
              "id": "utility-carts-yamaha-wolverine-rmax2-1000-xt-r",
              "name": "WOLVERINE RMAX2 1000 XT-R",
              "subcategories": []
            },
            {
              "id": "utility-carts-yamaha-wolverine-rmax4-1000-le",
              "name": "WOLVERINE RMAX4 1000 LE",
              "subcategories": []
            },
            {
              "id": "utility-carts-yamaha-wolverine-rmax4-1000-r-spec",
              "name": "WOLVERINE RMAX4 1000 R-SPEC",
              "subcategories": []
            },
            {
              "id": "utility-carts-yamaha-wolverine-r-spec",
              "name": "WOLVERINE R-SPEC",
              "subcategories": []
            },
            {
              "id": "utility-carts-yamaha-wolverine-r-spec-eps",
              "name": "WOLVERINE R-SPEC EPS",
              "subcategories": []
            },
            {
              "id": "utility-carts-yamaha-wolverine-x2",
              "name": "WOLVERINE X2",
              "subcategories": []
            },
            {
              "id": "utility-carts-yamaha-wolverine-x2-850-xt-r",
              "name": "WOLVERINE X2 850 XT-R",
              "subcategories": []
            },
            {
              "id": "utility-carts-yamaha-wolverine-x2-r-spec",
              "name": "WOLVERINE X2 R-SPEC",
              "subcategories": []
            },
            {
              "id": "utility-carts-yamaha-wolverine-x4",
              "name": "WOLVERINE X4",
              "subcategories": []
            },
            {
              "id": "utility-carts-yamaha-wolverine-x4-850-xt-r",
              "name": "WOLVERINE X4 850 XT-R",
              "subcategories": []
            },
            {
              "id": "utility-carts-yamaha-wolverine-x2-850-r-spec",
              "name": "WOLVERINE X2 850 R-SPEC",
              "subcategories": []
            },
            {
              "id": "utility-carts-yamaha-yxz1000r",
              "name": "YXZ1000R",
              "subcategories": []
            },
            {
              "id": "utility-carts-yamaha-yxz1000r-ss",
              "name": "YXZ1000R SS",
              "subcategories": []
            },
            {
              "id": "utility-carts-yamaha-other",
              "name": "OTHER",
              "subcategories": []
            }
          ]
        },
        {
          "id": "utility-carts-yanmar",
          "name": "Yanmar",
          "subcategories": [
            {
              "id": "utility-carts-yanmar-brahma-yu1000d",
              "name": "BRAHMA YU1000D",
              "subcategories": []
            },
            {
              "id": "utility-carts-yanmar-bull-yu700g",
              "name": "BULL YU700G",
              "subcategories": []
            },
            {
              "id": "utility-carts-yanmar-longhorn-yu700gmp",
              "name": "LONGHORN YU700GMP",
              "subcategories": []
            },
            {
              "id": "utility-carts-yanmar-other",
              "name": "OTHER",
              "subcategories": []
            }
          ]
        },
        {
          "id": "utility-carts-all-others",
          "name": "All Others",
          "subcategories": []
        }
      ]
    },
    {
      "id": "other-specialty",
      "name": "Other / Specialty",
      "subcategories": []
    }
  ]
};

export default categoriesConfig;
